/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 87);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mergeData; });
var __assign=Object.assign||function(e){for(var a,s=1,t=arguments.length;s<t;s++)for(var r in a=arguments[s])Object.prototype.hasOwnProperty.call(a,r)&&(e[r]=a[r]);return e};function mergeData(){for(var e,a,s={},t=arguments.length;t--;)for(var r=0,c=Object.keys(arguments[t]);r<c.length;r++)switch(e=c[r]){case"class":case"style":case"directives":Array.isArray(s[e])||(s[e]=[]),s[e]=s[e].concat(arguments[t][e]);break;case"staticClass":if(!arguments[t][e])break;void 0===s[e]&&(s[e]=""),s[e]&&(s[e]+=" "),s[e]+=arguments[t][e].trim();break;case"on":case"nativeOn":s[e]||(s[e]={});for(var o=0,n=Object.keys(arguments[t][e]||{});o<n.length;o++)a=n[o],s[e][a]?s[e][a]=[].concat(s[e][a],arguments[t][e][a]):s[e][a]=arguments[t][e][a];break;case"attrs":case"props":case"domProps":case"scopedSlots":case"staticStyle":case"hook":case"transition":s[e]||(s[e]={}),s[e]=__assign({},arguments[t][e],s[e]);break;case"slot":case"key":case"ref":case"tag":case"show":case"keepAlive":default:s[e]||(s[e]=arguments[t][e])}return s}
//# sourceMappingURL=lib.esm.js.map


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerComponent */
/* harmony export (immutable) */ __webpack_exports__["a"] = registerComponents;
/* unused harmony export registerDirective */
/* harmony export (immutable) */ __webpack_exports__["b"] = registerDirectives;
/* harmony export (immutable) */ __webpack_exports__["c"] = vueUse;
/**
 * Register a component plugin as being loaded. returns true if compoent plugin already registered
 * @param {object} Vue
 * @param {string} Component name
 * @param {object} Component definition
 */
function registerComponent(Vue, name, def) {
  Vue._bootstrap_vue_components_ = Vue._bootstrap_vue_components_ || {};
  var loaded = Vue._bootstrap_vue_components_[name];
  if (!loaded && def && name) {
    Vue._bootstrap_vue_components_[name] = true;
    Vue.component(name, def);
  }
  return loaded;
}

/**
 * Register a group of components as being loaded.
 * @param {object} Vue
 * @param {object} Object of component definitions
 */
function registerComponents(Vue, components) {
  for (var component in components) {
    registerComponent(Vue, component, components[component]);
  }
}

/**
 * Register a directive as being loaded. returns true if directive plugin already registered
 * @param {object} Vue
 * @param {string} Directive name
 * @param {object} Directive definition
 */
function registerDirective(Vue, name, def) {
  Vue._bootstrap_vue_directives_ = Vue._bootstrap_vue_directives_ || {};
  var loaded = Vue._bootstrap_vue_directives_[name];
  if (!loaded && def && name) {
    Vue._bootstrap_vue_directives_[name] = true;
    Vue.directive(name, def);
  }
  return loaded;
}

/**
 * Register a group of directives as being loaded.
 * @param {object} Vue
 * @param {object} Object of directive definitions
 */
function registerDirectives(Vue, directives) {
  for (var directive in directives) {
    registerDirective(Vue, directive, directives[directive]);
  }
}

/**
 * Install plugin if window.Vue available
 * @param {object} Plugin definition
 */
function vueUse(VuePlugin) {
  if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(VuePlugin);
  }
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assign; });
/* unused harmony export getOwnPropertyNames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defineProperties; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defineProperty; });
/* unused harmony export freeze */
/* unused harmony export getOwnPropertyDescriptor */
/* unused harmony export getOwnPropertySymbols */
/* unused harmony export getPrototypeOf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return create; });
/* unused harmony export isFrozen */
/* unused harmony export is */
/* harmony export (immutable) */ __webpack_exports__["f"] = readonlyDescriptor;
/**
 * Aliasing Object[method] allows the minifier to shorten methods to a single character variable,
 * as well as giving BV a chance to inject polyfills.
 * As long as we avoid
 * - import * as Object from "utils/object"
 * all unused exports should be removed by tree-shaking.
 */

// @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign !== 'function') {
  Object.assign = function (target, varArgs) {
    // .length of function is 2

    if (target == null) {
      // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) {
        // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// @link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#Polyfill
if (!Object.is) {
  Object.is = function (x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      // eslint-disable-next-line no-self-compare
      return x !== x && y !== y;
    }
  };
}

var assign = Object.assign;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var keys = Object.keys;
var defineProperties = Object.defineProperties;
var defineProperty = Object.defineProperty;
var freeze = Object.freeze;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getPrototypeOf = Object.getPrototypeOf;
var create = Object.create;
var isFrozen = Object.isFrozen;
var is = Object.is;

function readonlyDescriptor() {
  return { enumerable: true, configurable: false, writable: false };
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arrayIncludes; });
/* unused harmony export arrayFind */
/* harmony export (immutable) */ __webpack_exports__["b"] = concat;
// Production steps of ECMA-262, Edition 6, 22.1.2.1
// es6-ified by @alexsasharegan
if (!Array.from) {
  Array.from = function () {
    var toStr = Object.prototype.toString;
    var isCallable = function isCallable(fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function toInteger(value) {
      var number = Number(value);
      if (isNaN(number)) {
        return 0;
      }
      if (number === 0 || !isFinite(number)) {
        return number;
      }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function toLength(value) {
      return Math.min(Math.max(toInteger(value), 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike /*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T = void 0;

      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue = void 0;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }();
}

// https://tc39.github.io/ecma262/#sec-array.prototype.find
// Needed for IE support
if (!Array.prototype.find) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

// Static
var from = Array.from;
var isArray = Array.isArray;

// Instance
var arrayIncludes = function arrayIncludes(array, value) {
  return array.indexOf(value) !== -1;
};
var arrayFind = function arrayFind(array, fn, thisArg) {
  return array.find(fn, thisArg);
};
function concat() {
  return Array.prototype.concat.apply([], arguments);
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isVisible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isDisabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return reflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return selectAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return matches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return closest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return setAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return removeAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return hasAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getBCR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return offset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return position; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return eventOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return eventOff; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);


// Determine if an element is an HTML Element
var isElement = function isElement(el) {
  return el && el.nodeType === Node.ELEMENT_NODE;
};

// Determine if an HTML element is visible - Faster than CSS check
var isVisible = function isVisible(el) {
  return isElement(el) && document.body.contains(el) && el.getBoundingClientRect().height > 0 && el.getBoundingClientRect().width > 0;
};

// Determine if an element is disabled
var isDisabled = function isDisabled(el) {
  return !isElement(el) || el.disabled || el.classList.contains('disabled') || Boolean(el.getAttribute('disabled'));
};

// Cause/wait-for an element to reflow it's content (adjusting it's height/width)
var reflow = function reflow(el) {
  // requsting an elements offsetHight will trigger a reflow of the element content
  return isElement(el) && el.offsetHeight;
};

// Select all elements matching selector. Returns [] if none found
var selectAll = function selectAll(selector, root) {
  if (!isElement(root)) {
    root = document;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__array__["c" /* from */])(root.querySelectorAll(selector));
};

// Select a single element, returns null if not found
var select = function select(selector, root) {
  if (!isElement(root)) {
    root = document;
  }
  return root.querySelector(selector) || null;
};

// Determine if an element matches a selector
var matches = function matches(el, selector) {
  if (!isElement(el)) {
    return false;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
  // Prefer native implementations over polyfill function
  var proto = Element.prototype;
  var Matches = proto.matches || proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector ||
  /* istanbul ignore next */
  function (sel) {
    var element = this;
    var m = selectAll(sel, element.document || element.ownerDocument);
    var i = m.length;
    // eslint-disable-next-line no-empty
    while (--i >= 0 && m.item(i) !== element) {}
    return i > -1;
  };

  return Matches.call(el, selector);
};

// Finds closest element matching selector. Returns null if not found
var closest = function closest(selector, root) {
  if (!isElement(root)) {
    return null;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
  // Since we dont support IE < 10, we can use the "Matches" version of the polyfill for speed
  // Prefer native implementation over polyfill function
  var Closest = Element.prototype.closest ||
  /* istanbul ignore next */
  function (sel) {
    var element = this;
    if (!document.documentElement.contains(element)) {
      return null;
    }
    do {
      // Use our "patched" matches function
      if (matches(element, sel)) {
        return element;
      }
      element = element.parentElement;
    } while (element !== null);
    return null;
  };

  var el = Closest.call(root, selector);
  // Emulate jQuery closest and return null if match is the passed in element (root)
  return el === root ? null : el;
};

// Get an element given an ID
var getById = function getById(id) {
  return document.getElementById(/^#/.test(id) ? id.slice(1) : id) || null;
};

// Add a class to an element
var addClass = function addClass(el, className) {
  if (className && isElement(el)) {
    el.classList.add(className);
  }
};

// Remove a class from an element
var removeClass = function removeClass(el, className) {
  if (className && isElement(el)) {
    el.classList.remove(className);
  }
};

// Test if an element has a class
var hasClass = function hasClass(el, className) {
  if (className && isElement(el)) {
    return el.classList.contains(className);
  }
  return false;
};

// Set an attribute on an element
var setAttr = function setAttr(el, attr, value) {
  if (attr && isElement(el)) {
    el.setAttribute(attr, value);
  }
};

// Remove an attribute from an element
var removeAttr = function removeAttr(el, attr) {
  if (attr && isElement(el)) {
    el.removeAttribute(attr);
  }
};

// Get an attribute value from an element (returns null if not found)
var getAttr = function getAttr(el, attr) {
  if (attr && isElement(el)) {
    return el.getAttribute(attr);
  }
  return null;
};

// Determine if an attribute exists on an element (returns true or false, or null if element not found)
var hasAttr = function hasAttr(el, attr) {
  if (attr && isElement(el)) {
    return el.hasAttribute(attr);
  }
  return null;
};

// Return the Bounding Client Rec of an element. Retruns null if not an element
var getBCR = function getBCR(el) {
  return isElement(el) ? el.getBoundingClientRect() : null;
};

// Get computed style object for an element
var getCS = function getCS(el) {
  return isElement(el) ? window.getComputedStyle(el) : {};
};

// Return an element's offset wrt document element
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.offset
var offset = function offset(el) {
  if (isElement(el)) {
    if (!el.getClientRects().length) {
      return { top: 0, left: 0 };
    }
    var bcr = getBCR(el);
    var win = el.ownerDocument.defaultView;
    return {
      top: bcr.top + win.pageYOffset,
      left: bcr.left + win.pageXOffset
    };
  }
};

// Return an element's offset wrt to it's offsetParent
// https://j11y.io/jquery/#v=git&fn=jQuery.fn.position
var position = function position(el) {
  if (!isElement(el)) {
    return;
  }
  var parentOffset = { top: 0, left: 0 };
  var offsetSelf = void 0;
  var offsetParent = void 0;
  if (getCS(el).position === 'fixed') {
    offsetSelf = getBCR(el);
  } else {
    offsetSelf = offset(el);
    var doc = el.ownerDocument;
    offsetParent = el.offsetParent || doc.documentElement;
    while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && getCS(offsetParent).position === 'static') {
      offsetParent = offsetParent.parentNode;
    }
    if (offsetParent && offsetParent !== el && offsetParent.nodeType === Node.ELEMENT_NODE) {
      parentOffset = offset(offsetParent);
      parentOffset.top += parseFloat(getCS(offsetParent).borderTopWidth);
      parentOffset.left += parseFloat(getCS(offsetParent).borderLeftWidth);
    }
  }
  return {
    top: offsetSelf.top - parentOffset.top - parseFloat(getCS(el).marginTop),
    left: offsetSelf.left - parentOffset.left - parseFloat(getCS(el).marginLeft)
  };
};

// Attach an event listener to an element
var eventOn = function eventOn(el, evtName, handler) {
  if (el && el.addEventListener) {
    el.addEventListener(evtName, handler);
  }
};

// Remove an event listener from an element
var eventOff = function eventOff(el, evtName, handler) {
  if (el && el.removeEventListener) {
    el.removeEventListener(evtName, handler);
  }
};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * SSR Safe Client Side ID attribute generation
 *
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    id: {
      type: String,
      default: null
    }
  },
  methods: {
    safeId: function safeId() {
      var suffix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var id = this.id || this.localId_ || null;
      if (!id) {
        return null;
      }
      suffix = String(suffix).replace(/\s+/g, '_');
      return suffix ? id + '_' + suffix : id;
    }
  },
  computed: {
    localId_: function localId_() {
      if (!this.$isServer && !this.id && typeof this._uid !== 'undefined') {
        return '__BVID__' + this._uid;
      }
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(71);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        navigation: {
            breadcrumbs: [],
            active: ""
        },
        search: {
            filter: {},
            pagination: {
                numItems: 0,
                currentPage: 1
            },
            resultList: []
        },
        archiveItems: []
    },
    mutations: {
        setBreadcrumb: function setBreadcrumb(state, bc) {
            state.navigation.breadcrumbs = bc;
        },
        setActivePage: function setActivePage(state, page) {
            state.navigation.active = page;
        },
        resetSearchFilter: function resetSearchFilter(state) {
            state.search.filter = {};
        },
        setSearchFilter: function setSearchFilter(state, filter) {
            state.search.filter = filter;
        },
        setSearchResult: function setSearchResult(state, res) {
            state.search.resultList = res;
        },
        setArchiveItems: function setArchiveItems(state, items) {
            state.archiveItems = items;
        }
    },
    actions: {
        updateSearch: function updateSearch(context, filter) {
            __WEBPACK_IMPORTED_MODULE_2__search__["a" /* default */].applyFilter(filter);
            context.commit('setSearchResult', __WEBPACK_IMPORTED_MODULE_2__search__["a" /* default */].getResults());
        },
        setupItems: function setupItems(context) {
            context.commit('setArchiveItems', __WEBPACK_IMPORTED_MODULE_2__search__["a" /* default */].getIndex());
        }
    },
    getters: {
        getSearchResult: function getSearchResult(state) {
            return state.search.resultList;
        },
        getAllItems: function getAllItems(state) {
            return state.archiveItems;
        },
        getIndexFromSlug: function getIndexFromSlug(state) {
            return function (slug) {
                return __WEBPACK_IMPORTED_MODULE_2__search__["a" /* default */].getIndexBySlug(slug);
            };
        },
        getItemFromResult: function getItemFromResult(state) {
            return function (index) {
                return state.archiveItems[index];
            };
        }
    }
}));

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Log a warning message to the console with bootstrap-vue formatting sugar.
 * @param {string} message
 */
/* istanbul ignore next */
function warn(message) {
  console.warn("[Bootstrap-Vue warn]: " + message);
}

/* harmony default export */ __webpack_exports__["a"] = (warn);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = propsFactory;
/* unused harmony export props */
/* harmony export (immutable) */ __webpack_exports__["b"] = pickLinkProps;
/* unused harmony export omitLinkProps */
/* unused harmony export computed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__ = __webpack_require__(0);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/**
 * The Link component is used in many other BV components.
 * As such, sharing its props makes supporting all its features easier.
 * However, some components need to modify the defaults for their own purpose.
 * Prefer sharing a fresh copy of the props to ensure mutations
 * do not affect other component references to the props.
 *
 * https://github.com/vuejs/vue-router/blob/dev/src/components/link.js
 * @return {{}}
 */
function propsFactory() {
  return {
    href: {
      type: String,
      default: null
    },
    rel: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: '_self'
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: 'active'
    },
    append: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    event: {
      type: [String, Array],
      default: 'click'
    },
    exact: {
      type: Boolean,
      default: false
    },
    exactActiveClass: {
      type: String,
      default: 'active'
    },
    replace: {
      type: Boolean,
      default: false
    },
    routerTag: {
      type: String,
      default: 'a'
    },
    to: {
      type: [String, Object],
      default: null
    }
  };
}

var props = propsFactory();

function pickLinkProps(propsToPick) {
  var freshLinkProps = propsFactory();
  // Normalize everything to array.
  propsToPick = Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* concat */])(propsToPick);

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(freshLinkProps).reduce(function (memo, prop) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(propsToPick, prop)) {
      memo[prop] = freshLinkProps[prop];
    }

    return memo;
  }, {});
}

function omitLinkProps(propsToOmit) {
  var freshLinkProps = propsFactory();
  // Normalize everything to array.
  propsToOmit = Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["b" /* concat */])(propsToOmit);

  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(props).reduce(function (memo, prop) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(propsToOmit, prop)) {
      memo[prop] = freshLinkProps[prop];
    }

    return memo;
  }, {});
}

var computed = {
  linkProps: function linkProps() {
    var linkProps = {};
    var propKeys = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(props);

    for (var i = 0; i < propKeys.length; i++) {
      var prop = propKeys[i];
      // Computed Vue getters are bound to the instance.
      linkProps[prop] = this[prop];
    }

    return linkProps;
  }
};

function computeTag(props, parent) {
  return Boolean(parent.$router) && props.to && !props.disabled ? 'router-link' : 'a';
}

function computeHref(_ref, tag) {
  var disabled = _ref.disabled,
      href = _ref.href,
      to = _ref.to;

  // We've already checked the parent.$router in computeTag,
  // so router-link means live router.
  // When deferring to Vue Router's router-link,
  // don't use the href attr at all.
  // Must return undefined for router-link to populate href.
  if (tag === 'router-link') return void 0;
  // If href explicitly provided
  if (href) return href;
  // Reconstruct href when `to` used, but no router
  if (to) {
    // Fallback to `to` prop (if `to` is a string)
    if (typeof to === 'string') return to;
    // Fallback to `to.path` prop (if `to` is an object)
    if ((typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' && typeof to.path === 'string') return to.path;
  }
  // If nothing is provided use '#'
  return '#';
}

function computeRel(_ref2) {
  var target = _ref2.target,
      rel = _ref2.rel;

  if (target === '_blank' && rel === null) {
    return 'noopener';
  }
  return rel || null;
}

function clickHandlerFactory(_ref3) {
  var disabled = _ref3.disabled,
      tag = _ref3.tag,
      href = _ref3.href,
      suppliedHandler = _ref3.suppliedHandler,
      parent = _ref3.parent;

  var isRouterLink = tag === 'router-link';

  return function onClick(e) {
    if (disabled && e instanceof Event) {
      // Stop event from bubbling up.
      e.stopPropagation();
      // Kill the event loop attached to this specific EventTarget.
      e.stopImmediatePropagation();
    } else {
      parent.$root.$emit('clicked::link', e);

      if (isRouterLink && e.target.__vue__) {
        e.target.__vue__.$emit('click', e);
      }
      if (typeof suppliedHandler === 'function') {
        suppliedHandler.apply(undefined, arguments);
      }
    }

    if (!isRouterLink && href === '#' || disabled) {
      // Stop scroll-to-top behavior or navigation.
      e.preventDefault();
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: propsFactory(),
  render: function render(h, _ref4) {
    var props = _ref4.props,
        data = _ref4.data,
        parent = _ref4.parent,
        children = _ref4.children;

    var tag = computeTag(props, parent);
    var rel = computeRel(props);
    var href = computeHref(props, tag);
    var eventType = tag === 'router-link' ? 'nativeOn' : 'on';
    var suppliedHandler = (data[eventType] || {}).click;
    var handlers = { click: clickHandlerFactory({ tag: tag, href: href, disabled: props.disabled, suppliedHandler: suppliedHandler, parent: parent }) };

    var componentData = Object(__WEBPACK_IMPORTED_MODULE_2_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: [props.active ? props.exact ? props.exactActiveClass : props.activeClass : null, { disabled: props.disabled }],
      attrs: {
        rel: rel,
        href: href,
        target: props.target,
        tabindex: props.disabled ? '-1' : data.attrs ? data.attrs.tabindex : null,
        'aria-disabled': tag === 'a' && props.disabled ? 'true' : null
      },
      props: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(props, { tag: props.routerTag })
    });

    // If href prop exists on router-link (even undefined or null) it fails working on SSR
    if (!componentData.attrs.href) {
      delete componentData.attrs.href;
    }

    // We want to overwrite any click handler since our callback
    // will invoke the supplied handler if !props.disabled
    componentData[eventType] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(componentData[eventType] || {}, handlers);

    return h(tag, componentData, children);
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Form control contextual state class computation
 *
 * Returned class is either 'is-valid' or 'is-invalid' based on the 'state' prop
 * state can be one of five values:
 *  - true or 'valid' for is-valid
 *  - false or 'invalid' for is-invalid
 *  - null (or empty string) for no contextual state
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    state: {
      // true/'valid', false/'invalid', '',null
      type: [Boolean, String],
      default: null
    }
  },
  computed: {
    computedState: function computedState() {
      var state = this.state;
      if (state === true || state === 'valid') {
        return true;
      } else if (state === false || state === 'invalid') {
        return false;
      }
      return null;
    },
    stateClass: function stateClass() {
      var state = this.computedState;
      if (state === true) {
        return 'is-valid';
      } else if (state === false) {
        return 'is-invalid';
      }
      return null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String
    },
    id: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    required: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Key Codes (events)
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  SPACE: 32,
  ENTER: 13,
  ESC: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  PAGEUP: 33,
  PAGEDOWN: 34,
  HOME: 36,
  END: 35
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(204)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 15 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pluckProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(39);




/**
 * Given an array of properties or an object of property keys,
 * plucks all the values off the target object.
 * @param {{}|string[]} keysToPluck
 * @param {{}} objToPluck
 * @param {Function} transformFn
 * @return {{}}
 */
function pluckProps(keysToPluck, objToPluck) {
  var transformFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */];

  return (Object(__WEBPACK_IMPORTED_MODULE_1__array__["d" /* isArray */])(keysToPluck) ? keysToPluck.slice() : Object(__WEBPACK_IMPORTED_MODULE_0__object__["e" /* keys */])(keysToPluck)).reduce(function (memo, prop) {
    // eslint-disable-next-line no-sequences
    return memo[transformFn(prop)] = objToPluck[prop], memo;
  }, {});
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    sizeFormClass: function sizeFormClass() {
      return [this.size ? "form-control-" + this.size : null];
    },
    sizeBtnClass: function sizeBtnClass() {
      return [this.size ? "btn-" + this.size : null];
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = observeDOM;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);



/**
 * Observe a DOM element changes, falls back to eventListener mode
 * @param {Element} el The DOM element to observe
 * @param {Function} callback callback to be called on change
 * @param {object} [opts={childList: true, subtree: true}] observe options
 * @see http://stackoverflow.com/questions/3219758
 */
function observeDOM(el, callback, opts) {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  var eventListenerSupported = window.addEventListener;

  // Handle case where we might be passed a vue instance
  el = el ? el.$el || el : null;
  /* istanbul ignore next: dificult to test in JSDOM */
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["l" /* isElement */])(el)) {
    // We can't observe somthing that isn't an element
    return null;
  }

  var obs = null;

  /* istanbul ignore next: dificult to test in JSDOM */
  if (MutationObserver) {
    // Define a new observer
    obs = new MutationObserver(function (mutations) {
      var changed = false;
      // A Mutation can contain several change records, so we loop through them to see what has changed.
      // We break out of the loop early if any "significant" change has been detected
      for (var i = 0; i < mutations.length && !changed; i++) {
        // The muttion record
        var mutation = mutations[i];
        // Mutation Type
        var type = mutation.type;
        // DOM Node (could be any DOM Node type - HTMLElement, Text, comment, etc)
        var target = mutation.target;
        if (type === 'characterData' && target.nodeType === Node.TEXT_NODE) {
          // We ignore nodes that are not TEXt (i.e. comments, etc) as they don't change layout
          changed = true;
        } else if (type === 'attributes') {
          changed = true;
        } else if (type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // This includes HTMLElement and Text Nodes being added/removed/re-arranged
          changed = true;
        }
      }
      if (changed) {
        // We only call the callback if a change that could affect layout/size truely happened.
        callback();
      }
    });

    // Have the observer observe foo for changes in children, etc
    obs.observe(el, Object(__WEBPACK_IMPORTED_MODULE_0__object__["a" /* assign */])({ childList: true, subtree: true }, opts));
  } else if (eventListenerSupported) {
    // Legacy interface. most likely not used in modern browsers
    el.addEventListener('DOMNodeInserted', callback, false);
    el.addEventListener('DOMNodeRemoved', callback, false);
  }

  // We return a reference to the observer so that obs.disconnect() can be called if necessary
  // To reduce overhead when the root element is hiiden
  return obs;
}

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }


/**
 * Issue #569: collapse::toggle::state triggered too many times
 * @link https://github.com/bootstrap-vue/bootstrap-vue/issues/569
 */

var BVRL = '__BV_root_listeners__';

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
         * Safely register event listeners on the root Vue node.
         * While Vue automatically removes listeners for individual components,
         * when a component registers a listener on root and is destroyed,
         * this orphans a callback because the node is gone,
         * but the root does not clear the callback.
         *
         * This adds a non-reactive prop to a vm on the fly
         * in order to avoid object observation and its performance costs
         * to something that needs no reactivity.
         * It should be highly unlikely there are any naming collisions.
         * @param {string} event
         * @param {function} callback
         * @chainable
         */
    listenOnRoot: function listenOnRoot(event, callback) {
      if (!this[BVRL] || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["d" /* isArray */])(this[BVRL])) {
        this[BVRL] = [];
      }
      this[BVRL].push({ event: event, callback: callback });
      this.$root.$on(event, callback);
      return this;
    },


    /**
         * Convenience method for calling vm.$emit on vm.$root.
         * @param {string} event
         * @param {*} args
         * @chainable
         */
    emitOnRoot: function emitOnRoot(event) {
      var _$root;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      (_$root = this.$root).$emit.apply(_$root, [event].concat(_toConsumableArray(args)));
      return this;
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this[BVRL] && Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["d" /* isArray */])(this[BVRL])) {
      while (this[BVRL].length > 0) {
        // shift to process in order
        var _BVRL$shift = this[BVRL].shift(),
            event = _BVRL$shift.event,
            callback = _BVRL$shift.callback;

        this.$root.$off(event, callback);
      }
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    custom: function custom() {
      return !this.plain;
    }
  },
  props: {
    plain: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prefixPropName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upper_first__ = __webpack_require__(44);


/**
 * @param {string} prefix
 * @param {string} value
 */
function prefixPropName(prefix, value) {
  return prefix + Object(__WEBPACK_IMPORTED_MODULE_0__upper_first__["a" /* default */])(value);
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = copyProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(39);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





/**
 * @param {[]|{}} props
 * @param {Function} transformFn
 */
function copyProps(props) {
  var transformFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */];

  if (Object(__WEBPACK_IMPORTED_MODULE_0__array__["d" /* isArray */])(props)) {
    return props.map(transformFn);
  }
  // Props as an object.
  var copied = {};

  for (var prop in props) {
    if (props.hasOwnProperty(prop)) {
      if ((typeof prop === 'undefined' ? 'undefined' : _typeof(prop)) === 'object') {
        copied[transformFn(prop)] = Object(__WEBPACK_IMPORTED_MODULE_1__object__["a" /* assign */])({}, props[prop]);
      } else {
        copied[transformFn(prop)] = props[prop];
      }
    }
  }

  return copied;
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    bgVariant: {
      type: String,
      default: null
    },
    borderVariant: {
      type: String,
      default: null
    },
    textVariant: {
      type: String,
      default: null
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15)))

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.17
 * (c) 2014-2018 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it... e.g.
 * PhantomJS 1.x. Technically we don't need this anymore since native bind is
 * now more performant in most browsers, but removing it would be breaking for
 * code that was able to run in PhantomJS 1.x, so this must be kept for
 * backwards compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
})

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  if (!getter && arguments.length === 2) {
    val = obj[key];
  }
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both microtasks and (macro) tasks.
// In < 2.4 we used microtasks everywhere, but there are some scenarios where
// microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using (macro) tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use microtask by default, but expose a way to force (macro) task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine microtask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a (macro) task instead of a microtask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$1 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$1; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    hooks[key] = componentVNodeHooks[key];
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    // reset _rendered flag on slots for duplicate slot check
    if (false) {
      for (var key in vm.$slots) {
        // $flow-disable-line
        vm.$slots[key]._rendered = false;
      }
    }

    if (_parentVnode) {
      vm.$scopedSlots = _parentVnode.data.scopedSlots || emptyObject;
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
}

var builtInComponents = {
  KeepAlive: KeepAlive
}

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.5.17';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
}

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
}

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
]

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
}

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
}

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = {
    value: value.trim()
  };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
}

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
}

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
}

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {}

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
]

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
}

var platformDirectives = {
  model: directive,
  show: show
}

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
}

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important, avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
}

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
}

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
}

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
}

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
}

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([^]*?)\s+(?:in|of)\s+([^]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
}

var modules$1 = [
  klass$1,
  style$1,
  model$2
]

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
}

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  esc: 'Escape',
  tab: 'Tab',
  enter: 'Enter',
  space: ' ',
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  'delete': ['Backspace', 'Delete']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
}

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(15), __webpack_require__(88).setImmediate))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var props = {
  disabled: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Close'
  },
  textVariant: {
    type: String,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners,
        slots = _ref.slots;

    var componentData = {
      staticClass: 'close',
      class: _defineProperty({}, 'text-' + props.textVariant, props.textVariant),
      attrs: {
        type: 'button',
        disabled: props.disabled,
        'aria-label': props.ariaLabel ? String(props.ariaLabel) : null
      },
      on: {
        click: function click(e) {
          // Ensure click on button HTML content is also disabled
          if (props.disabled && e instanceof Event) {
            e.stopPropagation();
            e.preventDefault();
          }
        }
      }
      // Careful not to override the slot with innerHTML
    };if (!slots().default) {
      componentData.domProps = { innerHTML: '&times;' };
    }
    return h('button', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), slots().default);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__link_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var btnProps = {
  block: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: null
  },
  variant: {
    type: String,
    default: null
  },
  type: {
    type: String,
    default: 'button'
  },
  pressed: {
    // tri-state prop: true, false or null
    // => on, off, not a toggle
    type: Boolean,
    default: null
  }
};

var linkProps = Object(__WEBPACK_IMPORTED_MODULE_5__link_link__["c" /* propsFactory */])();
delete linkProps.href.default;
delete linkProps.to.default;
var linkPropKeys = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["e" /* keys */])(linkProps);

var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])(linkProps, btnProps);

function handleFocus(evt) {
  if (evt.type === 'focusin') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["a" /* addClass */])(evt.target, 'focus');
  } else if (evt.type === 'focusout') {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_dom__["s" /* removeClass */])(evt.target, 'focus');
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        listeners = _ref.listeners,
        children = _ref.children;

    var isLink = Boolean(props.href || props.to);
    var isToggle = typeof props.pressed === 'boolean';
    var on = {
      click: function click(e) {
        if (props.disabled && e instanceof Event) {
          e.stopPropagation();
          e.preventDefault();
        } else if (isToggle) {
          // Concat will normalize the value to an array
          // without double wrapping an array value in an array.
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_array__["b" /* concat */])(listeners['update:pressed']).forEach(function (fn) {
            if (typeof fn === 'function') {
              fn(!props.pressed);
            }
          });
        }
      }
    };

    if (isToggle) {
      on.focusin = handleFocus;
      on.focusout = handleFocus;
    }

    var componentData = {
      staticClass: 'btn',
      class: [props.variant ? 'btn-' + props.variant : 'btn-secondary', (_ref2 = {}, _defineProperty(_ref2, 'btn-' + props.size, Boolean(props.size)), _defineProperty(_ref2, 'btn-block', props.block), _defineProperty(_ref2, 'disabled', props.disabled), _defineProperty(_ref2, 'active', props.pressed), _ref2)],
      props: isLink ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a" /* default */])(linkPropKeys, props) : null,
      attrs: {
        type: isLink ? null : props.type,
        disabled: isLink ? null : props.disabled,
        // Data attribute not used for js logic,
        // but only for BS4 style selectors.
        'data-toggle': isToggle ? 'button' : null,
        'aria-pressed': isToggle ? String(props.pressed) : null,
        // Tab index is used when the component becomes a link.
        // Links are tabable, but don't allow disabled,
        // so we mimic that functionality by disabling tabbing.
        tabindex: props.disabled && isLink ? '-1' : data.attrs ? data.attrs['tabindex'] : null
      },
      on: on
    };

    return h(isLink ? __WEBPACK_IMPORTED_MODULE_5__link_link__["a" /* default */] : 'button', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propsFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_group_text__ = __webpack_require__(29);



var propsFactory = function propsFactory(append) {
  return {
    id: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'div'
    },
    append: {
      type: Boolean,
      default: append
    },
    isText: {
      type: Boolean,
      default: false
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: propsFactory(false),
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'input-group-' + (props.append ? 'append' : 'prepend'),
      attrs: {
        id: props.id
      }
    }), props.isText ? [h(__WEBPACK_IMPORTED_MODULE_1__input_group_text__["a" /* default */], children)] : children);
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: props,
  functional: true,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'input-group-text'
    }), children);
  }
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// Blank image with fill template
var BLANK_TEMPLATE = '<svg width="%{w}" height="%{h}" ' + 'xmlns="http://www.w3.org/2000/svg" ' + 'viewBox="0 0 %{w} %{h}" preserveAspectRatio="none">' + '<rect width="100%" height="100%" style="fill:%{f};"></rect>' + '</svg>';

function makeBlankImgSrc(width, height, color) {
  var src = encodeURIComponent(BLANK_TEMPLATE.replace('%{w}', String(width)).replace('%{h}', String(height)).replace('%{f}', color));
  return 'data:image/svg+xml;charset=UTF-8,' + src;
}

var props = {
  src: {
    type: String,
    default: null
  },
  alt: {
    type: String,
    default: null
  },
  width: {
    type: [Number, String],
    default: null
  },
  height: {
    type: [Number, String],
    default: null
  },
  block: {
    type: Boolean,
    default: false
  },
  fluid: {
    type: Boolean,
    default: false
  },
  fluidGrow: {
    // Gives fluid images class `w-100` to make them grow to fit container
    type: Boolean,
    default: false
  },
  rounded: {
    // rounded can be:
    //   false: no rounding of corners
    //   true: slightly rounded corners
    //   'top': top corners rounded
    //   'right': right corners rounded
    //   'bottom': bottom corners rounded
    //   'left': left corners rounded
    //   'circle': circle/oval
    //   '0': force rounding off
    type: [Boolean, String],
    default: false
  },
  thumbnail: {
    type: Boolean,
    default: false
  },
  left: {
    type: Boolean,
    default: false
  },
  right: {
    type: Boolean,
    default: false
  },
  center: {
    type: Boolean,
    default: false
  },
  blank: {
    type: Boolean,
    default: false
  },
  blankColor: {
    type: String,
    default: 'transparent'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data;

    var src = props.src;
    var width = parseInt(props.width, 10) ? parseInt(props.width, 10) : null;
    var height = parseInt(props.height, 10) ? parseInt(props.height, 10) : null;
    var align = null;
    var block = props.block;
    if (props.blank) {
      if (!height && Boolean(width)) {
        height = width;
      } else if (!width && Boolean(height)) {
        width = height;
      }
      if (!width && !height) {
        width = 1;
        height = 1;
      }
      // Make a blank SVG image
      src = makeBlankImgSrc(width, height, props.blankColor || 'transparent');
    }
    if (props.left) {
      align = 'float-left';
    } else if (props.right) {
      align = 'float-right';
    } else if (props.center) {
      align = 'mx-auto';
      block = true;
    }
    return h('img', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      attrs: {
        'src': src,
        'alt': props.alt,
        'width': width ? String(width) : null,
        'height': height ? String(height) : null
      },
      class: (_class = {
        'img-thumbnail': props.thumbnail,
        'img-fluid': props.fluid || props.fluidGrow,
        'w-100': props.fluidGrow,
        'rounded': props.rounded === '' || props.rounded === true
      }, _defineProperty(_class, 'rounded-' + props.rounded, typeof props.rounded === 'string' && props.rounded !== ''), _defineProperty(_class, align, Boolean(align)), _defineProperty(_class, 'd-block', block), _class)
    }));
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'form-row'
    }), children);
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dropdown__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_item__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown_header__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_plugins__ = __webpack_require__(1);







var components = {
  bDropdown: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a" /* default */],
  bDd: __WEBPACK_IMPORTED_MODULE_0__dropdown__["a" /* default */],
  bDropdownItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a" /* default */],
  bDdItem: __WEBPACK_IMPORTED_MODULE_1__dropdown_item__["a" /* default */],
  bDropdownItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* default */],
  bDropdownItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* default */],
  bDdItemButton: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* default */],
  bDdItemBtn: __WEBPACK_IMPORTED_MODULE_2__dropdown_item_button__["a" /* default */],
  bDropdownHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a" /* default */],
  bDdHeader: __WEBPACK_IMPORTED_MODULE_3__dropdown_header__["a" /* default */],
  bDropdownDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a" /* default */],
  bDdDivider: __WEBPACK_IMPORTED_MODULE_4__dropdown_divider__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var BvEvent = function () {
  function BvEvent(type) {
    var eventInit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, BvEvent);

    // Start by emulating native Event constructor.
    if (!type) {
      throw new TypeError('Failed to construct \'' + this.constructor.name + '\'. 1 argument required, ' + arguments.length + ' given.');
    }
    // Assign defaults first, the eventInit,
    // and the type last so it can't be overwritten.
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(this, BvEvent.defaults(), eventInit, { type: type });
    // Freeze some props as readonly, but leave them enumerable.
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["c" /* defineProperties */])(this, {
      type: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])(),
      cancelable: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])(),
      nativeEvent: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])(),
      target: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])(),
      relatedTarget: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])(),
      vueTarget: Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["f" /* readonlyDescriptor */])()
    });
    // Create a private variable using closure scoping.
    var defaultPrevented = false;
    // Recreate preventDefault method. One way setter.
    this.preventDefault = function preventDefault() {
      if (this.cancelable) {
        defaultPrevented = true;
      }
    };
    // Create 'defaultPrevented' publicly accessible prop
    // that can only be altered by the preventDefault method.
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["d" /* defineProperty */])(this, 'defaultPrevented', {
      enumerable: true,
      get: function get() {
        return defaultPrevented;
      }
    });
  }

  _createClass(BvEvent, null, [{
    key: 'defaults',
    value: function defaults() {
      return {
        type: '',
        cancelable: true,
        nativeEvent: null,
        target: null,
        relatedTarget: null,
        vueTarget: null
      };
    }
  }]);

  return BvEvent;
}();

/* harmony default export */ __webpack_exports__["a"] = (BvEvent);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object';
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 * Returns boolean true or false
 */
function looseEqual(a, b) {
  if (a === b) return true;
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Object(__WEBPACK_IMPORTED_MODULE_0__array__["d" /* isArray */])(a);
      var isArrayB = Object(__WEBPACK_IMPORTED_MODULE_0__array__["d" /* isArray */])(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i]);
        });
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object(__WEBPACK_IMPORTED_MODULE_1__object__["e" /* keys */])(a);
        var keysB = Object(__WEBPACK_IMPORTED_MODULE_1__object__["e" /* keys */])(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key]);
        });
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b);
  } else {
    return false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (looseEqual);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);



function isObject(obj) {
  return obj && {}.toString.call(obj) === '[object Object]';
}

/* harmony default export */ __webpack_exports__["a"] = ({

  props: {
    options: {
      type: [Array, Object],
      default: function _default() {
        return [];
      }
    },
    valueField: {
      type: String,
      default: 'value'
    },
    textField: {
      type: String,
      default: 'text'
    },
    disabledField: {
      type: String,
      default: 'disabled'
    }
  },
  computed: {
    formOptions: function formOptions() {
      var options = this.options;

      var valueField = this.valueField;
      var textField = this.textField;
      var disabledField = this.disabledField;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["d" /* isArray */])(options)) {
        // Normalize flat-ish arrays to Array of Objects
        return options.map(function (option) {
          if (isObject(option)) {
            return {
              value: option[valueField],
              text: String(option[textField]),
              disabled: option[disabledField] || false
            };
          }
          return {
            value: option,
            text: String(option),
            disabled: false
          };
        });
      } else {
        // options is Object
        // Normalize Objects to Array of Objects
        return Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["e" /* keys */])(options).map(function (key) {
          var option = options[key] || {};
          if (isObject(option)) {
            var value = option[valueField];
            var text = option[textField];
            return {
              value: typeof value === 'undefined' ? key : value,
              text: typeof text === 'undefined' ? key : String(text),
              disabled: option[disabledField] || false
            };
          }
          return {
            value: key,
            text: String(option),
            disabled: false
          };
        });
      }
    }
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bv_event_class__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var NAME = 'tooltip';
var CLASS_PREFIX = 'bs-tooltip';
var BSCLS_PREFIX_REGEX = new RegExp('\\b' + CLASS_PREFIX + '\\S+', 'g');

var TRANSITION_DURATION = 150;

// Modal $root hidden event
var MODAL_CLOSE_EVENT = 'bv::modal::hidden';
// Modal container for appending tip/popover
var MODAL_CLASS = '.modal-content';

var AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
  TOPLEFT: 'top',
  TOPRIGHT: 'top',
  RIGHTTOP: 'right',
  RIGHTBOTTOM: 'right',
  BOTTOMLEFT: 'bottom',
  BOTTOMRIGHT: 'bottom',
  LEFTTOP: 'left',
  LEFTBOTTOM: 'left'
};

var OffsetMap = {
  AUTO: 0,
  TOPLEFT: -1,
  TOP: 0,
  TOPRIGHT: +1,
  RIGHTTOP: -1,
  RIGHT: 0,
  RIGHTBOTTOM: +1,
  BOTTOMLEFT: -1,
  BOTTOM: 0,
  BOTTOMRIGHT: +1,
  LEFTTOP: -1,
  LEFT: 0,
  LEFTBOTTOM: +1
};

var HoverState = {
  SHOW: 'show',
  OUT: 'out'
};

var ClassName = {
  FADE: 'fade',
  SHOW: 'show'
};

var Selector = {
  TOOLTIP: '.tooltip',
  TOOLTIP_INNER: '.tooltip-inner',
  ARROW: '.arrow'

  // ESLINT: Not used
  // const Trigger = {
  //   HOVER: 'hover',
  //   FOCUS: 'focus',
  //   CLICK: 'click',
  //   BLUR: 'blur',
  //   MANUAL: 'manual'
  // }

};var Defaults = {
  animation: true,
  template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div>' + '</div>',
  trigger: 'hover focus',
  title: '',
  delay: 0,
  html: false,
  placement: 'top',
  offset: 0,
  arrowPadding: 6,
  container: false,
  fallbackPlacement: 'flip',
  callbacks: {},
  boundary: 'scrollParent'

  // Transition Event names
};var TransitionEndEvents = {
  WebkitTransition: ['webkitTransitionEnd'],
  MozTransition: ['transitionend'],
  OTransition: ['otransitionend', 'oTransitionEnd'],
  transition: ['transitionend']

  // Client Side Tip ID counter for aria-describedby attribute
  // Could use Alex's uid generator util
  // Each tooltip requires a unique client side ID
};var NEXTID = 1;
/* istanbul ignore next */
function generateId(name) {
  return '__BV_' + name + '_' + NEXTID++ + '__';
}

/*
 * ToolTip Class definition
 */
/* istanbul ignore next: difficult to test in Jest/JSDOM environment */

var ToolTip = function () {
  // Main constructor
  function ToolTip(element, config, $root) {
    _classCallCheck(this, ToolTip);

    // New tooltip object
    this.$isEnabled = true;
    this.$fadeTimeout = null;
    this.$hoverTimeout = null;
    this.$visibleInterval = null;
    this.$hoverState = '';
    this.$activeTrigger = {};
    this.$popper = null;
    this.$element = element;
    this.$tip = null;
    this.$id = generateId(this.constructor.NAME);
    this.$root = $root || null;
    this.$routeWatcher = null;
    // We use a bound version of the following handlers for root/modal listeners to maintain the 'this' context
    this.$forceHide = this.forceHide.bind(this);
    this.$doHide = this.doHide.bind(this);
    this.$doShow = this.doShow.bind(this);
    this.$doDisable = this.doDisable.bind(this);
    this.$doEnable = this.doEnable.bind(this);
    // Set the configuration
    this.updateConfig(config);
  }

  // NOTE: Overridden by PopOver class


  _createClass(ToolTip, [{
    key: 'updateConfig',


    // Update config
    value: function updateConfig(config) {
      // Merge config into defaults. We use "this" here because PopOver overrides Default
      var updatedConfig = Object(__WEBPACK_IMPORTED_MODULE_2__object__["a" /* assign */])({}, this.constructor.Default, config);

      // Sanitize delay
      if (config.delay && typeof config.delay === 'number') {
        updatedConfig.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      // Title for tooltip and popover
      if (config.title && typeof config.title === 'number') {
        updatedConfig.title = config.title.toString();
      }

      // Content only for popover
      if (config.content && typeof config.content === 'number') {
        updatedConfig.content = config.content.toString();
      }

      // Hide element original title if needed
      this.fixTitle();
      // Update the config
      this.$config = updatedConfig;
      // Stop/Restart listening
      this.unListen();
      this.listen();
    }

    // Destroy this instance

  }, {
    key: 'destroy',
    value: function destroy() {
      // Stop listening to trigger events
      this.unListen();
      // Disable while open listeners/watchers
      this.setWhileOpenListeners(false);
      // Clear any timeouts
      clearTimeout(this.$hoverTimeout);
      this.$hoverTimeout = null;
      clearTimeout(this.$fadeTimeout);
      this.$fadeTimeout = null;
      // Remove popper
      if (this.$popper) {
        this.$popper.destroy();
      }
      this.$popper = null;
      // Remove tip from document
      if (this.$tip && this.$tip.parentElement) {
        this.$tip.parentElement.removeChild(this.$tip);
      }
      this.$tip = null;
      // Null out other properties
      this.$id = null;
      this.$isEnabled = null;
      this.$root = null;
      this.$element = null;
      this.$config = null;
      this.$hoverState = null;
      this.$activeTrigger = null;
      this.$forceHide = null;
      this.$doHide = null;
      this.$doShow = null;
      this.$doDisable = null;
      this.$doEnable = null;
    }
  }, {
    key: 'enable',
    value: function enable() {
      // Create a non-cancelable BvEvent
      var enabledEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('enabled', {
        cancelable: false,
        target: this.$element,
        relatedTarget: null
      });
      this.$isEnabled = true;
      this.emitEvent(enabledEvt);
    }
  }, {
    key: 'disable',
    value: function disable() {
      // Create a non-cancelable BvEvent
      var disabledEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('disabled', {
        cancelable: false,
        target: this.$element,
        relatedTarget: null
      });
      this.$isEnabled = false;
      this.emitEvent(disabledEvt);
    }

    // Click toggler

  }, {
    key: 'toggle',
    value: function toggle(event) {
      if (!this.$isEnabled) {
        return;
      }
      if (event) {
        this.$activeTrigger.click = !this.$activeTrigger.click;

        if (this.isWithActiveTrigger()) {
          this.enter(null);
        } else {
          this.leave(null);
        }
      } else {
        if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["j" /* hasClass */])(this.getTipElement(), ClassName.SHOW)) {
          this.leave(null);
        } else {
          this.enter(null);
        }
      }
    }

    // Show tooltip

  }, {
    key: 'show',
    value: function show() {
      var _this = this;

      if (!document.body.contains(this.$element) || !Object(__WEBPACK_IMPORTED_MODULE_4__dom__["m" /* isVisible */])(this.$element)) {
        // If trigger element isn't in the DOM or is not visible
        return;
      }
      // Build tooltip element (also sets this.$tip)
      var tip = this.getTipElement();
      this.fixTitle();
      this.setContent(tip);
      if (!this.isWithContent(tip)) {
        // if No content, don't bother showing
        this.$tip = null;
        return;
      }

      // Set ID on tip and aria-describedby on element
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["v" /* setAttr */])(tip, 'id', this.$id);
      this.addAriaDescribedby();

      // Set animation on or off
      if (this.$config.animation) {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["a" /* addClass */])(tip, ClassName.FADE);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.FADE);
      }

      var placement = this.getPlacement();
      var attachment = this.constructor.getAttachment(placement);
      this.addAttachmentClass(attachment);

      // Create a cancelable BvEvent
      var showEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('show', {
        cancelable: true,
        target: this.$element,
        relatedTarget: tip
      });
      this.emitEvent(showEvt);
      if (showEvt.defaultPrevented) {
        // Don't show if event cancelled
        this.$tip = null;
        return;
      }

      // Insert tooltip if needed
      var container = this.getContainer();
      if (!document.body.contains(tip)) {
        container.appendChild(tip);
      }

      // Refresh popper
      this.removePopper();
      this.$popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](this.$element, tip, this.getPopperConfig(placement, tip));

      // Transitionend Callback
      var complete = function complete() {
        if (_this.$config.animation) {
          _this.fixTransition(tip);
        }
        var prevHoverState = _this.$hoverState;
        _this.$hoverState = null;
        if (prevHoverState === HoverState.OUT) {
          _this.leave(null);
        }
        // Create a non-cancelable BvEvent
        var shownEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('shown', {
          cancelable: false,
          target: _this.$element,
          relatedTarget: tip
        });
        _this.emitEvent(shownEvt);
      };

      // Enable while open listeners/watchers
      this.setWhileOpenListeners(true);

      // Show tip
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["a" /* addClass */])(tip, ClassName.SHOW);

      // Start the transition/animation
      this.transitionOnce(tip, complete);
    }

    // handler for periodic visibility check

  }, {
    key: 'visibleCheck',
    value: function visibleCheck(on) {
      var _this2 = this;

      clearInterval(this.$visibleInterval);
      this.$visibleInterval = null;
      if (on) {
        this.$visibleInterval = setInterval(function () {
          var tip = _this2.getTipElement();
          if (tip && !Object(__WEBPACK_IMPORTED_MODULE_4__dom__["m" /* isVisible */])(_this2.$element) && Object(__WEBPACK_IMPORTED_MODULE_4__dom__["j" /* hasClass */])(tip, ClassName.SHOW)) {
            // Element is no longer visible, so force-hide the tooltip
            _this2.forceHide();
          }
        }, 100);
      }
    }
  }, {
    key: 'setWhileOpenListeners',
    value: function setWhileOpenListeners(on) {
      // Modal close events
      this.setModalListener(on);
      // Periodic $element visibility check
      // For handling when tip is in <keepalive>, tabs, carousel, etc
      this.visibleCheck(on);
      // Route change events
      this.setRouteWatcher(on);
      // Ontouch start listeners
      this.setOnTouchStartListener(on);
      if (on && /(focus|blur)/.test(this.$config.trigger)) {
        // If focus moves between trigger element and tip container, dont close
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(this.$tip, 'focusout', this);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["c" /* eventOff */])(this.$tip, 'focusout', this);
      }
    }

    // force hide of tip (internal method)

  }, {
    key: 'forceHide',
    value: function forceHide() {
      if (!this.$tip || !Object(__WEBPACK_IMPORTED_MODULE_4__dom__["j" /* hasClass */])(this.$tip, ClassName.SHOW)) {
        return;
      }
      // Disable while open listeners/watchers
      this.setWhileOpenListeners(false);
      // Clear any hover enter/leave event
      clearTimeout(this.$hoverTimeout);
      this.$hoverTimeout = null;
      this.$hoverState = '';
      // Hide the tip
      this.hide(null, true);
    }

    // Hide tooltip

  }, {
    key: 'hide',
    value: function hide(callback, force) {
      var _this3 = this;

      var tip = this.$tip;
      if (!tip) {
        return;
      }

      // Create a canelable BvEvent
      var hideEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('hide', {
        // We disable cancelling if force is true
        cancelable: !force,
        target: this.$element,
        relatedTarget: tip
      });
      this.emitEvent(hideEvt);
      if (hideEvt.defaultPrevented) {
        // Don't hide if event cancelled
        return;
      }

      // Transitionend Callback
      /* istanbul ignore next */
      var complete = function complete() {
        if (_this3.$hoverState !== HoverState.SHOW && tip.parentNode) {
          // Remove tip from dom, and force recompile on next show
          tip.parentNode.removeChild(tip);
          _this3.removeAriaDescribedby();
          _this3.removePopper();
          _this3.$tip = null;
        }
        if (callback) {
          callback();
        }
        // Create a non-cancelable BvEvent
        var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_1__bv_event_class__["a" /* default */]('hidden', {
          cancelable: false,
          target: _this3.$element,
          relatedTarget: null
        });
        _this3.emitEvent(hiddenEvt);
      };

      // Disable while open listeners/watchers
      this.setWhileOpenListeners(false);

      // If forced close, disable animation
      if (force) {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.FADE);
      }
      // Hide tip
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.SHOW);

      this.$activeTrigger.click = false;
      this.$activeTrigger.focus = false;
      this.$activeTrigger.hover = false;

      // Start the hide transition
      this.transitionOnce(tip, complete);

      this.$hoverState = '';
    }
  }, {
    key: 'emitEvent',
    value: function emitEvent(evt) {
      var evtName = evt.type;
      if (this.$root && this.$root.$emit) {
        // Emit an event on $root
        this.$root.$emit('bv::' + this.constructor.NAME + '::' + evtName, evt);
      }
      var callbacks = this.$config.callbacks || {};
      if (typeof callbacks[evtName] === 'function') {
        callbacks[evtName](evt);
      }
    }
  }, {
    key: 'getContainer',
    value: function getContainer() {
      var container = this.$config.container;
      var body = document.body;
      // If we are in a modal, we append to the modal instead of body, unless a container is specified
      return container === false ? Object(__WEBPACK_IMPORTED_MODULE_4__dom__["b" /* closest */])(MODAL_CLASS, this.$element) || body : Object(__WEBPACK_IMPORTED_MODULE_4__dom__["t" /* select */])(container, body) || body;
    }

    // Will be overritten by popover if needed

  }, {
    key: 'addAriaDescribedby',
    value: function addAriaDescribedby() {
      // Add aria-describedby on trigger element, without removing any other IDs
      var desc = Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(this.$element, 'aria-describedby') || '';
      desc = desc.split(/\s+/).concat(this.$id).join(' ').trim();
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["v" /* setAttr */])(this.$element, 'aria-describedby', desc);
    }

    // Will be overritten by popover if needed

  }, {
    key: 'removeAriaDescribedby',
    value: function removeAriaDescribedby() {
      var _this4 = this;

      var desc = Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(this.$element, 'aria-describedby') || '';
      desc = desc.split(/\s+/).filter(function (d) {
        return d !== _this4.$id;
      }).join(' ').trim();
      if (desc) {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["v" /* setAttr */])(this.$element, 'aria-describedby', desc);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["r" /* removeAttr */])(this.$element, 'aria-describedby');
      }
    }
  }, {
    key: 'removePopper',
    value: function removePopper() {
      if (this.$popper) {
        this.$popper.destroy();
      }
      this.$popper = null;
    }

    /* istanbul ignore next */

  }, {
    key: 'transitionOnce',
    value: function transitionOnce(tip, complete) {
      var _this5 = this;

      var transEvents = this.getTransitionEndEvents();
      var called = false;
      clearTimeout(this.$fadeTimeout);
      this.$fadeTimeout = null;
      var fnOnce = function fnOnce() {
        if (called) {
          return;
        }
        called = true;
        clearTimeout(_this5.$fadeTimeout);
        _this5.$fadeTimeout = null;
        transEvents.forEach(function (evtName) {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["c" /* eventOff */])(tip, evtName, fnOnce);
        });
        // Call complete callback
        complete();
      };
      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["j" /* hasClass */])(tip, ClassName.FADE)) {
        transEvents.forEach(function (evtName) {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(tip, evtName, fnOnce);
        });
        // Fallback to setTimeout
        this.$fadeTimeout = setTimeout(fnOnce, TRANSITION_DURATION);
      } else {
        fnOnce();
      }
    }

    // What transitionend event(s) to use? (returns array of event names)

  }, {
    key: 'getTransitionEndEvents',
    value: function getTransitionEndEvents() {
      for (var name in TransitionEndEvents) {
        if (this.$element.style[name] !== undefined) {
          return TransitionEndEvents[name];
        }
      }
      // fallback
      return [];
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.$popper !== null) {
        this.$popper.scheduleUpdate();
      }
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'isWithContent',
    value: function isWithContent(tip) {
      tip = tip || this.$tip;
      if (!tip) {
        return false;
      }
      return Boolean((Object(__WEBPACK_IMPORTED_MODULE_4__dom__["t" /* select */])(Selector.TOOLTIP_INNER, tip) || {}).innerHTML);
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'addAttachmentClass',
    value: function addAttachmentClass(attachment) {
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["a" /* addClass */])(this.getTipElement(), CLASS_PREFIX + '-' + attachment);
    }
  }, {
    key: 'getTipElement',
    value: function getTipElement() {
      if (!this.$tip) {
        // Try and compile user supplied template, or fallback to default template
        this.$tip = this.compileTemplate(this.$config.template) || this.compileTemplate(this.constructor.Default.template);
      }
      // Add tab index so tip can be focused, and to allow it to be set as relatedTargt in focusin/out events
      this.$tip.tabIndex = -1;
      return this.$tip;
    }
  }, {
    key: 'compileTemplate',
    value: function compileTemplate(html) {
      if (!html || typeof html !== 'string') {
        return null;
      }
      var div = document.createElement('div');
      div.innerHTML = html.trim();
      var node = div.firstElementChild ? div.removeChild(div.firstElementChild) : null;
      div = null;
      return node;
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'setContent',
    value: function setContent(tip) {
      this.setElementContent(Object(__WEBPACK_IMPORTED_MODULE_4__dom__["t" /* select */])(Selector.TOOLTIP_INNER, tip), this.getTitle());
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.FADE);
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.SHOW);
    }
  }, {
    key: 'setElementContent',
    value: function setElementContent(container, content) {
      if (!container) {
        // If container element doesn't exist, just return
        return;
      }
      var allowHtml = this.$config.html;
      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && content.nodeType) {
        // content is a DOM node
        if (allowHtml) {
          if (content.parentElement !== container) {
            container.innerHtml = '';
            container.appendChild(content);
          }
        } else {
          container.innerText = content.innerText;
        }
      } else {
        // We have a plain HTML string or Text
        container[allowHtml ? 'innerHTML' : 'innerText'] = content;
      }
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'getTitle',
    value: function getTitle() {
      var title = this.$config.title || '';
      if (typeof title === 'function') {
        // Call the function to get the title value
        title = title(this.$element);
      }
      if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object' && title.nodeType && !title.innerHTML.trim()) {
        // We have a DOM node, but without inner content, so just return empty string
        title = '';
      }
      if (typeof title === 'string') {
        title = title.trim();
      }
      if (!title) {
        // If an explicit title is not given, try element's title atributes
        title = Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(this.$element, 'title') || Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(this.$element, 'data-original-title') || '';
        title = title.trim();
      }

      return title;
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this6 = this;

      var triggers = this.$config.trigger.trim().split(/\s+/);
      var el = this.$element;

      // Listen for global show/hide events
      this.setRootListener(true);

      // Using 'this' as the handler will get automagically directed to this.handleEvent
      // And maintain our binding to 'this'
      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'click', _this6);
        } else if (trigger === 'focus') {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'focusin', _this6);
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'focusout', _this6);
        } else if (trigger === 'blur') {
          // Used to close $tip when element looses focus
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'focusout', _this6);
        } else if (trigger === 'hover') {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'mouseenter', _this6);
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'mouseleave', _this6);
        }
      }, this);
    }
  }, {
    key: 'unListen',
    value: function unListen() {
      var _this7 = this;

      var events = ['click', 'focusin', 'focusout', 'mouseenter', 'mouseleave'];
      // Using "this" as the handler will get automagically directed to this.handleEvent
      events.forEach(function (evt) {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["c" /* eventOff */])(_this7.$element, evt, _this7);
      }, this);

      // Stop listening for global show/hide/enable/disable events
      this.setRootListener(false);
    }
  }, {
    key: 'handleEvent',
    value: function handleEvent(e) {
      // This special method allows us to use "this" as the event handlers
      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["k" /* isDisabled */])(this.$element)) {
        // If disabled, don't do anything. Note: if tip is shown before element gets
        // disabled, then tip not close until no longer disabled or forcefully closed.
        return;
      }
      if (!this.$isEnabled) {
        // If not enable
        return;
      }
      var type = e.type;
      var target = e.target;
      var relatedTarget = e.relatedTarget;
      var $element = this.$element;
      var $tip = this.$tip;
      if (type === 'click') {
        this.toggle(e);
      } else if (type === 'focusin' || type === 'mouseenter') {
        this.enter(e);
      } else if (type === 'focusout') {
        // target is the element which is loosing focus
        // And relatedTarget is the element gaining focus
        if ($tip && $element && $element.contains(target) && $tip.contains(relatedTarget)) {
          // If focus moves from $element to $tip, don't trigger a leave
          return;
        }
        if ($tip && $element && $tip.contains(target) && $element.contains(relatedTarget)) {
          // If focus moves from $tip to $element, don't trigger a leave
          return;
        }
        if ($tip && $tip.contains(target) && $tip.contains(relatedTarget)) {
          // If focus moves within $tip, don't trigger a leave
          return;
        }
        if ($element && $element.contains(target) && $element.contains(relatedTarget)) {
          // If focus moves within $element, don't trigger a leave
          return;
        }
        // Otherwise trigger a leave
        this.leave(e);
      } else if (type === 'mouseleave') {
        this.leave(e);
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'setRouteWatcher',
    value: function setRouteWatcher(on) {
      var _this8 = this;

      if (on) {
        this.setRouteWatcher(false);
        if (this.$root && Boolean(this.$root.$route)) {
          this.$routeWatcher = this.$root.$watch('$route', function (newVal, oldVal) {
            if (newVal === oldVal) {
              return;
            }
            // If route has changed, we force hide the tooltip/popover
            _this8.forceHide();
          });
        }
      } else {
        if (this.$routeWatcher) {
          // cancel the route watcher by calling hte stored reference
          this.$routeWatcher();
          this.$routeWatcher = null;
        }
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'setModalListener',
    value: function setModalListener(on) {
      var modal = Object(__WEBPACK_IMPORTED_MODULE_4__dom__["b" /* closest */])(MODAL_CLASS, this.$element);
      if (!modal) {
        // If we are not in a modal, don't worry. be happy
        return;
      }
      // We can listen for modal hidden events on $root
      if (this.$root) {
        this.$root[on ? '$on' : '$off'](MODAL_CLOSE_EVENT, this.$forceHide);
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'setRootListener',
    value: function setRootListener(on) {
      // Listen for global 'bv::{hide|show}::{tooltip|popover}' hide request event
      if (this.$root) {
        this.$root[on ? '$on' : '$off']('bv::hide::' + this.constructor.NAME, this.$doHide);
        this.$root[on ? '$on' : '$off']('bv::show::' + this.constructor.NAME, this.$doShow);
        this.$root[on ? '$on' : '$off']('bv::disable::' + this.constructor.NAME, this.$doDisable);
        this.$root[on ? '$on' : '$off']('bv::enable::' + this.constructor.NAME, this.$doEnable);
      }
    }
  }, {
    key: 'doHide',
    value: function doHide(id) {
      // Programmatically hide tooltip or popover
      if (!id) {
        // Close all tooltips or popovers
        this.forceHide();
      } else if (this.$element && this.$element.id && this.$element.id === id) {
        // Close this specific tooltip or popover
        this.hide();
      }
    }
  }, {
    key: 'doShow',
    value: function doShow(id) {
      // Programmatically show tooltip or popover
      if (!id) {
        // Open all tooltips or popovers
        this.show();
      } else if (id && this.$element && this.$element.id && this.$element.id === id) {
        // Show this specific tooltip or popover
        this.show();
      }
    }
  }, {
    key: 'doDisable',
    value: function doDisable(id) {
      // Programmatically disable tooltip or popover
      if (!id) {
        // Disable all tooltips or popovers
        this.disable();
      } else if (this.$element && this.$element.id && this.$element.id === id) {
        // Disable this specific tooltip or popover
        this.disable();
      }
    }
  }, {
    key: 'doEnable',
    value: function doEnable(id) {
      // Programmatically enable tooltip or popover
      if (!id) {
        // Enable all tooltips or popovers
        this.enable();
      } else if (this.$element && this.$element.id && this.$element.id === id) {
        // Enable this specific tooltip or popover
        this.enable();
      }
    }

    /* istanbul ignore next */

  }, {
    key: 'setOnTouchStartListener',
    value: function setOnTouchStartListener(on) {
      var _this9 = this;

      // if this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
      if ('ontouchstart' in document.documentElement) {
        Object(__WEBPACK_IMPORTED_MODULE_3__array__["c" /* from */])(document.body.children).forEach(function (el) {
          if (on) {
            Object(__WEBPACK_IMPORTED_MODULE_4__dom__["d" /* eventOn */])(el, 'mouseover', _this9._noop);
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_4__dom__["c" /* eventOff */])(el, 'mouseover', _this9._noop);
          }
        });
      }
    }

    /* istanbul ignore next */

  }, {
    key: '_noop',
    value: function _noop() {
      // Empty noop handler for ontouchstart devices
    }
  }, {
    key: 'fixTitle',
    value: function fixTitle() {
      var el = this.$element;
      var titleType = _typeof(Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(el, 'data-original-title'));
      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(el, 'title') || titleType !== 'string') {
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["v" /* setAttr */])(el, 'data-original-title', Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(el, 'title') || '');
        Object(__WEBPACK_IMPORTED_MODULE_4__dom__["v" /* setAttr */])(el, 'title', '');
      }
    }

    // Enter handler
    /* istanbul ignore next */

  }, {
    key: 'enter',
    value: function enter(e) {
      var _this10 = this;

      if (e) {
        this.$activeTrigger[e.type === 'focusin' ? 'focus' : 'hover'] = true;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["j" /* hasClass */])(this.getTipElement(), ClassName.SHOW) || this.$hoverState === HoverState.SHOW) {
        this.$hoverState = HoverState.SHOW;
        return;
      }
      clearTimeout(this.$hoverTimeout);
      this.$hoverState = HoverState.SHOW;
      if (!this.$config.delay || !this.$config.delay.show) {
        this.show();
        return;
      }
      this.$hoverTimeout = setTimeout(function () {
        if (_this10.$hoverState === HoverState.SHOW) {
          _this10.show();
        }
      }, this.$config.delay.show);
    }

    // Leave handler
    /* istanbul ignore next */

  }, {
    key: 'leave',
    value: function leave(e) {
      var _this11 = this;

      if (e) {
        this.$activeTrigger[e.type === 'focusout' ? 'focus' : 'hover'] = false;
        if (e.type === 'focusout' && /blur/.test(this.$config.trigger)) {
          // Special case for `blur`: we clear out the other triggers
          this.$activeTrigger.click = false;
          this.$activeTrigger.hover = false;
        }
      }
      if (this.isWithActiveTrigger()) {
        return;
      }
      clearTimeout(this.$hoverTimeout);
      this.$hoverState = HoverState.OUT;
      if (!this.$config.delay || !this.$config.delay.hide) {
        this.hide();
        return;
      }
      this.$hoverTimeout = setTimeout(function () {
        if (_this11.$hoverState === HoverState.OUT) {
          _this11.hide();
        }
      }, this.$config.delay.hide);
    }
  }, {
    key: 'getPopperConfig',
    value: function getPopperConfig(placement, tip) {
      var _this12 = this;

      return {
        placement: this.constructor.getAttachment(placement),
        modifiers: {
          offset: { offset: this.getOffset(placement, tip) },
          flip: { behavior: this.$config.fallbackPlacement },
          arrow: { element: '.arrow' },
          preventOverflow: { boundariesElement: this.$config.boundary }
        },
        onCreate: function onCreate(data) {
          // Handle flipping arrow classes
          if (data.originalPlacement !== data.placement) {
            _this12.handlePopperPlacementChange(data);
          }
        },
        onUpdate: function onUpdate(data) {
          // Handle flipping arrow classes
          _this12.handlePopperPlacementChange(data);
        }
      };
    }
  }, {
    key: 'getOffset',
    value: function getOffset(placement, tip) {
      if (!this.$config.offset) {
        var arrow = Object(__WEBPACK_IMPORTED_MODULE_4__dom__["t" /* select */])(Selector.ARROW, tip);
        var arrowOffset = parseFloat(Object(__WEBPACK_IMPORTED_MODULE_4__dom__["h" /* getCS */])(arrow).width) + parseFloat(this.$config.arrowPadding);
        switch (OffsetMap[placement.toUpperCase()]) {
          case +1:
            return '+50%p - ' + arrowOffset + 'px';
          case -1:
            return '-50%p + ' + arrowOffset + 'px';
          default:
            return 0;
        }
      }
      return this.$config.offset;
    }
  }, {
    key: 'getPlacement',
    value: function getPlacement() {
      var placement = this.$config.placement;
      if (typeof placement === 'function') {
        return placement.call(this, this.$tip, this.$element);
      }
      return placement;
    }
  }, {
    key: 'isWithActiveTrigger',
    value: function isWithActiveTrigger() {
      for (var trigger in this.$activeTrigger) {
        if (this.$activeTrigger[trigger]) {
          return true;
        }
      }
      return false;
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'cleanTipClass',
    value: function cleanTipClass() {
      var tip = this.getTipElement();
      var tabClass = tip.className.match(BSCLS_PREFIX_REGEX);
      if (tabClass !== null && tabClass.length > 0) {
        tabClass.forEach(function (cls) {
          Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, cls);
        });
      }
    }
  }, {
    key: 'handlePopperPlacementChange',
    value: function handlePopperPlacementChange(data) {
      this.cleanTipClass();
      this.addAttachmentClass(this.constructor.getAttachment(data.placement));
    }
  }, {
    key: 'fixTransition',
    value: function fixTransition(tip) {
      var initConfigAnimation = this.$config.animation || false;
      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom__["e" /* getAttr */])(tip, 'x-placement') !== null) {
        return;
      }
      Object(__WEBPACK_IMPORTED_MODULE_4__dom__["s" /* removeClass */])(tip, ClassName.FADE);
      this.$config.animation = false;
      this.hide();
      this.show();
      this.$config.animation = initConfigAnimation;
    }
  }], [{
    key: 'getAttachment',
    value: function getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    }
  }, {
    key: 'Default',
    get: function get() {
      return Defaults;
    }

    // NOTE: Overridden by PopOver class

  }, {
    key: 'NAME',
    get: function get() {
      return NAME;
    }
  }]);

  return ToolTip;
}();

/* harmony default export */ __webpack_exports__["a"] = (ToolTip);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TopicValues */
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TopicValues = [{ value: 1, text: 'Demonstrationen/Studentenunruhen' }, { value: 2, text: 'Dutschke' }, { value: 3, text: 'Evangelische Kirche und Studenten' }, { value: 4, text: 'Hochschulreform' }, { value: 5, text: 'Kommune I/Teufel/etc.' }, { value: 6, text: 'Mahler' }, { value: 7, text: 'Schah/Ohnesorg/Kurras' }, { value: 8, text: 'SDS' }, { value: 9, text: 'Sonstiges' }, { value: 10, text: 'Springer' }, { value: 11, text: 'Universitäten (diverse Vorgänge)' }];

var MediaValues = [{ value: 1, text: 'BERLINER MORGENPOST' }, { value: 2, text: 'BILD (Berlin)' }, { value: 3, text: 'BILD am SONNTAG' }, { value: 4, text: 'DIE WELT (Berlin)' }, { value: 5, text: 'WELT am SONNTAG' }, { value: 6, text: 'B.Z.' }, { value: 7, text: 'HAMBURGER ABENDBLATT' }, { value: 8, text: 'Tagesspiegel', external: true }, { value: 9, text: 'Telegraf', external: true }];

var TextTypeValues = [{ value: 1, text: 'Bericht' }, { value: 2, text: 'Glosse' }, { value: 3, text: 'Interview' }, { value: 4, text: 'Karikatur' }, { value: 5, text: 'Kommentar' }, { value: 6, text: 'Leserbrief' }, { value: 7, text: 'Reportage' }, { value: 8, text: 'Sonstiges' }];

var YesNoValues = [{ value: 1, text: 'Ja' }, { value: 2, text: 'Nein' }, { value: 3, text: 'Ristock als Demoteilnehmer' }, { value: 4, text: 'Porträt Schlamm' }, { value: 5, text: 'Karikatur von Oskar' }];

var PlacementValues = [{ value: 1, text: 'Aufmacher' }, { value: 2, text: 'Beisteller' }, { value: 3, text: 'Fuß' }, { value: 4, text: 'Ganzseite' }, { value: 5, text: 'Zweitstück' }];

var ExportFieldMapper = {
    'Dateinummer': 'id',
    'Thema': 'topic',
    'Objekt': 'object',
    'Datum': 'dateExport',
    'Ges-Umfang': 'pageCount',
    'Platzierung': 'place',
    'auf Seite(n)': 'page',
    'Überschrift': 'headline',
    'Dachzeile': 'kicker',
    'Unterzeile': 'subline',
    'Autoren': 'author',
    'Inhalt': 'content',
    'Abbildungen': 'illustration',
    'Textsorte': 'text'
};

var ExportFieldMeta = [[{
    'key': 'charset',
    'value': 'utf-8'
}]];

var LookUpHelper = function () {
    function LookUpHelper(val) {
        _classCallCheck(this, LookUpHelper);

        this.values = val;
        this.valueMap = {};
        this.textMap = {};

        for (var i = 0; i < this.values.length; i++) {
            this.valueMap[this.values[i].value] = i;
            this.textMap[this.values[i].text] = i;
        }
    }

    _createClass(LookUpHelper, [{
        key: 'getValues',
        value: function getValues(filter) {
            if (typeof filter == 'function') {
                return this.values.filter(filter);
            }

            return this.values;
        }
    }, {
        key: 'getTextMapByValue',
        value: function getTextMapByValue(idx) {
            var idxSlice = idx;
            var res = [];

            if (!Array.isArray(idxSlice)) {
                idxSlice = [idxSlice];
            }

            for (var i = 0; i < idxSlice.length; i++) {
                var val = this.getByValue(idxSlice[i]);
                if (val == false) {
                    continue;
                }

                res.push(val.text);
            }

            return res.join(', ');
        }
    }, {
        key: 'getByValue',
        value: function getByValue(idx) {
            var i = this.valueMap.hasOwnProperty(idx);
            if (i === true) {
                return this.values[this.valueMap[idx]];
            }

            return false;
        }
    }, {
        key: 'getByText',
        value: function getByText(idx) {
            var i = this.textMap.hasOwnProperty(idx);
            if (i === true) {
                return this.values[this.textMap[idx]];
            }

            return false;
        }
    }]);

    return LookUpHelper;
}();

var FieldMapper = function FieldMapper() {
    _classCallCheck(this, FieldMapper);

    this.topic = new LookUpHelper(TopicValues);
    this.media = new LookUpHelper(MediaValues);
    this.type = new LookUpHelper(TextTypeValues);
    this.placement = new LookUpHelper(PlacementValues);
    this.illustration = new LookUpHelper(YesNoValues);
    this.export = {
        fields: ExportFieldMapper,
        meta: ExportFieldMeta
    };
};

/* harmony default export */ __webpack_exports__["a"] = (new FieldMapper());

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = DateSmallDecorator;
/* harmony export (immutable) */ __webpack_exports__["a"] = DateObjectToExportDateDecorator;
/* harmony export (immutable) */ __webpack_exports__["e"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["d"] = ParseFormInputDate;
/* harmony export (immutable) */ __webpack_exports__["c"] = ParseDate;
// assuming that 1968-01-26 is the format of the date string
function DateSmallDecorator(date) {
    var y = date.substring(2, 4);
    var m = date.substring(5, 7);
    var d = date.substring(8, 10);

    return '' + d + '.' + m + '.' + y;
}

// transform date object to dd.mm.yyyy
function DateObjectToExportDateDecorator(date) {
    var y = date.getUTCFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();

    d = d.length < 2 ? '0' + d : d;
    m = m.length < 2 ? '0' + m : m;

    return '' + d + '.' + m + '.' + y;
}

function truncate(text, maxLength) {
    var useWordBoundary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var prepend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ' ...';

    // return if string is "to" short
    if (maxLength >= text.length) {
        return text;
    }

    var subString = text.substr(0, maxLength - 1);

    if (useWordBoundary) {
        subString = subString.substr(0, subString.lastIndexOf(' '));
    }

    return subString + prepend;
}

function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
}

// 31.12.1968
function ParseFormInputDate(date) {
    var y = date.substring(6, 10);
    var m = date.substring(3, 5);
    var d = date.substring(0, 2);

    var r = new Date('' + y + '-' + m + '-' + d);
    return isValidDate(r) ? r : false;
}

function ParseDate(date) {
    var y = date.substring(0, 4);
    var m = date.substring(5, 7);
    var d = date.substring(8, 10);

    var r = new Date('' + y + '-' + m + '-' + d);
    return isValidDate(r) ? r : false;
}

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
function identity(x) {
  return x;
}

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(41);




var props = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])({}, __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["b" /* props */], {
  text: {
    type: String,
    default: null
  },
  href: {
    type: String,
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h('li', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'breadcrumb-item',
      class: { active: props.active },
      attrs: { role: 'presentation' }
    }), [h(__WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["a" /* default */], { props: props }, children)]);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link_link__ = __webpack_require__(9);





var props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(Object(__WEBPACK_IMPORTED_MODULE_3__link_link__["c" /* propsFactory */])(), {
  text: {
    type: String,
    default: null
  },
  active: {
    type: Boolean,
    default: false
  },
  href: {
    type: String,
    default: '#'
  },
  ariaCurrent: {
    type: String,
    default: 'location'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var suppliedProps = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var tag = suppliedProps.active ? 'span' : __WEBPACK_IMPORTED_MODULE_3__link_link__["a" /* default */];

    var componentData = { props: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a" /* default */])(props, suppliedProps) };
    if (suppliedProps.active) {
      componentData.attrs = { 'aria-current': suppliedProps.ariaCurrent };
    } else {
      componentData.attrs = { href: suppliedProps.href };
    }

    return h(tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children || suppliedProps.text);
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_group_addon__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: Object(__WEBPACK_IMPORTED_MODULE_0__input_group_addon__["b" /* propsFactory */])(false),
  render: __WEBPACK_IMPORTED_MODULE_0__input_group_addon__["a" /* default */].render
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__input_group_addon__ = __webpack_require__(28);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: Object(__WEBPACK_IMPORTED_MODULE_0__input_group_addon__["b" /* propsFactory */])(true),
  render: __WEBPACK_IMPORTED_MODULE_0__input_group_addon__["a" /* default */].render
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = upperFirst;
/**
 * @param {string} str
 */
function upperFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(23);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'body')), {
  bodyClass: {
    type: [String, Object, Array],
    default: null
  },
  title: {
    type: String,
    default: null
  },
  titleTag: {
    type: String,
    default: 'h4'
  },
  subTitle: {
    type: String,
    default: null
  },
  subTitleTag: {
    type: String,
    default: 'h6'
  },
  overlay: {
    type: Boolean,
    default: false
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    var cardBodyChildren = [];
    if (props.title) {
      cardBodyChildren.push(h(props.titleTag, {
        staticClass: 'card-title',
        domProps: { innerHTML: props.title }
      }));
    }
    if (props.subTitle) {
      cardBodyChildren.push(h(props.subTitleTag, {
        staticClass: 'card-subtitle mb-2 text-muted',
        domProps: { innerHTML: props.subTitle }
      }));
    }
    cardBodyChildren.push(slots().default);

    return h(props.bodyTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-body',
      class: [(_ref2 = {
        'card-img-overlay': props.overlay
      }, _defineProperty(_ref2, 'bg-' + props.bodyBgVariant, Boolean(props.bodyBgVariant)), _defineProperty(_ref2, 'border-' + props.bodyBorderVariant, Boolean(props.bodyBorderVariant)), _defineProperty(_ref2, 'text-' + props.bodyTextVariant, Boolean(props.bodyTextVariant)), _ref2), props.bodyClass || {}]
    }), cardBodyChildren);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(23);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'header')), {
  header: {
    type: String,
    default: null
  },
  headerClass: {
    type: [String, Object, Array],
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        children = _ref.children;

    return h(props.headerTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-header',
      class: [props.headerClass, (_ref2 = {}, _defineProperty(_ref2, 'bg-' + props.headerBgVariant, Boolean(props.headerBgVariant)), _defineProperty(_ref2, 'border-' + props.headerBorderVariant, Boolean(props.headerBorderVariant)), _defineProperty(_ref2, 'text-' + props.headerTextVariant, Boolean(props.headerTextVariant)), _ref2)]
    }), children || [h('div', { domProps: { innerHTML: props.header } })]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_copyProps__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__ = __webpack_require__(23);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_2__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__mixins_card_mixin__["a" /* default */].props, __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'footer')), {
  footer: {
    type: String,
    default: null
  },
  footerClass: {
    type: [String, Object, Array],
    default: null
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _ref2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        children = _ref.children;

    return h(props.footerTag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card-footer',
      class: [props.footerClass, (_ref2 = {}, _defineProperty(_ref2, 'bg-' + props.footerBgVariant, Boolean(props.footerBgVariant)), _defineProperty(_ref2, 'border-' + props.footerBorderVariant, Boolean(props.footerBorderVariant)), _defineProperty(_ref2, 'text-' + props.footerTextVariant, Boolean(props.footerTextVariant)), _ref2)]
    }), children || [h('div', { domProps: { innerHTML: props.footer } })]);
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return props; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  src: {
    type: String,
    default: null,
    required: true
  },
  alt: {
    type: String,
    default: null
  },
  top: {
    type: Boolean,
    default: false
  },
  bottom: {
    type: Boolean,
    default: false
  },
  fluid: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    var staticClass = 'card-img';
    if (props.top) {
      staticClass += '-top';
    } else if (props.bottom) {
      staticClass += '-bottom';
    }

    return h('img', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: staticClass,
      class: { 'img-fluid': props.fluid },
      attrs: { src: props.src, alt: props.alt }
    }));
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  },
  fluid: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: {
        'container': !props.fluid,
        'container-fluid': props.fluid
      }
    }), children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__collapse__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_toggle__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bCollapse: __WEBPACK_IMPORTED_MODULE_0__collapse__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1__directives_toggle__["a" /* default */]);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toggle__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var directives = {
  bToggle: __WEBPACK_IMPORTED_MODULE_0__toggle__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* registerDirectives */])(Vue, directives);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindTargets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unbindTargets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);


var allListenTypes = { hover: true, click: true, focus: true };

var BVBoundListeners = '__BV_boundEventListeners__';

var bindTargets = function bindTargets(vnode, binding, listenTypes, fn) {
  var targets = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(binding.modifiers || {}).filter(function (t) {
    return !allListenTypes[t];
  });

  if (binding.value) {
    targets.push(binding.value);
  }

  var listener = function listener() {
    fn({ targets: targets, vnode: vnode });
  };

  Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(allListenTypes).forEach(function (type) {
    if (listenTypes[type] || binding.modifiers[type]) {
      vnode.elm.addEventListener(type, listener);
      var boundListeners = vnode.elm[BVBoundListeners] || {};
      boundListeners[type] = boundListeners[type] || [];
      boundListeners[type].push(listener);
      vnode.elm[BVBoundListeners] = boundListeners;
    }
  });

  // Return the list of targets
  return targets;
};

var unbindTargets = function unbindTargets(vnode, binding, listenTypes) {
  Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["e" /* keys */])(allListenTypes).forEach(function (type) {
    if (listenTypes[type] || binding.modifiers[type]) {
      var boundListeners = vnode.elm[BVBoundListeners] && vnode.elm[BVBoundListeners][type];
      if (boundListeners) {
        boundListeners.forEach(function (listener) {
          return vnode.elm.removeEventListener(type, listener);
        });
        delete vnode.elm[BVBoundListeners][type];
      }
    }
  });
};



/* harmony default export */ __webpack_exports__["b"] = (bindTargets);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__clickout__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listen_on_root__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bv_event_class__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dom__ = __webpack_require__(4);










// Return an Array of visible items
function filterVisible(els) {
  return (els || []).filter(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["m" /* isVisible */]);
}

// Dropdown item CSS selectors
// TODO: .dropdown-form handling
var ITEM_SELECTOR = '.dropdown-item:not(.disabled):not([disabled])';

// Popper attachment positions
var AttachmentMap = {
  // DropUp Left Align
  TOP: 'top-start',
  // DropUp Right Align
  TOPEND: 'top-end',
  // Dropdown left Align
  BOTTOM: 'bottom-start',
  // Dropdown Right Align
  BOTTOMEND: 'bottom-end'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__clickout__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__listen_on_root__["a" /* default */]],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      // Button label
      type: String,
      default: ''
    },
    dropup: {
      // place on top if possible
      type: Boolean,
      default: false
    },
    right: {
      // Right align menu (default is left align)
      type: Boolean,
      default: false
    },
    offset: {
      // Number of pixels to offset menu, or a CSS unit value (i.e. 1px, 1rem, etc)
      type: [Number, String],
      default: 0
    },
    noFlip: {
      // Disable auto-flipping of menu from bottom<=>top
      type: Boolean,
      default: false
    },
    popperOpts: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      visible: false,
      inNavbar: null,
      visibleChangePrevented: false
    };
  },
  created: function created() {
    // Create non-reactive property
    this._popper = null;
  },
  mounted: function mounted() {
    // To keep one dropdown opened on page
    this.listenOnRoot('bv::dropdown::shown', this.rootCloseListener);
    // Hide when clicked on links
    this.listenOnRoot('clicked::link', this.rootCloseListener);
    // Use new namespaced events
    this.listenOnRoot('bv::link::clicked', this.rootCloseListener);
  },

  /* istanbul ignore next: not easy to test */
  deactivated: function deactivated() {
    // In case we are inside a `<keep-alive>`
    this.visible = false;
    this.setTouchStart(false);
    this.removePopper();
  },

  /* istanbul ignore next: not easy to test */
  beforeDestroy: function beforeDestroy() {
    this.visible = false;
    this.setTouchStart(false);
    this.removePopper();
  },

  watch: {
    visible: function visible(newValue, oldValue) {
      if (this.visibleChangePrevented) {
        this.visibleChangePrevented = false;
        return;
      }

      if (newValue !== oldValue) {
        var evtName = newValue ? 'show' : 'hide';
        var bvEvt = new __WEBPACK_IMPORTED_MODULE_6__utils_bv_event_class__["a" /* default */](evtName, {
          cancelable: true,
          vueTarget: this,
          target: this.$refs.menu,
          relatedTarget: null
        });
        this.emitEvent(bvEvt);
        if (bvEvt.defaultPrevented) {
          // Reset value and exit if canceled
          this.visibleChangePrevented = true;
          this.visible = oldValue;
          return;
        }
        if (evtName === 'show') {
          this.showMenu();
        } else {
          this.hideMenu();
        }
      }
    },
    disabled: function disabled(newValue, oldValue) {
      if (newValue !== oldValue && newValue && this.visible) {
        // Hide dropdown if disabled changes to true
        this.visible = false;
      }
    }
  },
  computed: {
    toggler: function toggler() {
      return this.$refs.toggle.$el || this.$refs.toggle;
    }
  },
  methods: {
    // Event emitter
    emitEvent: function emitEvent(bvEvt) {
      var type = bvEvt.type;
      this.$emit(type, bvEvt);
      this.emitOnRoot('bv::dropdown::' + type, bvEvt);
    },
    showMenu: function showMenu() {
      if (this.disabled) {
        return;
      }
      // Ensure other menus are closed
      this.emitOnRoot('bv::dropdown::shown', this);

      // Are we in a navbar ?
      if (this.inNavbar === null && this.isNav) {
        this.inNavbar = Boolean(Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["b" /* closest */])('.navbar', this.$el));
      }

      // Disable totally Popper.js for Dropdown in Navbar
      /* istnbul ignore next: can't test popper in JSDOM */
      if (!this.inNavbar) {
        if (typeof __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */] === 'undefined') {
          Object(__WEBPACK_IMPORTED_MODULE_7__utils_warn__["a" /* default */])('b-dropdown: Popper.js not found. Falling back to CSS positioning.');
        } else {
          // for dropup with alignment we use the parent element as popper container
          var element = this.dropup && this.right || this.split ? this.$el : this.$refs.toggle;
          // Make sure we have a reference to an element, not a component!
          element = element.$el || element;
          // Instantiate popper.js
          this.createPopper(element);
        }
      }

      this.setTouchStart(true);
      this.$emit('shown');

      // Focus on the first item on show
      this.$nextTick(this.focusFirstItem);
    },
    hideMenu: function hideMenu() {
      this.setTouchStart(false);
      this.emitOnRoot('bv::dropdown::hidden', this);
      this.$emit('hidden');
      this.removePopper();
    },
    createPopper: function createPopper(element) {
      this.removePopper();
      this._popper = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](element, this.$refs.menu, this.getPopperConfig());
    },
    removePopper: function removePopper() {
      if (this._popper) {
        // Ensure popper event listeners are removed cleanly
        this._popper.destroy();
      }
      this._popper = null;
    },
    getPopperConfig /* istanbul ignore next: can't test popper in JSDOM */: function getPopperConfig() {
      var placement = AttachmentMap.BOTTOM;
      if (this.dropup && this.right) {
        // dropup + right
        placement = AttachmentMap.TOPEND;
      } else if (this.dropup) {
        // dropup + left
        placement = AttachmentMap.TOP;
      } else if (this.right) {
        // dropdown + right
        placement = AttachmentMap.BOTTOMEND;
      }
      var popperConfig = {
        placement: placement,
        modifiers: {
          offset: {
            offset: this.offset || 0
          },
          flip: {
            enabled: !this.noFlip
          }
        }
      };
      if (this.boundary) {
        popperConfig.modifiers.preventOverflow = {
          boundariesElement: this.boundary
        };
      }
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_object__["a" /* assign */])(popperConfig, this.popperOpts || {});
    },
    setTouchStart: function setTouchStart(on) {
      var _this = this;

      /*
       * If this is a touch-enabled device we add extra
       * empty mouseover listeners to the body's immediate children;
       * only needed because of broken event delegation on iOS
       * https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
       */
      if ('ontouchstart' in document.documentElement) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["c" /* from */])(document.body.children);
        children.forEach(function (el) {
          if (on) {
            Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["d" /* eventOn */])('mouseover', _this._noop);
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c" /* eventOff */])('mouseover', _this._noop);
          }
        });
      }
    },

    /* istanbul ignore next: not easy to test */
    _noop: function _noop() {
      // Do nothing event handler (used in touchstart event handler)
    },
    rootCloseListener: function rootCloseListener(vm) {
      if (vm !== this) {
        this.visible = false;
      }
    },
    clickOutListener: function clickOutListener() {
      this.visible = false;
    },
    show: function show() {
      // Public method to show dropdown
      if (this.disabled) {
        return;
      }
      this.visible = true;
    },
    hide: function hide() {
      // Public method to hide dropdown
      if (this.disabled) {
        return;
      }
      this.visible = false;
    },
    toggle: function toggle(evt) {
      // Called only by a button that toggles the menu
      evt = evt || {};
      var type = evt.type;
      var key = evt.keyCode;
      if (type !== 'click' && !(type === 'keydown' && (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].ENTER || key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].SPACE || key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].DOWN))) {
        // We only toggle on Click, Enter, Space, and Arrow Down
        return;
      }
      if (this.disabled) {
        this.visible = false;
        return;
      }
      this.$emit('toggle', evt);
      if (evt.defaultPrevented) {
        // Exit if canceled
        return;
      }
      evt.preventDefault();
      evt.stopPropagation();
      // Toggle visibility
      this.visible = !this.visible;
    },
    click: function click(evt) {
      // Calle only in split button mode, for the split button
      if (this.disabled) {
        this.visible = false;
        return;
      }
      this.$emit('click', evt);
    },

    /* istanbul ignore next: not easy to test */
    onKeydown: function onKeydown(evt) {
      // Called from dropdown menu context
      var key = evt.keyCode;
      if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].ESC) {
        // Close on ESC
        this.onEsc(evt);
      } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].TAB) {
        // Close on tab out
        this.onTab(evt);
      } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].DOWN) {
        // Down Arrow
        this.focusNext(evt, false);
      } else if (key === __WEBPACK_IMPORTED_MODULE_5__utils_key_codes__["a" /* default */].UP) {
        // Up Arrow
        this.focusNext(evt, true);
      }
    },

    /* istanbul ignore next: not easy to test */
    onEsc: function onEsc(evt) {
      if (this.visible) {
        this.visible = false;
        evt.preventDefault();
        evt.stopPropagation();
        // Return focus to original trigger button
        this.$nextTick(this.focusToggler);
      }
    },

    /* istanbul ignore next: not easy to test */
    onTab: function onTab(evt) {
      if (this.visible) {
        // TODO: Need special handler for dealing with form inputs
        // Tab, if in a text-like input, we should just focus next item in the dropdown
        // Note: Inputs are in a special .dropdown-form container
        this.visible = false;
      }
    },
    onFocusOut: function onFocusOut(evt) {
      if (this.$refs.menu.contains(evt.relatedTarget)) {
        return;
      }
      this.visible = false;
    },

    /* istanbul ignore next: not easy to test */
    onMouseOver: function onMouseOver(evt) {
      // Focus the item on hover
      // TODO: Special handling for inputs? Inputs are in a special .dropdown-form container
      var item = evt.target;
      if (item.classList.contains('dropdown-item') && !item.disabled && !item.classList.contains('disabled') && item.focus) {
        item.focus();
      }
    },
    focusNext: function focusNext(evt, up) {
      var _this2 = this;

      if (!this.visible) {
        return;
      }
      evt.preventDefault();
      evt.stopPropagation();
      this.$nextTick(function () {
        var items = _this2.getItems();
        if (items.length < 1) {
          return;
        }
        var index = items.indexOf(evt.target);
        if (up && index > 0) {
          index--;
        } else if (!up && index < items.length - 1) {
          index++;
        }
        if (index < 0) {
          index = 0;
        }
        _this2.focusItem(index, items);
      });
    },
    focusItem: function focusItem(idx, items) {
      var el = items.find(function (el, i) {
        return i === idx;
      });
      if (el && Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e" /* getAttr */])(el, 'tabindex') !== '-1') {
        el.focus();
      }
    },
    getItems: function getItems() {
      // Get all items
      return filterVisible(Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(ITEM_SELECTOR, this.$refs.menu));
    },
    getFirstItem: function getFirstItem() {
      // Get the first non-disabled item
      var item = this.getItems()[0];
      return item || null;
    },
    focusFirstItem: function focusFirstItem() {
      var item = this.getFirstItem();
      if (item) {
        this.focusItem(0, [item]);
      }
    },
    focusToggler: function focusToggler() {
      var toggler = this.toggler;
      if (toggler && toggler.focus) {
        toggler.focus();
      }
    }
  }
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  id: {
    type: String,
    default: null
  },
  inline: {
    type: Boolean,
    default: false
  },
  novalidate: {
    type: Boolean,
    default: false
  },
  validated: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h('form', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: {
        'form-inline': props.inline,
        'was-validated': props.validated
      },
      attrs: {
        id: props.id,
        novalidate: props.novalidate
      }
    }), children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var props = {
  id: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'small'
  },
  textVariant: {
    type: String,
    default: 'muted'
  },
  inline: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: _defineProperty({
        'form-text': !props.inline
      }, 'text-' + props.textVariant, Boolean(props.textVariant)),
      attrs: {
        id: props.id
      }
    }), children);
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  id: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'div'
  },
  forceShow: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'invalid-feedback',
      class: { 'd-block': props.forceShow },
      attrs: { id: props.id }
    }), children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  id: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'div'
  },
  forceShow: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'valid-feedback',
      class: { 'd-block': props.forceShow },
      attrs: { id: props.id }
    }), children);
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_radio_check__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__ = __webpack_require__(34);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form_radio_check__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    var input = h('input', {
      ref: 'check',
      class: [this.is_ButtonMode ? '' : this.is_Plain ? 'form-check-input' : 'custom-control-input', this.get_StateClass],
      directives: [{
        name: 'model',
        rawName: 'v-model',
        value: this.computedLocalChecked,
        expression: 'computedLocalChecked'
      }],
      attrs: {
        id: this.safeId(),
        type: 'checkbox',
        name: this.get_Name,
        disabled: this.is_Disabled,
        required: this.is_Required,
        autocomplete: 'off',
        'true-value': this.value,
        'false-value': this.uncheckedValue,
        'aria-required': this.is_Required ? 'true' : null
      },
      domProps: { value: this.value, checked: this.is_Checked },
      on: {
        focus: this.handleFocus,
        blur: this.handleFocus,
        change: this.emitChange,
        __c: function __c(evt) {
          var $$a = _this.computedLocalChecked;
          var $$el = evt.target;
          if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_array__["d" /* isArray */])($$a)) {
            // Multiple checkbox
            var $$v = _this.value;
            var $$i = _this._i($$a, $$v); // Vue's 'loose' Array.indexOf
            if ($$el.checked) {
              // Append value to array
              $$i < 0 && (_this.computedLocalChecked = $$a.concat([$$v]));
            } else {
              // Remove value from array
              $$i > -1 && (_this.computedLocalChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            // Single checkbox
            _this.computedLocalChecked = $$el.checked ? _this.value : _this.uncheckedValue;
          }
        }
      }
    });

    var description = h(this.is_ButtonMode ? 'span' : 'label', {
      class: this.is_ButtonMode ? null : this.is_Plain ? 'form-check-label' : 'custom-control-label',
      attrs: { for: this.is_ButtonMode ? null : this.safeId() }
    }, [this.$slots.default]);

    if (!this.is_ButtonMode) {
      return h('div', {
        class: [this.is_Plain ? 'form-check' : this.labelClasses, { 'form-check-inline': this.is_Plain && !this.is_Stacked }, { 'custom-control-inline': !this.is_Plain && !this.is_Stacked }]
      }, [input, description]);
    } else {
      return h('label', { class: [this.buttonClasses] }, [input, description]);
    }
  },

  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      // Not applicable in multi-check mode
      default: false
    },
    indeterminate: {
      // Not applicable in multi-check mode
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelClasses: function labelClasses() {
      return ['custom-control', 'custom-checkbox', this.get_Size ? 'form-control-' + this.get_Size : '', this.get_StateClass];
    },
    is_Checked: function is_Checked() {
      var checked = this.computedLocalChecked;
      if (Object(__WEBPACK_IMPORTED_MODULE_6__utils_array__["d" /* isArray */])(checked)) {
        for (var i = 0; i < checked.length; i++) {
          if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a" /* default */])(checked[i], this.value)) {
            return true;
          }
        }
        return false;
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a" /* default */])(checked, this.value);
      }
    }
  },
  watch: {
    computedLocalChecked: function computedLocalChecked(newVal, oldVal) {
      if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a" /* default */])(newVal, oldVal)) {
        return;
      }
      this.$emit('input', newVal);
      this.$emit('update:indeterminate', this.$refs.check.indeterminate);
    },
    checked: function checked(newVal, oldVal) {
      if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_7__utils_loose_equal__["a" /* default */])(newVal, oldVal)) {
        return;
      }
      this.computedLocalChecked = newVal;
    },
    indeterminate: function indeterminate(newVal, oldVal) {
      this.setIndeterminate(newVal);
    }
  },
  methods: {
    emitChange: function emitChange(_ref) {
      var checked = _ref.target.checked;

      // Change event is only fired via user interaction
      // And we only emit the value of this checkbox
      if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_6__utils_array__["d" /* isArray */])(this.computedLocalChecked)) {
        this.$emit('change', checked ? this.value : null);
        if (this.is_Child) {
          // If we are a child of form-checkbbox-group, emit change on parent
          this.$parent.$emit('change', this.computedLocalChecked);
        }
      } else {
        // Single radio mode supports unchecked value
        this.$emit('change', checked ? this.value : this.uncheckedValue);
      }
      this.$emit('update:indeterminate', this.$refs.check.indeterminate);
    },
    setIndeterminate: function setIndeterminate(state) {
      // Indeterminate only supported in single checkbox mode
      if (this.is_Child || Object(__WEBPACK_IMPORTED_MODULE_6__utils_array__["d" /* isArray */])(this.computedLocalChecked)) {
        return;
      }
      this.$refs.check.indeterminate = state;
      // Emit update event to prop
      this.$emit('update:indeterminate', this.$refs.check.indeterminate);
    }
  },
  mounted: function mounted() {
    // Set initial indeterminate state
    this.setIndeterminate(this.indeterminate);
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * form-radio & form-check mixin
 *
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      localChecked: this.checked,
      hasFocus: false
    };
  },

  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    value: {},
    checked: {
      // This is the model, except when in group mode
    },
    buttonVariant: {
      // Only applicable when rendered with button style
      type: String,
      default: null
    }
  },
  computed: {
    computedLocalChecked: {
      get: function get() {
        if (this.is_Child) {
          return this.$parent.localChecked;
        } else {
          return this.localChecked;
        }
      },
      set: function set(val) {
        if (this.is_Child) {
          this.$parent.localChecked = val;
        } else {
          this.localChecked = val;
        }
      }
    },
    is_Child: function is_Child() {
      return Boolean(this.$parent && this.$parent.is_RadioCheckGroup);
    },
    is_Disabled: function is_Disabled() {
      // Child can be disabled while parent isn't
      return Boolean(this.is_Child ? this.$parent.disabled || this.disabled : this.disabled);
    },
    is_Required: function is_Required() {
      return Boolean(this.is_Child ? this.$parent.required : this.required);
    },
    is_Plain: function is_Plain() {
      return Boolean(this.is_Child ? this.$parent.plain : this.plain);
    },
    is_Custom: function is_Custom() {
      return !this.is_Plain;
    },
    get_Size: function get_Size() {
      return this.is_Child ? this.$parent.size : this.size;
    },
    get_State: function get_State() {
      // This is a tri-state prop (true, false, null)
      if (this.is_Child && typeof this.$parent.get_State === 'boolean') {
        return this.$parent.get_State;
      }
      return this.computedState;
    },
    get_StateClass: function get_StateClass() {
      // This is a tri-state prop (true, false, null)
      return typeof this.get_State === 'boolean' ? this.get_State ? 'is-valid' : 'is-invalid' : '';
    },
    is_Stacked: function is_Stacked() {
      return Boolean(this.is_Child && this.$parent.stacked);
    },
    is_Inline: function is_Inline() {
      return !this.is_Stacked;
    },
    is_ButtonMode: function is_ButtonMode() {
      return Boolean(this.is_Child && this.$parent.buttons);
    },
    get_ButtonVariant: function get_ButtonVariant() {
      // Local variant trumps parent variant
      return this.buttonVariant || (this.is_Child ? this.$parent.buttonVariant : null) || 'secondary';
    },
    get_Name: function get_Name() {
      return (this.is_Child ? this.$parent.name || this.$parent.safeId() : this.name) || null;
    },
    buttonClasses: function buttonClasses() {
      // Same for radio & check
      return ['btn', 'btn-' + this.get_ButtonVariant, this.get_Size ? 'btn-' + this.get_Size : '',
      // 'disabled' class makes "button" look disabled
      this.is_Disabled ? 'disabled' : '',
      // 'active' class makes "button" look pressed
      this.is_Checked ? 'active' : '',
      // Focus class makes button look focused
      this.hasFocus ? 'focus' : ''];
    }
  },
  methods: {
    handleFocus: function handleFocus(evt) {
      // When in buttons mode, we need to add 'focus' class to label when radio focused
      if (this.is_ButtonMode && evt.target) {
        if (evt.type === 'focus') {
          this.hasFocus = true;
        } else if (evt.type === 'blur') {
          this.hasFocus = false;
        }
      }
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__ = __webpack_require__(34);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_radio_check__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    var input = h('input', {
      ref: 'radio',
      class: [this.is_ButtonMode ? '' : this.is_Plain ? 'form-check-input' : 'custom-control-input', this.get_StateClass],
      directives: [{
        name: 'model',
        rawName: 'v-model',
        value: this.computedLocalChecked,
        expression: 'computedLocalChecked'
      }],
      attrs: {
        id: this.safeId(),
        type: 'radio',
        name: this.get_Name,
        required: this.get_Name && this.is_Required,
        disabled: this.is_Disabled,
        autocomplete: 'off'
      },
      domProps: {
        value: this.value,
        checked: Object(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a" /* default */])(this.computedLocalChecked, this.value)
      },
      on: {
        focus: this.handleFocus,
        blur: this.handleFocus,
        change: this.emitChange,
        __c: function __c(evt) {
          _this.computedLocalChecked = _this.value;
        }
      }
    });

    var description = h(this.is_ButtonMode ? 'span' : 'label', {
      class: this.is_ButtonMode ? null : this.is_Plain ? 'form-check-label' : 'custom-control-label',
      attrs: { for: this.is_ButtonMode ? null : this.safeId() }
    }, [this.$slots.default]);

    if (!this.is_ButtonMode) {
      return h('div', {
        class: [this.is_Plain ? 'form-check' : this.labelClasses, { 'form-check-inline': this.is_Plain && !this.is_Stacked }, { 'custom-control-inline': !this.is_Plain && !this.is_Stacked }]
      }, [input, description]);
    } else {
      return h('label', { class: [this.buttonClasses] }, [input, description]);
    }
  },

  watch: {
    // Radio Groups can only have a single value, so our watchers are simple
    checked: function checked(newVal, oldVal) {
      this.computedLocalChecked = newVal;
    },
    computedLocalChceked: function computedLocalChceked(newVal, oldVal) {
      this.$emit('input', this.computedLocalChceked);
    }
  },
  computed: {
    is_Checked: function is_Checked() {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_loose_equal__["a" /* default */])(this.value, this.computedLocalChecked);
    },
    labelClasses: function labelClasses() {
      // Specific to radio
      return [this.get_Size ? 'form-control-' + this.get_Size : '', 'custom-control', 'custom-radio', this.get_StateClass];
    }
  },
  methods: {
    emitChange: function emitChange(_ref) {
      var checked = _ref.target.checked;

      // Change is only emitted on user interaction
      this.$emit('change', checked ? this.value : null);
      // If this is a child of form-radio-group, we emit a change event on it as well
      if (this.is_Child) {
        this.$parent.$emit('change', this.computedLocalChecked);
      }
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'media-body'
    }), children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var props = {
  tag: {
    type: String,
    default: 'div'
  },
  verticalAlign: {
    type: String,
    default: 'top'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'd-flex',
      class: _defineProperty({}, 'align-self-' + props.verticalAlign, props.verticalAlign)
    }), children);
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var directives = {
  bModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* registerDirectives */])(Vue, directives);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nav_item__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nav_text__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nav_form__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dropdown__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(1);








var components = {
  bNav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */],
  bNavItem: __WEBPACK_IMPORTED_MODULE_1__nav_item__["a" /* default */],
  bNavText: __WEBPACK_IMPORTED_MODULE_2__nav_text__["a" /* default */],
  bNavForm: __WEBPACK_IMPORTED_MODULE_3__nav_form__["a" /* default */],
  bNavItemDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* default */],
  bNavItemDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* default */],
  bNavDropdown: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* default */],
  bNavDd: __WEBPACK_IMPORTED_MODULE_4__nav_item_dropdown__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["a" /* registerComponents */])(Vue, components);
    Vue.use(__WEBPACK_IMPORTED_MODULE_5__dropdown__["a" /* default */]);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_range__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_link_link__ = __webpack_require__(9);
/*
 * Comon props, computed, data, render function, and methods for b-pagination and b-pagination-nav
 */






// Make an array of N to N+X
function makePageArray(startNum, numPages) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__utils_range__["a" /* default */])(numPages).map(function (value, index) {
    return { number: index + startNum, className: null };
  });
}

// Threshold of limit size when we start/stop showing ellipsis
var ELLIPSIS_THRESHOLD = 3;

// Props object
var props = {
  disabled: {
    type: Boolean,
    default: false
  },
  value: {
    type: Number,
    default: 1
  },
  limit: {
    type: Number,
    default: 5
  },
  size: {
    type: String,
    default: 'md'
  },
  align: {
    type: String,
    default: 'left'
  },
  hideGotoEndButtons: {
    type: Boolean,
    default: false
  },
  ariaLabel: {
    type: String,
    default: 'Pagination'
  },
  labelFirstPage: {
    type: String,
    default: 'Goto first page'
  },
  firstText: {
    type: String,
    default: '&laquo;'
  },
  labelPrevPage: {
    type: String,
    default: 'Goto previous page'
  },
  prevText: {
    type: String,
    default: '&lsaquo;'
  },
  labelNextPage: {
    type: String,
    default: 'Goto next page'
  },
  nextText: {
    type: String,
    default: '&rsaquo;'
  },
  labelLastPage: {
    type: String,
    default: 'Goto last page'
  },
  lastText: {
    type: String,
    default: '&raquo;'
  },
  labelPage: {
    type: String,
    default: 'Goto page'
  },
  hideEllipsis: {
    type: Boolean,
    default: false
  },
  ellipsisText: {
    type: String,
    default: '&hellip;'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bLink: __WEBPACK_IMPORTED_MODULE_3__components_link_link__["a" /* default */] },
  data: function data() {
    return {
      showFirstDots: false,
      showLastDots: false,
      currentPage: this.value
    };
  },

  props: props,
  render: function render(h) {
    var _this = this;

    var buttons = [];

    // Factory function for prev/next/first/last buttons
    var makeEndBtns = function makeEndBtns(linkTo, ariaLabel, btnText, pageTest) {
      var button = void 0;
      pageTest = pageTest || linkTo; // Page # to test against to disable
      if (_this.disabled || _this.isActive(pageTest)) {
        button = h('li', {
          class: ['page-item', 'disabled'],
          attrs: { role: 'none presentation', 'aria-hidden': 'true' }
        }, [h('span', {
          class: ['page-link'],
          domProps: { innerHTML: btnText }
        })]);
      } else {
        button = h('li', {
          class: ['page-item'],
          attrs: { role: 'none presentation' }
        }, [h('b-link', {
          class: ['page-link'],
          props: _this.linkProps(linkTo),
          attrs: {
            role: 'menuitem',
            tabindex: '-1',
            'aria-label': ariaLabel,
            'aria-controls': _this.ariaControls || null
          },
          on: {
            click: function click(evt) {
              _this.onClick(linkTo, evt);
            },
            keydown: function keydown(evt) {
              // Links don't normally respond to SPACE, so we add that functionality
              if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE) {
                evt.preventDefault();
                _this.onClick(linkTo, evt);
              }
            }
          }
        }, [h('span', {
          attrs: { 'aria-hidden': 'true' },
          domProps: { innerHTML: btnText }
        })])]);
      }
      return button;
    };

    // Ellipsis factory
    var makeEllipsis = function makeEllipsis() {
      return h('li', {
        class: ['page-item', 'disabled', 'd-none', 'd-sm-flex'],
        attrs: { role: 'separator' }
      }, [h('span', {
        class: ['page-link'],
        domProps: { innerHTML: _this.ellipsisText }
      })]);
    };

    // Goto First Page button
    buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(1, this.labelFirstPage, this.firstText));

    // Goto Previous page button
    buttons.push(makeEndBtns(this.currentPage - 1, this.labelPrevPage, this.prevText, 1));

    // First Ellipsis Bookend
    buttons.push(this.showFirstDots ? makeEllipsis() : h(false));

    // Individual Page links
    this.pageList.forEach(function (page) {
      var inner = void 0;
      var pageNum = _this.makePage(page.number);
      if (_this.disabled) {
        inner = h('span', {
          class: ['page-link'],
          domProps: { innerHTML: pageNum }
        });
      } else {
        var active = _this.isActive(page.number);
        inner = h('b-link', {
          class: _this.pageLinkClasses(page),
          props: _this.linkProps(page.number),
          attrs: {
            role: 'menuitemradio',
            tabindex: active ? '0' : '-1',
            'aria-controls': _this.ariaControls || null,
            'aria-label': _this.labelPage + ' ' + page.number,
            'aria-checked': active ? 'true' : 'false',
            'aria-posinset': page.number,
            'aria-setsize': _this.numberOfPages
          },
          domProps: { innerHTML: pageNum },
          on: {
            click: function click(evt) {
              _this.onClick(page.number, evt);
            },
            keydown: function keydown(evt) {
              if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE) {
                evt.preventDefault();
                _this.onClick(page.number, evt);
              }
            }
          }
        });
      }
      buttons.push(h('li', {
        key: page.number,
        class: _this.pageItemClasses(page),
        attrs: { role: 'none presentation' }
      }, [inner]));
    });

    // Last Ellipsis Bookend
    buttons.push(this.showLastDots ? makeEllipsis() : h(false));

    // Goto Next page button
    buttons.push(makeEndBtns(this.currentPage + 1, this.labelNextPage, this.nextText, this.numberOfPages));

    // Goto Last Page button
    buttons.push(this.hideGotoEndButtons ? h(false) : makeEndBtns(this.numberOfPages, this.labelLastPage, this.lastText));

    // Assemble the paginatiom buttons
    var pagination = h('ul', {
      ref: 'ul',
      class: ['pagination', 'b-pagination', this.btnSize, this.alignment],
      attrs: {
        role: 'menubar',
        'aria-disabled': this.disabled ? 'true' : 'false',
        'aria-label': this.ariaLabel || null
      },
      on: {
        keydown: function keydown(evt) {
          var keyCode = evt.keyCode;
          var shift = evt.shiftKey;
          if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT) {
            evt.preventDefault();
            shift ? _this.focusFirst() : _this.focusPrev();
          } else if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].RIGHT) {
            evt.preventDefault();
            shift ? _this.focusLast() : _this.focusNext();
          }
        }
      }
    }, buttons);

    // if we are pagination-nav, wrap in '<nav>' wrapper
    return this.isNav ? h('nav', {}, [pagination]) : pagination;
  },

  watch: {
    currentPage: function currentPage(newPage, oldPage) {
      if (newPage !== oldPage) {
        this.$emit('input', newPage);
      }
    },
    value: function value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = newValue;
      }
    }
  },
  computed: {
    btnSize: function btnSize() {
      return this.size ? 'pagination-' + this.size : '';
    },
    alignment: function alignment() {
      if (this.align === 'center') {
        return 'justify-content-center';
      } else if (this.align === 'end' || this.align === 'right') {
        return 'justify-content-end';
      }
      return '';
    },
    pageList: function pageList() {
      // Sanity checks
      if (this.currentPage > this.numberOfPages) {
        this.currentPage = this.numberOfPages;
      } else if (this.currentPage < 1) {
        this.currentPage = 1;
      }
      // - Hide first ellipsis marker
      this.showFirstDots = false;
      // - Hide last ellipsis marker
      this.showLastDots = false;
      var numLinks = this.limit;
      var startNum = 1;
      if (this.numberOfPages <= this.limit) {
        // Special Case: Less pages available than the limit of displayed pages
        numLinks = this.numberOfPages;
      } else if (this.currentPage < this.limit - 1 && this.limit > ELLIPSIS_THRESHOLD) {
        // We are near the beginning of the page list
        if (!this.hideEllipsis) {
          numLinks = this.limit - 1;
          this.showLastDots = true;
        }
      } else if (this.numberOfPages - this.currentPage + 2 < this.limit && this.limit > ELLIPSIS_THRESHOLD) {
        // We are near the end of the list
        if (!this.hideEllipsis) {
          this.showFirstDots = true;
          numLinks = this.limit - 1;
        }
        startNum = this.numberOfPages - numLinks + 1;
      } else {
        // We are somewhere in the middle of the page list
        if (this.limit > ELLIPSIS_THRESHOLD && !this.hideEllipsis) {
          this.showFirstDots = true;
          this.showLastDots = true;
          numLinks = this.limit - 2;
        }
        startNum = this.currentPage - Math.floor(numLinks / 2);
      }
      // Sanity checks
      if (startNum < 1) {
        startNum = 1;
      } else if (startNum > this.numberOfPages - numLinks) {
        startNum = this.numberOfPages - numLinks + 1;
      }
      // Generate list of page numbers
      var pages = makePageArray(startNum, numLinks);
      // We limit to a total of 3 page buttons on small screens
      // Ellipsis will also be hidden on small screens
      if (pages.length > 3) {
        var idx = this.currentPage - startNum;
        if (idx === 0) {
          // Keep leftmost 3 buttons visible
          for (var i = 3; i < pages.length; i++) {
            pages[i].className = 'd-none d-sm-flex';
          }
        } else if (idx === pages.length - 1) {
          // Keep rightmost 3 buttons visible
          for (var _i = 0; _i < pages.length - 3; _i++) {
            pages[_i].className = 'd-none d-sm-flex';
          }
        } else {
          // hide left button(s)
          for (var _i2 = 0; _i2 < idx - 1; _i2++) {
            pages[_i2].className = 'd-none d-sm-flex';
          }
          // hide right button(s)
          for (var _i3 = pages.length - 1; _i3 > idx + 1; _i3--) {
            pages[_i3].className = 'd-none d-sm-flex';
          }
        }
      }
      return pages;
    }
  },
  methods: {
    isActive: function isActive(pagenum) {
      return pagenum === this.currentPage;
    },
    pageItemClasses: function pageItemClasses(page) {
      return ['page-item', this.disabled ? 'disabled' : '', this.isActive(page.number) ? 'active' : '', page.className];
    },
    pageLinkClasses: function pageLinkClasses(page) {
      return ['page-link', this.disabled ? 'disabled' : '',
      // Interim workaround to get better focus styling of active button
      // See https://github.com/twbs/bootstrap/issues/24838
      this.isActive(page.number) ? 'btn-primary' : ''];
    },
    getButtons: function getButtons() {
      // Return only buttons that are visible
      return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["u" /* selectAll */])('a.page-link', this.$el).filter(function (btn) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["m" /* isVisible */])(btn);
      });
    },
    setBtnFocus: function setBtnFocus(btn) {
      this.$nextTick(function () {
        btn.focus();
      });
    },
    focusCurrent: function focusCurrent() {
      var _this2 = this;

      var btn = this.getButtons().find(function (el) {
        return parseInt(Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["e" /* getAttr */])(el, 'aria-posinset'), 10) === _this2.currentPage;
      });
      if (btn && btn.focus) {
        this.setBtnFocus(btn);
      } else {
        // Fallback if current page is not in button list
        this.focusFirst();
      }
    },
    focusFirst: function focusFirst() {
      var btn = this.getButtons().find(function (el) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* isDisabled */])(el);
      });
      if (btn && btn.focus && btn !== document.activeElement) {
        this.setBtnFocus(btn);
      }
    },
    focusLast: function focusLast() {
      var btn = this.getButtons().reverse().find(function (el) {
        return !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* isDisabled */])(el);
      });
      if (btn && btn.focus && btn !== document.activeElement) {
        this.setBtnFocus(btn);
      }
    },
    focusPrev: function focusPrev() {
      var buttons = this.getButtons();
      var idx = buttons.indexOf(document.activeElement);
      if (idx > 0 && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* isDisabled */])(buttons[idx - 1]) && buttons[idx - 1].focus) {
        this.setBtnFocus(buttons[idx - 1]);
      }
    },
    focusNext: function focusNext() {
      var buttons = this.getButtons();
      var idx = buttons.indexOf(document.activeElement);
      var cnt = buttons.length - 1;
      if (idx < cnt && !Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["k" /* isDisabled */])(buttons[idx + 1]) && buttons[idx + 1].focus) {
        this.setBtnFocus(buttons[idx + 1]);
      }
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__(4);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var NAME = 'popover';
var CLASS_PREFIX = 'bs-popover';
var BSCLS_PREFIX_REGEX = new RegExp('\\b' + CLASS_PREFIX + '\\S+', 'g');

var Defaults = Object(__WEBPACK_IMPORTED_MODULE_1__object__["a" /* assign */])({}, __WEBPACK_IMPORTED_MODULE_0__tooltip_class__["a" /* default */].Default, {
  placement: 'right',
  trigger: 'click',
  content: '',
  template: '<div class="popover" role="tooltip">' + '<div class="arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div></div>'
});

var ClassName = {
  FADE: 'fade',
  SHOW: 'show'
};

var Selector = {
  TITLE: '.popover-header',
  CONTENT: '.popover-body'

  /* istanbul ignore next: dificult to test in Jest/JSDOM environment */
};
var PopOver = function (_ToolTip) {
  _inherits(PopOver, _ToolTip);

  function PopOver() {
    _classCallCheck(this, PopOver);

    return _possibleConstructorReturn(this, (PopOver.__proto__ || Object.getPrototypeOf(PopOver)).apply(this, arguments));
  }

  _createClass(PopOver, [{
    key: 'isWithContent',


    // Method overrides

    value: function isWithContent(tip) {
      tip = tip || this.$tip;
      if (!tip) {
        return false;
      }
      var hasTitle = Boolean((Object(__WEBPACK_IMPORTED_MODULE_2__dom__["t" /* select */])(Selector.TITLE, tip) || {}).innerHTML);
      var hasContent = Boolean((Object(__WEBPACK_IMPORTED_MODULE_2__dom__["t" /* select */])(Selector.CONTENT, tip) || {}).innerHTML);
      return hasTitle || hasContent;
    }
  }, {
    key: 'addAttachmentClass',
    value: function addAttachmentClass(attachment) {
      Object(__WEBPACK_IMPORTED_MODULE_2__dom__["a" /* addClass */])(this.getTipElement(), CLASS_PREFIX + '-' + attachment);
    }
  }, {
    key: 'setContent',
    value: function setContent(tip) {
      // we use append for html objects to maintain js events/components
      this.setElementContent(Object(__WEBPACK_IMPORTED_MODULE_2__dom__["t" /* select */])(Selector.TITLE, tip), this.getTitle());
      this.setElementContent(Object(__WEBPACK_IMPORTED_MODULE_2__dom__["t" /* select */])(Selector.CONTENT, tip), this.getContent());

      Object(__WEBPACK_IMPORTED_MODULE_2__dom__["s" /* removeClass */])(tip, ClassName.FADE);
      Object(__WEBPACK_IMPORTED_MODULE_2__dom__["s" /* removeClass */])(tip, ClassName.SHOW);
    }

    // This method may look identical to ToolTip version, but it uses a different RegEx defined above

  }, {
    key: 'cleanTipClass',
    value: function cleanTipClass() {
      var tip = this.getTipElement();
      var tabClass = tip.className.match(BSCLS_PREFIX_REGEX);
      if (tabClass !== null && tabClass.length > 0) {
        tabClass.forEach(function (cls) {
          Object(__WEBPACK_IMPORTED_MODULE_2__dom__["s" /* removeClass */])(tip, cls);
        });
      }
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var title = this.$config.title || '';
      if (typeof title === 'function') {
        title = title(this.$element);
      }
      if ((typeof title === 'undefined' ? 'undefined' : _typeof(title)) === 'object' && title.nodeType && !title.innerHTML.trim()) {
        // We have a dom node, but without inner content, so just return an empty string
        title = '';
      }
      if (typeof title === 'string') {
        title = title.trim();
      }
      if (!title) {
        // Try and grab element's title attribute
        title = Object(__WEBPACK_IMPORTED_MODULE_2__dom__["e" /* getAttr */])(this.$element, 'title') || Object(__WEBPACK_IMPORTED_MODULE_2__dom__["e" /* getAttr */])(this.$element, 'data-original-title') || '';
        title = title.trim();
      }
      return title;
    }

    // New methods

  }, {
    key: 'getContent',
    value: function getContent() {
      var content = this.$config.content || '';
      if (typeof content === 'function') {
        content = content(this.$element);
      }
      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && content.nodeType && !content.innerHTML.trim()) {
        // We have a dom node, but without inner content, so just return an empty string
        content = '';
      }
      if (typeof content === 'string') {
        content = content.trim();
      }
      return content;
    }
  }], [{
    key: 'Default',

    // Getter overrides

    get: function get() {
      return Defaults;
    }
  }, {
    key: 'NAME',
    get: function get() {
      return NAME;
    }
  }]);

  return PopOver;
}(__WEBPACK_IMPORTED_MODULE_0__tooltip_class__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PopOver);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ssr__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__ = __webpack_require__(18);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * Tooltip/Popover component mixin
 * Common props
 */






var PLACEMENTS = {
  top: 'top',
  topleft: 'topleft',
  topright: 'topright',
  right: 'right',
  righttop: 'righttop',
  rightbottom: 'rightbottom',
  bottom: 'bottom',
  bottomleft: 'bottomleft',
  bottomright: 'bottomright',
  left: 'left',
  lefttop: 'lefttop',
  leftbottom: 'leftbottom',
  auto: 'auto'
};

var OBSERVER_CONFIG = {
  subtree: true,
  childList: true,
  characterData: true,
  attributes: true,
  attributeFilter: ['class', 'style']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    target: {
      // String ID of element, or element/component reference
      type: [String, Object, __WEBPACK_IMPORTED_MODULE_3__utils_ssr__["a" /* HTMLElement */], Function]
    },
    delay: {
      type: [Number, Object, String],
      default: 0
    },
    offset: {
      type: [Number, String],
      default: 0
    },
    noFade: {
      type: Boolean,
      default: false
    },
    container: {
      // String ID of container, if null body is used (default)
      type: String,
      default: null
    },
    boundary: {
      // String: scrollParent, window, or viewport
      // Element: element reference
      type: [String, Object],
      default: 'scrollParent'
    },
    show: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: function show(_show, old) {
      if (_show === old) {
        return;
      }
      _show ? this.onOpen() : this.onClose();
    },
    disabled: function disabled(_disabled, old) {
      if (_disabled === old) {
        return;
      }
      _disabled ? this.onDisable() : this.onEnable();
    }
  },
  created: function created() {
    // Create non-reactive property
    this._toolpop = null;
    this._obs_title = null;
    this._obs_content = null;
  },
  mounted: function mounted() {
    var _this = this;

    // We do this in a next tick to ensure DOM has rendered first
    this.$nextTick(function () {
      // Instantiate ToolTip/PopOver on target
      // The createToolpop method must exist in main component
      if (_this.createToolpop()) {
        if (_this.disabled) {
          // Initially disabled
          _this.onDisable();
        }
        // Listen to open signals from others
        _this.$on('open', _this.onOpen);
        // Listen to close signals from others
        _this.$on('close', _this.onClose);
        // Listen to disable signals from others
        _this.$on('disable', _this.onDisable);
        // Listen to disable signals from others
        _this.$on('enable', _this.onEnable);
        // Observe content Child changes so we can notify popper of possible size change
        _this.setObservers(true);
        // Set intially open state
        if (_this.show) {
          _this.onOpen();
        }
      }
    });
  },
  updated: function updated() {
    // If content/props changes, etc
    if (this._toolpop) {
      this._toolpop.updateConfig(this.getConfig());
    }
  },

  /* istanbul ignore next: not easy to test */
  activated: function activated() {
    // Called when component is inside a <keep-alive> and component brought offline
    this.setObservers(true);
  },

  /* istanbul ignore next: not easy to test */
  deactivated: function deactivated() {
    // Called when component is inside a <keep-alive> and component taken offline
    if (this._toolpop) {
      this.setObservers(false);
      this._toolpop.hide();
    }
  },

  /* istanbul ignore next: not easy to test */
  beforeDestroy: function beforeDestroy() {
    // Shutdown our local event listeners
    this.$off('open', this.onOpen);
    this.$off('close', this.onClose);
    this.$off('disable', this.onDisable);
    this.$off('enable', this.onEnable);
    this.setObservers(false);
    // bring our content back if needed
    this.bringItBack();
    if (this._toolpop) {
      this._toolpop.destroy();
      this._toolpop = null;
    }
  },

  computed: {
    baseConfig: function baseConfig() {
      var cont = this.container;
      var delay = _typeof(this.delay) === 'object' ? this.delay : parseInt(this.delay, 10) || 0;
      return {
        // Title prop
        title: (this.title || '').trim() || '',
        // Contnt prop (if popover)
        content: (this.content || '').trim() || '',
        // Tooltip/Popover placement
        placement: PLACEMENTS[this.placement] || 'auto',
        // Container curently needs to be an ID with '#' prepended, if null then body is used
        container: cont ? /^#/.test(cont) ? cont : '#' + cont : false,
        // boundariesElement passed to popper
        boundary: this.boundary,
        // Show/Hide delay
        delay: delay || 0,
        // Offset can be css distance. if no units, pixels are assumed
        offset: this.offset || 0,
        // Disable fade Animation?
        animation: !this.noFade,
        // Open/Close Trigger(s)
        trigger: Object(__WEBPACK_IMPORTED_MODULE_0__utils_array__["d" /* isArray */])(this.triggers) ? this.triggers.join(' ') : this.triggers,
        // Callbacks so we can trigger events on component
        callbacks: {
          show: this.onShow,
          shown: this.onShown,
          hide: this.onHide,
          hidden: this.onHidden,
          enabled: this.onEnabled,
          disabled: this.onDisabled
        }
      };
    }
  },
  methods: {
    getConfig: function getConfig() {
      var cfg = Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["a" /* assign */])({}, this.baseConfig);
      if (this.$refs.title && this.$refs.title.innerHTML.trim()) {
        // If slot has content, it overrides 'title' prop
        // We use the DOM node as content to allow components!
        cfg.title = this.$refs.title;
        cfg.html = true;
      }
      if (this.$refs.content && this.$refs.content.innerHTML.trim()) {
        // If slot has content, it overrides 'content' prop
        // We use the DOM node as content to allow components!
        cfg.content = this.$refs.content;
        cfg.html = true;
      }
      return cfg;
    },
    onOpen: function onOpen() {
      if (this._toolpop) {
        this._toolpop.show();
      }
    },
    onClose: function onClose(callback) {
      if (this._toolpop) {
        this._toolpop.hide(callback);
      } else if (typeof callback === 'function') {
        callback();
      }
    },
    onDisable: function onDisable() {
      if (this._toolpop) {
        this._toolpop.disable();
      }
    },
    onEnable: function onEnable() {
      if (this._toolpop) {
        this._toolpop.enable();
      }
    },
    updatePosition: function updatePosition() {
      if (this._toolpop) {
        // Instruct popper to reposition popover if necessary
        this._toolpop.update();
      }
    },
    getTarget: function getTarget() {
      var target = this.target;
      if (typeof target === 'function') {
        target = target();
      }
      if (typeof target === 'string') {
        // Assume ID of element
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["g" /* getById */])(target);
      } else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l" /* isElement */])(target.$el)) {
        // Component reference
        return target.$el;
      } else if ((typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["l" /* isElement */])(target)) {
        // Element reference
        return target;
      }
      return null;
    },
    onShow: function onShow(evt) {
      this.$emit('show', evt);
    },
    onShown: function onShown(evt) {
      this.setObservers(true);
      this.$emit('update:show', true);
      this.$emit('shown', evt);
    },
    onHide: function onHide(evt) {
      this.$emit('hide', evt);
    },
    onHidden: function onHidden(evt) {
      this.setObservers(false);
      // bring our content back if needed to keep Vue happy
      // Tooltip class will move it back to tip when shown again
      this.bringItBack();
      this.$emit('update:show', false);
      this.$emit('hidden', evt);
    },
    onEnabled: function onEnabled(evt) {
      if (!evt || evt.type !== 'enabled') {
        // Prevent possible endless loop if user mistakienly fires enabled instead of enable
        return;
      }
      this.$emit('update:disabled', false);
      this.$emit('disabled');
    },
    onDisabled: function onDisabled(evt) {
      if (!evt || evt.type !== 'disabled') {
        // Prevent possible endless loop if user mistakienly fires disabled instead of disable
        return;
      }
      this.$emit('update:disabled', true);
      this.$emit('enabled');
    },
    bringItBack: function bringItBack() {
      // bring our content back if needed to keep Vue happy
      if (this.$el && this.$refs.title) {
        this.$el.appendChild(this.$refs.title);
      }
      if (this.$el && this.$refs.content) {
        this.$el.appendChild(this.$refs.content);
      }
    },

    /* istanbul ignore next: not easy to test */
    setObservers: function setObservers(on) {
      if (on) {
        if (this.$refs.title) {
          this._obs_title = Object(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a" /* default */])(this.$refs.title, this.updatePosition.bind(this), OBSERVER_CONFIG);
        }
        if (this.$refs.content) {
          this._obs_content = Object(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a" /* default */])(this.$refs.content, this.updatePosition.bind(this), OBSERVER_CONFIG);
        }
      } else {
        if (this._obs_title) {
          this._obs_title.disconnect();
          this._obs_title = null;
        }
        if (this._obs_content) {
          this._obs_content.disconnect();
          this._obs_content = null;
        }
      }
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    var childNodes = h(false);
    if (this.$slots.default) {
      childNodes = this.$slots.default;
    } else if (this.label) {
      childNodes = h('span', { domProps: { innerHTML: this.label } });
    } else if (this.computedShowProgress) {
      childNodes = this.progress.toFixed(this.computedPrecision);
    } else if (this.computedShowValue) {
      childNodes = this.value.toFixed(this.computedPrecision);
    }
    return h('div', {
      class: this.progressBarClasses,
      style: this.progressBarStyles,
      attrs: {
        role: 'progressbar',
        'aria-valuemin': '0',
        'aria-valuemax': this.computedMax.toString(),
        'aria-valuenow': this.value.toFixed(this.computedPrecision)
      }
    }, [childNodes]);
  },

  computed: {
    progressBarClasses: function progressBarClasses() {
      return ['progress-bar', this.computedVariant ? 'bg-' + this.computedVariant : '', this.computedStriped || this.computedAnimated ? 'progress-bar-striped' : '', this.computedAnimated ? 'progress-bar-animated' : ''];
    },
    progressBarStyles: function progressBarStyles() {
      return {
        width: 100 * (this.value / this.computedMax) + '%'
      };
    },
    progress: function progress() {
      var p = Math.pow(10, this.computedPrecision);
      return Math.round(100 * p * this.value / this.computedMax) / p;
    },
    computedMax: function computedMax() {
      // Prefer our max over parent setting
      return typeof this.max === 'number' ? this.max : this.$parent.max || 100;
    },
    computedVariant: function computedVariant() {
      // Prefer our variant over parent setting
      return this.variant || this.$parent.variant;
    },
    computedPrecision: function computedPrecision() {
      // Prefer our precision over parent setting
      return typeof this.precision === 'number' ? this.precision : this.$parent.precision || 0;
    },
    computedStriped: function computedStriped() {
      // Prefer our striped over parent setting
      return typeof this.striped === 'boolean' ? this.striped : this.$parent.striped || false;
    },
    computedAnimated: function computedAnimated() {
      // Prefer our animated over parent setting
      return typeof this.animated === 'boolean' ? this.animated : this.$parent.animated || false;
    },
    computedShowProgress: function computedShowProgress() {
      // Prefer our showProgress over parent setting
      return typeof this.showProgress === 'boolean' ? this.showProgress : this.$parent.showProgress || false;
    },
    computedShowValue: function computedShowValue() {
      // Prefer our showValue over parent setting
      return typeof this.showValue === 'boolean' ? this.showValue : this.$parent.showValue || false;
    }
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    label: {
      type: String,
      default: null
    },
    // $parent prop values take precedence over the following props
    // Which is why they are defaulted to null
    max: {
      type: Number,
      default: null
    },
    precision: {
      type: Number,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    striped: {
      type: Boolean,
      default: null
    },
    animated: {
      type: Boolean,
      default: null
    },
    showProgress: {
      type: Boolean,
      default: null
    },
    showValue: {
      type: Boolean,
      default: null
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__search__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(73);
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-navigation': __WEBPACK_IMPORTED_MODULE_0__components_Navigation_vue__["a" /* default */],
    'app-footer': __WEBPACK_IMPORTED_MODULE_1__components_Footer_vue__["a" /* default */],
    'downloadExcel': __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */]
  },
  name: 'app',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('setupItems');
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Navigation',
  data: function data() {
    return {
      keywords: ""
    };
  },

  computed: {
    menuItems: function menuItems() {
      return [{
        label: 'Startseite',
        route: 'home'
      }, {
        label: 'Über das Archiv',
        route: 'about'
      }, {
        label: 'Medienarchiv',
        route: 'archive'
      }, {
        label: 'Pressespiegel',
        route: 'press'
      }, {
        label: 'Kontakt',
        route: 'contact'
      }];
    },
    breadcrumbs: function breadcrumbs() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.navigation.breadcrumbs;
    },
    getActivePage: function getActivePage() {
      return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].state.navigation.active;
    }
  },
  methods: {
    simpleSearch: function simpleSearch() {
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('updateSearch', { keywords: this.keywords });

      this.$router.push({
        name: 'archive',
        params: {
          inlineSearch: true
        }
      });
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_idx_index_json__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_idx_index_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_idx_index_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapping__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_speakingurl__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_speakingurl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_speakingurl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helper__ = __webpack_require__(38);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }






var Search = function () {
    function Search() {
        _classCallCheck(this, Search);

        this.index = [];
        this.resultIndex = [];
        this.slugs = {};
        this.filter = {};
        this.buildLookupIndex(__WEBPACK_IMPORTED_MODULE_0__assets_idx_index_json___default.a);
        this.resultIndex = [].concat(_toConsumableArray(this.index));
    }

    _createClass(Search, [{
        key: 'buildLookupIndex',
        value: function buildLookupIndex(rawIndex) {
            var transform = function transform() {
                for (var _len = arguments.length, parts = Array(_len), _key = 0; _key < _len; _key++) {
                    parts[_key] = arguments[_key];
                }

                var c = '' + parts.join(' ');
                c = c.toLowerCase().replace(/[\"\(\)]/g, '').replace(/[,\.\s{2,}]/g, ' ');
                return c;
            };

            for (var i = 0; i < rawIndex.length; i++) {
                var date = Object(__WEBPACK_IMPORTED_MODULE_3__helper__["c" /* ParseDate */])(rawIndex[i][1]);
                var row = {
                    index: i,
                    id: rawIndex[i][0],
                    date: rawIndex[i][1],
                    dateParsed: date,
                    dateExport: Object(__WEBPACK_IMPORTED_MODULE_3__helper__["a" /* DateObjectToExportDateDecorator */])(date),
                    content: rawIndex[i][2],
                    headline: rawIndex[i][3],
                    kicker: rawIndex[i][4],
                    subline: rawIndex[i][5],
                    author: rawIndex[i][6],
                    topic: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].topic.getTextMapByValue(rawIndex[i][7]),
                    topicIndex: rawIndex[i][7],
                    object: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].media.getByValue(rawIndex[i][8]).text,
                    objectIndex: rawIndex[i][8],
                    externalObject: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].media.getByValue(rawIndex[i][8]).external == true,
                    text: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].type.getTextMapByValue(rawIndex[i][9]),
                    textIndex: rawIndex[i][9],
                    place: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].placement.getTextMapByValue(rawIndex[i][10]),
                    placeIndex: rawIndex[i][10],
                    illustration: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].illustration.getByValue(rawIndex[i][11]).text,
                    illustrationIndex: rawIndex[i][11],
                    pageCount: rawIndex[i][12],
                    page: rawIndex[i][13],
                    slug: __WEBPACK_IMPORTED_MODULE_2_speakingurl___default()(rawIndex[i][3]),
                    textsearch: transform(rawIndex[i][2]),
                    titleSearch: transform(rawIndex[i][3], rawIndex[i][4], rawIndex[i][5])
                };

                this.slugs[row.slug] = i;
                this.index.push(row);
            }
        }
    }, {
        key: 'applyFilter',
        value: function applyFilter(filter) {
            if (!filter) {
                return;
            }

            if (!filter.dateRange) {
                filter.dateRange = { begin: '', end: '' };
            }

            this.resultIndex = [];
            this.filter = filter;
            var keywords = filter.keywords ? filter.keywords.toLowerCase().split(" ") : false;
            var title = filter.title ? filter.title.toLowerCase().split(" ") : false;
            var dateFrom = Object(__WEBPACK_IMPORTED_MODULE_3__helper__["d" /* ParseFormInputDate */])(filter.dateRange.begin);
            var dateTill = Object(__WEBPACK_IMPORTED_MODULE_3__helper__["d" /* ParseFormInputDate */])(filter.dateRange.end);

            for (var i = 0; i < this.index.length; i++) {
                // filter keywords
                if (keywords) {
                    var score = 0;
                    for (var k = 0; k < keywords.length; k++) {
                        if (this.index[i].textsearch.indexOf(keywords[k]) > -1) {
                            score++;
                        }
                    }
                    if (score == 0) {
                        continue;
                    }
                }

                // filter title
                if (title) {
                    var _score = 0;
                    for (var _k = 0; _k < title.length; _k++) {
                        if (this.index[i].titleSearch.indexOf(title[_k]) > -1) {
                            _score++;
                        }
                    }

                    if (_score == 0) {
                        continue;
                    }
                }

                // filter topic
                if (filter.topic > 0 && this.index[i].topicIndex != filter.topic) {
                    continue;
                }

                // filter text type
                if (filter.textType > 0 && this.index[i].textIndex.indexOf(filter.textType) == -1) {
                    continue;
                }

                // filter text type
                if (filter.frontPage && this.index[i].page != 1) {
                    continue;
                }

                // filter placement
                if (filter.placement && this.index[i].placeIndex.indexOf(filter.placement) == -1) {
                    continue;
                }

                // filter illustrated
                if (filter.illustration == "1" && this.index[i].illustrationIndex == 2) {
                    continue;
                }

                // filter media
                if (Array.isArray(filter.media) && filter.media.length > 0 && filter.media.indexOf(this.index[i].objectIndex) == -1) {
                    continue;
                }

                // external media
                if (Array.isArray(filter.externalMedia) && filter.externalMedia.length > 0 && filter.externalMedia.indexOf(this.index[i].objectIndex) == -1) {
                    continue;
                }

                // filter date range
                if (dateFrom && dateTill) {
                    if (this.index[i].dateParsed < dateFrom || this.index[i].dateParsed > dateTill) {
                        continue;
                    }
                }

                // filter data index
                if (filter.dataIndex && this.index[i].id != filter.dataIndex) {
                    continue;
                }

                this.resultIndex.push(this.index[i]);
            }
        }
    }, {
        key: 'getResults',
        value: function getResults() {
            return this.resultIndex;
        }
    }, {
        key: 'getIndex',
        value: function getIndex() {
            return this.index;
        }
    }, {
        key: 'getIndexBySlug',
        value: function getIndexBySlug(name) {
            var idx = this.slugs[name];
            return idx === undefined ? 0 : idx;
        }
    }]);

    return Search;
}();

/* harmony default export */ __webpack_exports__["a"] = (new Search());

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Footer',
  data: function data() {
    return {
      date: new Date().getFullYear()
    };
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_807d9fa8_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__(218);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_807d9fa8_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_downloadjs__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		// mime type [xls, csv], default: xls
		'type': {
			type: String,
			default: "xls"
		},
		// Json to download
		'data': {
			type: Array,
			required: true
		},
		// fields inside the Json Object that you want to export
		// if no given, all the properties in the Json are exported
		'fields': {
			type: Object,
			required: false
		},
		// this prop is used to fix the problem with other components that use the
		// variable fields, like vee-validate. exportFields works exactly like fields
		'exportFields': {
			type: Object,
			required: false
		},
		// Title(s) for the data, could be a string or an array of strings (multiple titles)
		'title': {
			default: null
		},
		// Footer(s) for the data, could be a string or an array of strings (multiple footers)
		'footer': {
			default: null
		},
		// filename to export, deault: data.xls
		'name': {
			type: String,
			default: "data.xls"
		},
		'meta': {
			type: Array,
			default: function _default() {
				return [];
			}
		}
	},
	computed: {
		// unique identifier
		idName: function idName() {
			var now = new Date().getTime();
			return 'export_' + now;
		},

		downloadFields: function downloadFields() {
			if (this.fields !== undefined) return this.fields;

			if (this.exportFields !== undefined) return this.exportFields;
		}
	},
	methods: {
		generate: function generate() {
			if (!this.data.length) {
				return;
			}
			var json = this.getProcessedJson(this.data, this.downloadFields);
			if (this.type == 'csv') {
				return this.export(this.jsonToCSV(json), this.name, "application/csv");
			}
			return this.export(this.jsonToXLS(json), this.name, "application/vnd.ms-excel");
		},

		/*
  Use downloadjs to generate the download link
  */
		export: function _export(data, filename, mime) {
			var blob = this.base64ToBlob(data, mime);
			__WEBPACK_IMPORTED_MODULE_0_downloadjs___default()(blob, filename, mime);
		},

		/*
  jsonToXLS
  ---------------
  Transform json data into an xml document with MS Excel format, sadly
  this format show a prompt when open due to a default behavior
  on Microsoft office. It's recommended to use CSV format instead.
  */
		jsonToXLS: function jsonToXLS(data) {
			var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>${table}</table></body></html>';
			var xlsData = '<thead><tr>';
			var colspan = Object.keys(data[0]).length;

			//Header
			if (this.title != null) {
				xlsData += this.parseExtraData(this.title, '<th colspan="' + colspan + '">${data}<th></tr><tr>');
			}
			//Fields
			for (var key in data[0]) {
				xlsData += '<th>' + key + '</th>';
			}
			xlsData += '</tr></thead>';
			xlsData += '<tbody>';
			//Data
			data.map(function (item, index) {
				xlsData += '<tbody><tr>';
				for (var _key in item) {
					xlsData += '<td>' + item[_key] + '</td>';
				}
				xlsData += '</tr></tbody>';
			});
			//Footer
			if (this.footer != null) {
				xlsData += '<tfooter><tr>';
				xlsData += this.parseExtraData(this.footer, '<td colspan="' + colspan + '">${data}<td></tr><tr>');
				xlsData += '</tr></tfooter>';
			}
			return xlsTemp.replace('${table}', xlsData);
		},

		/*
  jsonToCSV
  ---------------
  Transform json data into an CSV file.
  */
		jsonToCSV: function jsonToCSV(data) {
			var csvData = '';
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n');
			}
			//Fields
			for (var key in data[0]) {
				csvData += key + ',';
			}
			csvData = csvData.slice(0, csvData.length - 1);
			csvData += '\r\n';
			//Data
			data.map(function (item) {
				for (var _key2 in item) {
					var escapedCSV = item[_key2] + ''; // cast Numbers to string
					if (escapedCSV.match(/[,"\n]/)) {
						escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"';
					}
					csvData += escapedCSV + ',';
				}
				csvData = csvData.slice(0, csvData.length - 1);
				csvData += '\r\n';
			});
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n');
			}
			return csvData;
		},

		/*
  getProcessedJson
  ---------------
  Get only the data to export, if no fields are set return all the data
  */
		getProcessedJson: function getProcessedJson(data, header) {
			var keys = this.getKeys(data, header);
			var newData = [];
			var _self = this;
			data.map(function (item, index) {
				var newItem = {};
				for (var label in keys) {
					var iii = item;
					var property = keys[label];
					newItem[label] = _self.getNestedData(property, item);
				}
				newData.push(newItem);
			});

			return newData;
		},
		getKeys: function getKeys(data, header) {
			if (header) {
				return header;
			}

			var keys = {};
			for (var key in data[0]) {
				keys[key] = key;
			}
			return keys;
		},
		/*
  parseExtraData
  ---------------
  Parse title and footer attribute to the csv format
  */
		parseExtraData: function parseExtraData(extraData, format) {
			var parseData = '';
			if (Array.isArray(extraData)) {
				for (var i = 0; i < extraData.length; i++) {
					parseData += format.replace('${data}', extraData[i]);
				}
			} else {
				parseData += format.replace('${data}', extraData);
			}
			return parseData;
		},

		callItemCallback: function callItemCallback(field, itemValue) {
			if ((typeof field === 'undefined' ? 'undefined' : _typeof(field)) === 'object' && typeof field.callback === 'function') {
				return field.callback(itemValue);
			}
			return itemValue;
		},
		getNestedData: function getNestedData(key, item) {
			var field = (typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object' ? key.field : key;

			var valueFromNestedKey = null;
			var keyNestedSplit = field.split(".");

			valueFromNestedKey = item[keyNestedSplit[0]];
			for (var j = 1; j < keyNestedSplit.length; j++) {
				valueFromNestedKey = valueFromNestedKey[keyNestedSplit[j]];
			}

			valueFromNestedKey = this.callItemCallback(key, valueFromNestedKey);

			return valueFromNestedKey;
		},
		base64ToBlob: function base64ToBlob(data, mime) {
			var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
			var bstr = atob(base64);
			var n = bstr.length;
			var u8arr = new Uint8ClampedArray(n);
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n);
			}
			return new Blob([u8arr], { type: mime });
		}
	} // end methods
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomePage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', ['Startseite']);
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AboutPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', ['Über das Archiv']);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FaqPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', [{ text: 'Über das Archiv', to: { name: 'about' } }, 'Fragen und Antworten']);
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SearchForm_vue__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_SearchResult_vue__ = __webpack_require__(238);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'app-searchform': __WEBPACK_IMPORTED_MODULE_1__components_SearchForm_vue__["a" /* default */],
    'app-searchresult': __WEBPACK_IMPORTED_MODULE_2__components_SearchResult_vue__["a" /* default */]
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', ['Medienarchiv']);
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setActivePage', 'archive');
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('resetSearchFilter');
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('updateSearch');
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapping__ = __webpack_require__(37);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SearchFilterModel = {
    topic: null,
    title: null,
    keywords: null,
    placement: null,
    textType: null,
    media: [],
    externalMedia: [],
    frontPage: null,
    illustration: null,
    dataIndex: null,
    dateRange: {
        begin: '02.12.1966',
        end: '31.12.1968'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SearchForm',
    data: function data() {
        return {
            state: null,
            filter: Object.assign({}, SearchFilterModel),
            options: {
                topics: [{
                    value: null,
                    text: 'Bitte auswählen'
                }].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].topic.getValues())),
                textType: [{
                    value: null,
                    text: 'Bitte auswählen'
                }].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].type.getValues())),
                placement: [{
                    value: null,
                    text: 'Bitte auswählen'
                }].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].placement.getValues())),
                media: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].media.getValues(function (val) {
                    return !val.hasOwnProperty('external') || val.external == false;
                }),
                externalMedia: __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].media.getValues(function (val) {
                    return val.hasOwnProperty('external') && val.external == true;
                })
            }
        };
    },

    methods: {
        simpleSearch: function simpleSearch(event) {
            var filter = {
                topic: null,
                title: null,
                keywords: null,
                placement: null,
                textType: null,
                media: [],
                frontPage: null,
                illustration: null,
                dataIndex: null,
                dateRange: {
                    begin: '02.12.1966',
                    end: '31.12.1968'
                }
            };

            filter.keywords = '' + this.filter.keywords;
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('updateSearch', filter);
        },
        filteredSearch: function filteredSearch(event) {
            console.log(this.filter);
            __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('updateSearch', this.filter);
        },
        resetSearchFilter: function resetSearchFilter(event) {
            this.filter = {
                topic: null,
                title: null,
                keywords: null,
                placement: null,
                textType: null,
                media: [],
                frontPage: null,
                illustration: null,
                dataIndex: null,
                dateRange: {
                    begin: '02.12.1966',
                    end: '31.12.1968'
                }
            };
        }
    }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_json_excel__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapping__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SearchResultSingle_vue__ = __webpack_require__(239);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchResult',
  data: function data() {
    return {
      totalRows: 0,
      currentPage: 1,
      offsetFrom: 0,
      offsetTo: 0,
      limit: 25,
      items: []
    };
  },

  components: {
    SearchResultSingle: __WEBPACK_IMPORTED_MODULE_2__SearchResultSingle_vue__["a" /* default */],
    'downloadExcel': __WEBPACK_IMPORTED_MODULE_0_vue_json_excel__["a" /* default */]
  },
  computed: {
    paginatedData: function paginatedData(state) {
      this.getDataSet(this.currentPage);
    }
  },
  methods: {
    getExportFields: function getExportFields() {
      return __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].export.fields;
    },
    getExportMeta: function getExportMeta() {
      return __WEBPACK_IMPORTED_MODULE_1__mapping__["a" /* default */].export.meta;
    },
    getCurrentResultJSON: function getCurrentResultJSON() {
      var search = this.$store.getters.getSearchResult;
      var res = [];

      for (var i = 0; i < search.length; i++) {
        res.push(search[i]);
      }

      return res;
    },
    getCompleteResultJSON: function getCompleteResultJSON() {
      var items = this.$store.getters.getAllItems;
      var res = [];

      for (var i = 0; i < items.length; i++) {
        res.push(items[i]);
      }

      return res;
    },
    getDataSet: function getDataSet(curPage) {
      var res = this.$store.getters.getSearchResult;
      this.offsetFrom = (curPage - 1) * this.limit;
      this.offsetTo = this.offsetFrom + this.limit;

      var listLength = res.length;
      if (this.offsetFrom > listLength) {
        this.items = [];
        return;
      }

      if (this.offsetTo > listLength) {
        this.offsetTo = listLength;
      }

      this.totalRows = listLength;
      this.items = res.slice(this.offsetFrom, this.offsetTo);
    },
    paginationChange: function paginationChange(page) {
      this.getDataSet(page, this.limit);
    }
  },
  mounted: function mounted() {
    this.getDataSet(1, this.limit);
  }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(38);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchResultSingle',
  props: ['item'],
  computed: {
    shortedContent: function shortedContent() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__helper__["e" /* truncate */])(this.item.content, 120);
    },
    formattedDate: function formattedDate() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */])(this.item.date);
    },
    imageSrc: function imageSrc() {
      return '/dl/' + this.item.id + '/thumbnail.jpg';
    },
    imageAlt: function imageAlt() {
      return this.item.object + ' vom ' + Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */])(this.item.date);
    }
  },
  methods: {
    DateSmallDecorator: __WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */],
    truncate: __WEBPACK_IMPORTED_MODULE_0__helper__["e" /* truncate */]
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SearchHelpPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', [{ text: 'Medienarchiv', to: { name: 'archive' } }, 'Hilfe']);
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PressPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', ['Pressespiegel']);
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ContactPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', ['Kontakt']);
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MediaDetailPage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('setBreadcrumb', ['Medienarchiv']);
    this.routeSlug = this.$route.params.slug;
    this.itemIndex = this.$route.params.index;

    if (this.itemIndex === undefined) {
      this.itemIndex = this.$store.getters.getIndexFromSlug(this.routeSlug);
    }
  },

  computed: {
    item: function item() {
      return this.$store.getters.getItemFromResult(this.itemIndex);
    },
    slugNotFound: function slugNotFound() {
      return !this.item;
    },
    pdfDownloadurl: function pdfDownloadurl() {
      return '/dl/' + this.item.id + '/article.pdf';
    },
    imageSrc: function imageSrc() {
      return '/dl/' + this.item.id + '/thumbnail.jpg';
    },
    imageAlt: function imageAlt() {
      return this.item.object + ' vom ' + Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */])(this.item.date);
    },
    date: function date() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */])(this.item.date);
    }
  },
  methods: {
    DateSmallDecorator: __WEBPACK_IMPORTED_MODULE_0__helper__["b" /* DateSmallDecorator */]
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PrivacyClausePage',
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].commit('setBreadcrumb', [{ text: 'Kontakt', to: { name: 'contact' } }, 'Hinweise zum Datenschutz']);
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue_dist_bootstrap_vue_css__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  },
  created: function created() {}
});

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(89);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15), __webpack_require__(90)))

/***/ }),
/* 90 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var VuePlugin = {
  install: function install(Vue) {
    if (Vue._bootstrap_vue_installed) {
      return;
    }

    Vue._bootstrap_vue_installed = true;

    // Register component plugins
    for (var plugin in __WEBPACK_IMPORTED_MODULE_0__components__) {
      Vue.use(__WEBPACK_IMPORTED_MODULE_0__components__[plugin]);
    }

    // Register directive plugins
    for (var _plugin in __WEBPACK_IMPORTED_MODULE_1__directives__) {
      Vue.use(__WEBPACK_IMPORTED_MODULE_1__directives__[_plugin]);
    }
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__badge__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumb__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__button_group__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__button_toolbar__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__input_group__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__carousel__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__layout__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__collapse__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dropdown__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__embed__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__form__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__form_group__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__form_checkbox__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__form_radio__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__form_input__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__form_textarea__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_file__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__form_select__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__image__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__jumbotron__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__link__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__list_group__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__media__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__modal__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__nav__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__navbar__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pagination__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pagination_nav__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__popover__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__progress__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__table__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__tabs__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__tooltip__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return __WEBPACK_IMPORTED_MODULE_0__alert__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_1__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_3__button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_5__button_toolbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_4__button_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_7__card__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Carousel", function() { return __WEBPACK_IMPORTED_MODULE_8__carousel__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collapse", function() { return __WEBPACK_IMPORTED_MODULE_10__collapse__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_11__dropdown__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Embed", function() { return __WEBPACK_IMPORTED_MODULE_12__embed__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_13__form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_14__form_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormInput", function() { return __WEBPACK_IMPORTED_MODULE_17__form_input__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTextarea", function() { return __WEBPACK_IMPORTED_MODULE_18__form_textarea__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormFile", function() { return __WEBPACK_IMPORTED_MODULE_19__form_file__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_15__form_checkbox__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRadio", function() { return __WEBPACK_IMPORTED_MODULE_16__form_radio__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSelect", function() { return __WEBPACK_IMPORTED_MODULE_20__form_select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_21__image__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InputGroup", function() { return __WEBPACK_IMPORTED_MODULE_6__input_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Jumbotron", function() { return __WEBPACK_IMPORTED_MODULE_22__jumbotron__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Layout", function() { return __WEBPACK_IMPORTED_MODULE_9__layout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_23__link__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListGroup", function() { return __WEBPACK_IMPORTED_MODULE_24__list_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Media", function() { return __WEBPACK_IMPORTED_MODULE_25__media__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_26__modal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Nav", function() { return __WEBPACK_IMPORTED_MODULE_27__nav__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Navbar", function() { return __WEBPACK_IMPORTED_MODULE_28__navbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_29__pagination__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationNav", function() { return __WEBPACK_IMPORTED_MODULE_30__pagination_nav__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_31__popover__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return __WEBPACK_IMPORTED_MODULE_32__progress__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_33__table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return __WEBPACK_IMPORTED_MODULE_34__tabs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_35__tooltip__["a"]; });







































/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alert__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bAlert: __WEBPACK_IMPORTED_MODULE_0__alert__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_button_close__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_css__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__alert_css__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bButtonClose: __WEBPACK_IMPORTED_MODULE_0__button_button_close__["a" /* default */] },
  render: function render(h) {
    if (!this.localShow) {
      // If not showing, render placeholder
      return h(false);
    }
    var dismissBtn = h(false);
    if (this.dismissible) {
      // Add dismiss button
      dismissBtn = h('b-button-close', { attrs: { 'aria-label': this.dismissLabel }, on: { click: this.dismiss } }, [this.$slots.dismiss]);
    }
    var alert = h('div', { class: this.classObject, attrs: { role: 'alert', 'aria-live': 'polite', 'aria-atomic': true } }, [dismissBtn, this.$slots.default]);
    return !this.fade ? alert : h('transition', { props: { name: 'fade', appear: true } }, [alert]);
  },

  model: {
    prop: 'show',
    event: 'input'
  },
  data: function data() {
    return {
      countDownTimerId: null,
      dismissed: false
    };
  },

  computed: {
    classObject: function classObject() {
      return ['alert', this.alertVariant, this.dismissible ? 'alert-dismissible' : ''];
    },
    alertVariant: function alertVariant() {
      var variant = this.variant;
      return 'alert-' + variant;
    },
    localShow: function localShow() {
      return !this.dismissed && (this.countDownTimerId || this.show);
    }
  },
  props: {
    variant: {
      type: String,
      default: 'info'
    },
    dismissible: {
      type: Boolean,
      default: false
    },
    dismissLabel: {
      type: String,
      default: 'Close'
    },
    show: {
      type: [Boolean, Number],
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show: function show() {
      this.showChanged();
    }
  },
  mounted: function mounted() {
    this.showChanged();
  },
  destroyed /* istanbul ignore next */: function destroyed() {
    this.clearCounter();
  },

  methods: {
    dismiss: function dismiss() {
      this.clearCounter();
      this.dismissed = true;
      this.$emit('dismissed');
      this.$emit('input', false);
      if (typeof this.show === 'number') {
        this.$emit('dismiss-count-down', 0);
        this.$emit('input', 0);
      } else {
        this.$emit('input', false);
      }
    },
    clearCounter: function clearCounter() {
      if (this.countDownTimerId) {
        clearInterval(this.countDownTimerId);
        this.countDownTimerId = null;
      }
    },
    showChanged: function showChanged() {
      var _this = this;

      // Reset counter status
      this.clearCounter();
      // Reset dismiss status
      this.dismissed = false;
      // No timer for boolean values
      if (this.show === true || this.show === false || this.show === null || this.show === 0) {
        return;
      }
      // Start counter
      var dismissCountDown = this.show;
      this.countDownTimerId = setInterval(function () {
        if (dismissCountDown < 1) {
          _this.dismiss();
          return;
        }
        dismissCountDown--;
        _this.$emit('dismiss-count-down', dismissCountDown);
        _this.$emit('input', dismissCountDown);
      }, 1000);
    }
  }
});

/***/ }),
/* 95 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bBadge: __WEBPACK_IMPORTED_MODULE_0__badge__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__link_link__ = __webpack_require__(9);






var linkProps = Object(__WEBPACK_IMPORTED_MODULE_3__link_link__["c" /* propsFactory */])();
delete linkProps.href.default;
delete linkProps.to.default;

var props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(linkProps, {
  tag: {
    type: String,
    default: 'span'
  },
  variant: {
    type: String,
    default: 'secondary'
  },
  pill: {
    type: Boolean,
    default: false
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var tag = !props.href && !props.to ? props.tag : __WEBPACK_IMPORTED_MODULE_3__link_link__["a" /* default */];

    var componentData = {
      staticClass: 'badge',
      class: [!props.variant ? 'badge-secondary' : 'badge-' + props.variant, {
        'badge-pill': Boolean(props.pill),
        active: props.active,
        disabled: props.disabled
      }],
      props: Object(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a" /* default */])(linkProps, props)
    };

    return h(tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breadcrumb__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(1);





var components = {
  bBreadcrumb: __WEBPACK_IMPORTED_MODULE_0__breadcrumb__["a" /* default */],
  bBreadcrumbItem: __WEBPACK_IMPORTED_MODULE_1__breadcrumb_item__["a" /* default */],
  bBreadcrumbLink: __WEBPACK_IMPORTED_MODULE_2__breadcrumb_link__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__ = __webpack_require__(40);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






var props = {
  items: {
    type: Array,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var childNodes = children;
    // Build child nodes from items if given.
    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["d" /* isArray */])(props.items)) {
      var activeDefined = false;
      childNodes = props.items.map(function (item, idx) {
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) !== 'object') {
          item = { text: item };
        }
        // Copy the value here so we can normalize it.
        var active = item.active;
        if (active) {
          activeDefined = true;
        }
        if (!active && !activeDefined) {
          // Auto-detect active by position in list.
          active = idx + 1 === props.items.length;
        }

        return h(__WEBPACK_IMPORTED_MODULE_3__breadcrumb_item__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({}, item, { active: active }) });
      });
    }

    return h('ol', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: 'breadcrumb' }), childNodes);
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_close__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bButton: __WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */],
  bBtn: __WEBPACK_IMPORTED_MODULE_0__button__["a" /* default */],
  bButtonClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a" /* default */],
  bBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_close__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_group__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bButtonGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a" /* default */],
  bBtnGroup: __WEBPACK_IMPORTED_MODULE_0__button_group__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var props = {
  vertical: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: null,
    validator: function validator(size) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(['sm', '', 'lg'], size);
    }
  },
  tag: {
    type: String,
    default: 'div'
  },
  ariaRole: {
    type: String,
    default: 'group'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: _defineProperty({
        'btn-group': !props.vertical,
        'btn-group-vertical': props.vertical
      }, 'btn-group-' + props.size, Boolean(props.size)),
      attrs: { 'role': props.ariaRole }
    }), children);
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_toolbar__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bButtonToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a" /* default */],
  bBtnToolbar: __WEBPACK_IMPORTED_MODULE_0__button_toolbar__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(13);



var ITEM_SELECTOR = ['.btn:not(.disabled):not([disabled]):not(.dropdown-item)', '.form-control:not(.disabled):not([disabled])', 'select:not(.disabled):not([disabled])', 'input[type="checkbox"]:not(.disabled)', 'input[type="radio"]:not(.disabled)'].join(',');

/* harmony default export */ __webpack_exports__["a"] = ({
  render: function render(h) {
    return h('div', {
      class: this.classObject,
      attrs: {
        role: 'toolbar',
        tabindex: this.keyNav ? '0' : null
      },
      on: {
        focusin: this.onFocusin,
        keydown: this.onKeydown
      }
    }, [this.$slots.default]);
  },

  computed: {
    classObject: function classObject() {
      return ['btn-toolbar', this.justify && !this.vertical ? 'justify-content-between' : ''];
    }
  },
  props: {
    justify: {
      type: Boolean,
      default: false
    },
    keyNav: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onFocusin: function onFocusin(evt) {
      if (evt.target === this.$el) {
        evt.preventDefault();
        evt.stopPropagation();
        this.focusFirst(evt);
      }
    },
    onKeydown: function onKeydown(evt) {
      if (!this.keyNav) {
        return;
      }
      var key = evt.keyCode;
      var shift = evt.shiftKey;
      if (key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].UP || key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT) {
        evt.preventDefault();
        evt.stopPropagation();
        if (shift) {
          this.focusFirst(evt);
        } else {
          this.focusNext(evt, true);
        }
      } else if (key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].DOWN || key === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].RIGHT) {
        evt.preventDefault();
        evt.stopPropagation();
        if (shift) {
          this.focusLast(evt);
        } else {
          this.focusNext(evt, false);
        }
      }
    },
    setItemFocus: function setItemFocus(item) {
      this.$nextTick(function () {
        item.focus();
      });
    },
    focusNext: function focusNext(evt, prev) {
      var items = this.getItems();
      if (items.length < 1) {
        return;
      }
      var index = items.indexOf(evt.target);
      if (prev && index > 0) {
        index--;
      } else if (!prev && index < items.length - 1) {
        index++;
      }
      if (index < 0) {
        index = 0;
      }
      this.setItemFocus(items[index]);
    },
    focusFirst: function focusFirst(evt) {
      var items = this.getItems();
      if (items.length > 0) {
        this.setItemFocus(items[0]);
      }
    },
    focusLast: function focusLast(evt) {
      var items = this.getItems();
      if (items.length > 0) {
        this.setItemFocus([items.length - 1]);
      }
    },
    getItems: function getItems() {
      var items = Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["u" /* selectAll */])(ITEM_SELECTOR, this.$el);
      items.forEach(function (item) {
        // Ensure tabfocus is -1 on any new elements
        item.tabIndex = -1;
      });
      return items.filter(function (el) {
        return Object(__WEBPACK_IMPORTED_MODULE_0__utils_dom__["m" /* isVisible */])(el);
      });
    }
  },
  mounted: function mounted() {
    if (this.keyNav) {
      // Pre-set the tabindexes if the markup does not include tabindex="-1" on the toolbar items
      this.getItems();
    }
  }
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_plugins__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_group__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_group_addon__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_group_prepend__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__input_group_append__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__input_group_text__ = __webpack_require__(29);








var components = {
  bInputGroup: __WEBPACK_IMPORTED_MODULE_1__input_group__["a" /* default */],
  bInputGroupAddon: __WEBPACK_IMPORTED_MODULE_2__input_group_addon__["a" /* default */],
  bInputGroupPrepend: __WEBPACK_IMPORTED_MODULE_3__input_group_prepend__["a" /* default */],
  bInputGroupAppend: __WEBPACK_IMPORTED_MODULE_4__input_group_append__["a" /* default */],
  bInputGroupText: __WEBPACK_IMPORTED_MODULE_5__input_group_text__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_0__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_group_prepend__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_group_append__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_group_text__ = __webpack_require__(29);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var props = {
  id: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: null
  },
  prepend: {
    type: String,
    default: null
  },
  append: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'div'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    var $slots = slots();

    var childNodes = [];

    // Prepend prop
    if (props.prepend) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__input_group_prepend__["a" /* default */], [h(__WEBPACK_IMPORTED_MODULE_3__input_group_text__["a" /* default */], { domProps: { innerHTML: props.prepend } })]));
    }

    // Prepend slot
    if ($slots.prepend) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__input_group_prepend__["a" /* default */], $slots.prepend));
    }

    // Default slot
    childNodes.push($slots.default);

    // Append prop
    if (props.append) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__input_group_append__["a" /* default */], [h(__WEBPACK_IMPORTED_MODULE_3__input_group_text__["a" /* default */], { domProps: { innerHTML: props.append } })]));
    }

    // Append slot
    if ($slots.append) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__input_group_append__["a" /* default */], $slots.append));
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'input-group',
      class: _defineProperty({}, 'input-group-' + props.size, Boolean(props.size)),
      attrs: {
        id: props.id || null,
        role: 'group'
      }
    }), childNodes);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__card__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__card_header__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__card_body__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__card_footer__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__card_img__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__card_group__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_plugins__ = __webpack_require__(1);








var components = {
  bCard: __WEBPACK_IMPORTED_MODULE_0__card__["a" /* default */],
  bCardHeader: __WEBPACK_IMPORTED_MODULE_1__card_header__["a" /* default */],
  bCardBody: __WEBPACK_IMPORTED_MODULE_2__card_body__["a" /* default */],
  bCardFooter: __WEBPACK_IMPORTED_MODULE_3__card_footer__["a" /* default */],
  bCardImg: __WEBPACK_IMPORTED_MODULE_4__card_img__["a" /* default */],
  bCardGroup: __WEBPACK_IMPORTED_MODULE_5__card_group__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_6__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_copyProps__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__card_body__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__card_header__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__card_footer__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__card_img__ = __webpack_require__(48);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }














var cardImgProps = Object(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__card_img__["b" /* props */], __WEBPACK_IMPORTED_MODULE_1__utils_prefix_prop_name__["a" /* default */].bind(null, 'img'));
cardImgProps.imgSrc.required = false;

var props = Object(__WEBPACK_IMPORTED_MODULE_5__utils_object__["a" /* assign */])({}, __WEBPACK_IMPORTED_MODULE_7__card_body__["b" /* props */], __WEBPACK_IMPORTED_MODULE_8__card_header__["b" /* props */], __WEBPACK_IMPORTED_MODULE_9__card_footer__["b" /* props */], cardImgProps, Object(__WEBPACK_IMPORTED_MODULE_3__utils_copyProps__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_6__mixins_card_mixin__["a" /* default */].props), {
  align: {
    type: String,
    default: null
  },
  noBody: {
    type: Boolean,
    default: false
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        children = _ref.children;

    // The order of the conditionals matter.
    // We are building the component markup in order.
    var childNodes = [];
    var $slots = slots();
    var img = props.imgSrc ? h(__WEBPACK_IMPORTED_MODULE_10__card_img__["a" /* default */], {
      props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(cardImgProps, props, __WEBPACK_IMPORTED_MODULE_2__utils_unprefix_prop_name__["a" /* default */].bind(null, 'img'))
    }) : null;

    if (img) {
      // Above the header placement.
      if (props.imgTop || !props.imgBottom) {
        childNodes.push(img);
      }
    }
    if (props.header || $slots.header) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_8__card_header__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__card_header__["b" /* props */], props) }, $slots.header));
    }
    if (props.noBody) {
      childNodes.push($slots.default);
    } else {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_7__card_body__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7__card_body__["b" /* props */], props) }, $slots.default));
    }
    if (props.footer || $slots.footer) {
      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_9__card_footer__["a" /* default */], { props: Object(__WEBPACK_IMPORTED_MODULE_4__utils_pluck_props__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__card_footer__["b" /* props */], props) }, $slots.footer));
    }
    if (img && props.imgBottom) {
      // Below the footer placement.
      childNodes.push(img);
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'card',
      class: (_class = {}, _defineProperty(_class, 'text-' + props.align, Boolean(props.align)), _defineProperty(_class, 'bg-' + props.bgVariant, Boolean(props.bgVariant)), _defineProperty(_class, 'border-' + props.borderVariant, Boolean(props.borderVariant)), _defineProperty(_class, 'text-' + props.textVariant, Boolean(props.textVariant)), _class)
    }), childNodes);
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unPrefixPropName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lower_first__ = __webpack_require__(110);


/**
 * @param {string} prefix
 * @param {string} value
 */
function unPrefixPropName(prefix, value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__lower_first__["a" /* default */])(value.replace(prefix, ''));
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lowerFirst;
/**
 * @param {string} str
 */
function lowerFirst(str) {
  if (typeof str !== 'string') {
    str = String(str);
  }
  return str.charAt(0).toLowerCase() + str.slice(1);
}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  },
  deck: {
    type: Boolean,
    default: false
  },
  columns: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var staticClass = 'card-group';
    if (props.columns) {
      staticClass = 'card-columns';
    }
    if (props.deck) {
      staticClass = 'card-deck';
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: staticClass }), children);
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__carousel__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__carousel_slide__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bCarousel: __WEBPACK_IMPORTED_MODULE_0__carousel__["a" /* default */],
  bCarouselSlide: __WEBPACK_IMPORTED_MODULE_1__carousel_slide__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_id__ = __webpack_require__(5);





// Slide directional classes
var DIRECTION = {
  next: {
    dirClass: 'carousel-item-left',
    overlayClass: 'carousel-item-next'
  },
  prev: {
    dirClass: 'carousel-item-right',
    overlayClass: 'carousel-item-prev'
  }

  // Fallback Transition duration (with a little buffer) in ms
};var TRANS_DURATION = 600 + 50;

// Transition Event names
var TransitionEndEvents = {
  WebkitTransition: 'webkitTransitionEnd',
  MozTransition: 'transitionend',
  OTransition: 'otransitionend oTransitionEnd',
  transition: 'transitionend'

  // Return the browser specific transitionEnd event name
};function getTransisionEndEvent(el) {
  for (var name in TransitionEndEvents) {
    if (el.style[name] !== undefined) {
      return TransitionEndEvents[name];
    }
  }
  // fallback
  return null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_id__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    // Wrapper for slides
    var inner = h('div', {
      ref: 'inner',
      class: ['carousel-inner'],
      attrs: {
        id: this.safeId('__BV_inner_'),
        role: 'list'
      }
    }, [this.$slots.default]);

    // Prev and Next Controls
    var controls = h(false);
    if (this.controls) {
      controls = [h('a', {
        class: ['carousel-control-prev'],
        attrs: { href: '#', role: 'button', 'aria-controls': this.safeId('__BV_inner_') },
        on: {
          click: function click(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            _this.prev();
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              _this.prev();
            }
          }
        }
      }, [h('span', { class: ['carousel-control-prev-icon'], attrs: { 'aria-hidden': 'true' } }), h('span', { class: ['sr-only'] }, [this.labelPrev])]), h('a', {
        class: ['carousel-control-next'],
        attrs: { href: '#', role: 'button', 'aria-controls': this.safeId('__BV_inner_') },
        on: {
          click: function click(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            _this.next();
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              _this.next();
            }
          }
        }
      }, [h('span', { class: ['carousel-control-next-icon'], attrs: { 'aria-hidden': 'true' } }), h('span', { class: ['sr-only'] }, [this.labelNext])])];
    }

    // Indicators
    var indicators = h('ol', {
      class: ['carousel-indicators'],
      directives: [{ name: 'show', rawName: 'v-show', value: this.indicators, expression: 'indicators' }],
      attrs: {
        id: this.safeId('__BV_indicators_'),
        'aria-hidden': this.indicators ? 'false' : 'true',
        'aria-label': this.labelIndicators,
        'aria-owns': this.safeId('__BV_inner_')
      }
    }, this.slides.map(function (slide, n) {
      return h('li', {
        key: 'slide_' + n,
        class: { active: n === _this.index },
        attrs: {
          role: 'button',
          id: _this.safeId('__BV_indicator_' + (n + 1) + '_'),
          tabindex: _this.indicators ? '0' : '-1',
          'aria-current': n === _this.index ? 'true' : 'false',
          'aria-label': _this.labelGotoSlide + ' ' + (n + 1),
          'aria-describedby': _this.slides[n].id || null,
          'aria-controls': _this.safeId('__BV_inner_')
        },
        on: {
          click: function click(evt) {
            _this.setSlide(n);
          },
          keydown: function keydown(evt) {
            var keyCode = evt.keyCode;
            if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].SPACE || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].ENTER) {
              evt.preventDefault();
              evt.stopPropagation();
              _this.setSlide(n);
            }
          }
        }
      });
    }));

    // Return the carousel
    return h('div', {
      class: ['carousel', 'slide'],
      style: { background: this.background },
      attrs: {
        role: 'region',
        id: this.safeId(),
        'aria-busy': this.isSliding ? 'true' : 'false'
      },
      on: {
        mouseenter: this.pause,
        mouseleave: this.restart,
        focusin: this.pause,
        focusout: this.restart,
        keydown: function keydown(evt) {
          var keyCode = evt.keyCode;
          if (keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT || keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].RIGHT) {
            evt.preventDefault();
            evt.stopPropagation();
            _this[keyCode === __WEBPACK_IMPORTED_MODULE_1__utils_key_codes__["a" /* default */].LEFT ? 'prev' : 'next']();
          }
        }
      }
    }, [inner, controls, indicators]);
  },
  data: function data() {
    return {
      index: this.value || 0,
      isSliding: false,
      intervalId: null,
      transitionEndEvent: null,
      slides: [],
      direction: null
    };
  },

  props: {
    labelPrev: {
      type: String,
      default: 'Previous Slide'
    },
    labelNext: {
      type: String,
      default: 'Next Slide'
    },
    labelGotoSlide: {
      type: String,
      default: 'Goto Slide'
    },
    labelIndicators: {
      type: String,
      default: 'Select a slide to display'
    },
    interval: {
      type: Number,
      default: 5000
    },
    indicators: {
      type: Boolean,
      default: false
    },
    controls: {
      type: Boolean,
      default: false
    },
    imgWidth: {
      // Sniffed by carousel-slide
      type: [Number, String]
    },
    imgHeight: {
      // Sniffed by carousel-slide
      type: [Number, String]
    },
    background: {
      type: String
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isCycling: function isCycling() {
      return Boolean(this.intervalId);
    }
  },
  methods: {
    // Set slide
    setSlide: function setSlide(slide) {
      var _this2 = this;

      // Don't animate when page is not visible
      if (typeof document !== 'undefined' && document.visibilityState && document.hidden) {
        return;
      }
      var len = this.slides.length;
      // Don't do anything if nothing to slide to
      if (len === 0) {
        return;
      }
      // Don't change slide while transitioning, wait until transition is done
      if (this.isSliding) {
        // Schedule slide after sliding complete
        this.$once('sliding-end', function () {
          return _this2.setSlide(slide);
        });
        return;
      }
      // Make sure we have an integer (you never know!)
      slide = Math.floor(slide);
      // Set new slide index. Wrap around if necessary
      this.index = slide >= len ? 0 : slide >= 0 ? slide : len - 1;
    },

    // Previous slide
    prev: function prev() {
      this.direction = 'prev';
      this.setSlide(this.index - 1);
    },

    // Next slide
    next: function next() {
      this.direction = 'next';
      this.setSlide(this.index + 1);
    },

    // Pause auto rotation
    pause: function pause() {
      if (this.isCycling) {
        clearInterval(this.intervalId);
        this.intervalId = null;
        if (this.slides[this.index]) {
          // Make current slide focusable for screen readers
          this.slides[this.index].tabIndex = 0;
        }
      }
    },

    // Start auto rotate slides
    start: function start() {
      var _this3 = this;

      // Don't start if no interval, or if we are already running
      if (!this.interval || this.isCycling) {
        return;
      }
      this.slides.forEach(function (slide) {
        slide.tabIndex = -1;
      });
      this.intervalId = setInterval(function () {
        _this3.next();
      }, Math.max(1000, this.interval));
    },

    // Re-Start auto rotate slides when focus/hover leaves the carousel
    restart: function restart(evt) {
      if (!this.$el.contains(document.activeElement)) {
        this.start();
      }
    },

    // Update slide list
    updateSlides: function updateSlides() {
      this.pause();
      // Get all slides as DOM elements
      this.slides = Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["u" /* selectAll */])('.carousel-item', this.$refs.inner);
      var numSlides = this.slides.length;
      // Keep slide number in range
      var index = Math.max(0, Math.min(Math.floor(this.index), numSlides - 1));
      this.slides.forEach(function (slide, idx) {
        var n = idx + 1;
        if (idx === index) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(slide, 'active');
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(slide, 'active');
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-current', idx === index ? 'true' : 'false');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-posinset', String(n));
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(slide, 'aria-setsize', String(numSlides));
        slide.tabIndex = -1;
      });
      // Set slide as active
      this.setSlide(index);
      this.start();
    },
    calcDirection: function calcDirection() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var curIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var nextIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (!direction) {
        return nextIndex > curIndex ? DIRECTION.next : DIRECTION.prev;
      }
      return DIRECTION[direction];
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setSlide(newVal);
      }
    },
    interval: function interval(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (!newVal) {
        // Pausing slide show
        this.pause();
      } else {
        // Restarting or Changing interval
        this.pause();
        this.start();
      }
    },
    index: function index(val, oldVal) {
      var _this4 = this;

      if (val === oldVal || this.isSliding) {
        return;
      }
      // Determine sliding direction
      var direction = this.calcDirection(this.direction, oldVal, val);
      // Determine current and next slides
      var currentSlide = this.slides[oldVal];
      var nextSlide = this.slides[val];
      // Don't do anything if there aren't any slides to slide to
      if (!currentSlide || !nextSlide) {
        return;
      }
      // Start animating
      this.isSliding = true;
      this.$emit('sliding-start', val);
      // Update v-model
      this.$emit('input', this.index);
      nextSlide.classList.add(direction.overlayClass);
      // Trigger a reflow of next slide
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["q" /* reflow */])(nextSlide);
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(currentSlide, direction.dirClass);
      Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, direction.dirClass);
      // Transition End handler
      var called = false;
      /* istanbul ignore next: dificult to test */
      var onceTransEnd = function onceTransEnd(evt) {
        if (called) {
          return;
        }
        called = true;
        if (_this4.transitionEndEvent) {
          var events = _this4.transitionEndEvent.split(/\s+/);
          events.forEach(function (event) {
            Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["c" /* eventOff */])(currentSlide, event, onceTransEnd);
          });
        }
        _this4._animationTimeout = null;
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(nextSlide, direction.dirClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(nextSlide, direction.overlayClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["a" /* addClass */])(nextSlide, 'active');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, 'active');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, direction.dirClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["s" /* removeClass */])(currentSlide, direction.overlayClass);
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(currentSlide, 'aria-current', 'false');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(nextSlide, 'aria-current', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(currentSlide, 'aria-hidden', 'true');
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["v" /* setAttr */])(nextSlide, 'aria-hidden', 'false');
        currentSlide.tabIndex = -1;
        nextSlide.tabIndex = -1;
        if (!_this4.isCycling) {
          // Focus the next slide for screen readers if not in play mode
          nextSlide.tabIndex = 0;
          _this4.$nextTick(function () {
            nextSlide.focus();
          });
        }
        _this4.isSliding = false;
        _this4.direction = null;
        // Notify ourselves that we're done sliding (slid)
        _this4.$nextTick(function () {
          return _this4.$emit('sliding-end', val);
        });
      };
      // Clear transition classes after transition ends
      if (this.transitionEndEvent) {
        var events = this.transitionEndEvent.split(/\s+/);
        events.forEach(function (event) {
          Object(__WEBPACK_IMPORTED_MODULE_2__utils_dom__["d" /* eventOn */])(currentSlide, event, onceTransEnd);
        });
      }
      // Fallback to setTimeout
      this._animationTimeout = setTimeout(onceTransEnd, TRANS_DURATION);
    }
  },
  created: function created() {
    // Create private non-reactive props
    this._animationTimeout = null;
  },
  mounted: function mounted() {
    // Cache current browser transitionend event name
    this.transitionEndEvent = getTransisionEndEvent(this.$el) || null;
    // Get all slides
    this.updateSlides();
    // Observe child changes so we can update slide list
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_observe_dom__["a" /* default */])(this.$refs.inner, this.updateSlides.bind(this), {
      subtree: false,
      childList: true,
      attributes: true,
      attributeFilter: ['id']
    });
  },

  /* istanbul ignore next: dificult to test */
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.intervalId);
    clearTimeout(this._animationTimeout);
    this.intervalId = null;
    this._animationTimeout = null;
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__image_img__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(5);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bImg: __WEBPACK_IMPORTED_MODULE_0__image_img__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_id__["a" /* default */]],
  render: function render(h) {
    var $slots = this.$slots;

    var img = $slots.img;
    if (!img && (this.imgSrc || this.imgBlank)) {
      img = h('b-img', {
        props: {
          fluidGrow: true,
          block: true,
          src: this.imgSrc,
          blank: this.imgBlank,
          blankColor: this.imgBlankColor,
          width: this.computedWidth,
          height: this.computedHeight,
          alt: this.imgAlt
        }
      });
    }

    var content = h(this.contentTag, { class: this.contentClasses }, [this.caption ? h(this.captionTag, { domProps: { innerHTML: this.caption } }) : h(false), this.text ? h(this.textTag, { domProps: { innerHTML: this.text } }) : h(false), $slots.default]);

    return h('div', {
      class: ['carousel-item'],
      style: { background: this.background },
      attrs: { id: this.safeId(), role: 'listitem' }
    }, [img, content]);
  },

  props: {
    imgSrc: {
      type: String,
      default: function _default() {
        if (this && this.src) {
          // Deprecate src
          Object(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a" /* default */])("b-carousel-slide: prop 'src' has been deprecated. Use 'img-src' instead");
          return this.src;
        }
        return null;
      }
    },
    src: {
      // Deprecated: use img-src instead
      type: String
    },
    imgAlt: {
      type: String
    },
    imgWidth: {
      type: [Number, String]
    },
    imgHeight: {
      type: [Number, String]
    },
    imgBlank: {
      type: Boolean,
      default: false
    },
    imgBlankColor: {
      type: String,
      default: 'transparent'
    },
    contentVisibleUp: {
      type: String
    },
    contentTag: {
      type: String,
      default: 'div'
    },
    caption: {
      type: String
    },
    captionTag: {
      type: String,
      default: 'h3'
    },
    text: {
      type: String
    },
    textTag: {
      type: String,
      default: 'p'
    },
    background: {
      type: String
    }
  },
  computed: {
    contentClasses: function contentClasses() {
      return ['carousel-caption', this.contentVisibleUp ? 'd-none' : '', this.contentVisibleUp ? 'd-' + this.contentVisibleUp + '-block' : ''];
    },
    computedWidth: function computedWidth() {
      // Use local width, or try parent width
      return this.imgWidth || this.$parent.imgWidth;
    },
    computedHeight: function computedHeight() {
      // Use local height, or try parent height
      return this.imgHeight || this.$parent.imgHeight;
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__container__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__row__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__col__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_row__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_plugins__ = __webpack_require__(1);






var components = {
  bContainer: __WEBPACK_IMPORTED_MODULE_0__container__["a" /* default */],
  bRow: __WEBPACK_IMPORTED_MODULE_1__row__["a" /* default */],
  bCol: __WEBPACK_IMPORTED_MODULE_2__col__["a" /* default */],
  bFormRow: __WEBPACK_IMPORTED_MODULE_3__form_row__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_4__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var COMMON_ALIGNMENT = ['start', 'end', 'center'];

var props = {
  tag: {
    type: String,
    default: 'div'
  },
  noGutters: {
    type: Boolean,
    default: false
  },
  alignV: {
    type: String,
    default: null,
    validator: function validator(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(COMMON_ALIGNMENT.concat(['baseline', 'stretch']), str);
    }
  },
  alignH: {
    type: String,
    default: null,
    validator: function validator(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(COMMON_ALIGNMENT.concat(['between', 'around']), str);
    }
  },
  alignContent: {
    type: String,
    default: null,
    validator: function validator(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(COMMON_ALIGNMENT.concat(['between', 'around', 'stretch']), str);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'row',
      class: (_class = {
        'no-gutters': props.noGutters
      }, _defineProperty(_class, 'align-items-' + props.alignV, props.alignV), _defineProperty(_class, 'justify-content-' + props.alignH, props.alignH), _defineProperty(_class, 'align-content-' + props.alignContent, props.alignContent), _class)
    }), children);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export computeBkPtClass */
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_memoize__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * Generates a prop object with a type of
 * [Boolean, String, Number]
 */
function boolStrNum() {
  return {
    type: [Boolean, String, Number],
    default: false
  };
}

/**
 * Generates a prop object with a type of
 * [String, Number]
 */
function strNum() {
  return {
    type: [String, Number],
    default: null
  };
}

var computeBkPtClass = Object(__WEBPACK_IMPORTED_MODULE_1__utils_memoize__["a" /* default */])(function computeBkPt(type, breakpoint, val) {
  var className = type;
  if (val === false || val === null || val === undefined) {
    return undefined;
  }
  if (breakpoint) {
    className += '-' + breakpoint;
  }
  // Handling the boolean style prop when accepting [Boolean, String, Number]
  // means Vue will not convert <b-col sm /> to sm: true for us.
  // Since the default is false, an empty string indicates the prop's presence.
  if (type === 'col' && (val === '' || val === true)) {
    // .col-md
    return className.toLowerCase();
  }
  // .order-md-6
  className += '-' + val;
  return className.toLowerCase();
});

var BREAKPOINTS = ['sm', 'md', 'lg', 'xl'];
// Supports classes like: .col-sm, .col-md-6, .col-lg-auto
var breakpointCol = BREAKPOINTS.reduce(
// eslint-disable-next-line no-sequences
function (propMap, breakpoint) {
  return propMap[breakpoint] = boolStrNum(), propMap;
}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b" /* create */])(null));
// Supports classes like: .offset-md-1, .offset-lg-12
var breakpointOffset = BREAKPOINTS.reduce(
// eslint-disable-next-line no-sequences
function (propMap, breakpoint) {
  return propMap[Object(__WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__["a" /* default */])(breakpoint, 'offset')] = strNum(), propMap;
}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b" /* create */])(null));
// Supports classes like: .order-md-1, .order-lg-12
var breakpointOrder = BREAKPOINTS.reduce(
// eslint-disable-next-line no-sequences
function (propMap, breakpoint) {
  return propMap[Object(__WEBPACK_IMPORTED_MODULE_2__utils_suffix_prop_name__["a" /* default */])(breakpoint, 'order')] = strNum(), propMap;
}, Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b" /* create */])(null));

// For loop doesn't need to check hasOwnProperty
// when using an object created from null
var breakpointPropMap = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])(Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["b" /* create */])(null), {
  col: Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["e" /* keys */])(breakpointCol),
  offset: Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["e" /* keys */])(breakpointOffset),
  order: Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["e" /* keys */])(breakpointOrder)
});

var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])({}, breakpointCol, breakpointOffset, breakpointOrder, {
  tag: {
    type: String,
    default: 'div'
  },
  // Generic flexbox .col
  col: {
    type: Boolean,
    default: false
  },
  // .col-[1-12]|auto
  cols: strNum(),
  // .offset-[1-12]
  offset: strNum(),
  // Flex ordering utility .order-[1-12]
  order: strNum(),
  alignSelf: {
    type: String,
    default: null,
    validator: function validator(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a" /* arrayIncludes */])(['auto', 'start', 'end', 'center', 'baseline', 'stretch'], str);
    }
  }
});

/**
 * We need ".col" to default in when no other props are passed,
 * but always render when col=true.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _classList$push;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var classList = [];
    // Loop through `col`, `offset`, `order` breakpoint props
    for (var type in breakpointPropMap) {
      // Returns colSm, offset, offsetSm, orderMd, etc.
      var _keys = breakpointPropMap[type];
      for (var i = 0; i < _keys.length; i++) {
        // computeBkPt(col, colSm => Sm, value=[String, Number, Boolean])
        var c = computeBkPtClass(type, _keys[i].replace(type, ''), props[_keys[i]]);
        // If a class is returned, push it onto the array.
        if (c) {
          classList.push(c);
        }
      }
    }

    classList.push((_classList$push = {
      // Default to .col if no other classes generated nor `cols` specified.
      col: props.col || classList.length === 0 && !props.cols
    }, _defineProperty(_classList$push, 'col-' + props.cols, props.cols), _defineProperty(_classList$push, 'offset-' + props.offset, props.offset), _defineProperty(_classList$push, 'order-' + props.order, props.order), _defineProperty(_classList$push, 'align-self-' + props.alignSelf, props.alignSelf), _classList$push));

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { class: classList }), children);
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object__ = __webpack_require__(2);


function memoize(fn) {
  var cache = Object(__WEBPACK_IMPORTED_MODULE_0__object__["b" /* create */])(null);

  return function memoizedFn() {
    var args = JSON.stringify(arguments);
    return cache[args] = cache[args] || fn.apply(null, arguments);
  };
}

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = suffixPropName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__upper_first__ = __webpack_require__(44);


/**
 * Suffix can be a falsey value so nothing is appended to string.
 * (helps when looping over props & some shouldn't change)
 * Use data last parameters to allow for currying.
 * @param {string} suffix
 * @param {string} str
 */
function suffixPropName(suffix, str) {
  return str + (suffix ? Object(__WEBPACK_IMPORTED_MODULE_0__upper_first__["a" /* default */])(suffix) : '');
}

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);



// Events we emit on $root
var EVENT_STATE = 'bv::collapse::state';
var EVENT_ACCORDION = 'bv::collapse::accordion';
// Events we listen to on $root
var EVENT_TOGGLE = 'bv::toggle::collapse';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__["a" /* default */]],
  render: function render(h) {
    var content = h(this.tag, {
      class: this.classObject,
      directives: [{ name: 'show', value: this.show }],
      attrs: { id: this.id || null },
      on: { click: this.clickHandler }
    }, [this.$slots.default]);
    return h('transition', {
      props: {
        enterClass: '',
        enterActiveClass: 'collapsing',
        enterToClass: '',
        leaveClass: '',
        leaveActiveClass: 'collapsing',
        leaveToClass: ''
      },
      on: {
        enter: this.onEnter,
        afterEnter: this.onAfterEnter,
        leave: this.onLeave,
        afterLeave: this.onAfterLeave
      }
    }, [content]);
  },
  data: function data() {
    return {
      show: this.visible,
      transitioning: false
    };
  },

  model: {
    prop: 'visible',
    event: 'input'
  },
  props: {
    id: {
      type: String,
      required: true
    },
    isNav: {
      type: Boolean,
      default: false
    },
    accordion: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  watch: {
    visible: function visible(newVal) {
      if (newVal !== this.show) {
        this.show = newVal;
      }
    },
    show: function show(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.emitState();
      }
    }
  },
  computed: {
    classObject: function classObject() {
      return {
        'navbar-collapse': this.isNav,
        'collapse': !this.transitioning,
        'show': this.show && !this.transitioning
      };
    }
  },
  methods: {
    toggle: function toggle() {
      this.show = !this.show;
    },
    onEnter: function onEnter(el) {
      el.style.height = 0;
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["q" /* reflow */])(el);
      el.style.height = el.scrollHeight + 'px';
      this.transitioning = true;
      // This should be moved out so we can add cancellable events
      this.$emit('show');
    },
    onAfterEnter: function onAfterEnter(el) {
      el.style.height = null;
      this.transitioning = false;
      this.$emit('shown');
    },
    onLeave: function onLeave(el) {
      el.style.height = 'auto';
      el.style.display = 'block';
      el.style.height = el.getBoundingClientRect().height + 'px';
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["q" /* reflow */])(el);
      this.transitioning = true;
      el.style.height = 0;
      // This should be moved out so we can add cancellable events
      this.$emit('hide');
    },
    onAfterLeave: function onAfterLeave(el) {
      el.style.height = null;
      this.transitioning = false;
      this.$emit('hidden');
    },
    emitState: function emitState() {
      this.$emit('input', this.show);
      // Let v-b-toggle know the state of this collapse
      this.$root.$emit(EVENT_STATE, this.id, this.show);
      if (this.accordion && this.show) {
        // Tell the other collapses in this accordion to close
        this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
      }
    },
    clickHandler: function clickHandler(evt) {
      // If we are in a nav/navbar, close the collapse when non-disabled link clicked
      var el = evt.target;
      if (!this.isNav || !el || getComputedStyle(this.$el).display !== 'block') {
        return;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["j" /* hasClass */])(el, 'nav-link') || Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["j" /* hasClass */])(el, 'dropdown-item')) {
        this.show = false;
      }
    },
    handleToggleEvt: function handleToggleEvt(target) {
      if (target !== this.id) {
        return;
      }
      this.toggle();
    },
    handleAccordionEvt: function handleAccordionEvt(openedId, accordion) {
      if (!this.accordion || accordion !== this.accordion) {
        return;
      }
      if (openedId === this.id) {
        // Open this collapse if not shown
        if (!this.show) {
          this.toggle();
        }
      } else {
        // Close this collapse if shown
        if (this.show) {
          this.toggle();
        }
      }
    },
    handleResize: function handleResize() {
      // Handler for orientation/resize to set collapsed state in nav/navbar
      this.show = getComputedStyle(this.$el).display === 'block';
    }
  },
  created: function created() {
    // Listen for toggle events to open/close us
    this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);
    // Listen to otehr collapses for accordion events
    this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
  },
  mounted: function mounted() {
    if (this.isNav && typeof document !== 'undefined') {
      // Set up handlers
      window.addEventListener('resize', this.handleResize, false);
      window.addEventListener('orientationchange', this.handleResize, false);
      this.handleResize();
    }
    this.emitState();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isNav && typeof document !== 'undefined') {
      window.removeEventListener('resize', this.handleResize, false);
      window.removeEventListener('orientationchange', this.handleResize, false);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_target__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);



// Are we client side?
var inBrowser = typeof window !== 'undefined';

// target listen types
var listenTypes = { click: true

  // Property key for handler storage
};var BVT = '__BV_toggle__';

// Emitted Control Event for collapse (emitted to collapse)
var EVENT_TOGGLE = 'bv::toggle::collapse';

// Listen to Event for toggle state update (Emited by collapse)
var EVENT_STATE = 'bv::collapse::state';

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    var targets = Object(__WEBPACK_IMPORTED_MODULE_0__utils_target__["b" /* default */])(vnode, binding, listenTypes, function (_ref) {
      var targets = _ref.targets,
          vnode = _ref.vnode;

      targets.forEach(function (target) {
        vnode.context.$root.$emit(EVENT_TOGGLE, target);
      });
    });

    if (inBrowser && vnode.context && targets.length > 0) {
      // Add aria attributes to element
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(el, 'aria-controls', targets.join(' '));
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(el, 'aria-expanded', 'false');
      if (el.tagName !== 'BUTTON') {
        // If element is not a button, we add `role="button"` for accessibility
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(el, 'role', 'button');
      }

      // Toggle state hadnler, stored on element
      el[BVT] = function toggleDirectiveHandler(id, state) {
        if (targets.indexOf(id) !== -1) {
          // Set aria-expanded state
          Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(el, 'aria-expanded', state ? 'true' : 'false');
          // Set/Clear 'collapsed' class state
          if (state) {
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["s" /* removeClass */])(el, 'collapsed');
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["a" /* addClass */])(el, 'collapsed');
          }
        }
      };

      // Listen for toggle state changes
      vnode.context.$root.$on(EVENT_STATE, el[BVT]);
    }
  },
  unbind: function unbind(el, binding, vnode) {
    if (el[BVT]) {
      // Remove our $root listener
      vnode.context.$root.$off(EVENT_STATE, el[BVT]);
      el[BVT] = null;
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown_css__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dropdown_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__dropdown_css__);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__["a" /* default */]],
  components: { bButton: __WEBPACK_IMPORTED_MODULE_2__button_button__["a" /* default */] },
  render: function render(h) {
    var split = h(false);
    if (this.split) {
      split = h('b-button', {
        ref: 'button',
        props: {
          disabled: this.disabled,
          variant: this.variant,
          size: this.size
        },
        attrs: {
          id: this.safeId('_BV_button_')
        },
        on: {
          click: this.click
        }
      }, [this.$slots['button-content'] || this.$slots.text || this.text]);
    }
    var toggle = h('b-button', {
      ref: 'toggle',
      class: this.toggleClasses,
      props: {
        variant: this.variant,
        size: this.size,
        disabled: this.disabled
      },
      attrs: {
        id: this.safeId('_BV_toggle_'),
        'aria-haspopup': 'true',
        'aria-expanded': this.visible ? 'true' : 'false'
      },
      on: {
        click: this.toggle, // click
        keydown: this.toggle // enter, space, down
      }
    }, [this.split ? h('span', { class: ['sr-only'] }, [this.toggleText]) : this.$slots['button-content'] || this.$slots.text || this.text]);
    var menu = h('div', {
      ref: 'menu',
      class: this.menuClasses,
      attrs: {
        role: this.role,
        'aria-labelledby': this.safeId(this.split ? '_BV_button_' : '_BV_toggle_')
      },
      on: {
        mouseover: this.onMouseOver,
        keydown: this.onKeydown // tab, up, down, esc
      }
    }, [this.$slots.default]);
    return h('div', { attrs: { id: this.safeId() }, class: this.dropdownClasses }, [split, toggle, menu]);
  },

  props: {
    split: {
      type: Boolean,
      default: false
    },
    toggleText: {
      type: String,
      default: 'Toggle Dropdown'
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    menuClass: {
      type: [String, Array],
      default: null
    },
    toggleClass: {
      type: [String, Array],
      default: null
    },
    noCaret: {
      type: Boolean,
      default: false
    },
    role: {
      type: String,
      default: 'menu'
    },
    boundary: {
      // String: `scrollParent`, `window` or `viewport`
      // Object: HTML Element reference
      type: [String, Object],
      default: 'scrollParent'
    }
  },
  computed: {
    dropdownClasses: function dropdownClasses() {
      var position = '';
      // Position `static` is needed to allow menu to "breakout" of the scrollParent boundaries
      // when boundary is anything other than `scrollParent`
      // See https://github.com/twbs/bootstrap/issues/24251#issuecomment-341413786
      if (this.boundary !== 'scrollParent' || !this.boundary) {
        position = 'position-static';
      }
      return ['btn-group', 'b-dropdown', 'dropdown', this.dropup ? 'dropup' : '', this.visible ? 'show' : '', position];
    },
    menuClasses: function menuClasses() {
      return ['dropdown-menu', {
        'dropdown-menu-right': this.right,
        'show': this.visible
      }, this.menuClass];
    },
    toggleClasses: function toggleClasses() {
      return [{
        'dropdown-toggle': !this.noCaret || this.split,
        'dropdown-toggle-split': this.split
      }, this.toggleClass];
    }
  }
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (typeof document !== 'undefined') {
      document.documentElement.addEventListener('click', this._clickOutListener);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (typeof document !== 'undefined') {
      document.documentElement.removeEventListener('click', this._clickOutListener);
    }
  },

  methods: {
    _clickOutListener: function _clickOutListener(e) {
      if (!this.$el.contains(e.target)) {
        if (this.clickOutListener) {
          this.clickOutListener();
        }
      }
    }
  }
});

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_link__ = __webpack_require__(9);



var props = Object(__WEBPACK_IMPORTED_MODULE_1__link_link__["c" /* propsFactory */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(__WEBPACK_IMPORTED_MODULE_1__link_link__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      props: props,
      staticClass: 'dropdown-item',
      attrs: { role: 'menuitem' }
    }), children);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  disabled: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        parent = _ref.parent,
        children = _ref.children;

    return h('button', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      props: props,
      staticClass: 'dropdown-item',
      attrs: { role: 'menuitem', type: 'button', disabled: props.disabled },
      on: {
        click: function click(e) {
          parent.$root.$emit('clicked::link', e);
        }
      }
    }), children);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  id: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'h6'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'dropdown-header',
      attrs: { id: props.id || null }
    }), children);
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'dropdown-divider',
      attrs: { role: 'separator' }
    }));
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__embed__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bEmbed: __WEBPACK_IMPORTED_MODULE_0__embed__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_array__ = __webpack_require__(3);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var props = {
  type: {
    type: String,
    default: 'iframe',
    validator: function validator(str) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_array__["a" /* arrayIncludes */])(['iframe', 'embed', 'video', 'object', 'img', 'b-img', 'b-img-lazy'], str);
    }
  },
  tag: {
    type: String,
    default: 'div'
  },
  aspect: {
    type: String,
    default: '16by9'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, {
      ref: data.ref,
      staticClass: 'embed-responsive',
      class: _defineProperty({}, 'embed-responsive-' + props.aspect, Boolean(props.aspect))
    }, [h(props.type, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { ref: '', staticClass: 'embed-responsive-item' }), children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_row__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_text__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_plugins__ = __webpack_require__(1);







var components = {
  bForm: __WEBPACK_IMPORTED_MODULE_0__form__["a" /* default */],
  bFormRow: __WEBPACK_IMPORTED_MODULE_1__form_row__["a" /* default */],
  bFormText: __WEBPACK_IMPORTED_MODULE_2__form_text__["a" /* default */],
  bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a" /* default */],
  bFormFeedback: __WEBPACK_IMPORTED_MODULE_3__form_invalid_feedback__["a" /* default */],
  bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_4__form_valid_feedback__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_5__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__layout_form_row__ = __webpack_require__(31);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__layout_form_row__["a" /* default */]);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_group__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bFormGroup: __WEBPACK_IMPORTED_MODULE_0__form_group__["a" /* default */],
  bFormFieldset: __WEBPACK_IMPORTED_MODULE_0__form_group__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout_form_row__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_form_text__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_form_invalid_feedback__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__form_form_valid_feedback__ = __webpack_require__(57);









// Selector for finding firt input in the form-group
var SELECTOR = 'input:not(:disabled),textarea:not(:disabled),select:not(:disabled)';

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a" /* default */]],
  components: { bFormRow: __WEBPACK_IMPORTED_MODULE_4__layout_form_row__["a" /* default */], bFormText: __WEBPACK_IMPORTED_MODULE_5__form_form_text__["a" /* default */], bFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_6__form_form_invalid_feedback__["a" /* default */], bFormValidFeedback: __WEBPACK_IMPORTED_MODULE_7__form_form_valid_feedback__["a" /* default */] },
  render: function render(h) {
    var $slots = this.$slots;

    // Label / Legend
    var legend = h(false);
    if (this.hasLabel) {
      var children = $slots['label'];
      var legendTag = this.labelFor ? 'label' : 'legend';
      var legendDomProps = children ? {} : { innerHTML: this.label };
      var legendAttrs = { id: this.labelId, for: this.labelFor || null };
      var legendClick = this.labelFor || this.labelSrOnly ? {} : { click: this.legendClick };
      if (this.horizontal) {
        // Horizontal layout with label
        if (this.labelSrOnly) {
          // SR Only we wrap label/legend in a div to preserve layout
          children = h(legendTag, { class: ['sr-only'], attrs: legendAttrs, domProps: legendDomProps }, children);
          legend = h('div', { class: this.labelLayoutClasses }, [children]);
        } else {
          legend = h(legendTag, {
            class: [this.labelLayoutClasses, this.labelClasses],
            attrs: legendAttrs,
            domProps: legendDomProps,
            on: legendClick
          }, children);
        }
      } else {
        // Vertical layout with label
        legend = h(legendTag, {
          class: this.labelSrOnly ? ['sr-only'] : this.labelClasses,
          attrs: legendAttrs,
          domProps: legendDomProps,
          on: legendClick
        }, children);
      }
    } else if (this.horizontal) {
      // No label but has horizontal layout, so we need a spacer element for layout
      legend = h('div', { class: this.labelLayoutClasses });
    }

    // Invalid feeback text (explicitly hidden if state is valid)
    var invalidFeedback = h(false);
    if (this.hasInvalidFeedback) {
      var domProps = {};
      if (!$slots['invalid-feedback'] && !$slots['feedback']) {
        domProps = { innerHTML: this.invalidFeedback || this.feedback || '' };
      }
      invalidFeedback = h('b-form-invalid-feedback', {
        props: {
          id: this.invalidFeedbackId,
          forceShow: this.computedState === false
        },
        attrs: {
          role: 'alert',
          'aria-live': 'assertive',
          'aria-atomic': 'true'
        },
        domProps: domProps
      }, $slots['invalid-feedback'] || $slots['feedback']);
    }

    // Valid feeback text (explicitly hidden if state is invalid)
    var validFeedback = h(false);
    if (this.hasValidFeedback) {
      var _domProps = $slots['valid-feedback'] ? {} : { innerHTML: this.validFeedback || '' };
      validFeedback = h('b-form-valid-feedback', {
        props: {
          id: this.validFeedbackId,
          forceShow: this.computedState === true
        },
        attrs: {
          role: 'alert',
          'aria-live': 'assertive',
          'aria-atomic': 'true'
        },
        domProps: _domProps
      }, $slots['valid-feedback']);
    }

    // Form help text (description)
    var description = h(false);
    if (this.hasDescription) {
      var _domProps2 = $slots['description'] ? {} : { innerHTML: this.description || '' };
      description = h('b-form-text', { attrs: { id: this.descriptionId }, domProps: _domProps2 }, $slots['description']);
    }

    // Build content layout
    var content = h('div', {
      ref: 'content',
      class: this.inputLayoutClasses,
      attrs: this.labelFor ? {} : { role: 'group', 'aria-labelledby': this.labelId }
    }, [$slots['default'], invalidFeedback, validFeedback, description]);

    // Generate main form-group wrapper
    return h(this.labelFor ? 'div' : 'fieldset', {
      class: this.groupClasses,
      attrs: {
        id: this.safeId(),
        disabled: this.disabled,
        role: 'group',
        'aria-invalid': this.computedState === false ? 'true' : null,
        'aria-labelledby': this.labelId,
        'aria-describedby': this.labelFor ? null : this.describedByIds
      }
    }, this.horizontal ? [h('b-form-row', {}, [legend, content])] : [legend, content]);
  },

  props: {
    horizontal: {
      type: Boolean,
      default: false
    },
    labelCols: {
      type: [Number, String],
      default: 3,
      validator: function validator(value) {
        if (Number(value) >= 1 && Number(value) <= 11) {
          return true;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_warn__["a" /* default */])('b-form-group: label-cols must be a value between 1 and 11');
        return false;
      }
    },
    breakpoint: {
      type: String,
      default: 'sm'
    },
    labelTextAlign: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    labelFor: {
      type: String,
      default: null
    },
    labelSize: {
      type: String,
      default: null
    },
    labelSrOnly: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: [String, Array],
      default: null
    },
    description: {
      type: String,
      default: null
    },
    invalidFeedback: {
      type: String,
      default: null
    },
    feedback: {
      // Deprecated in favor of invalid-feedback
      type: String,
      default: null
    },
    validFeedback: {
      type: String,
      default: null
    },
    validated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    groupClasses: function groupClasses() {
      return ['b-form-group', 'form-group', this.validated ? 'was-validated' : null, this.stateClass];
    },
    labelClasses: function labelClasses() {
      return ['col-form-label', this.labelSize ? 'col-form-label-' + this.labelSize : null, this.labelTextAlign ? 'text-' + this.labelTextAlign : null, this.horizontal ? null : 'pt-0', this.labelClass];
    },
    labelLayoutClasses: function labelLayoutClasses() {
      return [this.horizontal ? 'col-' + this.breakpoint + '-' + this.labelCols : null];
    },
    inputLayoutClasses: function inputLayoutClasses() {
      return [this.horizontal ? 'col-' + this.breakpoint + '-' + (12 - Number(this.labelCols)) : null];
    },
    hasLabel: function hasLabel() {
      return this.label || this.$slots['label'];
    },
    hasDescription: function hasDescription() {
      return this.description || this.$slots['description'];
    },
    hasInvalidFeedback: function hasInvalidFeedback() {
      if (this.computedState === true) {
        // If the form-group state is explicityly valid, we return false
        return false;
      }
      return this.invalidFeedback || this.feedback || this.$slots['invalid-feedback'] || this.$slots['feedback'];
    },
    hasValidFeedback: function hasValidFeedback() {
      if (this.computedState === false) {
        // If the form-group state is explicityly invalid, we return false
        return false;
      }
      return this.validFeedback || this.$slots['valid-feedback'];
    },
    labelId: function labelId() {
      return this.hasLabel ? this.safeId('_BV_label_') : null;
    },
    descriptionId: function descriptionId() {
      return this.hasDescription ? this.safeId('_BV_description_') : null;
    },
    invalidFeedbackId: function invalidFeedbackId() {
      return this.hasInvalidFeedback ? this.safeId('_BV_feedback_invalid_') : null;
    },
    validFeedbackId: function validFeedbackId() {
      return this.hasValidFeedback ? this.safeId('_BV_feedback_valid_') : null;
    },
    describedByIds: function describedByIds() {
      return [this.descriptionId, this.invalidFeedbackId, this.validFeedbackId].filter(function (i) {
        return i;
      }).join(' ') || null;
    }
  },
  watch: {
    describedByIds: function describedByIds(add, remove) {
      if (add !== remove) {
        this.setInputDescribedBy(add, remove);
      }
    }
  },
  methods: {
    legendClick: function legendClick(evt) {
      var tagName = evt.target ? evt.target.tagName : '';
      if (/^(input|select|textarea|label)$/i.test(tagName)) {
        // If clicked an input inside legend, we just let the default happen
        return;
      }
      // Focus the first non-disabled visible input when the legend element is clicked
      var inputs = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["u" /* selectAll */])(SELECTOR, this.$refs.content).filter(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */]);
      if (inputs[0] && inputs[0].focus) {
        inputs[0].focus();
      }
    },
    setInputDescribedBy: function setInputDescribedBy(add, remove) {
      // Sets the `aria-describedby` attribute on the input if label-for is set.
      // Optionally accepts a string of IDs to remove as the second parameter
      if (this.labelFor && typeof document !== 'undefined') {
        var input = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["t" /* select */])('#' + this.labelFor, this.$refs.content);
        if (input) {
          var adb = 'aria-describedby';
          var ids = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["e" /* getAttr */])(input, adb) || '').split(/\s+/);
          remove = (remove || '').split(/\s+/);
          // Update ID list, preserving any original IDs
          ids = ids.filter(function (id) {
            return remove.indexOf(id) === -1;
          }).concat(add || '').join(' ').trim();
          if (ids) {
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(input, adb, ids);
          } else {
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["r" /* removeAttr */])(input, adb);
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      // Set the adia-describedby IDs on the input specified by label-for
      // We do this in a nextTick to ensure the children have finished rendering
      _this.setInputDescribedBy(_this.describedByIds);
    });
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_checkbox__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bFormCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* default */],
  bCheckbox: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* default */],
  bCheck: __WEBPACK_IMPORTED_MODULE_0__form_checkbox__["a" /* default */],
  bFormCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* default */],
  bCheckboxGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* default */],
  bCheckGroup: __WEBPACK_IMPORTED_MODULE_1__form_checkbox_group__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form_options__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_checkbox__ = __webpack_require__(58);









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form_options__["a" /* default */]],
  components: { bFormCheckbox: __WEBPACK_IMPORTED_MODULE_6__form_checkbox__["a" /* default */] },
  render: function render(h) {
    var _this = this;

    var $slots = this.$slots;

    var checks = this.formOptions.map(function (option, idx) {
      return h('b-form-checkbox', {
        key: 'check_' + idx + '_opt',
        props: {
          id: _this.safeId('_BV_check_' + idx + '_opt_'),
          name: _this.name,
          value: option.value,
          required: _this.name && _this.required,
          disabled: option.disabled
        }
      }, [h('span', { domProps: { innerHTML: option.text } })]);
    });
    return h('div', {
      class: this.groupClasses,
      attrs: {
        id: this.safeId(),
        role: 'group',
        tabindex: '-1',
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      }
    }, [$slots.first, checks, $slots.default]);
  },
  data: function data() {
    return {
      localChecked: this.checked || [],
      // Flag for children
      is_RadioCheckGroup: true
    };
  },

  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    checked: {
      type: [String, Number, Object, Array, Boolean],
      default: null
    },
    validated: {
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: false
    },
    stacked: {
      type: Boolean,
      default: false
    },
    buttons: {
      // Render as button style
      type: Boolean,
      default: false
    },
    buttonVariant: {
      // Only applicable when rendered with button style
      type: String,
      default: 'secondary'
    }
  },
  watch: {
    checked: function checked(newVal, oldVal) {
      this.localChecked = this.checked;
    },
    localChecked: function localChecked(newVal, oldVal) {
      this.$emit('input', newVal);
    }
  },
  computed: {
    groupClasses: function groupClasses() {
      if (this.buttons) {
        return ['btn-group-toggle', this.stacked ? 'btn-group-vertical' : 'btn-group', this.size ? 'btn-group-' + this.size : '', this.validated ? 'was-validated' : ''];
      }
      return [this.sizeFormClass, this.stacked && this.custom ? 'custom-controls-stacked' : '', this.validated ? 'was-validated' : ''];
    },
    computedAriaInvalid: function computedAriaInvalid() {
      if (this.ariaInvalid === true || this.ariaInvalid === 'true' || this.ariaInvalid === '') {
        return 'true';
      }
      return this.get_State === false ? 'true' : null;
    },
    get_State: function get_State() {
      // Child radios sniff this value
      return this.computedState;
    }
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_radio__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_radio_group__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bFormRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a" /* default */],
  bRadio: __WEBPACK_IMPORTED_MODULE_0__form_radio__["a" /* default */],
  bFormRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a" /* default */],
  bRadioGroup: __WEBPACK_IMPORTED_MODULE_1__form_radio_group__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_radio__ = __webpack_require__(60);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__["a" /* default */]],
  components: { bFormRadio: __WEBPACK_IMPORTED_MODULE_6__form_radio__["a" /* default */] },
  render: function render(h) {
    var _this = this;

    var $slots = this.$slots;

    var radios = this.formOptions.map(function (option, idx) {
      return h('b-form-radio', {
        key: 'radio_' + idx + '_opt',
        props: {
          id: _this.safeId('_BV_radio_' + idx + '_opt_'),
          name: _this.name,
          value: option.value,
          required: Boolean(_this.name && _this.required),
          disabled: option.disabled
        }
      }, [h('span', { domProps: { innerHTML: option.text } })]);
    });
    return h('div', {
      class: this.groupClasses,
      attrs: {
        id: this.safeId(),
        role: 'radiogroup',
        tabindex: '-1',
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      }
    }, [$slots.first, radios, $slots.default]);
  },
  data: function data() {
    return {
      localChecked: this.checked,
      // Flag for children
      is_RadioCheckGroup: true
    };
  },

  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    checked: {
      type: [String, Object, Number, Boolean],
      default: null
    },
    validated: {
      // Used for applying hte `was-validated` class to the group
      type: Boolean,
      default: false
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: false
    },
    stacked: {
      type: Boolean,
      default: false
    },
    buttons: {
      // Render as button style
      type: Boolean,
      default: false
    },
    buttonVariant: {
      // Only applicable when rendered with button style
      type: String,
      default: 'secondary'
    }
  },
  watch: {
    checked: function checked(newVal, oldVal) {
      this.localChecked = this.checked;
    },
    localChecked: function localChecked(newVal, oldVal) {
      this.$emit('input', newVal);
    }
  },
  computed: {
    groupClasses: function groupClasses() {
      if (this.buttons) {
        return ['btn-group-toggle', this.stacked ? 'btn-group-vertical' : 'btn-group', this.size ? 'btn-group-' + this.size : '', this.validated ? 'was-validated' : ''];
      }
      return [this.sizeFormClass, this.stacked && this.custom ? 'custom-controls-stacked' : '', this.validated ? 'was-validated' : ''];
    },
    computedAriaInvalid: function computedAriaInvalid() {
      if (this.ariaInvalid === true || this.ariaInvalid === 'true' || this.ariaInvalid === '') {
        return 'true';
      }
      return this.get_State === false ? 'true' : null;
    },
    get_State: function get_State() {
      // Required by child radios
      return this.computedState;
    }
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bFormInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */],
  bInput: __WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_input_css__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__form_input_css__);






// Import styles


// Valid supported input types
var TYPES = ['text', 'password', 'email', 'number', 'url', 'tel', 'search', 'range', 'color', 'date', 'time', 'datetime', 'datetime-local', 'month', 'week'];

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a" /* default */]],
  render: function render(h) {
    return h('input', {
      ref: 'input',
      class: this.inputClass,
      attrs: {
        id: this.safeId(),
        name: this.name,
        type: this.localType,
        disabled: this.disabled,
        required: this.required,
        readonly: this.readonly || this.plaintext,
        placeholder: this.placeholder,
        autocomplete: this.autocomplete || null,
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid,
        value: this.value
      },
      on: {
        input: this.onInput,
        change: this.onChange
      }
    });
  },

  props: {
    value: {
      default: null
    },
    type: {
      type: String,
      default: 'text',
      validator: function validator(type) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a" /* arrayIncludes */])(TYPES, type);
      }
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    plaintext: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    formatter: {
      type: Function
    },
    lazyFormatter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localType: function localType() {
      // We only allow certain types
      return Object(__WEBPACK_IMPORTED_MODULE_4__utils_array__["a" /* arrayIncludes */])(TYPES, this.type) ? this.type : 'text';
    },
    inputClass: function inputClass() {
      return [this.plaintext ? 'form-control-plaintext' : 'form-control', this.sizeFormClass, this.stateClass];
    },
    computedAriaInvalid: function computedAriaInvalid() {
      if (!this.ariaInvalid || this.ariaInvalid === 'false') {
        // this.ariaInvalid is null or false or 'false'
        return this.computedState === false ? 'true' : null;
      }
      if (this.ariaInvalid === true) {
        // User wants explicit aria-invalid=true
        return 'true';
      }
      // Most likely a string value (which could be 'true')
      return this.ariaInvalid;
    }
  },
  mounted: function mounted() {
    if (this.value) {
      var fValue = this.format(this.value, null);
      this.setValue(fValue);
    }
  },

  watch: {
    value: function value(newVal) {
      if (this.lazyFormatter) {
        this.setValue(newVal);
      } else {
        var fValue = this.format(newVal, null);
        this.setValue(fValue);
      }
    }
  },
  methods: {
    format: function format(value, e) {
      if (this.formatter) {
        return this.formatter(value, e);
      }
      return value;
    },
    setValue: function setValue(value) {
      this.$emit('input', value);
      // When formatter removes last typed character, value of text input should update to formatted value
      this.$refs.input.value = value;
    },
    onInput: function onInput(evt) {
      var value = evt.target.value;

      if (this.lazyFormatter) {
        this.setValue(value);
      } else {
        var fValue = this.format(value, evt);
        this.setValue(fValue);
      }
    },
    onChange: function onChange(evt) {
      var fValue = this.format(evt.target.value, evt);
      this.setValue(fValue);
      this.$emit('change', fValue);
    },
    focus: function focus() {
      if (!this.disabled) {
        this.$el.focus();
      }
    }
  }
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_textarea__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bFormTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a" /* default */],
  bTextarea: __WEBPACK_IMPORTED_MODULE_0__form_textarea__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__ = __webpack_require__(10);





/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_state__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    return h('textarea', {
      ref: 'input',
      class: this.inputClass,
      style: this.inputStyle,
      directives: [{
        name: 'model',
        rawName: 'v-model',
        value: this.localValue,
        expression: 'localValue'
      }],
      domProps: { value: this.value },
      attrs: {
        id: this.safeId(),
        name: this.name,
        disabled: this.disabled,
        placeholder: this.placeholder,
        required: this.required,
        autocomplete: this.autocomplete || null,
        readonly: this.readonly || this.plaintext,
        rows: this.rowsCount,
        wrap: this.wrap || null,
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      },
      on: {
        input: function input(evt) {
          _this.localValue = evt.target.value;
        }
      }
    });
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  props: {
    value: {
      type: String,
      default: ''
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    plaintext: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    rows: {
      type: [Number, String],
      default: null
    },
    maxRows: {
      type: [Number, String],
      default: null
    },
    wrap: {
      // 'soft', 'hard' or 'off'. Browser default is 'soft'
      type: String,
      default: 'soft'
    },
    noResize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rowsCount: function rowsCount() {
      // A better option could be based on https://codepen.io/vsync/pen/frudD
      // As linebreaks aren't added until the input is submitted
      var rows = parseInt(this.rows, 10) || 1;
      var maxRows = parseInt(this.maxRows, 10) || 0;
      var lines = (this.localValue || '').toString().split('\n').length;
      return maxRows ? Math.min(maxRows, Math.max(rows, lines)) : Math.max(rows, lines);
    },
    inputClass: function inputClass() {
      return [this.plaintext ? 'form-control-plaintext' : 'form-control', this.sizeFormClass, this.stateClass];
    },
    inputStyle: function inputStyle() {
      // We set width 100% in plaintext mode to get around a shortcoming in bootstrap CSS
      // setting noResize to true will disable the ability for the user to resize the textarea
      return {
        width: this.plaintext ? '100%' : null,
        resize: this.noResize ? 'none' : null
      };
    },
    computedAriaInvalid: function computedAriaInvalid() {
      if (!this.ariaInvalid || this.ariaInvalid === 'false') {
        // this.ariaInvalid is null or false or 'false'
        return this.computedState === false ? 'true' : null;
      }
      if (this.ariaInvalid === true) {
        // User wants explicit aria-invalid=true
        return 'true';
      }
      // Most likely a string value (which could be the string 'true')
      return this.ariaInvalid;
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      // Update our localValue
      if (newVal !== oldVal) {
        this.localValue = newVal;
      }
    },
    localValue: function localValue(newVal, oldVal) {
      // update Parent value
      if (newVal !== oldVal) {
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    focus: function focus() {
      // For external handler that may want a focus method
      if (!this.disabled) {
        this.$el.focus();
      }
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bFormFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */],
  bFile: __WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_custom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_array__ = __webpack_require__(3);






/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form_state__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_custom__["a" /* default */]],
  render: function render(h) {
    // Form Input
    var input = h('input', {
      ref: 'input',
      class: [{
        'form-control-file': this.plain,
        'custom-file-input': this.custom,
        focus: this.custom && this.hasFocus
      }, this.stateClass],
      attrs: {
        type: 'file',
        id: this.safeId(),
        name: this.name,
        disabled: this.disabled,
        required: this.required,
        capture: this.capture || null,
        accept: this.accept || null,
        multiple: this.multiple,
        webkitdirectory: this.directory,
        'aria-required': this.required ? 'true' : null,
        'aria-describedby': this.plain ? null : this.safeId('_BV_file_control_')
      },
      on: {
        change: this.onFileChange,
        focusin: this.focusHandler,
        focusout: this.focusHandler
      }
    });

    if (this.plain) {
      return input;
    }

    // Overlay Labels
    var label = h('label', {
      class: ['custom-file-label', this.dragging ? 'dragging' : null],
      attrs: {
        id: this.safeId('_BV_file_control_')
      }
    }, this.selectLabel);

    // Return rendered custom file input
    return h('div', {
      class: ['custom-file', 'b-form-file', this.stateClass],
      attrs: { id: this.safeId('_BV_file_outer_') },
      on: { dragover: this.dragover }
    }, [input, label]);
  },
  data: function data() {
    return {
      selectedFile: null,
      dragging: false,
      hasFocus: false
    };
  },

  props: {
    accept: {
      type: String,
      default: ''
    },
    // Instruct input to capture from camera
    capture: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: false
    },
    directory: {
      type: Boolean,
      default: false
    },
    noTraverse: {
      type: Boolean,
      default: false
    },
    noDrop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectLabel: function selectLabel() {
      // No file choosen
      if (!this.selectedFile || this.selectedFile.length === 0) {
        return this.placeholder;
      }

      // Multiple files
      if (this.multiple) {
        if (this.selectedFile.length === 1) {
          return this.selectedFile[0].name;
        }
        return this.selectedFile.map(function (file) {
          return file.name;
        }).join(', ');
      }

      // Single file
      return this.selectedFile.name;
    }
  },
  watch: {
    selectedFile: function selectedFile(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      if (!newVal && this.multiple) {
        this.$emit('input', []);
      } else {
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    focusHandler: function focusHandler(evt) {
      // Boostrap v4.beta doesn't have focus styling for custom file input
      // Firefox has a borked '[type=file]:focus ~ sibling' selector issue,
      // So we add a 'focus' class to get around these "bugs"
      if (this.plain || evt.type === 'focusout') {
        this.hasFocus = false;
      } else {
        // Add focus styling for custom file input
        this.hasFocus = true;
      }
    },
    reset: function reset() {
      try {
        // Wrapped in try in case IE < 11 craps out
        this.$refs.input.value = '';
      } catch (e) {}
      // IE < 11 doesn't support setting input.value to '' or null
      // So we use this little extra hack to reset the value, just in case
      // This also appears to work on modern browsers as well.
      this.$refs.input.type = '';
      this.$refs.input.type = 'file';
      this.selectedFile = this.multiple ? [] : null;
    },
    onFileChange: function onFileChange(evt) {
      var _this = this;

      // Always emit original event
      this.$emit('change', evt);
      // Check if special `items` prop is available on event (drop mode)
      // Can be disabled by setting no-traverse
      var items = evt.dataTransfer && evt.dataTransfer.items;
      if (items && !this.noTraverse) {
        var queue = [];
        for (var i = 0; i < items.length; i++) {
          var item = items[i].webkitGetAsEntry();
          if (item) {
            queue.push(this.traverseFileTree(item));
          }
        }
        Promise.all(queue).then(function (filesArr) {
          _this.setFiles(Object(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* from */])(filesArr));
        });
        return;
      }
      // Normal handling
      this.setFiles(evt.target.files || evt.dataTransfer.files);
    },
    setFiles: function setFiles(files) {
      if (!files) {
        this.selectedFile = null;
        return;
      }
      if (!this.multiple) {
        this.selectedFile = files[0];
        return;
      }
      // Convert files to array
      var filesArray = [];
      for (var i = 0; i < files.length; i++) {
        if (files[i].type.match(this.accept)) {
          filesArray.push(files[i]);
        }
      }
      this.selectedFile = filesArray;
    },
    dragover: function dragover(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.noDrop || !this.custom) {
        return;
      }
      this.dragging = true;
      evt.dataTransfer.dropEffect = 'copy';
    },
    dragleave: function dragleave(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      this.dragging = false;
    },
    drop: function drop(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.noDrop) {
        return;
      }
      this.dragging = false;
      if (evt.dataTransfer.files && evt.dataTransfer.files.length > 0) {
        this.onFileChange(evt);
      }
    },
    traverseFileTree: function traverseFileTree(item, path) {
      var _this2 = this;

      // Based on http://stackoverflow.com/questions/3590058
      return new Promise(function (resolve) {
        path = path || '';
        if (item.isFile) {
          // Get file
          item.file(function (file) {
            file.$path = path; // Inject $path to file obj
            resolve(file);
          });
        } else if (item.isDirectory) {
          // Get folder contents
          item.createReader().readEntries(function (entries) {
            var queue = [];
            for (var i = 0; i < entries.length; i++) {
              queue.push(_this2.traverseFileTree(entries[i], path + item.name + '/'));
            }
            Promise.all(queue).then(function (filesArr) {
              resolve(Object(__WEBPACK_IMPORTED_MODULE_4__utils_array__["c" /* from */])(filesArr));
            });
          });
        }
      });
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_select__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bFormSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a" /* default */],
  bSelect: __WEBPACK_IMPORTED_MODULE_0__form_select__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_form__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_array__ = __webpack_require__(3);








/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_form__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_form_size__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_form_state__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_form_custom__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_form_options__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    var $slots = this.$slots;
    var options = this.formOptions.map(function (option, index) {
      return h('option', {
        key: 'option_' + index + '_opt',
        attrs: { disabled: Boolean(option.disabled) },
        domProps: { innerHTML: option.text, value: option.value }
      });
    });
    return h('select', {
      ref: 'input',
      class: this.inputClass,
      directives: [{
        name: 'model',
        rawName: 'v-model',
        value: this.localValue,
        expression: 'localValue'
      }],
      attrs: {
        id: this.safeId(),
        name: this.name,
        multiple: this.multiple || null,
        size: this.computedSelectSize,
        disabled: this.disabled,
        required: this.required,
        'aria-required': this.required ? 'true' : null,
        'aria-invalid': this.computedAriaInvalid
      },
      on: {
        change: function change(evt) {
          var target = evt.target;
          var selectedVal = Object(__WEBPACK_IMPORTED_MODULE_6__utils_array__["c" /* from */])(target.options).filter(function (o) {
            return o.selected;
          }).map(function (o) {
            return '_value' in o ? o._value : o.value;
          });
          _this.localValue = target.multiple ? selectedVal : selectedVal[0];
          _this.$emit('change', _this.localValue);
        }
      }
    }, [$slots.first, options, $slots.default]);
  },
  data: function data() {
    return {
      localValue: this.value
    };
  },

  watch: {
    value: function value(newVal, oldVal) {
      this.localValue = newVal;
    },
    localValue: function localValue(newVal, oldVal) {
      this.$emit('input', this.localValue);
    }
  },
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false
    },
    selectSize: {
      // Browsers default size to 0, which shows 4 rows in most browsers in multiple mode
      // Size of 1 can bork out firefox
      type: Number,
      default: 0
    },
    ariaInvalid: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    computedSelectSize: function computedSelectSize() {
      // Custom selects with a size of zero causes the arrows to be hidden,
      // so dont render the size attribute in this case
      return !this.plain && this.selectSize === 0 ? null : this.selectSize;
    },
    inputClass: function inputClass() {
      return ['form-control', this.stateClass, this.sizeFormClass,
      // Awaiting for https://github.com/twbs/bootstrap/issues/23058
      this.plain ? null : 'custom-select', this.plain || !this.size ? null : 'custom-select-' + this.size];
    },
    computedAriaInvalid: function computedAriaInvalid() {
      if (this.ariaInvalid === true || this.ariaInvalid === 'true') {
        return 'true';
      }
      return this.stateClass === 'is-invalid' ? 'true' : null;
    }
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_lazy__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bImg: __WEBPACK_IMPORTED_MODULE_0__img__["a" /* default */],
  bImgLazy: __WEBPACK_IMPORTED_MODULE_1__img_lazy__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);


var THROTTLE = 100;

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bImg: __WEBPACK_IMPORTED_MODULE_0__img__["a" /* default */] },
  render: function render(h) {
    return h('b-img', {
      props: {
        src: this.computedSrc,
        alt: this.alt,
        blank: this.computedBlank,
        blankColor: this.blankColor,
        width: this.computedWidth,
        height: this.computedHeight,
        fluid: this.fluid,
        fluidGrow: this.fluidGrow,
        block: this.block,
        thumbnail: this.thumbnail,
        rounded: this.rounded,
        left: this.left,
        right: this.right,
        center: this.center
      }
    });
  },
  data: function data() {
    return {
      isShown: false,
      scrollTimeout: null
    };
  },

  props: {
    src: {
      type: String,
      default: null,
      required: true
    },
    alt: {
      type: String,
      default: null
    },
    width: {
      type: [Number, String],
      default: null
    },
    height: {
      type: [Number, String],
      default: null
    },
    blankSrc: {
      // If null, a blank image is generated
      type: String,
      default: null
    },
    blankColor: {
      type: String,
      default: 'transparent'
    },
    blankWidth: {
      type: [Number, String],
      default: null
    },
    blankHeight: {
      type: [Number, String],
      default: null
    },
    fluid: {
      type: Boolean,
      default: false
    },
    fluidGrow: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: [Boolean, String],
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    offset: {
      type: [Number, String],
      default: 360
    },
    throttle: {
      type: [Number, String],
      default: THROTTLE
    }
  },
  computed: {
    computedSrc: function computedSrc() {
      return !this.blankSrc || this.isShown ? this.src : this.blankSrc;
    },
    computedBlank: function computedBlank() {
      return !(this.isShown || this.blankSrc);
    },
    computedWidth: function computedWidth() {
      return this.isShown ? this.width : this.blankWidth || this.width;
    },
    computedHeight: function computedHeight() {
      return this.isShown ? this.height : this.blankHeight || this.height;
    }
  },
  mounted: function mounted() {
    this.setListeners(true);
    this.checkView();
  },
  activated: function activated() {
    this.setListeners(true);
    this.checkView();
  },
  deactivated: function deactivated() {
    this.setListeners(false);
  },
  beforeDdestroy: function beforeDdestroy() {
    this.setListeners(false);
  },

  methods: {
    setListeners: function setListeners(on) {
      clearTimeout(this.scrollTimer);
      this.scrollTimeout = null;
      var root = window;
      if (on) {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'scroll', this.onScroll);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'resize', this.onScroll);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["d" /* eventOn */])(root, 'orientationchange', this.onScroll);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'scroll', this.onScroll);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'resize', this.onScroll);
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["c" /* eventOff */])(root, 'orientationchange', this.onScroll);
      }
    },
    checkView: function checkView() {
      // check bounding box + offset to see if we should show
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(this.$el)) {
        // Element is hidden, so skip for now
        return;
      }
      var offset = parseInt(this.offset, 10) || 0;
      var docElement = document.documentElement;
      var view = {
        l: 0 - offset,
        t: 0 - offset,
        b: docElement.clientHeight + offset,
        r: docElement.clientWidth + offset
      };
      var box = Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["f" /* getBCR */])(this.$el);
      if (box.right >= view.l && box.bottom >= view.t && box.left <= view.r && box.top <= view.b) {
        // image is in view (or about to be in view)
        this.isShown = true;
        this.setListeners(false);
      }
    },
    onScroll: function onScroll() {
      if (this.isShown) {
        this.setListeners(false);
      } else {
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(this.checkView, parseInt(this.throttle, 10) || THROTTLE);
      }
    }
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jumbotron__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bJumbotron: __WEBPACK_IMPORTED_MODULE_0__jumbotron__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layout_container__ = __webpack_require__(49);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var props = {
  fluid: {
    type: Boolean,
    default: false
  },
  containerFluid: {
    type: Boolean,
    default: false
  },
  header: {
    type: String,
    default: null
  },
  headerTag: {
    type: String,
    default: 'h1'
  },
  headerLevel: {
    type: [Number, String],
    default: '3'
  },
  lead: {
    type: String,
    default: null
  },
  leadTag: {
    type: String,
    default: 'p'
  },
  tag: {
    type: String,
    default: 'div'
  },
  bgVariant: {
    type: String,
    default: null
  },
  borderVariant: {
    type: String,
    default: null
  },
  textVariant: {
    type: String,
    default: null
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class2;

    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots;

    // The order of the conditionals matter.
    // We are building the component markup in order.
    var childNodes = [];
    var $slots = slots();

    // Header
    if (props.header || $slots.header) {
      childNodes.push(h(props.headerTag, {
        class: _defineProperty({}, 'display-' + props.headerLevel, Boolean(props.headerLevel))
      }, $slots.header || props.header));
    }

    // Lead
    if (props.lead || $slots.lead) {
      childNodes.push(h(props.leadTag, { staticClass: 'lead' }, $slots.lead || props.lead));
    }

    // Default slot
    if ($slots.default) {
      childNodes.push($slots.default);
    }

    // If fluid, wrap content in a container/container-fluid
    if (props.fluid) {
      // Children become a child of a container
      childNodes = [h(__WEBPACK_IMPORTED_MODULE_1__layout_container__["a" /* default */], { props: { 'fluid': props.containerFluid } }, childNodes)];
    }
    // Return the jumbotron
    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'jumbotron',
      class: (_class2 = {
        'jumbotron-fluid': props.fluid
      }, _defineProperty(_class2, 'text-' + props.textVariant, Boolean(props.textVariant)), _defineProperty(_class2, 'bg-' + props.bgVariant, Boolean(props.bgVariant)), _defineProperty(_class2, 'border-' + props.borderVariant, Boolean(props.borderVariant)), _defineProperty(_class2, 'border', Boolean(props.borderVariant)), _class2)
    }), childNodes);
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bLink: __WEBPACK_IMPORTED_MODULE_0__link__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__list_group__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__list_group_item__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bListGroup: __WEBPACK_IMPORTED_MODULE_0__list_group__["a" /* default */],
  bListGroupItem: __WEBPACK_IMPORTED_MODULE_1__list_group_item__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'div'
  },
  flush: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var componentData = {
      staticClass: 'list-group',
      class: { 'list-group-flush': props.flush }
    };

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__link_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var actionTags = ['a', 'router-link', 'button', 'b-link'];
var linkProps = Object(__WEBPACK_IMPORTED_MODULE_4__link_link__["c" /* propsFactory */])();
delete linkProps.href.default;
delete linkProps.to.default;

var props = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])({
  tag: {
    type: String,
    default: 'div'
  },
  action: {
    type: Boolean,
    default: null
  },
  button: {
    type: Boolean,
    default: null
  },
  variant: {
    type: String,
    default: null
  }
}, linkProps);

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var tag = props.button ? 'button' : !props.href && !props.to ? props.tag : __WEBPACK_IMPORTED_MODULE_4__link_link__["a" /* default */];
    var isAction = Boolean(props.href || props.to || props.action || props.button || Object(__WEBPACK_IMPORTED_MODULE_3__utils_array__["a" /* arrayIncludes */])(actionTags, props.tag));
    var componentData = {
      staticClass: 'list-group-item',
      class: (_class = {}, _defineProperty(_class, 'list-group-item-' + props.variant, Boolean(props.variant)), _defineProperty(_class, 'list-group-item-action', isAction), _defineProperty(_class, 'active', props.active), _defineProperty(_class, 'disabled', props.disabled), _class),
      attrs: tag === 'button' && props.disabled ? { disabled: true } : {},
      props: props.button ? {} : Object(__WEBPACK_IMPORTED_MODULE_1__utils_pluck_props__["a" /* default */])(linkProps, props)
    };

    return h(tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, componentData), children);
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__media__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_aside__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_body__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_plugins__ = __webpack_require__(1);





var components = {
  bMedia: __WEBPACK_IMPORTED_MODULE_0__media__["a" /* default */],
  bMediaAside: __WEBPACK_IMPORTED_MODULE_1__media_aside__["a" /* default */],
  bMediaBody: __WEBPACK_IMPORTED_MODULE_2__media_body__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_3__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_body__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_aside__ = __webpack_require__(62);




var props = {
  tag: {
    type: String,
    default: 'div'
  },
  rightAlign: {
    type: Boolean,
    default: false
  },
  verticalAlign: {
    type: String,
    default: 'top'
  },
  noBody: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        slots = _ref.slots,
        children = _ref.children;

    var childNodes = props.noBody ? children : [];
    var $slots = slots();

    if (!props.noBody) {
      if ($slots.aside && !props.rightAlign) {
        childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__media_aside__["a" /* default */], { staticClass: 'mr-3', props: { verticalAlign: props.verticalAlign } }, $slots.aside));
      }

      childNodes.push(h(__WEBPACK_IMPORTED_MODULE_1__media_body__["a" /* default */], $slots.default));

      if ($slots.aside && props.rightAlign) {
        childNodes.push(h(__WEBPACK_IMPORTED_MODULE_2__media_aside__["a" /* default */], { staticClass: 'ml-3', props: { verticalAlign: props.verticalAlign } }, $slots.aside));
      }
    }

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: 'media' }), childNodes);
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_modal__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bModal: __WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
    Vue.use(__WEBPACK_IMPORTED_MODULE_1__directives_modal__["a" /* default */]);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__button_button__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__button_button_close__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_listen_on_root__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_dom__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












// Selectors for padding/margin adjustments
var Selector = {
  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
  STICKY_CONTENT: '.sticky-top',
  NAVBAR_TOGGLER: '.navbar-toggler'

  // ObserveDom config
};var OBSERVER_CONFIG = {
  subtree: true,
  childList: true,
  characterData: true,
  attributes: true,
  attributeFilter: ['style', 'class']
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_listen_on_root__["a" /* default */]],
  components: { bBtn: __WEBPACK_IMPORTED_MODULE_0__button_button__["a" /* default */], bBtnClose: __WEBPACK_IMPORTED_MODULE_1__button_button_close__["a" /* default */] },
  render: function render(h) {
    var _this = this;

    var $slots = this.$slots;
    // Modal Header
    var header = h(false);
    if (!this.hideHeader) {
      var modalHeader = $slots['modal-header'];
      if (!modalHeader) {
        var closeButton = h(false);
        if (!this.hideHeaderClose) {
          closeButton = h('b-btn-close', {
            props: {
              disabled: this.is_transitioning,
              ariaLabel: this.headerCloseLabel,
              textVariant: this.headerTextVariant
            },
            on: {
              click: function click(evt) {
                _this.hide('header-close');
              }
            }
          }, [$slots['modal-header-close']]);
        }
        modalHeader = [h(this.titleTag, { class: ['modal-title'] }, [$slots['modal-title'] || this.title]), closeButton];
      }
      header = h('header', {
        ref: 'header',
        class: this.headerClasses,
        attrs: { id: this.safeId('__BV_modal_header_') }
      }, [modalHeader]);
    }
    // Modal Body
    var body = h('div', {
      ref: 'body',
      class: this.bodyClasses,
      attrs: { id: this.safeId('__BV_modal_body_') }
    }, [$slots.default]);
    // Modal Footer
    var footer = h(false);
    if (!this.hideFooter) {
      var modalFooter = $slots['modal-footer'];
      if (!modalFooter) {
        var cancelButton = h(false);
        if (!this.okOnly) {
          cancelButton = h('b-btn', {
            props: {
              variant: this.cancelVariant,
              size: this.buttonSize,
              disabled: this.cancelDisabled || this.busy || this.is_transitioning
            },
            on: {
              click: function click(evt) {
                _this.hide('cancel');
              }
            }
          }, [$slots['modal-cancel'] || this.cancelTitle]);
        }
        var okButton = h('b-btn', {
          props: {
            variant: this.okVariant,
            size: this.buttonSize,
            disabled: this.okDisabled || this.busy || this.is_transitioning
          },
          on: {
            click: function click(evt) {
              _this.hide('ok');
            }
          }
        }, [$slots['modal-ok'] || this.okTitle]);
        modalFooter = [cancelButton, okButton];
      }
      footer = h('footer', {
        ref: 'footer',
        class: this.footerClasses,
        attrs: { id: this.safeId('__BV_modal_footer_') }
      }, [modalFooter]);
    }
    // Assemble Modal Content
    var modalContent = h('div', {
      ref: 'content',
      class: ['modal-content'],
      attrs: {
        tabindex: '-1',
        role: 'document',
        'aria-labelledby': this.hideHeader ? null : this.safeId('__BV_modal_header_'),
        'aria-describedby': this.safeId('__BV_modal_body_')
      },
      on: {
        focusout: this.onFocusout,
        click: function click(evt) {
          evt.stopPropagation();
          // https://github.com/bootstrap-vue/bootstrap-vue/issues/1528
          _this.$root.$emit('bv::dropdown::shown');
        }
      }
    }, [header, body, footer]);
    // Modal Dialog wrapper
    var modalDialog = h('div', { class: this.dialogClasses }, [modalContent]);
    // Modal
    var modal = h('div', {
      ref: 'modal',
      class: this.modalClasses,
      directives: [{
        name: 'show',
        rawName: 'v-show',
        value: this.is_visible,
        expression: 'is_visible'
      }],
      attrs: {
        id: this.safeId(),
        role: 'dialog',
        'aria-hidden': this.is_visible ? null : 'true'
      },
      on: {
        click: this.onClickOut,
        keydown: this.onEsc
      }
    }, [modalDialog]);
    // Wrap modal in transition
    modal = h('transition', {
      props: {
        enterClass: '',
        enterToClass: '',
        enterActiveClass: '',
        leaveClass: '',
        leaveActiveClass: '',
        leaveToClass: ''
      },
      on: {
        'before-enter': this.onBeforeEnter,
        enter: this.onEnter,
        'after-enter': this.onAfterEnter,
        'before-leave': this.onBeforeLeave,
        leave: this.onLeave,
        'after-leave': this.onAfterLeave
      }
    }, [modal]);
    // Modal Backdrop
    var backdrop = h(false);
    if (!this.hideBackdrop && (this.is_visible || this.is_transitioning)) {
      backdrop = h('div', {
        class: this.backdropClasses,
        attrs: { id: this.safeId('__BV_modal_backdrop_') }
      });
    }
    // Assemble modal and backdrop
    var outer = h(false);
    if (!this.is_hidden) {
      outer = h('div', { attrs: { id: this.safeId('__BV_modal_outer_') } }, [modal, backdrop]);
    }
    // Wrap in DIV to maintain thi.$el reference for hide/show method aceess
    return h('div', {}, [outer]);
  },
  data: function data() {
    return {
      is_hidden: this.lazy || false,
      is_visible: false,
      is_transitioning: false,
      is_show: false,
      is_block: false,
      scrollbarWidth: 0,
      isBodyOverflowing: false,
      return_focus: this.returnFocus || null
    };
  },

  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    titleTag: {
      type: String,
      default: 'h5'
    },
    size: {
      type: String,
      default: 'md'
    },
    centered: {
      type: Boolean,
      default: false
    },
    buttonSize: {
      type: String,
      default: ''
    },
    noFade: {
      type: Boolean,
      default: false
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    },
    noEnforceFocus: {
      type: Boolean,
      default: false
    },
    headerBgVariant: {
      type: String,
      default: null
    },
    headerBorderVariant: {
      type: String,
      default: null
    },
    headerTextVariant: {
      type: String,
      default: null
    },
    headerClass: {
      type: [String, Array],
      default: null
    },
    bodyBgVariant: {
      type: String,
      default: null
    },
    bodyTextVariant: {
      type: String,
      default: null
    },
    modalClass: {
      type: [String, Array],
      default: null
    },
    bodyClass: {
      type: [String, Array],
      default: null
    },
    footerBgVariant: {
      type: String,
      default: null
    },
    footerBorderVariant: {
      type: String,
      default: null
    },
    footerTextVariant: {
      type: String,
      default: null
    },
    footerClass: {
      type: [String, Array],
      default: null
    },
    hideHeader: {
      type: Boolean,
      default: false
    },
    hideFooter: {
      type: Boolean,
      default: false
    },
    hideHeaderClose: {
      type: Boolean,
      default: false
    },
    hideBackdrop: {
      type: Boolean,
      default: false
    },
    okOnly: {
      type: Boolean,
      default: false
    },
    okDisabled: {
      type: Boolean,
      default: false
    },
    cancelDisabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    returnFocus: {
      default: null
    },
    headerCloseLabel: {
      type: String,
      default: 'Close'
    },
    cancelTitle: {
      type: String,
      default: 'Cancel'
    },
    okTitle: {
      type: String,
      default: 'OK'
    },
    cancelVariant: {
      type: String,
      default: 'secondary'
    },
    okVariant: {
      type: String,
      default: 'primary'
    },
    lazy: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalClasses: function modalClasses() {
      return ['modal', {
        fade: !this.noFade,
        show: this.is_show,
        'd-block': this.is_block
      }, this.modalClass];
    },
    dialogClasses: function dialogClasses() {
      var _ref;

      return ['modal-dialog', (_ref = {}, _defineProperty(_ref, 'modal-' + this.size, Boolean(this.size)), _defineProperty(_ref, 'modal-dialog-centered', this.centered), _ref)];
    },
    backdropClasses: function backdropClasses() {
      return ['modal-backdrop', {
        fade: !this.noFade,
        show: this.is_show || this.noFade
      }];
    },
    headerClasses: function headerClasses() {
      var _ref2;

      return ['modal-header', (_ref2 = {}, _defineProperty(_ref2, 'bg-' + this.headerBgVariant, Boolean(this.headerBgVariant)), _defineProperty(_ref2, 'text-' + this.headerTextVariant, Boolean(this.headerTextVariant)), _defineProperty(_ref2, 'border-' + this.headerBorderVariant, Boolean(this.headerBorderVariant)), _ref2), this.headerClass];
    },
    bodyClasses: function bodyClasses() {
      var _ref3;

      return ['modal-body', (_ref3 = {}, _defineProperty(_ref3, 'bg-' + this.bodyBgVariant, Boolean(this.bodyBgVariant)), _defineProperty(_ref3, 'text-' + this.bodyTextVariant, Boolean(this.bodyTextVariant)), _ref3), this.bodyClass];
    },
    footerClasses: function footerClasses() {
      var _ref4;

      return ['modal-footer', (_ref4 = {}, _defineProperty(_ref4, 'bg-' + this.footerBgVariant, Boolean(this.footerBgVariant)), _defineProperty(_ref4, 'text-' + this.footerTextVariant, Boolean(this.footerTextVariant)), _defineProperty(_ref4, 'border-' + this.footerBorderVariant, Boolean(this.footerBorderVariant)), _ref4), this.footerClass];
    }
  },
  watch: {
    visible: function visible(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this[newVal ? 'show' : 'hide']();
    }
  },
  methods: {
    // Public Methods
    show: function show() {
      if (this.is_visible) {
        return;
      }
      var showEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a" /* default */]('show', {
        cancelable: true,
        vueTarget: this,
        target: this.$refs.modal,
        relatedTarget: null
      });
      this.emitEvent(showEvt);
      if (showEvt.defaultPrevented || this.is_visible) {
        // Don't show if canceled
        return;
      }
      if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["j" /* hasClass */])(document.body, 'modal-open')) {
        // If another modal is already open, wait for it to close
        this.$root.$once('bv::modal::hidden', this.doShow);
      } else {
        // Show the modal
        this.doShow();
      }
    },
    hide: function hide(trigger) {
      if (!this.is_visible) {
        return;
      }
      var hideEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a" /* default */]('hide', {
        cancelable: true,
        vueTarget: this,
        target: this.$refs.modal,
        // this could be the trigger element/component reference
        relatedTarget: null,
        isOK: trigger || null,
        trigger: trigger || null,
        cancel: function cancel() {
          // Backwards compatibility
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn__["a" /* default */])('b-modal: evt.cancel() is deprecated. Please use evt.preventDefault().');
          this.preventDefault();
        }
      });
      if (trigger === 'ok') {
        this.$emit('ok', hideEvt);
      } else if (trigger === 'cancel') {
        this.$emit('cancel', hideEvt);
      }
      this.emitEvent(hideEvt);
      // Hide if not canceled
      if (hideEvt.defaultPrevented || !this.is_visible) {
        return;
      }
      // stop observing for content changes
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      this.is_visible = false;
      this.$emit('change', false);
    },

    // Private method to finish showing modal
    doShow: function doShow() {
      var _this2 = this;

      // Plce modal in DOM if lazy
      this.is_hidden = false;
      this.$nextTick(function () {
        // We do this in nextTick to ensure the modal is in DOM first before we show it
        _this2.is_visible = true;
        _this2.$emit('change', true);
        // Observe changes in modal content and adjust if necessary
        _this2._observer = Object(__WEBPACK_IMPORTED_MODULE_4__utils_observe_dom__["a" /* default */])(_this2.$refs.content, _this2.adjustDialog.bind(_this2), OBSERVER_CONFIG);
      });
    },

    // Transition Handlers
    onBeforeEnter: function onBeforeEnter() {
      this.is_transitioning = true;
      this.checkScrollbar();
      this.setScrollbar();
      this.adjustDialog();
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["a" /* addClass */])(document.body, 'modal-open');
      this.setResizeEvent(true);
    },
    onEnter: function onEnter() {
      this.is_block = true;
      this.$refs.modal.scrollTop = 0;
    },
    onAfterEnter: function onAfterEnter() {
      var _this3 = this;

      this.is_show = true;
      this.is_transitioning = false;
      this.$nextTick(function () {
        _this3.focusFirst();
        var shownEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a" /* default */]('shown', {
          cancelable: false,
          vueTarget: _this3,
          target: _this3.$refs.modal,
          relatedTarget: null
        });
        _this3.emitEvent(shownEvt);
      });
    },
    onBeforeLeave: function onBeforeLeave() {
      this.is_transitioning = true;
      this.setResizeEvent(false);
    },
    onLeave: function onLeave() {
      // Remove the 'show' class
      this.is_show = false;
    },
    onAfterLeave: function onAfterLeave() {
      var _this4 = this;

      this.is_block = false;
      this.resetAdjustments();
      this.resetScrollbar();
      this.is_transitioning = false;
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
      this.$nextTick(function () {
        _this4.is_hidden = _this4.lazy || false;
        _this4.returnFocusTo();
        var hiddenEvt = new __WEBPACK_IMPORTED_MODULE_7__utils_bv_event_class__["a" /* default */]('hidden', {
          cancelable: false,
          vueTarget: _this4,
          target: _this4.lazy ? null : _this4.$refs.modal,
          relatedTarget: null
        });
        _this4.emitEvent(hiddenEvt);
      });
    },

    // Event emitter
    emitEvent: function emitEvent(bvEvt) {
      var type = bvEvt.type;
      this.$emit(type, bvEvt);
      this.$root.$emit('bv::modal::' + type, bvEvt);
    },

    // UI Event Handlers
    onClickOut: function onClickOut(evt) {
      // If backdrop clicked, hide modal
      if (this.is_visible && !this.noCloseOnBackdrop) {
        this.hide('backdrop');
      }
    },
    onEsc: function onEsc(evt) {
      // If ESC pressed, hide modal
      if (evt.keyCode === __WEBPACK_IMPORTED_MODULE_6__utils_key_codes__["a" /* default */].ESC && this.is_visible && !this.noCloseOnEsc) {
        this.hide('esc');
      }
    },
    onFocusout: function onFocusout(evt) {
      // If focus leaves modal, bring it back
      // 'focusout' Event Listener bound on content
      var content = this.$refs.content;
      if (!this.noEnforceFocus && this.is_visible && content && !content.contains(evt.relatedTarget)) {
        content.focus();
      }
    },

    // Resize Listener
    setResizeEvent: function setResizeEvent(on) {
      var _this5 = this;

      ;['resize', 'orientationchange'].forEach(function (evtName) {
        if (on) {
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["d" /* eventOn */])(window, evtName, _this5.adjustDialog);
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["c" /* eventOff */])(window, evtName, _this5.adjustDialog);
        }
      });
    },

    // Root Listener handlers
    showHandler: function showHandler(id, triggerEl) {
      if (id === this.id) {
        this.return_focus = triggerEl || null;
        this.show();
      }
    },
    hideHandler: function hideHandler(id) {
      if (id === this.id) {
        this.hide();
      }
    },
    modalListener: function modalListener(bvEvt) {
      // If another modal opens, close this one
      if (bvEvt.vueTarget !== this) {
        this.hide();
      }
    },

    // Focus control handlers
    focusFirst: function focusFirst() {
      // Don't try and focus if we are SSR
      if (typeof document === 'undefined') {
        return;
      }
      var content = this.$refs.content;
      var modal = this.$refs.modal;
      var activeElement = document.activeElement;
      if (activeElement && content && content.contains(activeElement)) {
        // If activeElement is child of content, no need to change focus
      } else if (content) {
        if (modal) {
          modal.scrollTop = 0;
        }
        // Focus the modal content wrapper
        content.focus();
      }
    },
    returnFocusTo: function returnFocusTo() {
      // Prefer returnFocus prop over event specified return_focus value
      var el = this.returnFocus || this.return_focus || null;
      if (typeof el === 'string') {
        // CSS Selector
        el = Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["t" /* select */])(el);
      }
      if (el) {
        el = el.$el || el;
        if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["m" /* isVisible */])(el)) {
          el.focus();
        }
      }
    },

    // Utility methods
    getScrollbarWidth: function getScrollbarWidth() {
      var scrollDiv = document.createElement('div');
      scrollDiv.className = 'modal-scrollbar-measure';
      document.body.appendChild(scrollDiv);
      this.scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    },
    adjustDialog: function adjustDialog() {
      if (!this.is_visible) {
        return;
      }
      var modal = this.$refs.modal;
      var isModalOverflowing = modal.scrollHeight > document.documentElement.clientHeight;
      if (!this.isBodyOverflowing && isModalOverflowing) {
        modal.style.paddingLeft = this.scrollbarWidth + 'px';
      }
      if (this.isBodyOverflowing && !isModalOverflowing) {
        modal.style.paddingRight = this.scrollbarWidth + 'px';
      }
    },
    resetAdjustments: function resetAdjustments() {
      var modal = this.$refs.modal;
      if (modal) {
        modal.style.paddingLeft = '';
        modal.style.paddingRight = '';
      }
    },
    checkScrollbar: function checkScrollbar() {
      var rect = Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["f" /* getBCR */])(document.body);
      this.isBodyOverflowing = rect.left + rect.right < window.innerWidth;
    },
    setScrollbar: function setScrollbar() {
      if (this.isBodyOverflowing) {
        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
        var computedStyle = window.getComputedStyle;
        var body = document.body;
        var scrollbarWidth = this.scrollbarWidth;
        // Adjust fixed content padding
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
          var actualPadding = el.style.paddingRight;
          var calculatedPadding = computedStyle(el).paddingRight || 0;
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["v" /* setAttr */])(el, 'data-padding-right', actualPadding);
          el.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
        });
        // Adjust sticky content margin
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT).forEach(function (el) {
          var actualMargin = el.style.marginRight;
          var calculatedMargin = computedStyle(el).marginRight || 0;
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
          el.style.marginRight = parseFloat(calculatedMargin) - scrollbarWidth + 'px';
        });
        // Adjust navbar-toggler margin
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(Selector.NAVBAR_TOGGLER).forEach(function (el) {
          var actualMargin = el.style.marginRight;
          var calculatedMargin = computedStyle(el).marginRight || 0;
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["v" /* setAttr */])(el, 'data-margin-right', actualMargin);
          el.style.marginRight = parseFloat(calculatedMargin) + scrollbarWidth + 'px';
        });
        // Adjust body padding
        var actualPadding = body.style.paddingRight;
        var calculatedPadding = computedStyle(body).paddingRight;
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["v" /* setAttr */])(body, 'data-padding-right', actualPadding);
        body.style.paddingRight = parseFloat(calculatedPadding) + scrollbarWidth + 'px';
      }
    },
    resetScrollbar: function resetScrollbar() {
      // Restore fixed content padding
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(Selector.FIXED_CONTENT).forEach(function (el) {
        if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["i" /* hasAttr */])(el, 'data-padding-right')) {
          el.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e" /* getAttr */])(el, 'data-padding-right') || '';
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["r" /* removeAttr */])(el, 'data-padding-right');
        }
      });
      // Restore sticky content and navbar-toggler margin
      Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["u" /* selectAll */])(Selector.STICKY_CONTENT + ', ' + Selector.NAVBAR_TOGGLER).forEach(function (el) {
        if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["i" /* hasAttr */])(el, 'data-margin-right')) {
          el.style.marginRight = Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e" /* getAttr */])(el, 'data-margin-right') || '';
          Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["r" /* removeAttr */])(el, 'data-margin-right');
        }
      });
      // Restore body padding
      var body = document.body;
      if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["i" /* hasAttr */])(body, 'data-padding-right')) {
        body.style.paddingRight = Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["e" /* getAttr */])(body, 'data-padding-right') || '';
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["r" /* removeAttr */])(body, 'data-padding-right');
      }
    }
  },
  created: function created() {
    // create non-reactive property
    this._observer = null;
  },
  mounted: function mounted() {
    // Measure scrollbar
    this.getScrollbarWidth();
    // Listen for events from others to either open or close ourselves
    this.listenOnRoot('bv::show::modal', this.showHandler);
    this.listenOnRoot('bv::hide::modal', this.hideHandler);
    // Listen for bv:modal::show events, and close ourselves if the opening modal not us
    this.listenOnRoot('bv::modal::show', this.modalListener);
    // Initially show modal?
    if (this.visible === true) {
      this.show();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // Ensure everything is back to normal
    if (this._observer) {
      this._observer.disconnect();
      this._observer = null;
    }
    this.setResizeEvent(false);
    // Re-adjust body/navbar/fixed padding/margins (if needed)
    Object(__WEBPACK_IMPORTED_MODULE_8__utils_dom__["s" /* removeClass */])(document.body, 'modal-open');
    this.resetAdjustments();
    this.resetScrollbar();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_target__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);



var listenTypes = { click: true };

/* harmony default export */ __webpack_exports__["a"] = ({
  // eslint-disable-next-line no-shadow-restricted-names
  bind: function bind(el, binding, vnode) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_target__["a" /* bindTargets */])(vnode, binding, listenTypes, function (_ref) {
      var targets = _ref.targets,
          vnode = _ref.vnode;

      targets.forEach(function (target) {
        vnode.context.$root.$emit('bv::show::modal', target, vnode.elm);
      });
    });
    if (el.tagName !== 'BUTTON') {
      // If element is not a button, we add `role="button"` for accessibility
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["v" /* setAttr */])(el, 'role', 'button');
    }
  },
  unbind: function unbind(el, binding, vnode) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_target__["c" /* unbindTargets */])(vnode, binding, listenTypes);
    if (el.tagName !== 'BUTTON') {
      // If element is not a button, we add `role="button"` for accessibility
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["r" /* removeAttr */])(el, 'role', 'button');
    }
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(8);



var props = {
  tag: {
    type: String,
    default: 'ul'
  },
  fill: {
    type: Boolean,
    default: false
  },
  justified: {
    type: Boolean,
    default: false
  },
  tabs: {
    type: Boolean,
    default: false
  },
  pills: {
    type: Boolean,
    default: false
  },
  vertical: {
    type: Boolean,
    default: false
  },
  isNavBar: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    if (props.isNavBar) {
      Object(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a" /* default */])("b-nav: Prop 'is-nav-bar' is deprecated. Please use component '<b-navbar-nav>' instead.");
    }
    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      class: {
        'nav': !props.isNavBar,
        'navbar-nav': props.isNavBar,
        'nav-tabs': props.tabs && !props.isNavBar,
        'nav-pills': props.pills && !props.isNavBar,
        'flex-column': props.vertical && !props.isNavBar,
        'nav-fill': props.fill,
        'nav-justified': props.justified
      }
    }), children);
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link_link__ = __webpack_require__(9);



var props = Object(__WEBPACK_IMPORTED_MODULE_1__link_link__["c" /* propsFactory */])();

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h('li', Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'nav-item'
    }), [h(__WEBPACK_IMPORTED_MODULE_1__link_link__["a" /* default */], { staticClass: 'nav-link', props: props }, children)]);
  }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'span'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, { staticClass: 'navbar-text' }), children);
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_form__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: {
    id: {
      type: String,
      default: null
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(__WEBPACK_IMPORTED_MODULE_0__form_form__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__["a" /* mergeData */])(data, { attrs: { id: props.id }, props: { inline: true } }), children);
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__ = __webpack_require__(53);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_dropdown__["a" /* default */]],
  render: function render(h) {
    var button = h('a', {
      class: this.toggleClasses,
      ref: 'toggle',
      attrs: {
        href: '#',
        id: this.safeId('_BV_button_'),
        disabled: this.disabled,
        'aria-haspopup': 'true',
        'aria-expanded': this.visible ? 'true' : 'false'
      },
      on: {
        click: this.toggle,
        keydown: this.toggle // space, enter, down
      }
    }, [this.$slots['button-content'] || this.$slots.text || h('span', { domProps: { innerHTML: this.text } })]);
    var menu = h('div', {
      class: this.menuClasses,
      ref: 'menu',
      attrs: { 'aria-labelledby': this.safeId('_BV_button_') },
      on: {
        mouseover: this.onMouseOver,
        keydown: this.onKeydown // tab, up, down, esc
      }
    }, [this.$slots.default]);
    return h('li', { attrs: { id: this.safeId() }, class: this.dropdownClasses }, [button, menu]);
  },

  computed: {
    isNav: function isNav() {
      // Signal to dropdown mixin that we are in a navbar
      return true;
    },
    dropdownClasses: function dropdownClasses() {
      return ['nav-item', 'b-nav-dropdown', 'dropdown', this.dropup ? 'dropup' : '', this.visible ? 'show' : ''];
    },
    toggleClasses: function toggleClasses() {
      return ['nav-link', this.noCaret ? '' : 'dropdown-toggle', this.disabled ? 'disabled' : '', this.extraToggleClasses ? this.extraToggleClasses : ''];
    },
    menuClasses: function menuClasses() {
      return ['dropdown-menu', this.right ? 'dropdown-menu-right' : 'dropdown-menu-left', this.visible ? 'show' : '', this.extraMenuClasses ? this.extraMenuClasses : ''];
    }
  },
  props: {
    noCaret: {
      type: Boolean,
      default: false
    },
    extraToggleClasses: {
      // Extra Toggle classes
      type: String,
      default: ''
    },
    extraMenuClasses: {
      // Extra Menu classes
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: 'menu'
    }
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__navbar__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__navbar_nav__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navbar_brand__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nav__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__collapse__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dropdown__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_plugins__ = __webpack_require__(1);









var components = {
  bNavbar: __WEBPACK_IMPORTED_MODULE_0__navbar__["a" /* default */],
  bNavbarNav: __WEBPACK_IMPORTED_MODULE_1__navbar_nav__["a" /* default */],
  bNavbarBrand: __WEBPACK_IMPORTED_MODULE_2__navbar_brand__["a" /* default */],
  bNavbarToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a" /* default */],
  bNavToggle: __WEBPACK_IMPORTED_MODULE_3__navbar_toggle__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils_plugins__["a" /* registerComponents */])(Vue, components);
    Vue.use(__WEBPACK_IMPORTED_MODULE_4__nav__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_5__collapse__["a" /* default */]);
    Vue.use(__WEBPACK_IMPORTED_MODULE_6__dropdown__["a" /* default */]);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_7__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var props = {
  tag: {
    type: String,
    default: 'nav'
  },
  type: {
    type: String,
    default: 'light'
  },
  variant: {
    type: String
  },
  toggleable: {
    type: [Boolean, String],
    default: false
  },
  toggleBreakpoint: {
    // Deprecated.  Set toggleable to a string breakpoint
    type: String,
    default: null
  },
  fixed: {
    type: String
  },
  sticky: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var _class;

    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var breakpoint = props.toggleBreakpoint || (props.toggleable === true ? 'sm' : props.toggleable) || 'sm';
    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'navbar',
      class: (_class = {}, _defineProperty(_class, 'navbar-' + props.type, Boolean(props.type)), _defineProperty(_class, 'bg-' + props.variant, Boolean(props.variant)), _defineProperty(_class, 'fixed-' + props.fixed, Boolean(props.fixed)), _defineProperty(_class, 'sticky-top', props.sticky), _defineProperty(_class, 'navbar-expand-' + breakpoint, props.toggleable !== false), _class)
    }), children);
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__ = __webpack_require__(0);


var props = {
  tag: {
    type: String,
    default: 'ul'
  },
  fill: {
    type: Boolean,
    default: false
  },
  justified: {
    type: Boolean,
    default: false
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    return h(props.tag, Object(__WEBPACK_IMPORTED_MODULE_0_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'navbar-nav',
      class: {
        'nav-fill': props.fill,
        'nav-justified': props.justified
      }
    }), children);
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__link_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_pluck_props__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object__ = __webpack_require__(2);





var linkProps = Object(__WEBPACK_IMPORTED_MODULE_0__link_link__["c" /* propsFactory */])();
linkProps.href.default = undefined;
linkProps.to.default = undefined;

var props = Object(__WEBPACK_IMPORTED_MODULE_3__utils_object__["a" /* assign */])(linkProps, {
  tag: {
    type: String,
    default: 'div'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var isLink = Boolean(props.to || props.href);
    var tag = isLink ? __WEBPACK_IMPORTED_MODULE_0__link_link__["a" /* default */] : props.tag;

    return h(tag, Object(__WEBPACK_IMPORTED_MODULE_1_vue_functional_data_merge__["a" /* mergeData */])(data, {
      staticClass: 'navbar-brand',
      props: isLink ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_pluck_props__["a" /* default */])(linkProps, props) : {}
    }), children);
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__ = __webpack_require__(19);


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_listen_on_root__["a" /* default */]],
  render: function render(h) {
    return h('button', {
      class: ['navbar-toggler'],
      attrs: {
        type: 'button',
        'aria-label': this.label,
        'aria-controls': this.target,
        'aria-expanded': this.toggleState ? 'true' : 'false'
      },
      on: { click: this.onClick }
    }, [this.$slots.default || h('span', { class: ['navbar-toggler-icon'] })]);
  },
  data: function data() {
    return {
      toggleState: false
    };
  },

  props: {
    label: {
      type: String,
      default: 'Toggle navigation'
    },
    target: {
      type: String,
      required: true
    }
  },
  methods: {
    onClick: function onClick() {
      this.$root.$emit('bv::toggle::collapse', this.target);
    },
    handleStateEvt: function handleStateEvt(id, state) {
      if (id === this.target) {
        this.toggleState = state;
      }
    }
  },
  created: function created() {
    this.listenOnRoot('bv::collapse::state', this.handleStateEvt);
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bPagination: __WEBPACK_IMPORTED_MODULE_0__pagination__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_pagination__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dom__ = __webpack_require__(4);



var props = {
  perPage: {
    type: Number,
    default: 20
  },
  totalRows: {
    type: Number,
    default: 20
  },
  ariaControls: {
    type: String,
    default: null
  }

  // Our render function is brought in from the pagination mixin
};/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_pagination__["a" /* default */]],
  props: props,
  computed: {
    numberOfPages: function numberOfPages() {
      var result = Math.ceil(this.totalRows / this.perPage);
      return result < 1 ? 1 : result;
    }
  },
  methods: {
    // These methods are used by the render function
    onClick: function onClick(num, evt) {
      var _this = this;

      // Handle edge cases where number of pages has changed (i.e. if perPage changes)
      if (num > this.numberOfPages) {
        num = this.numberOfPages;
      } else if (num < 1) {
        num = 1;
      }
      this.currentPage = num;
      this.$nextTick(function () {
        // Keep the current button focused if possible
        var target = evt.target;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_dom__["m" /* isVisible */])(target) && _this.$el.contains(target) && target.focus) {
          target.focus();
        } else {
          _this.focusCurrent();
        }
      });
      this.$emit('change', this.currentPage);
    },
    makePage: function makePage(pagenum) {
      return pagenum;
    },
    linkProps: function linkProps(pagenum) {
      return { href: '#' };
    }
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @param {number} length
 * @return {Array}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (length) {
  return Array.apply(null, { length: length });
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pagination_nav__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bPaginationNav: __WEBPACK_IMPORTED_MODULE_0__pagination_nav__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_pagination__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__link_link__ = __webpack_require__(9);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





// Props needed for router links
var routerProps = Object(__WEBPACK_IMPORTED_MODULE_2__link_link__["b" /* pickLinkProps */])('activeClass', 'exactActiveClass', 'append', 'exact', 'replace', 'target', 'rel');

// Props object
var props = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(
// pagination-nav specific props
{
  numberOfPages: {
    type: Number,
    default: 1
  },
  baseUrl: {
    type: String,
    default: '/'
  },
  useRouter: {
    type: Boolean,
    default: false
  },
  linkGen: {
    type: Function,
    default: null
  },
  pageGen: {
    type: Function,
    default: null
  }
},
// Router specific props
routerProps);
// Our render function is brought in via the pagination mixin
/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_pagination__["a" /* default */]],
  props: props,
  computed: {
    // Used by render function to trigger wraping in '<nav>' element
    isNav: function isNav() {
      return true;
    }
  },
  methods: {
    onClick: function onClick(pageNum, evt) {
      this.currentPage = pageNum;
    },
    makePage: function makePage(pagenum) {
      if (this.pageGen && typeof this.pageGen === 'function') {
        return this.pageGen(pagenum);
      }
      return pagenum;
    },
    makeLink: function makeLink(pagenum) {
      if (this.linkGen && typeof this.linkGen === 'function') {
        return this.linkGen(pagenum);
      }
      var link = '' + this.baseUrl + pagenum;
      return this.useRouter ? { path: link } : link;
    },
    linkProps: function linkProps(pagenum) {
      var link = this.makeLink(pagenum);
      var props = {
        href: typeof link === 'string' ? link : void 0,
        target: this.target || null,
        rel: this.rel || null,
        disabled: this.disabled
      };
      if (this.useRouter || (typeof link === 'undefined' ? 'undefined' : _typeof(link)) === 'object') {
        props = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])(props, {
          to: link,
          exact: this.exact,
          activeClass: this.activeClass,
          exactActiveClass: this.exactActiveClass,
          append: this.append,
          replace: this.replace
        });
      }
      return props;
    }
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__ = __webpack_require__(67);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__["a" /* default */]],
  render: function render(h) {
    return h('div', {
      class: ['d-none'],
      style: { display: 'none' },
      attrs: { 'aria-hidden': true }
    }, [h('div', { ref: 'title' }, this.$slots.title), h('div', { ref: 'content' }, this.$slots.default)]);
  },
  data: function data() {
    return {};
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    triggers: {
      type: [String, Array],
      default: 'click'
    },
    placement: {
      type: String,
      default: 'right'
    }
  },
  methods: {
    createToolpop: function createToolpop() {
      // getTarget is in toolpop mixin
      var target = this.getTarget();
      if (target) {
        this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_popover_class__["a" /* default */](target, this.getConfig(), this.$root);
      } else {
        this._toolpop = null;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a" /* default */])("b-popover: 'target' element not found!");
      }
      return this._toolpop;
    }
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTMLElement; });
// Polyfills for SSR

var isSSR = typeof window === 'undefined';

var HTMLElement = isSSR ? Object : window.HTMLElement;

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__progress_bar__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bProgress: __WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */],
  bProgressBar: __WEBPACK_IMPORTED_MODULE_1__progress_bar__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress_bar__ = __webpack_require__(68);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { bProgressBar: __WEBPACK_IMPORTED_MODULE_0__progress_bar__["a" /* default */] },
  render: function render(h) {
    var childNodes = this.$slots.default;
    if (!childNodes) {
      childNodes = h('b-progress-bar', {
        props: {
          value: this.value,
          max: this.max,
          precision: this.precision,
          variant: this.variant,
          animated: this.animated,
          striped: this.striped,
          showProgress: this.showProgress,
          showValue: this.showValue
        }
      });
    }
    return h('div', { class: ['progress'], style: this.progressHeight }, [childNodes]);
  },

  props: {
    // These props can be inherited via the child b-progress-bar(s)
    variant: {
      type: String,
      default: null
    },
    striped: {
      type: Boolean,
      default: false
    },
    animated: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: null
    },
    precision: {
      type: Number,
      default: 0
    },
    showProgress: {
      type: Boolean,
      default: false
    },
    showValue: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 100
    },
    // This prop is not inherited by child b-progress-bar(s)
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    progressHeight: function progressHeight() {
      return { height: this.height || null };
    }
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bTable: __WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_startcase__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_startcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_loose_equal__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_stable_sort__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_array__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_id__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__table_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__table_css__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };












// Import styles


function toString(v) {
  if (!v) {
    return '';
  }
  if (v instanceof Object) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(v).map(function (k) {
      return toString(v[k]);
    }).join(' ');
  }
  return String(v);
}

function recToString(obj) {
  if (!(obj instanceof Object)) {
    return '';
  }
  return toString(Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(obj).reduce(function (o, k) {
    // Ignore fields that start with _
    if (!/^_/.test(k)) {
      o[k] = obj[k];
    }
    return o;
  }, {}));
}

function defaultSortCompare(a, b, sortBy) {
  if (typeof a[sortBy] === 'number' && typeof b[sortBy] === 'number') {
    return a[sortBy] < b[sortBy] && -1 || a[sortBy] > b[sortBy] && 1 || 0;
  }
  return toString(a[sortBy]).localeCompare(toString(b[sortBy]), undefined, {
    numeric: true
  });
}

function processField(key, value) {
  var field = null;
  if (typeof value === 'string') {
    // Label shortcut
    field = { key: key, label: value };
  } else if (typeof value === 'function') {
    // Formatter shortcut
    field = { key: key, formatter: value };
  } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    field = Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a" /* assign */])({}, value);
    field.key = field.key || key;
  } else if (value !== false) {
    // Fallback to just key
    field = { key: key };
  }
  return field;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__mixins_id__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__mixins_listen_on_root__["a" /* default */]],
  render: function render(h) {
    var _this = this;

    var $slots = this.$slots;
    var $scoped = this.$scopedSlots;
    var fields = this.computedFields;
    var items = this.computedItems;

    // Build the caption
    var caption = h(false);
    if (this.caption || $slots['table-caption']) {
      var data = { style: this.captionStyles };
      if (!$slots['table-caption']) {
        data.domProps = { innerHTML: this.caption };
      }
      caption = h('caption', data, $slots['table-caption']);
    }

    // Build the colgroup
    var colgroup = $slots['table-colgroup'] ? h('colgroup', {}, $slots['table-colgroup']) : h(false);

    // factory function for thead and tfoot cells (th's)
    var makeHeadCells = function makeHeadCells() {
      var isFoot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return fields.map(function (field, colIndex) {
        var data = {
          key: field.key,
          class: _this.fieldClasses(field),
          style: field.thStyle || {},
          attrs: {
            tabindex: field.sortable ? '0' : null,
            abbr: field.headerAbbr || null,
            title: field.headerTitle || null,
            'aria-colindex': String(colIndex + 1),
            'aria-label': field.sortable ? _this.localSortDesc && _this.localSortBy === field.key ? _this.labelSortAsc : _this.labelSortDesc : null,
            'aria-sort': field.sortable && _this.localSortBy === field.key ? _this.localSortDesc ? 'descending' : 'ascending' : null
          },
          on: {
            click: function click(evt) {
              evt.stopPropagation();
              evt.preventDefault();
              _this.headClicked(evt, field);
            },
            keydown: function keydown(evt) {
              var keyCode = evt.keyCode;
              if (keyCode === __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__["a" /* default */].ENTER || keyCode === __WEBPACK_IMPORTED_MODULE_4__utils_key_codes__["a" /* default */].SPACE) {
                evt.stopPropagation();
                evt.preventDefault();
                _this.headClicked(evt, field);
              }
            }
          }
        };
        var slot = isFoot && $scoped['FOOT_' + field.key] ? $scoped['FOOT_' + field.key] : $scoped['HEAD_' + field.key];
        if (slot) {
          slot = [slot({ label: field.label, column: field.key, field: field })];
        } else {
          data.domProps = { innerHTML: field.label };
        }
        return h('th', data, slot);
      });
    };

    // Build the thead
    var thead = h(false);
    if (this.isStacked !== true) {
      // If in always stacked mode (this.isStacked === true), then we don't bother rendering the thead
      thead = h('thead', { class: this.headClasses }, [h('tr', { class: this.theadTrClass }, makeHeadCells(false))]);
    }

    // Build the tfoot
    var tfoot = h(false);
    if (this.footClone && this.isStacked !== true) {
      // If in always stacked mode (this.isStacked === true), then we don't bother rendering the tfoot
      tfoot = h('tfoot', { class: this.footClasses }, [h('tr', { class: this.tfootTrClass }, makeHeadCells(true))]);
    }

    // Prepare the tbody rows
    var rows = [];

    // Add static Top Row slot (hidden in visibly stacked mode as we can't control the data-label)
    // If in always stacked mode, we don't bother rendering the row
    if ($scoped['top-row'] && this.isStacked !== true) {
      rows.push(h('tr', { key: 'top-row', class: ['b-table-top-row', this.tbodyTrClass] }, [$scoped['top-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Add the item data rows
    items.forEach(function (item, rowIndex) {
      var detailsSlot = $scoped['row-details'];
      var rowShowDetails = Boolean(item._showDetails && detailsSlot);
      var detailsId = rowShowDetails ? _this.safeId('_details_' + rowIndex + '_') : null;
      var toggleDetailsFn = function toggleDetailsFn() {
        if (detailsSlot) {
          _this.$set(item, '_showDetails', !item._showDetails);
        }
      };
      // For each item data field in row
      var tds = fields.map(function (field, colIndex) {
        var data = {
          key: 'row-' + rowIndex + '-cell-' + colIndex,
          class: _this.tdClasses(field, item),
          attrs: _this.tdAttrs(field, item, colIndex),
          domProps: {}
        };
        var childNodes = void 0;
        if ($scoped[field.key]) {
          childNodes = [$scoped[field.key]({
            item: item,
            index: rowIndex,
            field: field,
            unformatted: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, field.key),
            value: _this.getFormattedValue(item, field),
            toggleDetails: toggleDetailsFn,
            detailsShowing: Boolean(item._showDetails)
          })];
          if (_this.isStacked) {
            // We wrap in a DIV to ensure rendered as a single cell when visually stacked!
            childNodes = [h('div', {}, [childNodes])];
          }
        } else {
          var formatted = _this.getFormattedValue(item, field);
          if (_this.isStacked) {
            // We innerHTML a DIV to ensure rendered as a single cell when visually stacked!
            childNodes = [h('div', formatted)];
          } else {
            // Non stacked
            childNodes = formatted;
          }
        }
        // Render either a td or th cell
        return h(field.isRowHeader ? 'th' : 'td', data, childNodes);
      });
      // Calculate the row number in the dataset (indexed from 1)
      var ariaRowIndex = null;
      if (_this.currentPage && _this.perPage && _this.perPage > 0) {
        ariaRowIndex = (_this.currentPage - 1) * _this.perPage + rowIndex + 1;
      }
      // Assemble and add the row
      rows.push(h('tr', {
        key: 'row-' + rowIndex,
        class: [_this.rowClasses(item), { 'b-table-has-details': rowShowDetails }],
        attrs: {
          'aria-describedby': detailsId,
          'aria-rowindex': ariaRowIndex,
          role: _this.isStacked ? 'row' : null
        },
        on: {
          click: function click(evt) {
            _this.rowClicked(evt, item, rowIndex);
          },
          dblclick: function dblclick(evt) {
            _this.rowDblClicked(evt, item, rowIndex);
          },
          mouseenter: function mouseenter(evt) {
            _this.rowHovered(evt, item, rowIndex);
          }
        }
      }, tds));
      // Row Details slot
      if (rowShowDetails) {
        var tdAttrs = { colspan: String(fields.length) };
        var trAttrs = { id: detailsId };
        if (_this.isStacked) {
          tdAttrs['role'] = 'cell';
          trAttrs['role'] = 'row';
        }
        var details = h('td', { attrs: tdAttrs }, [detailsSlot({
          item: item,
          index: rowIndex,
          fields: fields,
          toggleDetails: toggleDetailsFn
        })]);
        rows.push(h('tr', {
          key: 'details-' + rowIndex,
          class: ['b-table-details', _this.tbodyTrClass],
          attrs: trAttrs
        }, [details]));
      } else if (detailsSlot) {
        // Only add the placeholder if a the table has a row-details slot defined (but not shown)
        rows.push(h(false));
      }
    });

    // Empty Items / Empty Filtered Row slot
    if (this.showEmpty && (!items || items.length === 0)) {
      var empty = this.filter ? $slots['emptyfiltered'] : $slots['empty'];
      if (!empty) {
        empty = h('div', {
          class: ['text-center', 'my-2'],
          domProps: { innerHTML: this.filter ? this.emptyFilteredText : this.emptyText }
        });
      }
      empty = h('td', {
        attrs: {
          colspan: String(fields.length),
          role: this.isStacked ? 'cell' : null
        }
      }, [h('div', { attrs: { role: 'alert', 'aria-live': 'polite' } }, [empty])]);
      rows.push(h('tr', {
        key: 'empty-row',
        class: ['b-table-empty-row', this.tbodyTrClass],
        attrs: this.isStacked ? { role: 'row' } : {}
      }, [empty]));
    } else {
      rows.push(h(false));
    }

    // Static bottom row slot (hidden in visibly stacked mode as we can't control the data-label)
    // If in always stacked mode, we don't bother rendering the row
    if ($scoped['bottom-row'] && this.isStacked !== true) {
      rows.push(h('tr', { key: 'bottom-row', class: ['b-table-bottom-row', this.tbodyTrClass] }, [$scoped['bottom-row']({ columns: fields.length, fields: fields })]));
    } else {
      rows.push(h(false));
    }

    // Assemble the rows into the tbody
    var tbody = h('tbody', { class: this.bodyClasses, attrs: this.isStacked ? { role: 'rowgroup' } : {} }, rows);

    // Assemble table
    var table = h('table', {
      class: this.tableClasses,
      attrs: {
        id: this.safeId(),
        role: this.isStacked ? 'table' : null,
        'aria-busy': this.computedBusy ? 'true' : 'false',
        'aria-colcount': String(fields.length),
        'aria-rowcount': this.$attrs['aria-rowcount'] || this.items.length > this.perPage ? this.items.length : null
      }
    }, [caption, colgroup, thead, tfoot, tbody]);

    // Add responsive wrapper if needed and return table
    return this.isResponsive ? h('div', { class: this.responsiveClass }, [table]) : table;
  },
  data: function data() {
    return {
      localSortBy: this.sortBy || '',
      localSortDesc: this.sortDesc || false,
      localItems: [],
      // Note: filteredItems only used to determine if # of items changed
      filteredItems: [],
      localBusy: false
    };
  },

  props: {
    items: {
      type: [Array, Function],
      default: function _default() {
        return [];
      }
    },
    fields: {
      type: [Object, Array],
      default: null
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    },
    sortDirection: {
      type: String,
      default: 'asc',
      validator: function validator(direction) {
        return Object(__WEBPACK_IMPORTED_MODULE_7__utils_array__["a" /* arrayIncludes */])(['asc', 'desc', 'last'], direction);
      }
    },
    caption: {
      type: String,
      default: null
    },
    captionTop: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: function _default() {
        if (this && typeof this.inverse === 'boolean') {
          // Deprecate inverse
          Object(__WEBPACK_IMPORTED_MODULE_5__utils_warn__["a" /* default */])("b-table: prop 'inverse' has been deprecated. Use 'dark' instead");
          return this.dark;
        }
        return false;
      }
    },
    inverse: {
      // Deprecated in v1.0.0 in favor of `dark`
      type: Boolean,
      default: null
    },
    hover: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    footClone: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: [Boolean, String],
      default: false
    },
    stacked: {
      type: [Boolean, String],
      default: false
    },
    headVariant: {
      type: String,
      default: ''
    },
    footVariant: {
      type: String,
      default: ''
    },
    theadClass: {
      type: [String, Array],
      default: null
    },
    theadTrClass: {
      type: [String, Array],
      default: null
    },
    tbodyClass: {
      type: [String, Array],
      default: null
    },
    tbodyTrClass: {
      type: [String, Array],
      default: null
    },
    tfootClass: {
      type: [String, Array],
      default: null
    },
    tfootTrClass: {
      type: [String, Array],
      default: null
    },
    perPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    filter: {
      type: [String, RegExp, Function],
      default: null
    },
    sortCompare: {
      type: Function,
      default: null
    },
    noLocalSorting: {
      type: Boolean,
      default: false
    },
    noProviderPaging: {
      type: Boolean,
      default: false
    },
    noProviderSorting: {
      type: Boolean,
      default: false
    },
    noProviderFiltering: {
      type: Boolean,
      default: false
    },
    noSortReset: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    labelSortAsc: {
      type: String,
      default: 'Click to sort Ascending'
    },
    labelSortDesc: {
      type: String,
      default: 'Click to sort Descending'
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: 'There are no records to show'
    },
    emptyFilteredText: {
      type: String,
      default: 'There are no records matching your request'
    },
    apiUrl: {
      // Passthrough prop. Passed to the context object. Not used by b-table directly
      type: String,
      default: ''
    }
  },
  watch: {
    items: function items(newVal, oldVal) {
      if (oldVal !== newVal) {
        this._providerUpdate();
      }
    },
    context: function context(newVal, oldVal) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_2__utils_loose_equal__["a" /* default */])(newVal, oldVal)) {
        this.$emit('context-changed', newVal);
      }
    },
    filteredItems: function filteredItems(newVal, oldVal) {
      if (this.localFiltering && newVal.length !== oldVal.length) {
        // Emit a filtered notification event, as number of filtered items has changed
        this.$emit('filtered', newVal);
      }
    },
    sortDesc: function sortDesc(newVal, oldVal) {
      if (newVal === this.localSortDesc) {
        return;
      }
      this.localSortDesc = newVal || false;
    },
    localSortDesc: function localSortDesc(newVal, oldVal) {
      // Emit update to sort-desc.sync
      if (newVal !== oldVal) {
        this.$emit('update:sortDesc', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    sortBy: function sortBy(newVal, oldVal) {
      if (newVal === this.localSortBy) {
        return;
      }
      this.localSortBy = newVal || null;
    },
    localSortBy: function localSortBy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:sortBy', newVal);
        if (!this.noProviderSorting) {
          this._providerUpdate();
        }
      }
    },
    perPage: function perPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    currentPage: function currentPage(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderPaging) {
        this._providerUpdate();
      }
    },
    filter: function filter(newVal, oldVal) {
      if (oldVal !== newVal && !this.noProviderFiltering) {
        this._providerUpdate();
      }
    },
    localBusy: function localBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('update:busy', newVal);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.localSortBy = this.sortBy;
    this.localSortDesc = this.sortDesc;
    if (this.hasProvider) {
      this._providerUpdate();
    }
    this.listenOnRoot('bv::refresh::table', function (id) {
      if (id === _this2.id || id === _this2) {
        _this2._providerUpdate();
      }
    });
  },

  computed: {
    isStacked: function isStacked() {
      return this.stacked === '' ? true : this.stacked;
    },
    isResponsive: function isResponsive() {
      var responsive = this.responsive === '' ? true : this.responsive;
      return this.isStacked ? false : responsive;
    },
    responsiveClass: function responsiveClass() {
      return this.isResponsive === true ? 'table-responsive' : this.isResponsive ? 'table-responsive-' + this.responsive : '';
    },
    tableClasses: function tableClasses() {
      return ['table', 'b-table', this.striped ? 'table-striped' : '', this.hover ? 'table-hover' : '', this.dark ? 'table-dark' : '', this.bordered ? 'table-bordered' : '', this.small ? 'table-sm' : '', this.outlined ? 'border' : '', this.fixed ? 'b-table-fixed' : '', this.isStacked === true ? 'b-table-stacked' : this.isStacked ? 'b-table-stacked-' + this.stacked : ''];
    },
    headClasses: function headClasses() {
      return [this.headVariant ? 'thead-' + this.headVariant : '', this.theadClass];
    },
    bodyClasses: function bodyClasses() {
      return [this.tbodyClass];
    },
    footClasses: function footClasses() {
      var variant = this.footVariant || this.headVariant || null;
      return [variant ? 'thead-' + variant : '', this.tfootClass];
    },
    captionStyles: function captionStyles() {
      // Move caption to top
      return this.captionTop ? { captionSide: 'top' } : {};
    },
    hasProvider: function hasProvider() {
      return this.items instanceof Function;
    },
    localFiltering: function localFiltering() {
      return this.hasProvider ? this.noProviderFiltering : true;
    },
    localSorting: function localSorting() {
      return this.hasProvider ? this.noProviderSorting : !this.noLocalSorting;
    },
    localPaging: function localPaging() {
      return this.hasProvider ? this.noProviderPaging : true;
    },
    context: function context() {
      return {
        perPage: this.perPage,
        currentPage: this.currentPage,
        filter: this.filter,
        sortBy: this.localSortBy,
        sortDesc: this.localSortDesc,
        apiUrl: this.apiUrl
      };
    },
    computedFields: function computedFields() {
      var _this3 = this;

      // We normalize fields into an array of objects
      // [ { key:..., label:..., ...}, {...}, ..., {..}]
      var fields = [];
      if (Object(__WEBPACK_IMPORTED_MODULE_7__utils_array__["d" /* isArray */])(this.fields)) {
        // Normalize array Form
        this.fields.filter(function (f) {
          return f;
        }).forEach(function (f) {
          if (typeof f === 'string') {
            fields.push({ key: f, label: __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(f) });
          } else if ((typeof f === 'undefined' ? 'undefined' : _typeof(f)) === 'object' && f.key && typeof f.key === 'string') {
            // Full object definition. We use assign so that we don't mutate the original
            fields.push(Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a" /* assign */])({}, f));
          } else if ((typeof f === 'undefined' ? 'undefined' : _typeof(f)) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(f).length === 1) {
            // Shortcut object (i.e. { 'foo_bar': 'This is Foo Bar' }
            var key = Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(f)[0];
            var field = processField(key, f[key]);
            if (field) {
              fields.push(field);
            }
          }
        });
      } else if (this.fields && _typeof(this.fields) === 'object' && Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(this.fields).length > 0) {
        // Normalize object Form
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(this.fields).forEach(function (key) {
          var field = processField(key, _this3.fields[key]);
          if (field) {
            fields.push(field);
          }
        });
      }
      // If no field provided, take a sample from first record (if exits)
      if (fields.length === 0 && this.computedItems.length > 0) {
        var sample = this.computedItems[0];
        var ignoredKeys = ['_rowVariant', '_cellVariants', '_showDetails'];
        Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */])(sample).forEach(function (k) {
          if (!ignoredKeys.includes(k)) {
            fields.push({ key: k, label: __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(k) });
          }
        });
      }
      // Ensure we have a unique array of fields and that they have String labels
      var memo = {};
      return fields.filter(function (f) {
        if (!memo[f.key]) {
          memo[f.key] = true;
          f.label = typeof f.label === 'string' ? f.label : __WEBPACK_IMPORTED_MODULE_0_lodash_startcase___default()(f.key);
          return true;
        }
        return false;
      });
    },
    computedItems: function computedItems() {
      // Grab some props/data to ensure reactivity
      var perPage = this.perPage;
      var currentPage = this.currentPage;
      var filter = this.filter;
      var sortBy = this.localSortBy;
      var sortDesc = this.localSortDesc;
      var sortCompare = this.sortCompare;
      var localFiltering = this.localFiltering;
      var localSorting = this.localSorting;
      var localPaging = this.localPaging;
      var items = this.hasProvider ? this.localItems : this.items;
      if (!items) {
        this.$nextTick(this._providerUpdate);
        return [];
      }
      // Array copy for sorting, filtering, etc.
      items = items.slice();
      // Apply local filter
      if (filter && localFiltering) {
        if (filter instanceof Function) {
          items = items.filter(filter);
        } else {
          var regex = void 0;
          if (filter instanceof RegExp) {
            regex = filter;
          } else {
            regex = new RegExp('.*' + filter + '.*', 'ig');
          }
          items = items.filter(function (item) {
            var test = regex.test(recToString(item));
            regex.lastIndex = 0;
            return test;
          });
        }
      }
      if (localFiltering) {
        // Make a local copy of filtered items to trigger filtered event
        this.filteredItems = items.slice();
      }
      // Apply local Sort
      if (sortBy && localSorting) {
        items = Object(__WEBPACK_IMPORTED_MODULE_3__utils_stable_sort__["a" /* default */])(items, function (a, b) {
          var ret = null;
          if (typeof sortCompare === 'function') {
            // Call user provided sortCompare routine
            ret = sortCompare(a, b, sortBy);
          }
          if (ret === null || ret === undefined) {
            // Fallback to defaultSortCompare if sortCompare not defined or returns null
            ret = defaultSortCompare(a, b, sortBy);
          }
          // Handle sorting direction
          return (ret || 0) * (sortDesc ? -1 : 1);
        });
      }
      // Apply local pagination
      if (Boolean(perPage) && localPaging) {
        // Grab the current page of data (which may be past filtered items)
        items = items.slice((currentPage - 1) * perPage, currentPage * perPage);
      }
      // Update the value model with the filtered/sorted/paginated data set
      this.$emit('input', items);
      return items;
    },
    computedBusy: function computedBusy() {
      return this.busy || this.localBusy;
    }
  },
  methods: {
    keys: __WEBPACK_IMPORTED_MODULE_6__utils_object__["e" /* keys */],
    fieldClasses: function fieldClasses(field) {
      return [field.sortable ? 'sorting' : '', field.sortable && this.localSortBy === field.key ? 'sorting_' + (this.localSortDesc ? 'desc' : 'asc') : '', field.variant ? 'table-' + field.variant : '', field.class ? field.class : '', field.thClass ? field.thClass : ''];
    },
    tdClasses: function tdClasses(field, item) {
      var cellVariant = '';
      if (item._cellVariants && item._cellVariants[field.key]) {
        cellVariant = (this.dark ? 'bg' : 'table') + '-' + item._cellVariants[field.key];
      }
      return [field.variant && !cellVariant ? (this.dark ? 'bg' : 'table') + '-' + field.variant : '', cellVariant, field.class ? field.class : '', this.getTdValues(item, field.key, field.tdClass, '')];
    },
    tdAttrs: function tdAttrs(field, item, colIndex) {
      var attrs = {};
      attrs['aria-colindex'] = String(colIndex + 1);
      if (this.isStacked) {
        // Generate the "header cell" label content in stacked mode
        attrs['data-label'] = field.label;
        if (field.isRowHeader) {
          attrs['role'] = 'rowheader';
        } else {
          attrs['role'] = 'cell';
        }
      }
      return Object(__WEBPACK_IMPORTED_MODULE_6__utils_object__["a" /* assign */])({}, attrs, this.getTdValues(item, field.key, field.tdAttr, {}));
    },
    rowClasses: function rowClasses(item) {
      return [item._rowVariant ? (this.dark ? 'bg' : 'table') + '-' + item._rowVariant : '', this.tbodyTrClass];
    },
    rowClicked: function rowClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-clicked', item, index, e);
    },
    rowDblClicked: function rowDblClicked(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-dblclicked', item, index, e);
    },
    rowHovered: function rowHovered(e, item, index) {
      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      this.$emit('row-hovered', item, index, e);
    },
    headClicked: function headClicked(e, field) {
      var _this4 = this;

      if (this.stopIfBusy(e)) {
        // If table is busy (via provider) then don't propagate
        return;
      }
      var sortChanged = false;
      var toggleLocalSortDesc = function toggleLocalSortDesc() {
        var sortDirection = field.sortDirection || _this4.sortDirection;
        if (sortDirection === 'asc') {
          _this4.localSortDesc = false;
        } else if (sortDirection === 'desc') {
          _this4.localSortDesc = true;
        }
      };
      if (field.sortable) {
        if (field.key === this.localSortBy) {
          // Change sorting direction on current column
          this.localSortDesc = !this.localSortDesc;
        } else {
          // Start sorting this column ascending
          this.localSortBy = field.key;
          toggleLocalSortDesc();
        }
        sortChanged = true;
      } else if (this.localSortBy && !this.noSortReset) {
        this.localSortBy = null;
        toggleLocalSortDesc();
        sortChanged = true;
      }
      this.$emit('head-clicked', field.key, field, e);
      if (sortChanged) {
        // Sorting parameters changed
        this.$emit('sort-changed', this.context);
      }
    },
    stopIfBusy: function stopIfBusy(evt) {
      if (this.computedBusy) {
        // If table is busy (via provider) then don't propagate
        evt.preventDefault();
        evt.stopPropagation();
        return true;
      }
      return false;
    },
    refresh: function refresh() {
      // Expose refresh method
      if (this.hasProvider) {
        this._providerUpdate();
      }
    },
    _providerSetLocal: function _providerSetLocal(items) {
      this.localItems = items && items.length > 0 ? items.slice() : [];
      this.localBusy = false;
      this.$emit('refreshed');
      // Deprecated root emit
      this.emitOnRoot('table::refreshed', this.id);
      // New root emit
      if (this.id) {
        this.emitOnRoot('bv::table::refreshed', this.id);
      }
    },
    _providerUpdate: function _providerUpdate() {
      var _this5 = this;

      // Refresh the provider items
      if (this.computedBusy || !this.hasProvider) {
        // Don't refresh remote data if we are 'busy' or if no provider
        return;
      }
      // Set internal busy state
      this.localBusy = true;
      // Call provider function with context and optional callback
      var data = this.items(this.context, this._providerSetLocal);
      if (data && data.then && typeof data.then === 'function') {
        // Provider returned Promise
        data.then(function (items) {
          _this5._providerSetLocal(items);
        });
      } else {
        // Provider returned Array data
        this._providerSetLocal(data);
      }
    },
    getTdValues: function getTdValues(item, key, tdValue, defValue) {
      var parent = this.$parent;
      if (tdValue) {
        if (typeof tdValue === 'function') {
          var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
          return tdValue(value, key, item);
        } else if (typeof tdValue === 'string' && typeof parent[tdValue] === 'function') {
          var _value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
          return parent[tdValue](_value, key, item);
        }
        return tdValue;
      }
      return defValue;
    },
    getFormattedValue: function getFormattedValue(item, field) {
      var key = field.key;
      var formatter = field.formatter;
      var parent = this.$parent;
      var value = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item, key);
      if (formatter) {
        if (typeof formatter === 'function') {
          value = formatter(value, key, item);
        } else if (typeof formatter === 'string' && typeof parent[formatter] === 'function') {
          value = parent[formatter](value, key, item);
        }
      }
      return value;
    }
  }
});

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = startCase;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(15)))

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stableSort;
/*
 * Consitant and stable sort function across JavsaScript platforms
 *
 * Inconsistant sorts can cause SSR problems between client and server
 * such as in <b-table> if sortBy is applied to the data on server side render.
 * Chrome and V8 native sorts are inconsistant/unstable
 *
 * This function uses native sort with fallback to index compare when the a and b
 * compare returns 0
 *
 * Algorithm bsaed on:
 * https://stackoverflow.com/questions/1427608/fast-stable-sorting-algorithm-implementation-in-javascript/45422645#45422645
 *
 * @param {array} array to sort
 * @param {function} sortcompare function
 * @return {array}
 */

function stableSort(array, compareFn) {
  // Using `.bind(compareFn)` on the wrapped anonymous function improves
  // performance by avoiding the function call setup. We don't use an arrow
  // function here as it binds `this` to the `stableSort` context rather than
  // the `compareFn` context, which wouldn't give us the performance increase.
  return array.map(function (a, index) {
    return [index, a];
  }).sort(function (a, b) {
    return this(a[1], b[1]) || a[0] - b[0];
  }.bind(compareFn)).map(function (e) {
    return e[1];
  });
}

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tabs__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tab__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_plugins__ = __webpack_require__(1);




var components = {
  bTabs: __WEBPACK_IMPORTED_MODULE_0__tabs__["a" /* default */],
  bTab: __WEBPACK_IMPORTED_MODULE_1__tab__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_2__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_id__ = __webpack_require__(5);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// Helper component
var bTabButtonHelper = {
  name: 'bTabButtonHelper',
  props: {
    content: { type: [String, Array], default: '' },
    href: { type: String, default: '#' },
    posInSet: { type: Number, default: null },
    setSize: { type: Number, default: null },
    controls: { type: String, default: null },
    id: { type: String, default: null },
    active: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    linkClass: { default: null },
    itemClass: { default: null },
    noKeyNav: { type: Boolean, default: false }
  },
  render: function render(h) {
    var link = h('a', {
      class: ['nav-link', { active: this.active, disabled: this.disabled }, this.linkClass],
      attrs: {
        role: 'tab',
        tabindex: this.noKeyNav ? null : '-1',
        href: this.href,
        id: this.id,
        disabled: this.disabled,
        'aria-selected': this.active ? 'true' : 'false',
        'aria-setsize': this.setSize,
        'aria-posinset': this.posInSet,
        'aria-controls': this.controls
      },
      on: {
        click: this.handleClick,
        keydown: this.handleClick
      }
    }, this.content);
    return h('li', { class: ['nav-item', this.itemClass], attrs: { role: 'presentation' } }, [link]);
  },

  methods: {
    handleClick: function handleClick(evt) {
      function stop() {
        evt.preventDefault();
        evt.stopPropagation();
      }
      if (evt.type !== 'click' && this.noKeyNav) {
        return;
      }
      if (this.disabled) {
        stop();
        return;
      }
      if (evt.type === 'click' || evt.keyCode === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].ENTER || evt.keyCode === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].SPACE) {
        stop();
        this.$emit('click', evt);
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_id__["a" /* default */]],
  render: function render(h) {
    var _this = this,
        _ref;

    var tabs = this.tabs;
    // Navigation 'buttons'
    var buttons = tabs.map(function (tab, index) {
      return h(bTabButtonHelper, {
        key: index,
        props: {
          content: tab.$slots.title || tab.title,
          href: tab.href,
          id: tab.controlledBy || _this.safeId('_BV_tab_' + (index + 1) + '_'),
          active: tab.localActive,
          disabled: tab.disabled,
          setSize: tabs.length,
          posInSet: index + 1,
          controls: _this.safeId('_BV_tab_container_'),
          linkClass: tab.titleLinkClass,
          itemClass: tab.titleItemClass,
          noKeyNav: _this.noKeyNav
        },
        on: {
          click: function click(evt) {
            _this.setTab(index);
          }
        }
      });
    });

    // Nav 'button' wrapper
    var navs = h('ul', {
      class: ['nav', (_ref = {}, _defineProperty(_ref, 'nav-' + this.navStyle, !this.noNavStyle), _defineProperty(_ref, 'card-header-' + this.navStyle, this.card && !this.vertical), _defineProperty(_ref, 'card-header', this.card && this.vertical), _defineProperty(_ref, 'h-100', this.card && this.vertical), _defineProperty(_ref, 'flex-column', this.vertical), _defineProperty(_ref, 'border-bottom-0', this.vertical), _defineProperty(_ref, 'rounded-0', this.vertical), _defineProperty(_ref, 'small', this.small), _ref), this.navClass],
      attrs: {
        role: 'tablist',
        tabindex: this.noKeyNav ? null : '0',
        id: this.safeId('_BV_tab_controls_')
      },
      on: { keydown: this.onKeynav }
    }, [buttons, this.$slots.tabs]);
    navs = h('div', {
      class: [{
        'card-header': this.card && !this.vertical && !(this.end || this.bottom),
        'card-footer': this.card && !this.vertical && (this.end || this.bottom),
        'col-auto': this.vertical
      }, this.navWrapperClass]
    }, [navs]);

    var empty = void 0;
    if (tabs && tabs.length) {
      empty = h(false);
    } else {
      empty = h('div', { class: ['tab-pane', 'active', { 'card-body': this.card }] }, this.$slots.empty);
    }

    // Main content section
    var content = h('div', {
      ref: 'tabsContainer',
      class: ['tab-content', { col: this.vertical }, this.contentClass],
      attrs: { id: this.safeId('_BV_tab_container_') }
    }, [this.$slots.default, empty]);

    // Render final output
    return h(this.tag, {
      class: ['tabs', { row: this.vertical, 'no-gutters': this.vertical && this.card }],
      attrs: { id: this.safeId() }
    }, [this.end || this.bottom ? content : h(false), [navs], this.end || this.bottom ? h(false) : content]);
  },
  data: function data() {
    return {
      currentTab: this.value,
      tabs: []
    };
  },

  props: {
    tag: {
      type: String,
      default: 'div'
    },
    card: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: null
    },
    pills: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    },
    end: {
      // Synonym for 'bottom'
      type: Boolean,
      default: false
    },
    noFade: {
      type: Boolean,
      default: false
    },
    noNavStyle: {
      type: Boolean,
      default: false
    },
    noKeyNav: {
      type: Boolean,
      default: false
    },
    lazy: {
      // This prop is sniffed by the tab child
      type: Boolean,
      default: false
    },
    contentClass: {
      type: [String, Array, Object],
      default: null
    },
    navClass: {
      type: [String, Array, Object],
      default: null
    },
    navWrapperClass: {
      type: [String, Array, Object],
      default: null
    }
  },
  watch: {
    currentTab: function currentTab(val, old) {
      if (val === old) {
        return;
      }
      this.$root.$emit('changed::tab', this, val, this.tabs[val]);
      this.$emit('input', val);
      this.tabs[val].$emit('click');
    },
    value: function value(val, old) {
      if (val === old) {
        return;
      }
      if (typeof old !== 'number') {
        old = 0;
      }
      // Moving left or right?
      var direction = val < old ? -1 : 1;
      this.setTab(val, false, direction);
    }
  },
  computed: {
    fade: function fade() {
      // This computed prop is sniffed by the tab child
      return !this.noFade;
    },
    navStyle: function navStyle() {
      return this.pills ? 'pills' : 'tabs';
    }
  },
  methods: {
    /**
     * Util: Return the sign of a number (as -1, 0, or 1)
     */
    sign: function sign(x) {
      return x === 0 ? 0 : x > 0 ? 1 : -1;
    },

    /*
         * handle keyboard navigation
         */
    onKeynav: function onKeynav(evt) {
      if (this.noKeyNav) {
        return;
      }
      var key = evt.keyCode;
      var shift = evt.shiftKey;
      function stop() {
        evt.preventDefault();
        evt.stopPropagation();
      }
      if (key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].UP || key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].LEFT) {
        stop();
        if (shift) {
          this.setTab(0, false, 1);
        } else {
          this.previousTab();
        }
      } else if (key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].DOWN || key === __WEBPACK_IMPORTED_MODULE_0__utils_key_codes__["a" /* default */].RIGHT) {
        stop();
        if (shift) {
          this.setTab(this.tabs.length - 1, false, -1);
        } else {
          this.nextTab();
        }
      }
    },

    /**
     * Move to next tab
     */
    nextTab: function nextTab() {
      this.setTab(this.currentTab + 1, false, 1);
    },

    /**
     * Move to previous tab
     */
    previousTab: function previousTab() {
      this.setTab(this.currentTab - 1, false, -1);
    },

    /**
     * Set active tab on the tabs collection and the child 'tab' component
     * Index is the tab we want to activate. Direction is the direction we are moving
     * so if the tab we requested is disabled, we can skip over it.
     * Force is used by updateTabs to ensure we have cleared any previous active tabs.
     */
    setTab: function setTab(index, force, direction) {
      var _this2 = this;

      direction = this.sign(direction || 0);
      index = index || 0;
      // Prevent setting same tab and infinite loops!
      if (!force && index === this.currentTab) {
        return;
      }
      var tab = this.tabs[index];
      // Don't go beyond indexes!
      if (!tab) {
        // Reset the v-model to the current Tab
        this.$emit('input', this.currentTab);
        return;
      }
      // Ignore or Skip disabled
      if (tab.disabled) {
        if (direction) {
          // Skip to next non disabled tab in specified direction (recursive)
          this.setTab(index + direction, force, direction);
        }
        return;
      }
      // Activate requested current tab, and deactivte any old tabs
      this.tabs.forEach(function (t) {
        if (t === tab) {
          // Set new tab as active
          _this2.$set(t, 'localActive', true);
        } else {
          // Ensure non current tabs are not active
          _this2.$set(t, 'localActive', false);
        }
      });
      // Update currentTab
      this.currentTab = index;
    },

    /**
     * Dynamically update tabs list
     */
    updateTabs: function updateTabs() {
      // Probe tabs
      this.tabs = this.$children.filter(function (child) {
        return child._isTab;
      });
      // Set initial active tab
      var tabIndex = null;
      // Find *last* active non-dsabled tab in current tabs
      // We trust tab state over currentTab
      this.tabs.forEach(function (tab, index) {
        if (tab.localActive && !tab.disabled) {
          tabIndex = index;
        }
      });
      // Else try setting to currentTab
      if (tabIndex === null) {
        if (this.currentTab >= this.tabs.length) {
          // Handle last tab being removed
          this.setTab(this.tabs.length - 1, true, -1);
          return;
        } else if (this.tabs[this.currentTab] && !this.tabs[this.currentTab].disabled) {
          tabIndex = this.currentTab;
        }
      }
      // Else find *first* non-disabled tab in current tabs
      if (tabIndex === null) {
        this.tabs.forEach(function (tab, index) {
          if (!tab.disabled && tabIndex === null) {
            tabIndex = index;
          }
        });
      }
      this.setTab(tabIndex || 0, true, 0);
    }
  },
  mounted: function mounted() {
    this.updateTabs();
    // Observe Child changes so we can notify tabs change
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a" /* default */])(this.$refs.tabsContainer, this.updateTabs.bind(this), {
      subtree: false
    });
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_id__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_id__["a" /* default */]],
  render: function render(h) {
    var content = h(false);
    if (this.localActive || !this.computedLazy) {
      content = h(this.tag, {
        ref: 'panel',
        class: this.tabClasses,
        directives: [{ name: 'show', value: this.localActive }],
        attrs: {
          role: 'tabpanel',
          id: this.safeId(),
          'aria-hidden': this.localActive ? 'false' : 'true',
          'aria-expanded': this.localActive ? 'true' : 'false',
          'aria-lablelledby': this.controlledBy || null
        }
      }, [this.$slots.default]);
    }
    return h('transition', {
      props: { mode: 'out-in' },
      on: {
        beforeEnter: this.beforeEnter,
        beforeLeave: this.beforeLeave
      }
    }, [content]);
  },

  methods: {
    beforeEnter: function beforeEnter() {
      var _this = this;

      // change opacity 1 frame after display
      // otherwise css transition won't happen
      window.requestAnimationFrame(function () {
        _this.show = true;
      });
    },
    beforeLeave: function beforeLeave() {
      this.show = false;
    }
  },
  data: function data() {
    return {
      localActive: this.active && !this.disabled,
      show: false
    };
  },
  mounted: function mounted() {
    this.show = this.localActive;
  },

  computed: {
    tabClasses: function tabClasses() {
      return ['tab-pane', this.$parent && this.$parent.card && !this.noBody ? 'card-body' : '', this.show ? 'show' : '', this.computedFade ? 'fade' : '', this.disabled ? 'disabled' : '', this.localActive ? 'active' : ''];
    },
    controlledBy: function controlledBy() {
      return this.buttonId || this.safeId('__BV_tab_button__');
    },
    computedFade: function computedFade() {
      return this.$parent.fade;
    },
    computedLazy: function computedLazy() {
      return this.$parent.lazy;
    },
    _isTab: function _isTab() {
      // For parent sniffing of child
      return true;
    }
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'div'
    },
    buttonId: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    titleItemClass: {
      // Sniffed by tabs.vue and added to nav 'li.nav-item'
      type: [String, Array, Object],
      default: null
    },
    titleLinkClass: {
      // Sniffed by tabs.vue and added to nav 'a.nav-link'
      type: [String, Array, Object],
      default: null
    },
    headHtml: {
      // Is this actually ever used?
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    noBody: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: '#'
    }
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var components = {
  bTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["a" /* registerComponents */])(Vue, components);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__ = __webpack_require__(67);




/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_toolpop__["a" /* default */]],
  render: function render(h) {
    return h('div', { class: ['d-none'], style: { display: 'none' }, attrs: { 'aria-hidden': true } }, [h('div', { ref: 'title' }, this.$slots.default)]);
  },
  data: function data() {
    return {};
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    triggers: {
      type: [String, Array],
      default: 'hover focus'
    },
    placement: {
      type: String,
      default: 'top'
    }
  },
  methods: {
    createToolpop: function createToolpop() {
      // getTarget is in toolpop mixin
      var target = this.getTarget();
      if (target) {
        this._toolpop = new __WEBPACK_IMPORTED_MODULE_0__utils_tooltip_class__["a" /* default */](target, this.getConfig(), this.$root);
      } else {
        this._toolpop = null;
        Object(__WEBPACK_IMPORTED_MODULE_1__utils_warn__["a" /* default */])("b-tooltip: 'target' element not found!");
      }
      return this._toolpop;
    }
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toggle__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scrollspy__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tooltip__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popover__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return __WEBPACK_IMPORTED_MODULE_0__toggle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_1__modal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scrollspy", function() { return __WEBPACK_IMPORTED_MODULE_2__scrollspy__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_3__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popover", function() { return __WEBPACK_IMPORTED_MODULE_4__popover__["a"]; });








/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollspy__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var directives = {
  bScrollspy: __WEBPACK_IMPORTED_MODULE_0__scrollspy__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* registerDirectives */])(Vue, directives);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scrollspy_class__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object__ = __webpack_require__(2);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * ScrollSpy directive v-b-scrollspy
 */




var inBrowser = typeof window !== 'undefined';
var isServer = !inBrowser;

// Key we use to store our Instance
var BVSS = '__BV_ScrollSpy__';

// Generate config from bindings
/* istanbul ignore next: not easy to test */
function makeConfig(binding) {
  var config = {};

  // If Argument, assume element ID
  if (binding.arg) {
    // Element ID specified as arg. We must pre-pend #
    config.element = '#' + binding.arg;
  }

  // Process modifiers
  Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["e" /* keys */])(binding.modifiers).forEach(function (mod) {
    if (/^\d+$/.test(mod)) {
      // Offest value
      config.offset = parseInt(mod, 10);
    } else if (/^(auto|position|offset)$/.test(mod)) {
      // Offset method
      config.method = mod;
    }
  });

  // Process value
  if (typeof binding.value === 'string') {
    // Value is a CSS ID or selector
    config.element = binding.value;
  } else if (typeof binding.value === 'number') {
    // Value is offset
    config.offset = Math.round(binding.value);
  } else if (_typeof(binding.value) === 'object') {
    // Value is config object
    // Filter the object based on our supported config options
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_object__["e" /* keys */])(binding.value).filter(function (k) {
      return Boolean(__WEBPACK_IMPORTED_MODULE_0__scrollspy_class__["a" /* default */].DefaultType[k]);
    }).forEach(function (k) {
      config[k] = binding.value[k];
    });
  }

  return config;
}

/* istanbul ignore next: not easy to test */
function addBVSS(el, binding, vnode) {
  if (isServer) {
    return;
  }
  var cfg = makeConfig(binding);
  if (!el[BVSS]) {
    el[BVSS] = new __WEBPACK_IMPORTED_MODULE_0__scrollspy_class__["a" /* default */](el, cfg, vnode.context.$root);
  } else {
    el[BVSS].updateConfig(cfg, vnode.context.$root);
  }
  return el[BVSS];
}

/* istanbul ignore next: not easy to test */
function removeBVSS(el) {
  if (el[BVSS]) {
    el[BVSS].dispose();
    el[BVSS] = null;
  }
}

/*
 * Export our directive
 */

/* istanbul ignore next: not easy to test */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, vnode) {
    addBVSS(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    addBVSS(el, binding, vnode);
  },
  update: function update(el, binding, vnode) {
    addBVSS(el, binding, vnode);
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {
    addBVSS(el, binding, vnode);
  },
  unbind: function unbind(el) {
    if (isServer) {
      return;
    }
    // Remove scroll event listener on scrollElId
    removeBVSS(el);
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warn__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_dom__ = __webpack_require__(4);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 * ScrollSpy class definition
 */






/*
 * Constants / Defaults
 */

var NAME = 'v-b-scrollspy';
var ACTIVATE_EVENT = 'bv::scrollspy::activate';

var Default = {
  element: 'body',
  offset: 10,
  method: 'auto',
  throttle: 75
};

var DefaultType = {
  element: '(string|element|component)',
  offset: 'number',
  method: 'string',
  throttle: 'number'
};

var ClassName = {
  DROPDOWN_ITEM: 'dropdown-item',
  ACTIVE: 'active'
};

var Selector = {
  ACTIVE: '.active',
  NAV_LIST_GROUP: '.nav, .list-group',
  NAV_LINKS: '.nav-link',
  NAV_ITEMS: '.nav-item',
  LIST_ITEMS: '.list-group-item',
  DROPDOWN: '.dropdown, .dropup',
  DROPDOWN_ITEMS: '.dropdown-item',
  DROPDOWN_TOGGLE: '.dropdown-toggle'
};

var OffsetMethod = {
  OFFSET: 'offset',
  POSITION: 'position'

  // HREFs must start with # but can be === '#', or start with '#/' or '#!' (which can be router links)
};var HREF_REGEX = /^#[^/!]+/;

// Transition Events
var TransitionEndEvents = ['webkitTransitionEnd', 'transitionend', 'otransitionend', 'oTransitionEnd'];

/*
 * Utility Methods
 */

// Better var type detection
/* istanbul ignore next: not easy to test */
function toType(obj) {
  return {}.toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}

// Check config properties for expected types
/* istanbul ignore next: not easy to test */
function typeCheckConfig(componentName, config, configTypes) {
  for (var property in configTypes) {
    if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
      var expectedTypes = configTypes[property];
      var value = config[property];
      var valueType = value && Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["l" /* isElement */])(value) ? 'element' : toType(value);
      // handle Vue instances
      valueType = value && value._isVue ? 'component' : valueType;

      if (!new RegExp(expectedTypes).test(valueType)) {
        Object(__WEBPACK_IMPORTED_MODULE_2__utils_warn__["a" /* default */])(componentName + ': Option "' + property + '" provided type "' + valueType + '", but expected type "' + expectedTypes + '"');
      }
    }
  }
}

/*
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

/* istanbul ignore next: not easy to test */

var ScrollSpy = function () {
  function ScrollSpy(element, config, $root) {
    _classCallCheck(this, ScrollSpy);

    // The element we activate links in
    this.$el = element;
    this.$scroller = null;
    this.$selector = [Selector.NAV_LINKS, Selector.LIST_ITEMS, Selector.DROPDOWN_ITEMS].join(',');
    this.$offsets = [];
    this.$targets = [];
    this.$activeTarget = null;
    this.$scrollHeight = 0;
    this.$resizeTimeout = null;
    this.$obs_scroller = null;
    this.$obs_targets = null;
    this.$root = $root || null;
    this.$config = null;

    this.updateConfig(config);
  }

  _createClass(ScrollSpy, [{
    key: 'updateConfig',
    value: function updateConfig(config, $root) {
      if (this.$scroller) {
        // Just in case out scroll element has changed
        this.unlisten();
        this.$scroller = null;
      }
      var cfg = Object(__WEBPACK_IMPORTED_MODULE_0__utils_object__["a" /* assign */])({}, this.constructor.Default, config);
      if ($root) {
        this.$root = $root;
      }
      typeCheckConfig(this.constructor.Name, cfg, this.constructor.DefaultType);
      this.$config = cfg;

      if (this.$root) {
        var self = this;
        this.$root.$nextTick(function () {
          self.listen();
        });
      } else {
        this.listen();
      }
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      this.unlisten();
      clearTimeout(this.$resizeTimeout);
      this.$resizeTimeout = null;
      this.$el = null;
      this.$config = null;
      this.$scroller = null;
      this.$selector = null;
      this.$offsets = null;
      this.$targets = null;
      this.$activeTarget = null;
      this.$scrollHeight = null;
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this = this;

      var scroller = this.getScroller();
      if (scroller && scroller.tagName !== 'BODY') {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* eventOn */])(scroller, 'scroll', this);
      }
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* eventOn */])(window, 'scroll', this);
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* eventOn */])(window, 'resize', this);
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* eventOn */])(window, 'orientationchange', this);
      TransitionEndEvents.forEach(function (evtName) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["d" /* eventOn */])(window, evtName, _this);
      });
      this.setObservers(true);
      // Scedule a refresh
      this.handleEvent('refresh');
    }
  }, {
    key: 'unlisten',
    value: function unlisten() {
      var _this2 = this;

      var scroller = this.getScroller();
      this.setObservers(false);
      if (scroller && scroller.tagName !== 'BODY') {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* eventOff */])(scroller, 'scroll', this);
      }
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* eventOff */])(window, 'scroll', this);
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* eventOff */])(window, 'resize', this);
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* eventOff */])(window, 'orientationchange', this);
      TransitionEndEvents.forEach(function (evtName) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["c" /* eventOff */])(window, evtName, _this2);
      });
    }
  }, {
    key: 'setObservers',
    value: function setObservers(on) {
      var _this3 = this;

      // We observe both the scroller for content changes, and the target links
      if (this.$obs_scroller) {
        this.$obs_scroller.disconnect();
        this.$obs_scroller = null;
      }
      if (this.$obs_targets) {
        this.$obs_targets.disconnect();
        this.$obs_targets = null;
      }
      if (on) {
        this.$obs_targets = Object(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a" /* default */])(this.$el, function () {
          _this3.handleEvent('mutation');
        }, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['href']
        });
        this.$obs_scroller = Object(__WEBPACK_IMPORTED_MODULE_1__utils_observe_dom__["a" /* default */])(this.getScroller(), function () {
          _this3.handleEvent('mutation');
        }, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['id', 'style', 'class']
        });
      }
    }

    // general event handler

  }, {
    key: 'handleEvent',
    value: function handleEvent(evt) {
      var type = typeof evt === 'string' ? evt : evt.type;

      var self = this;
      function resizeThrottle() {
        if (!self.$resizeTimeout) {
          self.$resizeTimeout = setTimeout(function () {
            self.refresh();
            self.process();
            self.$resizeTimeout = null;
          }, self.$config.throttle);
        }
      }

      if (type === 'scroll') {
        if (!this.$obs_scroller) {
          // Just in case we are added to the DOM before the scroll target is
          // We re-instantiate our listeners, just in case
          this.listen();
        }
        this.process();
      } else if (/(resize|orientationchange|mutation|refresh)/.test(type)) {
        // Postpone these events by throttle time
        resizeThrottle();
      }
    }

    // Refresh the list of target links on the element we are applied to

  }, {
    key: 'refresh',
    value: function refresh() {
      var _this4 = this;

      var scroller = this.getScroller();
      if (!scroller) {
        return;
      }
      var autoMethod = scroller !== scroller.window ? OffsetMethod.POSITION : OffsetMethod.OFFSET;
      var method = this.$config.method === 'auto' ? autoMethod : this.$config.method;
      var methodFn = method === OffsetMethod.POSITION ? __WEBPACK_IMPORTED_MODULE_3__utils_dom__["p" /* position */] : __WEBPACK_IMPORTED_MODULE_3__utils_dom__["o" /* offset */];
      var offsetBase = method === OffsetMethod.POSITION ? this.getScrollTop() : 0;

      this.$offsets = [];
      this.$targets = [];

      this.$scrollHeight = this.getScrollHeight();

      // Find all the unique link href's
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["u" /* selectAll */])(this.$selector, this.$el).map(function (link) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["e" /* getAttr */])(link, 'href');
      }).filter(function (href) {
        return HREF_REGEX.test(href || '');
      }).map(function (href) {
        var el = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* select */])(href, scroller);
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["m" /* isVisible */])(el)) {
          return {
            offset: parseInt(methodFn(el).top, 10) + offsetBase,
            target: href
          };
        }
        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a.offset - b.offset;
      }).reduce(function (memo, item) {
        // record only unique targets/offfsets
        if (!memo[item.target]) {
          _this4.$offsets.push(item.offset);
          _this4.$targets.push(item.target);
          memo[item.target] = true;
        }
        return memo;
      }, {});

      return this;
    }

    // Handle activating/clearing

  }, {
    key: 'process',
    value: function process() {
      var scrollTop = this.getScrollTop() + this.$config.offset;
      var scrollHeight = this.getScrollHeight();
      var maxScroll = this.$config.offset + scrollHeight - this.getOffsetHeight();

      if (this.$scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this.$targets[this.$targets.length - 1];
        if (this.$activeTarget !== target) {
          this.activate(target);
        }
        return;
      }

      if (this.$activeTarget && scrollTop < this.$offsets[0] && this.$offsets[0] > 0) {
        this.$activeTarget = null;
        this.clear();
        return;
      }

      for (var i = this.$offsets.length; i--;) {
        var isActiveTarget = this.$activeTarget !== this.$targets[i] && scrollTop >= this.$offsets[i] && (typeof this.$offsets[i + 1] === 'undefined' || scrollTop < this.$offsets[i + 1]);

        if (isActiveTarget) {
          this.activate(this.$targets[i]);
        }
      }
    }
  }, {
    key: 'getScroller',
    value: function getScroller() {
      if (this.$scroller) {
        return this.$scroller;
      }
      var scroller = this.$config.element;
      if (!scroller) {
        return null;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["l" /* isElement */])(scroller.$el)) {
        scroller = scroller.$el;
      } else if (typeof scroller === 'string') {
        scroller = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* select */])(scroller);
      }
      if (!scroller) {
        return null;
      }
      this.$scroller = scroller.tagName === 'BODY' ? window : scroller;
      return this.$scroller;
    }
  }, {
    key: 'getScrollTop',
    value: function getScrollTop() {
      var scroller = this.getScroller();
      return scroller === window ? scroller.pageYOffset : scroller.scrollTop;
    }
  }, {
    key: 'getScrollHeight',
    value: function getScrollHeight() {
      return this.getScroller().scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    }
  }, {
    key: 'getOffsetHeight',
    value: function getOffsetHeight() {
      var scroller = this.getScroller();
      return scroller === window ? window.innerHeight : Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["f" /* getBCR */])(scroller).height;
    }
  }, {
    key: 'activate',
    value: function activate(target) {
      var _this5 = this;

      this.$activeTarget = target;
      this.clear();

      // Grab the list of target links (<a href="{$target}">)
      var links = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["u" /* selectAll */])(this.$selector.split(',').map(function (selector) {
        return selector + '[href="' + target + '"]';
      }).join(','), this.$el);

      links.forEach(function (link) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["j" /* hasClass */])(link, ClassName.DROPDOWN_ITEM)) {
          // This is a dropdown item, so find the .dropdown-toggle and set it's state
          var dropdown = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* closest */])(Selector.DROPDOWN, link);
          if (dropdown) {
            _this5.setActiveState(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* select */])(Selector.DROPDOWN_TOGGLE, dropdown), true);
          }
          // Also set this link's state
          _this5.setActiveState(link, true);
        } else {
          // Set triggered link as active
          _this5.setActiveState(link, true);
          if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n" /* matches */])(link.parentElement, Selector.NAV_ITEMS)) {
            // Handle nav-link inside nav-item, and set nav-item active
            _this5.setActiveState(link.parentElement, true);
          }
          // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
          var el = link;
          while (el) {
            el = Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["b" /* closest */])(Selector.NAV_LIST_GROUP, el);
            var sibling = el ? el.previousElementSibling : null;
            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n" /* matches */])(sibling, Selector.NAV_LINKS + ', ' + Selector.LIST_ITEMS)) {
              _this5.setActiveState(sibling, true);
            }
            // Handle special case where nav-link is inside a nav-item
            if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["n" /* matches */])(sibling, Selector.NAV_ITEMS)) {
              _this5.setActiveState(Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["t" /* select */])(Selector.NAV_LINKS, sibling), true);
              // Add active state to nav-item as well
              _this5.setActiveState(sibling, true);
            }
          }
        }
      });

      // Signal event to via $root, passing ID of activaed target and reference to array of links
      if (links && links.length > 0 && this.$root) {
        this.$root.$emit(ACTIVATE_EVENT, target, links);
      }
    }
  }, {
    key: 'clear',
    value: function clear() {
      var _this6 = this;

      Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["u" /* selectAll */])(this.$selector + ', ' + Selector.NAV_ITEMS, this.$el).filter(function (el) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["j" /* hasClass */])(el, ClassName.ACTIVE);
      }).forEach(function (el) {
        return _this6.setActiveState(el, false);
      });
    }
  }, {
    key: 'setActiveState',
    value: function setActiveState(el, active) {
      if (!el) {
        return;
      }
      if (active) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["a" /* addClass */])(el, ClassName.ACTIVE);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_dom__["s" /* removeClass */])(el, ClassName.ACTIVE);
      }
    }
  }], [{
    key: 'Name',
    get: function get() {
      return NAME;
    }
  }, {
    key: 'Default',
    get: function get() {
      return Default;
    }
  }, {
    key: 'DefaultType',
    get: function get() {
      return DefaultType;
    }
  }]);

  return ScrollSpy;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScrollSpy);

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tooltip__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var directives = {
  bTooltip: __WEBPACK_IMPORTED_MODULE_0__tooltip__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* registerDirectives */])(Vue, directives);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_tooltip_class__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warn__ = __webpack_require__(8);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






var inBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

// Key which we use to store tooltip object on element
var BVTT = '__BV_ToolTip__';

// Valid event triggers
var validTriggers = {
  'focus': true,
  'hover': true,
  'click': true,
  'blur': true

  // Build a ToolTip config based on bindings (if any)
  // Arguments and modifiers take precedence over passed value config object
  /* istanbul ignore next: not easy to test */
};function parseBindings(bindings) {
  // We start out with a blank config
  var config = {};

  // Process bindings.value
  if (typeof bindings.value === 'string') {
    // Value is tooltip content (html optionally supported)
    config.title = bindings.value;
  } else if (typeof bindings.value === 'function') {
    // Title generator function
    config.title = bindings.value;
  } else if (_typeof(bindings.value) === 'object') {
    // Value is config object, so merge
    config = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(bindings.value);
  }

  // If Argument, assume element ID of container element
  if (bindings.arg) {
    // Element ID specified as arg. We must prepend '#' to become a CSS selector
    config.container = '#' + bindings.arg;
  }

  // Process modifiers
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(bindings.modifiers).forEach(function (mod) {
    if (/^html$/.test(mod)) {
      // Title allows HTML
      config.html = true;
    } else if (/^nofade$/.test(mod)) {
      // no animation
      config.animation = false;
    } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
      // placement of tooltip
      config.placement = mod;
    } else if (/^(window|viewport)$/.test(mod)) {
      // bounday of tooltip
      config.boundary = mod;
    } else if (/^d\d+$/.test(mod)) {
      // delay value
      var delay = parseInt(mod.slice(1), 10) || 0;
      if (delay) {
        config.delay = delay;
      }
    } else if (/^o-?\d+$/.test(mod)) {
      // offset value. Negative allowed
      var offset = parseInt(mod.slice(1), 10) || 0;
      if (offset) {
        config.offset = offset;
      }
    }
  });

  // Special handling of event trigger modifiers Trigger is a space separated list
  var selectedTriggers = {};

  // parse current config object trigger
  var triggers = typeof config.trigger === 'string' ? config.trigger.trim().split(/\s+/) : [];
  triggers.forEach(function (trigger) {
    if (validTriggers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  });

  // Parse Modifiers for triggers
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(validTriggers).forEach(function (trigger) {
    if (bindings.modifiers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  });

  // Sanitize triggers
  config.trigger = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(selectedTriggers).join(' ');
  if (config.trigger === 'blur') {
    // Blur by itself is useless, so convert it to 'focus'
    config.trigger = 'focus';
  }
  if (!config.trigger) {
    // remove trigger config
    delete config.trigger;
  }

  return config;
}

//
// Add or Update tooltip on our element
//
/* istanbul ignore next: not easy to test */
function applyBVTT(el, bindings, vnode) {
  if (!inBrowser) {
    return;
  }
  if (!__WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */]) {
    // Popper is required for tooltips to work
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_warn__["a" /* default */])('v-b-tooltip: Popper.js is required for tooltips to work');
    return;
  }
  if (el[BVTT]) {
    el[BVTT].updateConfig(parseBindings(bindings));
  } else {
    el[BVTT] = new __WEBPACK_IMPORTED_MODULE_1__utils_tooltip_class__["a" /* default */](el, parseBindings(bindings), vnode.context.$root);
  }
}

//
// Remove tooltip on our element
//
/* istanbul ignore next: not easy to test */
function removeBVTT(el) {
  if (!inBrowser) {
    return;
  }
  if (el[BVTT]) {
    el[BVTT].destroy();
    el[BVTT] = null;
    delete el[BVTT];
  }
}

/*
 * Export our directive
 */
/* istanbul ignore next: not easy to test */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, bindings, vnode) {
    applyBVTT(el, bindings, vnode);
  },
  inserted: function inserted(el, bindings, vnode) {
    applyBVTT(el, bindings, vnode);
  },
  update: function update(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyBVTT(el, bindings, vnode);
    }
  },
  componentUpdated: function componentUpdated(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyBVTT(el, bindings, vnode);
    }
  },
  unbind: function unbind(el) {
    removeBVTT(el);
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popover__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_plugins__ = __webpack_require__(1);



var directives = {
  bPopover: __WEBPACK_IMPORTED_MODULE_0__popover__["a" /* default */]
};

var VuePlugin = {
  install: function install(Vue) {
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["b" /* registerDirectives */])(Vue, directives);
  }
};

Object(__WEBPACK_IMPORTED_MODULE_1__utils_plugins__["c" /* vueUse */])(VuePlugin);

/* harmony default export */ __webpack_exports__["a"] = (VuePlugin);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_popover_class__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warn__ = __webpack_require__(8);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






var inBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

// Key which we use to store tooltip object on element
var BVPO = '__BV_PopOver__';

// Valid event triggers
var validTriggers = {
  'focus': true,
  'hover': true,
  'click': true,
  'blur': true

  // Build a PopOver config based on bindings (if any)
  // Arguments and modifiers take precedence over pased value config object
  /* istanbul ignore next: not easy to test */
};function parseBindings(bindings) {
  // We start out with a blank config
  var config = {};

  // Process bindings.value
  if (typeof bindings.value === 'string') {
    // Value is popover content (html optionally supported)
    config.content = bindings.value;
  } else if (typeof bindings.value === 'function') {
    // Content generator function
    config.content = bindings.value;
  } else if (_typeof(bindings.value) === 'object') {
    // Value is config object, so merge
    config = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["a" /* assign */])(bindings.value);
  }

  // If Argument, assume element ID of container element
  if (bindings.arg) {
    // Element ID specified as arg. We must prepend '#' to become a CSS selector
    config.container = '#' + bindings.arg;
  }

  // Process modifiers
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(bindings.modifiers).forEach(function (mod) {
    if (/^html$/.test(mod)) {
      // Title allows HTML
      config.html = true;
    } else if (/^nofade$/.test(mod)) {
      // no animation
      config.animation = false;
    } else if (/^(auto|top(left|right)?|bottom(left|right)?|left(top|bottom)?|right(top|bottom)?)$/.test(mod)) {
      // placement of popover
      config.placement = mod;
    } else if (/^(window|viewport)$/.test(mod)) {
      // bounday of popover
      config.boundary = mod;
    } else if (/^d\d+$/.test(mod)) {
      // delay value
      var delay = parseInt(mod.slice(1), 10) || 0;
      if (delay) {
        config.delay = delay;
      }
    } else if (/^o-?\d+$/.test(mod)) {
      // offset value (negative allowed)
      var offset = parseInt(mod.slice(1), 10) || 0;
      if (offset) {
        config.offset = offset;
      }
    }
  });

  // Special handling of event trigger modifiers Trigger is a space separated list
  var selectedTriggers = {};

  // parse current config object trigger
  var triggers = typeof config.trigger === 'string' ? config.trigger.trim().split(/\s+/) : [];
  triggers.forEach(function (trigger) {
    if (validTriggers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  });

  // Parse Modifiers for triggers
  Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(validTriggers).forEach(function (trigger) {
    if (bindings.modifiers[trigger]) {
      selectedTriggers[trigger] = true;
    }
  });

  // Sanitize triggers
  config.trigger = Object(__WEBPACK_IMPORTED_MODULE_2__utils_object__["e" /* keys */])(selectedTriggers).join(' ');
  if (config.trigger === 'blur') {
    // Blur by itself is useless, so convert it to focus
    config.trigger = 'focus';
  }
  if (!config.trigger) {
    // remove trigger config
    delete config.trigger;
  }

  return config;
}

//
// Add or Update popover on our element
//
/* istanbul ignore next: not easy to test */
function applyBVPO(el, bindings, vnode) {
  if (!inBrowser) {
    return;
  }
  if (!__WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */]) {
    // Popper is required for tooltips to work
    Object(__WEBPACK_IMPORTED_MODULE_3__utils_warn__["a" /* default */])('v-b-popover: Popper.js is required for popovers to work');
    return;
  }
  if (el[BVPO]) {
    el[BVPO].updateConfig(parseBindings(bindings));
  } else {
    el[BVPO] = new __WEBPACK_IMPORTED_MODULE_1__utils_popover_class__["a" /* default */](el, parseBindings(bindings), vnode.context.$root);
  }
};

//
// Remove popover on our element
//
/* istanbul ignore next */
function removeBVPO(el) {
  if (!inBrowser) {
    return;
  }
  if (el[BVPO]) {
    el[BVPO].destroy();
    el[BVPO] = null;
    delete el[BVPO];
  }
}

/*
 * Export our directive
 */
/* istanbul ignore next: not easy to test */
/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, bindings, vnode) {
    applyBVPO(el, bindings, vnode);
  },
  inserted: function inserted(el, bindings, vnode) {
    applyBVPO(el, bindings, vnode);
  },
  update: function update(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyBVPO(el, bindings, vnode);
    }
  },
  componentUpdated: function componentUpdated(el, bindings, vnode) {
    if (bindings.value !== bindings.oldValue) {
      applyBVPO(el, bindings, vnode);
    }
  },
  unbind: function unbind(el) {
    removeBVPO(el);
  }
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d19c4c_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(219);
function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e0d19c4c_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(202);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("1a2c24be", content, true, {});

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports
exports.i(__webpack_require__(203), "");

// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "body{font-family:HelveticaNeue,Helvetica Neue,Helvetica,Arial,sans-serif;color:#333}h1{margin-bottom:1.8rem}.app{display:flex;flex-direction:column;width:100%}.help-text{margin-top:20px;font-size:12px}#m68_navbar_top{font-style:italic;font-family:Garamond,Times New Roman,serif;font-size:large;padding-top:12px;margin-bottom:30px}#m68_navbar_top_nav{justify-content:center;flex:1 0 auto}#m68_nav_collapse_top.show{border-bottom:1px solid #ced4da;padding-bottom:15px}#m68_navbar_footer{font-size:smaller}.m68_article_teaser{float:left;text-align:left;padding-right:1.5625em;width:13em}figcaption{color:rgba(0,0,0,.5);font-size:x-small;width:13em;margin-left:.5em}.m68_breadcrumb{font-size:x-small;background-color:#fff}", ""]);

// exports


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__ = __webpack_require__(70);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec61a468_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__ = __webpack_require__(212);
function injectStyle (ssrContext) {
  __webpack_require__(206)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec61a468_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(207);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("e43c72b8", content, true, {});

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Store */
/* unused harmony export install */
/* unused harmony export mapState */
/* unused harmony export mapMutations */
/* unused harmony export mapGetters */
/* unused harmony export mapActions */
/* unused harmony export createNamespacedHelpers */
/**
 * vuex v3.0.1
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '3.0.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["a"] = (index_esm);


/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = [["1","1966-12-02","TU-Studentenvertretung will auf das humanistische Grundstudium verzichten.","TU-Grundsatzdebatte über das Humanistische Grundstudium","","","Eigener Bericht",[11],4,[1],[2],2,"22","13"],["2","1966-12-03","TU-Studentenvertretung will Verzicht auf das humanistische Grundstudium.","Humanistisches Grundstudium ist ihnen zu lästig","","","Eigener Bericht",[11],1,[1],[2],2,"16","5"],["3","1966-12-05","Neuer Abschluss für TU-Studenten zugelassen.","Philosophische Fakultät der TU mit eigenem Staatsexamen","","","Eigener Bericht",[11],4,[1],[2],2,"20","11"],["4","1966-12-06","Wahlen an der FU. Zahl der politisch orientierten Kandidaten zurückgegangen, schwache Wahlbeteiligung erwartet.","FU-Studenten wählen Parlament","","keine ","Eigener Bericht",[11],1,[1],[2],2,"16","3"],["5","1966-12-06","Wahlen an der FU, nur 129 Bewerber für 79 Mandate,  Zahl der politisch orientierten Kandidaten zurückgegangen, schwache Wahlbeteiligung erwartet.","Weniger Kandidaten für FU-Konventswahlen","","","Eigener Bericht",[11],4,[1],[2],2,"18","11"],["6","1966-12-07","Tumultartige Szenen bei Auftritt des südvietnamesischen Botschafters an der FU bei RCDS-Veranstaltung (irrtümlich steht SDS).","Tumult an der FU","","","Eigener Bericht",[1],1,[1],[2],2,"14","1"],["7","1966-12-07","Kritik an Studenten, die Flugblätter produzieren statt zu studieren.","Unverständlich","","","W.W., Berlin 61",[9],1,[6],[3],2,"14","2"],["8","1966-12-07","Bericht über die Veranstaltung des südvietnamesischen Botschafters an der FU.","SDS-Studenten störten an der FU","","Veranstaltung des RCDS mit südvietnamesischem Botschafter aus Bonn ","Eigener Bericht",[1],8,[1],[3],2,"14","1"],["9","1966-12-07","Fortsetzung des Artikels \"SDS-Studenten störten an der FU\" von Seite vom 8.12.1966, Bericht über die Störung der RCDS-Veranstaltung mit dem südvietnamesischen Botschafter durch den SDS.","Vietnam-Krawall an der FU","","","Eigener Bericht",[1],8,[1],[2],2,"14","2"],["10","1966-12-08","Kritik am Tumult gegen den Auftritt des südvietnamesischen Botschafters. Die extrem linken Studenten hätten kein demokratisches Empfinden, seien Radaubrüder und Radikalinskis. Kritik auch an der Studentenschaft allgemein, die vermeintlich vernünftige Mehrheit habe sich schließlich noch nicht gegen die Krawallmacher zur Wehr gesetzt.","Die \"Rote Garde\" an der FU","","","wbr",[1],1,[5],[5],2,"16","2"],["11","1966-12-08","Tumultartige Szenen beim Auftritt des südvietnamesischen Botschafters werden beschrieben.","Botschafter in der FU angepöbelt","","","Eigener Bericht",[1],1,[1],[2],2,"16","2"],["12","1966-12-08","Kritischer Kommentar zum Verhalten des SDS in der FU am 6.12.1966, einschließlich des Vorschlags, nach \"drüben\" (hier: Unter die Linden) zu gehen. ","FU-Konsequenzen","Unsere Meinung","","E.W.",[1],8,[5],[2],2,"14","1"],["13","1966-12-08","Nachricht über Reaktion des RCDS.","RCDS bedauert Störung der FU-Veranstaltung durch den SDS","","","Eigener Bericht",[1],8,[1],[2],2,"14","2"],["14","1966-12-09","Der AStA der FU wehrt sich gegen die Berichte einer \"Berliner Morgenzeitung\" (gemeint wahrscheinlich: BM) über die Vorgänge bei der Diskussion mit dem südvietnamesischen Botschafter. Es habe keine Versuche von SDS-Leuten gegeben, die Diskussion an sich zu reißen.","AStA wehrt sich gegen einseitige Berichterstattung","","","Eigener Bericht",[1],4,[1],[2],2,"24","13"],["15","1966-12-10","Große Auseinandersetzung mit dem Phänomen zunehmender Jugend- und Bandengewalt. Kein direkter Bezug zu Studenten, aber sehr kritisch gegenüber Jugendgewalt aus kriminologischer und soziologischer Sicht.","Die Bande, eine Welt jenseits der Gesellschaft","","Angst vor dem Dasein / Schinderhannes als Vorbild?","Manfred Zollickhofer / Joachim Helmer",[9],4,[1],[1],1,"56","2"],["16","1966-12-11","Kritik an der Sprengung der RCDS-Veranstaltung.","Höchste Zeit","","","G.G., Berlin 10",[1],1,[6],[3],2,"48","2"],["17","1966-12-11","Demonstration gegen Vietnamkrieg, Ausschreitungen.","Tumulte auf dem Kurfürstendamm","","","Eigener Bericht",[1],1,[1],[2],2,"48","1"],["18","1966-12-11","Während unzählige Berliner den langen Samstag zum Einkaufen nutzten, entfesselten linksextreme Studenten ausgedehnte Krawalle und Verkehrsstörungen / Senatssprecher: \"Berlin verurteilt das Treiben der politischen Rowdys, die sich Studenten nennen. Die Berliner sind sicher, dass sich die Mehrheit unter der Studentenschaft von diesem Treiben distanzieren wird.\"","Schlägereien und Krawalle in der City","","74 Studenten wurden festgenommen","Go.",[1],1,[1],[1],1,"48","3"],["19","1966-12-11","Bericht über die Ausschreitungen am Kudamm.","Schwere Tumulte am Kudamm","","Demonstrationen gegen Vietnamkrieg","EB",[1],9,[1],[5],1,"32","1"],["20","1966-12-11","Bericht über die Ausschreitungen bei der Vietnam-Demonstration.","Zusammenstöße mit Polizei in Berlin bei Vietnam-Demonstration","","Studenten wichen von genehmigter Marschroute ab - 74 Festnahmen","Eigener Bericht",[1],8,[1],[3],2,"40","1,2"],["21","1966-12-11","Nachricht über das Wahlergebnis an der FU.","Gewinne der Linken an der FU","","","lbn",[11],5,[1],[2],2,"36","31"],["22","1966-12-11","Bericht über die Tumulte im Zuge der Vietnamdemonstration auf dem Kudamm.","Die Polizei nahm 86 Demonstranten fest","","","Hans L. Lingner",[1],5,[1],[1],1,"36","31"],["23","1966-12-12","Bericht über die Demonstration am Samstag auf dem Kudamm und über die Polizeiaktionen dagegen. Die Demonstranten werden als \"Radikalinskis\" und \"Knalltütenkorps der Berliner Studiker\" bezeichnet.","Prächtige Jungs...","Silberner Studenten-Sonnabend: Randalieren geht über Studieren","","Lutz Horst",[1],2,[7],[1],1,"10","3"],["24","1966-12-12","Solobild mit langer BU, geht um die Ausschreitungen am Samstag, stellt die Maskenverbrennung in den Mittelpunkt, Ulbricht galt als nicht radikal genug.","Johnson und Ulbricht...","","","Eigener Bericht",[1],6,[1],[5],1,"32","2"],["25","1966-12-12","Linksgerichtete Studentenverbände haben ihre Position im Konvent stabilisiert.","Erfolg der Linken im Konvent","","Nur 53,7 Prozent der FU-Studenten beteiligten sich an der Wahl","lb",[11],4,[1],[5],2,"20","12"],["26","1966-12-13","Bei den Konventwahlen Erfolg für die linksgerichteten Studenten.","Sieg der Linken","","","Eigener Bericht",[11],1,[1],[2],2,"12","5"],["27","1966-12-13","Kommentar über die Konventwahl. Analysiert die Wahlergebnisse, lobt das gute Ergebnis für den SHB, greift die radikal orientierte linke Kerngruppe an der FU an, schlägt vor, Studentengruppen, die sich illoyal verhalten, die Förderungswürdigkeit abzuerkennen.","Linke Studenten","","","Co.",[11],4,[5],[5],2,"20","2"],["28","1966-12-14","Leserbrief, Zustimmung zum Kommentar \"Die 'Rote Garde' an der FU\" vom 8.12.1966 in der Berliner Morgenpost.","\"Die Rote Garde an der FU\"","","","Leser",[1],1,[6],[3],2,"12","2"],["29","1966-12-14","Leserbrief, Zustimmung zum Kommentar \"Die 'Rote Garde' an der FU\" vom 8.12.1966 in der Berliner Morgenpost, fordert die Entfernung der Kommunisten von der FU.","Studentenkrawalle","","","W. Sch., Berlin 47",[1],1,[6],[3],2,"12","2"],["30","1966-12-14","Der AStA der FU kritisiert den Polizei-Einsatz vom Samstag. Der Regierende Bürgermeister wiederum kritisiert dies und sagt, dass die Berliner in ihrer übergroßen Mehrheit gegen Rowdytum seien.","Albertz: Studenten sollten sich schämen","","","Eigener Bericht",[1],1,[1],[2],2,"12","1"],["31","1966-12-14","Nevermann gratuliert Albertz zur Wahl, kritisiert zugleich aber scharf die Berliner Polizei. Albertz antwortet darauf in scharfen Worten, ebenso die Berliner Industrie- und Handelskammer.","\"Politische Rowdy- und Rüpelszenen\"","","Scharfe Reaktion auf Beschwerde des FU-AStA","vd",[1],4,[1],[5],2,"22","11"],["32","1966-12-16","In einem Leserbrief wird gefordert, studentischen \"Raudaubrüdern\" die Stipendien entziehen.","Stipendium","","","Katharina Saar, Berlin 37",[11],1,[6],[3],2,"16","2"],["33","1966-12-16","Bericht über Sitzung im Abgeordnetenhaus mit Äußerungen von Peter Lorenz und Werner Stein.","Krawalle waren \"politisches Rowdytum\"","","","vd",[1],4,[1],[2],2,"26","11"],["34","1966-12-17","Vorabbericht über die für diesen Tag zu erwartenden erneuten Demonstrationsversuche von Studenten auf dem Kudamm - bekannt geworden per Flugblatt, zitiert wird auch Flugblatt: eine offene Attacke gegen die \"Springer-Schreiber\". Die Demonstranten werden als Mao-gelbsüchtige Studiker bezeichnet. Dazu eine Karikatur.","Studenten wollen wieder Krawall","","Mach Dir ein paar schöne Stunden auf der Straße...","Lutz Horst",[1],2,[1,5,4],[1],1,"8","3"],["35","1966-12-17","Scharfe Angriffe gegen Studenten","Freiheit mit Füßen","","","Oswald Thronicker, Berlin 46",[11],1,[6],[3],2,"14","2"],["36","1966-12-17","Verteidigt die Studenten gegen den Leserbrief von W. Sch. aus der Berliner Morgenpost vom 14.12.1966. ","Gegen den Krieg in Vietnam","","","Kurt Kaufmann, Berlin 42",[11],1,[6],[3],2,"14","2"],["37","1966-12-17","Theatergutscheine für TU-Studenten werden gekürzt, weil sie nicht vollständig abgerufen wurden, hoffen auf Gutschrift für 1967.","Gutscheine für Studenten gekürzt","","","Eigener Bericht",[11],1,[1],[2],2,"14","5"],["38","1966-12-17","Bericht über Fragestunde im Konvent der FU, Nevermann stellt die Forderung auf Kennzeichnungspflicht der Polizisten wegen der Ereignisse am Rande der Tumulte am 10.12.1966.","Dienstnummer auf Polizei-Uniform?","","Forderung des AStA-Vorsitzenden an der FU","bp",[1],4,[1],[5],2,"48","11"],["39","1966-12-17","Nachricht über Kritik der CDU an SDS-Plan","CDU nennt SDS-Demonstration eine Herausforderung","","","dpa",[1],8,[1],[2],2,"16","2"],["40","1966-12-18","Demonstranten haben erneut während des Haupteinkaufstrubels ohne Erlaubnis in der Innenstadt demonstriert; ein Senatssprecher: \"Berlin lässt sich nicht auf der Nase herumtanzen\".","Studenten-Tumulte","","","Eigener Bericht",[1],1,[1],[2],2,"44","1"],["41","1966-12-18","Bei nicht-genehmigten Demonstrationen haben meist linksgerichtete Studenten nach dem Beispiel der Amsterdamer \"Provos\" demonstriert, den Verkehr behindert und Passanten angepöbelt.","Die Polizei ließ nicht mit sich spaßen","","Wieder Studentenkrawalle - 86 Festnahmen","Go.",[1],1,[1],[2],1,"44","5"],["42","1966-12-18","Bericht über die erneuten Demonstrationen, Passanten werden zitiert: \"Ihr solltet besser arbeiten\" oder \"Geht doch nach Ost-Berlin und demonstriert für die Freiheit\".","In der Tat: Narren","","Wieder Krawalle auf dem Kudamm","EB",[1],9,[1],[3],2,"32","1"],["43","1966-12-18","Bericht über die Ereignisse am 17.12.1966 (sogenannte Spaziergangsdemonstration), Senatssprecher wird zitiert mit den Worten: \"Berlin braucht keine Provos. Berlin lässt sich nicht auf der Nase herumtanzen, schon gar nicht von Leuten, die sich Studenten nennen.\"","Krawalle am Kurfürstendamm","","86 Festnahmen bei Demonstration von SDS-Anhängern gegen die Polizei","Eigener Bericht",[1],8,[1],[3],2,"36","1"],["44","1966-12-18","Bericht über die Ereignisse am 17.12.1966 (sogenannte Spaziergangsdemonstration), Senatssprecher wird zitiert mit den Worten: \"Berlin braucht keine Provos. Berlin lässt sich nicht auf der Nase herumtanzen, schon gar nicht von Leuten, die sich Studenten nennen.\"","Empörte Passanten riefen: Geht doch nach Ostberlin!","","Auch am Sonnabend wieder Krawalle mit Studenten-Rowdys ? 80 festgenommen","Wolfgang Voss",[1],5,[1],[1],1,"34","29"],["45","1966-12-18","Nachricht über die erneuten Demonstrationen während des Adventssamstags.","Wieder Krawalle auf dem Kurfürstendamm","","","Eigener Bericht",[1],5,[1],[2],2,"34","1"],["46","1966-12-19","Bericht über die Ausschreitungen auf dem Kudamm, 200 SDS-Anhänger begannen um 15.15 Uhr \"sonnabendliche Kinderei\", die Polizei habe schnell und konsequent durchgegriffen, ohne den Knüppel zu benutzen.","Freifahrt in Grüner Minna für 86 Krawallstudenten","","","Peter Behrendt",[1],2,[7],[5],1,"10","2"],["47","1966-12-19","Kritischer Bericht über die Ereignisse auf dem Kudamm am 17.12.1966. Die richtigen Mittel, um die Drahtzieher und Akteure in Schach zu halten, seien noch nicht gefunden. Albertz wird zitiert, dass die Regeln der Demokratie nicht dem internationalen Boxreglement entlehnt sind.","Bisher kein richtiges Mittel gegen studentische Krawalle","86 Festnahmen am Sonnabend","Senatssprecher: \"Berlin braucht keine Provos\"","gve",[1],4,[1],[1],2,"18","11"],["48","1966-12-20","Nachricht, dass der Landesvorstand der SPD eine Bestrafung der Randalierer verlangt.","Bestraft die Randalierer!","","","rb",[1],2,[1],[2],2,"8","3"],["49","1966-12-20","Albertz kündigt an, mit den Rektoren von FU und TU über die Studenten zu reden; SPD-Vorstand missbilligte scharf das Verhalten der Randalierer gegen die Bevölkerung, Kritik am Neuen Deutschland, dass das Vorgehen der Polizei als \"Demokratie des Knüppels\" bezeichnet hatte.","SPD will Krawalle unterbinden","","","Eigener Bericht",[1],1,[1],[2],2,"14","1"],["50","1966-12-20","Bericht über Reaktion der Berliner SPD und Albertz auf die Ereignisse (sogenannten Spaziergangsdemonstration) am vorigen Samstag.","Albertz will mit Rektor und AStA sprechen","","","Eigener Bericht",[11],4,[1],[2],2,"18","11"],["51","1966-12-20","Bericht über die Sitzung des SPD-Landesvorstandes.","Albertz will eingreifen","Studentenkrawalle am Kurfürstendamm","","Eigener Bericht",[1],9,[1],[5],2,"12","2"],["52","1966-12-21","Kritik an einer Entschuldigung von Albertz an einem bei den Tumulten auf dem Kudamm festgenommenen Journalisten, der aber keine Anzeige gestellt hat. Es gibt keine Untersuchung, aber die vorauseilende Entschuldigung des Regierenden Bürgermeisters. ","Zu einem Brief von Albertz","","","Jo.",[1],1,[5],[5],2,"14","2"],["53","1966-12-21","Großer Text über Dutschke, der erste in der BZ und überhaupt der erste größere in einem Blatt des Axel Springer Verlages. Dutschke sehe aus wie der leibhaftige Bürgerschreck.","Dutschke dreht an einem dollen Ding...","Der Führer der Berliner ,Provos' verteidigte das Treiben der ,Roten Garden'","","Udo Bergdoll",[1,2],6,[7],[1],1,"24","2"],["54","1966-12-21","Kommentar über die jüngsten Demonstrationen/ Studentenunruhen in West-Berlin. Die Demonstranten werden teils scharf kritisiert und als \"Radikalinskis\" bezeichnet, auf deren Wogen auch die SED gern mitschwimmt. Zugleich wird aber auch die Polizei kritisiert, die falsch reagiert habe bzw. den Demonstranten nicht so massiv gegenübertreten hätte sollen.","Kudamm 66","","","k.m.",[1],9,[5],[2],2,"12","2"],["55","1966-12-22","Das Oberverwaltungsgericht entscheidet gegen die FU: Ein eingetragenes Mitglied der West-Berliner SED darf nicht aus der Universität verwiesen werden. ","FU-Studium auch für SED-Mitglieder","","","Eigener Bericht",[11],1,[1],[2],2,"14","2"],["56","1966-12-22","Bericht über OVG-Entscheidung, dass SED-Mitglieder nicht von der FU ausgeschlossen werden dürfen.","FU-Studium auch für SED-Mitglieder","","Oberverwaltungsgericht entschied: Ausschluss ist rechtswidrig","wt",[11],4,[1],[2],2,"18","9"],["57","1966-12-23","BZ fragt bei Nevermann an, was er von Albertz bei einem angekündigten Gespräch verlangen werde: Kennzeichnung der Beamten, Ermittlungsverfahren gegen Polizisten, Einstellung von Verfahren gegen Demonstranten.","FU-Gespräch bei Albertz","","","Eigener Bericht",[1],6,[1],[2],2,"28","2"],["58","1966-12-24","Albertz spricht mit FU-Rektor und AStA-Vorsitzendem Nevermann über seine Sorgen wegen der Entwicklung an der FU.","Albertz über FU besorgt","","","Eigener Bericht",[11],1,[1],[2],2,"10","1"],["59","1966-12-30","Bericht über Albertz' Versuch, die Studentenunruhen an der FU zu schlichten.","Albertz will an der Freien Universität schlichten","","","Eigener Bericht",[11],4,[1],[2],2,"20","11"],["60","1967-01-01","Leserbrief, der Bezug nimmt auf eine verständnisvolle Leseräußerung; kritisiert die prokommunistischen Studenten, stellt aber klar, dass Demonstrationen gegen Vietnamkrieg im Prinzip in Ordnung sind. ","\"Friedensdemonstrationen\"","","","Kurt Berkner, Berlin 22",[1],1,[6],[2],2,"44","2"],["61","1967-01-04","Kurzer Bericht über Sperrzone in der City West; Grund: die Tumulte auf dem Kudamm.","Demonstration in der City verboten","","","Eigener Bericht",[1],1,[1],[3],2,"12","3"],["62","1967-01-04","Fünf zentrale Fragen zur Studienreform an neun Fachleute, u.a. zur Finanzierung, Zahl der Dozenten, Studienzeit.","Kommt der totale Numerus clausus?","Damoklesschwert über den deutschen Studenten","Fünf Fragen an Minister, Abgeordnete, den Wissenschaftsrat und die Rektorenkonferenz","Eigener Bericht",[4],4,[1],[4],1,"18","7"],["63","1967-01-06","Nachricht über einen Protest des VDS und des AStA gegen das Demoverbot für die City.","Einen scharfen Protest...","","","Eigener Bericht",[1],4,[1],[2],2,"9","9"],["64","1967-01-07","Scharfe Kritik an den linksradikalen Studenten.","Links vom Geist","","","Matthias Walden",[1],4,[5],[5],2,"52","I"],["65","1967-01-08","Bericht über Pläne von PH-Studenten, aus Protest gegen die Bildungspolitik in einen Streik zu treten. Der Streik sei jedoch nicht gegen die Lehrkräfte gerichtet.","PH-Studenten wollen in den Streik treten","","","Eigener Bericht",[4],1,[1],[2],2,"48","3"],["66","1967-01-08","16 inzwischen prominente Gründungsmitglieder der FU von 1948 veröffentlichen Beitrag in FU-Blatt und teilen mit, dass die Tagespolitik in FU-Gremien keinen Platz hätte.","FU-Gründer weisen AStA in die Schranken","","\"Kein Mandat für politische Stellungnahme\"","Eigener Bericht",[11],1,[1],[5],1,"48","1"],["67","1967-01-08","Albertz wird zitiert: kein allgemeinpolitisches Mandat des SDS.","Albertz mahnt die Studenten","","","AP",[1],9,[1],[2],2,"32","2"],["68","1967-01-08","Bericht über die Intervention der FU-Gründer gegen ein politisches Mandat.","Gründungsstudenten sprechen dem AStA ein politisches Mandat ab","","Stellungnahme an den Rektor der FU übergeben","Eigener Bericht",[11],8,[1],[1],2,"38","2"],["69","1967-01-08","Albertz spricht dem AStA ein politisches Mandat ab und kritisiert die jüngsten Studentenunruhen, das Verständnis der Berliner habe Grenzen, man erwarte von den Studenten, dass sie sich an die demokratischen Gepflogenheiten halten.","Albertz an Studenten: Verständnis hat Grenzen","","","lbn",[4],5,[1],[2],2,"30","25"],["70","1967-01-08","Der AStA der Pädagogischen Hochschule Berlin ruft zu einem Vorlesungsstreik gegen die \"konzeptionslose Bildungspolitik\" auf. Der Streik richte sich explizit nicht gegen die Lehrkräfte.","PH: Vorlesungsstreik","","","lbn",[11],5,[1],[2],2,"30","25"],["71","1967-01-09","Scharfer Kommentar gegen die linksradikalen Studenten, gefordert werden \"Schluss mit Provo-Manier\" und \"Roten Garden\" in Berlin! Manche Politiker verlangen nach einer Generalinventur der Studenten. Aber: das hieße, das Kind mit dem Bade auszuschütten! Aufrührer sollten aus der Uni verwiesen werden, aber wichtig ist jetzt, eine souveräne Haltung an den Tag zu legen und nicht überzureagieren. Dazu eine Karikatur, die die demonstrierenden Studenten als Anhänger des Kommunismus darstellt.","Der \"große Hammer\" wäre falsch","BZ meint","","Eigener Bericht, Karikatur: kay",[1],6,[5,4],[1],1,"28","2"],["72","1967-01-09","Bericht über die Intervention der FU-Gründer gegen ein politisches Mandat.","\"Universität kein Forum für die Tagespolitik\"","","","Co",[1],4,[1],[2],2,"16","1"],["73","1967-01-09","Bericht über den Aufruf der PH, gegen Studiengebühren zu streiken. Albertz kündigt an, dass der Senat sich äußern wird.","AStA der PH ruft zum Vorlesungsstreik auf","","","Eigener Bericht",[4],4,[1],[2],2,"16","9"],["74","1967-01-09","Dokumentation der Erklärung der 16 Mitbegründer der FU: gegen allgemeinpolitisches Mandat.","Gründer der Freien Universität erinnern an die Satzung","","Auch die politische Betätigung der Studentenvertretungen muss einer Stätte für Lehre und Forschung entsprechen","Eigener Bericht",[1],4,[1],[3],2,"16","9"],["75","1967-01-10","Feierstunde zu 20 Jahren PH fällt aus, weil der Senator nicht kommt / Grund: Streik gegen Bildungspolitik.","Feierstunde fällt aus","","","Eigener Bericht",[4],1,[1],[2],2,"12","1,5"],["76","1967-01-10","Das politische Mandat des AStA bzw. der Studentenschaft geht weiter als die FU-Gründer meinen, aber nicht so weit, wie die gegenwärtigen Studenten glauben.","Mit rhetorischen Aktionen ist der heutigen Studentenschaft nicht gedient","","Ehemalige AStA-Vorsitzende antworten auf die Erklärung der FU-Gründer","Eigener Bericht",[1],4,[1],[3],2,"18","11"],["77","1967-01-11","Studenten der Pädagogischen Hochschule Berlins traten aus Protest gegen die Bildungspolitik und die Einführung einer Studiengebühr in einen Vorlesungsstreik. ","Studenten der Pädagogischen Hochschule streiken","","","hb",[4],2,[1],[5],1,"8","2"],["78","1967-01-11","Leitartikel über die Situation bei den Berliner Studenten, aus Anlass der Senatserklärung und des PH-Streiks. Bemüht sich um Differenzierung, kritisiert die \"Radikalinskis\" scharf.","Die Studenten rumoren weiter","","","wbr",[11],1,[5],[5],2,"10","2"],["79","1967-01-11","Bericht über Vollversammlung an der PH.","PH-Studenten beschlossen, keine Gebühren zu bezahlen","","Ihr Argument: Bald fehlen in Berlin Grundschullehrer","Go.",[11],1,[1],[1],1,"10","5"],["80","1967-01-11","Karikatur, die einen bärtigen Studenten zeigt, der grinsend über ein Beet namens FU läuft.","Ein Student ging vorbei","","","Oskar",[11],1,[5,4],[2],1,"10","2"],["81","1967-01-11","Stellungnahme des Senates zu Unruhen; Aufforderung an Studenten und Lehrende, sich zu mäßigen, gegen Störenfriede sei vorzugehen, ehemalige AStA-Vorsitzende bestehen auf grundsätzlicher Zulässigkeit des politischen Mandates (u.a. Lummer, Wohlrabe). Eine Zwischenzeile lautet: \"Störenfriede ausmerzen\".","Appell des Senates an die Vernunft der FU-Studenten","","Minderheit bringt die Universität in Verruf","Eigener Bericht",[11],1,[1],[1],2,"10","1"],["82","1967-01-11","Bericht über Erklärung des Senates, über den Streik an der PH und die von der CDU beantragte Aktuelle Stunde.","2000 Studenten der PH streiken","","Senat verurteilt die FU-Krawalle","Eigener Bericht",[4],6,[1],[3],2,"26","2"],["83","1967-01-11","Bericht über die Stellungnahme des Senates / wiederholte Zwischenfälle hätten Haltung des Abgeordnetenhauses sehr verändert.","Senat verurteilt radikale Minderheit","","Konstruktive Zusammenarbeit an der FU gefordert","v. C.",[1],4,[1],[3],2,"18","1"],["84","1967-01-11","Längerer Bericht über PH-Versammlung, ihre Gespräche mit Verantwortlichen und ihre Ziele.","Streikende PH-Studenten erwägen sogar einen Zahlungsboykott","","Bewegte Protestversammlung gegen die Studiengebühr","eb",[4],4,[1],[5],2,"18","11"],["85","1967-01-11","Dokumentation der Erklärung des Berliner Senates zu den Vorgängen an der FU.","Dem Ansehen der Freien Universität geschadet","","Beleidigende Handlungen gegenüber dem Rektor vom Senat verurteilt","Eigener Bericht",[1],4,[1],[3],2,"18","11"],["86","1967-01-11","Leitartikel, der sich um Differenzierung bemüht. Die Mittel der streikenden Studenten der Pädagogischen Hochschule wie Obstruktion und Zahlungsboykott seien kontraproduktiv. Zusammenarbeit sei gefordert. Auch habe niemand etwas gegen Proteste, wenn sie sachlich begründet sind. Blockaden von Instituten, die der Allgemeinheit dienen, nützen jedoch nicht.","Studenten streiken","","","w.g.o.",[4],9,[5],[5],2,"12","2"],["87","1967-01-11","Bericht über die Erklärung des Senates zu den Tumulten auf dem Kudamm.","Appell an die FU und ihre Studenten","","Senat erklärt: Ereignisse haben dem Ansehen der FU geschadet","Eigener Bericht",[4],8,[1],[2],2,"10","1,2"],["88","1967-01-11","Kritischer Kommentar, der die Anti-Vietnamkriegs-Aktionen von FU-Studenten vergleicht mit dem Vorlesungsstreik der PH-Studenten. Das seien sehr unterschiedliche Dinge. Während erstere das Ansehen der Universität schädigen und zu Recht bei Bürgern für Unbehagen sorgen, tun letztere etwas durchaus Nachvollziehbares.","Studenten und Staat","","","E.W. ",[4],8,[5],[2],2,"10","1"],["89","1967-01-11","Bericht über die Vorgänge an der PH.","Zweitägiger Vorlesungsstreik an der PH Berlin","","Für bereits immatrikulierte PH-Studenten auch künftig keine Studiengebühren","Eigener Bericht",[4],8,[1],[2],2,"10","2"],["90","1967-01-13","Bericht über Aktuelle Stunde des Abgeordnetenhauses, Zitate von Albertz und anderen, aber zugleich folgende Passage: \"Aber alle Parlamentarier waren sich einig: man soll das Kind nicht mit dem Bade ausschütten und etwa das berühmte Berliner Modell, die Selbstverwaltung der Universitäten, zerstören. Wohl aber soll das Gros der Studenten dafür sorgen, dass die Unruhestifter kalt gestellt werden. Wer organisierte Anarchie betreibe, müsse damit rechen, dass ihm die Staatsautorität entgegen gestellt werde.","Studenten pöbeln gegen Bürgermeister","","Zeitschrift mit Beleidigungen an Abgeordnete verteilt","L.H.",[1],2,[1],[1],2,"10","2"],["91","1967-01-12","Senat der PH tritt aus Protest gegen neues PH-Gesetz geschlossen zurück.","Senat der PH zurück getreten","","","eigener Bericht / AP",[4],1,[1],[2],2,"12","1"],["92","1967-01-12","Bericht über den Streik der PH-Studenten gegen Studiengebühren und mehrere Rücktritte und Absagen von Professoren wegen des PH-Gesetzes.","Studenten der PH setzen ihren Streik heute fort","","Sie feiern den Gründungstag alleine","Eigener Bericht",[11],1,[1],[1],2,"12","5"],["93","1967-01-12","Appell des Akademischen Senates, der zugleich die Studenten in Schutz nimmt.","Akademischer Senat für freien Meinungsaustausch","","","VD",[11],4,[1],[3],2,"16","1"],["94","1967-01-12","Bericht über Gespräch des PH-Rektors mit streikenden Studenten / Bevölkerung nicht provozieren.","Unruhe sollte gezielter gestaltet werden","","Studenten diskutierten mit ihrem Rektor über die Gebühren","wt",[4],4,[1],[5],2,"16","10"],["95","1967-01-12","Dokumentation des Appell des Akademischen Senates: Einzelne Studenten und Gruppen missverstehen die akademische Freiheit / gegen unberechtigte Angriffe nimmt der Senat die Studenten in Schutz.","Nicht repräsentativ für die Studenten","","Beschwörender Appell des Akademischen Senates der FU","Eigener Bericht",[11],4,[1],[2],2,"16","9"],["96","1967-01-12","Bericht über die Kritik des Akademischen Senates am SDS.","Warnung des Akademischen Senates an den SDS","","","Eigener Bericht",[11],8,[1],[2],2,"12","2"],["97","1967-01-13","Größerer Text über geplante Demo gegen Bildungspolitik; PH-Rektor wird zitiert, dass er dem SDS die Zulassung entziehen will; kurze Erwähnung, dass am 11.1.1967 an der FU tumultartige Szenen im FU-Audimax stattgefunden hätten nach einem Film über die \"Roten Garden\" in China.","Studenten wollen auf die Straße gehen","","Vertreter der Hochschulen sind sich einig","J. M. ",[11],1,[1],[1],2,"14","3"],["98","1967-01-13","Bericht über Debatte im Abgeordnetenhaus; Redner aller drei Parteien sprechen sich gegen radikale Studenten aus, aktuelle Stunde auf Antrag der CDU, Albertz zitiert aus FU-Spiegel und überlegt, Zuwendungen zu streichen.","Parlament verurteilt radikale Studenten","keine ","Theuner verteidigt Berlins Polizei","Eigener Bericht",[11],1,[1],[5],1,"14","6"],["99","1967-01-13","Leserbrief über den Appell des Senates, Kritik an Senatsplänen für Veränderung der Rückmeldegebühr, die nicht zu Verbesserungen für Studenten führe.","Appell an die Vernunft","","","Jürgen Geisler, Berlin 41",[11],1,[6],[3],2,"14","2"],["100","1967-01-13","Bericht über die Aktuelle Stunde im Abgeordnetenhaus, Albertz zitiert aus FU-Spiegel und findet bei allen Parteien Empörung über solche Ausfälle, Senator Stein ruft Studentenschaft auf, sich versöhnlich zu zeigen.","Empörung im Parlament","","Debatte über Studenten-Krawalle und \"FU-Spiegel\"","Eigener Bericht",[4],6,[1],[3],2,"32","2"],["101","1967-01-13","Der Akademische Senat der FU Berlin hat dem SDS angedroht, ein Verfahren zum Widerruf der Anerkennung des SDS als studentische Vereinigung einzuleiten. Bisher sei dies noch nicht eingeleitet worden, weil der SDS sich bisher von den Aktionen seiner Mitglieder distanziert habe. Die drei Fraktionen des Berliner Abgeordnetenhauses haben die FU-Studenten davor gewarnt, sich weiter von den \"organisierten Minderheitengruppen terrorisieren zu lassen\".","Senat der Berliner FU droht SDS mit Ausschluss","","","Eigener Bericht",[1],4,[1],[2],2,"18","6"],["102","1967-01-13","Studentische Jubiläumsfeier zum 20-jährigen Bestand der Pädagogischen Hochschule Berlins. Dabeu wurde erneut die Bildungspolitik des Senats kritisiert.","Beim Jubiläum unter sich","","Auditorium maximum der PH von 800 Kommilitonen besucht","Eigener Bericht",[4],4,[1],[2],2,"18","11"],["103","1967-01-13","Bericht über die Aktuelle Stunde im Abgeordnetenhaus, Albertz zitiert aus FU-Spiegel und findet bei allen Parteien Empörung über solche Ausfälle, Senator Stein ruft Studentenschaft auf, sich versöhnlich zu zeigen.","Das große Lottoglück des Herrn Direktors","","Erregte Plenumsdebatten über FU-Studenten und Abfindungen","Eigener Bericht",[1],4,[1],[1],2,"18","11"],["104","1967-01-13","Bericht über die Fragestunde des Berliner Abgeordnetenhauses zu den jüngsten Ereignissen an der Pädagogischen Hochschule Berlins.","Auch Fragestunde im Zeichen der akademischen Jugend","","","Eigener Bericht",[1],4,[1],[5],2,"18","11"],["105","1967-01-13","Bericht über Aktuelle Stunde des Abgeordnetenhauses.","Abgeordnetenhaus diskutierte FU-Vorgänge","","Albertz kündigte weitere Gespräche mit den Universitäten an. Warnung vor Verallgemeinerung.","Eigener Bericht",[11],8,[1],[1],2,"14","9"],["106","1967-01-14","Nachricht über die Wahl von Wolfgang Lefèvre.","FU-Konvent wählte seinen Präsidenten","","","Eigener Bericht",[11],1,[1],[2],2,"12","3"],["107","1967-01-14","Reaktion verschiedener Professoren auf Matthias Waldens scharfen Gastkommentar und die darin gegen das Otto-Suhr-Institut erhobenen Vorwürfe. Löwenthal sagt, es handele sich um nur wenige Studenten, die aber so allergisch gegen antikommunistische Phrasen seien, dass sie das Kind mit dem Bade ausschütteten. Schuld seien daran auch frühere FU-Leitungen, die sehr intolerant gewesen seien.","\"Skepsis gegen den Staat geht zu weit\"","Freie Universität","Professor Löwenthal nimmt zu den Studentenkrawallen Stellung","VD",[1],4,[1],[2],2,"56","4"],["108","1967-01-14","Bericht über die Forderung des VDS, trotz Verbot in der City demonstrieren zu dürfen.","VDS beharrt auf City-Demonstration","","Vorschlag der Polizei abgelehnt","Eigener Bericht",[1],4,[1],[2],2,"56","11"],["109","1967-01-15","Leserbrief über PH-Streit und \"Radikalinskis\".","Merkwürdige studentische Freiheit","","","H. ST., Berlin 61",[11],1,[6],[3],2,"54","2"],["110","1967-01-15","Bericht über Gespräche zur Regelung des Demonstrationszuges gegen die Bildungspolitik des Senates, Studenten verlangen Route durch die City, Senat lehnt das wegen des Weihnachtsmonats Dezember ab.","Studenten wollen mit der Polizei verhandeln","","Ersatzroute für Demonstrationszug abgelehnt","Eigener Bericht",[11],1,[1],[3],2,"54","3"],["111","1967-01-15","Notiz, dass der VDS-Berlin mit dem Polizeipräsidenten verhandeln will.","VDS will mit der Polizei verhandeln","","","Eigener Bericht",[11],5,[1],[2],2,"32","1"],["112","1967-01-17","Drei Leserbriefe zu Waldens Kommentar \"Links vom Geist\" vom 7.01.1967 in der \"Welt\", zwei zustimmend, einer scharf ablehnend.","Berliner Studenten \"links vom Geist\"","Aus Briefen an die Redaktion","","mehrere",[1],4,[6],[5],2,"16","11"],["113","1967-01-19","Kritischer Bericht über die Sperrung des AStA-Zuschusses.","Keine Unterlagen! Zuschuss von 160.000 Mark gesperrt","FU-Kuratorium prüfte den Studentenhaushalt 1967","","Lutz Horst",[11],2,[1,5],[1],2,"10","2"],["114","1967-01-19","FU-Kuratorium unter Heinrich Albertz sperrt 160.000 DM; Grund: Keine Unterlagen zum Haushalt.","FU sperrt Studenten Zuschuss","","","Eigener Bericht",[11],1,[1],[2],2,"14","1"],["115","1967-01-19","Bericht über die Kuratoriumssitzung der FU. Festgehalten wird, dass der AStA dadurch in seiner Arbeit nicht behindert werde. Protestkundgebung genehmigt.","Den Geldhahn zugedreht","","Kuratorium sperrte vorläufig FU-Zuschuss","Go",[11],1,[1],[1],1,"14","5"],["116","1967-01-19","Bericht über die Kuratoriumssitzung an der FU und die Sperre der AStA-Mittel.","FU: 160500 Mark gesperrt","","","Eigener Bericht",[11],6,[1],[3],2,"24","2"],["117","1967-01-19","Das Kuratorium der FU Berlin hat den vorgesehenen Zuschuß für die Studentenvertretung vorläufig gesperrt, da diese ihrer Haushaltsunterlagen nicht eingereicht hatte.","FU-Kuratorium hält Zuschuss für AStA zurück","","","VD",[11],4,[1],[2],2,"18","1"],["118","1967-01-19","Ausführlicher Bericht über die Sperrung der 160.500 DM.","Zuschuss 1967 für AStA vom FU-Kuratorium gesperrt","Wegen fehlender Unterlagen","Rechnungshof überprüft den vorherigen Haushalt","eb",[11],4,[1],[2],2,"18","11"],["119","1967-01-20","Brief des Polizeipräsidenten an den VDS mit Erläuterungen zur genehmigten Demo in der TU, kündigt an, nicht genehmigte Demos würden mit allen Mitteln unterbunden.","Protest muss \"in Grenzen\" bleiben","","","L.H.",[1],2,[1],[2],2,"10","2"],["120","1967-01-20","Probleme zwischen Universität und Demokratie bedürfen der Durchleuchtung, sagt FU-Rektor Lieber.","Lieber: Probleme der Universität überprüfen","","","hws",[1],4,[1],[2],2,"18","3"],["121","1967-01-21","Leserbrief fragt, warum die verschwindend \"kleine Gruppe\" linksradikaler Studenten eine Mehrheit für ihren Kandidaten erzielt, der schon 1965 gestürzt worden war.","Kleine Gruppe erzielte Mehrheit","","","H. Scholz, Berlin 21",[11],1,[6],[2],2,"12","2"],["122","1967-01-22","AStA weist die Erklärung des Kuratoriums über die Gründe für die Sperre des Etats zurück und erkennt ausschließlich politische Gründe.","AStA der FU: Politische Gründe","","","Eigener Bericht",[11],1,[1],[2],2,"48","1"],["123","1967-01-23","Kurzmeldung über den Protest des AStA gegen die Haushaltssperre inkl. Zitat \"Das ist der Versuch, eine politische Disziplinierung der Studentenschaft zu erreichen.\"","Studenten-Protest","","","Eigener Bericht",[11],2,[1],[2],2,"12","2"],["124","1967-10-23","Schilderung des Ablaufs der Demo. Mutmaßung der Gefolgschaftsverweigerung für Dutschke.","Wichtig war, was nicht geschah!","BZ meint","","",[1],6,[5],[1],1,"40","2"],["125","1967-01-23","Bericht über die Lautsprecheransagen des Oberkommissars Textor bei einer Demonstration. Dieser habe mit seinen witzigen Durchsagen eine gefährliche Lage entkrampft. Dazu eine Karikatur.","Am Mikrofon: Polizist Nr. 79444","Randalierern die Schau gestohlen","","L.R.",[1],6,[7,5,4],[1],1,"40","3"],["126","1967-01-23","Bericht über die Universitätstage der FU Berlin 1967. Im Zentrum stand die Frage, wie politisch die Hochschule sein soll und wieviel Mitbestimmung die Studenten erhalten sollen. Hochkarätige Tagung mit Fraenkel, Haermas etc.","Universität zwischen Leidenschaft und Kühle","Berlin","Hochschulpolitische Fragen der FU standen im Mittelpunkt einer Tagung","Hans-Werner Sternsdorff",[1],4,[1],[3],2,"18","4"],["127","1967-01-23","Auszüge aus der Erklärung des AStA zu den gesperrten 160.500 DM.","Protest gegen Sperrung der Zuschüsse","","AStA der FU: Versuch der politischen Einflussnahme","Eigener Bericht",[11],4,[1],[2],2,"9","9"],["128","1967-01-24","Ankündigung der Versammlung in der TU gegen Studiengebühren.","Die Studenten protestieren","","","Eigener Bericht",[1],6,[1],[2],2,"24","2"],["129","1967-01-24","Gespräch mit Senatsrat Prill, der das Demoverbot mit verkehrstechnischen Gründen verteidigt.","\"Ein unpolitisches Verbot\"","Polizei zur nichtgenehmigten VDS-Demonstration","","pf",[1],9,[1],[2],2,"12","2"],["130","1967-01-25","Bericht über Versammlung gegen Studiengebühren in der TU.","Protest nur im Saal","","Studentendiskussion diesmal ohne Krawall","MM",[11],1,[1],[5],1,"10","3"],["131","1967-01-25","Karikatur","Protestieren ... geht über Studieren.","","","Stenzel",[11],1,[5,4],[3],1,"10","3"],["132","1967-01-25","Bericht über die Versammlung in der TU Berlin gegen Studiengebühren.","Demonstration in der TU","","","Eigener Bericht",[1],6,[1],[2],2,"24","3"],["133","1967-01-25","Ausführlicher Bericht von der Versammlung in der TU. Der Verlauf wird im Detail geschildert, die Entstehung der Unruhe nachgezeichnet und beschrieben, wie u.a. Nevermann das Ganze unter Kontrolle gebracht hat. Ansonsten hätte es wohl Auseinandersetzungen gegeben, sagt der Autor.","Tausend Studenten forderten die Beachtung der Grundrechte","Spannungsgeladene Protestversammlung","Besonnenheit setzte sich schließlich durch","hws",[11],4,[1],[1],2,"20","11"],["134","1967-01-25","Kritischer Leserbrief zu den Studentenprotesten: enttäuschte Erwartungen an die akademische Jugend, man rempelt mit der Polizei und beschwert sich dann lautsark gegen Freiheitsberaubung.","Unbehagen über die Studenten","","","Marlene Rieger, Berlin 13",[1],4,[6],[2],2,"20","12"],["135","1967-01-25","Bericht über kleinere Demonstration gegen den neuen Bundeskanzler.","Berliner Jugendliche demonstrieren gegen Kiesinger","","","Eigener Bericht",[1],8,[1],[2],2,"12","1"],["136","1967-01-27","Bericht über die Hausdurchsuchung beim SDS, bei der u. a. die Mitgliederkartei beschlagnahmt wurde. Hintergrund der Durchsuchung war ein Flugblatt, in dem von \"professoralen Fachidioten\" die Rede war, weswegen einige Professoren Strafantrag gestellt hatten.","Berlin: Haussuchung bei den Sozialistischen Studenten","","","hb/ kh",[8],2,[1],[5],2,"12","1"],["137","1967-01-27","Durchsuchung beim SDS am Kudamm 140, Hintergrund: Anzeige wegen Beleidigung durch vier ehemalige FU-Rektoren, Karteikästen und weiteres Material beschlagnahmt.","Polizei im Büro des SDS","","Kartei beschlagnahmt - Rote Nelken für die Kripo","K. G. ",[8],1,[1],[5],2,"14","1"],["138","1967-01-27","Differenzierter Kommentar über die Hausdurchsuchung beim SDS. Einerseits ist die Rede von dem \"unmöglich gewordenen Verhalten linksradikaler Studenten\", und auch die Suche nach den Verfassern des sogenannten \"Fachidiotenflugblattes\" sei legitim. Andererseits stelle sich die Frage, warum die Politische Polizei diese Hausdurchsuchung vornehmen musste. Und auch die beschlagnahmte Mitgliederkartei dürfe nur von zuständigen Richtern durchgesehen werden, bzw. diese müsse unverzüglich zurückgegeben werden, wenn sich dadurch keine Hinweise auf die Verfasser des Flugblattes ergeben.","Mitgliederkartei beschlagnahmt","Polizei machte Haussuchung in SDS-Zentrale","","Peter Borowsky",[8],6,[1],[1],1,"24","2"],["140","1967-01-27","Langer Bericht über die Durchsuchung, Mahler und Nevermann werden ausführlich zitiert, ebenso Protesterklärung des SDS und Erklärung der Fachschaftsinitiative des Otto-Suhr-Instituts.","Politische Polizei unternahm vierstündige Razzia beim SDS","Mitgliederkartei beschlagnahmt","Amtsgericht hatte Durchsuchung zuvor abgelehnt","Klaus Haetzel",[8],4,[1],[2],2,"20","13"],["141","1967-01-27","Bericht über die Hausdurchsuchung beim SDS, bei der u. a. die Mitgliederkartei beschlagnahmt wurde. Hintergrund der Durchsuchung war ein Flugblatt, in dem von \"professoralen Fachidioten\" die Rede war, weswegen einige Professoren Strafantrag gestellt hatten.","Beschlagnahme-Aktion beim SDS","","Protest gegen Sicherstellung der Mitgliederkartei. Zusammenhang mit beleidigendem Flugblatt gegen Professoren","Eigener Bericht",[8],8,[1],[3],2,"16","1,2"],["142","1967-01-28","Bericht über die bevorstehenden Proteste gegen die Hausdurchsuchung beim SDS, Mahler wird zitiert, Gollwitzer äußert sich gegen die Durchsuchung.","Wieder auf die Straße","Studenten wollen gegen Haussuchung protestieren","","Hella Boschmann",[8],2,[1],[2],2,"10","3"],["143","1967-01-28","Proteste gegen die Razzia","Studenten protestieren gegen Polizeirazzia","","","Klaus Haetzel",[8],4,[1],[2],2,"54","1"],["144","1967-01-28","Ausführliche Darstellung der Proteste gegen die Durchsuchung, Gollwitzer wird ausführlich zitiert, Nevermann und Mahler mit einzelnen Aussagen","Professor Gollwitzer: \"Polizeiaktion traf die Universitäten in ihrem Nerv\"","","Studentendemonstrationen für heute angekündigt - Solidaritätsbeweise aus Westdeutschland - FDP richtet Anfrage an den Senat","Haetzel / ska",[8],4,[1],[3],2,"54","9"],["145","1967-01-28","Beisteller zum Fuß mit Albertz und Hirsch-Zitaten.","Albertz zur Aussprache bereit. Hirsch lehnt Rechtfertigung ab","","","Eigener Bericht",[8],4,[1],[2],2,"54","9"],["146","1967-01-28","Notiz über Roman Herzogs Antrittsvorlesung.","Herzog gegen Ausweitung polizeilicher Generalklauseln","","","Eigener Bericht",[8],4,[1],[2],2,"54","9"],["147","1967-01-28","Kommentar zur Hausdurchsuchung beim SDS. Man wolle keineswegs das Verhalten der Studenten entschuldigen. Aber scharfe Kritik an der Hausdurchsuchung sei notwendig, insbesondere wegen der Durchführung durch die Politische Polizei und wegen der Beschlagnahmung der Mitgliederkartei. Diese müsse umgehend wieder zurückgegeben werden.","Ein Justizabseits","","","er",[8],9,[5],[5],2,"14","2"],["148","1967-01-28","Bericht über eine SHB-Protestkundgebung wegen der Hausdurchsuchung beim SDS / eingeklinkter Kommentar, in diesem wird die Beschlagnahmung der Mitgliederkartei kritisiert, so schaffe man Märtyrer.","Protestversammlung an der FU","","Studenten fordern Rückgabe der Mitgliederkartei an den SDS","Eigener Bericht / E. W. ",[8],8,[1],[1],2,"14","6"],["149","1967-01-29","Nachricht über die Demonstration gegen die SDS-Durchsuchung.","Studentenproteste in Berlin","","","Eigener Bericht",[8],3,[1],[2],2,"48","6"],["150","1967-01-29","Kurzfristig genehmigte Protestdemo gegen Durchsuchung des SDS, Nevermann fordert Rückgabe, Grass nennt Proteste eine Folge der Großen Koalition.","Studenten blockierten die City","","","Eigener Bericht",[1],1,[1],[5],1,"60","1"],["151","1967-01-29","Leitartikel, der sich gegen die SDS-Demo ausspricht, die Albertz kurzfristig erlaubt hat. Kritik vor allem an Albertz. Studenten sollten lieber gegen die Morde an der Mauer demonstrieren. Dazu eine Karikatur.","Haben wir keine anderen Sorgen?","","","wbr",[1],1,[5,4],[5],2,"60","2"],["152","1967-01-29","Bericht über Albertz' Reaktion auf die Durchsuchung des SDS / Anlass: Eröffnung des JFK-Instituts.","\"Durchsuchung war tief bedauerlich\"","","Neue Proteste - Albertz sprach mit Studenten","Go.",[1],1,[1],[1],1,"60","3"],["153","1967-01-29","Karikatur über die fehlende Thematisierung der deutschen Teilung, Aufschrift des Plakats: \"Wir protestieren gegen die Morde an der Mauer. SDS.\"","Eine Demonstration, die nicht stattfand","","","Oskar",[1],1,[5,4],[5],1,"60","2"],["154","1967-01-29","Bericht über die geplanten Proteste gegen die Durchsuchung bei JFK-Eröffnung und auf dem Kudamm.","Razzia im Studentenbüro zieht Kreise","Protestaktion angekündigt","Die Razzia der Politischen Polizei beim Berliner SDS zieht weite Kreise. An der FU ging es schon gestern hoch her. 2000 Studenten trafen sich zu einer Protestversammlung","be",[8],6,[1],[1],2,"28","6"],["155","1967-01-29","Bericht über eine Protestveranstaltung in West-Berlin, auf der u. a. die Heruasgabe der Mitgliederkartei des SDS gefordert wurde. Redner waren u. a. Grass und Enzensberger.","Grass trug Protestschild","","Demonstrationszug im Regen - Keine Zwischenfälle","lbn",[8],5,[1],[2],2,"38","31"],["156","1967-01-29","Bericht über Proteste bei JFK-Eröffnung, zwei Beisteller über VDS und JFK","Albertz zu Studenten: \"Bedauerlicher Vorgang\"","","Pfeifkonzert empfing den Regierenden Bürgermeister","lbn",[1],5,[1],[1],2,"38","31"],["157","1967-01-30","Bericht über die Demo auf dem Kudamm und die Folgen: Zwei Stunden Verkehrschaos. Kritik an Albertz, der den Protestmarsch kurzfristig genehmigt hatte.","Studenten marschierten trotz des Regens","","","Hella Boschmann",[8],2,[1],[2],2,"12","3"],["158","1967-01-30","\"Was ist los an der Freien Universität? Da demonstrieren 3500 Studenten gegen einen Teil ihrer Professoren. Da weigern sich akademische Würdenträger, an einer Feierstunde teilzunehmen. Da reißt ein Student seinem Rektor das Mikrophon weg. Da werden Dozenten offen als \"Fachidioten\" beschimpft. Auslöser war eine Demonstration mit etwa 1500 Teilnehmern auf dem Berliner Ku'damm gegen den Regierenden Bürgermeister und die Polizei. Diese Demo sei zwar ohne Zwischenfälle verlaufen, bei vorherigen Demos sei dies aber anders gewesen. Stellungnahmen von Professoren, Studenten und Politikern zur Frage, ob die Studentenschaft ein politisches Mandat habe (u. a. Nevermann und Häußermann).","Was ist los an der FU?","","Die BZ fragte Politiker, Professoren und Studenten","Eigener Bericht",[11],6,[1],[4],1,"36","24,25"],["159","1967-01-30","Bericht über mehrere Proteskundgebungen in Berlin. Auch H. M. Enzensberger, Günter Grass und Wolfgang Neuss nehmen teil.","Proteste polizeilich genehmigt","Berlin","Aktion gegen SDS löst neue Studentendemonstration aus","VD",[8],4,[1],[3],2,"18","3"],["160","1967-01-31","Die beschlagnahmte Mitgliederkartei des SDS wurde an den Studentenverband zurückgegeben. Rechtsanwalt Horst Mahler kündigte eine Dienstaufsichtsbeschwerde gegen die Staatsanwaltschaft wegen der Beschlagnahmung an.","SDS-Kartei zurück gegeben","","","Hella Boschmann",[8],2,[1],[5],2,"8","2"],["161","1967-01-31","Nachricht über Rückgabe der beschlagnahmten SDS-Kartei in ungeöffnetem Zustand.","Kartei zurückgegeben","","","Eigener Bericht",[8],1,[1],[2],2,"14","1"],["162","1967-01-31","Bericht über die Rückgabe der ungeöffneten SDS-Kartei / Rektor Lieber setzt sich bei Innenminister Lücke für den SDS ein, der nicht kommunistisch unterwandert sei.","Justiz gab Kartei des SDS zurück","","Rektor Lieber stellte Vertrauensfrage","Go",[8],1,[1],[1],2,"14","5"],["163","1967-01-31","Nachricht über die Bestätigung von Lieber.","Was ist los an der FU?","","","Eigener Bericht",[11],6,[1],[2],2,"26","2"],["164","1967-01-31","Fortsetzung der Umfrage mit Prominenten, diesmal mit Albertz, viele Zitate von ihm, Senatoren, Professoren u.a. ","Thema: Polizei","Was ist los an der FU?","Berlins Regierender Bürgermeister: \"Als Demokrat betroffen\".","Eigener Bericht",[11],6,[1],[1],1,"26","12"],["165","1967-01-31","Bericht über Rückgabe der versiegelten Kartei.","SDS-Kartei zurück gegeben. Beschluss ist rechtskräftig","","","Eigener Bericht",[8],4,[1],[2],2,"18","1"],["166","1967-01-31","Bericht über die Rückgabe der Kartei, zit.: Mahler, Albertz, Akademischer Senat.","SDS-Mitgliederkartei ungeöffnet zurück gegeben","","Tiergartener Amtsrichter lehnte Durchsicht ab - Senat der FU bedauert Belastungsprobe","rw",[8],4,[1],[3],2,"18","11"],["167","1967-01-31","Bericht über die Rückgabe der Kartei / Albertz dankt der Polizei für ihre Besonnenheit bei der Demo auf dem Kudamm.","Beschlagnahmte Mitgliederkartei des SDS ungeöffnet zurück gegeben ","","Keine Beschwerde des Generalstaatsanwaltes gegen Beschluss des Amtsrichters","Eigener Bericht",[8],8,[1],[1],2,"14","5"],["168","1967-02-01","Teil 3 der BZ-Umfrage: Die Atmosphäre zwischen Studenten und Öffentlichkeit ist zweifellos gestört. Welche Möglichkeiten gibt es, das zu ändern? Albertz, Senator Hoppe, Senator Evers, Wolfgang Büsch, Lummer, Oxfort, Lefèvre und mehrere Professoren.","\"Nicht der Nabel der Welt\"","Was ist los an der FU?","Studenten und Öffentlichkeit","Eigener Bericht",[11],6,[1],[1],2,"28","9"],["169","1967-02-02","Diskussion zwischen dem Chef der Schutzpolizei Hans-Ulrich Werner und Studenten-Vertretern bei der ÖTV. Gegensätze prallen hart aufeinander, Polizei stellt fest, nichts gegen Studenten zu haben, aber ihre gesetzlichen Pflichten erfüllen zu müssen.","Harte Diskussion zwischen Polizei und Studenten","","","Eigener Bericht",[1],1,[1],[5],1,"14","3"],["170","1967-02-02","BZ gibt Senatoren, Professoren und Studentenvertretern Pauschalurteile gegen Studenten zum Kommentieren, z. B. Studenten stünden zu weit links, Kommunisten sollten relegiert und Unruhestiftern die Stipendien entzogen werden, Professoren seien mehrheitlich reaktionär etc. Antworten werden knapp, aber in großer Fülle präsentiert. Studentenvertreter sind dabei.","\"Auch unter Studenten keine Fachidioten\"","Was ist los an der FU?","","",[11],6,[1],[1],2,"24","19"],["171","1967-02-02","Podiumsdiskussion der Polizei mit SDS- und AStA-Vertretern. \"Keine merkliche Annäherung\".","Polizei diskutierte mit Studenten","","","dpa",[1],9,[1],[2],2,"12","2"],["172","1967-02-02","Scharfer Text gegen Gastauftritte von SED-Vertretern an der FU, gezogen aus einem Veranstaltungsverzeichnis der FU.","SED-Bonzen als Gastredner an Universitäten","","","Lutz Horst",[11],2,[1],[5],2,"8","3"],["173","1967-02-03","Bericht über die Fragestunde, Thema u.a. die SDS-Durchsuchung, die rechtlich in Ordnung sei.","In der Fragestunde: SDS, Tollwut und Zollstempel","","Abgeordnete wollten vieles von den Senatoren wissen","Go",[8],1,[1],[1],1,"18","5"],["174","1967-02-03","Nachricht über die Wahl von Hartmut Häußermann.","Neuer AStA-Chef","","","Eigener Bericht",[11],1,[1],[2],2,"18","1"],["175","1967-02-03","Leserbrief mit scharfen Angriffen auf eine kleine, aber äußerst radikale Minderheit, die Staat und West-Berlin unterminiere. \"Wir als ehemalige FU-Studenten fordern die sofortige Relegierung aller radikalen Elemente\", sonst verliere die FU ihre Existenzberechtigung.","Studentendemonstrationen","","","G. Both, Berlin 10",[1],1,[6],[3],2,"18","2"],["176","1967-02-03","Neben dem Ergebnis der Wahlen zum neuen AStA der FU Berlin vermeldet der Artikel noch, dass die Hausdurchsuchung beim SDS Erfolg gehabt habe: Das beleidigende Flugblatt sei auf einer Maschine des SDS geschrieben worden.","Häußermann neuer Chef des FU-AStA","","","K.B.",[8],6,[1],[3],2,"36","2"],["177","1967-02-03","Bericht über Beschwerde des FU-Lehrkörpers (113 Dozenten), die die Einsetzung eines Untersuchungsausschusses fordern, der die Einschränkung der Meinungsfreiheit an der FU untersuchen soll. Hintergrund ist die SDS-Durchsuchung.","\"Missachtung der Grundrechte an der FU\"","","","Eigener Bericht",[11],4,[1],[2],2,"20","11"],["178","1967-02-03","Häußermanns Wahl wird mitgeteilt. Außerdem Details über die SDS-Durchsuchung.","Hartmut Häußermann neuer FU-AStA-Vorsitzender ","","","Eigener Bericht",[11],4,[1],[2],2,"20","11"],["179","1967-02-03","Bericht über Podiumsdiskussion, mit deutlicher Kritik an Polizeiführung und Senatsrat Prill.","Studenten und Polizei","","Eine Podiumsdiskussion und ihre Folgen","HDH",[1],8,[1],[5],2,"16","11"],["180","1967-02-04","Nachricht über die Wahlergebnisse des neu gewählten Konvents: je zwei SDS und SHB-Vertreter, vier nicht politisch gebundene Mitglieder, ein Posten blieb offen. ","Zusammensetzung des neuen AStA der FU","","","Eigener Bericht",[11],4,[1],[2],2,"48","15"],["181","1967-02-05","Studienreformkommission der FU legt ersten Bericht vor. Kritik an der geplanten Neuordnung des Studiums, weil Bedürfnisse der Studenten nicht berücksichtigt würden.","Kritik der Freien Universität","","","Eigener Bericht",[4],1,[1],[2],2,"54","1"],["182","1967-02-05","Reportage aus dem Jugendclub \"ca ira\" in Wilmersdorf, in dem FDJler ein- und ausgehen und der SDS ein neues Betätigungsfeld entdeckt hat.","Ist \"ca ira\" Tummelplatz für Berufsprotestierer?","","Verfassungsschutz nicht gern gesehen","Kurt Rech",[1],1,[7],[1],1,"54","4"],["183","1967-02-06","Der SDS will seine politische Aktivitäten verstärken. Der Aufnahmeantrag eines SED-Mitglieds wurde \"vorerst\" zurückgestellt.","SDS will noch aktiver werden","Politik - ganz kurz","","Eigener Bericht",[11],6,[1],[3],2,"32","2"],["184","1967-02-06","Bericht über Sitzung des SDS-Berlin. Er will Großwohnungen anmieten, um nach dem Beispiel von israelischen Kibbuzim Kommunen zu errichten. Außerdem sei die Gründung eines politischen Klubs geplant. Initiatoren seien William Borm und Hans Magnus Enzensberg.","Studentische Wohn-Kommunen nach dem Vorbild der Kibbuzim","","","Eigener Bericht",[11],4,[1],[2],2,"16","9"],["185","1967-02-07","Zwei Leserbriefe mit sehr kritischem Tonfall: Demonstrationen gegen die Politik eines anderen Landes seien eine \"Anmaßung sondergleichen\", aber auch andere Demonstrationen hätten \"anständig vor sich zu gehen\". Zweiter Leserbrief: das Verhalten der protestierenden Studenten sei früher dem \"Mob und Straßenpöbel vorbehalten gewesen\". Für den demokratischen Staat sind solche Studenten kein Gewinn.","Geordnete Demonstrationen. Früher unmöglich","","","J.H., Berlin 31, Charlotte Czamanski, Berlin 28",[1],1,[6],[3],2,"12","2"],["186","1967-02-07","Thema Berliner Modell, befragt werden Senatoren, Albertz, Nevermann, Häußermann und Professoren. Nevermann und Häußermann üben die schärfste Kritik und verlangen weitgehend Änderungen.","\"Nicht hinter versperrten Türen\"","Was ist los an der FU?","BZ fragte Politiker, Professoren und Studenten ","Eigener Bericht",[11],6,[1],[1],2,"24","19"],["187","1967-02-07","Zitiert wird aus einem Schreiben mehrerer FU-Dozenten, die sich auf die WELT-Meldung vom 3.2.1967 beziehen. Die Situation habe sich geändert (wohl durch die Rückgabe der ungeöffneten SDS-Kartei).","Situation hat sich geändert","","","Eigener Bericht",[11],4,[1],[2],2,"18","11"],["188","1967-02-08","Leserbrief: Studentenkrawalle beginnen auf Schüler überzugreifen.","Verkehrte Welt","","","G., Berlin 12",[1],1,[6],[3],2,"12","2"],["189","1967-02-09","Nachricht über dreistündiges Krisengespräch von Albertz mit Lieber und Professor.","Thema: FU","","","Eigener Bericht",[11],6,[1],[2],2,"28","2"],["190","1967-01-27","Nachricht über die vierstündige Durchsuchung.","Razzia im SDS-Büro","","","Eigener Bericht",[8],4,[1],[2],2,"20","1"],["191","1967-02-09","Nachricht über dreistündiges Krisengespräch von Albertz mit Lieber und Professor.","Albertz sprach mit FU-Rektor und Professor","","","Eigener Bericht",[11],4,[1],[2],2,"18","11"],["192","1967-02-10","Leserbrief, der Kritik übt am Text zum \"ca ira\". Ähnlich sei es in anderen Jugendclubs. FDJ-Mitglieder und der SDS dürften sich an Diskussionen beteiligen, ob nun radikal oder gemäßigt.","Freie Diskussion","","","Andreas Taurit, Berlin 41",[1],1,[6],[3],2,"16","2"],["193","1967-02-10","Wissenschaftsausschuss in Berlin lehnt die Studiengebühr von 160 DM ab.","\"Schützenhilfe\" für Studenten","","Parlamentsausschuss lehnt Gebührensätze als zu hoch ab","Eigener Bericht",[4],4,[1],[5],2,"22","13"],["194","1967-02-10","Der VDS will den Berliner Senat wegen des erlassenen Demonstrationsverbotes verklagen.","VDS wird Senat verklagen","","","Eigener Bericht",[11],4,[1],[2],2,"22","13"],["195","1967-02-10","Wissenschaftsausschuss spricht sich für Überprüfung der geplanten Studiengebühren aus.","Teilerfolg der Proteste","","Berlin: Studiengebühr soll überprüft werden","Eigener Bericht",[4],9,[1],[2],2,"14","2"],["196","1967-02-11","VDS in Verhandlungen mit FDJ, ob eine Delegation zum 150. Jahrestag des Wartburgfestes kommen kann - Ziel: aktuelle Fragen der Deutschlandpolitik diskutieren.","VDS zum Wartburgfest?","","","Eigener Bericht",[11],1,[1],[2],2,"12","1"],["197","1967-02-11","Ganz kurze Meldung über die Verhandlungen von VDS und FDJ.","Wartburg-Treffen mit der FDJ?","","","UPI",[11],4,[1],[2],2,"52","4"],["198","1967-02-12","Nachricht über die statistische Erhebung der FU: 43,1% der Studenten stammen aus Angestelltenfamilien, 27,2% aus Beamten- und 21,8% aus Familien mit freien Berufen. Arbeiterkinder machen 4,1% aus. Zwei Drittel der Studenten stammen aus nicht akademisch geprägten Familien.","FU: 4,1 Prozent Arbeiterkinder","","","Eigener Bericht",[11],1,[1],[2],2,"54","3"],["199","1967-02-12","Zusammenfassung der FU-Statistik 1966","FU-Bilanz 1966: Nur vier Prozent aus Arbeiterfamilien","","","dpa",[4],9,[1],[2],2,"12","2"],["200","1967-02-12","Sammelt zunächst Nachrichten über Studenten weltweit. An manchen Tagen machten sie mehr Lärm als alle anderen Ereignisse der Welt. Weltweiter Charakter der Studentenunruhen. \"Frei von gesellschaftlicher Verantwortung, im Besitz zu hoher Monatswechsel, überwiegend motorisiert, kümmert sich ein lautstarker Kreis von Studenten um alles, außer um das Studium. Podiumsdiskussionen mit Studenten enthüllen einen Wissenstiefstand von erschreckendem Ausmaß.\" Aber auch Enttäuschung über Professorenschaft. \"Vielleicht ist die studierende Jugend heute weniger intelligent als frühere Generationen. In jedem Fall ist sie einsamer und darum verzweifelter.\"","Viel Lärm um Studenten in aller Welt","","","R. A. König",[11],5,[5],[2],2,"38","4"],["201","1967-02-13","Nachricht über Demonstration des SDS gegen den Vietnamkrieg in Frankfurt, 500 Teilnehmer.","Demonstration gegen die USA","","","Eigener Bericht",[1],4,[1],[2],2,"18","4"],["202","1967-02-13","Fließtext über Gespräch mit Häußermann. Er kommt ausführlich zu Wort, kann seine Ansichten darlegen. Er verspricht, konzilianter vorzugehen.","Gestörtes Verhältnis wieder ins rechte Lot bringen","","Gespräch mit dem neuen AStA-Vorsitzenden","Hans-Erich Bilges",[11],4,[1],[3],2,"18","11"],["203","1967-02-14","Bericht über schwere Zusammenstöße zwischen Demonstranten und Polizei vor dem US-Konsulat in Frankfurt.","\"Provos\" in Frankfurt","","","AP / dpa",[1],9,[1],[1],1,"12","8"],["204","1967-02-18","Bericht über die Kritik tschechischer Studenten an FU-Kollegen bei einem gemeinsamen Seminar.","\"Backpfeife\" aus Prag für FU-Studenten","","","rb",[11],2,[1],[2],2,"8","3"],["205","1967-02-18","Bericht aus Prag über gemeinsames Seminar tschechischer und Berliner Studenten. Tschechen nennen ihre Gäste \"Utopisten, die an der Wirklichkeit ebenso vorbei gingen wie die Stalinisten der fünfziger Jahre\". Berliner hatten sich zu Maos Großer Kulturrevolution bekannt, Tschechen antworteten, es fehle den Gästen an Kenntnissen der tatsächlichen Gegebenheiten und Probleme des Sozialismus\".","FU-Studenten wurden belehrt","","","SAD",[11],1,[1],[2],2,"10","2"],["206","1967-02-20","Zusammenfassende Darstellung des Standes der Studienreform.","Was wird aus der Studienreform?","","","ems",[4],4,[5],[5],1,"18","2"],["207","1967-02-21","Die NYT berichtet, der CIA habe 1959 bis 1962 Zugriff auf Personalakten der FU gehabt. Außerdem seien US-Studenten der FU systematisch nach Ost-Berlin geschickt worden.","FU-Berlin - Tummelplatz für den CIA","","","kSAD",[11],6,[1],[2],2,"24","2"],["208","1967-02-22","Bericht über die Spekulationen der NYT, die FU habe der CIA Studentenpersonalakten zur Verfügung gestellt. Rektorat und AStA kommen zu Wort.","FU-Hilfe für CIA?","","","dpa",[11],9,[1],[2],2,"12","2"],["209","1967-02-21","Zusammenfassung der US-Medienberichte über die Finanzierung von Studentenorganisationen durch den CIA, bemerkenswert: die meisten geförderten Vereinigungen stünden links vom Zentrum.","Agenten ohne James-Bond-Look","","Skandal um die Finanzierung von Studentenorganisationen durch den amerikanischen Geheimdienst","Hans B. Meyer",[11],8,[1],[1],2,"16","3"],["210","1967-02-21","Bericht über eine Meldung der New York Times, wonach amerikanische und ausländische Studenten an der FU Berlin vom CIA angeworben wurden.","\"New York Times\": US-Geheimdienst war an der FU tätig","","Amerikanische und ausländische Studenten für Arbeiten angeworben","dpa",[11],8,[1],[1],2,"16","11"],["211","1967-02-22","Nach Medienberichten, der CIA habe in Personalunterlagen studierender Amerikaner an der FU Einsicht genommen, stellt das Rektorat der FU fest, das sei nicht zutreffend. AStA protestiert trotzdem scharf gegen \"die Spionagetätigkeit der CIA\".","FU gab keine Unterlagen weiter","","","Eigener Bericht",[11],1,[1],[2],2,"12","2"],["212","1967-02-22","Bericht über den Weg zur Reformuniversität, bei dem auch \"geheiligte Pfründe\" der Professorenschaft nicht unangetastet bleiben.","\"Kampf gegen Macht und Mammon\"","Thema Nr. 1 in Ulm, um Ulm und um Ulm herum","Die revolutionären Pläne der neuen Hochschule in Baden-Württemberg","Rolf Kroseberg",[4],4,[7],[4],1,"22","5"],["213","1967-02-22","Größere Nachricht über den scharfen Protest des AStA gegen die \"Spionagetätigkeit des CIA\" an der FU. Hintergrund: NYT-Bericht. Vier Forderungen werden explizit gestellt und dargestellt. ","Protest gegen \"Spionage des CIA\"","","Erklärung des AStA der FU aufgrund von US-Presseberichten","hws",[1],4,[1],[2],2,"22","9"],["214","1967-02-22","FU-Leitung weist Vorwürfe der NYT zurück, AStA fordert Aufklärung.","FU-Rektorat: Keine Informationen an CIA gegeben","","AStA fordert Stellungnahme und Untersuchung","U.S.",[11],8,[1],[5],2,"14","9"],["215","1967-02-23","Bericht zur FU-CIA-Geschichte. Laut einer Stellungnahme des FU-Rektorat würde die Berichterstattung der New York Times über Einsichtnahmen des CIA in die Studentendaten nicht stimmen.","FU: Bewusste Irreführung","","","Eigener Bericht",[11],1,[1],[2],2,"16","2"],["216","1967-02-23","Niemals hätten ausländische oder deutsche Geheimdienste Personalunterlagen über Studenten bekommen, stellt das FU-Rektorat klar. Auch der DAAD gab keine Personalunterlagen weiter.","FU-Rektorat: \"Bewusste Irreführung\"","","Vorwurf der Weitergabe von Personalunterlagen zurückgewiesen","wt",[1],4,[1],[2],2,"20","11"],["217","1967-02-23","Presseerklärung des Rektorats, Forderung des AStA nach Übergabe aller Personalakten, die im Zusammenhang mit dem CIA stehen.","Rektorat nennt CIA-Meldung \"bewusste Irreführung\"","","","Eigener Bericht",[11],8,[1],[5],2,"14","5"],["218","1967-02-24","VDS-Vertreter und Politiker sprechen über die geplanten Studiengebühren für PH-Studenten. Die Gespräche sollen fortgesetzt werden.","Gespräch mit Studenten über Gebühren","","Weitere Ausschuss-Sitzungen wegen Pauschalierung geplant","ska",[4],4,[1],[3],2,"24","13"],["219","1967-02-24","Der Konvent der Kirchlichen Hochschule erklärt, aus Studentenangaben sei bekannt, dass der CIA auch an dieser Hochschule tätig gewesen sei. Dagegen protestiert die Studentschaft. Der Rektor sagt, er habe darauf keine Hinweise. Kein Fremder habe Zugang zu Personalakten der Studenten.","CIA-Tätigkeit auch an der Kirchlichen Hochschule?","","","Eigener Bericht",[1],4,[1],[2],2,"24","13"],["220","1967-02-27","Kommentar über die gemeinsame Demonstration von FU-Studenten und SED-Mitgliedern gegen die CIA-Gerüchte, insgesamt 150 Personen vor dem US-Hauptquartier an der Clayallee. BZ findet das schizophren, weil die SED-Leute ja selbst Agenten seien. Außerdem sei es eine seltsame Koalition aus den Mao-Anhängern von der FU, denen Ulbricht zu lasch sei, und den West-Berliner SED-Mitgliedern, die streng auf Ulbrichts Linie liegen.","Moment mal!","","","Eigener Bericht",[11],6,[5],[2],2,"32","4"],["221","1967-02-27","An der Aufregung über die CIA-Affäre sei nichts dran, die USA hätten das legitime Recht gehabt, US-Studenten Auslandsaufenthalte zu finanzieren.","Das Ende eines nachrichtendienstlichen Striptease","Vereinigte Staaten","Vom Entrüstungssturm über die CIA-Enthüllung bleiben nur Kunstfehler Washingtons übrig","Heinz Barth",[1],4,[1],[3],2,"20","3"],["222","1967-02-27","Bericht über die Bedeutung der Studienberatung. Zu Wort kommt ein führender Mitarbeiter des VDS. Zusammenfassung einer VDS-Veranstaltung.","Guter Rat wird nicht billig sein","Konstanzer Kolloquium: Hilfe für erste Semester ","Einführung in die unbekannte Universität - Erfahrungsaustausch","Heinz-Theodor Jüchter",[4],4,[1],[1],2,"20","8"],["223","1967-03-02","Bericht über ein Gespräch Albertz mit dem FU-AStA, Thema: Studienreform. Weiteres Thema: Studiengebühren.","Albertz sprach mit FU-AStA","","","Eigener Bericht",[11],6,[1],[2],2,"24","2"],["224","1967-03-02","Rezension. Positiv.","Die dreifache Angst der Deutschen","","Plädoyer für gesunden Menschenverstand in der Einstellung zu Politik, Geschichte und Macht - Armin Mohlers neuestes Buch","Wilfried Hertz-Eichenrode",[9],4,[7],[3],1,"32","2"],["225","1967-03-07","Leserbrief, Kritik an den Studentenunruhen, Demonstranten erinnern an verwöhnte Kinder.","\"Die alten Jungen\"","","\"Die Welt vom 18. Februar\"","Leser",[9],4,[6],[3],2,"20","2"],["226","1967-03-08","kleine Studentengruppe demonstriert gegen Notstandsgesetz","Mit Bart und Plakaten gegen Lücke","","","k.a.",[1],2,[1],[2],1,"12","2"],["227","1967-03-08","Aufklärung für Schüler über Empfängnisverhütung, \"Helfershelfer ist der sozialistische Studentenbund\"","Sex-Unterricht hat einen Pferdefuß","","","Hella Boschmann",[9],2,[1],[2],2,"12","2"],["228","1967-03-09","Leserbrief, Kieler Studentenzeitung will Mitarbeiter nicht nennen, feige Studenten (entgegen der Objektzuordnung nicht in der Berlin-Ausgabe der \"Welt\", sondern in der Bundesausgabe)","Die gleiche Generation?","","\"Die Welt vom 1. März\"","Dr. Wolfgang Rust",[9],4,[6],[3],2,"20","2"],["229","1967-03-13","Kritik an Walden, pro Studenten","\"Die jungen Alten und die alten Jungen\"","","","René Leudesdorff, Studentenpfarrer aus Hamburg",[9],4,[6],[2],2,"20","8"],["230","1967-03-13","Studenten klären Landbevölkerung über Bildung auf","Wenn die Studenten trommeln?","","VDS berichtet über Werbung für höhere Schulen ","Holger Asche (VDS)",[9],4,[1],[2],2,"20","7"],["231","1967-03-15","Leserbrief, Berichterstattung zum Adenauer Preis zu einseitig","Adenauer Preis","","stehenden Mittel","Leser",[9],4,[6],[2],2,"26","7"],["232","1967-03-17","Der VDS bittet Ulbricht in einem Brief sich dafür einzusetzen, dass Studenten aller deutschen Hochschulen an der 150-Jahrfeier des Warthburgfestes teilnehmen können.","Studenten schreiben Brief an Ulbricht","","","e.",[11],4,[1],[2],2,"28","3"],["233","1967-03-17","Asta kritisiert Rede Lübkes zu Spanien und Franko, fordert Stellungnahme von Brandt","Unruhe über eine Äußerung Lübkes","","Schreiben der FU-AStA an Brandt","k.a.",[9],4,[1],[2],2,"28","13"],["234","1967-03-20","Beteiligung der Studenten an Uni-Sitzungen in Hamburg","Fraktur mit Professoren reden","Hochschul-Demokratie","Die WELT sprach mit dem Hamburger AStA-Vorsitzenden","Gisela Schiefler",[11],4,[3],[2],2,"20","15"],["235","1967-03-21","Streiks in London","Studentenstreik beschäftigt London","Grossbritannien","Parlamentsdebatte über Wirtschaftsuniversität gefordert","Marschall Bloom",[1],4,[1],[2],1,"22","3"],["236","1967-03-28","Zahl der Studenten steigt, Lösungen nicht ausreichend, Ungerechtigkeit wird vom Autor befürchtet","Stau vor den Universitäten","","","Günter Krems",[9],4,[1],[1],2,"20","2"],["237","1967-04-04","Vorstellung von Gerhard Gleisberg und Heinz Brakemeier anlässlich einer Zusammenkunft verschiedener linker Gruppierungen.","Hoffen auf die Stunde X","Links von der SPD (2)","Drei Gruppen warten in der Reservestellung","Hans-Dietrich Sande",[9],4,[7],[1],1,"20","5"],["238","1967-04-04","Bernhard de Vries hat geheiratet und es kam zu Aussschreitungen.","Personalie","","","k.a.",[1],4,[1],[2],2,"20","20"],["239","1967-04-06","Studenten des SDS hätten ein Bombenattentat auf Humphrey geplant gehabt (mit einem \"Mao-Cocktail\")","Berlin: Bomben- Anschlag auf US-Vizepräsidenten","Geplant","Elf Verschwörer gefaßt","rb",[1,5],2,[1],[1],2,"10","1"],["240","1967-04-06","Begrüßung von Humphrey in Berlin, die Demonstranten und Attentatspläne würden nicht die Einstellung der Mehrheit der Berliner wiedergeben, die Rede ist von verrückten Halbstarken.","Herzlich Willkommen!","","Herzlich Willkommen Mister Humphrey! Deutschlands Hauptstadt grüßt den Vizepräsidenten der USA","",[1,5],2,[5],[2],2,"10","1"],["241","1967-04-06","Bericht über die Festnahme von elf linksgerichteten Studenten, die gerade beim Mischen von Chemikalien gewesen seien. Der Sprengstoff stamme aus der rotchinesischen Botschaft in Ost-Berlin. Schwerer Zwischenfall vor dem SDS-Büro, Albertz hält Fernsehansprache und sagt dabei: \"Auch Hubert Humphrey soll dabei erfahren, dass es nur einige wenige Radaubrüder und Rüpel sind, die nicht wissen, was die Freundschaft des großen Volkes der Vereinigten Staaten von Amerika für unsere Stadt bedeutet.\". Eingeblockt in Fettdruck die Aufforderung der Morgenpost: \"Berliner! Lasst Euch durch einige wenige Verrückte in unserer Stadt nicht irre machen. Wir alle wissen, was wir den USA  verdanken. Bereitet dem Vizepräsidenten des großen amerikanischen Volkes nun erst recht einen würdigen und herzlichen Empfang.\"","Attentat auf Humphrey von Kripo vereitelt","","FU-Studenten fertigten Bomben mit Sprengstoff aus Peking","Eigener Bericht",[1,5],1,[1],[1],2,"16","1"],["242","1967-04-06","Bericht über die Festnahme der Pudding.-Attentäter, ausdrücklich gekennzeichnet als \"sensationelle Meldung\", die \"spätabends \" von der Politischen Polizei bekannt gegeben worden sei. Studenten sollen vorgehabt haben, mit Bomben, mit unbekannten Chemikalien in Plastikbeuteln und mit anderen Tatwerkzeugen wirrzugehen. Im Polizeibericht heißt es ausdrücklich, dass es sich bei den Verschwörern um eine kleine extrem radikale Gruppe innerhalb der politisch interessierten Studentenschaft handelt. Vor dem SDS-Büro kam es zu Handgemenge. Einige Studenten versuchten, einen Funkwagen umzustoßen. Zwei Studenten wurden festgenommen, darunter auch der SDS-Landesvorsitzende.","Studenten planten Attentat auf Humphrey. 11 Festnahmen","Berliner Polizei","Eine extrem radikale Gruppe der Berliner Studentenschaft steht unter dem dringenden Verdacht, einen Anschlag auf den amerikanischen Vizepräsidenten geplant zu haben","Eigener Bericht",[1,5],6,[1],[1],2,"28","1"],["243","1967-04-06","Über das später sogenannte Puddingattentat, hier noch der Verdacht eines Bombenattentats. Wenn sich der schwere Verdacht bestätigt, dann kann es sich nur um das Vorhaben einiger politisch Geisteskranker gehandelt haben. Trotzdem geht die Meldung um die Welt. Einzige Möglichkeit für die Berliner: Humphrey einen tollen Empfang bereiten.","Diese Schande ohne uns","","","Eigener Bericht",[1,5],6,[5],[2],2,"28","1"],["245","1967-04-06","Die Polizei habe ein Verschwörerkomplott aufgedeckt und 11 Personen festgenommen. Diese hätten ein Bombenattentat auf Humphrey vorgehabt. Bei den Festgenommenen handele es sich um Studenten einer \"extrem-radikalen Gruppe\".","Bombenattentat gegen Humphrey in Berlin vereitelt","","","Eigener Bericht",[1,5],9,[1],[1],2,"16","1"],["246","1967-04-06","Fußend auf dem Polizeibericht , berichtet der Artikel, dass elf Personen, überwiegend Studenten, Anschläge mittels Bomben, mit unbekannten Chemikalien gefüllten Plastikbeuteln oder anderen gefährlichen Tatwerkzeugen wie Steinen geplant hätten. \"In der polizeilichen Meldung wird hervorgehoben, dass es sich bei den Festgenommenen um eine extrem radikale Gruppe handele. Sie stelle innerhalb der politisch interessierten Studentenschaft nur eine verschwindende Minderheit dar.\"","Elf Personen von der Polizei festgenommen","","","Eigener Bericht",[1,5],8,[1],[5],2,"18","1"],["247","1967-04-07","Bericht über das vermeintlich geplante Bombenattentat auf Humphrey. Mitglieder der Kommune I äußern sich, wie und warum sie das \"Attentat\" planten, von einem Sprengstoffattentat könne keine Rede sein. Ulrich Enzensberger wird als Kopf der Kommune I dargestellt. Jörg Schlotterer wird festgenommen.  ","Haftbefehl für den Studenten-Boß","","Verschwörer beim Sprengstoffmischen in der Dachkammer überrascht","Horst Zylka und Marianne Bera",[9,5],2,[1],[3],2,"10","3"],["248","1967-04-07","Besuch Humphreys in Berlin, jubelnder Empfang, nur geringe und kaum erfolgreiche Störungen durch Demonstranten (\"Krachmacher\")","Jubel um Humphrey - Polizeischutz wie noch nie!","Nach dem Attentat - Plan der \"Mao-Studenten\"","Wenige Demonstrationen/ Bekenntnisse der USA zu Berlin erneut bekräftigt","rb",[1],2,[7],[1],1,"10","1"],["249","1967-04-07","Besuch im Springer Haus, Austausch mit A. Springer, kein Wort über Demonstranten","Humphrey im Springer-Haus: \"Das Morgen gehört uns\"","","","L.H.",[10],2,[1],[2],1,"10","1"],["250","1967-04-07","Karikatur: Student sitzt in Zelle, Polizist bringt Wasser und Brot, auf dem Gefangenenanzug steht \"Bombenwerfer\" ","Studentenfutter","","","zel",[9,5],2,[4,5],[3],2,"10","3"],["251","1967-04-07","Im Aufmacher 26 Zeilen über Störer. 2000 Demonstranten versammelten sich, zeigten Plakate mit Parolen wie US=SS, riefen Ho-Tschi-Minh. \"Einige Fanatiker warfen Knallkörper, Tüten mit Mehl und Beutel mit Farben, die aber niemanden trafen. Auch kam es zu Schlägereien zwischen Demonstranten für und gegen Humphrey.\"","Humphrey an die Berliner: Amerika bleibt Euer Freund","","Herzlicher Empfang für Vizepräsidenten - Botschaft Johnsons","",[1],1,[1],[1],1,"20","1"],["252","1967-04-07","Festgenommene verweigern jede Aussage, dem Haftrichter vorgeführt, bei Redaktionsschluss noch keine Entscheidung. Erste Untersuchungen des sichergestellten Materials hätten ergeben, dass es sich um Chemikalien handelte, die bei richtiger Mischung hochbrisanten und gemeingefährlichen Sprengstoff ergeben. Dagegen wird Horst Mahler zitiert. Meldungen, nach denen Teile der Sprengkörper aus der Ost-Berliner rotchinesischen Botschaft stammen, treffen dagegen nicht zu.","Gefährlicher Sprengstoff","","Bombenbastler verweigern jede Aussage","HES",[1,5],1,[1,5],[3],1,"20","3"],["253","1967-04-07","Bericht über Humphreys Besuch, darin ein Satz über Proteste: \"Einige hundert Studenten und Provos versuchten dabei die Anfahrt der Gäste zu stören. Ähnliche Zwischenfälle gab es vor dem Verlagshaus Axel Springer in der Kochstraße.","Amerika hält zu Berlin - Immer und jederzeit","","Vizepräsident Humphrey erneuert die Verpflichtung","Eigener Bericht",[1],6,[1],[1],1,"40","1"],["254","1967-04-07","Nur eine verschwindend geringe Minderheit versuchte, den Besuch von Humphrey zu stören. 200 bis 300 linksgerichtete Studenten störten am Charlottenburger Schloss, später etwa ebenso viele am Verlagshaus, es regnete in Strömen, Pfeifkonzert, Buhrufe. Polizei ignorierte das Geschrei der \"Krakeeler\" solange, bis diese Plakate mit der Aufschrift US=SS hochhielten. Es flogen mit Mehl und Farbe gefüllte Plastikbeutel, Eier, Feuerwerkskörper. 2. Form: Kurz vor der Abfahrt des Vizepräsidenten erreichten die Krawalle ihren Höhepunkt. Nun griff die Polizei durch.","Pfiffe, Sprechchöre und Tumulte","","","red",[1],6,[7],[1],1,"40","3"],["255","1967-04-07","Kommentar zu den Ereignissen beim Humphrey Besuch: Sind die Studenten frei, Kritik zu üben an wem und wo immer sie wollen? Natürlich sind sie das - wie oft muss man das \"unseren lieben Kleinen\" denn noch versichern? Aber ebenso frei ist auch das Recht der \"Kritik an der Kritik\". Ein Teil unserer Studenten bezweifelt die Berechtigung des Kampfes der Amerikaner in Vietnam. Nun gut, das ist ihre Sache. Sie haben das Recht, ihren Protest in würdiger Weise sichtbar zu machen. ","Von Würde keine Spur!","BZ meint","","Eigener Bericht",[1],6,[5],[2],2,"40","2"],["256","1967-04-07","Bericht über die Verhaftung der vermeintlichen Bombenattentäter auf Humphrey aus der Kommune I. Die Festgenommen verweigern die Aussage. Sie wurden einem Haftrichter vorgeführt, der bis Redaktionsschluss keine Entscheidung fällt. Studenten sagten aus, in den Tüten haben sich nur Weizenmehl befunden. Dies sei eine verniedlichende Darstellung, die Polizei widersprach dem schließlich energisch. Man habe Sprengstoff sichergestellt. Gegen Schlotterer Haftbefehl wegen Landfriedensbruch.","Die Verschwörer schalten auf stur","","","Eigener Bericht",[1,5],6,[1],[1],1,"40","4"],["257","1967-04-07","Humphrey zu Gast in Berlin, u.a. auch bei Axel Springer, letzter Absatz: Proteste von Jugendlichen am Schloss Charlottenburg und Verlag","Humphrey bekräftigt in Berlin Garantieverpflichtungen der USA","","Persönliche Botschaft des US-Präsidenten","Co,vC.",[1],4,[1],[1],2,"22","1"],["258","1967-04-07","Bericht über den Besuch Humphreys und Bericht über Stand der Dinge bei festgenommenen Studenten, diese seien beim Mischen von Chemikalien festgenommen worden. Proteste gegen Humphrey seitens Studenten.","Humphrey: Berlin ist stärker als zuvor","","\"Der Einsatz für die Freiheit kennt keinen Unterschied des Ortes\"","Co,vC.",[1,5],4,[1],[2],2,"22","3"],["259","1967-04-07","Kommentar zum angeblichen Bombenfund bei elf jungen Studenten aus Berlin anlässlich des Besuches des US-Vizepräsidenten Humphrey. Aufforderung der Studenten der FU, sich von solchen Aktionen zu distanzieren. Betonung auf kleine Gruppe, keine Verallgemeinerung","Studenten mit Bomben","","","Co,vC.",[1,5],4,[5],[2],2,"22","2"],["260","1967-04-07","Kripo ermittelt intensiv die Hintergründe des angeblich geplanten Attentats auf Humphrey. Mahler wird zitiert.","Zwei Vorsitzende des SDS unter den Verdächtigen","","","Eigener Bericht",[1,5],9,[1],[5],2,"16","1"],["261","1967-04-07","Leitartikel zum Humphrey-Besuch. Scharfe Kritik an Störern, auch hier ist von einem Sprengkörper die Rede.","Ein großer Tag","","","r.h.",[1,5],9,[5],[2],2,"16","2"],["262","1967-04-07","Die im Zuge des vermeintlichen Attentats auf Humphrey Festgenommenen verweigern die Aussage. Drei Studentinnen wurden sogar schon wieder freigelassen. Der Tagesspiegel stellt fest, dass die ursprünglich gemeldete Information, der Sprengstoffe stamme aus der rotchinesischen Botschaft in Ost-Berlin, nicht zutreffe. Mahler wird ausführlich zitiert, widerspricht den Darstellungen eines Sprengstoffattentates.","In Gewahrsam genommene Studenten verweigerten die Aussage","","Anwalt spricht von Rauchbomben nach Amsterdamer Vorbild","Eigener Bericht",[1,5],8,[1],[3],2,"22","1"],["263","1967-04-07","Bilanz des Besuches von Humphrey. Scharfe Kritik an den \"FU-Chinesen\", die nicht begreifen, dass ein Zurückweichen der USA in Vietnam auch die Freiheit Berlins in Frage stellt. \"Dennoch bleibt ihnen das Recht - dank des amerikanischen Schutzes - ihre Meinung in dieser Stadt auf demokratische Weise Ausdruck zu verleihen. Steinwürfe und Rauchbomben im Stile der Amsterdamer \"Provos\" gehen darüber weit hinaus.\" Kritik am Polizeibericht, der durch eine unglückliche Formulierung weltweit Schlagzeilen gemacht und dem Ansehen der Stadt damit geschadet hat.","Humphrey und die Berliner","","","Bn",[1,5],8,[5],[2],2,"22","1"],["264","1967-04-08","Polizei hat bei Humphrey Besuch korrekt gehandelt, keine Ausschreitungen, keine größeren Krawalle","Die Polizei hat sich ein Lob verdient","","","L.H.",[1],2,[1],[2],1,"12","2"],["265","1967-04-08","SDS-Mitglieder, die wegen des vermeintlich geplanten Attentats auf Humphrey verdächtig waren, werden freigelassen. Wurde sehr ernst genommen wegen möglicher, harter Reaktion des FBI","SDS-Randalierer freigelassen","","","ka",[8,5],2,[1],[2],1,"12","2"],["266","1967-04-08","Bericht von Pressekonferenz der Kommune. Die freigelassenen \"Bombenbauer\" erklären sich und kündigen weitere Aktionen auf dem Kudamm an. Sie hätten nur vorgehabt, mit Mehltüten und Rauchbomben auf Humphrey zu werfen, vielleicht auch mit Torten und Joghurt.","Radikale planen neue Krawalle","","","ohne",[1,5],1,[1],[2],2,"12","1"],["267","1967-04-08","Leitartikel zum Puddingattentat. Ruft in Erinnerung, dass ähnliches Verhalten in Ost-Berlin zu mindestens elfmal lebenslänglich statt elfmal Freilassung geführt hätte. Nennt jene im Sinne Lenins \"Nützliche Idioten\", die zwar selbst keine Gewalt anwenden, aber Gewalt immer dann verzeihlich finden, wenn sie von Kommunisten angewendet wird. Sieht Gefahr für die Demokratie, wenn eine aggressive Clique eine sich demokratisch verhaltende Mehrheit fortgesetzt tyrannisiert. \"Wie lange will der Senat, wie lange noch wollen die Berliner sich das ansehen?\"","Liebe kleine Bombenwerfer","","","Jo",[1,5],1,[5],[2],2,"12","2"],["268","1967-04-08","Festgenommene wieder auf freiem Fuß, Ermittlungsrichter hatte keinen Haftbefehl erlassen, Politische Polizei glaubt weiterhin, dass die Kommunarden echte Bomben bauen wollten. \"Vielleicht sind wir eine Stunde zu früh gekommen\", sagte ein Beamter. Dazu eine Karikatur.","Waren die Bomben noch nicht fertig?","","","L.R.",[1,5],6,[1,4,5],[1],1,"28","4"],["269","1967-04-08","Beobachtung am Rande der Proteste. Wie ein Student ein \"Prügelfoto\" provozieren wollte.","Für Spatzen braucht man keine Kanonen","","","Eigener Bericht",[11],6,[1],[1],1,"28","3"],["270","1967-04-08","Bericht über die PK der Kommune im Zuge des vermeintlichen Bombenattentats auf Humphrey. Enzensberger sagt, er habe nicht daran gedacht, dass eventuell hätte geschossen werden können. Kritisiert die \"Hysterie\", die auf Berlins Straßen herrsche. Die Krawalle auf dem Kudamm reichten noch längst nicht aus.","Die beschuldigte \"Provo\"-Gruppe vom Vernehmungsrichter freigelassen","","Ermittlungen des Staatsanwaltes gegen linksextreme Gruppe gehen weiter","Eigener Bericht",[1,5],8,[1],[1],2,"14","2"],["271","1967-04-09","Albertz will sich nicht länger \"auf der Nase herumtanzen lassen\". Die offizielle Studentenvertretung müsse sich endlich vom Treiben der FU-\"Chinesen\" (Formulierung der Berliner Morgenpost) distanzieren.","Albertz will FU-\"Chinesen\" hart auf die Finger klopfen","","Morgenpost-Interview mit dem Regierenden Bürgermeister","St / tf",[1],1,[3],[1],2,"58","1,2"],["272","1967-04-09","Aggressiver Leserbrief, der dazu auffordert, wenn die Polizei nicht einschreite, müssten eben die Berliner nach dem Vorbild der Amsterdamer Matrosen zur Selbsthilfe greifen (dort wurden Provos gewaltsam die langen Haare abgeschnitten und teilweise verprügelt).","Für Selbsthilfe","","","H. Hardtke, Berlin 41",[1],1,[6],[2],2,"58","11"],["273","1967-04-09","Leserbrief, der gegen die Studenten protestiert, die mit Hilfe von Steuermitteln studieren und gegen die USA demonstrieren. Es müsse doch möglich sein, sie zu exmatrikulieren.","Wir protestieren","","","Gb, Berlin 61",[1],1,[6],[2],2,"58","11"],["274","1967-04-09","Scharfer Leserbrief gegen die ultralinken Studenten, die vermeintlich einen Anschlag auf Humphrey geplant hatten: \"Wann wird endlich mit dem Linksradikalismus an der FU ausgeräumt? Die Langmut unserer Stadtväter kennt offenbar keine Grenze.\"","Ultralinke Studenten","","","W. Krüger, Grunewald",[1,5],8,[6],[2],2,"44","18"],["275","1967-04-09","Leserbrief, Kritik an den Studentenunruhen vor dem Hintergrund des Humphrey-Besuches.","Ultraradikale Studenten","","","Leser",[1],8,[6],[2],2,"44","18"],["276","1967-04-09","Alle elf Festgenommenen, die wegen des geplanten \"Pudding-Attentats\" in Haft saßen, sind wieder frei. Aber Senator Büsch lässt keinen Zweifel daran, dass man künftig gegen die \"FU-Chinesen\" hart durchgreifen werde. 200 Rädelsführer und 800 weitere Aktivisten seien der Polizei bekannt. Pressekonferenz von Enzensberger, in der er mehr Aktionen ankündigt, um Borniertheit aufzubrechen. An den Hochschulen formiert sich Widerstand: \"Dem Misskredit, in den 30.000 Mitstudierende durch die Radikalen gebracht werden, müssen wir ein Ende bereiten.\"","200 Anführer auf der Liste der Polizei","Studenten-Krawalle","","Eigener Bericht",[1,5],5,[1],[2],2,"38","3"],["277","1967-04-10","Diskussion über Gesamtschulen","Studenten plädieren energisch für Gesamtschule","","","k.a.",[4],4,[1],[3],2,"20","8"],["278","1967-04-11","FDP und SPD kritisieren die jüngsten Unruhen um den Besuch Humphreys. Die SPD fordert den Akademischen Senat auf, die verantwortlichen Studenten von der FU zu verweisen. Der AStA erklärt, er habe solche Mittel wie gegen den Besuch Humphreys nie gebilligt.","SPD fordert: Radikale von der Uni weisen","","","Eigener Bericht",[1,5],1,[1],[5],2,"16","1"],["279","1967-04-11","Aggressiver Leserbrief gegen die \"ideologischen Gammler\" und die \"pflaumenweichen Erklärungen\" von Heinrich Albertz.","Senat nicht ganz schuldlos","","","Gerd Schacht, Berlin 47",[1],1,[6],[3],2,"16","2"],["280","1967-04-11","Kritischer Leserbrief. Kritisert die \"Salonbolschewisten\" Gerass, Enzensberger, Johnson u.a. Die Unterlassungen des Senates lassen den Eindruck in der Bevölkerung aufkommen, man dulde und fördere den Linksradikalismus.","Wehret den Anfängen!","","","Leser",[1],1,[6],[3],2,"16","2"],["281","1967-04-11","Sehr kritischer Leserbrief, Autor war Augenzeuge der \"unerfreulichen Szenen\" am Schloss Charlottenburg, Senat geht das Risiko ein, die Demokratie unpopulär zu machen, wenn er weiterhin nichts tut.","Freibrief","","","Viktor Keller, Berlin 19",[1],1,[6],[3],2,"16","2"],["282","1967-04-11","Verhältnis zwischen Senat und AStA gespannt, dennoch wird erwartet, dass die Haushaltssperre für 150.000 DM Zuschuss für den AStA aufgehoben wird.","Bisher nichts entschieden","","","Eigener Bericht",[1],1,[1],[2],2,"16","6"],["283","1967-04-11","Berliner SPD und FDP verurteilten die Ausschreitungen beim Humphrey-Besuch und lobten die Umsicht der Polizei.","SPD und FDP gegen Radikale","","","dpa",[1],6,[1],[2],2,"24","2"],["284","1967-04-11","SPD fordert Disziplinarmaßnahmen gegen jene Studenten, die am \"Puddingattentat\" auf Humphrey beteiligt waren. AStA lehnt Distanzierung ab. Disziplinarstrafen werden erwogen.","SPD fordert disziplinarische Maßnahmen gegen FU-Studenten","","Mit Albertz einig in der Verurteilung der Störaktionen beim Humphrey-Besuch","Eigener Bericht",[1,5],8,[1],[1],2,"12","2"],["285","1967-04-12","Senat beschäftigt sich mit den Ereignissen beim Humphrey-Besuch. Nach seiner Ansicht wäre es zu schweren Zusammenstößen gekommen, wenn die Polizei nicht eingegriffen hätte.","Schwerer Zwischenfall verhindert","","","Eigener Bericht",[1,5],1,[1],[2],2,"18","1"],["286","1967-04-12","Paraphrase der Senatserklärung, Humphreys Sicherheitsbeamte hätten im Falle eines Falles von der Waffe Gebrauch gemacht, Beschluss der CDU-Fraktion. ","Studenten sollen ihr Ansehen wieder herstellen","","CDU für harte Bandagen gegen Radikale","Eigener Bericht",[1,5],1,[1],[1],2,"18","2"],["287","1967-04-13","Das Rektorat hat vom Senat eine Liste jener Personen erhalten, gegen die strafrechtliche Ermittlungen im Zusammenhang mit den Ausschreitungen gegen Humphrey laufen. Der Rektor der FU kann nun prüfen, wer davon Student ist und Disziplinarmaßnahmen erwägen. Humphrey spricht nach seiner Rückkehr von Maoisten.","Rektor soll entscheiden","","FU erhielt Namensliste ihrer \"Maoisten\"","BM/ dpa/ AP",[1,5],1,[1],[2],2,"16","1"],["288","1967-04-13","Kritischer Leserbrief, der die Toleranz der Berliner herausstellt. Wo Demonstrationen in Gewalt umschlagen, ist es Sache des Senates, mit Hilfe der Polizei für Ordnung zu sorgen. Der Rest ist Sache des Richters.","Toleranz der Bürger","","","Welker, Vorsitzender des Berliner Bürgervereins e.V. (Leser)",[1],1,[6],[3],2,"16","2"],["289","1967-04-13","Leserbrief, Kritik an Hartmut Häußermann, der in der Abendschau  vom 11.4.1967 einen Unterschied zwischen \"akademischen Bürgern\" und \"normalen Bürgern\" macht. Merkt man nicht auch in diesem Provo-Verein, dass sich durch solche Äußerungen das Verhältnis zwischen beiden noch weiter zuspitzt?","Zum Thema Studenten","","","Leser",[1],1,[8],[3],2,"16","2"],["290","1967-04-13","Kuratorium der FU gibt gesperrte Mittel für den AStA frei, lehnt aber eine 10%ige Erhöhung ab. Darüber beschwert sich der AStA und will in dieser \"Notlage\" jetzt um Spenden werben.","AStA will Spenden","","","Eigener Bericht",[11],1,[1],[2],2,"16","1"],["291","1967-04-13","In zwei Wochen Zwischenprüfung an der Film- und Fernsehakademie, dann wird sich entscheiden, ob die Einrichtung zur Ruhe kommt oder nicht. Verständnis für die Finanzlage der Studenten, Darstellung der harten Diskussionen um Leiser.","Von den Schwierigkeiten des akademischen Filmens","","Professoren und Studenten berichten über das erste Semester","Ilona Schrumpf",[1],1,[1],[1],1,"16","15"],["292","1967-04-13","Albertz übergab Lieber eine Liste mit den Namen der Festgenommenen im Zuge des vermeintlichen Bombenattentats auf Humphrey. Jetzt soll geprüft werden, wer davon FU-Student ist und ob Disziplinarmaßnahmen möglich sind.","FU-Rektor kennt jetzt die Namen","","","Bor",[1,5],6,[1],[2],2,"28","2"],["293","1967-04-14","Leserbrief fordert die Bestrafung der Aufrührer und hält die Einlassung des AStA, die Polizei wiegele die Öffentlichkeit auf, für \"lächerlich\". Die Fakten seien bekannt.","Bestrafung","","","G. Becker, Berlin 42",[11],1,[6],[3],2,"22","2"],["294","1967-04-15","Leserbrief zur Radikalisierung der Studenten","Radikalinskis","","","k.a.",[9],4,[6],[3],2,"20","2"],["295","1967-04-17","Humphrey Besuch, Tortenschlacht, Kinderrei von Einzelgängern","Einzelgänger","","","Jörg Peter Domann, Hans Ulrich Strehlow, 1. Vorsitzender und Presserefernt des AStA der Uni Kiel",[9,5],4,[6],[3],2,"20","2"],["296","1967-04-18","Landesverband Berlin des SDS hat sich mit der Kommune 1 solidarisch erklärt.","SDS mit \"Kommune\" solidarisch","","","AP",[5],1,[1],[2],2,"16","2"],["297","1967-04-19","Nachricht darüber, dass sich AStA und Senat geeinigt haben, rückwirkend zum Beginn des WS die Abgabe jedes FU-Studenten an den AStA von 7,50 DM auf 9,50 DM zu erhöhen.","Höherer Beitrag für FU-Studenten","","","Eigener Bericht",[11],1,[1],[2],2,"14","6"],["298","1967-04-19","Der AStA der FU billigte die Pläne der Kommune I hinsichtlich des Humphrey-Besuches nicht, ist aber gegen Disziplinarverfahren.","FU-AStA gegen disziplinarische Maßnahmen","","Debatte um die Kommune und den SDS gehen weiter - Brief an den Akademischen Senat","sak",[8,5],4,[1],[2],2,"24","14"],["299","1967-04-20","Disskussionsrunde an der FU wird durch die Polizei geräumt  ","Wieder Studenten-Krawalle! Polizei räumt FU","","","rb",[11],2,[1],[2],2,"12","8"],["300","1967-04-20","Mehr als 1000 Studenten protestierten gegen die Debatte im Akademischen Senat, ob der SDS förderungswürdig sei.","Wieder Studentenprotest","","","Eigener Bericht",[11],1,[1],[2],2,"18","1"],["301","1967-04-20","Knappe Nachricht über die Proteste an der FU. Hier ist von 2000 Demonstranten die Rede. Lieber hat das Audimax zur Verfügung gestellt. Häußermann gab zu verstehen, dass der AStA nicht gegen die FU-Chinesen vorgehen werde.","AStA deckt \"FU-Chinesen\"","","","Eigener Bericht",[11],1,[1],[5],2,"18","3"],["302","1967-04-20","Bericht: Scharfe Angriffe auf Sitzung gegen Berliner Polizei, Rechstanwalt Mahler spricht, vergleicht Völkermord in Vietnam mit Judenmord Eichmanns, Schriftsteller Lettau spricht ebenfalls","Polizeimeldung eine \"üble Nachrede\"","","SDS-Anwalt sprach auf Studentenversammlung in der FU","el",[11],4,[1],[2],2,"24","13"],["303","1967-04-21","Wissenschaftsenator Stein kritisiert, dass FU-Rektor von Studenten niedergeschrieen worden sei. CDU fordert Handeln des Senates. Die sieben SDS-Studenten, die während des Humphrey-Besuches festgenommen wurden, werden ein Disziplinarverfahren bekommen.","FU-Rektor erwartet harte Konsequenzen","","Senator fordert Bericht über Zwischenfälle","L.R.",[11],1,[1],[1],2,"22","5"],["304","1967-04-21","Akademischer Senat berät über Disziplinarmaßnahmen gegen festgenommene Studenten/ Demonstration dagegen/ Rektor befürchtet schwere Schäden.","Wieder Krach an der FU","Rektor befürchtet \"schwere Schäden\"","","Eigener Bericht",[11],6,[1],[1],2,"40","39"],["305","1967-04-22","Lage an der FU wird mit Albertz, Lieber und Abgeordneten besprochen, wiederholte Demos","Rabatz-Studenten soll es an den Kragen gehen","","Albertz sprach mit Fraktionschefs","Lutz Horst",[1],2,[1],[1],2,"12","2"],["306","1967-04-22","Akademischer Senat will erneut über Vorkommnisse beraten. CDU schlägt vor, die FU notfalls durch Errichtung einer Bannmeile vor Demonstrationen zu schützen. Albertz, Lieber und die Fraktionsvorsitzenden der drei Parteien berieten über Disziplinarmaßnahmen.","Beratung zwischen Albertz und Lieber","","","Eigener Bericht",[11],1,[1],[2],2,"12","1"],["307","1967-04-22","Streit zwischen FU-Spitze und Polizei, weil die Beamten nicht eingegriffen haben. AStA fordert Studenten auf, gegen sich selbst Disziplinarverfahren zu beantragen, um so die Verfahren gegen die Kommune 1 zu verhindern.","FU-Senat: Ärger mit der Polizei","","","Go",[11],1,[1],[5],2,"12","3"],["308","1967-04-22","Albertz und Lieber führen Krisengespräch über die Lage an der FU.","An der Uni droht wieder ein Gewitter","","","Eigener Bericht",[11],6,[1],[3],2,"28","2"],["309","1967-04-23","Lieber kündigt fristlos die Arbeitsverträge der drei Studentenfunktionäre Häußermann, Wilhelmener und Lefevre und beantragt Disziplinarverfahren. Erstmals in der Geschichte der FU. Akad. Senat verabschiedet Erklärung, dass \"Druck selbstverständlich Gegendruck\" erzeuge. Teilnehmer des Sit-Ins seien \"happening-süchtig\".","Rektor der FU greift jetzt durch","","","Eigener Bericht",[11],1,[1],[2],2,"56","1"],["310","1967-04-23","Nach Eintreffen der Einschreiben mit der Kündigung dreier Studentenfunktionäre trommelte der AStA seine Mitglieder zusammen. Details über die Sperrung der Mittel, Häußermann, Wilhelmener und Lefevre würden nicht mehr als Verhandlungspartner angesehen. Grund: \"schwere Verstöße gegen die FU-Ordnung\". Stein unterstützt Lieber. Weitere Disziplinarverfahren.","Entscheidung des Rektors traf wie eine Bombe","","Senator Stein will Profesor Lieber unterstützen","Michael L. Müller",[11],1,[1],[3],2,"56","3"],["311","1967-04-23","Universitäres Verfahren wegen \"Rauchbomben-Unternehmen\" gegen Humphrey bzw. wegen jüngster Protestkundgebungen. Hinweis auf Text im Heft.","Verfahren gegen zwölf Studenten","","","",[1,5],5,[1],[2],2,"44","1"],["312","1967-04-23","Bericht über die Disziplinarverfahren, die Lieber gegen FU-Studenten beantragt hat.","Lieber greift durch. Jetzt zwölf Verfahren.","","","Eigener Bericht",[11],5,[1],[1],2,"44","39"],["313","1967-04-23","Aggressiver Kommentar, der die Form einer ironischen Theaterkritik hat. ","FU-Theater geht weiter","","","Wolfgang Voss",[11],5,[5],[2],2,"44","39"],["314","1967-04-23","Nachricht über die eingeleiteten Verfahren gegen Puddingattentäter","Verfahren gegen zwölf Studenten","","","Eigener Bericht",[11,5],5,[1],[2],2,"44","1"],["315","1967-04-24","Studenten, die an den Demonstrationen bei Adenauer-Trauerfeier und bei Humphrey Protesten teilnahmen, verlieren ihre Ämter als studentische Hilfskraft.","FU-Randalierer verloren fristlos bezahlte Ämter","","","rb",[11],2,[1],[2],2,"12","2"],["316","1967-04-24","Reaktionen und Sanktionen gegen die Studenten nach der Sitzung im Henry-Ford Bau. Studenten wird gekündigt etc.","An der FU weht ein scharfer Wind","","Appell des Rektors und des akademischen Rates","",[1],4,[1],[2],2,"20","13"],["317","1967-04-25","B.Z. erfuhr aus Studentenkreisen, dass der 1. Mai zur Bühne für ihren Protest gemacht werden soll. Der Plan: 2000 Studenten wollen mitmachen, die Rede von Kiesinger stören, ihn als Nazi beschimpfen und Albertz, wenn er auftritt, die Parole \"Polizeistaat\" entgegen rufen","Krawall während der Mai-Kundgebung?","","","P.R.",[1],6,[1],[3],1,"24","2"],["318","1967-04-26","Bericht, dass der AStA gegen die fristlose Kündigung seiner drei Spitzenfunktionäre klagen will. Außerdem planen sie eine Verleumdungsklage gegen Lieber, der von verbrecherischen Aktionen gesprochen hatte. Außerdem Nachricht über die geplante Veröffentlichung einer Veranstaltungskritik des Seminars von Ernst Fraenkel im FU-Spiegel, die dieser ablehnt, weil es sich um ein Forschungsseminar handele, dessen Ergebnisse nicht für die Öffentlichkeit bestimmt seien.","AStA will vor Gericht klagen","","","Go",[11],1,[1],[2],2,"18","3"],["319","1967-04-26","Neuwahlen des RCDS an der FU Berlin, Programm wird vorgestellt","RCDS will Radikalisierung der Studenten verhindern","","","k.a.",[11],4,[1],[2],2,"20","13"],["320","1967-04-27","Proteste der Veterinärmediziner gegen \"Vergeudung der Studentengelder und radikale Kommillitonen\"","Studenten: Wir haben es satt?","","Veterinärmediziner und Einzelgänger gegen FU-AStA","wt",[11],4,[1],[2],2,"20","12"],["321","1967-07-27","R. Langhans und seine Freunde verteilen Flugblätter auf denen ein Steckbrief des Generalstaatsanwaltes zu sehen ist. Sie erhalten Hausverbot vor dem Gericht in Moabit und wurden namentlich festgestellt.  ","Hausverbot für Teufel-Freunde","","","rb",[5],2,[1],[2],1,"8","4"],["322","1967-04-27","FU will nun gegen die Studentenunruhen durchgreifen, Artikel erinnert an Gründung der Uni.","\"Jetzt wird aufgeräumt!\" ","Radau-Universität: Soll es dabei bleiben? Nein!","","",[1],2,[1],[1,4],1,"10","7"],["323","1967-04-27","Studenten wehren sich gegen Kommilitonen, eigene Flugblätter, keine Revoluzzer-Uni etc.","Studenten-Protest! Aber diesmal gegen eigene Radau-Brüder","","","L.H.",[1],2,[1],[3],2,"10","1"],["324","1967-04-27","Nicht alle Studenten der FU stehen hinter dem AStA. Veterinäre z.B. bringen ein Flugblatt heraus, in dem sie sich vom AStA distanzieren. Man wolle sich nicht in einen \"totalen Grabenkrieg zwischen Professoren und Studenten\" stürzen.","Studentenprotest gegen den AStA","","","Eigener Bericht",[11],1,[1],[2],2,"18","1"],["325","1967-04-27","Vollversammlung der tiermedizinischen Fakultät, distanziert sich von Protesten und fordert vom AStA, das Ansehen der Studentenschaft in der Öffentlichkeit wieder zu verbessern.","Veterinäre fordern Disziplin","","","Eigener Bericht",[11],1,[1],[2],2,"18","2"],["326","1967-04-27","Nachricht über einen Aufruf des Mai-Komitees. Darin wörtlich zitiert: \"Unsere große Freiheitsdemonstration ist auch eine Antwort auf alle Radaubrüder und Störenfriede, die in der jüngsten Vergangenheit unsere Geduld auf eine harte Probe gestellt haben.\"","1. Mai: Keiner darf fehlen!","","","Eigener Bericht",[1],6,[1],[2],2,"32","3"],["327","1967-04-28","Kommentar zu Verhalten der Studenten, Verbindung mit Rotgardisten, Chinesen wird herbeigeführt.","Die \"Rote Garde\": Polit-Gammler","Radau-Universität: Soll es dabei bleiben? Nein!","","Hella Boschmann und Klaus Heine",[1],2,[5],[2],1,"12","4"],["328","1967-04-28","Der RCDS fordert die Studenten auf, dem AStA das Vertrauen zu entziehen.","RCDS kontra AStA","","","Eigener Bericht",[11],1,[1],[2],2,"24","1"],["329","1967-04-28","Nachricht über die bevorstehende Urabstimmung an der FU.","Urabstimmung der FU-Studenten","","","Eigener Bericht",[11],1,[1],[2],2,"24","8"],["330","1967-04-28","Urabstimmung des Konvent wegen Disziplinarverfahren gegen die Studenten Häußermann und Wilhelmer.","Konvent der FU will Urabstimmung veranstalten","","","k.a.",[11],4,[1],[2],2,"24","14"],["331","1967-04-28","Protest bei Studenten mit Urabstimmung gegen Prof. Lieber, Rektor.","FU: Urabstimmung um Disziplinar-Maßnahmen","","","rb",[11],2,[1],[3],2,"12","4"],["332","1967-04-29","Lage an der FU hat sich noch nicht entspannt. AStA machte mehrere Vollversammlungen, um über die bevorstehende Urabstimmung zu unterrichten. Lieber beruft Sondersitzung ein.","Rektor beruft Sondersitzung an der FU ein","","","Eigener Bericht",[11],1,[1],[2],2,"12","2"],["333","1967-04-29","Meldung über die bevorstehende Urabstimmung an der FU. Die juristische und zahnmedizinische Fakultäten haben sich bereits gegen den AStA ausgesprochen, Geisteswissenschaften und Mathematik für ihn.","Juristen sind gegen den AStA","","","Eigener Bericht",[11],6,[1],[2],2,"28","2"],["334","1967-04-29","Vollversammlungen an der FU zu den jüngsten Vorkommnissen, unterschiedliche Bewertungen innerhalb der Studentenschaft","Vollversammlung offenbart tiefe Gegensätze","","Jurastudenten verurteilen das Verhalten der FU-AStA - Neue Demonstrationen angekündigt","",[11],4,[1],[3],2,"32","11"],["335","1967-04-30","Leitartikel zur deutsch-deutschen Lage, darin ein kurzer Nebensatz zu Studenten.","Noch keine Zeit zum Picknick","","","sto",[11],1,[5],[2],2,"48","2"],["336","1967-04-30","Sondersitzung zur Information über den Stand verlief ruhig.","Fakultäten informiert","","FU-Professoren hoffen auf Vernunft der Studenten","Eigener Bericht",[11],1,[1],[3],2,"48","1"],["337","1967-05-02","Der sozialistische Jugendverband ,Die Falken' hat zur eigenen Mai-Feier in die Neue Welt geladen. Hier kam es zur Verbrüderung der Jugendlichen mit den radikalen Studenten der FU; zum Abschluss wurde die Internationale gesungen.","Dann kam die Verbrüderung","Die Falken hatten zur Nachtfeier geladen","","Bor",[1],6,[1],[1],1,"40","4"],["338","1967-05-02","Schema des Studiengangs Germanistik, erster Teil einer Serie von Wegweisern.","Studenten-Wegweiser: Wenn ich Germanistik wähle","","","Eigener Bericht",[11],4,[1],[5],1,"24","8"],["339","1967-05-02","Falkenversammlung in der \"Neuen Welt\", Protest gegen die \"formierte Gesellschaft\" der Bundesrepublik und den Vietnamkrieg, Nevermann fordert eine \"unverzügliche Kooperation der politischen Linken\" in Berlin.","Falken protestieren gegen \"konforme Mai-Feiern\"","","","dpa",[11],4,[1],[2],2,"24","3"],["340","1967-05-02","Studenten, die sowohl den AStA als auch das Rektorat ablehnen, versuchen, einen neuen Weg zu finden, um die Spannung an der Hochschule zu vermindern.","Studenten der FU für \"dritten Weg\"","","","Eigener Bericht",[11],4,[1],[2],2,"24","14"],["341","1967-05-03","Was ist AStA und Konvent? Erklärung der Begriffe ","Was sind AStA und Konvent ","","","k.a.",[11],2,[3],[2],2,"12","6"],["342","1967-05-03","Rektor Lieber spricht: Enttäuschung, wenig Entspannung","Rektor: Hoffnung nicht erfüllt","","","rb",[11],2,[1],[3],1,"12","6"],["343","1967-05-03","Proteste an der FU; seien politische Aktivitäten einiger Studentenvertreter, geben nicht Meinung der gesamten Uni wieder; Misstrauensanträge gegen AStA, Rektor droht erneut mit Disziplinarverfahren","Radikalen geht die Puste aus","Radau-Universität: Soll es dabei bleiben? Nein!","","Hella Boschmann und Klaus Heine",[11],2,[5],[1,4],1,"12","6"],["344","1967-05-03","Veterinär-Studenten hätten kein Vertrauen mehr in AStA und Konvent ","Kein Vertrauen","","","k.a.",[11],2,[1],[2],2,"12","2"],["345","1967-05-03","Flugblattkrieg zur Urabstimmung, FU-Spiegel mit Seminarkritik zu Fraenkel wurde trotz dessen Protest ungehindert verteilt.","An der FU regnet es Flugblätter","","Werden die Studenten ihr Parlament bestätigen?","Go",[11],1,[1],[1],2,"22","5"],["346","1967-05-03","Rektor Lieber ruft Studenten auf, vier führenden Studentenfunktionären das Misstrauen auszusprechen. Konvent übt scharfe Kritik an Lieber.","Urabstimmung mit ungewissem Ausgang","","","Eigener Bericht",[11],1,[1],[2],2,"22","1"],["347","1967-05-03","Hochspannung an der FU: Wie wird die Urabstimmung ausgehen? Lieber verlangt Rückkehr zur Universitätsordnung als Voraussetzung für Entspannung, Zahnmediziner und korporierte Studenten sprachen sich gegen den AStA aus.","Wahlfieber an der FU","","","Eigener Bericht",[11],6,[1],[3],2,"32","2"],["348","1967-05-03","Rektor der FU lässt Flugblatt verteilen, in dem er den AStA angreift.","Krise an der FU zieht größere Kreise","","","V.D.",[11],4,[1],[2],2,"24","1"],["349","1967-05-03","Ausführlicher Bericht über den Auftakt zum \"Wahlkampf\" über die Urabstimmung, ob der AStA noch das Vertrauen der Studentenschaft genießt. Ausführlich wird aus Rektor Liebers Rede und aus Flugblättern zitiert.","FU-Rektor fordert Rückkehr zur Legalität","","Flugblätter und Ansprachen vor Beginn der Urabstimmung","ska",[11],4,[1],[1],2,"24","13"],["350","1967-05-03","Bericht über die Vorbereitungen zur Urabstimmung an der FU Berlin.","Rektor, AStA und Studenten","","Wahlkampfatmosphäre an der FU - Stellungsnahmen zur Urabstimmung","Uwe Schlicht",[11],8,[1],[1],2,"22","8"],["351","1967-05-04","FU-Senat setzt Kommission zur Überprüfung der Vorwürfe gegen den SDS ein; Berliner SPD-Vorstand erklärte, weder \"Sit-ins\" noch Disziplinarmaßnahmen seien geeignet, die Probleme an der FU zu lösen. SDS schließt Kommune-Mitglieder aus.","SDS-Schicksal ungewiss","","Kommission prüft Material gegen Studentenbund","Eigener Bericht",[11],1,[1],[3],2,"32","1"],["352","1967-05-04","Urabstimmung an der FU begann schleppend. Unklarheit über Zweck der Abstimmung. Verwirrung über NPD-nahen neuen Studentenbund.","Vertrauen oder Misstrauen?","","","Go",[11],1,[1],[5],1,"32","3"],["353","1967-05-04","Leserbrief über den AStA der Universität Marburg, der sich solidarisch mit der FU erklärt hat. RCDS weist darauf hin, dass keineswegs der überwiegende Teil der Marburger Studenten hinter der Solidaritätsadresse steht.","Universität Marburg","","","Wilfried Burchart, Wolfgang Limper, RCDS",[1],4,[6],[3],2,"28","2"],["354","1967-05-04","Große Wahlbeteiligung bei der Urabstimmung schon am ersten Tag; SDS suspendierte einige Mitglieder der Kommune 1 von ihren Mitgliedsrechten, Streitigkeiten in anderen hochschulpolitischen Debatten.","SDS-Vorstand will einige Kommune-Mitglieder ausschließen","","Schon 3600 FU-Studenten nahmen an Urabstimmung teil","wt",[5],4,[1],[5],2,"28","13"],["355","1967-06-05","Portrait von Benno Ohnesorg und Situation der Witwe.","Frau des Toten erwartet ein Baby","","","Chris Strohschön",[7],2,[1],[2],1,"12","2"],["356","1967-05-05","Urabstimmung des AStA, bisher bereits 23 Prozent Wahlbeteiligung, SDS-Flugblatt beschimpft Rektor und Regierenden Bürgermeister, SDS distanziert sich, hebt die Mitgliederrechte der Schreiber auf.","FU: \"Sturm\" auf die Wahlurnen ","","","hb",[11],2,[1],[2],1,"12","2"],["357","1967-06-05","Reaktionen auf den Tod Ohnesorgs. ","Jetzt greift der Senat hart durch","","","k.h.",[7],2,[1],[2],2,"12","2"],["358","1967-05-05","DIE Wahlkampfstimmung hat während der Urabstimmung wieder zugenommen: In der Nacht zum Donnerstag (schreibt die BZ am E-Tag Freitag): 17 von 23 Plakaten der AStA-Gegner verschwanden, aber keines der AStA-Befürworter. AStA greift scharf einen neuen Bund Gesamtdeutscher Studenten an.","Wer stahl 17 Plakate?","Hitziger Wahlkampf an der FU / Der erste Zwischenfall. ","","bow",[11],6,[1],[1],1,"48","9"],["359","1967-05-06","Asta: Dienstaufsichtsbeschwerde gegen FU-Rektor, Vorwurf: Rektor verspricht Ende der Disziplinarmaßnahmen wenn Studenten AStA Mißtrauen aussprechen ","AStA: Beschwerde gegen FU-Rektor","","","hb",[11],2,[1],[2],1,"10","2"],["360","1967-06-06","Sonderkommission soll Schuss klären, Senat hält Demoverbot weiter aufrecht, sachliche Diskussion an FU, Flugblätter an Arbeiter verteilt","Kommission untersucht Todesschuß","","8 Staatsanwälte eingeschaltet/ Studentenflugblätter an die Arbeiter","k.h.",[7],2,[8],[1],1,"12","2"],["361","1967-05-06","Vier Stunden lang war das Audimax ein erregter Debattierklub. Vollversammlung des AStA, Lieber sagte aber aus formalen Gründen ab. VV schickte einen Parlamentär, Taubes und Gollwitzer unterstützten den AStA. Der Prozess einer fortschreitenden Entmündigung der Studenten.","Rektor der FU sagte die Teilnahme ab","","Erregte Debatten bei AStA-Vollversammlung","Eigener Bericht",[11],1,[1],[3],2,"18","1"],["362","1967-05-06","Kommunarden versuchten die Vollversammlung zu entern und die Studenten zu wilden Demonstrationen gegen den Rektor aufzuwiegeln.","Vernichtende Niederlage","","\"Kommune\" wollte FU-Studenten aufwiegeln","Go",[11],1,[1],[3],2,"18","3"],["363","1967-05-06","Der Wahlkampf an der FU erreichte einen neuen Höhepunkt: 1500 Studenten diskutierten über die Ereignisse, die zur Urabstimmung führten. Häußermann verteidigte \"Sit-ins\" als politische Demonstration, ein Student der AStA-kritischen Opposition sagte: \"Wir wollen Reformen, aber keine proletarische Revolution\". Der AStA musste sich sagen lassen, er sei total unter die Fuchtel des SDS gekommen. Kommune forderte zu \"Wandzeitungen\" auf, offenbar kostümierte \"Rotgardisten\" verkauften Worte des Vorsitzenden Mao, gedruckt in Peking.","Mao-Worte aus Peking","","","be-",[11],6,[1],[5],2,"36","2"],["364","1967-05-06","Weiter sind die Auseinandersetzungen zwischen Rektor Lieber und dem AStA das Hauptthema. Taubes und Gollwitzer verteidigen Sit-Ins; SDS-Vorstand kritisiert Kommune-Mitglieder: Sie hätten die demokratische Auseinandersetzungen im Verband durch Überrumpelungsmanöver ersetzen wollen. Das könne der SDS nicht dulden.","Dienstaufsichtsbeschwerde gegen FU-Rektor","","Vollversammlung des AStA dauerte Stunden - 6500 Studenten gaben schon ihre Stimme ab","vd",[11],4,[1],[3],2,"52","11"],["365","1967-05-06","Kommentar zur Urabstimmung, der sich sehr um Abgewogenheit bemüht. Es bestehe Reformbedarf, kluge Professoren sähen das auch ein. Es gebe aber auch \"Randerscheinungen studentischer Überaktivität\". Es sei absurd, wenn disziplinarische Maßnahmen gegen Studentenvertreter dadurch abgewendet werden könnten, wenn die Studenten ihren gewählten Vertretern das Misstrauen aussprächen. Tricks des AStA werden beklagt.","FU und die Zukunft","","","E.W.",[11],8,[5],[2],2,"20","1"],["366","1967-05-07","\"Komödie\" in Dahlem, FU sollte wieder werden, was sie war: Ort der sachlichen Auseinandersetzung um Lehre und Forschung. Aber Extremisten haben das Heft in der Hand, auch wenn sie sich von den Kommunarden distanziert haben. Seit langem wurde gefordert, mit diesen Herren ein energisches Wort zu reden, die Ereignisse beim Humphrey-Besuch brachten endlich Taten. Nicht Lieber allein trägt die Verantwortung! Universitätsreform muss kommen, Kritik an schlechten Studienbedingungen und herrenhaftem Verhalten einiger Professoren. \"Da solche Fälle zu Hunderten vorkommen, ist zu verstehen, dass viele junge Akademiker einer Universitätsreform zu ihren Gunsten positiv gegenüberstehen.\"","Die Freie Universität ist aus den Fugen geraten","","","Walter Brückmann",[11],1,[7,5],[1],1,"52","10"],["367","1967-05-07","Kritischer Leserbrief. Der Bürger könne sich nur wundern über die Studentenvertreter. Die Sicherheit West-Berlins würde von den USA garantiert. Man sollte nicht die Fehler der Weimarer Republik wiederholen und den Extremisten das Feld überlassen.","Senat und FU","","","Hugo Steger",[11],8,[6],[2],2,"42","18"],["368","1967-05-08","Beitrag eines Studenten, der Maßnahmen zur höheren Effizienz von Seminaren vorschlägt.","Müssen Seminare immer unproduktiv sein?","Hochschulreform","Vorschläge zur Abhilfe","Winfried Schreblowski",[4],4,[1],[1],2,"18","11"],["369","1967-05-08","Schema des Studiengangs WiWi, zweiter Teil einer Serie von Wegweisern.","Wegweiser: Wenn ich Wirtschaftswissenschaften wähle","","","Eigener Bericht",[11],4,[1],[5],1,"18","11"],["370","1967-05-08","SHB appelliert an Studenten, den FU-AStA zu unterstützen.","FU-AStA erhält allmählich Unterstützung","","","Eigener Bericht",[11],4,[1],[2],2,"18","9"],["371","1967-05-09","Wissenschaftssenator Stein will neues Hochschulgesetz vorlegen. Studentische Mitverwaltung soll erhalten bleiben.","\"Berliner Modell\" soll bleiben","","","Eigener Bericht",[11],1,[1],[2],2,"14","1"],["372","1967-05-09","Um 18 Uhr schließen die Wahllokale zur Urabstimmung an der FU Berlin, mit ersten Ergebnissen wird um 22 Uhr gerechnet. Brandanschlag auf Haus des stv. Vorsitzenden der Jungdemokraten. Hintergrund unklar: Bekennerschreiben deutet auf Rechtsradikale hin, der Betroffene geht davon aus, dass es sich um eine Aktion wegen seiner Rücktrittsforderung an den AStA handelt.","Wer siegt an der FU?","","Heute Abend endet die Urabstimmung","Eigener Bericht",[11],1,[1],[5],1,"14","3"],["373","1967-05-09","Brandanschlag auf Haustür des stv. Jungdemokraten-Chefs in Berlin, Hartmut Röseler. AStA der FU verurteilt den Anschlag.","Wieder politische Brandstiftung","","","L.R.",[1],6,[1],[1],1,"28","4"],["374","1967-05-09","Kommentar zur Erklärung von 17 Studenten der Film- und Fernsehakademie. Zitiert wird aus ihrer Erklärung: Das Auswahlverfahren sei ein Instrument politischer Repression, Direktor Leiser verhalte sich autoritär. In Fettdruck: Die 17 Studenten fordern Annullierung der Prüfungsergebnisse. Dann folgt die Bewertung: Ein gut beleumundeter Mann werde öffentlich niedergemacht, eine interne Aussprache nicht gesucht. Mag sein, dass an der neuen Akademie noch nicht alles glatt laufe. Abschluss: Ein \"Protest\" dieser Art ist jedoch nichts anderes als studentisches Halbstarkentum!","Moment mal!","Moment mal!","","Eigener Bericht",[1],6,[5],[2],2,"28","8"],["375","1967-05-09","Studentische Resolution gegen Erwin Leiser, einen der beiden Rektoren der kurz zuvor begründeten Film- und Fernsehakademie. Die Hintergründe seien für Aßenstehende schwer zu beurteilen.","Studenten-Streik","","","L.S.",[1],4,[5],[2],2,"20","9"],["376","1967-05-09","Nachricht über den Verlauf der Urabstimmung. ","8523 FU-Studenten stimmten bisher ab","","","Eigener Bericht",[11],4,[1],[2],2,"20","11"],["377","1967-05-10","Abstimmungsergebnis, kein Erfolg für AStA laut Senat, knappe Mehrheit, über 1000 Stimmzettel ungültig","FU: Knappe Mehrheit für AStA","","","rb",[11],2,[1],[2],1,"10","2"],["378","1967-05-10","Nachricht über das vorläufige Abstimmungsergebnis: 4652 Ja - und 4265 eigener Berichtstimmen, ungültige Stimmen über zehn Prozent. Wahlbeteiligung nur 66 Prozent.","FU-Studenten stimmten knapp für den AStA","","","Eigener Bericht",[11],1,[1],[2],2,"14","1"],["379","1967-05-10","387 Stimmen entscheiden über das Schicksal der gegenwärtigen Studentenvertretung. Nicht einmal die Hälfte der abgegebenen Stimmen für den AStA. Lieber rief dazu auf, die Autonomie der Hochschule nicht durch illegale Aktionen zu gefährden. Lieber erlitt Kreislaufkollaps. Nach bekannt werden des Ergebnisses zogen Kommunarden unter Absingen der rotchinesischen Hymne zur Boltzmannstraße und hissten dort die nordvietnamesische Fahne.","Lieber: Besonnen bleiben","","Der AStA ist vom Ergebnis enttäuscht","wbr",[11],1,[1],[2],2,"14","2"],["380","1967-05-10","FU-Studenten haben sich einen Bärendienst erwiesen. Absehbar, dass sich die Situation an der FU verschärfen wird.","keine (eingeblockter Kommentar zu \"Lieber: Besonnen bleiben\" in kursiv)","","","wbr",[11],1,[5],[2],2,"14","2"],["381","1967-05-10","Urabstimmung am Vorabend zu Ende gegangen. Vorläufiges Ergebnis wird mitgeteilt. Hohe Zahl der ungültigen Stimmen zeigt, dass viele Teilnehmer weder die Politik des AStA noch die des Rektors unterstützen. Lieber hält fest, dass die Satzung der FU in Kraft bleibt. Häußermann wird zitiert: \"Unsere Politik wurde gebilligt - aber dieser Sieg ist kein Anlass zum Jubel.\"","FU-Urabstimmung: AStA blieb nur hauchdünn in Front","","","Eigener Bericht",[11],6,[1],[5],2,"28","28"],["382","1967-05-10","Sehr knappes Vertrauensvotum für den AStA bei der Urabstimmung. Von 9989 abgegebenen Stimmen stimmten 4652 für und 4265 gegen den AStA.","AStA der FU erhielt nur knappe Mehrheit","","","VD",[11],4,[1],[2],2,"22","1"],["383","1967-05-10","Etwas ausführlichere Darstellung des Abstimmungsergebnisses an der FU Berlin mit mehr Äußerungen dazu. Senatssprecher: Durch dieses Votum würden künftige Verstöße gegen die verfassungsmäßige Ordnung der FU nicht gerechtfertigt.","FU-AStA erhielt knappe Mehrheit","","Beteiligung an der Urabstimmung niedriger als erwartet","Eigener Bericht",[11],4,[1],[2],2,"22","11"],["384","1967-05-10","Bericht zum Ergebnis der Urabstimmung an der FU Berlin.","Knappe Mehrheit für FU-AStA","","","Eigener Bericht",[11],9,[1],[2],2,"12","1,2"],["385","1967-05-10","Kommentar zum Ergebnis der Urabstimmung, Lage an der FU ist nun noch komplizierter geworden. Viele Studenten können sich einer kleinen, radikalen Gruppe nicht mehr entziehen. Wie es weitergehen soll, bleibt rätselhaft.","Ein Pyrrhussieg","","","pf",[11],9,[5],[2],2,"12","2"],["386","1967-05-10","Bericht über das Ergebnis der Urabstimmung an der FU Berlin, die Abstimmungsfrage wird zitiert, alle wichtigen beteiligten Parteien kommen zu Wort.","Knapper Erfolg des AStA bei der Urabstimmung an der FU","","4652 Studenten billigten die Vertrauenserklärung - 4265 lehnten ab","Eigener Bericht",[11],8,[1],[5],2,"16","1"],["387","1967-05-10","Kritischer Kommentar zum Vorgehen des AStA. Ergebnis wenig schmeichelhaft für den AStA, der ein klares Votum gebraucht hätte, aber nicht bekommen hat.","Die Urabstimmung","","","J.B.",[11],8,[5],[2],2,"16","1"],["388","1967-05-11","Eine Urne fehlte bei dem Ergebnis der Urabstimmung, Wahlurne nicht korrekt bewacht, unter umständen Anfechtung der Wahl da knappes Ergebnis ","Schlampereien bei der FU-Urabstimmung","","","rb",[11],2,[1],[2],1,"10","2"],["389","1967-05-11","Wissenschaftssenator billigt Studenten das Recht zu, Kritik an den Zuständen an den Universitäten zu üben, kritisierte aber, dass an der FU \"anarchistische Elemente\" tätig seien. Frage der Urabstimmung haben gegen den Geist der Freiheit verstoßen, dennoch sei man dagegen nicht eingeschritten. \"Anarchistische Elemente\" seien eine verschwindende Minderheit. Streit um Unregelmäßigkeiten bei der Auszählung.","Senator Stein zum FU-Streit: Beide Seiten haben Recht","","Aufschlussreiche Pressekonferenz","Eigener Bericht",[11],1,[1],[1],2,"20","1"],["390","1967-05-11","Leitartikel über die Ergebnisse der Urabstimmung und die Reaktion von Senator Stein. Lage sei schlimmer als von Stein dargestellt. Besänftigung hat dort keinen Platz mehr, wo Studentenvertreter ihre extrem linke Politik mit Methoden durchzusetzen versuchen, die von mitteleuropäischen Umgangsformen weit entfernt sind.","Zu später Optimismus","","","wbr",[11],1,[5],[5],2,"20","2"],["391","1967-05-11","Weiterer Bericht über Steins Pressekonferenz. Zeichen der Entspannung. Häußermann ist bereit, die drei SDS-Mitglieder aus dem AStA zu entfernen. RCDS stellt fest, dass rund 4200 Stimmen für die eigene Politik ein Zeichen seien, dass die \"Resignation der nicht extrem linken Studenten\" vorbei sei.","Steins Eindruck: AStA ist gutwillig","","Senator will \"Berliner Modell\" retten","Go / MM",[11],1,[1],[1],1,"20","3"],["392","1967-05-11","Ungewissheit, was das Ergebnis nun bedeute. Kein \"Triumphgeheul\" auf beiden Seiten - \"und das lässt immerhin hoffen\". AStA gab sich kleinlaut. Die 1035 ungültigen Stimmen werden besonders hervorgehoben: \"Wir haben es hier mit einem ersten, aber kräftigen Lebenszeichen einer neuen ,Mitte' zu tun. Studenten, die sich von der Politik nicht ausschließen, in erster Linie aber studieren wollen. Diese Gruppe sollte ermuntert werden.\" Mit ewigem Streit sei eine Studienreform nicht voran zu treiben. Ganz ohne Reibereien wird eine solche Reform nicht über die Bühne gehen. Aber Demokratie ist nun einmal unbequem.\"","Dämpfer für den FU-AStA","Wie soll es weitergehen nach der Urabstimmung an der Freien Universität?","","Udo Bergdoll",[11],6,[1,5],[1],2,"32","2"],["393","1967-05-11","Ausführlicher Bericht über die Reaktionen auf das Wahlergebnis. Vorsprung des AStA nochmals reduziert. Senator Stein spricht mit den Beteiligten, verteidigt Rektor Lieber. SDS und RCDS werden zitiert.","Senator Stein: Wahlergebnis, ein nützliches Stimmungsbarometer","Gespräche mit FU-Kontrahenten","Große Hoffnung auf neues Hochschulgesetz","cg",[11],4,[1],[1],2,"20","11"],["394","1967-05-12","Kommentar zum Streit an der Berliner Film- und Fernsehakademie. Die 21 protestierenden Studenten fordern nichts anderes als die Annullierung ihrer Prüfungsergebnisse und stellen unbillige Forderungen, nötig seien dennoch Gespräche.","Fall Leiser","","","L.S. ",[1],4,[5],[2],2,"28","11"],["395","1967-05-12","Konvent sieht im Ergebnis eine \"Ermutigung\" , in ihrem Bemühen um eine \"Studienreform\" voranzukommen.","Konvent der FU unterstützt AStA","","Diskussion über Konsequenzen der Urabstimmung","wt",[11],4,[1],[3],2,"28","13"],["396","1967-05-13","Diskussion des AStA der FU zum Schah-Besuch, Persische Botschaft erwägt Absage wegen der Teilnahme von Dr. Nirumand.","Platzt der Schah-Besuch?","","","kh",[7],2,[1],[2],1,"12","3"],["397","1967-05-13","Persische Botschaft überlegt, den Besuch des Schahs in Berlin abzusagen, wenn die FU am 1. Juni eine Veranstaltung über Persien mit Nirumand veranstaltet. Senat versucht, den AStA zur Verschiebung zu veranlassen.","Schah-Besuch in Gefahr","","","Eigener Bericht",[7],1,[1],[2],2,"14","1"],["398","1967-05-13","Iranische Botschaft sieht in der Veranstaltung des AStA einen \"unfreundlichen Akt\". Senatssprecher versucht, eine Verschiebung zu erreichen. FU-Rektorat will sich nicht einmischen, die Veranstaltung sei ordnungsgemäß verabredet worden, für eine Verschiebung gebe es keinen Grund.","Kommt der Schah nicht nach Berlin?","","Persien gegen Studentendiskussion am 1. Juni","Diethard Goos",[7],1,[1],[1],2,"14","3"],["399","1967-05-13","Aufmacher über den Streit an der Film- und Fernsehakademie und die Auseinandersetzungen um Leiser. Anlass ist eine \"Dokumentation\", nach BM-Ansicht in Wirklichkeit eher ein Pamphlet, das sich vor allem gegen Direktor Leiser richtet. Angehängter Kurzkommentar: Wie talentiert die Studenten sind, sollen sie nach ihrer Ausbildung \"draußen\" beweisen, nicht nach den ersten Monaten in Protesterklärungen.","Nach der Schonzeit nun ein Aufstand","","Zur Situation an der Filmakademie","Dieter Strunz",[1],1,[1,5],[1],1,"14","13"],["400","1967-05-13","Persische Botschaft überlegt, den Besuch des Schahs in Berlin abzusagen, wenn die FU am 1. Juni eine Veranstaltung über Persien mit Nirumand veranstaltet. Senat versucht, den AStA zur Verschiebung zu veranlassen. Häußermann lehnt das ab. Möglichkeiten eines Kompromisses werden ausgelotet.","FU-AStA: Wir sagen nicht ab!","","","Eigener Bericht",[7],6,[1],[3],2,"32","2"],["401","1967-05-13","FU-AStA lädt zur Diskussion über Persien ein, bewusst am Vorabend des Staatsbesuchs. Senat hat Bedenken, weil er die Veranstaltung als unfreundlichen Akt betrachtet.","Kontroverse um Persien-Diskussion","","Verhandlungen zwischen FU-AStA und Senatssprecher","wt",[7],4,[1],[2],2,"56","11"],["402","1967-05-14","Exklusiv-Interview mit der BM. Stein gibt Details aus seinem Entwurf für ein Hochschulgesetz bekannt. Erklärt, warum die Presse keine Verantwortung für die negative Stimmung gegenüber Studenten tragen würde.","Senator Stein will Studenten mehr Mitspracherecht geben","","Für Kritik an Professoren","wbr /go",[11],1,[3],[1],1,"56","1,6"],["403","1967-05-14","Sonder-Vollversammlung des Berliner SDS, um die Kommune-Mitglieder auszuschließen. Cremetorten-Attentat ist der verwendete Begriff. Die Namen werden nicht bekannt gegeben.","SDS schloss fünf der \"Attentäter\" aus","","","ws",[1],5,[1],[2],2,"38","31"],["404","1967-05-16","Schema des Studiengangs Geschichte, erste 3 Semester ","Studenten-Wegweiser: Wenn ich Geschichte wähle","","","Eigener Bericht",[11],4,[1],[5],1,"20","7"],["405","1967-05-16","Fünf Angehörige der Kommune 1 wurden aus dem SDS ausgeschlossen. Ihre Namen wurden nicht veröffentlicht.","SDS schloss Mitglieder aus","","","Eigener Bericht",[5],4,[1],[2],2,"20","11"],["406","1967-05-17","Leserbrief eines Studenten, der sich gegen eine Gruppe randalierender persischer Studenten verwahrt. Hier würden die berühmte Demokratie und die Gutmütigkeit des Senates ausgenutzt.","Schnelle Reaktion","","","D, Berlin 41",[7],1,[6],[3],2,"16","2"],["407","1967-05-17","Leserbrief mit scharfen Angriffen gegen den AStA.","Studentenabstimmung","","","R. W. Berlin 47",[11],1,[6],[3],2,"16","2"],["408","1967-05-18","Scharfe Kritik an Stein, der nicht klar genug Position beziehe. \"Krebsübel\" sei, dass sich die Parteipolitik an der FU eingenistet habe. Wer von den Studenten das Interesse hat, sich mit Tagespolitik auseinander zu setzen setzen, soll in die Partei gehen. Wer das nicht will, hat an der Universität nichts zu suchen.","Senator Stein und die FU","","","Richard Fichte, Berlin 27",[11],1,[6],[3],2,"16","2"],["409","1967-05-18","AStA hält fest an der Veranstaltung am 1. Juni - trotz zweier Absagen. AStA wendet sich an Iranische Botschaft, um Ersatz zu erbitten. ","FU-AStA hat jetzt Iranische Botschaft eingeladen","","","Eigener Bericht",[7],4,[1],[2],2,"22","11"],["410","1967-05-19","Persische Botschaft hat keine Einwände mehr gegen die Diskussion mit Nirumand.","Keine Einwände mehr gegen AStA-Diskussion","","Das persische Kaiserpaar kommt nach Berlin","Go",[7],1,[1],[1],2,"18","5"],["411","1967-05-19","Deutliche Kritik an Senator Stein, man sollte sich aber hüten \"die\" Studenten zu sagen. Vielmehr gebe es \"diese\" Studenten, die eine kleine Minderheit seien.","Viele ungeklärte Fragen","","","H.-J. Lange, Berlin 41",[11],1,[6],[3],2,"18","2"],["412","1967-05-19","Schah wird genauso intensiv bewacht wie Humphrey. Bis zuletzt war sein Besuch gefährdet, weil der AStA der FU einen \"Persien-feindlichen Diskussionsabend veranstalten will.\"  Jeder persische Studenten wurde überprüft, alle politischen Gegner des Schahs sind bekannt. Zu Festnahmen kam es jedoch nicht. ","5000 Polizisten bewachen den Schah in Berlin!","Kripo befürchtet Attentats-Versuch","","",[7],6,[1],[1],2,"40","1"],["413","1967-05-19","Kompromiss zwischen der persischen Botschaft und Häußermann ermöglichte den Besuch des Schah in Berlin. Ein persischer Diplomat soll jedoch an der Veranstaltung teilnehmen. Polizei rechnet mit Attentatsversuch. Angeblich wurden mehrere Sprengstoffpakete schon sichergestellt.","Glanzvolles Programm für den Schah","","","lts",[7],6,[1],[2],2,"40","3"],["414","1967-05-19","Große Anfrage der CDU/CSU wegen Überfüllung der Unis etc.","CDU/CSU fragt nach den Hochschulen","","Bundesregierung soll über Stand der Studienreform berichten","ems",[4],4,[1],[2],2,"22","1"],["415","1967-05-19","Nachricht über Planungen, die Beteiligung an den Uni-Wahlen an der TU per \"Happening\" anzukurbeln.","\"Wahl-Happening\" an der TU","","","Eigener Bericht",[11],4,[1],[2],2,"22","13"],["416","1967-05-20","Senat beabsichtig nicht, persische Studenten festzunehmen. Es seien jedoch umfassende Sicherheitsmaßnahmen vorgesehen.","Großes Programm zum Schah-Besuch","","","Eigener Bericht",[7],4,[1],[2],2,"54","9"],["417","1967-05-21","Kritischer Leserbrief. Es sei selbstverständlich, einen Gast zu ehren statt ihn zu beleidigen. Autor bezweifelt, dass die gegenwärtig aktiven Studenten geeignet seien, wichtige Funktionen in der Gesellschaft zu übernehmen.","Mitspracherecht der Studenten","","","H. Rosenberg, Berlin 37",[7],1,[6],[3],2,"52","2"],["418","1967-05-23","Doppelseite über den Kaufhausbrand von Brüssel mit vielen Zitaten von Augenzeugen. Darunter auch die Äußerung einer Verkäuferin: \"Wir hörten eine Art Explosion. Aber wir dachten uns nichts dabei. Einige Anti-Amerikaner sind in den letzten Tagen ins Geschäft gekommen und haben Feuerwerkskörper losgelassen.. Wir dachten, das Spiel geht von vorne los.\" Meinungen zur Ursache des Großfeuers gehen stark auseinander. Ein Teil der Augenzeugen berichtete, die Explosion sei durch eine Butangas-Flasche in der Camping-Abteilung ausgelöst worden. \"Im Zusammenhang mit den Spekulationen über die Brandursache wurde auch bekannt, dass das Kaufhaus in der vergangenen Woche nach einer Bombe durchsucht worden war. Ein anonymer Anrufer hatte dem Personal erklärt, dass sich ein Sprengkörper in dem Gebäude befinde.\" Suche war erfolglos. Brüssels Kripo teilte mit, eventuell politisch motivierte Brandstifter könnten das Feuer gelegt haben. In der Nähe fand die Polizei zahlreiche antiamerikanische Flugblätter, in denen gefordert wurde, die amerikanische Werbeausstellung im Kaufhaus \"hochgehen\" zu lassen. ","Menschen sprangen brennend in den Tod","","Trotz Großalarm der Feuerwehr: das Kaufhaus wurde ein Raub der Flammen","N. R.",[9],6,[1],[4],1,"28","14,15"],["419","1967-05-23","Bericht über den Kaufhausbrand in Brüssel.","Kaufhaus in Flammen!","Bisher 22 Tote","Niemand weiß, wie viele noch drin sind. Über 100 Verletzte in den Krankenhäusern. Die Polizei hält Brandstiftung für möglich. In Brüssel wurde der Notstand ausgerufen","Eigener Bericht",[9],6,[1],[1],1,"28","1"],["420","1967-05-23","Bericht über den Kaufhausbrand in Brüssel.","Brandkatastrophe in Brüssel","","Warenhaus vernichtet - 22 Tote","AP / dpa",[9],9,[1],[1],1,"12","1,9"],["421","1967-05-23","Bericht über die Brandkatastrophe in Brüssel, Kriminalpolizei untersucht, ob Brandstiftung die Ursache gewesen sein könnte, Zitiert wird die Verkäuferin, die den Knall gehört und sich nichts dabei dachte, weil in den vorangegangenen Tagen mehrfach Vietnamdemonstranten Feuerwerkskörper hatten hochgehen lassen. Hinweis auf Bombendrohung in der vorangegangenen Woche.","Brandkatastrophe in Brüssel","","Feuer in Kaufhaus, möglicherweise durch Brandstiftung - 22 Tote geborgen","dpa, UPI , AP",[9],8,[1],[5],1,"12","1,5"],["422","1967-05-24","Bericht über die Brandkatastrophe in L'Innovation in Brüssel. Spekulation über Brandstiftung durch politische Fanatiker als Ursache. Kaum noch Zweifel an Brandstiftung, weil das Feuer an mehreren Stellen ausgebrochen sei. Ausführliche Zitate aus einem kommunistischen Flugblatt.","Mehr als 300 Tote befürchtet","","","SAD / dpa",[9],1,[1],[5],1,"16","1"],["423","1967-05-24","Zusammenfassung der Lage in Brüssel, zitiert werden verschiedene Augenzeugen, die Hinweise auf eine Brandstiftung wahrgenommen haben wollen. Die Polizei dagegen wird zitiert, dass sie keinen Hinweis auf Sabotage hat. ","Sabotage - Gerüchte wollen nicht verstummen","","Es gab zwei Brandherde","SAD / dpa",[9],1,[1],[1],1,"16","16"],["424","1967-05-24","Kurzer Text mit Fakten. Letzter Absatz: Inzwischen scheint festzustehen: das schreckliche Unglück ist auf einen Sabotageakt antiamerikanischer Gruppen zurückzuführen.","Rund 300 Tote durch SABOTAGE!","Kaufhaus-Katastrophe: Es gibt kaum noch Zweifel","Brandstiftung als Demonstration gegen Amerika-Ausstellung","Eigener Bericht",[9],6,[1],[1],1,"32","1"],["425","1967-05-24","Großer Bericht über die Katastrophe. Hälfte des Textes dreht sich um die Frage \"Brandstiftung?\". Oberstaatsanwalt ermittelt fieberhaft. Die amerikanische Woche des Kaufhauses hatte den Zorn der antiamerikanischen Gruppe \"Aktion für Frieden und Unabhängigkeit\" auf sich gezogen, einer kommunistischen Gruppe chinesischer Tendenz. Auffällig ist, dass das Feuer in mehreren Stockwerken gleichzeitig ausbrach. Vize-Chef des Kaufhauses glaubt nicht an einen Anschlag. Schriftstellerin Denise Greindl erzählt, sie habe einen jungen Mann laut rufen hören: \"Ich opfere mein Leben für Vietnam!\"","Wie in einem Leichenschauhaus","Brüssel: Noch immer rauchen die Trümmer. Zahl der Opfer steigt von Stunde zu Stunde","","",[9],6,[1],[4],1,"32","10"],["426","1967-05-24","Neun Zehntel der Marburger Studenten sind in einen zweitägigen Streik getreten. Dozenten schildern die missliche Lage ihrer Institute.","Marburger Studenten streiken","","Protest gegen Kürzung im hessischen Landeshaushalt","pff",[11],4,[1],[2],2,"24","1"],["427","1967-05-24","Da der AStA annimmt, dass persische Studenten während des Schahbesuches in \"Schutzhaft\" genommen werden sollten, sollen sie sich bei deutschen Kommilitonen verstecken. Der AStA ruft dazu auf, Adressen dazu anzugeben.","AStA will persische Studenten bei Deutschen unterbringen","","","Eigener Bericht",[7],4,[1],[2],2,"24","13"],["428","1967-05-24","Bericht zur Brandursache: Es gebe Gerüchte, dass es sich um Brandstiftung gehandelt habe. Vize-Chef des Kaufhauses sagt, er weigere sich, an die Möglichkeit einer politisch motivierten Brandstiftung zu glauben.","Noch 281 Vermisste beim Kaufhausbrand","","","AP / dpa",[9],9,[1],[5],1,"14","1,6"],["429","1967-05-24","Bericht über die Aufräumungsarbeiten und Ermittlungen zum Brüsseler Kaufhausbrand. Vizedirektor des Hauses bestätigt, dass der Brand an mehreren Stellen gleichzeitig ausgebrochen sei. Es gebe den Gerüchten über Brandstiftung Nahrung und erhärte den Verdacht, dass möglicherweise aus politischen Motiven von radikalen Elementen das Feuer gelegt worden sei. Ebenfalls zitiert wird die Überlebende, die gehört haben will: \"Ich gebe mein Leben für Vietnam!\"","Mehr als 300 Tote bei Brüsseler Brandkatastrophe befürchtet","","Zahl der geborgenen Opfer auf 68 erhöht - 281 Vermisste","AP, dpa",[9],8,[1],[1],2,"16","9"],["430","1967-05-25","Bericht über die Brüsseler Kaufhausbrandstiftung. Für den Verdacht der Brandstiftung lag auch gestern noch kein Hinweis vor. Ein Aktionskomitee, das Flugblätter verteilt hatte, wehrte sich gegen den Verdacht, mit dem Brand etwas zu tun zu haben.","Brandstiftung bestritten","","Zahl der Toten bei Brüsseler Katastrophe weiter gestiegen","dpa / AP BM",[9],1,[1],[3],2,"18","18"],["431","1967-05-25","Wird die Brandkatastrophe von Brüssel doch noch gesühnt? Ein junger Mann sei festgenommen worden - er habe sich an diesem Tag bewerben wollen, kurz vorher aber noch antiamerikanische Flugblätter verteilt. Aber der Verhaftete leugnet jede Schuld. Zahl der Toten steigt weiter.","Kaufhausbrand: Erste Verhaftung","","","Eigener Bericht",[9],6,[1],[2],2,"32","32"],["432","1967-05-25","Bilanz der Brandkatastrophe, Polizei verhört Demonstranten, der zuvor antiamerikanische Flugblätter verteilt hatte und vom stv. Kaufhausdirektor wiedererkannt worden war. Hinweise auf Brandstiftung gibt es aber keine.","Vermutlich mehr als 300 Todesopfer","","Polizei verhört Demonstranten ","SAD-dpa",[9],4,[1],[2],2,"18","18"],["433","1967-05-25","Knapp 500 Iraner sind in den vergangenen Tagen als \"Touristen\" eingereist, teilt NRW mit. Behörden gehen davon aus, dass sie wegen des Staatsbesuchs des Schahs gekommen sind. Man befürchtet Attentatsversuche. Für die Dauer des Schahbesuchs wurden für diese Personen Aufenthaltsbeschränkungen angeordnet.","Attentatsversuche auf den Schah befürchtet","","","frh",[7],4,[1],[2],2,"18","1"],["434","1967-05-25","VDS lehnt die Idee von Familienminister Bruno Heck ab, gestaffelte Ausbildungszulage an Eltern zu zahlen. Stattdessen müsste das Ausbildungsförderungsgesetz unterstützt werden.","Studenten lehnen Hecks Pläne ab","","","Mü",[11],4,[1],[2],2,"18","4"],["435","1967-05-25","Zweites großes Studentenwohnheim fast fertig.","Neue Wohnplätze für Studenten","","Bürgermeister-Reuter-Stiftung begeht Richtfest","ei",[11],4,[1],[2],2,"18","11"],["436","1967-05-26","Nachricht über Drohanruf in einer Lütticher Filiale von L'Innovation. Der Anrufer teilte mit, wenn nicht die US-Fahnen anlässlich einer amerikanischen Woche eingezogen würde, würde sich die Katastrophe von Brüssel wiederholen.","Anrufer droht Lütticher Kaufhaus","","","dpa / AP",[9],1,[1],[2],2,"18","1"],["437","1967-05-26","Gleich drei Drohungen mit Bombenanschlägen sind bei der Brüsseler Polizei eingegangen - in keinem Fall konnte ein Sprengkörper entdeckt werden. Büros einer prochinesischen Vereinigung, die gegen die USA demonstriert hatte, wurden durchsucht.","Immer neue Bombendrohungen","","","dpa",[9],1,[1],[2],2,"18","18"],["438","1967-05-26","Kritischer Kommentar zu den Flugblättern der Kommune: \"Bitte, halten Sie sich fest: Können Sie sich vorstellen, dass bei uns Leute die furchtbare Kaufhaus-Brandkatastrophe in Brüssel mit ihren fast 400 Toten als linksradikale, anti-amerikanische Heldentat feiern? Dass uns Leute darauf vorbereiten, nun bald auch Berliner Kaufhäuser brennen zu sehen?\" Über die Kommune I: \"Kommune 1 - Sie wissen ja Bescheid: Jener Club links von sich selbst stehender Jünglinge und Mädchen mit dem gestörten Hormonhaushalt\", \"halbverrückte und verhinderte Puddingwerfer\", gehören für die Flugblätter ins Gefängnis.","400 Tote - für sie ein Happening","Inspektor sagt","","Eigener Bericht",[5],6,[5],[3],2,"36","2"],["439","1967-05-26","Kommentar, der Kritik übt an den studentischen Aktivisten, die sich zu allen möglichen Themen äußern:  Vietnam, Griechenland, Persien, USA, aber jetzt nichts sagen zu den Zuspitzungen im Nahen Osten.","Plötzlich stumm","","","Co",[11],4,[5],[2],2,"32","2"],["440","1967-05-26","Dringlichkeitssitzung  des TU-Studentenparlaments wegen höherer Kosten für Wahlzeitung und Wahlhappening.","Wahlzeitung der TU wird teurer","","","Eigener Bericht",[11],4,[1],[2],2,"32","11"],["441","1967-05-27","Polizei leitet Verfahren wegen der Flugblätter der Kommune 1 ein. Zitat aus einem der Flugblätter (\"burn, Warehouse, burn\"). Polizei hält es für wahrscheinlich, dass die Kommune 1 direkte Verbindungen nach Brüssel unterhält.","Verfahren gegen die Kommune I","","","L.R.",[5],6,[1],[1],2,"28","4"],["442","1967-05-27","Staatsanwaltschaft überprüft, ob sie Ermittlungen gegen die Kommune 1 einleiten soll, die Flugblätter verteilt hatte, auf denen gefragt wurde, wann Berliner Kaufhäuser brennen. Der Brand sei ein \"Happening\" und ein \"Fanal\" genannt worden. Niemand solle sich wundern, wenn auch Berliner Kaufhäuser niederbrennen würden.","Staatsanwaltschaft prüft an der FU verteilte Flugblätter","","","UPI",[5],8,[1],[2],2,"12","2"],["443","1967-05-28","Konvent der FU hat die Regierung der USA und die \"von ihr abhängigen Regierungen\" als \"Verbrecher am Volke Vietnams\" bezeichnet. Ein US-Student erhob Einspruch und warf Lefevre vor, \"dumme Argumente\" zu gebrauchen.","Lefevre im Konvent der FU abgekanzelt","","","Eigener Bericht",[11],1,[1],[2],2,"54","2"],["444","1967-05-29","Studenten buhen Schah in Bonn aus, Programm des Paares, persische und deutsche Studenten demonstrieren","Buh-Rufe: Maskierte Männer an der Straße","","","Kut Dittrich",[7],2,[1],[2],1,"12","12"],["445","1967-05-29","Mit Reinhard Lettau habe der SDS jetzt einen Märtyrer - und zwar weil die Polizei ihn auf dem Verwaltungswege ausweisen wollte, statt den Rechtsweg zu gehen. Scharfe Kritik an diesem Vorgehen, dass aus dem Schriftsteller eben einen Märtyrer mache.","Nun haben sie einen Märtyrer","","","Peer",[1],6,[5],[2],2,"36","4"],["446","1967-05-29","Kein Publikumsansturm beim Schah-Besuch.","Der Jubel bliebt aus. Absperrgitter überflüssig","Schah-Besuch in Bonn","Aber ungetrübter Glanz beim Gala-Empfang","Rudi Strauch",[7],4,[1],[1],2,"22","3"],["447","1967-05-29","Wegen Aufwiegelung von Studenten gegen die Polizei will die West-Berliner Polizei den US-Schriftsteller Reinhard Lettau ausweisen. Dagegen formiert sich breiter Protest. AStA der FU erklärt Vietcong zum glaubwürdigsten Vertreter des vietnamesischen Volkes und die USA zu \"Verbrechern am Volke Vietnams\".","Polizei will Lettau notfalls abschieben","","","V. C.",[11],4,[1],[2],2,"22","3"],["448","1967-05-29","SPD-Landesparteitag setzt sich für stufenweise Senkung der Studiengebühr mit dem Ziel völliger Beitragsfreiheit ein.","SPD: Studiengeldpauschale soll abgebaut werden","","","Eigener Bericht",[11],4,[1],[2],2,"22","13"],["449","1967-05-30","Illegale Geldsammlung für den Vietcong auf dem Gelände der FU, Polizei löst dies auf.","Faule Sammlung","","","k.a.",[11],2,[1],[2],1,"12","2"],["450","1967-05-30","Schah in Kernforschungsanlage in Jülich, in Aachen etwas Jubel, in Bonn protestieren etwa 50 Studenten, Bild-Leser gegen Rummel um Schah.  ","Der Kaiser war plötzlich alleine","Klebte eine Bombe unter dem Schah-Sessel? ","Übereifer der Sicherheitsbeamten führte zu grotesker Panne","Jürgen Jucke und Heinrich Körner",[7],2,[1,6],[2],1,"10","10"],["451","1967-05-30","Verdächtiges Paket aufgetaucht, adressiert an einen persischen Studenten. Es enthielt aber nur zwei Hemden. Zur Zeit gäbe es 1176 persische Staatsangehörige in Berlin, davon sind 40 als radikal bekannt. Eine Liste von 120 weiteren Persern ist den Behörden bekannt; sie sollen zurück geschickt werden, wenn sie per Flugzeug ankommen.","Verdächtiges Paket alarmierte Polizei","","5000 Mann werden hohen Gast schützen","E. B.",[7],1,[1],[1],2,"16","6"],["452","1967-05-30","Ernst Lemmer nimmt Stellung zur Situation an der FU. Man könne nur von einer so genannten Freien Universität sprechen. Die Vorgänge an der FU rührten an der Existenz des freien Berlins.","\"Sogenannte\" FU","","","Eigener Bericht",[11],6,[1],[2],2,"28","2"],["453","1967-05-30","Polizei stellte Personalien von fünf Studenten fest, die ungenehmigt für die FNL gesammelt hatten. Streit darum, ob die Überprüfung auf öffentlichem Straßengelände stattfand oder auf FU-Gelände. AStA kritisiert, dass die Polizei einen \"groben Bruch der Universitätsautonomie\" begangen habe.","Studenten sammelten \"Wild\"","","","Eigener Bericht",[11],6,[1],[3],2,"28","3"],["454","1967-05-30","Kuratorium der Film- und Fernsehakademie unterstützt Leiser gegen den Protest von 21 Studenten; Rückmeldefrist bis 31. Mai  - Im Sinne der Akademie wäre es, wenn alle Studenten das täten.","Filmakademie","","","L.S.",[1],4,[5],[2],2,"20","9"],["455","1967-05-30","Kommentar über den Konventsbeschluss der FU, der die USA verurteilt. So schrecklich der Krieg auch sei, so wenig dürfe man einseitig sein. Auch der Vietcong benutze mörderische Mittel. Dem Konvent müsse deshalb ganz bewusste ideologische Einseitigkeit zur Last gelegt werden. Die Lektüre des Beschlusses sei daher \"betrüblich, so betrüblich wie die Tatsache, dass sich niemand aufgerafft hat, gegen einige an der FU verteilte Flugblätter zu protestieren, die den fürchterlichen Brüsseler Warenhausbrand als ein ,Happening' bezeichneten, das bald seine Fortsetzung in Berlin finden müsse. Solche Dinge erzeugen ein Klima, in dem auch berechtigte und verständliche Protesthaltungen der Jugend Akzente erhalten, die auf bewusste Zerstörung unserer Lebensordnung zielen. Man darf die jungen Revoltierer beglückwünschen, wenn sie ihre Ziele nicht erreichen. Sie stünden dann da, wo es auch für sie keine Revolte, keinen Protest und auch keine Diskussion mehr gäbe.\"","FU und Vietnam","","","Ê.W.",[5],8,[8],[2],2,"16","1"],["456","1967-05-31","Richard Löwenthal kritisiert Entschließung des Konvents als \"extrem einseitig\". Das Gremium sei für völlig andere Aufgaben gewählt.","Konvent handelt unwissenschaftlich","","","Eigener Bericht",[11],1,[1],[2],2,"12","2"],["457","1967-05-31","Leserbrief des Bundesvorstandsmitglieds des Liberalen Studentenbundes. Dieser verwahrt sich dagegen, nichts gegen die Aggression Ägyptens gesagt zu haben, wie die WELT in ihrem Kommentar feststelle, und verweist auf eine entsprechende PM. Aber der Verband ist im Kommentar mit keinem Wort erwähnt!","Entgegentreten","","","Reinhard Roericht",[11],4,[6],[2],2,"20","2"],["458","1967-06-01","Wissenschaftssenator Werner Stein sieht keine Möglichkeit, gegen die Veröffentlichung einer Seminarrezension im FU-Spiegel vorzugehen.","Stein: Eingriff nicht möglich","","","Eigener Bericht",[11],1,[1],[2],2,"18","2"],["459","1967-06-01","Nach einer Veranstaltung in der FU anlässlich des 125-jährigne Bestehens des Orden Pour-le-mèrite buhen Studenten Bundespräsident Lübke aus. Lemmer und Albertz zeigen sich entsetzt.","Studenten schmähten das Staatsoberhaupt","","","AP, dpa",[1],6,[1],[3],2,"32","2"],["460","1967-06-01","Kritik an überzogenen Polizeimaßnahmen. Zwar werden Krawalle erwartet, \"aber rechtfertigt das schon Einsätze, die an die finsterste Zeit eines Polizeistaates erinnern?\" Dazu eine Karikatur.","Begeisterung mit gebremstem Schaum","Morgen kommt der Schah","","Peer",[7],6,[5,4],[5],1,"32","4"],["461","1967-06-01","Professor will Lehrveranstaltungen einstellen, weil seine Seminare im FU-Siegel besprochen werden.","Im Hochschulrecht nicht bekannt","","","el",[11],4,[1],[2],2,"22","14"],["462","1967-06-01","200 Studenten stören Ordensveranstaltung mit Heinrich Lübke im Audimax der FU","Nur ein Lächeln für die Buh-Rufer","Pour Le Mérite","Radikale Studenten lösen Empörung durch ihr Verhalten aus","Co",[1],4,[1],[2],2,"22","3"],["463","1967-06-01","Lemmer habe mit seiner Form der Kritik an radikalen Studenten die FU als Ganzes herabgesetz, kritisiert der Senator","Senator Stein bedauert Äußerungen Lemmers","","","dpa",[1],4,[1],[2],2,"22","4"],["464","1967-06-02","Verbot einer Aktion, während Immatrikulationsfeier Grund: SDS sollen Gelder gestrichen werden","Protestaktion verboten","","","k.h",[1],2,[1],[2],1,"12","3"],["465","1967-06-02","Studenten und eine Dolmetscherin im Wedding bei Verteilen von Flugblättern festgenommen","Den Schah beleidigt","","","rb",[7],2,[1],[2],1,"12","2"],["466","1967-06-02","Schah in München, Demonstration vor der Pinakothek","Studenten sangen: Wer soll das bezahlen?","","","k.a.",[7],2,[1],[2],2,"12","8"],["467","1967-06-02","13 Studenten erstatten Anzeige wegen Freiheitsberaubung durch die Polizei bei Vorkommnissen in Bonn , Vorsitzender der Polizeigewerkschaft fand es geschmacklos, das die Polizei über Lautsprecher aufforderte, das Kaiserpaar zu beklatschen.","Strafanzeige gegen Polizei","","","k.a.",[7],2,[1],[2],2,"12","8"],["468","1967-06-02","Bericht über den bevorstehenden Besuch des Schahs in Berlin. In München sangen 500 Demonstranten spöttisch das Faschingslied \"Wer soll das bezahlen?\" Weitere Tumulte. Eingeblockt: Auch Berliner Studenten wollen demonstrieren. FU-Konvent ruft dazu auf. Der Schah wird einer Erklärung für angebliche Verhaftungen, Folterungen und Hinrichtungen verantwortlich gemacht.","Persiens Kaiserpaar ist 24 Stunden lang Ehrengast in Berlin","","Turbulenter Empfang für den Schah in München","AP UPI dpa",[7],1,[1],[1],1,"24","1"],["469","1967-06-02","Beim Verteilen von Flugblättern stellte die Polizei einen Studenten und eine Demonstrantin. Gegen sie wird wegen Beleidigung eines ausländischen Staatsoberhauptes ermittelt. Mehrere Zwischenfälle bei Veranstaltung mit Nirumand, u.A. wurde eine Vietcong-Fahne gehisst. Schah-Gegner versuchten, einen vermeintlichen persischen Agenten zu verprügeln. Studentenvertretung der TU protestierte gegen den Schah-Besuch. Mit Bestürzung habe man vernommen, dass die Ausländerpolizei iranische Studenten vernommen und bei zwei von ihnen eine Haussuchung vorgenommen hätten. Neue deutsch-iranische Gesellschaft will objektiv informieren.","Flugblätter in Wedding","","","Eigener Bericht",[7],1,[1],[2],2,"24","2"],["470","1967-06-02","Scharfe Attacke des Konvents gegen den Akademischen Senat, der zuvor dem SDS die Förderungswürdigkeit aberkannt hatte. Das sei eine \"klare Kriegserklärung\" an die Studentenschaft, sagte Häußermann. Gleichzeitig wurde im letzten Moment eine nach Häußermanns eigenen Worten \"nicht zu verantwortende\" Beschlussvorlage zurückgezogen. Den \"Linksextremisten im AStA\" war es gelungen, scharfe antiisraelische Formulierungen durchzusetzen und eine pro-arabische Position einzunehmen.","Am Skandal vorbei","","FU-Konvent zog unverantwortliche Vorlage zurück","Eigener Bericht",[11],1,[1],[3],2,"24","3"],["471","1967-06-02","Verbot der für die Immatrikulationsfeiern vorgesehenen Proteste.","Protestaktion in der FU verboten!","Auch Senator Stein hat sich eingeschaltet","","",[1],6,[1],[3],2,"44","2"],["472","1967-06-02","Polizeipräsident Duensing nennt Pläne für Störaktionen \"wesentlich härter und konkreter\" als bei Humphrey","Polizei rechnet mit Provo-Eiern","Berlin","","l.r.",[7],6,[1],[5],1,"44","23"],["473","1967-06-02","Abqualifizierung gewesener und angekündigter Demonstrationen. ","Unausgegorener Geltungsdrang","","","Bernt Conrad",[1],4,[1],[2],2,"22","2"],["474","1967-06-02","Ein gleichzeitig mit der Immatrikulationsfeier geplanter Protest des SDS gegen Mittelkürzungen wird untersagt. ","Senator verbietet Studenten-Protest","","Politische Auseinandersetzung an der FU spitzt sich zu","hws, Co",[8],4,[1],[2],2,"22","1"],["475","1967-06-03","300 Demonstranten vor der Oper, Zusammenstoß mit Polizei, 30 Verletzte, Polizei setzt Wasserwerfer und Gummiknüppel ein. In einer Bildunterschrift heißt es: \"In Berlin gab es bisher Terror nur östlich der Mauer. Gestern haben bösartige und dumme Wirrköpfe zum erstenmal versucht den Terror in den freien Teil der Stadt zu tragen.\" [1. Fassung; vgl. Artikel #478]","Oper: Blutige Krawalle","Der Schah und Farah in Berlin","Wasserwerfer eingesetzt/ Feuer auf dem Kudamm","k.a.",[7],2,[1],[1,4],1,"10","1"],["476","1967-06-03","Verurteilung der Demonstrationen am 2. Juni 1967 gegen den Schah vor der Oper. Rote Fahnen werden als Symbol für Mauerbau gewertet, und dies, wo gerade ein Mensch an der Mauer erschossen worden sei. Die Demonstranten werden als \"politische Halbstarke\" bezeichnet, die keine demokratischen Argumente hätten. Es wäre völlig egal, wer zu Besuch kommte, alle würden \"in einen Topf\" geworfen werden. Kein Verständnis für \"Rowdytum\". Demonstranten würden dem Grundgesetz ins Gesicht spucken. Härteres Vorgehen gegen die Demonstranten wird gefordert. [1. Fassung, vgl. Artikel #479] ","Demonstrieren JA! Randalieren NEIN!","","","BILD",[7],2,[5],[2],2,"10","1"],["477","1967-06-03","Besuch des Kaiserpaares in Berlin, Programm und Demonstrationen, Demonstranten werden als \"Schreihälse\" tituliert.","Erst Glanz und Jubel, dann Hiebe und Blut ","Kaiserpaar in Berlin","Feierliche Empfänge/Wilde Randalierer","k.a.",[7],2,[1],[1,4],1,"10","2"],["478","1967-06-03","Zweite Fassung des Berichts über die Demonstrationen vor der Deutschen Oper, erstmalig wird der Tod Ohnesorgs erwähnt. Dieser sei an einer Schädelfraktur gestorben. Die Demonstranten werden als \"Halbstarke\" und \"Randalierer\" bezeichnet. Mehrere Festnahmen und Verletzte. In einer Bildunterschrift heißt es: \"In Berlin gab es bisher Terror nur östlich der Mauer. Gestern haben bösartige und dumme Wirrköpfe zum erstenmal versucht den Terror in den freien Teil der Stadt zu tragen.\"","Blutige Krawalle: 1 Toter","Der Schah und Farah in Berlin","Wasserwerfer eingesetzt/ Feuer auf dem Kudamm","ka.",[7],2,[1],[1,4],1,"10","1"],["479","1967-06-03","Kommentar zum Demonstration am 2. Juni 1967 und zum Tod Benno Ohnesorgs. Ohnesorg sei Opfer von Krawallen, die politische Halbstarke inszeniert hätten. Krawallmacher, die sich für Demonstranten hielten, würden Blut sehen müssen, hier höre die demokratische Toleranz auf. \"Wir haben etwas gegen SA-Methoden. Die Deutschen wollen keine braune und keine rote SA. Sie wollen keine Schlägerkolonnen, sie wollen Frieden.\" (Erst ab der zweiten Fassung der Ausgabe)","Demonstrieren JA! Randalieren NEIN!","","","BILD",[7],2,[5],[1,3],2,"10","1"],["480","1967-06-03","Zwei Jungen im Zoo stehen vor dem  Nilpferd mit aufgerissenem Maul.","\"Mit die Schnauze könnta ma linksintelltuella Randalierer wern!\"","","\"Mit die Schnauze könnta ma linksintelltuella Randalierer wern!\"","zel",[7],2,[8],[3],2,"10","2"],["481","1967-06-03","Stein unterliegt mit seiner Klage gegen das Studentenparlament der FU Berlin vor dem Verwaltungsgericht. Die geplante Protestversammlung gegen die Aberkennung der Förderungsfähigkeit des SDS während der Immatrikulationsfeier kann stattfinden.","FU-Krach spitzt sich weiter zu","","","rb",[11],2,[1],[2],2,"10","4"],["482","1967-06-03","Der Ausschuß für Eingaben und Beschwerden des Berliner Abgeordnetenhauses tagte zeitgleich zu den Demonstrationen gegen den Schahbesuch im Rathaus Schöneberg zu den Punkten Lärmbelästigung und Studiengebühren.","Zufall","","","ka",[7],2,[1],[2],2,"10","3"],["483","1967-06-03","Mit einer Straßenschlacht endete der erste Tag des Schah-Besuches. Details von den Ausschreitungen. Ein Polizeibeamter feuerte im wirren Tumult und in dem unübersehbaren Handgemenge einen Warnschuss ab (Kurras). Demonstranten hätten \"Ku-Klux-Klan-Masken\" getragen. Schon vorher gab es beim Schöneberger Rathaus Ausschreitungen, vor allem von Persern gegen Perser. Schahfreunde schlugen mit Stöcken und Totschlägern auf Schah-Gegner ein. Erst als die berittene Polizei einschritt, konnte die Schlägerei beendet werden.","Blutige Straßenschlacht vor der Deutschen Oper","","Wüste Ausschreitungen beim Berlin-Besuch des Schahs","Eigener Bericht",[7],1,[1],[1],1,"14","1"],["485","1967-06-03","Aktualisierung von Datensatz 483: Letzter Absatz des Vorspanns lautet nun: \"Von den schwer verletzten Demonstranten starb gegen Mitternacht der 26-jährige Student Benno Ohnesorg im Krankenhaus Moabit an den Folgen eines Schädelbruchs.\"","Blutige Straßenschlacht vor der Deutschen Oper","","Ein Toter bei Demonstration gegen den Schah","Eigener Bericht",[7],1,[1],[1],1,"14","1"],["486","1967-06-03","Scharfe Kritik im Leitartikel gegen die Ausbrüche beim Schahbesuch. Das Bonner Außenamt habe viel investiert, um den Schah nach Berlin zu bringen, was angesichts der langen Grenze des Iran mit der Sowjetunion nicht ganz einfach gewesen sein dürfte. Um so schlimmer sei, was dem Gast an Feindschaft entgegen gebracht werde. Scharfe Kritik an Protestierern, u. A.: Hysterische Rudel von akademischen Halbstarken, notorische Radaumacher, geschulte kommunistische  Straßenkämpfer, amüsierte Nichtstuer. Es gehe nicht darum, Demonstrationen gegen den Vietnamkrieg zu unterbinden.","Es geht um den Ruf Berlins","","","Rudolf Stiege",[7],1,[5],[2],2,"14","2"],["487","1967-06-03","Bericht vom Schahbesuch in Berlin. Es ist die Rede von einer 50-köpfigen Störergruppe, die aus München vorausgeflogen sei. Die Polizei hat 5000 Mann in Bereitschaft und sei \"auf alles vorbereitet\". Zum Geschehen vor dem Rathaus: Die Schah-Anhänger hatten einen Sonderplatz. Zwischen ihnen und den Schah-Gegnern kam es erst zu Wortgefechten, dann zu Rangeleien und schließlich zu Schlägereien. Rauchbomben flogen. Im Text wird nicht deutlich, dass es die Jubelperser waren, die losprügelten, sehr wohl dagegen in der BU zum entsprechenden Foto. Schutzpolizei-Kommandant Werner soll seinen Unterstellten den Befehl gegeben haben: \"Reitet da mal ein bisschen rein.\"","Schah: Ich bewundere diese Stadt","","Beifall und Rauchbomben vor dem Rathaus Schöneberg","zahlreiche",[7],1,[1],[4],1,"14","6"],["488","1967-06-03","Zusammenfassung der Stadtrundfahrt mit 15 \"weißen Mäusen\". In vielen Straßen stehen Berliner Spalier. Auf dem Kurfürstendamm, vor allem am \"Kranzler-Eck\", wieder die organisierten Sprechchöre der \"FU-Chinesen\". Lautes Gejohle und drohende Fäuste gegen den Gast.","Schah sah auch Hinterhöfe","","Sprudel nach der Stadtrundfahrt","Eigener Bericht",[7],1,[1],[1],1,"14","7"],["489","1967-06-03","AStA darf gegen die Pläne der Universitätsleitung, dem SDS die Förderungswürdigkeit abzuerkennen, demonstrieren. Damit es nicht zu Störungen kommt, hat Rektor Lieber die feierliche Immatrikulation der neuen Studenten abgesagt.","Verwirrte Situation an der Freien Universität","","Verwaltungsgericht hob Demonstrationsverbot auf","Eigener Bericht",[11],1,[1],[5],2,"14","1"],["490","1967-06-03","Kritischer bis aggressiver Leserbrief gegen randalierende Studenten, die in West-Berlin eine Filiale der Ost-Berliner Universität errichten wollten. Sie sollten lieber ihre Nasen in ihre Bücher stecken, scharfe Kritik an Senator Stein.","Unwürdige Szenen an der FU","","","W.S., Berlin 51",[11],1,[6],[3],2,"14","2"],["491","1967-06-03","Leserbrief, der Senator Stein fragt, was er gegen die Tumulte an der FU zu unternehmen gedenke. Besonders die Proteste bei der Festsitzung des Ordens ,Pour le Mérite' empört den Leser.","Tumulte","","","B. R., Berlin 30",[11],1,[6],[3],2,"14","2"],["492","1967-06-03","Leserbrief: Warum haben wir eigentlich eine Polizei, die Gummiknüppel und Wasserwerfer hat? Mit \"schämen\" sei es nicht getan.","Kalte Dusche","","","Erika G. ",[11],1,[6],[3],2,"14","2"],["493","1967-06-03","Karikatur: Langhaarige Studenten lassen sich unterrichten. An der Tafel steht ein \"Buh\".","Grundausbildung für Berufsrandalierer der FU","","","Stenzel",[11],1,[5,4],[5],1,"14","3"],["494","1967-06-03","Immatrikulationsfeier wegen befürchteter Störungen abgesagt","FU-Rektor sagte die Feier ab!","","","",[1],6,[1],[3],2,"28","2"],["495","1967-06-03","Anriss des Themas. In der 2. Form wird \"nach ersten Berichten\" von einem Todesopfer geschrieben","Straßenschlacht vor der Oper!","Blutige Zwischenfälle beim Schah-Besuch (1. Form). Ein Todesopfer beim Schah-Besuch (2. Form)","Zahlreiche Verletzte in Krankenhäusern. Polizei musste Wasserwerfer einsetzen. Rauchbomben, Knallkörper, faule Eier","",[7],6,[1],[4],1,"28","1"],["496","1967-06-03","Kritisch-aggressiver Kommentar gegen die \"Rabauken\", die sich anschicken, die Aufbauleistung der Berliner kaputt zu machen. Kriminell und Terror als Schlüsselworte. Schlusssatz: \"Wer Terror produziert, muss Härte in Kauf nehmen.\"","Das ist Terror!","","","",[7],6,[5],[5],2,"28","3"],["497","1967-06-03","Schilderung der Auseinandersetzungen. Die Demonstranten werden als linksradikale Störenfriede sowie als Mob, dem es nicht um irgendeine politische Aussage, sondern nur um Krawall und Terror gehen würde, beschrieben. Verletzte Polizisten durch Steinwürfe: \"Die Polizei nahm jetzt keine Rücksicht mehr. Auch auf ihrer Seite kam es zu Härten.\" In diesem Text ist noch nicht von einem Todesopfer die Rede.","Straßenschlacht","","","L.R.",[7],6,[7,1],[1],1,"28","3"],["498","1967-06-03","Ausschreitungen vor dem Rathaus Schöneberg. Aus München seien extra 150 \"Provos\" zur Unterstützung der Demonstranten angeflogen. Diese hätten nur des Krawalls wegen \"randaliert\" und \"krakeelt\". Verschärfung der Zwischenfälle durch prügelnde Perser gegen Buhrufer. ","Randaliert - des Krawalles wegen","Das Kaiserpaar in Berlin","","",[7],6,[8],[4],1,"28","16"],["499","1967-06-03","Bericht über Besuchsverlauf und Auseinandersetzung auf Basis Kenntnisstand 21:00 Uhr. Hier noch keine Erwähnung Ohnesorgs","Viele Verletzte bei schweren Krawallen vor der Deutschen Oper","","Schah ruft zum Kampf gegen Hunger in der Welt auf","Co",[1],4,[1],[5],1,"26","1"],["500","1967-06-03","Kommentator bewertet Polizeimaßnahmen während des ganzen Schah-Besuchs als überzogen. Kein Bezug zu Berliner Ausschreitungen.","Die \"grüne Woche\" für den Schah","","Sicherheitsrisiko rechtfertigte eine Art Ausnahmezustand - Dennoch: Zuviel Polizei","Rudi Strauch",[1],4,[5],[5],1,"26","2"],["501","1967-06-03","Ablauf des Staatsbesuchs in Berlin etwa bis Nachmittag. An Auseinandersetzungen werden die vor dem Rathaus Schöneberg geschildert. Im Gegensatz zur Bildunterschrift wird im Text die Rolle der \"Prügel-Perser\" zumindest erwähnt.","Ovationen und Tumulte prallten aufeinander","","Schatten über dem Besuch des Kaiserpaares - 34 Personen verletzt","gvc, wt",[1],4,[1],[1],1,"26","9"],["502","1967-06-03","SDS darf trotz Immatrikulationsfeier und Stein-Verbot demonstrieren","Gericht lässt Demonstration an der FU zu","","","Co",[8],4,[1],[2],2,"26","1"],["503","1967-06-03","Bericht über den Schah-Besuch und die Ausschreitungen","Straßenschlacht vor der Oper","Blutige Krawalle beim Schahbesuch","Über 20 Verletzte - 35 Festnahmen","Eigener Bericht",[7],9,[1],[1],1,"12","1"],["504","1967-06-03","Scharfer Kommentar gegen die Ausschreitungen, dies sei \"nackter Terror\". Es sei den Demonstranten nicht um die die Situation in Persien, sondern nur um den Tumult seiner selbst Willen gegangen. Kritik auch an den \"Jubel-Persern\".","Sinnloses Wüten","","","pf.",[7],9,[5],[2],2,"12","2"],["505","1967-06-03","Große Reportage über den 2. Juni 1967, von der Ankunft bis zum Beginn der Zauberflöte, Bericht über die Demonstrationen. Über die Auseinandersetzungen nach Beginn der Zauberflöte sowie dem Tod Ohnesorgs noch keine Berichte.","Sympathie und Protest","\"Telegraf\"-Reporter beim Schah-Besuch","","Heino",[7],9,[1],[1],1,"12","3"],["506","1967-06-03","Umfangreicher Bericht zu den Ereignissen des Vortages","Schwere Tumulte vor der Deutschen Oper","","Ausschreitungen von Demonstranten beim Schah-Besuch  - Zahlreiche Zivilisten und Polizisten verletzt","Eigener Bericht",[7],8,[1],[1],1,"14","1"],["507","1967-06-03","Scharfe Kritik an den Ausschreitungen während des Schah-Besuchs. Nicht nur die Ausschreitungen selbst bereiten Sorge, sondern auch der mangelnde Umgang der Politik damit. Das Massenaufgebot der Polizei sei berechtigt gewesen, und sie habe glücklicher agiert als in anderen Städten. Was die Demonstranten verkennen würden, ist die Sonderrolle Persiens für Deutschland.","Der Schah in Deutschland","Unsere Meinung","","Gz.",[7],8,[5],[2],2,"14","1"],["508","1967-06-03","Große Zusammenfassung des Tages von der Ankunft bis zum frühen Abend. Zu den Ausschreitungen vor dem Rathaus Schöneberg: \"Anschließend entwickelte sich vor dem Rathaus zwischen den Schah-Freunden und den Schah-Gegnern eine Schlägerei. Im Handgemenge ist nach Augenzeugenberichten von einem Schah-treuen Demonstranten auch eine Stahlrute eingesetzt worden. Von berittenen Polizeibeamten wurden die Handgreiflichkeiten unter Einsatz von Schlagstöcken beendete. Wieder fielen Rauchbomben.\"","Der Berlin-Besuch des persischen Kaiserpaars","","Schah betont Pflicht zum Kampf gegen Hunger und Elend - Erste Zwischenfälle am Rathaus","Eigener Bericht",[7],8,[1],[4],1,"14","9"],["509","1967-06-04","In Berlin herrsche 24 Stunden nach dem Todesschuss praktisch Ausnahmezustand. Demonstrationsverbot. Erstmals seit 1948 war die Polizei gezwungen, im \"freien Teil\" der Stadt Maßnahmen gegen Terror zu ergreifen. Blutiges Drama, Folgen sind noch nicht abzusehen. Nicht einmal die Bilanz der Krawalle war geeignet, zur Mäßigung beizutragen. Albertz stellt sich vor die Polizei. Die Schilderung des Todesschusses folgt dem Polizeibericht. \"Schließlich verloren einige Uniformierte die Nerven und schlugen mit Gummiknüppeln.\"","Todesschuss vor der Deutschen Oper","","Handelte die Kripo in Notwehr?","Schah-Sonderredaktion (?)",[7],3,[1],[1],1,"48","2,3,4,5"],["510","1967-06-04","Scharfer Kommentar gegen die Ausschreitungen: \"Bis hierhin und nicht weiter! Polizisten wurden zusammengeschlagen, schlugen und schossen zurück. Ob es nun ein Unglücksfall oder Notwehr war: Wir wollen in Deutschland keine Polizisten, die Demonstranten töten. Aber wir wollen in Deutschland auch keine Krawallmacher, die Staatsgäste mit Rauchbomben \"begrüßen\" und Polizisten steinigen oder erstechen möchten. Wer den Frieden will, muss auch friedlich demonstrieren, ohne Rabatz. Wer den Straßenkrieg will, muss hart bestraft werden. Nicht durch schießende Polizisten, sondern durch schnell urteilende Gerichte. Ein Richter kann einen notorischen Krawallmacher gründlicher abkühlen als ein Wasserwerfer.\" Kein Recht auf Wurfgeschosse! Schützt friedliche Demonstranten. Und schützt die Deutschen vor jenen bösartigen Krawallmachern, die nur eines sehen wollen: Blut.\"","Krieg in unseren Städten?","","","BamS",[7],3,[5],[3],2,"48","2,3"],["511","1967-06-04","Demonstrationen und Ausschreitungen hielten auch am Samstag an. Zu dem bisher schwersten Zwischenfall war es kurz zuvor in Berlin gekommen: Ein ferngesteuertes Auto sollte die Kolonne des Schah treffen.","Ferngesteuerter VW sollte Schah-Auto rammen","Attentatsversuch in Berlin","","Eigener Bericht",[7],3,[1],[1],1,"48","1"],["512","1967-06-04","Der Senat beschloss bis auf weiteres ein Demonstrationsverbot. Albertz äußert: \"Wir lassen uns nicht länger einer Minderheit terrorisieren. Justizsenator prüft, ob man Schnellgerichte einsetzen soll. \"Im Zuge dieser Ermittlungen soll insbesondere der schwere Zwischenfall vor der Deutschen Oper vom Freitagabend geklärt werden, bei dem ein Student durch einen Pistolenschuss eines Kriminalbeamten getötet worden war.\" Albertz drückte der Familie des Getöteten sein Mitgefühl aus. Gleichzeitig sagte er: \"Die Geduld der Berliner hat ein Ende.\" Gemeint: mit den Demonstranten. SPD begrüßte das Demonstrationsverbot. CDU-Vorstand teilte mit, es sei höchste Zeit, \"studentische Rädelsführer, die auf Kosten der Gemeinschaft studieren, von der Universität zu entfernen\". FDP rief die Studenten auf, ihre Meinungsgegensätze im Rahmen der Legalität auszutragen. Nach ersten Ermittlungen wurde Benno Ohnesorg von einem Querschläger getroffen. Ein Kripo-Beamter, der von \"Rowdys\" bedroht worden sei, hätte einen Warnschuss abgegeben. Fritz Teufel verhaftet. Er soll eine Gruppe Studenten angeführt haben, die mit Steinen auf Polizisten warf.","Senat: Alle Demonstrationen sind vorläufig untersagt","","\"Wir lassen uns nicht länger von einer Minderheit terrorisieren \"","Eigener Bericht",[7],1,[1],[1],1,"52","1,2"],["513","1967-06-04","Stiege vermerkt, dass der AStA mit \"tiefer Betroffenheit\" den Tod Ohnesorgs zur Kenntnis nimmt,  bevor er sich sehr kritisch zu den Unruhen äußert: \"Wer würde nicht diesen wahrhaft sinnlosen Tod eines jungen Menschen bedauern! Wer wäre nicht betroffen davon, dass die Krawallen einiger radikaler Halbstarker die Situation heraufbeschworen haben, in deren Hysterie das Unglück geschah. Offenbar hätten die Hauptverantwortlichen für den Tod Ohnesorgs nichts dazu gelernt. Nicht die Polizei trage die Verantwortung, sondern die Demonstranten. Ohnesorg ist nicht der Märtyrer der FU-Chinesen, sondern ihr Opfer. Das Maß ist nun voll, die Geduld der Berliner Bevölkerung erschöpft. Wir sind es endgültig leid, uns von einer halberwachsenen Minderheit, die meist noch Gastrecht bei uns genießt, terrorisieren zu lassen.\"","Heinrich Albertz bleibt hart","","","Rudolf Stiege",[7],1,[5],[2],2,"52","2"],["514","1967-06-04","Scharfer Leserbrief: Die Drahtzieher der Demonstrationen wurden zu Mördern. Hinter den Krawallen stehen die eigentlichen Mörder. Sie schreien \"Unrecht\", um vom Unrecht an der Mauer und in Mitteldeutschland abzulenken. Die Schaulustigen, die zu solchen Demonstrationen gehen, sollten wissen: Im Strudel des Krawalls kann man sich keine Meinung bilden.","Im Strudel des Krawalls","","","D. Wapler, Berlin 41",[7],1,[6],[3],2,"52","2"],["515","1967-06-04","Scharfer Leserbrief, der sich fragt, ob jene, die teilnehmen an \"idiotischen Demonstrationen, überhaupt noch als Studenten zu bezeichnen sind\". Stipendien sollten entzogen, strengere Prüfungen eingeführt werden. Wer unter dem Deckmantel des Studiums nur randalieren wolle, solle dorthin gehen, wo er ausgebildet wurde. Da müsse er nämlich den Mund halten (gemeint ist die DDR).","Fort mit dem Studentenrummel","","","A. H. Berlin 30",[7],1,[6],[3],2,"52","2"],["516","1967-06-04","Friedlich nebeneinander im Krankenzimmer liegen ein verletzter Student und ein verletzter Polizist.","Berliner Trauerspiel","","","Oskar",[7],1,[5,4],[2],1,"52","2"],["517","1967-06-04","Karikatur: Bürger lüftet seinen Hut vor einem Rowdy in der Tür des Studentenausschusses, der eine Keule in der Hand hält.","\"Darf ich zum Fußballspiel gehen - oder randalieren Sie dort auch?\"","","","Stenzel",[1],1,[5,4],[5],1,"52","3"],["518","1967-06-04","Großer Bericht über die Trauer und den Protest wegen Ohnesorgs Tod. Häußermann wird zitiert, der Albertz angreift. Trauerversammlung mit mehreren Professoren und 3000 bis 4000 Studenten. Dreitägiger Vorlesungsboykott, um des Toten zu gedenken. Die Polizei und Büsch werden verantwortlich gemacht. Grass fordert die Studenten auf, die Ruhe zu bewahren und nicht die Methoden der Polizei zu übernehmen. Dutschke fordert den Rücktritt von Büsch, Albertz und Duensing.","Schwarze Fahnen vor der FU","","Studenten klagen Senat und Polizei an","Eigener Bericht",[7],1,[1],[4],1,"52","12"],["519","1967-06-04","Bericht über die Ereignisse des 3. Juni: Sondersitzung des Senates, versuchter Anschlag mit VW auf die Kolonne des Schah, Festnahme von Fritz Teufel, Beschreibung der Situation in der Krummen Straße folgt exakt den Angaben des Polizeiberichtes: Notwehrsituation.","Senat will hart durchgreifen","Demonstrationsverbote und Schnellgerichte - Anführer in Haft","Anschlag mit VW - Student erschossen","pf",[7],9,[1],[1],1,"32","1,2"],["520","1967-06-04","Großer Bericht über die Ereignisse des Freitagabends. Korrekt wird der Ermittlungsstand des Samstag wiedergegeben. Albertz und Sangmeister werden zitiert. ","FU-Student wurde durch Schuss eines Kriminalbeamten tödlich verletzt","","Sondersitzung des Senates - Alle öffentlichen Demonstrationen untersagt - Einsetzung von Schnellgerichten - Albertz appelliert an die Bevölkerung","Eigener Bericht",[7],8,[1],[1],2,"38","1,2"],["521","1967-06-04","Waffengebrauch sei letztes Mittel der Polizei, könne aber legitim sein. Albertz habe Recht, wenn er sagt, die Geduld der Stadt sei am Ende - allerdings nicht nur, was die extremen Gruppen vor allem an der FU angeht, sondern ebenso, was die politische Führung angeht. Über Jahre hinweg konnte man beobachten, wie sich gar nicht einmal kleine Gruppen bildeten, denen demokratische Methode zur Durchsetzung ihres Willens nicht mehr genügen. Die Politik habe versagt, ebenso die Universitätsleitung","Der erste Tote","","","J. B.",[7],8,[5],[5],2,"38","2"],["522","1967-06-04","Amtszeit des FU-Rektors Lieber geht zu Ende, aber noch ist kein Nachfolger in Sicht. Schuld daran sind Vorfälle wie zuletzt Störungen bei der Tagung des Ordens Pour le Mérite.","Hier will keiner Rektor sein","FU Berlin","","N.",[11],5,[5],[2],2,"36","3"],["523","1967-06-04","Darstellung der Vorgänge um Ohnesorgs Tod und des Demoverlaufs aus Sicht der ersten Polizeiverlautbarungen.","Erst Fußtritte - dann zogen sie die Messer","So kam es zum Tod des Studenten beim Schah-Besuch","","",[7],5,[1],[1],1,"36","8"],["524","1967-06-04","Kommentator findet deutsche Proteste gegen den Schah beschämend. Sie erinnerten an 1933. Wirft Demonstranten politische Einäugigkeit und Missbrauch des Demonstrationsrechts vor.","Sie schaden unserem Ruf","","","Stu.",[7],5,[5],[2],2,"36","8"],["525","1967-06-04","Drastische Maßnahmen des Senates, um weitere Ausschreitungen linksextremer Gruppen zu verhindern. Wie am Samstag bekannt wurde, sei Ohnesorg von einem Polizisten in Notwehr erschossen worden. Schilderung folgt der Darstellung des Polizeiberichtes. Schnellgerichte werden angekündigt. Albertz' Zitat, dass man sich nicht länger terrorisieren lasse.","Senat verbietet Demonstrationen. Polizist erschoss Student in Notwehr","Nach den Anti-Schah-Krawallen: Künftig Schnellgerichte gegen Randalierer","","N.",[7],5,[1],[1],2,"36","1"],["526","1967-06-05","Erste Aussage des Kripo-Beamten Kurras (namentlich noch nicht genannt). Er sei von 12 Studenten angegriffen worden, daraufhin habe er zwei ungezielte Warnschüsse abgeben, einer davon habe Ohnesorg als Querschläger getroffen.","Kripo-Beamter: Zwölf Mann griffen mich an!","","Erste Aussagen zum Tode des Studenten Benno Ohnesorg","rb",[7],2,[1],[1],1,"12","1"],["527","1967-06-05","Versammlungen und Demonstrationen am Tag nach dem Tod Benno Ohnesorgs. Studenten hätten BILD und BZ mitgeteilt, sollte die Polizei noch einmal auf sie schießen, würden sie zurückschießen.","Studenten drohen: Wir schießen zurück","","Sanfte Polizei-Welle/Überall Diskussionen","Klaus Heine und Peter Behrend",[7],2,[1],[1],1,"12","2"],["528","1967-06-05","Hinweis auf der Titelseite auf Texte im Heft, auf der Titelseite selbst keine weiteren Berichte.","Krise an der FU geht uns alle an!","Nach den Studenten-Krawallen","","",[7],6,[1],[5],2,"36","1"],["529","1967-06-05","Kommentator bezeichnet es als Trauerspiel, dass sich die Gesellschaft zu wenig um die Nöte der Mehrheit der hart arbeitenden Studenten kümmert. Das ist Nährboden für Hetzer. \"Noch ist die Krise zu meistern. Noch - aber es ist allerhöchste Zeit\". Die Ausschreitungen werden als \"Faschismus von links\" bezeichnet.","Das ist doch ein Trauerspiel!","Inspektor sagt:","","Inspektor (Werner Sikorski)",[7],6,[5],[1],1,"36","2"],["530","1967-06-05","Demonstrationen nach Ohnesorg-Tod. Auf Flugblättern wird Rücktritt des Bürgermeisters gefordert.","Flugblätter - Diskussionen","Unruhen in Berlin","","L.R.",[7],6,[1],[1],1,"36","3"],["531","1967-06-05","Beschreibung der Version des Tathergangs von Karl-Heinz Kurras (dieser wird namentlich nicht genannt).","Kripo-Beamter schoss zweimal","Unruhen in Berlin","","bt., U.D.",[7],6,[1],[5],2,"36","3"],["532","1967-06-05","Gedenkminute im FU-Senat, AStA sammelt Aussagen von Augenzeugen, Reaktionen verschiedener Verbände","Albertz beschwichtigte","Unruhen in Berlin","","P.R.",[7],6,[1],[1],1,"36","4"],["533","1967-06-05","Ausschreitungen der Studenten und Übergriffe der Polizei müssen juristisch geprüft werden. \"Radikalinskis\" verantwortlich, letztlich auch für den Tod Ohnesorgs. Es ist vom aufgepeitschten und aufgeputschten Mob die Rede.","Nicht Ursache und Wirkung verwechseln","","","Peer",[7],6,[5],[3],2,"36","4"],["534","1967-06-05","Deutliche Kritik an der Polizei, insbesondere am Prügeln bereits am Boden liegender Demonstranten und die falsche Lautsprecherdurchsage, dass ein Polizist tot sei.","Die Nerven verloren","Unruhen in Berlin","","Mü.",[7],6,[5],[1],1,"36","6"],["535","1967-06-05","Leserbriefe, die sämtlich die Studenten scharf kritisieren. Wiederholt Kritik an der Instrumentalisierung des Todes von Ohnesorg durch Studenten.","BZ-Leser schreiben zum Thema Demonstrationen","Unruhen in Berlin","","Leser",[7],6,[6],[4],1,"36","7"],["536","1967-06-05","Staatsanwaltschaft soll Ohnesorg-Tod klären. Unkommentierte Schilderung der Polizei-Version des Hergangs und von Studenten etc, die sich als Zeugen gemeldet haben. Demonstrationsverbot erlassen. Die Fortsetzung des Artikels auf Seite 3 schildert den Hergang der Unruhen noch einmal ausführlicher aus Polizeisicht. \"Der Regierende Bürgermeister Heinrich Albertz erklärte noch in der Nacht zum Samstag, der Tod Ohnesorgs gehe auf das Konto der Demonstranten.\" Gegenpositionen der studentischen Seite werden ausführlich dargestellt.","Albertz: Demonstrationen werden nicht mehr geduldet","Krawalle in Berlin","Widersprüche um den Tod des Studenten Ohnesorg","Co, wfm, ems",[1],4,[1],[5,1],1,"18","1,3"],["537","1967-06-05","Kommentator geht einseitig mit Demonstranten ins Gericht. Spricht den Studenten die \"moralische Verantwortung\" am Tode Ohnesorgs zu. Setzt sich kritisch mit dem \"Geisteszustand\" der \"anarchistischen Truppe\" um Treufel auseinander. Für \"Mao-Anhänger\" und Kommune-Mitglieder sollte an der FU Berlin kein Platz mehr sein.","Freiheit - kein Freibrief für Rowdies","","Der tödliche Schuss an der Oper. Polizei griff zu spät ein. Drakonische Maßnahmen nötig.","Bernt Conrad",[1],4,[5],[1],2,"18","2"],["538","1967-06-05","Stellungnahme des AStA: \"Wir stehen fassungslos vor der Lüge der Polizei, die den Mord als Notwehr bezeichnet, und aus fliehenden Demonstranten messerbewaffnete Angreifer macht.\"","Mit scharfen Worten verurteilt","","Stellungnahme des AStA","",[1],4,[1],[2],2,"18","3"],["539","1967-06-05","Stellungnahmen seitens des Senats zu den Vorfällen am 2. Juni 1967 und zum Tod Ohnesorgs. Zeugenaussagen. Reaktionen in der Uni.","Zeugenaussagen widersprechen Polizeibericht","","Diskussionen um die Ereignisse vor der Oper reißen nicht ab.","hae",[1],4,[1],[1],1,"18","9"],["540","1967-06-05","Offizielle und teils sehr kritische Stellungnahmen aus Politik und von Studentengruppierungen","Parteien und Organisationen nehmen Stellung","","","",[1],4,[1],[5],2,"18","9"],["541","1967-06-06","Leserbriefe aus allen Richtungen zum Schah-Besuch und den Vorkomnissen ","\"Raus! Randalierer gefährden Berlins Ruf\"","","","ka",[7],2,[6],[2],2,"12","2"],["542","1967-06-06","Generalstaatsanwalt kündigt Bildung einer Sonderkommission an, Büsch gibt Obduktionsbefund bekannt, Gerd Löffler wird zitiert. Ein Oberwachtmeister habe ihm gesagt: \"Warum hat der Kriminalbeamte geschossen, wir hatten den Demonstranten doch schon sicher.\" Konvent der FU verurteilt Stellungnahme von Albertz zynisch. Bundesregierung bedauert die Vorfälle, die zum Tod Ohnesorgs geführt haben.","Büsch: Ohnesorg starb an einem Schädelsteckschuss","","Sonderkommission gebildet","dpa Ap Upi + eigener Bericht",[7],1,[1],[5],2,"16","1"],["543","1967-06-06","Kritischer Leserbrief: Berlin sei bald keine Reise mehr wert, weil sozialistische Studenten und sozialistischer Senat gemeinsam den Ruf der Stadt untergraben würden.","Minderheit untergräbt den Ruf der FU","","","H.Ph., Berlin 37",[7],1,[6],[3],2,"16","2"],["544","1967-06-06","Kritischer Leserbrief: Die Demonstrationen am 2. Juni 1967 seien nicht nur ein Putsch gegen den Schah, sondern auch gegen die Berliner Bevölkerung gewesen. Die Ruhe und Sicherheit der Stadt sollen systematisch untergraben werden. Das lasse man nicht zu. ","Mit Empörung","","","K. H. Berlin37",[7],1,[6],[3],2,"16","2"],["545","1967-06-06","Kritischer Leserbrief: Was sich die Studenten anlässlich des Schah-Besuches geleistet haben, überschreitet alle Grenzen! Entfernt endlich diese Rowdys von den staatlichen Bildungseinrichtungen! Verteidigt den Beamten, weil der in Notwehr geschossen habe. Soll er erst warten, bis er erstochen wird? Wer spricht von den verletzten Polizisten? Höchste Zeit, dass energisch durchgegriffen wird.","Randalierende Studenten","","","W. L., Berlin 46",[7],1,[6],[3],2,"16","2"],["546","1967-06-06","Kritischer Leserbrief: Wer an bewusst provozierenden Aktionen teilnimmt, muss mit einem solchen Ende rechnen. Die anständigen Berliner sprechen den Polizisten von jeder Schuld frei.","Böses Ende","","","A. St., Berlin 31",[7],1,[6],[3],2,"16","2"],["547","1967-06-06","Sondersitzungen der Konvente von FU und TU. Einziger Tagesordnungspunkt: Trauerkundgebung. FU-Konvent fordert den Rücktritt von Albertz. Studenten verteilen bei Berliner Arbeitern Flugblätter, in denen diese aufgefordert werden, der Polizei eine Warnung zu erteilen. DGB-Chef Sickert nennt das unverantwortlich. ","FU-Konvent fordert Rücktritt von Albertz","","Rektor Lieber fährt zur Beerdigung Ohnesorgs","eigener Bericht / dpa / AP",[7],1,[1],[1],1,"16","14"],["548","1967-06-06","Bericht über die drei Versionen zum Tode Ohnesorg. 1. Notwehr, 2. Der Kriminalbeamte sei von Studenten im Wege der Nothilfe angegriffen worden, 3. Die Waffe sei ihm losgegangen.","Drei Versionen um den Tod von Ohnesorg","","","Eigener Bericht",[7],1,[1],[5],1,"16","14"],["549","1967-06-06","Sonderkommission der Staatsanwaltschaft zu Untersuchung der Unruhen eingesetzt","Untersuchung eingeleitet","Unruhen in Berlin","","K.B.",[7],6,[1],[1],2,"28","3"],["550","1967-06-06","Mit in Betrieben verteilten Flugblättern versuche der AStA, Arbeiter gegen Polizei \"aufzuhetzen\". DGB-Chef Sickert protestiert dagegen","Protest gegen Flugblätter","","","L.R.",[7],6,[1],[2],2,"28","3"],["551","1967-06-06","Fotoreportage mit Bildern, die unmittelbar vor den tödlichen Schüssen gemacht worden sind: Menschenmenge am Haus in der Krumme Straße, der abseits stehende Ohnesorg mit Polizei, der am Boden Liegende mit Polizisten. Text mutmaßt, dass die Bilder die Version des Schützen stützen könnten.","So starb Ohnesorg","","","",[7],6,[1],[5],1,"28","3"],["552","1967-06-06","Studenten wollen sich eine Woche lang mit den aktuellen Geschehnissen befassen","FU-Studenten streiken","","","Nic.",[7],6,[1],[2],2,"28","3"],["553","1967-06-06","Leserbriefe sehr unterschiedlichen Tenors. Die studentenkritischen weisen den Demonstranten vielfach die (Mit-)Schuld am Tod Ohnesorgs zu. Kritik auch an der Polizei und an der Berichterstattung","BZ-Leser schreiben zum Thema Demonstrationen","","","Leser",[7],6,[6],[4],1,"28","27"],["554","1967-06-06","Rechtliche Bewertung des von Albertz nach den Schah-Ausschreitungen verhängten Demonstrationsverbotes","Generelles Demonstrationsverbot unzulässig","","In jedem Einzelfall ist zu prüfen, ob Sicherheit und Ordnung gefährdet sind","Hans Schueler",[1],4,[5],[3],1,"22","2"],["555","1967-06-06","FDP fordert Einsetzung eines parlamentarischen Untersuchungsausschusses. Bericht über Ermittlungen und Vorgänge an den Unis.","Berliner FDP fordert Untersuchung","","Neue Studentenproteste gegen Tötung von Ohnesorg","Co, v.C.",[7],4,[1],[3],2,"22","1"],["556","1967-06-06","Ankündigung einer VDS-Kundgebung in Hannover","Trauer-Kundgebung am Tage der Beerdigung","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","","",[7],4,[1],[2],2,"22","4"],["557","1967-06-06","Stellungnahmen auf den Tod Ohnesorgs von Politikern, studentische Gremien, der Polizei etc. Dissens über Obduktionsgutachten. Bericht über FU-Konventssitzung.","Die Widersprüche über den Tod sind noch nicht aufgeklärt","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","Erregung und Emörung dauern an","",[1],4,[1],[1],2,"22","4"],["558","1967-06-06","Studentische Reaktionen und Maßnahmen in neun deutschen Hochschulstädten","Münchner Polizei: Wir sind hier liberaler","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","Demonstration der Studenten gegen Berliner Polizei genehmigt - Hochschüler blutig geschlagen","wfm, r.K., Sto., P.L.",[1],4,[1],[5],1,"22","4"],["559","1967-06-06","Protestkundgebungen in Kiel","Schweigemarsch und schwarze Fahnen","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","","H.A.,jw.",[1],4,[1],[2],2,"22","4"],["560","1967-06-06","Vorwürfe des Göttinger AStA zum Vorgehen der Berliner Polizei, Rücktrittsforderungen an Albertz.","\"Albertz soll zurücktreten\"","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","Göttingen: Demonstration ist ein legitimes Grundrecht","R.S.",[1],4,[1],[3],2,"22","4"],["561","1967-06-06","Scharfe Kritik an den Berliner Ausschreitungen. Schuldzuweisung an radikale Studenten. \"Gewiss, die Sicherheitsvorkehrungen der Polizei waren übertrieben und teilweise maßlos; auch das reizte, und doch gebietet die Gerechtigkeit festzustellen, dass in Westberlin studentische Cliquen eher für die Eskalation der Krawalle verantwortlich waren als die Ordnungshüter.\"","Protest","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","","Bernd Nellessen",[1],4,[5],[2],2,"22","4"],["562","1967-06-06","Erhebliche Unruhe an Unis in NRW","Ehrenwache auf dem Bonner Münsterplatz","Die Reaktion an den Hochschulen auf die Berliner Krawalle/Verbittert über die Polizei - aber auch Kritik an den Demonstranten","Unruhe in Nordrhein-Westfalen","frh.",[1],4,[1],[2],2,"22","4"],["563","1967-06-06","Sitzungen, Statements, Reaktionen von verschiedenen Berliner Gremien, insbesondere innerhalb des Senats und der SPD, zum 2. Juni 1967.","Nachspiel vor dem Parlament","","Innensenator und Polizeipräsident müssen sich verantworten","hae",[1],4,[1],[1],2,"22","11"],["564","1967-06-06","Auszüge aus der Resolution der außerordentlichen Sitzung des 19. Konvents der FU vom 5.6.67","FU-Konvent will gewaltlosen Widerstand","","","",[1],4,[1],[2],2,"22","11"],["565","1967-06-06","Scharfer Leitartikel zu den Unruhen und den Versäumnissen der Politik. Die Rede ist vom Terror einer Minderheit und von Radikalinskis, Dikatur der Straße.","Das ist keine Politik!","","","w.g.o.",[7],9,[5],[5],2,"12","3"],["566","1967-06-07","Kein klares Bild über Hintergründe der Tat, Reaktionen verschiedener Leute","Gegen 40 Personen wird ermittelt","","Der Tod des Studenten Ohnesorg: Noch keine Klarheit über die Hintergründe","kh",[7],2,[1],[3],2,"14","5"],["567","1967-06-07","Innensenator Büsch hat Zweifel an den Angaben des Todesschützen. SPD-Fraktion beschloss, einen Untersuchungsausschuss einzurichten. ","Zweifel am Bericht über Ohnesorg","","","Eigener Bericht",[7],1,[1],[2],2,"12","1"],["568","1967-06-07","Kritischer Leserbrief: Ereignisse vor dem Rathaus und der Oper schaden der Hauptstadt Berlin. Es muss eine Grenze von Freiheit und Demokratie geben!","Es muss endlich etwas geschehen","","","Theo Worina",[7],1,[6],[3],2,"12","2"],["569","1967-06-07","Kritischer Leserbrief: Zuviel Toleranz hat schon die Weimarer Republik zerstört. Kein vernünftiger Mensch nimmt der Regierung strengere Maßstäbe für junge Menschen übel.","Zuviel Toleranz","","","H. Weiche",[7],1,[6],[3],2,"12","2"],["570","1967-06-07","Kritischer Leserbrief: Mit Recht erging ein Demonstrationsverbot. Sollen sie doch rüber gehen. Wir Steuerzahler haben keine Lust mehr, diese kleine Minderheit zu finanzieren.","Lasst sie arbeiten","","","H. J. Berlin 42",[7],1,[6],[3],2,"12","2"],["571","1967-06-07","Generalstaatsanwalt Diether Dehnicke fordert die Studenten auf, bei der Aufklärung des Todes Ohnesorgs mitzuhelfen. Mahler kündigte eine Serie von Anzeigen gegen Polizeibeamte an. Vorwurf gegen Teufel: Rädelsführerschaft beim Landfriedensbruch.","Justiz: \"Es wird nichts vertuscht!\"","","Acht Staatsanwälte untersuchen Schah-Zwischenfälle","K.G. ",[7],1,[1],[1],1,"12","3"],["572","1967-06-07","DGB-Chef beklagt die lasche Handhabung des Demonstrationsverbotes, TU-Konvent fordert Rücktritt von Albertz.","Die Unruhe hält an","","Rücktritt von Heinrich Albertz gefordert","Eigener Bericht",[7],1,[1],[5],1,"12","3"],["573","1967-06-07","Vier FU-Studenten schreiben Brief an Hochschulgruppen. Ziel: Hilfe für Israel","Studenten rufen zur Hilfsaktion","","","l.r.",[9],6,[1],[1],1,"28","5"],["574","1967-06-07","BZ-Reporter konnte mit \"Karl-Heinz K.\" (Kurras) sprechen: Kann aus rechtlichen Gründen nicht ausführlich Stellung nehmen, bedauert den Tod, den er nicht gewollt habe. Hat selbst einige Verletzungen.","\"Ich habe seinen Tod nicht gewollt\"","Der Beamte, der den verhängnisvollen Schuss abgab:","","ö",[7],6,[3],[1],2,"28","6"],["575","1967-06-07","Bildunterschrift zu Foto von Trauerdemo in München mit Transparent \"Benno Ohnesorg + Politischer Mord\"","Protest","","","",[7],6,[5],[2],1,"28","6"],["576","1967-06-07","Kommentator setzt sich mit den juristischen Definitionen von Mord und Mörder auseinander.","Mord oder Rufmord?","","","Peer",[7],6,[5],[3],2,"28","6"],["577","1967-06-07","Planungen zum Trauerzug am folgenden Donnerstag","Über 8000 Studenten begleiten den Sarg","","","K.B.",[7],6,[1],[2],2,"28","6"],["578","1967-06-07","Leserbriefe. Teils studentenkritisch: verantwortlich am Tod Ohnesorgs sind die Studenten. Aber auch Kritik an Medien und den als zu studentenfreundlich empfundenen Inspektor-Kommentaren.","BZ-Leser schreiben zum Thema Demonstrationen","","","Leser",[7],6,[6],[4],2,"28","27"],["579","1967-06-07","Vier unabhängige FU-Studenten rufen zu Hilfe für Israel auf","Studenten: Hilfe für Israel","","","",[9],4,[1],[2],1,"22","13"],["580","1967-06-07","Fraktionen bereiten Anfragen vor, Senat eine Erklärung","Senat kündigt Erklärung an","","Krawalle werden untersucht","v.C.",[1],4,[1],[2],2,"22","1"],["581","1967-06-07","Leserbrief zum 2. Juni 1967: Polizei musste eingreifen. Tod von Ohnesorg geht zu Lasten der Demonstranten","Studentenkrawalle","","","Leser",[1],4,[6],[2],2,"22","2"],["582","1967-06-07","Provokationen und Eskalation seien bei Demos zunehmend eingeplant. Auch einige Dozenten seien daran mitschuldig. Gollwitzer hätte gesagt, die Studenten sollten nur ordentlich Rabatz machen, damit der Schah Berlin nicht mit Teheran verwechselt. ","Studentische Lust am politischen Rabatz","","Demonstrationen als Form der direkten Aktion - Die Radikalen tarnen sich als \"gute Demokraten\"","Günter Zehm",[1],4,[5],[3],1,"22","2"],["583","1967-06-07","In Erwartung der Senatsstellungnahme. Statements von unterschiedlichen Verbänden. Bischof Scharf spricht bei der Ohnesorg-Trauerfeier der TU. ","Senat gibt Erklärung ab","","Selbstkritische Stellungnahme vor Abgeordnetenhaus erwartet","vc, hae, fa",[1],4,[1],[1],2,"22","13"],["584","1967-06-07","Ankündigung der Überführung Ohnesorgs nach Hannover","Trauerkonvoi nach Hannover","","","",[1],4,[1],[2],2,"22","13"],["585","1967-06-07","Leserbriefe, unterschiedliche Tendenz","Stimmen aus der Bevölkerung","","Diskussion über den Tod des Studenten Benno Ohnesorg","6 Leserbriefe ",[7],8,[6],[4],2,"14","10"],["586","1967-06-08","Trauerfeier, Albertz und Büsch müssen draußen bleiben, Beerdigung im kleinen Kreis.","500 Fahrzeuge begleiten den Sarg des Studenten ","","","Hella Boschmann ",[7],2,[1],[1],1,"8","4"],["587","1967-06-08","Ausblick auf die Trauerfeier, zu der Albertz und Innensenator Büsch unerwünscht sind. Beim Trauerzug werden 10.000 Studenten erwartet. Der KOM (Kurras) habe zwei Anzeigen wegen Anstiftung zum Mord, versuchten Mord und weiterer, schwerer Delikte. Der Anwalt gibt seinen Namen bekannt: Karl-Heinz Kurras (irrtümlich als 40-jährig beschrieben).","Albertz nicht erwünscht","","Trauerfeier für Ohnesorg heute in der FU","Eigener Bericht",[7],1,[1],[3],2,"16","1"],["588","1967-06-08","Leitartikel des Chefredakteurs. Greift eine Rede von Professor Weischedel auf. Er habe Recht, wenn er gegen Rauchbomben etc. argumentiere. Nicht einer Meinung könne man mit Weischedel sein, wenn er beklage, dass am 2. Juni auch gegen \"friedliche Demonstranten\" \"nackte Gewalt\" eingesetzt worden sei. Die Demonstranten seien eben nicht friedlich gewesen. Unterstützt das Demonstrationsverbot, weil das die einzige Möglichkeit sei, die Situation zu beruhigen.Die Studenten sollten sich mit Senat und Uni-Leitung aussprechen. Köster betont, natürlich sei es nicht richtig, dass alle Studenten \"Radikalinskis\" seien. Aber an der FU hätten sie, jedenfalls was die Außenwirkung angeht, \"leider die Oberhand\" gewonnen.","Sachlichkeit - Gebot der Stunde","","","Köster",[7],1,[5],[2],2,"16","2"],["589","1967-06-08","18 Leserbriefe zu Ohnesorg und den Demonstrationen. Unterschiedliche Tendenz, überwiegend jedoch sehr kritisch gegenüber den Studenten, vier sind wohlwollend zu den Studenten.","Bürgerliche Ordnung in Gefahr?","Protest vieler Berliner gegen Studentendemonstrationen","\"Demonstrationen haben Sinn\"","zahlreiche",[7],1,[6],[4],2,"16","7"],["590","1967-06-08","Großer Bericht von der ersten von mehreren Trauerfeiern für Ohnesorg. Ausführlich wird Scharfs Rede zitiert. Weitere Stellungnahmen von Politikern mit Kritik an den Studentenunruhen.","\"Wir müssen in Berlin die Zerrissenheit überwinden\"","","Bischof Scharf zum Tode Ohnesorgs - Heute Trauerfeier in Dahlem","Eigener Bericht / dpa AP",[7],1,[1],[1],1,"16","14"],["591","1967-06-08","Ohnesorg-Trauerfeier in der TU","keine (Bildunterschrift)","","","dpa",[1],4,[1],[3],1,"18","1"],["592","1967-06-08","Leserin spricht sich für vermehrten Einsatz von Wasserwerfern gegen Randalierer aus","Kalte Dusche","","","Leserin",[1],4,[6],[2],2,"18","2"],["593","1967-06-08","Vor der Senatsdebatte zu den Unruhen: Polizei muss umsichtiger geführt werden, Disziplinarrecht der Unis muss überprüft werden.","Konsequenzen aus den Krawallen","","","Bernt Conrad",[1],4,[5],[5],1,"18","2"],["594","1967-06-08","Zitate der Scharf-Ansprache bei Gedenkfeier. AStA gegen Senatsteilnahme. RA Mahler verfügt über Tonband vom Geschehen vor der Oper. Reaktionen an anderen Unis.","Bischof Kurt Scharf: Die Zerrissenheit überwinden","Studenten","Trauerfeier für Benno Ohnesorg - Auseinandersetzung geht weiter","",[1],4,[1],[1],2,"18","6"],["595","1967-06-08","Nennung des Namens Kurras. Darstellung des Sachverhalts aus Sicht seines Verteidigers. Zitate vom Tonband, das bei der Demo aufgenommen worden war. Stellungnahmen und Aktionen an Hochschulen und Verbänden.","Zeugen hörten den Ruf: \"Bitte, nicht schießen!\"","","Erklärungen und Gegenerklärungen zum Tod von Ohnesorg","hae",[1],4,[1],[5],2,"18","11"],["596","1967-06-08","Leserbrief zweier Studenten, die sich gegen Rowdytum wenden","Demokratische Ordnung darf nicht unterhöhlt werden","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[1],2,"18","12"],["597","1967-06-09","Anreisser für den eigentlichen Bericht auf S. 5.","Berlins Polizeipräsident ließ sich beurlauben","","Bis zur Klärung der Studenten-Krawalle/Bericht Seite 5","k.a.",[7],2,[1],[1],2,"10","1"],["598","1967-06-09","Bericht von dem Auto-Konvoi für Benno Ohnesorg von der FU bis zum Zehlendorfer Kleeblatt","10.000 Studenten begleiteten den Sarg","","","rb",[7],2,[1],[2],1,"10","5"],["599","1967-06-09","Berliner Parlament tagt, verschiedene Reaktionen","Polizeipräsident Duensing ließ sich beurlauben","","Parlament debattierte sieben Stunden","Klaus Heine",[7],2,[1],[1],1,"10","5"],["600","1967-06-09","Debatte im Abgeordnetenhaus über den 2. Juni. Albertz: \"Die erdrückende Mehrheit unserer Mitbürger ist auf das Tiefste bedrückt.\" Innensenator Büsch verteidigte den Polizeieinsatz. Stein setzt sich für neues Hochschulgesetz ein.","Polizeipräsident geht vorläufig in Urlaub","","","Eigener Bericht",[7],1,[1],[5],1,"18","1"],["601","1967-06-09","Kommentar, der sich scharf gegen die Fehler der politischen Führung der Stadt richtet. \"Das Kind ist nun auf tragische Weise in den Brunnen gefallen, Benno Ohnesorg starb.\" Wenn Duensing geopfert werde, sei das eben ein Opfer für den Senat, der die politische Verantwortung trug und gegen den Rat des Polizeipräsidenten den südlichen Fußgängerstreifen nicht auch absperrte. ","Heute ja und morgen jein","","","Stiege",[7],1,[5],[2],2,"18","2"],["602","1967-06-09","Dokumentation der Ansprache bei der Trauerfeier im Audimax.","Dieser Tod soll nicht Quelle des Hasses sein","Prof. Loos auf der Trauerfeier für Ohnesorg","","Erich Loos",[7],1,[1],[4],1,"18","6"],["603","1967-06-09","Bericht von der Trauerfeier für Ohnesorg, ausführliche Zitate von Nevermann und Gollwitzer, der AStA-Vorsitzende Wilhelmer: Ohnesorgs Tod sei kein blinder und sinnloser Schlag des Schicksals. Daraus müsse jetzt gelernt werden.","Keine Vergeltung und Rache","","Wunsch der Witwe wurde erfüllt","Eigener Bericht",[7],1,[1],[5],1,"18","6"],["604","1967-06-09","Veranstaltung des Arbeitskreises christdemokratischer Polizisten, Motto: \"Die Polizei ist nicht der Prügelknabe für akademische Terroristen\". Bedauern für Ohnesorg. Scharfe Kritik am Senat. Die größere der beiden Regierungsparteien stelle sich hinter die \"Rowdys\". In Zukunft müsse nach dem Prinzip \"Wehret den Anfängen\" verfahren werden. ","Polizei hat das Wort","","","Eigener Bericht",[7],1,[1],[2],2,"18","6"],["605","1967-06-09","Resolution der Kirchlichen Hochschule, die zur Einhaltung der Mittel des gewaltlosen Widerstandes aufruft. Weiter wird an die Berliner Presse appelliert, \"verzerrende und diffamierende Berichterstattung zu unterlassen\". ","Studenten in eigener Sache","","","Eigener Bericht",[7],1,[1],[2],2,"18","6"],["606","1967-06-09","Ganzseite über Debatten im Abgeordnetenhaus mit vier Stücken, ausführlichen Zitaten, Notiz zur Einsetzung des Untersuchungsausschusses, auch SPD griff Albertz an, Opposition vermisste Selbstkritik.","\"Anspruch auf Hauptstadt nicht aufs Spiel setzen\"","Albertz an Studenten: \"Ohne Gäste können wir uns aufgeben\"","","Eigener Bericht",[7],1,[1],[4],1,"18","9"],["607","1967-06-09","Sammlung von Leserbriefen, größtenteils mit Kritik an Studenten.","Missverstandene Demokratie","Berliner diskutieren über Studentenrechte und -pflichten","","Ernst Reuter hätte sich für diese Studenten geschämt",[7],1,[6],[4],2,"18","11"],["608","1967-06-09","\"Friedliche Spaziergang-Demonstration\" auf Kudamm angekündigt. U. a. Freilassung Teufels gefordert.","Neue Demonstration","","","",[1],6,[1],[2],2,"40","3"],["609","1967-06-09","Bericht über die Trauerfeier Ohnesorgs, Zitate aus Reden. Verzögerung am Grenzkontrollpunkt weil FDJ noch nicht anwesend war. Am Kontrollpunkt Babelsberg-Ost Trauerkundgebung mit 4000 uniformierten Teilnehmern. Keine Grenzkontrollen.","Tausende gaben das letzte Geleit","","Ohnesorg nach Hannover überführt","Nic.",[7],6,[1],[1],1,"40","3"],["610","1967-06-09","Bericht über Abgeordnetenhaussitzung. \"Einsamkeit\" von Albertz. Dessen Kritik an nicht eingehaltenen Studentenzusagen. CDU-Kritik an Stein. ","Wie ist die FU noch zu retten?","Heiße Debatte im Berliner Abgeordnetenhaus:","","",[7],6,[1],[1],1,"40","2"],["611","1967-06-09","Auszüge aus Albertz-Rede: Student für viele ein Schimpfwort; Studenten wieder integrieren; Drahtzieher der Verschärfung suchen.","\"Bloß nicht pöbeln\"","","","",[7],6,[1],[3],2,"40","2"],["612","1967-06-09","Über das Bröckeln und Verschwinden des Demoverbots","Und wieder Demonstrationen","","Bevölkerung erwartet disziplinierten und würdigen Verlauf","tw",[1],4,[1],[2],2,"22","11"],["613","1967-06-09","Bericht über den Trauerzug mit mehr als 20000 Teilnehmern. Auszüge aus Gollwitzers Ansprache. Einige weitere Kommentare und Zitate.","Ergreifender Abschied von Benno Ohnesorg","","Ein kilometerlanger Trauerzug folgte dem Sarg","h",[7],4,[1],[1],1,"22","11"],["614","1967-06-09","Duensing-Beurlaubung, Senatsberatungen, Einsetzung des Ausschusses, Trauerfeier in der FU","Polizeipräsident Duensing beurlaubt","","Untersuchungsausschuss gebildet","Co, v.C.",[1],4,[1],[2],1,"22","1"],["615","1967-06-09","Kritik am Vorgehen der Polizei und an Albertz","Mehr Selbstdisziplin","","","Leser",[1],4,[6],[2],1,"22","2"],["616","1967-06-09","Leserbrief: Polizeieinsatz gegen \"studentischen Mob\" gerechtfertigt. Vergleich mit Maueropfern.","Straßenterror","","","Leser",[1],4,[6],[2],2,"22","2"],["617","1967-06-09","Ausführlicher Bericht über die Abgeordnetenhaussitzung zu den Schah-Demonstrationen","Albertz warnt vor einem Missbrauch der Freiheit","Berliner Abgeordnetenhaus","Objektive Untersuchung der Zischenfälle zugesagt - Die CDU übt harte Kritik","Co, v.C.",[1],4,[1],[4],1,"22","6"],["618","1967-06-09","In der Kirchlichen Hochschule werden Vermutungen geäußert, Polizeiaktion gegen Studenten sei möglicherweise geplant gewesen. ","Appell der Kirchlichen Hochschule","","Gegen Maßregelung politisch missliebiger Studenten","el",[1],4,[1],[2],2,"22","11"],["619","1967-06-09","Bußgeld bzw. Geldstrafe wegen Beleidigung und Widerstand bei Vietnamdemo im Dezember 1966","Widerstand war nur geringfügig","","Zwei Studenten kamen mit glimpflichen Strafen davon","Pd",[1],4,[1],[2],2,"22","11"],["620","1967-06-10","In Wohnung einer Ex-Verlobten wird eine Waffe von Kurras gefunden. Dieser gibt zu, das es seine ist, obwohl der Waffenbesitz verboten war. ","Der Kripo-Todesschütze hatte eine Privatwaffe","","Mit 1460 Schuß/ Ex-Verlobte informierte Polizei","M.B.",[7],2,[1],[1],2,"9","6"],["621","1967-06-10","Vorwürfe des Asta, Ärzte hätten an Todesursache Ohnesorgs herummanipuliert, wird auf das schärfste zurückgewiesen, Entschuldigung gefordert. ","Ärzte aus Moabit: Der AStA soll sich entschuldigen","","","k.a.",[11],2,[1],[2],2,"9","6"],["622","1967-06-10","Albertz betont in offenem Brief: Jeder Polizist wird von Führung gedeckt, wenn er sich an Gesetze hält. Haßgefühle dürfen nicht das Handeln bestimmen. ","Albertz: An die Gesetze halten","","","rb",[9],2,[1],[2],1,"9","6"],["623","1967-06-10","Schweigemarsch für Benno Ohnesorg in Hannover, keine Zwischenfälle","Schweigemarsch von 10.000 Studenten","","","",[1],2,[1],[2],1,"9","6"],["624","1967-06-10","Bericht über die Beisetzung Ohnesorgs im engsten Familienkreis. Vorher Überführung über die Interzonenautobahn. Das \"Zonenregime\" habe dies zum Anlass für eine große Propagandaschau genommen. Spruchbänder der FDJ werden zitiert. Brief von Albertz: Senat werde jeden Beamten decken, der seine schwere Pflicht erfüllt. Jedoch dürfe es keine Hassgefühle o.ä. geben. AStA beantragt Demonstration gegen Polizei und Senat.","Propaganda mit Ohnesorg","","Spruchbänder und FDJ begrüßen FU-Trauerkonvoi","Eigener Bericht dpa  UPI",[7],1,[1],[5],2,"12","1"],["625","1967-06-10","Sachlicher Bericht über die Beisetzung Ohnesorgs und Beileidstelegramme und -veranstaltungen.","Abschiedsworte am Grab von Benno Ohnesorg","keine ","","Eigener Bericht dpa",[7],1,[1],[5],1,"12","12"],["626","1967-06-10","Albertz bekundet Polizisten Solidarität","Albertz-Brief","","","",[1],6,[1],[2],2,"24","3"],["627","1967-06-10","Hinweis auf Texte im Heft","Skandal um den Kripo-Obermeister","Peinliche Entdeckung nach dem Todesschuss an der Oper","Illegale Waffe und Munition versteckt. Ex-Verlobte übergab den Fund der Polizei.","",[7],6,[1],[3],2,"24","1"],["628","1967-06-10","Fund einer polnischen Pistole und 1460 Schuss Munition in ehemaliger Wohnung von Kurras. Angehängter Kommentar wundert sich über die Entdeckung gerade jetzt. Kritisiert Kurras jedoch auch ausdrücklich.","Pistole und Munition gefunden","Peinliche Entdeckung in der ehemaligen Wohnung des Kriminalbeamten","","bt., togo, Mü.",[7],6,[1,5],[3],2,"24","3"],["629","1967-06-10","Würdigung Ohnesorgs und Erwägung der Lehren, die aus dem Geschehenen gezogern werden müssten.","Wenn dieser Tod einen Sinn hat?","","","ro",[7],6,[5],[1],1,"24","3"],["630","1967-06-10","Arzt widerspricht AStA-Vorwürfen des Manipulationversuchs","Chefarzt","","","",[7],6,[1],[2],2,"24","3"],["631","1967-06-10","Asta überrascht über Ost-Trauerfeier","Der AStA ist \"überrascht\"","","","",[7],6,[1],[2],2,"24","3"],["632","1967-06-10","Mutmaßung darüber, dass Lieber sich nicht wiederwählen lassen wird.","Rektorenwahl an der FU mit Spannung erwartet","","","v.C.",[11],4,[1],[2],2,"28","1"],["633","1967-06-10","Information über Beisetzung Ohnesorgs. Kritik von Helmut Schmidt am Polizeieinsatz am 2. Juni.","Benno Ohnesorg wurde in aller Stille beigesetzt","","7000 Studenten nahmen am Schweigemarsch in Hannover teil","",[7],4,[1],[5],2,"28","1"],["634","1967-06-10","Vier Texte. A) zum Studentischen Kongress \"Hochschule und Demokratie\" in Hannover, bei dem Erich Kuby der Polizei u. a. eine \"zynische Aktion zur physischen Ausrottung\" der Studenten unterstellt hat. B) über einen Schweigemarsch von 7000 Studenten. C) ein Bericht über die Fahrt über die Transitstrecke inkl. Ehrenbezeugung der FDJ. D) eine Schilderung der Fahrt durch Hannover und von der Beisetzung.","Der Abschied von Benno Ohnesorg","Trauerdemonstration, schwarze Fahnen, Schweigemarsch","Mahnung am Grabe: Angst und Hass dürfen nicht die Oberhand gewinnen","Bernd Nellessen, Rolf Seufert, Wolfgang Fahlke (UPI), Eberhard Nitschke",[7],4,[1],[1],1,"28","4"],["635","1967-06-10","Kommentar zum Redebeitrag des MdA Lummer zur Abgeordnetenhaussitzung","Kritik","","","Co.",[1],4,[5],[2],2,"28","2"],["636","1967-06-10","Ergänzung zum Zehm-Kommentar vom 7.6. 67","Herausforderung","","","Leser",[1],4,[6],[2],1,"28","2"],["637","1967-06-10","Fehler der Polizei war der Zeitpunkt des Eingreifens","Die Polizei hat zu spät gehandelt","","","Leser",[1],4,[6],[2],2,"28","2"],["638","1967-06-10","Stimmungsbericht zur angespannten Situation an der FU","Student sein, wenn die Hiebe fallen","Proteste, Plakate und Boykott","Nach den Tumulten - Die Stimmung an der FU","Hans-Wolfgang Sternsdorff",[1],4,[7],[4],1,"28","5"],["639","1967-06-10","Sammelartikel zu Schülerdiskussionen, zu abgesagter Studentendemo, zur Arztantwort auf Vertuschungsvorwürfe im Zusammenhang mit Ohnesorg-Tod und zur Beileidsbekundung der Pädagogischen Hochschule an Ohnesorg-Witwe.","Diskussionen nun auch in den Oberschulen","","Schulsenator stimmt zu - \"Spaziergangdemonstration\" abgesagt - Chefarzt weist Vorwürfe zurück","",[1],4,[1],[3],2,"28","9"],["640","1967-06-10","Aus dem Brief von Albertz an die Mitarbeiter der Berliner Polizei.","\"Keine Hassgefühle gegen Studenten\"","","Albertz an Polizeiangehörige","",[1],4,[1],[2],2,"28","9"],["641","1967-06-10","Zusammenstellung des Ausschusses. Personalie Duensing. Verfahren gegen Kurras. FDP-Streit um Borm.","Untersuchungsausschuss soll zunächst prüfen","","","v.C.",[7],4,[1],[2],2,"28","4"],["642","1967-06-10","Die Debatte im Abgeordnetenhaus weist neue Wege. Keine Pauschalierungen, sondern Vernunft ist das Gebot der Stunde","Nichts darf beim Alten bleiben!","","keine ","w.g.o.",[7],9,[5],[2],2,"12","2"],["643","1967-06-10","Kommentar über die Machtspiele in der SPD. Die angedachte Kandidatur von Innensenator Büsch für den Vorsitz wackelt. Seine innerparteilichen Gegner seien freilich gewarnt, die Krawalle beim Schah-Besuch zu instrumentalisieren. \"Die Meinung des AStA der FU ist dabei nicht von Belang. Er beschließt und fordert vieles, was mit seinen eigentlichen Aufgaben nichts zu tun hat. Welche Konsequenzen ziehen eigentlich die Studenten-Funktionäre? Sie werden sich hoffentlich durch Duensings Beurlaubung nicht in dem Fehlschluss bestärkt sehen, sie hätten alles n ur den anderen vorzuwerfen.\" \"Was haben die Studenten inzwischen unternommen oder geplant, um ihrerseits Exzessen vorzubeugen? Genügt ihnen der Konsensus mit der Bevölkerung, dass Steine und Eier keine Argumente seien? (...) Wir hören gern  auch Selbstkritik aus dem Auditorium Maximum.\"","Konsequenzen - aber welche?","","","Matthes",[7],8,[5],[2],2,"16","1"],["644","1967-06-11","Fünf Leserbriefe zu den aktuellen Ereignissen, u.a. zur FDJ-Propaganda und zum Thema Polizeinummern sowie allgemein. Überwiegend kritisch zu den Studentenunruhen.","Hatten sie nicht daran gedacht?","","","mehrere Leser",[7],1,[6],[3],2,"52","2"],["645","1967-06-11","Ganze Seite mit Berichten über die Debattieraktion auf dem Kudamm, mit Beistellern.","Studenten werben auf der Straße","Die \"Heilsarmee\" ist das Vorbild der akademischen Aktionsgruppen","Stimmen von Politikern zur großen Diskussion","Eigener Bericht",[7],1,[1],[4],1,"52","12"],["646","1967-06-11","800 FU-Studenten diskutierten auf dem Kudamm mit Passanten über die Ereignisse des 2. Juni und die Folgen. Auch Polizisten diskutierten mit. Alles blieb ruhig. SPD-Chef Mattick: Gutwillige sozialrevolutionäre Ideen größerer Studentengruppen werden von einer terroristischen studentischen Minderheit missbraucht.","Debattieraktion am Kurfürstendamm","","","Eigener Bericht dpa",[11],1,[1],[2],2,"52","1"],["647","1967-06-11","Demo mit Diskussionsgruppen auf dem Kudamm trotzt Demoverbots, bei der es zu Verkehrsbehinderungen kam. Reaktionen von Bürgermeister Albertz und SPD-Chef Mattick: \"Wer weiter den Terror auf die Straße trägt, kämpft nicht für Freiheit und Demokratie.\"","8 Studenten festgenommen. Sie störten den Verkehr.","","","N.",[1],5,[1],[2],2,"36","2"],["648","1967-06-11","Vorstellung des neuen FU-Rektors und anderer FU-Amtsinhaber","Prof. Harndt FU-Rektor","","Ordinarius für Zahnheilkunde wurde gewählt","",[11],5,[1],[2],1,"36","31"],["649","1967-06-11","Kommentator sieht drohendes Zerwürfnis zwischen Bevölkerung und Studentenschaft und beleuchtet die \"bedauerliche Entwicklung\". Fazit: \"Nein, Freunde! Der Werbefeldzug um die Gunst der Bevölkerung wird scheitern, wenn die Studentenschaft in falscher Solidarität mit den krawallfreudigen Terroristen verharrt.\"","Mit Farbtöpfen und Tomaten kann man nicht überzeugen?","","Studenten im Streit mit dem Staat","Herbert Hausen",[1],5,[5],[1],1,"36","7"],["650","1967-06-11","Lemmer versucht mit gravitätischem Aufruf an die Studenten, diese zur Vernunft zu bringen.","Lasst es jetzt genug sein!","","","Ernst Lemmer",[1],5,[5],[5],2,"36","7"],["651","1967-06-12","Neue Rektoren bei TU und FU","Neue Rektoren an FU und TU","","","k.a.",[11],2,[1],[2],2,"10","4"],["652","1967-06-12","Demo von acht Studenten mit der Forderung \"Albertz abtreten\"","Buchstaben-Ballett am Kudamm","","","",[1],6,[5],[5],1,"32","3"],["653","1967-06-12","Zuletzt viele Demos und Diskussionen sachlich. Abgrenzung von \"Radaubrüdern\". Einige westdeutsche Zeitungen kritsieren West-Berliner (Springer-)Presse, offenbar um selbst Studentenabos zu verkaufen.","Ruhe heißt nicht Friedhofsruhe","","","Peer",[1],6,[5],[5],2,"32","3"],["654","1967-06-12","Beispiele aus Gesprächsrunden auf dem Kudamm. Bemerkenswerte Sachlichkeit wird konstatiert, lediglich ein Verkäufer des Extra-Blatts sei aus dem Rahmen gefallen.","Die \"Arena\" reichte vom Kranzler bis zum Kempinski","","Studenten bemühen sich um informative Gespräche mit Passanten","Hans-Erich Bilges",[1],4,[1,5],[3],2,"20","11"],["655","1967-06-12","Kommentar zu Wahl des neuen FU-Rektors","Ewald Harndt","","","v.C.",[11],4,[5],[2],2,"20","2"],["656","1967-06-12","Leser äußert Sympathie für Studentenreaktionen nach Ohnesorg-Tod, nicht aber für einige ihrer Demonstrationen","Augenmaß","","","Leser",[1],4,[6],[2],2,"20","2"],["657","1967-06-12","Leser pflichtet Conrad-Kommentar vom 2.6. bei","Der legitime Platz","","","Leser",[1],4,[6],[2],2,"20","2"],["658","1967-06-12","Radikalisierung der Studenten beim Kongress in Hannover nach Ohnesorgs Tod. Erwähnung von Dutschkes \"Staunen erregender Eloquenz\".","Die Saat der Radikalen geht auf","","","Bernd Nellessen",[1],4,[1,5],[3],1,"20","2"],["659","1967-06-12","Fernsehaufruf von Albertz zu Ruhe und Besonnenheit. Personalien FU und TU. Diskussionen in den Berliner Parteien.","Gespräche zwischen den Beteiligten gefordert","Studenten","Mattick: Von radikaler Minderheit trennen - Neue Rektoren an FU und TU","v.C.",[1],4,[1],[1],2,"20","4"],["660","1967-06-13","Neue Auflagen für Proteste von Studenten, Demo genehmigt, unter Auflagen, Vorwurf der Studenten gegen Polizisten bei Schah-Besuch, Strafanzeige. ","Studenten dürfen protestieren! Aber: Rasen nicht betreten","Senat","","rb",[1],2,[1],[3],2,"10","5"],["661","1967-06-13","Um 14 Uhr beginnt AStA-Demo gegen Polizei und Senat. Das sei ein \"Testfall\" für die friedlichen Absichten. Scharfe Auflagen.","Senat: Demonstration ist ein \"Testfall\"","","","Eigener Bericht",[11],1,[1],[5],2,"12","1"],["662","1967-06-13","Höchstmaß an Geduld und Mäßigung seitens des Senates. Demonstration ist große Chance für die Studentenschaft. Ohnesorgs Tod war tragisch und völlig sinnlos. Jetzt scheint Bewegung in die Mehrheit der Studentenschaft gekommen zu sein. Stiege hofft, dass es kein neues Fiasko geben wird.","Ein Testfall","","","Stiege",[11],1,[5],[2],2,"12","2"],["663","1967-06-13","Vorschau auf die genehmigte Demo. AStA gibt bekannt, 62 Zeugenaussagen gesammelt zu haben. Kommune I wird angeklagt wegen der Flugblätter. Scharfe Kritik an Erich Kuby.","Provokationen dürfen nicht sein","","","Eigener Bericht",[11],1,[5],[1],1,"12","6"],["664","1967-06-13","Senat hebt generelles Demoverbot auf. Neue Demos beantragt.","Demonstration heute in Charlottenburg","","","",[1],6,[1],[2],2,"24","4"],["665","1967-06-13","Text eines Politologiestudenten der FU, der nicht die Meinung der Redaktion wiedergibt. Ihm wird Forum geboten, um das öffentliche Gespräch zu fördern. Autor kritisiert Schah-Regime, plädiert für sachliche Auseinandersetzung von Studenten und Gesellschaft, wehrt sich gegen einseitige Schuldzuweisungen.","Der Schah, wir Studenten und Sie","","","Gerhard Maurer",[7],6,[5],[1],2,"24","4"],["666","1967-06-13","Anzeige gegen Duensing u.a. wegen des Vorgehens der Polizei am 2.Juni.","AStA erstattet Strafanzeige","","","",[7],6,[1],[2],2,"24","4"],["667","1967-06-13","Vom FU-AStA beantragte Demo genehmigt. Anzeige wegen Körperverletzung gegen Polizeipräsidenten.","Senat genehmigt Demonstration","","AStA zeigt Duensing an","v.C.",[1],4,[1],[2],2,"18","1"],["668","1967-06-13","Demo in Charlottenburg genehmigt. Diskussionen in den Unis und bei Politikern. Vermehrt Albertz-Rücktritt gefordert. Resolution von Medizinstudenten zum Ohnesorg-Tod.","Studenten dürfen heute demonstrieren","","Innensenator Büsch: Wir müssen aus dem Teufelskreis ausbrechen","eb",[1],4,[1],[1],2,"18","11"],["669","1967-06-13","Vorstellung der neuen Rektoren Hanrdt (FU) und Weichselberger (TU)","Die beiden neuen Magnifizenzen","","Berliner Universitäten wählten ihre neuen Rektoren","bi",[11],4,[1],[5],1,"18","11"],["670","1967-06-13","15 Leserbriefe mit unterschiedlicher Tendenz, überwiegend kritisch zu den Studenten","DEMOKRATISCHES FORUM","Demokratisches Forum","zahlreiche","Leser",[11],8,[6],[4],1,"14","11"],["671","1967-06-14","Demo von Studenten, eher ausgelassen, fordern bei anschließender Kundgebung Freilassung Teufels.","Demonstration unter Bettlaken","","","hb",[1],2,[1],[2],1,"10","4"],["672","1967-06-14","Staatsanwälte schauen sich TV-Aufnahmen an zwecks Untersuchung, weitere Zeugen sollen verhört werden, Teufel sitzt in U-Haft","Studenten-Tod: Im Kino forschten 8 Staatsanwälte","","Demonstranten im Film durchleuchtet","rb",[7],2,[1],[1],2,"10","4"],["673","1967-06-14","Zwölf Staatsanwälte befassen sich mit den Vorgängen bei der Anti-Schah-Demonstration, allein drei ermitteln gegen Kurras. Gegen Teufel wird wegen Aufforderung zu einer schweren Straftat ermittelt, er sitzt weiterhin in Haft.","Schon 30 Zeugen im Fall Ohnesorg vernommen","","Hochbetrieb bei der Staatsanwaltschaft","Eigener Bericht",[7],1,[1],[5],2,"12","5"],["674","1967-06-14","Demonstration verlief ohne Zwischenfälle. Ein Redner nannte die Auflagen \"idiotisch und diskriminierend\". Dagegen protestierten die Demonstranten, indem jeweils ein \"Demonstrant\" auf 50 \"Ordner\" kam.","Mehr \"Ordner\" als Demonstranten","","","Eigener Bericht",[11],1,[1],[2],2,"12","1"],["675","1967-06-14","Bericht über die Demo mit 3000 Teilnehmern. Im Beisteller werden wichtige Sprecher des SDS (Dutschke, Lefevre, Ströhle) zitiert, Untersuchungsausschuss konstituiert sich.","Parolen an Mützen und Regenschirmen","","Studentendemonstration ohne Krawall","MM / K.G. ",[11],1,[1],[1],1,"12","5"],["676","1967-06-14","Demoauflagen werden konterkariert mit je 50 Ordnern pro einem Demonstranten. Beteiligung von Mitgliedern der Kommune I. Freilassung Teufels gefordert.","Demonstration der Ordner","","4000 Studenten der Ordner","bor",[1],6,[7],[1],1,"28","6"],["677","1967-06-14","Anklagen wegen Anstiftung zur schweren Brandstiftung und wegen gewalttätigen Landfriedensbruchs","Anklage gegen Fritz Teufel","","","L.R.",[5],6,[1],[2],2,"28","6"],["678","1967-06-14","Demo mit 4000 Teilnehmern: 50 \"Ordner\" pro \"Demonstrant\"","Mit zahlreichen Insignien unübersehbaren Spotts","","","",[1],4,[1],[2],1,"20","1"],["679","1967-06-14","Leser spricht heutigen Studenten mit Verweis auf Geschister Scholl Ernsthaftigkeit ihrer Absichten ab.","Das Beispiel der Geschwister Scholl","","","Leser",[1],4,[6],[2],2,"20","2"],["680","1967-06-14","Bericht über Stand der Ermittlungen. Stand der Zusammensetzung des Untersuchungsausschusses. Studentendemo mit mehr Ordnern als Demonstranten. Aussage Dutschkes, dass eine echte Demokratisierung Berlins nur durch Aktionen der Studentenschaft gewährleistet werden könne.","Zwölf Staatsanwälte untersuchen die Krawalle","Berlin","Sonderkommission verstärkt - Studenten verulken Senatsappell","v.C., hae., Bi.",[1],4,[1],[1],2,"20","6"],["681","1967-06-15","Zahl der Verletzten bei Schah-Besuch, Parlamentsausschuß wird eingesetzt, Fritz Teufel weiter in U-Haft, 34 Verfahren gegen Demonstranten und Polizei","Drei Demonstranten noch im Krankenhaus ","","Senat: 75 Verletzte bei Schah-Tumulten","hb",[7],2,[1],[2],2,"8","4"],["682","1967-06-15","SPD überlegt Duensing aus Partei auszuschließen","Ausschluß aus der Partei?","","","rb",[7],2,[1],[2],2,"8","4"],["683","1967-06-15","Mitglieder des Konvents klagen vor dem Verwaltungsgericht gegen das beanspruchte \"politische Mandat\" des Studentenparlaments. Erster Staatsanwalt Voigt, der auch die Beschlagnahme der SDS-Kartei verantwortet habe, soll vom Fall Ohnesorg abgezogen werden, fordern Studentenvertreter. Extreme Studentengruppen hatten angekündigt, den Kudamm zu blockieren, falls Teufel nicht freigelassen werde.","Studenten verklagen Konvent","","Gegen politische Resolutionen - Drohen neue Krawalle?","Eigener Bericht",[11],1,[1],[3],2,"16","3"],["684","1967-06-15","Fritz Teufel, wegen Landfriedensbruch in U-Haft, kommt nicht auf freien Fuß. Duensing soll aus SPD ausgeschlossen werden. Studenten legen Dokumentation vor.","Haftverschonung für Teufel abgelehnt","","","Eigener Bericht",[5],1,[1],[2],1,"16","1"],["685","1967-06-15","Kommentator plädiert für Entwaffnung von Polizisten bei Demonstrationen. \"Einen zweiten Fall Ohnesorg darf es nicht geben!\"","Gehört die Pistole wirklich dazu?","","","Peer",[7],6,[5],[1],2,"28","7"],["686","1967-06-15","Untersuchungsausschuss soll Unruhen bei Schah-Besuch behandeln.","Fritz Teufel bleibt in Haft!","Untersuchungsausschuss einberufen. 75 Verletzte bei Schah-Besuch. Richter entschied:","","L.R.",[7],6,[1],[1],2,"28","6"],["687","1967-06-15","Zwei zum rechten Flügel der Studentenschaft gehörende Mitglieder des FU-Konvents wollen gerichtlich die Rechmäßigkeit eines politischen Mandats des Gremiums prüfen lassen.","Musterprozess gegen den FU-Konvent angestrengt","","Zwei Mitglieder klagen. Gegen jedes politische Mandat.","Klaus Haetzel",[11],4,[1],[1],2,"16","9"],["688","1967-06-16","Asta nimmt Vorwürfe gegen die Moabiter Ärzte wegen Ohnesorg mit Bedauern zurück","AStA nahm Vorwürfe zurück","","","rb",[7],2,[1],[2],2,"10","2"],["689","1967-06-16","Leserbrief: Studenten wollten gar nicht ernsthaft diskutieren, das zeige die letzte Demonstration auf dem Theodor-Heuss-Platz. Die Stehkonvente auf dem Kudamm reichten, man wolle endlich wieder ungehindert flanieren.","Keine ernste Diskussion","","","E.G.K., Berlin 45",[11],1,[6],[3],2,"16","2"],["690","1967-06-16","Vertreter des VDS und der Bonner SPD-Spitze trafen sich im Bundeshaus. Man wurde sich in der Beurteilung der Vorfälle am 2. Juni 1967 nicht einig. Helmut Schmidt nahm die Polizei gegen pauschale Verdächtigungen in Schutz","Differenzen mit Studenten","","Stundenlanges nächtliches Gespräch mit dem SPD-Präsidium","dws",[11],1,[1],[3],2,"16","2"],["691","1967-06-16","Gerd Löffler eröffnet die Arbeit des parlamentarischen Untersuchungsausschusses. Staatsanwaltschaft stellt alle Verhörprotokolle zur Verfügung, schon mehr als 400 Blatt. Lefevre wehrt sich dagegen, dem Untersuchungsausschuss die Akten des Konvents zur Verfügung zu stellen, muss das aber dennoch laut Gerichtsbeschluss tun. Falken fordern Albertz' Rücktritt.","Universität muss Akten herausgeben","","Untersuchungsausschuss begann mit seiner Arbeit","Eigener Bericht",[11],1,[1],[1],1,"16","6"],["692","1967-06-16","SPD unter Willy Brandt diskutiert sechs Stunden mit 100 Asta-Chefs","SPD-Gespräch mit AStA-Chefs","","","",[11],6,[1],[2],2,"36","2"],["693","1967-06-16","Konstituierung unter Gerd Löffler","Studenten-Akten fehlen noch","","Untersuchungs-Ausschuss tagte","Klaus Bär",[7],6,[1],[1],2,"36","5"],["694","1967-06-16","Albertz wünscht Verbesserung des Verhältnisses zu Studenten. Disziplinarordnung und studentische Mitwirkung in den Unis soll nicht nachteilig verändert werden.","\"Feindverhältnis zu Studenten abbauen\"","","WELT-Gespräch mit Albertz","Co.",[9],4,[1],[2],2,"28","1"],["695","1967-06-16","Eher ein Bericht über die Befindlichkeit von Albertz. Wenige konkrete Aussagen. Hass müsse überwunden werden.","\"Eine Brücke über den Graben schlagen\"","Studentische Opposition","WELT-Gespräch mit dem Regierenden Bürgermeister - Keine Konzessionen an die Radikalen","Bernt Conrad",[9],4,[1],[1],1,"28","3"],["696","1967-06-16","Gesprächsvorhaben von Peter Lorenz","Berlins CDU will mit Studentenvertretern sprechen","","","",[9],4,[1],[2],2,"28","9"],["697","1967-06-16","Der AStA der FU nimmt den Vorwurf der Vertuschung gegenüber den Gerichtsmedizinern, die den Leichnam Ohnesorgs untersuchten, zurück.","AStA nahm Vorwürfe gegen Ärzte zurück","","","",[7],4,[1],[2],2,"28","9"],["698","1967-06-16","Unterscheidet bei Schah-Demo überzeugte Demonstranten von Demonstranten aus Langeweile und \"berufsmäßigen Unruhestiftern\".","Unruhestifter","","","Leser",[1],4,[6],[2],2,"28","2"],["699","1967-06-16","Studenten bewerten Vorgänge am 2. Juni nicht als Kette unglücklicher Zufälle, sondern als Versagen der Demokratie","Diskussion in der FU: Versagen der Demokratie","","","hws.",[1],4,[1],[2],2,"28","3"],["700","1967-06-16","SPD stellt sich nicht hinter Senatserkärung zum 2. Juni","SPD: Keine Identifizierung mit Albertz","","Gespräch über Demonstrationen","ems.",[9],4,[1],[2],2,"28","3"],["701","1967-06-16","Karikatur: Ein Fidel Castro nachempfundener Student mit Gewehr und Handgranaten will per Anhalter nach Berlin","Mao-Mao","","","",[9],4,[5,4],[2],1,"28","VI"],["702","1967-06-16","Gespräch über Unruhen zwischen Polizisten, Abgeordneten, Gerwerkschaftern auf einem Rheindampfer. \"Benno Ohnesorg fuhr unsichtbar mit auf der 'Wiesbaden'\"","Freund und Helfer auch der Studenten","Öffentliche Sicherheit","Nur zögernd sprechen die Polizisten über die Krawalle","Rudolf Orlt",[1],4,[1],[3],2,"28","3"],["703","1967-06-17","Wissenschaftssenator Stein legt Entwurf für neues Hochschulgesetz vor. Kritik von Professoren","FU-Krise ohne Einfluss auf neues Universitätsgesetz","","Disziplinarrecht unverändert - Mehr Macht für den Rektor","Go",[11],1,[1],[1],2,"48","5"],["704","1967-06-17","AStA zieht Zusage zu Diskussion über Ereignisse beim Schah-Besuch zurück. Offizieller Grund: Voraussetzung des Gespräches sei eine direkte Einladung der politisch Verantwortlichen an die Studenten zu einer Auseinandersetzung in aller Öffentlichkeit. Wahrer Grund sei wahrscheinlich: Der Vertreter des Senates, Bürgermeister Streik, war nicht bereit, sich im Vorfeld von Heinrich Albertz zu distanzieren, wie der AStA forderte. Das wies Wilhelmer von sich","FU-AStA lehnt Diskussion ab","","","Eigener Bericht / dpa",[11],1,[1],[2],2,"48","1"],["705","1967-06-17","Kurzportrait Dutschkes und seiner politischen Linie","Rudi Dutschke wiegelt auf","","","Fred Schaffert",[2],5,[5],[2],1,"34","4"],["706","1967-06-17","Der Autor versucht, insbesondere anhand von Zitaten von Reimut Reiche, die Absichten und die Strategie des SDS darzustellen.","Berlin als Exerzierfeld für Revolutions-Modelle","","Ein Report über die Ideologen des SDS","Joachim Neander",[8],5,[5],[1],1,"34","4"],["707","1967-06-19","Bericht von Senatskundgebung. Am Ende Hinweis auf Gegenveranstaltung des AStA der FU mit Redner Krippendorff. Sagt:\"17. Juni sein eine Waffe des Kalten Krieges.","Kundgebung vor dem Rathaus","Am Tag der Deutschen Einheit","","P.R.",[1],6,[1],[1],1,"40","5"],["708","1967-06-19","Ablehnung der 17. Juni-Rituale, DDR-Lob, Eintreten für Teufel, Forderung nach Sturz der Regierung etc. Themen einer Veranstaltung des FU-AStA und des Republikanischen Clubs in der Neuen Welt. U. a. Krippendorff und Dutschke als Redner erwähnt. Anmerkung der Redaktion: Anm. der Red.: \"Die Existenz der Mauer, der sowjetzonalen Wachttürme und Maschinengewehre wurde von keinem Redner erwähnt.\"","\"Die Regierung muss gestürzt werden\"","","AStA-Veranstaltung am Tag der Deutschen Einheit","heb",[11],4,[1],[2],2,"22","11"],["709","1967-06-19","Parlamentsdebatte über Schahdemo: Tragen von Dienstnummern soll Pflicht werden. Studentin erstattet Anzeige, weil sie mit Gummiknüppeln geschlagen worden sei. Münchner Professoren schließen sich Berliner Professorenprotest gegen Vorkommnisse am 6. Juni an. Hinweis auf Veranstaltung u. a. mit Grass in der TU.","Sichtbare Dienstnummern sind \"psychologische Bremse\"","","Parlamentarier: Neue Bestimmungen für Polizisten - Studentin klagt gegen Duensing","wt",[9],4,[1],[3],2,"22","11"],["710","1967-06-19","Widerspricht Nellessen-Kommentar vom 12.6. Das Vokabular der Radikalen sei nicht geeignet, Breitenwirkung zu erzielen.","Die Radikalen","","","Leser",[1],4,[6],[2],2,"22","2"],["711","1967-06-19","Ankündigung einer Veranstaltungsstörung. Offener Brief aus dem Raum der evangelischen Kirche","Studenten wollen Debatte erzwingen","Berlin","Hungerstreik und Verkehrs-Chaos zugunsten Teufels empfohlen","",[5],4,[1],[2],2,"22","4"],["712","1967-06-19","Bericht über Mandatsverteilung","TU wählte Studentenparlament","","","",[11],4,[1],[2],2,"22","11"],["713","1967-06-20","Portät des Psychologen, äußert sich zu Schah-Krawallen, gibt Polizei Hilfestellung (\"müssen umdenken\"), die meisten Studenten würden sich in einer echten politischen Notlage befinden.","Neuer Polizei-Psychologe: Ich gehöre zu den Linken!","","Seine Aufgabe: Demonstrationen die \"Schärfe\" zu nehmen","Klaus Heine",[9],2,[1],[1],2,"8","2"],["714","1967-06-20","Untersuchung erstickt im Papier-Wust, Verlauf der ersten Sitzung, noch mehr Zeugen","Material über Schah-Krawalle umfasst 2000 Seiten","","","kh",[7],2,[1],[2],1,"8","3"],["715","1967-06-20","Wissenschaftssenator Stein will Rechte des Rektors reformieren","Senator fordert mehr Rechte für FU-Rektor ","","","hb",[11],2,[1],[2],2,"8","4"],["716","1967-06-20","Großer Bericht über die Neuregelungen durch Senator Steins Gesetzentwurf. Kommentar dazu (Go.): Eine Chance für die Hochschulen","Führungsspitze wird völlig neu gegliedert","","Universitätsgesetz bringt drastische Reformen","M. M. ",[4],1,[1],[1],1,"16","14"],["717","1967-06-20","Scharfer Kommentar gegen Sebastian Haffner, der die \"Springer-Presse\" verantwortlich macht für die \"Pogromstimmung\" gegen Studenten. ","Amoklauf","","","Stiege",[7],1,[5],[2],2,"16","2"],["718","1967-06-20","Diskussion an der TU über Demonstrationsrecht und Polizeibefugnis aus Anlass des 2. Juni. Günter Grass wirft der \"Springer-Presse\" vor, sie habe \"seit Wochen zu Gewalttätigkeiten gegen Studenten aufgefordert\". An der FU Diskussion mit Vertretern der Presse. Axel-Springer-Redakteure waren nicht erschienen, was Matthias Walden (SFB) bedauert habe, aber verstehen könne, nachdem er mit Zischen und Rufen empfangen wurde. Günter Matthes vom Tsp kritisierte, dass einige Studentensprecher die Situation zu primitiv darstellten. Für die Haltung der Berliner Presse sei nicht zuletzt Herr Ulbricht in Ost-Berlin verantwortlich. Jürgen Engert vom \"Abend\" stellte fest, dass mit Pauschalurteilen gegen die Presse vorgegangen würde. Er forderte Aufgeschlossenheit. Aufruf an Zeugen, sich bei der Staatsanwaltschaft zu melden.","Senat und Polizei im Kreuzfeuer","","TU-Studenten entfachten heftige Diskussionen","Eigener Bericht",[11],1,[1],[1],1,"16","6"],["719","1967-06-20","Hungerstreik für die Freilassung von Fritz Teufel und den Rücktritt von Albertz. \"Wir müssen zu diesem Mittel des Hungerstreiks greifen, weil wir anders  nicht unser Argument der Öffentlichkeit vermitteln  können\", sag Lefevre. ","Studenten wollen hungern","","Heute 22 Uhr: Streik in einer Kirche in Neu-Westend","Eigener Bericht",[1],1,[1],[5],2,"16","1"],["720","1967-06-20","Senator Stein stellt FU- und TU-Rektoren Entwurf für neues Uni-Gesetz vor.","Ein Schritt nach vorn für die FU","Universitäten erhalten ein neues Gesetz","","Bor",[11],6,[1],[1],2,"24","6"],["721","1967-06-20","Senator Stein stell einzelne Punkte des neuen Berliner Hochschulgesetzes vor","Stein warnt vor falscher Demokratisierung","Berliner Hochschulreform","Aber \"hierarchische Strukturen\" sollen abgebaut werden - Wahl des Rektors durch ein \"Konzil\"","v.C.",[4],4,[1],[2],2,"20","3"],["722","1967-06-20","Krawalle nicht als Unruhe verharmlosen.","Unruhe unter den Studenten?","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[2],2,"20","12"],["723","1967-06-20","AStA-Mitglieder der Kirchlichen Hochschule kritisieren Presse und politische Führung im Zusammenhang mit dem 2.Juni. Studentischen Anliegen muss mehr Raum in Zeitungen gegeben werden.","Keine Radikalinskis und Wirrköpfe","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[2],2,"20","12"],["724","1967-06-20","Ältere sind zu obrigkeitshörig und sollten Studenten dankbar sein.","Erinnerung an Matthäi","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[2],2,"20","12"],["725","1967-06-21","Rudi Dutschke hält Rede von der Kanzel der Westend-Kirche. Für die Freilassung von Fritz will man einen Hungestreik abhalten.","Mit Luftmatratzen in der Neu-Westend-Kirche ","","Gemeindemitglieder protestieren gegen Studenten-Versammlung","Hella Boschmann",[1],2,[1],[1],2,"10","2"],["726","1967-06-22","Studenten sammeln Geld für den Süden Vietnams (Befreieungskampf), Vermutung das davon Waffen gekauft werden, Mahler bestreitet dies ","Studenten sammeln für Kommunisten","","?aber was geschieht mit dem Geld","kh",[11],2,[1],[3],2,"8","1"],["727","1967-06-21","Der Diplompsychologe Helmut Kentler, der die Polizei berät, übt scharfe Kritik am Denken in der Behördenleitung. Leitende Beamte hätten seine Analyse empört von sich gewiesen. Kentler will nicht Polizeipsychologe werden. ","Psychologe urteilt hart über Berlins Polizeiführung","","Er spricht von vordemokratischem obrigkeitlichem Denken","J. M.",[7],1,[1],[1],1,"12","6"],["728","1967-06-21","Mitglieder Berliner Studentenverbände wollten in der evangelischen Kirche Neu-Westend Hungersteik zugunsten Fritz Teufels abhalten. Der Gemeindekirchenrat verweigert Gebäudenutzung. In einer zweiten, leicht ergänzten Form wird kurz über eine Ausweichaktion in Räumen der ESG der FU berichtet.","Hungerstreik in der Kirche fällt aus","Absage an die Studenten: Kein Mittel zur Verständigung","","be",[5],6,[1],[1],2,"28","4"],["729","1967-06-21","Kirchenleitung bittet Gemeinde, Hungerstreik für Teufel-Freilassung in ihren Räumen nicht zuzulassen.","Kirchenleitung gegen Hungerstreik","","Studentendiskussion in Westend","hae.",[5],4,[1],[2],2,"22","1"],["730","1967-06-21","FU-Minderheit stelle sich hinter \"Extremisten\" (Teufel). Wortspiel mit dem Namen Teufel.","Hungern","","","Co.",[5],4,[2],[2],2,"22","2"],["731","1967-06-21","Gemeinde Neu-Westend stellt Räume zur Diskussion zur Verfügung, nicht aber für den Hungerstreik gegen die Inhaftierung Fritz Teufels. Ausweichquartier in der Evangelischen Studentengemeinde. Diskussion in der Gemeinde Neu-Westend, Dutschke sprach von der Kanzel. Günter Grass diskutiert Diskussionsverhalten der Studenten nach einer Veranstaltung in der TU Berlin.","SDS-Vorsitzender Dutschke sprach von der Kanzel","Berlin","Empörung der Gemeindemitglieder: \"In diese Kirche gehe ich nie wieder\"","hae.",[5,3],4,[1],[1],1,"22","3"],["732","1967-06-22","Fritz Teufel geht in Hungerstreik, sitzt weiter in U-Haft, hat Haftentlassung gegen Auflagen abgelehnt","In den Hungerstreik","","","rb",[5],2,[1],[2],2,"8","2"],["733","1967-06-22","Leserbrief zum Hungerstreik. Es sei ja gut, dass sich Studenten an den Spruch erinnerten: \"Voller Bauch studiert nicht gern.\" Sie würden also zu ihrem eigenen Vorteil hungern. Nur: Warum in einer Kirche? ","Warum in einer Kirche?","","","R.E., Berlin 19",[1],1,[6],[3],2,"14","2"],["734","1967-06-22","Bischof Scharf setzt sich für Teufel ein. 100 Studenten begannen ihren Hungerstreik für Teufel, der in Haft ebenfalls hungert. Büsch genehmigt Sammelaktion des SDS für den Vietkong aus \"rechtlichen Gründen\"","Teufel in ein Kirchenheim?","","Heute Haftprüfungstermin für den Studenten","Eigener Bericht",[1],1,[1],[5],1,"14","3"],["735","1967-06-22","Kritischer Text zur Haftsache Teufel. \"Heute möchte der 24-jährige in Berlin Warenhäuser brennen sehen, was er als ,Großhappening' bezeichnet.\"","Fluchtgefahr!","","","L.R.",[1],1,[1,5],[2],1,"14","3"],["736","1967-06-22","Drei Leserbriefe zum angekündigten Hungerstreik. Sehr unterschiedliche Tendenz: A. W. sagt, nur KZler und Sowjet-Internierte könnten ermessen, was Haft in einem faschistischen Gefängnis bedeute. W. L. fragt kritisch, ob all diejenigen, \"die die mehr als zweifelhaften Maßnahmen gegen demonstrierende Studenten bedenkenlos befürworten und \"seit geraumer Zeit einen unbegreiflichen Hass gegen die Studenten allgemein entwickelt\" hätten, richtig liegen. Ruhe und Ordnung seien nicht alles, sondern Kriterien auch von totalitären Systemen. R.E. schießt scharf gegen die Hungerstreikenden.","Jetzt hungern sie für Teufel","","Studenten verschaffen sich um jeden Preis Gehör","A.W., Berlin 30; W. L., Berlin 31; R. E. Berlin 31",[1],1,[6],[3],2,"14","6"],["737","1967-06-22","Bundeskanzler Kiesinger fordert alle Minister auf, sich mit der Lage der Hochschulen zu befassen.","\"Diese Unruhe ist ein Problem\"","","","hob., Ki.",[9],6,[1],[5],2,"28","2"],["738","1967-06-22","Liberaler Studentenbund Deutschlands gegen SDS-Spendensammlung zugunsten Vietkong","LSD gegen Waffen für den Vietkong","","","",[8],6,[1],[2],2,"28","5"],["739","1967-06-22","Hungerstreik für Freilassung Teufels. Mehrere Solidaritätserklärungen. Kritik daran, dass Kurras frei ist.","Hungerstreik in der Kirche fällt aus","100 Studenten versammelten sich in der Gelfertstraße","","L.R.",[5],6,[1],[1],1,"28","5"],["740","1967-06-22","Scharf schlägt Generalstaatsanwalt vor, Teufel in Räume der Kirche zu verlegen. Anhängender Kommentar moniert, warum sich der Bischof nicht für Häftling einsetzt, deren Fälle weit problematischer sind.","Bischof Scharf setzte sich für Fritz Teufel ein","","","Hans Kricheldorff",[5],6,[1,5],[2],2,"28","5"],["741","1967-06-22","Kommentator fragt, ob Löffler der richtige (unparteiische) Ausschuss-Leiter sein kann, weil er als Augenzeuge Aussagen gemacht hat.","Kann Löffler seinen Schatten überspringen?","Morgen erste Sitzung des parlamentarischen Untersuchungsausschusses","","Klaus Bär",[7],6,[5],[1],1,"28","2"],["742","1967-06-22","Oberverwaltungsgericht lehnt pauschale Zulassung von Einzeldemos ab.","Studentenforderungen wurden abgelehnt","","OVG: Kein Freibrief für künftige Einzeldemonstrationen","",[1],4,[1],[5],1,"16","10"],["743","1967-06-22","Verlegung des Hungerstreiks in Evangelisches Studentenheim Dahlem. Diskussionen in Neu-Westend. Intervention von Scharf bei der Justiz zugunsten Teufels.","Hungerstreik mit Bier und Kabarett","Studenten","Bischof Scharf setzt sich für die Freilassung Fritz Teufels ein","hae.",[5],4,[1],[1],1,"16","3"],["744","1967-06-22","Zusammenfassender Bericht über Verletzte, Untersuchungsauschuss und verschiedene Reaktionen","Noch zwei Demonstranten im Urbankrankenhaus","","Ein Opfer kein Student. Untersuchungsausschuss fordert Material","hae",[1],4,[1],[1],2,"16","9"],["745","1967-06-22","Barzel plädiert für Gespräche statt Konfrontation. Weitere Stellungnahmen.","Kabinett erörtert Studentenunruhen","","\"Probleme sind nicht kurzfristig administrativ zu lösen\"","Co, v.C.",[1],4,[1],[2],2,"16","3"],["746","1967-06-23","Professor aus Hamburg fordert Abschaffung der Semesterferien","Semesterferien - Verlorene Zeit der Studenten","","","on",[9],2,[5],[2],2,"10","10"],["747","1967-06-23","Studentischer Untersuchungsausschuß erhebt schwere Vorwürfe, Foto von blutendem Polizisten wird gezeigt, klatschende Studenten ziehen Unmut auf sich, widersprüchliche Aussagen zum Abbruch des Hungerstreiks  ","Studentenausschuß: Härte war nicht gerechtfertigt","","","K.H.",[7],2,[1],[2],2,"10","2"],["748","1967-06-23","Ausblick auf die erste öffentliche Sitzung des Untersuchungsausschusses. Löffler könnte als befangen angesehen werden, weil er selbst Augenzeugen der Ereignisse war. ","Duensing heute vor dem Untersuchungsausschuss","","","",[7],1,[1],[5],2,"14","3"],["749","1967-06-23","Laut Polizeigewerkschaft herrsch große Verunsicherung bei Polizisten wegen der Ereignisse der letzten Zeit.","Polizisten sind verbittert","","","",[9],6,[1],[2],2,"36","4"],["750","1967-06-23","Reportage von Verfahren gegen Demonstranten","Wer hat wirklich zuerst geschlagen?","","","Kr.",[7],6,[7],[3],1,"36","4"],["751","1967-06-23","Scharf fühlt sich missverstanden. Mahler legt Rechtsmittel für Teufel ein. Studenten brechen Hungerstreik ab.","Scharf - falsch verstanden","","","L.R.",[5],6,[1],[2],2,"36","4"],["752","1967-06-23","Erläuterung der Arbeitsweise des Ausschusses. Duensing einer der ersten Zeugen. Zweifel an Löffler wachsen. Er soll am 2. Juni Demonstranten aufgewiegelt haben.","Rechte wie Richter","Heute vernimmt der Untersuchungsausschuss die ersten Zeugen","","K.B.",[7],6,[1],[1],1,"36","4"],["753","1967-06-23","VDS-Kritik an Behandlung des Themas Ausbildungsförderung durch Regierung","Studenten greifen die Bundesregierung scharf an","","","ems.",[4],4,[1],[2],2,"24","1"],["754","1967-06-23","VDS-Kritik an Behandlung des Themas Ausbildungsförderung durch Regierung","Studenten wollen nicht länger warten","Ausbildungsförderung","Der Bundestag soll gleiche Startchancen für alle schaffen","ems.",[4],4,[1],[1],2,"24","6"],["755","1967-06-23","Situation der Hungerstreikenden, Beschreibung der Umstände und einer Neuss-Veranstaltung im Evangelischen Studentenheim. Erwähnung von Vorwürfen, mit denen Dutschke belegt wird in Anführungszeichen; u. a. \"'Steineschmeisser'. (Auch wenn er's nicht getan hat - wen interessiert's?)\"","Mit Sympathie auf der Seite des Sohnes","","Neuss trat vor den Studenten auf - Hungerstreik vorzeitig beendet.","hp, hae",[5],4,[7],[3],2,"24","13"],["756","1967-06-24","Bericht über den Untersuchungsausschuß. Fragen und Antworten der Beschuldigten/Parlamentarier werden wörtlich wiedergegeben, Verletzte Polizisten stehen im Vordergrund.","Elf Polizisten verletzt, bevor es richtig losging","","Schah-Krawalle: Die ersten Zeugen vor dem Untersuchungsausschuß","Horst Zylka und Klaus Heine",[1],2,[1],[1,4],1,"8","2"],["757","1967-06-24","Rote Falken demonstrieren im Tiergarten gegen Vietnam Politik der USA, keine Zusammenstöße","Zuschauer zu den Falken: \"Geht lieber arbeiten!\" ","","","rb",[1],2,[1],[3],2,"8","2"],["758","1967-06-24","Interessen der Beamten sollen gemeinsam vertreten werden.","Polizei gründet Aktionsgemeinschaft","","","rb",[9],2,[1],[2],2,"8","2"],["759","1967-06-24","Duensing bestätigte, den Einsatzbefehl gegeben zu haben. Er sei überzeugt, dass es eine Führung der gewalttätigen Demonstranten gegeben habe und sie an der FU einen \"Befehlsapparat\" besäßen. Iwicki sagte, die Beamten seien teilweise 30 Stunden nicht aus der Uniform gekommen.","Duensing: \"Ich gab den Räumungsbefehl\"","","Aussage vor dem Untersuchungsausschuss","Eigener Bericht",[7],1,[1],[3],1,"12","1,3"],["760","1967-06-24","Erste öffentliche Sitzung des Untersuchungsausschusses. Duensing vertritt seine Position. Er habe den Geschosshagel miterlebt, auch Steine seien dabei gewesen. Er habe Kurras gesehen: \"Der Mann sah aus, als sei er zweimal durch den Schmutz gewälzt worden.\" Der Räumungsbefehl erging, um dem Regierenden eine Blamage zu ersparen. Iwicki sagte, er habe schneller als ursprünglich beabsichtigt räumen lassen, weil um 20 Uhr schon 11 Beamte verletzt gewesen seien: \"Unser rasches Vorgehen war uns durch die Haltung der Demonstranten aufgezwungen.\" Lautsprecherwagen schon um 20.05 Uhr?","Schah sollte die Deutsche Oper vorzeitig verlassen","","Aber Duensing wollte Albertz die \"Blamage ersparen\"","M.M.",[7],1,[1],[1],1,"12","3"],["761","1967-06-24","Atmosphärische Einschätzung des ersten Verhandlungstages des Untersuchungsausschusses.","Heißer Tag, heißes Thema","","","J. M.",[7],1,[5],[3],2,"12","3"],["762","1967-06-24","Leserbrief: Jugendlicher Unverstand, östliche Agenten und westdeutsche Wehrdienstverweigerer untergraben die Freiheit West-Berlins: \"Es wird höchste Zeit, dass wir Ordnung schaffen!\"","Wird unsere Freiheit untergraben?","","","W. U., Berlin 28",[1],1,[6],[3],2,"12","2"],["763","1967-06-24","Scharfe Kritik an Bischof Scharf wegen seiner Intervention zugunsten von Fritz Teufel. Warum wird der Hungerstreik nicht totgeschwiegen?","Unverständlich","","","M. S. Berlin 65",[1],1,[6],[3],2,"12","2"],["764","1967-06-24","Demo der Falken im Wedding","Vietnam-Demonstration ohne Zwischenfälle","","","L.R.",[1],6,[1],[3],2,"24","3"],["765","1967-06-24","Einsatzleiter begründet Vorgehen gegen Demonstranten mit 11 zum Zeitpunkt seines Befehls bereits verletzten Polizisten. Hinweis auf Text im Heft.","\"Ich konnte nicht anders?!\"","Einsatzleiter vor dem Untersuchungsausschuss:","","",[7],6,[1],[3],2,"24","1"],["766","1967-06-24","Aussagen von Polizeipräsident Duensing und Einsatzleiter Iwicki. Rechtfertigen Ihre Taktik, stellen sich vor die Polizei.","Duensing: \"Auf dem Rücken der Polizei!\"","Erste Sitzung des Untersuchungsausschusses","","Peter Borowsky",[7],6,[7],[4],1,"24","3"],["767","1967-06-24","Untersuchungsausschuss-Aussage des Polizeipräsidenten","Duensing fühlt sich von Persern hintergangen","","\"Ungelöste Studentenprobleme auf dem Rücken der Polizei ausgetragen\"","cg",[7],4,[1],[1],2,"28","9"],["768","1967-06-25","Bericht vom Untersuchungsausschuss, Aussage Iwicki. Die West-Berliner Polizei ermittelte in Hannover im Vorleben von Ohnesorg - ohne Auftrag der Staatsanwaltschaft","Kripo durchleuchtete Vorleben Ohnesorgs","","","Werner Kahl / Horst Zylka",[7],3,[1],[3],1,"48","4,5"],["769","1967-06-25","Konvent der FU fordert AStA auf, auf Haushaltsmitteln die Kaution für Fritz Teufel zu stellen. Disziplinarausschuss vertagte Sitzung gegen Kommune I","Kaution für Fritz Teufel?","","","Eigener Bericht",[1],1,[1],[2],2,"54","7"],["770","1967-06-25","Umgemeindung wegen Dutschke-Auftritt in Neu-Westend.","Austritt aus der Neu-Westend-Kirche","","","UPI",[3],5,[1],[2],2,"32","27"],["771","1967-06-25","Kommentator unterscheidet politische von politisierten Studenten. Studenten seien zu wichtig für den Staat, als dass man sie sich selbst überlassen dürfte.","Student und Staat","","","Werner Klose",[1],5,[5],[1],2,"32","2"],["772","1967-06-25","FU-Konvent ermächtigt AStA Geld für eventuelle Teufel-Kaution bereitzustellen.","10.000 DM AStA-Geld als Kaution für Teufel?","","","UPI",[5],5,[1],[2],2,"32","27"],["773","1967-06-26","Über eine Konventssitzung in der FU, u.a. mit Statements von Professor Nichols vom Kennedy-Institut","FU-Konvent: AStA soll 10000 DM Kaution für Fritz Teufel stellen","","Wieder Vorwürfe gegen die Staatsanwaltschaft","bi",[11],4,[7],[5],2,"20","11"],["774","1967-06-26","Kritik am Verlauf der Konventssitzung","Kritisch betrachtet","","","heb",[11],4,[5],[2],2,"20","12"],["775","1967-06-26","Kritik am politischen Ansatz der Schah-Demonstrationen durch früheren SPD-MdB","Ein offenes Wort an die Berliner Studenten","","","Heinrich Georg Ritzel",[1],4,[6],[3],1,"20","2"],["776","1967-06-26","Abgrenzung von Radikalen / Kritik am Polizeieinsatz am 2. Juni","Ein Teil der Studenten denkt gemäßigter / Leitung der Berliner Polizei nicht frei von Schuld","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[1],2,"20","6"],["777","1967-06-27","Bericht über Falschaussage Duensings im Rahmen des Untersuchungsausschuss zum 2. Juni 1967, wird mehrfach von Schupo-Kommandeur widerlegt, besonders persische Schah-Anhänger kommenzur Sprache, am Ende des Artikels \"Bild meint\": Studenten hätten Recht auf freie Meinungsäußerung mißbraucht, die könne man nicht absetzen, Duensing hat die Pflicht verletzt, die Wahrheit zu sagen, diesen müsse man absetzen.","Polizei-Chef: Es war zu heiß","","Duensing sagte am Freitag vor dem parlamentarischen Untersuchungsausschuß falsch aus","k.a.",[1],2,[1],[1],1,"8","2"],["778","1967-06-27","Fritz Teufel bleibt weiter in Haft, Kaution will er nicht.","Teufel muss noch weiter schmoren","","","rb",[5],2,[1],[2],1,"8","3"],["779","1967-06-27","Anreißer für Artikel im Heft, siehe Datensatz 777.","Polizeipräsident hat falsch ausgesagt ","","Duensings Gedächtnislücke: \"Es war zu heiß?\"/Bericht S. 2","k.a.",[7],2,[1],[1],2,"8","1"],["780","1967-06-27","Duensing räumt nach entsprechender Aussage von Werner ein, dass er selbst den Sonderplatz für die Jubelperser vor dem Rathaus Schöneberg angeordnet habe. Seine falsche Angabe bei der ersten Sitzung des Ausschusses begründete er mit der Hitze. Unklarheit über Lautsprecherdurchsagen","Vorzugsplatz für Jubelperser von Duensing angeordnet","","Polizeipräsident korrigierte seine Aussage","Eigener Bericht",[7],1,[1],[1],1,"12","1"],["781","1967-06-27","Leitartikel über Duensings Versagen. Er sei nicht mehr zu halten. Allerdings könnte das den \"Appetit radikaler Kreise\" nach weiteren Köpfen fördern","Der Präsident und die Hitze","","","Stiege",[7],1,[5],[2],2,"12","2"],["782","1967-06-27","Fehlleistung des Polizeipräsidenten im Detail. Auch weitere Unstimmigkeiten. Und erste Zeugen aus den Reihen der Demonstranten","\"Wahrscheinlich war die Hitze daran schuld...\"","","Schwarzer Tag für Polizeipräsident Duensing","Eigener Bericht",[7],1,[1],[1],1,"12","6"],["783","1967-06-27","Kammergericht prüft Untersuchungshaft Teufels. Professoren fordern Justizsenator auf, sich in Untersuchungen einzuschalten.","Fall Teufel jetzt vor dem Kammergericht","","","L.R.",[5],6,[1],[2],2,"24","3"],["784","1967-06-27","\"Jubel-Persern\" war auf ausdrückliche Weisung Duensings vor dem Rathaus Schöneberg Platz eingeräumt worden. Er hatte das zuvor in Abrede gestellt.","Polizeipräsident blamierte sich!","Er gab doch grünes Licht für die \"Jubel-Perser\"","","",[7],6,[1],[1],2,"24","1"],["785","1967-06-27","Duensing habe eine miserable Figur vor dem Untersuchungsausschuß abgegeben. Kommandeur der Schutzpolizei, Werner, widerspricht in Sachen Jubel-Perser, woraufhin Duensing seine erste Aussage korrigieren muss. Anhörung weiterer Zeugen.","Peinlich, Peinlich!","Duensing musste seine Aussage korrigieren:","","Peter Borowsky",[7],6,[7],[1],1,"24","3"],["786","1967-06-27","Kritik an der Kirche wegen Hungerstreiks in ihren Räumen","Hungerstreik  ","Aus Briefen an die Redaktion","","Leser",[5],4,[6],[2],2,"18","2"],["787","1967-06-27","Gegenstand sind vornehmlich organisatorische Kontroversen","In wichtigen Fragen \"kontrovers\"","","Streit der katholischen Studentengemeinde","eb",[9],4,[1],[2],2,"18","11"],["788","1967-06-27","Juristisches Hickhack um Teufel. Verschiedene Stellungnahmen","Landgericht wollte Teufel bereits entlassen","","Einspruch des Generalstaatsanwalts brachte Fall vor höhere Instanz","dw",[5],4,[1],[1],2,"18","11"],["789","1967-06-27","Bericht von der Sitzung des U-Ausschusses","Ausschuss hörte Augenzeugen","Berlin","Verletzte beider Seiten sagen aus - Polizeipräsident Duensing musste sich korrigieren","v.C.",[7],4,[1],[5],2,"18","4"],["790","1967-06-28","Staatsanwaltschaft beantragt Hauptverfahren gegen Kurras Vier Ermittler hätten in 15 Tagen 89 Zeugen vernommen und seien zum Ergebnis gekommen, dass eine Notwehrsituation, wie von Kurras behauptet, nicht hinreichend nachgewiesen sei. Mögliche Höchststrafe 5 Jahre.","Staatsanwalt: Todesschütze Kurras muss vor Gericht","","War es fahrlässige Tötung?","K.G.",[7],1,[1],[1],2,"16","1"],["791","1967-06-28","Studentin hatte sich an Diskussionen bei einer nicht genehmigten Kudamm-Demo beteiligt, und sich der Festnahme widersetzt: Geldstrafe 30 Mark.","\"Symbolische\" Geldstrafe","","","Kr.",[1],6,[1],[2],2,"28","5"],["792","1967-06-28","Anriss. Hinweis auf Text im Heft","Anklage gegen Kurras","Staatsanwaltschaft: Fahrlässige Tötung","","",[7],6,[1],[3],2,"28","1"],["793","1967-06-28","Gericht soll Vorwürfe gegen Kurras klären. Polizeisprecher begrüßt Vorgehen. Haftprüfung Teufels verzögert sich.","Anklage gegen Kurras!","","","L.R.",[7],6,[1],[1],1,"28","5"],["794","1967-06-28","Übersicht über gegenwärtig laufende Verfahren nach dem 2. Juni.","Der fahrlässigen Tötung angeklagt","","Verfahren gegen Karl-Heinz Kurras wird eingeleitet","wt",[7],4,[1],[2],2,"22","11"],["795","1967-06-28","Vorgehen und Taktik der Polizei bei Demonstrationen in Berlin und anderswo","\"Sollen wir etwa auch mit Tomaten werfen?\"","Die Polizei: Ganz ohne Knüppel geht es nicht","Berlin ist eine Lehre wert - Umfrage in deutschen Großstädten","Eberhard Nitschke",[9],4,[1],[1],1,"22","5"],["796","1967-06-28","Vier teils sehr differenzierte Meinungsbeiträge zur aktuellen Situation. Bei aller Kritik an Auswüchsen, vielfach deutliches Bemühen um Verständnis und der Suche nach Erklärungen.","Sollen die Studenten Rebellen sein?","Das Forum der Welt","Warum die jungen Pensionäre revoltieren (Erwin Kurt Scheuch). Die Hochschule wird zum Getto (Janpeter Kob). Die Selbstzufriedenheit am Pranger (Walter Görlitz). Studieren wäre Besser als den Aufstand probieren (HelmutSchoeck).","Erwin Kurt Scheuch, Janpeter Kob, Walter Görlitz, Helmut Schoack",[1],4,[5],[4],2,"22","7"],["797","1967-06-29","Erhebliche Widersprüche bei den Sitzung des Untersuchungsausschusses. Harte Fragen wegen der Prügelszenen durch \"Jubelperser\". Einsatzleiter sagt, er habe das nicht gesehen. Erst der Schupo-Chef gab den Befehl, die berittene Polizei einzusetzen. Falsche Angabe über die Zahl der verletzten Beamten bis 20 Uhr - nicht 11, sondern nur 2 Verletzte.","Harte Frage wegen der Bevorzugung der \"Jubel-Perser\"","","Polizei kann nur ausweichende Antwort geben","Eigener Bericht",[7],1,[1],[1],1,"18","1"],["798","1967-06-29","Karikatur über die gegenseitigen Schuldzuweisungen von Polizisten in Sachen \"Jubelperser\"","Untersuchungsergebnis","","\"Er gab den Befehl\"","Oskar",[7],1,[5,4],[2],1,"18","2"],["799","1967-06-29","Ausführliche Schilderung der Sitzung des Untersuchungsausschusses. Beamte korrigierten ihre vorherigen Aussagen in Details. Ein Student erklärt Eierwürfe als zulässiges Mittel einer Demonstration. Kriminalrat Eitner, Chef der Politischen Polizei, erläutert den geplanten Einsatz. ","Kam der Befehl \"Schlagstock frei\"?","","Polizeibeamte und ein Student sagen aus","Eigener Bericht",[7],1,[1],[1],1,"18","9"],["800","1967-06-29","Suspendierung und Einleitung eines förmlichen Disziplinarverfahrens gegen Kurras","Kurras vom Dienst suspendiert","","","",[7],6,[1],[2],2,"28","3"],["801","1967-06-29","Prozessterminierung gegen Teufel und Langhans wegen Aufforderung zur schweren Brandstiftung","Prozess gegen Teufel","","","H.K.",[5],6,[1],[2],2,"28","4"],["802","1967-06-29","Reportage zu den Themen der Überschrift","Unklar: Die Sache mit den Persern. Lautsprecherdurchsagen. Wie dicht stand die Menge? Iwickis Gewissenskonflikt. \"Knüppel frei\" um 20 Uhr","Parlamentarischer Untersuchungsausschuss hatte einen schweren Tag","","Peter Borowsky",[7],6,[7],[1],1,"28","4"],["803","1967-06-29","CDU hat zu Gesprächen mit Studentenvertretern nach Bonn eingeladen. Einige Unis nicht oder nur mit Beobachtern vertreten.","CDU diskutiert mit Studenten","","","ems.",[9],4,[1],[2],2,"20","3"],["804","1967-06-29","Diskussionen auch über Disziplinarrecht und aktuelle politische Lage","Debatte über Hochschulgesetz-Entwurf","","Vollversammlung aller Fakultäten der Freien Universität","el",[4],4,[1],[2],2,"20","11"],["805","1967-06-29","Dienstenthebung von Kurras bis Klärung der Vorwürfe","Karl-Heinz Kurras vorläufig dienstenthoben","","","",[7],4,[1],[2],2,"20","11"],["806","1967-06-29","Ohnesorg Opfer von studentischer Grenzüberschreitung und überschrittener Notwehr","Keine Synthese von Recht und Freiheit","Aus Briefen an die Redaktion","","Leser",[7],4,[6],[2],2,"20","7"],["807","1967-06-29","Drei Leserbriefe - zwei sehr kritisch - zum Ritzel-Beitrag vom 26. Juni","Nicht weich werden! / Die SPD hat Schuld / Gegen Bonn","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["808","1967-06-29","Kritisiert die Radikalisierung innerhalb der Studentenschaft","Wo sind die Studentengruppen der Mitte?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","7"],["809","1967-06-29","Ankündigung von Verfahren wegen Aufforderung zu schwerer Brandstiftung","Verfahren gegen zwei \"Kommune\"-Mitglieder","","","hae.",[5],4,[1],[2],2,"20","3"],["810","1967-06-29","Bericht vom dritten Verhandlungstag des Uuntersuchungsausschusses","Die Polizei muss Rede und Antwort stehen","Berlin","Ausschuss steht vor Widersprüchen - Student: Eierwerfen ist legal","v.C.",[7],4,[1],[1],1,"20","3"],["811","1967-06-30","Mitglieder der Kommune I schreiben Brief mit Selbstbezichtigung wegen Kaufhausbränden, wollen auch ins Gefängnis","Des \"Teufels \" Kollegen wollen hinter Gitter","","","rb",[5],2,[1],[2],2,"10","2"],["812","1967-06-30","Disziplinarverfahren der FU: Frage ob radikale Studenten von Uni verwiesen werden können, SED-Chef gibt Schützenhilfe","Politische Tätigkeiten an Universitäten rechtswidrig?","","","L.H.",[4],2,[1],[2],1,"10","3"],["813","1967-06-30","Stein ist nicht bereit, das Fernbleiben studentischer Vertreter bei den Sitzungen des Disziplinarausschusses zu akzeptieren. Das nähre Zweifel an der Bereitschaft zur verantwortungsvollen Zusammenarbeit. ","Senator ermahnt Studenten","","","Eigener Bericht, dpa, AP, UPI",[11],1,[1],[2],2,"22","1"],["814","1967-06-30","Leserbrief: Traurig, dass der Senat mit den ewigen Unruhen nicht fertig werde. Bei den Diskussionen komme der einfache Mann nicht mehr mit. Es werde alles so kompliziert wie möglich gemacht. \"Niemand aber kümmert sich um die Meinung des besonnenen und arbeitsamen Bürgers, dem langsam die Galle überläuft.\"","Zu kompliziert","","","K. E., Berlin 31",[11],1,[6],[3],2,"22","2"],["815","1967-06-30","TV-Diskussion mit allen Parteichefs über Studentenproteste. Brandt hat am meisten Verständnis","Studenten sollen mitarbeiten","","","Eigener Bericht",[11],1,[1],[3],2,"22","2"],["816","1967-06-30","Gutachten des Staatsrechtlers Prof. Bettermann belegt: Es gibt kein \"politisches Mandat\" der Studentenvertretung. Zitate aus dem Gutachten","FU-Politisierung gesetzwidrig","","","dpa",[1],1,[1],[2],1,"22","11"],["817","1967-06-30","Fernsehdiskussion zwischen Parteivorsitzenden und Studenten von 100 linksradikalen Studenten gestört.","Neuer Uni-Krawall","","Aktion gegen Fernsehdiskussion","AP, dpa",[1],6,[1],[3],2,"36","35"],["818","1967-06-30","Kommune I-Mitglieder sollen sich wegen \"Pudding-Aktion\" vor Disziplinarausschuss verantworten, die studentischen Beisitzer des Ausschusses bleiben aber fern. Senator Stein droht deshalb mit staatlichen Maßnahmen.","Senator Stein wird massiv!","","Verstoß gegen FU-Verfassung. Staatliche Maßnahmen angedroht","P.B.",[11],6,[1],[1],2,"36","5"],["819","1967-06-30","Kritik an Verfahrensmängeln. Beispiele.","Viele Mängel","Untersuchungsauschuss:","","Peter Borowsky",[7],6,[5],[5],2,"36","4"],["820","1967-06-30","Sehr gemäßigte Gespräche zwischen CDU- und Studentenvertretern in Bonn","Barzel: Wir wollen ihre Sorgen hören","Studenten","Auch Kiesinger nahm an Aussprache teil - \"Recht auf Demonstrationen\"","St.",[9],4,[1],[1],1,"20","3"],["821","1967-06-30","Verwaltungsrechtler spricht studentischen Gremien politisches Mandat ab","FU-Prof. Bettermann verneint politisches Mandat der Studenten","","Wissenschaftssenator erhielt ausführliches Gutachten","ska",[11],4,[1],[5],2,"20","11"],["822","1967-06-30","Kommunemitglieder weisen darauf hin, dass Flugblätter gemeinsam hergestellt worden sind, und sie daher alle in Haft genommen werden sollten.","\"Kommune I\" will zu Teufel ins Gefängnis","","","dpa",[5],4,[1],[2],2,"20","3"],["823","1967-06-30","Der Konvent hat einen Brief an alle vier Alliierten geschrieben. Man könnte das auf sich beruhen lassen, da es nicht die Sache des Konvents ist, Außenpolitik zu machen. Allerdings zeigt dieser Brief den \"Wunsch nach politischer Eskalation der in Berlin erregten Unruhe an\". Provokation der West-Berliner Bevölkerung. Den Studenten muss klar sein, dass sie sich der Möglichkeit berauben, mit der Bevölkerung ins Gespräch zu kommen. Die Radikalen Gruppen suchen ganz offen die Konfrontation mit den Westalliierten","Ein offener Brief","Unsere Meinung","","J. B.",[11],8,[5],[2],2,"22","1"],["824","1967-07-01","Bildung von \"FDJ-Alarmgruppen\" die Disskussionen mit West und Ostdeutschen Studenten an der HU in Ost-Berlin unterbinden sollen.","FDJ fängt Studenten ab","","","rb",[9],2,[1],[2],2,"8","3"],["825","1967-07-01","Medizinstudenten verwahren sich gegen die Radikalität einiger anderer Gruppen im Konvent. Heftige Auseinandersetzung zwischen Lefevre und Senator Stein. In Ost-Berlin werden Gruppen vorbereitet, die mit West-Berliner Studenten reden sollen, falls sie an die Humboldt-Universität kommen, um zu diskutieren. ","Scharfe Kritik an radikalen Studenten","","Konvent der Freien Universität tagte","Eigener Bericht",[11],1,[1],[3],2,"16","2"],["826","1967-07-01","Vor zwei Wochen soll es an der TU Dresden zu Protesten von Studenten gekommen sein. In Form eines \"Sit-ins\" forderten sie besseres Mensaessen, größere Ausnutzung der Lehrmittel und mehr Kontakt zu Professoren. Die Demonstration wurde nicht aufgelöst","Demonstration der Dresdner TU-Studenten","","","Eigener Bericht",[11],1,[1],[2],2,"16","1"],["827","1967-07-01","Studenten um früheren AStA-Chef Lefèvre planen Gegenuni","\"Dann sehe ich aber schwarz\"","Studenten-Gruppe plant Attacke gegen die Freie Universität","","Bor.",[11],6,[1],[5],2,"28","2"],["828","1967-07-01","Bericht über die \"Aktion 1. Juli\", dies sei ein studentische Demonstration der anderen Art, Ziele berechtigt.","Hier haben die Studenten recht","","\"Aktion 1. Juli\" soll auf Schwächen der Ausbildungsförderung aufmerksam machen","Günter Krems",[9],4,[1],[3],2,"26","2"],["829","1967-07-01","Erklärung des Berliner VDS zur Aktion 1. Juli","Dokumentation soll \"Aktion 1. Juli\" ersetzen","","","",[9],4,[1],[2],2,"26","13"],["830","1967-07-01","Neue Aktion an Uni Köln wendet sich gegen radikale Gruppierungen.","Aktion 67 in Köln gegründet","","Neue Studentenvereinigung","",[9],4,[1],[2],2,"26","3"],["831","1967-07-01","Wendet sich gegen Kritik an Demonstranten. Ausschreitungen sind nachvollziehbar, weil dann berichtet wird.","Nach der Fress- die Demonstrationswelle","","","Leser",[1],4,[6],[2],2,"26","2"],["832","1967-07-01","Kammergericht nennt Entscheidungstermin","Montag Entscheidung über Haftbeschwerde Teufels","","","",[5],4,[1],[2],2,"26","13"],["833","1967-07-01","Gemeinsame Demo von Professoren und Studenten in Kiel gegen Bildungsnotstand","\"Unruhe gehört zum Wesen der Universität\"","","","H.A.",[11],4,[1],[2],2,"26","3"],["834","1967-07-02","Morgenpost-Gespräch mit Bischof Scharf über den Auftritt des linksradikalen Studenten Dutschke in der Kirche Neu-Westend am 20. Juni. Noch ungeigneter als eine Ansprache von der Kanzel wäre aber eine Rede vom Altar aus gewesen, sagt Scharf. Die Morgenpost sei mitschuldig daran, dass die Studenten zur Kirche gekommen seien: \"Durch Ihre Berichterstattung haben Sie erst die Massen hingelockt.\" Das sei aber nicht die Absicht der BM gewesen. Etwa 20 Beschwerden von Gemeidnemitgliedern","Scharf von Dutschkes Auftritt nicht beglückt","","Ausweichende Auskunft des Berliner Bischofs","Eigener Bericht",[2,3],1,[1],[3],2,"52","1,2"],["835","1967-07-02","Kommentar sagt, dass es in Berlin immer mehr Mode werde, den Amerikanern, dem Senat und der \"Springer-Presse\" an allem Unglück der Welt Schuld zu geben. Auch Scharf tut das jetzt. Warum aber soll die BM Schuld daran sein, dass Studenten zum Hungerstreik in die Kirche Neu-Westend gekommen sind? Die Ausladung des Pfarrers, die nicht berichtet worden war, kam nach Redaktionsschluss. Kein Berliner Blatt brachte sie am nächsten Tag. Pastorale Fehlleistung von Scharf. Er verwechselt Ursachen und Wirkung","Widersprüche um Scharf","","","Stiege",[10],1,[5],[2],2,"52","2"],["836","1967-07-02","Senator Stein hat Einwände gegen den offenen Brief des Studentenkonvents der FU Berlin gegen die Übernahme der Notstandsgesetze in West-Berlin. Der Brief lese sich wie ein \"Kommentar zur Drei-Staaten-Theorie\"","Bedenken gegen Studenten-Brief","","","Eigener Bericht",[11],1,[1],[2],2,"52","7"],["837","1967-07-02","VDS-Vorsitzender Haubold zu den aktuellen Unruhen, dem Schah-Besuch und zur Notwendigkeit einer Hochschulreform","Wir Studenten sind keine Tagediebe?","","Ein Wort zu den Demonstrationen vom 1. Juli","Hans-Joachim Haubold",[4],5,[5],[1],1,"32","13"],["838","1967-07-03","Darstellung der Probleme und Notwendigkeiten in Sachen Ausbildungsförderung. Aufhänger sind die aktuellen Demonstrationen zum Thema.","Noch immer warten wir auf das Gesetz?","Ausbildungsförderung - acht Jahre verschleppt","Verzettelte Gelder - Bildungshilfe braucht einheitliche Lenkung","Wolfgang Bergsdorf",[4],4,[1],[1],2,"22","7"],["839","1967-07-03","FU-Konvent bittet Alliierte, Notstandsregelungen nicht für West-Berlin zu übernehmen.","Berliner Studenten schreiben an Alliierte","","","hws",[9],4,[1],[2],2,"22","6"],["840","1967-07-03","Leser ist Student und dankt Welt für Berichterstattung. Kritisiert Übergriffe der Polizei.","Alarmierend","","","Leser",[1],4,[6],[2],2,"22","2"],["841","1967-07-04","Fritz Teufel bleibt weiter in Haft wegen Fluchtgefahr, soll Steine geworfen haben und zur Brandstiftung aufgerufen haben.","Teufel weiter hinter Gittern","","","rb",[5],2,[1],[2],2,"8","3"],["842","1967-07-04","Universitäten dämmern im Dornröschenschlaf, kein Verständnis für Verschleppung der Reform, wenn Studenten Krach machen wegen der fehlenden Veränderung haben sie Recht.","Die Studenten haben diesmal recht","","","Hans W. Lenhard",[4],2,[5],[2],2,"8","8"],["843","1967-07-05","Senator Werner Stein schreibt an Studenten, fordert sie auf: \"die ihnen nach Satzung und Ordnung der Universität zur Verfügung stehenden Mittel zu nutzen, um eine fortschrittliche Hochschukpolitik zu gewährleisten\". Senat weist Brief der Studenten zur Notstandsverordnung scharf zurück.  ","Senator schrieb am Studenten","","","jo",[11],2,[5],[2],1,"8","3"],["844","1967-07-04","Bericht vom parlamentarischen Untersuchungsausschuss: Oberkomissar Burck kommt zu Wort, Zeugen werden vernommen.","\"Es gab keinen Befehl, den Schlagstock einzusetzen\"","Polizei-Kommissar vor dem Untersuchungsausschuss","","Horst Zylka",[7],2,[1],[1],1,"8","2"],["845","1967-07-04","Polizeioberkommisar Heinz Burck widerspricht Duensing. Er sagt, die \"Leberwurst-Taktik\" entspreche nicht polizeitaktischen Methoden. Um 20.07 Uhr begann der Einsatz, der nach etwa 40 Meter eingestellt werden musste, weil man auf den harten Kern der Demonstranten gestoßen war.","Widersprüche vor dem Ausschuss im Rathaus ","","Neue Version über Polizei-Einsatz","Eigener Bericht",[7],1,[1],[5],1,"14","1"],["846","1967-07-04","Fortsetzung Aussage Burck, der äußert das Gefühl, verschiedene Polizisten sollten gegeneinander ausgespielt werden. Aussage mehrere Reporter: Jürgen Dobberke, Rundfunkreporter, sagt, die Demonstranten hätten eine feindliche Wand gegen die Polizei gebildet. Radiokorrespondent Clemens Borchardt sagt, er habe das Kommando: Jetzt reichts! Knüppel frei! Drauf!\" gehört - allerdings ist der Befehl nicht auf seinem Band gespeichert. Die BZ-Reporterin Monika Nelisen sah bereits vor Beginn der Oper mindestens drei verletzte Beamte. Olaf Langelüdeke von der Nachtdepesche sagt, die Sprechchöre seinen immer hysterischer geworden. Walter Barthel als Berliner Korrespondent des Kölner Stadtanzeigers berichtete, am Anfang seien die Demonstranten eher vergnügter Stimmung gewesen, die Situation habe sich aber durch das Vorgehen gegen Demonstranten auf Bäumen und dem Bauzaun verschlechtert. Danach hätten sich die Demonstranten mehr oder weniger hilflos verprügeln lassen müssen. Kurt Geisler (BM), von 19 bis 23 Uhr vor Ort, beobachtete, dass zur Ankunft des Schah massiv Eier, Farbbeutel, Raunkerzen und auch Steine flogen. ","Reporter sagt aus: Plötzlich flogen Eier und auch Steine","Widersprüche vor dem Ausschuss","","Eigener Bericht",[7],1,[1],[1],1,"14","6"],["847","1967-07-04","Unzufriedenheit in der Gemeinde Neu-Westend hält an. Kritik an der Diskussion mit linksgerichteten Studenten. Unzufriedenheit mit einem Gemeindepfarrer. Erste Drohungen mit Kirchenaustritten wegen der Öffnung der Kirche. Pfarrer verteidigen Entscheidung","Unruhe in Neu-Westend hält an","","","Eigener Bericht",[11],1,[1],[2],2,"14","1,2"],["848","1967-07-04","Kammergericht entscheidet über Andauer der U-Haft","Teufel bleibt in Haft","","","",[5],6,[1],[2],2,"24","4"],["849","1967-07-04","Polizeioberkommissar Burck sagt aus, dass Beginn der Räumung gegenüber der Oper weitgehend gewaltlos vonstatten ging.","Der Ausschuss war verblüfft","Räumaktion der Polizei gestern in ganz anderem Licht","","Peter Borowsky",[7],6,[7],[1],1,"24","4"],["850","1967-07-04","Kritik an Helmut Schoecks Studentenschelte \"Sollen die Studenten Rebellen sein?\" in der \"Welt\" vom 28.06.1967 (Datensatz 796)","Unverständnis","","","Leser",[1],4,[6],[2],2,"18","2"],["851","1967-07-04","In inneruniversitären Fragen haben demonstrierende Studenten häufig Recht, ihre allgemeinpolitischen Äußerungen seien aber oft abwegig.","Studenten","","","Co.",[1],4,[5],[2],2,"18","2"],["852","1967-07-04","Information über Beschuldigungen und Prozesstermin","Prozess gegen Teufel beginnt am Donnerstag","","","dpa",[5],4,[1],[2],2,"18","3"],["853","1967-07-04","Aussage des Oberkommissars Burck über den Beginn der Räumung vor der Deutschen Oper","Demonstranten zuerst ohne Knüppel abgedrängt","","Die Unklarheiten nehmen immer mehr zu - Vierte Auschusssitzung","v.C.",[7],4,[7],[1],2,"18","3"],["854","1967-07-05","Bericht von Innenminister Lücke: Illegale KP konzentriert sich vor allem auf Studenten und Pazifisten, Hochburg soll NRW sein, Themen: Vietnam Krieg ","KP hetzt die Studenten auf","","","mk",[9],2,[1],[2],2,"8","8"],["855","1967-07-05","Senat weist Haltung des FU-Konvents zu den Notstandsgesetzen entschieden zurück. Offener Brief von Senator Stein an alle Studenten. AStA und Konvent gefährdeten den Bestand der FU. Offener Brief des AStA bringe die Studenten in Gegensatz zur Wirklichkeit. Stein attestiert \"geradezu erschreckende Unkenntnis\". AStA beschwerte sich, dass Dutschke nicht in einer Schule auftreten dürfe. Flugblätter der Kommune I hätten zu neuen Brandstiftungen aufgefordert.","Ernste Mahnung von Senator Stein an alle FU-Studenten","","Politik des Konvents gefährdet Universität","Eigener Bericht",[11],1,[1],[1],2,"12","1,5"],["856","1967-07-05","Senat warnt FU-Studenten vor Eskalation. Konvent hatte Brief über Notstandsregelungen in Berlin formuliert","Ernste Mahnung an Studenten","","","Klaus Bär",[11],6,[1],[1],2,"24","4"],["857","1967-07-05","Flugblätter mit Aufforderung zu Brandstiftung aufgetaucht. Vor FU-Mensa wird Geld für Vietkong gesammelt.","Flugblätter  ","","","",[1],6,[1],[5],1,"24","4"],["858","1967-07-05","Senator kritisiert AStA wegen des Eindrucks der einseitigen politischen Festlegung.","Alle Studenten erhalten den offenen Brief des Senators","","Prof. Stein nimmt Stellung zum FU-Konventsbeschluss","Werner Stein",[9],4,[1,6],[5],2,"33","11"],["859","1967-07-05","Professoren verteidigen Studenten gegen Pauschalurteile aus der Bevölkerung","Hamburger Professoren verteidigen ihre Studenten","","","",[1],4,[1],[2],2,"33","3"],["860","1967-07-05","VDS-Hearing zur Notstandsgesetzgebung in Bonner Uni ohne Politiker","VDS: Regierung will keine Notstandsdiskussion","","","",[1],4,[1],[2],2,"33","3"],["861","1967-07-05","Plädoyer für eine weitere \"deutsche\" Universität in Berlin, um die verworrene Situation des akademischen Berlin zu klären","Berlin muss geholfen werden","","","Gustav Stein, MdB",[1],4,[5],[1],1,"22","2"],["862","1967-07-05","Schmidt betont das Recht auf Demonstrationen. Dehler will klare Grenzen für legitimen Protest. Martin weist hin auf Unterschied zwischen kleinen marxistischen Gruppen und großer Zahl von Studenten mit ihren berechtigten Anliegen.","Das Unbehagen der Studenten","Drei Politiker nehmen zu der Unruhe an den Universitäten Stellung","","Helmut Schmidt, Thomas Dehler, Berthold Martin",[1],4,[5],[4],2,"33","7"],["863","1967-07-05","Bünde zerstreiten sich über die Frage politischer Reformen innerhalb der Katholischen Studentengemeinschaft.","Uneinig über Reformpläne","","Katholische Studentengemeinschaft ohne \"Unitas-Staffenberg\"","kann",[11],4,[1],[2],2,"33","11"],["864","1967-07-06","Für den Senat besteht vor Ergebnis des Untersuchungsausschusses kein Anlass, den Polizeipräsidenten auszutauschen ","Erst mal abwarten","","","jo",[7],2,[1],[2],2,"10","2"],["865","1967-07-06","Antwort des Asta auf Brief von Senator Stein","AStA kontert Senator Stein","","","rb",[11],2,[1],[2],2,"10","3"],["866","1967-07-06","Befragung des Polizei-Beraters Dr. Rolf Umbach","\"Fast immer Vorbestrafte\"","","","k.a.",[9],2,[1],[2],1,"10","2"],["867","1967-07-06","Vernehmung des Innensenators Wolfgang Büsch durch den Untersuchungsausschuss zum Thema \"Jubelperser\" sowie zum  Ablauf der Geschehnisse vor der Oper.  ","Der Innensenator soll Polizeieinsätze steuern","","","Horst Zylka",[7],2,[1],[1],2,"10","2"],["868","1967-07-06","Angehörige der Berliner Freiwilligen Polizeireserve kündigen Rücktritt an, weil Polizei bei Zwischenfällen zu hart vorgegangen ist. ","Reservisten kündigten","","","dae/kh",[9],2,[1],[2],2,"10","2"],["869","1967-07-06","Büsch sagt vor dem Ausschuss, wenn er gewusst hätte, was sich gegen 20 Uhr vor der Oper abspielte, wäre er heraus gekommen. Die studentischen Proteste hätten von Anfang an eine große Bedeutung in seiner (kurzen) Amtszeit gehabt. Als ein Abgeordneter beklagt, der \"Kopf der Demonstranten\" sei nicht rechtzeitig unschädlich gemacht worden, sagt Büsch: \"Es ist rechtlich nur schwer vertretbar, Rädelsführer vorbeugend festzunehmen.\"","Büsch vor dem Ausschuss","","Innensenator: Ich wurde nicht informiert","MM",[7],1,[1],[2],1,"12","1,6"],["870","1967-07-06","Büsch gibt zu, die Situation nicht ganz im Griff gehabt zu haben. Heftige Diskussionen mit Senatsrat Hans-Joachim Prill, der einräumen muss, übereifrig gewesen zu sein. Roman Herzog sagt, Eier und Tomaten seien keine Waffen im Sinne des Gesetzes. Polizeipsychologe Rolf Umbach sagt über die psychologischen Mechanismen einer Demonstration aus. Bedeutung habe das Imponiergehabe. Duensing werde seinen Dienst nicht wieder aufnehmen","Büsch: 18 \"Jubel-Perser\" sind namentlich bekannt","keine ","Senatsrat machte Gespräche zu Beschlüssen","Eigener Bericht",[7],1,[1],[1],1,"12","6"],["871","1967-07-06","AStA kritisiert Senats-Warnung vom Vortag","AStA bleibt auf seinem alten Kurs","","","",[11],6,[1],[2],2,"28","4"],["872","1967-07-06","Sachverständigen Statements vor dem Untersuchungsausschuss, u. a. von Juraprofessor Roman Herzog","Die Sachverständigen hatten das Wort","Gestern im Untersuchungsausschuss","","Peter Borowsky",[7],6,[7],[1],1,"28","4"],["873","1967-07-06","Stellungnahme des AStA der FU zum offenen Brief an die Alliierten. Stein fordere lediglich zu Ruhe und Ordnung auf. AStA und Konvent aber werden auch künftig geeignet erscheinende Maßnahmen anwenden, die rechtsstaatliche Ordnung Westberlins zu erhalten.","\"Senator Stein macht es sich zu leicht\"","","AStA der Freien Universität nimmt zum offenen Brief Stellung","eb",[9],4,[1],[2],2,"18","11"],["874","1967-07-06","Landesverband des Mitteldeutschen Jugendkreises Berlin distanziert sich von SDS und Kommune I","Wieder Kritik am SDS","","","",[8],4,[1],[2],2,"18","11"],["875","1967-07-06","Beurlaubung des Polizeipräsidenten","Duensing weiterhin beurlaubt","","","",[7],4,[1],[2],2,"18","11"],["876","1967-07-07","Bericht vom Prozess gegen Fritz Teufel vor dem Gericht in Berlin. Professoren kommen zu Wort, Mutter von Teufel, Beschreibung der Atmosphäre im Gerichtssaal, medizinisches Gutachten spricht von sexuellen Störungen.","Weiße Mäuse blieben in der Handtasche","Teufel-Prozess","","Lutz Horst",[5],2,[1],[4],1,"12","2"],["877","1967-07-07","SPD-Landeschef von Schleswig-Holstein springt den Studenten bei: Brutalität und Besserwissen forderten die Haltung der Studenten geradezu heraus","\"Obrigkeit fordert Studenten heraus\"","","","Eigener Bericht",[1],1,[1],[2],2,"18","2"],["878","1967-07-07","Prozessauftakt wegen der \"Burn, Warehouse, Burn\"-Flugblätter. Langhans wäre beinahe nicht durch die Kontrolle gekommen, heißt es ironisch. Erst mit seiner Versicherung, er sei hier heute angeklagt, ließ man ihn ins Gericht","Langhans las in der roten \"Mao-Bibel\"","","Prozess gegen zwei Kommune-Studenten begann","M. K. ",[5],1,[1],[1],1,"18","3"],["879","1967-07-07","Anklage wegen öffentlicher Aufforderung zu einem Verbrechen (Kaufhausbrandstiftung). Angeklagte widersprechen und legen Beweggründe dar.","\"Wir wollten nur protestieren!\"","Die Kommune-Studenten Teufel und Langhans erklärten zu den Flugblätter:","","Hans Kricheldorff",[5],6,[7],[1],1,"36","4"],["880","1967-07-07","Fotoausstellung über Krawalle aus studentischer Sicht in der Galerie Jule Hammer im Europa-Center. Zur Eröffnung spricht Jochen Steffen.","Ausstellung über die Krawalle","","","",[1],4,[1],[2],2,"22","13"],["881","1967-07-07","Kommentar zum geplanten Hungerstreik in der Kirche Neu-Westend. Dutschke auf der Kanzel. Sympathisierender Pfarrer. Gläubige sehen Gotteshaus entweiht. Grenze zum Profanen beachten.","Kirche muss Kirche bleiben","","Hungerstreik im Gotteshaus? Suche nach neuen Wegen. Das \"Anderssein\" der Kirche.","Bernt Conrad",[3],4,[5],[1],2,"22","2"],["882","1967-07-07","SPD gründet an den Berliner Hochschulen Betriebsgruppen zusammen mit dem SHB","SPD-Betriebsgruppen an den Hochschulen gegründet","","","",[11],4,[1],[2],2,"22","13"],["883","1967-07-07","\"Studentengewerkschaft Bonn 1967\" will das hierarchische System der deutschen Unis beseitigen","Studentengewerkschaft gegründet","","","dpa",[11],4,[1],[2],2,"22","3"],["884","1967-07-07","Verhandlungstag im Prozess gegen Teufel und Langhans wegen Brandstiftung. Kritik an mangelnder Autorität des Vorsitzenden Richters","\"Grüß dich, Fritz!\" rufen die Freunde","Berliner Kommune I","Gelächter im Gerichtssaal - Ist der Angeklagte Teufel ein Brandstifter?","Hans-Wolfgang Sternsdorff",[5],4,[7,2],[1],1,"22","6"],["885","1967-07-07","Thomas Sprengel als Unabhängiger gewählt","Neuer TU-Parlamentspräsident","","","",[11],4,[1],[2],2,"22","13"],["886","1967-07-08","Bisheriger Verlauf der Ermittlungen,  Zeugenbefragung etc.  ","Bisher rund 250 Zeugen vernommen","","","jo",[7],2,[1],[2],2,"8","2"],["887","1967-07-08","Untersuchungsausschussvorsitzender Löffler lässt sich von Burck Geschehnisse an der Oper erläutern","Lokaltermin vor der Oper","","","k.a.",[7],2,[1],[2],1,"8","2"],["888","1967-07-08","Bericht über den zweiten Verhandlungstag im Prozeß gegen Teufel und Langhans.","Psychiater soll die beiden Angeklagten untersuchen","","Teufel-Prozeß wird vertagt, bis das medizinische Gutachten vorliegt","Eckhard Daenell und Peter Behrend",[5],2,[1],[1],1,"8","2"],["889","1967-07-08","Ulrich Enzensberger erscheint nicht als Zeuge beim Untersuchungsausschuss, wird beim Teufel-Prozess gesehen.","Polizei suchte den Zeugen vergeblich","","","Horst Zylka",[5,7],2,[1],[2],1,"8","2"],["890","1967-07-09","Studentenvertreter boykottieren die Sitzung des Disziplinarausschusses und machen auf diese Weise eine Behandlung des Falls Kommune I und Pudding-Attentat unmöglich","Die Sitzung fiel aus","","FU-Disziplinarausschuss: Beisitzer erschienen nicht","K. R.",[11],1,[1],[2],1,"12","6"],["891","1967-07-09","Theodor Adorno hielt eine Gastvorlesung an der FU über den \"Klassizismus von Goethes Iphigenie\". Darum waren einige Teilnehmer nicht einverstanden; sie hatten gehofft, Adorno würde zu aktuellen politischen Fragen Stellung beziehen. Daher wurden Plakate mit Sprüchen wie \"Berlins linke Faschisten grüßen Teddy den Klassizisten\" oder \"Iphigenianer aller Länder, vereinigt Euch!\". Adorno hatte sich geweigert, im Prozess gegen Teufel und Langhans als Gutachter den Satirecharakter der umstrittenen Flugblätter zu bestätigen.","Thema passte den Studenten nicht","","","",[11],1,[1],[2],2,"12","6"],["892","1967-07-08","Kammer unterbricht den Prozess und ordnet eine psychiatrische Begutachtung der beiden Angeklagten an. Teufel sagt: Er lässt sich untersuchen, wenn auch Gericht und Staatsanwaltschaft sich untersuchen lassen. Langhans verlangte einen Intelligenztest der Richter mit Veröffentlichung des Untersuchungsergebnisses. Auf neuem Flugblatt, das Teufel verteilt, werden die Staatsanwälte als \"Schleimscheißer\" bezeichnet. Mahler kritisiert: Überfällige Rehabilitierung Teufels würde verhindert","Kommune - ein Fall für den Psychiater?","","Prozess gegen Teufel und Langhans unterbrochen","M.K. ",[5],1,[1],[1],1,"12","3"],["893","1967-07-08","18 Personen gründen Demokratischen Club und schreiben Brief an Studenten gegen linksradikale Aktionen","Offener Brief an die Studenten","","","P.R.",[1],6,[1],[5],2,"24","5"],["894","1967-07-08","Mahler erhebt Bedenken gegen Untersuchung. Langhans verteilt im Gerichtssaal Flugblätter.","Erst einmal zum Arzt","Prozess gegen Kommune-Studenten wurde vertagt","","Hans Kricheldorff",[5],6,[7],[1],1,"24","4"],["895","1967-07-08","Zitate aus Kommune-I-Flugblatt. Wird in Bezug zur psychiatrischen Untersuchung gesetzt.","Ohne Kommentar","","","L.R.",[5],6,[5],[3],2,"24","4"],["896","1967-07-08","Zwei Zeugen, u. a. Ulrich Enzensberger, bleiben dem Untersuchungsausschuss teils unbegründet fern. Sollen vorgeführt werden. Weitere Zeugenaussagen.","Teufel schien wichtiger","","Zwei Zeugen kamen nicht zum Untersuchungsausschuss","Peter Borowsky",[7],6,[7],[1],1,"24","5"],["897","1967-07-08","Aus Solidarität mit Teufel und Langhans zeigen sich Studenten des Verteilens der fraglichen Flugblätter zu den Kaufhausbränden in Brüssel an.","Berliner Studenten zeigen sich selbst an","","","dpa",[5,1],4,[1],[2],2,"28","6"],["898","1967-07-08","Bericht von Geplänkeln zwischen Richter, Angeklagten, Verteidiger zu Frage der psychiatrischen Untersuchung von Teufel und Langhans","Gericht will Psychiater heranziehen","","Verfahren gegen Teufel und Langhans ausgesetzt","hws",[5],4,[1],[2],2,"28","6"],["899","1967-07-08","Fortsetzung der Zeugenvernehmungen. Fernbleiben von Ulrich Enzensberger.","Ein Zeuge hörte: \"Stürmt die Oper!\"","Berliner Demonstrationen","Lokaltermin in der Bismarckstraße - Abschlussbericht noch nicht im Juli","v.C.",[7],4,[1],[1],1,"28","6"],["900","1967-07-09","Vier Leserbriefe die kritisch auf Haubold-Beitrag eingehen.","Studenten keine Tagediebe","","","Leser",[4],5,[6],[2],2,"30","4"],["901","1967-07-10","Kritik an allzu großer Abgewogenheit der Beiträge von Schmidt, Dehler und Martin am 5.7. in der Welt.","Unbehagen","","","Leser",[1],4,[6],[2],1,"22","2"],["902","1967-07-11","Vier Leserbriefe über die Vertagung des Prozesses gegen Teufel und Langhans, ihr Verhalten vor Gericht und die Forderung, sie ließen sich nur dann psychiatrisch untersuchen, wenn auch das Gericht begutachtet würde. Vorschlag eines Lesers: Teufel und Langhans sollen die Kosten, die durch ihr Verhalten entstanden sind, abarbeiten.","Würde des Gerichts gefährdet","","Brüskierung - Empört - Sie sollen die Kosten tragen","vier Leserbriefschreiber",[5],1,[6],[3],2,"14","2"],["903","1967-07-11","Antrag des OSI-Fachschaftssprechers auf Abwahl des Konventsvorsitzenden verfehlt Mehrheit","Misstrauensantrag gegen Lefèvre knapp abgelehnt","","","",[11],4,[1],[2],2,"18","9"],["904","1967-07-11","Vermutungen über den zu erwartenden Inhalt","Programm der \"Gegen-Universität\"","","Heute abend soll ein Vorlesungskalender veröffentlicht werden","nl",[11],4,[1],[2],2,"18","9"],["905","1967-07-12","Anruf bei Strafverteidiger G.J. Roos: Kind tot, wenn Sie Kurras verteidigen","Wenn Sie den Polizisten verteidigen, bringen wir ihr Kind um!","Berlin: Anwalt des Kripo-Obermeisters Kurras bedroht","","rb",[7],2,[1],[1],2,"10","1"],["906","1967-07-12","Kommentar zu Anruf und Anschlag auf Springer-Gebäude, Studenten soll sich von derartiger Gewalt lossagen und distanzieren ","Nur ein Spaß?","","","BILD",[7],2,[5],[2],2,"10","1"],["907","1967-07-12","Zeugenvernehmung von Ulrich Enzensberger und Dagmar von Doetinchen de Rande vor dem Untersuchungsausschuß zu den Geschehnissen des 2. Juni 1967. Enzensberger wird als \"arbeitsunschlüssiger FU-Fernbleiber\" beschrieben.","Mit Rauchbomben zum Untersuchungsausschuß","","Kommune-Mitglied Enzensberger: Zulässige Demonstrationsmittel","Horst Zylka",[7,5],2,[1],[1],1,"10","2"],["908","1967-07-12","Ulrich Enzensberger und Dagmar von Goetinchen mussten von Polizeibeamten vorgeführt werden, weil sie zum geladenen Termin unentschuldigt gefehlt hatten. Sie bestätigen, Rauchbomben und Farbeier geworfen zu haben, bestreiten aber das Werfen von Steinen. Auch mehrere Polizisten sagen aus, z. B. zum Zeitpunkt der Lautsprecherdurchsage. Es sei 20.05 Uhr gewesen, das habe er auf einen Zettel geschrieben, sagte POM Heinz Rugor. Im Dienstbuch nachgetragen habe er es aber erst später.  POK Hans Kaiser sagt, bisher gebe es keine einzige Verletztenmeldung im Zusammenhang mit den Prügel-Persern vor dem Rathaus Schöneberg","Zeugen von der Polizei vorgeführt","","Kommune-Mitglied vor dem Untersuchungsausschuss","MM",[7],1,[1],[1],1,"12","6"],["909","1967-07-12","Herbert Marcuse aus den USA hielt Gastvortrag an der FU. Thema: Studentische Opposition in den USA. Sie hätten objektiv das Recht zum Widerstand. Wenn Lehrpläne an Universitäten zu starr seien, müssten Gegenuniversitäten gegründet werden. Notizen über weitere Veranstaltungen von Studenten an der PH und in Frankfurt. Studenten sollten nicht erwarten, dass sie Wählermassen mobilisieren könnten. Delegation von FU-Studenten bei der FDP in Bonn","\"Recht zum Widerstand\"","","Vortrag über studentische Opposition an der FU","eigener Bericht / AP",[1],1,[1],[2],2,"12","2"],["910","1967-07-12","Enzensberger und v. Doetichen halten bestimmte Wurfgeschossen für legitim bei Demos. Weitere Befragungen.","Zeugen vorgeführt","","Schah-Demonstranten von Untersuchungsausschuss vernommen","Peter Borowsky",[7],6,[7],[1],1,"28","7"],["911","1967-07-12","Leser setzt sich kritisch mit Steins Antwort an Studenten auseinander","Berlin braucht Ruhe und Ordnung von Dauer","","","Leser",[1],4,[6],[1],2,"20","6"],["912","1967-07-12","Leser kritisiert einen anderen Artikel, der die Beweggründe der Anti-Schah-Demonstranten in Zweifel gezogen hatte","Offene Antwort auf ein \"offenes Wort\"","","","Leser",[1],4,[6],[2],2,"20","6"],["913","1967-07-12","Zwei Zuschriften, die Bettermann-Gutachten begrüßen, nach dem studentischen Gremien kein politisches Mandat besitzen","Gutachten von Professor Bettermann","","","Leser",[1],4,[6],[2],2,"20","6"],["914","1967-07-13","An der FU beginnen die Semesterferien, doch damit werden sich die Probleme nicht von selbst erledigen. Neben den Folgen des unglückseligen 2. Juni muss die FU eine Mine entschärfen, die  Studenten und Assistenten gelegt haben: Die Kritische Universität ist nichts weiter als der Versuch, die FU zu untergraben. Das Veranstaltungsverzeichnis zeigt, dass es um einen Generalangriff geht: Politische Praxis anstelle von Lehre, sexuelle Aufklärung, die \"im praktischen Umgang\" verwirklicht werden soll. \"Tribunal gegen die - wie könnte es anders sein? - \"Springer-Presse\", Es ist Studenten gelungen, den Schah-Besuch umzufunktionieren. Inzwischen heißt es, die Universitätsreform sei eine Folge des 2. Juni, obwohl das Thema seit Jahren auf dem Tisch liegt. Bedenkliches Zeichen, dass für die KU kein Rektor und kein Professor verantwortlich zeichnet, sondern nur der AStA.","Die Mine von Dahlem","","","wbr",[11],1,[5],[2],2,"16","2"],["915","1967-07-13","Student sitzt in praller Sonne und liest Marcuse. Berliner unter einer Markise sagt: \"Markise schützt vor Sonnenstich - nicht Marcuse!\"","\"Markise schützt vor Sonnenstich - nicht Marcuse!\"","","","Stenzel",[1],1,[5,4],[2],1,"16","3"],["916","1967-07-13","RA Mahler machte auf einer Pressekonferenz, zu der die BM explizit nicht eingeladen war, schwere Vorwürfe gegen die Justiz. Sie habe 24 Zeugen, die vor dem studentischen Ermittlungsausschuss ausgesagt hatten, dass Fritz Teufel keine Steine geworfen habe, nicht vernommen. Justiz wies den Vorwurf zurück: Das Kammergericht habe entscheiden, dass diese Zeugen ungeeignet seien. ","Mahler kritisiert Berliner Justiz","","","Agenturen",[5],1,[1],[2],2,"16","5"],["917","1967-07-13","Leserbriefe: Das Benehmen von Teufel und Langhans müsse sofort mit Gefängnis geahndet werden. Ohnehin sei es schon schlimm genug, dass die Kosten der Verfahren dem Steuerzahler aufgebürdet werde, da die Angeklagten nichts haben. Gerade die Studenten der FU sollten begreifen, dass ihre Zukunft von den Grundlagen des Staates und der Steuerzahlenden Bevölkerung abhängt - und nicht umgekehrt. Ein dritter Leser verlangt hartes Durchgreifen des Staates. Statt wie die Katze um den heißen Brei herum zu schleich, sei exemplarische Bestrafung von Studenten das richtige Mittel. \"Sollen wir mit ansehen, wie eine kleine irregeleitete Gruppe unsere Demokratie und unsere Freiheit zum Teufel jagt?\"","Zweierlei Maß","","Zuviel Toleranz kann auch schaden","drei Leserbriefe",[5],1,[6],[5],2,"16","6"],["918","1967-07-13","Bericht über Vorstellung der Kritischen Universität, die für alle offen sein soll. Veranstaltungsverzeichnis und Zielsetzung vorgestellt.","Für jeden offen","","","dpa",[11],6,[1],[2],2,"24","2"],["919","1967-07-13","Kurras-Anwalt wird bedroht. AStA verurteilt das scharf.","Vom AStA scharf verurteilt","","","",[7],6,[1],[2],2,"24","4"],["920","1967-07-13","Kommentator vermutet hinter Erpressungsversuchen Studentengegner","Zu leicht gemacht?","","","Peer",[7],6,[5],[5],2,"24","5"],["921","1967-07-13","Kein Zwischenbericht vor Sommerpause wegen zu umfangreichen Beweismaterials.","Überarbeitet!","","Ausschuss muss künftig kürzertreten","",[7],6,[1],[2],2,"24","4"],["922","1967-07-13","ÖTV lädt AStA-Vertreter zu Diskussion, um Frontstellungen zwische Studenten und Polizei abzubauen.","AStA-Vorsitzende von ÖTV eingeladen","","","uhl.",[11],4,[1],[2],2,"16","6"],["923","1967-07-13","Stein zur Arbeit des Uni-Ausschusses und den aktuellen Problemen","\"Disziplinarrecht nicht missbraucht\"","","Professor Stein zu Verfahren gegen Studenten","eb",[11],4,[1],[2],2,"16","9"],["924","1967-07-13","Vorstellung der KU-Pläne. Unterstützung von Marcuse.  Noch keine materielle und personlle Absicherung.","Studenten planen \"Kritische Universität\"","","Professor Marcuse: Geeignetes Mittel zur Vorbereitung einer Krise des Systems","Co., V.D.",[11],4,[1],[1],2,"16","6"],["925","1967-07-13","Bei einer Diskussion mit Schülern äußert Ernst Lemmer, dass viele Studenten nur nach Berlin kommen, um sich vor dem Wehrdienst zu drücken. Auch seien viele Demonstrationen kommunistisch mitgesteuert.","\"Demonstrationen von Kommunisten mitgesteuert\"","","","",[1],4,[1],[2],2,"16","9"],["926","1967-07-13","Leser setzt sich kritisch mit den Beiträgen von Dehler und Martin in der WELT auseinander","Versagen der \"politischen Erziehung\"","","","Leser",[1],4,[6],[2],2,"16","2"],["927","1967-07-13","In einer Rede vor Schülern äußert Evers Verständnis für studentische Unruhe. Nicht in Radikalität abdrängen lassen.","Zwischen Anspruch und Wirklichkeit","","Senator Evers unterstützt die Forderungen der Ingenieur-Studenten","vor Schülern über die Studenten-Unruhen",[1],4,[1],[2],1,"16","10"],["928","1967-07-13","Ausführlicher Beitrag über die Wohnungsnot von Studenten in Berlin und die Reaktionen der Studentenwerke darauf","Empörung über zu teure \"Buden\"","","Studentenwerke werfen Behörden mangelnde Kontrolle vor","vd",[11],4,[1],[2],2,"16","9"],["929","1967-07-13","Anwalt Mahler hält seinen Mandanten für entlastet und zu Unrecht inhaftiert","Schwere Vorwürfe gegen die Justiz","","Rechtsanwalt Mahler: Teufel zu Unrecht in Haft","eb",[5],4,[1],[2],2,"16","10"],["930","1967-07-13","Kommentiert das Verfahren gegen Teufel und Langhans, indem er schildert. \"Der Beschluss des Gerichtes, eine psychiatrische Untersuchung der Angeklagten zu unternehmen, lag nahe, zumal partielle Intelligenz noch nie als ausreichender Beweis für geistige Gesundheit gegolten hat.\"","Teufelei - oder was sonst?","","","Matthias Walden",[5],4,[5],[1],1,"16","2"],["931","1967-07-13","Zwischenbilanz des Ausschusses vor der Sommerpause","Voreilige Schulssfolgerungen könnten Erregung nur steigern","","Nur statistische Angaben des Untersuchungsausschusses","cg",[7],4,[1],[5],2,"16","9"],["932","1967-07-14","Gerichtsrefrendarin Carla Petersen sagt aus und pocht dabei auf ihre Rechte","Carla erteilte Nachhilfestunden","Untersuchungsausschuß tagte zum letzenmal vor den Parlamentsferien","","Horst Zylka",[9],2,[1],[3],1,"10","2"],["933","1967-07-14","Verweise für Studenten, weil sie nicht aussagen wollten. Eine Gerichtsreferendarin verweigerte die Aussage, weil sie sich nicht selbst belasten wolle. Löffler ermahnt Studenten, die ganze Wahrheit auszusagen \"und nicht nur den Teil, der für die Polizei nachteilig ist.\" (zu Gromotka)","Zeugin verweigerte Aussage","","Untersuchungsausschuss erteilt Studenten Verweise ","MM",[7],1,[1],[1],1,"14","13"],["934","1967-07-14","TU-Studentenvertreter bemängeln, dass ihre Interessen nicht ausreichend berücksichtigt würden. Justiz kritisiert Mahler. Angehängt wird ein Satz aus einer ADN-Meldung: \"Tausende von Studenten in der Zone werden in den Sommermonaten vormilitärisch ausgebildet oder in Betrieben arbeiten müssen.\"","Krise in Berlins TU","","Studentensprecher verließen Akademischen Senat","Eigener Bericht",[11],1,[1],[5],2,"14","2"],["935","1967-07-14","Ungereimtheiten bei Beschreibung von Prügelszene.","Die Wahrheit kam stückchenweise","Zeugen vom Untersuchungsausschuss verwarnt","","Peter Borowsky",[7],6,[7],[1],2,"36","4"],["936","1967-07-14","Termin für Bericht des Untersuchungsausschusses. Kritik an Meinungsäußerungen von Zeugen.","Zwischenbericht erst nach der Sommerpause","","","K.B.",[7],6,[1],[2],2,"36","4"],["937","1967-07-14","Stimmt Leitartikel vom 7.7. zu und kritisiert Bischof Scharf","Kein Tummelplatz","","","Leser",[3],4,[6],[2],2,"26","2"],["938","1967-07-14","Kommentator sieht Gegenuni als Anti-Universität. Angriff auf Freiheit der Lehre. Zum Scheitern verurteilt","Droht die Gegen-Universität?","","","Günter Zehm",[11],4,[5],[1],1,"26","2"],["939","1967-07-14","Münchener Diskussionsveranstaltung mit und über Studenten und Polizei","Schreiber gilt als \"Musterknabe\"","","Diskussion in München über Polizei und Studenten","wfm",[1],4,[1],[2],2,"26","4"],["940","1967-07-14","Generalstaatsanwalt Dehnicke widerspricht Mahlers Vorwürfen.","Justiz weist Vorwürfe zum Teufel-Verfahren zurück","","","",[5],4,[1],[2],2,"26","13"],["941","1967-07-14","Auseinandersetzungen über VWL-Prüfungsordnung","TU-Studenten stellen Arbeit im Akademischen Senat ein","","","",[11],4,[1],[2],2,"26","13"],["942","1967-07-14","Zeugenaussagen und Filmdokumente belasten Polizisten","Letzte Zeugenvernehmungen vor dem Untersuchungsausschuss","Studenten ","Polizei belastet - Auch Ausschreitungen der Demonstranten","v.C.",[7],4,[1],[5],2,"26","4"],["943","1967-07-14","Parlament diskutiert Frage, ob Berliner Sammlungsgesetz so geändert werden kann, dass Sammlungen für Waffen unmöglich werden.","Sammlung für den Vietkong Anstoß zur Gesetzesänderung?","","CDU-Antrag überwiesen. Letzte Parlamentssitzung vor den Ferien","hae",[1],4,[1],[1],2,"26","13"],["944","1967-07-15","Generalstaatsanwalt Dehnicke erhebt scharfe Vorwürfe gegen Mahler. Es sei einmalig in der Justizgeschichte, dass ein Verteidiger die Hauptverhandlung vorweg nehme, indem er vor der Öffentlichkeit und der Presse eine Art Beweisaufnahme vorführe. ","Vorwürfe gegen Teufels Anwalt","","","Eigener Bericht",[5],1,[1],[2],2,"12","1"],["945","1967-07-15","Anklage wegen Landfriedensbruchs am 2. Juni","Anklage gegen Fritz Teufel fertiggestellt","","","Kr.",[5],6,[1],[5],2,"28","5"],["946","1967-07-15","SHB wirft Stein vor, Uni-Disziplinarrecht sei zur politischen Disziplinierung von Studenten benutzt worden","SHB entgegnet Senator Stein","","","",[11],4,[1],[2],2,"24","13"],["947","1967-07-15","Anklageschrift gegen Mahler fertiggestellt. Mahlers Vorgehen \"höchst bedenklich\".","Anklage gegen Teufel wegen Landfriedensbruchs","","Generalstaatsanwalt Dehnicke wirft Rechtsanwalt Mahler Eingriff in schwebendes Verfahren vor","alf",[5],4,[1],[3],2,"24","13"],["948","1967-07-16","Senator Stein ist dafür, den Unvereinbarkeitsbeschluss der SPD in Bezug auf den SDS aufzuheben. Er habe schon 1961 davor gewarnt. Innensenator Büsch verlangte, vorher müsse der SDS feststellen, dass die Berliner SPD nicht aus Faschisten und Reaktionären besteht","Stein plädiert für den SDS","","","Eigener Bericht",[8],1,[1],[2],2,"48","1"],["949","1967-07-16","Kritik an Senator Stein. Er verlasse mit seinem Vorstoß, den Unvereinbarkeitsanspruch aufzugeben, den Weg der rationalen Argumente gegen den SDS. Er habe Geld für Waffen gesammelt, sich gegen die parlamentarische Demokratie ausgesprochen, Gewalt zum legitimen Mittel der Politik erklärt und sich die wahnwitzige Meinung zu eigen gemacht, eine kleine Gruppe könne im Besitz der absoluten Wahrheit sein. Für die SPD ist das eine Zerreissprobe, denn viele Beamte seien der Ansitz, der Untersuchungsausschuss schlachte das falsche Schwein, nämlich die Polizei. Volkspartei könne die SPD nur sein, wenn sie die radikalen von beiden Seiten ausschließe","Wie lange hält die SPD das aus?","","","Jo.",[8],1,[5],[2],2,"48","2"],["950","1967-07-16","Karikatur: Drei Reiter mit der Fahne SDS verlassen die Burg SPD. Senator Stein ruft ihnen hinterher und hält ein Parteibuch hoch","Zum Stein-Erweichen","","","Oskar",[8],1,[5,4],[3],1,"48","2"],["951","1967-07-16","FU-Rektor will für die Kritische Universität keine Räume zur Verfügung stellen. AStA beklagt, die wissenschaftliche Arbeit von Studenten solle so verhindert werden. ","Rektor Lieber lehnt ab","","Studenten standen vor verschlossenen Türen","Eigener Bericht",[11],1,[1],[2],2,"48","2"],["952","1967-07-16","Kritische Auseinandersetzung mit der Situation der studentischen Opposition vor allem der FU. Rolle von Marcuse. Zur Selbstwahrnehmung: \"\"Die bewusst aus dem Zusammenhang gerissenen Zitate aus kritischen Kommentaren der Berliner Zeitungen wecken unter den Studenten - wenn ihnen die Worte oft genug wiederholt werden - den verdacht , alle seien gegen sie. Scharfe Angriffe gegen die angekündigten \"direkten Aktionen\": Einrichtung der \"Kritischen Universität\", bei der es nicht allem um Politik gehe, sondern auch um Sex. Direkte Aktionen gegen die \"Springer-Presse\", wie sie Dutschke im Spiegel angekündigt hat. \"Hier wird zum ersten Mal offen ausgesprochenen dass der Linksradikalismus Gewaltaktionen in seine Überlegungen einbezieht. Kontakt mit Berliner Arbeitern. das sei das große Zukunftsprogramm: die totale Revolution in West-Berlin. Es sei geradezu eine Ironie, dass ausgerechnet die Universität mit der freiesten Verfassung einen solchen radikalen Kern gezüchtet habe. \"Aber eben weil die FU so frei ist, konnten die Linksradikalen hier ihre ersten Kerben schlagen.\"","Die studentische Opposition und ihre Hintergründe","Revolte um jeden Preis?","","Walter Brückmann ",[1],1,[1],[1],1,"48","12"],["953","1967-07-16","Geht auf die Pläne zur Gründung der KU ein und beschreibt ihre Absichten anhand der Titel einiger geplanter Lehrveranstaltungen.","Ihre Sprache spricht für sich","\"Gegen-Universität\"","","hls",[11],5,[1,5],[2],2,"30","3"],["954","1967-07-16","Helmut Schmidt versucht die Unzufriedenheit deutscher Studenten zu ergründen. Neben manchem Irrtum seien etliche berechtigte Kritikpunkte zu finden.","Deutsche Studenten und die Demokratie","","Diskussionsbeitrag","Helmut Schmidt ",[1],5,[5],[1],1,"30","4"],["955","1967-07-17","Vorschlag von Senator Stein: Mitgliedschaft im SDS soll nicht mehr unvereinbar mit der Mitgliedschaft in der SPD sein.","Lanze für den SDS","","","rb",[8],2,[1],[2],2,"10","2"],["956","1967-07-17","Vorstellung der Aktion, die insbesondere in Köln und Bonn aktiv zu werden beginnt.","\"Aktion 67\" setzt völlig neue Akzente","Studenten: Mittelweg am Rhein","Es geht um die Hochschule, nicht um utopische Rebellion","Wolfgang Bergsdorf",[9],4,[1],[1],2,"20","8"],["957","1967-07-17","FU will KU keine Räume zur Verfügung stellen","FU-AStA will erneut um Raum nachsuchen","","","",[11],4,[1],[2],2,"20","11"],["958","1967-07-17","Senator Stein plädiert in \"Berliner Stimme\" für Aufhebung des Unvereinbarkeitsbeschlusses","SPD soll SDS aufnehmen","","","v.C.",[8],4,[1],[2],2,"20","3"],["959","1967-07-17","Autor bedauert Verhandlungspause, sieht Notwendigkeit aber ein.","Pause","","","v.C.",[7],4,[5],[2],2,"20","2"],["960","1967-07-17","Zwischenbilanz des Ausschusses vor der Sommerpause","Erst im Herbst forscht der Untersuchungsausschuss nach den Ursachen der Explosion","Berliner Krawalle","Parlamentarische Ermittlungen unterbrochen","Götz von Coburg",[7],4,[5],[1],2,"20","3"],["961","1967-07-18","Studenten weigern sich weiterhin, ihre Aufgaben im Disziplinarausschuss zu erfüllen. Damit ist dieses Gremium nicht mehr arbeitsfähig. Bald muss Wissenschaftssenator Stein im Wege seiner Rechtsaufsicht über die FU eingreifen. Mutmaßlich müssen dann die Disziplinarausschüsse aufgehoben werden","Nach dem letzten Appell muss Stein eingreifen","","FU-Disziplinarausschüsse bald ohne Studentenvertreter","Eigener Bericht",[11],1,[1],[1],1,"12","10"],["962","1967-07-18","(Selbst-)Vorstellung des neuen Clubs (als Gegenstück zum Republikanischen Club)","\"Uns platzte da der Kragen\"","","\"Demokratischer Klub\" will in die Diskussion","ski",[1],6,[1],[1],2,"24","2"],["963","1967-07-18","Kritik an Senator Steins Vorschlag, den Unvereinbarkeitsbeschluss der SPD mit dem SDS aufzuheben. Dies sei unter den gegebenen Umständen nicht mehr möglich, man hätte den SDS aber vielleicht besser nie ausgeschlossen. Parteien müssen versuchen, sich den Studenten verständlich zu machen","Stein-Idee","","","W.T.",[8],4,[5],[2],2,"16","2"],["964","1967-07-19","Liberale Studenten kritisieren den SDS, der von \"steigender Intoleranz\" und \"immer schroffer werdendem Dogmatismus\" bestimmt werde. Wer Geld für Waffen für den Vietkong sammle, dürfe sich nicht wundern, wenn er in die Isolation gerate","Studentenkritik am SDS","","","Eigener Bericht",[1],1,[1],[2],2,"12","1"],["965","1967-07-19","Diskussionsveranstaltung in der Götttinger Uni: nach emotionsgeladenem Beginn drei Stunden Gespräch um Sachfragen","\"Studenten kontra Killy und Henckel\"","","Doch in der Göttinger Diskussion blieben die Professoren oben","Georg Luze",[11],4,[1],[1],1,"20","2"],["966","1967-07-19","2. Juni als Startpunkt für Solidarisierungswelle. Gefördert durch langwierige Arbeit des Untersuchungsausschusses und unglückliches Taktieren des Bürgermeisters. Mittlerweile geht es den studentischen Gremien um politisches Mandat. Dutschke predigt Rätedemokratie. Bereitschaft, extremen Parolen zu folgen ist bei Studenten zurückgegangen.","Der \"Hefeteig\" Berlin","Student 67: Portraits deutscher Hochschulen (I)","Im nächsten Semester sind an der Freien Universität weitere Aktionen zu erwarten","H.-W. Sternsdorff",[11],4,[5],[4],2,"20","5"],["967","1967-07-20","Antrag der Studenten auf eine \"kritische Universität\" mit eigenen Vorlesungen etc. wird abgelehnt, zum zweiten Mal","\"Kritische Universität\" muss weiter warten","","","hb",[11],2,[1],[3],2,"8","2"],["968","1967-07-20","Protokoll der Frühschoppen-Sendung v. 14.7.67. Diskussion über Studenten und ihre Möglichkeiten, in West-Berlin zu demonstrieren, und über die Rolle der \"Springer-Presse\". Sehr lebendige, kontroverse Diskussion","Berlin, die Studenten und Höfers Frühschoppen","","Auszüge aus einer bewegten Fernsehdiskussion","Tonbandabschrift",[10],1,[1],[4],1,"14","7"],["969","1967-07-20","Wolfgang Büsch legt eine Dokumentation über die Entfremdung von FU-Studenten (genauer: teile der Studentenschaft) und der Berliner Gesellschaft vor. Zu den Krawallen wird festgestellt, eine linksradikale Studentengruppe habe diese bewusst inszeniert","FU-Dokumentation des Innensenators","","","Eigener Bericht",[1],1,[1],[2],2,"14","2"],["970","1967-07-20","FU-Rektor lehnt Raumvergabe an KU ab","AStA-Gesuch abgelehnt","","","",[11],6,[1],[2],2,"28","2"],["971","1967-07-20","Senat droht, Ausschüsse mit Richter zu besetzen, wenn Studenten Arbeit nicht wieder aufnehmen","Richter sollen in die FU-Disziplinarausschüsse","","","V.D.",[11],4,[1],[2],2,"18","1"],["972","1967-07-20","Schilderung der politischen Veränderungen an den Hochschulen. ","\"Wenn der Dutschke kommt?\"","Student 67: Portraits deutscher Hochschulen (II)","Auch in Braunschweig, Hannover und Göttingen gerät das studentische Leben in Bewegung","Eberhard Nitschke",[11],4,[1],[4],1,"18","5"],["973","1967-07-20","FU will KU keine Räume zur Verfügung stellen","FU-Rektor lehnt Antrag des AStA ab","","Gutachten angefordert","dw",[11],4,[1],[2],2,"18","9"],["974","1967-07-20","Leser äußert Unverständnis für Unterscheidung zwischen Sachbeschädigung und Angriffe auf Staatsbesucher","Stimmt was nicht","","","Leser",[1],4,[6],[2],2,"18","2"],["975","1967-07-21","Zu der Arbeitsbesprechung der \"Kritischen Universität\" kamen \"nur\" 200 Studenten","Nur 200 Studenten kamen","\"Kritische Universität\"","","rb",[11],2,[1],[2],1,"8","3"],["976","1967-07-21","Gemäßigte Studentengruppen bilden ein Bündnis, um gemeinsam gegen den SDS und den SHB anzutreten. Häußermann protestierte entschieden gegen die Weigerung des Rektors, der Kritischen Universität Räume zur Verfügung zu stellen","Gemäßigte sammeln sich","","","Eigener Bericht",[11],1,[1],[2],2,"16","1,6"],["977","1967-07-21","BZ hat Studentenvertretungen von TU und FU gebeten, ihre Anliegen zum Abdruck einzureichen. Hier Abdruck des TU-Textes \"ohne jede Kürzung\".","Was ist eine Utopie?","Ein Beitrag der Studentenvertretung der Technischen Universität Berlin","","Studentenvertretung der TU Berlin",[11],6,[6],[1],2,"36","12"],["978","1967-07-21","RCDS bezeichnet Unireform als Möglichkeit den SDS auszuschalten","Offene Kampfansage gegen den SDS","","","bow, az",[11],6,[1],[3],2,"36","4"],["979","1967-07-21","Konservative Studentengruppen an der FU gründen Gruppierung zur \"Gegenpolitisierung\"","Gegen-Entwurf zum Hochschulgesetz geplant","","\"Aktion 20. Konvent\" gegründet. CDU soll an der Ausarbeitung mitwirken","hae",[9],4,[1],[1],2,"24","13"],["980","1967-07-21","Schilderung der politischen Veränderungen an den Hochschulen. ","\"Gerade noch Zeit für die Freundin\"","Student 67: Portraits deutscher Hochschulen (III)","In Aachen ist Arbeit Trumpf- Kleine, aber aktive Gruppen in Bonn","G. Krems, R. Strauch",[11],4,[1],[4],1,"24","5"],["981","1967-07-21","Plädoyer für Hochschulreform","Die Universität muss sich wandeln","","Wissenschaftsplanung ohne Illusion. Die Vorschau bis 1970. Forschungsschwerpunkte bilden.","Walter Görlitz",[4],4,[5],[1],2,"24","2"],["982","1967-07-22","Zustimmender Leserbrief zu Brückmanns Analyse v. 16.7.1967. Radikale Studenten wollen die demokratische Ordnung ins Wanken bringen, offenkundig gewordene Zerstörungsabsichten. Hat die SPD aus der Zeit des Straßenterrors gegen Ende der Weimarer Republik nichts gelernt?","Revolutionäre Studenten","","","R. I., Berlin 42",[1],1,[6],[2],2,"10","6"],["983","1967-07-22","Schilderung der politischen Veränderungen an den Hochschulen","\"Bremser\" und Avantgardisten","Student 67: Portraits deutscher Hochschulen (IV)","In Tübingen, Heidelberg und Freiburg gab es keine \"Machtübernahme\"","Walter Pfuhl",[11],4,[1],[4],1,"24","5"],["984","1967-07-23","Leserbrief zum Abdruck des Protokolls von Höfers Frühschoppen. Kritisiert die Haltung eines Teilnehmers, der das Demonstrationsrecht von Studenten in West-Berlin eingeschränkt sieht. Der Vergleich mit Ost-Berlin zeige, dass dies nicht richtig sein. ","Studenten in Ost und West","","","L. G., Berlin 41",[11],1,[6],[3],2,"48","2"],["985","1967-07-23","Morgenpost-Interview mit Justizsenator Hoppe, der die Anklage gegen Teufel und Langhans verteidigt, der Forderung nach Enteignung des Springer-Verlages widerspricht und die Beschlagnahme der SDS-Kartei als unglücklich einschätzt","Hoppe warnt vor radikalen Studenten","","","Eigener Bericht",[1],1,[3],[2],1,"48","1,7"],["986","1967-07-23","Mit einer faktenreichen empirischen Arbeit belegen Kölner Studenten die Krise in ihrer Fakultät. Uni hält sich bedeckt.","Es geht auch ohne Krawalle","","Kölner Studenten: Größte europäische Wiso-Fakultät vor dem Chaos","Heiko Sven Hausemann",[11],5,[1],[3],2,"28","4"],["987","1967-07-24","Schilderung der politischen Veränderungen an den Hochschulen","Vier Semester Fingerhakeln","Student 67: Portraits deutscher Hochschulen (V)","Mainz, Frankfurt, Marburg Gießen - das Unbehagen spürt man überall","R. Großkopf",[11],4,[1],[4],1,"18","5"],["988","1967-07-24","Essenz aus Hoppe-Interview der Berliner Morgenpost","\"Gesetze gelten auch für Studenten\"","Berlin","Justizsenator verteidigt Maßnahmen gegen Rechtsbrecher","hws",[1],4,[1],[2],2,"18","4"],["989","1967-07-25","SPD will keine \"kritische Universität\", lehnt Antrag des AStA ab ","SPD lehnt ab","","","k,a,",[11],2,[1],[2],2,"8","2"],["990","1967-07-25","Psychologe Helmut Kentler attackiert scharf die Polizei. Die Freiwillige Polizeireserve und die Greiftrupps müssten aufgelöst werden. Regierung seit dem 2. Juni von Totstellkomplex betroffen ","\"Politische Führung überfordert die Polizei\"","","Psychologe: Greiftrupps müssen aufgelöst werden","Eigener Bericht",[7],1,[1],[2],2,"12","2"],["991","1967-07-25","SPD gegen \"Kritische Universität\"","SPD gegen AStA-Pläne","","","Eigener Bericht",[11],1,[1],[2],2,"12","1"],["992","1967-07-25","Berliner SPD lehnt KU-Pläne ab","Absage an den AStA","","","",[11],6,[1],[2],2,"24","2"],["993","1967-07-25","Schilderung der politischen Veränderungen an den Hochschulen","Plötzlich erschraken die Professoren","Student 67: Portraits deutscher Hochschulen (Schluss)","München, Erlangen, Hamburg, Kiel","Rüdiger Dilloo, Wilhelm F. Maschner, Karsten Plog, Helmut Alt",[11],4,[1],[4],1,"18","5"],["994","1967-07-25","SPD lehnt derart politisch einseitige Einrichtung an der Uni ab","SPD gegen \"Kritische Universität\"","","Landesvorstand tagte gestern - Lehrfreiheit soll bleiben","sh",[11],4,[1],[2],2,"18","11"],["995","1967-07-25","Protest u. a. des FU-AStA gegen Mittelsperrung für einen griechischen Studenten","Protest gegen Athener Regierung","","","el",[1],4,[1],[2],2,"18","11"],["996","1967-07-26","Polizeidirektor Dittmann weist in scharfer Form die Kritik von Diplompsychologe Kentler zurück. Der Standort der Berliner Polizei ergebe sich aus dem Grundgesetz und müsse nicht neu definiert werden","Kritik an der Polizei scharf zurück gewiesen","","","Eigener Bericht",[7],1,[1],[2],1,"12","1"],["997","1967-07-26","Der dienstälteste Beamte der Schutzpolizei wendet sich in einem offenen Brief an den Psychologen Günter Kentler. Der urteile ohne Sachkenntnis. Greiftrupps z. B. kann man nicht auflösen, weil sie gar nicht dauerhaft bestehen. Polizisten könnten von jeher unterscheiden zwischen Studenten an der FU und östlichen Agenten.","Berlins Polizisten sind durchaus zivil","","Dittmann: Dienstvorschriften längst entschlackt","Günter Dittmann, Polizeidirektor",[7],1,[1],[2],1,"12","3"],["998","1967-07-26","Fünf offenbar ungekürzte Beiträge mit Stellungnahmen von Vertretern des RCDS (Kritik ohne Wurfgeschosse), LSD (Mehr Mut zu Wahrheit), VDS (Drei Gründe des Unbehagens), SHB (Gegen die Brüchigkeit der Normen?) und SDS (Berlin ist ein Exempel). Reiche vom SDS begründet u. a. die Forderung nach Springer-Enteignung. Diese Passage markiert die Welt mit einem Asterix: \"Die 'Beseitigung' des Hauses Springer wurde zum ersten Male von Walter Ulbricht gefordert, als er am 21. April 1966 zum 20. Gründungstag der SED 'über die Möglichkeiten der konföderierten deutschen Staaten' sprach. [die Red.]\".","Was wir wollen","","(Einleitung)","Wulf Schönbohm, Reinhard Roericht, Hans-Joachim Haubold, Jens Litten, Reimut Reiche",[8,10,1,11,4],4,[6],[4],1,"18","7"],["999","1967-07-26","Langhans u. a. Kommunarden verteilen im Saal der Teufel-Verhandlungen Flugblätter mit Vorwürfen gegen Generalstaatsanwalt","Flugblatt gegen Dr. Dehnicke von der \"Kommune\" verteilt","","","",[5],4,[1],[2],2,"18","11"],["1000","1967-07-27","Unbekannte schmeissen Farbbeutel auf AStA-Haus und zertrümmern Fenster durch Steine  ","AStA-Haus beschmiert ","","","P.Be",[11],2,[1],[2],2,"8","3"],["1001","1967-07-27","Leserbrief: Bisher war die Bundesregierung davon ausgegangen, dass der Demokratie Gefahr von rechtsaußen drohe. Nun wird durch das Treiben in Berlin, dass die \"Seuche der Terrorherrschaft von links\" her eindringt. Gerd Löffler habe in seiner Rolle als Vorsitzender des Untersuchungsausschusses diesen zum Propagandainstrument des SDS gemacht.","Revolutionäre Studenten","","","R. L. Berlin 42",[1],1,[6],[3],2,"14","2"],["1002","1967-07-27","Fenster in AStA-Gebäuder der FU eingeworfen","Mit Steinen gegen AStA","","","",[11],6,[1],[2],2,"24","4"],["1003","1967-08-28","Trotz von Studenten angekündigten Protesten und Blockaden von Kaufhäusern wegen verlängerter Öffnungszeiten am Samstag hätten die Kaufhäuser sehr hohen Umsatz gemacht, Angestellte bugsierten Studenten hinaus, einer wird verletzt, eigenes Flugblatt wird entworfen, Arbeitszeiten werden eingehalten, Verkäuferin will keinen Protest der Studenten, können sich selber helfen.  ","Volle Kassen wie an Weihnachten!","Trotz Flugblatt-Aktion/Trotz Radau der Studenten/Die Händler strahlen... ","","Renate Philip und Lutz Horst",[1],2,[1],[1],1,"12","3"],["1004","1967-07-28","Generalstaatsanwalt stellt Strafantrag gegen die Verfasser, Verteiler und Hersteller eines Flugblattes, u. a. auch gegen Ulrich Enzensberger.","Hausverbot ","","","rb",[9],2,[1],[2],2,"10","2"],["1005","1967-06-28","Karl-Heinz Kurras muß vor Gericht, Anwalt kommt zu Wort. ","Kripo-Todesschütze muß vor Gericht","","Anklage: Fahrlässige Tötung des Studenten Benno Ohnesorg","Horst Zylka ",[7],2,[1],[1],2,"10","1"],["1006","1967-07-28","Bericht über die Anklage. Kurras habe zwei entscheidende Fehler gemacht: Er durfte zu dem fraglichen Zeitpunkt keinen Warnschuss abgeben und die Waffe auch nicht ungesichert in der Hand halten. Zwei Polizisten belasteten Kurras schwer. ","Anklage behauptet: Kurras durfte auf keinen Fall schießen","","Kriminalbeamter bleibt dabei: Es war Notwehr","KG",[7],1,[1],[1],2,"14","1"],["1007","1967-07-28","Zwei Polizeibeamte sagen im Prozess gegen Kurras übereinstimmend aus, dass Kurras nicht bedrängt worden sei. 20 Seiten umfasst die Anklageschrift. Staatsanwaltschaft glaubt, dass der Schuss sich unbeabsichtigt löste","Polizeibeamte sagen als Kronzeugen aus","","Kurras durch zwei Kollegen schwer belastet","KG",[7],1,[1],[1],2,"14","3"],["1008","1967-07-28","Brief von Kentler an Innensenator Büsch mit der Bitte, ihn aus dem Beratungsverhältnis zu entlassen. Grund: Kritik an seiner Kritik. Ernst Lemmer nimmt Polizei in Schutz.","Kentler hat genug","","Diplom-Psychologe möchte Polizei nicht mehr beraten","Eigener Bericht",[7],1,[1],[2],2,"14","3"],["1009","1967-07-28","Angesichts der Ereignisse des 2. Juni hat sich die Polizeiführung Prototypen von Polizeihelmen kommen lassen, wie sie in den USA gebräuchlich sind.","\"New Look\" für Berlins Polizei","","","Eigener Bericht",[7],1,[1],[2],2,"14","5"],["1010","1967-07-28","Zwei Beamte, die unterschiedlichen Einsatzkommandos angehören, sagen übereinstimmend aus, dass Teufel einen Stein auf Polizisten geworfen habe. Teufel bestreitet das. Er sei festgenommen worden, als er sich an einem Sitzstreik beteiligte","Polizisten sagen gegen Teufel aus","","","Eigener Bericht",[5],1,[1],[2],2,"14","1"],["1011","1967-07-28","Braunschweiger Professor erläutert, dass er u. a. wegen Senatskritik nicht am Schweigemarsch für Ohnesorg teilgenommen hat.","Schweigemarsch nicht gutgeheißen","Aus Briefen an die Redaktion","","Leser",[7],4,[6],[5],2,"24","6"],["1012","1967-07-28","Kritik an der nachträglichen Schah-Reaktion auf die Demonstrationen bei seinem Besuch. Hinweis des Kommentators: \"?dass Demonstrationen bei uns erlaubt sind - sogar gegen ausländische Staatsoberhäupter.\"","Beleidigt","","","W.T.",[1],4,[5],[2],2,"24","2"],["1013","1967-07-29","Polizeivizepräsident Moch und mehrere Beamte haben Anzeige gegen Sebastian Haffner wegen dessen Beitrag \"Die Nacht der langen Messer\" gestellt. Haffner sieht den Tatbestand der Beleidigung nicht als erfüllt an. Verfahren gegen zwei Polizisten, die wegen Anzeigen eines Journalisten und eines Passanten wegen zu harten Vorgehens anlässlich der Kudamm-Demonstrationen im Dezember 1966 angestrengt worden waren, sind eingestellt worden. Es bestehe nicht der geringste Anlass zu der Annahme, dass sie sich strafbar gemacht hätten.","Keine Beleidigung?","","Strafantrag gegen Sebastian Haffner","Eigener Bericht",[7],1,[1],[5],2,"12","5"],["1014","1967-07-29","Wegen Beleidigung eines ausländischen Staatsoberhauptes laufen in der ganzen Bundesrepublik etwa 100 Vorermittlungsverfahren. Die persische Regierung fordert, Anti-Schah-Demonstranten zu bestrafen. Die Bundesregierung hat darüber noch nicht entschieden. ","Hundert Ermittlungen gegen Schah-Demonstranten","","","Eigener Bericht",[7],1,[1],[2],2,"12","1"],["1015","1967-07-29","FU-AStA verlangt Teufels Freilassung noch während der Ferien, um \"Verurteilung um jeden Preis\" zu verhindern.","Flugblatt verlangt Teufels Freilassung","","","lbn",[5],6,[1],[2],2,"28","6"],["1016","1967-07-29","AStA auf einer Linie mit Sozialdemokraten und Liberalen im Landtag","In Stuttgart droht offener Streit um das Hochschulgesetz","Baden-Württemberg","Studenten befürchten Einengung der Selbstverwaltung","uhl.",[4],4,[1],[5],2,"24","4"],["1017","1967-07-29","Information des Justizministeriums","Polizei ermittelt gegen 100 Schah-Gegner","","","dpa",[1],4,[1],[2],2,"24","3"],["1018","1967-07-29","Schah wünscht Ermittlungsverfahren. Termin für Kurras-Verfahren wird erwartet. Laut Polizistenaussagen war Kurras zum Zeitpunkt der Schussabgabe nicht bedrängt.","Schah-Ersuchen betrifft 28 Personen","","","",[1],4,[1],[2],2,"24","9"],["1019","1967-07-29","Anzeigen von Polizeibeamten gegen Sebastian Haffner. Hatte im Zusammenhang mit 2. Juni im \"Stern\" vom 25. Juni 1967 KZ-Vergleich gebracht und von Pogrom gesprochen.","Strafantrag wegen Artikels im \"Stern\"","","","",[1],4,[1],[2],2,"24","9"],["1020","1967-07-29","Ermittlungen gegen acht Mitglieder der Kommune I wegen Verdachts der Anstiftung zur Brandstiftung. AStA-Aktion zugunsten Teufels","Ermittlungen gegen Kommune-Mitglieder","","","",[5],4,[1],[2],2,"24","9"],["1021","1967-07-30","Nachricht über das viertägige Seminar von SDS und FDJ in Ost-Berlin. Schon in der Formulierung des Themas habe sich der SDS der SED unterworfen. Die Rede war vom \"gesamtmonopolistischen Herrschaftssystem der Bundesrepublik\". Berliner FU-Studenten hatten schon mehrfach beklagt, dass SDS-Vertretern in Diskussionen der FDJ nicht gewachsen seien.","SDS und FDJ tagten gemeinsam","","","dpa",[8],1,[1],[2],2,"56","1"],["1022","1967-07-30","Während die Mauer für West-Berliner undurchdringlich ist, begrüßt die FDJ SDS-Vertreter am Tor \"Für Genossen\" mit Handschlag. ","Brüder in eins nun die Hände","","","Oskar",[8],1,[5],[5],1,"56","2"],["1023","1967-07-30","Hochkarätig besetzte Tagung unter Leitung von Prof. Erwin K. Scheuch. Ziel: Diskussion der unterschiedlichen Auffassungen von DGB und VDS über die Rolle der Politik im Studium. Kritiker sagen: Studenten haben selbstverständlich als Staatsbürger das Recht zu politischer Betätigung, aber nicht in ihrer Funktion als Studenten (und damit auch nicht mit den Ressourcen für studentische Selbstverwaltung). Nitsch kritisierte, dass auf der Tagung nur \"die sauberen und gutwilligen\" Studenten reden dürften. In West-Berlin habe sich ein \"Mechanismus des Terrors von oben\" entwickelt. Löwenthal widersprach scharf; man solle mit Begriffen wie Terror vorsichtig sein.  Löwenthal kritisiert scharf die Resolution des FU-Konvents gegen die Notstandsgesetze. Sie wirke wie aus dem Osten \"bestellt\". VDS-Chef Haubold forderte ein \"Kontrollrecht für die Studenten\" - leider wird nicht gesagt, worüber.","Gehören Studium und Politik zusammen?","","Wochenendtagung im DGB-Haus","wbr",[11],1,[1],[1],1,"56","7"],["1024","1967-07-30","Leser geht aus Schmidt-Beitrag ein und fordert Provokation von Studenten, aber auch Anstand und Würde.","Provoziert doch, Studenten!","","","Leser",[1],5,[6],[2],2,"34","4"],["1025","1967-07-30","Gemeinsame Diskussionsveranstaltung von Kuratorium Unteilbares Deutschland und VDS zu politischem Mandat und Hochschulreform.","Geistige Unruhe wichtig","","Studenten, Professoren und Politiker diskutierten","",[1],5,[1],[2],2,"34","34"],["1026","1967-07-31","Pro-Teufel-Demo im Europa-Center","Studenten demonstrierten","","","",[5],6,[1],[2],2,"36","3"],["1027","1967-07-31","Bericht über Vorgänge in Göttingen. U.a. über Springer-Berichterstattung in AStA-Infoblatt.","Schwimmt der AStA sich frei?","","","W.G.",[11],4,[1],[2],2,"16","6"],["1028","1967-07-31","Viertägiges Seminar von SDS und FDJ in Ost-Berlin. Referate und Betriebsbesichtigungen","Sozialistische Studenten tagen mit FDJ in Ostberlin","","","v.C.",[8],4,[1],[2],2,"16","4"],["1029","1967-07-31","Tagung zu aktuellen Hochschulfragen in Berlin. Stellungnahmen von Karl Wienand (SPD) und Richard Löwenthal. ","Löwenthal: Minderheiten werden nicht gehört","Hochschulen","Berliner Professor fordert Auseinandersetzung der Gesellschaft mit Fragen der Studenten","hws",[1],4,[1],[3],1,"16","4"],["1030","1967-08-01","Christa Ohnesorg erhält Stipenium der Friedich-Ebert-Stiftung, so soll sichergestellt sein, das sie ihr Studium fortsetzen kann","Stipendium für Ohnesorg-Witwe","","","rb",[7],2,[1],[2],2,"10","4"],["1031","1967-08-01","Witwe von Ohnesorg erhält auf Professorenvorschlag Stipendium als FU-Studentin","Stipendium für Ohnesorgs Witwe","","","",[7],6,[1],[2],2,"24","6"],["1032","1967-08-01","Leser widerspricht den im Welt-Forum vorgetragenen Beweggründen der Studenten. Sie sollten sich dem Lernen widmen.","Zu allererst einmal lernen, lernen, lernen","","","Leser",[9],4,[1],[2],2,"16","2"],["1033","1967-08-01","Aufgrund von polizeilichen Übergriffen auf Demonstranten wird die Einführung eine Kennzeichnung von Polizisten gefordert.","Tragen von Dienstnummern gefordert","","FU-AStA reicht Petitionen und Dienstaufsichtsbeschwerde ein","hae",[9],4,[1],[2],2,"16","9"],["1034","1967-08-01","Vorlesungsfreie Zeit als Grund für Nichtbesetzung der Ausschüsse.","Frist wurde erneut verlängert","","Erste Reaktion der Studentenschaft auf Ultimatum","eb",[11],4,[1],[2],2,"16","9"],["1035","1967-08-01","Bildhauer Hans Hauffe hatte AStA Ohnesorg-Denkstein angeboten, bislang ohne Reaktion","Bildhauer ist befremdet","","","",[7],4,[1],[2],2,"16","9"],["1036","1967-08-01","Leserbriefschreiber polemisiert gegen \"revolutionäre\" Studenten","Was wollen die Studenten?","","","C.B.",[9],1,[6],[2],2,"14","2"],["1037","1967-08-02","Kommentar zum SDS-FDJ-Treffen in Ost-Berlin","Wohltemperiert","","","zel",[8],4,[5],[2],2,"18","2"],["1038","1967-08-02","Berliner DJD fordert Freilassung Teufels aus der U-Haft und u. a. die Errichtung eines Ohnesorg-Mahnmals","Jungdemokraten plädieren für Teufel","","Einrichtung eines Verfassungsgerichtes für Berlin gefordert","el",[5],4,[1],[2],2,"18","9"],["1039","1967-08-03","AStA lässt Film über Schah-Besuch drehen ","AStA dreht Film","","","k.a",[11],2,[1],[2],2,"8","2"],["1040","1967-08-03","Student der Deutschen Film- und Fernsehakademie arbeitet an Dokfilm über 2. Juni","Dokumentarfilm im Auftrage des FU-AStA","","","",[1],4,[1],[2],2,"16","9"],["1041","1967-08-03","Schah-Forderung nach Bestrafung der Demonstranten lässt Demonstranten mit ihren Forderung nachträglich gerechtfertigt erscheinen.","Umdenken","","","Leser",[1],4,[6],[2],2,"16","2"],["1042","1967-08-04","Gegen den Pädagogik-Professor Dr. Gottschalch ist ein Disziplinarverfahren eingeleitet worden. Er hatte sich abwertend zu den politischen Verhältnissen in West-Berlin geäußert. ","Disziplinarverfahren","","","rb",[11],2,[1],[2],2,"14","5"],["1043","1967-08-04","Geldstrafe für Widerstand gegen Staatsgewalt und Körperverletzung","Student verurteilt","","","",[1],6,[1],[2],2,"36","4"],["1044","1967-08-04","Demonstrant zu Geldstrafe verurteilt.","\"Demonstrationsstimmung\" als mildernder Umstand","","","",[1],4,[1],[2],2,"20","12"],["1045","1967-08-04","Leserbrief zur Hochschulserie der Welt. Äußert Verständnis für Unbehagen der Studenten.","Keine Tafeln mehr","","","Leser",[11],4,[6],[2],2,"20","2"],["1046","1967-08-05","Fritz Teufle bleibt weiter in Haft, 14 neue Zeugen werden vernommen ","Neue Zeugen im Fall Teufel","","","rb",[5],2,[1],[2],2,"8","3"],["1047","1967-08-05","Vorausgehende Meldung: Es sollen weiter 14 Zeugen vernommen werden. Anschließender Kommentar: Plädoyer für Entlassung Teufels aus der U-Haft","Warum sollte Teufel flüchten?","Noch nicht genug Zeugen?","","Peer",[5],6,[5],[5],2,"28","4"],["1048","1967-08-05","SHB-Kritik an Dienstaufsichtsbeschwerde gegen Psychologen nach Polizeikritik","SHB: Polizeiführung bescheinigt sich Unfähigkeit","","","",[9],4,[1],[2],2,"26","9"],["1049","1967-08-05","Vernehmung weiterer Zeugen beschlossen","Entlastungszeugen für Teufel müssen auch gehört werden","","","hws",[5],4,[1],[2],2,"26","4"],["1050","1967-08-06","Studenten bezweifeln Rechtmäßigkeit von U-Haft gegen Fritz Teufel und kritisieren, dass Todesschütze Kurras noch frei ist.","Studenten-Kritik an Senator Hoppe","","","",[5],1,[1],[2],2,"48","2"],["1051","1967-08-06","Mit Flugblättern wird in Berliner Innenstadt Teufel-Freilassung und Hoppe-Rücktritt gefordert.","Flugblatt-Aktion für Fritz Teufel in der City","","","lbn.",[5],5,[1],[2],2,"32","25"],["1052","1967-08-07","Korrektheit der langen U-Haft Teufels wird von verschiedenen Seiten kritisiert. Studenten fordern Rücktritt Senator Hoppes.","Studenten fordern Rücktritt des Justizsenators","Berlin","Zunehmendes Unbehagen über den Fall Teufel - Kritik an der Staatsanwaltschaft","hws",[5],4,[1,5],[3],1,"16","4"],["1053","1967-08-08","Möglicher Tathergang, Löscharbeiten, Beteiligte der Flugblattaktion festgenommen. ","Rauchbomben an der Gedächtniskirche ","","Fortsetzung von Seite 1","",[5],2,[1],[3],1,"8","2"],["1054","1967-08-08","Zeitzünder bringt Rauchbombe in Gedächtniskirche zur Explosion. Vom Europa-Center werden Flugblätter geworfen","Zeitzünder-Rauchbomben in der Gedächtniskirche","11.56: Alarm für die Kripo","","Ne",[5],2,[1],[1],1,"8","1"],["1055","1967-08-08","Als in der KWG-Ruine eine Rauchbombe explodiert, verteilen Langhans und Enzensberger Flugblätter im Europa-Center. \"Zufällig\" zeitgleich.","Alles nur Zufall?","","","L.R.",[5],6,[1,5],[1],1,"24","3"],["1056","1967-08-08","Brand im Turm der KWG und Pro-Teufel-Flugblätter zur selben Zeit.","Brandnester und Flugblätter gleichzeitig festgestellt","","","",[5],4,[1],[2],2,"16","9"],["1057","1967-08-09","Studenten lassen Besetzungsfrist verstreichen","Erklärung statt Nominierung","","","",[11],4,[1],[2],2,"18","9"],["1058","1967-08-09","Studenten der Philosophischern Fakultät der FU wollen nicht in Disziplinarausschuß","Kein Student will Beisitzer werden","","","dpa",[9],1,[1],[2],2,"12","2"],["1059","1967-08-10","Während der Trauerfeier kommen Studenten mit Sarg aus dem dann Kunzelmann springt und \"Freiheit für Fritz Teufel\" fordert. Vorher hatten Studenten die \"Berliner Justiz\" zu Grabe getragen.","Kommune störte die Trauerfeier","","","k.a",[1],2,[1],[2],1,"8","3"],["1060","1967-08-10","Ersatzmann für Disziplinarausschuß der Philosphischen Fakultät der FU bestellt. Studenten schickten zwei Mal keinen Vertreter. ","Ohne Studenten","","","k.a.",[4],2,[1],[2],2,"8","2"],["1061","1967-08-10","Hinweis auf Text im Heft","Kommune störte den Staatsakt","Skandal vor dem Rathaus Schöneberg","","",[5],6,[1],[5],2,"28","1"],["1062","1967-08-10","Störung der Trauerfeier für Paul Löbe vor dem Rathaus Schöneberg durch verkleidete Kommune-I-Mitglieder. Kunzelmann verteilt aus einem Sarg heraus Pro-Teufel-Flugblätter","Makabrer \"Scherz\" der Kommune I","","","H.-J. Nicolai",[5],6,[1,5],[4],1,"28","3"],["1063","1967-08-10","Jurist anstelle eines nichtbenannten Studenten für Ausschuss bestimmt.","Senator Stein ernannte Beisitzer","","FU-Disziplinarausschuss wieder voll besetzt","ska",[11],4,[1],[3],2,"16","9"],["1064","1967-08-10","Kommune-Mitglied Kunzelmann stört Trauerfeier für ehemaligen Reichtstagspräsidenten Paul Löbe","Kommune-Studenten störten Trauerfeier","","Unwürdiger Zwischfall auf dem Kennedy-Platz","",[5],1,[1],[1],1,"14","1"],["1065","1967-08-10","Hamburger SDS versucht Statue des Afrikaforschers Herrman von Wissmann zu stürzen","SDS bekämpft jetzt Statuen","","","AP",[9],1,[1],[2],2,"14","2"],["1066","1967-08-10","Abschied von früherem Reichstagspräsidenten und Berliner Ehrenbürger Paul Löbe (SPD) im Rathaus Schöneberg","Abschied von Paul Löbe. Staatsakt im Rathaus Schöneberg","","Störaktion der \"Kommune\" auf dem John-F.-Kennedy-Platz","Tsp.",[5],8,[1],[5],1,"14","1"],["1067","1967-08-10","Mitglieder der Kommune I stören Staatsakt vor Schöneberger Rathaus mit Sarg und Kostümen und fordern Freiheit für Teufel","Abschied von Paul Löbe","","Fortsetzung von Seite 1","",[5],8,[1],[3],2,"14","2"],["1068","1967-08-10","24 Studenten wegen Störung der öffentlichen Ordnung bei Trauerfeier für Paul Löbe festgenommen","Polizei muß Störer schützen","","Demonstranten vor dem Rathaus während der Trauerfeier für Paul Löbe","",[5],8,[1],[1],2,"14","7"],["1069","1967-08-10","Letzte Drittel des Artikels mit Zwischenüberschrift \"Makabere Szene\". Hier Schilderung des \"Beerdigungs Happenings\" der Kommune I zugunsten Fritz Teufels. ","Sein Leben - unser Schicksal","","Würdiger Staatsakt für Paul Löbe","U.B.",[5],9,[1],[4],1,"12","5"],["1070","1967-08-11","Teufel wird frei gelassen, keine Fluchtgefahr mehr, Haftbefehl bleibt bestehen, SDS kündigt Fortsetzung seiner Aktionen an.","Tatverdacht bleibt","\"Komunne Teufel\" wieder frei","","rb",[5],2,[1],[2],1,"8","2"],["1071","1967-08-11","Lemmer beschwert sich über Vorkomnisse während Trauerfeier, Cliquen von Studenten gefährden Ansehen, könnte zu Tätlichkeiten kommen, Polizei und Justiz sollen mehr mithelfen. Bild fügt Erklärung der Studenten der TU hinzu, die sich von Kommune und Vorfall distanzieren. ","Studenten-Cliquen schaden Berlin","Lemmer schrieb an Albertz","","rb",[5],2,[5],[2],1,"12","3"],["1072","1967-08-11","Hinweis auf Texte im Heft","Justiz ließ Teufel laufen","Haftbefehl bleibt bestehen, aber","","",[5],6,[1],[2],2,"32","1"],["1073","1967-08-11","Vollzugsverschonung. Ermittlungen gegen Löbe-Demonstranten. SDS feiert Erfolg","Teufel aus der Haft entlassen","","Dringender Tatverdacht besteht nach wie vor","L.R.",[5],6,[1],[5],2,"32","4"],["1074","1967-08-11","Teils scharfe Reaktionen auf Störung des Löbe-Staatsaktes durch Mitglieder der Kommune I","Ernst Lemmer sagt Tätlichkeiten voraus","Berlin","TU-Studenten distanzieren ","Co",[5],4,[1],[2],2,"16","6"],["1075","1967-08-11","Gericht beschließt Haftverschonung","Fritz Teufel aus der Untersuchungshaft entlassen","","","fa, hws",[5],4,[1],[2],2,"16","1"],["1076","1967-08-11","Haftverschonung für Teufel mit Meldeauflagen","Haftverschonung unter Auflagen","","Strafkammer bejaht weiterhin dringenden Tatverdacht","fa, hws",[5],4,[1],[2],2,"16","6"],["1077","1967-08-11","TU-Studenten distanzieren sich von Störaktion des SDS bei Trauerfeier für Paul Löbe in Berlin","TU-Studenten nehmen Stellung","","","",[5],1,[1],[2],2,"12","1"],["1078","1967-08-11","Fritz Teufel erhält Haftverschonung bei Anklage wegen Landfriedensbruchs","Teufel nicht mehr in Haft","","Der Beschluß des Gerichts kam überraschend","L.R.",[5],1,[1],[5],2,"12","3"],["1079","1967-08-11","Rechtsanwalt Horst Mahler wirft Berliner Justiz Abhängikeit von Berliner Senat vor","\"Geltendes Recht ins Gegenteil gekehrt\"","","","LUK",[6],1,[1],[2],2,"12","3"],["1080","1967-08-11","Teufel aus U-Haft entlassen. Modalitäten des Prozesses werden kritisiert. Zeitpunkt der Freilassung nach Zwischenfall bei Löbe-Staatsakt wird in seiner Wirkung als fatal gewertet. Zum Zwischenfall: \"Wen der Moabiter Prozess noch das Schmunzeln lehrte, dem verschlug es angesichts jener geschmacklosen Szene während des Staatsaktes für Paul Löbe den Atem. Hier wurde, was vorher noch den Anstrich des Originellen hatte, auch in Studentenaugen zum ebenso beschämenden wie würdelosen Schauspiel.\"","Neue Peinlichkeiten","","","h.e.",[5],9,[5],[3],2,"12","2"],["1081","1967-08-12","Albertz und Lemmer kritisieren Löbe-Störung","Scharf verurteilt","","","",[5],6,[1],[2],2,"24","2"],["1082","1967-08-12","TU- und FU-AStA distanzieren sich (graduell unterschiedlich) von Kommune-I-Aktionen","AStA-Kritik an Kommune-Aktionen","","","",[5],6,[1],[2],2,"24","2"],["1083","1967-08-12","Albertz stimmt Lemmer in seiner Kommune-I-Kritik zu","\"Anstandsregeln wurden verletzt\"","","Albertz antwortet Lemmer","",[5],4,[1],[2],2,"24","13"],["1084","1967-08-12","AStA wertet Aktion als schädlich für Anliegen der Studenten. Anfrage des MdA Luster zu Teufel.","AStA kritisiert Kommune-Methoden","","Luster rügt die Beantwortung seiner Anfrage als unsachlich","sh",[5],4,[1],[2],2,"24","13"],["1085","1967-08-12","In der Rubrik \"Die Meinung der Opposition\" geißelt ein Mitglied des Abgeordnetenhauses die \"Radikalen\" als antidemokratisch","Den Teufel mit Beelzebub austreiben?","keine ","","Rudolf Luster",[5],8,[5],[1],2,"12","6"],["1086","1967-08-15","AStA der FU Berlin distanziert sich von Aktionen der Kommune, kritisiert aber auch Senat und Justiz","Ein Letztes zur Kommune","","","AStA Berlin",[5],8,[5],[1],2,"12","6"],["1087","1967-08-13","Kritik an der Haftentlassung Fritz Teufels","Es geht um das Ansehen Berlins","","","B.O.",[5],1,[6],[3],2,"52","2"],["1088","1967-08-13","Jugendliche feiern Entlassung Teufels aus U-Haft mit Aktion auf Kudamm","Narrereien à la Kommune","","","",[5],1,[1],[3],1,"52","3"],["1089","1967-08-13","Kritik an einseitiger Darstellung des Verbands Deutscher Studentenschaften zu den Vorgängen beim Schah-Besuch in Berlin","Beweis der Einäugigkeit - glanzkaschiert","","Zweifelhafte \"Dokumentation\" des VDS zum 2. Juni","Walter Brückman",[7],1,[5],[1],1,"52","7"],["1090","1967-08-13","Teufel-Freilassung auf dem Kudamm mit Demo begangen, bei der Passanten um Geld gebeten wurden, um den 13. August besser feiern zu können. Autor erzürnt über geschmacklose Verhöhnung der Maueropfer.","Da sagten die Berliner auf dem Kudamm: Pfui, Teufel!","","","",[5],5,[5],[1],1,"32","3"],["1091","1967-08-14","Bundesweit erstatten 2000 Studenten Selbstanzeige wegen Beleidigung eines ausländischen Staatsoberhaupts aufgrund von Schah-Kritik. Kommentator plädiert auf Einstellung des Verfahrens. Dazu eine Karikatur.","Sie hoffen auf die große Show","BZ meint:","","",[7],6,[5,4],[1],1,"32","2"],["1092","1967-08-14","Autor kritisiert VDS-Dokumentation als einseitig, jedoch dadurch nicht illegitim. Fragt, ob dadurch die Interessen von 300000 Studenten wahrgenommen werden. Nevermann federführend.","Selbsternennung zur alleinigen Opposition","","Eine \"Dokumentation\" des Verbandes Deutscher Studentenschaften zu den Ereignissen beim Schah-Besuch","Günter Krems",[1],4,[1,5],[3],1,"18","2"],["1093","1967-08-16","Kurras-Verhandlung terminiert","Termin steht fest","","","",[7],6,[1],[2],2,"24","24"],["1094","1967-08-16","Ankündigung des Prozeßbeginns gegen Kriminal-Obermeister Karl-Heinz Kurras","Prozeß gegen Kurras im November","","","",[7],1,[1],[2],2,"10","1"],["1095","1967-08-17","Unbekannte hängen an der TU in Dahlem vier Plakate gegen die Erhöhung des Semesterbeitrages für die studentische Selbsverwaltung: \" Für Dutschke ein Stück Seife, für Langhans ein Friseur, das soll der AStA haben und keinen Pfennig mehr\".   ","\"Für Langhans den Friseur?\"","","","rb",[11],2,[1],[2],2,"8","3"],["1096","1967-08-17","Teufel will Meldepflicht auf Revier nicht nachkommen, will freiwillig wieder in U-Haft","Teufel will den Knast","","","rb",[5],2,[1],[2],2,"8","3"],["1097","1967-08-17","Anti-AStA-Plakate auf FU-Gelände","Protest der anderen","","","",[11],6,[1],[2],2,"24","4"],["1098","1967-08-17","aus Protest gegen Meldeauflagen","Fritz Teufel geht freiwillig wieder in die Haftzelle","","","",[5],6,[1],[2],2,"24","3"],["1099","1967-08-17","Protestaktion mit Plakaten auf FU-Gelände gegen AStA-Beiträge","Protest gegen FU-AStA","","","",[11],4,[1],[2],2,"16","9"],["1100","1967-08-17","Professor der TH Braunschweig äußert sich zu Ohnesorg-Gedenken. DDR-Rentnerin beschreibt Vopo-Vorgehen gegen Jugendliche in der DDR. Leserin aus Hamburg will Ende der Berichterstattung zum Thema","Studenten 67: Protest, Aktion, Gummiknüppel","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[1],2,"16","11"],["1101","1967-08-17","Fritz Teufel verweigert Meldepflicht und will zurück in U-Haft","Teufel will wieder ins Gefängnis","","","",[5],1,[1],[2],2,"14","2"],["1102","1967-08-17","Radikale Studenten sollen, bevor sie protestieren, erst einmal das notwendige Wissen erarbeiten","Gesellschaftliches Verhalten","","","E.G. Sch.",[9],1,[6],[3],2,"14","2"],["1103","1967-08-18","Angekündigte freiwillige Rückkehr Teufels in Haft ist juristisch nicht möglich. Was tun?","Justiz im Teufelskreis","","","Peer",[5],6,[5],[2],2,"36","4"],["1104","1967-08-18","Fachschaften Zahnmedizin und Pharmazie kritisieren Auflösung durch Konvent","Zwei Fachschaften protestieren","","","",[11],1,[1],[2],2,"14","5"],["1105","1967-08-19","Dutschke vor Gericht, Saal mehrfach geräumt, 200 D-Mark Geldstrafe, Beamten auf Suche nach Verbrecher, hielten Dutschke wohl dafür. ","Dutschke verging im Gericht das Lachen","","","P.Be",[2],2,[1],[2],1,"8","4"],["1106","1967-08-19","Fritz Teufel zieht in Büßerhemd und Ketten vor das Gericht in Mobit und will wieder in Haft, wird in \"Schinderkarren\" durch die Gegend gezogen, Polizei beendet die Demo (50 Teilnehmer)","Polizei beendet Teufels \"Spuk\"","","","rb",[5],2,[1],[2],2,"8","4"],["1107","1967-08-19","AStA Karlsruhe kündigt VDS-Mitgliedschaft","AStA kündigte","","","",[11],6,[1],[2],2,"28","2"],["1108","1967-08-19","Haftwilliger Teufel in U-Haft-Anstalt Moabit abgewiesen","Teufel wurde abgewiesen","","","",[5],6,[1],[2],2,"28","4"],["1109","1967-08-19","AStA der Uni Karlsruhe kündigt Mitgliedschaft im im Verband deutscher Studentenschaften.","Austritt aus dem VDS","","","",[11],1,[1],[2],2,"10","1"],["1110","1967-08-19","Moabiter Schöffengericht verurteilt Rudi Dutschke wegen öffentlicher Beleidigung zu einer Geldstrafe","Dutschke muß 200 Mark zahlen","","","",[2],1,[1],[2],2,"10","5"],["1111","1967-08-20","Demonstrierende Studenten bei amerikanischer Militärparade in Berlin bitten um Schutz vor prügelnden Zuschauern","Demonstranten bitten um Polizeischutz","","","",[1],1,[1],[2],2,"56","3"],["1112","1967-08-20","Folge von Erziehung ist für den Kommentator die Erkenntnis des Zusammenhangs zwischen Ursache und Wirkung. Wer in dieser Hinsicht unerziehbar ist, ist ein Schwachkopf. Die Jugend nicht zu erziehen, sei Betrug an ihr. - Die Kommunarden werden zu ernst genommen.","Das ist Betrug an der Jugend","","","William S. Schlamm",[1],5,[5],[3],1,"36","5"],["1113","1967-08-20","Verteiler von Anti-Vietnamkriegs-Flugblättern bei US-Militäparade von Zuschauern verprügelt.","Demonstranten in Neukölln verprügelt","","","N.",[1],5,[1],[2],2,"36","1"],["1114","1967-08-21","Nationaldemokratischer Hochschulbund (NPD-nah) an der FU gegründet","Wind auch von rechts","","","",[11],6,[1],[2],2,"36","6"],["1115","1967-08-21","Zuschauer einer US-Parade in Neukölln attackieren Flugblattverteiler, die gegen Vietnamkrieg protestieren.","Zuschauer verprügeln Demonstranten","Berlin","Zwischenfall während einer amerikanischen Militärparade","hws",[1],4,[1],[2],2,"18","3"],["1116","1967-08-22","Bei einer US-Truppenparade in Neukölln ist es zu Störungen gekommen, gegen die Bürger handgreiflich vorgegangen sind. Hiergegen sei die Polizei nicht (ausreichend) eingeschritten. Dagegen will der Republikanische Club vorgehen.","Polizisten in privater Schlägerkartei","","","dpa",[1],6,[1],[2],2,"24","3"],["1117","1967-08-23","Regierender Bürgermeister Heinrich Albertz informiert sich über Vorfälle bei US-Parade in Neukölln","Albertz informierte sich in Neukölln","","","",[1],1,[1],[2],2,"12","2"],["1118","1967-08-25","CDU-Politiker fordert AStA der FU Berlin auf, gegen Aberkennung der Staatsbürgerschaft für tschechoslowakischen Schriftsteller Mnacko zu protestieren","Warum schweigt der AStA zu Mnacko?","","","dpa",[11],1,[1],[2],2,"16","2"],["1119","1967-08-27","Studentische Störtrupps des SDS erzwingen Schließung von Berliner Kaufhäusern.","Kaufhäuser unter Druck der Strasse geschlossen","","Gewerkschaft distanziert sich von SDS und Falken","L.R.",[8],1,[1],[1],2,"56","1,3"],["1120","1967-08-27","Demonstration gegen überlangen Sonnabend führt zu Kaufhausschließungen. Hinweis auf Text im Heft.","Demonstrationen in der City - Zwei Kaufhäuser schlossen","","","V.",[1],5,[1],[3],1,"42","1"],["1121","1967-08-27","Bilanz des Langen Sonnabends. Demo von Falken und SDS führte zur zeitweiligen Schließung der Kaufhäuser KaDeWe und Defaka.","Demonstranten legten zwei Kaufhäuser lahm","","Zwischenfälle beeinträchtigten \"langen Sonnabend\"","Wolfgang Voss",[1],5,[1],[1],1,"42","31"],["1122","1967-08-27","Drei Pro-Schlamm-, zwei Contra-Schlamm-Leserbriefe. Ein Leser macht Unterschied zwischen Erziehung und Ausbildung.","Ein Betrug an der Jugend?","","","Leser",[1],5,[6],[2],2,"42","4"],["1123","1967-08-28","Studenten setzen sich in die Gänge des KaDeWe und des Defaka und verteilen Flugblätter, Kaufhäuser schließen vor 21 Uhr, Horst Mahler ist dabei, wird dann wegen Hausfriedensbruch etc. von Berliner CDU angezeigt.","Strafanzeige gegen Anwalt der Studenten","Nach den Ladenschluß-Störaktionen","","Lutz Horst",[6],2,[1],[2],1,"12","1"],["1124","1967-08-28","Fortsetzung von Datensatz 1123. Scharfe Verurteilung der Vorkommnisse, verschiedene Stimmen kommen zu Wort, Mahler spielt auf Seite 3 keine Rolle mehr. ","Anzeige gegen Studentenanwalt","","Fortsetzung von Seite 1","Lutz Horst",[6],2,[5],[2],2,"12","3"],["1125","1967-08-28","CDU-MdA erstattet Anzeige gegen Mahler wegen Störaktionen in der City anlässlich Langem Sonnabend, u. a. wegen einer Diskussion im KaDeWe.","Anwalt vor dem Kadi?","Stör-Aktionen in der City","","l.r.",[1],6,[1],[1],1,"36","4"],["1126","1967-08-28","Erwägungen zum Langen Sonnabend, und ob Mahler, der namentlich nicht genannt wird, hier der richtige Ratgeber ist.","Wohl kein guter Partner","","","ro",[1],6,[5],[5],2,"36","4"],["1127","1967-08-28","Enzensberger, Lettau, Walser, Neuß, Krüger werden einem CDU-Funktionär im Zusammenhang mit der Gegenwehr gegen Demonstranten bei US-Parade \"Mordhetze\" vor.","Man kann es auch übertreiben","","","",[11],6,[1,5],[2],2,"36","4"],["1128","1967-08-28","SDS räufelt den Geduldsfaden des Senats auf","\"Probieren geht über studieren\"","","","",[8],6,[5],[3],1,"36","4"],["1129","1967-08-28","Arzt schlägt auf einem Psychotherapie-Kongress Einrichtung von Betreuungsstellen für Studenten vor.","Seelische Störungen","","","dpa",[1],6,[1],[3],2,"36","4"],["1130","1967-08-28","Demonstranten um RA Mahler versuchen in Kaufhäusern mit Kunden zu diskutieren. Zwei Häuser schließen vorfristig","Vorfälle auf der Tauentzien beschäftigen die Justiz","","Anzeige gegen Rechtsanwalt Mahler","wt",[1],4,[1],[1],1,"18","11"],["1131","1967-08-28","Kommentator betont Recht auf Revolte. Versucht deren Ursachen zu ergründen. ","Die Revolte der Jugend","","Flucht zu künstlichen Gegenbildern. Für die Demokratie erzogen? Freiheit heißt nicht Unverbindlichkeit.","Walter Görlitz",[1],4,[5],[1],2,"18","2"],["1132","1967-08-29","Karikatur, Hausfrauen wollen ihren \"Mob\" an der Kaufhauskasse umtauschen, eine der Frauen hat ein SDS-Mitglied unter dem Arm.","\"Wir möchten unseren Mob umtauschen!\" (Karikatur)","","","zel",[9],2,[5,4],[2],1,"8","3"],["1133","1967-08-29","Sammlung kritischer Stimmen zu Maßnahmen gegen Langen Sonnabend. \"?in hoffnungsloser Isolierung von der Bevölkerung\"","Vor den falschen Karren gespannt","Scharfe Kritik an Urhebern der Krawalle am Sonnabend","","P.R.",[1],6,[5],[1],2,"24","2"],["1134","1967-08-29","Berliner Kaufleute fordern Maßnahmen gegen \"Treiben antidemokratischer und radikaler Minderheiten\"","Berliner an den Senat: Schluß mit dem Terror!","","Strafanträge gegen Radikale?","",[1],1,[1],[1],2,"14","1"],["1135","1967-08-29","Öffentlicher Brief von Helmut Lindermann an den Vorsitzenden des Untersuchungsausschusses zu den Ereignissen beim Schah-Besuch am 2. Juni ","Ausschuß wieder an der Arbeit","","","",[7],1,[1],[5],2,"14","3"],["1136","1967-08-30","Weitere Stimmen zu Störungen und zur Frage des Langen Sonnabends. Nächster Langer Sonnabend für 30.9. angekündigt.","Trotz Krawall - wieder langer Sonnabend","","","",[1],6,[5],[1],2,"28","4"],["1137","1967-08-30","Leser kritisiert \"unerträgliche\" Zustände. Studenten sollten lieber arbeiten.","Unerträglich","","","Leser",[1],4,[6],[2],2,"20","2"],["1138","1967-08-31","Fritz Teufel kommt Meldepflicht nicht regelmäßig nach, muss unter Umständen mit Verhaftung rechnen, meldet sich aber, wenn er bei Mutter ist (Urlaub) ","Keine Extra-Wurst für Fritz Teufel","","\"Kommune\"-Student Fritz Teufel ist ein Bürger wie jeder andere. Ihm wird keine Extrawurst gebraten! ","zy",[5],2,[1],[2],1,"12","3"],["1139","1967-08-31","Polizeigewerkschaft wendet sich mit Petition an Senat: Wiederherstellung der Rechtsstaatlichkeit auf Berlins Straßen. Polizisten seien auf Anweisung von höchster Stelle gezwungen bei Demonstrationen Verstöße gegen rechtsstaatliche Anordnungen zu dulden.","Die Polizei ist sauer","Demonstranten dürfen, was anderen Bürgern verboten ist","","L.R.",[9],6,[1],[1],2,"32","3"],["1140","1967-08-31","Aufbau eines Psychologischen Dienstes für die Polizei","Dr. Umbach hilft Berlin","","","",[9],6,[1],[2],2,"32","3"],["1141","1967-08-31","Teufel muss Meldeauflagen erfüllen","Kammergericht besteht auf seinem Beschluss","","","dpa",[5],6,[1],[2],2,"32","3"],["1142","1967-08-31","Schwäche des Senats gegenüber Linksradikalen schüren Angst der Westberliner, bald von Ost-Berlin einverleibt zu werden.","Unverständliche Haltung des Senats","","","A. St.",[9],1,[6],[3],2,"16","2"],["1143","1967-08-31","Polemische Attacke eines Leserbriefschreibers auf den Senat, der Berliner nicht vor studentischen \"Radaubrüdern\" schützen kann","Wir warten auf Antwort","","","F.A.R.",[9],1,[6],[3],2,"16","2"],["1144","1967-09-01","Sprecher der FU-Studenten Häusermann verteidigt Aktionen, Wort \"Terror\" sei unangemessen, Dutschke meldet sich zu Wort, man sei nun aus den Unis raus. ","Studenten-Chef: \"?aber der Berliner Senat ist doof\"","","Berufsdemonstrierer nahmen Stellung zum langen Sonnabend ","Lutz Horst",[1],2,[5],[3],2,"14","2"],["1145","1967-09-01","Republikanischer Club widerspricht der Aussage, dass Maßnahme gegen Langen Sonnabend Akt der Gewalt gewesen sei. Dutschke lobt Aktion.","Kein Akt der Gewalt","","","lts",[1],6,[1],[2],2,"44","3"],["1146","1967-09-01","Kritik an Aktion gegen Ladenöffnungszeiten","Der rote Pöbel entscheidet nicht. / AStA gerät ans Gängelband.","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[2],2,"22","12"],["1147","1967-09-01","Berliner Abgeordnetenhaus will über linke Krawalle debattieren","Diskussion um Krawalle","","","",[1],1,[1],[2],2,"18","1"],["1148","1967-09-02","Ausschußvorsitzender Gerd Löffler verteidigt sich gegen Offenen Brief von Helmut Lindermann","Löffler an Lindermann: \"Unrichtige Behauptung\"","","Ausschußvorsitzender beantwortet Offenen Brief","",[7],1,[1],[5],2,"14","3"],["1149","1967-09-03","Kommentator: APO-Anbiederungsversuch an Gewerkschaft etc. gescheitert. Arbeitnehmerinteressen von politischen Absichten der Linken unterscheiden.","Die Lehren aus dem Kaufhaus-Krawall","","Unmut der Berliner Bevölkerung über radikale Minderheit wächst.","Herbert Hausen",[1],5,[5],[3],2,"42","4"],["1150","1967-09-06","Bericht von Kontroversen auf Frankfurter SDS-Kongress, auf dem Duschke in einem Referat einen \"großstädtischen Guerillakrieg\" in der BRD gefordert hat. Vorwürfe, er sei ein Revisionist bzw. Anarchist. Erwähnung von FDJ-Vertretern.","\"Dutschke ist ein Anarchist\"","","Vorwürfe auf dem SDS-Kongress","Ne.",[8],4,[1],[2],2,"22","3"],["1151","1967-09-06","Teilnahme Teufels am Frankfurter SDS-Kongress trotz eingezogenen Personalausweises","Teufel reiste mit dem Reisepass","","","",[5],4,[1],[2],2,"22","13"],["1152","1967-09-06","CDU-nahe \"Politisch-Soziale Korrespondenz\" (PSK) erhebt schwere Vorwürfe gegen und Berliner Senat","CDU wirft Senat Versagen vor","","","Erd.",[11],1,[1],[2],2,"12","2"],["1153","1967-09-07","Klaus Granatz schreibt Brief an Senat, will ASTA nicht mitfinanzieren, will Bschlüsse des Konvent nicht akzeptieren, bitet Abgeordnete einzugreifen.","FU-Student platzte der Kragen!","Proteste gegen AStA/Proteste gegen Uni-Parlament/Protest gegen Radikale","","Klaus Heine",[11],2,[1],[1],1,"8","2"],["1154","1967-09-07","Reportage von SDS-Tagung in Frankfut/Main. U. a. geht es um Maßnahmen gegen Springer. Hierzu Zitat von Mahler.","?und über allem die Fahne des Vietkong","","","",[8],6,[7,5],[1],1,"28","4"],["1155","1967-09-07","Kritik am evangelischen Bischof Kurt Scharf, der Rudi Dutschke predigen ließ","Fragwürdig","","","ie.",[2,3],1,[5],[2],2,"16","2"],["1156","1967-09-07","Helmut Lindermann fordert Ausschussvorsitzenden Löffler auf, gegen Falschaussagen von Zeitungen rechtliche Schritte einzuleiten","Lindermann an Löffler","","Ausschuß-Vorsitzender soll Klage erheben","",[7],1,[1],[3],2,"16","8"],["1157","1967-09-08","Fritz Teufel fährt nach Amsterdam, Dutschke und Krahl wurden angezeigt wegen Sprengung einer Vietnam-Disskussion im Amerika Haus.  ","Teufel: Urlaub von Berlin","","","rb",[5],2,[1],[2],2,"12","4"],["1158","1967-09-08","Auflösung eines Sitzstreiks in Frankfurt","Auch die Frankfurter Polizei hat nun ihre Mühe mit linksradikalen Demonstranten","","","",[8],6,[1],[2],1,"30","2"],["1159","1967-09-08","Dutschke bei SDS-Kongress gegen Wiederzulassung der KPD, da sie \"eine sich anpassende Fraktion des Bonner Parlamentarismus\" sein würde. Maßnahmen gegen Springer geplant.","Dutschke gegen KP-Zulassung","","","",[8],4,[1],[2],1,"22","6"],["1160","1967-09-08","Bochumer Studentenzeitschrift ruft zur Gründung von Studentengewerkschaft auf.","Aufruf zur Gründung einer Studentengewerkschaft","","","dpa",[11],4,[1],[2],2,"22","6"],["1161","1967-09-08","Frankfurter Polizei will Anzeige gegen Rudi Dutschke wegen Hausfriedensbruch erstatten.","Anzeige gegen Dutschke","","","",[2],1,[1],[2],2,"16","1"],["1162","1967-09-08","In einer Sondersitzung will sich der Akademische Senat der FU mit der neugegründeten \"Kritischen Universität\" des SDS auseinandersetzen.","Uni in der Uni?","","","",[11],1,[1],[2],2,"16","5"],["1163","1967-09-11","Berliner und Frankfurter Polizei suchen an Rand von Kundgebungen in Frankfurt nach Fritz Teufel, der eigentlich wieder in das Gefängnis soll. Nach Angaben des SDS befindet er sich noch in Frankfurt.","Als die Polizei zupackte war Teufel verschwunden","","","rb",[5],2,[1],[2],1,"14","2"],["1164","1967-09-09","Anti-Schah-Demonstranten werden nicht strafrechtlich verfolgt. ","Die Anti-Schah-Demonstranten","","","k.a.",[1],2,[1],[2],2,"10","10"],["1165","1967-09-09","Teufel  in Amsterdam, Grenzbeamte sollen ihn festnehmen, Studenten: Kommt von alleine wieder zurück.","Fritz Teufel muss wieder hinter Gittern","","Grenzbehörde alamiert: Nehmt ihn fest!","",[5],2,[1],[1],1,"10","2"],["1166","1967-09-09","Teufel hat gegen Meldeauflagen verstoßen","Teufel muss wieder in den Knast","","","dpa",[5],6,[1],[3],2,"36","5"],["1167","1967-09-09","Neben verschiedenen Gruppierungen insbesondere Darstellung der Position von Alexander Schwan vom OSI","Aus \"negativ\" wurde \"aufgeschlossen\"","","FU-Professoren änderten Einstellung zur Gegen-Universität","cg",[11],4,[1],[2],2,"28","9"],["1168","1967-09-09","Kampfansage an den Teil der Studenten, der die Demokratie mißachtet, Warnung vor Weimarer Verhältnissen","Spielregeln der Demokratie","","","",[1],1,[6],[3],2,"12","2"],["1169","1967-09-11","Vier von fünf Vorstandsposten mit Dutschke-Anhängern besetzt. Anti-Springer-Maßnahmen beschlossen. Statt Teufels irrtümlich anderer \"Bartträger\" verhaftet.","Die Radikalen um den Berliner Dutschke setzen sich im SDS durch","Studenten","Frankfurter Tagung endet mit Krawall","Ne.",[8],4,[1],[5],2,"18","6"],["1170","1967-09-12","Bürgermeister Albertz spricht vor Landesausschuß der SPD über die große Anfrage der CDU im Bund. Thema: APO  ","SPD gab grünes Licht für Albertz","","","jo",[9],2,[1],[2],1,"8","2"],["1171","1967-09-12","Mahler: \"Den Zeitpunkt, zu dem sich Teufel stellt, bestimmen seine politischen Freunde und nicht die Justiz.\" Dazu eine Karikatur, die Justiz rollt Fritz Teufel den roten Teppich aus.","Teufel will sich stellen","","","L.R.",[5],6,[1,4,5],[3],1,"28","3"],["1172","1967-09-12","Kritik an Conrad-Beitrag und Mahnung zu sachlicher Auseinandersetzung","Mit den Studenten sachlich reden","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","7"],["1173","1967-09-13","Parlamentspräsident Sickert sorgt sich nicht vor angekündigtem Parlaments-Go-in von Teufel","Nicht zu ernst nehmen","","","",[5],6,[1],[2],2,"32","7"],["1174","1967-09-13","Auflistung der Geldzuweisungen an Studentengremien der Berliner Hochschulen","Prof. Stein erläuterte Studenten-Etat","","Antwort auf kleine Anfrage eines CDU-Abgeordneten","sh",[4],4,[1],[5],2,"22","14"],["1175","1967-09-13","Teufel will sich den Berliner Behörden stellen","Teufel wieder da","","","",[5],1,[1],[2],2,"14","3"],["1176","1967-09-14","CDU-MdB kritisiert den SDS","Martin: SDS bewegt sich am Rande der Verfassung","","","dpa",[8],4,[1],[2],2,"22","6"],["1177","1967-09-15","Linke Gruppen wollen mit Go-in im Abgeordnetenhaus gegen \"Versagen von Exekutive, Presse, politischer Führung und Justiz\" protestieren. Bei dieser Gelegenheit wird sich Teufel stellen.","Wollen uns das \"Zittern\" lehren?","","","L.R.",[5],6,[1],[5],2,"40","3"],["1178","1967-09-15","Anriss und Hinweis auf Text im Blatt","Demonstranten wurden kriminell - Polizeiführung hat versagt","Der Parlamentarische Untersuchungsausschuss für die Schah-Krawalle stellt eindeutig fest:","","",[7],6,[1],[5],2,"40","1"],["1179","1967-09-15","Fazit: Jubel-Perser und Schah-Gegner haben teils kriminell gehandelt, Polizeimaßnahmen waren grundsätzlich gerechtfertigt aber teils zu hart, Polizeiführung hat restlos versagt.","Das \"Urteil\" über die Krawalle am 2. Juni","Am Montag legt der Parlamentarische Untersuchungsausschuss seinen Bericht vor","","Klaus Bär",[7],6,[1],[4],2,"40","6"],["1180","1967-09-15","Programmhinweis auf Radiodiskussion über Kirche und Studenten, Dutschke und Neu-Westend","Diskussionen über Berliner Studentenunruhen","","","",[3],4,[1],[2],2,"22","13"],["1181","1967-09-16","Nicht jeden Mucks ernst nehmen, nicht zuviel Öffentlichkeit für Randgruppe, mit extremen Gruppen kann man fertig werden.","Albertz: Nicht jedes Räuspern der Narren allzusehr beachten!","","","k.a.",[9],2,[1],[1],1,"8","2"],["1182","1967-09-16","Kritisiert Senat scharf, sollen sich erklären, greift SDS scharf an, verteidigt Springer-Presse","Amrehn: Nicht Maßnahmen ankündigen und nichts tun!","","","k.a.",[9],2,[1],[1],1,"8","2"],["1183","1967-09-16","Lange Sitzung verschiedene Abgeordnete kommen zu Wort","9-Stunden Redeschlacht : Das war zuviel für die Besucher ","","","Klaus Heine und Jürgen Oster",[9],2,[1],[3],1,"8","2"],["1184","1967-09-16","Fritz Teufel wird im Rahmen des \"go-ins\" in der Halle Brandenburg verhaftet. Während der Demonstration kommt es zu Ausschreitungen, Teufel hat noch einen Doppelgänger. Statt von Dieter Kunzelmann ist in einer Bildunterschrift fälschlich von Dieter Heinzelmann die Rede.","Plötzlich hatte die Polizei zwei Teufel ","","","rb",[5],2,[1],[2],1,"8","2"],["1185","1967-09-16","Abgeordnete debatieren über Zustand in Berlin, Studenten stören vor der Sitzung mit einem \"go-in\", Scheiben gehen zu Bruch, Fritz Teufel wird erneut verhaftet ","CDU-Chef Amrehn: Der Senat soll endlich regieren!","Studenten-Krawalle vor der Parlaments-Sondersitzung","Albertz: Hart sein, aber Narreteien übersehen","rb",[9],2,[1],[1],2,"8","1"],["1186","1967-09-16","Beschwerde gegen Berliner SPD, kein Konzept etc.","?und draußen war Radau","","","BILD BERLIN",[9],2,[5],[2],2,"8","1"],["1187","1967-09-16","Aussprache über Große Anfrage der CDU zu Krawallen und innerer Lage. Albertz \"wich aus\". Dazu eine Karikatur.","So heiß, wie lange nicht mehr","Sondersitzung des Abgeordnetenhauses: Die innere Lage Berlins","","Klaus Bär",[9],6,[1,5,4],[1],1,"32","2"],["1188","1967-09-16","Zusammenfassung der Rede Amrehns: Fordert vom Senat konsequenters und härteres Vorgehen gegen Unruhestifter unter den Studenten. Qualifiziert Anti-Springer-Maßnahmen als Aktionen gegen die Meinungsfreiheit.","Amrehn: Es muss endlich wieder regiert werden!","\"Diese gesteuerte Unruhe fügt uns großen Schaden zu!\"","","P.R.",[9],6,[1],[4],1,"32","3"],["1189","1967-09-16","Zusammenfassung der Rede von Albertz: Verteidigt Senatsstrategie, betont Demonstrationsrecht, lobt Polizei bei Kaufhauseinsatz, weigert sich, die Philosophie des linksradikalen Republikanischen Clubs ernsthaft zu erörtern.","Berlin wird auch damit fertigwerden","\"Heldentum kann nicht auf Flaschen gezogen werden\"","","",[9],6,[1],[4],1,"32","4"],["1190","1967-09-16","Bericht über heftige Plenardebatte mit gegenseitigen Schuldzuweisungen. Mittlerweile Studenten vor dem Rathaus und in der Brandenburghalle","Lummer: Großes Bla-Bla","Harte Worte fielen in der nächtlichen Debatte im Plenarsaal","","Klaus Bär",[9,1],6,[1],[4],1,"32","5"],["1191","1967-09-16","Reportage über Krawall vor und in dem Rathaus. Teufel wird verhaftet. 200 bis 300 Demonstranten","Krawall im Rathaus","Die Demonstranten wollten den Plenarsaal stürmen","","L.R.",[1,5],6,[7],[4],1,"32","6"],["1192","1967-09-16","Passant verweist Langhaarigen auf Seifen-Messe, dort solle er ein Go-In machen.","\"Dort Go in\"","","","",[9],6,[5],[2],1,"32","10"],["1193","1967-09-16","Anriss, Hinweis auf Texte im Blatt","Demonstranten flogen aus dem Rathaus!","Nach Krawall in der Brandenburg-Halle","Amrehn: Der Senat muss endlich wieder regieren. Albertz: Berlin wird auch mit innerer Unruhe fertig.","",[5],6,[1],[4],1,"32","1"],["1194","1967-09-16","Oppositionsführer Amrehn fordert Polizeieinsätze gegen linke Krawallmacher, Albertz will \"flexibel\" bleiben","Amrehn: Gegen Radikale hilft nur noch die Polizei","","Albertz verteidigt den Senat. Hitzige Debatte im Parlament","",[1],1,[1],[1],1,"14","1"],["1195","1967-09-16","Morgenpost dokumentiert Reden von Heinrich Albertz, SPD, und Franz Amrehn, CDU","Amrehn: Senat muß endlich für Ordnung sorgen","","Auch Demokratie braucht Staatsautorität","",[9],1,[1],[1],1,"14","9"],["1196","1967-09-17","Im Morgenpost-Interview vergleicht emeritierter FU-Professor SDS mit SA und verwirft \"Kritische Universität\"","FU-Professor: Gegen die SA-Methoden des SDS zur Wehr setzen!","","Morgenpost-Interview mit Ernst Fraenkel","",[8],1,[3],[1],2,"56","1"],["1197","1967-09-17","Studenten traktieren einen Herrenschuh mit Bohrer, Nägeln und Schere.","Wo uns der Schuh drückt","","","Oskar",[9],1,[5,4],[2],1,"56","2"],["1198","1967-09-18","Albertz fordert in TV-Ansprache zum Dialog der Generationen auf. ","Albertz: Sprecht mit der jungen Generation","","Öffentliche Disskussion geht weiter","rb",[9],2,[8],[3],2,"8","3"],["1199","1967-09-18","Ironischer Kommentar zu Duschkes angeblicher Äußerung, die Reaktionsweise der Berliner ähnele denen von Lurchen. Über Rudi Dutschke: Chef-Revoluzzer, Idol des Häufleins der Mao-Freunde, der junge Mann mit dem fanatischen Stechblick, er und seine Mitstreiter hätten einen Menschenverächter-Komplex. Dazu eine Karikatur.","Guten Morgen, liebe Lurche!","Inspektor sagt:","","Inspektor (Werner Sikorski)",[2],6,[5,4],[1],1,"44","2"],["1200","1967-09-19","Häussermann tritt wegen Ablehnung der \"Kritischen Universität\" zurück.","AStA-Boß trat zurück","","","rb",[11],2,[1],[2],2,"10","2"],["1201","1967-09-19","Parlamentarischer U-Ausschuss verlangt Rücktritt von Duensing und Prill, Vorwürfe werden aufgezählt. Auch Vorwürfe gegen Polizeibeamte und Demonstranten. ","Ausschuß: Polizeiführung hat versagt - Abtreten!","","Vorwürfe gegen Präsident Duensing und Senatsrat Prill","Jürgen Oster",[7],2,[1],[1],1,"10","2"],["1202","1967-09-19","Akademischer Senat der FU spricht sich gegen KU-Gründung aus. AStA-Chef tritt aus Protest zurück.","Neue Krise an der FU","","","",[11],6,[1],[5],2,"28","3"],["1203","1967-09-19","Hinweis auf Text im Heft","Duensing zum Sündenbock Nr. 1 gemacht","Der parlamentarische Untersuchungsausschuss hat","","",[7],6,[1],[3],2,"28","1"],["1204","1967-09-19","Kritik an der juristischen Qualität des Ausschussberichts. Kritik an der Beurteilung Duensings und an den Maßnahmeempfehlungen.","Duensing soll zum Sündenbock gemacht werden","Der Bericht des parlamentarischen Ausschusses offenbart schwere Mängel","","K.B.",[7],6,[5],[1],2,"28","2"],["1205","1967-09-19","Akademischer Senat der FU lehnt Unterstützung der KU ab","Keine Unterstützung der \"Kritischen Universität\"","","","V.D.",[11],4,[1],[2],2,"20","1"],["1206","1967-09-19","Akademischer Senat der FU lehnt Unterstützung der KU ab. AStA-Chef Häußermann tritt aus Protest zurück.","Kritisch zur \"Kritischen Universität\"","","FU-Senat gegen Unterstützung - AStA-Vorsitzender tritt zurück","vd",[11],4,[1],[2],2,"20","11"],["1207","1967-09-19","U-Ausschuss zur Klärung der Vorfälle beim Schah-Besuch empfiehlt Entlassung von Polizeipräsident Erich Duensing","Ausschuß empfiehlt Abberufung Duensings","","","",[7],1,[1],[5],2,"14","1"],["1208","1967-09-19","Vorbericht zur Senatsdebatte über den Schah-Ausschußbericht. Details des Berichts","Duensing und Prill sollen in die Wüste","","Senat berät Bericht des Untersuchungsausschusses","",[7],1,[1],[1],2,"14","3"],["1209","1967-09-20","Hinweis auf Text im Heft","Innensenator zurückgetreten","Dramatische Sitzung der Berliner SPD-Fraktion","Büsch stolperte über den Bericht des Untersuchungs-Ausschusses","",[7],6,[1],[1],2,"32","1"],["1210","1967-09-20","Albertz nimmt Gesuch an. Spekulationen über Nachfolger.","Büsch trat zurück","","","Klaus Bär",[7],6,[1],[1],1,"32","3"],["1211","1967-09-20","Büsch-Rücktritt als Folge des 2. Juni","Kurt Neubauer als Innensenator?","","Nach seinem Rücktritt wurde Wolfgang Büsch gelobt","khh, hae",[7],4,[1],[1],1,"24","13"],["1212","1967-09-20","Haftbeschwerde abgelehnt","Fritz Teufel bleibt in Haft ","","","",[5],4,[1],[2],2,"24","13"],["1213","1967-09-20","Berliner Gericht verwirft Teufels Haftbeschwerde","Teufel bleibt hinter Gittern","","","",[5],1,[1],[2],2,"14","3"],["1214","1967-09-20","FU-Rektorat hält Rücktritt des AStA-Vorsitzenden wegen Weigerung der FU, die \"Kritische Universität\" zu unterstützen, für nicht notwendig","FU-Rektorat: Kein Grund zum Rücktritt","","","",[11],1,[1],[5],2,"14","3"],["1215","1967-09-21","Senator Wolfgang Büsch tritt endgültig zurück","Büsch: \"Nach dem Rücktritt hab ich prima geschlafen\"","","","Jürgen Oster",[7],2,[1],[2],1,"12","2"],["1216","1967-09-21","Borm verlangt Auskunft über politische Haltung des Clubs um über seine weitere Mitgliedschaft entscheiden zu können.","Borm stellt die Gretchen-Frage","","","",[11],6,[1],[2],2,"32","2"],["1217","1967-09-21","Kommentar zum Bück-Rücktritt als Folge des 2. Juni. Teil der \"Gewissenserforschung in Berlin\"","Zurückgetreten","","","P.L.",[7],4,[5],[2],2,"20","2"],["1218","1967-09-21","Über eine nichtöffentliche Beratung des Ausschusses","Jetzt berät der Ausschuss über FU-Zwischenfälle und Unruhe","","","",[7],4,[1],[2],2,"20","11"],["1219","1967-09-21","Parlamentarischer U-Ausschuss berät in zweiter Runde Vorfälle an der FU.","Zweite Runde","","","",[11],1,[1],[2],2,"16","3"],["1220","1967-09-23","Anti-AStA-Plakate auf FU-Gelände","Hinweisschilder","","","",[11],6,[1],[2],2,"24","4"],["1221","1967-09-23","Parlament billigt vorzeitigen Ruhestand des Polizeipräsidenten. Folgt anderen Empfehlungen des Berichts nicht. Teils kontroverse Diskussionen.","Duensing geht in Pension","","Abgeordnetenhaus beriet über Untersuchungsbericht","Klaus Bär",[7],6,[1],[1],1,"24","3"],["1222","1967-09-23","VDS kündigt neue Mittel der Provokation an, da stdentische Materialien bei Ausschussbericht nicht beachtet worden sind.","Neue Aktionen angekündigt","","","",[7],6,[1],[2],2,"24","3"],["1223","1967-09-23","Kommune-I-Mitglieder, die die Debatte des Abgeordnetenhauses auf der Besuchertribüne verfolgen wollten, sind vorübergehend festgenommen worden.","Aus dem Verkehr gezogen?","","","",[7],6,[1],[2],2,"24","3"],["1224","1967-09-24","VDS lehnt Empfehlungen des Wissenschaftsrates zum Ausbau der Hochschulen ab","Studenten lehnen ab","","","",[11],1,[1],[2],2,"56","1"],["1225","1967-09-24","Fritz Teufel verteilt auf dem Kudamm Flugblätter, in denen die Berliner aufgefordert werden, sich gegen den Abbau von Rechtsstaatlichkeit zu wehren","Flugblätter verteilt","keine ","","",[5],1,[1],[2],2,"56","3"],["1226","1967-09-25","\"Enteignet Springer!\"-Proteste gegen Einstellung des \"Mittag\" in Düsseldorf. \"Diagnose: Schizophrenie im fortgeschrittenen Stadium!\"","Moment mal!","","","",[10],6,[5],[2],2,"36","2"],["1227","1967-09-25","Störung der Eröffnung der Berliner Festwochen u. a. durch Zwischenrufe von Kunzelmann.","Die Radikalen fehlten nicht?","","","",[1],6,[1],[3],1,"36","3"],["1228","1967-09-25","Festwochenveranstaltung in der Philharmonie wird von Teufel-Sympatisanten gestört","\"Zwischen Ost und West ausgleichen\"","","Albertz eröffnet Festwochen - Demonstranten stören","",[5],4,[1],[2],2,"20","1"],["1229","1967-09-26","Die katholischen deutschen Studentenverbindungen wollen sich künftig an Hochschulpolitik beteiligen.","Katholische Studenten wollen aktiv werden","","","dpa",[4],4,[1],[2],2,"22","6"],["1230","1967-09-27","Redakteure von \"Bild\" und \"Bild am Sontag\" stellen Strafanzeige gegen Autor Günter Grass, weil dieser ihre Berichterstattung als \"faschistisch\" bezeichnet hatte","Strafantrag gegen Grass","","Journalisten wollen sich nicht verleumden lassen","",[10],1,[1],[3],2,"18","2"],["1231","1967-09-28","Leitende Redakteure der \"Welt\" erstatten Anzeige gegen Günter Grass wegen Beleidigung und Verleumdung","Auch \"Welt\" zeigt Grass an","","Ungerechtfertigte und unvertretbare Verleumdungen","",[10],1,[1],[3],2,"22","2"],["1232","1967-10-01","Bundesvertriebenenminister Kai Uwe von Hassel kritisiert Grass wegen Verleumdung von Springer-Redakteuren","Hassel: Grass hilft den Kommunisten","","","AP",[10],1,[1],[2],2,"62","1"],["1233","1967-10-01","Auf dem Kudamm demonstrierten Jugendliche und Studenten für die Freilassung Fritz Teufels","Als der Regen kam?","","? ließen die Randalierer Teufel Teufel sein","",[5],1,[1],[2],2,"62","3"],["1234","1967-10-01","Ausführlicher Kommentar zum Rücktritt von Albertz. Hier auch Rolle der Studentenunruhen.","Der Rücktritt in Berlin - und wie es dazu kam","Führungskrise deckt viele Schwächen auf","","Horst Eliseit",[7,9],5,[5],[1],1,"40","4"],["1235","1967-10-01","Augstein hat mit dem Spiegel auf dem Markt der Nachrichtenmagazine in Deutschland ein Monopol. Kommentator setzt auseinander, warum er dennoch gegen Enteignung ist. Springer wird nicht erwähnt.","Enteignet Augstein nicht!","","","William S. Schlamm",[9],5,[5],[3],1,"40","5"],["1236","1967-10-01","Etwa 600 Demonstranten haben auf dem Kudamm den Rücktritt des Regierenden Bürgermeisters gefeiert. Festnahmen offenbar wegen Verkehrsstörungen.","22 Festnahmen in der City","","","bi.",[1],5,[1],[2],2,"40","1"],["1237","1967-10-01","Demonstranten stören BBC-Konzert in der Philharmonie.","Festwochen gestört","","","dpa",[1],5,[1],[2],2,"40","1"],["1238","1967-10-02","Farbbeutel gegen AStA-Gebäude ","Farbe gegen AStA","","","ka",[11],2,[1],[2],2,"17","2"],["1239","1967-10-02","Zeitung kritisiert Günter Grass der verkündet, die Springer Zeitungen würden \"mit wahrhaft faschistischen Methoden Zweckmeldungen verbreiten\".","\"Einseitig bis zum Schwachsinn\" ","","Der Münchner Merkur kritisiert Günther Grass ","",[10],2,[1],[2],1,"16","16"],["1240","1967-10-02","Direktoren-Vereinigung warnt vor SDS-Einfluss an Oberschulen","Direktoren warnen vor Radikalismus an Gymnasien","","","dpa",[8],4,[1],[2],2,"20","6"],["1241","1967-10-05","SPD-Präsidiumsmitglied Alfred Nau wendet sich gegen die Parole \"Enteignet Springer!\"","SPD gegen radikale Thesen","","","",[10],1,[1],[2],2,"18","1"],["1242","1967-10-05","Staatssekretär Ehmke kritisiert Grass-Angriffe auf Springer","Grass-Protest \"sehr überspitzt\"","","","dpa",[10],1,[1],[2],1,"18","2"],["1243","1967-10-05","TU-Rektor Professor Kurt Weichselberger und FU-Rektor Professor Ewald Harndt nehmen Amtsgeschäfte auf","Neue Rektoren an TU und FU","","","",[11],1,[1],[2],2,"18","5"],["1244","1967-10-06","Konstituierung einer SPD-Betriebsgruppe an den Berliner Hochschulen und Forschungsinstituten","Gegen Disziplinarrecht für Studenten","","Konstituierende Versammlung der SPD-Betriebsgruppe","el",[4],4,[1],[2],2,"24","13"],["1245","1967-10-06","Hausverbot für Wilmersdorfer SDS, der in das Goethe-Gymnasium eingedrungen war","SDS-Mitglieder haben Hausverbot","","","",[8],1,[1],[2],2,"32","4"],["1246","1967-10-06","Leserbriefschreiber verteidigt den Begriff \"kalter Krieger\" gegen \"linke Radikaldemokraten\"","Der \"kalte Krieger\"","","","",[2],1,[6],[5],2,"32","21"],["1247","1967-10-07","Störung einer Feier im Audimax der FU wegen Brandt und Springer. Brandt muss Rede unterbrechen.","Studenten störten Rathenau-Feier","","","L.R.",[1],6,[1],[2],2,"32","3"],["1248","1967-10-08","Der künftige Regierende Bürgermeister Klaus Schütz kündigt harte Maßnahmen in Berlin an. Es sei untragbar, wenn studentische Minderheiten die gewählten Institutionen des Staates auseinandertreiben.","\"Harte Maßnahmen\"","","","Eigener Bericht",[1],3,[1],[2],2,"56","2"],["1249","1967-10-08","Auf dem Kudamm demonstrieren Studenten für und gegen Fritz Teufel","\"Teufel ins Irrenhaus\"","","","",[5],1,[1],[2],2,"56","3"],["1250","1967-10-08","Schütz trifft mit FU-Assistenten zusammen. In der Innenstadt Demo für Teufel-Freilassung.","Schütz: Aussöhnung der Berliner mit Studenten ist mein erstes Ziel","Bürgermeister-Kandidat sprach mit Hochschul-Assistenten","","N.",[9],5,[1],[1],2,"42","1"],["1251","1967-10-09","Etwa 2000 Demonstranten auf dem Kudamm. Flugblätter zu Senatskrise. Teilweise Verkehrsbehinderung.","Studenten demonstrierten auf dem Kurfürstendamm","","","",[1],4,[1],[2],2,"22","14"],["1252","1967-10-10","Professor lehnt Leitung des DIW wegen Auseinandersetzungen an der FU ab","Prof. Giersch lenht Arbeit in Berlin ab","","","gil",[11],4,[1],[2],2,"22","1"],["1253","1967-10-12","Kritischer Bericht der Bundesregierung über den Stand der \"Bildungsplanung\".","Sorge um Bildungswesen","","Bund und Länder legen ihre Berichte vor","Erd.",[4],1,[1],[5],2,"22","2"],["1254","1967-10-13","SPD Essen kritisiert Studentenplakat","Wirbel um Plakat","","","UPI",[11],6,[1],[2],2,"44","2"],["1255","1967-10-13","SHB sucht Kontakt zu IG Chemie und IG Metall","Studenten suchen Kontakt mit Gewerkschaften","","","UPI",[11],4,[1],[2],2,"26","6"],["1256","1967-10-13","Berlins Wissenschaftssenator kritisiert Kondolenz-Telegramm des SDS an kubanische Kommunisten zum Tod Che Guevaras","Gegen Diffamierung unserer Demokratie durch Linksradikale","","Scharfe Absage Steins an SDS","dpa/upi",[8],1,[1],[1],2,"28","1"],["1257","1967-10-14","Plakate auf FU-Gelände fragen nach Verurteilung eines DDR-Studenten nach AStA-Protesten","\"Wann protestiert der AStA?\"","","","",[11],4,[1],[2],2,"28","13"],["1258","1967-10-14","Anlässlich 150 Jahre Wartburgfest betont der VDS die Verpflichtung zu politischem Engagement","VDS will Engagement","","","dpa",[11],4,[1],[2],2,"28","6"],["1259","1967-10-14","Berliner Landesverband des Sozialdemokratischen Hochschulbundes attackiert Brandt wegen dessen Kritik an Anti-Schah-Demonstranten","Studenten-Attacke auf Willy Brandt","","","AP",[9],1,[1],[2],2,"14","2"],["1260","1967-10-15","Studenten verteilen SDS-Flugblätter am Welt-Stand auf der Frankfurter Buchmesse und zerrissen Zeitungen","Krawall auf der Buchmesse","","","",[1],1,[1],[2],2,"54","1"],["1261","1967-10-15","Axel Springer Verlag fordert Presserat auf, sich mit den Angriffen auf seine publizistischen Organe zu befassen","Fragen an den Presserat","","Warum Haß-Pamphlete im Deutschen Fernsehen?","",[10],1,[1],[5],2,"54","2"],["1262","1967-10-15","Springer bittet Presserat, sich mit Maßnahmen gegen den Verlag, u. a. SDS-Maßnahmen, zu befassen","Vier Fragen an den Presserat","","Es geht um Grass, SDS, Gruppe 47 und Falschmeldung","dpa",[10],5,[1],[2],2,"48","2"],["1263","1967-10-16","Springer bittet Presserat, sich mit Maßnahmen gegen den Verlag, u. a. SDS-Maßnahmen, zu befassen","Verlagshaus Springer fragt den Presserat","","","",[10],4,[1],[2],2,"20","4"],["1264","1967-10-16","Verleger kritisieren Demonstrationen gegen Springer-Stände auf Frankfurter Buchmesse","Verleger kritisieren Messe-Demonstrationen","","","cuch",[1],4,[1],[2],2,"20","1"],["1265","1967-10-16","Beschreibung der SDS-Demos gegen Springer-Stände von \"Welt der Literatur\" und Ullstein auf der Frankfurter Buchmesse","Kein Beifall, viel Schulterzucken, Empörung","Demonstration in Frankfurt","Anti-Springer-Aktionen des SDS ließen das Publikum der Buchmesse weitgehend unbeteiligt","Christian Ferber",[1],4,[1],[3],2,"20","4"],["1266","1967-10-16","TU-Professoren und Studenten streben Urabstimmung über AStA-Telegramm an","Urabstimmung angestrebt","","","",[11],4,[1],[2],2,"20","11"],["1267","1967-10-16","Zehn Beiträge zum Status der Reformbemühungen an westdeutschen Hochschulen","Wie steht es mit der Hochschulreform?","Deutsche Hochschulen zu Beginn des Wintersemesters 1967/68","Manches ist geschehen - aber die Hürde ist noch nicht genommen - Eine Umfrage","VD, bh, Wi, Walter Pfuhl, H.A., G. Krems, A. Freudenhammer, pff, Rüdiger Dilloo, Rolf Seufert, Rudolf Großkopff",[4],4,[1],[4],1,"20","7"],["1268","1967-10-17","400 Demonstranten an den Ständen von WELT und FAZ","Demonstration auf der Buchmesse","","","AP",[1],6,[1],[3],2,"24","24"],["1269","1967-10-17","Wendet sich gegen Enteignet-Springer-Parolen","Schwierig","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],1,"22","2"],["1270","1967-10-17","Unterstellt Demonstranten Krawall des Krawalls wegen","Krawall","Aus Briefen an die Redaktion","","",[1],4,[6],[2],2,"22","2"],["1271","1967-10-17","Polizei muss Messestand der Welt vor Demonstranten schützen. Presserat missbilligt Handlungen gegen Pressefreiheit","Studenten belagerten WELT-Stand","Frankfurter Buchmesse","Ausländische Aussteller wenden sich gegen Störversuche","cuch.",[10],4,[1],[2],2,"22","3"],["1272","1967-10-17","Rezension des Buches \"Das Recht auf freie Demonstration\" von Sieghart Ott","Love in auf dem Straßenpflaster","Das neue Buch","","Paul Lersch",[1],4,[5],[3],1,"22","2"],["1273","1967-10-17","Kritik am FU-Telegramm zum Guevara-Tod","Mitteldeutscher Jugendkreis gegen AStA-Telegramm","","","",[11],4,[1],[2],2,"22","14"],["1274","1967-10-17","AStA betont Notwendigkeit der KU","FU-AStA beharrt auf \"Kritischer Universität\"","","","dw",[11],4,[1],[2],2,"22","13"],["1275","1967-10-17","Hilfsaktion von \"Student für Europa, Student für Berlin\"","Studenten werden weiterhin helfen","","5500 Kinder verschickt","mw",[11],4,[1],[2],2,"22","14"],["1276","1967-10-17","Studenten des Mitteldeutschen Jugendkreises verurteilen die Beileidsbekundungen des Berliner SDS","Anmaßung zurückgewiesen","","","dpa",[8],1,[1],[2],2,"12","1"],["1277","1967-10-17","Presserat rügt Drohungen gegen Verlagshäuser","Drohungen mißbilligt","","Presserat zu den Studenten-Demonstrationen","AP/upi",[10],1,[1],[2],2,"12","2"],["1278","1967-10-18","Berliner Verwaltungsgericht spricht FU-Konvent Recht ab, Beschlüsse politischen Inhalts zu fassen.","Konvent der FU hat kein politisches Mandat","","","dpa",[11],6,[1],[3],2,"28","4"],["1279","1967-10-18","Namentlich Kiesinger und Lemmer kritisieren Dutschke und u. a. die Frankfurter Anti-Springer-Maßnahmen. Schmitt-Vockenhausen nennt diese \"als Revolution getarnten Unfug\".","Kritik an den Aktionen gegen Springer","Presse","Führende CDU-Politiker verurteilen Bestrebungen extremer Studenten - Protest in Frankfurt","",[10],4,[1],[3],2,"20","6"],["1280","1967-10-18","SDS-Demo vom neuen Senat mit Auflagen (Ordner) genehmigt","Vietnam-Marsch vom Senat genehmigt","","","v.C.",[1],4,[1],[2],2,"20","6"],["1281","1967-10-18","Plädoyer für eine große Hochschulreform","Die Universitäten im Atomzeitalter","","Umfrage zur Hochschulreform. Mitbestimmungsrecht der Studenten. Wann kommt die Operation?","Walter Görlitz",[4],4,[5],[1],2,"20","2"],["1282","1967-10-18","Berliner Verwaltungsgericht spricht FU-Konvent Recht ab, Beschlüsse politischen Inhalts zu fassen.","FU-Konvent hat kein politisches Mandat","","","",[11],4,[1],[2],2,"20","1"],["1283","1967-10-18","Berliner Verwaltungsgericht spricht FU-Konvent Recht ab, Beschlüsse politischen Inhalts zu fassen.","Konvent hat kein politisches Mandat","","Verwaltungsgericht sprach Grundsatzurteil aus","wt",[11],4,[1],[5],2,"20","11"],["1284","1967-10-18","Frankfurter Gericht schreitet gegen Anti-Lübke-Schmähung in DDR-Verlag ein","Frankfurter Richter beschlagnahmte das Zonen-\"Braunbuch\"","","Protest der Verlage gegen die SDS-Krawalle","dpa/AP/upi",[8],1,[1],[1],1,"12","1"],["1285","1967-10-19","Aufhebung des FU-Konventsbeschlusses zur Vietnam-Demo","Senator Stein hebt Konventsbeschluss auf","","","hws",[11],4,[1],[2],2,"22","1"],["1286","1967-10-19","Aufhebung des FU-Konventsbeschlusses zur Vietnam-Demo","Senator Stein hebt Konventsbeschluss auf","","","hws",[11],4,[1],[1],2,"22","6"],["1287","1967-10-20","Berliner VDS-Chef Vieten wegen Unstimmigkeiten über Kuba-Telegramm abgewählt","VDS-Vorsitzender abgewählt","","","",[11],4,[1],[2],2,"24","10"],["1288","1967-10-21","Sperrung der Straße wegen Demo gegen Kriegsführung der USA in Vietnam","Demonstration: Halber Kudamm gesperrt!","","Heute zwischen 15 und 17 Uhr","Jürgen Oster",[1],2,[1],[2],2,"12","2"],["1289","1967-10-19","CDU-Abgeordnete und Bürgermeister von Frankfurt fordern Bestrafung für die Krawalle in Frankfurt ","Studentenkrawalle haben ein Nachspiel","","","k.a.",[1],2,[1],[2],2,"12","8"],["1290","1967-10-21","Auflistung der Behördenmaßnahmen vor der Demonstration","Innensenator Neubauer rechnet mit einzelnen Übergriffen","","Behörden auf Anti-Vietnamkriegsdemonstration vorbereitet","gc, hae",[1],4,[1],[5],2,"30","9"],["1291","1967-10-21","Kommentar gegen den gewalttätigen Mißbrauch des Demonstrationsrechts","Demonstranten, Freiheit, Pflichten","","","wbr.",[1],1,[5],[2],2,"12","2"],["1292","1967-10-22","Weltweiter Aktionstag mit Demonstrationen in USA, Paris, Berlin. Hier waren die Veranstalter linksradikale Organisationen, darunter die in der Viermächte-Stadt zugelassene SED. Kudamm zwei Stunden lahmgelegt. Bis Redaktionsschluss kaum Zwischenfälle - aber: Zum ersten Mal warfen Anti-Demonstranten Eier auf die Marschierer.","Eier gegen Demonstranten","","Weltweiter Protest zum Vietnamkrieg","BamS-Redaktion",[1],3,[1],[1],1,"56","56"],["1293","1967-10-22","Krawalle bei Anti-Vietnam-Demo am Kudamm","Nachher Krawalle","","Vietnam-Demonstranten in West-Berlin","",[1],1,[1],[5],2,"56","1"],["1294","1967-10-22","SED und SDS marschieren gegen USA-Krieg in Vietnam und protestieren gegen \"Scheindemokratie\", Krawalle","Die \"Schlacht\" begann erst nach der Demonstration","","Anfangs kam Rudi Dutschke nicht zum Zuge","",[1],1,[1],[1],1,"56","3"],["1295","1967-10-22","Studentenparlament der TU spricht Studentenvertretung, die zum Tod von Che Guevara kondoliert hatte, Vertrauen aus","Knappe Mehrheit für Vorstand der TU-Studenten","","","Pü.",[11],1,[1],[2],2,"56","5"],["1296","1967-10-22","Kommentator stellt Burschenschafter auf Göttinger Wartburgtagung SDS als Gegenbild gegenüber. Dutschke wird immer wieder als Prototyp des linken Studenten angeführt.","Student und Gentleman","","","William S. Schlamm",[11],5,[5],[3],1,"42","5"],["1297","1967-10-22","RCDS distanziert sich in der TU von Guevara-Telegramm.","Nur knappe Mehrheit im TU-Studentenparlament","","","lbn, h.",[11],5,[1],[2],2,"42","35"],["1298","1967-10-22","Ausschreitungen und Wasserwerfereinsatz bei Demo auf dem Kudamm. Demos in fünf anderen deutschen Städten verlaufen ruhig.","Tumultszenen am Kurfürstendamm","","","",[1],5,[1],[2],1,"42","1"],["1299","1967-10-22","Ausschreitungen und Wasserwerfereinsatz bei Demo auf dem Kudamm. Schilderung des Ablaufs und von Reaktionen","Nach dem Marsch kam der Krawall","","Turbulente Szenen im Anschluss an die Demonstration","Bi., Bl.",[1],5,[1],[1],1,"42","35"],["1300","1967-10-23","Vier Studenten auf dem Bürgersteig, einer mit Erkältung und \"Minh\" Schild, Mann und Frau bei \"Love in\" und Student mit Zopf und Orden. Zwei Männer in Anzug und mit Hut und Fliege kommentieren die Szene.","\"Bald wirta nicht mehr Ku-, sondan Ochsendamm heißen!\" (Karikatur)","","","zel",[9],2,[5,4],[3],2,"12","3"],["1301","1967-10-23","Anti-USA-Vietnam Demo auf dem Kudamm, es kommt zu Aussschreitungen, Bilanz, Hinweis auf ähnliche Zustände in den USA/Washington","Krawalle dauerten bis zum frühen Morgen","","","rb",[1],2,[1],[2],1,"12","3"],["1302","1967-10-23","Geschehnisse der Nacht nach der Demo, Ablauf, Einsatz der Polizei, Blatt spricht von Halbstarken und Krawallbrüdern, humorvolle Polizei, Kunzelmann-Festnahme.","Nach der Demonstration: Die Nacht der Krawall-Brüder","","","rb",[1],2,[1],[1],1,"12","3"],["1303","1967-10-23","Reaktionen auf die jüngsten Demonstrationen/ Unruhen in West-Berlin","Schütz: Das Wort Studentenunruhen lasse ich nicht gelten... ","","","ka",[9],2,[1],[2],2,"12","3"],["1304","1967-10-23","Kundgegebung gegen das amerikanische Vorgehen im Vietnamkrieg, es beteiligten sich auch SED- und FDJ-Mitglieder.","Kundgebung mit Hippies und Fahnen ","","","jo",[1],2,[1],[2],2,"12","3"],["1305","1967-10-23","Polizist entkrampfte Demo mit humorigen Sprüchen","Dieser Polizist stahl den Randalierern die Schau","","Seine Waffe war Humor","L.R.",[1],6,[7],[1],1,"40","1"],["1306","1967-10-23","Bericht über die Räumung des Kudamms nach der Samstagsdemo","90000 Liter Wasser gratis","Sonnabendabend am Kurfürstendamm: Ärger gab's erst nach der Demonstration","","Günter Mücke",[1],6,[7],[1],1,"40","20,21"],["1307","1967-10-23","Diskussionen, ob die Telegramm-Unterzeichner im Sinne der Studentenmehrheit gehandelt hat.","Kritik an unklarer Formulierung","","Debatte um Guevara-Telegramm im TU-Parlament","wt",[11],4,[1],[2],2,"20","11"],["1308","1967-10-23","Friedliche Demo mit etwa 7000 Teilnehmern. Ausschreitungen erst am Ende. Schäden auf dem Kudamm. Humorvolle Polizeidurchsagen.","Provozierte Krawalle nach disziplinierter Demonstration","Berlin","Nächtlicher Wasserwerfereinsatz auf dem Kurfürstendamm","hws",[1],4,[1,7],[1],2,"20","3"],["1309","1967-10-23","Kaum Ausschreitungen bei Demos in westdeutschen Städten","Demonstrationen verliefen in anderen Städten ruhig","","","",[1],4,[1],[2],2,"20","3"],["1310","1967-10-23","Vier Bilder mit erläuterndem Text zu verschiedenen Stadien der Berliner Demonstration","Wasserwerfer auf dem Kurfürstendamm","","","",[1],4,[1],[1],1,"20","11"],["1311","1967-10-24","Frage, ob Studentenschaft noch hinter Parlament steht ? Urabstimmung an der TU, Auslöser: Beileidstelegramm zum Tode Guerevaras","Kritik am TU-Parlament","","","rb",[11],2,[1],[2],2,"11","3"],["1312","1967-10-24","Bericht über bei Demo verursachte Schäden","24 Anzeigen gegen Randalierer","","","L.R.",[1],6,[1],[5],2,"28","3"],["1313","1967-10-24","Bericht über Empfang im Springerhaus für Teilnehmer der VDZ-Tagung. Verbandspräsident Kluth stellt sich an die Seite Springers und kritisiert mit teils schaften Worten (\"rote SA\") die Springer-Gegner","\"Sie sagen Springer, aber sie meinen unsere demokratische Freiheit\"","","Zeitschriftenverleger-Präsident Kluthe weist auf Gefahren hin","co",[10],4,[1],[5],1,"20","11"],["1314","1967-10-24","\"Unabhängige Aktionsgemeinschaft\" in der TU will abstimmen lassen, ob Studenten hinter Studentenparlament stehen.","TU-Studenten rufen zur Urabstimmung auf","","","",[11],4,[1],[2],2,"20","11"],["1315","1967-10-24","Leser wendet sich gegen Anit-Vietnamkriegs-Demonstranten","Demonstrationen","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["1316","1967-10-24","Demokratisch-katholischer Arbeitskreis protestiert gegen Mißbrauch seiner Unterschrift unter Anti-Vietnam-Resolution durch \"Republikanischen Club\"","\"Unser  Name wurde mißbraucht\"","","","dpa/AP/upi",[1],1,[1],[2],2,"16","1"],["1317","1967-10-24","Leserbriefschreiber kritisieren Erlaubnis für die in Gewalt ausufernde Demo am Kudamm und den Auftritt von Theologieprofessor Gollwitzer, ziehen Vergleich mit zu den Nationalsozialisten.","Nicht am Kurfürstendamm!","","","H.B.",[1],1,[6],[3],2,"16","2"],["1318","1967-10-25","Dieter Kunzelmann muss nach seiner Festnahme bei der Demo am Kudamm drei Wochen Haft in Einzelzelle in Tegel absitzen","Kunzelmann drei Wochen in Einzelzelle","","","rb",[5],2,[1],[2],2,"12","3"],["1319","1967-10-25","Kritik an der SDS-Demo gegen Springer-Messestände","Die Freiheit missbraucht","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"26","2"],["1320","1967-10-25","Linke Studenten eine Gefahr für die Demokratie","Die akute Gefahr","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"26","2"],["1321","1967-10-25","Nicht der Axel Springer Verlag, sondern diejenigen, die den Verlag enteignen wollen, übten \"Meinungsterror\", meint Leserbriefschreiber S.Z.","Was ist Meinungsterror?","","","S.Z.",[10],1,[6],[3],2,"14","2"],["1322","1967-10-25","Dieter Kunzelmann, zur Fahndung ausgeschriebenes Mitglied der Berliner \"Kommune I\" verbüßt Haftstraße in Strafanstalt Tegel","Kunzelman sitzt in Tegel","","","",[5],1,[1],[2],2,"14","3"],["1323","1967-10-25","Leserbriefschreiber F.V. aus Berlin fordert Dialog zwischen Polizei und Studenten","Polizei - Studenten","","","F. V.",[9],1,[6],[5],2,"14","6"],["1324","1967-10-26","Raumzusage trotz weiterhin bestehender Bedenken gegen die KU","\"Kritische Universität\" erhält Räume","","Akademischer Senat der FU tagte","vd",[11],4,[1],[2],2,"22","11"],["1325","1967-10-26","Akademischer Senat der FU lehnt \"Kritische Universität\" weiter ab","Empfehlung an FU-Rektor","","","",[11],1,[1],[2],2,"20","1"],["1326","1967-10-26","Leserbriefschreiber fordert den Senat auf, die gewaltttätigen Studenten regreßpflichtig zu machen. Weiterer Leserbriefschreiber fordert \"Vietnam-Bilder mit Napalm verbrannter Menschen\"","Wer soll das bezahlen?","keine ","","A. D., F.h, U.M.T., K.H.K",[1],1,[6],[3],2,"20","2"],["1327","1967-10-26","Portrait von Berlins Innensenator Neubauer, der ein Verbot von Demonstrationen in der Berliner City erwägt","Senator Neubauer: \"So geht es nicht!\"","","Gegen Demonstrationen in der Innenstadt","Diethart Goos",[1],1,[1],[1],2,"20","3"],["1328","1967-10-27","Studentische Inanspruchnahme eines nicht existenten politischen Mandats beschädigt Selbstverwaltung, so OSI-Professor in einem linkskritischen Vortrag.","\"Radikale träumen von sowjetischen Vorbildern\"","Berlin","Professor Ernst Fraenkel verurteilt Frontalangriff auf studentische Selbstverwaltung","Co",[1],4,[1],[3],1,"24","6"],["1329","1967-10-27","Kritik am Senat, der Demonstrationen für den Frieden genehmigt, die unfriedlich verlaufen","Sie wissen nicht, was sie tun","","","R.O.",[1],1,[6],[3],2,"24","2"],["1330","1967-10-27","Moabiter Staatsanwaltschaft stellt Verfahren gegen Kommune-Mitglieder, die angeblich Sprengstoffanschläge vorbereitet hatten, ein","Mangels Beweises kein Verfahren?","","","",[5],1,[1],[2],2,"24","3"],["1331","1967-10-27","Axel Springer verteidigt Großverlage und bestreitet Monopolstellung in Berlin ","Axel Springer: Viel Lärm um unser Haus","","","",[10],1,[1],[1],1,"24","7"],["1332","1967-10-28","FU-Professoren sprechen sich für Hochschulreform und die KU aus.","50 Professoren sind dafür","","","dpa",[11],6,[1],[3],2,"28","2"],["1333","1967-10-28","John Jahr verteidigt Springer gegen Angriffe, obwohl \"in seinem Hause in den letzten Monaten einige Fehler gemacht worden seien.\" Nennt Sprnger einen Liberalen.","Schwedler: Ein konstruktiver Beitrag","","Rrichtfest für \"Constanze\"-Pressehaus - Jahr verteidigt Springer","wt",[10],4,[1],[2],2,"28","9"],["1334","1967-10-28","50 FU-Professoren sprechen sich für Hochschulreform aus","Professoren für Förderung der Hochschulreform","","","",[4],4,[1],[2],2,"28","9"],["1335","1967-10-28","Diskussionen in der FU zu Konzept und Lehrinhalten wenige Tage vor Gründung der KU","\"Gesetz des Handelns an sich reißen\"","","AStA legt neues Programm für eine Kritische Universität vor","lb ",[11],4,[1],[2],2,"28","9"],["1336","1967-10-28","Verhalten positive Beurteilung der Zusammenstöße am vorangegangenen Wochenende von Innensenator Neubauer.","Neubauer erhofft Besserung im Verhältnis Polizei-Studenten","","","",[9],4,[1],[2],2,"28","9"],["1337","1967-10-28","SPD-Bundestagsabgeordneter Schmitt-Vockenhausen kritisiert Aktion von Studentenausschüssen gegen Notstandsgesetze","Absage an Radikale","","","Erd.",[8],1,[1],[2],1,"28","1"],["1338","1967-10-28","50 Professoren der FU sprechen sich für offene Auseinandersetzung mit der vom SDS geforderten \"Kritischen Universität\" aus","Reformen notwendig","","Professoren-Erklärung zur \"Kritischen Universität\"","MM",[11],1,[1],[1],1,"28","6"],["1339","1967-10-29","Studentenvertretung der TU veranstaltet Vorlesung zum Thema \"Die Freiheit der Wissenschaft und die politische Funktion der Universität\".","Hochschule und Gesellschaft","","","",[11],1,[1],[2],2,"60","3"],["1340","1967-10-29","Kriminalobermeister Kurras, der den Studenten Benno Ohnesorg erschoß, vor Gericht in Berlin.","Am Freitag Kurras vor Gericht","","","",[7],1,[1],[2],2,"60","7"],["1341","1967-10-29","Senator Neubauer lobt Polizei und kündigt an, dass es Demoerlaubnisse nur noch ausnahmsweise geben wird.","Ein Lob für die Berliner Polizei","","","",[1],5,[1],[2],2,"46","1"],["1342","1967-10-29","Neubauer zu Schadensbilanz, Genehmigung für Demonstrationen, Ermittlungsverfahren","Krawalle kosteten uns 25.000 Mark","","Interview mit Bürgermeister Neubauer: Das ist das Fazit der jüngsten Vorfälle in der Innenstadt","Hans-Erich Bilges",[1],5,[3],[5],1,"46","39"],["1343","1967-10-29","Nach Lenin-Zitat, dass der Radikalismus die Kinderkrankheit des Kommunismus sei, führt Schlamm Dutschke als Exempel hierfür vor. Verweise auf 1933. Abschließend wird ein US-Obergerichtsurteil zitiert, welches die Redefreiheit einschränkt.","Dutschkismus?","","","William S. Schlamm",[2],5,[5],[3],1,"46","5"],["1344","1967-10-30","Vorbericht über den am 3. November beginnenden Prozess","Prozess um den Tod Benno Ohnesorgs","Berlin","Kurras hat sich wegen fahrlässiger Tötung zu verantworten","Fa.",[7],4,[1],[2],2,"20","6"],["1345","1967-10-31","Wegen Formulierungen eines gleichzeitig mit dem Guevara-Telegramm nach Tokio gegangenen Schreibens muss Vorstand des TU-Parlaments zurücktreten.","Studentenparlament der TU zwingt Vorstand zum Rücktritt","","","",[11],4,[1],[2],2,"22","11"],["1346","1967-10-31","KU-kritische FU-Studenten formieren sich","Bei Kritischer Universität mitsprechen","","Aufruf unabhängiger Studenten zur Gründungsversammlung","vd",[11],4,[1],[3],2,"22","11"],["1347","1967-10-31","Anklageerhebung wegen Verdachts der schweren Körperverletzung","Anklage gegen \"Jubel-Perser\" erhoben","","Vorwurf des Landfriedensbruches nicht bestätigt","wt",[1],4,[1],[2],2,"22","11"],["1348","1967-10-31","Studentenparlament der TU mißbilligt Aktionen der Studentenvertretung und spricht Mißtrauen aus","AStA-Vorsitzender der TU trat zurück","","","",[11],1,[1],[2],2,"18","1"],["1349","1967-10-31","Generalstaatsanwalt Dehnicke klagt Kriminalobermeister Kurras wegen Tötung des Studenten Benno Ohnesorg an","Kurras-Prozeß: Der \"General\" klagt an","","","",[7],1,[1],[2],2,"18","3"],["1350","1967-10-31","Morgenpost veröffentlicht Flugblatt von acht FU-Studenten, die das Programm der \"Kritischen Universität\" als Programm einer \"Gegenuniversität\" verstehen, das sie ablehnen","\"Unser Studium und mehr steht auf dem Spiel!\"","","Warnung vor der \"Kritischen Universität\"","",[11],1,[1],[5],2,"18","7"],["1351","1967-11-01","Wegen Sit-in im \"Astor\" fünf Studenten zu Geldstrafe verurteilt.","Studenten verurteilt","","","zy.",[1],2,[1],[2],2,"8","4"],["1352","1967-11-01","Ankündigung der Eröffnung des Hauptverfahrens wegen Landfriedensbruchs. Haftbeschwerde nach fünf Monaten U-Haft.","Teufel-Prozess","","","rb.",[5],2,[1],[2],2,"8","2"],["1353","1967-11-01","Wichtige Entscheidung des Landgerichts: Verfahren gegen Teufel wegen Landfriedensbruch (Steinwurf am 2. Juni) wird eröffnet. Untersuchungshaft dauert an","Hauptverfahren gegen Fritz Teufel eröffnet","","","Eigener Bericht",[5],1,[1],[2],2,"16","3"],["1354","1967-11-01","Kommentar zum anstehenden Prozess","Recht kennt keine Rache","","","Peer",[7],6,[5],[3],2,"28","3"],["1355","1967-11-01","sachliche Meldung","Verfahren eröffnet","","","",[5],6,[1],[2],2,"28","4"],["1356","1967-11-01","Versuch einer Erklärung der Unruhen","Ursachen der Studenten-Unruhen liegen tief","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[5],2,"24","15"],["1357","1967-11-01","Terminierung des Verfahrens wegen Landfriedensbruchs","Verhandlung gegen Teufel am 27. November","","","fa",[5],4,[1],[2],2,"24","6"],["1358","1967-11-02","Verleger Blanvalet lädt zu Diskussionsveranstaltung in Deutschlandhalle. 2000 Menschen reden über Themen von Vietnam bis Springer.","Redner wurden unterbrochen","","","rb.",[10],2,[1],[2],2,"10","2"],["1359","1967-11-02","Urabstimmung zum Gründung der KU durchgesetzt. Vermehrt kritische Stimmen.","\"Linke\" müssen warten","Kritische Uni ","","hb.",[11],2,[1],[2],2,"10","2"],["1360","1967-11-02","Gründungsversammlung der \"Kritischen Universität\". Nach sechs Stunden abgebrochen wegen einer Bombendrohung. Finanzierung durch Spenden - bisher 2.062 DM.","Ende mit Bombendrohung","","Heftige Debatte um \"Kritische Universität\"","Eigener Bericht",[11],1,[1],[3],1,"20","1"],["1361","1967-11-02","Stürmische Auseinandersetzung der radikal linken und der gemäßigten Kräfte. Ausführlich kommt RCDS-Chef Runge zu Wort. Vortrag von Prof. Gottschalch, der den Parlamenten vorwarf, zu Standesämtern herabgesunken zu sein. Bernhard Blanke sagte über das Thema \"Springer-Tribunal\" im Programm der KU: \"Wenn das Tribunal Springer anklage, dann klage es eine Gesellschaft an, die Springer nicht nur erträgt, sondern ihn hervor gebracht hat.\" Das Tribunal werde eine Versammlung der Betroffenen sein und deshalb selbstverständlich subjektiv und einseitig urteilen. Lefèvre gab zu, dass die KU im Gegensatz zum Reformprozess stehe. Ein polnischer FU-Mitarbeiter sagt: \"Was Sie hier planen, würde die Institution der Universität zerstören.\".","Stürmische Diskussion der FU-Studenten","","Thema: \"Kritische Universität\"","Eigener Bericht",[11],1,[1],[1],1,"20","13"],["1362","1967-11-02","Bericht zum Versammlungsverlauf der Vollversammlung des AStA der FU Berlin, eine Urabstimmung über die Kritische Universität wurde durchgesetzt.","Entscheidung wurde vertagt","Sechsstündige Redeschlacht um die Gründung der \"Kritischen Universität\"","","Heinz Rabbow",[9,11],6,[7],[1],1,"36","2"],["1363","1967-11-02","Gründungsversammlung wurde abgehalten. Über Konstituierung soll Urabstimmung stattfinden.","Urabstimmung über Kritische Universität","","","V.D.",[11],4,[1],[2],2,"22","1"],["1364","1967-11-02","Reportage von der lebhaften Gründungsversammlung der KU. Streit über Tagesordnung. Verschiedene Redebeiträge. U.a.: \"Über das geplante Springer-Tribunal referierte der Student Bernhard Lancke. Dieses Tribunal werde auch die Justiz anklagen und eine Gesellschaft, die 'Springer nicht nur erträgt, sondern hervorgebracht hat'. Ein unabhängiges Urteil über Springer wäre allerdings nur in einer Gesellschaft möglich, die von Springer unabhängig sei.\"","Offene Opposition und harte Kritik","Kritische Universität","Gründungsversammlung im Auditorium maximum - Buh-Rufe und Papiertauben","V.D.",[11],4,[7],[1],2,"22","6"],["1365","1967-11-03","Erwartungen zum Prozessbeginn. Polizisten müssen ohne Waffe erscheinen.","Waffen sollen draußen bleiben","","Heute beginnt der Prozess gegen Kriminal-Obermeister Kurras","Marianne Bera, Horst Zylka",[7],2,[1],[3],1,"18","2"],["1366","1967-11-03","Zellenverlegung und Schreibmaschinenentzug für Teufel in der U-Haft, weil er selbstgefertigte Flugblätter mit Mao-Zittaten auf den Freistundenhof geworfen hatte. In einer zum Beitrag gehörenden Karikatur wird Fritz Teufel als Teufel dargestellt.","Mao-Lektüre in der Freistunde","","Student Teufel warf Flugblätter aus der Zelle","zy., jo.",[5],2,[1,5,4],[1],1,"18","5"],["1367","1967-11-03","AStA sagt Teilnahme am Festakt zum zehnjährigen Bestehen des Wissenschaftsrates ab. Der Wissenschaftsrat sei einer Zusammenarbeit mit den Studenten stets aus dem Weg gegangen; die Einladung sei daher nur als \"Zumutung\" zu verstehen.","FU-AStA sagt ab","","","Eigener Bericht",[11],1,[1],[2],2,"32","1"],["1368","1967-11-04","Hinweis auf Text im Heft","Kurras-Prozess: Ich glaubte an eine Falle","Todesschuss beim Schah-Krawall","","",[7],2,[1],[1],2,"10","1"],["1369","1967-11-04","Nach einer atmosphärischen Einleitung zahlreiche wörtliche Zitate von Prozessbeteiligten, insbesondere Kurras selbst.","\"Ich fühlte mich wie in einer Falle\"","1. Prozesstag um den verhängnisvollen Schuss beim Schah-Krawall in Berlin","So verteidigt sich der Kripobeamte Kurras vor Gericht","Horst Zylka",[7],2,[7],[1],1,"10","5"],["1370","1967-11-04","SDS-Mitglied beim Landendiebstahl erwischt","Festgenommen","","","",[8],2,[1],[2],2,"8","2"],["1371","1967-11-04","Entscheidende Widersprüche des Angeklagten schon am ersten Tag. Er bleibt bei seiner Darstellung der Notwehr, obwohl kein Zeuge davon etwas gesagt habe. Im \"Hin und Her des Zerrens und Fallens habe sich der zweite Schuss gelöst\". Es gab aber gar keinen zweiten Schuss. Ohnesorg wurde aus mehr als 1,5 Metern erschossen, sagt der Sachverständige.","Widersprüche schon am ersten Tag des Kurras-Prozesses","","Der Polizist bleibt dabei: Mit Messern bedroht","Eigener Bericht",[7],1,[1],[1],1,"16","1"],["1372","1967-11-04","Breite Wiedergabe des Verhörs von Kurras und des Zeugen Starke","Kurras im Verhör: \"Meine Zunge war wie gelähmt\"","","Erst in höchster Not will er zur Pistole gegriffen haben","Michael Kreutzer",[7],1,[1],[1],1,"16","3"],["1373","1967-11-04","Bericht über teilweise Ablehnung der KU durch Studenten, aber auch Unterstützung an TU und FU.","Studenten fordern Urabstimmung","","Vollversammlungen und Sitzungen in beiden Universitäten","wt",[11],4,[1],[5],2,"28","17"],["1374","1967-11-05","Karikatur, die Demonstranten mit Plakaten mit der Aufschrift \"Enteignet...\" zeigt. Genannt werden Mao, Kunzelmann, Nannen, Wagenbach, Höfer, Rowohlt, Mahler u.a. Das \"Enteignet Augstein\"-Plakat trägt ein Gartenzwerg, das \"Enteignet Grass\" (mit SS-Rune) trägt ein erkennbarer Grass, das \"Enteignet (Wolfgang) Neuss\"-Plakat (mit SS-Rune) ein Affe. Die Bildunterschrift stellt eine Nähe der demonstrierenden Studenten zu Adolf Hitler her: \"...so haben wir auch mal angefangen. A. H.\"","Vorschlag unseres Karikaturisten: wen man noch enteignen könnte... ","","","Stenzel",[10,1],1,[5,4],[3],1,"62","12"],["1375","1967-11-05","Große Analyse der KU. Verhältnis zur Studienreform, Bedeutung von ideologischen Phrasen. Meinungsäußerung - aber zugleich die Aussicht, dass der SDS etwas in Bewegung setzen könnte, was gar nicht beabsichtigt ist.","Eine Waffe in den Händen der SDS-\"Revolutionäre\"","Hintergründe der \"Kritischen Universität\"","Der Ansatzpunkt der \"Kritischen Universität\" ist die längst überfällige Reform der deutschen Hochschule. Doch ihr Ziel geht weiter. Es heißt Klassenkampf und Sturz des gegenwärtigen Gesellschaftssystems. Werden die \"Revolutionäre\" Erfolg haben? ","Michael L. Müller",[11],1,[7],[1],1,"62","12"],["1376","1967-11-05","Beginn der Gerichtsverhandlung gegen Kurras wegen Tod von Benno Ohnesorg.","Hat Kurras wirklich in Notwehr gehandelt?","","","Hans Kricheldorff",[7],5,[1],[5],1,"42","3"],["1377","1967-11-05","Detaillierter Bericht über Kampf der Göttinger Studenten um Mitbestimmung in der Hochschule","Göttingens Professoren gaben noch keine Antwort","","","Pal von Janko",[11],5,[1],[1],2,"42","15"],["1378","1967-11-06","Kritik an Prof. Gottschlachs Auftritt bei KU-Eröffnung","Gottschlach","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","2"],["1379","1967-11-06","Führt SDS-Erfolge auf Solidarisierung nach Ohnesorg-Tod zurück. In letzter Zeit hätten sich aber vermehrt Gegenkräfte formiert, was man dadurch fördern können, dass man die Hochschulreform unterstütze.","Gegenkräfte","","","Co.",[11],4,[5],[2],2,"20","2"],["1380","1967-11-07","Entgegnung bzw. Verteidigung gegen Stern-Vorwürfe. Kampagnenvorwurf.","Ein Zerrbild der Wirklichkeit","Das Verlagshaus Axel Springer zum Stern-Artikel","","",[10],6,[5],[3],2,"28","9"],["1381","1967-11-07","Abwehr der Stern-Vorwürfe. Herausstellung der Essentials von Axel Springer.","Liebe BZ-Leser","Falsche Adresse?","","Malte-Till Kogge",[10],6,[5],[5],2,"28","9"],["1382","1967-11-07","Westdeutsche Rektorenkonferenz zum schleppenden Fortgang der Hochschulreform.","Rektoren geben Vorwürfe weiter","Hochschulen","\"Studienreform wird von den Kultusministern verzögert\"","ems.",[4],4,[1],[3],2,"20","4"],["1383","1967-11-08","Aussage des medizinischen Gutachters. 13 Zeugen sagen u.a., dass sie nur einen Schuss gehört haben, und dass die Situation zum Zeitpunkt des Schusses schon \"bereinigt\" war.","13 Zeugen hörten nur einen Schuss!","Zweiter Prozesstag gegen Kriminalobermeister Kurras","","Horst Zylka",[7],2,[7,1],[1],1,"10","2"],["1384","1967-11-08","Bericht vom zweiten Prozesstag gegen Kurras. 13 Zeugen werden befragt, doch keine Klarheit. Kein Zeuge hat zwei Schüsse gehört. Gutachter sagt: Ohnesorg hatte viele Schlagverletzungen, Kurras aber auch. Der ehemalige Polizeivizepräsident Prof. Friedensburg sollte aussagen - auf Antrag der Verteidigung - ob der Schusswaffengebrauch gerechtfertigt gewesen sei. Kammer lehnt das ab.","\"Ohnesorg brach im Feuer zusammen\"","","Gutachter: Schlagverletzungen auch bei Kurras","M. K.",[7],1,[1],[1],1,"14","3"],["1385","1967-11-09","Schupo-Obermeister belastet Kurras","Schwarzer Tag für den Todesschützen","Polizist als Zeuge in Moabit: \"Ohnesorg war auf der Flucht\"","","Horst Zylka",[7],2,[1],[5],1,"12","1"],["1386","1967-11-09","Zeugenaussage des Polististen Horst Geier mit wörtlichen Passagen.","Schwarzer Tag für den Todesschützen","","","Horst Zylka",[7],2,[7],[2],2,"12","10"],["1387","1967-11-09","Aussage von POM Horst Geier über die Vorgänge in der Krummen Straße. Er ist der einzige Zeuge, der Kurras mit der Waffe in der Hand gesehen hat. Widersprüche zu anderen Zeugen. Büsch konnte nur wenige Fragen beantworten. ","Auch am dritten Tag im Kurras-Prozess noch keine Klarheit","","Wurde der Angeklagte wirklich bedrängt?","Eigener Bericht",[7],1,[1],[1],1,"16","1"],["1388","1967-11-09","Dritter Verhandlungstag im Fall Kurras. Abermals 13 Zeugen, die irgendwie alle unterschiedliche Dinge wahrgenommen haben. ","Neue Widersprüche im Kurras-Prozess","","Jeder sah die entscheidenden Sekunden anders","Michael Kreutzer",[7],1,[1],[1],1,"16","3"],["1389","1967-11-09","Langhans erscheint zur angeordneten Untersuchung im Landesinstitut für gerichtliche und soziale Medizin","Diesmal war er pünktlich","","","",[5],6,[1],[2],2,"32","6"],["1390","1967-11-09","Bericht vom Verhandlungstag im Kurras-Prozess mit Aussage eines Polizisten","Der \"wichtigste Zeuge\" im Fall Kurras vor Gericht","Berlin","Ein Polizeibeamter erlebte Benno Ohnesorgs Tod aus nächster Nähe","Fa.",[7],4,[1],[1],2,"20","6"],["1391","1967-11-10","18 Mitglieder der Vereinigung für internationale Studentenarbeit besuchen eine Polizeikaserne.","Polizei öffnete die Tür und die Studenten kamen","","Es wurde heiß diskutiert","Klaus Heine",[9],2,[1],[1],1,"16","9"],["1392","1967-11-10","Ausschussvorsitzender Löffler will mit Studenten über Zwischenergebnisse diskutieren und wird deshalb der Parteilichkeit geziehen.","Krach zwischen SPD und CDU um Diskussion über Schah-Demonstration","","","rb.",[7],2,[1],[2],1,"16","9"],["1393","1967-11-10","Nach einem heißen Sommer und einem ebenso heißen herbst steht die nächste Konventswahl an - und allenthalben macht sich Ermüdung breit. RCDS und seine Probleme, genügend Kandidaten zu finden. ","Wahlkampf vor müden Wählern","","Wo steht Dahlems nächster Konvent?","MM",[11],1,[1],[1],2,"24","17"],["1394","1967-11-10","SPD lehnt Kürzung des Etats für studentische Selbstverwaltung ab, weil das nur zu neuem Aufruhr führen würde","Keine Kürzung des AStA-Etats","","","Eigener Bericht",[11],1,[1],[2],2,"24","17"],["1395","1967-11-10","Störungen der Rektoratsübergabe an der Universität Hamburg, unter anderem wurde das Spruchband \"Unter den Talaren der Muff von tausend Jahren\" entrollt.","Krawalle in Hamburger Uni","","","Eigener Bericht / dpa",[1],1,[1],[2],2,"24","2"],["1396","1967-11-10","Quorum für Urabstimmung über TU-AStA","Urabstimmung durchgesetzt","","","dpa",[11],6,[1],[2],2,"48","12"],["1397","1967-11-10","Tumulte bei Rektoratsübergabe","Tumulte in der Hamburger Uni","","","",[11],6,[1],[2],2,"48","2"],["1398","1967-11-10","\"Unabhängige Aktionsgemeinschaft\" in der TU hat Quorum für Urabstimmung über Telegramme.","Urabstimmung an der TU","","","",[11],4,[1],[2],2,"26","13"],["1399","1967-11-10","CDU kritisiert Löffler wegen seines Plans, Untersuchungsergebnisse mit AStA zu diskutieren.","Jetzt scharfe Kontroversen im Untersuchungsausschuss","","CDU attackiert Vorsitzenden. Löffler will mit FU-AStA Ergebnisse diskutieren.","ska",[7],4,[1],[1],2,"26","13"],["1400","1967-11-11","GKR stellt KWG nicht für Gottesdienst der ESG zur Verfügung.","Gedächtniskirche will keine Studenten!","Gemeindekirchenrat schockiert die Studentenpfarrer","","g.st.",[3],2,[1],[1],2,"8","2"],["1401","1967-11-11","Verwirrenden Zeugenaussagen. Urteil demnächst erwartet.","Verteidiger verzichten auf 27 Zeugen im Kurras-Prozeß","Zeugen im Kurras-Prozess","","Zy.",[7],2,[1],[3],1,"8","2"],["1402","1967-11-11","Frage der Förderungswürdigkeit des SDS in der FU zwischen den Gremien umstritten.","Hick-Hack um SDS","","","",[8],2,[1],[2],2,"8","2"],["1403","1967-11-11","Zwei Zeugen vom absoluten Rand des Geschehens sagen aus, dass sie an diesem Abend Personen mit Messern gesehen haben wollen. Das widerspricht allen anderen Aussagen. ","Zwei Zeugen sahen Männer mit Messern","","Am Dienstag sagt Heinrich Albertz im Kurras-Prozess aus","M. K.",[7],1,[1],[1],2,"12","3"],["1404","1967-11-11","Kaiser-Wilhelm-Gedächtnis-Kirche will nichts mehr mit der studentischen Gemeinde zu tun haben. Das beschloss der Gemeindekirchenrat. Grund: die \"Verpolitisierung von Kirche und Verkündung\". Studentengemeinden protestieren dagegen","Kirche sperrt Studenten aus","","","eigener Bericht / AP",[11],1,[1],[2],2,"12","1"],["1405","1967-11-11","GKR stellt KWG nicht für Gottesdienst der Evangelischen Studentengemeinden zur Verfügung.","Gedächtniskirche sperrt Studenten aus","","","KHH",[3],4,[1],[2],2,"28","1"],["1406","1967-11-11","GKR stellt KWG nicht für Gottesdienst der Evangelischen Studentengemeinden zur Verfügung. Klare Begründung fehlt. Der angehängte Kommentar kritisiert die GKR-Entscheidung.","Gedächtniskiche sperrt Studentengemeinden aus","","Grund: Kritik am Verhalten - Erfolglose Vermittlung des Konsistoriums","khh, co",[3],4,[1,5],[1],2,"28","9"],["1407","1967-11-11","Bericht über weitere Zeugenvernehmungen, die jedoch kaum neue Erkenntnisse gebracht hätten.","Der Kurras-Prozess gerät unter Zeitdruck","Berlin","Ein Krankenfahrer berichtet von einem merkwürdigen Frackträger","fa.",[7],4,[1],[1],2,"28","6"],["1408","1967-11-11","Hamburger Burschenschafter wehren sich mit Flugblättern gegen Einvernahme durch linke Minderheit, Kommentator begrüßt dies, denn diese Minderheiten würden die gesamte Studentenschaft in der Bevölkerung diskreditieren, spricht von Dutschke als \"Pseudo-Castro\".","Studenten","","","W.G.",[1,2],4,[5],[2],2,"28","2"],["1409","1967-11-12","Fortgang der Verhandlung gegen Kurras mit sich widersprechenden Aussagen.","Was Kurras aussagt, wird meist widerlegt","","","Hans Kricheldorff",[7],5,[1],[5],1,"44","3"],["1410","1967-11-13","Student protestiert in KWG ","Student von Kanzel geholt","","Protestaktion vor Gottesdienst in der Gedächtniskirche","rb.",[3],2,[1],[3],2,"12","3"],["1411","1967-11-13","Störung vor Gottesdienstbeginn","Zwischenfall in der Gedächtniskirche","Student stieg auf die Kanzel. AStA-Chef machte Fotos","","",[3],6,[1],[5],2,"40","1"],["1412","1967-11-13","Verhinderter Versuch eines Mitglieds der Evangelischen Studentengemeinde, Protestschreiben von der Kanzel zu verlesen. Strafanzeigen der Studenten.","Protest von der Kanzel","Student verursachte Zwischenfall in der Gedächtniskirche","","Lothar T. Schindlbeck",[3],6,[1],[1],2,"40","4"],["1413","1967-11-13","Zumeist kritische Stimmen zur KWG-Enntscheidung. Protestierender Student aus KWG entfernt.","Gollwitzer übt scharfe Kitik an der Kirche","","Gottesdienst der Studentengemeinden in der TU - Zwischenfall in der Gedächtniskirche","hws",[3],4,[1],[1],2,"20","6"],["1414","1967-11-13","Termin für KU-Abstimmung festgelegt. Konvent stimmt für weitere Förderung des Sozialistischen Studentenbundes.","FU-Konvent: Urabstimmung über \"Kritische Universität\"","","","hws",[11],4,[1],[2],2,"20","6"],["1415","1967-11-14","Scharf stellt sich im KWG-Konflikt auf die Seite der ESG. Kritik auch von Gollwitzer","Bischof unterstützt die Studenten","","Weiter Streit um die Gedächtniskirche","rb.",[3],2,[1],[3],2,"8","3"],["1416","1967-11-14","Zwei Mitglieder des Untersuchungsausschusses stellten sich auf einer Veranstaltung des AStA den Fragen interessierter Studenten. Umstritten: die Frage der Lautsprecherdurchsagen. Es habe bis zu vier Versionen zu einzelnen Details gegeben. Immer mussten die beiden Abgeordneten die Studenten ermahnen, sachlich zu bleiben.","Löffler vor Studenten","","Missfallenskundgebungen und Mahnung zur Sachlichkeit ","MM",[7],1,[1],[3],2,"14","2"],["1417","1967-11-14","Kommentar, der lobt, dass die Meldung vom 10.11.1967, die Kaiser-Wilhelm-Gedächtniskirche wolle Studenten aussperren, falsch gewesen sei. Es gehe nur um einige Sonderveranstaltungen. Bei denen u.a. der politisierende linksradikale Theologe Gollwitzer predigen sollte: leider habe sich Bischof Scharf auf die Seite der Gollwitzer-hörigen Studenten geschlagen.","Ein Ärgernis in der Kirche","","","Jo.",[11],1,[5],[2],2,"14","2"],["1418","1967-11-14","Der Gemeindekirchenrat der Kaiser-Wilhelm-Gedächtniskirche bestätigt die Untersagung der Nutzung der Kirche durch die Evangelische Studentengemeinde für Gottesdienste. Bischof Scharf kritisiert dies.","Kirchenrat beharrt auf seinem Beschluss","","Bischof Scharf bestreitet Kompetenz - Konflikt spitzt sich zu","hws.",[3],4,[1],[3],2,"20","1"],["1419","1967-11-14","Für Lehrbegründung der Raumverweigerung ist GKR laut Scharf nicht kompetent. Ablehnung Gollwitzers vermutet. Solidaritätsresolution der ESG mit KWG-Störer.","Bischof Scharf: Verweigerung der Kirche unerhört","Berlin","Beschluss gegen Gollwitzer gerichtet? - Resolution der evangelischen Studentengemeinden","hws.",[3],4,[1],[3],2,"20","6"],["1420","1967-11-14","Veranstaltungsreihe der FDP mit Studenten","FDP will die Jugend ansprechen","Parteien","Forumsdiskussionen beginnen in den Hochschulstädten","uhl.",[11],4,[1],[2],2,"20","6"],["1421","1967-11-14","Verschiedene Studentenvertretungen und Universitäten wollen sich nicht am 10-jährigen Jubiläum des Wissenschaftsrates beteiligen.","Studenten: Kein Anlass für eine Jubelfeier","Universitäten","Teilboykott zum Jubiläum des Wissenschaftsrats","",[4],4,[1],[1],2,"20","6"],["1422","1967-11-15","Wenig sachdienliche Aussagen von Albertz und Gollwitzer.","Theologie-Professor schwor weltlichen Eid","","Kurras-Prozess: Albertz und Dr. Gollwitzer als Zeugen vernommen.","Horst Zylka",[7],2,[1,5],[1],1,"10","2"],["1423","1967-11-15","Solobild: Albertz und Gollwitzer","Zeugen im Kurras-Prozess","","","b-b",[7],1,[1],[5],1,"14","1"],["1424","1967-11-15","Der fünfte Sitzungstag stand im Zeichen der Vernehmung von Albertz und Gollwitzer auf Antrag der Nebenkläger. Nur eine Frage an Gollwitzer, die er aus zweiter Anhand beantworten musste. Fragen an Albertz wurden vom Gericht nicht zugelassen, da sie nicht der Sache dienlich seien. Die Frau eines Polizeibeamten sagte auf einmal aus, sie habe gesehen, wie Kurras niedergeschlagen worden sei.","Kurras-Prozess: das Gericht geht ins \"Kino\"","","Urteil soll am Dienstag verkündet werden","Michael Kreutzer",[7],1,[1],[1],1,"14","3"],["1425","1967-11-15","Kommentar über das bevorstehende Ende des Prozesses. Es wäre gut, wenn es keine weiteren sinnlosen Beweisanträge mehr gäbe, weil man den Eindruck hat, dass sie \"die Wahrheitsfindung nur noch erschweren können\". Albertz unterhielt sich in einer Verhandlungspause mit Kurras (dabei entstand das immer wieder abgebildete Foto), Gollwitzer legte den Eid ohne Berufung auf Gott ab, obwohl er Theologe ist, und Löffler und Geier traten sich gegenüber. Geier wusste nicht mehr zu sagen, ob er Löffler in der Nacht Bericht erstattet hat - was aber erst die Staatsanwaltschaft in die Lage versetzt habe, Kurras anzuklagen.","Die Wahrheit finden...","","","ewe",[7],1,[5],[2],2,"14","3"],["1426","1967-11-18","Generalstaatsanwalt Dehnicke beantragt acht Monate Gefängnis auf Bewährung für Kurras. Verteidiger Roos beantragte Freispruch, die Vertreter der Nebenklage Gefängnis teilweise ohne Bewährung","Gefängnis im Kurras-Prozess beantragt","","","Eigener Bericht",[7],1,[1],[2],2,"12","1"],["1427","1967-11-18","Dehnicke sagte zur Begründung seines Antrages: \"Zum entscheidenden Zeitpunkt, als der Schuss fiel, war Kurras weder bedroht noch bedrängt. Er stand völlig frei in der Mitte des Grundstücks, das bereits fast völlig geräumt war. Zur Abgabe eines Schusses lag also keine Veranlassung mehr vor.\" Kurras anderslautenden Aussagen seien Schutzbehauptungen. Roos danke für die faire Prozessführung, kritisierte aber, dass der alte Grundsatz \"In dubio pro reo\" von den Vertretern der Nebenklage ignoriert worden sei. ","Anwalt von Kurras: \"Ein fairer Prozess\"","","Staatsanwalt fordert Gefängnis, Verteidiger Freispruch","M. K.",[7],1,[1],[1],1,"12","3"],["1428","1967-11-15","TU-AStA tritt zurück. Neuwahl des Uniparlaments im Dezember.","1:0 für die studentische Demokratie","","TU-Parlament löste sich auf. Urabstimmung damit hinfällig.","Heinz Rabbow",[11],6,[1],[1],2,"32","2"],["1429","1967-11-15","Versuche des Konsistoriums zur Entspannung der Situation. Studentenpfarrer weisen ihnen gemachte Vorwürfe zurück.","Berliner Kirchenleitung will Kontrahenten an einen Tisch bringen","Der Streit um die Gedächtniskirche","Fünfstündige Beratung ohne Kommuniqué","Co.",[3],4,[1],[1],2,"22","3"],["1430","1967-11-15","Unabhängige Arbeitsgemeinschaften kritisieren politische Arbeit des AStA und fordern mehr Engagement für Hochschulreform.","Flugblatt kritisiert FU-AStA","","Arbeitsgemeinschaften haben sich zusammengeschlossen","eb",[11],4,[1],[2],2,"22","11"],["1431","1967-11-15","Konservative Verbände begrüßen Neuwahl.","Auflösung des TU-Parlaments begrüßt","","BSG und RCDS geben Stellungnahmen ab","wt",[11],4,[1],[2],2,"22","11"],["1432","1967-11-15","Geschichte der Eskalation einer Uniauseinandersetzung, die 1966 mit einer Demo gegen Fahrpreiserhöhungen begonnen hatte.","Studenten fordern Sturz ihres Kanzlers","","Folge der Demonstration in Köln: Fehde zwischen der Universitätsverwaltung und dem AStA","Alfred Freudenhammer",[11],4,[1],[1],2,"22","22"],["1433","1967-11-15","Zeugenaussagen zur Rekonstruktion des Todes von Benno Ohnesorg bei Anti-Schah-Demo am 2. Juni.","Zeuge Albertz brauchte nur \"nein\" zu sagen","","Urteil im Kurras-Prozeß am Dienstag? - Heute Film vom Tatort","",[7],8,[1],[1],1,"12","12"],["1434","1967-11-16","Student wollte verhafteten Mitdemonstranten bei Humphrey-Besuch befreien. Geldstrafe.","Demonstrant muss Strafe zahlen","","","rb.",[1],2,[1],[2],2,"10","3"],["1435","1967-11-16","Film von der Schah-Demo trägt nicht zur Klärung des Ohnesorg-Todes bei. Sachverständiger billigt Kurras möglicherweise Panik zu.","\"Kurras handelte in Panik\"","","","zy.",[7],2,[1],[5],1,"10","4"],["1436","1967-11-16","Aussage Obermedizinalrat Spengler: \"Der Angeklagte befand sich zum Zeitpunkt der Abgabe des tödlichen Schusses vorübergehend in einem psychogenen Ausnahmezustand.\" Zu diesem überraschenden Ergebnis kam der medizinische Sachverständige Dr. Spengler. Geistig und körperlich sei Kurras gesund, jedoch sei sein vegetatives Nervensystem sehr labil. \"Er geriet in eine hektische und panische Situation.\" Außerdem sei er durch das häufig wechselnde Licht (Blitze, Dunkelheit) gehandicapt gewesen. Die Vertreter der Nebenklage glaubten das nicht recht. Nun muss aber auf jeden Fall noch geprüft werden, ob putativ Notwehr vorliegen könnte. ","Todesangst und Panik packten Kurras","","So sieht der Mediziner die Ereignisse vom 2. Juni","M. K.",[7],1,[1],[1],1,"20","6"],["1437","1967-11-16","Die ständigen Unruhen haben offenbar bisher unpolitische Studenten mobilisiert. Sie haben eine gemeinsame Liste gegründet, um besser gegen die extrem linke Ausrichtung des AStA antreten zu können. Bericht über die Wahlvorbereitzungen","FU: Die Chancen der Linken sind geringer geworden","","Bisher unpolitische Studenten schlossen sich vor der Wahl zusammen","Michael Ludwig Müller",[11],1,[1],[1],2,"60","5"],["1438","1967-11-16","Geldstrafe für Studenten, der an Ausschreitungen bei Humphrey-Besuch beteiligt war","130 Mark Geldstrafe für Studenten","","","Kr.",[1],6,[1],[2],2,"32","9"],["1439","1967-11-16","Kommentator erwägt die beiderseitigen Argumente des Konflikts, stellt sich letztlich aber gegen den GKR und auf die Seite der Ausgesperrten.","Gedächtniskirche","","","Co.",[3],4,[5],[2],1,"20","2"],["1440","1967-11-17","\"Falken\" in Hannover sagen Diskussionsveranstaltung mit Dutschke ab, da dieser die parlamentarische Demokratie abschaffen und tätlich gegen Berlins Regierenden Bürgermeister vorgehen wolle, was ihn für eine Diskussion mit Andersdenkenden diskreditiere. Hinweis auf Dutschkes Stipendium als Zonenflüchtling, der \"rote Rudi\" lasse sich vom ihm bekämpften Staat bezahlen.","\"Roter Rudi\" war nicht erwünscht","","","",[8],2,[1],[5],1,"16","9"],["1441","1967-11-17","Falken Hannover laden Dutschke u. a. wg. Demokratiefeindlichkeit von Diskussionsveranstaltung aus.","Dutschke ausgeladen","","","",[2],6,[1],[5],2,"48","6"],["1442","1967-11-18","Bundeswissenschaftsminister Stoltenberg fordert im Bundestag mehr Unis und Studenten, sowie neue Studienordnungen.","Minister fordert: Mehr Unis! Mehr Studenten!","","","Jürgen Cieslik",[4],2,[1],[2],2,"10","10"],["1443","1967-11-18","Plädoyers von Anklage und Verteidigung","Todesschuss war Fahrlässigkeit","Generalstaatsanwalt fordert 8 Monate Gefängnis für Kurras","","Horst Zylka",[7],2,[1],[1],1,"10","2"],["1444","1967-11-18","Zusammenfassung eines Gesprächs über die Zustände an der FU und die Pläne und Ansichten Harndts","\"Wille zur Zusammenarbeit muss auf beiden Seiten vorhanden sein\"","","WELT-Gespräch mit dem neuen Rektor der Freien Universität, Prof. Ewald Harndt","Valeska Voß-Dietrich",[11],4,[1],[3],1,"30","6"],["1445","1967-11-18","Bericht vom letzten Verhandlungstag vor der Urteilsverkündung mit Zusammenfassung der Ergebnisse.","Kurras hätte seine Pistole sichern müssen","Berlin","Plädoyer des Staatsanwaltes - Verteidiger fordert Freispruch","fa.",[7],4,[1],[1],2,"30","6"],["1446","1967-11-19","Kommentator kritisiert Auftritt des SEW-Chefs Danelius bei Podiumsdiskussion in der FU.","An der FU ist nichts unmöglich","","","Wolfgang Voss",[11],5,[5],[2],2,"50","43"],["1447","1967-11-19","Kommentator unterstreicht die Notwendigkeit einer Hochschulreform","Unruhe an der Uni","","","Klaus Hoff",[4],5,[5],[5],2,"50","2"],["1448","1967-11-19","Kommentator ist Professor in Bochum und plädiert für stärkere Einbindung von Studenten in universitäre Entscheidungsprozesse.","Die Studenten mehr beteiligen!","","Sonst geraten unsere Universitäten völlig in Unordnung","Joachim H. Knoll",[4],5,[5],[5],2,"50","40"],["1449","1967-11-19","Plädoyer von Anklage und Verteidigung im Fall Kurras","Gefängnis für den Todesschützen?","Kurras-Prozess ","","N.",[7],5,[1],[2],2,"50","3"],["1450","1967-11-20","Verteidigung der Berliner Justiz gegen Vorwürfe der Parteilichkeit","Falsch und gefährlich","Kurras-Prozess: Voreingenommenheit so oder so","","Hans Kricheldorff",[7],6,[5],[1],1,"40","8"],["1451","1967-11-20","Diskussion auf der Landes-VV des SDS über Aufnahme von Mitgliedern der West-Berliner SED und FDJ","SDS-Dutschke liebäugelt mit der Westberliner SED","","","AP",[8],6,[1],[3],2,"40","2"],["1452","1967-11-20","SHB-Vorstandsmitglied Jens Litten an Gründung der Hamburger Version der KU beteiligt. Beschreibung der Gründungsversammlug und der Ziele.","\"Lach nicht so dumm - hier geht es um Kampf\"","Studenten","\"Kritische Universität\" auch in Hamburg gegründet - Abweichung vom Berliner Modell?","Paul Lersch",[11],4,[1],[3],1,"20","6"],["1453","1967-11-20","Bei Landes-VV des Berliner SDS ist gegenseitige Mitgliedschaft mit SED und FDJ Thema.","Dutschke für Annäherung SDS und SED-Westberlin","","","AP",[8],4,[1],[2],2,"20","6"],["1454","1967-11-20","Künftig haben auch Mittelbau, Assistenten und Studenten Einfluß in Beschlussgremien in Tübingen","Mehr Einfluss für Studenten der Universität Tübingen","","","dpa",[11],4,[1],[2],2,"20","6"],["1455","1967-11-20","LSD-Programm für TU-Wahlen. Schwerpunkt Hochschulreform.","Aktionsprogramm des LSD für TU-Parlamentswahlen","","","",[11],4,[1],[2],2,"20","11"],["1456","1967-11-21","Auflistung der Sicherheitsvorkehrungen bei Teufel-Prozess. Anklagepunkte","Bomben sind an der Garderobe abzugeben","","Scharfe Kontrollen bei Teufel-Prozess","zy.",[5],2,[1],[1],1,"10","5"],["1457","1967-11-21","Studenten opponieren gegen Störung eine Vorlesung durch SDS","In Frankfurt: \"SDS raus!\"","","","",[11],6,[1],[2],2,"28","2"],["1458","1967-11-21","Dutschke widerspricht einer AP-Meldung vom Vortag, wonach er für eine gegenseitige Aufnahme von Mitgliedern von SDS und SED-Westberlin eintritt. Dies sei eine bewußte Lüge.","Dutschke bestreitet","","","",[8],6,[1],[5],2,"28","3"],["1459","1967-11-21","Bildungspolitische Erwägungen mit Plädoyer für Hochschulreform.","Die Massen-Universität","","Weder Kuba noch Humboldt. Gewisse \"Verschulung\" unvermeidlich. Die Diskussion wird sachlicher.\"","Günter Zehm",[4],4,[5],[1],2,"22","2"],["1460","1967-11-21","Fragenkatalog für Schütz vor dessen Vortrag an der Kirchlichen Hochschule.","SHB stellt acht Fragen an Regierenden Bürgermeister","","","",[3],4,[1],[2],2,"22","12"],["1461","1967-11-21","Anderthalbstündige Störung von Frankfurter Gastvorlesung Schmids durch 25 SDS-Mitglieder.","SDS-Tumulte bei Vorlesung Carlo Schmids","","","pff",[8],4,[1],[2],2,"22","6"],["1462","1967-11-21","Ausweispflicht und Taschenverbot für Prozessbeobachter","Strenge Kontrollen bei Teufel-Prozess","","","dpa",[5],4,[1],[2],2,"22","6"],["1463","1967-11-22","Zwei Leserbriefe. Der erste kritisiert Bischof Scharf und unterstützt den KWG-GKR. Der zweite vermutet, dass der GKR der Ideologie des KU auf den Leim gegangen ist.","Nicht Gottesdienst, sondern politisches Spektakel","Aus Briefen an die Redaktion","","Leser",[3],4,[6],[1],2,"24","17"],["1464","1967-11-22","Respekt vor der Entscheidung, jedoch \"mehr als kritische Distanz\" zum \"unqualifizierten Beamten\" Kurras. Kritik am Beifall einiger Zuschauer. Kritik an jenen, die hier unbedacht von Mord sprechen, aber von den Morden an der Mauer nichts erwähnen.","Kein Schuldbeweis für den Todesschuss","","Kurras musste freigesprochen werden - Dennoch Respekt vor dem Gericht","Matthias Walden",[7],4,[5],[3],1,"24","2"],["1465","1967-11-22","Referiert die Urteilsbegründung","Gericht: Eine restlose Klärung ist nicht möglich","Kurras-Freispruch","In der Urteilsbegründung werden Widersprüche und Zweifel hervorgehoben","fa.",[7],4,[1],[3],2,"24","3"],["1466","1967-11-22","Vom SHB bis zum RCDS Kritik am Kurras-Urteil","Scharfe Urteilsschelte von Studentenverbänden","","","hws.",[7],4,[1],[2],2,"24","3"],["1467","1967-11-22","Staat müsse sich schützend vor Polizisten stellen. Polizei=Staat","Kurras-Prozess","","","Leser",[7],4,[6],[2],2,"24","17"],["1468","1967-11-22","Freispruch für Todesschütze Kurras, aber Richter bleiben Zweifel","Gericht: Das Urteil befriedigt uns nicht völlig","","Der Kurras-Freispruch und seine Begründung - Keine Notwehr - Dennoch Zweifel an der Schuld","",[7],8,[1],[1],1,"20","10"],["1469","1967-11-22","Bericht über Kurras-Freispruch, die widerstreitenden Reaktionen im Gerichtssaal, Unzufriedenheitsbekundung des Richters und Reaktionen bzw. Proteste einzlner Studentengruppierungen.","Freispruch für Kurras. Widerspruchsvolles Urteil. Staatsanwalt beantragt Revision","","","eg",[7],9,[1],[1],1,"24","1"],["1470","1967-11-22","Kommentar, der die Frage stellt, ob das Beweismaterial nicht doch für eine Verurteilung ausgereicht hätte. Thematisiert wird auch die Unangemessenheit der Untersuchungshaft Teufels im Vergleich zum Kurras-Verfahren.","Ein Urteil im Zwielicht","","","h.e.",[7],9,[5],[1],2,"24","2"],["1471","1967-11-22","Bericht von der Urteilsverkündung und -begründung durch den Vorsitzenden Geus. Jubel auf der einen Seite, \"Lähmung, Kopfschütteln und Achselzucken\" insbesondere bei den Pressevertretern.","\"Unbehagen bleibt\"","Heino Eggers berichtet aus Moabit:","","Heino Eggers",[7],9,[1,5],[1],1,"24","3"],["1472","1967-11-23","Kritische Zusammenfassung des Urteils, des Verfahrens. Kritische Stimmen zum Urteil","Freispruch!","Kurras erschoss den Studenten Benno Ohnesorg?Kurras hat nicht immer die Wahrheit gesagt?Keiner der 58 Zeugen sah den Todesschuss?Das Urteil befriedigt das Gericht nicht, aber:","","Horst Zylka",[7],2,[1,5],[1],1,"16","2"],["1473","1967-11-23","Meinungsstreit über den Freispruch für Kurras, kritisch zum Urteil.","Kurras-Freispruch - kein Grund zur Freude","","","",[7],6,[1,5],[1],1,"32","1"],["1474","1967-11-23","Bewertung der Schuldfrage. Referieren aller Standpunkte. Es gilt der Grundsatz, Zweifel zu berücksichtigen.","Im Zweifel für den Angeklagten","Kurras-Urteil im Streit der Meinungen","","Hans Kricheldorff",[7],6,[1,5],[1],1,"32","4,5"],["1475","1967-11-23","Sehr Kurras-kritischer Kommentar zu Prozess und Urteil","Mit seiner Schuld ist er allein","","","Peer",[7],6,[5],[5],2,"32","4"],["1476","1967-11-23","Sachliche Darstellung insbesondere der Stellungnahmen zum Urteil aus studentischem Bereich.","Kurras dankbar für das Urteil","","","k",[7],6,[1],[3],2,"32","5"],["1477","1967-11-24","Schütz gibt Studenten in ihrer Forderung nach Hochschulreform recht","Schütz: Neues Hochschulgesetz für Studenten","","","rb. ",[4],2,[1],[2],2,"16","5"],["1478","1967-11-24","Disziplinarverfahren noch offen. Politikerkritik an unsachlicher Bewertung des Urteils.","Kurras bleibt vom Dienst suspendiert","","Senator Neubauer: \"Bis das Urteil rechtskräftig ist\"","jo.",[7],2,[1],[5],1,"16","6"],["1479","1967-11-24","Kurras bleibt solange vom Dienst suspendiert, wie das Urteil gegen ihn nicht rechtskräftig ist. FDP verlangt Entlassung. Das Urteil zeige, dass Kurras den Anforderungen nicht gewachsen sei. AStA nannte den Freispruch ein \"ungeheuerliches Fehlurteil\". Justiz wird vorgeworfen, ein Zwei-Klassen-Recht zu praktizieren.","Kurras bleibt vom Dienst suspendiert","","Weitere Proteste gegen Freispruch","M. M. ",[7],1,[1],[1],1,"28","3"],["1480","1967-11-24","Zuckmayer fordert Studenten auf, sich von Hasskampagnen fernzuhalten","Zuckmayer an die Studenten","ki","","dpa, UPI",[1],6,[1],[2],2,"40","2"],["1481","1967-11-24","Reaktionen auf das Kurras-Urteil. Dutschke vergleicht freigelassenen Kurras mit inhaftiertem Teufel.","Kurras weiter vom Dienst suspendiert","Berlin","Hoppe verteidigt das Gericht gegen unsachliche Kritik","v.C., Bi.",[7],4,[1],[2],2,"24","4"],["1482","1967-11-24","Neubauer zur Suspendierung von Kurras, Hoppe zur Sachlichkeit der Urteilskritik, Reaktionen der FDP und der Falken","Kurras bleibt vom Dienst suspendiert","","Justizsenator vermisst in den öffentlichen Protesten sachliche Kritik","",[7],9,[1],[1],2,"20","2"],["1483","1967-11-25","Schütz verweist auf Urteil. Guggomos wird wegen Kritik mit einstweiliger Verfügung belegt. Schütz beantwortet Fragen des SHB an der KiHo (u.a. zu Springer).","Schütz: Kurras wird nie wieder Waffe tragen","","","rb.",[7],2,[1],[5],2,"8","2"],["1484","1967-11-25","Weil eine Vortrag von Carlo Schmid gestört worden war, verliert der Frankfurter SDS an der dortigen Uni seine Zulassung.","SDS an der Uni verboten","","","bk.",[8],2,[1],[2],2,"8","8"],["1485","1967-11-25","Vorlesungsfrei an HfbK und PH für Diskussionen über Teufel und Kurras","Frei für Teufel-Diskussion","","","rb.",[5],2,[1],[2],2,"8","2"],["1486","1967-11-25","Tumulte bei der Rektoratsübergabe an Prof. Weichselberger in der TU. Schütz-Rede in der KiHo unterbrochen. Kunzelmann versucht, ihm den Mund zuzukleben.","\"Ich werde dem Terror nicht weichen!\"","","Neuer TU-Rektor kontert Krawall-Studenten","hb.",[11],2,[1],[5],1,"8","4"],["1487","1967-11-25","Die feierliche Rektoratsübergabe wurde mit Buh-Rufen, Pfiffen und rhythmischem Klatschen gestört. TU-Studenten beklagten, ein Großteil der Störer sei \"noch nie zuvor an der TU gesichtet worden\". Bei der Totenehrung erscholl mehrfach der Name \"Benno Ohnesorg\". Schütz sagte, ganz gleich wie die Revision gegen Kurras ausgehe, werde er nie wieder eine Waffe tragen. Plakate mit chinesischen Schriftzeichen wurden ausgerollt.","Störer randalierten","","Zwischenfälle bei der Rektoratsübergabe an der TU","MM",[11],1,[1],[5],1,"12","3"],["1488","1967-11-25","Schütz stellt sich in der Kirchlichen Hochschule der Kritik. Verteidigt seine Entscheidung, die Polizei gegen bestimmte Demonstrationsformen vorgehen zu lassen. Distanziert sich vom Vorgehen der Justiz gegen Teufel. Zur Pressekonzentration: \"Man kann eine Presse nicht verbieten, weil einem die politische Richtung nicht passt. Ich bedauere die Pressekonzentration in Berlin, aber: Springer wird nicht enteignet. Dazu gibt es keine, aber auch gar keine rechtsstaatlichen Mittel. Auch nicht den Paragrafen 16 der Verfassung des Landes Berlin. Solange ich in Berlin Verantwortung trage, geht es hier rechtsstaatlich zu.\" Kunzelmann stieg auf das Podium, um Schütz einen Zettel auf den Mund zu kleben, wurde daran aber unsanft von Anderen gehindert. ","Schütz: Demonstration ja, Sachbeschädigung nein!","","Turbulente Szenen in der Kirchlichen Hochschule","LUK",[1],1,[1],[5],1,"12","1"],["1489","1967-11-25","Störung eines Schütz-Vortrages an der KiHo u. a. durch Kunzelmann. Zu einem Foto u.a. von Langhans und Teufel heisst es: \"Sind das die Repräsentanten der Berliner Studentenschaft? Wohl kaum. Sie stören mehr, als dass sie studieren.\"","Pöbeleien gegen Schütz","","Tumulte bei Diskussionen mit Studenten","P.R.",[3],6,[7],[1],1,"24","8"],["1490","1967-11-25","EV gegen Flugblatt über Kurras mit Guggomos V.i.S.d.P.. Widerspruch angekündigt.","Kurras erwirkt Einstweilige Verfügung gegen Guggomos","","","",[7],4,[1],[2],2,"30","3"],["1491","1967-11-25","300 Studenten stürmten Informationsveranstaltung des Nationaldemokratischen Hochschulbundes an der FU","Studenten unterbrachen Veranstaltung des NHB","","","",[11],4,[1],[2],2,"30","1"],["1492","1967-11-25","Schilderung der Vorgänge bei der Veranstaltung und Erläuterung der Raumvergabe an NHB durch FU.","NPD-Funktionär mit \"Sieg Heil\" begrüßt","","Studenten protestieren gegen NHB-Veranstaltung in der FU","tw",[11],4,[1],[2],2,"30","13"],["1493","1967-11-25","Anti-Schütz-Proteste bei Veranstaltungen an KiHo und TU","Störaktionen gegen Klaus Schütz","","Auseinandersetzungen mit Studenten an zwei Hochschulen","",[1],4,[1],[2],2,"30","1"],["1494","1967-11-25","Tumultartige Szenen bei Vortragsveranstaltung von Schütz. Äußerungen zu Kurras, Teufel, Studentenfragen etc. U. a.: \"Mit aller Entschiedenheit wandte sich Schütz gegen eine Enteignung des Springer-Konzerns. 'Die Springer-Presse ist eine freie Presse', erklärte er. 'Außerdem bin ich dagegen, zu enteignen, nur weil einem die politische Richtung nicht passt.'\"","Schütz vor Studenten: Kurras wird nie wieder eine Waffe tragen","Berlin","Erregte Diskussion in der Kirchlichen Hochschule","hws., Bi.",[1],4,[1],[1],2,"30","3"],["1495","1967-11-25","Randale bei er Eröffnung des neuen Audimax der TU. Heftige Reaktionen auf beiden Seiten.","Verteidigung ging im Tumult unter","","Randalierer störten Festakt der Technischen Universität","V.D.",[1],4,[1],[5],2,"30","3"],["1496","1967-11-25","Vorbericht zum Prozess am folgenden Montag","Teufel-Prozess mit starken Sicherheitsmaßnahmen","","","",[5],4,[1],[2],2,"30","3"],["1497","1967-11-25","PH und HfbK sagen für folgenden Montag Lehrbetrieb ab, um Diskussionen über Teufel-Prozess und Kurras-Urteil zu ermöglichen","Vorlesungspause nur an zwei Hochschulen?","","","v.C.",[5],4,[1],[2],2,"30","3"],["1498","1967-11-26","Bei der Einführung des neuen Rektors der Universität München Proteste mit Trillerpfeifen, Flugblättern, Papierschlangen und Luftballons. Ministerpräsident und Kultusminister wurden ausgepfiffen. Versuch der Totenehrung wurde verhindert. \"Damit setzten einige Studenten eine ,Tradition' fort, die seit kurzer Zeit in der Bundesrepublik eingeführt ist: Junge Leute benutzen die Hörsäle, um Krawall zu machen.\" Beispiel Berlin, wo Mitglieder der Kommune I Schütz angepöbelt hatten. Ihr Führer Dutschke proklamierte...","Krawall statt Totenehrung","","","Eigener Bericht",[1],3,[1],[5],1,"56","10"],["1499","1967-11-26","Störungen der Rektoratsübergabe an der Universität München. In Hamburg fordern über 700 Medizinstudenten den AStA auf, sich von den dortigen Störungen der Rektoratsfeier zu distanzieren.","Krawalle an Münchens Uni","","AStA distanziert sich von SDS-Demonstranten ","Eigener Bericht, dpa, AP, UPI",[1],1,[1],[3],2,"60","2"],["1500","1967-11-26","Ausblick auf Prozess: \"Wenn linksradikale Studenten wahrmachen, was sie angekündigt haben, dürfte von Montag an im Kriminalgericht Moabit der Teufel los sein.\" Prozess auf 14 Verhandlungstage angesetzt. Zusammenfassung der Vorwürfe (Rädelsführer, schwerer Landfriedensbruch, Steinewerfer). 92 Zeugen sind geladen, Mahler darf sich äußern. Er will geklärt sehen, ob beim Werfen von Eiern, Tomaten und Steinen aus einer Menge schon von Gewalttätigkeit im Sinne des Gesetzes gesprochen werden kann.\" Ernst Vorwürfe könnten nur durch Sachlichkeit geklärt werden, sagte Mahler.","Ist beim Teufel-Prozess am Montag der Teufel los?","","Verteidiger Mahler will ruhige und sachliche Verhandlung","Michael Kreutzer",[5],1,[1],[1],2,"60","5"],["1501","1967-11-26","Leserbriefschreiber verteidigt Axel-Springer-Verlag gegen \"Springer-Hasser\"","Der Schah-Besuch","","","Eberhard Rosenke",[7],8,[6],[1],2,"44","27"],["1502","1967-11-26","Automobil- und Speditionsverbände etc. fordern vom Reg. Bürgermeister eine Freihalten wichtiger Straßen von Demonstrationen. Kommentator verteidigt zwar Demonstrationsrecht, unterscheidet legitime Demos jedoch von Randale.","Kein Szenarium für Rüpeleien","","","Christian Colmar (Claus Dieter Nagel)",[1],5,[5],[2],2,"44","37"],["1503","1967-11-26","Dutschke erhielt Einreiseerlaubnis in die DDR zur Beerdigung seiner Mutter. Nahm an einer SEW-Vorstanssitzung teil.","SED half Dutschke","","","",[2],5,[1],[2],2,"44","1"],["1504","1967-11-26","Kommentator hält Radikalisierung der \"ungekämmmten\" Studenten für eine Folge von Anpassung.","Junge Konformisten","","","William S. Schlamm",[1],5,[5],[5],1,"44","5"],["1505","1967-11-26","Sicherheitsvorkehrungen bei Teufel-Prozess. Dutschke hat zu einem Go-in aufgerufen.","Mit Tasche darf niemand in den Saal","Teufel-Prozess","","N.",[5],5,[1],[2],2,"44","3"],["1506","1967-11-26","Scheidender Universitätsrektor erinnert angesichts der Störungen bei der Rektoratsübergabe an Ausschreitungen zu Beginn der NS-Zeit.","Studenten-Tumulte in München","","Rektoratsfeier gestört - \"Goppel und Huber raus!\"","dpa",[11],5,[1],[3],2,"44","1"],["1507","1967-11-27","Untersuchungsausschuss zu Unruhen an der FU kündigt Zeugenanhörungen an.","Rektor sagt aus","","","",[1],2,[1],[2],2,"14","2"],["1508","1967-11-27","Deutliche Kritik an den dringend reformbedürftigen Zuständen der Uni, ebenso deutliche Kritik an der politischen Zielsetzung der KU","Politikhochschule oder Forum für echte Kritik?","Es geht um die \"Kritische Universität\"","","Heinz Rabbow",[11],6,[5],[1],1,"40","8,9"],["1509","1967-11-27","Asta und RCDS distanzieren sich von SDS nach Störungen","AStA der Münchener Uni distanziert sich von rüden Störmanövern","","","AP, dpa",[11],6,[1],[3],2,"40","8"],["1510","1967-11-27","Schütz zur KiHo-Veranstaltung und zum beginnenden Teufel-Prozess","Klaus Schütz: Es gibt nicht nur Studenten","","","Klaus Bär",[3],6,[1],[2],2,"40","4"],["1511","1967-11-27","Diskutanten: Rudi Dutschke, Rudolf Augstein, Ralf Dahrendorf, Harry Ristock, Knut Nevermann, Jens Litten. Ob er die Reform oder Revolution will, will Dutschke nicht beantworten, um nicht zu manipulieren. Im Plenum Springer-bezogene Angriffe auf Augstein. Dutschke fordert von Augstein 10000 Mark für die APO.","Rudi Dutschke will keine Antwort geben","Studenten","Reform oder Revolution? - Podiumsdiskussion in Hamburg","Paul Lersch",[1,2,9],4,[1],[1],1,"20","3"],["1512","1967-11-27","Tumulte bei Rektoratsübergabe in München. Auch Störungen bei Filmvorführung in Kiel.","Münchner Rektor erwägt Verbot des SDS","","Nach Störaktionen bei Amtseinführung Professor Beckers","di, kws.",[8],4,[1],[2],2,"20","3"],["1513","1967-11-28","FU-Diskussion über Prozesse von Kurras und Teufel wird nach Tumulten abgebroche. Juraprof. Heinitz wird niedergeschrien.","FU: Professor niedergeschrien","","","hb.",[5],2,[1],[2],2,"8","2"],["1514","1967-11-28","Bebilderter Bericht von den Ausschreitungen vor dem Kriminalgericht anlässlich des Teufel-Prozesses.","Schwere Krawalle in Moabit","","Randalierer durchbrachen Absperrungen. Wasserwerfer und Berittene im Einsatz.","Jürgen Oster, Peter Behrendt",[5],2,[1,7],[1],1,"8","1,2,3"],["1515","1967-11-28","Erster Verhandlungstag gegen Teufel wegen Ausschreitungen beim Schah-Besuch. Diverse Aussagen Teufels zu seinem Leben und seiner politischen Einstellung. Zitate aus der richterlichen Befragung Teufels.","Ich habe Aua gerufen, als man mich schlug","","Erster Prozesstag gegen den Kommune-Studenten Fritz Teufel","Horst Zylka",[5],2,[7],[1],1,"8","2"],["1516","1967-11-28","Tumultartige Zusammenstöße vor dem Kriminalgericht Moabit. Anhänger von Fritz Teufel versuchten, das Gericht zu stürmen. Dutschke und Lefevre hatten dazu aufgefordert. Wasserwerfer und berittene Polizei kamen zum Einsatz, um die Randalierer abzudrängen. 14 Festnahmen, 3 verletzte Beamte, keine Fahndung nach Dutschke (entgegen Gerüchten).","Sturm auf das Gericht vereitelt","","","MM",[5],1,[1],[2],1,"14","1"],["1517","1967-11-28","Betont sachlich begann der Prozess gegen Teufel. Die Zuhörer waren überwiegend junge Leute. Gerichtsdirektor überhörte souverän im Verfahren Provokationen des Angeklagten. Teufel bestritt energisch, einen Stein geworfen zu haben: \"Angesichts des Waffenarsenals von Militär und Polizei in der Bundesrepublik und West-Berlin wäre es Wahnsinn und glatter Selbstmord, gegen diese Gewalt mit Gewalt vorzugehen.\" Seine Festnahme sei ein Überfall gewesen. Tomaten, Eier und Rauchkörper seien \"demonstrationstaugliche Flugobjekte\". Staatsbesuch des Schah sei eine \"Schmierenkomödie\" gewesen. Die Bevölkerung sei zum Theaterpublikum reduziert, \"und es ist sein gutes Recht, mit Tomaten und Eiern zu werfen, wenn ihnen das Stück nicht gefällt.\" Ein Zeuge sagte aus, dass Teufel nicht derjenige gewesen sein könne, der einen Polizisten mit beidem Steinwurf verletzte.","Fritz Teufel kassierte einen Pluspunkt","","Prozess in sachlicher Atmosphäre","M. Kreutzer",[5],1,[1],[1],1,"14","3"],["1518","1967-11-28","Kommentar zum Prozessauftakt. Teufel sei \"nicht unsympathisch\". Dabei bleibe auch die Kommune I in spießbürgerlichen Tendenzen stecken. \"Vielleicht ist das die eigentliche Tragik des Teufel Fritz, der, mit rheinischem Humor begabt, mit seiner Nickelbrille plus Rauschebart eher wie ein russischer Muschik denn ein Berlin umstürzender Kommunarde wirkt. Schade, dass man diesem leicht spinnert wirkenden Mann in einem Monsterprozess die Gelegenheit gibt, seine unausgegorenen Ideen der Weltöffentlichkeit zu Gehör zu bringen.\"","\"Vorgeführt erscheint...\"","","","ewe",[5],1,[5],[2],2,"14","3"],["1519","1967-11-28","Karikatur: Zwei langhaarige Männer, der eine mit einer Tasche mit der Aufschrift WÜTkong in der Hand, treffen sich. Um die Ecke steht ein Wasserwerfer. ","\"Ick dachte, Du wolltest dieses Jahr nich mehr baden?\"","","","Stenzel",[5],1,[5,4],[2],1,"14","3"],["1520","1967-11-28","Versammlung vor dem Marsch nach Moabit an der FU. Diskussion über die Fälle Kurras und Teufel. Dutschke wird ausgepfiffen. Jura-Professor Ernst Heinitz sagt, zu einer Äußerung zum Kurras-Urteil sei es noch zu früh, man müsse auf die schriftliche Begründung warten. Politik-Professor Ossip K. Flechtheim sagt, es sei eine Tendenz zu politischen Prozessen erkennbar. Das Strafrecht in der Bundesrepublik stehe in einem geistigen Gegensatz zum Grundgesetz. Tumultartige Szenen, als ein Staatsanwalt das Wort ergreifen wollte. Lefèvre forderte seine Anhänger auf, den Saal zu verlassen. ","Stürmische Debatte","","Dutschke von einem Pfeifkonzert übertönt","MM",[5],1,[1],[3],1,"14","3"],["1521","1967-11-28","Bericht über den Prozess gegen Fritz Teufel und die Demonstrationen vor dem Gericht, Aufmacher zu den Texten im Blatt, Dutschke wird als \"Bürgerschreck\" bezeichnet.","Langeweile im Teufel-Prozess. Krawall vor der Tür","","","",[5],6,[1],[4],1,"28","1"],["1522","1967-11-28","Über die Demonstrationen im Zuge des Prozesses gegen Fritz Teufel, ginge den Demonstranten nur um Krawall, Unterscheidung von Kritik und Krawall.","BZ meint: Unser Recht - kein Recht der Straße!","","","",[5],6,[5],[1],2,"28","2"],["1523","1967-11-28","Bericht über Ausschreitungen vor dem Kriminalgericht Moabit","Krawall vor der Tür","","Mit Wasserwerfern und Pferden gegen Demonstranten","L.R.",[5],6,[7],[1],1,"28","4"],["1524","1967-11-28","Verhinderte Solidaritätserklärung für Teufel in der FU","Eine böse Schlappe für Dutschke","","","Heinz Rabbow",[5],6,[7],[5],2,"28","4"],["1525","1967-11-28","Bericht über Verhandlungstag","Erster Tag im Teufel-Prozess","","","Hans Kricheldorff",[5],6,[7],[1],2,"28","5"],["1526","1967-11-28","Auseinandersetzungen um Raumnutzung durch suspendierten SDS in Frankfurter Uni. In München sieht man keine rechtlichen Möglichkeiten, den SDS zu verbieten.","Der SDS darf nicht in den Hörsaal","","","pff, di",[8],4,[1],[2],2,"22","6"],["1527","1967-11-28","Einsatz von Wasserwerfern und berittener Polizei gegen etwa 2000 Demonstranten vor Kriminalgericht. Es wird geprüft, ob Dutschke bei nichtgenehmigter Demo strafbare Handlungen begangen habe. ","Wasserwerfer gegen Demonstranten","","Tumulte vor Gerichtsgebäude beim Teufel-Prozess in Moabit","hws., v.C.",[5],4,[1],[2],1,"22","1,6"],["1528","1967-11-28","Bericht vom ersten Verhandlungstag mit Zitaten aus Teufelstagebüchern und einiger seiner Aussagen.","Aus dem Tagebuch von Teufel: Ab fünf Uhr Eierfüllen beim SDS","Berlin","Prozess gegen den \"Kommunarden\" eröffnet","Alfred Faber",[5],4,[1,5],[1],1,"22","6"],["1529","1967-11-28","Vorbereitende Versammlung im FU-Audimax und Geschehen vor dem Kriminalgericht","Mit roten und schwarzen Fahnen nach Moabit","","\"Anheizen\" ist der Tenor in der FU - Turbulente Versammlung im Auditorium Maximum","Hans-Wolfgang Sternsdorff",[5],4,[7],[2],2,"22","6"],["1530","1967-11-28","Bei Hauptverhandlung wegen schweren Landfriedensbruchs verliest der Angeklagte Teufel Stellungsnahme","Berufsangabe Kommunarde","","Fritz Teufel bestreitet die Vorwürfe der Anklage energisch","",[5],8,[1],[1],1,"14","8"],["1531","1967-11-28","SPD erklärt Kurras Urteil als korrekt zustande gekommen.","Berliner SPD zum Kurras-Urteil","","","",[7],9,[1],[2],2,"12","2"],["1532","1967-11-28","Anzahl der Ermittlungsverfahren in Zusammenhang mit Schah-Demonstrationen, Flugblättern und den Ausschreitungen bei Neuköllner US-Parade.","Senator Hoppe zieht Bilanz","Ermittlungen gegen Jubel-Perser und Demonstranten","","pf",[7],9,[1],[2],2,"12","2"],["1533","1967-11-28","Schilderung der (nichtgenehmigten) Demonstration vor dem Gerichtsgebäude, die eskaliert ist nachdem Rudi Dutschke \"zum weiteren Vorgehen aufforderte\". Senator Neubauer äußert Verdacht der Aufforderung zum Landfriedensbruch.","Krawalle begleiten Teufel-Prozess. Wasserwerfer und berittene Polizei gegen Demonstranten","","","Kajo",[5],9,[1],[1],1,"12","1,12"],["1534","1967-11-28","Erregte Stimmung bei VV zu Kurras und Teufel, die sich zum Tumult auswächst. \"Als danach das SDS-Mitglied Rudi Dutschke in die Diskussion eingreifen wollte, entwickelten sich weitere Tumultszenen.\"","Tumulte erstickten die Diskussion","","Studentenvollversammlung der FU zu den Fällen Kurras und Teufel","U.B.",[5],9,[1],[1],1,"12","2"],["1535","1967-11-28","Ausführliche Wiedergabe der Aussagen Teufels während des ersten Tages der Verhandlung gegen ihn.","Beruf: Kommunarde","Fritz Teufel am ersten Tag in Moabit","","Heino Eggers",[5],9,[1],[1],1,"12","3"],["1536","1967-11-29","GKR der KWG nimmt mehrere Äußerungen über ESG zurück.","Kirchenstreit: Gemeinderat gab nach","","","rb.",[3],2,[1],[2],2,"10","3"],["1537","1967-11-29","SDS-Mitglied für Wurf farbgefüllten Eis auf Polizisten bei Kudammdemo zu Geldstrafe verurteilt.","Mit Eiern geworfen: 150 DM Geldstrafe","","","zy.",[1],2,[1],[2],2,"10","2"],["1538","1967-11-29","Ermittlungen wegen Landfriedensbruchs gegen Dutschke u. a. nach Ausschreitungen vor Kriminalgericht","Ermittlungen gegen Krawall-Studenten","","","rb.",[5,2],2,[1],[2],2,"10","3"],["1539","1967-11-29","CDU-MdB verglich Dutschke mit NPD-Chef von Thadden. Die Anwesenden reagierten mit stürmischen Missfallensbekundungen. Rudolf Luster sagte: \"Ich schätze Menschen mit neuen Gedanken sehr. Und ich halte radikale Gedanken für ein Staatswesen und jede menschliche Organisation für notwendig. Ich bin aber auch der Meinung, dass Radikale und Weltverbesserer immer gefährlich waren.\" Dann nannte er die Namen Dutschke und Thadden, worauf ein minutenlanges Pfeifkonzert folgte, unterbrochen von Rufen Ho-Ho-Ho-Tschi-Min.","SDS-Ideologe mit NPD-Chef verglichen","","","MM",[2],1,[1],[2],2,"18","2"],["1540","1967-11-29","Ermittlungsverfahren wegen des Verdachts des Landfriedensbruch gegen Dutschke und mehrere andere Studentenführer eingeleitet. Insgesamt laufen sechs Verfahren gegen Dutschke; Es sei zu erwaten, dass sie zu einem Verfahren zusammengefasst werden. Vor der griechischen Militärmission Randale: Etwa 200 Demonstranten warfen Fensterscheiben ein und schoben ein Autowrack vor die Tür. Außerdem hissten sie eine rote Fahne, bevor die Polizei kam.","Gegen Dutschke laufen schon sechs Verfahren","","","L.R.",[2],1,[1],[5],2,"18","3"],["1541","1967-11-29","Ermittlungsverfahren gegen Dutschke wegen Verdachts des Landfriedensbruchs zu Beginn des Teufel-Prozesses","Verfahren gegen Dutschke","","","L.R.",[5],6,[1],[5],2,"28","3"],["1542","1967-11-29","Kommentierten \"Pressespiegel\" von Ost-Zeitungen zum Teufel-Prozess","Jeder sucht seinen Teufel?","","","ski",[5],6,[5],[2],2,"28","3"],["1543","1967-11-29","Auseinandersetzungen vor Militärmission nach Veranstaltung des \"Berliner Ensembles\" im FU-Audimax über Griechenland","Studenten demonstrierten vor griechischer Militärmission","Berlin","In den frühen Morgenstunden wurde die Ruhe wiederhergestellt","hws.",[1],4,[1],[2],2,"24","6"],["1544","1967-11-29","GKR-Erklärung zur Arbeit der ESG. Pfarrer der KWG distanziert sich von Erklärung","Kirchengemeinde lenkt ein","","Zahlreiche Behauptungen gegen Studenten zurückgenommen","hws.",[3],4,[1],[2],2,"24","6"],["1545","1967-11-29","Ermittlungen wegen möglicher Vergehen bei Ausschreitungen vor dem Kriminalgericht","Ermittlungen gegen Dutschke","","Landfriedensbruch-Verdacht - Neun vorläufige Festnahmen","hws.",[2],4,[1],[3],2,"24","1"],["1546","1967-11-29","Gegen Aktionen radikaler Minderheit, für Verbesserung der Situation an den Unis. Dutschke ruft in Bremen zu \"revolutionären Aktionen\" auf.","\"Gegen unsinnige Demonstrationen\"","Kiel","AStA der Universität verurteilt unkontrollierte Störaktionen","H.A., M.",[11],4,[1],[3],2,"24","6"],["1547","1967-11-29","Diskussion mit Beiträgen von Dutschke (SDS), Oxfort (FDP), Beck (SPD), Luster (CDU) und Grossmann (ILfM). Während Dutschke und Oxfort Beifall bekommen, werden Beck und vor allem Luster ausgebuht.","Turbulente Podiumsdiskussion","\"Ziele und Methoden der außerparlamentarischen Opposition\"","","k.m.",[11],9,[1],[2],2,"12","2"],["1548","1967-11-30","DGB sperrt der Gewerkschaftlichen Studentengemeinschaft GSG die Mittel.","DGB sperrt \"seinen\" Studenten das Geld","","","rb.",[9],2,[1],[2],2,"12","5"],["1549","1967-11-30","Der amtierende Polizeipräsident Moch will künftig auf den Befehl \"Knüppel frei\" verzichten und dessen Einsatz der Verantwortlichkeit des einzelnen Polizsten überlassen. Der BILD-Kommentar widerspricht dem. Er verweist auf die Gefährlichkeit des Gummiknüppels, und dass \"Knüppel frei\" niemals heißt \"Schlag zu\".","Der Knüppel und die Verantwortung","","","",[5],2,[5],[5],2,"12","4"],["1550","1967-11-30","Abermaliger Antrag des Verteidigers Mahler auf Haftentlassung. Fragen Teufels an einen Zeugen.","Wird Fritz Teufel heute aus der Haft entlassen?","","Gericht prüft Antrag des Verteidigers","Horst Zylka",[5],2,[1],[1],1,"12","4"],["1551","1967-11-30","Der AStA der Uni Gießen behauptet, zwei Stundeten seien bei der Kripo Gießen dazu aufgefordert worden, gegen Geldzahlungen beim SDS einzutreten und über seine Aktivitäten zu berichten. Behörde bestätigt, dass etwas Ähnliches passiert sei, allerdings hätten sich die Studenten selbst angeboten, das zu tun. Rektor der Universität protestierte dagegen, Stundeten als Spitzel einzusetzen. ","Verfassungsschutz überwacht SDS","","","UPI / dpa",[8],1,[1],[2],2,"20","7"],["1552","1967-11-30","Weiter Untersuchungshaft für Teufel. Gericht will aber weitere Beweisaufnahme abwarten. Teufel las Zeitung während der Vernehmungen von Zeugen. Gelegentlich befragte er selbst Zeugen. Als das Gericht nach der Mittagspause wieder eintrat, \"leistete sich Teufel dann noch einen seiner ,Scherze'\": Er blieb sitzen. Als der Vorsitzende ihn aufforderte, aufzustehen, antwortete er: \"Wenn es der Wahrheitsfindung dienlich ist, natürlich.\" Dann erhob er sich.","Fritz Teufel weiter hinter Gittern","","Gericht lehnte Antrag auf Haftverschonung ab","Michael Kreutzer",[5],1,[1],[1],1,"20","3"],["1553","1967-11-30","Befehl \"Knüppel frei\" wird abgeschafft. Einsatz nur noch in Einzelfällen und bei Widerstand. Kontaktaufnahme der Polizei zu den Unis und AStA.","Polizei künftig ohne \"Knüppel frei\"","","","Mü.",[9],6,[1],[5],2,"36","4"],["1554","1967-11-30","Bericht über Verhandlungstag","Wollte Teufel wirklich beißen? ","","","Hans Kricheldorff",[5],6,[7],[1],1,"36","4"],["1555","1967-11-30","Rektor der Uni Gießen protestiert gegen Versuche der Polizei, den dortigen SDS auszuforschen.","Den SDS bespitzelt?","","","",[8],6,[1],[2],2,"36","2"],["1556","1967-11-30","Erwägungen, wie man mit Würde und demokratischen Mitteln Ruhe in die Unis bekommen könnte.","Mit Würde","","","Leserin",[1],4,[6],[2],2,"20","2"],["1557","1967-11-30","Von der Süddeutschen Zeitung übernommene Karikatur, Fritz Teufel (mit Teufelshörnern) wird unter der Lupe der Justiz aus einem \"Nichts\" erst riesig.","Riesig wird ein kleines Nichts erst durch die Lupe des Gerichts ...","","","E.M.Lang",[5],4,[5,4],[3],1,"20","2"],["1558","1967-11-30","Kommentator würdigt Tübinger Reformbemühungen und warnt vor radikalen Forderungen.","Mitspracherecht oder Studenten-Räte?","","Der Tübinger Beschluss. Verzopftes Berufungswesen. Chance der Studenten.","Walter Görlitz",[11],4,[5],[1],2,"20","2"],["1559","1967-11-30","Amtierender Polizeichef überträgt die Verantwortung für die Verwendung des Gummiknüppels auf den einzelnen Polizisten. Künftige Polzeiratsanwärter sollen bei Zeitungen und in Betrieben hospitieren.","Nicht mehr: Knüppel frei!","","","Kajo",[9],9,[1],[2],2,"12","1"],["1560","1967-11-30","Nach zweitem Verhandlungstag deutet Richter mögliche Wende im Prozess an.","Heute Haftentlassung von Fritz Teufel?","","","eg",[5],9,[1],[5],2,"12","1"],["1561","1967-11-30","Aussage eines Polizisten und Einlassungen von Teufel. Keine neuen Erkenntnisse.","Noch mal in die Zelle","","Fritz Teufel: \"Tatverdacht gleich null\"","Heino Eggers",[5],9,[1],[1],1,"12","12"],["1562","1967-12-01","Anzeige gegen einen Mann, der bei Demo vor Kriminalgerichten Kind als Schutzschild vor Wasserwerfer benutzt hatte.","Kinderschutzbund: Anzeige gegen diesen Mann","","Unbekannter hielt ein Kind in den Strahl des Wasserwerfers","Jürgen Oster ",[5],2,[1],[5],1,"18","1"],["1563","1967-12-01","Aussagen zweier Polizisten zu Steinwurf und Widerstand bei Festnahme.","Polizisten belasten Fritz Teufel schwer","","Weite in Haft. Staatsanwalt beantragte Ordnungsstrafe","Kurt Dittrich",[5],2,[1],[1],1,"18","2"],["1564","1967-12-01","Bericht über Verhandlungstag gegen Teufel wegen Steinwurfs am 2.6.1967","Moabit: Fritz Teufel schwer belastet","","","Hans Kricheldorff",[5],6,[7],[1],1,"48","2"],["1565","1967-12-01","Misslungener Versuch des Verfassungsschutzes, den Sohn des Gießener Unirektors zur Ausforschung des SDS zu bewegen.","Treffpunkt Café \"Euler\"","Verfassungsschutz","Wirbel um geplante Überwachung des SDS in Gießen","vdh.",[8],4,[1],[3],2,"24","3"],["1566","1967-12-01","Zeugen belasten den Kommunarden Fritz Teufel, einen Polizeibeamaten mit Steinen schwer verletzt zu haben.","Teufel fand das Gericht \"befremdlich\"","","Staatsanwalt beantragte eine Ordnungsstrafe","Bg.",[5],1,[1],[1],2,"32","3"],["1567","1967-12-02","Teufel vor dem Gefängnistor. Hinweis auf Text im Heft.","Teufel wieder frei","Nach 146 Tagen Untersuchungshaft","","Horst Zylka, Peter Behrendt",[5],2,[1,5],[2],2,"10","1"],["1568","1967-12-02","Empfang Teufels durch seine Freunde. Mahler zur Prozessanwesenheit seines Mandaten.","\"Karnevalszug\" für freien Teufel","","","Horst Zylka, Peter Behrendt",[5],2,[1],[1],1,"10","3"],["1569","1967-12-02","Bericht über Verlesung des Gerichtsbeschlusses und die Haftentlassung","Jetzt geht's auch ohne ihn","Teufel aus der Haft entlassen","","Hans Kricheldorff",[5],6,[1],[1],1,"32","11"],["1570","1967-12-02","Juristische Bewertung der Entlassung","Nicht die Sorge der Justiz?","","","ro",[5],6,[5],[2],2,"32","11"],["1571","1967-12-02","Untersuchungshaft-Entlassung Teufels wegen mangelnder Fluchtgefahr","Fritz Teufel wurde aus der Haft entlassen","","","fa.",[5],4,[1],[2],2,"32","1"],["1572","1967-12-02","Kommentator nennt die Haftenlassung \"überfällig\".","Teufel","","","hws",[5],4,[5],[2],2,"32","2"],["1573","1967-12-02","Begründung des Gerichts und Empfang Teufel durch seine Freunde.","Hauptverhandlung ist jetzt auch ohne Fritz Teufel möglich","Berlin","Gericht begründet Haftenlassung des Angeklagten","fa.",[5],4,[1],[5],2,"32","6"],["1574","1967-12-02","Zustimmender Kommentar zum Ende der Untersuchungshaft Teufels mit deutlich herauslesbarer Sympathie für den \"bärtigen Studenten\", der \"im Gegensatz zu seinem Namen\" kein notorischer Unruhestifter und Gesetzesbrecher sei.","Die Justiz korrigiert sich","","","h.e.",[5],9,[5],[2],2,"12","2"],["1575","1967-12-02","Bericht vom folkloristischen Empfang Teufels durch die Kommune I vor der Untersuchungshaft-ASnstalt.","Adventskranz zu Entlassung","\"Jetzt ist der Teufel los\"","","Heino Eggers",[5],9,[1],[1],1,"12","3"],["1576","1967-12-03","Vorbericht über die Konventwahlen an der FU Berlin","Mit Spannung verfolgt: Konventswahlen an der FU","","Weiter Kurs nach links? - \"Unpolitische\" haben die Entscheidung","MM",[11],1,[1],[1],2,"56","5"],["1577","1967-12-03","Hamburger Psychologie-Professor zur studentischen Kritik an der zu großen Macht der Professoren und Ordinarien. Verteidigt im wesentlichen seinen Stand.","Macht oder Würde der Professoren","","","Peter R. Hofstätter",[4],5,[5],[1],1,"50","16"],["1578","1967-12-03","Glossiert studentische Störaktionen wie Happenings und Go-Ins","Es kann noch heiter werden","","","Walther Schmieding",[1],5,[2],[2],1,"50","16"],["1579","1967-12-03","Kommentar zum Ende der Untersuchungshaft Teufels mit vorsichtiger Kritik an deren Dauer. Charakterisierung Teufels als \"harmlosen Spinner\" mit \"freundlichen Augen\".","So teuflisch ist Teufel nicht","","","Herbert Hausen",[5],5,[5],[2],1,"50","4"],["1580","1967-12-04","Bonner AStA-Blatt nimmt Kurras-Freispruch als Beleg für unpolitische Rechtsprechung","Studentenstimme zum Kurras-Prozess","","","UPI",[7],4,[1],[2],2,"22","3"],["1581","1967-12-04","Mittelbau und Studenten werden künftig an Entscheidungen des Senats beteiligt.","\"Weitere Schritte müssen folgen\"","Universitäten","AStA spricht von \"bemerkenswerter Entscheidung\" in Tübingen","uhl.",[11],4,[1],[2],2,"22","3"],["1582","1967-12-05","Bestandsaufnahme, Schilderung der Wahl und ihrer Bedeutung, Kritik an Radikalisierung","Konventswahl mit hohem Einsatz","","Es geht um die Zukunft der FU","Heinz Rabbow",[11],6,[1],[1],1,"24","2"],["1583","1967-12-05","Dutschke behauptet im Fernsehen, dass Augstein Geld für den SDS gespendet habe.","Dutschke: Auch Augstein hat schon Geld gegeben","","","",[8],4,[1],[2],2,"20","6"],["1584","1967-12-05","Wegen Nichtdistanzierung von Extremen will KWG-GKR weiterhin seine Kirche der ESG nicht zur Verfügung stellen.","Kirchengemeinde bleibt bei ihrem Nein","Berlin","Neue Verschärfung im Streit um die Gedächtniskirche","Co.",[3],4,[1],[3],2,"20","3"],["1585","1967-12-05","Ermittlungen gegen Mahler wegen Verdachts der Untreue","Ermittlungsverfahren gegen Rechtsanwalt Horst Mahler","","","fa.",[6],4,[1],[2],2,"20","6"],["1586","1967-12-05","Bundestagsanfrage zum Gießener Überwachngsversuch","Anfrage zur SDS-Überwachung","","","UPI",[8],4,[1],[2],2,"20","3"],["1587","1967-12-05","Leser fragt nach Geldquellen der \"Revolution 1967\"","Welche Quellen?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["1588","1967-12-05","Leser schlägt Ost-West-Tausch von West-Studenten und Ost-Ausreisewilligen vor.","Der Unterschied","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["1589","1967-12-05","Bericht vom vierten Verhandlungstag. Widersprüchliche Zeugenaussagen. Teufel zu Ermittlungen gegen Mahler.","Demonstranten entlasten Fritz Teufel","Berlin","Zeugen blieben unvereidigt - Wegen Verdachts strafbarer Handlungen","fa.",[5],4,[1],[2],1,"20","6"],["1590","1967-12-05","Studentische Zeugen entlasten Teufel, der bei der Demo am 2. Juni an der Deutschen Oper keine Steine geworfen haben soll","\"Wir hatten alle Angst\"","keine ","Entlastungszeugen im Teufel-Prozeß sagten aus","M.K.",[5],1,[1],[3],2,"16","3"],["1591","1967-12-06","Beginn der FU-Wahlen. Mutmaßungen über Ergebnis. Auch Abstimmung über KU.","Konventswahlen mit Freibier und Mauerparolen","","FU: Kandidatenrekord. Geht's der Linken an den Kragen?","hb.",[11],2,[1],[1],1,"8","2"],["1592","1967-12-06","Prof. Lieber von der FU vor Untersuchungsausschuss enttäuscht über Studentenvertreter","\"Hoffnung aus Zusammenarbeit mit Studenten hat getrogen\"","","","rb.",[1],2,[1],[2],2,"8","2"],["1593","1967-12-06","Ausschuss befragt Zeugen zu Hintergründen der Unruhen. Früherer Rektor schilder Zustände in der FU.","Professor Lieber sagt als Zeuge über die Unruhen in der FU aus","Berlin","\"Handfeste institutionelle Ansprüche der Studenten\"","v.C.",[7],4,[1],[5],2,"24","6"],["1594","1967-12-06","Kritisches Portrait des Studentenführers Wolfgang Lefèvre","Agitator hinter den Kulissen","","Lefèvre: Drahtzieher des SDS","Walter Brückmann",[11],1,[1],[1],1,"14","7"],["1595","1967-12-07","Dutschke bricht Vortrag an Bonner Uni nach Pfeiffkonzert ab.","Ausgepfiffen","","","",[2],2,[1],[2],2,"18","10"],["1596","1967-12-07","Verhandlungstag mit sehr verschiedenen Aussagen. Gebbert über Schäge für Teufel durch Polizisten.","Teufel: Sperren Sie die Zeugen doch gleich ein","","Studenten sagten aus. Urteil am 20. Dezember","Horst Zylka",[5],2,[1],[1],1,"18","6"],["1597","1967-12-07","Bericht über Verhandlungstag  ","Ein paar Widersprüche mehr","Teufel-Prozess in Moabit","","Hans Kricheldorff",[5],6,[7],[1],1,"32","4"],["1598","1967-12-07","Münchner AStA tritt nach ungünstigem Wahlausgang zurück. Demo von Studenten u.a. in NRW. Berliner ESG beschwert sich über KWG-GKR bei Kreiskirchenrat.","AStA in München tritt zurück","Studenten","Berlin: Beschwerde der ESG beim Kreiskirchenrat","",[3,11,1],4,[1],[2],2,"20","6"],["1599","1967-12-07","Studenten wehren sich schriftlich gegen Stein-Entscheidung zu FU-Konvent","Berliner Studenten schreiben an Senator Stein","","Der \"Unterdrückung\" bezichtigt","v.C.",[11],4,[1],[2],1,"20","5"],["1600","1967-12-07","Fortsetzung der Zeugenanhörung. Mahler verzichtet auf Entlastungszeugen.","Teufel-Urteil noch vor Weihnachten","","","fa.",[5],4,[1],[2],2,"20","7"],["1601","1967-12-07","Frankfurter Studenten versuchen Sitzung des Senats der Frankfurter Universität zu sprengen.","Studenten stürmen Universitätsrektorat","","","dpa/upi",[11],1,[1],[2],2,"20","1"],["1602","1967-12-07","Teufel-Anwalt Horst Mahler verzichtet auf weitere Zeugenanhörungen","Teufel-Urteil vor Weihnachten?","","","",[5],1,[1],[2],2,"20","3"],["1603","1967-12-07","AStA-Gegner starten Gegenaktionen beim Wahlkampf an FU","Rote Sprüche und eine buntgescheckte Kuh","keine ","FU-Wahlkampf läuft auf vollen Touren","",[11],1,[1],[5],1,"20","5"],["1604","1967-12-08","Zwischenstand der FU-Wahlen","Schon 50 Prozent Wahlbeteiligung","","","hb.",[11],2,[1],[2],2,"16","6"],["1605","1967-12-08","Nevermann zu Zwangsexmatrikulationen","Hartes Rededuell um Studenten-Unruhe an der FU","","Ex-AStA-Vorsitzender kontert Rektor","rb.",[1],2,[1],[2],2,"16","6"],["1606","1967-12-08","Verein an FU als förderungswürdig zugelassen.","Einen Begriff falsch ausgelegt","","\"Verein deutscher Studenten Berlin-Leipzig\" an FU zugelassen","eb",[11],4,[1],[2],2,"22","11"],["1607","1967-12-08","Stein verteidigt sein Verbot eines FU-Konventsbeschlusses.","Stein weist Vorwürfe zurück","Studenten","\"Maximum an politischen Äußerungsmöglichkeiten eingeräumt\"","v.C.",[11],4,[1],[2],2,"22","3"],["1608","1967-12-08","Verschiedene Gruppen verteilen Flugblätter vor FU-Wahlen auf Campus.","Ohne Flugblätter geht es nicht","","","",[11],4,[1],[2],2,"22","11"],["1609","1967-12-08","Sit-in in Frankfurter Uni wegen Gremienbesetzung. Spitzel-Anwerbungsversuch in Göttingen.","Professoren müssen über ein \"Sit-in\" hinweg","","","",[11],4,[1],[1],1,"22","3"],["1610","1967-12-08","Student kritisiert Professor, worauf dieser jenen aus Lehrveranstaltung aussperrt. AStA beschwert sich darüber.","AStA reicht Beschwerde gegen Professor Wenke ein","","","bh.",[11],4,[1],[2],2,"22","6"],["1611","1967-12-08","Früherer Rektor der FU schildert die Taktiken des SDS, die Uni-Leitung zu diskreditieren","So kam an der \"Uni\" der Stein ins Rollen","","Der Untersuchungsausschuß tagte","MM",[7],1,[1],[1],2,"24","7"],["1612","1967-12-09","Kreiskirchenrat überstimmt GKR in Sachen ESG-Nutzung der KWG","Gottesdienst genehmigt","","","rb.",[3],2,[1],[2],2,"10","2"],["1613","1967-12-09","67 Prozent Wahlbeteiligung: stolzes Ergebnis","Lange Nacht für Studenten","","","hb.",[11],2,[1],[2],2,"10","2"],["1614","1967-12-09","Verfassungsschutz hat in Göttingen versucht einen SDS-Spitzel zu werben.","Student als Spitzel geworben?","","","",[8],2,[1],[2],2,"10","7"],["1615","1967-12-09","Juso-Chef Müller fordert von Studenten Distanz zu Radikalen","\"Das sind die Folgen der Krawalle\"","","","jci.",[1],2,[1],[2],2,"10","1"],["1616","1967-12-09","Mehrheit für von AStA vorgeschlagene Organisationsform der KU.","53 Prozent für Kritische Universität","","","dpa",[11],4,[1],[2],2,"28","1"],["1617","1967-12-09","SDS-dominierte Gruppe von Frankfurter Studenten wollen Anti-Regierungs-Demo in Bon.","Marsch auf Bonn gefordert","Studenten","Plan in Frankfurt - \"Bruch der Großen Koalition erzwingen\"","",[8],4,[1],[5],2,"28","6"],["1618","1967-12-09","Juso-Chef Müller fordert von Studenten Distanz zu Radikalen","Studenten sollen von Radikalen abrücken","","","pff",[4],4,[1],[2],2,"28","6"],["1619","1967-12-10","Bei den Konventswahlen  erzielten die Oppositionsgruppen starke Gewinne und die Linke starke Verluste - und das bei ungewöhnlich hoher Wahlbeteiligung","\"Erdrutsch\" an der Uni Berlin","","","Eigener Bericht",[11],3,[1],[2],2,"56","3"],["1620","1967-12-10","Ganzseitiger Report über die schlechte Lage der Studenten (Finanzierung, Möglichkeiten zu Arbeiten, zu wenig Studienplätze), Universitäten platzen aus allen Nähten. Überblick über die wichtigsten Studentengruppen, an erster Stelle, der SDS. Zusammenfassung der Forderungen an eine Studienreform, diese sei dringend nötig. Besonders der SDS will mehr als nur eine Hochschulreform. Er will die Gesellschaft der Bundesrepublik verändern. Gruppen wie er machen Krawall, demonstrieren gegen den Vietnamkrieg und gegen die Diktatur in Griechenland. Wechsel bei den AStA-Wahlen hat begonnen.","Was ist faul an unseren Universitäten?","Politische Krawalle verschleiern die wirkliche Situation unserer Studenten: Sie dürfen nicht länger die Sorgenkinder der Nation sein","Studenten werfen Eier, Steine, Puddingtüten, Studenten durchbrechen Absperrungen, schlagen sich mit der Polizei. Studenten stören die Veranstaltungen ihrer Professoren und schimpfen auf die Talare. Seit Monaten zieht eine Welle der Unruhe durch unser Land","Kurt Dittrich",[1],3,[1],[4],1,"56","14,15"],["1621","1967-12-10","Von 76 Konventssitzen der FU fielen 40 an SDS, SHB und andere Gruppen, die den linken AStA-Kurs befürworten","Knappe Mehrheit der Linken","","","MM",[11],1,[1],[2],2,"54","1"],["1622","1967-12-10","Kopf-an-Kopf-Rennen zwischen \"Mitte\" und \"Linke\" bei Konventswahlen. Philosophen entscheiden Sieg der Linken","Um vier Uhr morgens kam der große Ruck nach links","","Großer Jubel der SDS-Anhänger nach dem Wahlsieg an der FU","MM",[11],1,[1],[1],1,"54","5"],["1623","1967-12-10","Ergebnisse der FU-Wahlen und der KU-Abstimmung","FU-Linke hatte mehr erwartet","","","",[11],5,[1],[2],2,"44","1"],["1624","1967-12-10","Linke Gruppen an der FU enttäuscht über knappes Ergebnis. Wissenschaftssenator lobt hohe Wahlbeteiligung. Mehrheit für KU.","Rückschläge für die Linke. Nur noch vier Sitze mehr.","Nach den Wahlen an der Freien Universität:","","Peter Kohagen",[11],5,[1,5],[5],2,"44","37"],["1625","1967-12-10","Studentischer Widerspruch zu Hofstätters Plädoyer vom 3.12. für einen \"aufgeklären\" Absolutismus an den Universitäten.","Demokratisiert die Uni!","Forum des Sonntags","","Leser",[4],5,[6],[2],2,"44","4"],["1626","1967-12-10","Studenten repräsentieren nicht die gesamte Jugend und Teufel und Langhans repräsentieren nicht die Studenten. Man hätte den Dutschke-Studenten, die den Klassenkampf propagieren, beizubringen, dass Deutschland eine Demokratie sei.","Studentischer Klassenkampf?","","","William S. Schlamm",[1],5,[5],[3],1,"44","5"],["1627","1967-12-11","Ergebnis der Uni-Wahlen. 53 Prozent für die KU.","Knappe Mehrheit für \"linke\" Studenten","","Aber: Starke Gewinne der \"Rechten\"","hb.",[11],2,[1],[3],2,"12","2"],["1628","1967-12-11","Glosse über Hippiefete in der TU-Mensa","Ein-zel-männchen staunte: \"Nieder mit dem Blumenkohl!\"","","","Hans Joachim Stenzel",[11],2,[2],[5],1,"12","3"],["1629","1967-12-11","Kommentar zum Wahlausgang","Gewonnen haben die Verlierer","","","Heinz Rabbow",[11],6,[5],[5],1,"40","2"],["1630","1967-12-11","Nach Aufhebung des GKR-Beschlusses durch den Kreiskirchenrat, findet in KWG Studentengottesdienst statt. Bischof Scharf würdigt die Entwicklung.","Studenten-Gottesdienst in der Gedächtniskirche","","","dpa",[3],4,[1],[2],2,"20","3"],["1631","1967-12-11","Kommentator wertet Konventswahlen trotz Mehrheit nicht als Erfolg für die Linke.","Konventswahlen","","","Co.",[11],4,[5],[2],2,"20","2"],["1632","1967-12-11","Linke musste Einbußen hinnehmen, stellen aber die Mehrheit.","Knappe Mehrheit für die Linke an der FU","Berlin","Konvents-Wahlen entschieden sich in der Philosophischen Fakultät","v.C.",[11],4,[1],[1],2,"20","6"],["1633","1967-12-11","Party in der neuen TU-Mensa mit 5000 Hippies","\"Seien Sie Licht. Sehen Sie Stimmen. Fühlen Sie Farben\"","Das vierzehnstündigen Super- Hippyning in der Mensa","Berlin war eine LSD-Reise wert","Klaus Geitel",[11],4,[7],[5],1,"20","5"],["1634","1967-12-11","Rechtliche Bewertung des Ministeriums der Tatsache, dass an den Unis Anti-SDS-Kundschafter geworben werden sollten.","\"Überwachung des SDS durch den Verfassungsschutz rechtmäßig\"","Studenten","Bundesinnenministerium zu Vorfällen in Gießen und Göttingen","",[8],4,[1],[5],2,"20","6"],["1635","1967-12-11","Karikatur (Übernahme aus der Süddeutschen Zeitung), Fritz Teufel wurde an die Wand gemalt, versehen mit dem Schriftzusatz \"ist doof\", der malende \"deutsche Michel\" rennt weg.","Den Teufel an die Wand malen","","","",[5],4,[5],[3],1,"20","2"],["1636","1967-12-12","Karikatur zu Spiegel-Titel mit Dutschke, dieser wird äußerst unvorteilhaft dargestellt.","\"Wenn wa jenuch Krawall machen, komm' wa villeicht ooch in'n SPIEJEL.\"","","","Hans Joachim Stenzel",[2],2,[5,4],[2],1,"8","2"],["1637","1967-12-12","Nach Teufels Versuch zu Frühstücken, mehrere Aussagen zu Ungunsten der Polizei","Fritz Teufel wollte im Gericht frühstücken","","Vorsitzender: Packen Sie das wieder ein. Zeugen belasteten Polizisten schwer","Horst Zylka",[5],2,[1],[1],2,"8","4"],["1638","1967-12-12","Ankündigung der Uni-Wahlen im Dezember","TU-Studenten wählen ihr Parlament","","","rb.",[11],2,[1],[2],2,"8","5"],["1639","1967-12-12","Bericht über Verhandlungstag","Ein Tag für den Angeklagten","Teufel-Prozess  ","Glaubwürdigkeit eines Belastungszeugen erschüttert","Hans Kricheldorff",[5],6,[7],[1],2,"24","4"],["1640","1967-12-12","Senator berichtet über ungenehmigte Demonstrationen und geplante Gegenmaßnahmen","Gegen wilde Demonstrationen","","Erklärung von Bürgermeisterr Neubauer vor Parlamentsausschuss","el",[1],4,[1],[2],2,"22","11"],["1641","1967-12-12","Rektor der TH Hannover korrigiert AStA-Angaben zur Studienreform","TH Hannover","","","Leser",[4],4,[6],[2],2,"22","13"],["1642","1967-12-12","Katholischer Studenten-Dachverband nennt Reformvorschläge von SDS, SHB und RCDS diskutabel.","Erklärung zu Reformvorschlägen","","","",[9],4,[1],[2],2,"22","11"],["1643","1967-12-12","Vier Professoren wenden sich gegen Verfassungsschutzmaßnahmen gegen SDS","Professoren: SDS wird diffamiert","","","",[8],4,[1],[2],2,"22","6"],["1644","1967-12-12","Bericht vom sechsten Verhandlungstag im Teufel-Prozess. Anklage erschüttert. Teufel provoziert Gericht.","Starke Zweifel an belastenden Aussagen","Berlin","Teufel packt während der Vernehmung seinen Frühstückskorb aus","fa.",[5],4,[1],[5],2,"22","6"],["1645","1967-12-12","Kritik am Görlitz-Kommentar vom 30.11. aus konservativer Sicht","Mitspracherecht oder Studenten-Räte?","Aus Briefen an die Redaktion","Professor Gotthold Rhode antwortet Walter Görlitz","Leser",[11],4,[6],[1],2,"22","13"],["1646","1967-12-12","Ausführlicher Text über die anstehenden Hochschulwahlen","Jetzt herrscht Wahlkampffieber in der TU und PH","","Bisher höchste Kandidatenzahl für Studentenparlamente - Brief an Abgeordnete","wt",[11],4,[1],[3],2,"22","11"],["1647","1967-12-12","Bundesinnenminister hält SDS für antidemokratisch und verfassungsfeindlich.","Überwachung des SDS ist dringend geboten","","Bonn: Die Ziele der Organisation sind antidemokratisch","",[8],1,[1],[1],2,"16","9"],["1648","1967-12-13","Zwischenstand der TU-Wahlen","Wahlbeteiligung 27 Prozent","","","hb.",[11],2,[1],[2],1,"8","2"],["1649","1967-12-13","Prof. Thielicke solidarisiert sich mit einem Kollegen, der von einem SDS-Mitglied angegriffen worden war.","Ein Professor begehrte auf","Nun hat auch die Universität Hamburg \"ihre\" Probleme","","P.R.",[11],6,[1],[1],1,"28","2"],["1650","1967-12-13","Bucerius gibt laut Spiegel Geld an SDS. Spiegel-Verlag gibt kein Geld, sondern Augstein persönlich.","Auch Bucerius gibt Spenden für den SDS","","","",[8],4,[1],[2],2,"24","6"],["1651","1967-12-13","Thielicke verteidigt in einer Erklärung vor seinen Studenten Professor Wenke. Nennt Anführer der Radikalen Demagogen.","Armes Deutschland","","Statt einer Vorlesung","Helmut Thielicke",[11],4,[5],[5],1,"24","2"],["1652","1967-12-13","Unterschiedliche Aussagen zu Raumvergabeverfahren in der FU","Professoren widersprechen einander","Berlin","Sontheimer und Lieber vor dem Untersuchungsausschuss","v.C.",[7],4,[1],[2],2,"24","6"],["1653","1967-12-13","Hamburger Theologe Helmut Thielicke kritisiert Masse der Studenten, die sich nicht vom SDS-Radikalismus distanzieren","Thielicke an Studenten verzweifelt","","","AP",[8],1,[1],[2],2,"12","1"],["1654","1967-12-13","Parlamentarischer Untersuchungsausschuss bemüht sich um Klärung der Vorgänge um \"Raumvergabe-Richtlinien\"","Ausschuß kommt nicht voran","","Untersuchung über FU-Zwischenfälle verliert sich in Details","Michael L. Müller",[11],1,[1],[3],2,"12","3"],["1655","1967-12-14","Bericht über Verhandlungstag","Die letzten Zeugen vernommen","","","Hans Kricheldorff",[5],6,[7],[5],2,"28","4"],["1656","1967-12-14","Bucerius erklärt, sich an Anwaltskosten für Demonstrationsteilnehmer zu beteiligen.","Bucerius gibt 5000 DM für Anwaltskosten","","","",[8],4,[1],[2],2,"14","6"],["1657","1967-12-14","Kritik an der Finanzausstattung der juristischen Fakultät der FU","Studentenvertretung kritisiert ungenügende Etatmittel","","","",[11],4,[1],[2],2,"14","9"],["1658","1967-12-14","Bayerischer SPD-Landesvorsitzender Grabert bezeichnet Tel der Studentenproteste als berechtigt.","\"Studentenproteste zum Teil berechtigt\"","","","wfm.",[1],4,[1],[2],2,"14","6"],["1659","1967-12-14","Zeugenaussagen zu verschiedenen Wurfgeschossen","Die letzten Zeugen im Teufel-Prozess","","","fa.",[5],4,[1],[2],2,"14","6"],["1660","1967-12-15","59,5 Prozent Wahlbeteiligung an der TU","\"Magere\" TU-Wahlen","","","hb.",[11],2,[1,5],[2],2,"18","8"],["1661","1967-12-15","Bericht über Verhandlungstag, Vorführung von Filmen vom 2. Juni","Filme vom 2. Juni","Gestern im Teufel-Prozess","","Hans Kricheldorff",[5],6,[7],[1],2,"44","9"],["1662","1967-12-15","Fernsehfilme von Schah-Demo belasten Teufel nicht","Filme können Fritz Teufels Beteiligung nicht aufklären","","","fa.",[5],4,[1],[2],2,"24","6"],["1663","1967-12-15","Zur Wahlbeteiligung an der TU","Nur 59 Prozent der TU-Studenten wählten","","","",[11],4,[1],[2],2,"24","13"],["1664","1967-12-15","Neuer AStA in München will sich auf Hochschulreform konzentrieren","Neuer Münchener AStA gegen Revolution","","","di.",[11],4,[1],[2],2,"24","6"],["1665","1967-12-15","Studenten protestieren in Botschaft Koreas gegen Entführung von Südkoreanern aus Deutschland","Polizei trug Studenten aus der Korea-Botschaft","","Viele Proteste gegen Urteile in Seoul","UP/dpa/AP",[1],1,[1],[2],2,"24","1"],["1666","1967-12-15","Studenten für Observierung des SDS von Verfassungsschutz angeworben","Landtag debattierte Studentenaffäre","","","AP/upi",[8],1,[1],[2],2,"24","2"],["1667","1967-12-15","Professor Richard Löwenthal nimmt Vorwurf an Professor Gottschalch zurück, er stehe nicht auf dem Boden der freiheitlich-demokratischen Grundordnung","Professor nahm Vorwurf zurück","","","",[11],1,[1],[5],2,"24","7"],["1668","1967-12-16","Schlusswort des Angeklaten, Plädoyers das Anklage und der Verteidigung","Teufel war kein Rädelsführer","","Aber: Staatsanwalt fordert fünf Monate Gefängnis","Horst Zylka",[5],2,[1],[3],1,"10","2"],["1669","1967-12-16","Bericht über Verhandlungstag und Plädoyers","Teufel soll wieder brummen","Staatsanwalt fordert fünf Monate Gefängnis","","Hans Kricheldorff",[5],6,[7],[1],2,"28","9"],["1670","1967-12-16","Wahlbeteiligung in der FU nach Fakultäten","71 % der Juristen wählten","","","",[11],4,[1],[2],2,"26","17"],["1671","1967-12-16","Debatte über Finanzausstattung und politische Bewertung der Studentenvertretungen","CDU: Studentenvertretungen erhalten zuviel Geld","","SPD: Beim Haushalt keine Zensuren erteilen - Mehrstündige Debatte im Abgeordnetenhaus","hae",[9],4,[1],[3],2,"26","17"],["1672","1967-12-16","Plädoyers und Schlußwort im Teufel-Prozess","Teufels Anwalt fordert Freispruch","Berlin","Letztes Wort des Angeklagten: Ich habe einen \"Stein\" geworfen?","fa.",[5],4,[1],[2],2,"26","3"],["1673","1967-12-16","Keine starken Mehrheiten im Studentenprlament. Wahlergebnis.","Verteilte Gewichte im Studentenparlament der TU","","","",[11],4,[1],[2],2,"26","17"],["1674","1967-12-16","SDS droht, Lehrbetrieb lahmzulegen, wenn Fall Wenke (Professor, der einen Studenten ausgeschlossen hatte.) nicht in seinem Sinn erledigt wird.","Universität im Dilemma der Machtlosigkeit","Hamburg","Polizeiliche Maßnahmen würden die Unruhe um den Fall Wenk nur verstärken","bh., B.N.",[11],4,[1],[1],1,"26","3"],["1675","1967-12-16","Leserbriefschreiber beklagt die Wahlabstinenz der gemäßigten Studenten","Verspielte Chance","","","R.W.",[11],1,[6],[2],2,"16","2"],["1676","1967-12-16","Bei den Wahlen zum Studentenparlament der TU siegten die Vertreter der gemäßigten Mitte","Weder links noch rechts","","TU-Wahlen: Wer spielt das Zünglein an der Waage?","",[11],1,[1],[5],2,"16","5"],["1677","1967-12-16","Jurist Professor Bettermann nennt vor Untersuchungsausschuss Namen von Uni-Lehrkräften und Studenten, die zur Unruhe an der FU 1966 beigetragen hätten.","Kritische Worte zur Situation an der FU","keine ","Professor Bettermann vor dem Untersuchungsausschuß","M.M",[11],1,[1],[1],2,"16","6"],["1678","1967-12-16","Staatsanwalt fordert fünft Monate Gefängnis für Kommunarden Teufel, Anwalt Mahler Freispruch","Staatsanwalt: Fünf Monate Gefängnis für Teufel","","","M.K.",[5],1,[1],[2],1,"16","6"],["1679","1967-12-17","Bundesforschungsminister Stoltenberg vertritt die Auffassung, die Forderung linker Studentengruppen nach \"Revolution\" stoße in der Bundesrepublik auf Ablehnung. ","Revolutionsrufe finden kein Echo","","","dpa/AP/upi",[1],1,[8],[2],2,"48","2"],["1680","1967-12-17","Unterstützt Thielicke in Teilen seiner Kritik, kritisiert jedoch pauschales Negativurteil über alle Studenten.","Prof. Thielicke und die Studenten","","","Berthold Martin",[11],5,[5],[5],1,"38","4"],["1681","1967-12-18","Geringes Echo auf Diskussions-\"Demo\" des RC auf dem Kudamm. Dazu eine Karikatur mit demonstrierenden Studenten gegen den Weihnachtsmann und ähnliches, im Schriftzug \"Weg mit dem Sack\" wird das S ähnlich der SS-Rune abgedruckt.","Kalte Schulter für Diskutier-Gruppen auf dem Ku'damm","","","rb.",[1],2,[1,5,4],[2],1,"12","2"],["1682","1967-12-18","Republikanischer Klub provoziert Diskussionen zu DDR-Anerkennung auf Kudamm. U.a. nimmt Dutschke teil.","Die Anerkennung Ostberlins auf der Straße diskutiert","Opposition","Kampagne am Kurfürstendamm","hws.",[1],4,[1],[2],2,"18","3"],["1683","1967-12-18","Kommentator gibt der zögerlichen Hochschulreform Schuld an den radikalisierten Zuständen in den Unis.","Sturm in den Universitäten","","Reform oder Revolte? Die Radikalen haben leichtes Spiel. Viele Pläne, aber wenig Taten.","Bernd Nellessen",[4],4,[5],[1],2,"18","2"],["1684","1967-12-18","Kommission aus Lehrkörper und Studenten sollen sich an Hamburger Uni mit Reform befassen","Paritätische Kommission an Hamburger Universität","","","bh.",[4],4,[1],[2],2,"18","3"],["1685","1967-12-18","Die Politiker Stoltenberg (CDU) und Schmid (SPD) äußern Verständnis für Unruhe unter Studenten bzw. widersprechen Thielicke.","\"Verständnis für Unruhe unter den Studenten\"","","","",[1],4,[1],[2],2,"18","3"],["1686","1967-12-18","Pflichtet Thielickes Text vom 13.12. bei","Die Schuld","","","Leser",[11],4,[6],[2],2,"18","2"],["1687","1967-12-18","Kritisiert Thielickes Text","Übers Ziel hinaus","","","Leser",[11],4,[6],[2],2,"18","2"],["1688","1967-12-20","Tumulte bei Schütz-Vortrag im Audimax der FU. Beleidigendes Plakat. Teufel will Schütz zum Weihnachtsmann wählen lassen.","FU: Tumulte um Schütz","","","rb.",[11],2,[1],[2],2,"10","1"],["1689","1967-12-20","Über eine gestörte Vortragsveranstaltung mit Klaus Schütz in der FU.","Abfuhr für die Radikalen","","","L.R.",[11],6,[7],[2],2,"28","4"],["1690","1967-12-20","Studenten attackieren Regierenden Schütz bei Rede im Audimax der FU.","\"Mit Ulbricht reden\"","","Tumulte bei einem Schütz-Vortrag an der FU","",[11],1,[1],[2],2,"14","1"],["1691","1967-12-20","Studenten stören Vorlesung und zwingen Rektor zu Erklärung über Ausweisung eines persischen Studenten ","Rektor mußte Vorlesung abbrechen","","","dpa/AP/upi",[1],1,[1],[2],2,"14","2"],["1692","1967-12-20","Leserbriefschreiber fordert vom Regierenden Schütz mehr Klarheit in der Abgrenzung von studentischem Radikalismus","So geht es nicht weiter","","","St.",[1],1,[6],[2],2,"14","2"],["1693","1967-12-21","Eingeworfene Scheiben am Amerikahaus nach Schütz-Diskussion in der FU. Bürgermeister entschuldigt sich bei Stadtkommandanten. Will weiter diskutieren, sich jedoch nicht beleidigen lassen.","Mit Rowdys nicht mehr","","\"Regierender\" entschuldigte sich für Studenten","jo.",[11],2,[1],[3],1,"10","2"],["1694","1967-12-21","Bericht über die von Zwischenfällen geprägte Diskussionsveranstaltung mit Schütz in der FU, eine Minderheit habe die Veranstaltung terrorisiert, dazu auch eine Karikatur.","Wo blieb an diesem Abend das Gastrecht?","","","Heinz Rabbow",[11],6,[1,4,5],[1],1,"28","2"],["1695","1967-12-21","Stellungnahme Schütz","\"Ich lasse mich nicht anpöbeln\"","","","K.B.",[11],6,[1],[2],2,"28","2"],["1696","1967-12-21","Vorschlag zur Reform des Landeshochschulgesetzes vorgelegt","\"Ochsentour an Hochschulen beenden\"","Baden-Württemberg","Gesetzentwurf von Universitätslehrern und Studenten veröffentlicht","R.K.",[4],4,[1],[1],2,"20","6"],["1697","1967-12-21","Diskussionsveranstaltung mit Klaus Schütz im Audimax der FU wird massiv gestört.","\"?dann geht auch der Regierende Bürgermeister\"","","Oppositionelle Studenten diskutieren mit Klaus Schütz - Beifall und Buh-Rufe","v.C.",[11],4,[1],[1],1,"20","3"],["1698","1967-12-21","Staatssekretär im Bundespräsidialamt Berger sieht Gefahren für Demokratie durch radikale Kräfte. CSU-Chef Strauß meint, die Radikalen hätten die Studenten in Verruf gebracht.","Gegen Terror von Minderheiten","Studentenfrage","Staatssekretär sieht Gefahren - Strauß: Atmosphäre verpestet","St.",[1],4,[1],[5],2,"20","6"],["1699","1967-12-21","Tumult in Münchener Uni, nachdem man Polizisten in Zivil in Studentenversammlung entdeckt hat.","Polizei in Zivil bei Studentenversammlung","","","",[11],4,[1],[2],2,"20","6"],["1700","1967-12-23","Freispruch Teufels. Reaktionen. 683 Selbstanzeigen von Demonstranten.","Jetzt will Teufel Geld vom Senat!","","Nach dem Freispruch: Anwalt fordert Schadenersatz","Horst Zylka",[5],2,[1,5],[1],1,"8","3"],["1701","1967-12-27","Hinweis auf Bericht im Blatt","So putschte Dutschke in der Kirche","","","",[3,2],6,[1],[5],2,"24","1"],["1702","1967-12-23","Bericht über Verhandlungstag und Urteilsverkündung, der Freispruch für Teufel hätte den Demonstranten einen Strich durch ihre geplanten Protestaktionen gemacht, es ist vom verhinderten Märtyrer Teufel die Rede.","Freispruch für Teufel","","","Hans Kricheldorff",[5],6,[7],[1],1,"24","4"],["1703","1967-12-23","Bericht über vorläufige Festnahmen von Prozessbesuchern, die Knallkörper und Buttersäure bei sich hatten.","Krach und Gestank","","","L.R.",[5],6,[1],[2],2,"24","4"],["1704","1967-12-23","Kommentar zum Teufel-Prozess, Fritz Teufel wird als \"pubertäter Spätzünder, wie ihn Psychiater nur selten zu Gesicht bekommen\", beschrieben, Teufel würde sich über den Freispruch ärgern, der Prozess hätte besser nie stattgefunden.","Zu den Akten gelegt","","","Peer",[5],6,[5],[5],2,"24","4"],["1705","1967-12-23","SPD-Kritik am SHB und AStA der FU","Genossen ließen Schütz im Stich","","","dpa",[11],6,[1],[2],2,"24","2"],["1706","1967-12-23","Senator fordert von AStA-Chef dafür Sorge zu tragen, dass sich ähnlich beschämende Vorfälle nicht wiederholen. Scharfe Reaktionen aus der Politik.","AStA soll künftig Vorsorge treffen","","Prof. Stein schrieb an Landsberg wegen der Vorfälle um Schütz","sh",[11],4,[1],[5],2,"28","17"],["1707","1967-12-23","Freispruch Teufels vom Vorwurf des Landfriedensbruchs. Mahler will Polizisten auf Schadensersatz verklagen. Schütz akzepiert Urteil. Anhängender Kommentar lobt das Urteil und die Richter und hält die Staatsmacht für blamiert.","\"Eierwerfen ist Gewalttätigkeit\"","Teufel-Prozess","Gericht hält aber Landfriedensbruch nicht für erwiesen","fa., H.Sch.",[5],4,[1,5],[5],2,"28","6"],["1708","1967-12-23","Teufel aus Mangel an Beweisen vom Vorwurf des Landfriedensbruchs freigesprochen","Teufel freigesprochen","","","",[5],1,[1],[2],2,"12","1"],["1709","1967-12-23","Wissenschaftsenator Stein fordert den AStA auf, als Veranstalter die freie Rede eines Gastredners zu ermöglichen","Stein: Verhalten des AStA unverantwortlich","","SPD rügt sozialdemokratische Studenten-Organisation","",[11],1,[8],[3],2,"12","2"],["1710","1967-12-23","Kommunarde Fritz Teufel mangels Beweisen freigesprochen. Aussagen der Polzei genügen nicht","\"Er hat sich selbst gekennzeichnet\"","","Fritz Teufel freigesprochen - Ihm war Landfriedensbruch nicht nachzuweisen","",[5],1,[1],[3],1,"12","5"],["1711","1967-12-23","Begründung des Gerichts, warum Fritz Teufel nicht wegen einfachen Landfriedensbruchs verurteilt wurde sowie Stellungnahmen ","Freispruch unter Beifall","","Tenor des Teufel-Urteils: \"Gewalt nicht mit vereinten Kräften","",[5],8,[1],[1],2,"12","12"],["1712","1967-12-23","Unterschiedliche Reaktionen verschiedener Gruppierungen auf Freispruch Teufels. Hinweis auf Text im Heft.","Fritz Teufel freigesprochen","","","eg",[5],9,[1],[2],2,"12","1"],["1713","1967-12-23","Lob für Freispruch. Vergleich mit Kurras-Urteil. Positive Bewertung des Verhaltens von Teufel im Gericht: Zivilcourage, kein deutscher Untertanengeist. Allerdings steht nächstes Verfahren bereits vor der Tür.","Licht und Schatten","","","h.e.",[5],9,[5],[2],2,"12","2"],["1714","1967-12-23","Urteilsbegründung. Unruhe vor dem Gerichtsgebäude durch Dutschke und Kommunarden. Langhans und Kunzelmann festgenommen.","Polizei und Kommune in Weihnachtsstimmung","","","Heino Eggers",[5],9,[1],[1],1,"12","3"],["1715","1967-12-23","Republikanischer Klub wertet Verfahren gegen Teufel als politisch motiviert. Humanistische Union kritisiert die Dauer der U-Haft.","\"Politische Motive\"","","","",[5],9,[1],[3],2,"12","3"],["1716","1967-12-24","Klaus Schütz über Ost-West-Verhältnis, Bundesorgane in Berlin, Ulbricht","Klaus Schütz: 1968 geht es in Berlin weiter aufwärts","","Interview mit dem Regierenden Bürgermeister","Diethard Goos, Rolf Stiege",[9],1,[3],[1],2,"52","1"],["1717","1967-12-24","Klaus Schütz fordert \"Selbstreinigungsprozeß\" der Studentenvertretungen","Die Universität muß ihre Fronten klären","Klaus Schütz in unserem Interview","","Diethard Goos, Rolf Stiege",[9],1,[3],[1],1,"52","12"],["1718","1967-12-24","Zustimmung für Schlamms Hinweis darauf, dass Radikale nur Minderheit sind. Unruhe an sich positiv.","Gegen die radikalen Studenten","Forum des Sonntags","","Leser",[1],5,[6],[2],2,"34","4"],["1719","1967-12-27","Demo gegen US-Vietnampolitik in der KWG. Dutschke erklimmt Kanzel. Pfarrer erstattet Anzeige wegen Hausfriedensbruchs und Sachbeschädigung.","Prügel für Dutschke bei Weihnachts-Andacht","","Zwischenfall in der Gedächtniskirche","Zy., PeBe",[3,2],2,[1],[1],2,"12","2"],["1720","1967-12-27","Gemeinde muss sich wehren. Ein Gehstock ist da aber nicht das richtige Mittel. Gottesdienststörung in Beziehung gebracht mit Synagogenschändungen.","Manchmal fängt es ganz harmlos an?","Der Pfarrer in Bild","","Waldemar Wilken",[3],2,[5],[2],1,"12","2"],["1721","1967-12-27","Störung der Christmette durch Gruppe um Dutschke; tätlicher Angriff auf Dutschke. Die Junge Union spricht vom \"Terror der kommunistischen Störenfriede mit Methoden der SA\".","Statt Liebe nur Hiebe","","Zwischenfall in der Gedächniskirche","az",[3,2],6,[1],[3],1,"28","4"],["1722","1967-12-27","Pfarrer zeigt Dutschke nach Störung der Christmette in KWG an","Strafanzeige gegen Rudi Dutschke","","Wegen Hausfriedensbruchs in der Gedächniskirche","v.C.",[3,2],4,[1],[2],2,"18","1"],["1723","1967-12-27","Details u.a. zur Entfernung der Demonstranten aus der Kirche. Verletzung Dutschkes durch Stockschlag.","Widersprüche um die Störaktion","Berlin","SDS: Dutschke stand nicht unter Einfluss von Alkohol","v.C.",[3,2],4,[1],[2],2,"18","3"],["1724","1967-12-27","Darstellung der Anti-Springer-Kampagne aus Sicht eines Springer Sympathisanten.","Die Parforcejagd auf Axel Springer","","Ein offener Brief an den Verleger","Hans Habe",[10],4,[5],[4],1,"18","6,7"],["1725","1967-12-28","KWG-Pfarrer gibt Dutschke Schuld an Vorfällen in der Kirche.","Dutschke hat Schuld","","","",[3,2],2,[1],[2],2,"10","2"],["1726","1967-12-28","Pfarrer Pohl zum Zwischenfall in KWG","\"Dutschke ist schuld\"","","","",[3,2],6,[1],[2],2,"24","4"],["1727","1967-12-28","GKR wirft Dutschke Kanzelmissbrauch vor und bedauert Tumulte. Ernst Lemmer krtisiert Kirche in offenem Brief, für den er wiederum von Kirchenvertretern kritisiert wird.","Offene Briefe schüren den Streit","Berlin","Immer mehr Widersprüche um Tumulte in der Kirche","v.C.",[3,2],4,[1],[2],2,"18","4"],["1728","1967-12-28","Leserbrief zum Nellessen-Kommentar vom 18.12. mit Betonung der Minderheit der Radikalen.","Reform oder Revolte?","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"18","6"],["1729","1967-12-28","Bericht über die tätlichen Auseinandersetzungen beim Weihnachtsgottesdienst in der Kaiser-Wilhelm-Gedächtniskirche, bei der junge Leute mit Plakaten gegen den Vietnam-Krieg demonstriert und Rudi Dutschke von der Kanzel herab agitiert hatte. ","Widersprüche um Dutschkes Auftritt","","Die Vorfälle bei der Christmette in der Kaiser-Wilhelm-Gedächtniskirche","",[2],8,[1],[1],2,"18","8"],["1730","1967-12-28","Kritik an den \"planmäßigen Provokationen\" der \"Dutschkisten\"","Stille Nacht der Provokation","","","thes",[2],8,[5],[2],2,"18","10"],["1731","1967-12-28","Handgreiflichkeiten mit und um Rudi Dutschke in der KWG am Weihnachtsabend aus der Sicht Dutschkes berichtet. In einem Anhang (\"Dutschkes Schuld\") Stellungnahmen aus anderer Perspektive.","Gebete und Prügel","","","H. Eggers",[3,2],9,[1],[1],2,"14","11"],["1732","1967-12-29","Juso-Chef Corterier grenzt sich vom SDS ab. Ihm ginge es lediglich um flegelhafte Provokationen.","\"Flegelhafte Provokationen\"","","","",[8],2,[1],[2],2,"12","1"],["1733","1967-12-29","Staatsanwaltschaft geht in Revision gegen Teufel-Freispruch","Revision gegen Teufel-Urteil","","","zy.",[5],2,[1],[2],2,"12","2"],["1734","1967-12-29","Plädoyer für wehrhafte Demokratie gegen radikale Linke von einem Konservativen.","Der Radikalisierung entgegentreten","Gefahren für den demokratischen Rechtsstaat","","Hans Joachim Schoeps",[1],4,[5],[5],1,"20","2"],["1735","1967-12-29","Bremer Pastoren fordern in Erklärung eine Entschuldigung des Gemeindekirchrats, in dessen Kirche der Studentenführer mit Gewalt von der Kanzel geholt worden sei","Pfarrer Pohls Protokoll","","Bremer Pastoren: Bei Dutschke entschuldigen","",[2],1,[1],[2],2,"16","2"],["1736","1967-12-29","30 Bremer Pastoren fordern Entschuldigung der Kirchengemeinde der Kaiser-Wilhelm-Gedächtniskirche, in der Rudi Dutschke bei Demonstration gegen Vietnam-Krieg von Gottesdienstbesuchern hinausgedrängt und geschlagen wurde.","30 Bremer Pastoren für Dutschke","","Per Telegramm fordern sie vom Gemeindekirchenrat eine Entschuldigung","",[2],8,[1],[1],2,"16","10"],["1737","1967-12-29","Generalstaatsanwalt legt Revision gegen Dutschke-Freispruch ein","Revision im Teufel-Verfahren","","","",[5],8,[1],[2],2,"16","10"],["1738","1967-12-30","Kleine Anfrage im Abgeordnetenhaus, ob wegen der KWG-Vorkommnisse Anzeige erstattet worden ist.","Strafanzeigen?","","","",[3],2,[1],[2],2,"12","2"],["1739","1967-12-30","Zusammenfassender Bericht über Gottesdienststörung durch Gemeindepfarrer. Gruppe Bremer Pastoren kritisiert Handgreiflichkeiten, was allerdings nicht als Parteinahme für Dutschke missverstanden werden dürfe.","Pastoren: Gewalt in der Kirche fehl am Platz","Evangelische Kirche","Sprecher in Bremen distanziert sich aber von radikalen Forderungen","Co., M.",[3,2],4,[1],[1],2,"24","8"],["1740","1967-12-30","Kritisiert Thielicke in der Pauschalität seines Urteils gegen die Studenten","Überlegungen eines \"gemäßigten\" Studenten","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[5],2,"24","8"],["1741","1967-12-30","Äußert Verständnis für Thielickes Position","Respekt vor dem Mitmenschen","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"24","8"],["1742","1967-12-30","Kritisiert am Fall Wenke aus konservativer Sicht Zustände an der Hamburger Uni.","Evolution statt Revolution","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"24","8"],["1743","1967-12-30","Der Berliner Propst Heinrich Grüber will Rudi Dutschke nicht zu Weihnachten in der Kaiser-Wilhelm-Gedächtniskirche auftreten lassen","Kirche muß Psychopathen in ihre Schranken weisen","","Propst Grüber gegen geforderte Diskussion","",[2,3],1,[1],[2],2,"14","1"],["1744","1967-12-30","Leserbriefschreiber fordert Studenten zu \"vernünftigen Diskussionen\" ohne Gewalt auf","Warum keine vernünftige Diskussion?","","","W.G.",[2],1,[6],[2],2,"14","2"],["1745","1967-12-30","Leserbriefschreiber polemisiert gegen Teufel-Freispruch, der den radikalen Studenten neuen Auftrieb gegeben habe","Neuer Auftrieb","","","R.O.",[5],1,[6],[2],2,"14","2"],["1746","1967-12-30","Kritik an Umgang des Senats mit radikalen Studenten","Rückblick und Ausblick","","","Peter Lorenz",[1],8,[5],[1],2,"10","5"],["1747","1967-12-30","CDU-Anfrage an den Senat wegen Kirchenstörung. Detaillierte Schilderung der Vorfälle","Dutschke und die Folgen","","Parlamentarisches Nachspiel, Kirchenkommentare und eine Vorschau","",[2],8,[1],[1],2,"10","9"],["1748","1967-12-31","Leserbriefschreiber üben scharfe Kritik an der Forderung Bremer Pastoren, der Kirchengemeinderat müsse sich bei Dutschke entschuldigen","Samthandschuhe nicht angebracht","","","F.J., W.G., A.v.K.I.K.",[2,3],1,[6],[3],2,"42","2"],["1749","1967-12-31","Umfrage in Europa, Südamerika, Ostafrika und Japan zur Lage der Studenten und ihrer Politisierung","Andere Länder andere Studenten","","Wir fragten: Welches Aufsehen haben die Ereignisse in Berlin in Ihrem Lande gemacht und gibt es ähnliche Probleme?","Julian Exner, Hans B. Meyer, hermann Bohle, Gustav Chalupa, Wolfgang Kraus, Alfred Schüler, Karl Puhlmann, Peter Wald, Richard Aschenborn, J. Heydecker, Anton Fendrich, Werner Crome",[11],8,[7],[4],2,"42","5"],["1750","1967-12-31","Zusammenfassung der Vorgänge am 2. Juni. Zu den Ursachen des Unbehagens der revoltierenden Studenten zählt der Autor u.a. das geringe Echo in Politik und Presse für die Anliegen der Hochschüler und den schleppenden Fortschritt der Hochschulreform. \"Ideologischer Schrittmacher und Motor der Aktion wird mehr und mehr der SDS, und eine linksradiale Clique versucht, den Dauerkonflikt zwischen Freiheit und Ordnung durch dosierte Anwendung von Gewalt für ihre revolutionären Tendenzen auszunutzen.\" \"Die Grenze zwischen Demonstranten, die von einem demokratischen Grundrecht Gebrauch machen, Gewalt anwendenden Extremisten und sympathisierenden oder bloß neugierigen Zuschauern wird oft schwer erkannt.\"","2. Juni - Explosion des Unbehagens","1967 in der Rückschau","","",[7],9,[5],[5],1,"31","14"],["1751","1967-12-31","Baden-Badener OB lehnt Dutschke-Auftritt ab: Für Rabauken und Flegel sein in der Kurstadt kein Platz. Hierüber Kontroverse.","Wieder Wirbel um Dutschke","","Im Kurhaus von Baden-Baden darf er nicht reden","",[2],5,[1],[3],2,"34","2"],["1752","1967-12-31","Witzzeichnungen mit satirisch gemeinten Liedertexten zu unterschiedlichen Aspekten des Jahres 1967, u.a. auch zum SDS.","Mit Musik geht alles besser!","Silvester-Potpourri","","Annemarie Lüders, Holfgang Hicks",[8],5,[2,4,5],[2],1,"34","17"],["1753","1967-12-31","Unruhe der Studenten legitim, aber in einzelnen Fällen über das Ziel hinaus geschossen. Man muss auch ihre Selbstkritik sehen. \"Der Untergang Deutschlands bahnt sich hier nicht an.\"","Deutschlands unruhige Studenten","Ein junger politischer Wissenschaftler zieht Bilanz","","Jürgen Dennert",[1],5,[5],[1],1,"34","4"],["1754","1967-12-31","Konstruiert radikale NPD-Vorkommnisse und das Handeln des Staates dagegen. Vergleicht das mit dem Verhalten gegenüber Linken.","Bericht aus dem Jahre 1968","","","William S. Schlamm",[1],5,[5],[5],1,"34","5"],["1755","1968-01-01","Strafgefangener aus Tegel verbittet sich Teufels Einsatz","Offener Brief an Teufel","","","\"Ein Strafgefangener\"",[5],6,[6],[5],2,"32","11"],["1756","1968-01-02","Stellungnahme von Pfarrer Pohl zu den Störungen des Weihnachtsgottesdienstes","Krawalle in der Gedächtniskirche","","","rb.",[1],2,[1],[3],1,"12","3"],["1757","1968-02-02","FU-Rektor Ewald Harndt nennt Belagerung der Philosophischen Fakultät \"Terror\" im Stil der SA","FU-Rektor: das war brutaler Terror von 200 Studenten","","","rb.",[11],2,[1],[3],2,"14","3"],["1758","1968-01-03","In der Rubrik \"Blickpunkt\" werden Stellungnahmen der Kirchenleitungen Berlin West und der Evangelischen Kirche Berlin-Brandenburg zitiert","Scharf verurteilt","","","",[1],2,[1],[2],2,"8","2"],["1759","1968-01-04","Ermittlungen gegen Kommunarden Teufel, Langhans, Kunzelmann und Antje Krüger wegen Gotteslästerung und Störung des Silvestergottesdienstes","Ermittlungen gegen Teufel-Anhänger","","","kh",[5],2,[1],[2],2,"8","5"],["1760","1968-01-05","Tagung des CC in Berlin, dieser distanziert sich von \"terroristischen Methoden\" des SDS.","Der \"COBURGER CONVENT\" tagt seit gestern in Berlin.","","","",[9],6,[1],[2],1,"36","2"],["1761","1968-01-05","Maßnahmen gegen aufbegehrende Studenten in USA","\"Studenten haben keine Vorrechte\"","In Amerika greift man jetzt härter durch","","sad",[11],6,[1],[1],2,"36","2"],["1762","1968-01-08","Linke Studenten stören Juristenball mit Feuerwerkskörper und werfen Schneebälle auf Taxen. Tätliche Auseinandersetzungen mit Polizei und Taxifahrern.","Taxifahrer verprügelten Krawall-Studenten","","","kh",[8],2,[1],[3],2,"12","1"],["1763","1968-01-08","Scharfe Kritik von Vertriebenenminister Kai-Uwe von Hassel an \"Terrormaßnahmen einer Minderheit\"","Bildung statt Terror","keine ","","jo.",[9],2,[1],[2],2,"12","3"],["1764","1968-01-08","Nach verhinderter Demo beim Juristenball, Tumult vor dem Haus des Rundfunks. Teufel, Kunzelmann und Antje Krüger dabei.","Krawall beim Ball","","","L.R.",[1],6,[1],[5],1,"32","3"],["1765","1968-01-09","Verfahren wegen Widerstands und Diebstahl einer Dienstmütze","Teufel wieder vor dem Kadi","","","L.R.",[1],6,[1],[2],2,"28","4"],["1766","1968-01-10","37 Hochschulrektoren wollen Reformen","Der alte Zopf muß ab!","Hochschul-Rektoren:","","Diethelm Schröder",[4],2,[1],[2],2,"8","1"],["1767","1968-01-11","Zwei SDS-Mitglieder haben in Polizeiuniform an der Münchener Uni gestört","Falsche Polizisten","","","",[8],6,[1],[2],2,"28","2"],["1768","1968-01-12","Kritische und friedliche Diskussion zwischen Studenten und Polizisten","So geht es auch!","Ingenieur-Studenten als kritische Gäste bei der Berliner Polizei","","L.R.",[9],6,[1],[1],1,"40","7"],["1769","1968-01-13","Evangelische Kirchenleitung Berlin-Brandenburg lädt zur Diskussion über Störung des Weihnachtsgottesdienstes","Diskussion mit Studenten","","","rb.",[1],2,[1],[2],2,"8","3"],["1770","1968-01-16","Neues TU-Parlament kritisiert Verurteilung von Schriftstellern in der UdSSR","TU-Protest gegen Urteil","","","bow",[11],6,[1],[2],2,"24","2"],["1771","1968-01-17","Konvent der FU wählt Soziologie-Studenten zum neuen Vorsitzenden","Neuer Vorsitzender","","","",[11],2,[1],[2],2,"10","2"],["1772","1968-01-17","Vorbeugehaft für Fritz Teufel vor Moabiter Gerichtsgebäude. Teufel hatte Knallkörper und Flugblätter bei sich. Schutzhaft für demonstrierende Studenten vor Schöneberger Rathaus","Studenten in Schutzhaft","","","Ne.",[5],2,[1],[2],2,"10","6"],["1773","1968-01-17","Zwei Studenten mussten nach Anti-SPD-Protesten vor Markthändlern in Schutzhaft genommen werden.","Schutzhaft","","","",[1],6,[1],[2],2,"28","3"],["1774","1968-01-17","Linke hatten es schwer, ihre Kandidaten durchzubringen","Die \"Linke\" hatte es schwer","","","bow",[11],6,[1],[2],2,"28","2"],["1775","1968-01-19","Vorwürfe vom RCDS gegen SDS vor Untersuchungsausschuss: Geplante Störaktionen","Protestaktionen sind vorbereitet","","Vorwürfe vor Untersuchungsausschuß","rb.",[7],2,[1],[5],2,"10","5"],["1776","1968-01-19","Studentenvertreter äußern sich zu ihrer Stellung zur Gewalt","Gretchen-Frage an Studenten","","","P.R.",[9],6,[1],[2],2,"32","4"],["1777","1968-01-20","Sieben Verfahren wegen Beleidigung, Aufruhr, Sachbeschädigung, schwerem Landfriedensbruchs, Körperverletzung. Antwort von Senator Hoppe auf CDU-Anfrage.","Sieben Verfahren gegen Dutschke","Senator Hoppe:","","rb.",[2],2,[1],[2],2,"8","3"],["1778","1968-01-21","Aufzählung von sieben z. Z. gegen Dutschke anhängige Ermittlungsverfahren","Dutschke hält die Gerichte in Atem","","","",[2],3,[1],[2],1,"48","4"],["1779","1968-01-23","Kein Großraum für den geplanten Vietnam-Kongreß des SDS","SDS ohne Raum","","","",[8],2,[1],[2],2,"8","2"],["1780","1968-01-25","Studenten am Romanischen Seminar wollten Diskussion, Professoren setzen Lehrbetrieb aus","Professoren schlossen Seminar","","","rb.",[11],2,[1],[2],2,"10","2"],["1781","1968-01-26","Verfassungsschutz-Analyse: Jugend läßt sich weder von Links- noch von Rechtsextremisten vereinnahmen","Die deutsche Jugend ist nicht radikal","","","Diethelm Schröder",[9],2,[1],[2],2,"12","1"],["1782","1968-01-26","Strafanzeige gegen Kommunarden Fritz Teufel wg. Hausfriedensbruchs und Richter-Beleidigung","Richter beleidigt","","","",[5],2,[1],[2],2,"12","2"],["1783","1968-01-27","Vorsitzender und Vorstand des RCDS zurückgetreten","Zurückgetreten","","","",[11],2,[1],[2],2,"10","2"],["1784","1968-01-29","Österreichischer Student. Betont zunächst seine Unabhängigkeit (kein \"Springer-Freund\"), und kritisiert dann reformgefährdenden Maßnahmen (linker) Studenten.","Schweigen zu kindischen Amokläufern","","Ein Student über die Studenten","Hermann Strasser",[9],6,[6],[5],2,"48","12"],["1785","1968-01-30","Bericht vom FDP-Parteitag und Dutschkes Auftritt dort, Dutschke wird als \"Star-Revoluzzer\" und unrasierter Mann mit Lederjacke beschrieben, habe seine Masche durchgezogen.","\"Er hinterlässt uns Trümmer\"","","","H. F. Birkenbeul, K. H. Kirchner",[2],6,[1],[1],1,"28","2"],["1786","1968-02-01","200 Studenten belagerten 60 Professoren im Sitzungssaal des Philosophischen Seminars der FU, um Vietnam-Diskussion zu erzwingen","FU-Studenten drehten Professoren das Licht ab","","","hb,kh.",[11],2,[1],[3],2,"8","3"],["1787","1968-02-01","Studenten wollen öffentliche Diskussion mit Professoren über Missstände am Romanischen Seminar mit Gewalt erzwingen.","Studenten traten die Tür ein","FU-Professoren unter Druck. Diskussionen. Tumulte. Sitzstreik","","L.R.",[11],6,[1],[1],1,"32","3"],["1788","1968-02-02","Theologieprofessor Helmut Gollwitzer hält Existenz des SDS für notwendig","Unterstützung für den SDS","keine ","","rb.",[8],2,[1],[2],2,"14","4"],["1789","1968-02-02","FU-Rektor Harndt kritisiert Sit-in scharf, u. a. mit hier zitiertem SA-Vergleich. Kritik auch vom Wissenschaftssenator Stein und dem Demokratischen Club","Kommt es zum offenen Bruch an der Freien Universität?","Scharfe Erklärung des Rektors. Vollversammlung der Studenten.","","L.R.",[11],6,[1],[1],2,"40","4"],["1790","1968-02-02","Rektor und Senator einigen sich auf Vorlesungsabbruch bei Störung","Bei Störung: Schluss der Vorlesung","","","K.B.",[11],6,[1],[2],2,"40","4"],["1791","1968-02-03","Linksradikale werfen Fenster von Morgenpost-Filialen ein. SPD-Justizsenator und das Verlagshaus Axel Springer vergleichen SDS mit SA, es ist die Rede von \"Terror-Studenten\". In einer Karikatur werden die Steinwürfe gegen Springer mit den Pogromen gegen die Juden 1938 verglichen, versehen mit der Zeile \"Wie sich die Bilder gleichen!\"","Terror-Aktion gegen Zeitungs-Filialen","","Justizsenator: \"Das sind faschistische Methoden\"","rb.",[10],2,[1,5,4],[1],1,"14","3"],["1792","1968-02-03","Steinwürfe zerstören die Scheiben mehrerer Ullstein-Filialen. Steine in Enteignet-Springer-Flugblätter gewickelt. Energische Proteste aus Verlag und Politik, die Stellungnahme des Springer-Verlags vergleicht die Aktion mit Handlungen der Nationalsozialisten.","Steine gegen die freie Meinung","","","L.R.",[10],6,[1,5],[4],1,"32","6,7"],["1793","1968-02-03","Reaktionen aus den Parteien zu den Steinwürfen auf Morgenpost-Filialen, alle Parteien verurteilen die Aktionen scharf.","Scharfe Proteste der Parteien","","SPD: Nicht hinnehmen! CDU: Energisch handeln! FDP: Faschistische Methoden!","",[10],6,[1],[2],2,"32","6"],["1794","1968-02-03","FU-VV. Solidarisierung mit Studenten der Phil.-Fak.","Gemäßigte ohne Chancen","","","bow",[11],6,[1],[3],1,"32","7"],["1795","1968-02-03","Mitglieder des Springer-Tribunals hätten Kontrollrecht in der BZ-Redaktion gefordert. Vergleich mit den Zensurmaßnahmen im Dritten Reich und in der DDR. Die Rede ist von SA-Manieren. Dazu eine Karikatur mit der Textzeile \"So können Sie's dann drucken, Sie Redaktionär.\"","SA-Manieren junger Herren","Inspektor sagt:","","Inspektor (Werner Sikorski)",[10],6,[5,4],[1],1,"32","2"],["1796","1968-02-04","Krawalle mit Sachbeschädigungen auf dem Kudamm. Demonstrationen auch in anderen Städten.","Krawalle in Berlin","","500 Jugendliche tobten auf dem Kudamm","Klaus Heine, Chris Strohschön",[1],3,[1],[1],2,"56","2"],["1797","1968-02-04","Kommentar gegen Krawalle in Berlin und die Angriffen auf Morgenpost-Filialen. Wiederholte Frage: \"Was wird gegen diejenigen getan??\". Vergleich mit dem Ende der Weimarer Republik. Nie alle Studenten in einen Topf geworfen, aber Unterscheidung ist nötig. Nicht klar erkennbar, \"wer ein vom Osten herübergeschickter Agitator ist\".","Enteignet Deutschland?","","","",[1],3,[5],[5],2,"56","2"],["1798","1968-02-04","Über den Ablauf eines Angriffs auf die BERLINER MORGENPOST-Filiale Bismarck- Ecke Schlossstraße","Neue Steinwürfe auf Zeitungsfiliale","","","",[10],9,[1],[2],2,"36","9"],["1799","1968-02-04","Ausschreitungen nach ursprünglich friedlicher und genehmigter Demonstration vor der griechischen Militärmission. Personen- und Sachschäden.","Schwere Krawalle auf dem Ku'damm","","City stundenlang blockiert. Acht Verletzte - 24 Festnahmen","Kajo",[1],9,[1],[1],1,"36","1"],["1800","1968-02-04","\"Blutverschmierte Gesichter, Großeinsatz für Sanitäter, regelrechte Kämpfe um rote Fahnen, Prügeleien mit zerfetzten Transparenten - das war am Sonnabend mehr als nur eine stundenlange Wasserschlacht um den Kurfürstendamm?\" Beschreibung der Vorgänge. ","Die \"Schlacht\" um den Kurfürstendamm","","","Leo Leu",[1],9,[1],[1],1,"36","9"],["1801","1968-02-05","In einer Erklärung fordert die Bild-Redaktion Maßnahmen gegen diejenigen, die zu Anschlägen aufrufen und erinnert an den Untergang der Weimarer Republik. Uni-Reform seien notwendig, aber berechtigten nicht zu Gewalt. Es ginge nicht um Springer oder den Verlag, sondern um Deutschland: aus \"Enteignet Springer\" würde bald \"Enteignet Deutschland\" werden. Nähe der Demonstranten zur DDR wird suggeriert.","Enteignet Deutschland?","","","",[10],2,[5],[3],1,"12","1"],["1802","1968-02-05","Demo mit Teufel und Kunzelmann richtet Chaos auf Ku'damm an.","Mit Fußtritten Autoscheibe zertrümmert","","Randalierer legen den Kurfürstendamm lahm","dae., hb",[1],2,[1],[5],1,"12","4"],["1803","1968-02-05","Regierender Klaus Schütz will \"Amok\" laufende Studenten hart bestrafen. Dazu eine Karikatur, in der \"linksradikale Randalierer\" mit Knüppeln in den Händen den Zugang zum Kurfürstendamm kontrollieren.","Amokläufer bestrafen!","Klaus Schütz nach der Amerikareise: \"Gesetze nicht nur auf dem Papier\"","","k.h.",[1],2,[1,4,5],[1],1,"12","4"],["1804","1968-02-06","1.000 Anhänger radikaler Studentengruppen lieferten sich in Frankfurt eine Straßenschlacht mit der Polizei und richteten Schäden an. Auch Rudi Dutschke habe sich daran beteiligt und sei kurzzeitig festgenommen worden.","Randalierer tobten in Frankfurt","","Scheiben zertrümmert. Autos demoliert. Fahne verbrannt","ner/jf/fi.",[1],2,[1],[5],2,"8","1"],["1805","1968-02-05","Hilfeaufruf bei Suche nach Steinwerfern","Wer sah die Steinwerfer?","3000 Mark Belohnung","","",[10],6,[5],[5],2,"44","3"],["1806","1968-02-05","Hinweis auf Bericht im Blatt","Armes Berlin, soll das so weitergehen?","","","",[1],6,[5],[5],1,"44","1"],["1807","1968-02-05","Reaktion des Bürgermeisters auf Ku'damm-Krawalle und Ullstein-Angriffe.","\"Es geht um den Ruf der Stadt!\"","Schütz kündigt schafe Reaktion an","","K.B.",[1],6,[1],[3],2,"44","2"],["1808","1968-02-05","Bildbericht vom Krawall am Wochenende","Armes Berlin - soll das so weitergehen?","","","L.R.",[1],6,[7,5],[4],1,"44","4,5"],["1809","1968-02-05","Stellt die Frage nach \"angemessenen Mitteln\", ohne sie direkt zu beantworten.","?was sind angemessene Mittel","","","Peer",[1],6,[5],[5],2,"44","4"],["1810","1968-02-05","Bericht über ein Treffen linker Gruppen, u.a. des SDS.","Sie küssten und sie stritten sich","Die Linke konnte die Hürde der Gemeinsamkeit nicht nehmen","","Hans F. Birkenbeul",[9],6,[1],[1],1,"44","2"],["1811","1968-02-05","BZ wartet auf die angekündigten Zensoren","BZ wartet?","","","k",[10],6,[2],[2],2,"44","3"],["1812","1968-02-06","Berliner Gewerkschaft ÖTV fordert konsequenteres Eingreifen der Polizei gegen \"politische Rowdys\".","Gewerkschaft: Es geht um unsere Stadt!","","Immer mehr Stimmen gegen Terror-Aktionen","jo.",[10],2,[1],[1],1,"8","2"],["1813","1968-02-06","Brief von SPD-Senator Adolph Arndt an Axel Springer. Arndt spricht von roten Faschisten und vergleicht die Steinwürfe auf Morgenpost-Filialen mit dem Nationalsozialismus.","\"Empörung und Abscheu?\"","","","",[10],6,[1],[2],2,"24","2"],["1814","1968-02-06","Demo mit Auschreitungen in Frankfurt. Teilnehmer u. a. Dutschke","Krawalle in Frankfurt","","","",[1],6,[1],[2],2,"24","2"],["1815","1968-02-06","Forderung von Ruhe durch ÖTV, auch der ÖTV vergleicht die Steinwürfe auf Morgenpost-Filialen mit der \"Reichskristallnacht\".","\"Schluss mit der Unordnung!\"","","","",[1],6,[1],[2],2,"24","2"],["1816","1968-02-06","Teils heftige Reaktionen gegen Krawalle und Filial-Angriffe","Armes Berlin?","BZ-Leser zum Thema","","Leser",[1],6,[6],[4],2,"24","7"],["1817","1968-02-06","Hinweis auf Bericht im Blatt, die Berliner Öffentlichkeit fordere angesichts der jüngsten Studentenunruhen, dass nun Schluss mit Gewalt und Terror sei.","Schluss mit Terror und Krawall","Berliner fordern:","Schütz will hart durchgreifen","",[1],6,[1],[1],2,"24","1"],["1818","1968-02-06","Schütz' Ankündigung von Plänen und Maßnahmen zur Befriedung der Universitäten. TU-Rektor Wechselberg widerruft Nutzungsgenehmigung des Audimax für Springer-Hearing.","Schütz will es jetzt wissen?","","Der \"Regierende\" kündigte gestern an: Universitäten sollen durch Gesetz von Krawallmachern gesäubert werden","Klaus Bär",[9],6,[1],[1],1,"24","2"],["1819","1968-02-06","Scharfe Reaktion des Regierenden Bürgermeisterrs Schütz auf Krawalle und Ullstein-Filialen-Angriffe. \"?die Lagen an den Universitäten lassen es offenbar zu, dass politische Veranstaltungen im Universitätsrahmen zu kriminellen Akten missbraucht würden.\" Reaktionen anderer Personen und Gruppierungen. SHB nennt Ullstein-Angriffe als \"mit dem Kampf für demokratische Freiheiten unvereinbar.\"Der Republikanische Klub lehnt sie ab, weil sie die \"Legitimität der Aufklärungskampagne und der Enteignungsforderung (gegen Springer) ... diskreditieren\".","Schütz: Scharfe Maßnahmen gegen kriminelle Übergriffe","","","pf, dpa",[1],9,[1],[1],1,"12","1,2"],["1820","1968-02-07","Erklärung der Bild-Redaktion zu den Aktionen linker Studenten. Aufruf an Politik und Justiz, den \"Terror der Jung-Roten\" zu stoppen. \"Man darf über das, was zur Zeit geschieht, nicht einfach zur Tagesordnung übergehen. Und man darf auch nicht die ganze Dreckarbeit der Polizei und ihren Wasserwerfern überlassen. Schlafen unsere Richter? Schlafen unsere Politiker?\"","Stoppt den Terror der Jung-Roten jetzt!","","","",[10],2,[5],[3],1,"10","1"],["1821","1968-02-07","Berlins Inensenator kündigt härteres Vorgehen gegen Randalierer an","Polizei soll bei Krawallen nicht \"spazierengehen\"","Innensenator Neubauer: Demonstranten werden eingekesselt","","Jürgen Oster",[1],2,[1],[1],1,"10","2"],["1822","1968-02-07","Studenten dringen in Amtszimmer des Bonner Uni-Rektors ein und beschmieren Goldenes Buch","Linksradikale Studenten","","","",[11],2,[1],[2],2,"10","7"],["1823","1968-02-07","Polizeigewerkschaft zu den Krawallen und ihren Folgen","\"Bevölkerung versteht das nicht!\"","","","dpa",[1],6,[1],[2],2,"28","2"],["1824","1968-02-07","Reaktionen in Bonn; Strafanzeige gegen Dutschke wegen Frankfurter Demo; Gästebuch der Bonner Uni von Studenten verunstaltet: Unter Lübke-Unterschrift \"KZ-Baumeister\" geschrieben.","\"Entschiedene Gegenwehr nötig\"","","Innenminister warnt. Parlament greift ein","P.R.",[1],6,[1],[3],2,"28","2"],["1825","1968-02-07","Ankündigung, Veranstaltungen künftig zu untersagen, bei denen Gefahr besteht, dass zu kriminellen Handlungen aufgerufen wird. \"Dementsprechend\" werden dem Springer-Hearing keine FU-Räume zur Verfügung gestellt.","Kommt es in Berlin zu einer Kraftprobe?","Harte Haltung des Senats. Vorwürfe gegen Senator Stein","","Klaus Bär",[9],6,[1],[1],2,"28","2"],["1826","1968-02-07","Rektoren von TU und FU teilen mit, dass sie weder für eine Vollversammlung der KU noch für die geplanten Springer-Hearings Räume zur Verfügung stellen werden, da die Gefahr besteht, dass zumindest mittelbar kriminelle Handlungen von solchen Veranstaltungen ausgehen könnten. Verschiedene Reaktionen. Innensenator hinsichtlich Behandlung der beantragten Vietnam-Demo noch unentschieden.","Notfalls Polizeischutz für Universitäten","","","pf",[10],9,[1],[5],2,"12","1,2"],["1827","1968-02-08","Bundesinnenminister Lücke will linken und rechten \"Terror\" mit allen Kräften bekämpfen. Der deutsche Gewerkschaftsbund protestiert gegen \"SA-Methoden\" der Demonstranten.","Demokratie muß sich wehren","Lücke zu den Krawallen:","","mk/dhs",[1],2,[1],[2],2,"12","1"],["1828","1968-02-08","CDU setzt in Dringlichkeitsantrag Beratung im Abgeordnetenhaus durch, um SDS verbieten zu lassen.","CDU fordert: Der Senat soll den SDS verbieten","","Heute Beratung im Abgeordnetenhaus","jo.",[8],2,[1],[1],1,"12","2"],["1829","1968-02-08","Hinweis auf Bericht im Blatt","Protestmarsch zum Rathaus verboten","","Studenten riefen trotzdem auf","",[1],6,[1],[3],2,"32","1"],["1830","1968-02-08","Nichtzurverfügungstellung von Räumen für Studenten in FU und TU. Versammlungen finden auf Fluren und in Treppenhäusern statt. Kuby rät Studenten, aus Berlin fortzugehen. Großer Teil der Studentenvertreter spricht sich für Gewaltlosigkeit aus.","TU: Tausend Studenten tagten im Treppenhaus","","","",[1],6,[1],[1],1,"32","4"],["1831","1968-02-08","Polizeigewerkschaft fordert Bürger zur Unterstützung gegen antidemokratische Gruppen auf.","Polizei unterstützen!","","","",[1],6,[1],[2],2,"32","4"],["1832","1968-02-08","Die Falken rufen die Jugend zur Teilnahme an Studenten-Demos auf.","Appell an die \"kritische Jugend\"","","","",[1],6,[1],[2],2,"32","4"],["1833","1968-02-08","Reaktionen gegen Krawalle und Filial-Angriffe","Armes Berlin?","BZ-Leser schreiben zum Thema","","Leser",[1],6,[6],[5],2,"32","7"],["1834","1968-02-08","Studentenvertretung des Romanischen Seminars abgewählt, Absage an radikale Kräfte.","Abgewählt","","","",[11],6,[1],[2],2,"32","4"],["1835","1968-02-08","Demokratischer Club spricht sich gegen Vietnam-Demo aus","Gegenaktionen der Berliner?","","","",[1],6,[1],[2],2,"32","4"],["1836","1968-02-09","Debatte über die Studentenunruhen im Abgeordnetenhaus. SPD-Innensenator schließt SDS-Verbot aus.","CDU-Chef Amrehn: Wer jetzt nicht handelt, macht sich schuldig","","Parlamentsdebatte über Krawalle","Jürgen Oster",[1],2,[1],[1],1,"12","2"],["1837","1968-02-09","SDS-Mitglied Peter Gäng habe vor 1000 Studenten geäußert, es wäre richtig, wenn die Arbeiterschaft den Verrat der Springer-Zeitungen erkennen und ein Springer Gebäude niederbrennen würde.","Er wünscht sich einen Brand?","","","",[10],6,[1],[2],2,"40","2"],["1838","1968-02-09","Hinweis auf Bericht im Blatt","Die Berliner haben mehr erwartet","Trauriger Parteienstreit um innere Ordnung","","",[1],6,[5],[1],2,"40","1"],["1839","1968-02-09","Kritik an der Debatte im Berliner Abgeordnetenhaus über die jüngsten Studentenunruhen: \"Tiefpunkt der Berliner Parlamentsgeschichte\", \"Kleinlicher Parteienstreit\", Zitate von Politikern, die diese Unruhen verurteilen.","Fragen - aber leider keine Antworten","Parlament diskutierte: Die innere Ordnung Berlins","","Klaus Bär",[1],6,[1,5],[1],1,"40","2"],["1840","1968-02-09","Schütz' Äußerungen in der Debatte","SDS-Verbot nicht möglich","","","",[1],6,[1],[2],2,"40","2"],["1841","1968-02-09","Dank an Polizei; keine billige Polemik, sondern Zusammenarbeit","SPD dankt Berliner Polizei für Einsatz","","","",[1],6,[1],[2],2,"40","2"],["1842","1968-02-09","Amrehns Beiträge in der Debatte","\"Macht ein Ende\"","Parlament diskutierte: Die innere Ordnung Berlins","CDU-Chef Amrehn fordert energische Schritte gegen Straftäter und Anführer von Krawallen","",[1],6,[1],[1],1,"40","3"],["1843","1968-02-10","Springer-Hearing im Ernst-Reuter-Haus fand nicht statt.","Studenten wurden \"enttäuscht\"","","","",[10],2,[1],[2],2,"8","2"],["1844","1968-02-10","Bei Vietnam-Demo in Hamburg auch Aktion gegen Auslieferung von Springer-Zeitungen","Krawall in Hamburg ? BILD-Fahrer verletzt","","","",[10],2,[1],[2],2,"8","6"],["1845","1968-02-10","U. a. Helmut Schmidt, der fordert, den Feinden der Demokratie auch persönlich entgegenzutreten.","Schmidt: \"Zeigt mehr Zivilcourage\"","Bundestag zu Studenten-Unruhen: Scharfe Ablehnung krimineller Gewaltakte","","P.R.",[1],6,[1],[1],2,"28","2"],["1846","1968-02-10","TU-AStA-Chef Wethekam sagt Hearing von 2000 Zuhörern ab","\"Hearing\" wurde abgesagt","","","",[10],6,[1],[5],1,"28","4"],["1847","1968-02-10","Über das geplante \"Springer-Hearing\". Niemand bestreitet Recht, Hearing abzuhalten; bei diesem Tribunal stände das Urteil aber schon vorher fest: Enteignet Springer; dies sei ein Mißbrauch des Rechts und der \"erste massive Versuch, die im Grundgesetz verankerte Freiheit der Presse anzutasten.\" Dies würde sich auf alle Zeitungen, die \"sich der geplanten Zerstörung unserer rechtsstaatlichen Grundordnung widersetzen\", ausweiten.","Urteil vor dem Prozess","","","Peer",[10],6,[5],[5],2,"28","4"],["1848","1968-02-11","13 Leserbriefe einhellig gegen Krawalle, insbesondere auch gegen Dutschke.","\"Demokratie an 'Grippe' erkrankt\"","","","Leser",[1],3,[6],[5],2,"56","27"],["1849","1968-02-12","Schütz auf dem SPD-Parteitag zu den Studentenunruhen und der APO. Diese Leute seien nur durch Zufall 'links'. Sie könnten genausogut rechts stehen. \"Ihr müsst diese Typen sehen. Ihr müsst ihnen genau ins Gesicht sehen. Dann wisst ihr, denen geht es nur darum, unsere freiheitliche Grundordnung zu zerstören.\"","\"Seht euch doch diese Typen an!\"","","Klaus Schütz auf dem SPD-Parteitag: Nicht länger debattieren - jetzt handeln!","Klaus Bär",[1],6,[1],[1],2,"44","2"],["1850","1968-02-12","Kommentar in der BZ, dass gestern das von Studenten an den Springer-Verlag gestellte Ultimatum abgelaufen sei, wonach die BZ studentischen \"Zensoren\" ein Kontrollrecht einräumen sollte.","\"Ultimatum\" abgelaufen","","","",[10],6,[2],[2],2,"44","3"],["1851","1968-02-14","Im studentischen FU-Spiegel wurde über die Behinderung des Regierenden Bürgermeisters Schütz berichtet. U. a. heisst es dort, er habe seinen Arm wegen \"Feigheit vor dem Feind\" verloren, zudem weitere Beleidigungen gegenüber Schütz. FU-Rektor Harndt spricht in diesem Zusammenhang von \"Methoden der Goebbels-Presse\" und \"gemeinster Pöbelei\", im Artikel ist vom \"Kloakenstil\" die Rede, Schütz will Strafanzeige gegen die Verantwortlichen des FU-Spiegels stellen.","\"FU-Spiegel\" warf mit Dreck","Der \"Regierende\" will sich gegen Beleidiger wehren","","ski, bow",[11],6,[1],[1],2,"32","2"],["1852","1968-02-14","SDS-Einschätzung von René Ahlberg vor Parlamentarischen Untersuchungsausschuss, dieser sei antidemokratisch.","\"Der SDS bekannt sich zu Gewalt\"","","","dpa",[8],6,[1],[2],1,"32","2"],["1853","1968-02-14","Kraftprobe befürchtet","Verbot bleibt!","","Keine Vietnam-Demonstration in Berlin","P.R.",[1],6,[1],[2],2,"32","4"],["1854","1968-02-15","Dutschke-Karikatur, umringt von Kommilitonen kommentiert mit: \"Als ich vor Jahren als unbekannter Student...\" (Möglicherweise Anspielung auf Hitler). Auf dem Gürtel Dutschkes steht SDS, geschrieben mit SS-Runen. ","\"Als ich vor Jahren als unbekannter Student ...\"","","","",[2],6,[5,4],[2],1,"28","2"],["1855","1968-02-16","Schütz' Beleidigungsklage gegen Redakteure des FU-Spiegels","Die Klage läuft","","","",[11],6,[1],[2],2,"40","2"],["1856","1968-02-16","Dritte Beantragung einer Demo. Alliierte zeigen sich beunruhigt. Flugblätter laden zur Teilnahme ein. Nutzung von TU-Räumen genehmigt.","Neuer Antrag auf Demonstration","Vietnam-Kongress gibt nicht auf","","L.R.",[1],6,[1],[1],1,"40","3"],["1857","1968-02-17","Hinweis auf Bericht im Blatt","Klaus Schütz: \"Übt keine Selbstjustiz!\"","Berlin vor einem heißen Wochenende","Vietnam-Kongress: Demonstration bleibt - trotz Verbot. Gewerkschaftsbund Berlin: Polizei muss Rechtsstaat schützen. Landesverband der SPD: Bevölkerung soll sich fernhalten","",[1],6,[1],[4],2,"36","1"],["1858","1968-02-17","siehe Unterzeilen. Peter Brandt unter den vorübergehend festgenommenen Flugblattverteilern.","Erste Zwischenfälle","","Die Bevölkerung ist über Flugblattverteiler empört. Vermittlungsversuche der evangelischen Kirche gescheitert.","L.R.",[1],6,[1],[1],2,"36","3"],["1859","1968-02-17","1500 westdeutsche Kongressteilnehmer sollen in Helmstedt bevorzugt abgefertigt und von Transitgebühren befreit werden.","Zahlen keine Gebühren","","","mz",[1],6,[1],[2],2,"36","3"],["1860","1968-02-17","Landesausschuss: Dem Vietnam-Kongress ? geht es um konsequente Verforgung antidemokratischer Ziele.","SPD hinter dem Senat","","Entschließung des Landesausschusses","B.",[1],6,[1],[2],2,"36","3"],["1861","1968-02-17","Erläuterung des Berliner Versammlungsgesetzes von 1950.","Entspricht der Verfassung","","","",[1],6,[1],[2],2,"36","3"],["1862","1968-02-17","Sammelmeldung zu US-Sympatieadresse aus OSI, zu einer Warnung Neubauers und zu AStA, der Stadtkommandanten beschuldigt, Konfrontation zu suchen.","Gute Freunde. Warnung. Beschuldigt.","","","",[1],6,[1],[3],2,"36","3"],["1863","1968-02-17","Beschwörender Appell an alle Berliner, sich nicht an illegalen Demos zu beteiligen und keine Selbstjustiz zu üben. \"Helfen Sie mit, Straftäter festzustellen, die Unsicherheit und Unordnung in die Stadt tragen wollen.\"","Klaus Schütz: \"Übt keine Selbstjustiz!\"","","","Klaus Bär",[1],6,[1],[1],1,"36","4"],["1864","1968-02-17","Demonstranten tragen Verantwortung für Folgen zu erwartender Gewalt. An die Staatsgewalt gerichtet: \"Aber wir müssen in letzter Stunde noch einmal dringend davor warnen, Härte mit Brutalität zu verwechseln, Verhältnismäßigkeit der Mittel in Gesetzlosigkeit ausarten zu lassen.\"","Sie tragen die Verantwortung","","","Peer",[1],6,[5],[5],2,"36","4"],["1865","1968-02-17","Antragsteller u. a. SDS und Evangelische Studentengemeinde","Vierter Antrag auf eine Demonstration","","","",[1],6,[1],[2],2,"36","4"],["1866","1968-02-17","Umfrage zum \"Engagement der Amerikaner in Vietnam\"","Vietnam-Umfrage in Deutschland","","","red",[1],6,[1],[2],2,"36","4"],["1867","1968-02-17","Demokratischer Club fordert zum Fernbleiben von der Demo auf","Flugblatt-Aktion","","","",[1],6,[1],[2],2,"36","4"],["1868","1968-02-17","Illegale Demonstranten können sich nicht auf Widerstandsrecht berufen.","Kein Recht auf Widerstand","","","",[1],6,[1],[2],2,"36","4"],["1869","1968-02-17","Berliner DGB stellt sich hinter Senat. Wortführer der illegalen Demo wollen \"in übler Weise unsere Rechtsstaatlichkeit beseitigen\".","DGB: Nicht vor den Karren der Demagogen","","","K.B.",[1],6,[1],[1],1,"36","5"],["1870","1968-02-18","Sechs US-kritische Leserstimmen zu Vietnam. Absage an Gewalt bei Demos.","\"Kritik - ja! Steine und Eier - nein!\"","","Briefe - Hier kann jeder seine Meinung sagen","Leser",[1],3,[6],[1],2,"56","27"],["1871","1968-02-18","300 Teilnehmer auf SDS-Einladung in TU. Dutschke Redner. Polizei erwartet \"heißen Sonntag\".","Kongress unter Vietcong-Fahne","Teilnehmer fuhren ohne Gebühren durch die Zone","","",[1],3,[1],[1],2,"56","3"],["1872","1968-02-18","Es wird eine Demo gegen den Krieg in Vietnam geben. Jeder vernünftige Mensch ist gegen Krieg. Dutschke und Co ist das aber nur Vorwand, um antiamerikanisches Propagandakapital herauszuschlagen.","Zweierlei Maß","","","",[1],3,[5],[5],1,"56","3"],["1873","1968-02-19","Hinweis auf Bericht im Blatt","Das war den Berlinern zuviel!","","Spontane Gegen-Demonstrationen. Arbeiter verbrannten rote Fahnen. Polizei musste SDS-Haus schützen","",[1],6,[8],[4],1,"40","1"],["1874","1968-02-19","Kritik an den Richtern des Verwaltungsgerichts wegen Zulassung der Vietnam-Demo.","Wie weit ist ein Gewissen?","","","Peer",[1],6,[5],[2],2,"40","2"],["1875","1968-02-19","Flapsiges Stimmungsbild vom Vietnam-Kongress","Mit Rucksack und Gepäck zum \"Kongress\"","","","",[1],6,[7,5],[3],1,"40","2"],["1876","1968-02-19","Reportage von der Demonstration und den spontanen Gegendemonstrationen","Absage an die Radikalen","","","L.R.",[1],6,[7,5],[4],1,"40","3,4"],["1877","1968-02-19","RA Dieter Prelingers Versuch, auf dem Rednerpult den Vietnam-Kongress zu kritisieren und beenden.","Einer gegen 3000","Berliner Rechtsanwalt protestierte gegen Vietnam-Kongreß","","red",[1],6,[1],[1],1,"40","4"],["1878","1968-02-19","Fotostrecke der Demo und von Gegendemonstrationen","Das war den Berlinern zuviel!","","Demonstration und Gegendemonstration - trotzdem diszipliniert","L.R.",[1],6,[1],[4],1,"40","20,21"],["1879","1968-02-19","Senat und Parteien laden zu Gegendemo ein. Gewerkschaften sollen mitmachen. Arbeitgeber sollen arbeitsfrei geben. Vietnam-Demo war von Verwaltungsgericht erlaubt worden.","Berlin wird ihnen eine Antwort geben","Große Gegenkundgebung in unserer Stadt gepant","","P.R.",[1],6,[1],[1],2,"40","2"],["1880","1968-02-20","Demonstrationsaufruf","Ganz Berlin ist aufgerufen!","Morgen heißt es Farbe bekennen","Massenkundgebung auf dem Kennedy-Platz","",[1],6,[5],[1],2,"28","1"],["1881","1968-02-20","Demonstrationsaufruf der \"Aktion Demokratisches Berlin\" mit Unterschriftenliste","\"Wir wollen sagen, wofür wir sind!\"","Berlin steht für Freiheit und Frieden","","",[1],6,[5],[4],2,"28","4"],["1882","1968-02-20","Kritik an der Bewertung der Gegendemonstrationen durch den Republikanischen Club, deren Funktionäre seien gelehrige Schüler der Zonenpropagandisten.","Alles wie gehabt","","","Peer",[1],6,[5],[5],2,"28","5"],["1883","1968-02-21","Demonstrationsaufruf, Hinweis auf Texte im Heft","Berlinerinnen und Berliner","","","",[1],6,[5],[1],2,"32","1"],["1884","1968-02-21","Demonstrationsaufruf. Bedeutung der Freiheit. Vergleich mit 1933. Warnung vor Erstarken der Rechten.","Inspektor sagt: Das muss jeder selber tun!","","","Inspektor (Werner Sikorski)",[1],6,[5],[1],1,"32","2"],["1885","1968-02-21","FDP-Streit, weil Borm als Mitglied des Republikanischen Clubs zur Senatsdemo aufgerufen hat.","Krach um den Berliner FDP-Chef William Borm","","","K.B.",[1],6,[1],[2],2,"32","2"],["1886","1968-02-21","Über den geplanten Ablauf der Demo. Tipps zur Beurlaubung.","Freiheitsglocke läutet um 16 Uhr 30","Berlin steht für Freiheit und Frieden","","K.B.",[1],6,[5],[1],2,"32","6"],["1887","1968-02-21","Solidarisieren sich mit den Anliegen der Senatsdemo","Studenten schreiben einen offenen Brief","","","Ingo Fiebiger, Lutz Bewig, Peter Göpelt",[1],6,[6],[2],2,"32","6"],["1888","1968-02-21","Tipps für Verkehrsverbindungen zur Demo","Die BVG setzt Sonderbusse ein","","","",[1],6,[1],[2],2,"32","6"],["1889","1968-02-21","Jusos und JU bedauern Absage der Jungdemokraten ","Auch die Jugend Berlins ruft zum Rathaus","","","",[1],6,[1],[3],2,"32","6"],["1890","1968-02-21","Tipps der Polizei zur Anfahrt etc.","Verkehr wird umgeleitet","Berlin steht für Freiheit und Frieden","","",[1],6,[1],[1],2,"32","7"],["1891","1968-02-21","Parallelziehung zur Reuterkundgebung 1948","Das ist erst 20 Jahre her","","","",[1],6,[5],[3],1,"32","7"],["1892","1968-02-21","Ordnungsgelder für Dutschke u. a. wegen Aussageverweigerung vor dem Parlamentarischen Untersuchungsausschuss. Dutschke nennt Wohlrabe einen \"exemplarischen Faschisten\". ","Teurer Tag für Rudi Dutschke","","","bow",[1,2,8],6,[1],[2],2,"32","4"],["1893","1968-02-21","Innerparteiliche Kritik an Vietnam-Demo-Teilnehmern der SPD","SPD: Gibt es eine Urabstimmung?","Erregung über die \"linken\" Funktionäre","","Klaus Bär",[1],6,[1],[5],2,"32","2"],["1894","1968-02-21","Kritische Leserbriefe gegen die die Vietnamdemo, sowie ein Leserbrief gegen die \"chronische Verlogenheit und Manipulation\" der BZ-Berichterstattung","Vietnam-Demonstration","BZ-Leser schreiben zum Thema","","Leser",[1],6,[6],[1],2,"32","5"],["1895","1968-02-22","Stichworte zum Ablauf, Hinweis auf Texte im Blatt","Das war die Antwort der Berliner","150000 auf dem Kennedy-Platz","","",[1],6,[1],[4],1,"32","1"],["1896","1968-02-22","Zitate aus den Reden von Schütz, Grimming, Sickert, Amrehn und Mattik","\"Schluss jetzt mit dem Rüpelspiel!\"","Berlin steht für Freiheit und Frieden","","Klaus Bär",[1],6,[1],[4],1,"32","2"],["1897","1968-02-22","Lob für die Teilnehmer der Demo, Kritik an einigen Transparenten, insbesondere an dem, das Dutschke zum \"Volksfeind Nummer 1\" erklärt. Das sei ein Unding.","BZ meint: Hass den Radikalen überlassen!","","","",[1],6,[5],[2],2,"32","2"],["1898","1968-02-22","Eindrücke von der Demo. Erwähnung des Transparents \"Dutschke raus aus West-Berlin\".","150000 kamen!","Berlin steht für Freiheit und Frieden","","mz",[1],6,[7],[1],1,"32","3"],["1899","1968-02-22","Begründung (Borm) und Zitat aus ungehaltener Hoppe-Rede","FDP war nicht vertreten","","","",[1],6,[1],[2],2,"32","3"],["1900","1968-02-22","Zitate aus Stellungnahmen des Republikanischen Clubs und von Danelius zur Großkundgebung des Berliner Senats, die Stellungnahmen würden sich völlig gleichen.","So sehen's die anderen","","SED und Republikanischer Club sind sich einig","P.R.",[1],6,[5],[5],2,"32","3"],["1901","1968-02-22","Vergleich zur 48er Kundgebung mit Reuter","Als hätte Ernst Reuter gerufen?","Berlin steht für Freiheit und Frieden","","",[1],6,[5],[4],1,"32","16,17"],["1902","1968-02-22","Kritik an Ausschreitungen, unter der die Würde der Veranstaltung gelitten habe","Auch solche Szenen gab es leider wieder","","","",[1],6,[5],[4],1,"32","32"],["1903","1968-02-23","Lob der Unruhe unter den Studenten, nicht die Unruhe der Radikalen. Berechtigtes Anliegen der Reform der Universitäten.","Jetzt müssen Taten folgen!","","","Peer",[1],6,[5],[5],2,"36","2"],["1904","1968-03-05","Bericht über erste Sitzung des Gerichts in Moabit gegen Rainer Langhans und Fritz Teufel im Stil einer Theaterkritik ","\"Kasperle-Theater\" in Moabit","","","k.a.",[5],2,[1],[2],1,"12","4"],["1905","1968-03-05","Bericht vom ersten Verhandlungstag im Prozess wegen Aufforderung zur menschengefährdenden Brandstiftung","Fritz Teufel verweigerte die Aussage","","","Nic.",[5],6,[7],[3],2,"28","4"],["1906","1968-03-08","Bericht vom zweiten Verhandlungstag","Ordnungsstrafen für die Kommunarden","","","Nic.",[5],6,[7],[3],2,"40","4"],["1907","1968-03-10","VDS droht Austrittswelle von Mitgliedern wegen Radikalisierung","Keine Einheitsfront an den Unis","","","",[11],3,[1],[2],2,"64","6"],["1908","1968-03-11","Angedrohte VDS-Austritte wegen Politisierung des Verbandes","Uneinige Studenten","","","UPI, dpa",[11],6,[1],[2],2,"44","2"],["1909","1968-03-12","Bericht vom Verhandlungstag","4 Tage Haft für Teufel","","","Nic.",[5],6,[7],[2],2,"28","4"],["1910","1968-03-15","Aussage von drei Professoren zu Flugblättern, die zum Brandanschlag auffordern: Diese sind nicht wörtlich zu nehmen, sondern literrarisch zu verstehen. ","Flugblätter sind nicht wörtlich zu nehmen","","","rb",[5],2,[1],[2],1,"18","4"],["1911","1968-03-13","Meinungskämpfe an Universitäten könnten Haltbarkeit des neuen Gesetztes unterwandern","Ungünstiger Zeitpunkt für Uni-Gesetz","","","jo",[11],2,[1],[2],2,"9","2"],["1912","1968-03-15","Bericht vom Verhandlungstag","Nur Satire?","","","",[5],6,[7],[2],2,"44","3"],["1913","1968-03-17","Minister Stoltenberg fordert Studenten auf, sich gegen Radikalität zu entscheiden.","Studenten müssen sich entscheiden","","","",[1],3,[1],[2],2,"56","9"],["1914","1968-03-18","Krawalle in Nürnberg, Angriff gegen Wehner und Brandt, Säureattentat","Radikale prügeln Wehner und Brandt","","Fortsetzung von Seite 1","k.a. ",[1],2,[1],[2],1,"16","9"],["1915","1968-03-19","Bericht vom Verhandlungstag mit Gutachteranhörung","Psychiater: \"Abnormale Persönlichkeiten\"","","","Nic.",[5],6,[7],[5],2,"36","3"],["1916","1968-03-20","Studentenunruhen verringern Bereitschaft, Studenten in Betriebe einzuladen","Sind Studenten unwillkommen?","","","",[9],6,[1],[2],2,"32","6"],["1917","1968-03-21","Bericht vom Verhandlungstag","Teufel-Prozess bald zu Ende","","","",[5],6,[7],[2],2,"36","4"],["1918","1968-03-22","Schlussplädoyers der Anklage und der Verteidigung, erneute Anklage gegen Teufel wegen Hausfriedensbruches vor dem Rathaus in Schöneberg  ","Neue Anklage gegen Teufel","","","rb",[5],2,[1],[2],2,"10","3"],["1919","1968-03-22","Bericht vom Verhandlungstag, Strafantrag des Staatsanwalts","Gefängnis für Kommunarden?","","","",[5],6,[7],[2],2,"40","3"],["1920","1968-03-23","Bericht von der Urteilsverkündung","Freispruch auf der ganzen Linie","","","",[5],6,[7],[2],2,"32","3"],["1922","1968-03-25","Ausschreitungen nach genehmigter und disziplinierten Demo","Demonstranten festgenommen","","","",[1],6,[1],[2],2,"48","3"],["1923","1968-03-29","Kunzelmann zu Geldstrafe verurteilt","Kommunarde verurteilt","","","",[11],6,[1],[2],2,"44","3"],["1924","1968-03-29","Dieter Kuntelmann wurde zu einer Strafe von 250 Mark verurteilt, weil er trotz Hausverbotes zur FU gekommen war und einen Vortrag von Außenminister Brand gestört hat.   ","Kommunarde Kunzelmann muss blechen","","","rb",[5],2,[1],[2],2,"14","4"],["1925","1968-04-01","An Beispielen verschiedener Studenten-Ehepaare ( Krippendorf, Schlotterer, Nevermann) wird erzählt, dass die Institution Ehe in den \"radikalen\" Studentenkreisen genauso gelebt wird wie in konservativen Kreisen. Die Freizügigkeit der Kommune 1 gehört nach Aussage der BILD eher zur Ausnahme. ","Vor dem Ehebett macht die Revolution halt?","Auch radikale Studenten lieben bürgerlich","","Ulrich Leisner",[9],2,[7],[1],1,"18","5"],["1926","1968-04-01","Bonner SDS will Berliner SDS aus Verband werfen, weil Dutschke mit Geldablehnung aus kommunistischen Ländern \"politisches Denuntiantentum\" begangen habe.","SDSler sind sauer","","","dpa",[8],6,[1],[2],2,"48","2"],["1927","1968-04-02","SDS will nicht an Bundestagswahlen teilnehmen, sondern weiter gegen Parlamentarismus kämpfen","SDS will nicht","","","dpa,UPI",[8],6,[1],[2],2,"36","2"],["1928","1968-04-04","\"Aktion für Menschenrechte\" protestierte gegen Einladung Dutschkes an Zürcher Uni.","Unerwünscht","","","dpa",[2],6,[1],[2],2,"44","11"],["1929","1968-04-06","Vier Verdächtige werden in Zusammenhang mit den Bränden der Warenhäusern in Berlin festgenommen. Kurze Biografie der Verhafteten, warum in Frankfurt gewesen, Funde der Polizei.","Drei Berliner die Bombenleger von Frankfurt?","","Warenhaus-Brände: Vier Verdächtige verhaftet","Klaus Nath",[9],2,[1],[2],1,"10","10"],["1930","1968-04-10","Frankfurter Kripo ermittelt gegen die vermutlichen Frankfurter Kaufhausbrandstifter Ensslin, Proll und Baader nun auch wegen Brandanschlags im Berliner Kriminalgericht am 6. März 68","\"Generalprobe\" in Berlin?","Verdacht gegen die vermutlichen Frankfurter Brandstifter erweitert","","L.R.",[9],6,[1],[1],1,"48","4"],["1931","1968-04-11","Demonstranten erzwingen Unterbrechung einer Theatervorführung","Krawall bei \"Faust\"","","","",[1],6,[1],[2],2,"36","36"],["1932","1968-04-13","Schadensauflistung ","250000 DM Schaden","Terror nach dem Attentat ","","rb",[2,1,10],2,[1],[2],1,"14","6"],["1933","1968-04-13","Appell des Regierenden Bürgermeisters Schütz an die Berliner Bevölkerung nach dem Attentat auf Rudi Dutschke. Die Gewalttat auf Dutschke dürfe nicht für neue Gewalttätigkeiten missbraucht werden, man werde mit den erforderlichen Mitteln dagegen vorgehen. Grundsätzlich sei er zu Gesprächen und Aussprachen bereit, nicht jedoch unter der Androhung von Gewalt.","Schütz: \"Macht endlich Schluß!\" ","Terror nach dem Attentat","","k.a.",[2,1],2,[1],[2],1,"14","8"],["1934","1968-04-13","Beschreibung der Ausschreitungen nach dem Attentat","Terror in Berlin!","Nach dem Attentat auf Rudi Dutschke: Krawalle am Kudamm, Rathaus und Rias, Großalarm für 20.000 Polizisten","","k.a.",[2],2,[1],[1],1,"14","1"],["1935","1968-04-13","Aufruf der Bild, Tat nicht zu missbrauchen, Kritik an Gewalt der Studenten, Kritik an Dutschke?, Aufforderung die Verantwortlichen vor Gericht zu stellen (Krawalle). \"Der fanatische linskradikale Dutschke wurde das Opfer eines halbirren Rechtsradikalen.\"","Im Berliner Westend-Krankenhaus ringen die Ärzte um Dutschkes Leben.","","","Bild",[2],2,[5],[2],2,"14","1"],["1936","1968-04-13","Der Attentäter: \"Mein Vorbild war der Mörder von Martin Luther King\".","Der Attentäter: \"Mein Vorbild war der Mörder von Martin Luther King\".","","Bericht auf der letzten Seite","k.a.",[2],2,[1],[2,1],2,"14","1"],["1937","1968-04-13","Nach dem Attentat auf Rudi Dutschke sei dieser plötzlich \"nicht mehr der radikale Agitator, sondern nur ein hilfloser Mensch.\" Kurzzeitig sei die politische Gegnerschaft durch die Anteilnahme am menschlichen Schicksal überdeckt gewesen, aber die am Abend des Attentats folgenden Unruhen seiner Weggefährten hätten diese Chance des \"Ausgleichs zwischen der außerparlamentarischen Opposition und der demokratischen Mehrheit wieder vertan\"","Millionen bangen mit","Terror nach dem Attentat","","k.a.",[2],2,[1],[1],1,"14","2"],["1938","1968-04-13","Augenzeuge berichtet über die Tat","Augenzeuge: Von seinen Armen rann das Blut","","","k.a.",[2],2,[3],[2],1,"14","2"],["1939","1968-04-13","Bericht über Tathergang, Festnahme und Abtransport des Attentäters Bachmann mit Zeugen und Zitaten.","Der Attentäter: \"Lebend kriegt ihr mich nicht!\"","Terror nach dem Attentat","","k.a.",[2],2,[1],[1],1,"14","4"],["1940","1968-04-13","Beschreibung der Ausschreitungen, Sprechchöre werden zitiert, Anwohner schütten Wasser auf Demonstranten  ","Anwohner halfen mit Wassereimern","Terror nach dem Attentat","","k.a.",[1],2,[1],[1],1,"14","8"],["1941","1968-04-13","Umfeld Bachmanns wird untersucht, Mutter, Schwägerin, Stiefbruder kommen zu Wort, zeichnen Bild eines Einzelgängers. Besuch in Wohnung Bachmanns und Wohnung der Mutter in Peine. Erklärung von Bundeskanzler Kiesinger zum Attentat. Erste Vernehmung Bachmanns nach der Tat.","Er malte Hitler und Napoleon und schoß auf Rudi Dutschke","Der Attentäter: Ich wollte es wie der Mörder von Luther King machen","","k.a.",[2],2,[7],[1],1,"14","14"],["1942","1968-04-13","Bericht über Demos und \"Krawalle\" nach dem Attentat auf Dutschke, Einsatz von Wasserwerfern, Vorgehen der Demonstranten, Vorgehen der Polizei  ","Ku'damm wurde zum Schlachtfeld","Terror nach dem Attentat","","k.a.",[10,2],2,[1],[1],1,"14","6"],["1943","1968-04-13","Demonstrationen und Sachbeschädigung in den anderen Bundesländern, München, Düsseldorf etc.","Schwere Krawalle im Bundesgebiet","","","k.a.",[1],2,[1],[2],1,"14","14"],["1944","1968-04-13","Bericht über die schwierige Festnahme Bachmanns","Mit dieser Waffe kämpfte Bachmann eine Stunde lang gegen die Polizei ","Terror nach dem Attentat","","k.a.",[2],2,[1],[1],1,"14","3"],["1945","1968-04-13","Bericht über Zustands Dutschkes nach der OP, Vater und Bruder anwesend, im letzten Absatz Bericht über Zustand des Attentäters.","Dutschkes Vater kam aus der Zone","","","k.a.",[2],2,[1],[2],1,"14","3"],["1946","1968-04-13","Beschreibung der Ausschreitungen an einem Wasserwerfer. Er soll nicht mehr auf die Demonstration gerichtet gewesen sein. ","Sturm auf den Wasserwerfer","","","k.a.",[1],2,[1],[1],1,"14","7"],["1947","1968-04-13","Bericht aus der Uni, Eskalation bis zum Eintreffen der Demonstranten am Springer-Gebäude, Ablauf der Geschehnisse, Tenor: wenig Polizei, viele Demonstranten, Feuerwehrleute hilflos, Bilanz der Schäden, Kritik an Polizeichef Dittmann. ","Zeitungswagen in Flammen","Terror nach dem Attentat","","k.a.",[10,2],2,[1],[1],1,"14","5"],["1948","1968-04-13","Demo vor Springer-Haus; Zerstörung von Lieferwagen; Behinderung von Löschfahrzeugen; Schadensbilanz","Ihr \"Protest\": Zerstörung!","","","L.R.",[10,2],6,[1],[4],1,"32","16,17"],["1949","1968-04-13","Bachmann zu seiner Absicht; Dutschke im Krankenhaus","Attentäter ein krimineller Sonderling","Ausführliche Berichte auf den Seiten 2 bis 6, Innen und auf der letzten Seite","","",[2],6,[1],[4],1,"32","1"],["1950","1968-04-13","Gesellschaft bangt um Leben des Opfers eines gemeinen Mordanschlages. Empörung und Bestürzung. Verabscheuung jeder Gewaltanwendung als Mittel der politischen Auseinandersetzung. Stichwort Weimar. Mordanschlag nach faschistischer Manier. Reaktionen von linksradikaler Seiten trugen ebenfalls faschistischen Charakter. Respekt vor Protesten. Schlusssatz: \"23 Jahre nach Wiedererrichtung der deutschen Demokratie wurde bei uns der erste Mordanschlag aus politischen Motiven verübt. Das muss uns alle schrecken.\"","Das muss uns alle schrecken!","BZ meint:","","",[2],6,[5],[1],2,"32","2"],["1951","1968-04-13","Foto von Gretchen Dutschke mit Begleitern","Sie harrte aus?","","BU: Sie harrte aus?","dpa",[2],6,[1],[5],1,"32","2"],["1952","1968-04-13","Reaktionen von Politikern auf Attentat","Der Kanzler unterbrach seinen Urlaub","","","P.R.",[2],6,[1],[3],2,"32","2"],["1953","1968-04-13","Schilderung des Tathergangs und der ersten Bachmann-Aussagen, sowie Biografisches zum Attentäter.","Das erste Geständnis des Attentäters","","","Wolfgang Schöne",[2],6,[1],[4],1,"32","3"],["1954","1968-04-13","Schütz-Aufruf zum Ende der Gewalttätigkeiten","Macht Schluss!","","","red",[2],6,[1],[2],2,"32","3"],["1955","1968-04-13","Schilderung der Demos und Ausschreitungen im Gefolge des Attentats, sowie der Gegenmaßnahmen der Polizei. Springer wird hier nicht erwähnt.","Schwere Krawalle in Berlin","","Zusammenstöße auf dem Kurfürstendamm; Straßenschlacht vor dem Rathaus; Steinwürfe gegen das RIAS-Gebäude","L.R.",[2],6,[1],[4],1,"32","4,5"],["1956","1968-04-13","Interview mit Klaus Schütz nach dem Attentat auf Rudi Dutschke und den folgenden ersten Osterunruhen. Schütz erklärt, man werde mit angemessenen Mitteln gegen Störungen vorgehen und werde die Auslieferung von Zeitungen gewährleisten. Von einer Diskussion mit den Demonstranten sieht er ab, solange er von diesen als \"Faschist\" und \"Mörder\" bezeichnet wird und sie Autos in Brand stecken.","\"Wir bleiben ruhig und besonnen\"","BZ sprach mit Klaus Schütz","","Klaus Bär",[2,10],6,[3],[4],1,"32","6"],["1957","1968-04-13","Schilderung von Angriffen auf Springer-Einrichtungen in mehreren Städten. Störungen in Kirchen. (So nur in der 2. Form des Blattes. In der 1. Form geht es ausschließlich um Störungen in Kirchen und Theatren.)","Jugendliche stürmten Kirchen und Verlage","Nach dem Dutschke-Attentat: Schwere Krawalle auch in Westdeutschland","","",[2,10],6,[1],[1],1,"32","32"],["1958","1968-04-14","Aussagen des Ex-Chefs, eines Münchener Ingenieurs, über den Dutschke-Attentäter Bachmann: \"?bei dem war eine Schraube locker.\"","Bachmann: \"Ich haue noch alles zusammen!\"","Zwei Wochen vor dem Attentat auf Dutschke","Der Ex-Chef hatte viel Ärger mit seinem Hilfsarbeiter","Franz Josef Wagner, Klaus Meyer",[2],3,[1],[4],1,"64","64"],["1959","1968-04-14","Dutschkes Arzt über den Zustand seines Patienten. Ehefrau war zu Besuch. Er habe \"kräftig geflucht und auf die ganze Scheißbande geschimpft.\"","Dutschke flucht wieder?","","","",[2],3,[1],[2],1,"64","64"],["1960","1968-04-14","Nach Dutschke-Attentat Schlag gegen die Pressefreiheit wie seit den Tagen des Dritten Reiches nicht mehr. Gewalt kein Mittel der politischen Auseinandersetzung. Hinweis auf Texte im Heft.","BILD am SONNTAG und BILD versprechen: Kein Terror wird uns beugen!","Sturm auf die Pressefreiheit - trotzdem kamen alle Zeitungen zu den Lesern","","",[2,10],3,[5],[4],2,"64","1"],["1961","1968-04-14","Zeitlicher Ablauf der Anti-Springer-Maßnahmen in Berlin, Hannover und Essen. Vorgehen \"offensichtlich ferngelenkt\". ","Anschlag auf die Verlage misslang","Sturm auf die Pressefreiheit","","",[2,10],3,[1],[4],1,"64","2"],["1962","1968-04-14","Bundeskanzler im Fernsehen zu Dutschke-Attentat und den nachfolgenden Unruhen. Auch Äußerungen anderer Politiker.","Kiesinger: Schluss mit der Gewalt! ","","","",[2],3,[1],[1],2,"64","3"],["1963","1968-04-14","Demonstrationen auch am Karsamstag in Berlin. Demo vor deutscher Botschaft in Oslo.","Berlin: In Seitenstraße abgedrängt","","","pol.",[2],3,[1],[2],2,"64","3"],["1964","1968-04-14","Anzahl der verletzten Polizisten und Demonstranten in sechs Städten nach Anti-Springer-Demos","Mehr als 100 Verletzte!","","","",[2,10],3,[1],[2],2,"64","3"],["1965","1968-04-14","Zeitlicher Ablauf der Anti-Springer-Maßnahmen in Frankfurt, Stuttgart und München. ","Essen: Die Polizei gab auf","Sturm auf die Pressefreiheit!","","",[2,10],3,[1],[4],1,"64","4,5"],["1966","1968-04-14","Alfred Neven DuMont hat sich Studenten gegenüber bereit erklärt, darüber zu verhandeln, die Kölner Teilauflage der Bild nicht mehr zu drucken.","Einer fiel um!","","","",[2],3,[1,5],[2],1,"64","5"],["1967","1968-04-14","Gebrüder Bechtle in Esslingen wollen weiterhin Bild-Teilauflage drucken.","?und sie standen!","","","",[2],3,[1,5],[2],1,"64","5"],["1968","1968-04-14","Bild und BamS bedanken sich bei Zeitungsfahrern, Polizisten, Lesern, Journalisten etc. für Einsatz und Solidarität","Unser Dank","Meinung","","",[2,10],3,[5],[4],1,"64","6"],["1969","1968-04-14","Pressespiegel zu den Vorgängen. Teil mit Vergleich Dutschke und Martin Luther King.","\"Eine Krankheit ist ausgebrochen\"","","","",[2,10],3,[5],[3],2,"64","6"],["1971","1968-04-16","Weitere Pressestimmen, Reifen von drei Zeitungswagen zerstochen, Unfall in Hamburg","Bundesgebiet: Wieder schwere Krawalle","","Reifen von drei Zeitungswagen durchstochen","",[10,2],2,[1],[3],1,"14","14"],["1972","1968-04-16","Bericht über die Zerstörung eines Möbelhauses in Gladbeck, fälschlich wird dies in Zusammenhang mit SDS und Studentenunruhen gebracht. Ausschreitungen gegen den Springer-Verlag, den Demonstranten ginge es nicht nur um Springer, sondern um die Zerstörung der gesamten Gesellschaftsordnung.","Möbelhaus in Brand gesteckt","Ist das Demonstration? Ist das Diskussion?","Nackte Zerstörungswut! Anschlag auf privates Eigentum/ Marsch auf Zeitungshäuser mit Molotow-Cocktails und roten Fahnen/ Aufrührer werden von Kommdandowagen mit Sprechfunk gesteuert","k.a.",[2,10],2,[1],[1],1,"14","1"],["1973","1968-04-16","Ärzte zum Zustand Rudi Dutschkes, positiv, bewegt Arme und Beine, Bachmann ebenfalls außer Lebensgefahr ","Ärzte: Er ist recht munter","Dutschke außer Lebensgefahr","","k.a.",[2],2,[1],[3],1,"14","2"],["1974","1968-04-16","Demos in Köln, München, Brüssel, Rom.","SDS: Marsch auf Bonn!","","","k.a.",[9,1,2,10],2,[1],[2],2,"14","14"],["1975","1968-04-16","Wer wurde festgenommen, warum, wer ist wieder frei, warum, Stimmen der Polizei","381 Festnahmen! Die Störer müssen mit Anklage rechnen","Terror nach dem Attentat ","","zy",[1],2,[1],[2],1,"14","4"],["1976","1968-04-16","Karikatur: Drei Demonstranten jagen den Osterhasen","Oster-Spaziergang","","","zel",[9],2,[5,4],[3],1,"14","2"],["1977","1968-04-16","Kommentar zu Geschehnissen der vergangenen Tage, nimmt nur Bezug auf Behinderungen der Auslieferung, der Zerstörung am Verlagsgebäude, verurteilt Maßnahmen, betont die Organisiertheit der Aktionen.  ","Fröhliche Ostern waren das","","","BILD",[10,2],2,[5],[2],2,"14","1"],["1978","1968-04-16","Pressestimmen pro Springer, Leserbriefe contra Bild aber pro Springer, Hilfsangebote vereinzelter Leser.  ","Und morgen das VW-Werk?","","Fortsetzung von Seite 1","k.a.",[1],2,[6],[1],1,"14","14"],["1979","1968-04-16","1: Senat dankt der Polizei für Arbeit, 2: Zeitungsdiebe werden von BILD-Leserin am klauen des Blattes gehindert und von Polizei gefasst, 3: Sondersitzung des Senats, 4: Intendant des SFB lehnt  einstündige, tägliche Sendezeit für die APO ab. 4: Bischof an der TU, sucht Gespräch mit Studenten, verurteilt Gewalt, fordert \"Die Manipulation durch die Massenmedien muß beendet werden.\"    ","Dank an die Polizei / Zeitungsdiebe gefasst / Senat tritt zusammen / Barsig lehnt ab / Bischof Scharf an der TU","","","k.a.",[10,1,2],2,[1],[2],2,"14","2"],["1980","1968-04-16","Ausschreitungen am Ostersonntag, Passanten helfen Polizei gegen Demonstranten","Passanten halfen der Polizei","Terror nach dem Attentat","","rb",[2,1,10],2,[1],[2],1,"14","4"],["1981","1968-04-16","Der Regierende Bürgermeister äussert nach Kundgebung seine Enttäuschung, keine Änderung der Sichtweise bei Demonstranten  ","Schütz: Keine Hilfe?","","","rb",[1],2,[1],[2],2,"14","2"],["1982","1968-04-16","Täter, der seit März angeblich Reifen von etwa 100 Autos zerstochen hat, ist gefasst worden, es handelt sich um den 20-jährigen Michael Baumann (später Bommi Baumann).  ","Reifenstecher gefasst - es ist ein Kommunarde","","Protest gegen Gesellschaft","rb",[9,5],2,[1],[1],1,"14","5"],["1983","1968-04-16","Die beiden Brüder Otto Wolfgang und Friedrich Bechtle von der Eßlinger Zeitung weigern sich, dem Druck der Demonstranten nachzugeben, und die Bild nicht auszuliefern.","?und sie standen","","","hek",[10],2,[1],[2],1,"14","2"],["1984","1968-04-16","Verleger Alfred Neven DuMont weigert sich 28.000 zusätzliche Bild-Zeitung zu drucken, obwohl Druckmaschinen Springer gehören.  ","Ein Verleger fiel um?","","","k.a.",[9,10],2,[1],[2],2,"14","2"],["1985","1968-04-16","Touristen und Berliner werden dazu befragt, ob sie nach den Krawallen nun Angst haben, wiederkommen etc. ","Berlin bleibt eine Reise wert","Westdeutsche Besucher über die Krawalle am Ku'damm","","k.a.",[1],2,[1],[1],1,"14","3"],["1986","1968-04-16","Ausschreitungen gegen Springer-Autos an der Oranienstraße , Hinweis: Film zum Bau von Molotow-Cocktails angeblich an der TU gezeigt. ","Erst zerstören, erst verwüsten - dann lesen","","","k.a.",[10],2,[5],[3],1,"14","4"],["1987","1968-04-16","Demos insbesondere gegen westdeutsche Springer-Einrichtungen. Teils mit Versuchen, Zeitungsauslieferung zu behindern.","Neue SDS-Aktionen in Westdeutschland","","","dpa,AP",[10],6,[1],[3],2,"44","44"],["1988","1968-04-16","Demo vor SFB wegen Intendantenweigerung, APO regelmäßige Sendezeit zur Verfügung zu stellen. (nur in der dritten Fassung der Ausgabe)","Demonstranten zogen zum SFB","letzte Meldung","","",[1],6,[1],[2],2,"44","44"],["1989","1968-04-16","Kundgebung vor den Messehallen u. a. mit Schütz und APO-Redner. Bei anschließender Versammlung in TU Forderung nach Enteignung Springers. Hinweis auf Texte im Blatt.","\"Damit ist Berlin nicht geholfen!\"","Gestern am Funkturm: Reden und neue Verketzerung. Klaus Schütz:","","",[2,10],6,[1],[4],2,"44","1"],["1990","1968-04-16","Angriffe gegen Springer. Attentat war nur Auslöser. Ziel ist eine Meinungsdiktatur. Pressefreiheit in Gefahr","Inspektor meint: Das sollen Sie nicht lesen dürfen!","","","Inspektor (Werner Sikorski)",[2,10],6,[5],[1],1,"44","3"],["1991","1968-04-16","Dank an Leser und Kollegen anderer Verlage für Hilfeangebote.","Herzlichen Dank!","","","",[2,10],6,[5],[2],2,"44","3"],["1992","1968-04-16","5000 Menschen bei der Kundgebung \"Macht einen neuen Anfang\". \"Mehr oder weniger scharf akzentuiert forderten alle Redner vom Parlament eine 'Entflechtung des Meinungsmonopol' bzw. eine Enteignung des Verlegers Axel Springer.\"","Reden, Reden, Reden","","","mz",[2,10],6,[1],[1],1,"44","10"],["1993","1968-04-16","Appelle unterschiedlicher Politiker gegen Gewalt. Erwähnung weiterer Demos, u. a. mit Anti-Springer-Parolen.","Appelle an die Vernunft","","","dpa",[2,10],6,[1],[2],2,"44","10"],["1994","1968-04-16","Stellungnahmen unterschiedlicher Senatoren etc.","Wie soll es weitergehen?","","BZ sprach mit führenden Politikern Berlins","Klaus Bär",[2],6,[1,3],[4],2,"44","11"],["1995","1968-04-16","Meinungsverschiedenheiten in der SPD über den Umgang mit Demonstranten.","Zweifel am Polizeieinsatz","","","",[2],6,[1],[2],2,"44","11"],["1996","1968-04-16","Informationen über Dutschkes Gesundheitszustand und über eingegangene Genesungswünsche","Glückwünsche für Dutschke","","","",[2],6,[1],[2],1,"44","11"],["1997","1968-04-16","Bericht über Unruhen u. a. auf dem Kudamm und in der Friesenstraße. Erwähnung der Berichterstattung im Neuen Deutschland. Dank an Polizei.","Auch am Ostersonntag wieder Krawalle","","Zonenrundfunk übertrug direkt","L.R.",[2],6,[1],[4],1,"44","12"],["1998","1968-04-16","Kritik an vermeintlicher Ungleichbehandlung von Demonstranten und \"Normalbürgern\" bei Ordnungswidrichkeiten bzw. Straftaten, es ist die Rede von der antiparlamentarischen Opposition.","Wenn Sie und ich das täten?","","","Peer",[2],6,[5],[4],2,"44","13"],["1999","1968-04-16","Michael \"Bommi\" Baumann als Reifenstecher verhaftet. Protest gegen die Gesellschaft.","Reifenstecher gefasst","","\"Kommunarde\" gestand: Über 100 Fälle","",[9,5],6,[1],[1],1,"44","6"],["2001","1968-04-17","Politische Stimmen zu Krawallen und Folgen, ","Aufruhr wird hart bestraft","","","k.a.",[1],2,[1],[2],1,"10","10"],["2002","1968-04-17","Zustand von Rudi Dutschke nach dem Attentat bessert sich.","Besserung","","","",[2],2,[1],[3],2,"10","2"],["2003","1968-04-17","Zusammenfassung von Verletzten und Festgenommenen in den einzelnen Städten im Zuge der Unruhen nach dem Attentat auf Rudi Dutschke.","\"Er sprang vor meinen Wagen\"","","Hamburger Student geht es besser/Prellungen und Rippen gebrochen","pal",[1,2],2,[1],[3],1,"10","10"],["2004","1968-04-17","Demonstrationen aus Sicht der Polizisten, die Zusatzdienst machen müssen. Am Beispiel eines Polizisten, der Verlobung feiern wollte. Verpflegung mit Zitat von Brandt Sohn: \"Besser als in der Mensa\", Sondergeld für Einsatz  ","Statt Verlobung: Straßenschlacht!","\"Heiße Ostern\" für Berliner Polizisten","Sonderprämie des Senats: Fünf Mark","rb",[1],2,[1],[1],2,"10","2"],["2005","1968-04-17","Vielleicht Gespräche zw. Schütz und Studenten","Doch Gespräche?","","","",[9],2,[1],[3],2,"10","2"],["2006","1968-04-17","Ermittlungen gegen Studenten wegen Beteiligung an den Osterunruhen","Ermittlungen","","","",[1],2,[1],[3],2,"10","2"],["2007","1968-04-17","Bachmann-Geständnis, Haß auf Kommunisten","Geständnis","","","",[2],2,[1],[3],2,"10","2"],["2008","1968-04-17","Wer hat vor den Türen des Verlags gesessen? Weniger Studenten, mehr Schüler. \"Halbstarke\" etc. hatten angeblich Waffen dabei. Weniger als ein Drittel sind \"Krawallmacher\". Bitte wird wiederholt: \"Werft Studenten nicht in einen Topf!\"","Sagt nicht immer Studenten?.","","Es sind Berufsrevolutionäre!","BILD",[1],2,[5],[3],2,"10","1"],["2009","1968-04-17","Reaktionen und Leserbriefe von Bild-Lesern","Das ist offene Rebellion gegen die Demokratie","","","k.a.",[2,1,10],2,[6],[5],1,"10","10"],["2010","1968-04-17","Deutsche Presseschau, WAZ, FAZ, RP","Wer Steine wirft... ","","Pressestimmen zu den Krawallen","k.a.",[1,2,10],2,[8],[2],2,"10","10"],["2011","1968-04-17","Schütz will Erklärung abgeben","Senatserklärung","","","",[9],2,[1],[3],2,"10","2"],["2012","1968-04-17","Festnahme der \"Randalierer und Rädelsführer\", verschiedene Politiker werden zitiert (Dr. Merck, Brandt, von Eckardt)","Endlich! Schnellgerichte gegen die Rädelsführer!","","Erstes Urteil: 7 Monate Gefängnis ohne Bewährung","",[10,2],2,[1],[1],1,"10","1"],["2013","1968-04-17","Neue Mitarbeiter im Studienreferat der Senatsverwaltung für Wissenschaft und Kunst, sollen an studentischen Veranstaltungen teilnehmen um \"Schneller reagieren zu können\" .  ","Verstärkung","","","",[9],2,[1],[3],2,"10","2"],["2014","1968-04-17","Bericht über verletzten Pressefotografen, Montags in München bei Demo vermutlich von Pflastersteinen getroffen ","Ohne Titel","","","k.a.",[10,2],2,[1],[1],1,"10","10"],["2015","1968-04-17","Erklärung der Frankfurter Societätsdruckerei zu Versuchen, BILD-Auslieferung zu verhindern, dies sei eine \"terroristische Aggression\".","\"Aggression nicht nachgeben\"","Frankfurt","","dpa",[10],6,[1],[2],2,"28","2"],["2016","1968-04-17","Enteignungsforderung von Gewerkschaft zurückgewiesen","IG Druck lehnt Enteignung ab","Stuttgart","","AP, dpa",[10],6,[1],[2],2,"28","2"],["2017","1968-04-17","Falschmeldung über Solidarisierung Kölner Polizei mit BILD-Blockierern. Nevermann schweigt.","Moment mal!","BZ","","",[10],6,[5],[2],2,"28","2"],["2018","1968-04-17","Fotograf bei Münchener Anti-Springer-Demo von Stein getroffen.","Lebensgefahr","","BU ","",[10,2],6,[1,5],[3],1,"28","3"],["2019","1968-04-17","Barsig im Audimax der TU. Lehnt Sendezeit für einzelne Gruppen ab. Will Ausgewogenheit der SFB-Berichterstattung prüfen lassen. Kabarettist Neuss greift Matthias Walden an und nennt ihn einen Faschisten. Mahler wird zitiert. Barsig wird beschimpft. BZ weist darauf hin, dass dieses Verhalten etlichen Studenten nicht gefallen hat.","Barsig in der \"Höhle des Löwen\"","","Versuch des SFB-Intendanten scheiterte an Beschimpfungen","P.R.",[1],6,[7],[1],1,"28","2"],["2020","1968-04-17","Brüsseler Medizinstudenten missbilligen Gewalttätigkeiten in Deutschland","Radikal missbilligt","","","dpa",[1],6,[1],[2],2,"28","2"],["2021","1968-04-17","Demo in Bonn von Bürgern wenig beachtet","Wenig beachtet","","","dpa",[1],6,[1],[2],2,"28","2"],["2022","1968-04-17","Schütz bereitet Erklärung vor. Senator Evers spricht von Polizeiübergriffen. Meinungsverschiedenheiten.","Regierungs-Erklärung vorbereitet","","","Klaus Bär",[1],6,[1],[2],2,"28","3"],["2023","1968-04-17","Beratungen im Kabinett zur Lage. Gegen Rädelsführer soll unverzüglich Anklage erhoben werden. Stellungnahmen verschiedener Politiker","Bonn beriet über die Lage","","","dpa,AP",[2],6,[1],[3],2,"28","2"],["2024","1968-04-17","Berliner Gesellschaft für Bürgerrechte hat vorgeschlagen, Straftaten, die nach dem Mordanschlag auf Dutschke begangen worden sind, zu amnestieren. Peer widerspricht.","Amnestie - das wäre wohl zu bequem!","","","Peer",[2],6,[5],[5],2,"28","3"],["2025","1968-04-17","Bachmann legt Geständnis ab, nennt Kommunistenhass als Grund und verweist auf Ermordung Martin Luther Kings. Zustand Dutsches bessert sich.","Ausführliches Geständnis","","","",[2],6,[1],[2],2,"28","3"],["2026","1968-04-17","Verfahren (u.a. gegen Lefèvre) wegen Aufforderung zu strafbaren Handlungen eingeleitet","Verfahren eingeleitet","","","",[2],6,[1],[2],2,"28","3"],["2027","1968-04-17","Anriss des Themas, Hinweis auf Text im Heft","Bannmeile um den Kudamm","Jetzt fordern die Berliner Gastwirte:","Schwere wirtschaftliche Schäden durch die ständigen Krawalle","",[1],6,[1],[1],2,"28","1"],["2028","1968-04-17","Gastwirtsinnung will Forderungen an den Senat stellen.","Gastwirte fordern jetzt Schadenersatz","Schwere Einbußen durch die Krawalle","","Uwe Dannenbaum",[1],6,[1],[1],2,"28","3"],["2031","1968-04-18","Albertz wird wegen Rede am Funkturm kritisiert aus eigenen Reihen, SPD-Abgeordnete kritisieren Vorgehen der Polizei als \"unnütz hart\".","Wirbel um Albertz in der SPD-Fraktion","","","kh",[9],2,[1],[2],2,"10","2"],["2032","1968-04-18","Willy Brandt schreibt Brief an Schütz: Früher Eingreifen, Rädelsführern keine Chance lassen, sich vorzubereiten","Brandt an Schütz: Greift vorher ein!","","","rb",[9],2,[1],[2],2,"10","2"],["2033","1968-04-18","Bericht über die Ermittlungen zum Tode von Klaus Frings. Ein Mitglied des Münchener LSD erklärte, man müsse bei solchen Aktionen eben mit allem rechnen.","Der Stein kam aus dem Gebüsch am Straßenrand","","Mordkommission fragt: Wer fotografierte in der Barerstraße?","Richard Mahkorn und Ingrid Gallmeister",[1,10,2],2,[1],[4],2,"10","10"],["2034","1968-04-18","P. Brandt hat angeblich Interview mit der britischen Sun geführt. Darin fordert er seinen Vater zum Rücktritt auf und fordert viele \"Vietnams\", Führungsspitze muss ausgetauscht werden, behauptet  Interview ist gefälscht    ","Will Peter Brandt seinen Vater stürzen? ","","Umstrittenes Interview mit einer Londoner Zeitung","sad",[9],2,[1],[2],1,"1","1"],["2035","1968-04-18","Kommentar zu Frings, SDS wird angegriffen, rufen zur Besinnung auf, muss letztes Opfer sein, geteiltes Land soll nicht auch noch gespaltenes West-Berlin bedeuten ","Es ist noch nicht zu spät!","","Klaus Frings ist tot. Er hat nicht demonstriert. Er ist nicht Polizist. Er gehört auch nicht dem Springerhaus an.","",[10,2],2,[5],[3],2,"10","1"],["2036","1968-04-18","Foto von Gerangel in München auf einer Demo am Abend des Ostermontag, Springer Fahrzeuge sollen an der Auslieferung  gehindert werden. Polizei und Demonstranten bedrängen sich. K. Frings macht Foto der Szene vermutlich über dem Kopf ","Das war sein letztes Foto",""," - dann flog der Stein","k.a.",[10,2],2,[1],[5],1,"10","5"],["2037","1968-04-18","Politische Führung soll sich vor Polizei stellen, Forderung der Polizeigewerkschaft, Berliner FDP gründet Hochschulgruppe/ Münchner Kripo schaltet sich im Fall Bachmann ein/ ÖTV-Aufruf: Behindert nicht die Feuerwehr ","Im Fernsehen/Unterstützung/Mehr Einfluss/München hilft/ÖTV-Appell","","","k.a.",[9],2,[1],[2],1,"10","2"],["2038","1968-04-18","Nachruf auf K. Frings, Kollegen und Ehefrau kommen zu Wort","Sein Leben - seine Bilder","Pressefotograf Klaus Frings","","Ingrid Gallmeister",[10,2],2,[1],[1],1,"10","5"],["2039","1968-04-18","SDS plante Blockade auf Zufahrtswegen nach Westdeutschland, Plan verworfen, da vermutlich keine Zustimmung durch Bevölkerung ","SDS plante \"Berlin Blockade\"","","","rb",[8],2,[1],[2],2,"10","2"],["2040","1968-04-18","Etwa 300 Strafverfahren in Folge der Osterunruhen in West-Berlin wurden bisher eingeleitet.","Krawalle: 300 Strafverfahren ","","","rb",[10,2],2,[1],[2],2,"20","1"],["2041","1968-04-18","Polizei fahndet, Täterbeschreibung, die meisten Studenten distanzieren sich, SDS auch, Verdacht, das Aktionen von Kommunisten gesteuert werden ","\"Liefert den Täter aus!\"","Foto-Reporter Frings ist tot: ","Kripo fand heiße Spur","",[10,2],2,[1],[1],1,"10","1"],["2042","1968-04-18","Fotograf bei Münchener Demo getötet. Hinweis auf Texte im Heft","Sein letztes Foto","Fotoreporter durch Steinwurf eines Demonstranten getötet","","",[10,2],6,[1],[5],1,"36","1"],["2043","1968-04-18","Bei Demo vor Hamburger Springerhaus von Verlagsfahrzeug verletzte Studentin ist außer Lebensgefahr","Außer Gefahr","","","UPI",[10,2],6,[1],[2],2,"36","2"],["2044","1968-04-18","Verein sieht Pressefreiheit durch Blockaden gefährdet.","Erklärung des Bürger Vereins","","","lbn",[10],6,[1],[2],2,"36","7"],["2045","1968-04-18","","Von einem Demonstranten getötet","","Münchener Fotograf erlag seinen schweren Verletzungen. Kripo ermittelt pausenlos","N.R.",[10,2],6,[1],[4],1,"36","12,13"],["2046","1968-04-18","Reaktionen von Parteien und der DJU","CSU: \"Das Opfer einer gesteuerten Terror-Aktion\"","","","",[10,2],6,[1],[2],2,"36","13"],["2047","1968-04-18","Warnung vor Rache, aber klare Schuldzuweisung an \"Linksradikale\" für den Tod von Klaus Frings.","Nicht nach Rache rufen","","","Peer",[10,2],6,[5],[5],2,"36","12"],["2048","1968-04-18","Unterstützung für Schütz aus der SPD. Hinweis auf Text im Heft","Willy Brandt greift ein","Gewalt im Keim ersticken!","SPD-Chef stärkt dem \"Regierenden\" den Rücken","",[1],6,[1],[1],2,"36","1"],["2049","1968-04-18","Auszüge aus Brandt-Brief. Widerspruch von Senator Hoppe","\"Im Keim ersticken\"","Brief Willy Brandts an Klaus Schütz","","K.B.",[1],6,[1],[1],2,"36","2"],["2050","1968-04-18","Lageeinschätzungen der Regierung und Länderinnenminister","\"Wir bleiben Herr der Lage\"","","","Bolesch, Kirchner",[1],6,[1],[5],1,"36","2"],["2051","1968-04-18","Senator wendet sich gegen AStA von TU und FU, die sich für \"Gewalt gegen Sachen\" ausgesprochen haben","Stein verurteilt jede Gewalt","","","",[1],6,[1],[2],2,"36","3"],["2052","1968-04-18","Forderungen nach mehr Unterstützung","Das verlangt Berlins Polizei","Vier Forderungen der Gewerkschaft","","L.R.",[1],6,[1],[1],2,"36","7"],["2053","1968-04-18","Protest gegen Behinderungen bei Einsätzen","Offener Brief der Feuerwehr","","","red",[1],6,[1],[5],2,"36","7"],["2054","1968-04-18","Versicherungen melden, dass sie bei Krawallschäden nicht haften.","Kein Geld bei Krawall-Schäden","","","dpa",[1],6,[1],[2],2,"36","7"],["2055","1968-04-18","23 Professoren verurteilen Attentat und kritisieren Springer, ohne Namen zu nennen","FU-Professoren mahnen","","","",[2],6,[1],[2],2,"36","3"],["2056","1968-04-18","Nachricht über Gesundheitszustand","Dutschke geht es besser","","","dpa",[2],6,[1],[2],2,"36","7"],["2057","1968-04-18","Kurras-Verteidiger RA Roos vertritt Bachmann nicht.","Roos verteidigt den Attentäter nicht","","","L.R.",[2],6,[1],[2],2,"36","7"],["2058","1968-04-18","Politisches Handeln Peter Brandts ist kein Grund, den Außenminister zu kritisieren. Verteidigung Willy Brandts.","Peter Brandt - immer dabei","","","Werner Sikorski",[9],6,[5],[4],1,"36","34"],["2059","1968-04-18","Auszüge aus SUN-Interview Peter Brandts. U. a. mit Anti-Springer-Passage.","\"Auch mein Vater muss weg!\"","","","sad,dpa",[9],6,[1],[5],2,"36","34"],["2060","1968-04-18","Peter Brandt will auf kommunistischer Versammlung in Paris reden","Zu Gast bei Kommunisten","","","sad",[9],6,[1],[2],2,"36","34"],["2061","1968-04-18","K.-D. Wolff kündigt Demo an und wird mit dem Satz zitiert: \"Revolutionäre Gewalt ist Notwehr.\"","Bekenntnis zur Gewalt","SDS-Chef kündigt neue Aktionen an","kene","dpa,UPI",[8],6,[1],[2],2,"36","2"],["2062","1968-04-18","SDS Hannover will Demonstrationen aussetzen, Anklage gegen Mitglieder","Anklage gegen 14 Rädelsführer","","","dpa",[8],6,[1],[2],2,"36","2"],["2063","1968-04-18","Ostberliner RA vertritt Heer und Pate, die in einem Flugblatt auf \"brennbare Kaufhäuser\" in Bonn hingewiesen hatten","Kaul vertritt SDS","","","AP ",[8],6,[1],[2],2,"36","2"],["2064","1968-04-19","Unbeteiligter Student (Rüdiger Schreck) an Verletzung nach Münchener Demo gestorben. Hinweis auf Text im Heft.","Er wollte zusehen - und wurde getötet","Demonstrationen fordern zweites Opfer","","",[10,2],6,[1],[1],1,"44","1"],["2065","1968-04-19","Ausriss aus Zeit-Text über Zerstörungen bei Springer mit gegenübergestelltem Foto. Kritik an Kai Hermann","So sah es \"Die Zeit\". Und das ist die Wahrheit","","","",[10],6,[5],[3],1,"44","2"],["2066","1968-04-19","Über Artikel von Max Lerner in der New York Post, dass man an der Seite der Springer-Zeitungen stehen müsse. Kritik an Dutschke. Schuldzuweisungen an Springer seien \"ziemlich hysterisch\".","Wer ist hier totalitärer?","","","sad",[10,2],6,[1],[2],2,"44","3"],["2067","1968-04-19","Schilderung des Ablaufs der Demo in München mit den beiden Todesfällen. Erwähnung eines Prozesses gegen zwei SDS-Mitglieder.","\"Ich wollte den Demonstranten nur zusehen\"","München: Oster-Krawalle forderten zweites Todesopfer. Letzte Worte des Studenten:","","",[10,2],6,[1],[4],1,"44","42"],["2068","1968-04-19","Eine Holzbohle hat den Tod von Rüdiger Schreck verursacht.","Von Bohle getroffen","letzte Meldung","","AP",[10,2],6,[1],[2],2,"44","42"],["2069","1968-04-19","Hinweis auf Bericht im Blatt","Klaus Schütz: Unser Dank gilt den Berlinern","","","",[1],6,[1],[5],2,"44","1"],["2070","1968-04-19","Bericht über Senatserklärung zu den vergangenen Unruhen","Senat: \"Uns kann man nicht brechen!\"","","","Klaus Bär",[1],6,[1],[1],1,"44","2,3"],["2071","1968-04-19","Politikerstimmen zur Senatserklärung","Neubauer: Steht nun zusammen!","","","K.B.",[1],6,[1],[5],2,"44","2"],["2072","1968-04-19","Verhaftung von Rädelsführern findet keine Zustimmung in Bonn","Keine Zustimmung","","","",[1],6,[1],[2],2,"44","2"],["2073","1968-04-19","Demos in USA und Italien wegen Dutschke-Attentat","Demonstrationen","","","",[1],6,[1],[2],2,"44","2"],["2074","1968-04-19","Rede von Peter Lorenz im Abgeordnetenhaus mit namentlichen Schuldzuweisungen. Kritik an Bischof Scharf.","\"Sorgfältig geplante Straftaten\"","","","dpa,BZ",[1],6,[1],[2],2,"44","3"],["2075","1968-04-19","Stellungnahmen von Brandt und Barzel; Frankfurter AStA-Chef fordert Entwaffnung von Steinewerfern","AStA will \"entwaffnen\"","","","",[1],6,[1],[2],2,"44","42"],["2076","1968-04-20","Landesregierung rechnet mit Großdemo zum 100. Firmenjubiläum von Bechtle, weil dort eine Teilauflage der BILD gedruckt wird.","Großdemonstration","","","",[10],6,[1],[2],2,"28","2"],["2077","1968-04-20","Societäts-Druckerei will weiter BILD drucken","Vertrag läuft weiter","","","",[10],6,[1],[2],2,"28","2"],["2078","1968-04-20","Ermittlungen zur Münchener Demo. Rainer Jendis vom Münchener SDS kündigt weitere Gewalt gegen Sachen an.","Polizei ermittelte drei der Steinewerfer","","","",[10,2],6,[1],[5],2,"28","28"],["2079","1968-04-20","Landsberg kündigt wegen zunehmender Ausschreitungen bei Demos Rücktritt als AStA-Chef der FU an. AStA billigt Gewalt gegen Sachen in einer Erklärung.","Gewalt - für ihn der falsche Weg","AStA-Vorsitzender der FU Wolfgang Landsberg tritt zurück","","Rudolf Müller",[1],6,[1],[2],1,"28","3"],["2080","1968-04-20","Gesundheitliche Fortschritte","Dutschke isst selbst","","","",[2],6,[1],[2],2,"28","3"],["2081","1968-04-20","Grass äußert im Fernsehen, der SDS habe seinen Fürungsanspruch verloren.","Grass kontra SDS","","","",[8],6,[1],[2],2,"28","2"],["2082","1968-04-20","Bundesinnnenministerium will SDS-Verbot prüfen","SDS-Verbot prüfen","","","",[8],6,[1],[2],2,"28","2"],["2083","1968-04-21","Trauerfeier für Klaus Frings, den Fotografen, der bei den Münchener Anti-Springer-Unruhen zu Tode gekommen war.","\"Er zahlt mit dem höchsten Preis!\"","","","Ingrid Gallmeister",[10,2],3,[1],[4],1,"64","2,3"],["2084","1968-04-21","Hinweis, dass bald mit Verhandlung gegen Bachmann zu rechnen ist","Bald vor Gericht","","","ka.",[2],3,[1],[2],2,"64","64"],["2085","1968-04-21","Während einer Wahlkampftour bekommt Willy Brandt zahlreiche \"Tipps\" für die Erziehung seines Sohnes Peter.","\"Zieh Peter die Hosen stramm!\"","","Schwäbische Ratschläge an Vater Willy Brandt","Thomas Leichsenring",[9],3,[1],[1],2,"64","2"],["2086","1968-04-21","Beschreibung des SDS und seiner vom Autor ausgemachten Fraktionen: der marxistisch-leninistischen Gruppe, der radikal-revolutionären Gruppe, der anarchistischen Gruppe. Frage, welche Weg der Verband gehen wird, wenn Dutschke wieder da ist. Kurzportraits von Wolff, Krahl, Lefèvre und Rabehl.","\"Wir werden keine Ruhe geben!\"","Radikal, revolutionär, zerstritten - das ist der SDS. Aber darin herrscht Einigkeit:","","Diethelm Schroeder",[8],3,[1,5],[4],1,"64","24,25"],["2087","1968-04-22","Frankfurter AStA-Chef kündigt Demo gegen Springer-ähnliche Provinzzeitungen an","Es geht weiter","","","",[10],6,[1],[2],2,"44","2"],["2088","1968-04-22","Nachdenklicher Kommentar zu den Kommunikationsproblemen zwischen den Generationen. U. a. Erwähnung von Gewalt ausgeübt von der \"Mehrheit\". Dazu Karikatur, in der sich jung und alt gegenseitig anbrüllen und zugleich die Ohren zuhalten.","Inspektor sagt: Dschungel des Unverstehens","","","Inspektor (Werner Sikorski)",[1],6,[5,4],[1],1,"44","2"],["2089","1968-04-22","Straßentheater auf Wittenbergplatz gegen griechische Militärregierung","Griechenland-Demonstration mit \"Theater\"","","","Rudolf Müller",[1],6,[1],[1],1,"44","3"],["2090","1968-04-23","Mahler hat mit Toten gerechnet. SPD-MdB hat deshalb Maßnahmen gegen ihn geforrdert.","Mit Toten gerechnet","","","dpa",[1],6,[1],[2],2,"32","2"],["2091","1968-04-23","Gründung der DSU (Deutsche Studenten-Union) als Gegenkraft zum SDS","Für sachliche Diskussion","","","dpa,AP",[8],6,[1],[2],2,"32","2"],["2092","1968-04-25","Schadenersatzklage des Axel Springer Verlages gegen Horst Mahler für Demo-Schäden am 11. April 1968.","Mahler soll bezahlen","","","",[10,6,2],6,[1],[2],2,"36","3"],["2093","1968-04-25","Hamburger Bürgermeister Weichmann appeliert an Jugend","Wehrt den Anfängen eines Radikalismus!","","","dpa",[1],6,[1],[2],2,"36","2"],["2094","1968-04-25","Mai-Demo der APO genehmigt","Gegenkundgebung wird genehmigt","","","",[1],6,[1],[2],2,"36","3"],["2095","1968-04-25","Gesundheitliche Fortschritte","Dutschke durfte aufstehen","","","",[2],6,[1],[2],2,"36","3"],["2096","1968-04-26","U.a.: Rechtshilfestelle der APO rät Münchener Demonstranten, gegenüber Polizei, keine Aussagen zu machen.","Studenten sollen nicht aussagen","","","dpa,AP",[10,2],6,[1],[2],2,"42","2"],["2097","1968-04-26","Schütz sagt wegen Vorbedingungen geplantes Treffen mit Studentenvertretern bei der Evangelischen Studentengemeinde ab.","Brauchen sie einen Vormund?","BZ meint:","","",[3],6,[5],[1],1,"42","2"],["2098","1968-04-26","Die Berliner AStA betrachten sich als Teil der APO und wollen Sprecher bei Diskussionen selbst bestimmen.","\"Selbstbestimmung\"","","","dpa",[3],6,[1],[2],2,"42","2"],["2099","1968-04-26","SFB-Redakteure erwirken EV gegen Meschkat","SFB wehrt sich","","","dpa",[9],6,[1],[2],2,"42","2"],["2100","1968-04-29","Antiamerikanische Demonstrationen in mehreren Ländern","So geht es auch!","Unruhen in aller Welt. Prags Studenten gaben ein Beispiel:","","ski",[1],6,[1,5],[1],1,"48","2"],["2101","1968-05-02","Pädagogische Hochschule Berlin gründet Kreis für Mitarbeit bei Hochschulreform, ","Aktionskreis gegen Radikale","","","rb",[4],2,[1],[2],2,"14","4"],["2102","1968-05-02","SDS-Maikundgebung, gemeinsam mit SED und anderen kommunistischen Gemeinschaften, Zitate und Ablauf, Anti-amerikanisch ","Arm in Arm unter der Roten Fahne","","","rb",[1],2,[1],[2],1,"14","2"],["2103","1968-05-03","Man solle Willy Brandt nicht für das Verhalten seines Sohnes Peter verantwortlich machen.","Sein zorniger Sohn kostet Willy Brandt viele Sympathien","","","k.a.",[9],2,[1],[3],1,"14","1"],["2104","1968-05-03","Mehr Verständnis für zornige Söhne und geplagte Väter, Beispiel Willy Brandt und Sohn Peter","Haben Sie nicht auch Sorgen mit Ihren Söhnen?","","","BILD",[9],2,[5],[2],2,"14","1"],["2105","1968-05-03","Ergebnis der Landtagswahlen von BW, Verhalten von Peter Brandt.","\"Der Minister hat den Sohn falsch erzogen\"","","","Leserbriefe",[9],2,[6],[2],2,"14","14"],["2106","1968-05-03","Gesundheitszustand Rudi Dutschke","Dutschke geht es besser","","","rb",[2],2,[1],[2],2,"14","5"],["2107","1968-05-03","VDS legt Forderung der Hochschulreformen vor, legt Wert auf Ruhe und Disziplin, Parole \"Enteignet Springer\" wird abgelehnt. Pressekonzentration auch in der Regionalpresse","Studenten: Stipendien nur nach Begabung","","","Diethelm Schröder",[11],2,[5],[2],2,"14","14"],["2108","1968-05-03","Kritik an Verwendung öffentlicher Mittel durch APO. Was, wenn nun die NPD käme, und Gelder forderte?","Wer zahlt hier für wen?","","","Peer",[1],6,[5],[1],2,"48","9"],["2109","1968-05-04","Gegen Peter Brandt werden sechs Wochen Haft auf Bewährung beantragt. Antrag für \"Kommunarden\" Teufel und Langhans: Haft ohne Bewährung.","Gefängnis für Peter Brandt beantragt","","Staatsanwalt: 6 Wochen auf Bewährung","zy",[9],2,[1],[2],1,"14","2"],["2110","1968-05-04","Vollversammung (VV) in der FU. Debatten zu Personalfragen","Heiße Debatten im FU-Konvent","","","Rudolf Müller",[11],6,[7],[1],2,"36","4"],["2111","1968-05-04","Anzeigen bzw. beantragte Strafbefehle gegen Mahler, Lefèvre, Meschkat, Semmler, Wolf, Brandt, Teufel, Langhans.","TU-Rektor erstattet Strafanzeige","","","L.R.",[1],6,[1],[2],2,"36","4"],["2112","1968-05-06","Keine Einigung bei Wahl zum Asta-Vorsitzenden: SDS gegen RCDS.","Wahl des AStA-Chefs gescheitert","","","rb",[11],2,[1],[2],2,"13","5"],["2113","1968-05-06","Reportage von der FU-Konventssitzung. Rede von Sigrid Fronius mit radikalen politischen Forderungen. Dazu eine Karikatur, in der ein Redner mit SDS-Krawatte Zettel mit Forderungen wie \"Studienreform\" fallen lässt und nur noch jenen mit der Forderung \"Revolution\" behält.","An Gewalt und SED scheiden sich die Geister!","","Wahlen zum AStA-Vorsitz der FU wurden vertagt","Rudolf Müller",[11],6,[7,4],[1],1,"48","2"],["2114","1968-05-07","Alle Meinungen vertreten","Was sind das für Demokraten?","keien","?die wegen Peter Brandt nicht SPD wählen? Das fragen BILD-Leser","Leserbriefe",[9],2,[6],[2],2,"10","7"],["2115","1968-05-08","Bundesregierung will sich stärker in Hochschulpolitik engagieren, Rede Stoltenbergs","Hochschulreform: Bonn will mehr mitreden","","","Jürgen Cieslik",[4],2,[1],[2],2,"12","1"],["2116","1968-05-08","Diskussion im Parlament, weitere Stimmen ","Hochschul-Reform","","","k.a.",[4],2,[1],[2],2,"12","12"],["2117","1968-05-08","Schüler vor Einmischung der APO gewarnt durch Demokratischen Klub, \"Kontrollfunktion über die terroritsischen Maßnahmen der Lehrerclique ausüben\": Flugblatt APO.","Schüler gewarnt !","","","rb",[1],2,[1],[2],2,"12","2"],["2118","1968-05-08","Verhandlungen und Entscheidungen des Bundestages. In einem Beisteller Kritik an den leeren Sitzreihen im Parlament bei diesem für die Jugend so wichtigen Thema.","Grünes Licht für Reformen","","Einigkeit im Bundestag: Aktive Hochschulpolitik","H.O.Bolesch",[4],6,[1],[1],1,"32","2"],["2119","1968-05-09","Ausgang der Wahlen","Sigrid Fronius neue AStA Vorsitzende","","","k.a.",[11],2,[1],[2],1,"10","2"],["2120","1968-05-09","Student wird im Rahmen der Schah-Proteste in der Nähe des Hilton Hotels grundlos zusammengeschlagen, Beamte erhalten Bewährungsstrafe und Geldbuße.","Studenten im Polizeiwagen verprügelt","","4 Monate Gefängnis für Beamte","zek",[7],2,[1],[3],2,"10","4"],["2121","1968-05-09","Konvent zusammengetreten, Wahl noch nicht erfolgt","AStA-Wahlen - zweite Runde","","","R.M.",[11],6,[7],[2],2,"40","3"],["2122","1968-05-10","Wohlrabe (CDU) regt sich über Wahl der neuen AStA-Vorsitzenden der FU Berlin auf, Ziele der neuen AStA-Vorsitzenden, Generalstreik wegen Notstandsgesetzen","\"Als Frau bin ich eine Ausnahme\"","","","rb",[11],2,[1],[2],1,"16","5"],["2123","1968-05-10","Schilderung des Wahlablaufs. Kommentar des JU-Vorsitzenden Wohlrabe (Zwischenüberschrift): \"Unfassbar!\"","SDS siegte bei AStA-Wahl","","Mehrheit für Sigrid Fronius","Rudolf Müller",[11],6,[1,5],[1],1,"48","6"],["2124","1968-05-11","SED Zusammenarbeit mit AStA der TU wird abgelehnt von Studenten. AStA tritt daraufhin zurück.","Proteste an der TU: AStA trat zurück","","","rb",[1],2,[1],[2],2,"10","3"],["2125","1968-05-11","Diskussionststoff ; Papier mit Punkten: Gewalt gegen Sachen, Gewalt gegen Springer-Sachen, Verhältnis zur Presse","SDS für Gewalt gegen Sachen","","30 Schreibmaschinenseiten. Agitationsmaterial für die \"Genossen\"  ","rb",[8],2,[1],[2],2,"10","4"],["2126","1968-05-11","AStA unterliegt in Frage der SED-Zusammenarbeit und tritt zurück","TU-AStA wurde gekippt","","","dpa",[11],6,[1],[1],2,"32","8"],["2127","1968-05-11","Kommentar zum AStA-Rücktritt.","BZ meint: Vernunft bricht sich Bahn","","","",[11],6,[5],[5],2,"32","8"],["2128","1968-05-12","Bis zu 50000 friedliche Demonstranten in Bonn gegen dass Notstandsgesetz","In Bonn blieb alles ganz friedlich","","Notstandsgegner demonstrierten unter roten Fahnen. Kein Polizeieinsatz. Kennedy-Brücke wackelte","F.L.Müller, M.K.Keune, D.Schröder, J.Cielik, E.Lütke, R.Mahkorn",[1],3,[1],[1],1,"56","4,5"],["2129","1968-05-12","Reportage von der Fahrt Berliner Demonstranten zur Bonner Großkundgebung","\"Wasserdampf für Klassenkampf\"","","","K.Albrecht Hinze, Diethelm Schröder, ap",[1],3,[7,2],[5],2,"56","4"],["2130","1968-05-12","Vergleich der Unruhen in Deutschland und Frankreich.","Unter falschen Fahnen","Meinung","","Kurt Dittrich",[1],3,[5],[1],2,"56","8"],["2131","1968-05-14","RCDS distanziert sich von Uni-Streik gegen Notstandsgesetz.","Protest gegen Uni-Streik","","","rb",[1],2,[1],[2],2,"10","3"],["2132","1968-05-14","Studenten verbrennen aus Protest gegen Notstandsgesetze und Nichtteilnahme der Professoren ein Emblem der Uni ","Studenten verbrannten FU-Emblem","","","k.a.",[11],2,[1],[2],2,"8","3"],["2133","1968-05-14","Marcuse berichtet Studenten in der FU von Rekonvalenszenz Duschkes und löst Begeisterung aus","Marcuse bei Dutschke","","","",[2],6,[1],[2],2,"32","6"],["2134","1968-05-14","Nicht als Gegendarstellung bezeichnete Stellungnahme von Fronius zu BZ-Bericht vom 6.Mai.","Die AStA-Chefin nimmt Stellung","","","Sigrid Fronius",[11],6,[6],[1],1,"32","9"],["2135","1968-05-15","Meldung über Nachoperation","Dutschke wurde operiert","","","",[2],6,[1],[2],2,"36","6"],["2136","1968-05-15","Studenten verbrennen nach Marcuse-Veranstaltung ein FU-Emblem: Reaktion Senator Stein.","FU-Emblem verbrannt","","","L.R.",[11],6,[1],[3],1,"36","4"],["2137","1968-05-15","Unterstützung der Notwendigkeit der Reform des Medizinstudiums","Sechs Jahre Studium - dann arbeitslos!","","Forderungen der Medizin-Studenten sind berechtigt","Hans F. Birkenbeul",[4],6,[1,5],[1],1,"36","2"],["2138","1968-05-16","Prozesse gegen Politzei und Studenten","Polizisten angeklagt: Körperverletzung im Amt","","","rb",[1],2,[1],[2],2,"10","2"],["2139","1968-05-16","","Barrikaden vor der Uni","","","Fortsetzung von Seite 1",[1],2,[1],[2],2,"10","10"],["2140","1968-05-16","Studenten demonstrieren bundesweit gegen Notstandsgesetz, Einigung in letzter Minute.","Einigung in letzter Minute","","Koalitiosnparteien schließen Kompromiss zum Notstand","Diethelm Schröder",[1],2,[1],[1],1,"10","1"],["2141","1968-05-16","Sammelmeldung über - nicht nur - studentische Proteste gegen Notstandsverfassung","Überall kam es zu Streiks und Protesten","","","gr",[1],6,[1],[5],1,"36","3"],["2142","1968-05-16","Anklagen gegen Polizisten und Demonstranten nach Ausschreitungen am 2.6.67","Gerichtliches Nachspiel zum 2. Juni","","","Kr",[1],6,[1],[2],2,"36","8"],["2143","1968-05-17","Auseinandersetzungen zwischen Streikenden und Streikbrechern an der Uni Frankfurt","Frankfurt: Neue Tumulte um SDS-\"Streikposten\"","","","gr",[1],6,[1],[5],2,"44","3"],["2144","1968-05-18","TU wählt linken Asta","TU: Wieder linker AStA gewählt","","","rb",[11],2,[1],[2],2,"10","3"],["2145","1968-05-18","Asta der PH München tritt aus dem VDS aus","Keinen Auftrag","","","dpa,UPI",[11],6,[1],[2],2,"32","2"],["2146","1968-05-20","SDS-Zentrale demoliert, Sachbeschädigung und Prügel für zwei Mitglieder die im Haus waren.","SDS-Zentrale demoliert","","","rb",[8],2,[1],[2],2,"10","3"],["2147","1968-05-20","Überfall auf SDS-Büro und APO-Treffpunkt.","SDS-Zentrale demoliert","","Die Täter entkamen","L.R.",[8],6,[1],[3],2,"48","4"],["2148","1968-05-21","Schilderung der Institutsbesetzung. Schilderung der Missstände unter Professor Eckardt. Anhängender Kommentar unterstützt die Studenten.","FU-Institut besetzt","","Studenten wollen Direktor zum Rücktritt zwingen","Rudolf Müller",[11],6,[1,5],[1],1,"32","4"],["2150","1968-05-22","Bildung einer linksliberalen marxistischen Gruppe an der FU","Neue Gruppe an der UNI?","","","rb",[4],2,[1],[2],2,"10","3"],["2151","1968-05-22","Panne bei Personalratswahlen, Hilfskräfte dürfen auch wählen.","Bis zum 29. Mai: Streik an der FU","","","rb",[11],2,[1],[2],2,"10","2"],["2152","1968-05-22","Wegen Streik gegen Notstandsgesetzte Lehrplan ausgesetzt.","FU-Studenten wollen streiken","","","rb",[11],2,[1],[2],2,"10","2"],["2153","1968-05-22","Streike in mehreren Instituten. Akademischer Senat fordert Räumung","Rektor appelliert an die Studenten","Ost-Asiatisches Institut der Freien Universität Berlin weiterhin besetzt","","L.R.",[11],6,[1],[1],1,"40","4"],["2154","1968-05-22","Schütz sagt bei Beantwortung einer kleinen Anfrage, dass missliebige Zeitungsartikel keine Gewalt darstellen und diese auch nicht rechtfertigen.","Senat: Keine Rechtfertigung für Gewalt","","","K.B.",[11],6,[1],[2],2,"40","4"],["2155","1968-05-24","Reportage über Studentenunruhen in Frankreich/Paris","In Paris schläft man am Tag am besten?","","","Dietrich Wild",[9],2,[7],[2],1,"14","14"],["2156","1968-05-24","Cohn-Bendit aus Frankreich ausgeschlossen, SDS will ihn zurückbringen, Streik in Frankreich in Betrieben etc.","SDS: Wir bringen den roten Dany über die Grenze","","Frankreich verbietet dem Studentenführer die Einreise","sad",[8],2,[1],[2],1,"14","1"],["2157","1968-05-24","Otto-Suhr-Institut (OSI) wird von Studenten umbenannt in Karl-Liebknecht-Institut.","Studenten taufen das Otto-Suhr-Institut um","","","rb",[11],2,[1],[2],1,"14","2"],["2158","1968-05-24","Auseinandersetzungen am OSI wegen der Notstandsgesetze","Tumulte an der FU","","","L.R.",[11],6,[1],[5],2,"48","3"],["2159","1968-05-24","Polizei ermittelt NPD-Leute als Schuldige bei SDS-Überfall.","Rechtsradikale wüteten beim SDS","","","bt",[8],6,[1],[2],2,"48","5"],["2160","1968-05-25","FU : Mehrere Institute wollen nicht mehr streiken, etc.","Interesse am Streik lässt nach","","","kh",[11],2,[1],[2],1,"12","2"],["2161","1968-05-25","Sohn von Willi Brandt  wird vor Jugendgericht gestellt. Unter Ausschluß der Öffentlichkeit","Hinter verschlossenen Türen","","","rb",[9],2,[1],[2],2,"12","3"],["2162","1968-05-25","Gericht bestätigt korrekte Vorgehensweise gegen ewige Studenten","Dreimal durchgefallen - Ende des Studiums!","","Gericht: TU feuerte \"ewige Studenten\" zu recht","rb",[11],2,[1],[2],2,"12","3"],["2163","1968-05-25","Vertrauensvotum für Studentenvertretung am OSI gegen SDS","Radikale ohne Mehrheit","Abstimmung am Otto-Suhr-Institut","","Rudolf Müller",[11],6,[1],[1],1,"36","3"],["2164","1968-05-27","Vorschlag zur Befriedung der Situation bei Demonstrationen","Verzichtet auf jede Gewalt!","\"Spielregeln\" für Polizei und Demonstranten - Eindringlicher Appell der Humanistischen Union","","L.R.",[11],6,[1],[1],2,"48","4"],["2165","1968-05-27","Würdigung des Vorschlags der HU","Spät - aber nicht zu spät","","","Peer",[11],6,[5],[5],2,"48","4"],["2166","1968-05-28","Peter Brandt erscheint vor Gericht mit schwarzem Hemd und roter Krawatte, Verteidiger ist Horst Mahler.","Rot und schwarz","","","zek",[9],2,[1],[2],1,"10","2"],["2167","1968-05-28","Streiks und Tumulte an der Uni zwischen Studenten die streiken und Studenten die nicht streiken wollen, Besetzung einiger Institute und Umbennenung, Grund: Notstandsgesetze","Streik von Studenten legt den Lehrbetrieb lahm","","","b",[1],2,[1],[2],2,"10","2"],["2168","1968-05-28","Germanisches Institut der FU ist von Studenten in \"Rosa-Luxemburg-Institut\" umbenannt worden. Foto zeigt Abnahme des entsprechenden Transparents.","keine ","","","",[11],6,[1],[3],1,"32","4"],["2169","1968-05-28","Auslistung unterschiedlicher Aktionen in verschiedenen Berliner Hochschulen und an anderen Orten.","Proteste und Diskussionen in Hochschulen","","","Rudolf Müller",[1],6,[1],[5],2,"32","4"],["2170","1968-05-28","Blutspendeaktion von Studenten mit deren Erlös Kindern Ferien finanziert werden sollen.","Frankfurter Studenten spenden Blut","","","",[9],6,[1],[2],2,"32","4"],["2171","1968-05-28","Handgreifliche Auseinandersetzungen um das besetzte Germanische Institut der FU. Namentlich erwähnt wird Fritz Teufel. (Nur in der zweiten Fassung der Ausgabe)","Prügelei um FU-Institut","Letzte Meldung","","",[11],6,[1],[2],2,"32","32"],["2172","1968-05-28","Nach Audimax-Besetzung muss eine Veranstaltung mit dem britischen Archäologen Wheeler abgesagt werden. Schütz ist empört. Hinweis auf Text im Heft","Skandal in der TU","2000 Studenten verhinderten Ehrung für Englands Königin. Botschafter und Stadtkommandanten mussten umkehren","Prügelei und rote Fahnen im Audimax","",[11],6,[1],[1],2,"32","1"],["2173","1968-05-28","2000 Studenten haben Audimax der TU gestürmt und Festvorlesung eines britischen Wissenschaftlers verhindert.","Audimax der TU gestürmt","Skandal bei \"Queen's Lecture\". Studenten vereitelten Vortrag","","L.R.",[11],6,[7],[1],1,"32","4"],["2174","1968-05-28","Peter Brandt wegen Verdachts des \"Auflaufs\" vor Jugendgericht. Öffentlichkeit ausgeschlossen.","Peter Brandt hinter verschlossenen Türen","","","Kr",[9],6,[1],[5],1,"32","5"],["2175","1968-05-29","Tumulte an der Uni, Streik, Zusammenstöße mit RCDS und Korpsleuten, Wann und Wo sind die nächsten Demos?","Direkte Aktionen","","","rb",[1],2,[1],[2],2,"12","2"],["2176","1968-05-29","Rektor und Prorektor der TU legen Amt aus Protest gegen Studenten und deren Verhalten nieder. Vortrag war trotz anderslautender Verpsrechungen gestört worden.","Dem TU-Rektor reicht es: Er trat zurück","","Auch Prorektor legte Amt nieder","k.a.",[1],2,[1],[1],1,"12","2"],["2177","1968-05-29","Studenten wollen Schiller Theater stürmen um dort über die Notstandsgesetze zu diskutieren, werden von Polizei zurück gedrängt. Besucher bekommen nichts mit. Dann zurück zur TU, dort pro und contra von Studenten zu der Aktion.","Sturm auf das Schiller Theater","Gestern abend: Schwere Zusammenstöße zwischen Polizei und Studenten","Eingangstüre zertrümmert - Beamte zogen die Pistolen","rb",[1],2,[1],[1],2,"12","1"],["2178","1968-05-29","Personalversammlung an der FU ohne Ergebnis, Frage ob Beamte aus Protest gegen den Protest Arbeit niederlegen können","Sichert unsere Arbeitsplätze!","","","kh",[11],2,[1],[2],2,"12","2"],["2179","1968-05-29","SPD will Antrag auf Urabstimmung an der FU stellen","Urabstimmung an der FU","","","rb",[11],2,[1],[2],2,"12","2"],["2180","1968-05-29","Drei Demonstrationen geplant. Demonstranten haben das Recht dazu. Man sollte sich den Argumenten der Demonstranten nicht verschließen, diese dürfen sie einem aber auch nicht auszwingen. Polizei ist nicht das Mittel, politische Konflikte zu lösen.","Politische Bewährung","","","C.W.Caro",[1],6,[5],[1],2,"40","5"],["2181","1968-05-29","Rücktritt von Rektor Weichselberger und Prorektor Gundlach. Stellungnahmen und Reaktionen.","Rektoren traten zurück","Nach dem Skandal an der Technischen Universität","","L.R.",[11],6,[1],[1],1,"40","4"],["2182","1968-05-29","Ein Bürger versucht erfolglos einen Zuständigen zu finden, der eine rote Fahne vom Dach der TU holt. BZ-Kommentator \"hängt das Problem niedriger\" und hofft, dass sich die Mehrheit der Studenten gegen die radikale Minderheit durchsetzen kann.","Fahne oder Bürgerschreck","","","Peer",[11],6,[5],[2],2,"40","4"],["2183","1968-05-29","Hinweis auf Text im Heft","Polizisten zogen Pistolen gegen Studenten","Sturm auf das Schiller-Theater","","",[1],6,[1],[1],2,"40","1"],["2184","1968-05-29","Versuchtes Eindringen von etwa 800 Studenten ins Schiller-Theater, um dort über die Notstandsgesetze zu diskutieren.","Sturm auf Schillertheater","","Hunderte von Demonstranten bedrängten acht Polizisten","L.R.",[1],6,[1],[5],1,"40","4"],["2185","1968-05-29","Abgeordnetenhaus will Gesetz verabschieden, dass Akademischem Senat Recht gibt, Urabstimmungen einzuleiten.","\"Blitzgesetz\" für die FU","","","",[11],6,[1],[2],2,"40","5"],["2186","1968-05-30","Bei Krawallen in Sylvester-Nacht Mütze durch Student entwendet, muss laut Gericht 150 Mark Strafe zahlen","150 Mark für Polizeimütze","","","zek",[9],2,[1],[2],2,"14","5"],["2187","1968-05-30","Weitere Zusammenstöße und Sitzblockaden","Krawalle auf dem Ku`Damm","","","Marianne Büittner",[1],2,[1],[2],1,"14","2"],["2188","1968-05-30","Tumulte und Zusammenstöße auf dem Ku`damm zwischen Studenten, Polizei und Mitarbeitern des Maison de France ","Wieder Krawalle auf dem Ku`damm","keiner","","Marianne Büittner",[1],2,[1],[2],1,"14","1"],["2189","1968-05-30","Reform des Strafrechts","Keine Prozesse gegen Straftäter der Oster-Unruhen?","","Neues politisches Strafrecht beschlossen","k.a.",[1],2,[1],[2],2,"14","9"],["2190","1968-05-30","Strafanzeige wegen Sachbeschädigung bei Demo am Schiller-Theater. Ansprüche gegen vier Demonstranten.","Schadenersatz gefordert","","","rb",[9],2,[1],[2],2,"14","2"],["2191","1968-05-30","Studentenproteste und Streiks in mehreren Großstädten, kaum Arbeiter darunter. Es gibt auch Gegenprotest, Verlauf der Debatte im Bundestag in Bonn","Studentenprotest gegen Studenten","Während die Notstandsgesetze im Bundestag in die letzte Runde gingen: ","","k.a.",[1],2,[1],[2],1,"14","9"],["2192","1968-05-30","Studenten sammeln Unterschriften für Weichselberger, Stein bedauert Rücktritt.","Unterschriften-Sammlung für Weichselberger","","","kh",[9],2,[1],[2],2,"14","2"],["2193","1968-05-30","Zug der Demonstranten entlang der großen Betriebe, wollen Arbeiter dabei haben, keinen Erfolg, ziehen singend zum Bundeshaus, weitere Sitzblockaden an größeren Kreuzungen","Weddinger Arbeiter ließen Demonstranten abblitzen","","","Marianne Büittner",[1],2,[1],[1],1,"14","2"],["2194","1968-05-30","Anriss. Hinweis auf Texte im Heft.","City wurde zum Hexenkessel","Schwarzer Tag für Demonstranten: Arbeiter lehnten Solidarisierung ab","Tausende am Kudamm - Polizei ließ sie leerlaufen","",[1],6,[1,5],[4],1,"40","1"],["2195","1968-05-30","Schilderung des Demoablaufs und der Strategie der Polizei, sich zurückzuhalten. Schilderung eines Vorfalls, bei dem ein Baggerfahrer in die Menge fährt; nach eigener Aussage, um sein Fahrzeug wegzubringen; nach Ansicht der Demonstranten, um gegen sie vorzugehen. Heftige Auseinandersetzungen hierbei.","Hexenkessel City","","","",[1],6,[7,1],[1],1,"40","40,4"],["2196","1968-05-30","Demo zu Weddinger Fabriken führte nicht zur erhofften Solidarisierung der Arbeiter. \"Muss deprimierend sein\".","Das ging daneben","","","Hein Metzger",[1],6,[5],[2],2,"40","4"],["2197","1968-05-30","Vorbereitung und Durchführung der Falken-Demo im Wedding. Keine Resonanz bei den Arbeitern.","Demonstranten blieben unter sich","Anti-Notstandsdemonstration durch Wedding","","Lothar T. Schindlbeck",[1],6,[1,5],[4],1,"40","5"],["2198","1968-05-30","Stimmungsbericht. Schilderung eines Geplänkels zwischen Institutsbesetzern und Demonstranten vor dem Haus.","Bei Rosas wilden Revoluzzern","","","Wolfgang Schöne",[11],6,[7,5],[1],1,"40","8"],["2199","1968-05-30","Unterschriftensammlung zugunsten des zurückgetretenen Rektors","Studenten sammeln Unterschriften","","","",[11],6,[1],[2],2,"40","4"],["2200","1968-05-30","Theater will Demonstranten für Schäden haftbar machen","Schiller-Theater stellte Strafantrag","","","",[1],6,[1],[2],2,"40","4"],["2201","1968-05-31","Plan der SPD für Urabstimmung in FU gescheiert","FU-Urabstimmung auf der langen Bank","","","kh",[11],2,[1],[3],2,"16","2"],["2202","1968-05-31","Akademie ist gesperrt worden, Sachbeschädigung, Direktor verlangt Schadenserstaz","4000 Mark Schaden an der Filmakademie","","Streik beendet","rb",[9],2,[1],[3],2,"16","2"],["2203","1968-05-31","Staatsanwalt beantragt Haft für Peter Brandt","Gefängnis für Peter Brandt? ","","","rb",[9],2,[1],[2],2,"14","3"],["2204","1968-05-31","Bundestagsdebatte und Besetzung der Frankfurter Uni","Mit dem Notstand wird nicht gespielt","","Fortsetzung von Seite 1","k,a",[1],2,[1],[3],1,"16","16"],["2205","1968-05-31","Bericht über eine \"über weite Strecken niveaulose\" Debatte im Abgeordnetenhaus. Zitate einzelner Redner. ÖTV-Chef Schwäbl lobt die \"gesamte Berliner Presse\", deren Berichterstattung zur Zurückhaltung der Bevölkerung und Arbeitnehmerschaft geführt habe.","Trubel im Parlament","Berlins Abgeordnete diskutieren über die vergangenen Studentenunruhen","","Klaus Bär",[1],6,[1],[1],2,"44","3"],["2206","1968-05-31","Polizei hat Anzeige gegen Baggerfahrer erstattet wegen Nichtbeachtung einer polizeilichen Anweisung. Schilderung der Vorfälle aus Sicht des Fahrers.","Anzeige gegen Baggerführer vom Ku'damm","","","U.D.",[1],6,[1],[1],1,"44","4"],["2207","1968-05-31","Lob für Demonstranten, Kritik an radikaler Minderheit, \"ewig Gestrigen Ho-Tchi-Minh-Rufern\".","Dämmerung?","","","Peer",[1],6,[5],[5],2,"44","4"],["2208","1968-05-31","Kurzbilanz zu Schäden und Vorgängen in Hochschulen","Vorlesungsbetrieb fast normal","","","",[1],6,[1],[2],2,"44","4"],["2209","1968-05-31","Kleindemo der Jusos ohne Zwischenfälle","Ruhiger Protest","","","",[1],6,[1],[2],2,"44","4"],["2210","1968-05-31","Die seit vier Tagen von Studenten besetzte Frankfurter Uni wurde geräumt","Uni wurde geräumt","","","",[1],6,[1],[2],2,"44","43"],["2211","1968-05-31","s.o.","Wir spielen nicht mit dem Notstand","","","Klaus Blume und Diethelm Schröder",[1],2,[1],[2],1,"16","1"],["2212","1968-06-04","1500 versammeln sich Pfingstsonntag vor Deutscher Oper mit roten Fahnen und Trauerflor. Jugendliche blockieren zwei Stunden Kranzlereck.","1500 gedenken Benno Ohnesorg ","","","rb",[7],2,[1],[2],2,"10","2"],["2213","1968-06-01","Polizei dringt gewaltsam in Wohnung der Kommune I ein, Kommunarden sollen an Einbruch in das Zulassungsbüro der FU beteiligt gewesen sein, Pawla, Teufel und Gebbert bewerfen Polizei mit Mao-Bibel-Pakteten, werden festgenommen, später wieder freigelassen, keine Beweise. ","Haussuchung bei der Kommune I","","Polizei drang gewaltsam ein/Teufel und Pawla festgenommen","rb",[5],2,[1],[3],1,"10","2"],["2214","1968-06-01","Polizei durchsucht Räume des SDS in Frankfurt auf der Suche nach Material gegen Vorstandt Jürgen Krahl","Die Räume des SDS","","","k.a.",[8],2,[1],[2],2,"10","10"],["2215","1968-06-01","Siegel und andere Unterlagen aus Immatrikulationsbüro der FU gestohlen. Haussuchung bei Kommune 1, Teufel vorübergehend festgenommen, aber wieder freigelassen. Maobibeln und Krähenfüße entdeckt.","Siegel der FU gestohlen","","Haussuchung bei der Kommune ohne Ergebnis","Wolfgang Schöne",[11],6,[1],[1],1,"32","4"],["2216","1968-06-01","Wandschmierereien im wieder zugänglichen Germanischen Institut, \"Radikale\" hätten die Institutsräume in \"Schweineställe\" verwandelt.","Eine Stätte der Lehre","","","A.R.",[11],6,[5],[3],1,"32","4"],["2217","1968-06-01","Polizeipräsident Moch hat Kranzniederlegung für Ohnesorg angeregt, wovon man aufgrund innerpolizeilicher Bedenken dann abgesehen hat.","Guter Wille für die Tat","","","L.R.",[7],6,[1],[2],2,"32","4"],["2218","1968-06-01","Polizeiliche Durchsuchung der SDS-Zentrale in Frankfurt im Ermittlungsverfahren Krahl","Polizei in SDS-Zentrale","","","dpa",[8],6,[1],[2],2,"32","31"],["2219","1968-06-04","Gedenkkundgebung an der Deutschen Oper für Ohnesorg; Demo auf Kudamm","Ein Pfingstsonntag der Gegensätze","","Gedenkfeier und Demonstration","R.M.",[7],6,[1],[5],1,"48","24,25"],["2220","1968-06-05","Studentenunruhen in Belgrad, Besetzung der Phil-Fak., Polizei greift ein, Hochschulreform wird besprochen","Demonstrationen verboten","Bild von Polizist in Belgrad","Aber auch Hochschulreform wird versprochen","k.a.",[1],2,[1],[2],2,"10","10"],["2221","1968-06-05","Unruhen in Frankreich ebben ab, Aufruf Cohn Bendits folgen wenige, Geismars Auto wird bei Ausflug an Pfingsten beschädigt ","Die Revolution ist tot","","Fortsetzung von Seite 1","k.a.",[1],2,[5],[2],2,"10","10"],["2222","1968-06-05","Gerichtliche Voruntersuchung eröffnet","Voruntersuchung gegen Attentäter Josef Bachmann","","","Kr.",[2],6,[1],[2],2,"32","6"],["2223","1968-06-06","Gesundheitszustand Dutschkes, Ärtzte kommen zu Wort, kann bald entlassen werden","Dutschke soll entlassen werden","","","rb",[2],2,[1],[2],2,"13","8"],["2224","1968-06-06","Folgen der Besetzung des Germanischen Seminars. Wer haftet?","FU-Kurator bittet zur Kasse!","Folgen der Besetzung: 20000 Mark Sachschaden","","R.M.",[11],6,[1],[3],2,"40","4"],["2225","1968-06-07","Peter Brandt erhält Arrest für zwei Wochen nach Verhandlung, wird nach dem Jugendstrafrecht verurteilt, fühlt sich daurch \"erniedrigt\", Mahler fordert Erwachsenenstrafrecht für ihn. ","Richterin bescheinigte kindliche Unreife","Zwei Wochen Dauerarrest für Peter Brandt","kene","Hans-Peter Filzek",[9],2,[1],[1],1,"16","6"],["2226","1968-06-07","U-Richter spricht mit Dutschke über Ablauf des Attentats gegen ihn, Bachmann hat Teile des Geständnisses widerrufen ","Untersuchungsrichter sprach mit Dutschke","","","Ne",[2],2,[1],[2],1,"16","7"],["2227","1968-06-07","Dutschke als Zeuge zu Attentat vernommen.","Rudi Dutschke vernommen","","","",[2],6,[1],[2],2,"44","44"],["2228","1968-06-07","Peter Brandt wegen Auflaufs zu zwei Wochen Dauerarrest verurteilt. Jugendrichterin spricht von \"kindlicher Unreife\".","Dauerarrest!","Peter Brandt verurteilt","","Kr.",[9],6,[1],[1],2,"44","9"],["2229","1968-06-07","Republikanischer Club protestiert gegen Brandt-Verurteilung.","APO protestiert","","","",[9],6,[1],[2],2,"44","9"],["2230","1968-06-10","Brandt übt scharfe Kritik an Urteil gegen seinen Sohn, wollte auch kein Jugendstrafrecht, kindliche Unreife sei nicht vorhanden, Weltfremdheit gegenüber Jugend.","Vater Brandt ist verstimmt","Ist Peter unreif?","","",[9],2,[1],[2],1,"14","14"],["2231","1968-06-10","Teufel protestiert zu recht gegen ein Theaterstück über ihn.","Armer Teufel!","Am besten schnell vergessen: Premiere im Forum-Theater","","A. Borski",[5],6,[5],[5],2,"48","12"],["2232","1968-06-11","Bachmann versucht Selbstmord in Gefängnis, Dutschke reist in die Schweiz","Dutschke Attentäter hing in der Todeschlinge","","Schon bewußtlos/Wärter rettete ihn","Horst Zylka und Peter Schmalz",[2],2,[1],[1],1,"8","1"],["2233","1968-06-11","Schadenersatzverhandlung gegen Mahler vertagt","Vertagt nach vier Stunden","","","",[10,6],6,[1],[2],2,"32","3"],["2234","1968-06-11","Selbstmordversuch Bachmanns. Dutschke konnte Krankenhaus verlassen. Hinweis auf Text im Heft","Dutschke-Attentäter wollt sich erhängen","","","",[2],6,[1],[5],2,"32","1"],["2235","1968-06-11","Bachmanns Selbstmordversuch vereitelt. Dutschke begibt sich zur weiteren Erholung in ein Sanatorium in Zürich. US-Kongressabgeordneter forder Einreiseverbot für Dutschke.","Bachmann wollte sterben","","Dutschke-Attentäter in letzter Minute gerettet","L.R.",[2],6,[1],[1],1,"32","4"],["2236","1968-06-11","Befürchtung einer neuen Besetzung. Zusammenstellung der Schäden im Institut","Wieder eine Besetzung an der FU?","Germanisches Seminar:","","Rudolf Müller",[11],6,[1],[1],2,"32","6"],["2237","1968-06-12","HU wirbt um West-Berliner Japanologie-Studenten. Bericht über unhaltbare Zustände am Ostasiatischen Institut der FU. Streik von 60000 Ingenieurstudenten wegen Nichtanerkennung ihrer Prüfung im Ausland: ungeheuerliche Zumutung.","Ost-Berlin wirbt nun um Studenten","","","Rudolf Müller",[1],6,[1],[1],1,"32","4"],["2238","1968-06-13","Demo von Unabhängiger Aktionsgemeinschaft, JU und RCDS der TU gegen DDR-Visagebühren","Studenten riefen zum Protest auf!","Tausende demonstrierten gestern abend gegen Pankows neue Schikane","","L.R.",[1],6,[1],[1],1,"36","4"],["2239","1968-06-13","Linker Protest an Übergang Prinzenstraße gegen neue Zonenbestimmungen von Grenzpolizisten abgewiesen","Grepos wiesen Studenten ab","","","red",[1],6,[1],[5],1,"36","4"],["2240","1968-06-13","Weitere Demo angekündigt","13 Uhr: Neuer Protestmarsch","","","",[1],6,[1],[2],2,"36","4"],["2241","1968-06-13","Streiks gegen Unterbewertung deutscher Ingenieure","Ingenieure wollen Reformen","65000 deutsche Ingenieure an den Akademien fordern ihr Recht","","Rudolf Müller",[11],6,[1],[5],2,"36","6"],["2242","1968-06-13","Unterstützung für das Anliegen der Ingenieure","Ihre Sache - unsere Sache","","","ro",[11],6,[5],[2],2,"36","6"],["2243","1968-06-14","Studenten inkl. SDS, Schüler, Arbeiter demonstrieren gegen Behinderung des Berlin-Verkehrs","2000 demonstrierten an der Mauer","","","Rudolf Müller",[1],6,[1],[1],1,"44","6"],["2244","1968-06-14","Auch Linke haben mitdemonstriert: \"Für uns Westberliner aber die Erkenntnis, dass den sich auch noch so radikal gebärdenden Extremisten unter den Studenten das Gefühl für Recht auf Freiheit, für Gerechtigkeit und für die Realitäten geblieben ist.\"","Immerhin eine Erkenntnis","","","Peer",[1],6,[5],[5],2,"44","6"],["2245","1968-06-15","Rede von Evers in Gauß-Akademie","\"?und das hat Eile\"","","Senator Evers unterstützt die Forderungen der Ingenieur-Studenten","Rudolf Müller",[11],6,[1],[1],1,"32","6"],["2246","1968-06-18","Maßnahmen gegen Probleme bei Ingenieurausbildung","Prüfungsboykott und Streik?","Morgen und übermorgen: Urabstimmung an den Berliner Ingenieur-Akademien","","Rudolf Müller",[11],6,[1],[1],2,"48","6"],["2247","1968-06-21","Bachmann noch im JVA-Krankenrevier","Bachmann noch unter Beobachtung","","","Kr",[2],6,[1],[2],2,"40","6"],["2248","1968-06-21","Stempel in einem Schreibbüro bei einem angeblichen Westberliner SED-Mitglied aufgetaucht.","Gestohlene FU-Stempel wieder da","keie","","L.R.",[11],6,[1],[5],1,"40","3"],["2249","1968-06-21","Ergebnis der Urabstimmung","\"Ingenieure\" für Streik","","kein","",[11],6,[1],[2],2,"40","40"],["2250","1968-06-22","Teufel hat angeblich ahnungsloser Frau Pakete (mit Stempeln) zur Aufbewahrung übergeben","Teufel ließ gestohlene FU-Stempel verstecken","","","ö",[11],6,[1],[3],1,"28","4"],["2251","1968-06-22","Stellvertretender Direktor der Gauß-Akademie äußert Verständnis für streikende Studenten","Verständnis für Studenten","","","",[11],6,[1],[2],2,"28","3"],["2252","1968-06-23","Eierwürfe von Studenten auf Schütz bei Eröffnung der Kieler Woche","Studenten warfen Eier","","","",[1],3,[1],[2],2,"56","10"],["2253","1968-06-25","Bachmann widerruft Tötungsabsicht","Bachmann wird vernommen","","","",[2],6,[1],[2],2,"32","3"],["2254","1968-06-25","Vorlesungsboykott der Ingenieure","Streik geht weiter","","","",[11],6,[1],[2],2,"32","3"],["2255","1968-06-26","Leinwand im FU-Filmstudio zerstört, daher keine Vorführungen möglich. Erster Professor wandert wegen Unruhen an andere Uni ab.","FU-Rektor bedauert","","","",[11],6,[1],[2],2,"36","3"],["2256","1968-06-27","Maßnahme gegen Missstände am Ostasiatischen Seminar","Studenten besetzten das Sinologische Institut","","","Nic.",[1],6,[1],[3],2,"38","4"],["2257","1968-06-28","Nach Polizeiaktionen gegen besetzte FU-Institute stürmen Studenten das Rektorat. Handgreiflichkeiten. Abends Versammlung im Audimax mit Cohn-Bendit.","Tumulte an der FU","","Proteste gegen Polizeiaktionen. Senator Evers wollte vermitteln","L.R.",[1],6,[1],[1],1,"44","3"],["2258","1968-06-28","RCDS will gegen SDS und Reaktionäre in der CDU kämpfen.","Kampf gegen zwei Seiten","","","",[11],6,[1],[2],2,"44","2"],["2259","1968-06-29","Senator Stein konstatiert Vertrauenskrise zum Akademischen Senat der FU wegen der von Rektor Harndt geforderten Polizeimaßnahme.","Senat kritisiert den Rektor der FU","","","Reinhard Losik",[1],6,[1],[1],2,"32","3"],["2260","1968-06-29","Wieder relative Ruhe in der Uni. Versammlung im \"Audi 'Marx'\". Sit-in im Haupteingang der Wirtschafts- und Sozialwissenschaftlichen Fakultät.","Besetzung als Warnung","","","L.R.",[1],6,[1],[3],1,"32","3"],["2261","1968-07-01","Kritik an der Berliner CDU, welche zwar den Senat für sein Verhalten bei den Studentenunruhen kritisiert, selbst jedoch keine Lösung der studentischen Probleme bietet. Auch der RCDS fühlt sich von der CDU im Stich gelassen, Lorenz antwortet darauf, die CDU sei nicht die Vertretung der Studenten, sondern des Volkes. Kommentator kritisiert dies scharf und fragt, ob die Studenten etwa kein Teil des Volkes seien.","Inspektor sagt: Sind sie kein Volk?","","","Inspektor (Werner Sikorski)",[9],6,[5],[1],2,"48","2"],["2262","1968-07-02","SDS-Aktion gegen Innenminister Benda in Kölner Uni","Eier, Farbe, Wasser - doch Benda behielt die Nerven!","","","",[8],6,[1],[3],1,"32","2"],["2263","1968-07-03","Sachliche Diskussion von 600 Studenten im Audimax über OSI-Satzung","FU: Sachliche Atmosphäre","","","Nic.",[11],6,[1],[3],2,"32","4"],["2264","1968-07-04","Go-in in Fakultätssitzung von 40 Studenten in Uni und Rathaus","Studenten zogen zum Rathaus","Wieder Proteste an der FU","","Nic.",[11],6,[1],[1],2,"36","5"],["2265","1968-07-05","Proteste gegen Leiter des Ostasiatischen Instituts haben Erfolg. Ordnungsgemäßer Lehrbetrieb wieder möglich.","Professor Eckardt trat zurück","","","L.R.",[1],6,[1],[5],2,"44","3"],["2266","1968-07-06","Wachmann verhindert Selbsttötung. Hinweis auf Text im Heft.","Er wollte sich den Kopf einrennen","Neuer Selbstmordversuch des Dutschke-Attentäters","","",[2],6,[1],[1],2,"32","1"],["2267","1968-07-06","Zweiter verhinderter Selbstmordversuch Bachmanns innerhalb von vier Wochen","Schon wieder ein Selbstmordversuch","","","ö",[2],6,[1],[5],1,"32","4"],["2268","1968-07-06","Unterschriftensammlung gegen SDS-Nähe des FU-AStA","Unterschriften gegen AStA","","","",[11],6,[1],[2],2,"32","3"],["2269","1968-07-06","Untersuchungsausschuss des Abgeordnetenhauses legt Bericht über Studentenunruhen vor und macht Vorschläge für Reformen an der Uni.","Neue Modelle suchen","","","Klaus Bär",[9],6,[1],[5],2,"32","3"],["2270","1968-07-08","Gegendarstellung von Eckhardt zu BZ-Artikel vom 12.6.68. Redaktionsschwanz.","Prof. Eckardt berichtigt","","","L.R.",[1],6,[6],[2],2,"48","4"],["2271","1968-07-09","Hinweis auf Text im Heft","Dritter Selbstmordversuch des Dutschke-Attentäters","","","",[2],6,[1],[5],2,"28","1"],["2272","1968-07-09","Die Selbsttötungsversuche von Bachmann","Bachmann schluckte Löffelstiel","Dritter Selbstmordversuch des Dutschke-Attentäters","","L.R.",[2],6,[1],[1],2,"28","7"],["2273","1968-07-09","Konservative Studenten wollen Zahlungen an AStA verweigern","Studentenverbände: Kein Geld für den AStA","","","Nic.",[11],6,[1],[2],2,"28","4"],["2274","1968-07-10","Gründung der Linksliberalen Hochschulgruppe","Neue Linke an der FU","","","",[11],6,[1],[2],2,"32","3"],["2275","1968-07-10","Acht APO-Mitglieder vor Gericht wegen Hausfriedensbruchs im Abgeordentenhaus 1967. Teufel, Kunzelmann und Langhans besetzen in Verhandlungspause Richterbank. Verteidiger Mahler greift nicht ein.","Rüpeleien in Moabit","","Kommune sorgt für Tumulte","Kr.",[9,5],6,[1],[1],1,"32","7"],["2276","1968-07-10","OSI-Direktoren treten nach abermaliger Ablehnung eines Satzungsentwurfes zurück","Offene Krise","Otto-Suhr-Institut","","L.R.",[11],6,[1],[2],2,"32","3"],["2277","1968-07-11","Besetzung des FU-Rektorats durch Polizei beendet. Abtransport Verhafteter aufgrund von Straßenblockaden schwierig. Diskussionen im Audimax.","Schwere Tumulte an der FU","","Rektorat wurde verwüstet. 72 Studenten festgenommen. 600 Studenten im Einsatz","",[1],6,[1],[4],1,"32","1"],["2278","1968-07-11","Beschreibung des Hergangs, der Zerstörungen und der Reaktionen von Politikern. ","Rektorat gestürmt","","","L.R.",[1],6,[1],[1],1,"32","4"],["2279","1968-07-12","RA Mahler darf Angeklagte, die des Auflaufs am13.4.67 in der Meinekestraße verdächtigt werden, nicht verteidigen, da ihm Anstiftung vorgeworfen wird.","Mahler darf nicht verteidigen","","","Kr.",[1],6,[1],[3],2,"40","4"],["2280","1968-07-12","Polizeischutz gegen mögliche Besetzungsaktionen","FU unter Polizeischutz","","","",[11],6,[1],[2],2,"40","4"],["2281","1968-07-12","OSI-Professoren sprechen sich für Reformen des Instituts aus.","Professoren für Reformen","","","",[11],6,[1],[2],2,"40","4"],["2282","1968-07-12","Uni geschlossen, da Sicherheit der Dozenten nicht gewährleistet werden kann.","Uni geschlossen","","","dpa",[11],6,[1],[2],2,"40","2"],["2283","1968-07-12","Bericht von einer Abgeordnetenhausdiskussion \"ohne Höhepunkte\". Berechtigung des Unbehagens der Studenten an einzelnen Dingen wird konstatiert, \"terroristische Praktiken linksradikaler Studenten\" werden jedoch als \"pseudo-linker Faschismus\" gebrandmarkt. (Zitat SPD-Abg. Löffler)","Ihr Unbehagen ist nicht unberechtigt","Untersuchungsausschuss über die Situation der Studenten","","Klaus Bär",[9],6,[1],[1],1,"40","4"],["2284","1968-07-16","123 Studenten der FU verweigern Zahlung ihrer AStA-Gebühren","AStA-Gebühren verweigert","","","R.M.",[11],6,[1],[2],2,"28","3"],["2285","1968-07-24","AStA-kritische Linksliberale Hochschulgruppe kritisiert FU-Rektorat wegen Freistellung von AStA-Kritikern von Gebühren.","Kritik am Rektorat","","","",[11],6,[1],[5],2,"32","3"],["2286","1968-07-24","Studenten ermöglichen Großstadtkindern durch Arbeitseinsätze Ferien.","Studenten spenden Ferienfreude","","","",[11],6,[1],[2],2,"32","7"],["2287","1968-07-25","Zahlung von AStA-Beiträgen auf \"Verwahrungs-Konto\" möglich.","Gebühren \"verwahrt\"","","Regelung für AStA-Beiträge","",[11],6,[1],[2],2,"32","5"],["2288","1968-07-30","Drohbriefe, Sachbeschädigungen etc. am Ostasiatischen Institut","Mysteriöse Vorgänge an der FU","","","Rudolf Müller",[1],6,[1],[1],2,"28","3"],["2289","1968-08-05","VDS klagt gegen geplanten Austritt des Münchener AStA","Vor den Kadi","","","UPI",[11],6,[1],[2],2,"44","8"],["2290","1968-08-05","SDS-Chef K. D. Wolff bei Weltjugendfestspielen am Reden gehindert.","Rummel um SDS","","","dpa",[8],6,[1],[2],2,"44","8"],["2291","1968-08-06","Der beim dritten Selbstmordversuch verschluckte Löffelstiel muss operativ entfernt werden.","Bachmann wird operiert","","","H.-J. Nicolai",[2],6,[1],[1],1,"28","6"],["2292","1968-08-06","Teufel beim Grenzübertritt nach Ausweisung aus Österreich, wird als des \"deutschen Bürgers liebster Schreck\" bezeichnet.","Teufel kam barfuß zurück","","","dpa",[5],6,[5],[3],1,"28","28"],["2293","1968-08-06","Studentenvertretung des Ostasiatischen Instituts distanziert sich von mysteriösen Vorkommnissen.","Vorwürfe zurückgewiesen","","","R.M.",[1],6,[1],[2],2,"28","5"],["2294","1968-08-12","Dutschke zu Erholungsaufenthalt in Henzes Ferienhaus in Neapel.","Dutschke Gast von Hans W. Henze","","","",[2],6,[1],[2],2,"44","3"],["2295","1968-08-13","49 FU-Lehrstühle unbesetzt. Von Massenflucht wegen Studenten-Unruhen kann nicht gesprochen werden.","49 Lehrstühle stehen leer","","","",[11],6,[1],[2],2,"28","3"],["2296","1968-08-26","Ankündigung der Revisionsverhandlung beim BGH. Als Ergebnis ist ein neuer Prozess möglich.","Neuer Prozess gegen Kurras?","","","red",[7],6,[1],[1],2,"48","7"],["2297","1968-09-11","Dutschke wieder in Berlin. Zustand ausgezeichnet. Bachmann am Arm operiert.","Dutschke ist wieder in Berlin","","","R.M.",[2],6,[1],[5],2,"36","3"],["2298","1968-09-11","Befristete Regelung für mehr studentische Mitbestimmung in Satzungsfragen an der FU wegen starrer Haltung des Akademischen Senats.","Neue Wege an der Uni","Senat: Studenten sollen mehr Rechte erhalten","","Rudolf Müller",[11],6,[1],[3],2,"36","8"],["2299","1968-09-11","BGH bestätigt Freispruch","Teufels Freispruch bestätigt","Zuhörer protestierten an der falschen Stelle","","Kr.",[5],6,[1],[1],2,"36","7"],["2300","1968-09-16","Störungen von APO-Mitgliedern bei Eröffnung des Museums.","Beat, Protest und schöne Reden","","Eröffnung der Neuen Nationalgalerie","R. Thies",[1],6,[1],[1],1,"48","10"],["2301","1968-09-16","Cohn-Bendit kritisiert SDS wegen unklarer Haltung zu CSSR","SDS unter Beschuß","","","dpa",[8],6,[1],[2],2,"48","2"],["2302","1968-09-18","SDS-Delegiertenkonferenz in Frankfurt wegen politischer Meinungsverschiedenheiten abgebrochen.","SDS gescheitert","","","dpa",[8],6,[1],[2],2,"36","2"],["2303","1968-09-19","Haftbefehl gegen Teufel und anderes APO-Mitglied wegen Fernbleibens vor Gericht bei anderem Verfahren.","Haftbefehl für Teufel","","","Kr.",[5],6,[1],[2],2,"36","4"],["2304","1968-09-21","Tumulte linksradikaler Jugendlicher um Minister Strauß auf Buchmesse. SDS kündigt weitere Störungen an.","Tumulte auf der Frankfurter Buchmesse","","","AP, dpa",[1],6,[1],[2],2,"36","10"],["2305","1968-09-23","Reportage über massive Störungen und Auseinandersetzungen auf der Buchmesse und vor der Paulskirche anlässlich der Friedenspreis-Verleihung, u.a. ist von Terrorakten die Rede.","Straßenschlacht und Friedenspreis","Frankfurt: Schwere Tumulte vor der Paulskirche. Platzt die Buchmesse? Studenten-Führer Cohn-Bendit festgenommen. SDS plünderte Kaltes Büfett","","N.R.",[1],6,[7],[1],1,"48","8,9"],["2306","1968-09-24","Verleger wehren sich gegen den von der Messeleitung Frankfurt angeforderten Polizeischutz","Verleger \"erschrocken\" über den Polizeischutz","","","dpa,AP,UPI",[1],6,[1],[2],2,"32","2"],["2307","1968-09-25","200 Demonstraten stürmen Gericht bei Prozess gegen Teilnehmer an Frankfurter Osterunruhen","SDS stürmte Gerichtssaal","","","dpa,UPI",[8],6,[1],[3],2,"36","36"],["2308","1968-09-26","Prozess gegen Dutschke wegen schweren Landfriedensbruchs während Teufel-Prozesses auf Januar terminiert","Dutschke-Prozess im Januar","","","",[2],6,[1],[2],2,"40","3"],["2309","1968-09-26","Akademischer Senat wehrt sich gegen Reformbestrebungen der Stadt bei der FU","Wirbel um Reformgesetz","FU kontra Senat:","","Rudolf Müller",[11],6,[1],[1],2,"40","4"],["2310","1968-09-26","80 Demonstraten dringen in Kriminalgericht ein, um gegen Prozess wegen Aufruhrs zu protestieren.","Wieder Krawall","","","",[1],6,[1],[2],2,"40","4"],["2311","1968-09-27","Darstellung der Änderungen für die universitäre Selbstverwaltung","Mehr Rechte für Studenten","","Reformgesetze im Parlament verabschiedet","Rudolf Müller",[11],6,[1],[1],2,"48","4"],["2312","1968-09-27","Polizisten wegen Körperverletzung im Amt bei Schah-Demo angeklagt.","Polizisten angeklagt","","","Kr.",[1],6,[1],[2],2,"48","9"],["2313","1968-09-28","Cohn-Bendit wegen Aufruhrs, Land- und Hausfriedensbruchs zu Bewehrungsstrafe verurteilt.","Schnellverfahren","","","UPI",[1],6,[1],[2],2,"36","2"],["2314","1968-10-02","BGH-Entscheidung. Hinweis auf Texte im Heft","Todesschütze Kurras muss wieder vor Gericht","","Freispruch aufgehoben","",[7],6,[1],[1],2,"40","1"],["2315","1968-10-02","Erläutert BGH-Entscheidung","Kurras-Urteil aufgehoben","","","Hans Kricheldorff",[7],6,[1],[5],1,"40","8"],["2316","1968-10-02","Beginn Prozess wegen Landfriedensbruchs am 2.6.68 gegen persischen Studenten","Nächste Woche wieder","","","Kr.",[7],6,[1],[5],1,"40","8"],["2317","1968-10-04","Prozess gegen Teufel und Schlotterer wegen Sit-in im Abgeordnetenhaus und Gottesdienststörung in der Kaiser-Wilhelm-Gedächtniskirche (KWG).","Teufel wieder vor Gericht","","","Kr.",[5],6,[1],[5],1,"48","8"],["2318","1968-10-08","AStA von TU und FU schicken Solidaritätstelegramm an mexikanischen Studentenverband. Kommentaranhang meint, sie sollten nicht so tun, als sprächen sie für alle Berliner Studenten","AStA schickte Telegramm - aber streng vertraulich","","","",[11],6,[1,5],[2],2,"30","2"],["2319","1968-10-08","Haftstrafe ohne Bewährung","Fritz Teufel verurteilt","","Sieben Monate Gefängnis für 25jährigen Kommunarden","Kr.",[5],6,[7],[1],2,"30","6"],["2320","1968-10-09","Dutschke zieht Visumsantrag für USA zurück","Nicht nach Amerika","","","",[2],6,[1],[2],2,"40","40"],["2321","1968-10-09","Proteste angekündigt. Kritik am Konzept des Klinikums","Kritik am Klinikum","","Einen Tag vor der Übergabe eröffneten Studenten den Meinungskrieg","A.Zipzer",[1],6,[1],[1],2,"40","4"],["2322","1968-10-09","Mehrstündige Diskussion auf Germanistentag erzwungen","Proteste beim Germanistentag","","","",[1],6,[1],[2],2,"40","3"],["2323","1968-10-09","Verwaltungsgericht urteilt, dass Einsatz von Polizeiknüppeln am 2. Juni 1967 rechtswidrig war.","Knüppel ohne Gesetz","","","",[1],6,[1],[1],2,"40","5"],["2324","1968-10-09","Aufgrund des Knüppelurteils Kritik am Fehlen gesetzlicher Vorschriften","Aber wie?","","","Günter Mücke",[1],6,[5],[2],2,"40","5"],["2325","1968-10-09","Abgeordnetenhaus startet Reformversuche an den Unis","Gesetz über Reformen","","","",[4],6,[1],[2],2,"40","3"],["2326","1968-10-10","Festakt zur Klinikumsübergabe gestört","Festakt gestört","","","",[1],6,[1],[2],1,"40","4"],["2327","1968-10-10","Kritik an der Form der Proteste","Sie lassen nichts aus?","","","Peer",[1],6,[5],[5],2,"40","4"],["2328","1968-10-10","Fronius will nicht mehr fürs Studentenparlament kandidieren","Will jetzt studieren","","","",[8],6,[1],[2],2,"40","7"],["2329","1968-10-11","60 Demonstranten stören Germanistenversammlung","Erneut gestört","","","",[1],6,[1],[2],2,"48","4"],["2330","1968-10-12","Rentner, der Dutschke in der KWG geschlagen hat, zu Geldstrafe verurteilt","Verurteilt","","","",[3,2],6,[1],[2],2,"32","8"],["2331","1968-10-15","Arbeiter wegen Steinwurfs auf Polizisten vor Springer-Haus verurteilt","Steinewerfer verurteilt","","","",[10,2],6,[1],[2],2,"40","5"],["2332","1968-10-22","Polizist bestreitet Körperverletzung im Amt am 2. Juni","Vorwürfe bestritten","Polizeibeamter vor dem Richter","","Kr.",[1],6,[1],[5],2,"38","7"],["2333","1968-10-24","Fünfter Selbstmordversuch Bachmanns, diesmal mit einem zerbrochenen Messer. Ins Haftkrankenhaus verlegt.","Bachmann verschluckte ein Messer","","","Kr.",[2],6,[1],[2],2,"44","3"],["2334","1968-10-25","Freispruch vom Vorwurf der Körperverletzung im Amt","Polizist freigesprochen","","","Kr.",[1],6,[1],[2],2,"40","5"],["2335","1968-10-26","Studentenvertretungen fordern, ausgefüllte Formulare von Wohnungszählungen bei AStA, nicht aber bei den Zählern abzugben. Senator verbietet Aufruf.","Nur Zähler dürfen Zählen","Stein verbot Studenten-Aufruf","","Rudolf Müller",[11],6,[1],[1],2,"32","5"],["2336","1968-10-28","Wegen Nichtdistanzierung von SDS-Parolen bei Pro-Vietkong-Demo dürfen Ristock und Beck befristet keine SPD-Ehrenämter ausüben.","Keine Ehrenämter","","","dpa",[8],6,[1],[2],2,"48","2"],["2337","1968-10-29","Verschluckte Messer wieder \"ausgeschieden\". Gerichtsverhandlung eventuell Dezember","Verhandlung doch im Dezember?","","","",[2],6,[1],[2],2,"36","4"],["2338","1968-10-29","AStA-Aktion gegen Wohnungszählung kein Erfolg","Studenten zählten kaum","","","",[11],6,[1],[2],2,"36","3"],["2339","1968-10-30","Assistenten einiger FU-Institute protestieren gegen Nichteinstellung von Bernd Rabehl. Harndt meint, er stehe nicht auf dem Boden der Verfassung.","Protest der Assistenten","","","Rudolf Müller",[11],6,[1],[5],2,"44","3"],["2340","1968-10-31","Weitere Assistenten protestieren gegen Nichteinstellung Rabehls. Kritik ausch von Professoren.","Streik an der FU weitet sich aus","","","L.R.",[11],6,[1],[5],2,"44","4"],["2341","1968-11-01","Verurteilung von Enßlin, Baader, Proll und Söhnlein. Tumulte unter Beteiligung von Cohn-Bendit","Brandstifter-Prozess endete mit Tumulten","","Je drei Jahre Zuchthaus für die vier Angeklagten","",[9],6,[7],[1],1,"48","48"],["2342","1968-11-04","Ehrengerichtsverfahren gegen Mahler. Radikale haben zu \"Sturm auf das Landgericht\" aufgerufen. Wem soll das nützen? Kommentator ruft zu Mäßigung auf.","Terror - wem soll das nützen?","","","Peer",[6],6,[5],[3],2,"48","6"],["2343","1968-11-05","Unbekannte Täter haben mit Molotow-Cocktails und etwa 30 Litern Benzin den Stall der Polizeipferde in Grunewald entzündet. Ein Pferd verletzt, die anderen konnten rechtzeitig gerettet werden. Es ist von einem Terrorakt die Rede.","Brandstiftung im Stall der Polizeipferde","Molotow-Cocktail durchs Fenster geworfen","","Wolfgang Schöne",[6],6,[1],[1],1,"36","15"],["2344","1968-11-05","Bei Versammlung in der TU wird in Flugblättern zu Aktionen gegen CDU-Veranstaltung aufgerufen. Anleitung zur Herstellung von Molotow-Cocktails.","Aktionen geplant","letzte Meldung","","",[1],6,[1],[2],2,"36","36"],["2345","1968-11-05","Hinweis auf Texte im Heft","In ihren Gesichtern blanker Hass!","130 Polizisten bei Straßenschlacht verletzt. Aufgepeitschte Jugendliche üben Terror aus","","",[6],6,[7],[4],1,"36","1"],["2346","1968-11-05","Reaktion des Senats und von Politikern auf die sogenannte \"Schlacht am Tegeler Weg\"","Ernste Warnung vor neuer Gewalt","","","Klaus Bär",[6],6,[1],[1],1,"36","3"],["2347","1968-11-05","SPD-Betriebsgruppe der Berliner Hochschulen verurteilt Ausschreitungen","Verurteilt","","","",[6],6,[1],[2],2,"36","3"],["2348","1968-11-05","Linksliberale Hochschulgruppe distanziert sich von Ausschreitungen","Distanziert","","","",[6],6,[1],[2],2,"36","3"],["2349","1968-11-05","Justizsenator und Fraktionen danken Polizei","Dank an Polizei","","","",[6],6,[1],[2],2,"36","3"],["2350","1968-11-05","Man habe es kommen sehen und zugelassen. \"Hier geht es nicht um eine unruhige, rebellische Jugend, die sich gegen die angebliche Trägheit einer Wohlstandsgesellschaft auflehnt. Überhaupt nicht. Hier geht es um Anarchie, um die Zerstörung aller sittlichen und materiellen Werte.\"","Und alles ging nach Plan?","BZ meint:","","",[6],6,[5],[5],2,"36","14"],["2351","1968-11-05","Schilderung des Hergangs. Absicht: Justiz unter Druck zu setzen. Christian Semler bei Nachtreffen im Audimax der TU: wichtigster Erfolg der Aktion sei \"die Bekämpfung von Polizeiketten durch massiven Steinwurf\". Ankündigung, dass mit kleinen Gruppen \"auch privat\" gegen Richter vorgegangen werden soll.","Straßenschlacht am Landgericht","","","L.R.",[6],6,[7,1],[1],1,"36","14"],["2352","1968-11-05","Ehrengericht verhängt keine Strafe","Kein Berufsverbot für Mahler","","","",[6],6,[1],[3],2,"36","14"],["2353","1968-11-05","Bildbericht über die \"Schlacht am Tegeler Weg\" als \"Mahnung und Warnung\", dies sei blanker Terror gewesen.","Das ist offener Aufruhr","","","L.R.",[6],6,[5],[4],1,"36","18,19"],["2354","1968-11-06","Bei CDU-Veranstaltung werden Auseinandersetzungen erwartet. Polizei muss sichern","Heute in der Hasenheide","","","",[1],6,[1],[2],2,"34","4"],["2355","1968-11-06","Terroristen werden lt. Innensenator künftig wie Kriminelle behandelt. Senatsaufruf an Studenten, von Gewalt abzulassen.","Kein Pardon mehr für Terroristen!","Senat","Aufruf an alle Studenten","",[6],6,[1],[1],2,"34","1"],["2356","1968-11-06","Senat will seine Linie verschärfen","Polizei greift durch","Neubauer: Terroristen werden wie Kriminelle behandelt","","Klaus Bär",[6],6,[1],[1],1,"34","4"],["2357","1968-11-06","Juristische Zwischenbilanz der Straßenschlacht","35 Verfahren eingeleitet","","","L.R.",[6],6,[1],[2],2,"34","4"],["2358","1968-11-06","Gewerkschaften mahnen besseren Schutz für Polizisten an","Recht auf Schutz","","","",[6],6,[1],[2],2,"34","4"],["2359","1968-11-06","FU und TU AStA bezeichnen Äußerungen von Presse und Senat \"angesichts der täglichen Gewaltanwendung gegen uns\" als \"zynische Meinungsmache\". Andere Studentenpruppierungen distanzieren sich.","AStA nennt es \"Meinungsmache\"","","","R.M.",[6],6,[1],[3],2,"34","4"],["2360","1968-11-06","Gewerkschaften fordern Strafverfolgung","Kriminelle verfolgen","","","",[6],6,[1],[2],2,"34","4"],["2361","1968-11-06","Versicherungen fordern zur Meldung von Schäden auf","Schäden melden","","","",[6],6,[1],[2],2,"34","4"],["2362","1968-11-06","Rabehl kann Bedenken des Rektors ausräumen und wird an der FU Assistent","\"Stellungskrieg\" an der FU beendet","","","R.M.",[11],6,[1],[2],2,"34","7"],["2363","1968-11-07","Hilfe und Dank für verletzte Polizisten","Scharfe Sachen zur Genesung","","Landgericht und Bürgermeister beschenkten Polizisten","Siegfried Wiechmann",[6],6,[1],[1],1,"40","5"],["2364","1968-11-07","Teils heftige, teils abwägende und kritische Leserbriefe. Im Vorspann teilt die Redaktion mit, dass etliche Zuschriften nicht druckreif waren, diese auch nicht auszugsweise veröffentlicht werden.","Straßenschlacht am Landgericht","BZ-Leser schreiben zum Thema","","",[6],6,[6],[1],2,"40","10"],["2365","1968-11-07","AStA abgewählt, weil Haltung von Studentenschaft nicht gebilligt werden kann","TU-AStA gestürzt","","","",[11],6,[1],[2],2,"40","40"],["2366","1968-11-10","Schütz unterstreicht das Recht auf Demonstrationen in Berlin. Mit APO-Extremisten jedoch keine Auseinandersetzung möglich.","Alle dürfen demonstrieren","","","",[1],3,[1],[2],2,"64","3"],["2367","1968-11-13","Prozesse gegen SDS-Mitglieder in München und Nürnberg wegen Aufruhrs bzw. Landfriedensbruchs","Prozesse gegen SDS","","","dpa",[8],6,[1],[2],2,"40","2"],["2368","1968-11-15","Uni zahlt Vorschuss an AStA. Ein Drittel der Studenten zahl Beitrag nicht.","Vorschuss für den AStA","","","",[11],6,[1],[2],2,"48","3"],["2369","1968-11-15","Wiederwahl des abgewählten AStA (nur in der zweiten Fassung der Ausgabe)","Neuer TU-AStA ist der alte","","","",[11],6,[1],[2],2,"48","3"],["2370","1968-11-16","Feuerwerkskörper gezündet, Assistent hat Hörbeschwerden. Bombendrohung","Zwischenfall an der FU","","","",[11],6,[1],[2],2,"32","3"],["2371","1968-11-16","SDS-Räume am Kudamm demoliert","SDS-Zentrale verwüstet","","","bt.",[8],6,[1],[2],2,"32","3"],["2372","1968-11-23","Schlägerei APO / NPD im Bürgerbräukeller","Schlacht mit der APO","","","AP",[1],6,[1],[2],2,"32","9"],["2373","1968-11-25","Der Rektor der FU Berlin, Harndt, äußert sich zu seiner NS-Vergangenheit, nachdem es zuvor studentische Flugblätter diesbezüglich gegeben hatte. Die Äußerungen der Studentenschaft gegen ihren Rektor würden laut Kommentator dazu dienen, einen Menschen moralisch fertig zu machen. Dies würde an faschistische Methoden im Stile von Goebbels und Streicher erinnern.","Der werfe den ersten Stein","","","Peer",[9],6,[5],[5],2,"48","4"],["2374","1968-11-26","Steinwürfe gegen Häuser und Drohanrufe gegen Richter, die am Klarsfeld-Verfahren beteiligt sind. Ermittlungen gegen Langhans wegen Aufrufs zur \"Justizkampagne\".","Wieder Steinwürfe","","Justiz verurteilt Terror-Aktionen","L.R.",[9],6,[1],[1],2,"36","4"],["2375","1968-11-26","Kommentar zu Angriffen mit Steinen gegen Richter. Schlusssatz: \"Das Recht muss stark genug sein, sich nicht provozieren zu lassen.\" Die Rede ist von politischen Wirrköpfen.","Alles auf einer Linie","","","Peer",[9],6,[5],[5],2,"36","4"],["2376","1968-11-26","Reportage über Verhandlung wegen Sit-in im Abgeordnetenhaus, angeklagt ist Dieter Kunzelmann. Erwartete Ausschreitungen ausgeblieben. Kunzelmann habe dem Richter angedroht, sein Haus anzuzünden, es kümmere keinen, wenn der Richter dabei sterben würde.","Kommunarde in Handschellen","","","Hans Kricheldorff",[11],6,[7],[5],1,"36","4"],["2377","1968-11-29","18 Studenten der Film- und Fernsehakademie wurde fristlos gekündigt, weil sie mehrfach an Gewaltakten gegen die Akademie beteiligt gewesen sein sollen.","18 Studierende mussten gehen","","","R.M.",[1],6,[1],[2],2,"48","4"],["2378","1968-11-30","SFB-Gebäude unter Polizeischutz wegen Protesten gegen Studentenentlassungen aus Akademie","Polizei schützt Filmakademie","","Studenten protestieren gegen Entlassungen","R.M.",[1],6,[1],[1],2,"32","6"],["2379","1968-11-30","Kommentar äußert sich kritisch zu den angekündigten \"massenhaften militanten Aktionen\"","Moment mal!","","","",[1],6,[5],[2],2,"32","6"],["2380","1968-12-01","Polizeichefs beschließen neue Strategie gegen gewaltbereite Demonstranten. Dänischer Journalist Bonde-Henriksen äußert sich APO-kritisch.","Die Polizei soll früher eingreifen","","Neues Tränengas","sei.",[1],3,[1],[2],2,"64","10"],["2381","1968-12-04","SDS bekommt in NRW und Hessen keine staatliche Zuschüsse mehr","Kein Geld für SDS","","","dpa",[8],6,[1],[2],2,"36","2"],["2382","1968-12-03","Aufgrund filmischen Beweismaterials werden Verfahren gegen Demonstranten vom Tegeler Weg eingeleitet. Auswertung noch nicht abgeschlossen.","50 Verfahren eingeleitet","Berliner Landgericht: Film- und Kameratrupps der Kripo arbeiteten erfolgreich","","Mü.",[6],6,[1,4,5],[1],1,"32","3"],["2383","1968-12-04","Versammlung mit 2000 Studenten, auf der \"massenhafte militante Aktionen\" beschlossen werden sollten. Dokumente aus Rektoratsbüro zu entlassenen Studenten verlesen.","Teach-in im Audimax","","","L.R.",[1],6,[7],[1],2,"36","4"],["2384","1968-12-07","In einem Flugblatt des FU-AStA war \"Gewalt als einzig angemessenes Mittel der studentischen Politik\" bezeichnet worden. Wissenschaftssenator erwidert mit einer scharfen Stellungnahme.","\"Extremisten wollen die FU zerstören\"","","Scharfe Erklärung Senator Steins","Rudolf Müller",[1],6,[1],[1],2,"32","4"],["2385","1968-12-09","Solidaritätsaktionen für die entlassenen Filmstudenten","Streik an der Universität?","","","",[1],6,[1],[2],2,"44","7"],["2386","1968-12-10","16 Lehrveranstaltungen wegen Störungen abgebrochen. Weitere Maßnahmen angekündigt.","Störungen halten an","","","R.M.",[1],6,[1],[2],2,"28","3"],["2387","1968-12-11","Zeitweilige Institutsbesetzung gegen Entlassung der Film-Studenten","FU: Unruhe hält an","","","R.M.",[1],6,[1],[2],2,"32","3"],["2388","1968-12-12","Hinweis auf Text im Heft","Prozess gegen Bachmann verschoben","Dutschke-Attentäter hatte Erfolg","","",[2],6,[1],[5],2,"36","1"],["2389","1968-12-12","Wahlverteidiger Bachmanns erkrankt","Bachmann-Prozess verschoben","","Bis zur Genesung des Anwalts","Kr.",[2],6,[1],[1],2,"36","8"],["2390","1968-12-12","Streik für Reformen","Streik an den Akademien","","","",[11],6,[1],[2],2,"36","4"],["2391","1968-12-12","Lehrveranstaltungen nach Störungen abgebrochen. Bei Medizinern mussten Störer abziehen.","Abfuhr für Störer","","","",[1],6,[1],[2],2,"36","4"],["2392","1968-12-13","Wegen Nichtteilnahme der Ingenieurstudenten an der Solidemo für die Filmstudenten, wurde die Demonstration abgesagt.","Demonstration fiel aus","","keie","L.R.",[1],6,[1],[2],2,"44","3"],["2393","1968-12-13","Bestätigung der Urteile gegen Kommune-I-Mitglieder wegen Hausfriedensbruch","Urteile bestätigt","","","",[5],6,[1],[2],2,"44","5"],["2394","1968-12-13","Solidaritäts-Strip für des Hausfriedensbruchs angeklagte Studentin. Freispruch","Massen-Strip im Gericht","","","UPI",[8],6,[1],[2],2,"44","44"],["2395","1968-12-14","Wahlbeteiligung bei FU-Konventswahlen 38,7 Prozent","Kaum Interesse","","","",[11],6,[1],[2],2,"32","3"],["2396","1968-12-14","Geldstrafen wegen Auflauf in zwei Fällen","Geldstrafen für Peter Brandt","","","Hans Kricheldorff",[9],6,[1],[5],2,"32","3"],["2397","1968-12-15","Bei deutsch-amerikanischer Weihnachtsfeier in einer Mannheimer Kirche vermuteten deutsche Teilnehmer Gottesdienststörung wie im Vorjahr in KWG und wollten einen Ruprecht-Darsteller verprügeln.","\"Gammler raus!\" bei der Weihnachtsfeier","","Mannheim: Stilechter Knecht Ruprecht bezog beinahe Prügel","sti.",[3],3,[1],[3],2,"64","10"],["2398","1968-12-15","Tumult in der Uni Kiel bei Stoltenberg-Vortrag","Prügel bei Studenten","","","",[1],3,[1],[2],1,"64","10"],["2399","1968-12-17","Mehrheit in Urabstimmung für Reformsatzung des OSI","Für OSI-Reform","","","",[11],6,[1],[2],2,"32","32"],["2400","1968-12-17","Störungen bei Eröffnung für neue Uni","Scharf verurteilt","","","dpa",[11],6,[1],[2],2,"32","2"],["2401","1968-12-18","Kölner Polizeikapelle demonstriert mit Musikstudenten gegen deren schlechte Unterbringung","Polizei demonstrierte mit Studenten","","","",[1],6,[1],[2],2,"32","32"],["2402","1968-12-18","Lehrbetrieb am Philosophischen Seminar wieder aufgenommen.  Institutsdirektor gegenüber Studenten kompromissbereit.","Bereit zum Kompromiss","","","R.M.",[1],6,[1],[2],2,"32","3"],["2403","1968-12-19","RA Mahler kündigt an, dass Dutschke als Angeklagter nicht zum Prozess wegen Landfriedensbruch erscheinen werde, weil es ihm nicht zuzumuten ist, nach Deutschland zu kommen, wo sein Mandant u. a. aufgrund der \"Pogromhetze der Springer-Presse\" nicht sicher sei.","Rudi Dutschke kommt nicht nach Berlin","","","L.R.",[2],6,[1],[2],2,"36","4"],["2404","1968-12-19","Hausordnungsverfahren gegen Studenten wegen Lehrbehinderung. OSI-Studenten sprechen von \"Terrorakt\"","Verfahren gegen neun Studenten beantragt","","","",[1],6,[1],[2],2,"36","3"],["2405","1968-12-20","Wohl als Folge des Hausordnungsverfahrens: Brandanschlag auf FU-Rektorat, Ankündigung eines studentischen Generalstreiks, Rücktritt des geschäftsführenden OSI-Direktors Völz.","Brandstiftung im FU-Rektorat","","","L.R.",[1],6,[1],[1],1,"44","4"],["2406","1968-12-20","Bauarbeiter befestigen an Gerüst an Uni-Institut studentenkritische Plakate","Arbeiter gegen \"Aktionisten\"","","","dpa",[11],6,[1],[2],2,"44","44"],["2407","1968-12-21","Mahler kündigt im Republikanischen Club \"Kampfaktionen\" gegen die Bundesversammlung in Berlin an. ","Nur hinter Stacheldraht?","","","",[9],6,[1],[3],2,"32","3"],["2408","1968-12-21","Für Januar vorgesehener Prozess gegen Dutschke aufgrund dessen Gesundheitszustand vorläufig eingestellt. ","Dutschke-Prozess verschoben","","","L.R.",[2],6,[1],[2],2,"32","4"],["2409","1968-12-22","Weil Hochschulsenat ungestört tagen wollte, wurde Kölner Uni für sieben Stunden geschlossen. Studenten wehren sich dagegen.","Uni war gesperrt","","","",[11],3,[1],[2],2,"56","9"],["2410","1968-12-27","Bilanz der Feiertage. Siehe Dachzeile","Störaktionen zum Weihnachtsfest","Sturm auf Zuchthaus Tegel. Krawalle während der Gottesdienste. Christusfigur umgestürzt","","Wolfgang Schöne",[3],6,[1],[1],1,"36","5"],["2411","1967-09-16","Schlagabtausch zwischen Albertz und Amrehn wegen des Eindringens von studentischen Störern in das Plenum","Erregt eilte Albertz wiederholt zum Pult","","\"Öffnung nach Osten ist kein Wunderrezept\"","",[1],1,[1],[2],1,"14","10"],["2412","1967-07-06","FU-Rechtsprofessor Herzog nimmt in U-Ausschuss Stellung zu unterschiedlichen Rechtsfragen: Tomaten sind keine Waffen, Polizisten in Zivil müssen sich zu erkennen geben, wenn sie Staatsgewalt ausüben. ","Tomaten sind keine Waffen","","","k.a.",[9],2,[1],[2],1,"10","2"],["2413","1967-07-20","Duensing bleibt auf eigenen Wunsch bis zur Erklärung des U-Ausschusses in Urlaub.","Duensing bleibt im Urlaub","","","rb",[7],2,[1],[3],2,"8","3"],["2414","1967-04-21","Sitzstreik und Blockade nach Sitzung des Akademischen Senats","Rektor der FU alarmiert die Polizei","","Veranstaltung der Asta im Henry-Ford-Bau endete mit Krawallen","hae/ska",[11],4,[1],[1],2,"20","10"],["2415","1967-11-24","Freispruch aus \"subjektiven Gründen\" auf Kosten der Landeskasse Berlin. Der Todesschuss sei eine \"ungesteuerte\", vom Willen des Schützen unabhängige Tat gewesen. Es fehle der Nachweis, dass er anders habe handeln können.","Landgericht spricht Kurras trotz großem Unbehagen frei","","Studenten wollen öffentliche Diskussion","Eigener Bericht",[7],1,[1],[1],1,"28","1"],["2416","1967-11-23","Leitartikel zum Urteil. Das Verfahren sei kein politischer Prozess gewesen, das Gericht habe alles richtig gemacht, in dem es sich auf die Wahrheitsfindung über den tödlichen Schuss beschränkte.","Im Zweifel für den Angeklagten","","","ewe",[7],1,[5],[2],2,"28","2"],["2417","1967-11-22","Bericht von der Urteilsverkündung. Großer Presserummel. Auf den Freispruch gab es lebhaftes Beifallklatschen im Saal, der fast ausschließlich von älteren Menschen besetzt war. Das erstickte der vorsitzende Richter sofort.","Strafkammer: \"Es bleibt ein gewisses Unbehagen\"","","Revision im Kurras-Prozess?","Michael Kreutzer",[7],1,[1],[1],1,"28","3"],["2418","1967-03-23","Numerus Clausus aus Sicht des Wissenschaftsrats unvermeidbar, da immer mehr Studenten an die Unis drängen.","Wissenschaftsrat stellt düstere Prognose für die Universitäten ","","Zahl der Studenten steigt erheblich-Auswahl unvermeidlich ","ems",[11],4,[1],[1],2,"23","1"],["2421","1968-02-07","Kommentator warnt vor Eskalation durch Radikalisierung an den Unis. Aktuelle Gründe für ein möglicherweise nötiges Eingreifen des Staates: \"Das faschistische des Zertrümmerns von Schaufensterscheiben, die Vorführung eines Films über die Herstellung von Molotow-Cocktails, in dem zum Schluss ohne Kommentar das Springer-Hochhaus gezeigt wurde, und die sinnlosen Krawalle des letzten Sonnabends auf dem Kurfürstendamm. Die Empörung über diese drei Ereignisse ist nur zu berechtigt. Die indirekte Aufforderung zu Attentaten gegen das Springer-Haus ist ebenso kriminell wie die nächtlichen Überfälle auf die 'Morgenpost'-Filialen und das Errichten von Barrikaden auf dem Kurfürstendamm...\"","Vor einer Zerreißprobe?","","","pf.",[1],9,[5],[1],2,"12","2"],["2422","1968-02-08","KU-Vollversammlung im Audimax der TU. Thema u. a. die nicht zur Verfügung gestellten Räume für das Springer-Hearing in FU und TU. ","Beifall und Buh-Rufe der \"kritischen Studenten\"","","","Kajo, pf.",[10],9,[1],[5],1,"12","1,2"],["2423","1968-02-09","Verwaltungsgericht hebt Entscheidung des FU-Rektors über Nichtvergabe von Räumen für Springer-Hearing auf.","Gericht hebt Rektor-Entscheidung auf","","","dpa",[10],9,[1],[5],1,"14","2"],["2424","1968-02-10","Meldung über Beginn des Springer-Hearings mit 2000 Teilnehmern, für das die TU den Ernst-Reuter-Saal zur Verfügung gestellt hatte, nach schriftlich zugesichert worden war, dass nicht zu ungesetzlichen Handlungen aufgerufen werden würde. In Hamburg hat eine Anti-Springer-Demo stattgefunden, bei der u. a. eine Toreinfahrt des Verlagshauses angezündet worden ist.","Beginn des \"Springer-Hearings\"","","","dpa",[10],9,[1],[5],2,"12","2"],["2425","1968-02-11","Kommentar zu den zunehmenden Ausschreitungen in der Stadt. Namentlich werden wiederholt Dutschke und Teufel angesprochen. Kritische Meinungen und Auseinandersetzungen sind legitim, aber: \"Das Maß ist voll. Wer nach 1945 die demokratische Ordnung wiederaufgebaut hat, wird nicht länger zusehen. Rechts- und Linksradikale hatten sich schon einmal vereint - um die Weimarer Republik zu zerstören... Wer Steine wirft, Scheiben einschlägt und Autos demoliert, muss damit rechnen, dass die Ordnung - auch gegen ihn - aufrechterhalten wird... Soll es erst dazu kommen, dass eine Selbstjustiz einsetzt? Es sind mehr dazu bereit, als den radikalen Studentengruppen lieb sein kann. Es ist allerhöchste Zeit, dass die Mehrheit der Studenten sich distanziert von denen, die die demokratische Ordnung Berlins zerstören wollen.\"","Die Steine waren zuviel","","","Arno Scholz",[1],9,[5],[1],2,"32","2"],["2426","1968-02-11","Hearing eröffnet und gleich wieder vertagt weil aufgrund der unsicheren Raumsituation wichtige Teilnehmer nicht kommen konnten. Anschließend vierstündige Diskussion mit 1500 Teilnehmern. Direkte Aktionen werden von den meisten Diskutanten gegenwärtig abgelehnt. Ebenso ein Demonstrationzug zum Springer-Haus aus Solidarität mit den Hamburger Anti-Springer-Demonstranten.","\"Springer-Hearing\" vertagt","","","k.m.",[10],9,[1],[2],2,"32","7"],["2427","1968-02-11","Leserin äußert ihr Entsetzen über Begegnung mit gewaltbereiten Demonstranten auf dem Kudamm.","Bürger bedroht","Demonstranten","","Leser",[1],9,[6],[2],2,"32","32"],["2428","1968-02-15","Machtprobe zwischen Senat und linksradikalen Gruppen bei z. Z. noch nicht genehmigten Vietnam-Demo kaum noch zu vermeiden. \"Der Zorn der demokratisch gesinnten Bevölkerung ist nun keineswegs unverständlich.\" Empörung über Leserbrief von Kommune I im FU-Spiegel zu der Armverletzung von Schütz. \"Jeden anständigen Menschen packt bei dieser Lektüre der Zorn. Aber das ist ja gerade die Absicht.\"","Gefährliches Wochenende","","","pf.",[1],9,[5],[5],1,"12","2"],["2429","1968-02-15","Ankündigung des für den folgenden Sonnabend geplanten Vietnam-Kongress und eine anschließende - bislang noch nicht genehmigte - Großdemonstration. Der Senat weist darauf hin, dass eine nichtgenehmigte Demo widerrechtlich ist.","Senat hält an Verbot fest - Konfrontation unvermeidlich?","","Dutschke: Demonstration findet auf jeden Fall statt","",[1],9,[1],[1],2,"12","2"],["2430","1968-02-16","Juristische und politisches Hickhack um Genehmigung von Demonstrationen. Eine von einem SPD-Mann beantragte Kleindemo ist genehmigt worden unter der Auflage, keine SDS-Mitglieder teilnehmen zu lassen.","Die ersten demonstrieren morgen","","Innenverwaltung prüft neuen Antrag für Vietnam-Demonstration am Sonntag","pf.",[1],9,[1],[1],2,"14","2"],["2431","1968-02-16","Kommentator kritisiert die nur teilweise gelungene Art der Entschuldigung des FU-Spiegels für den Bürgermeister Schütz diskriminierenden Leserbrief der Kommune I.","Entschuldigung","","","",[11],9,[5],[3],2,"14","2"],["2432","1968-02-17","Für das Wochenende werden Auseinandersetzungen erwartet. Schütz appelliert an die Berliner: \"Lassen Sie die Extremisten unter sich. Sie erleichtern damit die Arbeit der Polizei! Üben Sie keine Selbstjustiz! Helfen Sie mit, Straftäter festzustellen, die Unsicherheit und Unordnung in die Stadt tragen wollen!\"","Schütz: Appell an die Berliner. Lasst die Radikalen unter sich!","","","pf.",[1],9,[1],[1],2,"12","1"],["2433","1968-02-17","Stellungnahmen aus unterschiedlichen Lagern zu den erwarteten Unruhen.","Harte Fronten in Berlin","","Schütz: Der Senat wird seine Pflicht tun","",[1],9,[1],[1],2,"12","2"],["2434","1968-02-17","Verbot einer Demonstration der Humanistischen Union im Sommer 1967 war rechtswidrig. Wichtige Gerichtsentscheidung zur Versammlungsfreiheit.","Verbot war rechtswidrig","","","AP, dpa",[1],9,[1],[3],2,"12","2"],["2435","1968-02-18","Bericht vom Vietnam-Kongress im Audimax der TU","Kommt es heute zu der Kraftprobe?","","","",[1],9,[1,5],[2],1,"32","1"],["2436","1968-02-18","Kommentator setzt sich mit der kompromislosen Haltung radikaler Studenten zum Vietnamkrieg auseinander. Es ginge gar nicht um Frieden, nicht gegen Gewalt, sondern um den Sieg des Vietkong. Deshalb sei an diesem Wochenende Wachsamkeit der Demokraten wichtig.","Nicht gegen Gewalt","","","Arno Scholz",[1],9,[5],[1],2,"32","2"],["2437","1968-02-18","Schilderung der Atmosphäre während des Vietnam-Kongresses. Probleme bei der Anreise über die Interzonenstrecke. Sozialdemokrat Gerull sagt Separatdemo ab.","Heerlager in der TU","","","",[1],9,[7],[1],1,"32","3"],["2438","1968-02-18","Glosse über einen fiktiven Berufsrevolutionär zwischen politischen Idealen und häuslicher Realität","Die Geschichte von Willi Matuschke, dem Berufsrevolutionär","","","OLAF",[1],9,[2],[1],1,"32","21"],["2439","1968-02-20","Aufruf des Senats, der Parteien und Gewerkschaften zur Teilnahme an der Senatsdemo vor dem Schöneberger Rathaus.","Morgen 16.30 Uhr vor dem Rathaus Schöneberg","","Berlin steht für Freiheit und Frieden","pf.",[1],9,[1],[1],1,"12","1,2"],["2440","1968-02-20","In der SPD wird die Forderung laut, Sozialdemokraten, die an der Vietnam-Demo teilgenommen haben, aus der Partei auszuschließen.","Ausschluss von Ristock und Beck aus der SPD gefordert","","","pf.",[1],9,[1],[3],2,"12","1"],["2441","1968-02-20","Erleichterung über den weitgehend friedlichen Verlauf der Demo am Wochenende. Hinweis auf die Absichten der Senatsdemo","Bilanz eines Wochenendes","","","pf.",[1],9,[5],[5],2,"12","2"],["2442","1968-02-20","Schilderung des Verlaufs der Demonstration und des Volkszornes, der sie \"verfolgte\". Trotz kleinerer Auseinandersetzungen insgesamt ruhig.","Ohne Steine und Knüppel","","","Heino Eggers",[1],9,[1],[1],1,"12","3"],["2443","1968-02-21","Abermaliger Aufruf zur Teilnahme an der Senatsdemo. Stimmen verschiedener Politiker.","Heute haben die Berliner das Wort","","","pf.",[1],9,[1],[1],2,"12","1,2"],["2444","1968-02-21","Der amerikanische Stadtkommandant lobt in einem Brief an Schütz den Einsatz der Polizei bei der Vietnam-Demo.","Lob für die Berliner Polizei","","","dpa",[1],9,[1],[2],2,"12","1"],["2445","1968-02-21","Wegen Aussageverweigerung wurden sechs SDS-Mitglieder mit Geldstrafen belegt. Dutschke erhielt zusätzliches Strafgeld wegen ungebührlichen Verhaltens. Er hatte den Abgeordneten Wohlrabe einen \"exemplarischen Faschisten\" genannt.","Geldstrafe für SDS-Mitglieder","","","pf.",[7],9,[1],[2],2,"12","1"],["2446","1968-02-21","Wegen Aussageverweigerung wurden sechs SDS-Mitglieder mit Geldstrafen belegt. Dutschke erhielt zusätzliches Strafgeld wegen ungebührlichen Verhaltens. Er hatte den Abgeordneten Wohlrabe einen \"exemplarischen Faschisten\" genannt. Hier ausführlicher dargestellt.","Peinliche SDS-Pannen","","Bestraftes Schweigen vor dem Untersuchungsausschuss","pf.",[7],9,[1],[1],2,"12","8"],["2447","1968-02-21","Teufel und Peter Urbach müssen sich wegen Werfens von Feuerwerkskörpern und Missachtung des Gerichts verantworten. Geplänkel zwischen Teufel, dem Staatsanwalt, Verteidiger RA Schily über die Verhandlungsführung.","Dialog mit dem Teufel","Im Moabiter Gerichtssaal:","","Heino Eggers",[5],9,[1],[1],2,"12","12"],["2448","1968-02-22","Bericht von der Senatsdemo. Diverse Redenauszüge. Hinweis auf Ausschreitungen gegen Andersdenkende.","Berlins machtvolles Bekenntnis zum demokratischen Rechsstaat","","","pf.",[1],9,[1],[1],1,"12","1,2"],["2449","1968-02-22","Kritik an Ausschreitungen am Rande der Kundgebung.","Trübe Schatten auf hellem Bild","","","w.w.",[1],9,[5],[2],2,"12","2"],["2450","1968-02-22","Stimmungsbild von der Demo. Pro- und Contra-Stimmen","Am Rande der Kundgebung","","","W.H",[1],9,[1],[1],1,"12","3"],["2451","1968-02-22","Zahl der Festgenommenen. Auswüchse richten sich immer wieder gegen \"Dutschke\".","Bedauerliche Szenen","","","Kajo ",[1,10],9,[1],[2],2,"12","3"],["2452","1968-02-25","Vietnam-Demo war keine Friedenskundgebung, sondern eine antiamerikanische und prokommunistische Demonstration. Gegenbild war Senatsdemo. Bedauerlich hier die Ausschreitungen. Aber: \"Wer jedoch hier Randereignisse zum eigentlichen Geschehen sich zu machen bemüht..., der muss doch einmal an die alte Weisheit erinnert werden: Wer Wind sät, wird Sturm ernten.\"","Notwendige Rückblende","","","w.w.",[1],9,[5],[1],2,"32","2"],["2453","1968-04-12","Betroffene Reaktionen und Stellungnahmen von Politikern aller Parteien. Schuldzuweisungen an Springer und den Senat durch SDS und eine Vertreterin der \"Jungen Linken\" in der SPD: \"?die 'hemmungslose Hetzkampagne' des Westberliner Senats und der 'Springer-Presse' gegen die Minderheiten habe alle Oppositionellen zum 'Freiwild' gemacht.\"","Berlin: Rudi Dutschke auf der Straße niedergeschossen","","Täter von der Polizei überwältigt","dpa,ap",[2],9,[1],[1],1,"24","1,2"],["2454","1968-04-12","Für Mord gibt es keine politische Rechtfertigung. \"Gerade war der 'Rummel' um Rudi Dutschke etwas abgeebbt. Er fand Kritiker in seinen eigenen Reihen. Die Schüsse von Berlin sind geeignet, Differenzen zu verwischen und Fronten erstarren zu lassen.\" ","Die Schüsse von Berlin","","","w.w.",[2],9,[5],[2],2,"24","2"],["2455","1968-04-14","Bericht über Demonstrationen und Ausschreitungen gegen Häuser, Druckorte und Lieferfahrzeugedes Springer-Verlages in Berlin und anderen deutschen Städten.","Massenfestnahmen in Berliner Innenstadt","","","",[10,2],9,[1],[1],1,"32","1"],["2456","1968-04-14","Über den Gesundheitszustand des Opfers","Dutschke geht es besser","","","",[2],9,[1],[2],2,"32","1,2"],["2457","1968-04-14","Bericht über Demonstrationen und Ausschreitungen gegen Häuser, Druckorte und Lieferfahrzeugedes Springer-Verlages in Berlin und anderen deutschen Städten.","Die Nacht der Unruhen","","","AP, dpa",[10,2],9,[1],[1],1,"32","2"],["2458","1968-04-14","SPD verurteilt Attantat auf Dutschke und die \"schweren terroristischen Ausschreitungen gegen Zeitungen und Druckereien\".","SPD verurteilt Ausschreitungen","","","dpa",[10,2],9,[1],[2],2,"32","2"],["2459","1968-04-14","Erste Aussagen Bachmanns. Portrait des Attentäters.","Der Attentäter malte Adolf Hitler","","Bachmann plante \"etwas ganz Schreckliches\"","Kajo",[2],9,[1],[1],1,"32","3"],["2460","1968-04-14","Angriffe auf Springer-Objekte und Lieferfahrer. Unruhen auch an anderen Orten.","63 Festnahmen. 30 verletzte Beamte","","","reut",[10,2],9,[1],[5],2,"32","3"],["2461","1968-04-17","Geforderte bzw. eingeleitete Verfahren wegen Unruhen. Namentlich wird Wolfgang Lefèvre genannt.","Koalition fordert Anklagen gegen kriminelle Rädelsführer","","","dpa,ap",[10,2],9,[1],[1],1,"32","1"],["2462","1968-04-17","Fotograf Klaus Frings bei Münchner Anti-Springer-Krawallen durch Steinwurf verletzt.","Fotoreporter bei Krawallen schwer verletzt","","","",[10,2],9,[1],[2],1,"32","1"],["2463","1968-04-17","Nach Anti-Springer-Demo in München Vorbestrafter wegen Aufrufs und Auflaufs verurteilt.","Erster Demonstrant verurteilt: 7 Monate","","","AP, dpa",[10,2],9,[1],[2],2,"32","1"],["2464","1968-04-17","Bewertung der Osterkrawalle. U. a.: \"Die Aktionen richteten sich in Berlin und auch in anderen Städten des Bundesgebietes gegen Springer-Zeitungen. Wahrscheinlich ist der Unmut dadurch ausgelöst worden, dass es seit mehr als drei Jahren eine Diskussion über Pressekonzentration gibt und viele Kommissionen eingesetzt wurden, sie zu untersuchen, aber bisher keine zu wirklich greifbaren Resultaten gekommen ist. Sie sind auch nicht leicht zu finden, denn den Großverlagen - nicht nur Springer - die eine Pressekonzentration betrieben haben, ist kein gesetzwidriges Handeln vorzuwerfen. Sie bieten täglich ihre Ware, sehr häufig sogar allein, im Straßenverkauf an. Wer nicht will, muss ja diese Zeitungen nicht kaufen. Es ist etwas naiv, sich vorzustellen, dass Käufer dieser Zeitungen dadurch umgestimmt werden, dass Wagen, die diese Zeitungen transportieren, umgeworfen und angesteckt werden. Wahrscheinlich wird dadurch eine gegenteilige Reaktion ausgelöst.\"","Freiheit ja - aber nicht Zügellosigkeit","","","Arno Scholz",[10,2],9,[5],[1],2,"32","2"],["2465","1968-04-17","Situation nach den Unruhen. U a. Beschwerde Neven DuMonts bei BDZV über BamS-Berichterstattung.","Die meisten sind wieder frei","","Rudi Dutschke geht es besser - Schütz dankt der Polizei","dpa, AP, EB",[10,2],9,[1],[1],2,"32","2"],["2466","1968-04-17","Diskussionen auf dem Hammarskjöldplatz u. a. mit Ralf Dahrendorf und Knud Nevermann, der Gewalt gegen Menschen ablehnt.","Abkehr von Gewalt","Versuch eines neuen Anfangs","","Wolfgang Lehmann",[1],9,[1],[1],1,"32","3"],["2467","1968-04-18","Nach dem Tod des bei der Münchener Anti-Springer-Demo verletzten Fotografen ermittelt die Mordkommission.","Klaus Frings erlag seinen Verletzungen","","","AP, dpa",[10,2],9,[1],[5],1,"12","1"],["2468","1968-04-18","\"Fast im gleichen Augenblick, in dem der Münchener Bildjournalist Klaus Frings seinen durch einen Steinwurf erlittenen Verletzungen erlag, bekannten sich in Berlin der AStA der TU, der FU und der Kirchlichen Hochschule zu 'Gewaltanwendung als legitimes Mittel zur politischen Auseinandersetzung'. Sie verstehen darunter Gewalt gegen Sachen, nicht gegen Personen.\" Kommentator zitiert auch Peter Brandt, der sich in der \"sun\" u. a. auch gegen seinen Vater gewandt hat.","Gewalt führte die Hand","","","Arno Scholz",[1],9,[5],[1],2,"12","2"],["2469","1968-04-18","Überblick über aktuelle Beratungen und Äußerungen zu Studentenunruhen. Auch zu den Angriffen auf Springer-Einrichtungen.","Bonn erwägt kein SDS-Verbot","","","AP, dpa",[1],9,[1],[5],2,"12","2"],["2470","1968-04-18","Brandt-kritische Äußerungen von Peter Brandt in der \"Sun\".","Wirbel um Brandt-Sohn","","","dpa, AP ",[9],9,[1],[3],2,"12","2"],["2471","1968-04-19","Nach dem Fotografen Klaus Frings ist nun auch der in München verletzte Student Rüdiger Schreck gestorben. Reaktionen.","Trauer und Bestürzung über zweites Todesopfer der Münchener Krawalle","","","AP, dpa",[10,2],9,[1],[5],1,"16","1"],["2472","1968-04-19","Regierender Bürgermeister warnt nach Tod des Münchener Studenten vor Hysterie und Kurzschlussreaktionen. Erläutert die Haltung des Senats.","Schütz warnt vor Hysterie und Terror","","Dank an Polizei und Bevölkerung","",[1],9,[1],[1],2,"16","1"],["2473","1968-04-19","Politiker sagen geplante Diskussion mit APO-Mitgliedern ab, weil aus deren Reihen erneut Aufforderungen zur Anwendung von Gewalt ergangen waren.","Schütz und Neubauer sagen Diskussionen ab","","","",[1],9,[1],[3],2,"16","1"],["2474","1968-04-20","Bereits angemeldeter Trauermarsch zum Gedenken an die Münchener Demo-Opfer wurde abgesagt, da keine gemeinsame Haltung zur Frage der Anwendung von Gewalt gegen Sachen erzielt werden konnte. Reaktionen.","Studenten sagten Trauermarsch ab","","","AP, dpa",[10,2],9,[1],[1],2,"12","2"],["2475","1968-04-20","Demoabsage. \"Die in der Nacht zum Freitag in der Freien Universität tagenden etwa tausend Studenten wollten von ihren bisherigen Methoden zur Gewaltanwendung gegen Sachen und Institutionen (Personen ausgenommen) nicht abrücken, sahen aber unter diesen Umständen keine Möglichkeit, der Bevölkerung verständlich zu machen, warum sie dennoch die Opfer derartiger Unternehmungen betrauert.\" Kommentator erörtert die Frage der Gewaltanwendung.","Das Dilemma","","","w.w.",[10,2],9,[5],[2],2,"12","2"],["2476","1968-11-01","US-Soldaten von TU-Studentenvertretung \"in unverantwortlicher Weise provoziert worden\": Mehrheitlich war ein Aufruf zu Desertion verabschiedet worden.","Studenten provozieren US-Schutzmacht","","","EB, dpa",[11],9,[1],[3],2,"16","1"],["2477","1968-11-01","Tumultartige Szenen bei Urteilsverkündung gegen Ensslin, Baader, Proll und Söhnlein wegen vorsätzlicher versuchter menschengefährdender Brandstiftung in Frankfurt.","Schwere Tumulte im Gerichtssaal","","Zuchthaus für die Kaufhaus-Brandstifter","dpa",[9],9,[1],[1],1,"16","5"],["2478","1968-11-02","Brandanschlag auf Frankfurter Gerichtsgebäude nach Urteilsverkündung gegen Ensslin, Baader, Proll und Söhnlein.","Molotow-Cocktails gegen Gerichtsgebäude","","","AP, dpa",[9],9,[1],[1],2,"16","13"],["2479","1968-11-03","Demoaufruf wegen Mahler-Verfahren. Auflistung der verschiedenen Vorwürfe gegen Mahler, u.a. Schadenersatzforderung des Springer-Verlages über 506000 DM nach Osterunruhen in der Kochstraße.","APO will Mahler \"verteidigen\"","","","H. Eggers",[6],9,[1],[1],2,"32","10"],["2480","1968-11-05","\"Mit allgemeiner Empörung sind in Berlin die schweren Gewalttätigkeiten aufgenommen worden, die sich gestern vormittag am Landgericht am Tegeler Weg und an der Schlossbrücke entwickelten. Was als Demonstration für den APO-Rechtsanwalt Horst Mahler gedacht war, entwickelte sich zu einem blutigen Aufruhr...\" Reaktionen von Politikern.","Abscheu und Empörung über radikale Rowdys","","","",[6],9,[1],[1],1,"12","1,2"],["2481","1968-11-05","\"Die außerparlamentarische Opposition (APO) sah sich veranlasst, den Fall Horst Mahler aufzugreifen, um wieder einmal von sich reden zu machen und ihrem Publicity-Drang Geltung zu verschaffen. ?es ging ihnen darum, Krawall zu machen, gewalttätig zu werden. Und so wurden notwendigerweise die Vorgänge ... zu einem kriminellen Delikt umfunktioniert.","Am Ende der Geduld","","","w.n.",[6],9,[5],[1],2,"12","2"],["2482","1968-11-05","Details der Verhandlung gegen Mahler mit wörtlichen Zitaten. Mahler-Verteidiger Augstein u. a. zum Dutschke-Attentat: \"Dieses Attentat wurde der Springer-Presse in die Schuhe geschoben.\"","Kein Berufsverbot für Horst Mahler","","","Heino Eggers",[6],9,[1],[5],2,"12","3"],["2483","1968-11-05","Schilderung der Eskalation am Tegeler Weg. \"Aus der Demonstration wurde in Sekundenschnelle eine Aggression. Polizei setzt erstmals Tränengas ein. Anwohner schütten Wasser auf die Demonstranten. Schadensbilanz.","Blutige Straßenschlacht","","","Kajo",[6],9,[1],[1],1,"12","3"],["2484","1968-11-06","Reaktionen aus Politik, Verbänden und Universitäten zu den Vorkommnissen am Tegeler Weg. Innensenator warnt vor Schusswaffengebrauch durch Polizei.","Senat warnt Terroristen","","","pf.",[6],9,[1],[5],2,"12","1"],["2485","1968-11-09","\"Die Sozialdemokraten wollen künftig gegen die Terroraktionen der außerparlamentarischen Opposition vorgehen.\" SPD-Präsidium veröffentlicht dazu in Bonn eine \"äußerst scharfe Erklärung\". ","SPD: Kampf gegen den Terror","","","dpa",[6],9,[1],[1],2,"12","1"],["2486","1968-01-07","300 Demonstranten. Auseinandersetzungen mit der Polizei. Bürgermeister verweigert Zutritt zum Kurhaus. Dutschke mit Megaphon in Orchestermuschel im Kurgarten.","Tumult vor dem Kurhaus","","Dutschke und Gefolge randalierten in Baden-Baden","Ne.",[2],5,[1],[2],2,"32","2"],["2487","1968-01-07","Evangelische Kirche trägt durch ihre zunehmende Politisierung Mitschuld an den Vorkommnissen in Neu-Westend und in der KWG. Bischof Scharfs Vorgehen wird dem von Bischof Dibelius gegenübergestellt.","Toleranz für die Kanzel-Stürmer?","","Ein offenes Wort zu den Vorgängen in der Gedächtniskirche","H. G. von Studnitz",[3,2],5,[5],[1],1,"32","4"],["2488","1968-01-07","Handgemenge mit Kommunarden, Taxifahrern u. a. vor Palais am Funkturm","Störtrupps auch vor dem \"Juristenball\"","","","lbn, s.",[5],5,[1],[2],2,"32","27"],["2489","1968-01-07","In einer Radiosendung für Jugendliche spricht Schütz \"lautstarken extremen Gruppen\" Diskussionsbereitschaft ab. Will künftig nur noch mit \"Vernünftigen\" reden.","Schütz: Nur mit \"Vernünftigen\"","","","lbn.",[9],5,[1],[2],2,"32","29"],["2490","1968-01-14","Kommentator stellt Protesten für Gedankenfreiheit den Studentenunruhen in Deutschland gegenüber","Gedankenfreiheit","","","Horst Eliseit",[1],5,[5],[5],2,"34","2"],["2491","1968-01-14","\"Arbeitskreis zum Schutz der Freiheit von Forschung und Lehre\" und \"Vereinigte Arbeitsgemeinschaften an der Freien Universität\" wollen versuchen, den Radikalen Paroli zu bieten.","Aktionen gegen FU-Radikale. Zwei Gruppen werden aktiv","","Ziel: Ein vernünftiger Kurs an der Freien Universität - Werben um \"Mitläufer\"","Martin Pfeideler",[1],5,[1],[5],2,"34","34"],["2492","1968-01-21","Kommentator kritisiert die deutsche Rechtsprechung, der er das Messen mit zweierlei Maß unterstellt: der Normalbürger kommt schlechter weg als das, das er Dutschkerei nennt.","Ist die deutsche Justiz ritterlich?","","","William S. Schlamm",[9],5,[5],[5],1,"34","5"],["2493","1968-01-21","FU-Konventsvorsitzender Lefèvre hat Rückmeldung vergessen.","Ein Student, der keiner ist","","","Wolfgang Voss",[11],5,[2],[2],2,"34","I"],["2494","1968-01-28","SDS-Mitglieder stören Musikveranstaltung in Heidelberger Uni","SDS stört in Heidelberg","","","dpa",[8],5,[1],[2],2,"40","2"],["2495","1968-01-28","Fünf Leserbriefe zum Schlamm-Kommentar zur Rechtsprechung: einer kritisch, vier teile enthusiastisch.","Die Justiz und Dutschke","","","Leser",[9],5,[6],[2],2,"40","4"],["2496","1968-02-04","Scheiben mehrerer Ullstein-Filialen durch Steinwürfe zerstört. Reaktionen von Politikern unterschiedlicher Parteien. ","Steinwürfe scharf verurteilt","","Politiker: In Berlin wirkungsvoll durchgreifen - Täter fotografiert","KHS., N.",[10],5,[1],[5],2,"40","1"],["2497","1968-02-04","Störung und Belagerung von Professorensitzungen an der FU erinnern Kommentator an Methoden der SA.","Das ist keine Demokratie","","","Herbert Hausen",[1],5,[5],[2],2,"40","2"],["2498","1968-02-04","Dekan der Philosophischen Fakultät der FU, Prof. Loos, beklagt Gewaltakte in der FU.","Terror studentischer Minderheit","","","Leser",[11],5,[6],[2],1,"40","4"],["2499","1968-02-04","Acht Leserbriefe zu Schlamm-Kommentar, teils kritisch","Sucht die Jugend Autorität?","","","Leser",[1],5,[6],[2],2,"40","4"],["2500","1968-02-04","Zitate von Richard Stücklen, Helmut Schmidt, Wolfgang Mischnik, Ernst Lemmer, Johann Baptist Gradl, Ernst Scharnowski, Kurt Mattick und Hans-Günter Hoppe zu den Angriffen auf die Ullstein-Filialen","Stücklen erklärt: Übles Rowdytum","","Politiker äußern sich zu Vorgängen in Berlin","KHS., N.",[10],5,[5],[1],2,"40","5"],["2501","1968-02-04","Krawalle in Kiel und Frankfurt am Main, wo Dutschke ein Teach-in ankündigt.","Mit Eiern gegen Polizisten","","Aus Fahrpreis-Protesten wurden massive Krawalle","",[1],5,[1],[2],1,"40","5"],["2502","1968-02-04","Das Aufbrechen der Tür zu einem Sitzungszimmer in der FU wird kritisiert. In der Bildunterschrift wird FU-Präsident Harndt zitiert: \"Auf diesem Wege haben sich einst SA-Männer Zutritt in die Wohnung jüdischer Bürger verschafft.\" Prof. Ernst Fraenkel:\" Ich möchte ganz deutlich sagen, dass die sogenannte Springerpresse sich gerade dadurch ein bleibendes Verdienst erworben hat, dass sie frühzeitig und nachdrücklich auf die Gefahren hingewiesen hat, die der Stadt Berlin und ihren Universitäten aus dem unverantwortlichen Treiben einer zum Teil fanatisierten und radikalisierten Studentenschaft erwachsen wird.\"","Schluss jetzt mit dem Terror!","Wie geht es weiter an der Freien Universität? Welt am Sonntag befragte die Professoren","","Hans-Erich Bilges",[11],5,[1],[1],1,"40","35"],["2503","1968-02-04","Wilde Demonstration nach Protest vor griechischer Militärmission. Festnahmen und Verletzte. Senator Naubauer: \"Mit diesem Spuk muss endlich Schluss gemacht werden.\"","City: 1000 Polizisten im Einsatz","","Schwerpunkt war das Kranzler-Eck - Hier fuhren acht Wasserwerfer auf","",[1],5,[1],[5],1,"40","35"],["2504","1968-02-11","Schütz über die Notwendigkeit der Bekämpfung \"terroristischer Auswüchse\" ","Der Terror wird bekämpft","","Bürgermeister Schütz vor Berliner Sozialdemokraten","",[1],5,[1],[2],2,"44","1"],["2505","1968-02-11","Springer-Hearing wegen Nichterscheinens zahlreicher \"Gutachter\" vertagt. In einer Resolution werden repressive Maßnahmen des Senats verantwortlich gemacht.","\"Hearing\" geplatzt","","","N.",[10],5,[1],[2],2,"44","2"],["2506","1968-02-11","Gastbeitrag eines CDU-MdB, der die wehrhafte Demokratie gegen Terrorgruppen und radikalisierte Proteste empfiehlt.","Kein zweites Weimar?!","","Die parlamentarische Demokratie muss sich jetzt wehren","Werner Marx",[1],5,[5],[1],1,"44","4"],["2507","1968-02-11","Zunehmende Radikalisierung des SDS. Aufrufe zu Gewaltaktionen. Forderung nach Redaktionskontrolle bei Springer durch studentische Kontrollkommissionen, ggf. mit erzwungener Duldung durch Geleit-Kommandos. Erwähnung des Films über den Bau von Molotow-Cocktails mit Bild vom Springer-Haus.","SDS greift zur Guerillataktik","","","Curt Reuter",[8],5,[1,5],[2],2,"44","4"],["2508","1968-02-11","Springer-Zitate aus Harpprecht-Sendung im ZDF. Springer führt Angriffe auf ihn und sein Haus auf seine Haltung zum Staat zurück.","Ein Ja zu diesem Staat","","Axel Springer über die Ursachen der Hetzkampagne","",[10],5,[1],[2],2,"44","4"],["2509","1968-02-11","Scharfe Kampfansage an Unruhestifter in der Stadt auf Parteitag.","Schütz: Kampfansage an alle Unruhestifter","Eindringlicher Appell zu Beginn des Berliner SPD-Parteitages","","Klaus Haetzel",[1],5,[1],[1],2,"44","37"],["2510","1968-02-11","DDR-RA Kaul als Gast des Bonner SDS. Unerwartete Proteste gegen Opfer der Mauer.","Lehrreiches Exempel","","","Thilo Bär",[8],5,[5],[2],2,"44","37"],["2511","1968-02-11","Senator und Jurist nehmen Stellung zu Fragen der juristischen Behandlung von Krawallen, Kurras, Teufel etc.","Sind unsere Justizbehörden zu milde?","","Senator Hoppe und Generalstaatsanwalt Dr. Dehnicke antworten Welt am Sonntag auf aktuelle Fragen","Hans-Erich Bilges",[9],5,[3],[3],1,"44","37"],["2512","1968-02-11","Antiamerikanische Plakate und Flugblätter in einigen Berliner Bezirken.","SDS klebte Plakate","","","srz.",[8],5,[1],[2],2,"44","43"],["2513","1968-02-18","Zunächst verbotene Vietnam-Demo nun doch erlaubt. Bericht vom Vietnam-Kongress, u. a. mit Hinweis auf Auftritt des RA Prelinger, der gegen den Kongress protestiert hat.","Vietnam-Protestmarsch überraschend erlaubt. 3000 Polizisten bereit","Bürgermeister Schütz: Gerichtsentscheid wird respektiert","","Claus Dieter Nagel",[1],5,[1],[1],1,"42","1"],["2514","1968-02-18","Aufzählung einladender Gruppen. Stellung der DDR-Presse zum Geschehen. Vermutung, dass Geld aus Ostquellen kommt.","Wer stützt die Demonstranten","","Viele Gruppen unter der Vietkong-Fahne vereint - Mysteriöse Geldquellen","V., Z.",[1],5,[1,5],[3],2,"42","2"],["2515","1968-02-18","Vertreter von Studentengruppierungen in Hamburger Heeresoffiziersschule. SDS-Vertreter ermüdet mit Endlosvortrag.","SDS-Palaver vor jungen Offizieren","","Aufschlussreicher Versuch","G. Scharnhorst",[8],5,[1],[1],1,"42","4"],["2516","1968-02-18","CDU-MdB Jahn betont Gefährlichkeit radikaler Gruppen und Reformen als Gegenmittel.","Gefährliche Dutschkisten","","","Leser",[1],5,[6],[2],1,"42","4"],["2517","1968-02-18","Begründet die Triftigkeit von Vergleichen des SDS mit SA und SS.","Rabauken und Rebellen","","","William S. Schlamm",[8],5,[5],[3],1,"42","5"],["2518","1968-02-18","Situation vor einer erwarteten Vitnam-Demonstration","Gericht stellte fest: Verbot ist zu Unrecht erfolgt","Keine Demonstrationserlaubnis in Dahlem. Polizei bleibt trotzdem voll einsatzbereit","","",[1],5,[1],[1],2,"42","35"],["2519","1968-02-18","Absage der vom SPD-Abgeordneten Jürgen Gerull beantragten Vietnam-Demo.","Gerull sagte in letzter Minute ab","","\"Klein-Demonstration\" fiel aus - Pfiffe vor dem Rathaus","",[1],5,[1],[2],1,"42","35"],["2520","1968-02-25","Kommentator würdigt Senatsdemo und schreibt Ausschreitungen am Rande \"unvernünftigen Rabauken\" zu, die es überall gäbe.","Berlin gab ein Beispiel","","","Herbert Hausen",[1],5,[5],[5],2,"42","2"],["2521","1968-02-25","Regierungsstudie zum SDS über dessen politische Ausrichtung","Zwanzig SDS-Mitglieder mit KPD-Parteibüchern","","","K.H.",[8],5,[1],[2],2,"42","2"],["2522","1968-02-25","Zustimmung für Schlamms jüngsten Kommentar und Kritik an der Bundeswehr-Diskussionsveranstaltung in Hamburg","Rabauken und Rebellen","","","Leser",[8],5,[6],[2],2,"42","4"],["2523","1968-02-25","Gastkommentar beklagt linke Politisierung der evangelischen Kirche","Das Bethaus wird zum Debattierklub","","Kirche und Politik","Alexander Evertz",[3],5,[5],[1],1,"42","5"],["2524","1968-02-25","Kommentator \"empfiehlt\" SDS als probaten Ersatz für die verbotene KPD.","Aus guten Familien?","","","William S. Schlamm",[8],5,[5],[5],1,"42","5"],["2525","1968-02-25","Krise in der Berliner SPD wegen Teilnahme einiger Mitglieder des linken Flügels an Vietnam-Demo.","Droht der SPD die Spaltung?","50 Mitglieder kann der Ausschluss treffen. Auch Landesvorstand vor der Zerreißprobe","In allen Bezirken kursieren jetzt die Stimmlisten - Urabstimmung bietet die einzige Handhabe","Wolfgang Voss",[1],5,[1],[1],1,"42","35"],["2526","1968-03-03","Frage nach Schadensregulierung bei Schäden an ausländischem Eigentum nach Demonstrationen. Beispiel Amerikahaus.","Wer bezahlt die Fensterscheiben?","Studentenunruhen","","J.N.",[1],5,[1],[2],1,"46","3"],["2527","1968-03-10","Spaltungstendenzen beim VDS während der Münchener Tagung wegen der Frage des politischen Mandats.","Vier Unis traten schon aus","VDS-Versammlung","","",[11],5,[1],[2],1,"54","3"],["2528","1968-03-17","Beklagt das Schweigen der Mehrheit in der Gesellschaft gegen die radikale Linke in der Studentenschaft","Die Mehrheit schweigt","","","William S. Schlamm",[1],5,[5],[5],1,"54","5"],["2529","1968-03-31","SDS-Tagung in Frankfurt ohne Dutschke wird als Zeichen der Entfremdung vom \"Massenidol\" genommen.","SDS ohne Dutschke","","","Joachim Neander",[8],5,[5],[5],2,"66","2"],["2530","1968-04-07","Verhaftung von Ensslin, Baader, Proll und Söhnlein wegen Feuern in zwei Frankfurter Kaufhäusern. SDS-Kontakte werden angenommen, aber nicht belegt.","Erst zum SDS-Kongress - und dann Feuer gelegt?","","","Ne., O.",[9],5,[1],[5],2,"56","8"],["2531","1968-04-07","Die Stadt bereitet sich auf Ostermarschierer und andere Demonstranten vor.","\"Heiße Ostern\" in der City? Radikale planen Aktionen","","Fünf-Minuten-Ruhe des Verkehrs wird gefordert. Polizeipräsident Moch: Bisher keine Anträge!","Ulrich Gruga",[1],5,[1],[1],1,"56","49"],["2532","1968-04-07","Stellt das Verhalten der Demonstrierer dem der \"Normalbürger\" gegenüber.","Sie sind eben anders als wir","","","Wolfgang Voss",[1],5,[5],[2],2,"56","49"],["2533","1968-04-14","Auflistung verschiedener Fakten zur Situation nach Dutschke-Attentat. Hier auch kurze Erwähnung der Anti-Springer-Maßnahmen. Im Vorspann wird Bundesinnenminister Benda u. a. zitiert: \"Sollten sich bei weiterer Entwicklung die polizeilichen Mittel als nicht ausreichend erweisen, könnte eine Situation entstehen, in der die freiheitlich gesinnte Bevölkerung zum Schutz der verfassungsmäßigen Ordnung aufgerufen werden muss.\"","Unruhige Ostern: Minister Benda warnt vor neuen Gewalttätigkeiten","Nach dem Dutschke-Attentat und schweren Ausschreitungen in vielen deutschen Städten","","",[2,10],5,[1],[1],1,"54","1"],["2534","1968-04-14","Zitate aus konservativen Pressetexten aus Großbritannien, Frankreich, Schweiz und USA.","Übergriffe in Deutschland alarmieren das Ausland","","","",[2,10],5,[5],[5],2,"54","1"],["2535","1968-04-14","Meldung zu den Ostermärschen, ohne Erwähnung des Dutschke-Attentats","Die Ostermärsche haben begonnen","","","",[1],5,[1],[2],2,"54","1"],["2536","1968-04-14","Brandanschlag auf deutsche Botschaft in Oslo nacht Dutschke-Attentat","Anschlag in Oslo","","","UPI",[2],5,[1],[2],2,"54","1"],["2537","1968-04-14","Brandanschlag in Rom nach Dutschke-Attentat","Gegen Mercedes-Büro","","","",[2],5,[1],[2],2,"54","1"],["2538","1968-04-14","Kommentator vergleicht Attentate auf King und Dutschke miteinander. Schreibt u. a.: \"Die Tragik Dutschkes ist, dass ihn die Kugel erreichte, als er den Weg nach Damaskus anzutreten schien. Den Geistern, von denen er sich abzusetzen begann, konnte nichts gelegener kommen als ein Anschlag auf das Idol, über dessen Wandlung sie sich zerstritten hatten. ... Der Reichstagsbrand verzehrte den Weimarar Staat, der Versuch, das Berliner Springerhaus in Flammen aufgehen zu lassen, könnte leicht zum Anfang des Endes der Bundesrepublik werden.\"","Deutsche Ostern","","","H. G. von Studnitz",[2],5,[5],[5],2,"54","2"],["2539","1968-04-14","Statements verschiedener Politiker. U. a. MdB Müller-Hermann: \"Die hysterischen Versuche, für die Unruhe und Verwirrung im Lande ein Verlagshaus verantwortlich zu machen, erinnern an die Parolen der Nazis, dass an allem Unglück die Juden Schuld seien.\" Dazu eine Karikatur mit Walter Ulbricht vor dem Fernseher, Ulbricht kommentiert Bilder von den Osterunruhen mit: \"Die lieben Jungens ahnen ja nicht, welche Osterfreude sie mir machen...!\"","\"…erinnern an alte Nazi-Parolen\"","","Prominente deutsche Politiker verurteilen die schweren Ausschreitungen der letzten Tage","",[2,10],5,[5,4],[1],1,"54","2"],["2540","1968-04-14","Minister will zur Not Bevölkerung zum Vorgehen gegen die \"Eskalation des Irrsinns\" aufrufen","Benda vertraut auf Bevölkerung","","Interview mit dem Innenminister: Sonst ist der Rechtsstaat in Gefahr","Claus Dieter Nagel",[2],5,[3],[3],2,"54","2"],["2541","1968-04-14","Sammlung von Kurzbeiträgen zu Dutschkes Gesundheitszustand, zu Bachmann, der SDS-Taktik und Gottesdienststörungen, Anti-Springer-Maßnahmen und Lemmers Mahnung, den Hass zu beenden.","Nach dem Attentat auf Rudi Dutschke","","","hls, W.V., J.N., N., Kam., Ne., WPS, hsh, kdl.",[2],5,[1],[4],1,"54","3"],["2542","1968-04-14","Ausführlicher Bericht über Demo auf dem Kudamm mit anschließender Versammlung in der TU.","Auch Brandt-Sohn Peter unter den Verhafteten","","Massiver Polizeieinsatz gegen \"Verkehrsblockade\"","",[1],5,[1],[1],2,"54","47"],["2543","1968-04-21","Bericht von der Trauerfeier Frings, Persönliches über den Fotografen, Politiker-Statements","Die Polizei ermittelt gegen 6 Steinwerfer. CDU: Rasch aburteilen","Während München Abschied nahm von Fotoreporter Frings","","",[10,2],5,[1],[1],1,"48","1"],["2544","1968-04-21","Kommentar zur Weltlage, der die beiden Münchener Todesopfer als \"Aufhänger\" benutzt.","Heißes Frühjahr","","","Wolfgang Bretholz",[10,2,1],5,[5],[5],2,"48","2"],["2545","1968-04-21","Anhand einiger Zitate von SDS-Funktionären widerlegt der Autor die Aussage, die Anti-Springer-Kampagne sei eine Folge des Dutschke-Attentats gewesen.","?bis alles in Scherben fällt","Das Revolutionsrezept des radikalen SDS und seine Folgen","","Joachim Neander",[2],5,[5],[1],1,"48","4"],["2546","1968-04-21","Professor mach Minister in Brief auf eine Textstelle aufmerksam, in der Dutschke Tyrannenmord als im Einzelfall \"richitg und sinnvoll\" darstellt. (Uwe Bergmann, Rudi Dutschke, Wolfgang Lefèvre, Bernd Rabehl (Hg.), Rebellion der Studenten oder Die neue Opposition, Rowohlt 1968)","Dutschke - und der politische Mord","","Ein warnender Brief des Philosophen Prof. Kuhn an Bayerns Innenminister","Helmut Kuhn",[2],5,[6],[2],1,"48","4"],["2547","1968-04-21","Polizei plant nach Ausschreitungen der letzten Zeit veränderte Ausrüstung und Taktik","Polizei mit Elektro-Stock?","","Nach den Demonstrationen: Bessere Ausrüstung - neue Taktik","Günter Schlichting",[1],5,[1],[1],1,"48","5"],["2548","1968-04-21","Kommentator wirft der Justiz vor, nicht ausreichend konsequent gegen die Organisatoren der Unruhen vorzugehen. \"Diese unsagbare Frivolität der Justizverwaltung wäre selbst in Nigerien undenkbar.\"","Suspendierte Justiz","","","William S. Schlamm",[1],5,[5],[5],1,"48","5"],["2549","1968-04-28","Vorstellung eines neu gegründeten konservativen studentischen Dachverbandes","Sie bejahen unseren Staat","Deutsche Studentenunion","","K.H.",[11],5,[1],[2],1,"50","3"],["2550","1968-04-28","Mitglieder der Humanistischen Union widersprechen HU-bezogenen Aussagen Schlamms in seinem letzten Kommentar. Anderer Leser lobt Schlamm.","?Humanistische Union","","","Leser",[1],5,[6],[2],2,"50","4"],["2551","1968-04-28","SDS schuld am Niedergang universitärer Diskussionskultur","Diskussion mit Sprechchor?","","","William S. Schlamm",[8],5,[5],[5],1,"50","5"],["2552","1968-05-05","Sigrid Fronius im ersten Anlauf bei Wahl zur AStA-Chefin der FU ohne Erfolg","Schlappe für SDS-Kandidatin. AStA-Wahl abgebrochen","","","",[11],5,[1],[1],2,"52","45"],["2553","1968-05-12","Bericht über die Großdemonstration in Bonn \"Unter den Demonstranten überwogen die Jugendlichen. Man sah aber auch ehemalige KZ-Insassen in gestreifter Häftlingskleidung, Geistliche in Amtstracht sowie bekannte Altkommunisten.\"","Sternmarsch auf Bonn unter roten Fahnen - Bannmeile abgeriegelt","So verlief der Sonnabend der Notstandskundgebungen","","K.H., H.K., H.Z., Dl.",[1],5,[1],[1],1,"40","1"],["2554","1968-05-12","VDS erklärt sich solidarisch mit Pariser Studenten","VDS schließt sich an","","","UPI",[1],5,[1],[2],1,"40","1"],["2555","1968-05-12","Nach Pariser Ereignissen unternimmt der SDS einen Demozug von der Notstandskundgebung hin zur französischen Botschaft.","Marsch des SDS zur Botschaft","Letzte Meldung:","","",[1],5,[1],[2],2,"40","1"],["2556","1968-05-12","Bericht vom Verlauf der Großdemonstration. Dazu eine Karikatur mit Demonstranten gegen Notstandsgesetze, dazu eine Oma mit Hörrohr, die sagt: \"Ja, ja, der böse Herr Springer!\"","Da waren die Marschierer müde","","Streiflichter von der großen Notstands-Demonstration in Bonn","Horst Zimmermann",[1],5,[1,4,5],[1],1,"40","2"],["2557","1968-05-12","Kommentator fragt, warum der Staat \"bei aller Anerkennung des Rechtes auf Demonstration und Protest\" so weit entgegenkommen muss.","Der 11. Mai in Bonn","","","Klaus Hoff",[1],5,[5],[5],2,"40","2"],["2558","1968-05-26","Streiks bzw. Besetzungen an verschiedenen Unis gegen die Notstandsgesetze","Montag Besetzung der Uni","","Aufruf in Frankfurt - Letzte \"Notstands-Gefechte\"","",[1],5,[1],[3],2,"40","1"],["2559","1968-05-26","FU-Verwaltung warnt von Semesterannullierung bei \"antidemokratischer Manipulation und Terror\". \"Antidemokratische Gruppen wollten 'die Anarchie institutionalisieren'\" Pläne für Streiks etc.","Rektor und FU-Senat warnen eindringlich","","Möglicherweise sogar Annullierung des Semesters","",[11],5,[1],[1],2,"40","35"],["2560","1968-06-02","Rektoratsbesetzung der Frankfurter Uni. Fehlende Unterlagen und Gegenstände","Sie zogen sich die Talare an","Frankfurter SDS","","J.N.",[11],5,[5],[2],2,"40","3"],["2561","1968-06-02","Hintergründes des Rücktritts des TU-Rektors Weichselberger","Liberaler Rektor gibt auf","Die Radikalen unterschätzt","","Herbert Hausen",[11],5,[5],[1],1,"40","14"],["2562","1968-06-09","Bericht vom Burschentag. Burschenschafter als Gegenbild zu den Linken an den Unis","Die Burschenschaften wandeln sich","","Tradition und fortschrittliche Hochschul-Politik schließen sich nicht aus","J. Neander",[9],5,[1],[3],1,"40","6"],["2563","1968-06-09","Kommentator spricht Recht auf Revolution ab","Recht auf Revolution?","","","William S. Schlamm",[1],5,[5],[3],1,"40","7"],["2564","1968-06-23","Amt aus Protest gegen unzureichend Räume im Psychologie-Institut der Uni von 60 Studenten belagert. Polizei räumt.","Von Studenten belagertes Luftschutzamt \"gestürmt\"","","","dpa",[11],5,[1],[2],2,"40","2"],["2565","1968-06-30","Senator fürchtet nach Krawallen und Rektoratsbesetzung Abwanderung von Hochschullehrern","Stein: Sorgen um die FU","","Kultursenator befürchtet Professoren-Abwanderung","Bi.",[11],5,[1],[3],2,"36","2"],["2566","1968-07-14","Rektor nach neuem Wahlmodus gewählt","Wever neuer TU-Rektor","","Schon im ersten Wahlgang absolute Mehrheit","",[11],5,[1],[2],2,"32","2"],["2567","1968-07-14","Formlose Feier des 10. Unijubiläums","Die Professoren kamen ohne Talar","Bonner Universität","","H.K.",[11],5,[2],[2],2,"32","3"],["2568","1968-07-14","Vergleicht Rektoratsbesetzer der FU mit den Rollkommandos, die 1948 das Berliner Stadthaus überfallen haben. Absage an Gewalt","Rollkommandos wie vor 20 Jahren","","","Christian Colmar",[1],5,[5],[2],2,"32","27"],["2569","1968-07-14","Krawalle insbesondere an der FU werden für geringere Bewerberzahlen verantwortlich gemacht.","Studentenzahl ging rapide zurück","","Eine Bilanz, die aufhorchen lässt - Allein an der FU 900 Bewerbungen weniger als im Vorjahr","Rainer Rehberg",[11],5,[1],[5],2,"32","27"],["2570","1968-07-14","Werbe- bzw. Bleibeverhandlungen in der FU","Kurator wirbt um 34 Professoren für FU","","","Bi.",[11],5,[1],[2],2,"32","27"],["2571","1968-09-15","Kommentator sieht \"(scheinbaren) revolutionären Teilerfolg\" der Osterunruhen und die \"Blamage\" des CSSR-Einmarsches als Gründe für SDS-Neupositionierung bei Frankfurter Deligiertenversammlung (\"Säuberung des SDS\") Fraktionierung soll überwunden werden. Traditionalisten würden beschuldigt, Anti-Springer-Aktionen in Koln und München sabotiert zu haben. Kommentator erwartet letztendlich keine Abwendung vom Stalinismus.","Beim SDS endete die Ära Dutschke","","Links-Studenten suchen einen neuen Anfang - Konferenz in Frankfurt","Joachim Neander",[8],5,[1,5],[5],2,"42","4"],["2572","1968-09-22","Ausschreitung mit etwa 50 Teilnehmern am Diederichs-Messestand führt zu zeitweiliger Hallenschließung","Buchmesse wurde gestört","","SDS protestierte gegen Preisträger Senghor","",[8],5,[1],[3],2,"52","1"],["2573","1968-09-22","Ausschreitung mit etwa 50 Teilnehmern am Diederichs-Messestand führt zu zeitweiliger Hallenschließung. Neben Cohn-Bendit werden Kunzelmann und Langhans als Demonstranten namentlich genannt.","Der \"rote Dany\" störte den Messefrieden","Bücherschau","","I.B.",[8],5,[1],[2],1,"52","3"],["2574","1968-09-29","Kommentator zu Ausschreitungen auf der Buchmesse und vor der Paulskirche. SDS scheint mit NS-Parolen provozieren zu wollen. \"?ist sicher ironisch-verfremdend gemeint.\" Meint Konflikte zwischen Cohn-Bendit und Krahl zu erkennen. Neue Art der Aggression. Steinwurf gegen Synagoge. \"Es ist schiere Verzweiflung, sagen Kenner. Der SDS kämpfe wie ein angeschossenes Tier, das keinen Rückzug mehr hat.\"","Neue Masche des SDS: \"Sieg Heil!\"","","","Joachim Neander",[8],5,[5],[2],2,"50","4"],["2575","1968-09-29","Leser kritisiert Ausschreitung vor der Friedenspreisverleihung an Senghor","Die Krawalle in Frankfurt?","","","Leser",[8],5,[6],[2],1,"50","4"],["2576","1968-10-06","Leser kritisiert Leserbrief von Heinrich Schneider vom 29.6., und macht ihn für einen Teil der Probleme selbst verantwortlich.","Der SDS - nicht überwacht","","","Leser",[8],5,[6],[2],2,"46","4"],["2577","1968-10-13","SDS stört Veranstaltung zum 50. Jahrestag der Einführung des Frauenwahlrechts in der Paulkirche","SDS störte wieder","","","AP ",[8],5,[1],[2],2,"42","1"],["2578","1968-10-20","Briefschreiber widerspricht der im Artikel \"Neue Masche des SDS\" vom 29.9. gemachten Behauptung, es hätte vor der Paulskirche Filmaufnahmen für den HR gemacht.","Gegendarstellung","","","Christoph Fröhder",[8],5,[6],[2],2,"62","4"],["2579","1968-11-03","Radikale Studentengruppen planen am Montag wegen Mahler-Prozess Landgericht zu stürmen","Sturm auf das Landgericht?","","Teilalarmstufe für die Polizei angeordnet","",[6],5,[1],[2],2,"46","2"],["2580","1968-11-03","Zwei Demonstranten, die an Verlagsblockade teilgenommen hatten, freigesprochen. Zahlreiche Reaktionen von Verlegern und Zeitungen.","Verleger sind empört: Ein absurdes Urteil","Demonstrationsrecht","","",[10,2],5,[5],[2],2,"46","3"],["2581","1968-11-10","Berliner Innensenator zu den Ausschreitungen am Tegeler Weg","Mit Taktik gegen Terror","","Bürgermeister Neubauer: \"Alle notwendigen Mittel\"","N.",[6],5,[3],[2],2,"48","2"],["2582","1968-11-10","Meldung über eine friedlich verlaufene Demo in Berlin mit 2000 Teilnehmern","Ohne Zwischenfälle","","","dpa",[1],5,[1],[2],2,"48","2"],["2583","1968-11-10","Krawall bei APO-Demo in München. Sitz von Amtsgericht und Generalstaatsanwaltschaft wird mit Steinen beworfen.","Steinhagel in München","","","AP",[11],5,[1],[2],2,"48","2"],["2584","1968-11-10","Leser geht auf Freispruch der Zeitungsblockierer ein und sieht dadurch Vertrauen in Justiz schwinden.","Demonstranten und Justiz","","","Leser",[10,2],5,[6],[2],2,"48","4"],["2585","1968-11-10","Interview mit Bürgermeister und Innensenator Kurt Neubauer. Zieht Bilanz nach den Ausschreitungen am Tegeler Weg. Äußert sich zu Taktik und künftigen Maßnahmen. Widerspricht ausdrücklich einer \"verstümmelten Meldung einer Nachrichtenagentur\", er hätte Schusswaffengebrauch erwogen.","\"Wer so handelt, der gilt für uns als Krimineller\"","(Längerer Vorspann: \"Scheiden sich nun die Geister? ?)","","",[6],5,[3],[5],1,"48","43"],["2586","1968-11-10","Der Polizei sei wiederholt vorgeworfen worden, eine Schlägertruppe zu sein, Terror gegen Andersdenkende auszuüben. Die Beamten seien \"Psychologisch falsch eingestellt\". Bei wem dies jedoch tatsächlich der Fall sei, darüber hätte die vergangene Woche die Quittung präsentiert.","Die Quittung präsentiert","","","Christian Colmar",[6],5,[5],[2],1,"48","43"],["2587","1968-12-01","Auf einer Tagung der Polizeichefs werden in Frankfurt über die Verbesserung der Polizeiausrüstung und neue Taktiken bei Krawallen diskutiert. Ähnlich Frankreich, wird der Einsatz von Schutzschilden erwogen.","Polizeichefs: Nicht mehr tatenlos?","","?wenn Demonstranten Wurfgeschosse zusammentragen - Schutzschilde für Beamte?","AP",[9],5,[1],[1],1,"52","2"],["2588","1968-12-01","APO bzw. SDS stören Gewerkschaftsveranstaltung zum Thema Mitbestimmung. Rosenberg: \"Ihr benehmt euch, als würdet ihr von unseren Gegnern bezahlt!\"","APO buhte bei Rosenberg-Rede","","","Ne.",[1],5,[1],[2],2,"52","2"],["2589","1968-12-08","AStA der FU will Solidaritätsstreik aller Berliner Hochschulen zugunsten religierter Studenten der Film- und Fernseh-Akademie.","AStA will Streik","","","sb.",[1],5,[1],[2],2,"50","47"],["2590","1968-12-15","Vortragsveranstaltung von Bundesforschungsminister Stoltenberg in der Kieler Uni von SDS-Mitgliedern gestört. Mehrmals wurde das Mikrokabel durchgeschnitten. ","Turbulente Szenen um Minister Stoltenberg","","","dpa, AP",[11],5,[1],[3],2,"44","1"],["2591","1968-12-15","Kritischer Kommentar zu den FU-Konventswahlen mit Zweidrittel-Mehrheit für linke Kandidaten aufgrund mangelnder Wahlbeteiligung.","Eine Chance wurde vertan","","","H.-E. Bilges",[11],5,[5],[2],2,"44","39"],["2592","1968-12-29","Lange Haare und Bärte quer durch die Kulturgeschichte.","Eine \"haarige Kulturgeschichte\"","Kultur und Kunst","Generationsprobleme waren schon immer auch ein Kampf um die Frisur","Werner Klose",[9],5,[2],[5],1,"42","20"],["2593","1968-06-01","Hausdurchsuchung wegen des Verdachts, Stempel etc. bei der Besetzung des FU-Immatrikulationsbüros gestohlen zu haben. Stempel wurden nicht gefunden, jedoch Uniformteile, Krähenfüße und \"Bauteile\" für Molotowcocktails.","Haussuchung bei der \"Kommune I\"","","Polizei drang gewaltsam ein. Teufel und Pawla festgenommen","rb.",[11],2,[1],[3],1,"10","2"],["2594","1968-06-01","Hausdurchsuchung beim Frankfurter SDS wegen Suche nach Belastungsmaterial gegen Hans Jürgen Krahl.","Die Räume des SDS","","","",[8],2,[1],[2],2,"10","10"],["2595","1968-06-04","Erster Todestag von Ohnesorg. Gedenken an der Oper, anschließend auf dem Kudamm.","1500 gedenken Benno Ohnesorg","","","rb.",[7],2,[1],[2],2,"20","2"],["2596","1968-06-05","Studentenunruhen in Belgrad.","Demonstrationen verboten!","","Aber auch Hochschulreform wird versprochen","",[9],2,[1],[5],1,"10","10"],["2597","1968-06-06","Ankündigung der Krankenhausentlassung.","Dutschke soll entlassen werden","","","rb.",[2],2,[1],[2],2,"12","8"],["2598","1968-06-07","Zwei Wochen Arrest wegen Auflaufs für den Sohn des Außenministers.","Richterin bescheinigte kindliche Unreife","Zwei Wochen Dauerarrest für Peter Brandt","","Hans-Peter Fitzek",[9],2,[1],[1],1,"16","6"],["2599","1968-06-07","Richter befragt Dutschke im Krankenhaus zum Tathergang. Bachmann ändert seine erste Aussage.","Untersuchungsrichter sprach mit Dutschke","","","Ne.",[2],2,[1],[2],1,"16","7"],["2600","1968-06-10","Willi Brandt kritisiert Unreife-Vorwurf von Jugendrichterin","Vater Brandt ist verstimmt","Ist Peter unreif?","","jci.",[9],2,[1],[2],1,"14","14"],["2601","1968-06-11","Selbstmordversuch von Bachmann mit Kabel von Hörkissen.","Dutschke-Attentäter hing in der Todesschlinge","","Schon bewusstlos. Wärter rettete ihn","Horst Zylka, Peter Schmalz",[2],2,[1],[1],1,"8","1"],["2602","1968-06-11","TU-Rektor lehnt Strukturveränderungen an der Uni als Allheilmittel ab. Plädiert für Freiheit der Wissenschaft.","Keine Kontrolle der Wissenschaft","","","rb.",[4],2,[1],[2],2,"8","3"],["2603","1968-06-11","Fortsetzung des Berichts von Seite 1 mit Details zu Bachmann. Dutschke zu Sanatoriumsaufenthalt in die Schweiz gereist.US-Politiker beantragt bei Behörden Einreiseverbot für Dutschke in die USA.","Bachmann in der Nervenklinik - sein Opfer reiste in die Schweiz","Dutschke-Attentat","","Horst Zylka, Peter Schmalz",[2],2,[1],[3],1,"8","8"],["2604","1968-06-13","Ingenieur-Studenten beabsichtigen Vorlesungsstreik für mehr Selbstverwaltung","Vorlesungsstreik","","","",[11],2,[1],[2],2,"10","2"],["2605","1968-06-14","Jugdemokraten fordern streikende Studenten des Ostasiatischen Seminars der FU auf, die Einladung der Humboldt-Uni, dort zu studieren, anzunehmen","Studiert in Ost-Berlin!","","","rb.",[1],2,[1],[2],2,"14","4"],["2606","1968-06-14","Studentenvertreter dürfen künftig TU-Rektor und Prorektor mitwählen.","TU-Studenten wählen mit","","","rb.",[11],2,[1],[2],2,"14","4"],["2607","1968-06-18","Ingenieurstudenten stimmen über Streik ab","Abstimmung","","","",[11],2,[1],[2],2,"14","2"],["2608","1968-06-22","In einem Vervielfältigungsbüro sind die vermissten Stempel aufgetaucht. Teufel soll sie dort untergestellt haben.","Stahl Teufel 150 FU-Stempel?","","","rb.",[11],2,[1],[2],2,"10","2"],["2609","1968-06-25","Attentäter soll dem Untersuchungsrichter vorgeführt werden.","Bachmann wird vernommen","","","rb.",[2],2,[1],[2],2,"10","3"],["2610","1968-06-26","Cohn-Bendit nimmt an Teach-in zu Berlin-Situation in TU teil.","\"Der rote Dany\" in Berlin","","","rb.",[9],2,[1],[2],2,"8","2"],["2611","1968-06-27","Besetzer des Ostasiatischen Instituts werfen Rektorat Untätigkeit vor.","Studenten vernagelten Fenster","","","rb.",[1],2,[1],[2],2,"12","2"],["2612","1968-06-28","Rektor Harndt will nicht vor VV im Audimax sprechen. Daraufhin \"ernennen\" Studenten Teufel zum neuen Rektor. Ostasiatischen Institut wird gewaltsam geräumt.","FU-Studenten ernannten Teufel zum neuen Rektor","","Polizei räumte Ostasien-Institut","rb.",[1],2,[1],[3],1,"12","1"],["2613","1968-06-28","Fünfstündige Vernehmung Bachmanns ergibt Einzeltäterschaft.","Attentäter vernommen","","","rb.",[2],2,[1],[2],1,"12","2"],["2614","1968-06-29","FU-Rektor Harndt weiter nicht zu Gesprächen bereit. Senator Stein bedauert FU-Absage neuer OSI-Satzung. Harndt will nach polizeilicher Institutsräumung auch künfit Rechtbrüche verhindern lassen.","Studenten legen übers Wochenende eine Pause ein","","Polizei sichert weiter FU-Gelände ab","rb.",[1],2,[1],[3],1,"6","2"],["2615","1968-07-04","Zehn Protestierer dringen in Rathaus Schöneberg ein, um bei dortiger Fakultätssitzung zu protestieren.","Studenten-Protest im Rathaus Schöneberg","","","rb.",[1],2,[1],[2],2,"10","4"],["2616","1968-07-06","Zweiter Selbstmordversuch Bachmanns.","Dutschke-Attentäter rannte mit dem Kopf durchs Zellenfenster","Neuer Selbstmord-Versuch!","","zy.",[2],2,[1],[1],2,"8","1"],["2617","1968-07-08","Zonen-Zollposten haben Dutschkes Gepäck durchwühlt","Gepäck durchwühlt","","","",[2],2,[1],[2],2,"12","2"],["2618","1968-07-08","Student veranstaltet Unterschriftensammlung mit dem Ziel des AStA-Rücktritts","Gegen den AStA","","","",[11],2,[1],[2],2,"12","2"],["2619","1968-07-09","Dritter Selbsttötungsversuch Bachmanns, diesmal mit verschlucktem Löffelstiel","Dutschke-Attentäter wird jetzt gefüttert","","Neuer Selbstmordversuch","zy.",[2],2,[1],[5],1,"8","4"],["2620","1968-07-09","Neun konservative Studentenverbände wollen Beitragszahlungen an AStA verweigern","Keine Beiträge mehr für den AStA","","","rb.",[11],2,[1],[2],2,"8","5"],["2621","1968-07-09","RCDS schenk Bundesminister Benda eine neues Hemd nachdem er bei einer Diskussionsveranstaltung mit Farbeiern beworfen worden war.","Ein neues Oberhemd","","","",[11],2,[1],[2],1,"8","8"],["2622","1968-07-10","Studenten der ESG und der PH-AStA sammeln für Biafra","Studenten helfen","","","",[11],2,[1],[2],2,"8","2"],["2623","1968-07-10","Verhandlung wegen Hausfriedensbruchs im Rathaus Schöneberg im September 1967. Ordnungsstrafen für Langhans und Kunzelmann wegen Störaktionen, Gefängnisstrafen für zwei Kommunardinnen. Dazu Karikatur mit der Unterschrift \"sit-in\" und zwei Kommunarden im Gefängnis.","\"Kommune-Kasper\" landeten im Knast","","Gefängnis für die Damen. Ordnungsstrafen für die Herren","rb.",[5],2,[1,5,4],[1],1,"8","4"],["2624","1968-07-11","Protest gegen erneute Ablehnung der neuen OSI-Satzung. Rektoratsräume verwüstet. Polizei räumt und verhaftet u. a. Asta-Chefin Fronius.","AStA-Vorsitzende und 80 Studenten festgenommen","","Krawalle nach Besetzung des FU-Rektorats","rb.",[1],2,[1],[5],1,"10","1,2"],["2625","1968-07-11","Republikanischer US-Abgeordneter gegen Dutschke-Einreise in die USA","\"Lasst den roten Rudi draussen!\"","","","",[2],2,[1],[2],1,"10","10"],["2626","1968-07-12","Abg. Löffler legt Bericht über FU-Unruhen vor. Sagt. U.a.: \"Er [der SDS] wird von einer anarcho-kommunistischen Führungsgruppe beherrscht.\". Vertreter aller Parteien fordern Hochschulreform.","Parteien einig: Hochschulreform - Aber schnell!","","Parlament billigte Bericht über FU-Unruhen","Klaus Heine",[1],2,[1],[1],1,"10","2"],["2627","1968-07-12","Mehrere FU-Gebäude unter Polizeischutz. Professoren Schwan und Sontheimer wollen von ihren Posten zurücktreten wegen Ablehnung ihrer Reformvorschläge für das OSI","Polizeischutz","","","rb.",[1],2,[1],[2],2,"10","2"],["2628","1968-07-12","Mahler von Richter als Verteidiger abgelehnt wegen Verdachts der Anstiftung zur Tat seiner Mandanten.","Apo-Anwalt abgelehnt","","","rb.",[6],2,[1],[2],1,"10","2"],["2629","1968-07-12","Dutschke aus Schweizer Sanatorium mit unbekanntem Ziel abgereist. Will nicht wieder nach Berlin zurück.","Rudi Dutschke: Nicht mehr nach Berlin","","","",[2],2,[1],[2],2,"10","10"],["2630","1968-07-15","Professoren Wever und Wille zu Rektor und Prorektor der TU gewählt - unter Beteiligung von Assistenten und Studenten.","Neuer Rektor an der TU: Studenten wählten mit","","","r.b.",[11],2,[1],[3],1,"12","2"],["2631","1968-07-16","Kunzelmann zu Haft wegen Pro-Teufel-Aktionen verurteilt","3 Tage Haft für Kunzelmann","","","rb.",[5],2,[1],[2],2,"8","2"],["2632","1968-07-16","FU-Studenten verweigern die Zahlung ihres AStA-Beitrages","FU: Die Hälfte zahlte nicht","","","rb.",[11],2,[1],[2],2,"8","2"],["2633","1968-07-17","Anklage gegen Kunzelmann und Langhans wegen Anti-Schütz-Artikel im \"FU-Spiegel\" erhoben.","Anklage gegen Kommunarden","","","rb.",[11],2,[1],[2],2,"10","3"],["2634","1968-07-18","FU-Fakultäten lehnen OSI-Satzung aus Angst vor Gleichschaltung ab","Fakultäten lehnten Satzung ab","","","rb.",[11],2,[1],[2],2,"10","2"],["2635","1968-07-18","Zwei Monate Haft für Teufel u. a. wegen Zündens von Knallkörpern im Gerichtssaal","Teufel muss doch in den Knast","","","rb.",[5],2,[1],[2],2,"10","6"],["2636","1968-07-22","Handgreifliche Auseinandersetzung in München zwischen einem Gastwirt und Teufel","Teufel griff zum Leberkäs","","","rb.",[5],2,[2],[2],1,"10","2"],["2637","1968-07-24","Dekan der Philosophischen Fakultät der FU, Prof. Loos, warnt in einem Brief an Senator Stein vor Professoren-Abwanderung","Warnung vor Professoren-Ausverkauf","","","rb.",[1],2,[1],[2],1,"12","2"],["2638","1968-07-24","Ermittlungsverfahren gegen Guggomos wegen übler Nachrede gegen Neubauer eingestellt.","Verfahren eingestellt","","","rb.",[9],2,[1],[2],1,"12","2"],["2639","1968-07-25","FU-AStA-Beiträge müssen gezahlt werden, z. Z. jedoch unter Vorbehalt","Pflichtbeiträge","","","",[11],2,[1],[2],2,"8","2"],["2640","1968-07-27","TU-AStA sammelt Spenden für Biafra","Studenten sammeln","","","",[11],2,[1],[2],2,"10","2"],["2641","1968-07-31","Internationale Studenten halfen bei einem Fest in einem Hospital","Patienten durften feiern","","Studenten halfen alten Leuten","Luba.",[11],2,[1],[5],1,"8","2"],["2642","1968-08-01","Teufel in einem Münchener Beat-Lokal in eine Prügelei verwickelt","Prügel","","","",[5],2,[1],[2],2,"10","7"],["2643","1968-08-02","U. a. Rabehl, Lefèvre und Treulieb vom Berliner SDS bzw. FU-AStA in Kuba zu einem Kurs über \"revolutionäre Kampfmethoden\".","SDS-Spitze in Kuba","","","rb.",[8],2,[1],[2],2,"14","3"],["2644","1968-08-05","Wegen verschiedener Verstöße ist Teufel in Österreich festgenommen worden. Soll abgeschoben werden.","Fritz Teufel in Österreich festgenommen","","","",[5],2,[1],[2],2,"12","1"],["2645","1968-08-07","Von Bachmann vor einem Monat verschluckter Löffelstiel soll auf natürlichem Weg wieder ans Tageslicht befördert werden.","Sauerkraut schafft's doch","","","rb.",[2],2,[1],[2],1,"8","2"],["2646","1968-08-08","Verbindung von AStA-Gebühren und Rückmeldung ist nicht zwingend","Gericht: FU-Studium ohne AStA-Gebühren","","","rb.",[11],2,[1],[2],2,"8","3"],["2647","1968-08-13","Abwanderungen und Ablehnungen von Berufungen in der FU seit Beginn der Unruhen","Sechs Professoren verließen die FU","","","rb.",[1],2,[1],[2],2,"8","3"],["2648","1968-08-15","Löffelstiel musste doch operativ entfernt werden.","Attentäter Bachmann doch operiert","","","rb.",[2],2,[1],[2],1,"10","3"],["2649","1968-08-23","AStA der Berliner Hochschulen sammeln für \"Freunde und Genossen\", die z. Z. nicht in die CSSR zurück können. BILD druckt Nummer des Spendenkontos ab.","Studenten sammeln","","","",[11],2,[1],[2],2,"12","7"],["2650","1968-09-03","Staatsanwaltschaft legt Revision gegen Urteile gegen Kurras und Teufel ein.","Neue Prozesse gegen Kurras und Teufel","","","rb.",[7,5],2,[1],[2],2,"10","3"],["2651","1968-09-05","Siehe Überschrift. Es geht um dem Kommunarden Karl-Heinz Pawla.","Kommunarde verrichtete sein \"großes Geschäft\" vor dem Richtertisch","","","zek.",[5],2,[1],[2],1,"10","4"],["2652","1968-09-10","Oberverwaltungsgerichtsentscheidung zu politischem Mandat des FU-Studentenprlaments","Gericht: Studentenparlament muss unpolitisch sein","","","rb.",[11],2,[1],[2],2,"10","2"],["2653","1968-09-11","Reformen, ähnlich dem OSI, sollen gem. Vorschlag von Senator Stein künftig ohne Zustimmung des Akademischen Senats getestet werden dürfen.","Neue Hochschul-Reformen","","","ob.",[4],2,[1],[2],1,"10","2"],["2654","1968-09-11","Revision gegen Teufel-Urteil als unbegründet verworfen.","Es bleibt beim Freispruch","","","zek.",[5],2,[1],[2],2,"10","4"],["2655","1968-09-12","FU-Parlament legt gegen Entscheidung zu politischem Mandat Revision ein.","Konvent will nicht verzichten","","","rb.",[11],2,[1],[2],2,"12","2"],["2656","1968-09-14","Senator Stein will mit Studenten über seine Reformpläne sprechen.","Gespräch mit Studenten","","","",[4],2,[1],[2],2,"10","2"],["2657","1968-09-18","Kommunarden Kunzelmann, Langhans und Würffel wegen Hausfriedensbruchs 1967 im Rathaus Schöneberg vor Gericht.","Höfliche Kommunarden","","","zek.",[5],2,[1],[2],2,"10","4"],["2658","1968-09-19","Kommunarden Teufel und Schlotterer bekommen Haftbefehl wegen Fernbleibens von Gerichtsverhandlung wegen Hausfriedensbruchs. Kunzelmann, Langhans und Würffel zu Haftstrafen ohne Bewährung verurteilt.","Kommunarde Teufel bekam Haftbefehl","","","zek.",[5],2,[1],[2],1,"10","5"],["2659","1968-09-21","Cohn-Bendit, Langhans u. a. stören Buchmessenveranstaltung mit F.-J. Strauß. ","Der \"Rote Dany\" sprengte eine Party","","","",[8],2,[1],[2],1,"10","5"],["2660","1968-09-23","Krawalle vor der Frankfurter Paulskirche anlässlich der Verleihung des Friedenspreises des deutschen Buchhandels an Leopold Senghor.","Polizeireiter mussten Lübke schützen","","Schwere Krawalle in Frankfurt","",[8],2,[1],[5],1,"12","1"],["2661","1968-09-23","Schlderung der Ausschreitungen vor der Paulskirche. Festnahme Cohn-Bendits: Politikerreaktionen.","Der Botschafter musste über die Barriere springen","","Polizeireiter schützten Lübke","",[8],2,[1],[5],1,"12","12"],["2662","1968-09-28","Urteil im Schnellgerichtsverfahren wegen Krawallen vor der Paulskirche","8 Monate Gefängnis für den \"Roten Dany\"","","","bk.",[8],2,[1],[2],2,"14","1"],["2663","1968-09-30","FU-Kuratorium beschließt Haushalt für Studentenschaft","FU beschloss Haushaltsplan","","","rb.",[11],2,[1],[2],2,"16","4"],["2664","1968-09-30","Handgreiflichkeiten nach friedlicher Demonstration vor der griechischen Militärmission.","Kundgebung für Demokratie","","","rb.",[1],2,[1],[2],2,"16","4"],["2665","1968-10-02","BGH-Richter kritisiert Polizeieinsatz am 2. Juni 1967 mit deutlichen Worten. Hier als Zitat wiedergegeben. Ungereimtheiten führen zu Urteilsaufhebung gegen Kurras.","Kurras muss noch einmal vor Gericht","Bundesgerichtshof hob das erste Urteil auf:","Wie oft schoss der Kripo-Beamte wirklich?","Horst Zylka ",[7],2,[1],[1],1,"12","2"],["2666","1968-10-02","Zusammenstöße im und vor dem Kriminalgericht bei Prozess gegen persischen Studenten wegen der Vorkommnisse am 2.6.67","Zusammenstöße im Gericht","","","zek.",[1],2,[1],[2],1,"12","2"],["2667","1968-10-08","Teufel, Schlotterer und Gebbert wegen Gottesdienststörung u. a. Vergehen zu Haftstrafen ohne Bewährung verurteilt.","Teufel muss für sieben Monate ins Gefängnis","","","rb.",[5],2,[1],[2],2,"8","2"],["2668","1968-10-10","Handgreifliche antiamerikanische Demonstration bei Krankenhaus-Eröffnung.","Student wollte Frau Minister vom Mikrofon wegdrängen","Bei der Übergabe des Klinikums","Jugendliche blockierten Haupteingang des Krankenhauses","Renate Philipp",[1],2,[1],[1],1,"14","2"],["2669","1968-10-10","Prozess gegen Bachmann terminiert.","Dutschke-Attentäter vor Gericht","","","ok.",[2],2,[1],[2],2,"14","2"],["2670","1968-10-10","Die AStA-Vorsitzende der FU Berlin, Siegrid Frohnius (sic! Richtig ist Sigrid Fronius) ist von ihrem Amt zurückgetreten.","AStA-Vorsitzende zurückgetreten","","","",[8],2,[1],[2],2,"14","2"],["2671","1968-10-11","Nach Selbstmordversuchen am 9.6., 5.7. und 14.8. jetzt vierter Versuch Bachmanns, sich selbst zu töten.","Sonderposten an Bachmanns Bett","","Dutschke-Attentäter unternahm vierten Selbstmordversuch","M.B.",[2],2,[1],[5],1,"14","2"],["2672","1968-10-12","Jürgen Treulieb kandidiert als Nachfolger von Sigrid Fronius","AStA-Wahl am 21. Oktober","","","",[11],2,[1],[2],2,"14","2"],["2673","1968-10-15","Studenten betreuen Kinder in Ferienlagern","Studenten betreuen 6100 Kinder","","","rb.",[11],2,[1],[2],2,"12","2"],["2674","1968-10-22","Cohn-Bendit beinahe zum Rektor der Uni Glasgow gewählt","\"Roter Dany\" fast Rektor","","","",[9],2,[1],[2],2,"10","2"],["2675","1968-10-24","Fünfter Selbstmordversuch Bachmanns gescheitert.","Bachmann kann es nicht lassen","","","rb.",[2],2,[1],[2],2,"10","2"],["2676","1968-10-24","Kommunarde Pawla macht sich über seinen Richter namens Loch lustig.","Den Richter beschimpft - drei Tage Haft","","","rb.",[5],2,[1],[2],2,"10","4"],["2677","1968-10-25","In der Philosophischen Fakultät der TU sollen Studenten künftig stärker an der akademischen Verwaltung beteiligt werden.","Mitspracherecht für Studenten","","","",[4],2,[1],[2],2,"14","2"],["2678","1968-10-29","Bachmann hat verschlucktes Besteckmesser wieder ausgeschieden.","Dutschke-Attentäter wird nicht operiert","","","zek.",[2],2,[1],[2],2,"10","4"],["2679","1968-11-05","Bericht über Straßenschlacht nahe dem Landgericht am Tegeler Weg, wo Standesverfahren gegen RA Mahler stattfand. \"Nie dagewesene Aggressivität?\". \"Bürgermeister Neubauer: Das war keine Demonstration mehr, sondern ein gewaltsamer Aufruhr! Die Ausschreitungen seien ein Beweis dafür, dass eine gewisse Gruppe nur Terror wolle.\"","Bürgermeister: Das war Terror!","Nach zwei Stunden Straßenschlacht: 130 verletzte Polizisten, 21 verletzte Demonstranten","\"Rocker\"-Gruppen am Krawall beteiligt.","",[6],2,[1],[1],1,"10","1"],["2680","1968-11-05","Ausführliche Schilderung der Vorgänge am Tegeler Weg. Aktion war angekündigt, Polizei hatte abgesperrt. Schadensbilanz. \"Christian Semmler vom SDS nannte als wichtigsten Erfolg dieser Aktion die Bekämpfung von Polizeiketten durch massiven Steinwurf. Der Kampf auf der Straße sei auf eine völlig neue militante Ebene gebracht worden. Ein anderer Sprecher: 'Es ist zwecklos gegen abgesicherte Gerichtsgebäude zu stürmen. Es ist besser, private Aktionen nach 'Rocker-Art' gegen Justizbeamte zu unternehmen, die sich unter schwarzen Talaren verstecken.'\"","130 Polizisten wurden verletzt","Straßenschlacht in Charlottenburg: Um 8.30 Uhr flogen die ersten Steine","\"Hände weg von Mahler\" riefen die APO-Leute und warfen Pflastersteine, Molotow-Cocktails, Farbbeutel und Rauchkerzen","Jürgen Overdick",[6],2,[1],[4],1,"10","2"],["2681","1968-11-05","Linksliberale Hochschulgruppe distanziert sich von Ausschreitungen. Reaktionen von Politikern aller Abgeordnetenhausfraktionen. ","Das ging zu weit","APO-Gruppe zu Steinwürfen:","","rb.",[6],2,[1],[5],2,"10","2"],["2682","1968-11-05","Brandanschlag auf Stallung der Polizeipferde fünf Stunden nach Straßenschlacht am Tegeler Weg. Zusammenhang vermutet.","Überfall auf Polizeipferde mit Feuerflaschen","","Durch Molotow-Cocktails schwer verletzt: Polizeipferd \"Zerline\"","M.B.",[6],2,[1],[1],1,"10","3"],["2683","1968-11-05","Informationen über einen durch Steinwurf verletzten Polizisten","Zwei Kinder bangen um den Vater","","","M.B.",[6],2,[1],[2],1,"10","3"],["2684","1968-11-05","Reaktion Bürgermeisters und Innensenators Neubauer. Wertet Ausschreitungen nicht als Demonstration, sondern als kriminelles Delikt.","Das ist keine Demonstration! Das ist Terror!","","Neubauer warnt vor neuen Krawallen","rb.",[6],2,[1],[2],1,"10","3"],["2685","1968-11-05","Ehrengericht der Berliner Anwaltskammer lehnt Berufsverbot für Mahler ab.","Kein Berufsverbot für Apo-Anwalt Mahler","","","zek.",[6],2,[1],[3],1,"10","3"],["2686","1968-11-05","Rektor Harndt hatte Einstellung Rabehls als Assistent am OSI abgelehnt. Es finden aber Gespräche statt.","Stein stellt sich vor FU-Rektor","","","rb.",[11],2,[1],[2],2,"10","5"],["2687","1968-11-06","Erklärung des Bürgermeisters und Innnensenators Neubauer zu den Ausschreitungen am Rande des Mahler-Prozesses","Polizisten nicht länger Zielscheibe für Wildgewordene!","Scharfe Warnung des Senats:","\"Gesetzliche Mittel reichen bis zum Gebrauch der Schusswaffe\"","rb.",[6],2,[1],[1],1,"10","1"],["2688","1968-11-05","Bilanz der und Reaktionen auf die Unruhen vom Wochenbeginn. Polizeigewerkschaft fordert scharfe Konsequenzen.","\"Polizeiführung hat die Lage falsch eingeschätzt\"","","Gewerkschaft fordert: Stoppt den Terror auf der Straße!","rb.",[6],2,[1],[1],1,"10","2"],["2689","1968-11-06","Situation der Polizei angesichts der eskalierenden Gewalt bei Demonstrationen.","Die Prügelknaben der Nation?","Was taugt die Polizei? Wenig Geld und viel Kritik. Supermänner oder Zettelkleber? Auf den Straßen Feind Nr. 1. 1000 Beamte im Dienst getötet","\"Niemand darf zusehen, wie das Leben dieser Männer sinnlos gefährdet wird\"","Kurt Dittrich",[6],2,[1],[1],1,"10","6"],["2690","1968-11-07","Kein Krawall bei CDU-Kundgebung aufgrund starker Sicherheitsvorkehrungen","Die APO-Krawalle fielen ins Wasser","","CDU-Kundgebung: \"Neue Welt\" wurde zur Festung","rb.",[1],2,[1],[1],1,"14","4"],["2691","1968-11-07","Senator Neubauer besucht verletzte Polizisten im Krankenhaus","Geschenke für die Verletzten","","","",[6],2,[1],[2],1,"14","4"],["2692","1968-11-09","SPD kritisiert in einer Erklärung die Terroraktionen der APO. \"Die SPD setzt sich dagegen zur Wehr, dass das Demonstrationsrecht zu übelstem Terror und zu blutigen Straßenkämpfen missbraucht wird.\"","SPD: Mehr Sicherheit für Bürger und Polizei!","","","",[1],2,[1],[2],2,"10","1"],["2693","1968-11-09","Terminankündigung","Bachmann-Prozess ab 13. Dezember","","","",[2],2,[1],[2],2,"10","2"],["2694","1968-11-11","Vietnam-Demo der APO in Berlin ohne Ausschreitungen.","Demonstration ohne Krawalle","","","rb.",[1],2,[1],[2],2,"16","2"],["2695","1968-11-11","Rundfunkansprache des Regierenden Bürgermeisters Schütz. Spricht von gewaltsamem Aufruhr, einem harten Kern von Terroristen und droht, dass wie ein Verbrecher behandelt wird, wer sich krimineller Mittel bedient.","Wer Terror ausübt, wird wie ein Verbrecher behandelt","Berlins Regierender zu den Ausschreitungen am 4. November.","","eis.",[6],2,[1],[2],2,"16","3"],["2696","1968-11-15","Auf Vorschlag Senator Steins soll die FU dem AStA die Summe der noch nicht gezahlten Studentenbeiträge vorschießen.","FU soll 43700 Mark vorschießen","","","rb.",[11],2,[1],[2],2,"14","4"],["2697","1968-11-16","Frankfurter Societätsdruckerei forder in einem Zivilprozess vom SDS Ersatz für Schaden durch Osterunruhen.","Der SDS soll zahlen","","","",[10],2,[1],[2],2,"10","7"],["2698","1968-11-23","Rektoratsübergabe an der TU ohne Roben und feierliche Musik","Rektoratsübergabe an der TU diesmal ohne Fanfarenmusik","","","rb.",[11],2,[1],[2],2,"12","3"],["2699","1968-11-23","Von Feuer verletztes Pferd noch immer in ernstem Zustand. Ratschläge für die Behandlung.","Tierfreunde: Milch und Honig können Stute \"Zerline\" heilen","","","eis.",[6],2,[1],[2],1,"12","3"],["2700","1968-11-27","Prüfung der Möglichkeit eines Hausverbots für Christian Semmler in der TU wegen Gewaltaufrufs.","Hausverbot für radikales SDS-Mitglied in der TU?","leine","","kh.",[8],2,[1],[2],2,"14","3"],["2701","1968-11-28","Verteidiger fällt aus. Prozess soll dennoch wie terminiert beginnen.","Verteidiger von Attentäter Bachmann erkrankt","","","rb.",[2],2,[1],[2],1,"12","2"],["2702","1968-11-28","Gewaltsame Verhinderung eines Vortrages im Tübinger Amerika-Haus. Sachbeschädigungen und Brandstiftungen.","Studentenkrawalle im Amerika-Haus","","","hek.",[11],2,[1],[2],2,"12","12"],["2703","1968-11-30","Krawalle befürchtet zugunsten der von der Film- und Fernsehakademie religierten Studenten.","Studenten kündigen \"Aktionen\" an","","","rb.",[1],2,[1],[2],2,"10","4"],["2704","1968-12-03","Um Satzungsentwurf für Philosophisches Seminar der FU zu erzwingen, werden Professoren etc. behindert.","Studenten verhindern Vorlesungen","","","rb.",[1],2,[1],[2],2,"10","2"],["2705","1968-12-03","Bachmann erhält Ersatz für seinen erkrankten Verteidiger","Pflichverteidiger für Dutschke-Attentäter","","","",[2],2,[1],[2],2,"10","2"],["2706","1968-12-05","Fakultätsversammlung der FU von Studenten gesprengt, um Diskussion über neue Satzung zu erzwingen. Gewaltrechtfertigung. Um Filmstudenten \"Produktionsmittel zurückzuerobern\", wurde einem SFB-Team eine Kamera gestohlen. Sie wurde \"vergesellschaftet\". Dazu Karikatur mit zwei Dieben, die ein Auto \"vergesellschaften\" wollen, im Hintergrund veränderte Warnschilder vor Taschen- und Fahrradvergesellschaftern statt Dieben.","Fernseh-Kamera wurde von Studenten \"vergesellschaftet\"","","SFB erstattete Anzeige. Fakultätsversammlung gesprengt","rb.",[1],2,[1,4,5],[1],1,"12","2"],["2707","1968-12-06","Des Auflaufs bei der Scha-Demo beschuldigter Student wird nicht verurteilt.","Verfahren eingestellt","","","rb.",[1],2,[1],[2],2,"16","4"],["2708","1968-12-06","Maßnahmen zur Verbesserung des Informationsflusses an der TU","Neue Reformen an der TU","","","rb.",[4],2,[1],[2],2,"16","4"],["2709","1968-12-07","Otto v. Simson sieht Funktion der Universität durch Störungen behindert.","Studien durch Terror behindert!","","","rb.",[1],2,[1],[2],2,"14","2"],["2710","1968-12-07","Senator ruft Studenten dazu auf, Extremisten auszugrenzen","Stein: Studenten sollen sich aktiv gegen Störenfriede wehren","","","kh.",[1],2,[1],[2],1,"14","3"],["2711","1968-12-09","Alle Berliner Hochschulen sollen aus Solidarität mit den relegierten Filmstudenten streiken.","Streikaufruf aus Solidarität","","","",[1],2,[1],[2],2,"14","2"],["2712","1968-12-10","Entwendete SFB-Kamera anonym zurückgegeben","Der SFB hat seine Kamera wieder","","","",[1],2,[1],[2],2,"10","2"],["2713","1968-12-10","Hautverpflanzung in der Tierklinik Düppel","Polizeistute \"Zerline\" wird operiert","","","eis.",[6],2,[1],[3],2,"10","3"],["2714","1968-12-11","Bachmann lehnt Richter ab, da dieser kürzlich einen ehemaligen NS-Richter freigesprochen hat.","Dutschke-Attentäter: Dieses Gericht lehne ich ab!","","Grund: Dr. Oske ist der Vorsitzende","Hans-Peter Fitzek",[2],2,[1],[1],1,"14","4"],["2715","1968-12-12","Berufungsverfahren gegen Peter Brandt wegen Auflaufs","Peter Brandt vor Gericht","","","",[9],2,[1],[2],2,"12","2"],["2716","1968-12-12","Schüler der Reinickendorfer Humboldt-Schule wenden sich gegen 30 APO-Mitglieder, die eine Diskussion erzwingen wollen.","Schüler ließen APO \"abblitzen\"","","\"Go-in\" und Diskussion nicht erwünscht","Gerhard Eisenkolb",[1],2,[1],[5],1,"12","4"],["2717","1968-12-13","Anzahl der z. Z. eingeleiteten Verfahren nach Ausschreitungen am Tegeler Weg","64 Verfahren eingeleitet","","","kh.",[6],2,[1],[2],2,"16","2"],["2718","1968-12-13","Haftstrafen gegen Teufel, Kunzelmann u. a. in Berufungsverfahren bestätigt","Haftstrafen bestätigt","","","",[5],2,[1],[2],2,"16","2"],["2719","1968-12-13","Bürotür eines TU-Professoren-Zimmers aufgebrochen und Akten durchsucht","Studenten brachen Türen auf","","","",[1],2,[1],[2],2,"16","2"],["2720","1968-12-14","Brandt wegen Auflaufs in zwei Fällen zu 400 Mark Geldstrafe verurteilt.","Geldstrafe für Peter Brandt","","","zek.",[9],2,[1],[2],1,"12","2"],["2721","1968-12-16","Weitgehend friedliche APO-Demo gegen Freispruch für NS-Richter","Protest von 5000 gegen Rehse-Urteil","","","rb.",[1],2,[1,4,5],[2],1,"12","2"],["2722","1968-12-19","OSI-Assistenten protestieren gegen Hausordnungsverfahren gegen Störer","Protest gegen Verfahren","","","rb.",[11],2,[1],[2],2,"10","2"],["2723","1968-12-19","Dutschke soll sich wegen Landfriedensbruchs verantworten. Sein Anwalt Mahler sagt, es sei ihm nicht zuzumuten vor einem deutschen Gericht zu erscheinen","Dutschke kommt nicht zum Prozess","","","rb.",[2],2,[1],[2],2,"10","3"],["2724","1968-12-19","Leserin widerspricht einer sie betreffenden Äußerung im BILD-Artikel \"Schüler ließen APO 'abblitzen'\"","\"Ich war nicht die Initiatorin des Go-in\"","","Gegendarstellung der Referendarin Dahle","Leser",[1],2,[6],[2],2,"10","4"],["2725","1968-12-20","Gericht fordert medizinisches Gutachten zur Verhandlungsfähigkeit Dutschkes.","Gutachten angefordert","","","",[2],2,[1],[2],2,"16","2"],["2726","1968-12-20","Brandstiftung mit 5000 Mark Sachschaden im FU-Rektorat. Senator verurteilt Tat.","Brandanschlag auf FU-Rektorat","","","rb.",[11],2,[1],[2],1,"16","3"],["2727","1968-12-20","Zur Abbiegung der Hausordnungsverfahren wurde in einer OSI-Diskussion die Geiselnahme des FU-Direktors vorgeschlagen.","FU-Direktor sollte als Geisel festgehalten werden?","","","rb.",[11],2,[1],[2],2,"16","3"],["2728","1968-12-21","Landfriedensbruchsverfahren gegen Dutschke aus gesundheitlichen Gründen vorläufig eingestellt.","Verfahren vorläufig eingestellt","","","rb.",[2],2,[1],[2],1,"12","4"],["2729","1968-12-30","Abschnitt April im Jahresrückblick. Hinweis aus Dutschke-Attentat und Anti-Springer-Demonstrationen.","Im April beginnt ein heißer Sommer für die Bundesrepublik","War das ein Jahr! Wir werden 1968 lange nicht vergessen!","","Klaus Heine",[2],2,[5],[2],1,"14","6"],["2730","1968-02-01","Dreistündiges \"Go-in\" bei Ordinariensitzung der Phil. Fak. der FU. Tür gewaltsam geöffnet. Einzelne Professoren zu Zugeständnissen z. B. in der Prüfungsordnung bereit.","Studenten erzwangen Sitzungsabbruch","Freie Universität","Störung einer Versammlung der Philosophischen Fakultät","Bi., v.C.",[11],4,[1],[2],2,"20","6"],["2731","1968-02-02","FU-Rektor Harndt verurteilt Übergriffe von Studenten in der Philosophischen Fakultät und zieht Vergleich zu Ausschreitungen im Dritten Reich.","FU-Rektor spricht von brutalem Terror","","\"Übergriffe von Studenten erinnern an schlimmste Zeiten\"","v.C.",[11],4,[1],[2],2,"20","1"],["2732","1968-02-02","Nochmals Harndt-Reaktion auf studentische Übergriffe. Verurteilung auch durch Wissenschaftssenator Stein. Warnt davor, Seminare bei Störungen zu schnell zu schließen.","Stein: Seminare nicht vorschnell schließen","","","v.C.",[11],4,[1],[2],2,"20","4"],["2733","1968-02-02","Professor Gollwitzer wird Mitverantwortung an studentischen Unruhen in Berlin zugeschrieben. Er selbst sieht seine Diskussionen mit den Studenten als Möglichkeit, eine weitere Verhärtung der Fronten zu verhindern. Er fördert den SDS, obwohl er nicht mit all seinen Zielen übereinstimmt. Untersuchungsausschuss zu Demonstrationen auch in Bremen.","Gollwitzer stellt sich hinter den SDS","Demonstrationen","Untersuchungsausschüsse in Berlin und Bremen tagen","v.C., M.",[1],4,[1],[2],2,"20","4"],["2734","1968-02-02","Politische Hintergründe des Bespitzelungsversuchs des Gießener SDS im November 1967","\"Klare Anweisungen vom Staatssekretär\"","Verfassungsschutz","CDU-Abgeordneter über die Gießener Spitzel-Affäre","pff., H.A.",[8],4,[1],[2],2,"20","4"],["2735","1968-02-02","Studentenkritische, aber betont sachliche Äußerungen von Professor Richard Löwenthal. Kritik auch von Professor Loos. Schilderung des Hergangs bei der Störung der Ordinariensitzung, auch der letztlich erfolglosen Bemühungen um Mäßigung. Teufel als Teilnehmer benannt. Gollwitzer spricht mit den Studenten.","An der Spitze: Fritz Teufel und der SDS","Berlin ","","Erich Bilges",[11],4,[1],[5],1,"20","5"],["2736","1968-02-02","Der amerikanische Journalist James O'Donnell äußert sich in einem US-Magazin zu Studentenunruhen (\"unreife Jugendliche\") und sieht Gefahr für Berlin. \"Hinter dem wilden Gebahren dieser jungen Studenten, die Schütz bei einer Diskussion als 'Idiot' beleidigt hätten, verberge sich eine 'neue Mentalität mit neurotischen, nationalistischen Untertönen, die durch einen modischen ultralinken Jargon überdeckt' würden.\"","\"Berlin durch Krise von innen bedroht\"","","","AP",[1],4,[5],[2],2,"20","5"],["2737","1968-02-03","Innensenator und Parteienvertreter verurteilen Angriffe auf sieben Ullstein-Filialen, bei denen Schaufensterscheiben eingeworfen worden sind, als kriminelle Akte. Erwähnung des Molotow-Cocktail-Films bei einer Vorveranstaltung des Springer-Tribunals","Senator Neubauer: Diese Anschläge sind kriminell","","Steinwürfe auf Zeitungsfilialen","v.C.",[10],4,[1],[2],2,"29","1"],["2738","1968-02-03","Karikatur schildert Radikale als Springer-Gegner nicht aber als Gegner der Mauer.","\"Ihr reaktionären Opas, was wollt ihr denn hier?!\"","","","Wolfgang Hicks",[10],4,[5,4],[2],1,"29","2"],["2739","1968-02-03","Ausführliche Schilderung der Anti-Springer-Versammlung im Audimax der TU mit detailierter Inhaltswiedergabe des Molotow-Cocktail-Films. Nach zweiter Vorführung Ultimatum der Demonstranten für Veto-Recht bei Studentenberichterstattung bzw. Aufruf zu direkten Aktionen. Hinweis, dass es neben dem Verlagshaus in der Kochstraße von Springer noch Filialen gäbe. Einige davon wurden dann in der Nacht angegriffen. Zitiert wird auch aus dem Text der \"Anleihe der Antispringerkampagne\". Senator Hoppe spricht von \"faschistischen Methoden\". Gerüchteweise wird erwähnt, dass die DDR die Anti-Springer-Maßnahmen unterstützen soll.","Einer rief: Es gibt 21 Filialen","Nach dem Film über Molotow-Cocktails","Studenten stellen ein \"Ultimatum\" - Wenige Stunden danach Steinwürfe in Schaufensterscheiben","v.C., Bi.",[10],4,[1],[1],1,"29","3"],["2740","1968-02-03","Kommentar zur Eskalation der Gewalt in Berlin, speziell gegen Springer; Vergleich mit dem Ende der Weimarer Republik und dem Nationalsozialismus.","Das ist kein Jux mehr - das ist Terror","","Zu den Vorgängen in Westberlin","Bernd Nellessen",[10],4,[5],[5],2,"29","3"],["2741","1968-02-03","Verschiedene Stimmen zum \"Go-in\" in der Philosophischen Fakultät der FU. AStA-Chef Landsberg distanziert sich von gewaltsamem Vorgehen. Studenten verwahren sich gegen Professor Harndts NS-Vergleich.","Senator Stein will vermitteln","Freie Universität","AStA-Vorsitzender kritisiert Studenten-Aktion","K.P., v.C.",[11],4,[1],[2],2,"29","3"],["2742","1968-02-05","Regierender Bürgermeister bezeichnet Angriffe auf Morgenpost-Filialen als \"kriminelles Rowdytum\".","\"Gesetze mit Härte anwenden\"","","Schütz zu den Unruhen in Berlin","v.C.",[10],4,[1],[2],2,"18","1"],["2743","1968-02-05","Berichte über Kudamm-Krawalle in Berlin, Ausschreitungen in Kiel, eine Demonstration in Bochum und Angriffe gegen das Frankfurter Amerika-Haus. Schwerpunkt Berlin, wo sich nach einer Demo vor der griechischen Militärmission zu einer gewalttätigen Straßenschlacht auf dem Kudamm ausgewachsen hatte.","Mehr als 100 Randalierer gestellt","Demonstrationen","Behörden greifen härter durch - Zwischenfälle in vier Großstädten","Bi., Eich.",[1],4,[1],[1],1,"18","3"],["2744","1968-02-05","Kommentar zur Entwicklung von der diskutierten zur angewendeten Gewalt. Insbesondere der SDS wird hier in der Verantwortung gesehen.","Die Praxis der \"rationalen Gewalt\"","","","Karsten Plog",[9],4,[5],[2],2,"18","3"],["2745","1968-02-05","Linksgruppen vereinigen sich zu einem Aktionszentrum. SDS verhält sich distanziert.","Zum Abschluss die \"Internationale\"","Linksgruppen","Sozialistisches Aktionszentrum in Offenbach gegründet","pff. ",[8],4,[1],[2],2,"18","3"],["2746","1968-02-06","500 Demonstranten, darunter Dutschke, attackieren in Frankfurt am Main mehrere amerikanische Einrichtungen","Deutsche Flagge wurde vom Dach geholt","","","pff.",[1],4,[1],[2],2,"18","1"],["2747","1968-02-06","Zwei Leserbriefe, die sich kritisch mit den Ausschreitungen der letzten Tage auseinandersetzen. NS-Bezüge.","Unglaublich / Gleiche Ziele","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"18","2"],["2748","1968-02-06","Vollversammlung der KU und Springer-Hearing in TU-Räumen nicht möglich. Gewaltaufrufe als Grund. Zu den Angriffen auf Morgenpost-Filialen wird ein Brief von Senator a.D. Adolf Arndt an Axel Springer zitiert: \"Als sei es gestern gewesen, steht mir vor Augen, dass Hitlers braune SA die Schaufenster der jüdischen Warenhäuser zertrümmerte. Das war einer der Auftakte zum Völkermord. Die Gewalttaten roter Faschisten gegen Zweigstellen Ihres Verlages erfüllen mich mit Empörung und Abscheu. Dieser Bubenstreich ist ein gegen Recht und Freiheit gerichtetes Verbrechen. Alle müssen darin solidarisch sein, solchen Wiederanfängen zu wehren.\"","TU-Rektor nimmt Genehmigung für zwei Veranstaltungen auf Hochschulgelände zurück","Berlin","Weichselberger erinnert an Bedingungen","v.C.",[10],4,[1],[5],2,"18","3"],["2749","1968-02-07","Parlamentsanfragen und Äußerungen verschiedener Politiker zu eskalierenden Unruhen.","Gerstenmaier: Jetzt ist ein deutliches Wort zu den Unruhen nötig","Regierung und Parlament schalten sich ein","IG Metall sieht noch keine Gefahr","ST., OR.",[1],4,[1],[1],2,"20","1,3"],["2750","1968-02-07","Vorschlag für niedersächsisches Hochschulgesetz","Studenten fordern Abschaffung der Habilitation","","Entwurf für ein Hochschulgesetz","R.S.",[4],4,[1],[2],2,"20","1"],["2751","1968-02-07","Kommentator vergleicht Erstarken der Kommunisten in Vietnam mit den zunehmenden Krawallen radikaler Kräfte in Deutschland.","Vietnam - auch in Deutschland?","","","Werner Titzrath",[1],4,[5],[5],2,"20","2"],["2752","1968-02-07","Details zu den Ausschreitungen in Frankfurt, an denen z. T. auch Rudi Dutschke teilgenommen hat.","Frankfurt: Polizei erstattet dreizehn Strafanzeigen","","Nach Demonstration - Vietkong-Fahne auf US-Handelszentrum","pff.",[1],4,[1],[1],1,"20","3"],["2753","1968-02-07","Parlamentsanfrage zu prügelnden Polizisten bei Schah-Demonstration.","FDP-Fraktionschef fordert Erklärung vom Justizsenator","","Versagen bei der Strafverfolgung - \"Schützenhilfe\" mit kleiner Anfrage beabsichtigt?","hae",[1],4,[1],[1],2,"20","11"],["2754","1968-02-07","Lt. Sontheimer könnte die Frage der Teilnahme von Erich Kuby an einer Podiumsdiskussion im OSI 1965 den Beginn den Beginn der Solidarisierung der Studenten markieren.","Solidarisierung begann mit \"Fall Kuby\"","","Prof. Sontheimer vor dem Untersuchungsausschuss","wt",[11],4,[1],[2],2,"20","11"],["2755","1968-02-08","Niedersächsischer Innenminister beobachtet beim SDS Vorbereitung von Arbeit in der Illegalität","Lehners: SDS plant Untergrundarbeit","","Für den Fall eines Verbots - Enger Kontakt mit Kommunisten","R.S., St.",[8],4,[1],[2],2,"18","1"],["2756","1968-02-08","Superintendent tadelt in einem Leserbrief den allzu nachsichtigen Umgang der Kirche mit Gottesdienststörern.","Für Provokateure nur sanfte Worte","Aus Briefen an die Redaktion","","Leser",[3],4,[6],[2],1,"18","2"],["2757","1968-02-08","Studenten vom RCDS u. a. verhindern durch \"SDS-artige\" Störaktionen einen Vortrag von DDR-RA Kaul, der auf SDS-Einladung an Bonner Uni reden sollte. Zahlreiche wörtliche Zitate von Zwischenrufen etc.","Der SDS gab sich geschlagen","Studenten ","\"Gastvorlesung\" Kauls mit Dutschke-Methoden verhindert","Rudolf Strauch",[8],4,[1,2],[5],1,"18","3"],["2758","1968-02-08","CDU-Fraktion im Abgeordnetenhaus stellt Antrag zur Verhinderung von Studentenunruhen. In der TU findet VOR dem Audimax eine VV der KU statt, bei der es u. a. um das geplante Springer-Hearing geht um um die Nichtzurverfügungstellung von Räumen durch die Uni.","Krawalle schon im Ansatz verhindern","","Dringlichkeitsantrag der CDU","eb",[11],4,[1],[1],2,"18","9"],["2759","1968-02-09","Sammelbericht über Innenministerkonferenz und Verhandlungen im Berliner Abgeordnetenhaus. Hier sieht die FDP ein SDS-Verbot kritisch.","Unruhen und Übergriffe sind Hauptthema in Bonn","Konferenz der Innenminister:","Gespräche mit den Ministerpräsidenten der Länder; SPD und CDU erwägen SDS-Verbot / Anträge beider Fraktionen im Abgeordnetenhaus; Innenminister warnen Radikale / \"Verletzungen der Rechtsordnung wird entgegengetreten\"","v.C., St.",[1],4,[1],[5],1,"16","1"],["2760","1968-02-09","Kritik an Bund und Ländern, die sich mit einer Hochschulreform zu viel Zeit lassen. \"?teils zu Recht erboste Studenten.\"","Langsam voran","Zum Tage","","W.G.",[4],4,[5],[2],2,"16","2"],["2761","1968-02-09","Vollversammlung aller Berliner Hochschulen im Haus des Städtetages. Diskussionen zwischen RCDS- und SDS-Vertretern. Versammlungen und Unruhen u.a. auch in Frankfurt, Kiel und Bonn. Sitzung der Deutschland-Stiftung wird gestört.","RCDS wendet sich gegen Gewalt als Mittel der Politik","","Rüegg: Jungrebellen in der Minderheit","",[1],4,[1],[1],2,"16","3"],["2762","1968-02-09","Heftige Debatten im Abgeordnetenhaus über Studentenunruhen, Hochschulreform, Anti-Krawall-Maßnahmen und ein mögliches SDS-Verbot.","Hochschulreform löst nicht alle Probleme","","Im Abgeordnetenhaus steigerten sich die Auseinandersetzungen zur Turbulenz","hae",[1],4,[1],[1],1,"16","9"],["2763","1968-02-09","FU-AStA scheitert vor Gericht mit Versuch, von Senator Stein eingesetztes außeruniversitäres Mitglied im Disziplinarausschuss der Philosophischen Fakultät zu verhindern. Er bekommt aber mit seinem Widerspruch gegen eine Raumverweigerung in der FU Recht. TU-AStA wehrt sich gegen Raumverweigerung für Springer-Hearing.","FU-AStA verlor und gewann","","\"Universitätstag\" vor dem Verwaltungsgericht","",[11],4,[1],[2],2,"16","10"],["2764","1968-02-10","Regierungserklärung zur Radikalisierung der Studentenunruhen mit anschließender Aussprache. Ausführliche Zitate.","Kiesinger: Gewaltakte der Radikalen werden nicht länger geduldet","Bund und Länder einig","Einmütige Haltung auch im Parlament","Schr.",[1],4,[1],[1],1,"30","1,3"],["2765","1968-02-10","Proteste in Baden-Württemberg gegen neues Hochschulgesetz","Betriebsrat unterstützt Studenten","","Vorlesungsstreik im Südwesten nur teilweise befolgt","Uhl.",[4],4,[1],[2],2,"30","1"],["2766","1968-02-10","Kommentator lobt Warnung der Politiker an Radikale, betont aber zugleich Notwendigkeit einer Hochschulreform.","Radikale","Zum Tage","","W.T.",[1],4,[5],[2],2,"30","2"],["2767","1968-02-10","Eröffnung einer Kunstausstellung durch Vietnamkriegs-Gegner gesprengt","Demonstranten stürmen Münchner Amerikahaus","","","AP",[1],4,[1],[2],2,"30","3"],["2768","1968-02-10","Einige wenige Demonstranten diskutieren mit Bundestagsabgeordneten vor dem Parlamentsgebäude.","Diskussion mit Studenten vor dem Bundeshaus","","","St.",[1],4,[1],[2],2,"30","3"],["2769","1968-02-10","Ausführlicher Stimmungsbericht von einem Sit-in, aus der SDS-Zentrale und dem Hauptquartier des Republikanischen Klubs. Versuch einer (laien-psychologischen) Erklärung der Radikalisierung.","\"Herr Kommilitone, Sie machen es sich zu leicht\"","In den Hauptquartieren der Rebellen","Sit-in in Berlin - Die Stützpunkte des SDS","Bernd Nellessen",[8],4,[5],[4],1,"30","5"],["2770","1968-02-10","Studentische Kritik an Gesetzentwurf und Anti-SDS-Anträgen. TU-Rektor rechtfertigt Raumvergabe für Springer-Hearing. Wertung des Molotow-Cocktail-Films als Satire weist er zurück.","TU-Studentenparlament lehnt Hochschulreformentwurf ab","","Parlamentsdebatte verurteilt / Anträge von SPD und CDU zeigen \"totalitären Geist\"","wt",[4],4,[1],[1],2,"30","15"],["2771","1968-02-12","Schütz warnt auf SPD-Landesparteitag vor Teilnahme an Vietnam-Demo.","Vor ungesetzlicher Demonstration gewarnt","","Schütz kündigt Vorgehen an","v.C. ",[1],4,[1],[2],2,"18","1"],["2772","1968-02-12","Kommentierender Bericht von der Veranstaltung bei der, unter Teilnahme von Eugen Kogon und Erich Kuby, das Nichtzustandekommen des geplanten Springer-Hearings beklagt wurde. Schuld sei der \"'Terror' und die 'Diktatur' des dem Verleger Axel Springer 'hörigen' Westberliner Senats\". Kritik ernteten Sicherungsmaßnahmen des Springer-Hauses. Kritik von Günter Anders erntete die Springer-Berichterstattung des Sechs-Tage-Krieges. Diese hätte den \"faschistischen Stil\" und \"faschistischen Geist\" der Springer-Zeitungen belegt.","Nicht \"Hearing\", sondern Schauprozess","","Die Vorbereitungen für ein \"Springer-Tribunal\" bestätigen die demagogische Absicht","Bernd Nellessen",[10],4,[1,5],[3],1,"18","2"],["2773","1968-02-12","Kritik an schleppenden und bislang weitgehend ergebnislosen Ermittlungen zu Polizei-Ausschreitungen bei der Anti-Schah-Demonstration im vergangenen Juni.","Wer kennt, wer nennt die Namen?","Berlin","Massive Kritik an Ermittlungen gegen drei Polizeibeamte","bi.",[7],4,[1],[2],2,"18","3"],["2774","1968-02-12","\"Das Kunststück, in der gegenwärtigen explosiven Erregung ein Gespräch zwischen Professoren und dem SDS-Agitator Rudi Dutschke über 'Revolution in Deutschland' herbeizuführen und friedlich, fast familiär, zu beenden - die älteste Evangelische Akademie in der Bundesrepublik, Bad Boll, hat es zuwege gebracht.\" Teilnehmer neben Dutschke waren die Professoren Maihofer, Bloch, Flechtheim und Marsch.","Diesmal sprach Rudi Dutschke nicht von Gewalt","Studenten","In der Evangelischen Akademie Bad Boll diskutierte der SDS-Ideologe mit den Professoren","Uhl.",[2],4,[1],[3],2,"18","4"],["2775","1968-02-13","Bericht über Dortmunder Großveranstaltung zur Hochschulreform, bei der der CDU-MdB und Reformbefürworter Hans Dichgans \"ausgezischt und ausgelacht\" wird.","Front der Professoren und Studenten","Bildungspolitik","Beim Kongress \"Hochschule und Demokratie\" in Dortmund","frh.",[4],4,[1],[3],2,"20","4"],["2776","1968-02-13","Kritik am angeblich zu laxen Umgang der Strafverfolgungsbehörden und insbesondere der Gerichte mit Unruhestiftern.","Kritisch betrachtet","","","er",[1],4,[5],[2],2,"20","12"],["2777","1968-02-13","Drei Leserbriefe, die sich kritisch mit dem Heinemann-Vorschlag auseinandersetzen, Gottesdienststörer durch Singen frommer Lieder zu vertreiben.","Störung des Gottesdienstes strafbar","","","Leser",[3],4,[6],[2],2,"20","13"],["2778","1968-02-14","Kritik an einer \"Panorama\"-Sendung mit Günter Grass und Eugen Kogon über das Springer-Hearing. Grass warnt vor studentischen Exzessen, kommt aber weniger als Kogon zu Wort.","\"Panoramas\" Kronzeugen","","","Bernd Nellessen",[10],4,[5],[2],2,"22","2"],["2779","1968-02-14","In den Verhandlungen der Synode wird Verständnis für die Unruhe der Studenten geäußert.","Synode beschäftigt sich mit den Studenten","Evangelische Union","Konferenzen in Spandau und Potsdam tauschen Grußbotschaften aus","Co.",[3],4,[1],[3],2,"22","4"],["2780","1968-02-14","Stimmungsbericht von den Diskussionen mit Dutschke u. a. in Bad Boll","\"Mit Tomaten werfen ist nicht genug\"","Bad Boll: Blick in den Abgrund","Gewalt contra Gewaltlosigkeit - Diskussion über die Revolution","Walter Pfuhl",[2],4,[1,5],[5],2,"22","5"],["2781","1968-02-14","Situation vor der für das Wochenende geplanten Demo des Vietnam-Kongresses gespannt","Senat bekräftigt Verbot der geplanten Vietnam-Demonstration","Berlin","Kraftprobe erwartet - Flugblätter rufen zur Kundgebung auf","v.C. ",[1],4,[1],[1],2,"22","6"],["2782","1968-02-14","Wissenschaftssenator Stein kritisiert Zustände an der FU","\"Dem Staat sind die Hände gebunden\"","","Stein: Autonomie verhindert Aufsicht an der Universität","Bi.",[11],4,[1],[2],2,"22","6"],["2783","1968-02-14","Vorläufige Verweisung des SDS-Mitglieds Hannes Heer von der Uni wird zurückgenommen","Bonner Rektor lenkt ein","","","dpa",[11],4,[1],[2],2,"22","6"],["2784","1968-02-14","Bayerischer Innenminister kritisiert Auswüchse der Studentenunruhen, will aber mit Studenten das Gespräch suchen.","Merk will mit den Studenten diskutieren","Bayern","Rede im Landtag - Kritik am Missbrauch der Grundrechte","wfm.",[1],4,[1],[2],2,"22","6"],["2785","1968-02-14","Frankfurter Studenten wollen bei Außenminister Brandt gegen Regierungsreaktion auf Verschleppung von Koreanern protestieren.","Notfalls \"Go-in\" bei Brandt","","","pff",[11],4,[1],[2],2,"22","6"],["2786","1968-02-14","Offizier hatte durch Gottesdienstbesuch mit Soldaten Störung im Hamburger Michel verhindert. Bonn kritisiert das nicht.","Bonn stellt sich vor General Hermann Wulf","","","St.",[3],4,[1],[2],2,"22","6"],["2787","1968-02-14","Kommunarden verunglimpfen in Leserbrief im FU-Studentenmagazin den Regierenden Bürgermeister. FU-Rektor distanziert sich. Schütz will Anzeige erstatten.","Schütz will Beleidigungsklage einreichen","","Gegen Redakteur des FU-Spiegels wegen Kommune-Leserbriefs","vc",[11],4,[1],[2],2,"22","11"],["2788","1968-02-14","Vorschlag der SPD zur Hochschulreform","SPD-Gesetzentwurf zur Hochschulreform","","Basis ist die Vorlage von Senator Prof. Werner Stein","eb",[4],4,[1],[2],2,"22","11"],["2789","1968-02-15","Stellungnahmen verschiedener Seiten zur geplanten Großdemonstration","Senat: Es bleibt bei dem Demonstrationsverbot","","","v.C.",[1],4,[1],[2],2,"20","1"],["2790","1968-02-15","Bundesinnenminister droht mit vereinsrechtlichen Schritten gegen den SDS.","Innenminister Lücke kündigt an: Der SDS wird notfalls verboten","Gespräch mit der Welt","Unter Berufung auf das Vereinsgesetz","W. H.-E.",[8],4,[1],[1],2,"20","3"],["2791","1968-02-15","Demo wird ungeachtet des Senatsverbots weiter vorbereitet. Stellungnahmen verschiedener Politiker und Gruppierungen.","Dutschke: Demonstration auf jeden Fall","Berlin","Teilnehmer wollen sich bei \"Provokationen\" zur Wehr setzen","v.C.",[1],4,[1],[2],2,"20","3"],["2792","1968-02-15","Engländer kritisiert, dass es immer noch Deutsche gibt, die radikalen Charismatikern (Dutschke) anhängen.","\"Nicht die geringste befreiende Erneuerung\"","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[1],2,"20","13"],["2793","1968-02-16","Gustav Heinemann verteidigt seinen Leserbrief vom 27.1. 1968 zum Verhalten bei Gottesdienststörungen","Selbstvertrauen","Aus Briefen an die Redaktion","","Leser",[3],4,[6],[2],2,"24","2"],["2794","1968-02-16","Leser (MdL) kritisiert \"Panorama\"-Sendung zum Springer-Hearing","Verzerrt","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","2"],["2795","1968-02-16","Karikatur zeigt gegen Lehrer demonstrierende Schulklasse (Übernahme aus der Süddeutschen Zeitung).","Gefahr von unten","","","H. Schoen",[1],4,[5,4],[3],1,"24","2"],["2796","1968-02-16","Versuch des Eindringens von Studenten in den Landtag wird von der Polizei verhindert. Innerhalb der CSU Meinungsverschiedenheiten zum Umgang mit Studenten. Strauß plädiert für mehr Härte.","Der Marsch auf den Münchner Landtag","","Nach einem \"Teach-in\" wollte eine Gruppe von Studenten in das Parlamentsgebäude eindringen","Rüdiger Dilloo",[1],4,[1],[5],1,"24","5"],["2797","1968-02-16","Demo gegen geplantes Hochschulgesetz in Stuttgart","Scharfe Töne auf dem Schillerplatz","Baden-Württemberg","Landtag gibt dem Druck gegen das Hochschulgesetz ein wenig nach","ühl., R.K.",[4],4,[1],[1],2,"24","6"],["2798","1968-02-16","Verhandlungen im Wissenschaftsausschuss des Bundestages","Beiräte sollen Hochschulreform in der Öffentlichkeit fördern","Universitäten","Wissenschaftsausschuss hört Professoren und Studenten","St.",[4],4,[1],[5],1,"24","6"],["2799","1968-02-16","Kleinere Demo des SPD-Mitgliedes Jürgen Gerull genehmigt. Stellungnahmen und Befürchtungen zu erwarteten Auseinandersetzungen bei einer Großdemo.","Befürchtungen einer Konfrontation häufen sich","","Vietnam-\"Aufzug\" genehmigt / SPD-Landesausschuss tritt zusammen","hae",[1],4,[1],[1],2,"24","13"],["2800","1968-02-16","Chefredakteur der Studentenzeitschrift entschuldigt sich bei Schütz und begründet, warum ihn der Beitrag nicht beleidigen sollte. Diesem Bericht ist ein Kommentar angehängt, der diesen Vorgang nach Form und Inhalt kritisiert: \"Der 'FU-Spiegel' hat sich nicht distanziert, sondern rational disqualifiziert.\"","FU-Spiegel entschuldigt sich","","Kommune-Pamphlet sollte Schütz nicht diffamieren","gvc.",[11],4,[1,5],[2],2,"24","14"],["2801","1968-02-16","Überlegungen der SPD-Fraktion im Kieler Landtag zur Hochschulreform","\"Prüfstein für die Konflikte\"","SPD diskutiert mit Studenten","Kiel: Drittel-Beteiligung in den akademischen Gremien gefordert","Helmut Alt",[4],4,[1],[2],2,"24","15"],["2802","1968-02-17","Politiker raten Bevölkerung, sich von ggf. stattfindender illegaler Demo fernzuhalten","Vietnam-Demonstration bleibt verboten / Politiker appellieren an die Berliner","","Ausschreitungen befürchetet - Kirchenleitung schaltet sich ein","Co.",[1],4,[1],[2],2,"26","1"],["2803","1968-02-17","Kritischer Kommentar zur Rolle Eugen Kogons beim Springer-Hearing","Das Abenteuer des Professors Kogon","","","Matthias Walden",[10],4,[5],[5],1,"26","2"],["2804","1968-02-17","Kritik an Abschaffung von Grundstudium und Zwischenprüfung in Bereichen der FU","Bärendienst","Zum Tage","","W.G.",[1],4,[5],[2],2,"26","2"],["2805","1968-02-17","Erklärungen von Senat, Parteien, Unigruppierungen etc. zur geplanten Demo. Schütz: \"Üben Sie keine Selbstjustiz:\"","Schütz: Extremisten unter sich lassen","","Erklärungen zur verbotenen Vietnam-Demonstration reißen nicht ab","gvc.",[1],4,[1],[1],2,"26","9"],["2806","1968-02-17","Entscheidung über eine Klage zum Demonstrationsrecht","Versammlungsgesetz ist nicht verfassungsfeindlich","","Verwaltungsgericht nahm zur Genehmigungspflicht von Demonstrationen Stellung","fa",[1],4,[1],[3],2,"26","9"],["2807","1968-02-19","Vietnam-Demo kurzfristig von Gericht genehmigt. Bericht vom weitgehend friedlichen Verlauf. Zitate von Schütz, Dutschke u. a. Hinweis auf eine Gegendemonstration.","Schütz: Radikale wollen unsere Städte in Unordnung bringen","","Gegendemonstration nach Vietnam-Kundgebung","",[1],4,[1],[1],1,"20","1"],["2808","1968-02-19","Kommentator begrüßt Zulassung der Demo. Position des SDS jetzt klarer. Rote Fahnen für Berliner \"schwer erträglich\".","Klärung","","","Co.",[1],4,[5],[2],2,"20","1"],["2809","1968-02-19","Leser wendet sich gegen die studentische Forderung, die Habilitation abzuschaffen","Habilitation","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"20","2"],["2810","1968-02-19","Kommentierender Bericht von der vierzehnstündigen Veranstaltung in der TU mit zahlreichen Zitaten, u.a. von Dutschke, der u.a. von einer Verpflichtung, sich auf den direkten Kampf vorzubereiten, spricht.","Revolutionstaumel bis ein Uhr nachts","Der Vietnam-Kongress in der TU-Berlin","Zum Schluss fordert Rudi Dutschke den \"direkten Kampf\"","Bernd Nellessen",[1],4,[1,5],[1],1,"20","5"],["2811","1968-02-19","Verlauf der Vietnam-Demo und ihrer Vorgeschichte. Innensenator lobt Berliner für Zurückhaltung. Für die Genehmigung der Demo hatte sich u.a. Bucerius eingesetzt. ","Neubauer würdigt entschiedene Haltung der Bevölkerung","","\"Appell des Senats befolgt\" - Demonstration im Zeichen der roten Fahne - Parteien beraten über Gegenkundgebung","",[1],4,[1],[5],2,"20","5"],["2812","1968-02-20","1500 Erlanger Studenten demonstrieren gegen die neue Satzung ihrer Hochschule","Studenten-Kritik an Erlanger Satzung","","Professoren: Ein Vorbild","wfm.",[4],4,[1],[2],2,"16","1"],["2813","1968-02-20","Aufruf des Regierenden Bürgermeisters an die Berliner, an einer von Parteien und Verbänden unterstützten Kundgebung vor dem Rathaus Schöneberg teilzunehmen. ","Freiheitskundgebung auf dem Kennedyplatz","Antwort an die Extremisten","Für Mittwoch einberufen - Schütz appelliert an die Berliner","v.C.",[1],4,[1],[5],2,"16","1"],["2814","1968-02-20","Meinungsverschiedenheiten in der SPD um Teilnahme von Ristock, Beck u.a. an der Vietnam-Demo","SPD: Demonstration der Mitglieder mißbilligt","","","Co.",[1],4,[1],[2],2,"16","1"],["2815","1968-02-20","Kommentar gegen die antiamerikanische Vietnam-Demonstration in Berlin, einer Stadt, die ihre Freiheit den Amerikanern verdankt. Ruhiger Demoverlauf nur aus taktischen Gründen. Mit Eskalationen muss gerechnet werden.","Revolutionärer Schall und Rauch","","Die Vietnam-Demonstration. Internationale \"Avantgarde\". Wille zur direkten Aktion","Bernt Conrad",[1],4,[5],[1],1,"16","2"],["2816","1968-02-20","Leser wehrt sich gegen Pauschalurteile über Studenten","Mit Pinsel und Farbe","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"16","2"],["2817","1968-02-20","Bericht über Erlanger Demo und über studentische Kritikpunkte an Hochschulsatzung, die von Professoren als besonders modern empfunden wird.","Erlanger Studenten: Eine Beruhigungspille, die wir nicht schlucken werden","Universitätsreform","Scharfe Attacken auf die neue Satzung","Wilhelm F. Maschner",[4],4,[1],[1],2,"16","3"],["2818","1968-02-20","SDS-Klage gegen Nichtgewährung von Bundeszuschüssen seit 1960","Keine Zuschüsse aus Bundesmitteln","","SDS erhebt Klage gegen Sperre","dpa",[8],4,[1],[2],2,"16","3"],["2819","1968-02-20","Rektorentagung zum Thema in Bad Godesberg","Rektoren beraten Hochschul-Reform","","Neuer Gewerkschaftsvorschlag","dpa",[4],4,[1],[2],2,"16","3"],["2820","1968-02-20","Meinungsverschiedenheiten in der SPD um Teilnahme von Ristock, Beck u.a. an der Vietnam-Demo","SPD-Landesausschuß behält sich personelle Konsequenzen vor","","Lebhafte Debatte nach der Vietnam-Demonstration","hae",[1],4,[1],[5],2,"16","3"],["2821","1968-02-21","Rüegg fordert Umorganisation der Rektorenkonferenz. Biedenkopf stellt Personalfrage. Uneinigkeit über Reformen.","Rektorenkonferenz uneinig: Kontroverse um Hochschulreform","","Kritik an Professor Rüegg - Wiederwahl gefährdet","ems",[4],4,[1],[1],2,"20","1"],["2822","1968-02-21","Wiedergabe des Demonstrationsaufrufes und Stellungnahme von Vertretern von Parteien und Verbänden.","\"Alle Berliner sind aufgerufen\"","Gegen den Extremismus","Freiheitskundgebung vor dem Schöneberger Rathaus heute 16:30 Uhr","",[1],4,[1],[5],2,"20","1"],["2823","1968-02-21","Karikatur, die den Kopf Dutschkes zeigt, der von fünf kleinen Männchen (Ärzten?) untersucht wird","Schwierige Diagnose","","","Wilhelm Hartung",[2],4,[5,4],[1],1,"20","2"],["2824","1968-02-21","Kommentator vergleicht die momentanen Unruhen mit denen 1932 und kommt zu dem Schluss, dass die Lage damals anders war. Dennoch müsse es heißen: \"Wehret den Anfängen.\"","Es ist anders als 1932","","","Michael Freund",[1],4,[5],[5],2,"20","2"],["2825","1968-02-21","Auseinandersetzungen um Demo-Teilnahme von SPD-Mitgliedern tragen zur Klärung des SPD-Standpunktes bei.","Klärung","Zum Tage","","Co.",[1],4,[5],[2],2,"20","2"],["2826","1968-02-21","Untersuchungsausschuss im Rathaus Schöneberg. Ordnungsstrafen für Dutschke und andere SDS-Mitglieder. Ausführliche Textzitate der Anhörungen. Vor dem Rathaus müssen SDS-Leute von der Polizei vor Markthändlern geschützt werden.","Polizei muss SDS-Anhänger schützen","Berlin","Tumult auf Schöneberger Wochenmarkt - \"Ich werfe Dich ins Heringsfass!\"","Hans-Erich Bilges",[7],4,[1],[1],1,"20","3"],["2827","1968-02-21","Niedersächsische Studenten gegen die Einführung von Trimestern","Studenten wenden sich gegen Trimester","","","R.S.",[4],4,[1],[2],2,"20","3"],["2828","1968-02-21","Äußerungen von Vertretern der Bezirksverbände der SPD zu Ristock & Co.","Urabstimmung in der Berliner SPD gefordert","","Erregte Diskussion in den Parteigremien über die Demonstrations-Teilnehmer","v.C.",[1],4,[1],[2],2,"20","3"],["2829","1968-02-21","Demoaufrufe verschiedener Verbände und Organisationen. Hinweise zur Anreise.","\"Wo wir Berliner wirklich stehen\"","","Aufrufe zur heutigen Kundgebung häufen sich","wt",[1],4,[1],[1],2,"20","11"],["2830","1968-02-22","Bericht über die Senatsdemo mit Zitaten der Redner. Wiederholt werden Texte von Anti-Dutschke-Transparenten und entsprechenden Sprechchören zitiert. Erwähnung mehrerer Schlägereien.","150000 Berliner machen Front gegen die Radikalen","","Schütz: \"Wir lassen uns die Freiheit nicht zertrampeln\"","",[1],4,[1],[1],1,"20","1"],["2831","1968-02-22","Würdigung der Kundgebung. \"Dass es dabei am Straßenrand verschiedentlich zu unerfreulichen Prügelszenen kam, ist sehr zu bedauern. Schläge sind niemals ein Argument.\"","Unbeirrt","","","Co.",[1],4,[5],[2],2,"20","1"],["2832","1968-02-22","Kommentator erwägt, ob Vietnam ein Thema für den Bundestag ist. Er kritisiert die radikalen Demonstranten in Deutschland und ihre politische Stoßrichtung.","Vietnam scheidet die Geister","","Eskalation der Demonstrationen - Ist eine Bundestagsdebatte nötig? - Für Frieden, aber nicht gegen Amerika","Günter Weiswrod",[1],4,[5],[1],2,"20","2"],["2833","1968-02-22","Zwei Münchener Studenten haben vertrauliche Protokolle des Akademischen Senats öffentlich gemacht. Ein solches Verhalten verträgt sich nicht mit dem Verlangen nach mehr universitärer Mitbestimmung.","Vertraulich","Studenten","","W.G.",[11],4,[5],[2],2,"20","2"],["2834","1968-02-22","Längere Zitate aus den Beiträgen der Kundgebungsredner. ","Eine Abfuhr für die Extremisten","Berlins Antwort","Sickert: Die Arbeitnehmer verteidigen den Rechtsstaat","",[1],4,[1],[1],1,"20","3"],["2835","1968-02-22","Dutschke auf niederländischem Flughafen für 20 Minuten festgenommen.","Dutschke in Amsterdam kurz festgenommen","","","dpa",[2],4,[1],[2],2,"20","3"],["2836","1968-02-22","FDP stellt keinen Redner bei der Senatsdemo. Grund hauptsächlich innerparteiliche Auseinandersetzungen mit und um William Borm.","Nur ein Missverständnis der FDP?","","Der \"Streit\" um William Borm - Niemand hat interveniert","Co., v.C.",[1],4,[1],[2],1,"20","3"],["2837","1968-02-22","Stimmungsbericht vom Rande der Demonstration. \"Vielen stand Rudi Dutschke als Symbol der Unruhen vor Augen. Das schlug sich nieder, auf Plakaten, Holz- und Papptransparenten und in Sprechchören. 'Berliner, das geht alle an - raus mit Dutschke, Teufel, Kunzelmann', hieß es. Ein junger Mann wurde sogar verprügelt, weil ihn Demonstranten fälschlicherweise für Dutschke hielten. Über einen Lautsprecher ertönte die Stimme eines Gewerkschaftsfunktionärs: 'Wer unsere Demokratie in Gefahr bringt, muss mit der Entschlossenheit der Gewerkschaft rechnen.' Tosender Beifall. Bauarbeiter trugen ein Holzplakat mit der gelben Aufschrift 'Volksfeind Nr. 1 - Rudi Dutschke, raus mit dieser Bande'.\"","\"?raus mit Dutschke, Teufel, Kunzelmann\"","","","Bi.",[1],4,[1],[2],2,"20","3"],["2838","1968-02-23","Tagung der Westdeutschen Rektorenkonferenz u. a. mit personellen Querelen.","Rektoren in der Defensive","","Nach der Plenarsitzung - Es wird mittlerer Kurs gesteuert - Der neue Präsident","Walter Görlitz",[4],4,[5],[1],2,"22","2"],["2839","1968-02-23","IG Metall-Sprecher betont Nichtverhältnis zum Republikanischen Club.","Kein Verhältnis","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"22","2"],["2840","1968-02-23","Leserbrief gegen linke Studenten, denen es längst nicht mehr um eine Hochschulreform ginge. \"Wie lange müssen wir das kommunistische Revoluzzer-Geschrei ertragen?\"","Revoluzzer-Geschrei","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["2841","1968-02-23","Kommentar der Senatsdemo. Die Berliner wollen, dass Berlin eine normale Stadt ist. \"?Walter Sickert forderte, nicht Hass gegen Hass zu setzen, und Klaus Schütz wies darauf hin, dass keineswegs alle Studenten in einen Topf geworfen werden könnten. Nein, eine 'Pogrom-Stimmung', wie mancherorts zu lesen war, wurde hier nicht angeheizt. Der unter Hochdruck stehende Kessel der Emotionen kochte an einigen Stellen einfach über. Jeder vernünftige Mensch in Berlin bedauert das, und es ist zu hoffen, dass nach dieser Entladung und der eindrucksvollen Manifestation der politischen Kundgebung nun die sprichwörtliche Gelassenheit der Berliner wieder Platz greift.\"","Was die Berliner wollen","","","Bernt Conrad",[1],4,[5],[2],2,"22","2"],["2842","1968-02-23","Stellungnahmen aus West und - vor allem - aus Ost zur Senatsdemo. Aus der DDR einhellige Ablehnung.","Die SED spricht von \"Porgrom-Hetze\"","Demonstration","Schütz: Alle Welt weiß jetzt, wo die Berliner stehen","Co., v.C.",[1],4,[1],[1],2,"22","3"],["2843","1968-02-23","Bayern bildet Gremium aus Politikern und Studenten zur Hochschulreform.","Politiker und Studenten bilden Kommission","","Meinungsaustausch erstrebt","di.",[4],4,[1],[2],2,"22","3"],["2844","1968-02-23","Hochschulrektorenkonferenz u.a. zum Status der Assistenten","\"Rektoren weichen nicht vom Reformkurs ab\"","Universitäten","Erklärung nach der Plenarsitzung - Modellentwurf für die Hochschulorgane","ems",[4],4,[1],[3],2,"22","3"],["2845","1968-02-23","Meinungsumfrage unter Berlinern zur politischen Haltung der Studenten hat liberales Ergebnis.","Tolerante Haltung befürwortet","","Umfrage zum politischen Engagement der Studenten","el",[1],4,[1],[2],2,"22","13"],["2846","1968-02-23","CDU stellt im Abgeordnetenhaus die Frage, ob öffentlich Bediensteten, die an der Vietnam-Demo teilgenommen haben, Konsequenzen drohen.","Schütz: Besondere Zurückhaltung bei juristischen Konsequenzen","","Teilnahme an Demonstrationen beschäftigten das Parlament","hae",[1],4,[1],[5],2,"22","13"],["2847","1968-02-24","Studenten und Dozenten der HfG wehren sich gegen geplante Eingliederung in die Ulmer Ingenieurschule.","Dozenten und Studenten in Ulm drohen: Wir machen Schluß","\"Hochschule für Gestaltung\" vor der Auflösung?","Minister Hahn bestürzt - \"Ich kann es nicht glauben\"","dns",[11],4,[1],[5],2,"26","1"],["2848","1968-02-24","Berliner DGB-Chef weist Kritik hessischer Gewerkschaftsfunktionäre an seiner Beteiligung an der Senatsdemo zurück.","Sickert weist Vorwürfe zurück","","\"Haltung der Kritiker schädlich für die Gewerkschaften\"","v.C.",[1],4,[1],[2],2,"26","1"],["2849","1968-02-24","Linke Proteste gegen Redner bei Gedenkveranstaltung in Münchener Uni.","Krawalle bei Gedenkfeier für die Geschwister Scholl","","","di.",[1],4,[1],[2],2,"26","1"],["2850","1968-02-24","Statistisches zu den Studenten in NRW","72,5 Prozent beendeten Studium mit Hauptexamen","","","AP",[11],4,[1],[2],2,"26","1"],["2851","1968-02-24","Hochschulrektoren und Kulturminister zur Semesterordnung","Holthoff: Studienjahr statt Semester","Universitäten","Rektoren schränken ihr Nein zu Hahns Trimester-Vorschlag ein","frh., uhl.",[4],4,[1],[5],1,"26","4"],["2852","1968-02-24","Schilderung der Störungen bei der Scholl-Gedenkfeier. Vater der Widerstandskämpfer hatte um Unterlassung von Störungen gebeten. Zum Marsch zum Münchener Verlagssitz von Axel Springer aufgefordert.","Der Appell des Vaters blieb unbeachtet","Radikale","Linksgruppen stören Gedenkfeier für die Geschwister Scholl","di.",[1],4,[1],[2],2,"26","4"],["2853","1968-02-24","Teufel u.a. wegen Richterbeleidigung zu Haftstrafe verurteilt.","Zwei Monate Haft für Fritz Teufel","","","fa.",[5],4,[1],[2],2,"26","4"],["2854","1968-02-24","Entgegen einem AStA-Beschluss veranstaltet Uni Göttingen weiterhin Studentenfahrten nach Berlin.","Berlin-Seminar findet statt","","","dpa",[11],4,[1],[2],2,"26","4"],["2855","1968-02-24","CDU will Ristock wegen Teilnahme an Vietnam-Demo als Charlottenburger Volksbildungsstadtrat abwählen lassen.","CDU-Fraktion beantragt Ristocks Abwahl","","","",[1],4,[1],[2],2,"26","4"],["2856","1968-02-24","Juso-Kritik u.a. Schütz wegen Senats-Demo.","Jungsozialisten üben Kritik an Berliner SPD","","","dpa",[1],4,[1],[2],2,"26","4"],["2857","1968-02-24","Ausgehend von dem Bloch-Zitat, Gründe für eine Revolution könnten auch Langeweile und Schwermut sein, erwägt der Autor mögliche Ursachen für die Unruhe der Radikalen.","Revolution aus Langeweile?","","","Günter Zehm",[1],4,[5],[5],2,"26","I"],["2858","1968-02-26","Schüler entrüstet sich über Schüler- und Studentendemos gegen Fahrpreiserhöhungen.","Fahrgeld","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"16","2"],["2859","1968-02-26","Vom \"Extradienst\" wird die Aufstellung einer Miliz als \"wirkungsvolles Instrument verfassungskonformer, demokratischer Gegengewalt\" ins Gespräch gebracht. Innerhalb der SPD Uneinigkeit bei der Bewertung der Senatsdemo.","Eine \"Miliz\" soll Aktionen der Radikalen auf der Straße schützen","Berlin","Vorschlag der Linken - SPD ringt um Geschlossenheit","v.C.",[1],4,[1],[5],2,"16","4"],["2860","1968-02-26","Junge Union Schleswig-Holstein kritisiert Jungdemokraten für Solidaritätserklärung mit SDS.","Fragen an Jungdemokraten nach Solidarität mit SDS","","","H.A.",[8],4,[1],[2],2,"16","4"],["2861","1968-02-26","Gastbeitrag des Marburger Theologen, der sich kritisch mit verschiedenen Bestrebungen der Hochschulreformen und mit den Unruhen unter den Studenten auseinandersetzt.","\"Ich kann nicht länger schweigen?\"","In tiefer Sorge um unsere Universität","Was heißt \"Demokratisierung\"? Und was bedeutet sie?","Ernst Benz",[4],4,[5],[1],2,"16","6"],["2862","1968-02-26","Strukturneuordnung an der TH Braunschweig","TH Carolo-Wilhelmina wird neue Satzung beraten","","","DW.",[4],4,[1],[2],2,"16","6"],["2863","1968-02-26","Reformbestrebungen durch Jus-Studenten an der Uni Tübingen.","Jura-Studenten wollen Jura-Studium verbessern","","","DW.",[4],4,[1],[2],2,"16","6"],["2864","1968-02-27","Kommentar zur Verwendung von Fahnen, u.a. von Demonstranten in Deutschland","Aber die Fahne ist wieder dabei","","Nicht nur in Vietnam?auch auf deutschen Straßen - Gefühle brauchen ein Symbol","Ernst-Ulrich Fromm",[1],4,[5],[1],2,"18","2"],["2865","1968-02-27","Innerparteiliche Diskussion und Untersuchung der Teilnahme an der Vietnam-Demo u.a. von Ristock und Beck.","SPD wirft Mitgliedern \"schwere Schädigung der Parteiinteressen\" vor","Berlin","Kommission untersucht Vietnam-Demonstration","v.C.",[1],4,[1],[5],2,"18","4"],["2866","1968-02-28","Leser kritisiert Demo-Teilnahme von SPD-Politikern, die gemerkt haben müssten, worum es eigentlich gegangen sei.","Gar nicht um Vietnam","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["2867","1968-02-28","Artikel zu polizeilichen Ausschreitungen bei Schah-Besuch Juni 1967 und schleppender Aufarbeitung derselben.","Eine Flut von Verfahren gegen Polizeibeamte","Berlin","Vorwurf schwere Unkorrektheit gegen Staatsanwaltschaft - \"Es wurden Fehler gemacht\"","Bi.",[1],4,[1],[1],2,"20","6"],["2868","1968-02-29","Vor VDS-Kongress Erwartung stärkerer Politisierung des Verbandes. Erwähnung mehrerer zu erwartender Anträge, einer z. B. auf Anerkennung der DDR.","Studenten: VDS soll politischer Interessen-Verband werden","","Anträge für die Tagung in München enthalten viel Zündstoff","ems",[11],4,[1],[1],2,"20","1,3"],["2869","1968-02-29","Leser kritisiert Vorschlag zu Abschaffung der Habilitation.","Hochschullehrer","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"20","2"],["2870","1968-02-29","Kritik an schleppenden Ermittlungen gegen Polizisten nach Ausschreitungen bei Schah-Besuch und an noch nicht eingeleiteten Verfahren gegen Demonstranten.","Berliner Justiz","","","bi.",[1],4,[5],[2],2,"20","2"],["2871","1968-02-29","Leser versucht sich in einer Analyse möglicher Gründe für studentische Radikalisierung.","Der radikale Teil der Studentenschaft","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[1],2,"20","13"],["2872","1968-03-01","Kommentator warnt vor Politisierung des VDS.","Studentenverband am Kreuzweg","","VDS als politische Kampfgruppe? - Absage an Staat und Gesellschaft - Diagnose, nicht Prognose","Walter Görlitz",[11],4,[5],[1],2,"24","2"],["2873","1968-03-01","Empörung über die Störung der Scholl-Gedenkfeier","Rüpelhaft","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"24","2"],["2874","1968-03-01","Sprecher der Bayerischen Assistentenkonferenz erläutert in Gastbeitrag die Forderung der Assistenten nach größerer Beteiligung an Hochschulentscheidungen.","Was die Assistenten fordern","","","Walter Mayer",[4],4,[6],[5],1,"24","2"],["2875","1968-03-01","Wohlwollende Kirchendiskussionen zu Studentenunruhen","Kirchenkonferenz berät Lage der Jugend","","\"Nicht repressiv abwehren\"","Co.",[3],4,[1],[2],2,"24","3"],["2876","1968-03-01","Senat und Berliner Gewerkschaften rechtfertigen Senatsdemo","\"Wir sind kein Nachtwächter-Staat\"","Berlin","Schütz und DGB weisen Kritik an Demonstration zurück","v.C.",[1],4,[1],[2],2,"24","4"],["2877","1968-03-01","Ex-Gewerkschaftsboss veurteilt hessische Gewerkschaftskritik an DGB-Beteiligung an Senatsdemo","\"Zum Schaden der Gewerkschaften\"","","Scharnowski: Verurteilung der Kundgebung war leichtfertig","Co.",[1],4,[1],[2],2,"24","4"],["2878","1968-03-01","Ausblick auf die Bundesdeligiertenversammlung des SHB. Veränderung der Struktur der Presse gefordert.","Studenten sprechen von \"Gemeinplätzen\"","Sozialdemokratischer Hochschulbund","Hochschulgruppen fordern Anerkennung der \"DDR\"","St.",[11],4,[1],[2],2,"24","6"],["2879","1968-03-01","Bundesforschungsminister kritisiert auf RCDS-Kongress Linksgruppen","Stoltenberg: Utopien des SDS längst überholt","","","UPI",[8],4,[1],[2],2,"24","6"],["2880","1968-03-02","Reg. Bürgermeister äußert sich in SPD-Blatt zur Senatsdemo und kritisiert Vietnam-Demonstranten.","Schütz warnt vor Konfrontationen","","","dpa",[1],4,[1],[2],2,"28","4"],["2881","1968-03-02","Foto mit längerer BU von Studentenkrawallen in Rom.","keinen (Foto mit Bildunterschrift)","","","",[9],4,[1],[5],1,"28","4"],["2882","1968-03-02","Aufgehängt am Zehm-Beitrag plädiert Leser teilweise im Sinne der Studenten.","Aus Langeweile?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","6"],["2883","1968-03-02","Leser äußert sich zur Deutschland-Stiftung und zur Störung der Gedenkfeier","Geschwister-Scholl-Gedenkfeier","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","6"],["2884","1968-03-02","Lob für die Senatsdemo","Dank den Berlinern","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","6"],["2885","1968-03-04","Leser schreibt SDS zu, endlich ensthafte Diskussionen über Hochschulreform in Gang gebracht zu haben.","Das Positive im SDS","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"20","2"],["2886","1968-03-04","Kommentator verwahrt sich gegen ungerechtfertigte Kritik an Senatsdemo. U.a. Kritik an Grass.","Von \"Pogromhetze\" kann nicht die Rede sein","Die Begriffe richtigstellen","","Ernst-Ulrich Fromm",[1],4,[5],[5],2,"20","2"],["2887","1968-03-04","Glossiert die Bartmode des Studenten und damit einhergehende Gefahren. Geht nebenbei auf Ausschreitungen bei Senatsdemo ein.","Kritisch betrachtet","","","hae",[1],4,[2],[2],2,"20","11"],["2888","1968-03-05","Bericht konstatiert weitere Politisierung des VDS","VDS von Spaltung bedroht","","Neue politische Aktionen bei Jahresversammlung angekündigt","di.",[11],4,[1],[2],2,"20","1"],["2889","1968-03-05","Bericht vom Beginn des VDS-Kongresses","Rektoren fordern sachlichere Arbeit","Studenten","Grußbotschaften an VDS-Versammlung - Plädoyer für politisches Engagement","di.",[11],4,[1],[1],2,"20","6"],["2890","1968-03-05","Kritik am baden-württembergischen Hochschulgesetz-Entwurf","Hochschulgesetz stößt auf Ablehnung","","Universitäten haben Bedenken","HH",[4],4,[1],[2],2,"20","6"],["2891","1968-03-05","Streit zwischen Frankfurter Bürgermeister und Polizei über vorübergehende Verhaftung Dutschkes.","Kontroverse in Frankfurt um Rudi Dutschke","","","pff",[2],4,[1],[2],2,"20","6"],["2892","1968-03-06","VDS brüskiert Bayerische Landesregierung durch Absage eines vorgesehenen Empfangs.","VDS sagt Empfang der Regierung ab","","Telegramm spricht von studentenfeindlicher Politik","di.",[11],4,[1],[3],2,"20","1"],["2893","1968-03-06","OSI-Direktor Alexander Schwan zu Reformen an seinem Institut","\"Für Dutschkisten keine Zukunft\"","","Der Leiter des Berliner Otto-Suhr-Instituts nimmt wichtige Änderungen in Angriff","Bi.",[11],4,[1],[3],2,"22","10"],["2894","1968-03-06","Bericht über Unruhen an Schulen und die Unabhängige Schülergemeinschaft USG","Welle der Unruhe ist bereits auf Schulen übergegangen","","Senator Evers will vor allem flexibel reagieren - Überall aktive Gruppen","hae",[9],4,[1],[3],2,"22","11"],["2895","1968-03-06","Flügel-Auseinandersetzungen in der SPD um Teilnehmer an Vietnam-Demo.","Zwist in der SPD hat sich erneut überraschend zugespitzt","","Vertrauliche Gespräche mit Bundesprominenz","el",[1],4,[1],[5],2,"22","11"],["2896","1968-03-07","Kommentar setzt sich kritisch mit dem Verlangen der Studenten nach politischer Verantwortung auseinander.","Die traditionelle Universität in den Grundfesten bedroht","","VDS-Kongress in München - Wie weit reicht das politische Mandat der Studentenschaft?","Paul Lersch",[11],4,[5],[3],1,"22","2"],["2897","1968-03-07","Grass und Bucerius kritisieren Berliner Senat für Senats-Demo. Grass spricht von Pogromstimmung. Schütz reagiert mit offenem Brief, in dem er die Erhaltung des freiheitlichen Rechtsstaates zum Maßstab des Handelns erklärt.","Grass appelliert an SPD-Parteitag","Berlin","Veranstaltung in der TU - Schütz schreibt offenen Brief","Bi.",[1],4,[1],[3],2,"22","3"],["2898","1968-03-07","Auflistung der durchgeführten bzw. angekündigten Maßnahmen gegen das nun verabschiedete Hochschulgesetz.","Landtag weicht den Drohungen nicht","Baden-Württemberg","Hochschulgesetz wird trotz der Studentenproteste verabschiedet","Uhl.",[4],4,[1],[1],2,"22","6"],["2899","1968-03-07","Kontroverse Diskussionen zu politischen Fragen beim VDS-Kongress","VDS berät über Vietnam-Antrag - Harte Kritik am Jahresbericht","Studenten","Bonner \"Aktion 68\" warnt vor Politisierung","di., ems.",[11],4,[1],[5],2,"22","6"],["2900","1968-03-08","Auflösungsbeschluss wird möglicherweise verschoben.","Ulmer Hochschule gewinnt Zeit","","","dns.",[11],4,[1],[2],2,"22","1"],["2901","1968-03-08","Hochschulgesetz soll trotz aller Proteste in Kraft treten.","Hochschulgesetz tritt bald in Kraft","","","Uhl.",[4],4,[1],[2],2,"22","1"],["2902","1968-03-08","Münchener Philosophie-Professor kritisiert Gefährdung der Universitäten und die Studentenunruhen. Nennt namentlich Marcus, erwähnt den SDS. \"Zum zweitenmal in diesem Jahrhundert ist die deutsche Universität in tödliche Gefahr geraten.\"","Die Techniker der Studentenrebellion","Gast der WELT","","Helmut Kuhn",[1],4,[5],[5],1,"22","2"],["2903","1968-03-08","Ausgelöst durch eine Pro-Vietkong-Resolution betont Walter Görlitz, dass der VDS nicht für alle Studenten spreche.","Resolution","Zum Tage","","W.G.",[11],4,[5],[2],2,"22","2"],["2904","1968-03-08","Mitunter wie eine Glosse wirkender Bericht vom Münchener VDS-Kongress, der besonders \"Mauscheleien\" der Beteiligten aufs Korn nimmt.","\"Hauptsache, es hat Wirbel gemacht\"","Die VDS-Tagung in München","Die Studentenvertreter halten ihr politisches Mandat für selbstverständlich","Rüdiger Dilloo",[11],4,[1,5],[1],1,"22","5"],["2905","1968-03-08","Studenten aus Tübingen und Ludwigsburg fahren abends über Dörfer und betreiben Bildungsarbeit","Bildungsoffensive mit Film und Luftballons","","Baden-Württemberg: Studentische Aktivität - einmal anders aufgefasst","uhl.",[11],4,[1],[5],2,"22","5"],["2906","1968-03-08","Buh-Rufe von der Besuchertribüne bei Parlamentsabstimmung. Als Räumung angeordnet wird, fliegen zerrissene Flugblätter durch das Plenum.","Protest mit zerrissenen Flugblättern","Baden-Württemberg","Studenten demonstrierten bei der Abstimmung über das neue Hochschulgesetz","Uhl.",[4],4,[1],[1],2,"22","6"],["2907","1968-03-08","Kurzer Bericht über verschiedene Beschlüsse des Münchener VDS-Kongresses","VDS für gesetzliche Krankenversicherung","","\"Drittelparität\" gefordert","dpa,UPI,AP",[11],4,[1],[2],2,"22","6"],["2908","1968-03-08","Studienrätin versucht eine differenzierte Erklärung der Studentenunruhen.","Jugend braucht Vorbilder und Anreiz zur Leistung","Aus Briefen an die Redaktion","","Leserin",[1],4,[6],[1],2,"22","9"],["2909","1968-03-08","Geht auf den Fromm-Kommentar vom 4.3. ein und warnt vor Gewaltaufrufen grundsätzlich und gegen Menschen, nur weil sie Studenten oder Bartträger sind im Besonderen. (Leserbriefschreiber ist MdB Adolf Arndt)","Keine Pogromhetze","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","9"],["2910","1968-03-08","Falken äußert Sorge, dass Vietnam-Kriegsgegner in ihren Berlin-Reisegruppen in physische Bedrängnis kommen könnten. ","\"Falken\" sorgen sich um Berlin-Fahrten","","Positive Eindrücke könnten in das Gegenteil umschlagen","",[9],4,[1],[2],2,"22","13"],["2911","1968-03-08","Innerparteiliche Unterstützung für Vietnam-Demo-Teilnehmer Erwin Beck.","SPD-Fraktion steht hinter Beck","","Diskussion um Abwahlantrag - Bezirksparlament tagte","er",[1],4,[1],[2],2,"22","13"],["2912","1968-03-09","Kein Beschluss zur Frage des politischen Mandats auf Münchener VDS-Kongress","VDS uneinig über politisches Mandat","","Von der Tagesordnung abgesetzt","di., ems.",[11],4,[1],[2],2,"30","1"],["2913","1968-03-09","Leserbrief von Gerd Bucerius, in dem er darauf hinweise, dass er Dutschke nicht als gefährlich, sondern als gefährdet bezeichnet habe.","Dutschke","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[2],2,"30","2"],["2914","1968-03-09","Kommentator sieht Diskussion zu Vietnam-Demo-Teilnehmern auf SPD-Parteitag als Beitrag zur Klärung der Parteiflügel.","Berliner SPD","","","Co.",[1],4,[5],[2],2,"30","2"],["2915","1968-03-09","Auflistung anstehender Verfahren im Gefolge der Anti-Schah-Demonstration Juni 1967. Neben Polizisten und Studenten soll ein Arzt vor Gericht, der die Behandlung einer verletzten Person verweigert hat.","Demonstrations-Nachlese: Neun Anklagen","","Polizisten, Studenten und ein Arzt sollen sich verantworten","af",[1],4,[1],[2],2,"30","9"],["2916","1968-03-09","Schütz weist in Brief an Grass dessen Pogrom-Vorwurf ebenso als unangebracht zurück wie den anderweitig vorgebrachten Vergleich des Angriffs auf Morgenpost-Filialen mit der \"Reichskristallnacht\".","Briefwechsel geht weiter","","","",[1],4,[1],[2],2,"30","9"],["2917","1968-03-09","Angriffe gegen Ristock als Charlottenburger Volksbildungsstadtrat.","Ristock musste sich verteidigen","","CDU-Abwahlantrag erregte Charlottenburger Bezirksverordnete","ska",[1],4,[1],[2],2,"30","9"],["2918","1968-03-09","Prozess gegen Polizeipräsidenten unterbrochen, weil geklärt werden muss, ob Knüppeleinsatz bei Schah-Demo als \"alliiertes Vorbehaltsrecht zu betrachten\" gewesen wäre.","Gericht will britischen Stadtkommandanten befragen","","Verhandlung der Klage einer Studentin gegen Polizeipräsidenten überraschend vertagt.","fa",[1],4,[1],[2],2,"30","9"],["2919","1968-03-09","Zehlendorfer Jusos fordern Rücktritt Innensenator Neubauers wegen Nichtgenehmigung der Vietnam-Demo","Rücktritt Neubauers gefordert","","","",[1],4,[1],[2],2,"30","9"],["2920","1968-03-09","Berliner SPD-Chef weist Falken-Vorwürfe gegen Senatsdemo zurück.","Mattick schreibt an \"Falken\"","","","",[1],4,[1],[2],2,"30","9"],["2921","1968-03-11","Erste VDS-Austritte nach Münchener Tagung: Würzburg, Saarbrücken, Karlsruhe, Clausthal (TH)","Vier Hochschulen verlassen VDS","","","di.",[11],4,[1],[2],2,"20","1,3"],["2922","1968-03-11","Forderung nach Reform der Ingenieursausbildung durch AStA-Chef eines Polytechnikums","Ingenieurschulen drohen mit \"Rebellion\"","","","wfm.",[11],4,[1],[2],2,"20","1"],["2923","1968-03-11","Leser stellt das \"politische Mandat\" von Studenten in Frage","Politisches Mandat","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","2"],["2924","1968-03-11","Kommentator räsonniert über VDS-Austritte. Gründe u. a. Verhältnis zu den Amerikanern und zur DDR.","VDS-Revolution?","Zum Tage","","W.G.",[11],4,[5],[2],2,"20","2"],["2925","1968-03-11","Kritik an der Senatsdemo, insbesondere an einigen Politikeräußerungen und Ausschreitungen gegen Andersdenkende.","Begleitumstände erfüllen mit Sorge","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","13"],["2926","1968-03-12","Neuer VDS-Vorstand unter Christoph Ehmann formuliert prononciert Linkskurs des Verbandes","VDS: Wir lehnen diesen Staat ab","","Verband Deutscher Studentenschaften geht auf Linkskurs","di.",[11],4,[1],[2],1,"22","1,6"],["2927","1968-03-12","Aufgehängt an einem SDS-Zitat: Kritik an 137 Wissenschaftlern, die sich gegen die geplante Notstandsgesetzgebung ausgesprochen haben.","Anti-Notstand","","","ems",[1],4,[5],[2],2,"22","2"],["2928","1968-03-12","Mehrheitlich äußern sich Studentengruppierungen in einer FDP-Veranstaltung gegen die Notstandspläne der Regierung","Studentenverbände sagen nein zur geplanten Notstands-Verfassung","Freie Demokraten","FDP-Hearing im Bundeshaus - RCDS verlässt die Sitzung","ems",[1],4,[1],[1],2,"22","6"],["2929","1968-03-12","Haftstrafe für Teufel wegen ungebührlichen Benehmens vor Gericht. In der Verhandlung geht es um Brandstiftung.","Weitere vier Tage Haft für Fritz Teufel","","","Bi.",[5],4,[1],[2],2,"22","6"],["2930","1968-03-12","Bericht über Delegiertenversammlung des RCDS, der sich zunehmend kritischer zur CDU positionieren will.","CDU-Studenten lösen sich von den Rockschößen","RCDS","\"Initialzündung für die Partei\" - Reform statt Revolution steht auf dem Programm","ems",[11],4,[1],[3],2,"22","6"],["2931","1968-03-12","Parteilinker Jürgen Gerull und vier Mitglieder der Falken aus SPD ausgeschlossen. Ristock und Beck beantragen Parteiordnungsverfahren gegen sich selbst.","SPD schloss fünf Mitglieder aus","","Landesvorstand entschied sich schon jetzt für drastische Maßnahmen","wt",[1],4,[1],[1],2,"22","11"],["2932","1968-03-13","VDS-Vorsitzender grenzt Verband von SDS ab, betont jedoch Nähe zur APO","VDS-Vorsitzender: Verband nicht in den Klauen des SDS","","Für Reform statt Revolution","ems",[11],4,[1],[2],2,"22","1,6"],["2933","1968-03-13","Kritik am Bundeskanzler, weil er nicht bzw. zu wenig auf die Anliegen der Studenten eingeht. Die Politik lässt damit zu, dass die Jugend von anderen Kräften politisch geformt wird.","An der Jugend vorbei","","Kiesingers Lagebericht - Keine Antwort an die Studenten - Pragmatiker und Idealisten","Georg Schröder",[1],4,[5],[1],2,"22","2"],["2934","1968-03-13","Kommentator räsonniert über die Zerrissenheit der Berliner SPD im Gefolge der Vietnam-Demo.","Gerull und die Folgen","","Der Ausschluss von Berliner SPD-Mitgliedern ist Zündstoff für Nürnberg","Bernt Conrad",[1],4,[5],[3],2,"22","2"],["2935","1968-03-13","Berliner Studentengruppierungen schreiben an polnischen Ministerpräsidenten, um demonstrierende polnische Studenten zu unterstützen.","Berliner Studenten schreiben an Cyrankiewicz","","","Bi.",[11],4,[1],[2],2,"22","4"],["2936","1968-03-13","Rektor und Akademischer Senat bringen bei Senator Stein Kritik gegen geplantes Gesetz vor.","Bedenken der FU gegen neues Universitätsgesetz","","","v.C.",[4],4,[1],[2],2,"22","6"],["2937","1968-03-13","Katholische Deutsche Studenten-Einigung gegen das vom VDS beanspruchte politisches Mandat.","Katholische Studenten gegen politisches Mandat","","","KANN,dpa",[11],4,[1],[2],2,"22","6"],["2938","1968-03-13","Heftige innerparteiliche Diskussionen wegen des Umgangs mit Vietnam-Demo-Teilnehmern","Sehr unterschiedliches Echo auf SPD-\"Säuberungswelle\"","","Protest beim Bundesvorstand - Schütz gegen Urabstimmung und Parteiausschluss","hae",[1],4,[1],[1],2,"22","9"],["2939","1968-03-14","Kritik an der zögerlichen juristischen Aufarbeitung polizeilicher Ausschreitungen am 2. Juni 1967. Polizisten werden vor untere Gerichtsebenen gebracht, während sich Langhans und Teufel vor Großer Strafkammer verantworten müssen.","Polizei-Prozess","Zum Tage","","H. Sch.",[1],4,[5],[2],2,"20","2"],["2940","1968-03-15","Vierspaltiger Gastbeitrag des VDS-Vorsitzenden, in dem er die politische Verortung seines Verbandes erläutert. Im Vorspann distanziert sich die WELT von dessen Meinung.","Der Standort der Studentenschaften","","","Christoph Ehmann",[11],4,[5],[3],1,"24","2"],["2941","1968-03-15","VDS verurteilt Niederschlagung Warschauer Studentenunruhen","VDS verurteilt Vorgehen der Warschauer Polizei","","","AP",[11],4,[1],[2],2,"24","4"],["2942","1968-03-15","Uni Karlsruhe verlässt VDS aus politischen Gründen","Karlsruhe bestätigt Austritt aus dem VDS","","","",[11],4,[1],[2],2,"24","4"],["2943","1968-03-15","Laut Gutachter rufen Flugblätter von Teufel und Langhans nicht zur Brandstiftung auf, sondern sind surrealistische Dokumente.","Gutachter entlasten die \"Kommunarden\"","","","Bi.",[5],4,[1],[2],2,"24","4"],["2944","1968-03-15","Solidarisierung mit den aus der SPD ausgeschlossenen Mitgliedern","Falken bekunden Solidarität","","","",[1],4,[1],[2],2,"24","13"],["2945","1968-03-15","SPD streitet über politische Bewertung der Vietnam-Demo und den zu ziehenden Konsequenzen.","\"Demonstration galt dem Vietkong-Sieg\"","","SPD-Landesvorstand beriet über Konsequenzen des 18. Februar","gvc.",[1],4,[1],[2],2,"24","13"],["2946","1968-03-15","Berliner Jungdemokraten wollen enger mit Republikanischem Club zusammenarbeiten.","Kleiner Berlin-Spiegel","","","",[11],4,[1],[2],2,"24","13"],["2947","1968-03-16","Reportage von der SPD-Sitzung, die mit dem Parteiausschluss (mit Recht auf Einspruch) von Ristock und Beck endete.","Symbolischer Türknall nach Mitternacht","Sozialdemokraten","Sechs Stunden dauerte das Ringen in Berlin um Ristock und Beck","Götz von Coburg",[1],4,[7],[1],1,"28","3"],["2948","1968-03-16","Stimmen zu den Parteiausschlüssen aus unterschiedlichen Landesverbänden der SPD","Hart dafür und hart dagegen","","Geteiltes Echo in der SPD zu Berliner Parteiausschlüssen","",[1],4,[1],[2],2,"28","3"],["2949","1968-03-16","Karikatur von einer Demo mit Ausschreitungen, begleitet von einem satirischen Gedicht, das u.a. den Schlagstockeinsatz kritisiert.","Bonifaz","","","Steinfink (?)",[1],4,[2,5,4],[1],1,"28","VI"],["2950","1968-03-18","Leser kritisiert Aussagen Ehmanns aus dessen Gastbeitrag in der WELT.","Ehmann","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","2"],["2951","1968-03-18","SHB-Delegiertenversammlung ohne Ergebnis abgebrochen. Kritik an der SPD wegen der Parteiausschlüsse.","SHB-Studenten erheben schwere Vorwürfe gegen Parteivorstand","Sozialdemokratischer Hochschulbund","Keine Einigung über zukünftigen Kurs des Verbandes","K.P.",[11],4,[1],[5],2,"20","6"],["2952","1968-03-18","Kommentierende Reportage von einem Verhandlungstag gegen Teufel und Langhans mit zahlreichen Zitaten. Berichterstatter macht sich unzweideutig lustig über Richter und Staatsanwalt und ergreift Partei für die Angeklagten.","\"Bei aller Anerkennung?wem soll das nützen?\"","Berlin","Aus einem Brief der Mutter an Fritz Teufel - Schwierigkeiten bei der Rechtsprechung","Hans-Erich Bilges",[5],4,[7,5],[3],2,"20","6"],["2953","1968-03-18","Leser verneint Zusammenhang von Dutschke und Pop-Kultur, sieht eher Bezug zum Absurden Theater","Dutschke und Pop-Kultur","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[2],2,"20","7"],["2954","1968-03-19","Bericht vom Bundesparteitag der SPD mit Rede von Willy Brandt. Mehrere Zitate aus dessen Rede, u.a.: \"Ich meine nicht, Ruhe sei die erste Bürgerpflicht. Aber es ist doch wohl so, dass von der Freiheit der Meinungsäußerung einige Leute Gebrauch machen, um Intoleranz und Terror zu etablieren. Pöbel bleibt Pöbel, auch wenn junge Gesichter darunter sind. Intoleranz und Terror, ob sie von links kommen oder von rechts, dürfen die Freiheit nicht benutzen, um sie zu zerstören.\"","Brandt fragt Gewerkschafter: Wissen Sie, was Sie tun?","","Kritik an Unterstützung der Protestaktionen","ST., W.T.",[1],4,[1],[1],1,"20","1"],["2955","1968-03-19","Leser lobt Springer, weil er Gastbeitrag des VDS-Chefs veröffentlicht hat, widerspricht letzterem jedoch.","Studenten","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","2"],["2956","1968-03-20","Drei Gastbeiträge zu Reformbemühungen an der Uni Marburg","Ist hier probieren besser als studieren?","Marburg gab ein Beispiel für praktische Hochschulreform: Der Rektor, ein Professor und ein Assistent nehmen Stellung","Das Eis ist gebrochen - Wir stehen erst am Anfang - Wenn man Studenten zur Mitarbeit bringt?","Otfried Madelung, Diethelm Conrad, Leonhard Froese",[4],4,[5],[4],1,"26","24"],["2957","1968-03-21","Rücknahme des Parteiausschlusses wegen Teilnahme an Vietnam-Demo","Ristock und Beck faktisch wieder SPD-Mitglieder","","Neue Schiedsordnung","St.",[1],4,[1],[2],2,"20","1,6"],["2958","1968-03-21","VDS beschwert sich über fehlende Einladung zum SPD-Parteitag","VDS vermisst Einladung nach Nürnberg","","","",[11],4,[1],[2],2,"20","6"],["2959","1968-03-21","Reaktion Ristocks auf Rücknahme des Parteiausschlusses","Ristock: Gräben können wieder zugeschüttet werden","","","Bi.",[1],4,[1],[2],2,"20","6"],["2960","1968-03-22","Plädoyer der Staatsanwaltschaft im Prozess um Flugblätter.","Harte Kritik an den Sachverständigen","Berlin","Staatsanwalt fordert Gefängnis für Teufel und Langhans","Bi.",[5],4,[1],[2],2,"24","3"],["2961","1968-03-23","Kommentator begrüßt Freispruch von Teufel und Langhans und wirft Justiz mangelndes Augenmaß vor.","Freigesprochen","Zum Tage","","Bi.",[5],4,[5],[2],2,"32","2"],["2962","1968-03-23","Bericht über Urteil im Flugblätter-Prozess","Teufel und Langhans freigesprochen","","","Bi.",[5],4,[1],[2],2,"32","4"],["2963","1968-03-27","Vier Jahre alte \"Rauschtat\" mit entsprechender Vorstrafe Ehmanns führt nicht zu dessen Suspendierung.","Delegiertenrat spricht Ehmann das Vertrauen aus","Studenten","\"Die begangene Straftat ist kein Anlass zur Suspendierung des VDS-Vorsitzenden\"","ems",[11],4,[1],[3],1,"24","6"],["2964","1968-03-28","Dissenz zu Fragen der Hochschulreform","Ernst Kontroverse zwischen Rektoren und Hochschulverband","Universitätsreform","Zusammenarbeit bedroht? - Kultusminister tagen","ems., pff.",[4],4,[1],[1],2,"22","6"],["2965","1968-03-28","Kartellverband Katholischer Deutscher Studentenvereine (KV) gegen politisches Mandat des VDS","Katholische Studenten gegen politisches Mandat","","","dpa",[11],4,[1],[2],2,"22","6"],["2966","1968-04-01","Frankfurter SDS-Mitglieder stürmen Treffen von Griechen, die im Palmengarten ihren Nationalfeiertag begehen.","SDS stürmt griechische Versammlung in Frankfurt","","","",[8],4,[1],[2],2,"20","1"],["2967","1968-04-01","Polemischer Bericht von Frankfurter SDS-Delegiertentagung mit zahlreichen Zitaten Beteiligter","Ratlose Suche nach einer \"breiten Front\"","SDS-Delegiertentagung","Anti-Autoritäre und Traditionalisten trugen in Frankfurt ihre Gegenstäze aus","Paul Lersch",[8],4,[1,5],[2],2,"20","6"],["2968","1968-04-01","Verständnis für Forderung nach Hochschulreform, Kritik an den politischen Äußerungen des VDS","Naive politische Vorstellungen","","","Leser",[11],4,[6],[2],2,"20","7"],["2969","1968-04-02","Kommentator äußert nach Delegiertentagung Zweifel an der politischen Bedeutung des SDS.","SDS-Ohnmacht","Zum Tage","","P. L.",[8],4,[5],[2],2,"20","2"],["2970","1968-04-02","SDS lehnt Beteiligung an Bundestagswahl auf Delegiertenversammlung ab, will APO bleiben.","Knappe Niederlage des KP-Flügels","SDS-Kongress","Delegierte lehnen Teilnahme an Wahlkampf ab","pff.",[8],4,[1],[5],1,"20","7"],["2971","1968-04-03","Leser kritisiert Ehmanns Gastbeitrag und dessen Anspruch, im Namen der Studenten Erklärungen abzugeben","Eigenmächtig","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"26","2"],["2972","1968-04-03","Drei Leserbriefe, die sich kritisch mit dem VDS-Anspruch eines politischen Mandats auseinandersetzen.","Politisches Mandat der Studentenschaften","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[1],2,"26","26"],["2973","1968-04-03","Kritisiert die bei Überlegungen zur Hochschulreform vorgebrachte Idee einer Einführung von Trimestern.","Trimester - kein richtiger Weg","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"26","26"],["2974","1968-04-05","Schwedischer Leser berichtet kurz von Dutschke-Auftritt in Schweden, zitiert ihn und meint, er hätte dort keine neuen Freunde gefunden.","\"Fegt alles hinweg\"","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[2],2,"22","2"],["2975","1968-04-05","Bayerischer SPD-Unterbezirk grenzt sich von SDS ab. Warten auf Entscheidung der Bundespartei zur \"Unvereinbarkeit\".","SPD will keine Radikalen","Bayern","Knoeringen: Mit dem SDS außerhalb der Partei diskutieren","wfm.",[8],4,[1],[5],2,"22","6"],["2976","1968-04-06","Bader, Proll, Soehnlein und Ensslin nach Brandstiftung in Frankfurter Kaufhäusern festgenommen. Baders SDS-Mitgliedschaft wird erwähnt.","Vier Verdächtige wegen Brandstiftung verhaftet","","Darunter Berliner SDS-Mitglied?","dpa-AP",[9],4,[1],[2],2,"34","1,4"],["2977","1968-04-06","Frage, ob die vier verhafteten Männer (!) die Frankfurter Brandstifter sein könnten.","Sind die vier Männer die Frankfurter Brandstifter?","","","pff.",[9],4,[1],[2],2,"34","16"],["2978","1968-04-06","Studenteninitiative organisiert ehrenamtlich Ferienaufenthalte für 5500 Kinder, viele davon aus Berlin","Studenten demonstrieren?","","?etwas ganz anderes: Wie man Kinder in die Ferien schickt","pff",[11],4,[1],[3],2,"34","16"],["2979","1968-04-09","Rheinland-Pfälzischer Kultusminister Bernhard Vogel präsentiert auf Kultusministerkonferenz Acht-Punkte-Liste mit Forderungen zur Hochschulreform. Diese werden kurz referiert.","Vogel legt ein Optimal-Programm vor","Hochschulreform","Große Wunschliste für die nächste Sitzung der Kultusminister","pff.",[4],4,[1],[1],2,"24","6"],["2980","1968-04-09","Widerspruch zu Vogels skeptischer Reformsicht aus NRW.","\"Radikale Vorschläge\" für die Universität","","Anregung aus Düsseldorf","frh ",[4],4,[1],[2],2,"24","6"],["2981","1968-04-09","Akademischer Senat prüft Widerruf der Zulassung des SDS an der FU.","Zulassung des SDS soll von der FU geprüft werden","","","",[8],4,[1],[2],2,"24","13"],["2982","1968-04-09","FU-AStA veranstaltet öffentliches Hearing zu Hochschulreformplänen und fordert z.B. Rektoren-Abwahl mit einfacher Mehrheit","Kollegiales Gremium statt Präsident","","FU-Studentenvertreter kamen zu Wort","sh",[4],4,[1],[2],2,"24","13"],["2983","1968-04-10","Leser stellt Bezug her zwischen Teufel/Langhans-Freispruch und Kaufhausbrand wenig später.","Warenhausbrände","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"28","2"],["2984","1968-04-10","Recherche, ob die wegen Brandstiftung Verhafteten Kontakte zum SDS oder der Kommune I hatten. Bei den Personalangaben werden z.T. komplette Adressangaben gemacht.","Niemand beim SDS will die Verhafteten kennen","Kaufhausbrand","Nur die Kommune I berichtet von \"gemeinsamen Aktionen\" mit drei der Verdächtigen.","Hans-Erich Bilges",[9,8,5],4,[1],[5],2,"28","3"],["2985","1968-04-10","Brandt ist bereit mit Dutschke zu diskutieren - nach Terminabsprache","Brandt: Zu Diskussion mit Rudi Dutschke bereit","","","St.",[2],4,[1],[2],2,"28","3"],["2986","1968-04-10","Der studentische Fachverband Medizin wirft dem VDS Machtmissbrauch vor","Kritik am VDS","","","",[11],4,[1],[2],2,"28","6"],["2987","1968-04-10","Leser erklärt politische Ausrichtung des VDS mit einem \"Geburtsfehler\" der Organisation","Politisches Mandat des VDS","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"28","8"],["2988","1968-04-10","Leser zieht Verbindungslinie von den Flugblättern der \"Teufel-und-Dutschke-Gruppe\" zu den Frankfurter Kaufhausbränden. Sieht bei Nichtbekämpfung die Demokratie in Gefahr.","Brandstifter","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"28","8"],["2989","1968-04-10","Bestätigung des Urteils wegen Hausfriedensbruchs von sechs Studenten im Astor-Kino.","Verurteilung bestätigt","","Sitzstreik im Filmtheater war Hausfriedensbruch","er",[1],4,[1],[2],2,"28","12"],["2990","1968-04-11","Kultusministerkonferenz beschließt Eckdaten der Hochschulreform. Auflistung von sieben Grundsätzen.","Kultusminister einig über die Reform der Hochschulen","","Weitreichende Beschlüsse - Sieben Grundsätze verkündet - Für Präsidialverfassung, Fachbereiche und Mitsprache der Studenten - \"Lehrstühle öffentlich ausschreiben - Lange Studienzeit verkürzen\"","ems",[4],4,[1],[1],2,"28","1"],["2991","1968-04-11","Kritik an den bisherigen unzureichenden Reformbemühungen. \"Es ist keine Zeit mehr zu verlieren. Außergewöhnliche, krisenhafte Situationen lassen sich nur mit außergewöhnlichen Anstrengungen meistern. Auf diese warten wir bisher vergeblich.\"","Es droht die Bildungskatastrophe","","Die große Strukturreform fehlt immer noch - Zu wenig Schulen und Universitäten - Nötig sind 22 Milliarden jährlich","Günter Krems",[4],4,[5],[1],2,"28","2"],["2992","1968-04-11","Kritik am Beschluss der Kultusminister zur Hochschulreform von der Katholischen Deutschen Studentenvereinigung als nicht weitreichend genug.","\"Klare Bildungspolitik fehlt\"","Katholische Studenten","Kritik am Vorschlag für ein Bundeskultusministerium","ems",[4],4,[1],[5],2,"28","3"],["2993","1968-04-11","Laut RA Mahler handelt es sich bei dem SDS-Mitglied Baader um eine andere Person als Andreas Baader.","Mahler: Baader nicht bei SDS","Kurz berichtet","","Bi.",[8],4,[1],[2],2,"28","3"],["2994","1968-04-11","Frankfurter AStA-Räume im Zusammenhang mit Spenden für Ohnesorg-Witwe durchsucht.","Räume des Frankfurter AStA durchsucht","","","Ne.",[7],4,[1],[2],2,"28","4"],["2995","1968-04-13","Überschrift und Vorspann für mehrere Artikel zum Thema auf dieser Seite","Schwere Ausschreitungen nach dem Attentat auf Dutschke","Der Kanzler bricht seinen Urlaub ab","Der Täter identifiziert - Zweimal vorbestraft","",[2,10],4,[1],[1],2,"34","1"],["2996","1968-04-13","Zusammenfassender Bericht über die Demonstrationen und Ausschreitungen nach dem Dutschke-Attentat. Schilderung der Ausschreitungen gegen Springer-Einrichtungen.","Auch am Karfreitag Schlägereien mit zahlreichen Verletzten","","Rote Fahnen auf den Straßen - Tausende Polizisten im Einsatz","Bi.",[2,10],4,[1],[5],1,"34","1"],["2997","1968-04-13","Informationen über die Entwicklung des Gesundheitszustandes von Dutschke.","Nach der Operation nicht mehr in akuter Gefahr","","Vater und Bruder am Krankenbett","",[2],4,[1],[5],2,"34","1"],["2998","1968-04-13","Schütz bricht Osterurlaub ab und fordert ein Ende der Gewalttätigkeiten","Schütz: Gewaltätigkeit einstellen","","Aufforderung nach neuen Krawallen - Senat gesprächsbereit","Co.",[2],4,[1],[2],2,"34","1"],["2999","1968-04-13","In einer ersten Vernehmung behauptet Bachmann, vom Attentat auf Martin Luther King zu seiner Tat angeregt worden zu sein.","\"Ich beschloss, Dutschke zu töten\"","","Erste Aussage des Attentäters","v. C.",[2],4,[1],[5],1,"34","1"],["3000","1968-04-13","Verurteilung des Anschlages auf Dutschke als Verbrechen. Zunahme der Spannungen der letzten Zeit als Werk linksextremer Provokateure. Zum Sturm auf das Springer-Haus: \"Zerbrochene Scheiben und brennende Autos sind kein Ausdruck verständlichen Protestes, sondern zeugen von Terror.\" Und weiter: \"Der Anschlag auf Rudi Dutschke wird mit der Härte des Gesetzes geahndet werden. Wer aber ein Verbrechen zum Anlass für neue Vergehen benutzt, verliert als politisch engagierter Bürger seine Glaubwürdigkeit.\"","Die Saat des Hasses","","Das Attentat auf Dutschke - Politischer Mord ein Verbrechen - Warnung vor weiterer Hetze","Bernt Conrad",[2,10],4,[5],[1],1,"34","2"],["3001","1968-04-13","Rekonstruktion des Tathergangs.","Drei Revolver-Schüsse auf dem Kurfürstendamm","Das Attentat","Der Täter wartete vor dem SDS-Büro auf Dutschke","Co.",[2],4,[1],[1],2,"34","3"],["3002","1968-04-13","Informationen über Bachmann, seine Familie und die häuslichen Verhältnisse","Mutter des Attentäters brach zusammen","","","",[2],4,[1],[2],2,"34","3"],["3003","1968-04-13","Chronik der Demonstrationen bzw. Ausschreitungen in Berlin, insbesondere vor dem Springer-Haus. Am Schluss: Verlags-Stellungnahme.","Die Nacht nach dem Attentat in Berlin","Ausschreitungen","Die Polizei hatte nach den Ausschreitungen \"große Alarmstufe\"","v. C.",[2,10],4,[1],[5],1,"34","3"],["3004","1968-04-13","Zusammenfassende Infos über die Demonstrationen in deutschen Städten, auch über die Anti-Springer-Maßnahmen z.B. in Hamburg, Frankfurt und München.","Proteste und Aktionen","Nach dem Attentat","Demonstrationswelle in den Städten breitet sich weiter aus","",[2,10],4,[1],[1],1,"34","4"],["3005","1968-04-13","Reaktionen von Politikern auf das Attentat. Zitate.","Bestürzung über den Mordanschlag","Reaktionen","Bedauern in Berlin und Bonn","",[2],4,[1],[5],2,"34","4"],["3006","1968-04-13","Scharfe Angriffe gegen die Bundesrepublik aus der DDR. Das Attentat wird als \"weitere böse Frucht der Pogromhetze?des Westberliner Senats und der Monopolpresse\" bezeichnet.","Ostberlin spricht von \"blutigem Terror\"","","","",[2],4,[1],[2],2,"34","4"],["3007","1968-04-13","Kritische Würdigung Dutschkes und seines ambivalenten Verhältnisses zur Gewalt. Parallelen zum Kampf gegen die Apartheit in den USA.","Ein Opfer jener Gewalt, die er selbst verschmäht","Rudi Dutschke","Die Schüsse auf dem Kurfürstendamm haben das Gesicht der Bundesrepublik verunstaltet.","Paul Lersch",[2],4,[5],[3],2,"34","4"],["3008","1968-04-13","Chronik von Demonstrationen, Ausschreitungen etc. von Mai 1967 bis April 1968. Erwähnung der Vorwürfe gegen das Haus Springer.","Stationen der Gewalttätigkeit","Chronologie","Von Ohnesorg bis Dutschke","",[2],4,[1],[2],2,"34","4"],["3009","1968-04-13","Bericht über die Maßnahmen der Ärzte von Dutschke und Bachmann.","Attentäter und Opfer im selben Krankenhaus","Westend","Ärzte operieren mehrere Stunden","Co.",[2],4,[1],[2],2,"34","4"],["3010","1968-04-13","Versammlungen beim SDS und in der TU, wo über Ursachen und Maßnahmen gesprochen wird. Chef des Republikanischen Clubs spricht davon, Springer aus der Stadt zu vertreiben.","Nur vereinzeltes Unbehagen über den nächtlichen Terror","","Turbulente Sitzungen im SDS-Zentrum und der TU","eb",[2,10],4,[1],[2],2,"34","9"],["3011","1968-04-13","Mitglieder der ESG werfen der Kaiser-Wilhelm-Gedächtnis-Kirchengemeinde vor, sich von den Angriffen auf Dutschke zu Weihnachten nicht berührt gezeigt zu haben. In der Zehlendorfer Gemeinde \"Zur Heimat\" verlassen einige Menschen einen Gottesdienst, nachdem der dortige Pfarrer sagt, Dutschke sei \"Opfer der Hetze der Springerpresse\".","Flugblattaktion vor der Gedächtniskirche","","Zwischenfall auch in Zehlendorf","",[2,3,10],4,[1],[2],2,"34","9"],["3012","1968-04-16","In mehreren Städten unterschiedliche, großteils gewalttätige Maßnahmen. Häufig gegen Springer-Standorte oder -Druckereien. Der SDS verbreitet eine Erklärung, in der es heißt: \"Wir erklären, dass es keine Ruhe geben wird, bis geeignete Maßnahmen zur Enteignung des Springer-Konzerns eingeleitet sind.\"","Neue Attacken radikaler Gruppen gegen Zeitungen und Druckereien","","Schwere Zusammenstöße auch während der Osterfeiertage","",[2,10],4,[1],[1],2,"24","1,3"],["3013","1968-04-16","Details zum Gesundheitszustand Dutschkes, kurze Angabe zu Bachmann.","Dutschkes Zustand weiter gebessert","","Attentäter außer Lebensgefahr","",[2],4,[1],[2],2,"24","1"],["3014","1968-04-16","Kundgebung u.a. von FDP, Jungdemokraten und SHB in Berlin. In zahlreichen Reden Angriffe gegen Verlag und Verleger Axel Springer. ","Dahrendorf fordert Lübkes Rücktritt","","","v.C.",[2,10],4,[1],[2],2,"24","1"],["3015","1968-04-16","Dutschke-Attentat wird von radikalen Kräften (im SDS) ausgenutzt. Springer steht für das \"spätkapitalistische System\". Jetzt muss sich zeigen, ob Ruhe und Ordnung bewahrt werden kann. Die Alternative wäre Anarchie.","Wem beugt sich der Staat?","","Gewalt soll Gewalt provozieren - Aktionen gegen die Pressefreiheit - Steht am Ende die Anarchie?","Werner Titzrath",[2,10],4,[5],[1],2,"24","2"],["3016","1968-04-16","Karikatur: Zwei NPD-Leute, im Hintergrund Flammen und radikale Demonstranten.","\"Unsere beste Werbekolonne ...\"","","","Wolfgang Hicks",[2],4,[5,4],[5],1,"24","2"],["3017","1968-04-16","Das Dutschke-Attentat als Aufhänger, die Anti-Springer-Kampagne als Vehikel für weiterreichende radiakle politische Ziele des SDS. Gefahr für die Pressefreiheit.","Der SDS probt den Notstand","","","Hans Schueler",[10,2],4,[5],[5],2,"24","2"],["3018","1968-04-16","Anhand von Zitaten aus SDS-Dokumenten qualifiziert der Autor den SDS als \"Moskau-unabhängige, marxistisch-leninistische Konkurrenzpartei zur illegalen KPD\".","Eine revolutionäre politische Partei","","Offizielle Dokumente und Ziele des \"Sozialistischen Deutschen Studentenbundes\"","H.Sch.",[8],4,[5],[3],2,"24","2"],["3019","1968-04-16","Kommentar zu den Beschlüssen der Kultusministerkonferenz","Anlauf zur Hochschulreform","Zum Tage","","Walter Görlitz",[4],4,[5],[2],2,"24","2"],["3020","1968-04-16","Bischof Scharf und Pastor Gollwitzer mahnen auf einer Studentenversammlung in der TU zur Gewaltlosigkeit.","Scharf: Aus Gewalt kann nichts Gutes kommen","Berlin","Studenten haben den Bischof um Vermittlung gebeten","Hans-Erich Bilges",[1],4,[1],[1],1,"24","3"],["3021","1968-04-16","Bilanz der zumeist gegen Springer gerichteten Demonstrationen im In-und Ausland","Am Karfreitag hundert Verletzte","","Neue Demonstrationen","",[1],4,[1],[2],2,"24","3"],["3022","1968-04-16","Ausschreitungen bei der Blockade der Frankfurter Sozietäts-Druckerei.","SDS blockiert auch die FAZ","Hessen","Kritik am zögernden Eingreifen der Polizei","pff",[10,2],4,[1],[5],2,"24","3"],["3023","1968-04-16","Demonstranten fordern \"Revanche für Rudi Dutschke\" und \"protestieren gegen Neofaschismus und gegen die Springer-Presse\"","Studenten demonstrieren für Dutschke in London","","","wth",[10,2],4,[1],[2],2,"24","3"],["3024","1968-04-16","Polizeigewerkschafter fordern chemische Betäubungsmittel, um Rädelsführer kampfunfähig zu machen, ohne sie zu verletzen.","Polizei: Neue Mittel gegen Massenkrawall nötig","","","UPI",[1],4,[1],[2],2,"24","3"],["3025","1968-04-16","Vertreter von Parteien, Kirchen und Gewerkschaften warnen vor weiterer Eskalation.","Kiesinger warnt Radikale vor weiterer Gewalttätigkeit","Ausschreitungen","Sonst sind gefährliche Gegenaktionen zu befürchten","",[1],4,[1],[1],1,"24","4"],["3026","1968-04-16","Auszüge aus verschiedenen Presseveröffentlichungen zum Thema","Schock und bange Sorge über Ausbruch von Terror","","","",[1],4,[1],[2],2,"24","4"],["3027","1968-04-16","Intendant Barsig trifft sich mit Gruppe um Hans Magnus Enzensberger. Letztere wollen SFB-Programm künftig kontrollieren, fordern eigenen Sender.","Intendant sprach mit \"Rundfunk-Komitee\"","","Ultimatum an den SFB","",[1],4,[1],[2],2,"24","4"],["3028","1968-04-16","Kundgebung u.a. von FDP, Jungdemokraten und SHB in Berlin. In zahlreichen Reden Angriffe gegen Verlag und Verleger Axel Springer. Das Verlagshaus habe \"die Bildung eines rational bestimmten Klimas verhindert\".","Albertz zur Vermittlung ins Rathaus","Berlin","Nach der Kundgebung auf dem Hammarskjöldplatz Diskussion in der Technischen Universität","v.C.",[2,10],4,[1],[3],2,"24","4"],["3029","1968-04-16","Leserbriefschreiber ist Ernst Schanowski, ehemaliger DGB-Vorsitzender. Er kritisiert die Ausschreitungen und mahnt die Politiker zum Handeln.","Sie rennen gegen die Ordnung an","Aus Briefen an die Redaktion","Stellungnahme zur Situation","Leser",[1],4,[6],[5],2,"24","13"],["3030","1968-04-16","Juristische Würdigung der Unruhen der vergangenen Tage.","Strafjustiz steht vor neuer Belastungsprobe","","Zahlreiche Verfahren nach Demonstrationen und Ausschreitungen erwartet","fa",[1],4,[5],[1],2,"24","14"],["3031","1968-04-17","Kabinettsberatung zu den vergangenen Unruhen und dem Attentat auf Dutschke. Sondersitzung des Bundestages z.Z. nicht vorgesehen. Äußerungen verschiedener Politiker.","Kanzler und Koalition einig: Jetzt ist rasches Handeln notwendig","Nach den Aktionen radikaler Gruppen","\"Weitere Ausschreitungen müssen verhindert werden\"","Schr., St.",[1],4,[1],[1],2,"24","1"],["3032","1968-04-17","Gesellschaft muss aufgerüttelt werden, jedoch ohne jede Anwendung von Gewalt.","\"Wir lehnen jede Gewalttätigkeit ab\"","","Weltkongress der katholischen Jugend in Berlin eröffnet","Co.",[1],4,[1],[2],2,"24","1"],["3033","1968-04-17","Schütz kündigt Stellungnahme an.","Erklärung des Senats für Donnerstag angekündigt","","","v.C.",[1],4,[1],[2],2,"24","1"],["3034","1968-04-17","Kommentator sieht die Autorität des Staates auf dem Prüfstand. Vorwürfe gegen Taktierer. Vergleich mit Weimar. Schicksalstage für die Parlamentarische Demokratie.","Die Standfestigkeit wird geprüft","","Vorrang hat die Autorität - Nicht nur von Reformen reden - Keine Zeit für Schwankende","Georg Schröder",[1],4,[5],[1],1,"24","2"],["3035","1968-04-17","Solidaritätsadresse eines Lesers","Verbundenheit","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","2"],["3036","1968-04-17","Vergleich zu NS-Ausschreitungen. \"?bald brennen wieder Synagogen!\"","Wie damals","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","2"],["3037","1968-04-17","Neben Springer wird der SFB von der APO kritisiert. Barsig sieht keine Diskussionsmöglichkeiten. APO will eigene Sendezeit.","Tief enttäuscht verließ Franz Barsig um Mitternacht das Auditorium Maximum","Berlin","Außerparlamentarische Opposition beharrt auf Sendezeit im SFB","Hans-Erich Bilges",[1],4,[1],[1],1,"24","3"],["3038","1968-04-17","Bundesanwaltschaft für Verfolgung politischer Straftaten zuständig. Prüfung, ob hier anwendbar. Kurzberichte aus einigen Brennpunkten des Geschehens. Vielfach Anti-Springer-Aktionen.","Bundesanwaltschaft prüft Kompetenz für Strafverfolgung","SDS-Aktionen","CDU in Stuttgart: Das Maß ist voll","",[1],4,[1],[5],2,"24","3"],["3039","1968-04-17","Baden-Württembergs Ministerpräsident vergleicht Ausschreitungen mit NS-Aktionen im Dritten Reich.","Filbinger: Rückfall in faschistische Methoden","","","hh",[1],4,[1],[2],2,"24","3"],["3040","1968-04-17","Ablehnung von Gewaltanwendung zur Durchsetzung politischer Ziele.","Berliner DGB-Vorstand verurteilt Terror","","","nw, UPI",[1],4,[1],[2],2,"24","3"],["3041","1968-04-17","AP-Fotograf Frings bei Münchener Anti-Springer-Demo durch Steinwurf verletzt. Hamburger Demonstranten werden von AS-Lieferfahrzeug verletzt. Verlag \"bedauert außerordentlich\".","AP-Fotograf gefährlich verletzt","","","",[10,2],4,[1],[2],2,"24","3"],["3042","1968-04-17","Bachmann hat laut Geständnis als Alleintäter aus Kommunistenhass gehandelt. Anregung durch King-Attentat.","Bachmann voll geständig","","","fa",[2],4,[1],[2],2,"24","3"],["3043","1968-04-17","Rektor und Dekane der FU mahnen zur Besonnenheit.","FU-Studenten zur Vernunft gemahnt","","","dpa",[1],4,[1],[2],2,"24","3"],["3044","1968-04-17","IG Druck weist Forderung nach Springer-Enteignung zurück.","IG Druck verurteilt Studentenaktionen","","","AP",[10],4,[1],[2],2,"24","4"],["3045","1968-04-17","Rektoren der Hochschulen in NRW äußern sich zu Dutschke-Attentat und rufen zu Mäßigung auf.","Rektoren rufen zur Ordnung auf","","","St.",[1],4,[1],[2],2,"24","4"],["3046","1968-04-17","Friedliche Demo in Bonn. Sprecher: Bachmann sei kein Einzeltäter, es gelte die Schreibtischtäter im Hintergrund zu suchen.","Die vielen Parolen widersprachen einander","Studenten","Demonstranten und Gegendemonstranten zogen gemeinsam durch die Bonner Innenstadt","St.",[1],4,[1],[3],2,"24","4"],["3047","1968-04-17","Erklärungen der Frankfurter Neuen Presse und der FAZ zu den Angriffen auf die Sozietätsdruckerei, in der u.a. auch die BILD hergestellt wird.","\"Arbeiter werden seit Tagen bedroht\"","","Stellungnahme aus Frankfurt","",[10],4,[1],[2],2,"24","4"],["3048","1968-04-17","Pressestimmen zu den Unruhen bzw. den Angriffen auf Springer.","\"Wir haben die Studenten des SDS für klüger gehalten\"","Zeitungen","Stellungnahmen zu den Unruhen in der Bundesrepublik","",[1],4,[1],[5],2,"24","4"],["3049","1968-04-17","Zu den (Anti-Springer-) Aktionen und deren Vorbereitung in Stuttgart, München, Düsseldorf, Berlin und Hamburg","Der Hörsaal als Befehlsstand für Radikale","Wenn die Studenten ihre Aktionen planen?","Umfrage unserer Korrespondenten bei deutschen Rektoren","Walter Pfuhl, Wilhelm F. Maschner, Alfred Freudenhammer, Götz v. Coburg, Paul Lersch",[1],4,[1],[1],1,"24","5"],["3050","1968-04-17","Demo vor dem Londonder \"Daily Mirror\"-Gebäude, wo sich auch Springer-Büros befinden. Etwa einstündige Blockade. Anti-Springer-Demo war angeblich zunächst gar nicht geplant.","\"Sieg Heil\" und Geldstücke gegen Polizisten","","Die Demonstration in London","Fritz Wirth",[1],4,[1],[3],1,"24","5"],["3051","1968-04-17","\"Irrtümlicher\" Polizeieinsatz an der TU am Ostersamstag. Rektor teilt mit, dass Unibetrieb wieder geregelt läuft.","Pförtner sollte Hilfe rufen","","TU-Rektor erläuterte Polizei-Einsatz in der Universität","eb",[11],4,[1],[2],2,"24","13"],["3052","1968-04-17","Gespräche von Bürgern mit Studenten, die vor dem SFB demonstrieren. Vorgeführt wird angebliche weitgehende Ahnungslosigkeit und Naivität bei den Demonstranten.","Immer wieder die Frage: \"Was wollt Ihr eigentlich?\"","","Stundenlang diskutierten Berliner mit den Demonstranten","jj",[1],4,[1,2],[3],2,"24","13"],["3053","1968-04-18","Politikgremien betonen Entschlossenheit. Justizminister spricht über strafrechtliche Folgen.","Gewaltakte sollen im Keim erstickt werden","Nach den Ausschreitungen und Straßenschlachten während der Osterfeiertage","Bund und Länder ziehen Konsequenzen","Schr., ems.",[1],4,[1],[1],2,"20","1,4"],["3054","1968-04-18","SDS hat erreicht, dass die Politiker ihn ernst nehmen.","Bonn","","","Schr.",[1],4,[5],[2],2,"20","1"],["3055","1968-04-18","Politikeräußerungen und Schweigemarsch nach Tod des Fotografen Klaus Frings.","Bestürzung über das erste Opfer der Unruhen","Nach den Ausschreitungen und Straßenschlachten während der Osterfeiertage","Pressefotograf gestorben","",[10,2],4,[1],[5],1,"20","1,3"],["3056","1968-04-18","Politiker zur Hochschulreform","\"Jetzt Reform der Hochschule beschleunigen\"","Nach den Ausschreitungen und Straßenschlachten während der Osterfeiertage","Gespräche so bald wie möglich","St.",[4],4,[1],[2],2,"20","1"],["3057","1968-04-18","Zur Haftungsfrage","Bezahlen Versicherer die Aufruhr-Schäden?","","","G.S.",[1],4,[1],[2],2,"20","1"],["3058","1968-04-18","Brandt mahnt bessere Verhinderung von Unruhen an. Man solle nicht zusehen, wenn der SDS tagelang unbehelligt zu Gewalttaten aufruft.","\"Das Gesetz muss geachtet werden\"","","Schreiben von Brandt an den Berliner Regierenden Bürgermeister","dpa",[1],4,[1],[3],2,"20","1"],["3059","1968-04-18","Polizei führt Ermittlungen in 300 Fällen, die mit den jüngsten Ausschreitungen zu tun haben.","Nach den Krawallen: 300 Strafverfahren","","","dpa",[1],4,[1],[2],2,"20","1"],["3060","1968-04-18","Kommentator befürchtet, dass die West-Berliner Krawalle die Propaganda der SED stützen. Notwendig sei, dem Recht wieder zur Geltung zu verhelfen.","Freiheit und Ordnung","","Wie wirken die Krawalle drüben? - Wasser auf die Mühlen der SED - Was ein Rechtsstaat braucht","Günter Zehm",[1],4,[5],[1],2,"20","2"],["3061","1968-04-18","Dutschke-Attentat keine Rechtfertigung für SDS-Gewalt.","Mit Schrecken","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[2],2,"20","2"],["3062","1968-04-18","Leser fordert Taten zur Eindämmung der Gewaltausbrüche.","Worte genügen nicht","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["3063","1968-04-18","Leser spricht aggressiven Demonstranten Reife ab","Unreife","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["3064","1968-04-18","Leser ergreift Partei für rebellierende Gruppierungen","Gegen wen sonst?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["3065","1968-04-18","Schilderung der Vorgänge, die zum Tod von Frings geführt haben","Der tragische Tod des Fotografen Klaus Frings","Ausschreitungen","Der Stein traf ihn wie ein Geschoss","Wilhelm F. Maschner",[10,2],4,[1],[1],1,"20","3"],["3066","1968-04-18","Kommentar zum Tod des Fotografen, der vor weiterer Gewalteskalation warnt. Über die Gewaltbereiten: \"Hass könnten sie ernten; doch davor sollten sie sich selbst und uns bewahren.\"","Terror","","","B.N.",[10,2],4,[5],[2],2,"20","3"],["3067","1968-04-18","Betroffenheitserklärung zum Tod von Frings. \"Wir glauben: Aus einem mit Blut getränkten Boden kann keine gute Ordnung erwachsen, sondern nur Tyrannei von Menschen gegen Menschen.\"","\"Ein Unschuldiger kam ums Leben\"","","Erklärung der AP","AP",[10,2],4,[5],[2],2,"20","3"],["3068","1968-04-18","Hans-Jürgen Krahl spricht sich gegen Gewaltlosigkeit aus. Unterschiedliche Formen von Anti-Springer-Maßnahmen im Gespräch: von Verkaufsbehinderungen bis zur \"rationalen Auseinandersetzung\".","SDS-Vorstand bekennt sich zu \"revolutionärer Gewalt\"","Radikale Studenten","Die Gruppen in Hannover und München wollen keine neuen Aktionen auf der Straße","pff",[8],4,[1],[3],2,"20","3"],["3069","1968-04-18","Verbesserter Gesundheitszustand Dutschkes. Wortlauf eines Grußtelegramms von Max Reimann, dem Vorsitzenden der verbotenen KPD.","Dutschke nimmt wieder Kontakt zur Umwelt auf","","","AP",[2],4,[1],[2],2,"20","3"],["3070","1968-04-18","AStA-Erklärung lehnt Gewalt gegen Personen ab, befürwortet aber Gewalt gegen Sachen. Diskussion in der Kirchlichen Hochschule mit Gollwitzer.","\"Gewalt gegen Sachen\" befürwortet","","Stellungnahme der Studentenausschüsse von FU und TU","",[1],4,[1],[2],2,"20","3"],["3071","1968-04-18","KurzPortraits von Bernd Rabehl, Herbert Ledererr, Hans-Jürgen Krahl, Frank Wolff und Karl-Dietrich Wolff. ","Die jungen Männer an der Spitze des SDS","Nach dem Vorbild von Lenin und Rosa Luxemburg","Wer sind sie, woher kommen sie, was wollen sie?","bi., frh., Ne",[8],4,[1,5],[1],1,"20","5"],["3072","1968-04-18","Schutz gegen Steinwürfe gefordert.","Polizeigewerkschaft fordert Schutzhelme","","","ems., pff.",[1],4,[1],[2],2,"20","5"],["3073","1968-04-18","Polizei sucht nach \"humanen Waffen\", um sich radikaler Demonstranten erwehren zu können.","Schaum und Spray statt der Gummiknüppel?","","Polizeiwaffen, die Blutvergießen vermeiden, werden in Amerika schon erprobt","Eckart Dietzemann",[1],4,[1],[3],1,"20","5"],["3074","1968-04-18","Ausschreitungen beginnen den Berlin-Tourismus zu beeinträchtigen.","Zwischenfälle wirkten sich ebenfalls auf die Touristik aus","","Schwedische Gruppe sagte ab - Auch aus Dänemark liefen besorgte Anfragen ein.","eb",[1],4,[1],[1],2,"20","11"],["3075","1968-04-18","Gewerkschaften fordern Unterstützung der Politik gegen Gewaltanwender","Aufrufe gegen jeden Terror","","Stellungnahmen von Beamtenbund und Polizeigewerkschaft","",[1],4,[1],[2],2,"20","11"],["3076","1968-04-19","Der wie Klaus Frings bei den Unruhen vor dem Münchener Buchgewerbehaus während Anti-Springer-Unruhen verletzte, unbeteiligte Student Rüdiger Schreck ist gestorben.","Zweites Opfer der Unruhen in München","","Student starb nach Gehirnblutung","wfm.",[10,2],4,[1],[5],1,"24","1,6"],["3077","1968-04-19","Vertreter des Senats und aller Parteien sprechen sich gegen Gewalttätigkeiten aus.","Schütz: Berlin braucht Ordnung und Sicherheit","Lebhafte Debatte im Abgeordnetenhaus","","v.C.",[1],4,[1],[5],2,"24","1"],["3078","1968-04-19","Wegen mangelnder Ablehnung von Gewalt bei SDS-Vertretern treten Schütz und Neubauer von Gesprächsangebot zurück.","Schütz sagt Gespräch mit SDS ab","","","v.C.",[8],4,[1],[2],2,"32","1"],["3079","1968-04-19","Zwei Münchener Studenten wegen mehrerer Delikte bei Demonstrationen verurteilt.","Gefängnisstrafen für zwei SDS-Mitglieder","","","dpa",[8],4,[1],[2],2,"32","1"],["3080","1968-04-19","Leser betont Unterschied zwischen Studenten, die die Hochschule reformieren wollen und dem SDS.","Revolutionszentrale","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","2"],["3081","1968-04-19","Leser fragt nach Verantwortung der Eltern aufmüpfiger Studenten.","Und die Eltern?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","2"],["3082","1968-04-19","Leser fordert Studenten auf, sich gegen SDS zu wehren.","Kein Märchenprinz","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","2"],["3083","1968-04-19","Kommentator lobt differenzierte Abgeordnetenhausdebatte, kritisiert aber die FDP, die für \"gesetzliche Maßnahmen zur Einschränkung der 'Vormachtstellung' des Springer-Verlages\" plädiert hatte.","Berlin","Zum Tage","","Co.",[1],4,[5],[2],2,"32","2"],["3084","1968-04-19","Die Eskalation der Gewalt mit zwei Verletzten und zwei Toten in Berlin und München zwingt zu härterem Vorgehen gegen Extremisten.","Zwei Tote","Zum Tage","","B.N.",[10,2],4,[5],[2],2,"32","2"],["3085","1968-04-19","US-Kolumnist Max Lerner warnt vor dem totalitären Geist der \"Dutschke-Gruppe\". Er sieht durch die Anti-Springer-Aktionen die Pressefreiheit gefährdet, und zieht NS-Vergleich.","\"Das ist der Weg zu den Nazis\"","Ausschreitungen","Amerikanischer Publizist sieht Pressefreiheit bedroht","SAD",[10,2],4,[1],[2],2,"32","3"],["3086","1968-04-19","Weitere Forderungen der Polizeigewerkschaft zum Schutze ihrer Klientel.","Polizeibeamte sollen Schutzhelme erhalten","","","ems., pff.",[1],4,[1],[2],2,"32","3"],["3087","1968-04-19","Axel Springer äußert sich bei einer Veranstaltung dazu, dass sein Berlin-Engagement nicht gefährdet ist.","\"Wir verlassen Berlin nicht\"","","Springer: Aktivitäten unseres Hauses werden noch zunehmen","",[10],4,[1],[2],2,"32","3"],["3088","1968-04-19","Studentenpfarrer sieht aus ideologischen Gründen keine Möglichkeit zur Beteiligung der Evangelischen Studentengemeinde (ESG) an der APO.","Studentenpfarrer: Keine Beteiligungsmöglichkeit","","","Bi.",[3],4,[1],[2],2,"32","3"],["3089","1968-04-19","Antrag des SHB, bei der DGB-Mai-Kundgebung sprechen zu dürfen, ist abgelehnt worden.","\"1. Mai: Keine Studentensprecher\"","","","AP",[11],4,[1],[2],2,"32","3"],["3090","1968-04-19","Bachmann ist in Untersuchungsgefängnis verlegt worden.","Kurz berichtet","","","",[2],4,[1],[2],2,"32","3"],["3091","1968-04-19","Noch keine Erfolge bei Klärung des Frings-Todes.","Fahndung nach Steinwerfer bisher erfolglos","","","AP",[10,2],4,[1],[2],2,"32","6"],["3092","1968-04-19","CDU-MdB v. Wrangel kritisiert SDS-Äußerungen zum Frings-Tod und der Nichtabsage an die Gewalt als zynisch.","\"Gipfel des kalten Zynismus und Fanatismus\"","","","St.",[10,2],4,[1],[2],2,"32","6"],["3093","1968-04-19","Innenminister lehnt auch bei Wiederholungsgefahr von Rädelsführern Vorbeugehaft ab.","Benda lehnt Einführung von Vorbeugehaft ab","","","ems., pff.",[1],4,[1],[2],2,"32","6"],["3094","1968-04-19","Frankfurts OB Brundert lässt sich vom SDS zu einem Gespräch zwingen. Ergebnisse wenig konkret.","Frankfurts Oberbürgermeister will über Details noch nicht reden","Nach den Demonstrationen","","Rudolf Groszkopff",[1],4,[1],[5],2,"32","9"],["3095","1968-04-19","Diskussion im TU-Audimax über die Frage der Gewaltanwendung. Während zahlreiche Studenten hier eine eher verhaltene Position einzunehmen scheinen, stellt Horst Mahler diesen Standpunkt anscheinend in Frage. Mit Unfällen wie bei Frings müsse gerechnet werden.","Wie wenn ich mich in ein Auto setze","","Horst Mahler zum Tod des Fotoreporters Klaus Frings","Bi.",[10,6,2],4,[1],[2],2,"32","9"],["3096","1968-04-19","Sehr ausführliche Darstellung der Diskussionen im Abgeordnetenhaus. Ein Springersches Pressemonopol wird vom Sprecher der CDU als Popanz bezeichnet.","Nur im Prinzip war man sich einig","","Leidenschaftliche Parlamentsdebatte über die Ausschreitungen","vc, hae",[1],4,[1],[1],1,"32","13"],["3097","1968-04-19","Leser kritisiert das \"lendenlahme\" Vorgehen von Politikern gegen Gewalt bei Demos.","Bei Gewaltakten darf der Staat nicht zögern","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[1],2,"32","32"],["3098","1968-04-19","Scharf formulierter Angriff gegen die \"Linksfaschisten\" um Dutschke und den SDS.","Vergiftung der politischen Atmosphäre","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","32"],["3099","1968-04-19","Leserin fordert, dass Proteste die Würde des Menschen achten müssen.","Entarteter Protest","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","32"],["3100","1968-04-20","Innenminister sieht rechtliche Voraussetzungen für SDS als gegeben an. Vorbeugehaft lehnt er ab. Er benennt Unzulänglichkeiten bei den Sicherheitsbehörden. Spricht über Grundrecht der Demonstrationsfreiheit und Gewaltausübung.","Benda: Der SDS ist verfassungsfeindlich","Die Folgen der schweren Ausschreitungen bleiben das beherrschende Thema","WELT-Interview mit dem Innenminister","Günter Krems",[8],4,[1,3],[1],1,"28","1,6"],["3101","1968-04-20","Bundestagsfraktionen einigen sich auf Debattentermin","Bundestag will über Unruhen debattieren","Die Folgen der schweren Ausschreitungen bleiben das beherrschende Thema","Sondersitzung am 30. April","ems., pff.",[1],4,[1],[2],2,"28","1"],["3102","1968-04-20","Nur langsame Fortschritte in Sachen der Todesfälle Frings und Schreck in München.","Mordkommission kennt mehrere Steinwerfer","Die Folgen der schweren Ausschreitungen bleiben das beherrschende Thema","\"Ermittlungen sehr schwierig\"","",[10,2],4,[1],[2],2,"28","1"],["3103","1968-04-20","SDS ist zur kommunistischen Partei geworden, von der der Staat genesen muss.","Baldige Genesung","Aus Briefen an die Redaktion","","Le",[8],4,[6],[2],2,"28","2"],["3104","1968-04-20","Kritisiert einen Kommentar von Gerd Kistenmacher in der Süddeutschen Zeitung, der nach den Anti-Springer-Ausschreitung nicht die Angreifer, sondern den Angegriffenen kritisiert hat. Zudem verteidigt Walden einen eigenen Kommentar, den er Ende 1967 gegen den \"immatrikulierten, mobilisierten Mob\" geschrieben hat, als nun erwiesenermaßen berechtigt.","Perfidie","","","Matthias Walden",[10,2],4,[5],[2],2,"28","2"],["3105","1968-04-20","Richterbund verweist auch im Zusammenhang mit juristischer Behandlung der jüngsten Ausschreitungen auf seine Unabhängigkeit von der Politik.","Richterbund über Politiker befremdet","","","",[1],4,[1],[2],2,"28","3"],["3106","1968-04-20","Umfrage zeigt große Friedfertigkeit der Studenten. Und nur weniger als ein Prozent seien Mitglieder des SDS.","Gewalt von 80 Prozent der Studenten abgelehnt","","","St.",[9],4,[1],[2],2,"28","3"],["3107","1968-04-20","Wolfgang Landsberg will wegen Dissens mit SDS Amt niederlegen.","AStA-Vorsitzender der FU will zurücktreten","","","Bi.",[11],4,[1],[2],2,"28","6"],["3108","1968-04-20","Anzeige der Frankfurter Druckerei wegen der Schäden durch die Osterunruhen in Frankfurt. Druckvertrag mit Springer wird nicht in Frage gestellt.","Societäts-Druckerei erstattet Anzeige","","","E.K.",[10],4,[1],[2],2,"28","6"],["3109","1968-04-20","In einem Gespräch mit einer britischen Zeitung vermutet Axel Springer kommunistische Inspiration hintern den Angriffen auf ihn und seinen Verlag. Es gebe eine tiefe Animosität gegen das Establishment. Auf die Frage, ob er eine Parallele zu der Zeit vor Hitler sehe: \"Ja. Die Ähnlichkeit liegt in der unkontrollierten und gedankenlosen Weise, in der die Menschen einer Führung folgen.\" Springer verneint, ein Pressemonopol zu besitzen.","\"Der Fehler liegt bei uns allen, nicht beim Staat\"","Studenten","Interview der \"Daily Mail\" mit Axel Springer - Vertrauen zur jungen Generation","",[10],4,[1,3],[3],2,"28","6"],["3110","1968-04-20","Terence Prittie bezweifelt Springer-Kenntnis der englischen Anti-Springer-Demonstranten. Lobt die WELT.","Britischer Journalist: Ich frage mich?","","","SAD",[10],4,[1],[2],2,"28","6"],["3111","1968-04-20","Ralf Dahrendorf und - modifiziert - auch Helmut Schmidt empfehlen, den Axel Springer Verlag als Stiftung zu organisieren.","Dahrendorf empfiehlt eine Stiftung","","","",[10],4,[1],[2],2,"28","6"],["3112","1968-04-20","Der VDZ-Vorsitzende Kluthe kritisiert die Angriffe auf Axel Springer.","Kluthe erklärt sich solidarisch","","","",[10],4,[1],[2],2,"28","6"],["3113","1968-04-20","Angesichts der APO, die er als vielfach \"antiparlamentarisch, ja antidemokratisch\" kennzeichnet, raisonniert der Autor über die Notwendigkeit eines Parlaments.","Brauchen wir ein Parlament?","","","Michael Freund",[1],4,[5],[1],1,"28","I"],["3114","1968-04-22","CDU-MdB Haase kritisiert Forderung der Hessen-Süd-SPD, Springer zu entmachten.","Groteske Forderung","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"22","2"],["3115","1968-04-22","Leser wird Angst und Bange, wenn aus heute randalierenden Jura-Studenten einst Richter werden.","Später Richter","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["3116","1968-04-22","Fordert die Aufklärung der Hintergründe der Unruhen.","Sicherheit","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["3117","1968-04-22","Karikatur auf der Peter Brandt am Stuhl seines Vaters sägt. Übernahme aus dem Kölner Stadt-Anzeiger","Vater und Sohn","","","Pielert",[9],4,[5,4],[2],1,"22","2"],["3118","1968-04-22","Kommentator kritisiert Anbiederung von Leuten wie Albertz und Dahrendorf bei Gesprächen mit APO-Vertretern. Es dürfe keine Kompromisse mit Intoleranten geben.","Keine Kompromisse mit der Intoleranz","","Respekt von Andersdenkenden erfordert Gegenseitigkeit","Matthias Walden",[1],4,[5],[5],2,"22","2"],["3119","1968-04-22","Kritik am Taktieren der FDP im Zusammenhang mit der geplanten Sondersitzung des Bundestages zu den Studentenunruhen.","Sondersitzung","Zum Tage","","Schr.",[1],4,[5],[2],2,"22","2"],["3120","1968-04-22","Bei für den 11. Mai geplanter Demo in Bonn darf Bannmeile nicht verletzt werden. Justizminister plädiert für Annäherung an jene, die sich von den Radikalen lösen. Der SDS kritisiert Minister Bandas Äußerung zur Verfassungsfeindlichkeit der Organisation.","Heinemann:Von den Radikalen lösen","Unruhen","Justizminister warnt vor der Verletzung der Bannmeile in Bonn","",[1],4,[1],[2],2,"22","6"],["3121","1968-04-22","Kritik an einer \"Report\"-Sendung von Peter v. Zahn über Dutschke und die Studentenunruhen. Insbesondere werden Mitscherlichs Anti-Springer-Äußerungen kritisiert.","Report über Studenten","Fernsehen","","cuch",[1],4,[5],[2],2,"22","13"],["3122","1968-04-23","TU-Rektor Weichselberger sieht für sich keine weiteren Möglichkeiten, außerparlamentarischen Gruppen, Uniräume zu verweigern.","\"Meine Möglichkeiten sind erschöpft\"","","WELT-Gespräch mit TU-Rektor","Bi.",[11],4,[1],[2],2,"28","1"],["3123","1968-04-23","Attentat auf Dutschke wird von Vietkong-Freunden beklagt, Vietkong-Opfer nicht.","Hierzu kein Wort","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","2"],["3124","1968-04-23","Angriffe auf Springer vertragen sich nicht mit Forderung nach Informationsfreiheit","Informationsfreiheit","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"28","2"],["3125","1968-04-23","Wer bezahlt eigentlich die revoltierenden Studenten?","\"In Fleiß bemüht\"","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","2"],["3126","1968-04-23","TU-Rektor Weichselberger sieht für sich keine weiteren Möglichkeiten, außerparlamentarischen Gruppen, Uniräume zu verweigern. Er fordert Senator Stein auf, tätig zu werden, und den AStA entsprechend anzuweisen.","Weichselberger fordert Eingreifen des Senats","Berlin","TU-Rektor nimmt Stellung im Streit um Benutzung der Universitätsräume","Bi.",[11],4,[1],[3],2,"28","4"],["3127","1968-04-23","Zurückgetretener FU-Asta-Vorsitzender begründet seinen Schritt und geht mit der Linken ins Gericht.","\"Von sinnvollen Aktionen zu ziellosem Aktivismus\"","","","dpa",[11],4,[1],[2],2,"28","4"],["3128","1968-04-23","In Bonn gründet sich eine Deutsche Studentenunion, die gegen den SDS vorgehen will.","Neue Hochschulgruppe attackiert den SDS","","","ems. ",[8],4,[1],[2],2,"28","6"],["3129","1968-04-23","Diskussionen an zahlreichen Hochschulstandorten zur Gewaltfrage bei Demos.","Studenten suchen nach neuen Formen des politischen Protestes","Demonstration","Gewalt gegen Personen soll in Zukunft verhindert werden","K. P.",[1],4,[1],[5],2,"28","6"],["3130","1968-04-23","Empfehlung, in Partein mitzuarbeiten, um Hochschulreform voranzubringen.","RCDS fordert zum Eintritt in die Parteien auf","","","ems.",[11],4,[1],[2],2,"28","6"],["3131","1968-04-24","Wissenschaftssenator Stein soll sich mit der Nutzung von TU-Räumen durch die APO beschäftigen.","Kritische Lage an der TU Berlin","","Senat will eingreifen","Bi., v.C.",[11],4,[1],[2],2,"24","1"],["3132","1968-04-24","APO-Mitglied Meschkat verbreitet sich im Fernsehen über die Frage der Gewaltanwendung. Die vom \"Presserat\" des Berliner Aktionskomitees vom SFB geforderte Sendezeit für die APO ist nicht nötig, weil es solche Sendungen bereits gibt. Dagegen gebe es kein Meinungsmonopol Springers.","Verführung zur Gewalt","","Klaus Meschkat in \"Panorama\" - Teils ernüchtert, teils wild entschlossen - Wer hat ein Meinungsmonopol?","Günter Zehm",[10],4,[5],[1],2,"24","2"],["3133","1968-04-24","Springer macht keine Meinung, er macht die der Leser nur publik. Kritik an den Dutschkisten.","Gegen die Methode","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","2"],["3134","1968-04-24","Kritik am Nichtverbot des SDS.","Unzweckmäßig?","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"24","2"],["3135","1968-04-24","Lob für Springer-Presse angesichts der Springer-Kritik","Voll einverstanden","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","2"],["3136","1968-04-24","Lagebericht aus den von der APO genutzten TU-Räumen, die man nicht verlassen will.","Aktionskomitees folgen dem Rektor nicht","Technische Universität","Räume als Zentrum der \"Außerparlamentarischen Opposition\"","Bi.",[11],4,[7],[1],1,"24","6"],["3137","1968-04-24","Publizisten wollen wegen schleppender Berufung eines Nachfolgers für Professor Eberhard streiken.","Studenten der Publizistik billigen Streik","Berlin","\"Berufung bewusst verschleppt\"","Bi.",[11],4,[1],[2],2,"24","6"],["3138","1968-04-24","Regierender Bürgermeister bereit zur Diskussion mit Vertretern aller Berliner AStA","Schütz will öffentlich mit Studenten diskutieren","","","AP",[1],4,[1],[2],2,"24","6"],["3139","1968-04-24","Anzeige eines Anwalts gegen Mahler wegen Gewaltbefürwortung","Strafanzeige gegen Rechtsanwalt Mahler","","","UPI",[6],4,[1],[2],2,"24","6"],["3140","1968-04-24","Französische Linkspartei PSU erklärt sich mit SDS solidarisch","Mit dem SDS solidarisch","","","SAD",[8],4,[1],[2],2,"24","6"],["3141","1968-04-24","Bei Erläuterungen seiner Rücktrittsgründe geht der ehemalige Asta-Vorsitzende der FU mit den Linken hart ins Gericht.","\"Diskussionen sind dringender denn je\"","","Wolfgang Landsberg erläutert vor FU-Konvent seinen Rücktritt","",[11],4,[1],[2],2,"24","13"],["3142","1968-04-25","Verfahrensbilanz nach Demos in Bayern. Bayerischer Innenminister äußert sich zu SDS-Verbot.","Bilanz in Bayern: Bisher 300 Verfahren","","","wfm., St.",[1],4,[1],[2],2,"28","1"],["3143","1968-04-25","Klaus W. Läpple, Vorsitzender der Deutschen Studentenunion, spricht SDS Glaubwürdigkeit ab.","\"Der SDS hat seine Glaubwürdigkeit verloren\"","","","ems.",[8],4,[1],[2],2,"28","1"],["3144","1968-04-25","Dutschkes Weltbeglückungspläne sind Utopien, die für das geteilte Deutschland nicht taugen. Und zu Springer: Wer zwingt jemanden, ein Springer-Blatt zu lesen?","Beglückungspläne","Aus Briefen an die Redaktion","","Leser",[10,2],4,[6],[2],2,"28","2"],["3145","1968-04-25","Kritik am Meschkat-Auftritt in \"Panorama\"","Vorbild Kuba","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","2"],["3146","1968-04-25","Harte Kritik Waldens an journalistischer Fälschung bzw. Verfälschung Theo Sommers in der Zeit, als er am 19.4.1968 in der Zeit sinnentstellend verkürzt die Bild vom 7. Februar 1968 zitiert, und ihr so \"Pogromhetze\" unterstellt. Sommer zitiert: \"Man darf auch nicht die ganze Dreckarbeit der Polizei und ihren Wasserwerfern überlassen.\" Das komplette Zitat hätte folgendermaßen lauten müssen: \"Man darf über das, was zurzeit geschieht, nicht einfach zur Tagesordnung übergehen. Und man darf auch nicht die ganze Dreckarbeit der Polizei und ihren Wasserwerfern überlassen. Schlafen unsere Richter, schlafen unsere Politiker? Wie lange wollen sie noch zulassen, dass unsere jungen Leute von roten Agitatoren aufgehetzt, dass unsere Gesetze in Frage gestellt, unterwandert und missdeutet werden?\"","Der Meinungsstreit muss fair sein","","","Matthias Walden",[10],4,[5],[3],2,"28","2"],["3147","1968-04-25","Läpple grenzt seinen neuen Verband vom SDS ab und beschreibt dessen Ziele. Gewaltverzicht wesentlich.","\"Demonstrationen ja - Gewalt nein\"","Studenten","Die Ziele der Deutschen Studentenunion - Interview mit der WELT","Günter Krems",[11],4,[3],[1],1,"28","6"],["3148","1968-04-25","Dutschke auf dem Weg der Besserung","Dutschke beginnt mit Krankengymnastik","","","UPI",[2],4,[1],[2],2,"28","6"],["3149","1968-04-25","Mehr als 20.000 Ingenieurstudenten NRWs treten in einen Streik, um ihren Forderungen nach Reformen Nachdruck zu verschaffen.","Studenten der Ingenieurschulen wollen streiken","","Protest gegen die Politiker","frh",[4],4,[1],[2],2,"28","6"],["3151","1968-01-03","Evangelische Kirchenleitung verurteilt Gottesdienststörungen durch Studenten, spricht sich zugleich auch gegen vorschnelle Verurteilung der Studenten durch Gemeindemitglieder aus. Pfarrer Pohl der KWG spricht sich gegen eine Entschuldigung wegen der Übergriffe seitens einiger Gemeindemitglieder aus. Schilderung der Störungen in der Gedächtniskirche in der Silvesternacht.","Kirche rügt Radikale","","\"Demonstrationen gehören nicht in den Gottesdienst","",[3],1,[1],[2],2,"14","2,5"],["3152","1968-01-03","Verurteilung der Demonstrationen/Störung im Gottesdienst der Gedächtniskirche seitens Studenten, teils auch Kritik an den Übergriffen auf Dutschke, insgesamt überwiegt jedoch deutlich die Kritik an den Studenten.","Kritik nach beiden Seiten","Leserbriefe","","Leser",[3],1,[6],[2],2,"14","2"],["3153","1968-01-04","Kurze Ankündigung des Vietnamkongresses des SDS am 17. und 18.2.1968 sowie die Meldung, dass der SDS 10.000 Teilnehmer erwartet.","Vietnamkongreß in Berlin","Kurz gemeldet","","",[1],1,[1],[2],2,"14","2"],["3154","1968-01-04","Kritik an den Störungen des Gottesdienstes in der Gedächtniskirche sowie an der Kirchenleitung, weil sie nicht hart genug dagegen vorgehen würde. Zudem Kritik an den Studenten der FU, weil diese sich nicht ausreichend vom SDS und seinen Aktionen distanzieren bzw. diesen Einhalt gebieten. Forderung nach einer \"Anti-Dutschke-Kampagne\".","Warum gibt es keine Gegenaktion?","Leserbriefe","","Leser",[3],1,[6],[2],2,"14","2"],["3155","1968-01-04","Berliner Studentenschaft droht mit Klage gegen jeden, der behauptet, dass die Geldsammlungen für die Witwe Ohnesorg nicht ordnungsgemäß verrechnet worden seien.","Drohen mit Klage","","","",[7],1,[1],[2],2,"14","3"],["3156","1968-01-05","Kritik an den Gottesdienststörungen in der Gedächtniskirche, Beifall für die Übergriffe auf Dutschke.","Warum kein Notdienst?","Leserbriefe","","Leser",[3,2],1,[6],[2],2,"18","2"],["3157","1968-01-06","Wehner begrüßt Vorhandensein einer außerparlamentarischen Opposition, doch sei die Grenze zu ziehen, wo die außerparlamentarische Opposition antiparlamentarisch wirke.","Antiparlamentarische Opposition gefährlich","","Wehner: Größere Aktivität \"links von der Mitte\"","DPA",[11],1,[1],[2],2,"12","2"],["3158","1968-01-06","Landsberg, AStA-Vorsitzender der FU, weist Kritik des Wissenschaftssenators Stein an Art der Diskussion mit Bürgermeister Schütz zurück. Dieser habe durch sein Verhalten selbst dazu beigetragen, dass er von Seiten der Diskussionsteilnehmer beleidigt worden sei, zudem habe Schütz die Studenten ebenfalls beleidigt.","AStA-Chef gibt Schütz die Schuld","","","",[1],1,[1],[2],2,"12","2"],["3159","1968-01-06","Kritik an den Gottesdienststörungen in der Gedächniskirche sowie an den Reaktionen seitens der Kirchenführung und des SPD-Senats darauf; Ankündigung von Selbsthilfeaktionen der West-Berliner Bevölkerung.","Um die Anerkennung","Leserbriefe","","Leser",[3],1,[6],[2],2,"12","2"],["3160","1968-01-07","Forderung der Humanistischen Union, dass gegen die \"Jubelperser\" vom Schah-Besuch Anklage wegen schweren Landfriedensbruchs erhoben wird.","Doch noch Anklage gegen \"Jubelperser\"?","","","",[7],1,[1],[2],2,"48","5"],["3161","1968-01-09","Schilderung einer Demonstration vor dem Palais am Funkturm, bei der 14 Personen vorübergehend festgenommen wurden. Gegen sieben Teilnehmer hat die Polizei Strafanzeige erstattet, u.a. wegen Widerstand und Körperverletzung, namentlich erwähnt von diesen sieben werden Fritz Teufel und Dieter Kunzelmann. Zudem Schilderung, dass ein Taxifahrer mit einem Holzknüppel auf Demonstranten eingeschlagen habe, ohne dass die Polizei eingeschritten sei.","Fritz Teufel war wieder einmal dabei","","","",[1],1,[1],[2],2,"14","6"],["3162","1968-01-11","Der VDS wies die Godesberger Erklärung der Rektoren zur Hochschulreform als unzureichend zurück.","Studenten nicht zufrieden","Schnell informiert","","",[4],1,[1],[2],2,"14","1"],["3163","1968-01-11","Störung von Vorlesungen an der Uni München durch sechs in Polizeiuniform auftretende Studenten, die teils dem SDS angehörten. Zudem forderte die studentische Vollversammlung der Hamburger Universität den Rücktritt des Hamburger Schulsenators Drexelius.","Krawall an Münchens Uni","","","DPA",[1],1,[1],[3],2,"14","2"],["3164","1968-01-11","Die Witwe Ohnesorg erhält von der Frankfurter Studentenschaft weitere 1400 DM, nachdem das Geld zunächst zur Deckung von Ausgaben des AStA einbehalten worden war.","Geld für Frau Ohnesorg","Kurz gemeldet","","",[7],1,[1],[2],2,"14","2"],["3165","1968-11-12","Kritik an den Aussagen des FU-Professors Weischedel und seiner Assistenten Meschkat und Krippendorff vor dem Untersuchungsausschuss des Abgeordnetenhauses. Diese würden den Staat verachten und mit ihren Aussagen die Ressentiments gegen die Studentenschaft in der Bevölkerung weiter schüren. Als Beispiel werden unverhältnismäßige Übergriffe der Polizei gegen Studenten angeführt, welche Folge solchen Auftretens sei. Generell wird das Klima der Eskalation in der Stadt beklagt, für das die \"radikalen studentischen Minderheiten\" verantwortlich gemacht werden. Fordert Mäßigung und Vernunft auf allen Seiten. Die Rede ist von Mao-Hanswursten.","Haß und Gewalt","","","Rudolf Stiege",[1],1,[5],[5],2,"18","2"],["3166","1968-11-12","Aussagen von Prof. Weischedel und den Assistenten Meschkat, Krippendorff und Agnoli sowie der früheren Studentin Sigrid Rüger (SDS) vor dem Untersuchungsausschuss des Abgeordnetenhauses. Diese erklärten, dass man sich unter Umständen über das geltende Hausrecht hinwegsetzen dürfe und verteidigten das Sit-In vom 22. Juni 1966.","FU-Professor verteidigt \"Sit-In\" der Studenten","","Untersuchungsausschuß prüft Zwischenfall an der Universität","Michael L. Müller",[1],1,[1],[1],1,"18","6"],["3167","1968-11-12","Zwei Angehörige der FU Berlin werfen Polizeibeamten des Reviers 181 Misshandlung vor.","Wer schlug hier wen?","","Vorwürfe gegen die Polizei - Dementi der Beamten","",[9],1,[1],[2],2,"18","6"],["3168","1968-01-13","Absage der Rektoratsübergabe an der FU Berlin wegen befürchteter Störungen.","Kein Festakt an der FU","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["3169","1968-01-13","Vertreter des SHB schlugen bei einer Zusammenkunft mit der FDJ in Ost-Berlin einen gegenseitigen Redneraustausch vor, die FDJ lehnte dies bis zur Anerkennung der DDR durch Bonn ab.","SHB bei der FDJ","Schnell informiert","","",[9],1,[1],[2],2,"12","1"],["3170","1968-01-13","Demonstrierenden Studenten wird Moskauhörigkeit vorgeworfen, die Richter werden mit Bezug auf den Teufel-Prozess zu härterer Prozessführung aufgefordert.","Zu kalt zum Demonstrieren?","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3171","1968-01-14","Prof. Weischedel von der FU Berlin wird für seine Aussagen vor dem Untersuchungsausschuss teils scharf kritisiert, teils auch verteidigt. Leserbriefe sind Reaktion auf den Leitkommentar \"Haß und Gewalt\" von Rudolf Stiege vom 12.11.1968.","Neuaufguß des Kommunismus","Leserbriefe","","Leser",[1],1,[6],[2],2,"60","2"],["3172","1968-01-14","Eine Delegation der Universität Leningrad ist zu Gast an der FU Berlin, u.a. soll die Möglichkeit eines wissenschaftlichen Austausches zwischen beiden Universitäten besprochen werden.","FU hat Gäste der Uni Leningrad","","","",[11],1,[1],[2],2,"60","3"],["3173","1968-01-16","Die Professoren Friedeburg und Goldschmidt kritisieren scharf den Leitartikel \"Hass und Gewalt\" von Stiege vom 12.11.1968 und sprechen sich für Prof. Weischedel aus. Die Äußerungen im Leitartikel würden an gewisse Zeitungen aus dem Jahre 1932 erinnern. Ein weiterer Leserbrief vertritt die gegenteilige Auffassung, der Leitartikel wird gelobt und die Studentenunruhen werden für ein eventuelles Aufkommen der NPD verantwortlich gemacht. Auch hier wird eine Parallele zu 1933 gezogen. ","Zwei Professoren antworten","Leserbriefe","","Prof. Friedeburg, Prof. Goldschmidt, Leser",[1],1,[6],[2],2,"14","2"],["3174","1968-01-16","Konstituierende Sitzung des neugewählten FU-Konvents, nur noch knappe linke Mehrheit.","Erste Sitzung des FU-Konvents","","","",[4],1,[1],[3],2,"14","3"],["3175","1968-01-16","Der Parlamentarische Untersuchungsausschuss des Senats befragt erstmals Vertreter der politischen Studentengruppen zu den Unruhen an der FU Berlin.","Ausschuß hört am Donnerstag Studenten","","","M.M.",[1],1,[1],[2],2,"14","3"],["3176","1968-01-16","Sondergottesdienst aller evangelischen Studentengemeinden fand wegen den vorangegangen Gottesdienststörungen durch Studenten statt in der Kaiser-Wilhelm-Gedächtniskirche im Studentenhaus am Steinplatz statt.","Gottesdienst im Studentenhaus","","","",[1],1,[1],[2],2,"14","6"],["3177","1968-01-17","Die FDJ will erst dann wieder mit westdeutschen Studentenorganisationen in Kontakt treten, wenn diese auf Grundlage Ulbrichtscher Deutschlandvorschläge diskutieren. Hintergrund waren vorangegangene Kontaktaufnahmen des SHBs, die laut FDJ nicht entschieden genug vom Alleinvertretungsanspruchs Bonns abgerückt sind.","FDJ will nicht mehr","Schnell informiert","","",[9],1,[1],[2],2,"12","1"],["3178","1968-01-17","Bundesvertriebenenminister von Hassel kritisiert Demonstrationen und Handgreiflichkeiten wie auch Polizeieinsätze in Kirchen. Zudem kritisiert er Geistliche, die Gottesdienste für die Verkündung ihrer politischen Überzeugungen benutzen. Bezugnahme auf Gottesdienststörungen in der Gedächtniskirche.","Hassel: Gefahr für die Kirche","","","",[3],1,[1],[2],2,"12","2"],["3179","1968-01-17","Kritik an den Aussagen des FU-Professors Weischedel vor dem Parlamentarischen Untersuchungsausschuss, Vergleich mit der NS-Zeit.","Über Rechtsordnung hinweggesetzt","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3180","1968-01-17","Für den Vietnamkongress am 17. und 18. Februar haben die Veranstalter noch keinen Raum, nach Absagen sollen nun die Universitäten möglicher Tagungsort werden.","Kein Saal für Vietnam-Kongreß?","","","",[1],1,[1],[2],2,"12","3"],["3181","1968-01-17","Über die konstituierende Sitzung des neuen FU-Konvents und die Wahl des neuen Vorsitzenden. Zudem wird vermeldet, dass Wolfgang Lefèvre auf Grund fehlender Rückmeldung aus der Studentenliste der FU Berlin gestrichen worden sei.","FU-Konvent bleibt auf Linkskurs","","","",[4],1,[1],[2],2,"12","3"],["3182","1968-01-18","Demonstration in Bremen gegen die Erhöhung der Gebühren für die Straßenbahnen, Polizei setzt Wasserwerfer gegen die etwa 1000 Demonstranten ein.","Tumulte in Bremen","","","",[1],1,[1],[3],2,"16","1"],["3183","1968-01-18","In den Studentendemonstrationen wird eine große Gefahr gesehen, diese seien kommunistisch gesteuert, die Polizei müsse notfalls auch Gummiknüppel und Wasserwerfer einsetzen. In anderen Leserbriefen wird das Urteil und die Prozessführung im Rehse-Fall scharf kritisiert.","Unbehagen an Fall Rehse","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3184","1968-01-18","Nach Studenten aus Göttingen und Gießen protestierten nun auch Studenten aus Kiel gegen eine vermutete Überwachung durch den Bundesverfassungsschutz.","Auch Kiel protestiert","Kurz gemeldet","","",[1],1,[1],[2],2,"16","2"],["3185","1968-01-19","Das Studentenparlament der TU Berlin spricht sich empört gegen den Vorschlag der Ernennung des Senatsrats Prill zum Polizei-Vizepräsidenten aus.","Studenten gegen Prill","","","",[1],1,[1],[2],2,"16","3"],["3186","1968-01-19","Die CDU kündigt eine verstärkte Aktivität im Bereich der Hochschul- und Forschungspolitik an, insbesondere mit den linksradikalen Studentengruppen will man sich entschiedener auseinandersetzen. Diese hätten laut Minister Stoltenberg antidemokratische und antiliberale Tendenzen und würden rechtsextreme Tendenzen in einer Wechselwirkung stärken.","CDU bildet Hochschulbeirat","","Stoltenberg: Auseinandersetzung mit Linksradikalen","HOH.",[1],1,[1],[2],2,"16","7"],["3187","1968-01-19","Jürgen-Bernd Runge, RCDS-Vorsitzender an der FU Berlin, schildert vor dem Parlamentarischen Untersuchungsausschuss seine Sicht über die Unruhen an der FU Berlin.","Ein Kolleg über die Taktik der Linksextremisten","","Studenten vor dem Untersuchungsausschuß","MM.",[1],1,[1],[1],2,"16","7"],["3188","1968-01-20","Freiwilliges Engagement von 70 Bundeswehroffizieren in Zivil zum Schutz vor befürchteten Störungen des Gottesdienstes von Professor Thielicke in der Hamburger St.-Michaelis-Kirche.","Offiziere auf der Seite Thielickes","","","",[1],1,[1],[2],2,"12","1"],["3189","1968-01-20","Demonstranten randalierten während eines Prozesses um die Zwischenfälle bei der Aufführung des Films \"Africa addio\".","Wieder Krawall","","","",[1],1,[1],[2],2,"12","3"],["3190","1968-01-20","Der FU-Konvent lehnt die Föderungsfähigkeit zweier schlagender Verbindungen ab. Das TU-Studentenparlament wählte einen neuen Vorsitzenden.","Nicht förderungswürdig / TU-Parlament wählte","","","",[4],1,[1],[2],2,"12","3"],["3191","1968-01-20","Aufzählung der noch laufenden Verfahren gegen Rudi Dutschke nach einer Kleinen Anfrage der CDU-Abgeordneten Dr. Ursula Besser.","Acht Verfahren gegen Dutschke","","","LUK",[2],1,[1],[2],2,"12","5"],["3192","1968-01-20","Bericht über die Verurteilung von Demonstranten gegen die Fahrpreiserhöhung, die Urteile und der Einsatz der Polizei bei den Demonstrationen werden als hart bezeichnet, ohne diese jedoch zu kritisieren; insbesondere die Bevölkerung sei über die Härte der Polizei empört.","Harte Strafen gegen Bremer Randalierer","","Gestern herrschte wieder Ruhe in der Hansestadt","",[1],1,[1],[1],1,"12","12"],["3193","1968-01-21","Der FU-Konvent verurteilt das Disziplinarverfahren gegen Prof. Gottschalch, dieses zeige, wie weit sich die Politik des Senats von der Verfassungsnorm entfernt habe.","Harte Kritik des FU-Konvents","","","",[4],1,[1],[2],2,"56","3"],["3194","1968-01-21","Die Humanistische Union protestiert gegen die Ernennung des Senatsrats Prill zum Polizei-Vizepräsidenten, diesem mangele es an einer demokratischen Einstellung.","Gegen Prill","","","",[4],1,[1],[2],2,"56","3"],["3195","1968-01-23","Kritik an dem Leitkommentar \"Haß und Gewalt\" von Stiege vom 12.1.1968, Plädoyer für Prof. Weischedel.","Der Status quo von Berlin","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3196","1968-01-23","Über die Auseinandersetzung um die Fahrpreiserhöhung in Bremen.","Erster Erfolg der Demonstranten","","","DPA",[1],1,[1],[2],2,"14","2"],["3197","1968-01-23","Der FU-Konvent habe zwar endlich eine Stellungnahme zum Moskauer Schriftstellerprozess veröffentlicht, diese zeige jedoch die \"geistig-politische Verwirrung der Mehrheit der FU-Parlamentarier\", sie würden die Realitäten nicht mehr wahrnehmen. Die Konventsmiglieder könnten aber kaum noch als Sprecher der FU-Studentenschaft angesehen werden.","FU-Konvent im Elfenbeinturm","","","KI.",[1],1,[5],[2],2,"14","2"],["3198","1968-01-24","Tumulte beim Prozess um die Vorfälle bei den Aufführungen des Film \"Africa Addio\". Dem Richter sollte u.a. ein Exemplar von Hitlers \"Mein Kampf\" überreicht werden, Knallkörper explodierten, der Saal wurde schließlich geräumt. Dazu eine Karikatur.","Saalschlacht im Moabiter Gericht","","Prozess um \"Africa addio\" endete mit Tumulten","M.K.",[1],1,[1,4,5],[1],1,"14","3"],["3199","1968-01-24","Gerd Börnsen und Knut Nevermann sagen vor dem Parlamentarischen Untersuchungsausschuss zu den Unruhen an der FU Berlin aus. Insbesondere Nevermann wird kritisch dargestellt.","Bewußte Beeinflussung der Studenten zugegeben","","Ex-AStA-Funktionäre als Zeugen vernommen","MM.",[1],1,[1],[5],1,"14","6"],["3200","1968-01-25","Der Rektor der TU Berlin, Prof. Weichselberger, weist auf die Notwendigkeit einer Gesamtreform der Bildungspolitik hin und wirft der Politik vor, sich diesen Reformen zu entziehen und sie allein der Universität zu überlassen. Die fehlenden Reformen seien auch ein Grund für die Unruhe der Studenten.","Universität muß die Last tragen","","","",[4],1,[1],[3],2,"18","2"],["3201","1968-01-25","Ein Ermittlungsverfahren gegen den ehemaligen Polizeipräsidenten Duensing und mehrere leitende Polizeibeamte wurde eingestellt.","Anhaltspunkte für Straftaten fehlen","","","",[1],1,[1],[2],2,"18","3"],["3202","1968-01-25","Eine Sitzdemonstration für den 3. Februar vor der Griechischen Militärmission in Berlin wird von dem \"Komitee der 100 für die Freiheit Griechenlands\" angekündigt. Die Demonstranten sollen unter allen Umständen der Gewaltlosigkeit verpflichtet bleiben.","Sitzdemonstration","","","",[1],1,[1],[2],2,"18","3"],["3203","1968-01-25","Das Studentenparlament der Pädagogischen Hochschule verurteilt das Disziplinarverfahren gegen Prof. Gottschalch.","Für Gottschalch","","","",[4],1,[1],[2],2,"18","3"],["3204","1968-01-26","Prof. Weischedel von der FU Berlin wird für seine Aussagen vor dem Untersuchungsausschuß kritisiert. Kritik an den demonstrierenden Studenten. Reaktion auf den Leitkommentar \"Haß und Gewalt\" von Rudolf Stiege vom 12.11.1968 und die darauffolgenden Leserbriefe.","Aufgabe der Professoren","Leserbriefe","","Leser",[1],1,[6],[2],2,"18","2"],["3205","1968-01-26","Das Innenministerium verteidigt die Überwachung des SDS durch den Verfassungsschutz. Zudem würden Umfragen belegen, dass nur eine Minderheit der Bevölkerung die Aktionen der Studenten uneingeschränkt begrüßen würden, zwei Drittel sprachen sich gegen diese Aktionen aus.","Radikale sind nicht gefragt","","","",[1],1,[1],[3],2,"18","2"],["3206","1968-01-26","Mehrere Vertreter des FU-AStAs seien bei der Reise in die DDR mehrere Stunden verhört und kontrolliert worden. Trotzdem würden sie nicht dagegen demonstrieren, sondern würden stattdessen noch um eine Sonderermäßigung für nach Westdeutschland fliegende Studentenvertreter bei Herrn Wehner bitten.","Stinkt nicht","","","",[1],1,[5],[3],2,"18","2"],["3207","1968-01-26","Nach Bremer Vorbild wollen in Regensburg Schüler gegen Fahrpreiserhöhungen demonstrieren.","Schüler protestieren","Kurz gemeldet","","",[1],1,[1],[2],2,"18","2"],["3208","1968-01-26","Ein Protestschreiben gegen den Moskauer Schriftstellerprozess wurde von ca. 4000 Angehörigen der FU Berlin unterschrieben.","Protest gegen Moskauer Urteile","","","",[9],1,[1],[2],2,"18","6"],["3209","1968-01-26","Wissenschaftssenator Stein plädiert für Anwendung des Hausrechtes bei Störungen an den Universitäten.","Stein: Hausrecht anwenden","","","",[1],1,[1],[2],2,"18","6"],["3210","1968-01-26","Justizsenator Hoppe berichtet über Zeugenvernehmungen und Ermittlungen im Zusammenhang mit den Demonstrationen beim Schah-Besuch am 2. Juni.","Schwierige Ermittlungen","","Schahbesuch - Hoppe berichtete dem Justizausschuß","LUK",[1],1,[1],[2],2,"18","6"],["3211","1968-01-26","Strafanzeigen gegen mehrere Studenten wegen Vorfällen während des \"Africa addio\"-Prozesses, namentlich erwähnt wird nur Fritz Teufel.","Richter erstattete Strafanzeige","","","",[1],1,[1],[2],2,"18","7"],["3212","1968-01-27","Nach Bremer Vorbild wollen in Kiel Schüler gegen Fahrpreiserhöhungen demonstrieren.","Kieler Schüler wollen demonstrieren","","","",[1],1,[1],[2],2,"14","2"],["3213","1968-01-27","Über die geplante Demonstration des \"Komitee der 100\" vor der Griechischen Militärmission, diese Demonstration richte sich nicht wirklich gegen die Zustände in Griechenland, sondern eher gegen den Berliner Senat und den Staat im Allgemeinen. Kritik an den Initiatoren um Prof. Flechtheim und Horst Mahler, deren Mitwirken zeige, dass die Masse der Studentenschaft nur ausgenutzt wird.","Der manipulierte Protest","","","wbr.",[1],1,[5],[2],2,"14","2"],["3214","1968-01-28","Die Jungdemokraten wollen auf dem Parteitag der FDP die Anerkennung der DDR erreichen. Dies, wie auch die Kontakte zu Rudi Dutschke, soll die FDP für Wähler links von der SPD attraktiv machen.","FDP mit Blick nach links","","","Harald O. Hermann",[1],1,[5],[2],2,"68","2"],["3215","1968-01-28","Anhänger des SDS haben in Heidelberg das traditionelle \"Nationensingen\" gestört, wurden jedoch von ausländischen Studenten abgedrängt.","SDS störte","Kurz gemeldet","","",[1],1,[1],[2],2,"68","2"],["3216","1968-01-30","Eine Rede des israelischen Botschafters Asher Ben Natan wurde von linksextremen Studentenvertretern mehrfach durch Missfallenskundgebungen unterbrochen.","Israels Botschafter sprach in der FU","","","",[1],1,[1],[2],2,"14","1"],["3217","1968-01-30","Nach Bremer Vorbild ist es auch in Bochum zu heftigen Demonstrationen gegen Fahrpreiserhöhungen bei den öffentlichen Verkehrsmitteln gekommen, auch in Regensburg demonstrierten Schüler aus dem gleichen Grund.","Jetzt Proteste in Bochum","","","",[1],1,[1],[2],2,"14","1"],["3218","1968-01-31","Über den Parteitag der FDP, im Mittelpunkt der Berichterstattung steht Ralf Dahrendorf, dieser wollte bei einer nicht genehmigten Veranstaltung mit Dutschke diskutieren. Als später der Parteitag per Go In seitens Studenten besetzt werden sollte, wurden Saalordner gegen die Studenten eingesetzt.","Nicht ernst nehmen - so lautete die Devise der FDP","","Doch die \"zornigen jungen Leute\" blieben unzufrieden","Harald O. Hermann",[1],1,[1],[1],1,"12","2"],["3219","1968-01-31","Über Studentenunruhen in Spanien, zum Schluss wird konstatiert, dass unter den spanischen Studenten Beatniks und Hippies keinen Platz hätten und diese im Gegensatz zu den protestierenden deutschen Studenten radikaler seien und größere Risiken in Kauf nehmen würden.","Gegensätze zwischen Studenten und Polizei","","Schwere Unruhen an Spaniens Universitäten","",[1],1,[1],[2],2,"12","2"],["3220","1968-01-31","Kritik und Zuspruch zum Artikel \"Der manipulierte Protest\" vom 27.01.1968 über die geplante Demonstration des \"Komitees der 100\" vor der Griechischen Militärmission","\"Es geht ihnen nicht um Griechenland\"","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3221","1968-02-01","Der langjährige Korrespondent des US-Nachrichtenmagazins \"The Reporter\" in Berlin und der Bundesrepublik konstatiert eine neue Berlin-Krise, die von den linksextremen Studenten geschaffen sei. Diese weisen u.a. einen Anti-Amerikanismus auf, hinter ihrem ultralinken Jargon verbergen sich neurotische nationale Untertöne.","\"Berlin-Krise durch Radikale\"","","","",[1],1,[1],[2],2,"18","1"],["3222","1968-02-01","Eine Fakultätssitzung der Philosophischen Fakultät wird mit einem Go-In gestört, weil die Professoren nicht mit den Studenten diskutieren wollen. Prof. Gollwitzer versucht zu vermitteln, das RCDS-Mitglied Runge berichtet von körperlichen Übergriffen seitens einiger Studenten. Namentlich erwähnt wird von den protestierenden Studenten nur Fritz Teufel.","Professoren tagten bei Kerzenlicht","","Studentenkrawall während der Fakultätssitzung","L. R.",[1],1,[1],[1],2,"18","3"],["3223","1968-02-02","Kritik an den Studenten- und Schülerdemonstrationen sowie an der medialen Aufmerksamkeit für Rudi Dutschke.","Schlechte Beispiele verderben die Sitten","Leserbriefe","","Leser",[1],1,[6],[2],2,"18","2"],["3224","1968-02-02","Demonstrationen von Schülern und Studenten in Kiel, Freiburg, Hannover und Münster.","Auch Deutschlands Schüler gehen auf die Barrikaden","","Tumulte in mehreren Städten der Bundesrepublik","",[1],1,[1],[1],1,"18","1,8"],["3225","1968-02-02","Studentenverbände von Fachhochschulen und Akademien drohen bei ausbleibenden Reformen Vorlesungsstreiks an.","Akademie-Studenten drohen mit Streik","","","cd.",[4],1,[1],[2],2,"18","8"],["3226","1968-02-02","Ergebnis der Neuwahlen zum Hamburger Studentenparlament.","Kein Übergewicht","","","",[4],1,[1],[2],2,"18","8"],["3227","1968-02-02","Wissenschaftssenator Stein fordert Studenten zum Dialog mit den Lehrenden für die Neuordnung des Studiums, kritisiert zugleich die jüngsten Auseinandersetzungen an der Universität, dies schade auch der geplanten Neufassung eines Universitätsgesetzes.","Scharfe Erklärung Steins","","Neufassung eines Universitätsgesetzes gefährdet","",[1],1,[1],[2],1,"18","8"],["3228","1968-02-02","FU-Rektor Harndt wirft den beteiligten Studenten am Go-In der Philosophischen Fakultät Terrormethoden vor, vergleicht die Methoden mit denen der SA.","FU-Rektor Harndt stellt fest: Das ist brutaler Terror","","","",[1],1,[1],[5],2,"18","8"],["3229","1968-02-02","Die Professoren der Philosophischen Fakultät erklären ihre grundsätzliche Gesprächsbereitschaft mit den Studenten, sie würden sich aber nicht von diesen unter Druck setzen lassen. Auch AStA und der Demokratische Klub nehmen Stellung dazu","Professoren zur Diskussion bereit","","","",[1],1,[1],[2],2,"18","8"],["3230","1968-02-02","Aussagen von Prof Gollwitzer und Prof. Taubes sowie vom Senatsrat Prill und zweier Studentenvertreter vor dem Parlamentarischen Untersuchungsausschuss.","Gollwitzer ist im SDS-Förderkreis","","Aussagen vor dem Untersuchungsausschuß","J. M.",[1],1,[1],[1],1,"18","1,9"],["3231","1968-02-03","Erneute Demonstrationen in Kiel und Freiburg gegen Fahrpreiserhöhungen.","Neue Demonstrationen in Freiburg und Kiel","","Zehnjährige Kinder zwangen Busse zum Halten","",[1],1,[1],[2],2,"14","1"],["3232","1968-02-03","Politiker aller Parteien verurteilen scharf die eingeschmissenen Fensterscheiben der Filialen der Berliner Morgenpost.","Gesetzlosem Treiben ein Ende bereiten!","","Politiker verurteilen Terrorakte","LUK",[10],1,[1],[5],2,"14","1"],["3233","1968-02-03","Steinwürfe und eingeschmissene Scheiben der Morgenpostfilialen werden mit der Machtergreifung der Nazis 1933 und der \"Reichskristallnacht\" 1938 verglichen.","Steine gegen unsere Filialen / Die Schaufenster klirrten wie in der Kristallnacht","","Sechs Filialen der Berliner Morgenpost demoliert","L. R.",[10],1,[1],[1],1,"14","1,6"],["3234","1968-02-03","Anfragen von Heinrich Lummer über den in der TU Berlin gezeigten Film über die Herstellung eines Molotowcocktails","Fragen an den Senat","","","L. R.",[1],1,[1],[5],2,"14","6"],["3235","1968-02-03","Ein Student wurde wegen mangelnder Beweise vom Vorwurf des Landfriedensbruchs im Zuge der Demonstrationen am 2. Juni 1967 freigesprochen.","Gericht: Kein Landfriedensbruch","","","",[1],1,[1],[2],2,"14","6"],["3236","1968-02-03","Kommentar zum Molotowcocktail-Film/ den Vorbereitungen zum Springer-Tribunal in der TU Berlin und den in der Nacht folgenden eingeworfenen Scheiben der Morgenpost-Filialen, Vergleich mit der Reichskristallnacht","Molotow-Cocktails vor dem Zirkus","","","Heinz Köster",[10],1,[5],[2],1,"14","2,3"],["3237","1968-02-03","Molotowcocktail-Film an der TU Berlin, 14-tägiges Ultimatum an Springer, sich selbst zu enteignen.","\"Wie stelle ich einen Molotow-Cocktail her?\"","","\"Springer-Tribunal\": Aufforderung zum Terror","",[1],1,[1],[1],1,"14","7"],["3238","1968-02-03","Die Studentenvereinigung UAG der TU Berlin kritisiert die Vorkommnisse der \"Kritischen Universität\" an der TU, die Veranstalter des Springer-Tribunals hätten gezeigt, dass der Vorwurf des Faschismus auf sie selbst zurückfällt.","Scharfe Kritik von TU-Studenten","","","",[1],1,[1],[2],2,"14","7"],["3239","1968-02-03","Vollversammlung der FU Berlin zum Go-In bei der Philosophischen Fakultät. Man sprach sich gegen eine Verurteilung des Go-Ins aus. Erwähnt wird im Bericht, dass ein Sonderdruck der SED-Zeitung \"Die Wahrheit\" verteilt wurde.","Gewaltakte an der FU wurden nicht verurteilt","","Vollversammlung: Streiks und \"Go-ins\"","keiner",[1],1,[1],[2],2,"14","7"],["3240","1968-02-03","Senator Stein will nach dem Go-In an der Philosophischen Fakultät zwischen Studenten und Professoren vemitteln.","Stein will vermitteln","","","LUK",[1],1,[1],[2],2,"14","7"],["3241","1968-02-03","Der AStA der Pädagogischen Hochschule lädt den Vorsitzenden der West-Berliner SED, Danelius, zu einem Gespräch ein, um etwas über die Stellung der SED zur APO zu erfahren.","PH lädt SED-Chef Danelius ein","","","",[9],1,[1],[2],2,"14","7"],["3242","1968-02-04","Erneuter Steinwurf gegen eine Filiale der Berliner Morgenpost, Stellungnahmen von Politikern dazu.","Wieder Scheiben zertrümmert","","","",[10],1,[1],[2],2,"64","1"],["3243","1968-02-04","Demonstration vor der Griechischen Militärmission und anschließender Protestmarsch zum Kurfürstendamm, Kritik am zögerlichen Vorgehen der Polizei, Stellungnahme von Neubauer, der die Demonstrationen scharf kritisiert.","Krawalle in der Innenstadt durch wilde Demonstranten","","Kurfürstendamm glich gestern Nachmittag einem Hexenkessel.","EB.",[1],1,[1],[1],1,"64","1"],["3244","1968-02-04","Kritik an den Aussagen Gollwitzers und Taubes' vor dem Parlamentarischen Untersuchungsausschuss sowie Kritik an der medialen Aufmerksamkeit für die Studenten um Rudi Dutschke.","Keine klaren Antworten","Leserbriefe","","Leser",[1],1,[6],[2],2,"64","2"],["3245","1968-02-04","Absage des Journalisten Georges Reymond an das Springer-Hearing auf Grund der Vorfälle auf dem vorbereitendem Springer-Tribunal in der TU Berlin (Forderung von Zensoren und Molotowcocktail-Film), weiterhin aber scharfe Kritik am Journalismus des Springer-Verlags.","Absage an das 'Springer-Hearing'","","","Georges Reymond",[10],1,[5],[3],2,"64","2"],["3246","1968-02-04","Vorfälle wie der Molotowcocktail-Film und folgende Aktionen gegen die Springer-Filialen würden das Umschwenken der Provokation der Gewalt zur Gewalt an sich dokumentieren. Kritik an den Professoren Gollwitzer und Weischedel, weil diese zu den seiner Meinung nach faschistischen Aktionen gegen den Springer Verlag schweigen. Forderung nach härterem Vorgehen der Polizei und der Justiz gegen die demonstrierenden Studenten.","Es geht um Berlins Ruf","","","Rudolf Stiege",[1],1,[5],[2],2,"64","2"],["3247","1968-02-04","Demonstrationen in Kiel und Bochum","Bomben, Eier und Tomaten","","","",[1],1,[1],[2],2,"64","2"],["3248","1968-02-04","Demonstration vor der Griechischen Militärmission und anschließender Protestmarsch zum Kurfürstendamm, Kritik am zögerlichen Vorgehen der Polizei, nur Fritz Teufel wird von den Demonstranten namentlich erwähnt.","Die Polizei hielt sich lange zurück","","Bilanz der Straßenschlacht: 7 Verletzte","L. R.",[1],1,[1],[1],2,"64","3"],["3249","1968-02-04","Ermittlungen wegen den Steinwürfen auf Filialen der Berliner Morgenpost, Rudi Dutschke rechtfertigt die Steinwürfe, der Fachverband Publizistik im VDS distanziert sich dagegen.","Attentate auf Filialen: Kripo prüft viele Spuren","","","",[10],1,[1],[5],1,"64","3"],["3250","1968-02-06","Gottesdienste in Hamburg und Heidelberg wurden gestört.","Gottesdienst gestört","Schnell informiert","","",[3],1,[1],[2],2,"18","1"],["3251","1968-02-06","Rektor Weichselberger von der TU Berlin zieht die Genehmigung für das geplante Springer-Hearing vom 9. bis 11.2. in der TU Berlin zurück.","TU-Rektor: Kein 'Springer-Hearing' in der Uni","","","",[10],1,[1],[2],2,"18","1"],["3252","1968-02-06","Demonstration in Frankfurt am Main vor dem US-Generalkonsulat. Eine deutsche Fahne wurde angezündet sowie des Amerika-Hauses eingeschlagen. Auseinandersetzungen mit der Polizei. Ausgelöst worden seien die Krawalle durch Rudi Dutschke auf einer Veranstaltung in der Frankfurter Universität.","Deutsche Fahne angezündet","","","",[1],1,[1],[2],2,"18","1"],["3253","1968-02-06","Gollwitzer und Taubes fordern Gewaltlosigkeit bei der bevorstehenden Vietnamkonferenz und bedauern die Vorfälle um das Springer-Tribunal in der TU Berlin. Zugleich kritisieren sie Vergleiche der studentischen Aktionen mit Methoden des NS. In einem anderen Leserbrief werden diese Parallelen wieder behauptet.","Öffentliche Erklärung","Leserbriefe","","Prof. Gollwitzer, Prof. Taubes, Leser",[1],1,[6],[2],2,"18","2"],["3254","1968-02-06","Demonstrationen in Kiel und Osnabrück gegen Fahrpreiserhöhungen.","Mißtrauensantrag in Bremen","","","",[1],1,[1],[3],2,"18","2"],["3255","1968-02-06","Wolfgang Lefèvre musste sein Amt als stellv. Konventsvorsitzender niederlegen, weil er es versäumte, sich rechtzeitig zum Wintersemester zurückzumelden und deshalb von der Studentenliste der FU gestrichen worden war; Terminansetzung des Parlamentarischen Untersuchungsausschusses; Die Philosophische Fakultät der FU Berlin akzeptiert den Vorschlag von Senator Stein, dass dieser als Vermittler zwischen Lehrenden und Lernenden auftritt.","Levèfre legte sein Amt nieder / Vorschlag akzeptiert / Heute Beweiserhebung","","","",[1],1,[1],[2],2,"18","3"],["3256","1968-02-06","Der Regierende Bürgermeister Schütz kritisiert scharf die jünsten Demonstrationen und Aktionen der studentischen APO. Der Bundestagsabgeordnete Adolf Arndt (SPD) vergleicht in einem Brief an Axel Springer die Aktionen gegen die Filialen der Berliner Morgenpost mit der SA. Das \"Komitee der 100\" bedauert die gewalttätige Fortsetzung seiner Demonstration vor der Griechischen Militärmission.","Schütz will jetzt hart durchgreifen","","Demonstrationsrecht kriminell mißbraucht","",[1],1,[1],[1],1,"18","3"],["3257","1968-02-06","Zahlreiche Leserbriefe, die die Aktionen gegen Springer-Verlag verurteilen. Wiederholt werden Vergleiche mit der SA bzw. der NS-Zeit gezogen und härteres Vorgehen seitens Justiz, Polizei und Universität gegen die protestierenden Studenten gefordert. Namentlich werden Dutschke und Teufel mehrfach als Rädelsführer genannt.","Sie sagen \"Springer\" und meinen die Demokratie","Leserbriefe","Das Ziel ist Anarchie und Chaos","Leser",[10],1,[6],[2],2,"18","7"],["3258","1968-02-07","Demonstration in Freiburg von Schülern und Studenten gegen Fahrpreiserhöhungen.","Sturm auf das Rathaus abgewehrt","","","",[1],1,[1],[2],2,"14","1"],["3259","1968-02-07","Die Rektoren der FU und TU Berlin stellen keine Räume in ihren Universitäten für das geplante Springer-Hearing zur Verfügung. Die CDU verurteilt zudem, dass sich Senator Stein als Vermittler mit den \"studentischen Aufrührern\" unterhalte.","Radikale: Keine Zusicherungen für \"Springer-Hearing\"","","","",[10],1,[1],[5],1,"14","1"],["3260","1968-02-07","Studenten sind in das Zimmer des Rektors der Universität Bonn eingedrungen und haben im Goldenen Buch der Universität unter dem Namen von Bundespräsident Lübke das Wort \"KZ-Baumeister\" hinzugefügt. Zudem Bericht über mehrere Anzeigen in Frankfurt gegen Rudi Dutschke.","Studenten mißbrauchten \"Goldenes Buch\" in Bonn","","Krawalle werden auch den Bundestag beschäftigen","",[1],1,[1],[2],2,"14","1"],["3261","1968-02-07","Der West-Berliner Vorsitzende der SED, Danelius, wurde auf einer Diskussion in der Pädagogischen Hochschule vom Plenum ausgezischt. Danelius verteidigte auch die Steinwürfe gegen Morgenpost-Filialen.","SED-Funktionär ausgezischt","","","",[9],1,[1],[2],2,"14","2"],["3262","1968-02-07","Solidarität der Leser mit Axel Springer, Forderung nach härterem Eingreifen gegenüber den demonstrierenden Studenten, Vorwurf, dass die demonstrierenden Studenten Ulbricht West-Berlin zuspielen.","Spielregeln der Demokratie","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3263","1968-02-07","Rainer Barzel bezeichnet die Steinwürfe gegen Springer-Filialen als Terror. Die CDU/CSU- und SPD-Fraktion kündigen eine große Anfrage im Bundestag zu den jüngsten Ausschreitungen in der Bundesrepublik an.","Steinwürfe sind Terror","","","dws.",[10],1,[1],[2],2,"14","2"],["3264","1968-02-07","Innensenator Neubauer kündigt an, dass die Polizei künftig härter gegen Demonstranten vorgehen wird. Es soll keine Genehmigung für eine beantragte Demonstration im Anschluss an den Vietnam-Kongress geben. Professoren der FU Berlin werfen Senator Stein vor, sich nicht deutlich genug für ihre Seite nach dem jüngsten Konflikt mit Studenten (Go-In) ausgesprochen zu haben. Solidaritätserklärungen von Politikern gegenüber Springer. Erwähnung von Rudi Dutschke. Dazu eine Karikatur zum Springer-Hearing.","Professoren sind von Stein enttäuscht","","Neubauer: Polizei darf nicht lächerlich gemacht werden","L.R.",[1],1,[1,5,4],[1],1,"14","3"],["3265","1968-02-07","Scharfe Kritik an den Studentenunruhen, härteres Vorgehen dagegen wird gefordert, die Unruhen seien von östlicher Seite gelenkt.","Frage an den Senat","Leserbriefe","Geduld der Berliner nicht strapazieren","Leser",[1],1,[6],[2],2,"14","6"],["3266","1968-02-07","Prof. Sontheimer sagte vor dem Parlamentarischen Untersuchungsausschuss aus, insbesondere wurde er zum Krippendorff-Fall befragt. Das Ausschussmitglied Werth wirft Sontheimer vor, seine Informationspflicht gegenüber den Studenten versäumt und so zur Eskalation der Unruhen beigetragen zu haben.","Sontheimer: \"Zum Teil törichter Radikalismus\"","","Aussagen vor dem Untersuchungsausschuß","MM.",[1],1,[1],[5],1,"14","9"],["3267","1968-02-08","Neue Demonstrationen werden befürchtet, der Vorsitzende der Polizeigewerkschaft zieht Vergleich zur \"Reichskristallnacht\", der Demokratische Klub spricht von Linksfaschisten, der niedersächsische Innenminister bezeichnet zahlreichen Studentengruppen als kommunistisch unterwandert.","Neue Protestwelle?","","Bundeskabinett äußert sich zu den Krawallen","",[1],1,[1],[2],2,"16","1"],["3268","1968-02-08","Neue Demonstrationen in Freiburg gegen Fahrpreiserhöhungen, schwere Auseinandersetzungen mit der Polizei. Demonstration auch in Bonn.","Schwere Tumulte in Freiburg","","","",[1],1,[1],[2],2,"16","2"],["3269","1968-02-08","Härtere Maßnahmen gegen die demonstrierenden Studenten werden gefordert, die SPD wird kritisiert, weil sie nicht hart genug dagegen vorgegangen wäre, linke Radikale würden rechte Radikale stärken.","Härtere Maßnahmen","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3270","1968-02-08","Das Berliner Abgeordnetenhaus beschäftigt sich in seiner nächsten Sitzung schwerpunktmäßig mit den Studentenunruhen. Die CDU-Fraktion wird einen Antrag einbringen, in dem ein Verbot des SDS gefordert wird.","Universitäten im Mittelpunkt","","","",[1],1,[1],[2],2,"16","3"],["3271","1968-02-08","Vollversammlung der \"Kritischen Universität\" (KU) in der TU Berlin, Ankündigung eines Protestmarsches zum Rathaus Schöneberg wegen Raumvergabeverbot, Bürgermeister Schütz bezeichnet demonstrierende Studenten als Pöbel und vergleicht sie mit dem \"kommunistischen Mob\".","Marsch zum Rathaus nicht genehmigt","","Studenten attackieren Neubauer","L.R.",[1],1,[1],[1],2,"16","3"],["3272","1968-02-09","Debatte im Berliner Abgeordnetenhaus über die Studentenunruhen, Forderung nach Verbot des SDS und härterem Vorgehen.","Berliner Parteien einig: Schluss mit den Krawallen / Die Fraktionen verurteilen einmütig Krawallaktionen","","Aber keine konkreten Beschlüsse - Ausschüsse sollen beraten","",[1],1,[1],[1],1,"20","1,8"],["3273","1968-02-09","Neue Studentenunruhen in der Bundesrepublik. Die Innenminister der Länder beschließen härteres Vorgehen gegen die Unruhen, Mitläufer sollen von den Störenfrieden isoliert werden.","Störenfriede isolieren","","Innenminister rügen Universitätsleitungen","",[1],1,[1],[3],2,"20","1"],["3274","1968-02-09","Schwere Kritik am Regierenden Bürgermeister Schütz und am Senat, dieser gehe nicht hart genug gegen die Studentenunruhen vor, es ist die Rede von SDS-Terroristen. Kritik auch an der Entscheidung des Verwaltungsgerichts, das Raumvergabeverbot für das geplante Springer-Hearing an der FU Berlin aufzuheben. Peter Gäng habe zudem geäußert, dass er es für richtig halte, wenn die Arbeiterschaft ein Gebäude des Springer-Verlags niederbrennen würde.","Zarte Antworten auf harte Fragen","","","Rudolf Stiege",[1],1,[5],[2],1,"20","2"],["3275","1968-02-09","Wahl des neuen FU-AStA","Neuer FU-AStA","","","",[4],1,[1],[3],2,"20","8"],["3276","1968-02-09","Das Berliner Verwaltungsgericht hat die Entscheidung des Rektors der FU, keine Räume für das geplante Springer-Hearing zur Verfügung zu stellen, aufgehoben. Peter Gäng kritisiert eingeschmissene Fensterscheiben der Morgenpostfilialen, hätte aber Verständnis für ein Niederbrennen eines Springer-Gebäudes.","FU-Entscheidung aufgehoben/ SDS-Mitglied: Verständnis für Brandstiftung","","","",[1],1,[1],[5],1,"20","1,8"],["3277","1968-02-09","RCDS-Vorsitzender Schönbohm greift den SDS an, kündigt Mobilisierung der gemäßigten Studenten an. Der CDU-Bundestagsabgeordnete Majonica fordert ein härteres Eingreifen bei den Studentenunruhen. Nach einer Umfrage nehmen nur sechs bis acht Prozent der Studenten an den Unruhen teil. Im Kölner und Göttinger AStA wird ein \"Linksrutsch\" konstatiert.","RCDS erwartet Mobilisierung der Gemäßigten","","","",[1],1,[1],[2],1,"20","9"],["3278","1968-02-09","Solidarisierung der Leser mit Springer, es wird ein härteres Vorgehen gegen die Studentenunruhen gefordert, letztere seien vom Osten gesteuert. In einem Leserbrief wird der Springer-Presse Hetze bescheinigt und dass sie Ausschreitungen gegen den eigenen Verlag selbst provoziert hätten.","\"Nun erst recht!\"","Leserbriefe","Die Wahrheit sagen - was in Berlin geschieht","Leser",[1],1,[6],[2],2,"20","9"],["3279","1968-02-10","Demonstrationen in Hamburg, Freiburg und München. In Hamburg demonstrierte man auch vor dem Springerhaus.","Hamburger Jugendliche blockierten Innenstadt","","Auch in Freiburg kam es erneut zu Krawallen","",[1],1,[1],[2],2,"12","1"],["3280","1968-02-10","Aktuelle Stunde im Bundestag über die Studentenunruhen, härteres Durchgreifen wird von Bundeskanzler Kiesinger angekündigt, große Mehrheit der Studenten würden nicht zu den Demonstranten gehören, deren Reformsorgen würde man ernst nehmen, der SHB ist empört über den Verlauf der Aktuellen Stunde.","Kanzler: Rechtsstaat muss entschlossener verteidigt werden/ Lücke bedauert Kritik an der Berliner Polizei","","Kiesinger warnt vor unverzeihlicher Schwäche/ Aktuelle Stunde im Bundestag über Studentenunruhen","",[1],1,[1],[1],2,"12","1,2"],["3281","1968-02-10","Bericht über das Gespräch im ZDF zwischen Klaus Harpprecht und Axel Springer","Axel Springer: Wir haben kein \"Meinungsmonopol\"","","Dialog mit dem Verleger im Fernsehen","",[1],1,[1],[5],1,"12","6"],["3282","1968-02-10","Der Rektor der TU Berlin stellte im Ernst-Reuter-Haus Räume für das Springer-Hearing unter der Auflage, dass keine Springer-Aktien verkauft werden, zur Verfügung. Diese Auflage wurde nicht eingehalten. Peter Schneider wird zitiert, dass es nicht kriminell sei, wenn man aus Überzeugung Fensterscheiben der Filialen der Berliner Morgenpost einwirft.","Die Auflage von Neubauer wurde missachtet","","\"Hearing\"-Veranstalter hielten sich nicht an Zusicherung","M.M.",[10],1,[1],[1],1,"12","6"],["3283","1968-02-10","Ausschüsse der TU Berlin haben Vorschläge zum Hochschulgesetzentwurf erarbeitet, das Studentenparlament der TU lehnt diese Vorschläge ab, stattdessen verlangen sie ein Hearing zu diesem Thema.","Hochschulgesetz ein Stück weiter","","","",[4],1,[1],[2],2,"12","6"],["3284","1968-02-11","Die erste Sitzung zum satzungsgebenden Senat an der Universität Marburg musste abgebrochen werden.","Sitzung abgebrochen","Schnell informiert","","",[4],1,[1],[2],2,"64","1"],["3285","1968-02-11","Verzicht der Schüler und Studenten in Freiburg auf weitere Demonstrationen, solange über die Erhöhung der Straßenbahntarife neu verhandelt wird.","Kompromiß in Freiburg","Schnell informiert","","",[1],1,[1],[2],2,"64","1"],["3286","1968-02-11","Vergleiche der Studentenunruhen mit der SA, Lob für Axel Springers Interview im ZDF.","Nichts aus der Vergangenheit gelernt?","Leserbriefe","","Leser",[1],1,[6],[2],2,"64","2"],["3287","1968-02-11","Die Politik habe noch nicht das gesamte Ausmaß der Unruhen erfasst, die linksradikalen Studenten würden sich in einer Wechselwirkung mit der NPD gegenseitig stärken, sieht große Gemeinsamkeiten zwischen NPD und SDS, beide Feinde der Demokratie, um der NPD Einhalt zu gebieten, müsse man zuerst hart gegen den SDS vorgehen.","Der Linksmob hilft der NPD","","","Rudolf Stiege",[1],1,[5],[2],1,"64","2"],["3288","1968-02-11","Ausführlicher Bericht über die APO und ihre Trägergruppen, allerdings sei die APO nicht mehr außerparlamentarisch, sondern antiparlamentarisch, es müsste konsequenter gegen illegale Störungen vorgegangen werden, die SED versuche zumindestens bei den Protesten mitzuwirken. Die FU sei nicht der Hort des Radikalismus, es gäbe auch viele Insitute an der FU, die mit dem Protest nichts zu tun hätten, wie auch die große Mehrheit der Studenten. Ein Zentrum sei aber das Philosophische Seminar unter Professor Weischedel. Mehrere Professoren und Assistenten wie Gollwitzer, Taubes und Haug werden als Mentoren des Protests aufgeführt, Kritik, dass viele ehemalige SDSler im Max-Planck-Institut für Bildungsforschung eine Anstellung bekommen haben, Bericht über den Republikanischen Club.","Verschwörung gegen die Demokratie","Hintergründe der sogenannten außerparlamentarischen Opposition","","Walter Brückmann",[1],1,[1],[1],1,"64","12"],["3289","1968-02-13","Demonstration in Kiel gegen Fahrpreiserhöhungen.","Demonstration in Kiel","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["3290","1968-02-13","Demonstration in Heidelberg, bei der vor dem Amerikahaus Vietkong-Fahnen gehisst wurden.","Vietkong-Fahnen gehißt","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["3291","1968-02-13","Die CDU lehnt den SDS wegen dessen antidemokratischen Programms als Gesprächspartner ab.","SDS kein Gesprächspartner","Schnell informiert","","",[8],1,[1],[2],2,"12","1"],["3292","1968-02-13","Scharfe Kritik an den Studentenunruhen, Vergleiche mit der NS-Zeit, härteres Vorgehen gefordert, es gelte, die Demokratie zu retten.","Es geht nicht um \"Futterkrippen\"","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3293","1968-02-13","Demonstration in Wien gegen den Besuch des Schahs von Persien.","Proteste gegen den Schah","Kurz gemeldet","","",[1],1,[1],[2],2,"12","2"],["3294","1968-02-13","Bericht über den außerordentlichen Parteitag der Berliner SPD, Auseinandersetzungen zwischen rechtem und linkem Flügel, Bürgermeister Schütz wendet sich gegen die Studentenunruhen.","Schütz: Wenn wir nichts tun, werden wir davongejagt","","Sieg des \"rechten\" Flügels auf dem SPD-Parteitag","Go.",[1],1,[1],[1],2,"12","2"],["3295","1968-02-13","Ankündigung der nächsten Zeugenvernehmung des Parlamentarischen Untersuchungsausschusses zu den Studentenunruhen.","Sachverständige sagen aus","","","",[1],1,[1],[2],2,"12","5"],["3296","1968-02-13","Der Akademische Senat der FU Berlin beriet über seine Stellungnahmen zum Hochschulentwurf; der Konvent der Pädagogischen Hochschule fordert ein Mitspracherecht von Studenten bei der Studienreform.","Professoren tagten","","Entwurf zum Hochschulgesetz wurde beraten","MM.",[4],1,[1],[2],2,"12","5"],["3297","1968-02-14","Dr. René Ahlberg sagte vor dem Parlamentarischen Untersuchungsausschuss über den SDS aus, dieser würde die Abschaffung der parlamentarischen Demokratie anstreben, Hochschulreformen oder Springer-Kampagne seien dafür nur Mittel zum Zweck.","Sudienreform - 'Vehikel' für den Umsturzplan","","SDS-Taktik vor dem Untersuchungsauschuß","MM.",[1],1,[1],[1],1,"14","9"],["3298","1968-02-14","Keine Genehmigung für eine Demonstration im Anschluss an die Vietnam-Konferenz in der TU Berlin.","Der Senat bleibt dabei","","Vietnam-Demonstration werden nicht genehmigt","",[1],1,[1],[2],2,"14","9"],["3299","1968-02-14","Die drei Fraktionen des Berliner Abgeordnetenhauses wollen jeweils eigene Initiativgesetzentwürfe zur Hochschulreform einbringen.","Entwürfe zu Uni-Reform","","","",[4],1,[1],[2],2,"14","9"],["3300","1968-02-14","Der SHB kritisiert Minister Stoltenberg für seine Äußerung, dass er nicht mit dem SDS reden werde.","SHB übt Kritik an Stoltenberg","","","",[8],1,[1],[2],2,"14","9"],["3301","1968-02-14","Der SDS verteilte Flugblätter vor dem Münchener Arbeitsamt und rief zu einer Demonstration und einem Go-In auf, in Tübingen wurde Strafanzeige gegen ein SDS-Mitglied gestellt.","Demonstration in München geplant","","","",[1],1,[1],[2],2,"14","9"],["3302","1968-02-14","Die Bundesregierung sieht auf Anfrage vom FDP-Abgeordneten Borm keinen Anlass, den angekündigten Gottesdienstschutz von Offizieren zu missbilligen.","Bonn billigt Kirchenschutz","","","",[3],1,[1],[2],2,"14","9"],["3303","1968-02-14","Prof. Schelsky plädiert für eine Mitwirkung der Assistenten in den Selbstverwaltungsorganen der Universität.","Assistenten sollen mitwirken","","","",[4],1,[1],[2],2,"14","9"],["3304","1968-02-15","Der Berliner Senat warnt vor der Durchführung nicht genehmigter Demonstrationen, Hintergrund ist die geplante Demonstration nach dem Vietnamkongress. Bischof Scharf bietet sich als Vermittler an. Das Berliner Abgeordnetenhaus fordert den Senat auf, mit allen rechtsstaatlichen Mitteln gewalttätige Angriffe auf die freiheitlich demokratische Grundordnung zu verhindern, u.a. wird schärferes Demonstrationsverbot sowie ein Verbot des SDS gefordert. Dutschke kündigt Demonstration unter allen Umständen an.","Senat warnt vor Demonstration/ Kein generelles Verbot","","","Go.",[1],1,[1],[2],2,"18","1,14"],["3305","1968-02-15","Entwürfe der Fraktionen des Berliner Abgeordnetenhauses für ein neues Hochschulgesetz.","Nun Wettlauf der Parteien um neues Hochschulgesetz","","","",[4],1,[1],[2],2,"18","14"],["3306","1968-02-15","SDS-Demonstration in München, Gegendemonstration hätten SDS als Pestbeule der Demokratie bezeichnet.","SDS-Demonstration","","","",[1],1,[1],[2],2,"18","14"],["3307","1968-02-15","Publizisitik-Studenten kritisieren, dass die Berufungsverhandlung für den Nachfolger für Prof. Eberhard seit drei Jahren ergebnislos geblieben sind. Bei einer weiteren Verzögerung werden u.a. Vorlesungsstreiks angekündigt.","Publizisten der FU kritisieren","","","",[4],1,[1],[2],2,"18","14"],["3308","1968-02-16","Der SPD-Funktionär Gerull erhält Genehmigung für eine Vietnam-Demonstration unter der Auflage, dass der SDS daran nicht teilnehmen darf, weil Gewalttaten befürchtet werden. Horst Mahler beantragt weitere Demonstration. Die Humanistische Union erklärt, dass ein Verbot der Demonstration diese nicht verhindern könne. RCDS und das Studentenparlament sprechen sich für eine Genehmigung der Demonstration aus.","Doch Vietnam-Demonstration","","SPD-Funktionär ist Veranstalter - Polizei warnt vor Gewaltakten","",[1],1,[1],[2],2,"18","3"],["3309","1968-02-16","Bestimmte Pflichtübungen sind an der Philosophischen Fakultät und dem Otto-Suhr-Institut künftig freiwillig.","Wünsche der Studenten erfüllt","","","",[4],1,[1],[2],2,"18","3"],["3310","1968-02-16","Der Chefredakteur des FU-Spiegels bedauert eine Verunglimpfung des Regierenden Bürgermeisters Schütz in einer vorangegangenen Ausgabe.","Bedauert","","","",[1],1,[1],[2],2,"18","3"],["3311","1968-02-16","Der Vorsitzende des VDS, Haubold, erläuterte Vorstellungen zur Hochschulreform vor dem Wissenschaftsausschuss des Bundestages, erhielt Beifall. In Stuttgart gab es Demonstration gegen eine vorschnelle Verabschiedung eines neuen Hochschulgesetzes, dies sei noch nicht fortschrittlich genug.","Studentenvertreter erhielt Beifall der Abgeordneten","","Sachverständige äußerten sich zur Hochschulreform","",[4],1,[1],[1],1,"18","11"],["3312","1968-02-17","Der Regierende Bürgermeister Schütz bekräftigt Verbot der SDS-Demonstration und warnt alle davor, sich an solchen Veranstaltungen zu beteiligen. Er kündigt rigoroses Einschreiten gegen illegale Verantaltungen an. Begründet wird das Verbot damit, dass der SDS in dem letzten Monat wiederholt versucht habe, die demokratische Ordnung Berlins zu stören.","Schütz: Senat wird illegale Demonstrationen verhindern/ Berlin vor einem heißen Wochenende?","","Berliner sollen Polizei unterstützen - Keine Selbstjustiz/ DGB: Von illegalen Demonstrationen fernhalten","Go.",[1],1,[1],[1],2,"16","1,3"],["3313","1968-02-17","Die Mehrheit der Berliner SPD unterstützt Verbot der SDS-Vietnam-Demonstration; der dem linken Flügel zuzurechnende SPD-Funktionär Gerull will an seiner Demonstration jedoch festhalten. Harry Ristock beantragte weitere Vietnam-Demonstration, wurde abgelehnt.","Auch SPD für das Verbot","","\"SDS verfolgt antidemokratische Ziele\"","",[1],1,[1],[2],2,"16","1"],["3314","1968-02-17","Die Jungdemokraten der FDP präsentieren eigenen Entwurf für ein Hochschulgesetz.","Jungdemokraten gegen befristete Studienzeit","","","ndt.",[4],1,[1],[2],2,"16","7"],["3315","1968-02-17","Die bundesdeutschen Studentenunruhen würden in den Ostblockstaaten nur ein geringes Echo finden. Die Machthaber kritisieren das Verständnis vom Sozialismus der deutschen Studenten und befürchten wohl auch ein Überschwappen der Unruhen, die Studenten der Ostblockstaaten hätten konkretere materielle und berufliche Sorgen, hätten deshalb kein Verständnis für protestierende deutsche Studenten.","Linksradikale finden im Ostblock geringes Echo","","Studenten kommunistischer Länder haben andere Sorgen","Karl Rau",[1],1,[1],[1],2,"16","7"],["3316","1968-02-18","Das Berliner Verwaltungsgericht genehmigt die SDS-Vietnam-Demonstration unter der Auflage, dass man nicht zur amerikanischen Siedlung zieht. Der Regierende Bürgermeister Schütz appelliert weiterhin an die Bevölkerung, nicht daran teilzunehmen.","Schütz: Meidet den Aufmarsch der Vietnam-Demonstranten","","Gericht billigt Protestzug - Aber nicht zur US-Siedlung","Go.",[1],1,[1],[1],2,"70","1"],["3317","1968-02-18","Kritisiert die Entscheidung des Gerichts, die Vietnamdemonstration des SDS zu genehmigen, dies erinnere an die Selbstzerstörung der Weimarer Demokratie. Von der Demonstration seien Gewalttaten zu erwarten, Studenten wollen Berlin zu Saigon machen, alle Berliner werden sich von der Demonstration fern halten, aber auch von der Versuchung, Selbstjustiz zu üben. Dazu eine Karikatur, ein Demonstrant fragt einem im Stacheldraht hängenden Grenzflüchtling, ob er für den Vietkong ist.","Berlin darf nicht Saigon werden!","","","Rudolf Stiege",[1],1,[5,4],[2],1,"70","2"],["3318","1968-02-18","Bericht über die Internationale Vietnam-Konferenz, sei ohne Zwischenfälle abgelaufen, lediglich ein Rechtsanwalt wurde vom Mikrofon weggezerrt, die Referate hätten zum größten Teil in Angriffen gegen die USA, die Bundesrepublik und den Berliner Senat gegipfelt; SPD-Funktionär Gerull sagte seine Demonstration ab.","Auf der TU-Bühne fehlten die Stars","","Parole: Es ist Pflicht, Revolution zu machen!","",[1],1,[1],[1],1,"70","3"],["3319","1968-02-18","Zweite Fassung des Berichts über die Internationale Vietnam-Konferenz, neu ist die Wiedergabe vom Inhalt der Rede Peter WeißŽ","Weiss ruft Genossen zur Sabotage auf","","Parole: Es ist Pflicht, Revolution zu machen!","",[1],1,[1],[1],1,"70","3"],["3320","1968-02-20","Ankündigung der Großkundgebung \"Berlin steht für Frieden und Freiheit\" am 21.2.1968 als Gegendemonstration zur Vietnamdemonstration.","Morgen demonstriert Berlin für Frieden und Freiheit","","Schütz ruft zur Kundgebung vor dem Rathaus Schöneberg","Go.",[1],1,[1],[1],1,"14","1"],["3321","1968-02-20","Antrag innerhalb der Berliner SPD für den Ausschluss jener SPD-Mitglieder, die an der Vietnamdemonstration des SDS teilgenommen hatten, darunter Harry Ristock. Der SPD-Landesvorstand missbilligte die Teilnahme.","Ausschluß von Ristock aus der SPD beantragt","","","LUK",[1],1,[1],[5],2,"14","1"],["3322","1968-02-20","Der SDS erhält von einigen Bundesländern für Zwecke der politischen Bildung Mittel aus Steuergeldern, aus Bundesmitteln wird er seit 1960 nicht mehr gefördert, wogegen der SDS klagt.","Steuerzahler finanzieren SDS","","","",[8],1,[1],[2],2,"14","1"],["3323","1968-02-20","Scharfe Kritik an der Gerichtsentscheidung, die Vietnamdemonstration zu genehmigen. Den Demonstranten ginge es nicht um Vietnam, sondern nur um die Beseitigung der demokratischen Ordnung in Berlin.","Demokratische Ordnung in Gefahr","Leserbreife","","Leser",[1],1,[6],[2],2,"14","2"],["3324","1968-02-20","In Bad Godesberg beraten die westdeutschen Rektoren u.a. die Hochschulreform.","Rektoren beraten Hochschulreform","","","",[4],1,[1],[3],2,"14","2"],["3325","1968-02-20","Die Vietnamdemonstration sei zwar überwiegend friedlich verlaufen, allerdings hätte es mehrfach am seidenen Faden gehangen, ob sich nicht doch eine Straßenschlacht entwickelt. Auch künftig müsse man jede Demonstration, \"die von den Kommunisten oder ihren Strohmännern\" betrieben wird, als potentiellen Aufruhr gegen die staatliche Ordnung sehen. Zudem wird um die Teilnahme bei der Großkundgebung des Berliner Senats geworben, dies sei ein Ausdruck dafür, dass die Mehrheit der Berliner Bevölkerung die Studentenunruhen missbilligen und sich zur Solidarität mit der amerikanischen Schutzmacht bekennen würden. Die SPD-Teilnehmer der Vietnamdemonstration um Ristock werden scharf kritisiert.","Für Freiheit gegen Chaos","","","Rudolf Stiege",[1],1,[5],[2],2,"14","2"],["3326","1968-02-20","Ankündigung der Anhörung von Mitgliedern des SDS vor dem Parlamentarischen Untersuchungsausschuss","SDS-Mitglieder werden gehört","","","",[1],1,[1],[2],2,"14","3"],["3327","1968-02-20","Bericht über die Vietnamdemonstration, diese sei weitestgehend diszipliniert verlaufen. Der SPD-Abgeordnete Zehden wird zitiert, wie er die Demonstranten Totengräber der Demokratie und antidemokratische Kräfte nennt. Erwähnt werden zwei Gegendemonstrationen mit Parolen wie Teufel zur Hölle und Dutschke raus aus West-Berlin.","Vietkong-Fahnen wurden auf der Straße verbrannt","","Demonstration und Gegendemonstration verliefen diszipliniert","",[1],1,[1],[1],1,"14","6"],["3328","1968-02-21","Die geladenen Mitglieder des SDS, u.a. Dutschke, verweigerten vor dem Parlamentarischen Untersuchungsausschuss die Aussage und wurden deshalb mit Geldstrafen belegt. Parlamentspräsident Sickert wurde als Sozialfaschist beschimpft, dieser bezeichnete den Auftritt des SDS als \"Demonstration der Dummheit\".","SDS-Führer zu Geldbußen verurteilt","","","MM.",[1],1,[1],[2],2,"12","1"],["3329","1968-02-21","Aufruf zur Großkundgebung \"Berlin steht für Freiheit und Frieden\" des Berliner Senats, hier würde sich das freie Berlin versammeln. Die FDP stellt keinen Redner, da in einem ersten Aufruf die Mitinitiatorenschaft William Borms bemängelt wurde, der zugleich Mitglied im Republikanischen Club ist.","Was Berlin denkt, will es heute vor aller Welt kundtun","","Treffpunkt: 16 Uhr 30 vor dem Rathaus Schöneberg","Go.",[1],1,[1],[1],1,"12","1"],["3330","1968-02-21","Kritik an der Entscheidung des Gerichts, die Vietnamdemonstration zu genehmigen. Kritik am SDS und an Prof. Gollwitzer, der sich gegen ein Verbot des SDS ausgesprochen hat.","Demonstration im Grunewald","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3331","1968-02-21","Aufruf für die Großkundgebung des Berliner Senats, die Berliner werden geschlossen gegen den SDS und seine Sympathisanten, gegen die Untergrabung der Lebensfähigkeit West-Berlins, stehen. Der SDS habe vor dem Parlamentarischen Untersuchungsausschuss gezeigt, dass er dumm ist, da er die Chance nicht nutzte, seine Motive zu offenbaren. Dies zeige auch, dass es dem SDS nicht um das Elend in Vietnam oder der 3. Welt gehe, sondern nur um die Zerstörung der parlamentarischen Demokratie. Die Kommunisten seien schon unter uns.","Der SDS steht allein","","","Rudolf Stiege",[1],1,[5],[2],2,"12","2"],["3332","1968-02-21","Offener Brief von 129 Studenten der Berliner Universitäten und der Pädagogischen Hochschule, sie verwehren sich gegen eine Gleichsetzung mit einer radikalen Studentenminderheit, distanzieren sich von Krawallen etc., bekennen sich zum Grundgesetz und fordern Hochschulreformen.","Reformen ja - Krawalle nein","","","",[1],1,[1],[2],2,"12","3"],["3333","1968-02-21","Werbung für die Großkundgebung des Berliner Senats, Sonderfahrten der BVG.","Sternfahrten zum Rathaus","","BVG und Polizei sind jedem Ansturm gewachsen","",[1],1,[1],[2],2,"12","3"],["3334","1968-02-21","Aussageverweigerung von sechs geladenen SDS-Mitgliedern vor dem Parlamentarischen Untersuchungsausschuss, darunter Dutschke, Levèfre, Semler. Geldstrafen für die Aussageverweigerung, Dutschke bezeichnete Wohlrabe als exemplarischen Faschisten.","Funktionäre des SDS verweigerten die Aussage","","Geduldsprobe im Parlamentarischen Untersuchungsausschuß","M.M.",[1],1,[1],[1],2,"12","5"],["3335","1968-02-22","Bericht über die Großkundgebung des Berliner Senats, diese sei eine machtvolle Kundgebung des freien Berlin gegen radikale Störer gewesen. Wiedergabe von Teilen der Reden.","150000 Berliner gaben die Antwort/ \"Freiheit und Ordnung sind unteilbar\"","","Eine klare Absage an die radikalen Extremisten/ Randalierer zeigten nicht das wahre Berlin","Go.",[1],1,[1],[1],1,"16","1,3"],["3336","1968-02-22","Der Beschluss des Verwaltungsgerichts wird begrüßt, er zeuge von der Demokratie in West-Berlin, Studenten seien auch nicht vorschnell als Störer zu bezeichnen, wie die friedliche Demonstration gezeigt habe. In anderen Leserbriefen Kritik an der Demonstration und vor allem an der Teilnahme von SPD-Politikern um Ristock.","Zum Beschluß des Verwaltungsgerichts","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3337","1968-02-22","Die Großkundgebung sei ein Zeichen des Geistes Berlins gewesen, das von linksextremistischen Revoluzzern beschmutzte Bild der Stadt sei wieder begradigt worden. Scharfe Kritik an den SPD-Mitgliedern um Ristock. Kurz wird das gewalttätige Verhalten einiger Demonstranten bedauert.","Der Geist Berlins ist wach und fest","","","Rudolf Stiege",[1],1,[5],[2],2,"16","2"],["3338","1968-02-22","Es wird von mehreren Störaktionen während der Großkundgebung berichtet, u.a. Flugblätter gegen den Krieg in Vietnam und gegen die Großkundgebung.","Viele Störaktionen","","","",[1],1,[1],[2],2,"16","3"],["3339","1968-02-22","Kritik an den gewalttätigen Ausschreitungen einiger Demonstranten gegenüber vermeintlichen Studenten, Schilderung von Auseinandersetzungen.","\"Wir wollen kein zweites 1933\"","","","L.R.",[1],1,[1],[2],2,"16","3"],["3340","1968-02-22","33 Personen mussten während der Großkundgebung in Verwahrung genommen werden, teilweise zum Schutz vor gewalttätigen Angriffen von Demonstranten. 25 Personen erlitten Verletzungen.","22 Verletzte bei Schlägereien","","","",[1],1,[1],[2],2,"16","3"],["3341","1968-02-22","II. Fassung des Artikels aus dem Datensatz 3340 zur Großkundgebung des Berliner Senats, leichte Änderungen.","Verletzte durch Schlägereien","","","",[1],1,[1],[2],2,"16","3"],["3342","1968-02-23","Positive Äußerungen zur Großkundgebung des Senats seitens Politiker und der US-amerikanischen Presse, Schütz bezeichnet protestierende Studenten als Terroristen, wehrt sich gegen den Vorwurf der Pogrom-Hetze durch die Kundgebung.","Schütz: Platz für jede politische Meinung","","Echo auf Berliner Kundgebung","",[1],1,[1],[2],2,"16","1"],["3343","1968-02-23","Prüfung der Einleitung von Disziplinarverfahren gegen SPD-Mitglieder um Ristock, schwere Kritik an diesen.","Verfahren gegen zwei Bezirksstadträte?/ CDU: \"So machen wir unsere Demokratie kaputt\"","","Debatte über die Bezirksstadträte Ristock und Beck","Go.",[1],1,[1],[5,1],2,"16","1,2"],["3344","1968-02-23","Bericht über die Westdeutsche Rektorenkonferenz in Bad Godesberg, diese wolle vor allem künftig die Unabhängigkeit der Assistenten stützen. Man sprach sich gegen die studentische Forderung einer Drittelparität aus.","Neue Stellung für Hochschulassistenten","","","",[4],1,[1],[2],1,"16","2"],["3345","1968-02-23","Umfrage zur Beurteilung der Studentenunruhen durch die West-Berliner Bevölkerung, deren Einstellung hätte sich seit dem 2. Juni 1967 nicht verhärtet oder geändert.","Meinung über Studenten hat sich nicht verhärtet","","Jeder vierte Berliner ist zur Diskussion bereit","LUK",[1],1,[1],[2],2,"16","2"],["3346","1968-02-23","Entwürfe der CDU- und SPD-Fraktionen des Berliner Abgeordnetenhauses für ein neues Hochschulgesetz.","Künftig Präsident statt Magnifizienz","","Entwürfe von CDU und SPD für das Universitätsgesetz","LUK",[4],1,[1],[1],1,"16","6"],["3347","1968-02-23","Prof. Stammer und Prof. Fraenkel sagten vor dem Parlamentarischen Untersuchungsausschuss aus, Stammer nennt Studentenbewegung soziale Bewegung, der man mit autoritären Mitteln nicht Herr werden könne. Die Bewegung werde jedoch auch zunehmend intolerant und habe ein romantisch-utopisches Konzept. Beide Professoren wiesen auf die Wichtigkeit der Assistentenfrage hin. Zu Beginn wurde das SDS-Mitglied Nitsch während seiner Befragung mit Ordnungsstrafen belegt.","\"Viele schwimmen im Sog des SDS mit\"","","Professoren vor dem Ausschuß","Michael L. Müller",[1],1,[1],[1],1,"16","7"],["3348","1968-02-24","Bericht vom Prozess gegen Fritz Teufel, dieser wurde zu zwei Monaten Haft ohne Bewährung verurteilt. Mitangeklagt war Peter Urbach. Teufel habe im Gerichtssaal eine Schau abgezogen.","Gefängnis für Kommunarden Teufel","","","",[5],1,[1],[2],2,"12","6"],["3349","1968-02-24","Störung der Geschwister-Scholl-Gedenkfeier an der Universität München durch Studenten.","SchwereTumulte bei Scholl-Gedenkfeier","","Bitte des Vaters der Hingerichteten mißachtet","",[1],1,[1],[1],1,"12","12"],["3350","1968-02-25","Über die Störung der Geschwister-Scholl-Gedenkfeier an der Universität München; die Ausschreitungen bei der Großkundgebung seien laut der Aktion Demokratisches Berlin teilweise provoziert worden, der Arbeitskreis Evangelischer und Katholischer Jugend rügte in einem Brief an Innenminister Neubauer diese Gewalttaten.","Grüber: Beschämend","","Brief an den Vater der Geschwister Scholl","",[1],1,[1],[2],2,"64","1"],["3351","1968-02-25","Verteidigung der Großkundgebung gegen die Gleichsetzung mit dem NS, vergleicht stattdessen die Studentenunruhen mit Methoden des Nationalsozialismus.","Eine notwendige Klarstellung","Leserbriefe","","Leser",[1],1,[6],[2],2,"64","2"],["3352","1968-02-25","Die Neue Zürcher Zeitung zieht Vergleich zwischen den Forderungen auf dem Internationalen Vietnamkongress und dem Karlsbader Kommunistentreffen von 1967, beide wollen die Zerschlagung der NATO.","\"Agitation im Sinne der Kommunisten\"","","","",[1],1,[1],[2],2,"64","2"],["3353","1968-02-27","Vor dem SPD-Bundesparteitag werden zunächst keine Konsequenzen gegen Ristock und Beck wegen ihrer Beteiligung bei der Vietnamdemonstration ergriffen. Es wurde jedoch eine Untersuchungskommission eingesetzt. Dazu eine Karikatur. II. Fassung mit leichter Ergänzung.","Gnadenfrist für Beck und Ristock vom SPD-Vorstand","","Kein sofortiger Parteiausschluß","Go.",[1],1,[1,5,4],[1],1,"14","1,2"],["3354","1968-02-27","Den SDS-Mitgliedern, die vor dem Parlamentarischen Untersuchungsausschuss ihre Aussage verweigerten und mit Ordnungsstrafen belegt wurden, droht bei weiter Nichtzahlung eine Erhöhung der Strafe oder auch ersatzweise Haft.","SDS-Führern droht Haft","","","",[1],1,[1],[2],2,"14","2"],["3355","1968-02-27","Kritik an Beck und Ristock sowie an der Störung der Gedenkfeier für die Geschwister Scholl. Ristock und Beck werden als Kommunisten bezeichnet.","Beck, Ristock und andere","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3356","1968-02-29","Franz-Josef Strauß sieht keine Berechtigung für einen Radikalismus, wie er Deutschland in den 30er Jahren beherrscht habe. Der CSU-Bundestagsabgeordnete Unertl bezeichnete die demonstrierenden Studenten als Rotzlöffel, Dutschke bezeichnete er als \"ungewaschene, verlauste und verdreckte Kreatur\".","Strauß zum Thema Radikalismus","","","",[1],1,[1],[2],2,"20","2"],["3357","1968-02-29","Die Staatsanwaltschaft Amsterdam ermittelt gegen Dutschke, weil der Prinz Claus als Faschisten bezeichnet hat.","Anzeige gegen Dutschke","Kurz gemeldet","","",[1],1,[1],[2],2,"20","2"],["3358","1968-02-29","Teufel, Langhans und Kunzelmann lehnen Angebot eines Bremer Pastors ab, wegen der Situation in Berlin nach Bremen umzuziehen, der Hass der Berliner halte sie in Berlin.","Kommunarden bleiben","Kurz gemeldet","","",[5],1,[1],[2],2,"20","2"],["3359","1968-02-29","Debatte in der SPD über die Beteiligung einiger Mitglieder um Ristock bei der Vietnamdemonstration.","Scharfe Mißbilligung","","Vietnam-Demonstration zieht immer weitere Kreise","",[1],1,[1],[2],2,"20","2"],["3360","1968-03-01","Bundeskanzler Kiesinger und Berlins Regierender Bürgermeister Schütz sprechen sich gegen die jüngsten Unruhen aus. Kiesinger unterscheidet zwischen den Studenten und ihrer berechtigten Unruhe, für die man Verständnis haben müsse, und destruktiven Kritikern.","Kiesinger gegen ständige Verleumdung des Staates","","Auch Schütz erteilt radikalen Minderheiten eine Absage","",[1],1,[1],[1],2,"24","1"],["3361","1968-03-01","Die Antipathie der Bevölkerung richte sich nicht gegen die Studenten und die Hochschulreform, sondern nur gegen gewisse Rädelsfüher. Hier werden Vergleiche zur NS-Zeit gezogen.","Die Bevölkerung kann differenzieren","Leserbriefe","","Leser",[1],1,[6],[2],2,"24","2"],["3362","1968-03-01","In Kiel laufen 240 Ermittlungsverfahren im Zuge der Demonstrationen gegen die Fahrpreiserhöhungen.","240 Ermittlungsverfahren","Kurz gemeldet","","",[1],1,[1],[2],2,"24","2"],["3363","1968-03-01","Kundgebung und Demonstration in Frankfurt/Main gegen den Vietnamkrieg, Martin Niemöller als Redner, der Demokratische Club fordert, dass gegen alle Kriege und das Unrecht an der deutsch-deutschen Grenze und nicht nur gegen den Krieg in Vietnam demonstriert werden muss. Der \"SDS-Ideologe\" Rudi Dutschke wurde kurzfristig in Frankfurt festgenommen, wegen befürchteter Ausschreitungen jedoch wieder freigelassen.","Gegen alle Kriege protestieren!","","","",[1],1,[1],[2],2,"24","2"],["3364","1968-03-01","Für Bundesforschungsminister Stoltenberg sind die Forderungen nach Hochschulen bei den linksradikalen Gruppen nur Vorwand für eine antidemokratische Revolution. Ein früherer DGB-Funktionär weist den Vorwurf zurück, dass die Großkundgebung des Senats faschistoide Züge gehabt habe. Vielmehr seien die Kungebungsteilnehmer durch Linksradikale provoziert worden.","Stoltenberg kontra SDS","","","",[4],1,[1],[2],2,"24","13"],["3365","1968-03-02","Berlins Regierender Bürgermeister Schütz hält weitere Zusammenstöße mit linksradikalen Kreisen durch die Berliner Großkundgebung des Senats vorerst für gebannt.","Schütz hält Gefahr fürs erste gebannt","","","",[1],1,[1],[2],2,"16","1"],["3366","1968-03-03","Der Berliner Senat hat nur Teile der Empfehlung des Parlamentarischen Untersuchungsausschusses zu den Vorfällen am 2. Juni 1967 befolgt.","Drei mußten gehen und einer blieb","","Senat folgte nicht allen Ausschuß-Empfehlungen","D. Goos",[1],1,[1],[1],1,"70","3"],["3367","1968-03-03","Ankündigung der Prozessfortsetzung gegen Teufel und Langhans wegen der Aufforderung zur lebensgefährlichen Brandstiftung (Flugblätter der Kommune I zum Brüsseler Kaufhausbrand)","Immer wieder Teufel","","Hochbetrieb in den Moabiter Gerichtssälen","M.K.",[5],1,[1],[2],2,"70","5"],["3368","1968-03-05","Bericht über den ersten Tag der Prozessfortsetzung gegen Teufel und Langhans wegen der Aufforderung zur lebensgefährlichen Brandstiftung (Flugblätter der Kommune I zum Brüsseler Kaufhausbrand).","Teufel wie gehabt","","","",[5],1,[1],[2],2,"16","6"],["3369","1968-03-05","Berlins Regierender Bürgermeister Schütz kritisiert die Übergriffe auf der Großkundgebung des Berliner Senats gegen vermeintliche linke Studenten, ruft zur Toleranz auf, kritisiert zugleich die einseitige Parteinahme auf Seiten der demonstrierenden Studenten im Vietnamkrieg.","Schütz ruft zu Toleranz auf","","","",[1],1,[1],[2],2,"16","6"],["3370","1968-03-05","Bericht über die ordentliche Mitgliederversammlung des VDS, einige Verbände melden Bedenken wegen des politischen Engagements des VDS an.","Uni Würzburg verließ VdS","","","",[4],1,[1],[2],2,"16","6"],["3371","1968-03-06","Bericht über die ordentliche Mitgliederversammlung des VDS.","VdS brüskiert Landesregierung","","Empfang in der bayerischen Staatskanzlei boykottiert","Walter Brückmann",[4],1,[1],[3],2,"14","2"],["3372","1968-03-07","Kritik und Unverständnis für Studentenunruhen, sei auch keine kleine Minderheit, sondern eine Mehrheit, dieser ginge es nur um die Zerstörung der Demokratie.","Die Grenzen sind überschritten","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3373","1968-03-07","Berlins Regierender Bürgermeister Schütz weist den Vorwurf von Günter Grass und weiteren 127 Unterzeichnern zurück, dass die Berliner Großkundgebung eine Pogromstimmung geschaffen hätte.","\"Unbegründete Erregung\"","","Schütz weist Angriffe auf den Senat zurück","",[1],1,[1],[2],2,"16","2"],["3374","1968-03-07","Kritik am Berliner Senat von Bucerius, Grass und Heinz Brandt. Bucerius bezeichnet als einen Mann, der keine Gewalt wolle.","Kritik eines \"absolut Fremden\"","","","",[1],1,[1],[2],2,"16","2"],["3375","1968-03-08","Bericht über die ordentliche Mitgliederversammlung des VdS.","VDS: Keine Hilfe bei Berlin-Fahrten","","","",[4],1,[1],[2],2,"24","2"],["3376","1968-03-08","SHB und FDJ wollen sich am 10. April in Bonn zu neuen Gesprächen treffen.","Neues Gespräch mit FDJ","Kurz gemeldet","","",[9],1,[1],[2],2,"24","2"],["3377","1968-03-08","Der baden-württembergische Landtag hat das neue Hochschulgesetz angenommen. Vor dem Landtag protestierten Studenten gegen das Gesetz. In Hamburg demonstrierten Ingenieursstudenten vor dem Rathaus gegen die Einstufung als berufliche Ausbildung anstatt zum Hochschulbereich gezählt zu werden.","Erweiterte Mitsprache","","","",[4],1,[1],[2],1,"24","9"],["3378","1968-03-09","Leserbrief aus den USA, in dem sich für die Großkundgebung des Berliner Senats und die Sympathiekundgebungen der Berliner Bevölkerung für die USA bedankt wird.","Dank aus Amerika","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3379","1968-03-09","Prozeß einer Studentin gegen die Polizei wegen mehrfacher Schläge mit Schlagstöcken.","Prozeß um Ereignisse am 2. Juni auf der langen Bank","","Einsatz von Schlagstöcken unterliegt alliiertem Vorbehalt","M. L. Müller",[1],1,[1],[1],2,"14","5"],["3380","1968-03-09","Anklage gegen drei Polizisten wegen Körperverletzung im Amt, begangen am 2. Juni 1967. Wegen den Vorfällen am gleichen Tag wurde auch ein Arzt wegen unterlassener Hilfestellung sowie vier Studenten und ein Medizinalassistent u.a. wegen Aufruhrs angeklagt.","Anklage gegen drei Polizisten","","","",[1],1,[1],[2],2,"14","5"],["3381","1968-03-09","Bericht über die Mitgliederversammlung des VdS. Insbesondere die Berliner Delegierten, die klar links seien, würden die Versammlung dominieren. Auch die konservativen und rechten Delegierten würden sich zum politischen Mandat und zur anti-amerikanischen Haltung bekennen. Es wird die Gefahr konstatiert, dass der VdS nur noch am Gängelband des SDS zur Umwälzung der Gesellschaft hängen würde.","Beherrscher der Tagung: Die Berliner Delegierten","","Politisierung der Studentenschaft auf der VDS-Tagung","Walter Brückmann",[4],1,[1],[1],1,"14","7"],["3382","1968-03-10","Die Großkundgebung des Berliner Senats wird verteidigt und kritisiert, der Frankfurter Rundschau wird falsche Berichterstattung über die Kundgebung vorgeworfen.","Falsche Berichterstattung","Leserbriefe","","Leser",[1],1,[6],[2],2,"70","2"],["3383","1968-03-10","Bericht über die Studentenunruhen in Italien, es ist die Rede von den Turiner Dutschkes und den Linksfaschisten, teilweise seien die Proteste aber auch berechtigt.","Kommunistische Partei wird links überholt","","Hintergründe der Studentenunruhen in Italien","Azio de Franciscis",[1],1,[1],[1],2,"70","2"],["3384","1968-03-10","Bericht über die Mitgliederversammlung des VdS. Mehrere Universitäten haben ihren Austritt aus dem VdS angekündigt, Grund sei die Politisierung und Vietnamerklärung des VdS. Der Berichterstatter kritisiert den Austritt, da so den linken Verbänden das Feld überlassen wird.","Austritt aus dem VDS erklärt","","","",[4],1,[1],[2],2,"70","2"],["3385","1968-03-12","Eine Meinungsfrage habe ergeben, dass die große Mehrheit der Berliner Bevölkerung die Großkundgebung des Senats gebilligt habe. Zahlen zu den Einschätzungen der Studentenunruhen in der Berliner Bevölkerung.","Berliner urteilen abgewogen","","","LUK",[1],1,[1],[2],2,"16","1"],["3386","1968-03-12","FDP lud Studentenvertreter zur Anhörung über Notstandsgesetzgebung. Mit Ausnahme des RCDS lehnten alle Verbände eine solche Gesetzgebung ab, sahen aber bis auf den SDS eine Verbesserung im Entwurf der FDP.","Studenten gegen Notstandsvorsorge","","","Erd.",[1],1,[1],[2],2,"16","2"],["3387","1968-03-12","Bericht über den Prozess gegen Teufel wegen der Aufforderung zur lebensgefährlichen Brandstiftung (Flugblätter der Kommune I zum Brüsseler Kaufhausbrand).","Diesmal kam Teufel im Frack","","","M. K.",[5],1,[1],[2],2,"16","5"],["3388","1968-03-12","Kritik an Beck und Ristock wegen ihrer Teilnahme an der Vietnamdemonstration; Kritik an der evangelischen Kirche, die Rudi Dutschke einen Raum für einen Vortrag zur Verfügung stellt.","Was muß erst geschehen?","Leserbriefe","\"Ristock und Beck sollten den Hut nehmen\"","Leser",[1],1,[6],[2],2,"16","7"],["3389","1968-03-12","Bericht über die Mitgliederversammlung des VDS. Der neue Voritzende Ehmann kündigte einen heißen Sommer mit wachsenden Studentenunruhen an, man forderte die geistige Revolution und die Revolution als Mittel der Demokratisierung.","VDS: Geistige Revolution","","","",[4],1,[1],[2],2,"16","8"],["3390","1968-03-13","Die Jungsozialisten kritisieren den VdS für seine Beschlüsse auf der Mitgliederversammlung.","Jungsozialisten kritisieren VDS","","","",[4],1,[1],[2],2,"14","2"],["3391","1968-03-13","Mehrere Studentenverbände erklären sich solidarisch mit den demonstrierenden Studenten in Polen, darunter auch der SHB und der SDS.","Solidarisch mit Polens Studenten","","","",[1],1,[1],[2],2,"14","2"],["3392","1968-03-13","Rudi Dutschke wird u.a. wegen Landfriedensbruch im Zuge des Prozesses gegen Fritz Teufel vom 27.11.1967 angeklagt. Anklage auch gegen zehn weitere Studenten, namentlich erwähnt wird nur Peter Brandt.","Anklage gegen Rudi Dutschke","","","K. G.",[1],1,[1],[2],2,"14","5"],["3393","1968-03-13","Rektor und Senat der FU Berlin kritisieren in ihrer Stellungnahme den Entwurf von Senator Stein für ein neues Hochschulgesetz.","\"Steins Entwurf schränkt die Autonomie zu sehr ein\"","","Kritik von Rektor und Senat der Freien Universität","MM.",[4],1,[1],[1],2,"14","11"],["3394","1968-03-14","Solidaritätsmarsch für die demonstrierenden polnischen Studenten seitens der APO, namentlich genannt wird Peter Brandt.","Solidaritätsmarsch für Polens Studenten","","","MM.",[1],1,[1],[2],2,"18","2"],["3395","1968-03-15","Austritt der Uni Karlsruhe aus dem VdS.","Uni Karlsruhe verließ VDS","Kurz gemeldet","","",[4],1,[1],[2],2,"28","2"],["3396","1968-03-15","Kritik an den Studentenunruhen, diese Krawalle überschreiten das Maß der Demokratie, müssten verboten werden.","Was heißt Demokratie?","Leserbriefe","","Leser",[1],1,[6],[2],2,"28","2"],["3397","1968-03-17","Kritik an einer Veranstaltung mit Mahler und Lefèvre in Kirchenräumen in Berlin.","Berechtigte Kritik","Leserbriefe","","Leser",[1],1,[6],[2],2,"72","2"],["3398","1968-03-19","Bericht vom Prozess gegen Teufel und Langhans, auch der vierte Gutachter spricht sie vom Vorwurf der Aufforderung zur Brandstiftung frei, konstatiert aber Geltungssucht bis hin zu abnormer Persönlichkeit.","Teufel und kein Ende","","Mediziner spricht von abnormer Persönlichkeit","",[5],1,[1],[2],2,"20","6"],["3399","1968-03-19","Erneut wurde eine Scheibe einer Filiale der Berliner Morgenpost eingeworfen. Es werde geprüft, ob ein Zusammenhang mit den Beschädigungen im Februar besteht. Keine direkte Verdachtnahme der linken Studentengruppen.","Wieder Anschlag auf Morgenpost-Filiale","","","",[10],1,[1],[2],2,"20","6"],["3400","1968-03-19","Körperliche Übergriffe auf Wehner und Brandt und Demonstrationen auf dem SPD-Parteitag in Nürnberg. Der SHB distanziert sich von den Vorfällen. Brandt bezeichnet die Randalierer als Pöbel. Das Kuratorium Notstand der Demokratie meint, dass die Übergriffe nur wegen mangelnder Diskussionsbereitschaft und vorangegangenen Schlägen der Fahrer von Wehner und Brandt geschehen seien.","Scharfe Proteste gegen die Krawalle in Nürnberg ","","Jugendliche Rowdys schlugen auf Brandt und Wehner ein","",[1],1,[1],[1],1,"20","13"],["3401","1968-03-20","Schäden und Verunreinigung der Räume des Internationalen Vietnam-Kongresses in der TU Berlin sollen von den Studenten bezahlt werden. Aufzählung der Schäden.","Studenten werden zur Kasse gebeten","","Schäden in der TU nach dem Vietnam-Kongreß","M. L. Müller",[1],1,[1],[1],2,"18","3"],["3402","1968-03-20","Etwa 50 Demonstranten müssen im Zuge der Ausschreitungen auf dem SPD-Parteitag in Nürnberg mit Anzeigen rechnen. Die Polizei weist Presseberichte zurück, nach denen Wehner und Brandt von den Demonstranten geschlagen wurden.","Anzeigen gegen 50 Randalierer","","","",[1],1,[1],[2],2,"18","10"],["3403","1968-03-20","Bericht über den SPD-Parteitag in Nürnberg, kurz wird erwähnt, dass ein bärtiger Journalist von den Ordnern zunächst für einen Demonstranten gehalten und ihm deshalb der Zutritt verwehrt wurde. Nach Klärung der Lage wurde er von Polizisten in die Halle begleitet, die Demonstranten hätten nun gedacht, einer von ihnen werde abgeführt. Die Demonstranten werden als extremistischer Pöbel bezeichnet.","Die jungen Damen bleiben unnahbar","","Streiflichter vom SPD-Parteitag in Nürnberg","Rudolf Stiege",[1],1,[1],[1],1,"18","10"],["3404","1968-03-21","Scharfe Kritik an den Studentenunruhen, das seien intolerant fanatisierte Jugendliche. Die Studentschaft müsse sich von den kriminellen Rabauken distanzieren, sonst sinke das Ansehen der Studenten in der Bevölkerung weiter.","Ist der Berliner kritiklos?","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3405","1968-03-21","Laut Minister Stoltenberg sei mit der Abwanderung zahlreicher Professoren in die USA zu rechnen, wenn die Studentenunruhen weiter anhalten würden.","Professoren weichen dem Radikalismus","","","Erd.",[1],1,[1],[2],2,"16","8"],["3406","1968-03-21","Kritik des VDS an der SPD, weil diese den VdS nicht auf ihrem Parteitag in Nürnberg sprechen ließe und auch nicht eingeladen habe.","VDS will vor dem Parteitag sprechen","","","",[4],1,[1],[2],2,"16","8"],["3407","1968-03-22","Die FU Berlin erwirkte vor dem Hamburger Oberlandesgericht eine Gegendarstellung im \"Spiegel\". Hintergrund war ein Artikel über das Go-In während der Sitzung der Philosophischen Fakultät.","FU erwirkt Gegendarstellung","","","",[1],1,[1],[2],2,"24","2"],["3408","1968-03-22","Bericht vom Prozess gegen Teufel und Langhans (Flugblätter der Kommune I zum Kaufhausbrand in Brüssel). Der Staatsanwalt forderte neun Monate Haft ohne Bewährung, die Verteidigung um Mahler fordert Freispruch.","Gefängnis für Kommunarden?","","","M.K.",[5],1,[1],[2],2,"24","5"],["3409","1968-03-23","Teufel und Langhans wurden vom Vorwurf der Aufforderung zur menschengefährdenden Brandstiftung freigesprochen. Urteil des Richters. Neue Anklagen gegen Teufel, Langhans und weitere Kommunarden wegen Hausfriedensbruchs.","\"Objektiv schuldig\"","","Teufel und Langhans wurden freigesprochen","M.K.",[5],1,[1],[2],2,"14","6"],["3410","1968-03-24","Demosntration vor dem Berliner Amerika-Haus","Demonstranten vor dem Amerika-Haus","","","MM.",[1],1,[1],[2],2,"68","11"],["3411","1968-03-24","Kritik und auch Verteidigung der Studenten","Denk ich an Deutschland?","Leserbriefe","Berliner besitzen Urteilsfähigkeit","Leser",[1],1,[6],[2],2,"68","11"],["3412","1968-03-26","Der VDS will entscheiden, ob sein Vorsitzender Ehmann den Posten behalten kann. Erst kürzlich war bekannt geworden, dass Ehmann 1965 zu einem Monat Haft mit Bewährung verurteilt worden war.","Wirbel um den VDS-Vorsitzenden","","","",[4],1,[1],[2],2,"14","2"],["3413","1968-03-26","Die Rektoren der FU und TU Berlin nahmen vor dem Parlamentsausschuss für Wissenschaft und Kunst Stellung zu Fragen des neuen Universitätsgesetzes.","\"Für uns ein Sprung ins kalte Wasser\"","","Rektoren von FU und TU zu Fragen des neuen Universitätsgesetzes gehört","MM.",[4],1,[1],[2],2,"14","5"],["3414","1968-03-27","Der VDS-Vorsitzende Ehmann darf seinen Posten behalten, obwohl er 1965 zu einem Monat Haft auf Bewährung verurteilt worden war.","Ehmann bleibt","Schnell informiert","","",[4],1,[1],[2],2,"16","1"],["3415","1968-03-27","Der SDS Bonn begrüßte die Absicht der KPD, zu den Bundestagswahlen 1969 anzutreten und sicherte seine Unterstützung zu.","SDS Bonn will die KPD unterstützen","","","",[8],1,[1],[2],2,"16","2"],["3416","1968-03-28","Das Berliner Verwaltungsgericht gab der Klage eines FU-Studenten gegen die FU Berlin statt, nachdem diese seinen zunächst unbefristeten Studiengang auch für ihn befristet hatte.","Studienbefristung war unzulässig","","","",[4],1,[1],[2],2,"22","7"],["3417","1968-03-29","Ernst Benda befürwortet eine nähere Prüfung der Politisierung des VDS, schließlich sei ein politisches Mandat des VDS von mehreren Gerichten verneint worden.","VDS unter der Lupe","Schnell informiert","","",[1],1,[1],[2],2,"28","1"],["3418","1968-03-29","Dieter Kunzelmann wurde wegen Hausfriedensbruch zu einer Geldstrafe von 250 DM verurteilt, vom Vorwurf der üblen Nachrede und der Sachbeschädigung dagegen freigesprochen.","Geldstrafe für einen Kommunarden","","","",[5],1,[1],[2],2,"28","5"],["3419","1968-03-29","In Mainz protestierten Ingenieurstudenten für die Eingliederung der Ingenieurschulen in den Hochschulbereich.","Protest der Ingenieurstudenten","","","",[4],1,[1],[2],1,"28","9"],["3420","1968-03-30","SDS eröffnet außerordentliche Delegiertenversammlung in Frankfurt, habe zum Kampf gegen den Parlamentarismus aufgerufen und von der Entlarvung der totalitären Demokratie gesprochen.","Programm des SDS","Kurz gemeldet","","",[8],1,[1],[2],2,"16","2"],["3421","1968-03-30","Die Studentenunruhen würden an der Existenz der Bundesrepublik rühren, da immer mehr Wissenschaftler aus Deutschland fortgehen würden. Deshalb müssten die Unruhen radikal unterbunden werden.","Gefährliche Studenten-Schlagworte","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3422","1968-03-30","Kritik am Freispruch von Langhans und Teufel, alkoholisierte Autofahrer würden ungerechterweise viel härter bestraft werden.","Höfliche Behördenbriefe","Leserbriefe","Ein Dankeschön an ehrenamtliche Helfer fehlt","Leser",[1],1,[6],[2],2,"16","6"],["3423","1968-03-30","An der FU Berlin übernimmt ein neuer AStA die Geschäfte, Aufzählung der Funktionsträger.","Neuer AStA an der Freien Universität","","","",[4],1,[1],[2],2,"78","5"],["3424","1968-04-02","Außerplanmäßige Professoren und Privatdozenten sagten vor dem Parlamentsausschuss für Wissenschaft und Kunst zum geplanten Hochschulgesetz aus.","Rektor oder Präsident - hier schieden sich die Geister","","Reformfreudige Privatdozenten vor dem Parlamentsausschuß","Michael L. Müller",[4],1,[1],[1],2,"18","6"],["3425","1968-04-02","Über die außerordentliche Bundesdelegiertenkonferenz des SDS, laut K. D. Wolff wolle der SDS den nächsten Bundestagswahlkampf dazu nutzen, die Manipulationsform des Parlamentarismus zu entschleiern. Am Rande der Veranstaltung kam es in Frankfurt zu einer Demonstration bzw. einem Go-In bei einer griechischen Feier, es gab Verletzte und Verhaftungen.","Der SDS will \"entschleiern\"","","","",[8],1,[1],[2],2,"18","9"],["3426","1968-04-04","Bericht über die Brandstiftung in den Kaufhäusern Schneider und Kaufhof, es wird noch kein Bezug zu den Studentenunruhen oder den Kommune-Flugblättern hergestellt.","Attentate auf zwei Kaufhäuser","","Brandstiftung durch Zeitzünder - Täter noch unbekannt","",[9],1,[1],[2],1,"22","22"],["3427","1968-04-06","Festnahme der mutmaßlichen Brandstifter der Kaufhausbrände in Frankfurt, alle vier Täter (namentlich aufgezählt) hätten an der letzten Bundesdelegiertentagung des SDS teilgenommen, die Beschuldigten bestreiten die Tat bzw. verweigern die Aussage.","Frankfurter Brandstifter vom SDS? / Bauanleitung im Gepäck","","","",[9],1,[1],[2],2,"16","1,2"],["3428","1968-04-07","Trauermarsch in West-Berlin für Martin Luther King, angeführt vom Regierenden Bürgermeister Schütz. Nach dem Trauermarsch stürmten 1000 Studenten den Platz vorm Rathaus Schöneberg und trugen Plakate mit der Aufschrift \"Rassenkampf - Klassenkampf\"","Schütz führte Schweigemarsch an","Schnell informiert","","",[9],1,[1],[2],2,"68","1"],["3429","1968-04-07","Bundesinnenminister Benda kündigt im Zuge der Kaufhausbrandstiftung in Frankfurt sorgfältige Prüfung eines Verbots des SDS an.","Benda: SDS-Verbot sorgfältig überlegen/ Die Behörden wie ein Unternehmen führen","","Interview mit dem Innenminister/ Benda rügt veralteten Arbeitsstil","Diethart Goos",[8],1,[3],[2],1,"68","1,7"],["3430","1968-04-07","Der SDS bestreitet, dass die vier festgenommenen Kaufhausbrandstifter Mitglieder des SDS sind. Der SDS distanziert sich von der Tat.","SDS streitet ab","Kurz gemeldet","","",[9,8],1,[1],[2],2,"68","2"],["3431","1968-04-07","Bericht Hans Habes über seinen letzten Berlinbesuch. Tenor: Den Studenten geht es nur darum, Berlin zu ruinieren. Rudi Dutschke streue die Saat für die NPD, die \"NPDutschke\". Spricht von Ulbrichts Marionetten. (Abdruck aus der Zürcher Woche)","Denn sie wollen Berlin ruinieren","","Hans Habe: Diese Stadt greift einem ans Herz","Hans Habe",[1],1,[7],[1],1,"68","12"],["3432","1968-04-09","53 Prozent der Bevölkerung der Bundesrepublik würden in Demonstrationen eine zulässige Art der Meinungsäußerung sehen.","Für Demonstrationsrecht","Kurz gemeldet","","",[1],1,[1],[2],2,"18","2"],["3433","1968-04-09","Vor dem Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kunst sagten Angehörige des Mittelbaus von FU und TU sowie Studentenvertreter der FU Berlin aus. Kritik an den Aussagen der Rektoren vor dem Untersuchungsausschuss, diese hätten fälschlich proklamiert, für die gesamte Universität zu sprechen. Die Studentenvertreter kritisieren den Verlauf der Reformstruktur von oben nach unten.","Rektor oder Präsident  - das ändert nichts am System","","Heftige Kritik an der Lehrstuhl-Struktur der Universitäten","Michael L. Müller",[4],1,[1],[1],1,"18","5"],["3434","1968-04-09","Laut Senator Stein erhält der SDS seit 1962 keine staatlichen Gelder mehr, die FU prüfe zudem, ob die Zulassung der SDS-Gruppe an der FU widerrufen werden könne. Solange hat der SDS aber das Recht zu bestimmten Nutzungen innerhalb der Universität.","SDS bekommt vom Staat kein Geld","","","",[8],1,[1],[2],2,"18","6"],["3435","1968-04-10","Delegierte des studentischen Fachverbandes Medizin werfen dem VdS eklatanten Machtmissbrauch vor, da viele Beschlüsse auf dessen letzter Mitgliederversammlung in keinem Zusammenhang mit studentischen Problemen ständen.","Kritik am VDS","Schnell informiert","","",[4],1,[1],[2],2,"24","1"],["3436","1968-04-10","Programm des Parlamentsausschusses für Wissenschaft und Kunst in Bezug auf die Anhörungen für ein neues Hochschulgesetz.","TU-Rektor als nächster gehört","","","",[4],1,[1],[2],2,"24","5"],["3437","1968-04-10","Große Zustimmung für Hans Habes kritischen Artikel über die Studentenunruhen, die Studenten um Dutschke seien Totengräber der Demokratie; Bezug auch auf die Kaufhausbrandstiftung in Frankfurt, wird mit den Kommune-Flugblättern in Verbindung gebracht, hartes Vorgehen vom Rechtsstaat gefordert.","Habes Diagnose","Leserbriefe","\"Denn sie wollen Berlin ruinieren\"","Leser",[1],1,[6],[2],2,"24","7"],["3438","1968-04-11","Der SHB empfang Vertreter des FDJ in Bonn, Übereinstimmung erzielte man nur in der Forderung nach einer raschen Beendigung des Vietnamkrieges.","Gespräche mit der FDJ","Kurz gemeldet","","",[9],1,[1],[2],2,"18","2"],["3439","1968-04-11","Vorschläge der Kultusminister zur Hochschulreform","Studium soll kürzer werden","","Vorschläge der Kultusminister zur Hochschulreform","dws.",[4],1,[1],[3],2,"18","2"],["3440","1968-04-11","Zustimmung für Hans Habes kritischen Artikel über die Studentenunruhen.","Ein mutiger Mann","Leserbriefe","","Leser",[1],1,[6],[2],2,"18","2"],["3441","1968-04-11","Störung einer Aufführung von Goethes \"Faust II\" im Schiller-Theater.","Krawall im Theater","","","",[1],1,[1],[2],2,"18","3"],["3442","1968-04-12","Bericht über das Attentat auf Rudi Dutschke und die Verfolgung des Attentäter Bachmann, Wiedergabe der Beileidstelegramme von Kiesinger und Schütz. Auch der Senat und das Berliner Abgeordnetenhaus veurteilten das Attentat. Der Sprecher der Bundesregierung weist die Vorwürfe des SDS, dass der Berliner Senat und die Parteien schuld am Attentat sind, als unverantwortlich zurück. Weitere Stellungnahmen von Politikern. SDS und VDS machen Politik und den Springer-Verlag für das Attentat verantwortlich.","Einhellige Empörung über Schüsse auf Rudi Dutschke/ SPD: Abscheu und Empörung","","Attentat am Kurfürstendamm - Täter noch nicht identifiziert","",[2],1,[1],[1],1,"24","1,2"],["3443","1968-04-12","Empörung über das Attentat auf Dutschke, dies sei heimtückisch und abscheulich. Befürchtung neuer Ausschreitungen, ruft alle zur Besonnenheit auf, Berlin sei nicht Memphis, kritisiert Dutschke für Schweigen zu den Verbrechen des Vietkong, Kritik am SDS für Behauptung der Ermordung Dutschkes und der systematischen Hetze durch Senat und Springer-Konzern. Zwar sei der Schmerz von Dutschkes Freunden nachzuvollziehen, sie sollten Dutschke jedoch nicht zum Märtyrer und Grund für Gewalt machen.","Das Verbrechen","","","Rudolf Stiege",[2],1,[5],[2],2,"24","2"],["3444","1968-04-12","Über die Ermittlungen und den Ablauf des Attentats auf Dutschke.","Staatsanwälte leiten die Emittlungen","","","",[2],1,[1],[2],2,"24","3"],["3445","1968-04-12","Protestkundgebung des SDS im Audimax der TU Berlin, Schütz und Neubauer seien als Mörder bezeichnet worden, der Senat solle zurücktreten, Ankündigung eines Protestmarsches für den nächsten Tag.","Protestkundgebung in der TU","","","",[2],1,[1],[2],2,"24","3"],["3446","1968-04-12","Über die Situation im Krankenhaus Westend in dem Dutschke operiert wird (Nur in der ersten Fassung der Ausgabe).","Polizei sperrt Krankenhaus","","","",[2],1,[1],[2],2,"24","3"],["3447","1968-04-12","Augenzeugenberichte von Passanten über das Attentat auf Rudi Dutschke. Es ist die Rede vom empörenden Verbrechen. (In der II. Fassung der Ausgabe vom 12./13. April 1968 ist an Stelle des Fotos vom Tatort ein Foto von der Demonstration vor dem Springer-Hochhaus in Berlin. Vgl. Datensatz 3449.)","Dutschke stammelte nur noch: \"Vater, Mutter!\"","","Augenzeugen berichten über das Attentat","L.R.",[2],1,[1],[1],1,"24","3"],["3448","1968-04-12","Demonstration vor dem Springer-Hochhaus in West-Berlin, Scheiben wurden eingeschmissen und Fahrzeuge in Brand gesetzt, einige Demonstranten durchbrachen die Polizeikette und gelangten in das Gebäude. Großalarm der Polizei. (Nur in der zweiten Fassung der Ausgabe).","Steine auf das Springer-Haus. Brandstiftung","","","",[2,10],1,[1],[2],2,"24","1"],["3449","1968-04-12","Zwei Geschosse konnten aus Rudi Dutschkes Kopf entfernt werden, er schwebte allerdings noch in Lebensgefahr. Die Operation beim Attentäter war bereits beendet, seine Identität zu diesem Zeitpunkt immer noch unklar. (Nur in der zweiten Fassung der Ausgabe)","Geschoß konnte entfernt werden","","","",[2],1,[1],[2],2,"24","3"],["3450","1968-04-14","Demonstration auf dem Kurfürstendamm in Folge des Attentats auf Dutschke, Aktionen der Polizei gegen die \"Rädelsführer\", zahlreiche Waffen seien gefunden worden. Ankündigung des SDS für Aktionen gegen den Springer-Verlag am Ostermontag. Der Demokratische Klub wird derart zitiert, dass es den Demonstranten nur um die Zerstörung des Staates ginge, sie würden das Attentat für ihre Zwecke ausnutzen. In der III. Fassung leicht veränderter Artikel, Bericht über neue Aktionen vom Samstagabend.","Polizei greift durch! Bisher 230 Aufrührer festgenommen","","Vorher warfen sie Schlagringe; Messer und Totschläger weg","",[2,10],1,[1],[1],1,"64","1"],["3451","1968-04-14","Bericht über Verletzte und Festgenommene sowie eingeleitete Strafverfahren in West-Berlin. Bericht über die Schäden des Axel Springer Verlages. Kurzer Bericht über Demonstrationen in Westdeutschland.","57 Polizisten verletzt. 70 Strafverfahren.","","Erschreckende Bilanz der Straßenunruhen","",[2,10],1,[1],[2],2,"64","1"],["3452","1968-04-14","Solidarität der Leser mit der Berliner Morgenpost und dem Axel Springer Verlag, dem Verlag sei u.a. Hilfe bei der Auslieferung der Zeitungen angeboten worden.","Unsere Leser wollen helfen","","","",[2,10],1,[1],[2],2,"64","1"],["3453","1968-04-14","Appelle von Bundeskanzler Kiesinger, Bundesinnenminister Benda und dem Regierenden Bürgermeister von Berlin, Schütz, an die Demonstranten, von Gewalttaten abzusehen und sich von den \"Rädelsführern\" zu distanzieren. Kiesinger kündigt sonst härteres Vorgehen der Polizei an. Schütz behauptet versuchte Einmischung der SED. Der Präsident des Verbandes deutscher Zeitschriftenverleger, Kluthe, fordert Verbot des SDS, vergleicht die Aktionen gegen den Springer-Verlag mit denen der Nationalsozialisten. Auch der DGB verurteilt die Ausschreitungen. Stellungnahme des Springer-Verlages, dieser verurteilt das Attentat auf Dutschke wie auch die folgenden Ausschreitungen, sei reine Zerstörungslust. Weitere Stellungnahmen von SPD und CDU. Bischof Scharf ermahnt den Senat, sein eigenes Verhalten in den letzten Monaten zu überprüfen, kritisiert aber auch die Studenten für die Ausschreitungen.","Kiesinger appelliert an die Studenten/ Auch DGB-Chef Rosenberg verurteilt den Terror","","IG Druck und Papier: Arbeitnehmer werden gefährdet","",[2,10],1,[1],[2],2,"64","1,2"],["3454","1968-04-14","Kurzbericht über die Ostermärsche in einigen Städten, Tumulte im Zuge des Attentats auf Dutschke.","Tumulte bei Ostermärschen","","","",[2,10],1,[1],[2],2,"64","1"],["3455","1968-04-14","Empörung über das Attentat auf Dutschke, aber auch Kritik an den Unruhen danach sowie an den Studentenunruhen davor, diese hätten auch schon Gewalt angewandt.","Niemand kann dieses Attentat billigen","Leserbriefe","","Leser",[2],1,[6],[2],2,"64","2"],["3456","1968-04-14","Das Attentat auf Dutschke werde von den Linksextremisten als Feigenblatt eigener Gewalt ausgenutzt, zieht Vergleiche mit dem Untergang der Weimarer Republik, Aktionen gegen Springer-Zeitungen werden mit denen von Goebbels verglichen, Demonstranten seien fanatischer Mob. Behauptet Steuerung durch Ulbricht, dieser würde weitere Demonstranten einschleusen, Ziel sei die schleichende Machtübernahme in West-Berlin. Redet vom wachsenden Volkszorn der Bürger gegen die Demonstranten, befürchtet Übergriffe auf die Demonstranten und Bürgerkrieg, warnt vor Selbstjustiz, fordert aber auch die Verantwortlichen zum härteren Durchgreifen gegen die \"Rädelsführer\" auf. Namentlich genannt werden Meschkat, Lefèvre, Krippendorff, Langhans, Teufel, Kunzelmann und die \"Karikatur des Rechtsverwahrers\", Horst Mahler. Dazu eine Karikatur, in Mitten der Osterdemonstranten marschiert Ulbricht mit.","Berlin ist nicht Memphis","","","Rudolf Stiege",[2,10],1,[1],[2],1,"64","2"],["3457","1968-04-14","Versammlung von Studenten im Audimax der TU Berlin, dieses war zunächst von der Polizei gesperrt worden. Meinhof und Mahler werden als Befürworter von Gewalt zitiert und dargestellt, einige Studenten hätten sich aber auch gegen die Ausschreitungen der letzten Tage gewandt. Forderung der Studenten nach täglicher Sendezeit im SFB für ihre eigenen Ziele.","Prediger der Gewalt fordern Funk-Sendezeit","","\"Wenn Autos mit Springer-Zeitungen brennen, so ist das eine politische Aktion\"","",[2,10],1,[1],[2],1,"64","3"],["3458","1968-04-14","Ankündigung einer Kundgebung am Ostermontag im Zuge des Attentats auf Dutschke, Redner u.a. Bischof Albert, Ralf Dahrendorf, Harry Ristock. Auch die FDP hat sich angeschlossen.","Kundgebung mit Albertz und Ristock","","","",[2],1,[1],[2],2,"64","3"],["3459","1968-04-14","Bericht über Demonstrationen am Ostersamstag um den Kurfürstendamm. Namentlich genannt von den Festgenommenen werden Peter Brandt, Fritz Teufel und Dieter Kunzelmann","\"Heißer\" Nachmittag in der City","","Endstation Hauptkinderheim für die jungen Demonstranten","",[2],1,[1],[1],1,"64","3"],["3460","1968-04-14","Bericht über den Dutschke-Attentäter Josef Bachmann, gelte als Sonderling.","Der Attentäter Josef Bachmann galt als erregbarer Sonderling","","Er kam kurz vor der Tat aus München","",[2],1,[1],[5],1,"64","6"],["3461","1968-04-14","Stellungnahme der SED bzw. dem Neuen Deutschland zum Attentat auf Dutschke, das Attentat werde zur Agitation gegen die Bundesrepublik benutzt.","SED spricht von Pogromhetze","","","",[2],1,[1],[2],2,"64","6"],["3462","1968-04-14","Bericht über den Gesundheitszustand von Rudi Dutschke, Besuch der Eltern aus der DDR. Ein Prozess gegen Dutschke wegen Landfriedensbruch soll verschoben werden. Angeblich hätte Dutschke in einem Interview mit der \"Sun\" erst kürzlich gesagt, dass eines Tages ein Wahnsinniger auf ihn schießen würde.","Dutschke geht es besser","","Bisher keine Lähmungserscheinungen","",[2],1,[1],[2],2,"64","6"],["3463","1968-04-14","Demonstrationen im Zuge des Attentats auf Dutschke in zahlreichen europäischen Städten, vielerorts auch gegen Niederlassungen des Springer-Verlags. In der Schweiz wird auch der Ringier-Konzern für mitschuldig am Attentat auf Dutschke erklärt.","Polizei schützt Botschaften","","","",[2,10],1,[1],[2],2,"64","7"],["3464","1968-04-14","Senatssitzung im Zuge des Attentats auf Dutschke und den folgenden Unruhen. Der Regierende Bürgermeister Berlins, Schütz, empfing eine sechsköpfige Delegation der Demonstranten. Diese forderten die Enteignung Springers und das Geständnis der Urheberschaft des Senats am Mordanschlag auf Rudi Dutschke.","Senat will erforderliche Rechtsmittel einsetzen","","","",[2,10],1,[1],[5],2,"64","7"],["3465","1968-04-14","Bericht über die Veranstaltung im Audimax der TU Berlin am Karfreitag. Es sei offen zu Gewalt aufgerufen worden, insbesondere von Wolfgang Lefèvre, aber auch von Prof. Gottschalk und Klaus Meschkat. Eine der zentralen Forderungen sei, dass der Springer-Konzern aus der Stadt vertrieben werde. Prof. Gottschalk gibt dem Artikel von Hans Habe (7.4.1968) Schuld an der jüngst zugenommen Hetze gegen die Bewegung.","Keine Trauer, nur politische Aktionen","","SDS ruft offen zu neuen Gewalttaten auf","",[2,10],1,[1],[1],1,"64","7"],["3466","1968-04-14","Demonstrationen und Ausschreitungen in zahlreichen Städten der Bundesrepublik, vor allem gegen Niederlassungen des Springer-Konzerns. Es wird bedauert, dass die Polizei nur zögernd einschritt. Zahlreiche Fotos mit schwerer Kritik an den Unruhen, Mahler, Regensburger und Krippendorff werden als Rädelsführer dargestellt, Krippendorff als \"Lautsprecher der Außerparlamentarischen Opposition\". Verbrennungen von Springer-Zeitungen werden mit den Bücherverbrennungen zur NS-Zeit verglichen.","Brandstiftung, offener Aufruhr und Gewalt auf Westberliner Straßen","","Terrorakte auch im Westen","",[2,10],1,[1],[4],1,"64","8,9"],["3467","1968-04-17","Erklärung Bachmanns, dass er alleine gehandelt habe und warum er dies getan habe. Verbesserung des Gesundheitszustandes von Rudi Dutschke. ","Bachmann war ohne Helfer","","","",[2],1,[1],[2],2,"16","1"],["3468","1968-04-17","Verurteilung eines ersten Demonstranten in München, Beschäftigung der Politik mit den Unruhen, insgesamt über 1000 Demonstranten vorübergehend festgenommen. Der durch einen Steinwurf verletzte Fotograf Klaus Frings schwebt in Lebensgefahr, der SDS distanziert sich von der Tat. Prüfung eines Verbots von NPD und SDS. Stellungnahmen von Politikern und Gewerkschaften. Die Gesellschaft für Bürgerrechte fordert eine Osteramnesie. Kritik von Katholiken an der katholischen Kirche, weil diese zum Attentat schweigt. Der SDS fordert eine Stellungnahme von Journalisten zu der Berichterstattung über die Demonstrationen.","Aufrührer bald vor Gericht. In München schon ein Urteil/ Forderungen nach Verbot von SDS und NPD wachsen","","Krawalle heute vor Kabinett - Morgen tagt Berlins Parlament/ Stein und Evers kritisieren Vorgehen der Berliner Polizei","",[2],1,[1],[1],1,"16","1,2"],["3469","1968-04-17","Schwere Kritik an den Unruhen nach dem Attentat, Demonstranten würden das Attentat für ihre Krawalle ausnutzen, Kritik auch am Berliner Senat, weil dieser nicht hart genug durchgreife, u.a. müsse Horst Mahler die Rechtsanwaltsgenehmigung entzogen werden.","Mißbrauch der Demokratie","Leserbriefe","","Leser",[2],1,[6],[2],2,"16","2"],["3470","1968-04-17","Schwere Kritik am \"Tagesspiegel\", weil dieser sich nicht gegen die Ausschreitungen gegen den Springer-Konzern gewandt hat, obwohl die Pressefreiheit bedroht sei.","Ist Pressefreiheit teilbar?","","","Jo.",[2,10],1,[5],[2],2,"16","2"],["3471","1968-04-17","Die Demonstranten seien mit ihrem Ziel des Umsturzes und der Provokation von Gewalt durch die Bevölkerung zunächst gescheitert, sei aber nur eine Atempause. Die Bewegung wende faschistische Methoden an. Kritik an Heinrich Albertz und Prof. Gollwitzer für deren Reden, sie würden Gewalt gegen Sachen gutheißen. Wieder Vergleich mit Bücherverbrennungen unter Goebbels. Ruft zu Gewaltlosigkeit auf. Dazu eine Karikatur zur Forderung der APO nach einer Stunde Sendezeit im öffentlichen Fernsehen.","Haßt den Haß!","","","Rudolf Stiege",[2,10],1,[5,4],[2],1,"16","2"],["3472","1968-04-17","Einleitung von Ermittlungen gegen die \"Rädelsführer\". Namentlich genannt wird Wolfgang Lefèvre. Plan von Schnellverurteilungen, neue Einsatzstrategie der Polizei.","Moabit fahndet nach den Rädelsführern","","Staatsanwälte erwarten Lawine von Verfahren","K.G.",[2],1,[1],[1],2,"16","3"],["3473","1968-04-17","Der Rektor der FU Berlin, Harndt, und die Dekane der FU mahnen in einem Aufruf die Westberliner Bervölkerung zur Vernunft und warnen vor Gewalt. Der AStA-Vorsitzende Landsberg lehnte die Mitunterzeichnung des Aufrufes ab.","Zur Vernunft gemahnt","","","",[1],1,[1],[2],2,"16","3"],["3474","1968-04-17","Der Rektor der TU Berlin, Prof. Weichselberger, verteidigt seinen Entschluss, das Audimax der TU Berlin trotz Versammlungsverbot am Karfreitag nicht geräumt zu haben.","\"Räumung war zu schwierig\"","","","",[2],1,[1],[2],1,"16","3"],["3475","1968-04-17","Kritik an den Unruhen nach dem Attentat, Dutschke habe Gewalt gesät und nun geerntet. Kritik an Willy Brandt, weil sein Sohn Peter an den Unruhen beteiligt war. Forderung nach harten Strafen für die Demonstranten durch die Justiz. Ein Leserbrief kritisiert die Kommentare von Rudolf Stiege, stellt sie mit der Hetze von Goebbels gleich.","Was ist zu tun?","Leserbriefe","Politisches Interesse beim Bürger wecken","Leser",[2],1,[6],[2],2,"16","6"],["3476","1968-04-17","Bericht über die Geschehnisse/Demonstrationen von Ostersonntag bis Dienstag. Der Rektor der TU Berlin verbot von Sonntag an die Nutzung des Audimaxes der TU für Beratungen der APO. Kundgebung unter dem Motto \"Macht einen neuen Anfang\" am Ostermontag mit Heinrich Albertz, Inhalte der Reden, die Junge Union sprach von linken Faschisten. Protestmarsch zum SFB, weil dieser nicht eine einstündige tägliche Sendezeit für die APO freigeben möchte. Gegendarstellung von Marianne Regensburger, die in der Ausgabe vom 14.4.1968 als Rädelsführer der Gewalt dargestellt worden war, jedoch mit Billigung der Polizei zur Absage an Gewalt aufgerufen habe.","Nach Terror gegen Springer Aktionen gegen den SFB","","Bilanz eines \"Osterfestes\"","",[2,10],1,[1],[1],1,"16","6"],["3477","1968-04-17","Pressespiegel über die Berichterstattung der Demonstrationen in Folge des Attentats auf Dutschke in aller Welt, nahezu komplett kritisch gegenüber den Unruhen, Besorgnis wegen deutscher Vergangenheit.","Demonstrationen im Spiegel der Weltpresse","","","",[2],1,[1],[2],2,"16","7"],["3478","1968-04-17","Stellungnahmen der Parteien und von Politikern zu den Unruhen, Forderung nach Schutz der Demokratie und hartem Durchgreifen (SPD lehnt dies ab). Der \"Vorwärts\" wirft den Springer-Zeitungen Verteufelung der Studenten um Dutschke vor. U.a. Stellungnahmen von Lemmer, Scharf, Heinemann. Die SED-Presse spricht von faschistischem Terror.","Die demokratische Freiheit schützen!","","Scharfe Ablehnung der Gewalttaten","",[2,10],1,[1],[1],1,"16","7"],["3479","1968-04-17","Demonstrationen in London vor dem Büro des Springer-Verlages, Verurteilungen von Demonstranten.","Schnelle Urteile","","London: Demonstranten bestraft","",[2,10],1,[1],[2],1,"16","7"],["3480","1968-04-17","Demonstrationen in zahlreichen Städten der Bundesrepublik, Ziel die Verhinderung der Auslieferungen von Springer-Zeitungen, ist aber überall misslungen. Sicherstellungen von gefährlichen Gegenständen/Waffen. In Hamburg wird bei der Auslieferung der Springer-Zeitungen ein Student überfahren, in einer Stellungnahme bedauert der Verlag dies, spricht den Fahrer des Wagens aber frei und gibt die Schuld dem Demonstranten. Alle Vermittlungsversuche, den SDS von weiteren gewaltsamen Aktionen abzubringen, seien gescheitert, der SDS-BV Wolff habe stattdessen erklärt: \"Wir werden marschieren\".","SDS-Chef Wolff: Wir werden marschieren","","Schwere Straßenschlachten in vielen Städten","",[2,10],1,[1],[1],1,"16","16"],["3481","1968-04-18","Bericht über den Tod des Fotografen Klaus Frings, hervorgerufen durch einen Steinwurf in München. Stellungnahmen/Bedauern von Politiker und Verbänden, auch der SDS bekundet sein Beileid, will aber auch nicht \"rührselig\" werden. Der VdS ruft zur Gewaltlosigkeit auf. Der AStA-Vorsitzende der FU, Landsberg, gibt die Schuld den Polizisten, weil sie studentische Ordner entfernt hätten. Geldsammlungen an mehreren Universitäten für die Hinterbliebenen von Klaus Frings.","Erschütterung über den Tod des Münchner AP-Fotografen/ Den blutigen Terror endlich beenden","","Mahnung zur Besinnung - Polizei fahndet nach Verdächtigem/ SPD-Vorstand: Initiatoren sind mitschuldig","",[2],1,[1],[1],1,"16","1,8"],["3482","1968-04-18","Tagung der Bundesregierung und der Ausschüsse in Bonn über die Unruhen nach dem Attentat auf Dutschke. Bundesregierung gibt SDS die Schuld für die Osterunruhen, bis auf die FDP wollen die Parteien nicht mehr mit dem SDS in Kontakt treten. Ein Verbot wurde nicht besprochen. Prozesse gegen \"Rädelsführer\" sollen beschleunigt werden. Einschätzungen der Unruhen von Politikern, Statistiken zu den Unruhen, nur ein Drittel bis etwa die Hälfte der Teilnehmer seien Studenten gewesen. Willy Brandt fordert Maßnahmen gegen \"Rädelsführer\" schon im Vorfeld der gewalttätigen Aktionen. In der SPD-Fraktionssitzung wurde gefordert, Wolfgang Landsberg und Knut Nevermann aus der SPD auszuschließen.","Beschleunigte Prozesse gegen die Rädelsführer","","","dws.",[2],1,[1],[2],2,"16","1"],["3483","1968-04-18","Der SDS habe die Sperrung der Autobahnzufahrten zwischen Berlin und dem übrigen Bundesgebiet erwogen, aber wegen zu erwartendem Unverständnis in der Bevölkerung davon abgesehen. Rudi Dutschkes Gesundheitszustand verbessere sich weiter. Senator Stein verurteilt studentische Erklärung zur Befürwortung von Gewalt gegen Sachen. Erklärung von 23 Professoren der FU Berlin, Gefahr der Anarchie drohe, hierfür seien nicht zuletzt die politischen Machthaber verantwortlich. Der in Hamburg von einem Auslieferwagen des Springer-Verlages angefahrene Student ist außer Lebensgefahr. Parolen in Nizza gegen Springer. ","SDS plante Berlin-Blockade","","Autobahn-Zufahrt sollte gesperrt werden","",[2],1,[1],[2],2,"16","1"],["3484","1968-04-18","Der DGB lehnt den Vorschlag des SHB ab, studentische Sprecher bei den Maikundgebungen des DGB sprechen zu lassen.","Ohne Studentenreden","Schnell informiert","","",[1],1,[1],[2],2,"16","1"],["3485","1968-04-18","Kritik an den Osterunruhen, sei Angriff auf die Pressefreiheit, Rudi Dutschke sei seinen eigenen Gewaltaufrufen zum Opfer gefallen.","Verletzung der Pressefreiheit","Leserbriefe","","Leser",[2],1,[6],[2],2,"16","2"],["3486","1968-04-18","Der stellvertretende Bundespressechef Conrad Ahlers spricht sich gegen die Vorwürfe aus, die Springer-Presse sei Schuld an den Osterunruhen. Stattdessen sieht er die Verantwortlichkeit beim SDS.","Nicht die Urheber","","Ahlers: Journalisten an Krawallen unschuldig","",[2],1,[1],[2],2,"16","2"],["3487","1968-04-18","Klaus Frings sei Opfer der politischen Radikalisierung der Gesellschaft, der Tod Frings' zeige den fließenden Übergang von Gewalt gegen Sachen zu Gewalt gegen Personen, hofft aber, dass der Tod Frings' einige zum Umdenken bringen werde. Kritisiert den Tagesspiegel für den Abdruck eines Programms der APO, in der zu Gewalt gegen den Springer-Verlag aufgerufen wird. Dazu eine Karikatur: SDS-Demonstrant marschiert einen Berg hoch, hinter der Spitze kommt der Abgrund.","Übt Einkehr!","","","Rudolf Stiege",[2],1,[5,4],[2],1,"16","2"],["3488","1968-04-18","Parolen mit roter Farbe an Gebäude der FU Berlin angebracht, u.a. \"Studenten macht euch fertig zur Revolution - haut die Professoren\".","FU-Mensa mit roter Farbe \"verziert\"","","","",[1],1,[1],[2],2,"16","3"],["3489","1968-04-18","Die Feuerwehr ist während ihrer Arbeit bei den Osterunruhen von Demonstranten bedroht und angegriffen worden, wendet sich in einem offenen Brief an die APO. Der SFB nimmt Stellung zu den Forderungen der APO ihm gegenüber.","Feuerwehr behindert und bedroht","","Offener Brief an Demonstranten","L.R.",[2],1,[1],[1],2,"16","3"],["3490","1968-04-18","Kritik an den Osterunruhen, Verbot des SDS und der NPD wird gefordert, Kritik an Willy Brandt wegen Beteiligung seines Sohnes Peter an den Unruhen, Dutschke sei von der SED geschult und mit klarem Auftrag nach West-Berlin geschickt worden, Springer-Presse hätte die Rolle der Juden übernommen.","Wo blieben die Proteste?","Leserbriefe","Martin Luther King trat für Gewaltlosigkeit ein","Leser",[2],1,[6],[2],2,"16","6"],["3491","1968-04-18","Laut einer Umfrage befürworten nur sechs Prozent der Bevölkerung die Demonstrationen um Ostern 1968, 68 Prozent lehnen sie ab.","Nur sechs Prozent für Demonstranten","","","",[2],1,[1],[2],2,"16","8"],["3492","1968-04-18","Ein Ost-Berliner SED-Anwalt vertritt zwei Studenten des SDS an der Universität Bonn, darunter Hannes Heer.","SED-Anwalt vertritt SDS-Studenten","","","",[1],1,[1],[2],2,"16","8"],["3493","1968-04-18","Laut Tariq Ali sei die Demonstration vor dem Springer-Büro in London auf Wunsch deutscher Studenten zu Stande gekommen.","Protest-Kundgebung war bestellt","","","",[2],1,[1],[2],2,"16","8"],["3494","1968-04-18","Der SDS verteidige die Zugangssperren der SED für Minister und leitende Beamte Bonns nach West-Berlin. Verteidigung auch für Gewalt gegen Sachen. Namentlich erwähnt werden Krahl und K.-D. Wolff.","SDS verteidigt Schikane der SED gegen Berlin","","Linksradikale künden neue Aktionen an","",[1],1,[1],[2],2,"16","8"],["3495","1968-04-19","Das Berliner Abgeordnetenhaus verurteilt die Osterunruhen, das Attentat an Dutschke sei von einigen Gruppen missbraucht worden. Lob für die Polizei. Forderung von der CDU, dass Verfahren gegen Demonstranten zügig durchgeführt werden, Kritik, dass die Rädelsführer nicht schon vor dem Attentat längst im Gefängnis säßen.","Abgeordnete verurteilen einmütig jeden Gewaltakt","","Schütz: Attentat auf Dutschke wurde zynisch mißbraucht","Go./LUK",[2],1,[1],[1],2,"18","1"],["3496","1968-04-19","Kritik der Polizeigewerkschaft an den Politikern, diese hätten die Polizisten während der Osterunruhen nicht genügend unterstützt. Bericht über verletzte Polizisten. Die FDP kritisiert die Große Koalition, deren Gehabe sei mitverantwortlich für die Radikalisierung der Studenten. In München wurden zwei SDS-Mitglieder wegen früherer Anklagen zu Gefängnisstrafen verurteilt. Schütz und Neubauer ziehen Gesprächszusage mit Vertretern der APO zurück. Die SED-Zeitung \"Wahrheit\" fordert Sofortmaßnahmen gegen \"Bild\" und \"BZ\", gleiches fordere auch der SDS. Im Ausland kam es zu Demonstrationen vor deutschen diplomatischen Missionen. Diskussion in der FU Berlin über Gewaltanwendung.","Harte Kritik der Polizei an den Politikern/ Zwei Mitglieder des SDS in München verurteilt","","\"Bittere Erfahrungen in den letzten Tagen\"/ Die Polizei Berlins mahnt die politische Führung","",[2],1,[1],[2],2,"18","1,2"],["3497","1968-04-19","Bericht über den Tod des Studenten Rüdiger Schreck, der vermutlich durch eine Holzbohle getötet worden sei. Trauermarsch des AStA der TU Berlin wegen dem Tod Schrecks und Frings. Schreck sei wohl nur Zuschauer der Demonstration gewesen. Stellungnahmen von Politikern, der SDS wird für die Toten verantwortlich gemacht. (In II. Fassung leicht veränderter Artikel auf S. 1, die Ankündigung des Trauermarsches des AStA der TU Berlin ist gestrichen worden.)","Jetzt auch ein Student Opfer der Krawalle/ Rüdiger Schreck wollte nur einmal zusehen?","","Vermutlich durch Holzbohle getötet/ CSU: SDS ist sich seiner Verantwortung nicht bewußt","",[2],1,[1],[2,1],1,"18","1,9"],["3498","1968-04-19","Der Gesamtbetriebsrat des Axel-Springer-Konzerns sieht Demonstration als legitim an, kritisiert aber jegliche Gewaltanwendung und Sachbeschädigung. Die Existenz des Staates stände auf dem Spiel.","\"Demonstrationen sind legitim\"","","","",[2],1,[1],[2],2,"18","2"],["3499","1968-04-19","Über die Abgeordnetenhaussitzung zum Thema Osterunruhen, begrüßt, dass alle Parteien die Unruhen kritisieren, Bewahrung des Rechtsstaates habe im Vordergrund gestanden. Kritisiert die Parole des SDS, Gewalt gegen Sachen sei legitim, nur gegen Menschen nicht, das sei verlogen. SDS/ APO wolle den Staat zerstören. Lob für die besonnene Polizei, diese hätte Schlimmeres verhindert. Kritik an der SPD, dass Ristock, Beck, Nevermann und Landsberg noch Mitglieder seien. Ein Hauch von Weimar sei in der Luft, fordert Vorgehen gegen Ankündigungen von kriminellen Handlungen.","Ein Hauch von Weimar","","","Rudolf Stiege",[2],1,[5],[2],2,"18","2"],["3500","1968-04-19","Bericht über den Einsatz eines Wasserwerfers am Karfreitag auf dem Kurfürstendamm. Die Besatzung wurde durch Demonstranten verletzt, der Wasserwerfer beschädigt. Demonstranten versuchten, den Wasserwerfer zu übernehmen.","Dienstmeldung des Wasserwerfers B-3590","","","",[2],1,[1],[2],1,"18","3"],["3501","1968-04-19","Debatte im Berliner Abgeordnetenhaus über die Studentenunruhen, laut Schütz gehe es den Demonstranten nur darum, den freiheitlichen Rechtsstaat handlungsunfähig zu machen. Ausführlich zur Erklärung von Schütz.","Entschlossene Absage an die Aufrührer","","","Go./LUK.",[2],1,[1],[1],1,"18","6"],["3502","1968-04-19","Debatte im Berliner Abgeordnetenhaus über die Studentenunruhen. Erklärung von Peter Lorenz für die CDU und Ella Barowsky für die FDP zu den Studentenunruhen, insbesondere Lorenz kritisiert diese scharf. U.a. kritisiert er auch Gollwitzer. Weitere Äußerungen von Politikern.","CDU kritisiert Senatspolitik/ Amrehn: Jeder Bürger muß lesen können, was er will","","Justiz soll schnell und gerecht vorgehen","Go./LUK.",[2],1,[1],[2,1],1,"18","6,7"],["3503","1968-04-19","Pressespiegel über die Berichterstattung zum Tod von Klaus Frings in aller Welt. SDS/Demonstranten werden verantwortlich gemacht, Gollwitzer kritisiert, die deutsche Bevölkerung für ihre besonnene Haltung gelobt.","\"Es geht um die Freiheit der Presse\"","","","",[2],1,[1],[2],2,"18","9"],["3504","1968-04-19","Mahler befürwortet während einer Veranstaltung in der TU Berlin die Gewaltanwendung, der Tod von Klaus Frings sei im gewissen Sinne unvermeidlich gewesen, sein zynischer Vergleich mit dem Steuern eines PKWs, bei dem ja auch ein Reifen platzen könne. Überraschend viele Teilnehmer der Veranstaltung hätten sich aber gegen Gewaltanwendungen ausgesprochen. Mahler warnte zudem vor beschleunigten Prozessen.","Mahler befürwortet Gewaltanwendung","","","",[2],1,[1],[2],2,"18","9"],["3505","1968-04-19","Mitglieder der APO konnten am Ostersonntag kostenlos die S-Bahn benutzen.","SED verzichtete auf Fahrgeld","","","",[2],1,[1],[2],2,"18","9"],["3506","1968-04-19","Wehner äußert sich besorgt über das Bild der Bundesrepublik im Ausland durch die Osterunruhen. Helmut Schmidt äußert, dass der Protest gegen Springer nur ein Vorwand sei, in Wahrheit ginge es um die freiheitliche Rechtsordnung und die parlamentarische Demokratie. Schmidt richtet an Springer den Vorschlag, dafür zu sorgen, dass seine Blätter die Pluralität der Meinungen in dem Maße widerspiegeln, wie es der pluralistischen Gesellschaft entspreche.","Besorgt über Auslandsecho","","","",[2],1,[1],[2],1,"18","9"],["3507","1968-04-19","Der Bundesjugendring appelliert an die Bundesregierung, sich mit den Forderungen der demonstrierenden Studenten auseinanderzusetzen. Die mangelnde Bereitschaft, auf die Forderungen einzugehen, sei ein Grund für die Radikalisierung.","Appell des Jugendrings","","Regierung soll sich mit Studenten auseinandersetzen","",[2],1,[1],[2],2,"18","9"],["3508","1968-04-20","Bundestagspräsident Gerstenmaier ruft eine Sondersitzung des Bundestages am 30. April zum Thema der Studentenunruhen ein. Die Initiative ging von der FDP aus. Bundesinnenminister Benda kündigt in Kürze eine Entscheidung über ein Verbot des SDS an.","Bundestag berät über Unruhen/ CDU/CSU fordert schnellere Aburteilung der Straftäter","","Bessere Zusammenarbeit von Justiz und Polizei gewünscht","dws.",[2],1,[1],[2,1],2,"12","1,2"],["3509","1968-04-20","Schütz betont, wichtigste Aufgabe sei es, Rädelsführer von diskutierenden Studenten zu trennen. Schütz mahnt die Bevölkerung zur Besonnenheit, nachdem ein Arbeiter Selbstjustiz vorgeschlagen hat.","\"Radikale isolieren\"","","Klaus Schütz sprach vor Berliner Arbeitern","",[1],1,[1],[2],2,"12","1"],["3510","1968-04-20","Der Münchner SDS wie auch der jeweilige AStA von der FU und TU Berlin sprechen sich für Gewalt gegen Sachen aus. Günter Grass spricht dem SDS wegen der jüngsten Gewalttaten den Führungsanspruch ab. LSD erklärt Mitverantwortung für den Tod von Frings und Schreck. Ermittlungen in beiden Todesfällen.","Studenten-Vertreter fordern erneut Gewalt","","Berliner AStA: Einzig mögliche Form der Artikulation","",[1],1,[1],[2],2,"12","1"],["3511","1968-04-20","Lob für die Kommentare von Rudolf Stiege zu den Osterunruhen; Kritik an Schwarz-Weiß-Malerei, jegliche Kritik an der Demokratie wie sie bspw. von Grass kommt dürfe nicht mit der Zerstörungswut der Studenten um Dutschke gleichgesetzt werden.","Gegen Schwarz-Weiß-Malerei","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3512","1968-04-20","Axel Springer äußert sich in einem Interview der \"Daily Mail\" zu den jüngsten Studentenunruhen, die Angriffe auf ihn seien kommunistisch inspiriert.","Mehr Freiheit und mehr Wohlstand als je zuvor","","","",[1],1,[1],[2],1,"12","6"],["3513","1968-04-20","Axel Springer betonte auf einem Empfang, dass er trotz der Studentenunruhen und der Anfeindungen gegen sein Haus Berlin nicht verlassen werde, sondern die Aktivitäten seines Konzerns künftig noch zunehmen werden.","Springer wird Berlin nicht verlassen","","","",[1],1,[1],[2],2,"12","6"],["3514","1968-04-20","Der AStA-Vorsitzende der FU Berlin, Wolfgang Landsberg, ist wegen des nicht stattfindenden Trauermarschs für Klaus Frings und Rüdiger Schreck zurückgetreten. Rudi Dutschkes Gesundheitszustand verbessere sich weiter.","Kein Trauermarsch","","Der Rücktritt des AStA-Vorsitzenden Landsberg","",[2],1,[1],[2],2,"12","6"],["3515","1968-04-20","Beisetzung von Klaus Frings. Die Deutsche Angestellten-Gewerkschaft distanziert sich scharf von den Demonstranten. Bundeswirtschaftsminister Schiller ruft die Bevölkerung zur Besinnung auf und kündigt an, dass die SPD gemeinsam mit den jugendlichen Kritikern, zu denen er nicht die \"außerdemokratischen Kräfte\" zählt, die Demokratie neu überdenken und formen wolle. Schiller ruft nach Ordnung.","Ein Meer von Kränzen für Klaus Frings","","\"Gewalt löst keine Probleme - sie schafft nur neue\"","",[2],1,[1],[2],1,"64","1"],["3516","1968-04-20","Studentenvertreter werden aufgefordert, sich von den Gewalttaten und der APO zu distanzieren, sonst werde die Bevölkerung ein negatives Bild von der Studentenschaft erhalten.","Distanz ist angebracht","Leserbriefe","","",[1],1,[6],[2],2,"64","2"],["3517","1968-04-20","Kundgebung des SHB aus Anlass des einjährigen Jahrestages des Militärputsches in Griechenland. Ein Demonstrationszug wurde dagegen abgesagt.","Demonstrationszug wurde abgesagt","","","",[1],1,[1],[2],2,"64","3"],["3518","1968-04-20","Scharfe Kritik an Zeitungen ( Zeit, Süddeutsche, Tagesspiegel) und Politikern (Ristock, Barowsky), diese würden auf den Zug der Kritik am Springer-Verlag aufspringen, eine Anti-Springer-Kampagne weiter forcieren. Studentenbewegung wird in die Nähe des SDS gerückt. Erklärung für die studentische Anti-Springer-Kampagne, sei vor allem geschehen, weil die Studenten nicht an die Arbeiter herankommen. Zitate von Peter Schneider, man bekämpfe die Springer-Presse weil sie einseitig im Interesse der Herrschenden, statt einseitig im Interesse der Massen berichte. Weil Enteignung nicht zog, griff man zur Gewalt. Bildungshochmut und geschäftliches Interesse seien Grund für die weite Verbreitung der Anti-Springer-Emotionen.","Was auch geschehen mag: Springer ist an allem schuld?","","Bündnis der Revoluzzer und Konkurrenten","Walter Brückmann",[1],1,[1],[1],1,"64","12"],["3519","1968-04-23","Publizistikstudenten riefen Streik wegen Nichtbesetzung des Institutsdirektors aus. Prof. Weichselberger, Rektor der TU Berlin, will gegen die Raumnutzung durch Studenten der APO vorgehen; Wolfgang Landsberg erklärt Gründe für seinen Rücktritt vom AStA-Vorsitz, dies hätte nichts mit der Einstellung zur Gewalt zu tun, denn die Erklärung der APO zur Gewaltanwendung habe er zusammen mit Nevermann selbst ausgearbeitet.","Publizisten streiken","","Protest gegen schleppende Berufungsverhandlungen","MM.",[1],1,[1],[2],2,"16","1"],["3520","1968-04-23","Scharfe Kritik an \"Panorama\", dass Klaus Meschkat die Gelegenheit gab, Ziele und Motive der APO darzulegen. Ulbricht sei Meschkat noch nicht kommunistisch genug, hätte ihn noch links überholt. \"Panorama\" mit Peter Merseburger springe auf den Zug der Anti-Springer-Kampagne auf. Kritik auch an Heinrich Albertz, der die Springer-Presse als Gefahr für Berlin bezeichnet habe.","Ulbricht links überholt","","","ge.",[1],1,[5],[2],2,"16","2"],["3521","1968-04-23","Kritik an den Studentenunruhen und an der Gewaltanwendung. Mehrheitlich seien es jedoch gar keine Studenten, sondern kommunistisch geschulte Jugendliche, die SED zeichne sich als Organisator der Unruhen ab. Vergleich mit der \"Reichskristallnacht\", der Springer-Konzern habe die Rolle der Juden übernommen.","Es sind keine Studenten","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3522","1968-04-23","Der Gesundheitszustand von Rudi Dutschke habe sich weiter verbessert.","Rudi Dutschke geht es besser","","","",[2],1,[1],[2],2,"16","3"],["3523","1968-04-23","Im Disziplinarverfahren der FU Berlin gegen die Studenten Häußermann, Wilhelmer, Dutschke, Lefèvre und Nevermann sei noch kein neuer Termin angesetzt worden.","Noch kein neuer Termin","","","",[1],1,[1],[2],2,"16","3"],["3524","1968-04-23","Mehrere Demonstrationen anlässlich des Jahrestages des griechischen Militärputsches.","Demonstration gegen Athen","","","",[1],1,[1],[2],2,"16","13"],["3525","1968-04-23","Der Rundfunkrat des SFB unterstützt die Entscheidung seines Intendanten Barsig, der APO keine regelmäßige Sendezeit zur Verfügung zu stellen. Der Berliner SPD-Bundestagsabgeordnete Bühling forderte strafrechtliche Maßnahmen gegen Horst Mahler wegen dessen Gewaltaufrufen. Der AStA der Kirchlichen Hochschule weist die Kritik von Peter Lorenz an Bischof Scharf und Prof. Gollwitzer zurück, dies sei nur ein Versuch, die Manipulationen des Springer-Konzerns zu rechtfertigen.","Haltung Barsigs gebilligt","","Staatsanwaltschaft soll gegen Mahler vorgehen","",[1],1,[1],[2],2,"16","13"],["3526","1968-04-23","Streik der Publizistikstudenten wegen der Verzögerung der Neubesetzung eines Lehrstuhls. Kritik am Dekan, dieser würde bei der Berufung nicht demokratisch entscheiden.","Vorwürfe der Studenten: 'Bewußte Verschleppung'","","Streit an der FU um Publizistik-Institut","LUK/MM",[4],1,[1],[2],2,"16","13"],["3527","1968-04-24","Senator Stein bezeichnet die Nutzung von Räumen der TU-Studentenvertretung durch Komitees und Ausschüsse der APO als rechtswidrig, da die Studentenvertretung kein allgemeinpolitisches Mandat besäße.","Senator Stein: Rechtswidrig","","","",[1],1,[1],[2],2,"12","1"],["3528","1968-04-24","Freiheitskundgebung am 1. Mai 1968. Der Vorsitzende des Berliner Mai-Komitees und DGB-Funktionär Sickert hat Innensenator Neubauer darum gebeten, Demonstrationen und Kundgebungen der APO nur zu genehmigen, wenn Zusammenstöße mit der eigenen Kundgebung vermieden werden können. Der Vorschlag der SPD-Falken, Knut Nevermann auf der Veranstaltung reden zu lassen, wird von Sickert abgelehnt.","Willy Brandt spricht am 1. Mai auf dem Platz der Republik","","Sickert ruft die Berliner zur Teilnahme auf","MM.",[1],1,[1],[1],2,"12","1"],["3529","1968-04-24","Die CDU-Abgeordnete Ursula Besser hat in einem Brief an die Anwaltskammer scharfe Kritik an Horst Mahler geübt und gefragt, wann auf Grund dessen Gewaltaufrufen Verfahren von der Standesorganisation gegen Mahler eingeleitet werden.","Frage an die Anwaltskammer","","","",[1],1,[1],[2],2,"12","2"],["3530","1968-04-24","Laut einer Umfrage der Universität Mannheim bekennen sich Studenten in allen wesentlichen Punkten deutlich stärker zu den demokratischen Grundideen als der Durchschnitt der Bevölkerung.","Bekenntnis der Studenten zu demokratischen Ideen","","Wesentliche Unterschiede zur übrigen Bevölkerung","",[1],1,[1],[5],2,"12","2"],["3531","1968-04-24","Trauerfeier für Rüdiger Schreck. Anzeigen gegen 21 Personen, die in Essen die Auslieferung von Springer-Zeitungen verhindern wollten. Carlo Schmid begrüßt das Vorhandensein einer außerparlamentarischen Opposition, um bürgerkriegsähnliche Zustände zu vermeiden, müsse rechtzeitig ein Maximum der studentischen Forderungen erfüllt werden. Bundeskanzler Kiesinger und Forschungsminister Stoltenberg diskutieren mit Studenten. Der SPD-Pressedienst kritisiert versuchte Verhinderungen der Auslieferungen von Springer-Zeitungen.","Zone gestattete der Mutter von Schreck die Ausreise","","Carlo Schmid bejaht \"außerparlamentarische Opposition\"","",[1],1,[1],[1],1,"12","2"],["3532","1968-04-24","Der Dutschke-Attentäter Josef Bachmann wird auf seinen Geisteszustand untersucht.","Attentäter wird untersucht","","","",[2],1,[1],[2],2,"12","3"],["3533","1968-04-24","Meinungsverschiedenheiten zwischen SPD und CDU, ob man den Parlamentarischen Untersuchungsausschuss über die Studentenunruhen weiterführen solle. Die SPD sieht dies auf Grund der Osterunruhen als überholt an.","Krach im Ausschuß","","","",[1],1,[1],[2],2,"12","3"],["3534","1968-04-24","Ankündigung der Neuwahl des AStA-Vorsitzenden der FU Berlin für den 3. Mai, nachdem Wolfgang Landsberg zurückgetreten ist.","Neue Gesichter","","","",[4],1,[1],[2],2,"12","3"],["3535","1968-04-24","Berlins Regierender Bürgermeister Schütz erklärt sich zu einer Diskussion mit der Evangelischen Studentengemeinde bereit. Diese hatte vorher erklärt, dass auch sie Schuld am Tod von Klaus Frings und Rüdiger Schreck seien, aber keine Möglichkeit sehen, die außerparlamentarische Opposition zur Gewaltlosigkeit zu verpflichten, wenn politisch Verantwortliche sich der Diskussion nicht stellen. Streik der Publizistikstudenten der FU Berlin, der Rektor der FU weist Vorwürfe der Studenten bzgl. der Neubesetzung des freien Lehrstuhls der Publizistik zurück.","Gespräch mit Studenten","","Klaus Schütz zu einer Diskussion in Dahlem bereit","",[1],1,[1],[2],2,"12","3"],["3536","1968-04-25","Zeugenaussage zum Tod von Rüdiger Schreck; Ermittlungsverfahren gegen zahlreiche Teilnehmer von Demonstrationen, Ostern 1968, in mehreren Städten; Deutscher Richterbund lehnt Schnellverfahren ab; Der SDS-Hessen wird weiterhin mit Mitteln der Landesregierung finanziell unterstützt; Münchens Innenminister kritisiert Polizei für Schlagstockgebrauch; Allensbach-Umfrage, ob die Vorwürfe der Studenten an die vermeintlich rückständigen Professoren korrekt sind, sehr geteilte Meinungen.","München: Erste heiße Spur im Fall Schreck/ Richter: Schnellverfahren kein geeignetes Mittel","","Strafanzeigen gegen SDS-Funktionäre und Kommunisten","",[1],1,[1],[5,1],2,"18","1,2"],["3537","1968-04-25","Senator Stein fordert die Studentenvertretung der TU Berlin auf, die Übergabe ihrer Räume an Institutionen der APO zu beenden.","Stein mahnt AStA der TU","","","",[1],1,[1],[2],2,"18","1"],["3538","1968-04-25","Der Vorstand der Bundesstudenten-Gewerkschaft fordert den Rückritt des neuen VdS-Vorsitzenden Ehmann, weil dieser eine Vorstrafe bei seiner Wahl verschwiegen habe.","VDS-Chef soll gehen","Schnell informiert","","",[4],1,[1],[2],2,"18","1"],["3539","1968-04-25","Der Akademische Senat der FU Berlin ist noch zu keinem Ergebnis bzgl. der Förderungsfähigkeit des SDS gekommen, weiteres Material soll Aufschluss geben, inwieweit der SDS als Organisation an den Studentenunruhen beteiligt gewesen ist. (Nur in der ersten Fassung der Ausgabe)","Neue Untersuchungen über den SDS","Schnell informiert","","",[8],1,[1],[2],2,"18","1"],["3540","1968-04-25","Der Bonner Professor von Weber hat um seine Entlassung gebeten, nachdem der SDS ihm sein Verhalten während des Nationalsozialismus vorgeworfen hatte. Eine Sonderkommission der Bonner Universität hatte die Vorwürfe als nicht gerechtfertigt zurückgewiesen.","Bonner Professor bittet um Entlassung","","","",[1],1,[1],[3],2,"18","2"],["3541","1968-04-25","Die vier mutmaßlichen Täter der Kaufhausbrände (u.a. Baader, Ensslin) haben entgegen vorangegangener Meldungen doch nicht am außerordentlichen Delegiertenkongress des SDS im März in Frankfurt teilgenommen.","Nicht beim SDS-Kongreß","Kurz gemeldet","","",[9],1,[1],[2],2,"18","2"],["3542","1968-04-25","450 Studenten der Höheren Wirtschaftsfachschule Köln sind in einen Vorlesungsstreik getreten, um so ihren Protest gegen das geplante Akademie-Gesetz auszudrücken.","Streik aus Protest","","","",[4],1,[1],[2],2,"18","2"],["3543","1968-04-25","Der Gesundheitszustand von Rudi Dutschke habe sich weiter verbessert.","Es geht weiter bergauf","","","",[2],1,[1],[2],2,"18","3"],["3544","1968-04-25","Streit zwischen CDU und SPD über die Fortsetzung der Arbeit des Parlamentarischen Untersuchungsausschusses über die Studentenunruhen.","Kritik zurückgewiesen","","Löffler: Ausschuß soll \"global\" werten","",[1],1,[1],[3],2,"18","3"],["3545","1968-04-25","29 Professoren der FU Berlin kritisieren in einem Schreiben die Stellungnahme des FU-Rektors Harndt zu dem geplanten Universitätsgesetz, fordern mehr demokratische Strukturen an der Universität. Harndt weist die Vorwürfe zurück.","\"Konservative Ideologien\"","","","",[4],1,[1],[2],2,"18","7"],["3546","1968-04-25","Der Axel Springer Verlag hat eine Klage auf Schadensersatz in Höhe von mindestens 250.000 DM gegen Horst Mahler eingereicht. Mahler wird vorgeworfen, an der Spitze des Zuges gegen das Axel-Springer-Hochhaus in Berlin, Ostern 1968, marschiert zu sein.","Klage gegen Rechtsanwalt Mahler","","","",[6],1,[1],[2],2,"18","7"],["3547","1968-04-25","An der Kirchlichen Hochschule Berlin findet im Sommersemester 1968 keine Immatrikulationsfeier statt, nachdem mehrere Studenten die Ableistung des Immatrikulationsversprechens als Ausdruck der Manifestation der Ordinarien-Universität verweigert hatten.","Keine feierliche Immatrikulation","","","",[4],1,[1],[2],2,"18","7"],["3548","1968-04-25","Eine Diskussion zwischen Berlins Regierendem Bürgermeister Schütz und Vertretern der Studentenschaft ist fraglich, weil die APO darauf besteht, dass Meschkat und Lefèvre an der Diskussion teilnehmen. (Nur in der II. Fassung vom 25. April 1968.)","Diskussion mit Schütz in Frage gestellt","Schnell informiert","","",[1],1,[1],[2],2,"18","1"],["3549","1968-04-26","Die Diskussion zwischen Berlins Regierendem Bürgermeister Schütz und Vertretern der Berliner Studentenschaft wurde wegen der Forderung der APO, dass Meschkat und Lefèvre an der Diskussion beteiligt werden, abgesagt.","Unannehmbare Forderung der Radikalen","","","",[1],1,[1],[2],2,"28","1"],["3550","1968-04-26","Über die bevorstehenden Kundgebungen am 1. Mai. Die Berliner werden aufgefordert, der Kundgebung der APO fernzubleiben und sich auch nicht von dieser provozieren zu lassen, Warnung vor Selbstjustiz. Der Anspruch der APO, mit Arbeitern in Kontakt zu kommen, wird als realitätsfern zurückgewiesen. Indirekt wird der APO unterstellt, dass sie auf einen blutigen 1. Mai hoffe. Kritik am TU-Rektor und an Senator Stein, dass diese entgegen ihrer Ankündigungen nichts gegen die Raumnutzung der APO in der TU Berlin unternehmen, Kritik an der \"Süddeutschen Zeitung\" und der \"Zeit\", weil diese im Einklang mit Ulbrichts Zeitungen den \"Gegendemokraten\" Beifall zollen würden. Mahler und Meschkat werden namentlich erwähnt.","Ins Gewissen","","","Rudolf Stiege",[1],1,[5],[2],2,"28","2"],["3551","1968-04-26","Kritik am Senat und der Justiz für ihr vermeintlich zu schwaches Vorgehen gegen die Studentenunruhen. Die Teilnehmer der Unruhen würden gegen die Berliner Verfassung verstoßen und in den Fußstapfen der Nazis totalitäre Ziele verfolgen.","Quo vadis - Senat?","Leserbriefe","","Leser",[1],1,[6],[2],2,"28","2"],["3552","1968-04-26","Der SFB hat eine einstweilige Verfügung gegen Klaus Meschkat erlassen. Diesem wird unter Androhung einer Geldstrafe untersagt, zu behaupten, dass der SFB oder seine Nachrichtenradakteure Nachrichten manipulieren oder Lügen verbreiten würden.","SFB gegen Meschkat","","","",[1],1,[1],[2],2,"28","3"],["3553","1968-04-26","In einer kleinen Anfrage gibt Innensenator Neubauer bekannt, dass der Rektor der TU Berlin am 13.04.1968 zunächst die Polizei zum Einsatz auf dem Universitätsgelände angefordert habe, um diese kurz danach zum Rückzug zu bitten.","Neubauer: TU bat um Polizeieinsatz","","","",[1],1,[1],[2],2,"28","6"],["3554","1968-04-26","Stellungnahme des VDS zur verzögerten Neubesetzung eines Lehrstuhls am Institut für Publizistik der FU Berlin, Kritik an Rektor Harndt, dessen Vorwürfe, dass die Studentenschaft für die Verzögerung verantwortlich sei, wird scharf zurückgewiesen.","Studenten-Kritik an Rektor Harndt","","","",[4],1,[1],[2],2,"28","8"],["3555","1968-04-26","Der Münchner Kriminaldirektor Haering wirft der APO vor, die Ermittlungen bzgl. der Todesfälle von Frings und Schreck zu behindern. So hätte die Rechtshilfe der APO mehreren Zeugen geraten, die Aussage zu verweigern. Die APO würde anscheinend befürchten, dass die Täter aus den eigenen Reihen kommen.","Ermittlung behindert?","","","",[10,2],1,[1],[2],2,"28","8"],["3556","1968-04-26","Demonstration in Düsseldorf und Vorlesungsstreik in Nordrhein-Westfalen der Studenten der Ingenieur- und Höheren Wirtschaftsfachschulen wegen des Entwurfes für das geplante Akademiegesetz des Landes.","Unbefristeter Vorlesungsstreik","","","",[4],1,[1],[2],2,"28","8"],["3557","1968-04-26","Prof. Roman Herzog kritisiert scharf die Stellungnahme von 29 Professoren gegen die Erklärung der FU Berlin zum geplanten Universitätsgesetz.","Mit den Kritikern scharf ins Gericht gegangen","","FU-Professor beantwortet Attacke auf Gesetzentwurf","MM.",[4],1,[1],[2],1,"28","8"],["3558","1968-04-27","Gegen elf Demonstranten wurden Strafbefehle wegen der Beteiligung an den Osterunruhen im Zuge des Attentats auf Dutschke beantragt. Namentlich erwähnt werden Fritz Teufel und Rainer Langhans.","Staatsanwalt beantragt erste Strafbefehle","","","K.G.",[1],1,[1],[2],2,"14","1"],["3559","1968-04-27","Aufrufe an die Berliner zur Beteiligung an der Maikundgebung des Berliner Maikomitees 1968. Kurze Erwähnung der geplanten Kundgebung der APO.","Unmut in Bonn über lasches Verhalten der Alliierten","","Schütz in Babelsberg gestoppt - US-Regierung: Sehr ernste Lage","",[1],1,[1],[1],1,"14","1"],["3560","1968-04-27","Bundeskanzler Kiesinger kündigt ein Treffen mit dem Vorstand des VDS an; Willy Brandt spricht sich gegen Schnellgerichte, aber für die Verurteilung von straffälligen Demonstranten aus; das \"Berliner Bürgerkomitee\" um Heinrich Albertz und Harry Ristock sieht im studentischen Protest den Ausdruck einer allgemeinen Unruhe im Volk.","Kanzler spricht mit Studentenführern","","","",[1],1,[1],[2],2,"14","2"],["3561","1968-04-27","Der AStA der Staatlichen Ingenieur-Akademie Beuth in Berlin erklärt sich mit den streikenden Ingenieurstudenten in Nordrhein-Westfalen solidarisch. Zugleich sieht man auf Grund der progressiven Planung des Berliner Schulsenators von einem eigenen Streik ab.","Kein Streik geplant","","","",[4],1,[1],[2],2,"14","3"],["3562","1968-04-27","Der AStA der FU Berlin beruft für den 3. Mai eine Vollversammlung ein, bei der u.a. Rektor Harndt und Wissenschaftssenator Stein zu ihren Plänen zur Behebung der von den Studenten als misslich empfundenen Situation befragt werden sollen.","\"Mißliche Situation\"","","","",[4],1,[1],[2],2,"14","3"],["3563","1968-04-28","Die Berliner SPD ruft zur Teilnahme an der Freiheitskundgebung am 1. Mai auf, versteht diese als Antwort gegen die APO. Kritik aus Reihen der SPD, dass an der Veranstaltung der APO auch Gliederung der eigenen Partei teilnehmen. Willy Brandt kritisiert die demonstrierenden Studenten, diese würden nicht begreifen, dass ihre Schritte außenpolitische Folgen hätten und würden so tun, als wenn man auf einem eigenen Stern leben würde.","SPD: 1. Mai Antwort auf Provokation und Gewalt","","","",[1],1,[1],[3],2,"70","1"],["3564","1968-04-28","Die Jusos kritisieren den SDS für sein Verhalten im Wahlkampf in Baden-Württemberg. IG-Metall-Chef Brenner spricht sich gegen ein Verbot des SDS aus, dies würde den radikalen Kräften nur Auftrieb geben. Unruhen in Rom und Tokio. Während sich französische Studenten mit den deutschen Studenten solidarisch erklären, erklärten SDS-Funktionäre in Zürich, dass die Schweizer Studenten ihre Probleme selbst lösen müssten.","Jungsozialisten verurteilen SDS","","","",[1],1,[1],[2],2,"70","2"],["3565","1968-04-28","Über die an dem Tag stattfindende Landtagswahl in Baden-Württemberg. Die radikale Linke/ der SDS habe durch ihr jüngstes Verhalten der NPD das Sprungbrett in den Landtag geschaffen. Dazu eine Karikatur, eine dunkle Wolke \"Linker Radikalismus\" treibt die Windmühle NPD an.","Ein Test für die Demokratie","","","Rudolf Stiege",[8],1,[1,5,4],[2],1,"70","2"],["3566","1968-04-30","Der Berliner SPD-Vorsitzende Mattick ruft zur Teilnahme an der Freiheitskundgebung am 1. Mai auf. Der Kundgebung der APO unterstellt er Nähe zum Ulbricht-Regime. Die APO dagegen warnt vor der Teilnahme an der Friedenskundgebung, mit dem falschen Aussehen sei dies lebensgefährlich.","Klare Entscheidung von jedem Berliner am 1. Mai gefordert","","Aufruf zur Kundgebung vor dem Reichstag","",[1],1,[1],[1],2,"16","1"],["3567","1968-04-30","Über die Landtagswahl in Baden-Württemberg, die Radikalisierung der Bevölkerung erinnere an die Weimarer Republik, die linksextremistischen Osterunruhen hätten der NPD viele Wähler zugeführt, dies sei aber auch nicht der einzige Grund für den Stimmengewinn der NPD.","Kein Grund zur Panik","","","Rudolf Stiege",[8],1,[5],[2],2,"16","2"],["3568","1968-04-30","Berlins Regierender Bürgermeister Schütz muss aus Termingründen eine Fernsehdiskussion mit Vertretern der APO absagen. Stattdessen sollen nun Vertreter von CDU, FDP und SPD mit der APO diskutieren, die CDU lehnt dies ab.","Schütz mußte absagen","","Keine Diskussion mit der radikalen Linken","",[1],1,[1],[2],2,"16","2"],["3569","1968-04-30","Die Westdeutsche Rektorenkonferenz setzt sich für eine weitere Nutzung von Universitätsräumen durch Studenten für politische Veranstaltungen ein, solange dort keine kriminellen Handlungen beschlossen werden.","Universitäten stehen der Diskussion offen","","","",[1],1,[1],[2],2,"16","2"],["3570","1968-04-30","Ankündigung der Sondersitzung des Bundestages über die jüngsten Unruhen. Bundeskanzler Kiesinger diskutierte drei Stunden mit dem Vorstand des VDS.","Bundestag debattiert Unruhen","","Beratungen werden in der nächsten Woche fortgesetzt","dws.",[1],1,[1],[3],2,"16","2"],["3571","1968-04-30","TU-Studenten sagen vor dem Parlamentsausschuss für Wissenschaft und Kunst zu dem geplanten Universitätsgesetz aus, kritisieren dies und den gegenwärtigen Zustand an den Universitäten scharf.","\"Heilige Allianz der Herrschenden\"","","TU-Studenten vor dem Parlamentsausschuß","Michael L. Müller",[4],1,[1],[1],2,"16","5"],["3572","1968-04-30","Rudi Dutschkes Gesundheitszustand verbessert sich weiter.","Dutschke geht es besser","","Ärzte rechnen nicht mit bleibenden Schäden","",[2],1,[1],[2],2,"16","6"],["3573","1968-04-30","Die Studenten der \"Kritischen Universität\" kündigen eine höhere Aktivität unter den Berliner Bürgern an. Die KU versteht sich als Teil der APO.","\"KU\" will noch aktiver werden","","","",[1],1,[1],[2],2,"16","6"],["3574","1968-05-01","Verbot einer Versammlung des SDS und SHB in Bonn, Grund u.a. die Ankündigung das Programm für eine neue kommunistische Partei zu verteilen.","SDS-Versammlung verboten","Schnell informiert","","",[1],1,[1],[2],2,"16","1"],["3575","1968-05-01","Aufruf zur Freiheitskundgebung am 1. Mai; wird als Bekenntnis gegen die APO gewertet; deren Kundgebung würde mit Hilfe der SED abgehalten werden. Aufruf an die Bevölkerung, sich nicht von der APO provozieren zu lassen und keine Selbstjustiz zu üben.","Die besseren Argumente","","","",[1],1,[1],[2],1,"24","1"],["3576","1968-05-01","Über die Sondersitzung des Bundestages über die Studentenunruhen. Alle Parteien äußerten teils Verständnis, wollen künftig mehr mit der jungen Generation das Gespräch suchen, differenzieren zwischen Reformstudenten und Extremisten aus dem Umfeld des SDS. Für Innenminister Benda ist der SDS eindeutig verfassungsfeindlich, spricht sich aber gegen ein Verbot des SDS aus. Helmut Schmidt spricht von einer elitären Arroganz bei einigen Studenten, die genauso von Rechtsaußen kommen könnte.","Bundestag einig im Kampf gegen jeden Radikalismus","","Parteien wollen Gespräch mit der jungen Generation suchen","dws.",[1],1,[1],[1],2,"24","1"],["3577","1968-05-01","Über die Sondersitzung des Bundestages über die Studentenunruhen. Lob für die Reden von Helmut Schmidt und Ernst Benda. Letzterer habe Horst Mahler als Hauptverantwortlichen für die letzten Gewalttaten bloßgestellt. Dessen Tage als Rädelsführer der gegendemokratischen Opposition seien gezählt. Befürwortet, dass der SDS erstmal nicht verboten wird, sei momentan zwecklos. Differenzierung zwischen der großen Mehrheit der Studenten und dem kleinen extremistischen Kreis, welcher das demokratische Staatswesen zerstören wolle. Die unruhige Jugend müsse nun zeigen, ob sie die Hand annimmt, die ihr die Politiker angeboten haben. Dazu eine Karikatur, die die Berliner Bevölkerung zur Ruhe trotz der Unruhen aufruft. Der Berliner Bär wird von Insekten des SDS, der SED und der SED-Westberlin umschwärmt.","Eine Chance","","","Rudolf Stiege",[1],1,[1,5,4],[2],1,"24","2"],["3578","1968-05-01","Streit um die Neubesetzung der Professur am Institut für Publizistik der FU Berlin.","Professor Harndt widerspricht","","","",[4],1,[1],[2],2,"24","5"],["3579","1968-05-01","Über die Sondersitzung des Bundestages über die Studentenunruhen. Ausführlich zu den Reden u.a von Benda, Scheel, Barzel, Kiesinger und Schmidt. Für Innenminister Benda ist der SDS eindeutig verfassungsfeindlich, spricht sich aber gegen ein Verbot des SDS aus. Laut Benda schaukeln sich NPD und SDS gegenseitig hoch. Zahlen zu den Ermittlungsverfahren sowie zu der gesellschaftlichen Zusammensetzung der Beschuldigten (Alter, Beruf), Zahlen würden zeigen, dass es falsch wäre von Studentenunruhen zu sprechen. Walter Scheel kritisiert im Namen der FDP die Große Koalition, diese müsse endlich den berechtigten Kern der Unruhen aufgreifen. Scheel kritisiert weiter den Springer-Verlag. Helmut Schmidt spricht von einer elitären Arroganz bei einigen Studenten, die genauso von Rechtsaußen kommen könnte, und kritisiert den Slogan \"Enteignet Springer\". Barzel weist die Monopolvorwürfe gegenüber Springer zurück. Kiesinger schöpft Hoffnung aus der Unruhe der Jugend. Der VDS weist die Vorwürfe zurück, dass die Studentenunruhen ein Anwachsen der NPD-Stimmen bei der Landtagswahl in Baden-Württemberg bewirkt hätten, und dass das Ziel der Zerstörung der Demokratie sei.","Unruhen haben den Staat nicht bedroht/ \"Wir werden unsere Demokratie nicht wieder zerstören lassen\"","","Innenminister Benda gegen Verbot des SDS/ Der Bundestag debattierte über die Oster-Unruhen","",[1],1,[1],[1],1,"24","8,9"],["3580","1968-05-03","Einleitung eines Ehrengerichtsverfahrens gegen Horst Mahler. Der Generalstaatsanwalt strebt ein Berufsverbot für Mahler an.","Verfahren gegen Mahler","","","",[1],1,[1],[2],2,"26","1"],["3581","1968-05-03","Gegen das Hamburger SDS-Mitglied Karl-Heinz Roth ist ein Haftbefehl erlassen worden, u.a. weil er einen Polizisten getreten haben soll. Der SDS widerspricht dem, stattdessen sei Roth von dem Polizisten in den Unterleib getreten worden.","SDS-Führer verhaftet","Schnell informiert","","",[1],1,[1],[2],2,"26","1"],["3582","1968-05-03","Mehrere Studenten- und Jugendverbände, u.a. der VDS, kritisieren die Sondersitzung des Bundestags zu den jüngsten Unruhen, der Bundestag hat auf die Fragen der Jugend keine Antwort gefunden. Der SDS behält sich eine Klage gegen Innenminister Benda wegen dessen Behauptung, der SDS sei verfassungsfeindlich, vor.","VDS unzufrieden","","Studentenverband kritisiert Bundestag","",[1],1,[1],[3],2,"26","2"],["3583","1968-05-03","Kritik an der Maikundgebung der APO und deren Zusammenarbeit mit der SED West-Berlin.","Zwei Maikundgebungen","Leserbriefe","","Leser",[1],1,[6],[2],2,"26","2"],["3584","1968-05-03","Die Maikundgebung der APO habe endgültig offensichtlich gemacht, dass diese kommunistisch unterwandert sei. Spricht von einer kommunistischen Verschwörung gegen West-Berlin. Horst Mahler wird als Einpeitscher gegen die rechtsstaatliche Ordnung und eigentlicher Führer der \"antiparlamentarischen Opposition\" bezeichnet. Mahler wird Bündnis mit den Kommunisten vorgeworfen. Die Brandfackeln, die am Gründonnerstag gegen den Springer-Verlag geflogen sind, seien aus Ost-Berlin geliefert worden. Die APO sei stalinistisch.","Arm in Arm mit der SED","","","Rudolf Stiege",[1],1,[5],[2],2,"26","2"],["3585","1968-05-03","Vertreter der FU-Assistenten sagen vor dem Parlamentsausschuss für Wissenschaft und Kunst zum geplanten Universitätsgesetz sowie zur aktuellen Situation an den Hochschulen aus.","\"Bedrückende Abhängigkeit vom Inhaber des Lehrstuhls\"","","Vertreter der FU-Assistenten vor dem Parlamentsausschuß","Michael L. Müller",[4],1,[1],[1],2,"26","6"],["3586","1968-05-03","Über die Friedenskundgebung am 1. Mai, insbesondere zu den Reden von Brandt und Schütz, die beide auch knapp auf die jüngsten Unruhen eingehen.","Brandt ruft zur Toleranz auf beiden Seiten auf","","Friedliche Maikundgebung auf dem Platz der Republik","LUK",[1],1,[1],[1],1,"26","7"],["3587","1968-05-03","Über die Maikundgebung der APO, ca. 25.000 Teilnehmer, betont wird die Teilnahme der SED-West-Berlin. Als Gastredner trat u.a. Giancomo Feltrinelli auf. Es sei zu Auseinandersetzungen mit Andersdenkenden gekommen.","Schüler und rote Fahnen","","SED marschierte bei der Gegenkundgebung mit","",[1],1,[1],[2],1,"26","7"],["3588","1968-05-03","Ausführlich über die seit Jahren anstehende Neubesetzung des Lehrstuhls für Publizistik an der FU Berlin und den deshalb stattfindenden Streik der Publizistikstudenten. Verständnis für die Studenten.","Publizistik-Studenten nennen gute Gründe zum Streik","","Kein Ordinarius - Bedrängte Platzverhältnisse","Michael L. Müller",[4],1,[1],[1],1,"26","22"],["3589","1968-05-04","Der Rektor der TU Berlin, Prof. Weichselberger, hat Strafanzeige gegen fünf nichtstudentische Mitglieder der APO gestellt. Grund ist die aktive Teilnahme an einer nicht genehmigten Diskussionsveranstaltung in der TU während der Osterunruhen. Unter den fünf sind Horst Mahler und Klaus Meschkat.","TU-Rektor stellt fünf Strafanträge","","","",[1],1,[1],[2],2,"20","1"],["3590","1968-05-04","Der Hamburger SDS-Funktionär Karl-Heinz Roth ist aus der Haft entlassen worden.","SDS-Funktionär entlassen","Kurz gemeldet","","",[1],1,[1],[2],2,"20","2"],["3591","1968-05-04","Der Hamburger Senat erteilt Prof. Spuler für seinen Ausruf \"Ihr gehört alle ins KZ\" gegenüber Studenten einen Verweis. Der Ausruf sei jedoch nur in Erregung zu Stande gekommen und spiegele nicht die Einstellung von Prof. Spuler wider.","Verweis für Professor","Kurz gemeldet","","",[1],1,[1],[2],2,"20","2"],["3592","1968-05-04","Die Linke würde der Rechten Auftrieb verschaffen, Vergleich mit der Weimarer Republik.","Die Linke schafft der Rechten Auftrieb","Leserbriefe","","Leser",[1],1,[6],[2],2,"20","2"],["3593","1968-05-04","Der zurückgetretende AStA-Vorsitzende der FU Berlin, Landsberg, wurde zum stellv. Konventsvorsitzenden gewählt. Auf der vorangegangenen Sitzung habe es Landsberg ausdrücklich ausgeschlossen, sich von symbolischer Gewalt gegen Sachen und Kontakten mit der SED zu distanzieren.","Landsberg zweiter Konvents-Präsident","","","",[1],1,[1],[2],2,"20","3"],["3594","1968-05-04","Mehrere Professoren stellten sich in einer Vollversammlung der FU Berlin den Studenten und nahmen zu Hochschulthemen Stellung, u.a. zum Berufungsverfahren für den Lehrstuhl der Publizistik.","Professoren stellten sich","","Studenten-Vollversammlung an der Freien Universität","Michael L. Müller",[1],1,[1],[5],2,"20","3"],["3595","1968-05-05","Die Wahl des neuen AStA-Vorsitzenden der FU Berlin wurde ergebnislos abgebrochen. Favoritin sei Sigrid Fronius vom SDS. Diese habe sich weder von der Gewalt noch von Aktionsgemeinschaften mit der SED distanziert. Zudem wolle sie sich auch nicht für das parlamentarische Regierungssystem aussprechen.","Noch kein Nachfolger","","Wahl des FU-AStA-Vorsitzenden unterbrochen","MM.",[1],1,[1],[2],2,"70","3"],["3596","1968-05-07","Die Bundesregierung will prüfen lassen, ob der VDS ein politisches Mandat hat.","Bonn will prüfen","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["3597","1968-05-07","Ankündigung, dass der Bundestag seine Sondersitzung zu den Osterunruhen fortsetzt.","Bundestag setzt Sondersitzung fort","","","",[1],1,[1],[3],2,"14","1"],["3598","1968-05-07","Bericht über die Unruhen an der Pariser Sorbonne. In Frankfurt demonstrierten 1500 Studenten vor dem Generalkonsulat Frankreichs gegen die Schließung der Sorbonne. Der AStA der TU und der FU Berlin erklärte sich jeweils solidarisch mit den Pariser Studenten, dem französischen Generalkonsulat in West-Berlin wurde ein Protestschreiben gegen die Unterdrückung der Pariser Studenten überreicht.","Straßenschlacht vor der Sorbonne","","Französische Zeitungen gegen Krawalle","",[1],1,[1],[2],1,"14","1"],["3599","1968-05-07","Berlins Bürgermeister Neubauer konstatiert eine Unterwanderung der SPD durch Mitglieder der APO, welche die Partei von innen zerstören wollen. Neubauer fordert scharfes Vorgehen dagegen. Auch Senator Stein äußert sich ähnlich und fordert eine scharfe Abgrenzung zur APO.","Neubauer: SPD wird unterwandert/ Landesausschuß der SPD tagt","","","",[11],1,[1],[2],2,"14","1,5"],["3600","1968-05-07","Der SDS fordert die West-Berliner SED zu einer Diskussion über den Stalinismus und die Arbeiterdemokratie auf. Sollte es zu dieser Diskussion nicht kommen, sieht man von weiteren Aktionen mit der SED ab.","SDS fordert die SED zur Diskussion auf","","Debatte über den Stalinismus vorgeschlagen","",[9,8],1,[1],[2],2,"14","2"],["3601","1968-05-07","Müchner und Heidelberger Studenten initiieren Desertationskampagnen vor US-amerikanischen Kasernen.","Studenten rufen zur Fahnenflucht auf","","","",[1],1,[1],[2],2,"14","2"],["3602","1968-05-07","Über den Vietnamkrieg, dieser sei wie jeder Krieg grausam, aber im Gegensatz zum Vietkong würden die USA Mord nicht als Mittel der Einschüchterung benutzen. Kritik an der \"gegendemokratischen Opposition\", dass sie nicht die Verbrechen des Vietkong anprangert.","Die Mörder","","","Rudolf Stiege",[1],1,[5],[2],2,"14","2"],["3603","1968-05-08","Fortsetzung der Sondersitzung des Bundestages zu den Oster- und Studentenunruhen. Alle Beteiligten sind sich in der Forderung nach einer umfassenden Hochschulreform einig. Bundesforschungsminister Stoltenberg äußert zum Teil Verständnis für die Kritik und Unruhe der Jugend. Zugleich kritisiert er die Professoren Abendroth, Flechtheim, Hofmann, Maus und Ridder, welche durch bösartige Agitation die Studentenschaft radikalisiert hätten.","Bund und Länder einig: Reform der Hochschulen","","Minister-Kritik an Professoren","dws.",[1],1,[1],[1],2,"18","1"],["3604","1968-05-08","Der SDS fordert die Einrichtung von Lehrstühlen für Marxismus an allen Hochschulen. Der VDS kritisiert die Bundesregierung für die Prüfung des politischen Mandats des Verbandes. Bundeskanzler Kiesinger hätte dieses bereits stillschweigend bestätigt.","SDS-Forderung","Kurz gemeldet","","",[1],1,[1],[2],2,"18","2"],["3605","1968-05-08","Über die Fortsetzung der Sondersitzung des Bundestages zu den Studentenunruhen. Konstatiert die Notwendigkeit einer Hochschulreforme und Versäumnisse der Politik.","Hochschulreform nicht ohne Bund","","","Rudolf Stiege",[4],1,[5],[2],2,"18","2"],["3606","1968-05-08","Der Berliner Landesverband kritisiert scharf die CDU, deren Haltung sei größtenteils obrigkeitsstaatlich, ihre einzige Forderung der Polizeiknüppel. U.a. wird die Entmachtung des Springer-Konzerns gefordert.","RCDS stellt sich gegen die CDU ","","","",[1],1,[1],[2],2,"18","2"],["3607","1968-05-08","Über Ermittlungsverfahren und Strafbefehle im Zuge der Osterunruhen in West-Berlin. Zudem muss sich Peter Brandt wegen dem Vorwurf des Auflaufs am 27. November 1967 vor dem Jugendgericht verantworten.","Bald erste Verhandlungen","","26 Strafbefehle wegen Auflaufs beantragt","K.G.",[1],1,[1],[2],2,"18","3"],["3608","1968-05-08","Ausführlicher Bericht zur Fortsetzung der Sondersitzung des Bundestages zu den Oster- und Studentenunruhen. Alle Beteiligten sind sich in der Forderung nach einer umfassenden Hochschulreform einig. Bundesforschungsminister Stoltenberg äußert zum Teil Verständnis für die Kritik und Unruhe der Jugend. Zugleich kritisiert er die Professoren Abendroth, Flechtheim, Hofmann, Maus und Ridder, welche durch bösartige Agitation die Studentenschaft radikalisiert hätten. Stoltenberg greift den VDS an, dieser kritisiert wiederum den Minister.","Bundesminister Stoltenberg: Das Gespräch mit der Jugend suchen","","Regierung kündigt im Parlament aktive Hochschulpolitik an","",[1],1,[1],[1],1,"18","7"],["3609","1968-05-08","Kritik an der Berichterstattung von \"Stern\" und \"Zeit\" über die Osterunruhen, diese würden Tatsachen verdrehen.","Man merkt die Absicht und ist verstimmt/ Ein Stern-Bild","","","",[1],1,[1],[5],1,"18","8"],["3610","1968-05-09","Bericht über die Unruhen in Paris. Nach der vorläufigen Schließung der Sorbonne solle diese wieder geöffnet werden.","Sorbonne öffnet wieder","","","",[1],1,[1],[2],2,"22","1"],["3611","1968-05-09","Wegen der Störung der Gedenkfeier für die Geschwister Scholl wird es in München im Sommersemester 1968 erstmals keine traditionellen Eröffnungsfeierlichkeiten geben.","Keine Feier in München","Kurz gemeldet","","",[1],1,[1],[2],2,"22","2"],["3612","1968-05-09","Der Bayernkurier veröffentlichte ein Aktionsprogramm des SDS, nach dem dieser eine Räterepublik anstrebt. Laut Bayernkurier sei der SDS die fünfte Kolonne von Ulbricht.","\"Exerzierfeld West-Berlin\"","","","",[1],1,[1],[2],2,"22","2"],["3613","1968-05-09","Über die Studentenunruhen in Paris. Diese seien weitgehend auf Grund der Reformbedürftigkeit der Universitäten berechtigt. Cohn-Bendit wird als Dutschke von Paris identifiziert. Keine Kritik an den Aktionen der Studenten!","Ein Schlag für General de Gaulle","","","Rudolf Stiege",[1],1,[1],[2],2,"22","2"],["3614","1968-05-09","Der Akademische Senat der FU Berlin lehnt den Vorschlag des AStA-Vorsitzenden Landsberg ab, den 15. Mai zu einem dies academicus zu machen und dort Diskussionen über die Notstandsgesetze stattfinden zu lassen.","Abgelehnt","","","",[1],1,[1],[2],2,"22","3"],["3615","1968-05-09","Der erste Prozess gegen Polizeibeamte wegen Körperverletzung im Zuge des Schahbesuchs. Zwei Polizisten wurden wegen Körperverletzung im Amt an einem Studenten während des 2. Juni 1967 zu einer Gefängnisstrafe von vier Monaten mit Bewährung verurteilt.","Erst \"verfrachtet\" - dann verprügelt","","Gericht verurteilte zwei Polizisten zu Gefängnis","M.K.",[1],1,[1],[1],2,"22","3"],["3616","1968-05-09","Reaktion der Berliner CDU auf die scharfe Kritik des RCDS an ihr (siehe Berliner Morgenpost vom 8.5.1968)","CDU: Nicht überbewerten","","","",[1],1,[1],[2],2,"22","8"],["3617","1968-05-09","Kritik an der Berichterstattung des \"Spiegel\" über die Studentenunruhen und die dagegen eingesetzte Polizei. Der \"Spiegel\" würde den Staat und all seine Institution bzw. ihm loyal gegenüberstehende Einrichtungen wie den Springer-Verlag hassen und seine Leser gegen den Staat verhetzen. (Reaktion auf die Artikel \"Im Amt verleitet\" und \"Eine 'Bild'-Schlagzeile ist mehr Gewalt als ein Stein am Polizisten-Kopf\" im \"Spiegel\" vom 6.5.1968. )","Polizei und Justiz in der Sprache des 'Spiegel'","","","CW",[1],1,[1],[2],2,"22","8"],["3618","1968-05-10","Erneuter Haftbefehl gegen das Hamburger SDS-Mitglied Karl-Heinz Roth.","Wieder Haftbefehl","Kurz gemeldet","","",[1],1,[1],[2],2,"28","2"],["3619","1968-05-10","3000 Ingenieurstudenten in Schleswig-Holstein treten in einen dreitägigen Sympathiestreik für ihre ebenfalls streikenden Kommilitonen in Nordrhein-Westfalen. Zudem fordern sie den Rücktritt von Forschungsminister Stoltenberg als Privatdozent an der Universität Kiel.","Sympathie-Streik","Kurz gemeldet","","",[4],1,[1],[2],2,"28","2"],["3620","1968-05-10","Die Bundesanwaltschaft hat Ermittlungen gegen die APO in West-Berlin eingeleitet. Nach CSU-Darstellung sei der Artikel über die Pläne des SDS für eine Räterepublik dafür der Anlass (siehe Berliner Morgenpost vom 9.5.1968). Der Berliner Justizsenator Hoppe widerspricht dieser Darstellung.","Ermittlungen gegen den SDS","","","",[1],1,[1],[2],2,"28","2"],["3621","1968-05-10","Über die Situation der Medizinalassistenten/ Medizinstudenten, die meist ohne Gehalt im Krankenhaus arbeiten müssen. Reformforderungen des Marburger Bundes.","Studenten müssen ohne Geld im Krankenhaus arbeiten","","Denn die Stellen für Medizinalassistenten sind knapp","G. L.",[4],1,[1],[1],2,"28","6"],["3622","1968-05-10","Wahl von Sigrid Fronius zur neuen AStA-Vorsitzenden der FU Berlin. Jürgen Wohlrabe, Vorsitzender der Jungen Union, kritisiert deren Wahl. Es sei unfassbar, dass die große Mehrheit reformwilliger Studenten von einem SDS-Mitglied repräsentiert werde. ","Sie leitet den AStA","","SDS-Studentin zur Vorsitzenden gewählt","MM.",[4],1,[1],[2],1,"28","6"],["3623","1968-05-10","300 Demonstranten vor dem Französischen Konsulat in West-Berlin protestieren für die Freilassung der in Paris festgenommenen Studenten.","300 Personen protestieren","","","",[1],1,[1],[2],2,"28","6"],["3624","1968-05-11","In einer neuen Broschüre würde der SDS sich eindeutig zur Gewalt bekennen, insbesondere gegen den Springer-Verlag. Rechtfertigung des Vorgehens gegen Presse und Funk, diese würden Lügen als Waffe gegen den SDS und seine Sympathisanten einsetzen. ","Der SDS bekennt sich zur Gewalt/ \"Die Steine sollen treffen\"","","","",[1],1,[1],[2],2,"14","1,2"],["3625","1968-05-11","Zum ersten Mal fand die Rektoratsübergabe der Universität Göttingen unter Ausschluss der Studentenschaft statt. Diese karikierte vor der Universität die traditionelle Übergabe.","Feier ohne Studenten","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["3626","1968-05-11","Der AStA der TU Berlin ist zurückgetreten, nachdem ihm gegenüber zuvor mehrheitlich das Misstrauen ausgesprochen wurde. Hintergrund sei die positive Einstellung des AStA-Vorsitzenden Wethekams zur SED.","AStA der TU zurückgetreten","","","",[11],1,[1],[2],2,"14","5"],["3627","1968-05-11","Bundestagsreden zu der geplanten Notstandsgesetzgebung und dem dagegen angekündigten Sternmarsch. Politiker von CDU und SPD kritisieren Sternmarsch und die APO für ihre Einstellung zur Notstandsgesetzgebung. Laut dem CDU-Bundestagsabgeordneten Even sei der Sternmarsch kommunistisch unterwandert.","Notstandsgesetze sind kein \"Abmarsch in die Diktatur\"","","\"Sternmarsch\"-Teilnehmer kommunistisch unterwandert","",[1],1,[1],[1],1,"14","7"],["3628","1968-05-12","Bevorstehender Generalstreik in Frankreich und schwere Unruhen in Paris. Gewerkschaften stehen hinter den französischen Studenten. Der VDS erklärt sich mit den französischen Studenten solidarisch und verurteilt das \"brutale Vorgehen\" der Polizei.","Explosive Lage in Paris. Generalstreik ausgerufen","","Gewerkschaften unterstützen Studenten - De Gaulle greift ein","",[1],1,[1],[1],1,"66","1"],["3629","1968-05-12","Der Vorsitzende der Gewerkschaft Bau redet von einer winzigen revolutionären Minderheit in der Studentenschaft, von der man sich nicht zu Emotionen gegen die Studenten allgemein hinreißen lassen will. Absage an ein revolutionäres Bündnis zwischen Arbeitern und Studenten. Kritik auch an den Professoren und ihren autokratischen Zügen, die für die Unzufriedenheit der Studenten verantwortlich seien.","Professoren scharf kritisiert","","","",[1],1,[1],[2],2,"66","1"],["3630","1968-05-12","Sternmarsch der Notstandsgegner auf Bonn, anschließende Großkundgebung, u.a. mit Heinrich Böll. Keine Ausschreitungen. Namentlich erwähnt wird Karl-Heinz Roth, gegen den ein Haftbefehl vorliegt. Die DDR-Bürger hätten für die Parolen der West-Berliner Teilnehmer bei deren Durchfahrt durch die DDR kein Verständnis gehabt.","\"Sternmarsch\" durch Bonn ohne Zwischenfälle/ \"Deutsche Bürger, trinkt deutschen Wein\"","","Rote Fahnen und Transparente beherrschten die Stadt/ Auch Winzer und Bauern marschierten in Bonn mit","dws.",[1],1,[1],[5,1],2,"66","1,2"],["3631","1968-05-12","Studentenunruhen und Generalstreik in Paris, Bündnis Arbeiter und Studenten. Stiege sieht mit einem Schaudern eine vorrevolutionäre Situation in Frankreich, zieht aber keine Parallele nach Deutschland, sieht vielmehr De Gaulles Ansehen beschädigt.","Dunkle Wolken über Frankreich","","","Rudolf Stiege",[1],1,[5],[2],2,"66","2"],["3632","1968-05-12","In Belgrad und Den Haag fanden Demonstrationen für die deutsche APO und ihren Kampf gegen die Notstandsgesetzgebung statt.","Demonstration vor Bonner Botschaft","","","",[1],1,[1],[2],2,"66","2"],["3633","1968-05-14","Die Marburger Studenten-Union (MSU) wurde als Alternative zum VDS gegründet.","Alternative zum VDS","Kurz gemeldet","","",[4],1,[1],[2],2,"14","2"],["3634","1968-05-14","Linksextreme Studenten würden Erstsemestler mit Studienberatungen indoktrinieren, marxistisch-kommunistische Wühlarbeit betreiben sowie durch Tutorien gezielt die Autorität der Lehrkräfte schwächen.","Zur Lage an der Freien Universität","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3635","1968-05-14","Der VDS fordert alle Rektoren auf, den Vorlesungsbetrieb an den Universitäten am Tag der zweiten Lesung über die Notstandsgesetzgebung einzustellen. Der Rektor der FU Berlin verweigert dies.","Notstands-Entwurf noch umstritten","","Zahreiche Änderungsanträge erwartet","dws.",[1],1,[1],[2],2,"14","2"],["3636","1968-05-14","Der AStA der TU Berlin bestreitet eine Zusammenarbeit mit der SED West-Berlin. Das Studentenparlament der TU Berlin hat einen Antrag verabschiedet, nach dem mit der SED West-Berlin nicht zusammengearbeitet werden kann, solange diese den Kurs der SED Ost unterstützt. Mahler, Meschkat und Nevermann befürworten dagegen eine Zusammenarbeit der APO mit der SED West-Berlin.","TU-AStA bestreitet Liaison mit SED","","","",[9,11],1,[1],[2],2,"14","9"],["3637","1968-05-14","Die APO kündigt Aktionen gegen die Fernsehanstalten an, Grund ist die Berichterstattung über den Sternmarsch auf Bonn. Das Fernsehen sei auf dem Weg zum Staatsfernsehen, weshalb die Aktionen über Springer hinaus ausgedehnt werden müssten.","Jetzt auch Kritik am Fernsehen","","","",[1],1,[1],[2],2,"14","9"],["3638","1968-05-14","An der FU Berlin ist es nach einem Vortrag von Herbert Marcuse zu Ausschreitungen gekommen, linksradikale Studenten hätten wegen der Weigerung des Rektors, am Tag der Entscheidung über die Notstandsgesetze die Vorlesungen ausfallen zu lassen, das Wappenschild der FU verbrannt und Scheiben des Rektorats eingeschmissen. (Nur in der zweiten Fassung der Ausgabe)","In der Nacht: Ausschreitungen an der FU","","","",[1],1,[1],[2],2,"14","1"],["3639","1968-05-15","Der VDS kündigt Vorlesungsstreiks an allen Universitäten an, damit die Studenten die Notstandsdebatte über Rundfunk oder Fernsehen in den Hörsälen verfolgen können. Unterschiedliche Reaktionen von den Rektoren der Universitäten. Erneuter Bericht über die Ausschreitungen an der FU nach dem Vortrag von Marcuse. Senator Stein kritisiert die Verbrennung des Wappens der FU Berlin. Anzeige gegen unbekannt wurde bereits erstattet, verdächtigt werden u.a. Teufel und Kunzelmann.","Vorlesungsstreik in den Hochschulen/ Der FU-Rektor erstattet Anzeige gegen Unbekannt","","Stein empört über Ausschreitungen an der FU","",[1],1,[1],[5],1,"16","1,3"],["3640","1968-05-15","\"Männer vom Bau\" äußern ihr Unverständnis über die Studentenunruhen, das Ziel der Studenten, sich mit Arbeitern zu verbünden, sei nur zu belächeln.","Männer vom Bau","Leserbriefe","","",[1],1,[6],[2],2,"16","2"],["3641","1968-05-15","In Kiel verhinderten Studenten die feierliche Rektoratsübergabe, indem sie sich mit falschen Eintrittskarten Einlass in den Festsaal verschafften.","Feier abgesagt","","","",[1],1,[1],[2],2,"16","2"],["3642","1968-05-15","Über die Notstandsgesetzgebung, diese wird bereits als zu liberal und kompliziert empfunden, sie sei jedoch dringend notwendig.","Bonns liberales Notstandsrecht","","","Dietrich W. Schulz",[1],1,[1],[2],2,"16","2"],["3643","1968-05-15","Im Audimax der FU Berlin fand eine Diskussion mit Vertretern der Ärztekammer über die Situation der Medizinalassistenten statt, Studenten und Medizinalassistenten forderten grundlegende Reformen.","Reformen gefordert","","","",[4],1,[1],[2],2,"16","3"],["3644","1968-05-16","Die ersten Prozesse im Zuge der Demonstrationen gegen den Besuch des Schahs vom 2. Juni 1967 stehen kurz vor dem Beginn.","Die ersten Prozesse","Schnell informiert","","",[1],1,[1],[2],2,"18","1"],["3645","1968-05-16","Trotz Haftbefehls konnte Karl Heinz Roth auf einer Studentenkundgebung in Hamburg sprechen.","Trotz Haftbefehls frei","Schnell informiert","","",[1],1,[1],[2],2,"18","1"],["3646","1968-05-16","Gruppen der APO rufen zu einem allgemeinen Streik gegen die endgültige Verabschiedung der Notstandsgesetze auf. Der Vorlesungsstreik an den Universitäten während der zweiten Lesung des Bundestages über die Notstandsgesetze sei uneinheitlich befolgt worden, an der FU und TU Berlin hätten Studenten mehrere Vorlesungen gestürmt und zum Abbruch gezwungen. An der Universität Frankfurt sei es zu schweren Ausschreitungen gekommen. Schwere Auseinandersetzungen zwischen Studenten auch an der FU Berlin, Tränengasbomben wurden geworfen, Kritik an den Vorlesungstreiks des AStA.","Die Notstandsgegner wünschen Generalstreik/ Tränengasbombe leerte das Audimax","","Vorlesungsboykott nur zum Teil befolgt/ Heftige Auseinandersetzung an der FU","",[1],1,[1],[5,1],1,"18","1,3"],["3647","1968-05-16","Kommentar zur zweiten Lesung der Notstandsgesetzgebung","Wiederholungen schreckten nicht","","","",[1],1,[1],[2],2,"18","2"],["3648","1968-05-16","Anklagen gegen Polizisten und Demonstranten im Zuge der Demonstrationen gegen den Besuch des Schahs am 2. Juni 1967.","Polizisten angeklagt","","","",[1],1,[1],[2],2,"18","3"],["3649","1968-05-16","West-Berliner Medizinstudenten forden auf dem Deutschen Kongress für ärztliche Fortbildung Berlins Regierenden Bürgermeister Schütz zu Stellungnahmen zu Fragen der Krankenhaus- und Studienreform auf. Umfangreiche Reformen werden gefordert.","Schütz soll sich zur Studienreform äußern","","Medizinstudenten fordern einschneidende Änderungen","M.M.",[4],1,[1],[2],2,"18","6"],["3650","1968-05-16","Blockade der Universität Frankfurt seitens des SDS im Zuge der zweiten Lesung der Notstandsgesetze. Auseinandersetzungen mit anderen Studenten, Sachbeschädigungen, Rektor Ruegg kündigt Strafanzeigen an. Krahl kündigte mehrtägige Blockade der Uni an, will aber von einer Stürmung der Uni absehen, weil es sonst zu Auseinandersetzungen mit \"faschistischen Studentengruppen\" kommen könnte. In Hamburg beteiligten sich etwa zwei Drittel der Studenten an den Streiks, keine Vorfälle, auch an zahlreichen weiteren Universitäten kam es zu Streiks und Demonstrationen.","Frankfurts Universität wird vom SDS blockiert","","\"Streikposten\" vor den Türen","",[1],1,[1],[5],1,"18","9"],["3651","1968-05-16","Eine an der Brandeis-Universität bei Boston angekündigte Demonstration gegen den Springer Verlag musste wegen mangelnder Teilnahme abgesagt werden. Hintergrund ist die Stiftung einer Professur für westeuropäische Zeitungsgeschichte durch Axel Springer. Zunächst war seitens des \"Spiegel\" berichtet worden, dass die Hälfte der Studenten und Professoren sich gegen Springer ausgesprochen hätten.","Nur 75 von 2800 Studenten protestierten","","Fragwürdige Angaben über Stiftung","",[1],1,[1],[3],2,"18","11"],["3652","1968-05-17","Vereinzelte Proteste von Studenten gegen die Verabschiedung der Notstandsgesetze im gesamten Bundesgebiet, in Frankfurt kam es zur Fortsetzung der Blockade der Universität, Auseinandersetzungen zwischen Studenten, die SDS-Vorsitzenden Karl-Dietrich und Frank Wolff nannten die Studenten, die die Blockaden geräumt hatten, \"rechte Faschisten\". Sechs Professoren schließen sich dem Aufruf an, den 29. Mai zum Tag der Demonstration gegen die Notstandsgesetzgebung zu machen (u.a. Gollwitzer und Bloch). ","Barrikade vor Frankfurter Universität/ Rosenberg kontert hessischen DGB","","CDU: Notstandsgegner unsachlich","",[1],1,[1],[3,1],1,"20","1,2"],["3653","1968-05-17","Strafanträge gegen 20 Kölner Demonstranten im Zuge der Osterunruhen, nur zwölf der Beschuldigten seien Studenten.","Strafantrag gegen 20 Demonstranten","","","",[1],1,[1],[2],2,"20","2"],["3654","1968-05-17","Scharfe Distanzierung der IG Metall von der Außerparlamentarischen Opposition. Man wird auch im Kampf gegen die Notstandsgesetze nicht zusammenarbeiten. Es wird die Frage aufgeworfen, wann Horst Mahler es für notwendig hält, wie mit der SED auch mit der NPD zu paktieren.","IG Metall distanziert sich von Radikalen","","","",[1],1,[1],[2],2,"20","2"],["3655","1968-05-17","Kritik am Demonstrationsverbot der NPD, diese sei so schwach, dass man sie verkraften könne, es werde in Bezug auf linke Demonstrationen mit zweierlei Maß gemessen. Dazu eine Karikatur: Auf dem Misthaufen \"Linker Radikalismus\" gedeiht das Unkraut NPD mit dem Kopf Hitlers als Blüte.","Eine Mücke","","","Rudolf Stiege",[9],1,[1,5,4],[2],1,"20","2"],["3656","1968-05-17","Der AStA der FU Berlin lehnt kurzfristig ein Gespräch mit der CDU-Fraktion des Berliner Abgeordnetenhauses über das neue Universitätsgesetz ab, weil man dies nicht hinter verschlossenen Türen durchführen wolle. Auch die Anwesenheit der Presse genüge auf Grund ihres gestörten Verhältnisses zur studentischen Öffentlichkeit nicht. Die CDU kritisierte die Entscheidung.","Studenten lehnen Gespräch ab","","","",[4],1,[1],[2],2,"20","3"],["3657","1968-05-17","Harry Pross soll die seit mehreren Jahren freie Professur für Publizistik an der FU Berlin übernehmen. Die Nichtbesetzung hatte zu einem Streik der Publizistikstudenten geführt.","Harry Pross zum Ordinarius berufen","","","",[4],1,[1],[2],2,"20","3"],["3658","1968-05-17","Ankündigung einer SFB-Reihe zum Thema \"Hochschule und Gesellschaft\".","Aktuelles Thema","","","",[4],1,[1],[2],2,"20","3"],["3659","1968-05-17","Austritt von zwölf Mitgliedern der FU-Gruppe des RCDS um Jürgen-Bernd Runge, nachdem der Vorstand des RCDS an der FU deren Ausschluss empfohlen hatte. Vorgeworfen wurde ihnen verbandschädigendes Verhalten.","Beim RCDS gab's Krach","","","",[4],1,[1],[2],2,"20","5"],["3660","1968-05-17","Vor dem Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kunst sagten die drei Professoren Herzog, Schütte und Rossow zu dem geplanten Universitätsgesetz aus.","\"Universitätspräsidenten wie Manager bezahlen\"","","Professoren kritisieren veraltete Methoden","MM.",[4],1,[1],[1],1,"20","9"],["3661","1968-05-18","Der AStA der Pädagogischen Hochschule München erklärt seinen Austritt aus dem VDS, auch der AStA der Universität Clausthal kündigt diesen Schritt an. Hintergrund ist der Streit um das Politische Mandat.","Benda warnt den DGB","","\"Politischer Streik ist verfassungswidrig\"","",[4],1,[1],[3],2,"14","2"],["3662","1968-05-18","Rektoratsübergabe an der Pädagogischen Hochschule Berlin, Studenten kritisieren die Forderungen nach Hochschulreformen als Taschenspielertricks, Hochschulreform könne nur Gesellschaftsänderung heißen.","Neuer Rektor der PH im Amt","","","",[1],1,[1],[2],2,"14","5"],["3663","1967-05-18","Urteil des OVG Berlin, dass auch Zuschauer von Demonstrationen unter Umständen als Demonstranten angesehen werden können und die Polizei bei nicht genehmigten Demonstrationen dementsprechend gegen diese vorgehen kann. Hintergrund war ein Vorfall vom 3. Juni 1967 im Zuge der Demonstrationen gegen den Schah-Besuch.","Wer zusieht, kann als Demonstrant gelten","","Wichtiges Urteil des Oberverwaltungsgerichts","",[1],1,[1],[2],2,"14","5"],["3664","1968-05-18","Neuwahl des AStA der TU Berlin.","Neue Vertretung der TU-Studenten","","","",[4],1,[1],[2],2,"14","6"],["3665","1968-05-18","Bericht eines Studenten der Juristischen Fakultät der FU Berlin über die Sprengung von Klausuren und Vorlesungen seitens linker Studenten. Diese seien mehrfach gewalttätig gegen andersdenkende Studenten vorgegangen.","\"Jünger der Gewaltlosigkeit\"","","","Michael Mutz",[1],1,[6],[2],2,"14","9"],["3666","1968-05-19","Bericht über die Unruhen in Paris.  ","Frankreich vor dem Chaos. Streiks lähmen das Land","","De Gaulle brach Rumänien-Besuch vorzeitig ab","",[1],1,[1],[1],2,"68","1"],["3667","1968-05-19","Nur zwei der im Februar 1968 vom parlamentarischen Untersuchungsausschuss mit einer Geldstrafe belegten SDS-Mitglieder haben ihre Strafe bezahlt (Gäng und Nitsch). Bei Dutschke sei die Strafe in eine Haftstrafe umgewandelt worden, aber bis zur völligen Genesung ausgesetzt.","Erst zwei vom SDS bezahlten","","","",[1],1,[1],[2],2,"68","3"],["3668","1968-05-21","Gegen 64 Demonstranten und 35 Polizisten werden Ermittlungsverfahren wegen der Frankfurter Osterunruhen eingeleitet.","Ermittlungsverfahren","Schnell informiert","","",[1],1,[1],[2],2,"16","1"],["3669","1968-05-21","Studenten haben das Institut für Japanologie an der FU Berlin besetzt, der SDS kündigt weitere Besetzungen an. Die Polizei besetzte daraufhin die Telefonzentrale der FU Berlin. Hintergrund der Besetzung des Japanischen Instituts sind u.a. frühere antisemitische Äußerungen von Prof. Eckardt. Die Jüdische Studentenvereinigung begrüßt daher die Besetzung. In Frankfurt versuchten fünf Professoren, den IG-Metall-Chef Brenner zu einer Teilnahme an den Demonstrationen gegen die Notstandsgesetze zu bewegen, dieser lehnte ab.","FU-Institut von Studenten besetzt/ Institut besetzt","","Studenten wollen Berufungsausschuß einsetzen","M.M.",[1],1,[1],[2],1,"16","1,6"],["3670","1968-05-21","Laut einer ifas-Umfrage hat ein Großteil der deutschen Bevölkerung ein falsches Bild von und Vorurteile gegenüber den Studenten, sei teilweise sogar studentenfeindlich eingestellt.","Schwere Vorurteile","","","",[1],1,[1],[2],2,"16","2"],["3671","1968-05-21","Studenten der Pädagogischen Hochschule Bonn haben mit einem dreitägigen Vorlesungsstreik begonnen. Sie fordern eine Erhöhung der Zahl der Lehrbeauftragten von 50 auf 96.","Streik in Bonn","Kurz gemeldet","","",[4],1,[1],[2],2,"16","2"],["3672","1968-05-21","Ein roter Teppich wurde von der Ehrentribüne der Alliierten-Parade an der Straße des 17. Juni gestohlen. Die Täter gaben an, dass sie ihn auslegen wollten, wenn Rudi Dutschke aus dem Krankenhaus entlassen wird, damit er auch einmal über einen roten Teppich laufen kann.","Roter Teppich für Dutschke?","","","",[2],1,[1],[2],2,"16","5"],["3673","1968-05-21","Mehrere Männer übefielen das SDS-Büro, richteten Sachschaden an und verprügelten zwei SDS-Mitglieder. Rudolf Stiege verurteilt den Überfall.","SDS-Büro überfallen","","","Rudolf Stiege",[8],1,[1],[2],2,"16","6"],["3674","1968-05-21","Die Wirtschafts- und Sozialwissenschaftliche Fakultät weist die Kritik von Minister Stoltenberg an Prof. Flechtheim zurück.","\"Schiefes Bild\"","","","",[1],1,[1],[2],2,"16","6"],["3675","1968-05-21","An der Juristischen Fakultät der FU Berlin beginnt eine regelmäßige Ring-Vorlesung zur Notstandsgesetzgebung.","Vorlesung zum Thema Notstand","","","",[1],1,[1],[2],2,"16","6"],["3676","1968-05-21","FU-Professoren sagten vor dem Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kultur zum geplanten neuen Universitätsgesetz aus (u.a. Prof. Bettermann, Prof. Harndt).","Autonomie der Universität unzulässig eingeschränkt","","Parlamentsausschuß für Wissenschaft hörte FU-Professoren","M. L. Müller",[4],1,[1],[1],2,"16","6"],["3677","1968-05-22","Die Westdeutsche Rektorenkonferenz beschließt, bei Studentenunruhen künftig möglichst ohne Polizei auszukommen.","Möglichst ohne Polizei","Schnell informiert","","",[1],1,[1],[2],2,"18","1"],["3678","1968-05-22","Daniel Cohn-Bendit sprach im Audimax der FU Berlin, plädiert für Aktionen auf der Straße im Kampf gegen das kapitalistische System, äußert sich zu den Unruhen in Paris. Studenten wenden sich gegen die Besetzung des Japanologischen Instituts. In der II. Fassung der Ausgabe vom 22. Mai 1968 leicht erweiterter Artikel, ergänzt um einen Beschluss, das Otto-Suhr-Institut zu besetzen sowie um eine Ankündigung für einen dreitägigen Streik.","\"Aktion auf der Straße\"","","Frankreichs \"Roter Dany\": Baut Barrikaden","MM.",[1],1,[1],[3],1,"18","1"],["3679","1968-05-22","Anfragen von CSU-Bundestagsabgeordneten zum SDS, u.a. ob dieser verfassungsfeindlich sei und zur Desertationskampagne. Vorwurf, dass ausländische Studenten meist kommunistische Parteiaufgaben in der Bundesrepublik ausführen würden.","Schwere Vorwürfe gegen den SDS","","","dws.",[8],1,[1],[3],2,"18","1"],["3680","1968-05-22","Kritik an den Professoren, weil sie nicht genügend gegen die demonstrierenden Studenten vorgehen würden.","Professoren sind Papiertiger","Leserbriefe","","Leser",[1],1,[1],[2],2,"18","2"],["3681","1968-05-22","Axel Springer weist in einem ZDF-Interview die Vorwürfe, sein Verlag habe ein Meinungsmonopol, zurück.","Kein Meinungsmonopol","","Interview mit Axel Springer im Fernsehen","",[10],1,[1],[2],2,"18","2"],["3682","1968-05-22","Rektor Harndt fordert die Studenten auf, die Besetzung des Japanologischen Instituts unverzüglich zu beenden. Die Studenten kündigen weitere Aktionen an. Namentlich erwähnt werden Cohn-Bendit, Rabehl, Semler.","Rektor fordert: Räumen!","","Besetztes FU-Institut als \"Wallfahrtsort\"","MM.",[1],1,[1],[5],1,"18","3"],["3683","1968-05-22","Der Senat kritisiert eine Stellungnahme der Studentenvertretungen der FU, TU sowie der Kirchlichen Hochschule Berlins, in der diese \"die Mittel von Springers Hetze\" und der Polizei als Gewaltanwendung bezeichneten, die eine Gegengewalt statthaft werden lässt.","Senat: Gewalt wird bestraft","","","",[1],1,[1],[2],2,"18","3"],["3684","1968-05-22","Das Bundesverwaltungsgericht hat eine Personalratswahl von 1965 für ungültig erklärt. Grund ist der damalige Ausschluss von wissenschaftlichen Hilfsassistenten, Tutoren und studentischen Hilfskräften.","Personalratswahl an der FU ungültig","","","",[4],1,[1],[2],2,"18","9"],["3685","1968-05-23","Am Otto-Suhr-Institut diskutierten ca. 600 Studenten darüber, ob das Institut besetzt werden solle. Gegner und Befürworter konnten sich bisher nicht einigen. Die Besetzer des Japanologischen Insituts reagieren auf die Forderung des Rektors, das Institut zu räumen. Als Bedingung nennen sie die Amtsenthebung von Prof. Eckardt.","Diskussion an der FU","","","M.M.",[1],1,[1],[2],2,"28","1"],["3686","1968-05-23","Die Westdeutsche Rektorenkonferenz befürwortet die Beratungs- und Entscheidungsbefugnis der Studenten, spricht sich aber gegen deren Teilhabe bei der Entscheidung bei der Berufung von Professoren aus. Allerdings sollen die Studenten zuvor gehört werden.","Studenten sollen mitarbeiten","","","",[4],1,[1],[2],2,"28","2"],["3687","1968-05-23","Der VDS rief im Zuge der dritten Lesung der Notstandsgesetze zu einem dreitägigen Streik auf. Mehrere Studentenvertretungen von Universitäten schlossen sich dem bereits an. Die französische Regierung verweigert Daniel Cohn-Bendit die Einreise nach Frankreich.","Studentenverband ruft zu Vorlesungsstreiks auf","","Wieder Aktionen gegen die Notstandsgesetze geplant","",[1],1,[1],[1],2,"28","2"],["3688","1968-05-23","Kritik am Ausschluss der Presse bei einigen Prozessen von Angeklagten wegen Delikten während der Osterunruhen.","Unter Ausschluß der Presse","","","Jo.",[1],1,[5],[2],2,"28","2"],["3689","1968-05-23","Die Überfälle auf zwei Büros des SDS wurden von Mitgliedern der NPD verübt.","SDS-Zentrale von NPD-Anhängern verwüstet","","","",[8],1,[1],[2],2,"28","3"],["3690","1968-05-23","Über den Beschluss einer Vollversammlung, das Otto-Suhr-Institut der FU Berlin zu besetzen. Kritik von Studenten und Professoren an dem Beschluss. Dieser geht auf einen Antrag von Christian Semler zurück. Jürgen-Bernd Runge und weitere ehemalige RCDS-Mitglieder rufen zur Gründung einer neuen linksliberalen, nicht-marxistischen Vereinigung auf.","Nicht alle Studenten spielen mit","","\"Otto-Suhr-Institut soll nicht einseitig mißbraucht werden\"","",[1],1,[1],[5],1,"28","3"],["3691","1968-05-23","Statistik über die Ermittlungsverfahren seit dem 2. Juni 1967 bis zu den Osterunruhen.","Der Stand der Ermittlungen","","","",[1],1,[1],[2],2,"28","3"],["3692","1968-05-23","Das Bundesjustizministerium erwägt eine Amnestie für politische Straftäter. Hierunter würden auch strafbare Handlungen im Zuge der Studentenunruhen fallen.","Bonn erwägt Amnestie","","","",[1],1,[1],[2],2,"28","8"],["3693","1968-05-25","Eine Vollversammlung der Studenten des Otto-Suhr-Instituts sprach den Studentensprechern des Instituts das Misstrauen aus, weil sie ohne Rücksprache mit den Studenten eine Besetzung des Instituts unterstützt hatten. Ähnliches auch an der Juristischen Fakultät. Die Publizistik-Studenten haben nach der Neubesetzung des vakanten Lehrstuhls ihren Streik beendet. Daniel Cohn-Bendit wurde die Einreise nach Frankreich verweigert. An der Uni Frankfurt werden in der kommenden Woche die Vorlesungen ausfallen. (In der II. Fassung der Ausgabe vom 22. Mai 1968 leicht veränderter Artikel. Hinzugefügt wurde die Nachricht, dass das Institut nach Debatten mit Professoren für die nächsten fünf Tage den Studenten zur Verfügung stehen soll. Ein zehnköpfiges Studentenkomitee übe nun quasi das Hausrecht aus. Bedingung war, dass die Studenten die Professorenzimmer und Bibliothek nicht betreten.)","Radikale Sprecher der Studenten mußten gehen","","Vollversammlung im Otto-Suhr-Institut","",[1],1,[1],[5],2,"16","1"],["3694","1968-05-25","Eine Tübinger Studentenversammlung sprach sich mehrheitlich gegen eine weitere Zahlung der Pflichtbeiträge an den AStA der Universität aus, weil dieser entgegen eines Verwaltungsgerichtsurteils politische Stellungnahmen abgegeben habe.","Kein Geld für den AStA","Kurz gemeldet","","",[4],1,[1],[2],2,"16","2"],["3695","1968-05-25","Eine Vollversammlung der Studenten des Otto-Suhr-Instituts sprach den Studentensprechern des Instituts das Misstrauen aus, weil sie ohne Rücksprache mit den Studenten eine Besetzung des Instituts unterstützt hatten. Diese traten zurück. Bei einer Veranstaltung sei Jürgen Wohlrabe, Vorsitzender der Jungen Union, von mehreren Studenten umringt und geschlagen worden. Falls es doch zu einer Besetzung des Instituts kommen sollte, wollen die Angestellten und Arbeiter des Instituts streiken.","Politologen der FU erteilten Radikalen eine Abfuhr","","Heiße Debatten im Otto-Suhr-Institut","MM.",[1],1,[1],[1],2,"16","6"],["3696","1968-05-26","Willy Brandt, Klaus Schütz und Kurt Mattick grenzen sich auf dem Berliner SPD-Parteitag von linksextremen Kreisen in und außerhalb der SPD ab.","Willy Brandt sagt Radikalen in der SPD den Kampf an","","Klare Mehrheit für Klaus Schütz auf dem Landesparteitag","Go/ LUK",[1],1,[1],[1],2,"66","1"],["3697","1968-05-26","Für den Regierenden Bürgermeister Berlins, Schütz, geht es darum, die Mehrheit der Studenten vor einer radikalen Minderheit zu schützen. Diese würden der Mehrheit ihren Willen aufdrängen wollen. Ähnlich äußerte sich auch der Akademische Senat der FU. Es drohe die Annullierung des Semesters wegen der fortlaufenden Störung des Lehrbetriebs. Der RCDS fordert eine entschiedene Haltung gegen die Methoden des SDS.","\"Missbrauch durch die Radikalen\"","","","MM.",[1],1,[1],[2],2,"66","1"],["3698","1968-05-26","Über den Berliner SPD-Parteitag, ausführlich zur Rede Schütz und seiner Abgrenzung von Gewalt befürwortenden Personen. Ca. 100 Studenten der FU erhielten die Möglichkeit, mit den Delegierten zu diskutieren.","\"Wer Gewalt anwendet gehört nicht in die SPD\"","","Schütz bietet Ost-Berlin erneut Gespräche an","",[1],1,[1],[2],2,"66","2"],["3699","1968-05-26","Der FU-Assistent Pommerening erwirkte eine einstweilige Verfügung gegen die Studentenvertreter des Englischen und des John-F.-Kennedy-Instituts wegen der Behauptung, er übe Meinungsterror und üble Zensur aus.","FU-Assistent ging vor Gericht","","","",[1],1,[1],[2],2,"66","3"],["3700","1968-05-26","An der FU Berlin soll von Montag bis Mittwoch, dem Tag der dritten Lesung der Notstandsgesetze, der Universitätsbetrieb eingestellt und stattdessen über die Notstandsgesetzgebung debattiert werden. Ein Zentrum ist das an Studenten übergebene Otto-Suhr-Institut. Befürchtet wird, dass die Besetzung des Insituts über die vereinbarten fünf Tage hinaus aufrecht erhalten wird. Warnung vor der Gefahr der Annullierung des Semesters. Der Akademische Senat spricht von Manipulation und Terror seitens antidemokratischer Gruppen, die Interessen der Studentenschaft würden missbraucht.","Statt Vorlesungen Notstandsdebatten","","Universitätsbetrieb soll drei Tage lahmgelegt werden","Michael L. Müller",[1],1,[1],[1],1,"66","3"],["3701","1968-05-26","Der Gesundheitszustand von Rudi Dutschke habe sich weiter verbessert.","Dutschke geht es weiter besser","","","",[2],1,[1],[2],2,"66","5"],["3702","1968-05-26","Über den Inhalt der kurz vor der Verabschiedung stehenden Notstandsgesetze, wer den Inhalt kennt, könne nicht von einem Weg in die Diktatur reden, dies sei sorgloser Umgang mit der Wahrheit.","Das Notstandsrecht hat keine Fußangeln","","Wer die Gesetze kennt, kann nicht vom \"Weg in die Diktatur\" reden","Dietrich W. Schulz",[1],1,[1],[1],2,"66","12"],["3703","1968-04-25","Ingenieurstudenten in NRW wollen für Reformen ihrer Fachbereiche streiken.","Studenten der Ingenieurschulen wollen streiken","","Protest gegen die Politiker","frh",[4],4,[1],[2],2,"28","6"],["3704","1968-04-25","Große Kundgebung in München nach Tod von Frings und Schreck. Gemeinsamer Auftritt von Politikern und Studenten, aber teils stark divergierende Äußerungen.","Politiker und Studenten suchen neuen Anfang","","","pff",[1],4,[1],[2],2,"28","6"],["3705","1968-04-25","Mehrere Neustudenten der evangelischen Kirchlichen Hochschule Berlin lehnen Immatrikulationsformel ab. Rektor zeigt Verständnis.","Immatrikulationsfeier der Theologen abgebrochen","","","epd",[3],4,[1],[2],2,"28","6"],["3706","1968-04-26","Senator Stein sieht Nutzung von TU-Räumen durch APO als widerrechtlich an. ","Streit in der TU geht weiter","","Rechtslage noch ungeklärt","Bi",[11],4,[1],[2],2,"28","1"],["3707","1968-04-26","Austritt wegen zunehmender Politisierung","Bonner Studentenschaft verlässt den VDS","","Aus politischen Gründen","ems.",[11],4,[1],[2],2,"28","1"],["3708","1968-04-26","AStA-Vertreter sagen Gespräche mit Schütz ab, weil dieser zwei APO-Vertreter abgelehnt hatte.","Studentenvertreter sagen Gespräch mit Schütz ab","","Kurzfristig neue Bedingungen","Bi.",[1],4,[1],[2],2,"28","1"],["3709","1968-04-26","Ehmann und drei weitere VDS-Vertreter beim Kanzler. Stenograph soll auch teilnehmen.","Kiesinger empfängt VDS-Vorstand","","Gespräch am Montag in Stuttgart","ems.",[11],4,[1],[2],2,"28","1"],["3710","1968-04-26","Demonstrierende Jugend hat keine Ahnung von den Entbehrungen, die zum Aufbau der Bundesrepublik nötig gewesen sind. Wie lange will die Regierung die Fanatiker noch dulden? Dazu eine Karikatur, auf der SDS-Mäuse die Katze \"Strafgesetz\" jagen.","Keine Ahnung","Aus Briefen an die Redaktion","","Leser",[1],4,[6,4,5],[2],1,"28","2"],["3711","1968-04-26","SDS-Aktivitäten werden zu Rechtsruck bei Wahlen führen","Die Wirkung","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"28","2"],["3712","1968-04-26","Kritik daran, dem Regierenden Bürgermeister APO-Diskutanten aufzwingen zu wollen.","So nicht","Zum Tage","","Bi.",[1],4,[5],[2],2,"28","2"],["3713","1968-04-26","Demo in Düsseldorf mit 8000 Teilnehmern für Reformen bei den Ingenieuren.","Studenten-Protest in Düsseldorf","","Streik an den Ingenieurschulen","frh.",[4],4,[1],[2],2,"28","6"],["3714","1968-04-26","Geschäftsführer eines Bremer Beat-Lokals habe bei SDS-Versammlung zu Umsturz aufgerufen.","Umsturzpläne in der \"Lila Eule\"","","","M.",[8],4,[1],[2],2,"28","6"],["3715","1968-04-26","Meschkat hatte SFB manipulierte Nachrichten und Lügen vorgeworfen.","Einstweilige Verfügung gegen Meschkat erwirkt","","","dpa",[11],4,[1],[2],2,"28","6"],["3716","1968-04-27","APO sei nicht außer- sondern antiparlamentarisch","Antiparlamentarisch","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"38","2"],["3717","1968-04-27","Schwarmgeister wollen Staat zerstören, nehmen aber gerne Stipendien von ihm.","Sinne vernebelt?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"38","2"],["3718","1968-04-27","Studentenverbindung grenzt sich von SDS ab.","Falscher Eindruck","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"38","2"],["3719","1968-04-27","Vergleich von Meschkats politischen Ideen, die er z.T. in \"Panorama\" kundgetan hat, und der politischen Situation in Polen.","Der Ruf nach den Räten","","Meschkats polnische Gesinnungsfreunde sitzen längst im Gefängnis","Walter Günzel",[11],4,[5],[5],2,"38","2"],["3720","1968-04-27","Erster Teil einer Serie über Hochschulgruppen. Geschichte, Ideologie und Finanzen des SDS.","Planspiele für die Revolution","Die politischen Hochschulgruppen - was denken sie und was wollen sie? (I)","Der SDS: \"Bürger im Marxpelz\" und andere","Paul Lersch",[8],4,[1],[4],1,"38","5"],["3721","1968-04-27","Leiter mehrerer FU-Institute in Vollversammlung eingeladen, um über dortige Studiensituation zu diskutieren.","Zur Situation der FU-Institute","","","",[11],4,[1],[2],2,"38","13"],["3722","1968-04-29","Kritik an \"Panorama\" wegen Meschkat-Auftritt etc.","Noch neutral?","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"24","2"],["3723","1968-04-29","Schütz sollte Gespräche nicht wegen APO ablehnen","Nicht ablehnen","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"24","2"],["3724","1968-04-29","Geschichte des SHB und seiner innerparteilichen Veränderungen.","\"Kampf der SPD - aber in der SPD\"","Die politischen Hochschulgruppen - was denken sie und was wollen sie? (II)","Der SHB: Die letzte Brücke der Sozialdemokraten zur unruhigen Studentenschaft droht zu brechen","Karsten Plog",[11],4,[1],[4],1,"24","5"],["3725","1968-04-29","Artikel übernommen aus dem Rheinischen Merkur vom 26.4.68. Diskutiert die Strafwürdigkeit verschiedender SDS-Aktivitäten.","Steht der SDS über dem Gesetz?","Studenten-Unruhen","Auch Vorbereitungshandlungen sind rechtswidrig","P. W. Wenger",[8],4,[5],[1],2,"24","6"],["3726","1968-04-29","Artikel übernommen aus dem Rheinischen Merkur vom 26.4.68. Glossiert Helmut Schmidts Vorschlag, Springer in eine Stiftung umzuwandeln.","Einheitspresse","","","A.B.",[10],4,[2],[2],2,"24","6"],["3727","1968-04-29","Störungen der Jubelfeiern durch Springer-kritische Demonstranten, weil bei Bechtle eine Teilauflage der BILD gedruckt wird.","Diskussionen mit ungebetenen Gästen","Jubiläum in Eßlingen","Der Bechtle-Verlag feiert sein 100jähriges Bestehen","uhl.",[10],4,[1],[2],2,"24","6"],["3728","1968-04-29","Aus der Festrede in Eßlingen. \"Was heute dem Verlag Springer geschieht, kann morgen jedem anderen Verlag passieren, wenn seine Meinung der Minderheit nicht gefällt.\"","\"Ohne Pressefreiheit keine Demokratie\"","","Auszüge aus der Rede des Verlegers Dr. Hellmut Girardet","Hellmut Girardet",[10],4,[5],[2],2,"24","6"],["3729","1968-04-29","Walter Ulbricht lobt in einer Rede in Jena die \"westdeutschen Jungarbeiter, Studenten und Schüler\" für ihre Aktionen.","Ulbricht lobt radikale Gruppen","","","Co.",[1],4,[1],[2],2,"24","7"],["3730","1968-04-29","Juso-Chef Corterier nennt einzelne SDS-Aktionen \"primitive Sabotageakten\"","Jungsozialisten kritisieren den SDS","","","dpa",[8],4,[1],[2],2,"24","7"],["3731","1968-04-29","Rektoren zu diversen Reformen bereit. Einzelne Themen werden angerissen.","Überholte Prüfungsmethoden sollen abgeschafft werden","Hochschulreform","Ergebnis der Rektorenkonferenz - \"Räume der Universität für Diskussionen offenhalten\"","St.",[4],4,[1],[3],2,"24","7"],["3732","1968-04-29","Kritische Anmerkungen zu geplanten Reformplänen","Schlagworte der Hochschulreform","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"24","11"],["3733","1968-04-29","Äußert Sorge über marxistisch-leninistische Angriffe auf die Medien","Viele Demonstranten keine Studenten","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"24","11"],["3734","1968-04-29","Leser fehlen Belege für die Vorwürfe gegen Springer","Haltlose Vorwürfe","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","11"],["3735","1968-04-30","Dissens bei Gewaltfrage. Gespräch soll fortgesetzt werden","Kiesinger sprach vier Stunden mit VDS","","","uhl.",[11],4,[1],[2],2,"28","1"],["3736","1968-04-30","Durch die Linke ist der konservative Verband gezwungen, sich deutlicher zu positionieren. Portrait der Gruppierung.","Revolution in kleinen Dosen","Die politischen Hochschulgruppen - was denken sie und was wollen sie? (III)","Der Linkruck an den Universitäten schreckt auch den RCDS auf","Karsten Plog",[11],4,[1],[4],1,"28","5"],["3737","1968-04-30","CDU-Politiker aus NRW macht als Ursache der Anti-Springer-Kampagne die politische Meinung des Verlages aus. ","\"Pressekonzentration ist nicht der Grund\"","","","frh.",[10],4,[1],[2],2,"28","7"],["3738","1968-05-02","Wohlwollende Kritik der Sondersitzung des Bundestages, der nicht auf den SDS gestarrt habe wie das Kaninchen auf die Schlange. Debatte über Reformen und mehr Rechte für die Jugend.","Es geht nicht nur um Studenten","","Junge Generation sucht Mitsprache - Erwachsen schon mit 18 Jahren? - Bundestag muss konkrete Fragen lösen","Georg Schröder",[1],4,[5],[1],2,"24","2"],["3739","1968-05-02","Kritik an Scheels Beitrag im Bundestag, der verkannt habe, dass Springer nicht mit bedrucktem Papier handelt, sondern eine klare Meinung hat. Die WELT habe sich nicht am Hochschaukeln von Dutschke beteiligt.","Scheel","Zum Tage","","ejc",[10],4,[5],[2],2,"24","2"],["3740","1968-05-02","Sammel-Portrait des Liberalen Studentenbundes Deutschland (LSD), der Humanistischen Studentenunion (HSU), der Evangelischen Studentengemeinde (ESG).","Satelliten, die den SDS umkreisen","Die politischen Hochschulgruppen - was denken sie und was wollen sie? (IV)","Splittergruppen an den Universitäten suchen ihren Standort","Paul Lersch",[11],4,[1],[1],1,"24","5"],["3741","1968-05-02","Sepp Gottfried Bieler beschreibt die Situation in Österreich und lehnt Gewalt ab.","\"Gewaltanwendung ist doch Wahnsinn\"","","Gespräch mit dem Vorsitzenden der Hochschülerschaft Österreichs","Co.",[9],4,[1],[2],2,"24","5"],["3742","1968-05-02","Bericht zu verschiedenen Aussagen und Forderungen. U.a. Absage an Gewalt als Mittel der Politik.","Kampf gegen die NPD und Absage an die Gewalt","Maifeiern im In- und Ausland","Gewerkschaftsführer fordern ein Verbot der Rechtsradikalen","",[1],4,[1],[1],2,"24","6"],["3743","1968-05-02","Siehe Unterzeile. Frage eines SDS-Verbots wird angeschnitten. Gewaltabsage. Ausschnitte aus Scheel-Rede mit Springer-Bezügen.","Die große Debatte im Bundestag","Nach den Osterunruhen","Sprecher aller Parteien verurteilen die Ausschreitungen während der Demonstrationen - Wille zu Reformen","",[1],4,[1],[4],1,"24","7"],["3744","1968-05-02","Kongress u.a. mit Scheuch, Horkheimer, Jungk, Hentig und Obermayer, der die Opposition hofiert habe, wobei unklar geblieben sei, wer/ was die Opposition sei.","Einübung in Gewaltlosigkeit","","oder Opposition in Deutschland - Das 4. Nürnberger Gespräch","Dietmar N. Schmidt",[1],4,[1,5],[1],2,"24","11"],["3745","1968-05-02","Politiker und Gewerkschafter betonen mit Entschiedenheit gegen Gewalt vorzugehen.","Redner bekannten sich zum Gespräch mit der Jugend","","Eindrucksvolle Mai-Kundgebung - Absage an jede Art von Radikalismus","vc",[1],4,[1],[1],1,"24","13"],["3746","1968-05-03","SDS will gegen Benda vorgehen, weil dieser den Verband als verfassungsfeindlich eingestuft hat.","SDS erwägt Klage gegen Minister Benda","","","ems.",[8],4,[1],[2],2,"34","1"],["3747","1968-05-03","Bericht über vielfältige Kontakte und Verflechtungen zwischen der westdeutschen APO bzw. einzelnen dort agierenden Personen und der SED. Erwähnt wird z.B. der Druck von APO-Publikationen im Druckhaus Norden, das zur West-SED (SEW) gehört. Die Rolle des \"Extra-Blatt\" wird gestreift. ","Ostberlin billigt den Pakt mit den Jung-Revolutionären","Radikale","Suche nach einer gemeinsamen Strategie","J.R.",[1],4,[1],[1],2,"34","3"],["3748","1968-05-03","Die Vorwürfe, Gert W. Settje, SDS- und SPD-Mitglied, plane einen militärischen Umsturz, entbehren offenbar jeder Grundlage.","Der \"Fall\" des Lila-Eulen-Chefs","Bremen","Militärisches Geheimdossier enthält viel Phantasie","Nils v. d. Heyde",[8],4,[1],[5],2,"34","3"],["3749","1968-05-03","Strafanträge u.a. gegen Mahler und Meschkat wegen Durchführung einer nichtgenehmigten Diskussionsveranstaltung in aufgebrochenen Räumen der TU.","TU-Rektor stellt fünf Strafanträge","","","v.C.",[11],4,[1],[2],2,"34","3"],["3750","1968-05-03","Ergebnisse von Meinungsumfragen über Studenten und ihr politisches Engagement: differenziert, uneinheitlich. Viele nehmen Studenten nur bei Ausschreitungen wahr. Eine Mehrheit der Befragten gibt Ohnesorg Verantwortung an seinem Tod. Schuld an diesem schiefen Bild sind keineswegs nur die Studenten selbst.","Was denkt der Bürger vom Studenten?","Die politischen Hochschulgruppen (Schluss)","Ein \"Politogramm\" deckt falsche Ansichten auf","Hans Schueler",[1],4,[5],[4],1,"34","5"],["3751","1968-05-03","Kommentator beklagt Ergebnis der Meinungsumfragen über Studenten. Dass nur die Radikalen wahrgenommen werden, was Radikalität zu rechtfertigen scheint. Hier gäbe es Versäumnisse, nicht nur bei den Studentenverbänden.","Bilanz in Moll","","","Bernd Nellessen",[1],4,[5],[2],2,"34","5"],["3752","1968-05-03","Ehmann stellt vier ausschließlich hochschulpolitische Forderungen vor.","VDS nennt vier Schwerpunkte","","Politisches Programm für 1968","ems.",[11],4,[1],[2],2,"34","6"],["3753","1968-05-04","Benda gelassen wegen der Schritte, die der SDS gegen ihn vorhat. Er will Verfassungsfeindlichkeit belegen.","In Kürze Weißbuch über den SDS","","Benda will Material über Verfassungsfeindlichkeit vorlegen","ems.",[8],4,[1],[5],2,"28","1,3"],["3754","1968-05-04","Verfahren beantragt mit dem Ziel des Berufsverbots.","Verfahren gegen Mahler vor dem Ehrengericht beantragt","","","UPI",[6],4,[1],[2],2,"28","1"],["3755","1968-05-04","Verständnisvoller Artikel über den Studentenstreik am Publizistik-Institut der FU.","Studenten streiken, weil sie arbeiten wollen","Freie Universität Berlin","Seit Jahren wartet das Publizistische Institut auf einen neuen Ordinarius","Matthias Walden",[11],4,[1,5],[1],2,"28","3"],["3756","1968-05-04","Hamburger SDS-Mitglied Karl-Heinz Roth nach 1. Mai-Kundgebung vorübergehend festgenommen.","SDS-Mitglied Roth aus der Haft entlassen","","","",[8],4,[1],[2],2,"28","3"],["3757","1968-05-04","Wolfgang Landsberg zum neuen stv. Vorsitzenden des FU-Konvents gewählt. Als neues AStA-Vorsitzende wird Sigrid Fronius erwartet.","Landsberg gewählt","","","Bi",[11],4,[1],[2],2,"28","3"],["3758","1968-05-04","Interview mit dem Schweizer Psychiater Adolf Friedemann über die Studentenunruhen: Aggressionen ins Leere laufen lassen, ansonsten alles \"niedriger hängen\". Plädoyer für einen entspannteren Umgang miteinander.","Über Professoren lachen ist doch keine Majestätsbeleidigung","","Professor Friedemann: Früher Erregung wegen der Schillerkragen, heute wegen der langen Haare","Friedrich Deich",[1],4,[3],[5],2,"28","3"],["3759","1968-05-04","Probleme bei Publizisten, Theaterwissenschaftlern und Japanologen. ","Erregte Vollversammlung über Berufungsprobleme der FU","","Dekan setzt sich zur Wehr - Missstände an drei Instituten kritisiert","ut",[11],4,[1],[1],2,"28","17"],["3760","1968-05-04","Strafantrag wegen Auflaufs gegen den Sohn des Bundesaußenministers.","Gefängnis für Peter Brandt beantragt","","","",[9],4,[1],[2],2,"28","17"],["3761","1968-05-04","Bischof Scharf regt in einem Zeitungsbeitrag Diskussionen über gut begründete Sachvorschläge der APO an. Führt weiter als Unruhe. Verständnis für die Jugend.","Sachdiskussionen angeregt.","","","",[1],4,[1],[2],2,"28","17"],["3762","1968-05-06","Anlässlich einer Ausstellungseröffnung über Marx in Trier äußert sich Brand kritisch über den ideologischen Umgang mit dem Philosophen. Studenten werfen SPD Marx-Verfälschung vor.","\"Glaube an Karl Marx ist zur Gewaltlehre missbraucht worden\"","Trier","Brandt warnt radikale Studentengruppen","St.",[1],4,[1],[5],2,"22","5"],["3763","1968-05-06","Drei Tübinger Studenten kündigen Aktionen gegen ihren AStA an, da dieser ein politisches Mandat für sich in Anspruch nimmt.","Gegen den AStA","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"22","7"],["3764","1968-05-07","MdB-Frage nach Eigentumsverhältnissen an der TU, damit auch nach den Verantwortlichkeiten.","Wem gehört die TU","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],1,"22","2"],["3765","1968-05-07","LSD-Mitglied widerspricht der WELT-Beurteilung über den Verband","Abgelehnt","Aus Briefen an die Redaktion","","Leser",[1],4,[5],[2],2,"22","2"],["3766","1968-05-07","Beschreibt und bewertet die Studentenunruhen in Frankreich und vergleicht sie mit denen in Deutschland.","Frankreichs unruhige Studenten","","Gast der WELT","Alfred Grosser",[9],4,[5],[5],1,"22","2"],["3767","1968-05-07","Kritik am Anti-Springer-Beitrag des Spiegel vom Vortag: \"Eine Bild-Schlagzeile ist mehr Gewalt als ein Stein am Polizistenkopf\". Mit Zitatverkürzungen soll der Eindruck von Scharfmacherei erweckt werden.","Zerspiegelt","Zum Tage","","W.T.",[10],4,[5],[2],2,"22","2"],["3768","1968-05-07","Zustand verbessert, aber wohl Partien der Großhirnrinde geschädigt.","Dutschkes Zustand weiter gebessert","","Namensgedächtnis betroffen?","Bi.",[2],4,[1],[2],2,"22","3"],["3769","1968-05-07","Kritik des FU-AStA gegen Reformvorschläge an der Uni","Radikal gegen alle Zwischenprüfungen","","","wt",[4],4,[1],[2],2,"22","11"],["3770","1968-05-08","Bericht über bildungspolitische Debatte des Bundestages. Alle einig über Notwenigkeiten von Reformen.","Bundestag dringt auf schnelle Reformen an den Hochschulen","","Regierung soll eingreifen - Keine Verfassungsänderung","ems.",[4],4,[1],[1],2,"26","1"],["3771","1968-05-08","MdB plädiert dafür, APO Weg ins Parlament zu bahnen, da das der Ort für politische Auseinandersetzungen ist.","Zuständig bleibt das Parlament","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],1,"26","2"],["3772","1968-05-08","Weist darauf hin, dass Wortführer der Studenten zumeist Geisteswissenschaftler sind. Naturwissenschaftler und Techniker seien realistischer.","Viel realistischer","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"26","2"],["3773","1968-05-08","Karikatur zum Chaos der Hochschulreform","Der Föderalismus als \"dynamisches Verfassungsprinzip\"","","","Wilhelm Hartung",[4],4,[5,4],[5],1,"26","2"],["3774","1968-05-08","Auszüge aus der Rede des Bundesforschungsministers und anderer Beiträge. Alle einig in der Notwendigkeit von Reformen.","Stoltenberg: Kritik der Jugend ernst nehmen","Die Hochschul-Debatte im Bundestag","\"Kein Anlass zur Zufriedenheit\" - Gründliche Gewissenserforschung der Politiker gefordert","ems., St.",[4],4,[1],[4],2,"26","5"],["3775","1968-05-09","Debatte war ein \"Reden zum Fenster hinaus\", was Wasser auf die Mühlen der Radikalen ist. Schnelle Einigkeit und Reformen nötig.","Kein Anlass zur Zufriedenheit","","Die Debatte über die Hochschulreform - Streit um des Kaisers Bart - Kompetenzen oder Kooperation?","Walter Görlitz",[4],4,[5],[1],2,"20","2"],["3776","1968-05-09","SDS provoziert absichtlich, um den Gegner als Faschisten zu überführen.","Die Taktik","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"20","2"],["3777","1968-05-09","Verwaltungsgericht erklärt Raumverweigerung durch den Senator für rechtmäßig","FU-Konvent verlor Klage gegen Stein","","Verbot studentischer Versammlung erfolgte rechtmäßig","er",[11],4,[1],[2],2,"20","11"],["3778","1968-05-09","Polizisten wegen brutaler Schläge auf Demonstranten am 02.06.67 verurteilt","Keine mildernden Umstände zugebilligt","","Polizisten wegen Körperverletzung im Amt verurteilt","fa",[1],4,[1],[2],2,"20","11"],["3779","1968-05-09","RCDS sieht sich in seiner Arbeit durch Mutterpartei behindert","RCDS macht der CDU schwere Vorwürfe","","","",[11],4,[1],[2],2,"20","11"],["3780","1968-05-10","Vorbereitungen für eine u.a. von SDS-Leuten mitorganisierte Großdemo in Bonn gegen die geplanten Notstandsgesetze. 30.000 Teilnehmer erwartet.","Der \"Schauer-Marsch\" nach Bonn","Demonstration gegen die Notstandsverfassung","Was die Bundeshauptstadt alles zu erwarten hat","Manfred Eichhöfer",[1],4,[1],[1],1,"24","5"],["3781","1968-05-10","Vorbereitende erwarten keine Ausschreitungen.","Provokationen sollen vermieden werden","","Sprecher des \"Sternmarsches\" sagen ruhigen Verlauf voraus","ems.",[1],4,[1],[2],2,"24","5"],["3782","1968-05-10","Gesinnungswandel beim Kartellverband der katholischen deutschen Studentenverbindungen","Linksruck auch bei katholischen Studenten","","","ems.",[11],4,[1],[2],2,"24","6"],["3783","1968-05-10","Bericht über den Verlauf der Wahlsitzung. Fronius ist SDS-Mitglied und gilt als eine der exponiertesten Vertreterinnen der APO.","Studenten wählen linke Lady aus gutbürgerlichem Hause","","Sigrid Fronius ist neue AStA-Vorsitzende der Freien Universität","Bi.",[11],4,[1],[5],1,"24","6"],["3784","1968-05-11","Abwahl des Vorstandes wegen dessen ungeklärter Stellung zur SED","Gemäßigte stürzen Vorstand der TU-Studentenvertretung","","","dpa",[11],4,[1],[2],2,"32","1"],["3785","1968-05-11","Springer-Blätter verschwiegen Polizei-Übergriffe darf nicht mehr behauptet werden. Ablehnung einer Einstweiligen Verfügung zu Fälschungen in Springer-Blättern vermutlich wegen zu großen Umfangs des Prozessstoffes.","Einstweilige Verfügung gegen die \"Zeit\"","","Weiterer Antrag des Springer-Verlages abgelehnt","dpa, AP",[10],4,[1],[2],2,"32","6"],["3786","1968-05-11","Abwahl des Vorstandes wegen dessen ungeklärter Stellung zur SED","Nach Mitternacht wurden die Linken abgewählt","Berlin","Keine Zusammenarbeit mit SED","Bi.",[11],4,[1],[5],1,"32","6"],["3787","1968-05-14","Diskussion von Politikern und Studenten über deren Forderungen und die Möglichkeit einer Einbindung ihrer Gruppierungen in die parlamentarische Arbeit. Anriss eines Beitrags im Blatt.","\"Die Rebellen müssen sich jetzt entscheiden\"","Nach den Unruhen in Deutschland:","DIE WELT bat die drei Fraktionsvorsitzenden und Sprecher der Studentenschaft an den runden Tisch","",[1],4,[1],[5],2,"22","1"],["3788","1968-05-14","Leser widersprechen MdB Enk: TU ist Körperschaft öffentlichen Rechts, nicht Eigentum Berlins.","Die TU Berlin","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"22","2"],["3789","1968-05-14","Besprechung des Buches von Hans Dieter Jaene: Der Spiegel - ein deutsches Nachrichten-Magazin. Besonderes Augenmerk auf Spiegel/Springer. Zitate von Claus Jacobi.","Des \"Spiegels\" Blatt-Gold blättert ab","Das neue Buch","","Eckart Dietzemann",[10],4,[5],[3],2,"22","2"],["3790","1968-05-14","Siehe Unterzeile. Als WELT-Vertreter: Günter Zehm, Bernd Nellessen und Georg Schröder","Wieviel Kritik hat dieser Staat verdient?","Die WELT bat die Fraktionsvorsitzenden der Bundestagsparteien und Vertreter der Studentenschaft zur Diskussion an einen Tisch über das Thema:","Barzel: Große Würfe fehlen nicht in unserer Politik - Litten: Wir wollen diesen Staat nicht kaputtmachen - Mischnick: Im Bildungswesen klare Kompetenzen für den Bund - Schmidt: Die außerparlamentarische Opposition muss sich entscheiden - Pätzoldt: Ich halte die Regierungskoalition für ein Kartell","",[1],4,[3],[4],1,"22","6,7"],["3791","1968-05-14","Zwei Hochschulen in Regensburg und München kündigen VDS-Mitgliedschaft","Hochschulen kündigen Mitgliedschaft im VDS","","","di.",[11],4,[1],[2],2,"22","8"],["3792","1968-05-14","Springer widerspricht dem Vorwurf, eine Mitverantwortung an den Unruhen und den damit verbundenen Gewalttaten zu haben.","\"Dieser Staat ist wert, verteidigt zu werden\"","Evangelische Akademiker","Eine Antwort des Verlegers Axel Springer - Warnung vor einem neuen Totalitarismus","Axel Springer",[10],4,[5],[3],2,"22","8"],["3793","1968-05-14","Professor Harndt gegen Unistreik wegen der Notstandsgesetze. Kritik am Streik vom RCDS.","Für und wider Vorlesungsstreik","","FU-Rektor erwartet unbehinderten Universitätsbetrieb","eb",[11],4,[1],[2],2,"22","11"],["3794","1968-05-15","Vortrag Marcuses im Audimax der FU zum Thema \"Geschichte, Transzendenz und sozialer Wandel\". Weniger Beifall als im Vorjahr. Nach dem Vortrag zerstören Teufel, Kunzelmann u.a. ein FU-Emblem.","Sinkt Herbert Marcuses Stern bei den Berliner Studenten?","","Vortrag in der FU - \"Minderheiten können Ausbeutung beenden\"","Bi.",[11],4,[7],[5],1,"22","3"],["3795","1968-05-15","Zum Gesundheitszustand Dutschkes. Besuch von Marcuse.","Rudi Dutschke überstand zweite Operation gut","","","UPI",[2],4,[1],[2],2,"22","3"],["3796","1968-05-15","Rektor der Bochumer Uni erklärt Streiktag als vorlesungsfrei.","Biedenkopf kommt Studentenstreik zuvor","","","W.E.",[1],4,[1],[2],2,"22","3"],["3797","1968-05-15","Über die Unruhen an der \"in 711 Jahren veralteten Sorbonne\". Kurzportrait Cohn-Bendit.","Er führt die \"Zornigen\" von Paris","","Cohn-Bendits Vorbild ist Dutschke","E.D.",[9],4,[1],[2],1,"22","4"],["3798","1968-05-15","Bei Unruhen wird der Straßenverkehr von Madrid beeinträchtigt. Versammlung in der Medizinischen Fakultät.","Wieder Studentenunruhen in Madrid","","","AP",[11],4,[1],[2],2,"22","4"],["3799","1968-05-15","SED-Chefideologe setzt große Hoffnungen auf die APO, ist zu einem direkten Bündnis jedoch nicht bereit. Stellt Verhältnis des SDS zu Autorität in Frage.","Ostberlin misstraut den Revolutionären","Hagers Absage an den SDS","SED will \"führende Rolle der Arbeiterklasse\" nicht an die \"Intelligenzelite\" abtreten","G.K.",[8],4,[1],[1],2,"22","7"],["3800","1968-05-15","Studentische Podiumsdiskussion in Paderborn. Läpple von der DSU schlägt Dialog mit Springer vor. Jankowsky vom Hamburger AStA kritisiert Gewaltanwendung zu Ostern.","\"Demonstrationen waren ein Misserfolg\"","Studenten ","Klaus Läpple: Warum sprechen wir nicht mit Axel Springer?","ad",[10],4,[1],[2],1,"22","7"],["3801","1968-05-16","Proteste an allen Hochschulorten gegen die geplante Notstandsgesetzgebung.","Studentenstreiks und Proteste","","Grass fordert Realismus","",[1],4,[1],[2],1,"22","1"],["3802","1968-05-16","SDS will Diskussion über Notstandsgesetze erzwingen.","Göttingen: SDS sprengt Immatrikulationsfeier","","","e., Ih.",[8],4,[1],[2],2,"22","1"],["3803","1968-05-16","Blockaden und Schlägereien in der Frankfurter Uni. Unruhe auch an anderen Hochschulen. Details.","Streikposten versperrten Zutritt zur Frankfurter Universität","","Aufruf zum Protest von den Studenten unterschiedlich befolgt","Ih.",[8],4,[1],[3],2,"22","4"],["3804","1968-05-16","AStA der Uni Kiel will bei Kieler Woche demonstrieren.","Auch die Studenten bereiten sich auf die Kieler Woche 1968 vor","","\"Angemessener Empfang\" für Klaus Schütz angekündigt","H.A.",[1],4,[1],[5],1,"22","6"],["3805","1968-05-17","Kritik an der Medien- bzw. Springer-Kritik.","Keine halben Sachen!","Aus Briefen an die Redaktion","","Leserin",[10],4,[6],[2],2,"24","2"],["3806","1968-05-17","Gewalttätige Pariser Unruhen sind nicht nach Deutschland durchgeschlagen, Osterunruhen haben sich nicht wiederholt. Warum? Autor führt das auf eine neue Art der Differenzierung zurück. Warnt davor, wieder zur Tagesordnung überzugehen, da der Anspruch der Demokratiie noch immer nicht mit der Wirklichkeit übereinstimme. Das sei ein politisches und kein Generationenproblem.","Studenten: Radikale Thesen finden weniger Zustimmung","","Prozess der Differenzierung an den Universitäten - Die Frage nach dem politischen Mandat","Hans-Erich Bilges",[1],4,[5],[3],2,"24","2"],["3807","1968-05-17","Rebellen hatten Abschaffung von Examina gefordert. Gefolgschaft schwindet.","Extreme Wortführer verlieren Anhang unter den Studenten","Frankreich","Fallen die Abschlussexamen dieses Jahr aus?","SAD",[9],4,[1],[5],2,"24","3"],["3808","1968-05-17","Heftige handgreifliche Auseinandersetzungen an den Unieingängen in Frankfurt. SDS kann die Stellung nicht mehr halten.","Rektor und Studenten als Blockadebrecher in Frankfurt","","SDS musste eine Schlappe hinnehmen - Organisierter Widerstand","lh.",[8],4,[1],[3],2,"24","6"],["3809","1968-05-18","Kritik an der Springer-Kritik der Evangelischen Akademikerschaft in Deutschland.","Es gibt wichtigere Aufgaben","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"30","2"],["3810","1968-05-18","Situationsbericht aus unterschiedlichen Bereichen der beiden Unis. ","Das Sommersemester wird keine Idylle","Berliner Studenten","An der Technischen und der Freien Universität gärt es weiter","Eberhard Nitschke",[1],4,[7],[1],1,"30","5"],["3811","1968-05-18","Kupsch und v. Schöning als interimistische Studentenvertreter gewählt. Haltung des Dekans König wird kritisiert.","TU-Professor soll Rücktritt erklären","","","Bi.",[11],4,[1],[2],2,"30","5"],["3812","1968-05-18","Uniblockade hat 7000 Mark Schaden angerichtet. Anzeigen werden geprüft. Rektor gibt bekannt, dass Hans-Jürgen Krahl nicht Student der Uni ist.","Frankfurter SDS-Sprecher ist nicht immatrikuliert","","","lh.",[8],4,[1],[2],2,"30","6"],["3813","1968-05-18","Leser stimmt Springer und seinem Brief an die Evangelische Akademikerschaft zu.","\"Dieser Staat ist wert, verteidigt zu werden\"","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[1],2,"30","19"],["3814","1968-05-18","Hält das Stiftungsmodell für Zeitungen ungeeignet","Zeitung als Stiftung?","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"30","19"],["3815","1968-05-20","APO sollte versuchen, als Partei Protestwähler zu aktivieren","Studenten sollen sich zur Partei formieren","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","2"],["3816","1968-05-20","Unbekannte Männer dringen in SDS-Zentrale am Kudamm und eine Außenstelle in Tiergarten ein und verwüsten die Büros. NPD behauptet, nichts damit zu tun zu haben.","SDS-Zentrale überfallen und verwüstet","","Mahler: 3000 DM Schaden","AP",[8],4,[1],[2],2,"20","6"],["3817","1968-05-21","Wegen angeblich mangelnder Qualifikation und antisemitischer Äußerungen des Institutsleiters, Professor Eckardt, wird das Ostasiatische Institut besetzt und auf dem Dach eine rote Fahne gehisst. ","Studenten besetzen FU-Institut","","Rektor konferiert mit Schütz","ska.",[11],4,[1],[2],2,"22","1"],["3818","1968-05-21","Münchner Akademie der bildenden Künste durch Streik lahmgelegt. Mehr als die Hälfte der Professoren erklärt sich solidarisch.","Streik legt Münchner Akademie lahm","Studenten","Gegen Notstandsgesetze - Professoren beteiligen sich","pff",[1],4,[1],[2],2,"22","7"],["3819","1968-05-21","64 Ermittlungsverfahren wegen der Osterunruhen in Frankfurt. Zahl kann sich noch erhöhen.","Verfahren gegen Polizisten und Demonstranten","","","lh.",[10,2],4,[1],[2],2,"22","7"],["3820","1968-05-21","Mit Billigung der Professoren sind an der PH Bonn wegen der schlechten Studienbedingungen 2300 Studenten in einen dreitägigen Warnstreik getreten.","Studenten-Warnstreik an der PH in Bonn","","","ems.",[4],4,[1],[2],2,"22","7"],["3821","1968-05-21","Wegen angeblich mangelnder Qualifikation und antisemitischer Äußerungen des Institutsleiters, Professor Eckardt, wird das Ostasiatische Institut besetzt und auf dem Dach eine rote Fahne gehisst. Institutsbestände sollen bei Auseinandersetzungen geschützt werden. AStA billigt die Aktion.","Rote Fahne über Institutsgebäude der FU","","Studenten besetzten Ostasiatisches Seminar","ska.",[11],4,[1],[5],1,"22","13"],["3822","1968-05-21","Professor Harndt kritisiert SPD-Entwurf für ein neues Hochschulgesetz","Harndt gegen Mitbestimmung","","FU-Rektor: Hierarchische Rangfolge muss erhalten bleiben","tw",[4],4,[1],[2],2,"22","13"],["3823","1968-05-21","Leserbriefschreiber ist Generalstaatsanwalt und kritisiert Gastbeitrag vom 29. April, der der Justiz zu laxes Handeln dem SDS gegenüber vorgeworfen hatte. ","Justiz kein Instrument für die Politik","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[1],2,"22","17"],["3824","1968-05-22","FU-VV beschließt Streik, um in dieser Zeit in der Stadt über Notstandsgesetze zu informieren.","FU-Studenten beschlossen Streik","","","dpa",[1],4,[1],[2],2,"28","3"],["3825","1968-05-22","Sehr verständnisvolle Reportage vom besetzen FU-Institut. Informationen zu Professor Eckardt.","Im Handstreich \"fiel\" das Ostasien-Seminar","","Studenten-Aktion in Berlin","Bi.",[11],4,[7],[2],2,"28","5"],["3826","1968-05-22","Englischer Student warnt, dass Ausschreitungen Deutschland im Ausland Kredit kosten könnten.","Mahnung eines englischen Studenten","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"28","27"],["3827","1968-05-24","Student schildert einen missglückten Versuch des AStA, eine Diskussionsveranstaltung mit dem Journalisten Thilo Koch an der Uni Bochum notstandskritisch umzudrehen.","Kritik am AStA","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["3828","1968-05-24","Studentin schildert Abbruch einer Vorlesung an der Münchner Uni, damit über Notstandsgesetze diskutiert werden kann.","Auch das ist Notstand - an der Uni","Aus Briefen an die Redaktion","","Leserin",[1],4,[6],[2],2,"20","2"],["3829","1968-05-24","Orte und Termine verschiedener angekündigter Demos","Proteste gegen das Parlament","Notstandsgesetze","Demonstrationswelle zur dritten Lesung angekündigt","",[1],4,[1],[2],2,"20","3"],["3830","1968-05-24","Angreifer auf Berliner SDS-Büros sind identifiziert","NPD-Mitglied gesteht Anschlag auf SDS-Büro","","","Bi.",[8],4,[1],[2],2,"20","3"],["3831","1968-05-24","Besetzer beschließen, das OSI in \"Karl-Liebknecht-Institut\" umzubenennen. Cohn-Bendit spricht im Audimax und ruft zum Barrikadenbau auf.","200 Studenten hielten das Otto-Suhr-Institut besetzt","Berlin","Voraussichtlich Kampfabstimmung über weiteres Vorgehen","Bi.",[11],4,[1],[5],2,"20","3"],["3832","1968-05-24","Entsprechender Beschluss der westdeutschen Rektorenkonferenz","Rektoren wollen künftig ohne Polizei auskommen","","","dpa",[1],4,[1],[2],2,"20","7"],["3833","1968-05-24","Ex-RCDSler gründen linksliberale nichtmarxistische Gruppe an der FU","Ehemalige RCSD-Mitglieder gründen neue Gruppe","","","",[11],4,[1],[2],2,"20","12"],["3834","1968-05-25","Unruhe unter FU-Professoren wegen der aktuellen Situation an der FU","Acht Professoren wollen gehen","","Wegen Unruhe an der FU","Bi.",[11],4,[1],[2],2,"30","1"],["3835","1968-05-25","Arbeitsgemeinschaft selbständiger Unternehmer ASU spricht sich für praxisnähere Uniausbildung aus.","\"Hochschulreform vordringlich\"","","","gil.",[4],4,[1],[2],2,"30","1"],["3836","1968-05-25","Erneut Blockade vor der Frankfurter Uni. Anti-Notstandsaktionen auch an der Uni München. ","Frankfurter Studenten blockieren Eingänge","","Vorlesungsstreik in München","lh., di.",[1],4,[1],[2],2,"30","3"],["3837","1968-05-25","Institutsvertretung knapp abgewählt. Turbulente Sitzung. Uneinigkeit auch unter Professoren. Publizisten wollen Streik beenden.","Vollversammlung stürzt die Studentenvertretung am Otto-Suhr-Institut","Berlin","Lehrbetrieb bis zum 29. Mai eingestellt","Bi.",[11],4,[1],[5],2,"30","3"],["3838","1968-05-25","Frankreich verhindert Cohn-Bendits Rückkehr ins Land mit massivem Militäraufgebot.","Misslungener Sturm auf die Grenze","Cohn-Bendit","Garde Mobile schwer bewaffnet - \"Schießbefehl in der Tasche\"","D.",[9],4,[1],[3],2,"30","3"],["3839","1968-05-25","VDS kritisiert Beschluss der Rektorenkonferenz, wegen zu geringer Mitsprachemöglichkeiten.","VDS: Beschluss der Rektoren keine annehmbare Lösung","Hochschulreform","Studenten halten an \"Drittelparität\" fest","ems",[4],4,[1],[5],2,"30","4"],["3840","1968-05-25","An der Uni Tübingen sprechen sich bei einer Abstimmung die meisten Studenten gegen die politischen Pläne des AStA aus. Abstimmung kam gegen Willen des SDS zustande.","Im Hammelsprung gegen den AStA","Studenten","Mehrheit der Studentenversammlung gegen politisches Mandat","Rg.",[11],4,[1],[2],2,"30","6"],["3841","1968-05-25","SPD-MdB will Anti-Notstandsflugblatt aus der FU im Bundestag in seiner Fraktion verteilen.","\"Notstandsentwürfe neu durchdenken\"","","Offener Brief der Psychologiestudenten","",[1],4,[1],[2],2,"30","9"],["3842","1968-05-27","Uniblockaden und Einsatz für Grundrechte im Kampf gegen Notstandsgesetze widersprechen sich.","Universitäten müssen geöffnet bleiben","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"20","2"],["3843","1968-05-27","Pastor Wilken aus Hamburg kritisiert evangelische Springer-Kritik als niveaulos und einseitig","\"Dieser Staat ist wert, verteidigt zu werden\"","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[1],2,"20","13"],["3844","1968-05-28","Aktionen von Studenten, Politikern und Alliierten vor Notstandsbeschlüssen.","Studenten stürmen Rektorat der Universität Frankfurt","","Aktionen gegen Notstandsgesetze - Alliierte Note an Bonn","",[1],4,[1],[5],1,"24","1"],["3845","1968-05-28","Germanisches Seminar in der Boltzmannstraße besetzt und in \"Rosa-Luxemburg-Institut\" umbenannt. Besetzungen auch an der TU.","Das Germanische Seminar der FU besetzt","","Studenten hissen rote Fahnen auf Gebäude der Universität","v.C.",[1],4,[1],[2],2,"24","1"],["3846","1968-05-28","Die Unibesetzungen sind nicht schön, schlimmer aber sind die Schmähungen für die Professoren. Bitte an diese: bleibt da!","Besetzen - heißt die Parole","","Die Aktionen an den Universitäten - Schließen oder nicht? - Eine Bitte an die Professoren","Günter Zehm",[1],4,[5],[1],2,"24","2"],["3847","1968-05-28","Situationsberichte von Hochschulen aus sechs Bundesländern","Aktionen und Diskussionen an fast allen Hochschulen","Die Protestwelle gegen die Notstandsgesetze erreicht vor der dritten Lesung im Bundestag einen Höhepunkt","Der DGB verhandelt mit den Parteien in Bonn","",[1],4,[1],[1],1,"24","3"],["3848","1968-05-28","Hochschullehrer suchen bei der Politik Unterstützung gegen Besetzungen in ihren Unis.","\"Linksradikale Gruppen blockieren die Forschung\"","Die Protestwelle gegen die Notstandsgesetze erreicht vor der dritten Lesung im Bundestag einen Höhepunkt","FU-Rektor und Dekane bei Schütz","v.C., lh.",[1],4,[1],[5],2,"24","3"],["3849","1968-05-29","TU-Rektor und sein Vize treten nach Störungen bei den sog. Queen's Lectures zurück. Eine weitere Zusammenarbeit mit dem AStA sei nicht möglich.","Rektor der TU tritt zurück","","Harte Vorwürfe Weichselbergers gegen die Studentenvertretung","Co.",[11],4,[1],[2],1,"22","1,7"],["3850","1968-05-29","Demonstranten wollten in Theater eindringen, um mit Publikum über Notstandsgesetze zu diskutieren","Krawalle vor dem Schiller-Theater","","Polizei zog Pistolen","dpa",[1],4,[1],[2],2,"22","1,7"],["3851","1968-05-29","Rücktritt spiegelt Ratlosigkeit im Hochschulbereich wider. Rektor ist an seinem Entgegenkommen gescheitert.","Der Rücktritt Weichselbergers","Zum Tage","","Co.",[11],4,[5],[2],2,"22","2"],["3852","1968-05-29","Lageberichte aus verschiedenen Städten","Studenten in Göttingen wollten Rathaus stürmen","","Demonstrationen weiten sich aus","",[1],4,[1],[2],2,"22","7"],["3853","1968-05-29","Überblick über die Situation an den Berliner Hochschulen. FU-Mitarbeiter bitten Senat um Hilfe.","\"Arbeitsfrieden an der FU wieder herstellen\"","","Bedienstete appellieren an Senat","v.C.",[11],4,[1],[2],2,"22","7"],["3854","1968-05-30","Unverändert intensive Proteste an beinahe allen deutschen Hochschulorten","Hochschulen im Süden lahmgelegt","Proteste","","",[1],4,[1],[2],2,"24","1"],["3855","1968-05-30","Demo von Jusos und Studenten auf dem Ku'damm. Bagger fährt in Menschengruppe. Demonstranten erklimmen Fahrzeug. Fahrer kommt ins Krankenhaus.","Bagger fuhr in Demonstrantengruppe","","Zwischenfall auf dem Kurfürstendamm","v.C.",[1],4,[1],[3],2,"24","1"],["3856","1968-05-30","Karikatur - Vordergrund: Babys randalieren mit Kinderwagen und Transparent \"Max und Moritz\". Hintergrund: Demonstranten randalieren mit Autos und Transparent \"Marx und Mao\". Übernahme aus der Süddeutschen Zeitung.","Eskalation","","","Erich Maria Lang",[1],4,[5,4],[3],1,"24","2"],["3857","1968-05-30","Fünf Kurzberichte aus den Brennpunkten der Unruhen. Zwischenüberschrift zu Berlin: \"Besorgnis an der Freien Universität - Staatliches Eingreifen unumgänglich? - Stein im Seminar\"","Die Studenten setzen ihre Proteste fort","Demonstrationen","Schwerpunkte der Aktionen sind Berlin, München, Heidelberg und Frankfurt","Co, v.C., uhl., H.A., pff, lh.",[1],4,[1],[1],2,"24","5"],["3858","1968-05-30","Gegen den Hamburger SDS-Chef Karl-Heinz Roth besteht ein Haftbefehl. Versuchte Festnahme war jedoch aufgrund Personenschutzes nicht möglich. Schilderung des Geschehens und der Hintergründe.","Der Mann, der nicht verhaftet wird","Fall Roth","\"Leibgarde\" vereitelte Festnahme des SDS-Vorsitzenden","vdh.",[8],4,[1],[3],2,"24","5"],["3859","1968-05-30","Rät beim Versuch, Roth zu verhaften, zu Überlegtheit und Vermeidung von Aktionismus","Eile mit Weile","","","H.Sch.",[8],4,[5],[2],2,"24","5"],["3860","1968-05-30","Überblick über die Streiksituation an den einzelnen Uniinstituten, sowie über andere Protestaktivitäten.","Hochschulen sind Schwerpunkte der Anti-Notstandskampagne","","Ablehnungstelegramm an den Bundestagspräsidenten geschickt - Auch Professoren unterzeichneten","hae",[1],4,[1],[3],1,"24","11"],["3861","1968-05-31","Margot Becke, Rektorin der Heidelberger Uni, suspendiert AStA per Megaphon wegen Amtsmissbrauchs. AStA und SDS hatten Räume besetzt.","Resolute Hausherrin","","","Walter Pfuhl",[1],4,[5],[2],1,"22","2"],["3862","1968-05-31","Kommentator beklagt Gewalt der letzten Tage als Mittel politischer Auseinandersetzung.","Politische Verwilderung","Zum Tage","","W.T.",[1],4,[5],[2],2,"22","2"],["3863","1968-05-31","Proteste verlaufen zumeist ruhig. Einige Besetzungen sind beendet worden, so die der Film- und Fernsehakademie in Berlin. Handgreiflichkeiten mit einem Professor in Köln. ","Kommen die Universitäten zur Ruhe?","Demonstrationen","Kaum noch Zwischenfälle bei den Protesten gegen die Notstandsverfassung","",[1],4,[1],[1],1,"22","7"],["3864","1968-05-31","Fronius war in einem Bericht vorgeworfen worden, in eine Prügelei verwickelt gewesen zu sein. Sie widerspricht. Sie habe eine solche verhindern wollen.","Gegendarstellung","","","Sigrid Fronius",[11],4,[6],[2],2,"22","7"],["3865","1968-05-31","Über eine Abgeordnetenhaussitzung, die sich u.a. mit den Auseinandersetzungen an der FU beschäftigte. ","CDU verließ unter Protest den Saal","","Scharfe Kontroversen kennzeichneten die \"aktuelle Stunde\"","vc, hae",[1],4,[1],[1],2,"22","13"],["3866","1968-05-31","Strafantrag der Staatsanwaltschaft gegen Peter Brand wegen zweifachen Auflaufs.","Antrag entspricht dem Erwachsenenstrafrecht","","","",[9],4,[1],[2],2,"22","13"],["3867","1968-06-01","Durchsuchung von SDS-Räumen auf der Suche nach Urkunden, Akten, Stempeln etc., die bei der Besetzung aus der Uni verschwunden sind.","Hauptquartier des SDS durchsucht","","Es geht um die Diebstähle in der Frankfurter Universität","lh.",[8],4,[1],[3],2,"32","1"],["3868","1968-06-01","Römische Studenten besetzen ihre Uni aus Solidarität mit streikenden Franzosen.","Studenten in Rom besetzen die Universität","","","AP",[9],4,[1],[2],2,"32","1"],["3869","1968-06-01","Gegenstände aus Unibesitz bei Besetzung des Germanischen Seminars verschwunden. Kommunarden unter Verdacht.","Siegel und Ausweise der FU gestohlen","","","v.C.",[11],4,[1],[2],2,"32","1"],["3870","1968-06-01","RCDS-Funktionär kritisiert fehlende Toleranz an Unis und fordert Reformen","Fehlende Toleranz an den Hochschulen","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"32","2"],["3871","1968-05-26","Ausführlicher Bericht zu der bevorstehenden Notstandsgesetzgebung, die Befürchtung, man befinde sich mit den Gesetzen auf dem Weg in eine Diktatur, sei nicht zutreffend.","Das Notstandsrecht hat keine Fußangeln","","Wer die Gesetze kennt, kann nicht vom \"Weg in die Diktatur\" reden","Dietrich W. Schulz",[1],1,[1],[1],1,"66","12"],["3872","1968-05-28","Ein Festvortrag im Audimax der TU Berlin zu Ehren des Berlin-Besuchs von Königin Elisabeth II. musste auf Grund von Störungen mehrerer hundert Studenten abgesagt werden. Einige seien handgreiflich geworden. Der Regierende Bürgermeister Schütz äußerte sich empört und nennt die Studenten Rowdys. Zeitweise wurde das Audimax von Studenten besetzt. Die FU Berlin setzte den Senat davon in Kenntnis, dass linksradikale Gruppen Lehre, Forschung und Verwaltung der Universität blockiert hätten und die Uni nicht alleine in der Lage ist, diesen Zustand zu beheben.","Britische Ehrengäste in Berlin beleidigt/ Radikale wurden tätlich","","Radikale verhinderten Festvortrag/ Studenten mißachteten Aufruf des TU-Rektors","",[1],1,[1],[5],2,"24","1,2"],["3873","1968-05-28","Kleine Anfrage des CDU-Abgeordneten Besser an den Berliner Senat zur Aufrechterhaltung des Lehrbetriebs an der FU Berlin.","Kleine CDU-Anfrage an den Senat","","","",[1],1,[1],[2],2,"24","6"],["3874","1968-05-28","Die Studenten der Soziologischen Fakultät der TU Berlin fordern den Rücktritt von Prof. Mackensen und kritisieren auch das Verfahren seiner Berufung.","Rücktritt gefordert","","Studentenprotest gegen TU-Professor","J.M.",[1],1,[1],[2],2,"24","6"],["3875","1968-05-28","Auftakt des Prozesses gegen Peter Brandt, den Sohn Willy Brandts, wegen zwei Vergehen des Auflaufs.","Eltern kamen nicht zum Brandt-Prozess","","","",[1],1,[1],[2],2,"24","6"],["3876","1968-05-28","Mehrere Institute und Seminare an Berliner Hochschulen wurden besetzt, so u.a. das Germanische Seminar der FU, welches in Rosa-Luxemburg-Institut von den Besetzern umbenannt wurde. Es ginge bei der Besetzung nicht nur um die Notstandsgesetzgebung, sondern auch um ein neues Bild der germanistischen Wissenschaft. Studenten protestieren gegen die Besetzung, die Besatzer verweigern die Räumung auch gegen einen Mehrheitsentscheid, man müsse die Meinung einer Minderheit akzeptieren. Kritik am Widerstandsparagraphen im Notstandsrecht. Auf einer Vollversammlung der Wirtschafts- und Sozialwissenschaftlichen Fakultät der FU kam es zu Prügeleien zwischen Studenten.","Sturm auf Institute und Vorlesungsstreik","","Aktionen gegen Notstandsgesetze verstärkt","MM.",[1],1,[1],[1],1,"24","6"],["3877","1968-05-28","Der Tod von Klaus Frings und Rüdiger Schreck während der Osterunruhen kann wahrscheinlich nicht aufgeklärt werden. Frings wurde im Overseas Press Club in New York posthum geehrt.","Tod von Frings bleibt ungeklärt","","","",[10,2],1,[1],[2],2,"24","19"],["3878","1968-05-28","Bericht über Aktionen gegen die Notstandsgesetzgebung in Frankfurt/Main. Nur eine Minderheit der Studenten beteilige sich an den Aktionen, die Universität wurde von ihnen besetzt. Auch in anderen Universitätsstädten kam es zu Aktionen.","Nur eine Minderheit der Studenten \"streikt\"","","","",[1],1,[1],[1],1,"24","19"],["3879","1968-05-29","Fortsetzung der Aktionen an den Universitäten gegen die Notstandsgesetzgebung. An der TU Berlin trat Rektor Weichselberger von seinem Amt zurück. Am Donnerstag, den 30. April soll es eine aktuelle Stunde im Berliner Abgeordnetenhaus zu der Situation an den Berliner Hochschulen geben. Die CDU-Fraktion wolle die sofortige Exmatrikulation von wiederholten studentischen Rechtsbrechern fordern. Künftig soll auch der Akademische Senat an der FU eine Urabstimmung abhalten können. Polizeieinsätze sollen auf dem Universitätsgelände vermieden werden. An der TU Berlin wird eine paritätische Besetzung des Universitätsausschusses seitens der Studentenvertreter gefordert.","Rote Fahnen über Seminaren - Rektor der TU trat zurück","","Abgeordnete sollen morgen FU-Satzung ändern","Go.",[1],1,[1],[1],1,"16","1"],["3880","1968-05-29","Mehrere hundert Studenten hatten nach einem Beschluss im Audimax der TU Berlin versucht, das Schillertheater zu besetzen. Die Polizei hinderte sie mit gezogenen Waffen. Zuvor waren die Glastüren des Theaters eingeschmissen worden. Verletzte und fünf Festnahmen. (Erst ab der II. Fassung der Ausgabe vom 29. Mai 1968 ist das erwähnte Foto sowie die Angabe, dass fünf Steinewerfer festgenommen wurden, enthalten)","Sturm auf das Schillertheater","","","",[1],1,[1],[2],1,"16","1"],["3881","1968-05-29","Kritik, dass nicht gegen die Besetzung von Instituten/ öffentlichen Gebäuden vorgegangen wird.","Sind wir so ohnmächtig?","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["3882","1968-05-29","Demonstrationen gegen die Notstandsgesetzgebung in mehreren Städten unter Beteiligung von Studenten.","Demonstrationen weiten sich aus","","","",[1],1,[1],[2],2,"16","2"],["3883","1968-05-29","Über den Rücktritt vom TU-Rektor Weichselberger. Dieser hätte schon früher erfolgen müssen, er sei zu nachsichtig gegenüber demonstrierenden Studenten gewesen. Diese werden als antidemokratische Kräfte und antiparlamentarische Opposition bezeichnet. Generell Kritik an Professoren, dass sie nicht energisch genug gegen die Studentenunruhen vorgehen würden. Die Situation an den Unis müsse von diesen selbst gelöst werden, die Polizei solle nicht einschreiten.","Die Uni-Krise","","","Rudolf Stiege",[1],1,[5],[2],1,"16","2"],["3884","1968-05-29","Rücktritt des TU Rektors Weichselberger, Grund sei die abgesagte Veranstaltung zu Ehren Queen Elisabeths II. wegen Störungen durch Studenten. Über Weichselbergers Haltungen gegenüber den Studentenunruhen. Sein Rücktritt sei ein Eingeständnis, dass seine Praxis des Unterlaufens der Rebellion erfolglos gewesen sei. Weitere Institutsbesetzungen an TU und FU, Störungen von Lehrveranstaltungen, an der Juristischen Fakultät und der Wirtschafts- und Sozialwissenschaftlichen Fakultät sichern Studenten den Lehrbetrieb gegen Streiktrupps. (In der III. Fassung der Ausgabe vom 29. Mai 1968 ist eine kleine Ergänzung vorgenommen worden. Demnach habe eine Vollversammlung der Germanisten der Besetzung des Germanischen Seminars mit großer Mehrheit zugestimmt.)","Weichselbergers Weg in die Resignation","","Liberaler Rektor spricht von \"Fehleinschätzung\"","MM.",[1],1,[1],[1],1,"16","3"],["3885","1968-05-29","Die bayerische SPD kritisiert die Notstandsgegner, die zwar weitestgehend heftige Gegner der USA seien, aber anscheinend nichts dagegen hätten, wenn der amerikanische Geheimdienst Telefonate etc. abhören kann. Proteste an zahlreichen Universitäten gegen die Notstandsgesetze. Ein Kölner Verwaltungsgericht verbot dem AStA der Uni Köln, politische Forderungen oder Stellungnahmen abzugeben, sofern sie nicht studentischen Belange berühren. Dies betreffe auch Veranstaltungen gegen die Notstandsgesetze. Der AStA erklärte, er werde sich daran nicht halten. Weitere Veranstaltungen gegen die Notstandsgesetze.","SPD-Kritik an Gegnern der Notstandsverfassung","","\"Bereitschaft zu nüchterner Überlegung schwindet\"","",[1],1,[1],[1],1,"16","9"],["3886","1968-05-30","Linke Demonstranten versuchten das Bundeshaus und das Maison de France in West-Berlin zu stürmen. Auseinandersetzungen mit der Polizei. Zwei Arbeiter fuhren mit einem Bagger in die Menge der Demonstranten, Auseinandersetzungen mit den Demonstranten, die Arbeiter wurden schließlich wegen versuchten Totschlags festgenommen. Laut Bundeskabinett kam es nur an einigen Universitäten zu größeren Protesten gegen die Notstandsgesetzgebung. In Bonn wurde Bundespräsident Lübke von hunderten Studenten bedrängt.","Wilde Proteste vor Bundeshaus und Maison de France/ Die Tür ging zu Bruch","","Bagger fuhr in die Menge - Fahrer festgenommen/ Drohungen der \"außerparlamentarischen Opposition\"","",[1],1,[1],[1,2],1,"24","1,2"],["3887","1968-05-30","Strafantrag gegen die Demonstranten, die versucht hatten, das Schiller-Theater zu besetzen und dabei den Eingangsbereich zerstört haben (siehe BM vom 29.05.1968).","Schiller-Theater stellt Strafantrag","Schnell informiert","","",[1],1,[1],[2],2,"24","1"],["3888","1968-05-30","Bericht über die Unruhen in Paris, de Gaulle stehe kurz vorm Rücktritt. Deutschen Studenten ist die Einreise nach Frankreich untersagt, damit sie sich nicht an den Unruhen beteiligen können. Daniel Cohn-Bendit gelang trotz Einreiseverbot die Rückkehr nach Paris.","Tritt de Gaulle zurück/ Antwort der Streikenden: \"Zu wenig und zu spät\"","","In Paris jagten sich die Gerüchte - Rätsel um den General/ Deutsche Studenten dürfen nicht mehr nach Frankreich","",[1],1,[1],[5,1],2,"24","1,2"],["3889","1968-05-30","Schwere Kritik an den jüngsten Studentenunruhen, Frage wer für die Kosten der Sachbeschädigungen an den Universitäten aufkommen soll; Kritik an Willy Brandt, weil der Anwalt seines Sohnes Horst Mahler ist; Kritik an Wehner für die Forderung nach einem Verbot der NPD, dies sei nur gerechtfertigt, wenn man im gleichen Maße gegen die linksradikalen Unruhen vorgehen würde.","Wer kommt für den Schaden auf?","Leserbriefe","","Leser",[1],1,[6],[2],2,"24","2"],["3890","1968-05-30","Studentische Demonstrationen in West-Berlin gegen die Notstandsgesetzgebung, Marsch auf das DGB-Haus. Statt Solidarisierung der Arbeiter mit den Studenten sei es wiederholt zu Auseinandersetzungen gekommen.","Demonstranten stießen auf eindeutige Ablehnung","","Arbeiter boten Prügel statt Diskussionen an","J.M.",[1],1,[1],[1],1,"24","3"],["3891","1968-05-30","Der Tag der dritten Lesung der Notstandsgesetze sei an den Berliner Universitäten bemerkenswert ruhig verlaufen. Gegner der Besetzung des Germanischen Seminars versuchten wiederholt, die Besetzer zu vertreiben. Senator Stein besichtigte das besetzte Seminar, äußerte sich kritisch über dessen Zustand. An der TU Berlin gab es studentische Unterschriftensammlungen und Fackelzüge dafür, dass Rektor Weichselberger im Amt bleibt. Senator Stein bedauert den Rücktritt der TU-Spitze. Die CDU greift Stein an und fordert dessen Rücktritt. Im Otto-Suhr-Institut wird zu einer Versammlung einberufen, in der die Zukunft des Instituts besprochen werden soll. Der DGB kündigt der Gerwerkschaftlichen Studentengemeinschaft (GSG) wegen dessen politischem Auftreten die Büroräume.","Vorlesungen und Rauchbomben in Dahlem","","Kultursenator Stein im besetzten Germanischen Seminar","MM.",[1],1,[1],[2],2,"24","3"],["3892","1968-05-30","Bericht über zahlreiche Demonstrationen in Universitätsstädten gegen die Notstandsgesetze, der Lehrbetrieb konnte allerdings meist Aufrecht erhalten bleiben. Das Vorhaben der studentischen Demonstranten, Arbeiter zur Solidarisierung zu bewegen, sei bis auf wenige Ausnahmen gescheitert. Auch viele Studenten würden sich vermehrt den Demonstranten entgegenstellen. In Frankfurt wurde die Uni von Besetzern in Karl-Marx-Universität umbenannt. In Hamburg verhinderte eine \"Leibgarde\" des SDS mit Gewalt die Verhaftung von Karl-Heinz Roth. Auch rechtsgerichtete Studenten würden sich verstärkt bemerkbar machen.","Widerstand gegen Extremisten wächst","","Arbeiter nicht zur Solidarisierung bereit","",[1],1,[1],[1],1,"24","10"],["3893","1968-05-30","Zu Pfingsten führt die SED in Halle einen Kongress der Arbeiterjugend durch, an dem auch Vertreter der Falken, des SDS, der FDJ und der SED West-Berlin teilnehmen werden.","Umschulung' durch die SED in Halle","","","",[9],1,[1],[2],2,"24","11"],["3894","1968-05-31","Eine Vollversammlung des Otto-Suhr-Instituts konnte sich nach siebenstündiger Debatte nicht auf ein Reformmodell für das Institut einigen. Nun sollen drei Kommissionen weitere Reformmodelle ausarbeiten.","Keine Einigung","Schnell informiert","","",[4],1,[1],[2],2,"24","1"],["3895","1968-05-31","Lediglich in Frankfurt sei es noch zu größeren Auseinandersetzungen im Zuge der Verabschiedung der Notstandsgesetzgebung gekommen, dort räumte die Polizei die besetzte Universität. Zudem wurde das Frankfurter Schauspielhaus von Demonstranten gestürmt. In Bonn erklärte SDS-Funktionär Heer: Wir haben eine Niederlage erlitten. Auch in Wien, Brüssel, Madrid und Israel sei es zu studentischen Auseinandersetzungen gekommen, insbesondere in Wien seien die Demonstranten in der Minderheit gewesen.","Proteste flauten ab","","","",[1],1,[1],[2],2,"24","1"],["3896","1968-05-31","Aktuelle Stunde im Berliner Abgeordnetenhaus zur Situation an den Berliner Hochschulen. Die CDU warf der SPD vor, bei der Besetzung von Hochschulinstituten tatenlos zuzusehen, fordert zudem den Rücktritt von den Senatoren Stein, Evers und Hoppe.","CDU-Abgeordnete gingen","","Stürmische Aktuelle Stunde im Berliner Parlament","",[1],1,[1],[2],2,"24","1"],["3897","1968-05-31","Kritik an den Studentenunruhen und vor allem an dem zu laschen Vorgehen gegen diese.","Merkwürdiges Rechtsbewußtsein","Leserbriefe","","Leser",[1],1,[6],[2],2,"24","2"],["3898","1968-05-31","Begrüßt die Verabschiedung der Notstandsgesetze und dass sich die Abgeordneten nicht von den Protesten gegen diese beeindrucken haben lassen. Spricht vom Kampf gegen die Notstandsgesetze als zynisches Feigenblatt für den Kampf gegen die Demokratie.","Wir können ein wenig aufatmen","","","Rudolf Stiege",[1],1,[5],[2],2,"24","2"],["3899","1968-05-31","Der AStA der Pädagogischen Hochschule Bonn kritisiert das erzbischöfliche Vikariat in Köln für dessen Entscheidung, die Berufung von Prof. Halbfas zu verhindern. Die Studenten würden eventuell beabsichtigen, das Generalvikariat zu stürmen.","Kirche in der Schußlinie","","","",[4],1,[1],[2],2,"24","2"],["3900","1968-05-31","Ausführlicher Bericht über die Vollversammlung des Otto-Suhr-Instituts, auf der zunächst ergebnislos über die Reformmodelle für das Institut debattiert wurde. Stellungnahmen u.a. von Prof. Löwenthal dazu. Mehrere Institute der FU Berlin seien weiterhin besetzt. An der Juristischen Fakultät dagegen wachten Studenten vor den Gebäuden, um eine Besetzung zu verhindern. Richtigstellung, dass vor dem Kunsthistorischen Institut entgegen anderslautender Meldungen vom Vortag keine Streikwachen positioniert waren. Die Deutsche Film- und Fernsehakademie wurde für die Nutzung vom Direktorium gesperrt, da während einer dreitägigen Besetzung ein Sachschaden von etwa 4.000 DM entstanden sei.","Politologen proben die Entmachtung des Ordinarius","","Diskussion um revolutionäre Pläne im Otto-Suhr-Institut","M.L. Müller",[4],1,[1],[1],2,"24","8"],["3901","1968-05-31","Ausführlich zur Aktuellen Stunde im Berliner Abgeordnetenhaus zur Situation an den Berliner Hochschulen. Die CDU warf der SPD vor, bei der Besetzung von Hochschulinstituten tatenlos zuzusehen, fordert zudem den Rücktritt von den Senatoren Stein, Evers und Hoppe.","CDU: Drei Senatoren sollte ihre Ämter niederlegen","","Bei Neubauers Rede zog die Opposition verärgert aus dem Saal","D. Goos",[1],1,[1],[1],1,"24","10"],["3902","1968-05-31","Gesetzentwurf zur Anpassung der Satzung der FU Berlin an jene der TU. Demnach kann auch der Akademische Senat eine Urabstimmung der Studentenschaft initiieren, was bislang der Studentenvertretung vorbehalten war.","Studenten, Richter, Polizisten","","Gesetzesvorschlag zur Änderung der FU-Satzung diskutiert","L.K.",[4],1,[1],[3],1,"24","10"],["3903","1968-05-31","Die Staatsanwaltschaft hat das Verfahren gegen Polizeibeamte, die am 2. Juni 1967 Rauchbomben zurück in die Menge der Demonstranten warfen, eingestellt.","EWG-Ausschuß nach Berlin?","","","LUK",[1],1,[1],[2],2,"24","10"],["3904","1968-05-31","Offener Brief der SPD-Betriebsgruppe der TU Berlin an den Rektor und den Akademischen Senat. Darin heißt es, dass eine radikale politische Gruppe die TU terrorisiere, der Rektor wird zu Maßnahmen dagegen aufgefordert sowie zur Fortsetzung der Reformarbeit. Gegen den Baggerfahrer, der sein Fahrzeug in die Demonstrantenmenge gelenkt hatte (siehe BM vom 30.05.1968), wird nun nicht mehr wegen versuchten Totschlags, sondern nur noch wegen Verkehrsgefährdung und Missachtung eines Haltezeichens eines Polizisten ermittelt.","Offener Brief an den Senat der TU","","","",[1],1,[1],[2],2,"24","10"],["3905","1968-05-31","Auf Veranlassung des Rektors Rüegg beendete die Polizei die Besetzung der Frankfurter Universität. Der Rektor begründete seine Entscheidung mit Sachbeschädigungen durch die Besetzer. Auf einer Veranstaltung hätten zahlreiche Studenten dem SDS die Unterstützung aufgekündigt, SDS-Sprecher Krahl sei ausgepfiffen worden. Die hessischen Minister Schütt und Arndt stellten sich den Studenten zur Diskussion. Strafanzeigen und Festnahmen gegen einige Besetzer. Kurzberichte zur Situation an weiteren westdeutschen Hochschulen. Mehrere Bundestagsabgeordnete sollen anonyme Drohbriefe erhalten haben, in denen ihnen der Tod angedroht wurde, falls sie für die Notstandsgesetze stimmen würden. Der stellv. Vorsitzende des VdS, Pätzold, trat aus der SPD aus, weil deren Bundestagsfraktion den Notstandsgesetzen zustimmte. Streik bei der \"Westfalen-Post\".","Frankfurter Uni von der Polizei geräumt","","Fünf Studenten des \"Streikkomitees\" festgenommen","",[1],1,[1],[1],1,"24","11"],["3906","1968-05-31","Ausführlicher Bericht zur dritten Lesung der Notstandsverfassung, Reden der Politiker.","Helmut Schmidt: Das parlamentarischste Notstandsrecht in Europa","","Minister Schröder nahm an der Abstimmung nicht teil","",[1],1,[1],[1],1,"24","13"],["3907","1968-06-01","Hausdurchsuchungen bei linksradikalen Organisationen in Frankfurt und Berlin, u.a. auch bei der Kommune I und dem SDS-Bundesvorstand. Das erwartete Diebesgut wurde nicht gefunden, dafür Molotow-Cocktails sichergestellt. Lediglich in Heidelberg sei die Universität noch teilweise besetzt, an den meisten anderen Universitäten wurde der Lehrbetrieb wieder aufgenommen und die Schäden durch die Besetzungen behoben. In Frankfurt kam es zu einem Polizeieinsatz gegen 200 Schüler eines Gymnasiums, die eine Sitzdemonstration veranstaltet hatten.","Einbrecher in der FU","","Polizei fand bei \"Kommune\" Molotow-Cocktails","",[1],1,[1],[2],2,"14","1"],["3908","1968-06-01","Kritik an den Studentenunruhen, Aufforderung an den Senat, endlich etwas dagegen zu unternehmen. Richtigstellung von Prof. Simson zu einer Meldung der BM über die Einstellung des Lehrbetriebs am Kunsthistorischen Institut der FU.","Vollversammlung distanzierte sich","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["3909","1968-06-01","Kritik an den Studentenunruhen und den Universitätsbesetzungen. Das Demonstrationsrecht sei kein Freibrief für kriminelle Handlungen. Kritik an den Behörden, dass zu wenig und zu langsam gegen die Straftäter vorgegangen werde, dies sei bei Verkehrsdelikten und bei Straftaten aus dem Umfeld der NPD anders, was auf Unverständnis in der Bevölkerung stoßen müsse. Linke Rowdys würden besser behandelt werden als rechte.","Wenn es nur der Rasen wäre?","","","wbr.",[1],1,[5],[2],2,"14","2"],["3910","1968-06-01","Einbruch in das Immatrikulationsbüro der FU Berlin, 200 Stempel sowie Studentenausweise und Vordrucke für Zeugnisse seien entwendet worden. Im Germanischen Seminar, was von den Besetzern in einem katastrophalen Zustand zurückgelassen worden sei, wurden einige der entwendete Akten gefunden. Zudem wurde eine Liste der Personen, die das Germanische Seminar besetzt hatten, gefunden. Verdacht gegen Fritz Teufel und Karl-Heinz Pawla, Durchsuchung der Kommune I. An der FU wurde zum Schutz der studentischen Mehrheit ein Aktionskomitee gegründet, dem überwiegend Studenten des RCDS angehören.","200 Stempel aus FU-Büro gestohlen","","Diebe können damit wichtige Dokumente fälschen","M.M.",[1],1,[1],[1],1,"14","3"],["3911","1968-06-01","Hausdurchsuchung der Räume des SDS-Bundesvorstandes in Frankfurt. Grund war der Verdacht, dass sich dort die entwendeten Disziplinarakten aus der Frankfurter Universität befänden, welche jedoch nicht gefunden wurden. Stattdessen wurden u.a. Tränengaskerzen und Briefwechsel mit der FDJ beschlagnahmt. Der SDS protestierte gegen die Durchsuchung. Nur noch vereinzelte Studentendemonstrationen in verschiedenen Städten in der Bundesrepublik.","Haussuchung beim SDS","","Frankfurter Kripo suchte verschwundene Disziplinarakten","",[8],1,[1],[5],1,"14","3"],["3912","1968-06-02","Die Berliner Gewerkschaftsjugend nimmt nicht an der Demonstration zum 1. Todestag von Benno Ohnesorg teil, weil sie befürchtet, dass die Demonstration umfunktionalisiert werden würde.","Ohne Gewerkschaftsjugend","Schnell informiert","","",[1],1,[1],[2],2,"64","1"],["3913","1968-06-02","Studenten- und Schülerkongress in Frankfurt zum Thema \"Schluss mit der Pressemanipulation in Deutschland\". Statt der erwarteten 10.000 Teilnehmer kamen nur etwa 650.","Nur 650 kamen","","","",[10],1,[1],[2],1,"64","2"],["3914","1968-06-02","Serie der Berliner Morgenpost, die gegenwärtigen Unruhen werden als Generationenkonflikt gedeutet, alle zum gegenseitigen Verständnis aufgerufen, auch die heute älteren Generationen hätten in ihrer Jugend oftmals protestiert, nur die historischen Erfahrungen sind anders. Fiktiver Bericht Kloses über die Jugend von 1890-1914.","Deutschland - deine Jugend","","","Werner Klose",[1],1,[1],[1],1,"64","12"],["3915","1968-06-05","Der polnische sozialistische Jugendverband kritisiert die deutsche APO, diese sei ideologisch unreif, weil sie zwar für das richtige Ziel der sozialistischen Revolution demonstrieren würde, aber keine Einheitsfront mit der marxistischen Arbeiterbewegung bilde und Parolen wie \"Alle macht den Räten\" propagiere.","Kritik aus Polen an Linksradikalen","","","",[11],1,[1],[2],2,"18","2"],["3916","1968-06-05","Zeitplan für den Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kunst zum neuen Universitätsgesetz.","Noch acht weitere Sitzungen geplant","","","",[4],1,[1],[2],2,"18","6"],["3917","1968-06-05","Prozess gegen fünf Teilnehmer der Demonstrationen gegen den Besuch des Schahs am 2. Juni 1967, unter ihnen Christian Semler. Verteidiger Horst Mahler lehnt eine Vertagung des Prozesses bis zur Entscheidung über eine eventuelle politische Amnestie ab, da der Prozess nötig sei, um das gesetzeswidrige Verhalten der Polizei gegenüber den Demonstranten darzustellen.","Demonstrant: \"Ei traf leider nicht den Schah\"","","","",[1],1,[1],[2],2,"18","6"],["3918","1968-06-05","Bundeskanzler Kiesinger warnt die ältere Generation vor selbstgefälligen Urteilen über die Studentenunruhen, man müsse herausfinden, was man selber falsch gemacht habe. An der Universität Frankfurt soll der Lehrbetrieb nach 10 Tagen wieder aufgenommen werden, die Uni in Heidelberg bleibt dagegen weiter besetzt. Grund ist die Suspendierung des AStA durch die Rektorin. Der Coburger Convent will sich künftig auch hochschulpolitisch engagieren. Prof. Bettermann von der FU fordert Aufnahmeprüfungen für Studenten.","Aufnahmeprüfung zum Studium?","","","",[1],1,[1],[2],2,"18","8"],["3919","1968-06-06","U.a. auch eine Stellungnahme zum Attentat auf Robert Kennedy von Rudi Dutschke, der sich tief erschüttert gezeigt habe.","Mitgefühl in aller Welt","","","",[9],1,[1],[2],2,"18","1"],["3920","1968-06-06","Das Verwaltungsgericht Karlsruhe bestätigt die Suspendierung des AStA der Universität Heidelberg durch die Rektorin.","AStA suspendiert","Kurz gemeldet","","",[1],1,[1],[2],2,"18","2"],["3921","1968-06-07","Schweigermarsch von ca. 1.500 Berliner Jugendlichen für den ermordeteten Robert Kennedy. Der FU-AStA verweigert seine Teilnahme, weil der Trauermarsch vom Ring Politischer Jugend veranstaltet werde.","Schweigemarsch zum Rathaus","","","Go.",[9],1,[1],[2],1,"24","1"],["3922","1968-06-07","Hausverbot der Universität Frankfurt gegenüber Hans-Jürgen Krahl. Das bayerische Justizministerium spricht sich gegen eine politische Amnestie aus. Die deutsche Burschenschaft sprach sich gegen radikale Aktionen aus, zeigte aber auch Verständnis für die Proteste.","Hausverbot für SDS-Funktionär","","","",[1],1,[1],[2],2,"24","2"],["3923","1968-06-07","Bericht über die Ermittlungsverfahren gegen Demonstranten und Polizisten wegen der Osterunruhen.","Viel Arbeit für die Justiz","","","",[1],1,[1],[2],2,"24","3"],["3924","1968-06-07","Der Ausschuss für Wissenschaft und Kunst stimmte der Satzungsänderung der FU, wonach auch der Akademische Senat Urabstimmungen der Studentenschaft beantragen kann, zu.","Zugestimmt","","","",[4],1,[1],[2],2,"24","3"],["3925","1968-06-07","Rudi Dutschke wurde im Krankenhaus zum Attentat auf ihn vernommen. Am Tag dieser Meldung soll der Attentäter Josef Bachmann dem Untersuchungsrichter zur Vernehmung vorgeführt werden.","Dutschke wurde gestern vernommen","","","",[2],1,[1],[2],2,"24","3"],["3926","1968-06-07","Ankündigung der bevorstehenden Rektoratswahlen an der TU und FU Berlin.","Rektoratswahlen am 15. Juni","","","",[4],1,[1],[2],2,"24","3"],["3927","1968-06-07","Gegen Peter Brandt wurden zwei Wochen Dauerarrest wegen Auflaufs in zwei Fällen verhängt. Laut Gericht sei Brandt charakterlich und sittlich noch als Jugendlicher anzusehen.","Dauerarrest für Peter Brandt","","","",[1],1,[1],[2],2,"24","5"],["3928","1968-06-07","Studenten der VAFU und weiteren zum SDS in Opposition stehenden Organsisationen wurden vor dem Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kunst zum geplanten Universitätsgesetz gehört. Die Studenten verneinen ein politisches Mandat des AStA.","\"Kein Anspruch auf ein politisches Mandat\"","","Studenten von FU und TU vor dem Ausschuß für Wissenschaft","",[4],1,[1],[2],2,"24","6"],["3929","1968-06-07","Die Ermittlungen der Frankfurter Kriminalpolizei gegen die vier mutmaßlichen Frankfurter Kaufhausbrandstifter sind abgeschlossen. Kurze Portraits über Baader, Proll, Söhnlein und Ensslin. Baader sei SDS-Mitglied.","Vier Brandstifter warten auf die Anklageschrift","","","J.M.",[9],1,[1],[2],2,"24","6"],["3930","1968-06-08","In mehreren Städten kam es zu Studentenprotesten. In Würzburg kam es zu Schlägereien während eines Trauermarsches für Robert Kennedy zwischen Veranstaltern und linksradikalen Studenten. In Hamburg fordern die Studenten der Ingenieurschulen eine bessere Berücksichtigung ihrer Belange. Gegen 23 Hamburger Polizeibeamte werde wegen der Vorgänge während der Osterunruhen ermittelt. 1.000 deutsche Hochschullehrer haben bisher das Marburger Manifest, in dem man sich gegen die Bestrebungen radikaler Professoren und Studenten ausspricht, unterzeichnet.","Minister ausgepfiffen","","","",[1],1,[1],[2],2,"14","2"],["3931","1968-06-08","Die Instandsetzung der Räume des Germanischen Seminars der FU Berlin nach der Besetzung durch Studenten koste etwa 18.000 DM. Zudem seien 300 Bände aus der Institutsbibliothek entwendet worden. Der AStA der FU verweigert die Übernahme der Kosten.","FU-AStA will nicht zahlen","","","",[1],1,[1],[2],2,"14","3"],["3932","1968-06-09","Der Wahlkampf zum Studentenparlament an der TU Berlin hat begonnen. Wegen der jüngsten Vorkommnisse an der TU Berlin wird eine erhöhte Beteiligung erwartet. Der Ausgang der Wahlen sei offen.","Wahlkampf an der TU begann","","","MM.",[4],1,[1],[2],2,"60","5"],["3933","1968-06-11","Rudi Dutschke wurde aus dem Krankenhaus entlassen und befindet sich nun zur Kur in der Schweiz. Angeblich wolle Dutschke nach der Kur in den Vereinigten Staaten leben und sein Studium fortsetzen. Ein amerikanischer Kongressabgeordneter forderte daraufhin ein Einreiseverbot für Dutschke, die USA dürften nicht zum Treffpunkt für Fanatiker und Agitatoren aus aller Welt werden. Dutschkes Attentäter Bachmann hat versucht, sich zu erdrosseln","Dutschke flog zur Kur in die Schweiz","","Selbstmordversuch des Attentäters Bachmann","L.R.",[2],1,[1],[1],1,"14","3"],["3934","1968-06-11","Am Germanischen Seminar hat sich ein geschäftführendes Gremium gebildet. Auch Studentenvertretern wird die Mitarbeit angeboten. Zugleich wird die kürzliche Besetzung des Germanischen Seminars vom Gremium kritisiert.","\"Vernunftswidrige Besetzung\"","","","",[4],1,[1],[2],2,"14","3"],["3935","1968-06-11","Studenten der Berliner Wirtschaftsakademie und der Ingenieur-Akademien wollen streiken, da die Kultusministerkonferenz in Hannover nicht ausreichend auf ihre Belange eingegangen seien.","Vorlesungsstreik","","","",[4],1,[1],[2],2,"14","3"],["3936","1968-06-11","Gerichtsprozess gegen Horst Mahler wegen einer Zivilklage des Axel Springer Verlages auf Schadensersatz in Höhe von etwa 500.000 DM, Hintergrund ist die Beteiligung Mahlers bei den Unruhen vor dem Springer-Hochhaus Ostern 1968. Ein Vergleich scheiterte.","Prozeß gegen Mahler vertagt","","","",[6],1,[1],[2],2,"14","6"],["3937","1968-06-11","Prof. Weichselberger sagte vor dem Parlamentarischen Untersuchungsausschuss für Wissenschaft und Kultur zum geplanten Universitätsgesetz und den Studentenunruhen aus. Weichselberger habe die Abgeordneten mit seiner Rede sehr beeindruckt, man solle von der Hochschulreform nicht die Eindämmung jeglicher studentischer Unruhe erwarten.","Die Universitätsreform ist kein Allheilmittel","","Professor Weichselberger erneut vor dem Parlamentsausschuß","Michael L. Müller",[4],1,[1],[1],1,"14","6"],["3938","1968-06-12","Erneut schwere Studentenunruhen in Paris. Das französische Innenministerium hat mittlerweile 22 deutsche Studenten, die Mitglieder des SDS sind, des Landes verwiesen.","Paris wieder ein Hexenkessel","","","",[1],1,[1],[2],1,"14","1"],["3939","1968-06-12","Unbefristeter Vorlesungsstreik der Mehrzahl der deutschen Ingenieurstudenten zwecks Verbesserung ihrer Studiensituation.","Streik an den Ingenieurschulen","","","",[4],1,[1],[2],2,"14","2"],["3940","1968-06-12","An der FU Berlin wird in mehreren Instituten über eine bevorstehende Reform debattiert. Vorbild seien dabei die Reformmodelle des Otto-Suhr-Instituts.","\"Sprengstoff an der FU\"","","Plan zur Neuordnung des Otto-Suhr-Institutes","",[4],1,[1],[2],2,"14","3"],["3941","1968-06-12","Die Ost-Berliner Humboldt-Universität bietet den Japanologie-Studenten der FU Berlin an, ihr Studium im Ostteil der Stadt fortzusetzen. Diese sehen dies jedoch nur als letzte Möglichkeit an. Die Besetzung des Japanologischen Instituts wird weiter aufrecht erhalten und an der Forderung der Absetzung von Prof. Eckardt festgehalten. Einige Seminare wurden bereits wieder aufgenommen, die Studenten hätten die Schäden, die im Institut durch die Besetzung entstanden seien, weitestgehend bereits selbst beseitigt.","Der Osten lockt FU-Japanologen","","","MM.",[1],1,[1],[2],2,"14","5"],["3942","1968-06-12","Der Prozess gegen Josef Bachmann wegen des Attentats auf Dutschke werde wohl wegen weiterer Untersuchungen des Geisteszustands von Bachmann vertagt.","Prozeß vertagt","","","",[2],1,[1],[2],2,"14","5"],["3943","1968-06-13","Etwa 3000 junge Berliner, darunter zahlreiche Studenten, seien vor den Alliierten-Kontrollrat gezogen, um gegen die jüngsten Maßnahmen der DDR zu protestieren. (In der II. Fassung vom 13.06.1968 leicht ergänzte Version, demnach hat ein Teil der Demonstranten vor dem Rathaus Schöneberg eine Unterredung mit Bürgermeister Schütz gefordert.)","Demonstration vor Kontrollrat","","","",[1],1,[1],[2],2,"18","1"],["3944","1968-06-13","Die Studenten der Staatlichen Akademie für Bauwesen streiken, um so gegen die Beschlüsse der Kultusministerkonferenz zu protestieren, welche ihrer Meinung nach ihre Reformvorstellungen nicht ausreichend berücksichtig haben.","Weiter Streik","","","",[4],1,[1],[2],2,"18","3"],["3945","1968-06-13","Das Abgeordnetenhaus stimmte einer Änderung der Satzung der FU Berlin zu, wonach nun auch der Akademische Senat die Studentenschaft zu einer Urabstimmung aufrufen kann. Der Akademische Senat kritisierte, dass diese Entscheidung ohne seine Anhörung getroffen worden sei, zudem sei die Änderung nicht geeignet, den Unruhen und strafbaren Handlungen an der Universität Einhalt zu gebieten.","Schütz: \"Noch härter arbeiten als zuvor\"","","Erklärung zu den neuen Schikanen der Zone","D. Goos",[4],1,[1],[2],1,"18","3"],["3946","1968-06-13","Erneut schwere Unruhen in Paris. Daniel Cohn-Bendit erhält nach Protesten von Studentenvertretern aus mehreren anderen Ländern eine vierzehntägige Aufenthaltsgenehmigung in London, wo die BBC-Sendung \"Revolte der Studenten\" aufgezeichnet wird. Zuvor war er erst in Abschiebehaft genommen worden, bevor er eine auf 24 Stunden begrenzte Aufenthaltsgenehmigung erhalten hatte.","Wieder eine heiße Nacht in Frankreich","","Studenten- und Arbeiter-Krawalle ohne Ende","",[1],1,[1],[1],1,"18","18"],["3947","1968-06-14","Erneut demonstrierende junge Berliner und Studenten gegen die jüngsten Behinderungen der DDR im Berlin-Verkehr.","Protest gegen die Schikanen","","","",[1],1,[1],[2],2,"18","1"],["3948","1968-06-14","Am Otto-Suhr-Institut wurde in einer Vollversammlung ein neuer Satzungsentwurf beschlossen, der eine weitgehende Reform bedeuten würde (u.a. Drittelparität). Der Akademische Senat stehe nun vor der schwierigen Situation, diesen entweder zu billigen und damit zu riskieren, dass auch andere Institute ähnliche Modelle vorlegen, oder ihn abzulehnen und damit der studentischen Revolution neuen Auftrieb zu geben.","Neuer Satzungsentwurf tickt als \"Zeitbombe\"","","Vor revolutionären Veränderungen am Otto-Suhr-Institut?","MM.",[4],1,[1],[1],2,"18","5"],["3949","1968-06-14","Bei der Rektorenwahl an der TU Berlin werden künftig auch Studentenvertreter teilnehmen dürfen.","Rektorwahl nach neuem Modus","","","",[4],1,[1],[2],2,"18","5"],["3950","1968-06-14","Die Beteiligung an den Wahlen zum TU-Studentenparlament sei bisher schwach gewesen.","TU: Schwache Wahlbeteiligung","","","",[4],1,[1],[2],2,"18","5"],["3951","1968-06-14","Diskussion an der TU Berlin um die Berufung von Prof. Mackensen auf den neuen zweiten Lehrstuhl für Soziologie. Die Studenten lehnen Mackensen ab.","Der Beweis ist noch in Arbeit","","Die Studenten lehnten Professor bereits wegen \"Unfähigkeit\" ab","J. M.",[4],1,[1],[3],2,"18","5"],["3952","1968-06-14","Senator Stein hat im Studentendorf Schlachtensee an einer Hochschuldebatte teilgenommen. Er bejahte nur bedingt die Forderung nach Autonomie der Hochschulen, diese seien ein Teil der Gesellschaft, sodass die Gesellschaft auch mitbestimmen dürfe.","Diskussionen um Hochschulgesetz","","","",[4],1,[1],[3],2,"18","5"],["3953","1968-06-14","Die Berliner Jungdemokraten empfehlen den Studenten des Ostasiatischen Seminars der FU, ihr Studium an der HU Berlin im Ostteil fortzusetzen. So könne man auch an den Universitäten in der DDR das demokratische Potential aktivieren.","Empfehlung","","","",[1],1,[1],[3],2,"18","5"],["3954","1968-06-15","Kritik an der Berliner Bevölkerung, weil diese nicht gegen die jüngsten Maßnahmen der DDR im Berlin-Verkehr protestiert hätten, sondern dies erneut einer studentischen Minderheit überlassen hätten.","Spontaner Protest blieb aus","Leserbriefe","","Leser",[1],1,[6],[2],2,"12","2"],["3955","1968-06-15","Eine Vollversammlung des Otto-Suhr-Instituts der FU Berlin hat eine neue Satzung verabschiedet, die wegweisend für die Hochschulreform sein soll (u.a. Drittelparität).","Neue Satzung","","","",[4],1,[1],[2],2,"12","3"],["3956","1968-06-15","Bei der Besetzung des Germanischen Seminars der FU Berlin sei ein Schaden von mehr als 33.000 Mark entstanden. Nun werde geprüft, wer für den Schaden aufkommen müsse.","33.000 Mark Schaden im Germanischen Seminar","","","",[1],1,[1],[2],2,"12","5"],["3957","1968-06-15","Demonstration und Protestzug von etwa 3.000 streikenden Ingenieurstudenten gegen die jüngste Erklärung der Kultusministerkonferenz. Debatte mit Senator Evers, der nicht gegen die Erklärung gestimmt hatte, obwohl er wie die Studenten weiterreichende Reformen fordert.","Ingenieur-Studenten faßten Evers hart an","","Diskussion mit dem Senator nach dem Protestmarsch","J. M.",[1],1,[1],[5],1,"12","5"],["3958","1968-06-16","Die Rektoratswahlen an der TU und FU Berlin haben kaum personelle Veränderungen gebracht, die Rektoren wurden im Amt bestätigt. Die Wahl zum Studentenparlament der TU habe eine Pattsituation zwischen linken und rechten bzw. gemäßigten Studenten gebracht. Die Wahlbeteiligung sei gegenüber der letzten Wahl zurückgegangen, dies sei auch ein Grund, warum der \"Ruck zur Mitte\" nicht erfolgt sei. Das Ergebnis sei Nahrung für die Diskussionen, ob Studentenparlamente überhaupt noch in der Lage sind, wirksame und für die ganze Studentenschaft nützliche Politik zu betreiben.","Kaum Wechsel durch Rekoratswahlen","","An der FU bleiben Harndt und Lieber im Amt - TU erhält \"Übergangs-Spitze\"","M.M.",[4],1,[1],[3],1,"62","3"],["3959","1968-06-16","Die Studentenschaft der Wirtschaftsakademie hat einen Vorlesungsstreik bis zum 30. Juni beschlossen. Die Dozenten haben sich mit den Streikenden solidarisch erklärt. Gemeinsam wolle man neue Pläne für Reformen der Akademie ausarbeiten.","Streik an der Wirtschaftsakademie","","","",[4],1,[1],[3],2,"62","3"],["3960","1968-06-19","Demonstrationen der Ingenieurstudenten für eine Anerkennung der Ingenieurschulen als Hochschulen. Die Polizei bezeichnete die Protestmärsche als ungewöhnlich diszipliniert.","Gesitteter Protest","","","",[4],1,[1],[2],1,"20","2"],["3961","1968-06-19","Neuwahl des Berliner Landesvorstandes des RCDS. Dieser verlangt eine fortschrittliche Politik und befürchtet die akute Gefahr der geistigen Austrocknung in der CDU. Der RCDS soll als Alternative zu den außerparlamentarischen Kräften profiliert werden. Die Berliner Ingenieurstudenten beteiligen sich an einer bundesweiten Urabstimmung über einen Prüfungsboykott und einen Vorlesungsstreik an den Ingenieurschulen.","RCDS spricht von akuter Gefahr","","","",[4],1,[1],[2],2,"20","5"],["3962","1968-06-20","Franz-Josef Strauß spricht sich gegen eine Amnestie für Studenten, die an gesetzeswidrigen Aktionen gegen die öffentliche Ordnung teilgenommen haben, aus. Diese Studenten würden auch keine Stipendien aus öffentlichen Mitteln verdienen. (Nur in der ersten Fassung der Ausgabe).","Strauß gegen Amnestie","Schnell informiert","","",[1],1,[1],[2],2,"20","1"],["3963","1968-06-20","Laut dem VdS bereite sich seit den erfolglosen Protesten gegen die Notstandsgesetzgebung Aktionsmüdigkeit und Resignation unter den Studenten aus. Der Vorsitzende Ehmann forderte seine Kommilitonen auf, in Parteien und Betriebe zu gehen.","Studenten sind müde","Kurz gemeldet","","",[1],1,[1],[2],2,"20","2"],["3964","1968-06-21","Die Studenten an den Berliner Ingenieur-Akademien haben sich in einer Urabstimmung mehrheitlich für einen unbefristeten Vorlesungs- und Prüfungsboykott ausgesprochen.","Studenten für Streik","","","",[4],1,[1],[2],2,"18","3"],["3965","1968-06-22","Bei der Grundsteinlegung für die Universität Bielefeld ist es zu Schlägereien zwischen Studenten und der Polizei gekommen. Die Studenten protestierten vor allem gegen den Kultusminister von Nordrhein-Westfalen, Holthoff, dem sie vorwerfen, die Hochschulreform nicht genügend voranzutreiben. In Tübingen besetzten Studenten die Räume der zivilen Luftschutz-Hilfsdienststelle, um gegen unzureichende Studienbedingungen zu protestieren. Der VdS schlägt Institutsmodelle nach Drittelparität vor. Der parlamentarische Staatsekretär im Bundesinnenministerium kündigt an, das Studenten, die sich einer strafbaren Handlung schuldig gemacht haben, künftig kein Stipendium nach dem Honnefer Modell erhalten sollen.","Schlägerei zwischen Polizei und Studenten","","","",[1],1,[1],[2],2,"14","2"],["3966","1968-06-22","Der Verdacht gegen Fritz Teufel, dass dieser während der Besetzung des Germanischen Seminars in das Immatrikulationsbüro eingebrochen und Dienststempel und Unterlagen gestohlen habe, hat sich nach Ansicht der Polizei und einer Zeugenaussage erhärtet.","Teufel unter schwerem Verdacht","","","",[1],1,[1],[2],2,"14","5"],["3967","1968-06-22","Die Berliner FDP-Fraktion stellt eine Dringlichkeitsanfrage an den Senat, ob dieser künftig beabsichtige, die fachbezogenen Akademien in den Hochschulbereich zu integrieren. Der stellvertretende Direktor der Staatlichen Ingenieurakademie bezeichnete die Entscheidung seiner Studenten zu einem unbefristeten Streik als wohlüberlegten und zu respektierenden Beschluss. Die Wirtschaftsakademie Berlin setzt ihren Streik bis Ende Juni fort.","FDP fragt Senat nach Akademien","","","",[4],1,[1],[2],2,"14","5"],["3968","1968-06-22","Über die Sitzung des Konvents der FU Berlin, dieser habe die Tagesordnung nicht erfüllt, generell habe die Veranstaltung wenig Aufmerksamkeit bei den Teilnehmern erhalten, sie sei wie so oft disziplinlos gewesen.","Tagesordnung nicht geschafft","","Über Geldfragen diskutierte der FU-Konvent zu gemütlich","F. H.",[4],1,[1],[3],2,"14","5"],["3969","1968-06-22","An der Pädagogischen Hochschule Berlin fehlten etwa 15 bis 20 Studienplätze. Im Sommersemester waren bereits etwa 200 Studenten mehr aufgenommen als vorgesehen wurde. Senator Stein kündigte zusätzliche Planstellen für die PH an.","Studienplätze fehlten","","","L.K.",[4],1,[1],[3],2,"14","5"],["3970","1968-06-22","Der Vorstand der FU-Betriebsgruppe der SPD wurde neu gewählt. Man verstehe sich weiterhin als innerparteiliche Opposition in der SPD und plane gemeinsame Aktionen mit der APO.","Neuer Vorstand","","","",[4],1,[1],[3],2,"14","5"],["3971","1968-06-22","Ein Dozent gab seinen Lehrauftrag an der FU Berlin zurück, weil seine Veranstaltung für Studienanfänger vermehrt von älteren Studenten gestört wurde.","Dozent resignierte","","","",[1],1,[1],[3],2,"14","5"],["3972","1968-06-22","Auch die nichtwissenschaftlichen Mitarbeiter der Berliner Universitäten sollen nach einer Forderung der Personalräte von FU und TU Berlin künftig zu den Mitgliedern der Universität gehören. Deshalb sollen auch sie ein Mitbestimmungsrecht erhalten.","Mitbestimmung gefordert","","","",[4],1,[1],[3],2,"14","5"],["3973","1968-06-23","Der CDU-Politiker Dufhues spricht sich gegen eine politische Amnestie aus.","Dufhues gegen Amnestie","Schnell informiert","","",[1],1,[1],[2],2,"60","1"],["3974","1968-06-23","Studenten der Berliner Film- und Fernsehakademie veranstalteten in der TU Berlin ein \"Eierwurf-Happening\", um so gegen mehrere Filmregisseure zu protestieren.","Protest","Schnell informiert","","",[1],1,[1],[2],2,"60","1"],["3975","1968-06-23","Bei der Eröffnung der Kieler Woche kam es zu Störungen durch Studenten, insbesondere als Klaus Schütz in der Funktion des Bundesratspräsidenten seine Eröffnungsrede hielt. Schütz kritisierte die Studenten, unterstellte Verabsolutierung des eigenen Standpunktes. Diese warfen mit Eiern nach ihm und sprachen vom \"imperialistischen Ritual\" der Kieler Woche.","Zur Eröffnung flogen Eier","","","",[1],1,[1],[3],2,"60","1"],["3976","1968-06-23","Die von Studenten besetzte Tübinger Luftschutz-Dienststelle wurde von der Polizei geräumt, der AStA wirft der Polizei Brutalität vor.","Polizei drängte Studenten hinaus","","","",[1],1,[1],[2],2,"60","2"],["3977","1968-06-25","An der Universität Frankfurt sind durch die Besetzung im Mai Schäden zwischen 70.000 und 100.000 DM entstanden. Mehrere Studenten, vorwiegend Angehörige des SDS, sollen durch Klagen zum Schadensersatz gezwungen werden.","Aufrührer sollen zahlen","Schnell informiert","","",[1],1,[1],[2],2,"16","1"],["3978","1968-06-25","Neue Termine für die Vernehmung von Josef Bachmann wurden angesetzt. Bachmann wird nach wie vor nach seinem Selbstmordversuch wegen Erregungszuständen behandelt.","Bachmann wird bald vernommen","","","",[2],1,[1],[2],2,"16","3"],["3979","1968-06-25","Die Studenten der Ingenieur-Akademien stellen Foderungen, die erfüllt werden müssten, damit sie ihren Streik beenden, u.a. die Eingliederung in den Hochschulbereich. Sie gehen damit weitestgehend konform mit den Vorstellungen von Senator Evers.","Studenten stellen vier Forderungen","","","",[4],1,[1],[2],2,"16","3"],["3980","1968-06-25","Prof. Leussink sagte vor dem Ausschuss für Wissenschaft und Kunst zu den geplanten Hochschulgesetzen aus.","Lob für Berlins Entwürfe zum Hochschulgesetz","","","",[4],1,[1],[2],2,"16","3"],["3981","1968-06-26","In Koblenz setzte die Polizei Tränengas gegen demonstrierende Ingenieurschüler ein und verhaftete vorübergehend 21 Studenten.","Studenten zogen sich aus Kunstakademie zurück","","Sowjets beteiligen sich an der Biennale","",[4],1,[1],[2],2,"12","2"],["3982","1968-06-26","Der Direktor des Seminars für Alte Geschichte an der FU Berlin, Prof. Werner, verlässt die FU, weil man weder von universitärer noch von staatlicher Seite aus gewillt oder befähigt sei, die Studentenunruhen zu meistern.","Professor Werner geht","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["3983","1968-06-27","Die FU Berlin müsse in Zukunft befürchten, dass sie auf Grund der Studentenunruhen große Probleme bei der Berufung von Professoren haben werde. Kritik von Prof. Loos an Senator Stein, dass dieser die Unruhen an der FU nicht in voller Schärfe sehe. Prof. Hatfield von der Harvard-Universität teilte dem Rektor mit, dass er auf Grund der Unruhen weder einem Studenten noch einem Kollegen raten könne, in Berlin zu arbeiten.","FU-Direktor kritisiert Senat","","","",[1],1,[1],[2],2,"16","1"],["3984","1968-06-27","Der niedersächsische Kultusminister Langeheine spricht der Göttinger Universität wie auch der Studentenschaft und ihrer Organe ein allgemeines politisches Mandat ab. Der Göttinger AStA erklärt, dass eine Spaltung in politische und hochschulpolitische Stellungnahmen nicht möglich sei.","Kein politisches Mandat für AStA","","","",[11],1,[1],[3],2,"16","2"],["3985","1968-06-27","Das Sinologische Institut der FU Berlin wurde besetzt. Grund ist die Forderung nach Entbindung von Prof. Eckardt, dem man u.a. antisemitische Äußerungen vorwirft. Auch das Japanologische Institut ist deshalb bereits besetzt. Kritik am Hauptausschuss der Philosophischen Fakultät, der Prof. Eckardt nun aufforderte, freiwillig zurückzutreten. Schwere Kritik vom RCDS an der CDU, diese habe in der Auseinandersetzung mit der jungen Generation versagt, eine Große Koalition sei eine Demokratie ohne Alternative. Man wolle eine Revolution der Vernunft verwirklichen.","Wieder Institut besetzt","","Studenten fordern mehr Härte im \"Fall Eckardt\"","ck",[1],1,[1],[2],2,"16","3"],["3986","1968-06-27","Die FU Berlin müsse in Zukunft befürchten, dass sie auf Grund der Studentenunruhen große Probleme bei der Berufung von Professoren haben werde. Kritik von Prof. Loos an Senator Stein, dass dieser die Unruhen an der FU nicht in voller Schärfe sehe. Die Dozenten seien dem psychischen Druck der APO nicht mehr gewachsen. Prof. Hatfield von der Harvard-Universität teilte dem Rektor mit, dass er auf Grund der Unruhen weder einem Studenten noch einem Kollegen raten könne, in Berlin zu arbeiten. (ausführlicher als der Bericht auf S. 1 in der gleichen Ausgabe)","\"Die FU Berlin ist in größter Gefahr\"","","Ständige Unruhen vertreiben Professoren","Walter Brückmann",[1],1,[1],[1],2,"16","8"],["3987","1968-06-28","Studenten besetzten das Rektorat und den Henry-Ford-Bau der FU Berlin aus Protest gegen die polizeiliche Räumung der Sinologischen und Japanologischen Institute. Zu den Studenten gehöre auch die AStA-Vorsitzende Fronius. Senator Evers und der SPD-Politiker Löffler stellten sich vergeblich als Vermittler zur Verfügung. Löffler bezeichnete das Verhalten des Rektors als bedauerlich. Im Audimax der FU Berlin sprach Cohn-Bendit. Die Studenten erklärten Rektor Harndt für abgesetzt, ein Fleischer trat in der Robe des Rektors auf. Von den 17 Personen, die in den geräumten Instituten angetroffen worden waren, waren neun keine Studenten.","Rektorat der FU von Studenten besetzt/ Ein Fleischer präsentierte sich in der Robe des Rektors","","Ultimative Forderungen an Professor Harndt/ Professor Harndt: Unter Druck werde ich nicht verhandeln","L.R.",[1],1,[1],[5,1],1,"18","1,5"],["3988","1968-06-28","Erstmals seit acht Jahren trafen sich wieder Vertreter des VdS mit der FDJ. Bei den Gesprächen in Ost-Berlin sei bei einigen Punkten Einigkeit erzielt worden, u.a. in der Anerkennung der DDR und der Bewertung des Notstandsgesetzes und des Vietnamkrieges.","VDS-Kontakte zur FDJ","","","",[9],1,[1],[3],2,"18","2"],["3989","1968-06-28","Beratung im Berliner Abgeordnetenhaus über die Vorlage eines neuen Fachhochschulgesetzes, die Forderungen der streikenden Ingenieurstudenten wurden einstimmig weitestgehend übernommen. Diese machten für die Übergangsphase weitere Vorschläge, die sie Senator Evers überreichten.","Parteien für Gesetz über Fachschulen","","","J.M.",[4],1,[1],[2],2,"18","5"],["3990","1968-06-29","Prof. Eckardt ist nach Aufforderung von der kommissarischen Leitung des Sinologischen Instituts zurückgetreten. Der Akademische Senat gibt den Reformvorschlag des Otto-Suhr-Instituts an die Verfasser zur Überabreitung zurück. Senator Stein verteidigt die polizeiliche Räumung zweier Insitute, bedauert aber die Rückgabe des Reformvorschlags für das OSI. Der Demokratische Klub begrüßt ebenfalls die Räumung. Prof. Harndt verteidigt die polizeiliche Räumung, mit der Besetzung des Sinologischen Instituts habe für ihn ein \"Kriegsfall\" vorgelegen, begründet auch, warum er eine Diskussion mit den Studenten ablehnte. Der Akademische Senat billigt Harndts Verhalten mit großer Mehrheit. Die Ingenieurstudenten setzen ihren Streik aus, nachdem die Berliner Politik auf ihre Forderungen eingegangen ist.","Wochenend-Pause an der Freien Universität/ Rektor Harndt: \"Ich war stets für die Studenten da\"","","Satzung des Otto-Suhr-Instituts zurückgewiesen/ FU-Senat nahm Satzung des Otto-Suhr-Instituts nicht an","",[1],1,[1],[2,1],1,"12","1,5"],["3991","1968-06-29","Prof. Werner, der von der FU Berlin zur Uni Erlangen wechselt, wird vom Erlanger AStA eine Podiumsdiskussion angekündigt. Seine Auffassung von der Hochschule sei ein alarmierendes Zeichen.","Studenten attackieren Professor Werner","","Erlangen will Diskussion mit ihm \"erzwingen\"","",[1],1,[1],[2],2,"12","2"],["3992","1968-06-29","Begrüßt die polizeiliche Räumung der zwei ostasiatischen Institute der FU Berlin, verteidigt Rektor Harndt, kritisiert Politiker, die Harndt für seine Entscheidung angreifen, der Berliner Senat hätte die FU lange genug im Stich gelassen. Dem SDS gehe es nicht um die Verbesserung der Studienbedingungen, sondern nur um den Umsturz.","Manipulation des Chaos","","","wbr.",[1],1,[1],[2],2,"12","2"],["3993","1968-06-30","Die CDU fordert den Rücktritt von Senator Stein auf ihrem Landesparteitag, ein Delegierter bezeichnet ihn als \"heimliches Mitglied des SDS\". Das Verhalten von FU-Rektor Harndt wird unterstützt. Der Berliner RCDS-Vorsitzende Hacke griff die CDU scharf an, diese hätte den RCDS nicht genügend unterstützt. Reaktionen von Schmitz und Amrehn dazu.","Berliner CDU fordert den Rücktritt von Senator Prof. Stein/ Amrehn attackiert den Senat","","Vorwurf: Er hat in Universitätsfragen versagt","LUK.",[1],1,[1],[1,3],2,"64","1,2"],["3994","1968-06-30","Der VDS fordert die Bundestagsfraktionen aller Parteien auf, zügig ein Ausbildungsförderungs-Gesetz zu verabschieden. Bundesforschungsminister Stoltenberg spricht Studentenvertretungen das politische Mandat ab.","Studenten drängen Bonner Fraktionen","","","",[4],1,[1],[2],2,"64","2"],["3995","1968-06-30","Die Jüdische Studentenvereinigung fordert den FU-Rektor Harndt auf, alles zu unternehmen, dass Prof. Eckardt künftig keine Vorlesungen mehr halten darf. Dieser sei ein Antisemit, seine Vorlesungen nazistisch durchsetzt. Ansonsten müssten alle jüdischen Studenten und Dozenten erwägen, die FU zu verlassen. Wegen der polizeilichen Räumung der zwei ostasiatischen Institute hat sich eine Vollversammlung der FU dafür ausgesprochen, die studentischen Vertreter aus dem Akademischen Senat abzuziehen. Dem Senat wurde \"jegliche Funktion\" abgesprochen.","\"Eckardt darf nicht mehr lesen\"","","","",[1],1,[1],[2],2,"64","5"],["3996","1968-06-30","Es sei zwar stiller um die Gruppen der APO geworden, dies könne sich aber schnell ändern. Sie habe ihre Strategie geändert und versuche nun, über Diskussionen und Basisgruppen die Solidarität mit den Arbeitern zu erreichen. Dies seien jedoch keine Diskussionen, sondern reine Agitation. Dafür existiere auch ein Schulungspapier in dem es u.a. heißt: Es ginge nicht darum, möglichst viele Menschen von ihrer Meinung zu überzeugen, sondern wenigstens wohlwollende Neutralität zu erreichen. Ziel sei immer noch das Bündnis mit der Arbeiterschaft. Gewalt gegen den Axel Springer Verlag wird weiter gerechtfertigt. Ziel sind Arbeiterräte.","Des APO-Mannes Zunge soll glatter werden","","","Walter Brückmann",[11],1,[1],[1],1,"64","12"],["3997","1968-07-02","Bei einer Diskussionsveranstaltung in der Kölner Universität wurde Bundesinnenminister Benda wiederholt mit Eiern, Tinte und Blumen beworfen, erst nach einer Stunde ebbten die Proteste ab und konnte die Diskussion relativ ruhig stattfinden.","Benda mit Eiern beworfen","","","",[1],1,[1],[2],2,"16","2"],["3998","1968-07-02","Senator Stein weist die Rücktrittsforderung seitens der CDU gegen seine Person zurück, wie auch die Behauptung, er sei Mitglied des SDS gewesen und immer noch deren Sympathisant.","Stein: Ich war nicht im SDS","","","",[1],1,[1],[2],2,"16","2"],["3999","1968-07-02","Vor dem Ausschuss für Wissenschaft und Kunst wurden Vertreter des SDS und des RCDS zum geplanten Universitätsgesetz gehört. Die SDS-Vertreter erklärten, es ginge ihnen nicht um Reformen, sondern um die revolutionäre Umgestaltung. Sie wollten die aktuelle Situation an der FU diskutieren, dies lehnte der Ausschuss ab.","Löffler: \"Das ist hier keine Farce\"","","SDS-Vertreter wollten mit Parlamentariern diskutieren","Fred Huck",[4],1,[1],[1],2,"16","5"],["4000","1968-07-02","Berliner Regierender Bürgermeister Klaus Schütz spricht sich für Experimente, wie sie die Satzungsänderungsvorschläge am Otto-Suhr-Institut darstellen, aus. Polizeieinsätze an Universitäten soll es nur in vertretbarem Ausmaß geben. An der FU kam es zu Vollversammlungen für neue Satzungsmodelle.","Klaus Schütz für Experimente","","","",[4],1,[1],[2],2,"16","5"],["4001","1968-07-03","Erneut wurde das Japanologische Institut besetzt, Rektor Harndt handelte mit studentischen Vertretern einen Kompromiss aus, wodurch die Besetzung aufgegeben wurde. Danach erhalten die Studenten bei der Neubesetzung eines zweiten Lehrstuhls am Institut ein Mitspracherecht. In mehreren Vollversammlungen wurde über die Zurückweisung des Reformmodells für das Otto-Suhr-Institut debattiert und neue, teils weitergehende Vorschläge gemacht. Das Otto-Suhr-Institut will auf seinem Satzungsvorschlag beharren.","Rektor schloß Kompromiß/ Heiße Debatten","","In der FU ging es um neue Satzungen","ck",[1],1,[1],[2],2,"14","1,3"],["4002","1968-07-03","In Hamburg protestierten ca. 500 Studenten für die Beendigung des Krieges zwischen Nigeria und Biafra.","Protest gegen Völkermord","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["4003","1968-07-03","Zwei Professoren des Otto-Suhr-Instituts, die sich kritisch gegen das Reformmodell für das OSI geäußert hatten, haben auf gestohlenem Briefpapier aus dem Rektorat Drohbriefe erhalten, in denen ihnen die fristlose Kündigung ausgesprochen wird. Die FU-Pressestelle spricht von faschistischen Methoden.","Zwei Professoren erhielten Drohbriefe","","","",[1],1,[1],[3],2,"14","3"],["4004","1968-07-04","Kritik an den Studentenunruhen, die sollten u.a. lieber gegen die Mauer und Ulbricht protestieren und vor allem nicht immer im Namen der deutschen Jugend sprechen.","Nicht im Namen der Jugend","Leserbriefe","","Leser",[1],1,[6],[2],2,"14","2"],["4005","1968-07-04","Die Philosophische Fakultät der FU Berlin verurteilt jeden Druck auf den Akademischen Senat, um diesen zu Annahmen von Satzungsentwürfen zu bewegen.","Druck auf Senat der FU verurteilt","","","",[4],1,[1],[2],2,"14","2"],["4006","1968-07-04","Rücktritt des Finanzreferenten des AStA der FU, u.a. wegen der Überproduktion von Flugblättern.","Finanzreferent des AStA trat zurück","","","",[4],1,[1],[2],2,"14","5"],["4007","1968-07-04","FU-Rektor Harndt widerspricht Meldungen, nach denen er bei der neuerlichen Besetzung des Japanologischen Instituts einen Kompromiss mit den Studenten ausgehandelt und so deren Besetzung nachträglich legitimiert habe. Die angeblichen Zugeständnisse seien bereits seit langem geplant gewesen, die studentischen Gesprächspartner des Rektors hätten sich von der Besetzung distanziert.","FU-Rektor: Keine Zugeständnisse an die Rechtsbrecher","","","",[1],1,[1],[2],2,"14","5"],["4008","1968-07-05","Proteste bei der Rektorenwahl an der Uni Hamburg. Da sich die Vollversammlung weigerte, die Wahl öffentlich durchzuführen, zogen die Studentenvertreter ab, weshalb die Vollversammlung nicht mehr beschlussfähig war und die Wahl vertagt werden musste.","Tumulte in Hamburg bei Rektorwahl","","","",[1],1,[1],[2],2,"20","2"],["4009","1968-07-05","Neuer AStA-Vorsitzender der Uni Kiel ist der schleswig-holsteinische Landesvorsitzende des SDS, Bernhard Achterberg.","AStA-Chef im SDS","Kurz gemeldet","","",[4],1,[1],[2],2,"20","2"],["4010","1968-07-05","Herbert Marcuse hat Morddrohungen erhalten, nachdem ein amerikanisches Nachrichtenmagazin berichtete, dass Rudi Dutschke bei ihm studieren wolle. Marcuse sagte dazu, dass sich Dutschke in einem Krankenhaus in Boston behandeln lassen wolle.","Marcuse wird bedroht","Kurz gemeldet","","",[2],1,[1],[2],2,"20","2"],["4011","1968-07-05","Studenten des Ostasiatischen Seminars kündigen einen Protestmarsch durch die Berliner Innenstadt an, um so auf ihre Belange aufmerksam zu machen.","Studenten planen Protestmarsch","","","",[1],1,[1],[2],2,"20","3"],["4012","1968-07-05","Vor dem Ausschuss für Wissenschaft und Kunst wurden Vertreter des LSD und des Coburger Convents zu dem geplanten Universitätsgesetz gehört. Einzige Übereinstimmung sei die Forderung nach Abschaffung des Numerus Clausus gewesen. Der SHB erklärte sich lediglich solidarisch mit dem SDS. SHB und SDS sollen noch einmal gehört werden.","Ausschuß hörte zwei Studentengruppen","","","L.R.",[4],1,[1],[2],2,"20","6"],["4013","1968-07-06","Kritik an den Unruhen an der FU Berlin und vor allem an der Besetzung des Rektorats. Kritik auch am Berliner Senat, dass dieser die Besetzer unterstützt habe. Die FU sei in ihrem Bestand gefährdet.","Reform ja - \"Kulturrevolution\" nein","Leserbriefe","","Leser",[1],1,[1],[2],2,"16","2"],["4014","1968-07-06","Der Dutschke-Attentäter Bachmann hat einen zweiten Selbstmordversuch im Gefängnis unternommen. Er hatte versucht, mit dem Kopf das Zellenfenster zu zertrümmern.","Selbstmordversuch","","","",[2],1,[1],[2],2,"16","3"],["4015","1968-07-06","Ein Doktorand der Philosophischen Fakultät der FU Berlin hat eine Unterschriftenaktion initiiert, die über einen Misstrauensantrag zum Sturz des AStA führen soll. Am ersten Tag haben sich bereits mehr als 500 Studenten in die Listen eingetragen. Die Japanologen demonstrieren weiter gegen Prof. Eckardt. In der Nacht wurde das Institut für Soziologie kurzzeitig besetzt, um so die Lehrkräfte des Intituts zu warnen und die Forderung nach der schnellen Annahme einer neuen Satzung zu unterstreichen.","Doktorand gegen AStA","","Über 500 FU-Studenten unterschrieben bereits","",[4],1,[1],[2],2,"16","3"],["4016","1968-07-06","Nach über einjährigen Beratungen und 113 Sitzungen liegt der Bericht des Untersuchungsausschusses des Berliner Abgeordnetenhauses zu den Studentenunruhen seit dem 2. Juni 1967 vor. SPD/FDP und CDU legen zwei verschiedene Versionen vor, die CDU kritisiert insbesondere, dass es für Teilnehmer an bestimmten Demonstrationen keine Rechtsfolgen gegeben hätte.","Ausschuß-Bericht liegt jetzt vor","","","Lutz Krieger",[1],1,[1],[2],2,"16","3"],["4017","1968-07-07","Das Parteiorgan \"Die Wahrheit\" der SED kritisiert die APO für deren Forderungen nach einer Räterepublik und wegen der Konfrontation mit der Polizei. Dazu auf Seite 2 eine Karikatur: APO und SED-West wollen beide den Baum \"Demokratie\" fällen, der Protagonist der SED-West mit Säge in der Hand belehrt den APO-Vertreter mit Hackebeil: \"Nicht hacken! Sägen, Genossen!\"","SED distanziert sich von \"Ultralinken\"","","","",[1],1,[1],[2],1,"60","1,2"],["4018","1968-07-07","Beim Transport von West-Berlin nach Westdeutschland wurde das Gepäck von Rudi Dutschke von Zollkontrolleuren der DDR durchwühlt. Dutschke verweilt zur Erholung noch immer in der Schweiz.","Dutschkes Gepäck in der Zone durchwühlt","","","",[2],1,[1],[2],2,"60","5"],["4019","1968-07-09","Der Dutschke-Attentäter Bachmann hat einen dritten Selbstmordversuch im Gefängnis unternommen. Er hat einen abgebrochenen Löffelstiel verschluckt.","Bachmann schluckte einen Löffelstiel","","","",[2],1,[1],[2],2,"12","3"],["4020","1968-07-09","Gegen den Pflichtbetrag für die studentische Selbstverwaltung klagt ein Student vor dem Verwaltungsgericht. Auch der Coburger Convent empfiehlt seinen Mitgliedern, diesen Beitrag nicht mehr zu zahlen. Zeitgleich läuft eine Unterschriftenaktion gegen den Pflichtbeitrag an, an der sich am ersten Tag bereits 1.400 Studenten beteiligt haben.","Studenten wollen nicht mehr zahlen","","","",[4],1,[1],[2],2,"12","3"],["4021","1968-07-10","Aus Protest gegen die neuerliche Zurückweisung des Satzungsentwurfs durch den Akademischen Senat ist das geschäftsführende Direktorium des Otto-Suhr-Instituts zurückgetreten. Studenten erklärten das Institut für besetzt.","Rücktritt aus Protest","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["4022","1968-07-10","Wegen Hausfriedensbruch standen acht Mitglieder der Kommune I vor Gericht. Sechs von ihnen wurden noch vor Prozessbeginn inhaftiert, weil sie über auf den Richtertisch sprangen und sich ein Handgemenge mit Polizei und Justizbeamten lieferten, darunter Teufel, Kunzelmann und Langhans. Die Urteile gegen die beiden Verbliebenen lauteten zwei bzw. drei Monate Gefängnis ohne Bewährung.","Ordnungsstrafen für sechs Kommunarden","","","",[5],1,[1],[2],2,"12","3"],["4023","1968-07-10","Auch in der zweiten Beratung weist der Akademische Senat der FU Berlin den Satzungsentwurf für das Otto-Suhr-Institut zurück. Ein Student der TU Berlin klagt mit Unterstützung der Humanistischen Union, um die Rechtswidrigkeit eines Polizeieinsatzes am Ostersonnabend in der Meinekestraße feststellen zu lassen. Vorstellung der \"Linksliberalen Hochschulgruppe\", der auch der ehemalige RCDS-Vorsitzende der FU, Jürgen-Bernd Runge, angehört. Laut Runge liegen von FDP und SPD Angebote zur Zusammenarbeit vor.","Satzungsentwurf für OSI wieder nicht angenommen","","","",[4],1,[1],[5],2,"12","5"],["4024","1968-07-11","Zum zweiten Mal besetzten Studenten das FU-Rektorat, darunter wohl zahlreiche SDS-Mitglieder. Grund war die erneute Ablehnung des Satzungsentwurfes des Otto-Suhr-Instituts durch den Akademischen Senat. Die Polizei räumte nach drei Stunden das Gebäude. Alle Räume seien verwüstet und zahlreiche Dienstsiegel und Unterlagen entwendet worden. Der Schaden soll mehrere zehntausend Mark betragen. Die Polizisten wurden als SS-Mörder und Nazis beschimpft. Senator Stein kritisierte die Studenten dafür scharf, Klaus Schütz sprach von einem Akt des Wandalismus. Ernst Lemmer fordert härteres Vorgehen, da es sonst um die Existenz des freiheitlichen Berlins gehe. Auch Jürgen-Bernd Runge, ehemals RCDS, unterstützte die Besetzung. Etwa 60 bis 80 Studenten seien vorläufig festgenommen worden. Der AStA forderte in einer Resolution die Demokratisierung aller FU-Institute, den Rücktritt des Rektors und die Auflösung des Akademischen Senats. Die Philosophische Fakultät unterstützt mehrheitlich die Ablehnung des Satzungsentwurfs.","FU-Rektorat verwüstet/ FU: Zahlreiche Festnahmen","","Senator Stein: Die Studenten haben unrecht getan/ SDS droht mit Aktionen auch in den Semesterferien","ck",[1],1,[1],[2],1,"16","1,3"],["4025","1968-07-11","Neuwahl des AStA der TU Berlin.","Acht Wahlgänge waren nötig","","","",[4],1,[1],[2],2,"16","3"],["4026","1968-07-11","Das Berliner Verwaltungsgericht hat einer Klage der Studentenverbindung Lusatia-Leipzig zu Berlin stattgegeben, wonach die FU verpflichtet ist, diese als studentische Vertretung an der FU zuzulassen.","Gericht: Verbindung muss an der FU zugelassen werden","","","",[4],1,[1],[2],2,"16","5"],["4027","1968-07-12","Nach einem Beschluss des Amtsgerichts Tiergarten darf Horst Mahler in den Prozessen um die Osterunruhen nicht die Verteidigung von Angeklagten übernehmen, da er verdächtig sei, als Anstifter in diesem Fall tätig gewesen zu sein.","Mahler darf nicht verteidigen","","","",[6],1,[1],[3],2,"16","1"],["4028","1968-07-12","Herbert Marcuse hat nach Morddrohungen sein Heim in San Diego verlassen. Marcuse bestreitet, dass er Rudi Dutschke in die USA eingeladen habe.","Marcuse floh","Schnell informiert","","",[2],1,[1],[2],2,"16","1"],["4029","1968-07-12","Die Universität Würzburg ist nach anhaltenden Studentenunruhen geschlossen worden. U.a. waren Barrikaden errichtet worden. Die Studenten wollten so gegen die Verabschiedung einer neuen Universitätssatzung protestieren, die ihrer Meinung nach zu wenig studentisches Mitspracherecht einräumt.","Uni Würzburg nach Tumulten geschlossen","Schnell informiert","","",[1],1,[1],[2],2,"16","1"],["4030","1968-07-12","Mit der Mehrheit von SPD/FDP wurde der Bericht des Untersuchungsausschusses über die Studentenunruhen vom Abgeordnetenhaus angenommen. Der Fraktionsvorsitzende der FDP, Oxfort, forderte eine Lex OSI, mit der neue Modelle bis zum neuen Universitätsgesetz erprobt werden sollen. Sicht des Ausschussvorsizenden Löffler auf die Gründe für die Studentenunruhen. Scharfe Kritik an SDS und SHB. Gegenstellungnahme der CDU-Mitglieder des Ausschusses.","Vier Stunden Debatten über die Unruhen/ Verständnis für Reformen. Kritik an Extremisten","","Berliner Abgeordnetenhaus debattierte über Studenten-Bericht","LUK./J.M.",[1],1,[1],[2,1],1,"16","1,3"],["4031","1968-07-12","Mitglieder des SDS haben einen Festempfang der Universität Bonn gestört. Es kam zu Schlägereien mit der Polizei.","Feierstunde und Schlägerei in Bonn","","","",[1],1,[1],[2],2,"16","2"],["4032","1968-07-12","Prof. Schwan warnt die Studenten vor illegalen Aktionen wegen dem erneut abgelehnten Satzungsentwurf durch den Akademischen Senat. Dies würde den Reformbemühungen entgegen stehen. Kritik von Schwan am Akademischen Senat. Er und Prof. Sontheimer legten aus Protest ihre Ämter nieder. Der SDS und der AStA erklärt die Satzung dagegen für \"in Kraft gesetzt\" und kündigt Okkupationen von Instituten an.","Schwan: \"Illegale Aktionen schaden dem OSI nur!\"","","","ck",[1],1,[1],[2],2,"16","3"],["4033","1968-07-12","Rudi Dutschke hat seinen Kuraufenthalt in der Schweiz beendet und diese mit unbekanntem Ziel verlassen.","Dutschke hat die Schweiz verlassen","","","",[2],1,[1],[2],2,"16","6"],["4034","1968-07-13","Die nach Unruhen vorübergehend geschlossene Universität Würzburg soll wieder geöffnet werden. Der AStA kündigte einen neuen Streik an.","Uni öffnet wieder","Kurz gemeldet","","",[1],1,[1],[2],2,"12","2"],["4035","1968-07-13","Vier Jugendliche wurden zu Jugend- und Freizeitarrest wegen ihrer Teilnahme an den Demonstrationen gegen die Fahrpreiserhöhungen in Kiel verurteilt.","Arrest für Demonstranten","Kurz gemeldet","","",[1],1,[1],[2],2,"12","2"],["4036","1968-07-13","Über die Rektoratswahl an der TU Berlin. Die Öffentlichkeit wurde zugelassen. An der Kirchlichen Hochschule wurden 22 der 24 Sitze im Konvent von der linken Seite gewonnen.","TU: Drei Kandidaten blieben übrig","","","",[4],1,[1],[2],2,"12","3"],["4037","1968-07-14","Unbekannte haben die Türen der Würzburger Universität zertrümmert.","Uni-Türen zertrümmert","Schnell informiert","","",[1],1,[1],[2],2,"58","1"],["4038","1968-07-14","Über die Rektoratswahl an der TU Berlin. Neuer Rektor ist Prof. Wever. Wever wolle sich für eine funktionsgerechte Mitbestimmung, aber gegen schematischen Proporz einsetzen.","Neuer TU-Rektor Professor Wever/ Professor Wever tritt sein Amt ohne Illusionen an","","Neuer TU-Rektor: Universitäts-Gemeinschaft muss erhalten bleiben","ck",[4],1,[1],[2,1],1,"58","1,6"],["4039","1968-07-14","Der Institutsrat am Otto-Suhr-Institut wurde gewählt, überwiegend wurden linke Vertreter gewählt.","Institutsrat am OSI gewählt","","","",[4],1,[1],[2],2,"58","6"],["4040","1968-07-14","Die Landeskonferenz der wissenschaftlichen Mitarbeiter der Berliner Universitäten und Hochschulen begrüßt Experimente von der Art des Satzungsentwurfs des Otto-Suhr-Instituts und kritisiert den Akademischen Senat der FU für dessen Ablehnung.","Experimente an Hochschulen begrüßt","","","",[4],1,[1],[2],2,"58","6"],["4041","1968-07-16","Tumulte während eines Gerichtsprozesses, Zuschauer warfen Flugblätter in die Menge. Dieter Kunzelmann störte mehrfach seine eigene Zeugenbelehrung, wurde zu drei Tagen Ordnungshaft verurteilt.","Tumult im Gerichtssaal","","","",[1],1,[1],[2],2,"12","5"],["4042","1968-07-16","Studenten der FU können vorläufig von der Zahlung des AStA-Beitrages befreit werden. Dies beschloss die Uni, weil zahlreiche Studenten die Zahlung verweigerten, um die Politik des AStA nicht zu unterstützen. Vor dem Verwaltungsgericht läuft in diesem Zusammenhang eine Klage. Von den 285 Studenten, die sich am Vortag zurückmeldeten, haben 123 den Beitrag nicht gezahlt. Der AStA sieht in der Entscheidung der Uni einen gezielten Versuch, mit Druck die studentische Reformarbeit zu verhindern.","Rückmeldung ohne AStA-Gebühren","","","",[4],1,[1],[2],2,"12","5"],["4043","1968-07-16","Nach ihrer vorübergehenden Schließung wegen Studentenunruhen wurde die Uni Würzburg wieder geöffnet. Die Gebäude stehen unter Polizeischutz. Ein Komitee zur Demokratisierung der Universitäten kündigte harte Gegengewalt an, sollte die Universität die umstrittene Universitätssatzung verabschieden. Vier Studenten der Heidelberger Universität wurden zu Geldstrafen wegen Beteiligungen an Demonstration verurteilt.","Polizeischutz für Uni Würzburg","","","",[1],1,[1],[2],2,"12","6"],["4044","1968-07-17","Prof. Gerhard A. Ritter lehnt einen Ruf an das Otto-Suhr-Institut wegen der jüngsten Unruhen ab.","Absage an die FU","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["4045","1968-07-17","Unter Polizeischutz wurde an der Universität Würzburg die neue Universitätssatzung verabschiedet. Es kam nur zu vereinzelten Demonstrationen.","Tagung unter Polizeischutz","Schnell informiert","","",[1],1,[1],[2],2,"12","1"],["4046","1968-07-17","Gegen Rainer Langhans und Dieter Kunzelmann ist Anklage wegen Beleidigung des Regierenden Bürgermeisters erhoben worden. Beide hatten in einem Leserbrief des \"FU-Spiegel\" geschrieben, dieser habe seinen Arm \"wegen Feigheit vor dem Feind\" verloren.","Anklage erhoben","","","",[5],1,[1],[2],2,"12","3"],["4047","1968-07-17","Am Vortag haben erneut ca. die Hälfte der sich zurückmeldenden Studenten den Beitrag zum AStA nicht gezahlt.","Mehr als die Hälfte zahlte nicht","","","",[4],1,[1],[2],2,"12","6"],["4048","1968-07-17","Bericht über die erste Konferenz des neuen Institutsrates des Otto-Suhr-Institutes, Bildung von drei Kommissionen, u.a. um für die Legalisierung der zurückgewiesenen Satzung des OSI zu sorgen. Die Medizinische Fakultät billigt ebenfalls mit nur einer Gegenstimme die Zurückweisung der Satzung durch den Akademischen Senat der FU.","Drei Kommissionen im OSI gebildet","","","",[4],1,[1],[2],2,"12","6"],["4049","1968-07-17","Prof. Gerhard A. Ritter lehnt einen Ruf an das Otto-Suhr-Institut wegen der jüngsten Unruhen ab.","Ruf an die FU abgelehnt","","\"Wirklich fruchtbare Lehrtätigkeit nicht möglich\"","MM.",[1],1,[1],[2],2,"12","6"],["4050","1968-07-18","Rückblick auf das Sommersemester 1968, die rebellierenden Studenten hätten viele Kommilitonen durch ihre Aktionen verprellt, zugleich reife in der Professorenschaft endlich die Erkenntnis, dass man etwas an den überkommenen Univeristätsstrukturen ändern müsse.","Bilanz eines Semesters","","","MM.",[1],1,[1],[2],2,"14","2"],["4051","1968-07-18","Die Mathematisch-Naturwissenschaftliche Fakultät der FU hat mit großer Mehrheit die Zurückweisung des Satzungsentwurfs des OSI durch den Akademischen Senat gebilligt. Auch Professoren der Wirtschafts- und Sozialwissenschaftlichen Fakultät unterstützen dies.","Mit großer Mehrheit","","","",[4],1,[1],[2],2,"14","3"],["4052","1968-07-18","Der Akademische Senat trifft Regelungen für die Neuordnung des Ostasiatischen Seminars an der FU Berlin. U.a. wird die Nachfolge von Prof. Eckardt geregelt. Der Konvent der Kirchlichen Hochschulen wirft dem FU-Senat vor, dass sich Studenten ohne Zahlung des Pflichtbeitrages für den AStA zurückmelden können. Dies greife dem Urteil des Berliner Verwaltungsgerichtes vor und beweise, dass der Senat alle Ansätze für eine Hochschulreform zerstören wolle.","Nachfolger für Prof. Eckardt","","","",[4],1,[1],[2],2,"14","3"],["4053","1968-07-18","Die Berufungsverhandlung bestätigt das Urteil von zwei Monaten Gefängnis ohne Bewährung gegen Fritz Teufel wegen Störung eines Gerichtsprozesses und Beleidigung. Die Bewährung wurde abegelehnt mit dem Hinweis, dass gegen Teufel 16 Strafverfahren anhängig seien.","Teufel muss hinter Gitter","","","ut",[5],1,[1],[2],2,"14","5"],["4054","1968-07-19","Der VdS will durch intensivere Kontakte mit der FDJ einen Studentenaustausch zwischen der DDR und der Bundesrepublik ermöglichen.","Kontakte mit der FDJ","Schnell informiert","","",[9],1,[1],[2],2,"12","1"],["4055","1968-07-19","Die IG Metall erklärte sich mit den wesentlichen Forderungen der Ingenieurstudenten solidarisch.","Solidarisch mit Studenten","Kurz gemeldet","","",[4],1,[1],[2],2,"12","2"],["4056","1968-07-19","Der AStA der FU fragt im Rektorat an, ob der studentische Haushalt auch unabhängig von den kassierten Pflichtbeiträgen zum AStA gedeckt sei. Wenn dies nicht der Fall sei, wäre dies eine weitere Unterprivilegierung der Studentenschaft.","FU-AStA will nicht zahlen","","","",[4],1,[1],[2],2,"12","5"],["4057","1968-07-19","Die Kommission zur Vorbereitung des Inkraftreten der neuen Satzung des OSI trat zum ersten Mal zusammen. Man will verstärkt auf die Unterstützung der Politik setzen.","OSI-Kommission hofft auf Politiker","","","",[4],1,[1],[2],2,"12","5"],["4058","1968-07-21","Das Organ der chinesischen KP lobt die deutsche Studentenbewegung. (Nur in der ersten Fassung der Ausgabe)","Peking lobt die radikalen Studenten","","","",[1],1,[1],[2],2,"56","1"],["4059","1968-07-21","Die Wahl zum Marburger Studentenparlament muss wiederholt werden, da linksradikale Studenten mit einer Tarnliste angeblich unlauteren Stimmenfang betrieben hätten. Anhänger des SDS und der HSU seien als Vertreter einer rechtsliberalen Studentenschaft aufgetreten.","Stimmenfang in Marburg","","","",[4],1,[1],[2],2,"56","2"],["4060","1968-07-23","Der RCDS fordert in einem Offenen Brief den sowjetischen Botschafter Zarapkin auf, zur Verständigung der Völker und zur Achtung der Souveränität aller Staaten beizutragen. Ansonsten solle er seinen Posten aufgeben. Hintergrund ist der Konflikt der SU mit der CSSR (Prager Frühling).","Studenten appellieren an Zarapkin","","","",[4],1,[1],[2],2,"12","2"],["4061","1968-07-24","Laut Bundesinnenminister Benda stelle der Linksradikalismus in der Bundesrepublik bisher keine ernste Gefahr für die verfassungsmäßige Ordnung dar. Der SDS sei der Tendenz nach verfassungsfeindlich. Der KPD sei es nicht gelungen, den SDS in ihr genehme Bahnen zu lenken.","Absage an Linksradikale","","Keine ernsthafte Gefahr für die Bundesrepublik","",[1],1,[1],[2],2,"12","1"],["4062","1968-07-24","Der Berliner CDU-Abgeordnete Wohlrabe fordert den Rücktritt von Senator Stein wegen der \"desolaten Verhältnisse\" an der FU Berlin.","CDU: Senator Stein soll gehen","","","",[4],1,[1],[2],2,"12","2"],["4063","1968-07-25","Der Brief von Prof. Loos an Senator Stein über die Situation an der FU Berlin hat Kontroversen auf der Sitzung des Kuratoriums der FU ausgelöst. Bemängelt wurde vor allem, dass der Brief bereits in Zeitungen abgedruckt wurde, bevor er Stein erreicht habe. Bis zur Klärung, ob die Zwangsbeiträge zur studentischen Selbstverwaltung gezahlt werden müssen, soll ein Verwahrungskonto eingerichtet werden.","FU: Krach um einen Brief","","","MM.",[4],1,[1],[2],2,"16","5"],["4064","1968-07-27","Der AStA der FU Berlin will beim Senator für Wissenschaft und Kunst darum ersuchen, dass die Frage der studentischen Beiträge für die Selbstverwaltung im Wege der Staatsaufsicht geklärt wird, da die materielle Grundlage der Studentenvertretung eindeutig geklärt sein müsse.","AStA: Frage der Beiträge klären!","","","",[4],1,[1],[2],2,"12","5"],["4065","1968-07-28","Die Staatsanwaltschaft Marburg hat Anklage wegen Beleidigung und übler Nachrede gegen den Vorsitzenden des VdS, Ehmann, und den Pressereferenten des Marburger AStA, Claas, gestellt. Beide hatten behauptet, die Kriminalpolizei Marburgs halte Briefe von Studenten zurück.","Anklage gegen VDS-Chef","Schnell informiert","","",[11],1,[1],[2],2,"64","1"],["4066","1968-07-30","Der SHB hat auf seiner Bundesdelegiertenversammlung einstimmig beschlossen, der SPD die Unterstütztung für die Bundestagswahl 1969 aufzukündigen. Stattdessen will man sich für linke Kandidaten einsetzen, deren Politik in Opposition zur SPD stehe. Zudem fordert man die Rücknahme des Unvereinbarkeitsbeschlusses der SPD gegenüber dem SDS.","SHB unterstützt 1969 linke Kandidaten","","","",[4],1,[1],[2],2,"14","6"],["4067","1968-08-01","Etwa 40 deutsche Studenten, vornehmlich Mitglieder des SDS, nehmen in Kuba an einem \"Ausbildungslehrgang\" teil. Auch Daniel Cohn-Bendit soll unter den Teilnehmern sein.","Schulung in Kuba","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["4068","1968-08-02","Unbekannte verschicken gefälschte Briefe im Namen vom FU-Rektor Harndt. Sie benutzten dafür gestohlenes Briefpapier und Siegel aus dem Rektorat. Zwei dieser Briefe wurden in einer Erlanger Studentenzeitung abgedruckt.","FU-Siegel mißbraucht","","","MM.",[1],1,[1],[2],2,"18","6"],["4069","1968-08-02","Führende SDS-Mitglieder, unter ihnen Rabehl, Lefèvre und Treulieb, befinden sich zur Schulung in Kuba. Unterschiedliche Darlegungen, ob dies zur Schulung im revolutionären Kampf oder zur Diskussion über die politische Lage Südamerikas und den Vietnamkrieg geschieht.","SDS-Funktionäre zur Schulung in Kuba","","","",[1],1,[1],[3],2,"18","6"],["4070","1968-08-04","Als Antwort auf einen Artikel des \"Spiegel\", in dem aus einem \"Anti-Springer-Buch\" vermeintliche Zitate aus Springer-Zeitungen abgedruckt wurden, veröffentlicht die BERLINER MORGENPOST diese Zitate aus dem \"Spiegel\" und die dazugehörigen Originalzitate. Ca. die Hälfte beziehen sich auf die Studentenunruhen. Mehrheitlich sind die Zitate aus dem Zusammenhang gerissen bzw. wurden Zitate von Politikern als Meinung der Springer-Journalisten dargestellt. Dem \"Spiegel\" und Augstein werden deshalb Manipulationen vorgeworfen. (Reaktion auf einen Artikel im \"Spiegel\" vom 29.07.1968)","Zitate gegen den Buhmann","Der Spiegel ?neuer Kraftakt: Steinwürfe aus dem Glashaus","Wie ernst darf man \"Das deutsche Nachrichten-Magazin\" nehmen?","",[10],1,[1],[1],1,"60","12"],["4071","1968-08-06","Fritz Teufel wurde zu drei Wochen Arrest in Wien verurteilt, zudem erhielt er ein unbegrenztes Aufenthaltsverbot für Österreich.","Teufel abgeschoben","Kurz gemeldet","","",[5],1,[1],[2],2,"12","2"],["4072","1968-08-08","Nach einem Urteil des Berliner Verwaltungsgerichts darf die FU Berlin die Rückmeldung der Studenten für ein neues Semester nicht von der Zahlung der Pflichtbeiträge für die studentische Selbstverwaltung abhängig machen. Offen bleibt, ob die Zahlung grundsätzlich verweigert werden darf.","Studium auch ohne AStA-Gebühr möglich","Schnell informiert","","",[4],1,[1],[2],2,"16","1"],["4073","1968-08-08","Nach einem Urteil des Berliner Verwaltungsgerichts darf die FU Berlin die Rückmeldung der Studenten für ein neues Semester nicht von der Zahlung der Pflichtbeiträge für die studentische Selbstverwaltung abhängig machen. Offen bleibt, ob die Zahlung grundsätzlich verweigert werden darf. Bisher hatten von 2.701 rückgemeldeten Studenten 1.204 den Pflichtbetrag nicht gezahlt. Zudem wurde gerichtlich festgestellt, dass befristete Zulassungen an der FU durch deren Universitätsordnung nicht gedeckt und damit rechtsunwirksam sind.","FU-Praxis bestätigt","","Gericht: Studenten können AStA-Beitrag verweigern","MM.",[4],1,[1],[2],2,"16","3"],["4074","1968-08-08","Die Moabiter Staatsanwaltschaft beantragt, einen Prozess gegen Dutschke wegen Landfriedensbruch doch zu führen. Wegen des Attentats auf Dutschke war dieser zunächst eingestellt worden.","Muß Dutschke doch vor Gericht?","","","",[2],1,[1],[2],2,"16","3"],["4075","1968-08-09","Unter dem Thema \"Demokratisierung der Hochschule\" veranstaltet die FU Berlin ihren Ferienkurs im Sommersemester 1968.","Ferienkurs der FU","","","",[4],1,[1],[2],2,"14","3"],["4076","1968-08-11","Nach einer Entscheidung des Verwaltungsgerichtshof Baden-Württemberg haben die Studentenschaften kein politisches Mandat.","AStA besitzt kein politisches Mandat","","","",[11],1,[1],[2],2,"48","2"],["4077","1968-08-11","Ausführlich zur Entwicklung und zum Inhalt der Reformvorschläge bzw. des neuen Satzungsentwurfs für das Otto-Suhr-Insitut. Kritik am Akademischen Senat, dass dieser nicht klar sagt, warum er die Satzung ablehnt und welche Gefahren durch sie drohen. Generell kritisch zum Satzungsentwurf, eine Loslösung des Insituts von der FU wird als letzter Ausweg vorgeschlagen.","Otto-Suhr-Institut oder Politakademie für Extremisten?","Die Freie Universität steht vor einer Zerreißprobe:","","Michael L. Müller",[4],1,[1],[1],1,"48","12"],["4078","1968-08-13","Stellungnahme von Axel Springer zum Bericht der vom Bundestag eingesetzten \"Günther-Kommission\" über die Pressekonzentration, er lehnt den Vorschlag der Begrenzung der Marktanteile als verfassungswidrig ab.","Ein Meinungsmonopol kann nicht entstehen","","Springer: Begrenzung der Marktanteile verfassungswidrig","",[10],1,[1],[1],2,"12","2"],["4079","1968-08-13","Statistik, wieviele Lehrstühle an der FU Berlin nicht besetzt sind, wieviele Professoren seit dem Ende des Sommersemesters 1967 einen Ruf einer anderen Universität angenommen und wieviele Professoren einen Ruf der FU abgelehnt haben.","49 FU-Lehrstühle nicht besetzt","","","",[4],1,[1],[2],2,"12","5"],["4080","1968-08-14","Anklage der Staatsanwaltschaft gegen die mutmaßlichen Täter der Brandstiftungen in zwei Frankfurter Kaufhäusern im April 1968 (Baader, Ensslin, Proll, Söhnlein).","Frankfurter Kaufhausbrände vor Gericht","Schnell informiert","","",[9],1,[1],[2],2,"12","1"],["4081","1968-08-14","Das Bundesverwaltungsgericht urteilt, dass ein Hochschulstudium eine Vollzeitbeschäftigung ist, die dem Studenten eigentlich keine Zeit lässt, sich nebenbei seinen Lebensunterhalt zu verdienen. Hintergrund ist ein Rechtsstreit um die Ausbildungsbeihilfe.","Studieren ist Vollbeschäftigung","","","",[4],1,[1],[2],2,"12","3"],["4082","1968-08-15","Der Dutschke-Attentäter Bachmann wurde wegen seines dritten Selbstmordversuches, einem verschluckten Löffelstiel, operiert, wobei ihm dieser entfernt wurde.","Attentäter operiert","","","",[2],1,[1],[2],2,"14","3"],["4083","1968-08-16","100 Mitglieder und Anhänger des Hamburger SDS hätten bei einem Gerichtsprozess gegen einen Arbeiter wegen der Beteiligung bei den Osterunruhen randaliert.","Krawall im Gericht","Kurz gemeldet","","",[1],1,[1],[2],2,"16","2"],["4084","1968-08-16","Prozess gegen Ulrich Enzensberger, Mitglied der Kommune I, wegen übler Nachrede gegen einen Oberstaatsanwalt. Auf Grund seines Verhaltens vor Gericht sei er zeitweise aus dem Saal entfernt worden.","Enzensberger aus dem Saal entfernt","","","",[1],1,[1],[2],2,"16","6"],["4085","1968-08-21","Die Bonner Staatsanwaltschaft ermittelt gegen 40 Studenten wegen der Beteiligung an Ausschreitungen im Zeitraum von Februar bis Juli 1968.","Verfahren gegen Studenten","Kurz gemeldet","","",[1],1,[1],[2],2,"12","2"],["4086","1968-08-21","Antwort von Prof. Schwan, dem Geschäftsführenden Direktor des Otto-Suhr-Instituts der FU, auf den Artikel von Michael Müller vom 11.08.1968. Prof. Schwan verteidigt den Satzungsentwurf für das OSI und weist die Kritik von Müller zurück. Das OSI werde auch unter der neuen Satzung keine Akademie für Linksextremisten werden.","\"Von Rätesystem kann nicht die Rede sein\"","FU-Professor Schwan zur OSI-Satzung:","","",[4],1,[1],[1],1,"12","9"],["4087","1968-08-21","Direkte Antwort von Müller auf den Beitrag von Prof. Schwan. Müller erneuert seine Kritik an dem Satzungsentwurf für das OSI, dieser sei untauglich. Die BERLINER MORGENPOST sei sich aber mit Prof. Schwan einig, dass die deutschen Universitäten dringende Reformen benötigen.","Reform auf Treibsand","","","Michael L. Müller",[4],1,[5],[3],2,"12","9"],["4088","1968-08-22","Zahlreiche Proteste gegen den Einmarsch in der CSSR, in Frankfurt/Main versuchten ca. 400 Studenten und Jungsozialisten, die sowjetische Militärmission zu stürmen, sie skandidierten Parolen wie \"Amis raus aus Vietnam - Russen raus aus der CSSR!\"","Demonstrationen und Proteste","","","",[9],1,[1],[3],2,"18","2"],["4089","1968-08-22","Vor der tschechischen Militärmission in West-Berlin hatten sich etwa drei- bis viertausend Studenten versammelt, um ihre Solidarität mit den Reformern der CSSR zu bekunden. Auch vor dem Amerikahaus kam es zu Protesten, Sprechchöre wie \"Amis raus aus Vietnam - Russen raus aus Prag\"","Immer wieder Dubcek-Rufe vor der Militärmission","","","",[9],1,[1],[2],1,"18","3"],["4090","1968-08-23","Etwa 3.000 Demonstranten versuchten, die sowjetische Militärmission in Frankfurt/Main aus Protest gegen die Besetzung der CSSR zu stürmen. Die Polizei griff erst ein, als Demonstranten, darunter wohl Mitglieder des SDS, den die Mission umgebenden Maschendrahtzaun einzureißen begannen.","Proteststurm auf Sowjet-Mission","","","",[9],1,[1],[2],2,"16","1"],["4091","1968-08-25","Der VdS teilte mit, dass er tschechoslowakischen Studenten, die sich in der Bundesrepublik aufhalten oder hierher fliehen, finanziell unterstützen will.","VDS hilft CSSR-Studenten","","","",[9],1,[1],[2],2,"64","10"],["4092","1968-08-29","Scharfe Kritik an einer Demonstration der APO gegen die Besetzung der CSSR, an der auch Lehrer und Schüler beteiligt waren. Für die APO sei die Besetzung der CSSR nur Anlass, um sich bemerkbar zu machen. Es spräche von politischer Dummheit, wenn die APO die Besetzung der CSSR mit ihrer Auseinandersetzung mit dem Springer-Verlag vergleicht (dazu Zitate aus einer Solidaritätsadresse der APO).","Protest mit zwei Seiten","","","wbr.",[9],1,[5],[2],2,"16","2"],["4093","1968-08-29","Bericht über zwei Demonstrationen von Schülern gegen die Besetzung der CSSR. Eine sei von der APO instrumentalisiert worden. Dazu eine Karikatur: Demonstrant der APO fragt ein Baby im Kinderwagen: \"Willste nich ooch endlich demonstrieren?\" Im Hintergrund ein Jugendlicher mit einem Schild \"AP Null\".","Protest der Schüler mal so, mal so","","Demonstration für die besetzte Tschechoslowakei","MM.",[9],1,[1,5,4],[1],1,"16","3"],["4094","1968-08-31","Laut einer noch geheimen Vorlage für den Senat von Senator Stein sollen \"revolutionäre Satzungsentwürfe\" wie jener des Otto-Suhr-Instituts seitens der Politik als Experiment zugelassen werden. Zudem sollen über eine neue Hausordnung Disziplinarverfahren wegen Störungen des Universitätsbetriebs erleichtert werden.","Steins Hochschulreform ist noch streng geheim","","","Michael L. Müller",[4],1,[1],[5],2,"12","3"],["4095","1968-08-31","Laut einer Umfrage von Infas unter 644 Studenten der TU und FU Berlin ist die Gesamtheit der Berliner Studentenschaft politisch relativ links orientiert. Selbst die Anhänger des RCDS würden häufig links von den SPD-Anhängern stehen. 61 Prozent der SDS-Anhänger gaben als Ziel die völlige Umgestaltung der Gesellschaft an. Beim RCDS sei dies die Modernisierung der gesellschaftlichen Ordnung.","Studenten stehen \"relativ links\"","","","",[11],1,[1],[2],2,"12","5"],["4096","1968-09-05","Die Voruntersuchungen des Dutschke-Attentäters Bachmann wurden beendet. Da dieser seinen seelischen Tiefstand überwunden habe, rechnet man mit einem baldigen Beginn der Hauptverhandlung.","Bald Bachmann-Prozess","","","",[2],1,[1],[2],2,"18","3"],["4097","1968-09-05","Während eines Prozesses sprang der angeklagte Student Karl-Heinz Pawla auf und verrichtete im Gerichtssaal seine Notdurft, bevor er sich mit Akten säuberte.","Gerichtssaal als Toilette benutzt","","","",[1],1,[1],[2],2,"18","5"],["4098","1968-09-05","An der Freien Universität wurden drei ordentliche Lehrstühle neu besetzt.","Drei Lehrstühle an der FU wurden neu besetzt","","","",[4],1,[1],[2],2,"18","5"],["4099","1968-09-07","Unverständnis für Pawla für die Verrichtung seiner Notdurft im Gerichtssaal, solche Studenten sollten von der Universität entfernt werden. ","Kritik ist notwendig","Leserbriefe","","Leser",[1],1,[6],[2],2,"16","2"],["4100","1968-09-07","Karl-Heinz Pawla wurde wegen Beleidigung zu zehn Monaten Gefängnis ohne Bewährung verurteilt. Für die Verrichtung seiner Notdurft im Gerichtssaal bezeichnete ihn der Vorsitzende des Gerichts als \"Quadratferkel\". Weitere drei Tage Ordnungshaft bekam Pawla, weil er mit einer Sandale nach dem Staatsanwalt geworfen hatte.","Gefängnis für \"Quadratferkel\"","","","",[1],1,[1],[2],2,"16","5"],["4101","1968-09-07","Zwar sei noch keine \"Fluchtbewegung\" von Professoren der FU Berlin zu konstatieren, jedoch sei die Neigung, an die FU zu kommen bzw. dort zu bleiben deutlich zurückgegangen, wie die Berufungsstatistik der FU Berlin belege. Seit den Studentenunruhen und insbesondere dem 2. Juni 1967 hätte die FU an Anziehungskraft eingebüßt.","FU verlor an Anziehungskraft","","Unruhen erschwerten Berufungsverhandlungen","",[1],1,[1],[5],2,"16","6"],["4102","1968-09-08","Studenten sammelten für die Erdbebenopfer im nördlichen Teil Persiens.","Studenten sammeln für Erdbebenopfer","","","",[11],1,[1],[2],2,"68","3"],["4103","1968-09-10","Das Berliner Oberverwaltungsgericht entschied, dass der Konvent der FU Berlin kein politisches Mandat besitzt und deshalb sich nicht zu allgemeinpolitischen Fragen äußern darf.","Beschluß gegen FU-Konvent","Schnell informiert","","",[11],1,[1],[2],2,"16","1"],["4104","1968-09-10","Der Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses legte den Plan für die Beratungen über ein neues Hochschulgesetz fest.","Ausschuß legte Marschroute fest","","","",[4],1,[1],[2],2,"16","3"],["4105","1968-09-10","Das Berliner Oberverwaltungsgericht entschied, dass der Konvent der FU Berlin kein politisches Mandat besitzt und deshalb sich nicht zu allgemeinpolitischen Fragen äußern darf. Hintergrund war eine Klage von FU-Studenten gegen die Äußerung des FU-Konvents vom 26. Mai 1967, in der die USA als Verbrecher am Volke Vietnams bezeichnet wurden.","\"Kein politisches Mandat\"","","Gerichtsurteil über FU-Konvent bestätigt","",[11],1,[1],[2],2,"16","6"],["4106","1968-09-10","Eine Gedenkfeier im ehemaligen Konzentrationslager Dachau mit 5000 Gästen aus dem In- und Ausland wurde von linksradikalen Demonstranten gestört.","Gedenkfeier in Dachau gestört","","","",[11],1,[1],[2],2,"16","7"],["4107","1968-09-11","Der Berliner Senat empfiehlt in einer Vorlage dem Berliner Abgeordetenhaus, solche \"fortschrittlichen Experimente\", wie sie im Satzungsentwurf am Otto-Suhr-Institut betrieben wurden, per Gesetz zuzulassen. Dies würde den Akademischen Senat von seinem Recht, neue Institutssatzungen zu genehmigen, entbinden und einen Eingriff in die Autonomie der Hochschule darstellen. Stattdessen soll künftig in Urabstimmungen der jeweiligen Institute über neue Satzungen entschieden werden.","Senat bejaht Experiment/ So will Stein toten Punkt überwinden","","Studenten kennen Reform-Pläne noch nicht","M.M.",[4],1,[1],[2],2,"14","1"],["4108","1968-09-12","Die Studentenvertretungen von TU und FU Berlin lehnen es ab, dass der Berliner Senat Kompetenzen des Akademischen Senats übernimmt und per Gesetz geplante Institutsreformen einschränken kann. Dies zeige, dass es dem Senat nicht um die wirkliche Demokratisierung der Universität ginge.","Abgelehnt","","","",[4],1,[1],[2],2,"18","6"],["4109","1968-09-13","Auch im neuen Universitätsgesetz sollen FU und TU die Rechtsstellung einer Körperschaft des öffentlichen Rechts behalten, ebenso wie das Recht der akademischen Selbstverwaltung.","Weiterhin Körperschaft","","","",[4],1,[1],[2],2,"20","3"],["4110","1968-09-13","Die Anzahl nichtbesetzter Lehrstühle an der TU und FU Berlin sei normal. Generell sei die Anzahl der Lehrenden in den letzten deutlich stärker gestiegen als die der Studenten. Statistiken hierzu.","\"Professoren-Defizit\" normal","","Kein Grund zur Beunruhigung an den Universitäten","MM.",[4],1,[1],[5],2,"20","5"],["4111","1968-09-14","Fünf ehemals führende SDS-Mitglieder der sogenannten KPD-Fraktion wurden aus dem Verband ausgeschlossen. Delegierte forderten, die Spaltung offiziell zu machen und auch alle Gruppen, die sich mit der KP-Fraktion solidarisieren, auszuschließen.","SDS vor der Spaltung?","Kurz gemeldet","","",[8],1,[1],[2],2,"14","2"],["4112","1968-09-14","Senator Stein will mit den Studentenvertretern der TU und FU Berlin über seine Vorstellungen der Reformversuche an den Universitäten diskutieren.","Stein stellt sich","","","",[4],1,[1],[3],2,"14","3"],["4113","1968-09-18","Wegen erheblicher Meinungsverschiedenheiten wurde die SDS-Bundesdelegiertenkonferenz vertagt. Sie soll im November fortgesetzt werden. Nach Sicht des SPD-Pressedienstes ist der SDS am Unvermögen seiner Mitglieder, die Welt in ihrer Realität zu erkennen, gescheitert.","SDS-Kongreß vertagt","Kurz gemeldet","","",[8],1,[1],[2],2,"14","2"],["4114","1968-09-18","Vertreter des VdS und der FDJ diskutierten über die Ereignisse in der CSSR.","VDS diskutierte mit FDJ","Kurz gemeldet","","",[9],1,[1],[2],2,"14","2"],["4115","1968-09-18","Der geschäftsführende Direktor des Otto-Suhr-Instituts, Prof. Schwan, begrüßt die Senatsempfehlungen nach denen Reformexperimente noch vor Verabschiedung des Universitätsgesetzes umgesetzt werden sollen.","Schwan begrüßt Experiment","Kurz gemeldet","","",[4],1,[1],[2],2,"14","2"],["4116","1968-09-20","Firtz Teufel wurde in München-Schwabing verhaftet. Er soll nun zwangsweise in West-Berlin vor Gericht gestellt werden.","Teufel verhaftet","Kurz gemeldet","","",[5],1,[1],[2],2,"20","2"],["4117","1968-09-21","Etwa 150 linksradikale Jugendliche lieferten sich Auseinandersetzungen mit der Polizei auf der Frankfurter Buchmesse. Franz-Josef Strauß wurde mit Sprechchören wie \"Strauß ist ein Faschist und Ostlandreiter\" bedacht. Zu den Demonstranten gehörte auch Daniel Cohn-Bendit.","Krawall auf der Buchmesse","","","",[1],1,[1],[2],2,"16","1"],["4118","1968-09-22","Mehrere hundert Demonstranten, die teils von SDS-Mitgliedern angeführt worden seien, haben auf der Frankfurter Buchmesse gegen die Verleihung des Friedenspreis des Deutschen Buchhandels an den senegalesischen Staatspräsidenten Senghor demonstriert. U.a. wurden Stinkbomben geworfen.","Stinkbomben auf der Buchmesse","","","",[1],1,[1],[2],2,"66","1"],["4119","1968-09-22","Mehrere Professoren der FU Berlin sprechen sich in einer Resolution gegen die vom Senat geplanten Erprobungen der Reformmodelle der Art des Otto-Suhr-Instituts aus. Insbesondere die Drittelparität wird stark kritisiert, dies sei ein Rückfall in ein mittelalterliches Ständewesen. Zu den Unterzeichnern gehört u.a. Prof. Roman Herzog.","Statt Reform Rückkehr in das Mittelalter?","","FU-Profesoren lehnen Senatsvorschläge ab","M. L. Müller",[4],1,[1],[1],2,"66","6"],["4120","1968-09-24","Anklage gegen den Dutschke-Attentäter Josef Bachmann wegen versuchten Mordes. Bachmann habe mittlerweile sein Geständnis zurückgezogen und behaupte nun, dass er von Dutschke bedroht worden sei, woraufhin er seinen Revolver gezogen hätte. Zu den Zeugen der Staatsanwaltschaft soll auch Rudi Dutschke gehören.","Anklage gegen Josef Bachmann","","","",[2],1,[1],[2],2,"16","3"],["4121","1968-09-25","Prof. Sanmann von der FU Berlin bezeichnet die Einrichtung von Reformmodellen an der FU vor dem eigentlichen Universitätsgesetz als \"Appeasement-Politik\" und \"Liquidierung einer Universität\". Die Westdeutsche Rektorenkonferenz kritisiert die diesbezüglichen Pläne des Berliner Senats, sie ständen in eklatantem Widerspruch zu den Bemühungen, eine einheitliche Neugestaltung des Hochschulwesens zu erreichen.","Scharfe Kritik an Reformmodellen","","","MM.",[4],1,[1],[2],2,"18","1"],["4122","1968-09-25","Der Akademische Rat Dr. Scheler von der FU Berlin kritisiert die geplanten Reformmodelle für Institute der FU Berlin. Kritik auch an der unpolitischen Studentenschaft, dem Senat und vor allem den Aktivisten der Studentenunruhen. Er sieht die Unabhängigkeit von Lehre und Forschung bedroht.","Berliner FU muß frei bleiben","Zur Sache","","Dr. Manfred Scheler",[4],1,[5],[1],1,"18","2"],["4123","1968-09-25","Prof. Sanmann von der FU Berlin bezeichnet die Einrichtung von Reformmodellen an der FU vor dem eigentlichen Universitätsgesetz als \"Appeasement-Politik\" und \"Liquidierung einer Universität\". Ausführliche Kritik an dem geplanten Reformmodell und deren Zustandekommen. Kritik auch an Prof. Löwenthal für seine Wandlung in der Haltung zu dem geplanten Modell.","\"Lex OSI\" führt zur Liquidierung der \"Uni\"","","Das behauptet FU-Professor Sanmann in einer Dokumentation","Michael L. Müller",[4],1,[1],[1],2,"18","7"],["4124","1968-09-26","Die Kritik von Prof. Sanmann an den geplanten Reformmodellen nach Vorbild des Otto-Suhr-Instituts wurde sowohl von Professoren des OSI (Schwan, Sontheimer, Ziebura) als auch von Senator Stein scharf zurückgewiesen. Sie sei unwissenschaftlich und habe einen demagogischen Charakter.","Sanmanns Kritik zurückgewiesen","","","",[4],1,[1],[2],2,"20","5"],["4125","1968-09-27","Scharfe Kritik, dass der Schah von Persien nun in Moskau zu Besuch sei und es dagegen keine Demonstrationen und Protest gab. Dies zeige, dass es den Demonstranten vom 2. Juni 1967 nur um den Krawall ging, nicht um die Sache selbst.","Wo bleiben die Demonstranten?","Leserbriefe","","Leser",[1],1,[6],[2],2,"32","2"],["4126","1968-09-27","Willy Brandt kritisierte im Bundestag scharf die Unruhen auf der Frankfurter Buchmesse, verursacht durch linksradikale Demonstranten gegen die Verleihung des Friedenspreises für den senegalesischen Staatspräsidenten Senghor. Er fände es beschämend, wenn ausländische Gäste behelligt werden würden.","Brandt erteilte den Linksradikalen eine harte Abfuhr","","\"Gastfreundschaft muß gewahrt bleiben\"","",[1],1,[1],[1],2,"32","11"],["4127","1968-09-29","Etwa 40 Prozent der Studenten hätten bei ihrer Rückmeldung an der FU Berlin die AStA-Gebühren nicht entrichtet. Debatte des Kuratoriums darüber, wie in diesem Fall zu verfahren sei. Zustimmung zur Einrichtung eines zweiten Lehrstuhls für Japanologie.","40 Prozent zahlten nicht","","FU-Kuratorium erörterte Studenten-Gebühren","MM.",[4],1,[1],[2],2,"80","6"],["4128","1968-09-29","Ankündigung von bevorstehenden Prozessen, u.a. die Revisionsverhandlung gegen Karl-Heinz Kurras und ein Prozess gegen Fritz Teufel und weitere Kommunarden wegen Hausfriedensbruch im Rathaus Schöneberg und der Gedächtniskirche. Teufel sitzt nach wie vor in Untersuchungshaft.","Perser, Kurras und Fritz Teufel","","","M.K.",[1],1,[1],[2],2,"80","6"],["4129","1968-10-01","Drei Polizisten wurden im Zuge der Prozesse zu den Geschehnissen am 2. Juni 1967 wegen Körperverletzung im Amt zu je sechs Wochen Gefängnis mit Bewährung verurteilt. Ein 23-jähriger wurde vom Vorwurf der Beleidigung durch Flugblätter bei den Weihnachts- und Silvestergottesdiensten in der Gedächtniskirche freigesprochen.","Gefängnis für drei Polizisten","","","",[1],1,[1],[2],2,"20","6"],["4130","1968-10-01","Ankündigung der Berliner Hochschultage, auf denen Professoren und Studenten über nötige Reformen und den Aufbau der Universität diskutieren werden.","Professoren und Studenten diskutieren","","","",[4],1,[1],[2],2,"20","6"],["4131","1968-10-02","Der Bundesgerichtshof hat das freisprechende Urteil gegen Karl-Heinz Kurras wegen des tödlichen Schusses auf Benno Ohnesorg aufgehoben.","Kurras-Urteil vom 5. Strafsenat aufgehoben","Schnell informiert","","",[1],1,[1],[2],2,"18","1"],["4132","1968-10-02","Der Bundesgerichtshof hat das freisprechende Urteil gegen Karl-Heinz Kurras wegen des tödlichen Schusses auf Benno Ohnesorg aufgehoben (ausführlicherer Bericht). Gerügt wurde die Nichtvernehmung eines Zeugen, auf dessen Tonband nur ein Schuss statt der von Kurras angegebenen zwei Schüsse zu hören sein soll.","Bundesgerichtshof hob Kurras-Freispruch auf","","Neuer Prozeß um den Tod von Benno Ohnesorg","M. K.",[1],1,[1],[2],1,"18","3"],["4133","1968-10-02","Prozess gegen einen iranischen Studenten, dem vorgeworfen wird am 2. Juni 1967 mittels Sprechchören Demonstranten gegen den persischen Schah aufgewiegelt zu haben. Während des Prozesses kam es zu Tumulten, der Saal wurde mehrfach von der Polizei geräumt. Vor dem Gericht wartete eine Gruppe kaisertreuer Perser.","Tumult im Gerichtssaal","","Prozeß gegen Schahgegner mußte vertagt werden","",[1],1,[1],[3],1,"18","6"],["4134","1968-10-03","Der Akademische Senat der FU begrüßt nach sechsstündigen Beratungen die Gesetzesvorlage von SPD und FDP, welche Reform-Experimente an der Universität ermöglichen soll. Man sprach sich jedoch gegen die Ausschaltung des Akademischen Senats und der Fakultäten aus dem Entscheidungsprozess über die Universitätsreform aus. Dies würde einen organisatorischen Wildwuchs bewirken, der den Zerfall der Universität zur Folge hätte.","Wildwuchs bei der FU?","","","",[4],1,[1],[2],2,"20","3"],["4135","1968-10-03","Anhörung von Mitgliedern der TU und FU Berlin vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses zum geplanten Universitätsgesetz. Auch Stellungnahme zum Gesetzesentwurf für kurzfristige Reformmodelle an der FU. Die Rektoren von TU und FU begrüßen dies grundsätzlich, der Prorektor der FU befürchtet dagegen einen Wildwuchs an der Uni. Rektor Wever von der TU weist darauf hin, dass die Studentenvertreter gegen die Formulierung, dass die Universität ihre Aufgaben ungestört erfüllen kann, sind, da Störungen nützlich für Reformen seien.","Studentenvertreter halten \"Störungen für nützlich\"","","Bedenken gegen Begrenzung der Reformversuche","LUK",[4],1,[1],[3],2,"20","15"],["4136","1968-10-04","Die Studentenförderung nach dem Honnefer Modell wird verbessert, die Förderungsbeiträge und die Grenzen für die maximalen Einkommen der Eltern erhöht.","Studenten mit mehr Geld","","","",[4],1,[1],[2],2,"36","2"],["4137","1968-10-04","Schwere Kritik, dass an ein Verbot der NPD gedacht wird, gleichzeitig aber eine neue kommunistische Partei zugelassen werden soll, die überwiegend aus Teilnehmern der jüngsten linken Unruhen bestehen würde. Auch SDS müsse dann verboten werden.","Zum NPD-Verbot","Leserbriefe","","Leser",[1],1,[6],[2],2,"36","2"],["4138","1968-10-04","Fritz Teufel würde im Prozess gegen ihn als reuiger Sünder auftreten, hätte sich zu den Anschuldigungen bekannt, seine Anhänger im Zuhörerraum als Lumpengesindel und seinen Anwalt Mahler als Linksanwalt bezeichnet zu haben.","Teufels neue Tour","","","",[5],1,[1],[2],2,"36","3"],["4139","1968-10-04","Der Akademische Senat der FU empfiehlt den Insituten und Fakultäten eine Reihe von Reformen. Zudem nimmt er Stellung zum Vorschaltgesetz des Berliner Senats für kurzfristige Reformmodelle. Es müsse sichergestellt werden, dass dadurch nicht ein Missbrauch durch radikale, antidemokratische Kräfte ermöglicht wird.","Reformen empfohlen","","","MM.",[4],1,[1],[3],2,"36","6"],["4140","1968-10-04","Anhörungen von Professoren der FU und TU Berlin vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses zum neuen Universitätsgesetz, insbesondere zum Vorschaltgesetz für kurzfristige Reformmodelle. Gehört wurden u.a. Prof. Schwan, Prof. Herzog und Prof. Sanmann.","Wissenschaftlicher begrüßen Gesetz","","","",[4],1,[1],[3],2,"36","6"],["4141","1968-10-05","Der Medizinstudent Gerhard Paar wurde zu einem Jahr Gefängnis wegen Aufruhrs und Landfriedensbruchs während der Osterunruhen am Karfreitag in Frankfurt/Main verurteilt. Aus einer Diskussion mit einem jungen Polizisten sei eine Prügelei geworden.","Demonstrant verurteilt","Schnell informiert","","",[1],1,[1],[2],2,"20","1"],["4142","1968-10-05","Der Deutsche Germanistenverband versuche, das Fach Germanistik aus der traditionellen Isolierung herauszuführen. ","Germanisten auf neuen Wegen","","","J.M.",[4],1,[1],[2],2,"20","5"],["4143","1968-10-08","Studenten kündigten an, den Deutschen Germanistentag zu Änderungen im Tagesablauf bringen zu wollen. Zuvor hatten 50 Studenten das Restaurant im Hotel am Zoo für eine improvisierte Pressekonferenz besetzt.","Studenten gegen Germanisten","","","",[4],1,[1],[2],2,"18","3"],["4144","1968-10-08","Die CDU brachte einen Abänderungsvorschlag zum geplanten Reformgesetz für die Universitäten im Berliner Abgeordnetenhaus ein. Demnach soll bei Reformversuchen an den Universitätsinstituten auch den Fakultäten ein Mitspracherecht eingeräumt werden.","CDU für Mitspracherecht der Fakultäten","","","",[4],1,[1],[2],2,"18","3"],["4145","1968-10-08","Wegen zweifachen Hausfriedensbruchs wurde Fritz Teufel zu sieben Monaten Gefängnis verurteilt. Durch \"ungebührliches Benehmen\" vor Gericht erhielt er weitere zwölf Tage Haft. Zwei Mitangeklagte erhielten ebenfalls Haftstrafen.","Für Teufel sieben Monate ins Gefängnis","","","",[5],1,[1],[2],2,"18","6"],["4146","1968-10-08","Der Prozess zwischen dem Axel Springer Verlag und Horst Mahler wurde erneut vertagt. Mahler wird von Springer zu Schadensersatz in Höhe von 506.000 DM wegen der Beschädigungen am Verlagshaus im Zuge der Osterunruhen aufgefordert.","Prozeß gegen Mahler erneut vertagt","","","",[6],1,[1],[2],2,"18","6"],["4147","1968-10-09","Der VdS ist mit den Verbesserungen der Studentenförderung nach dem Honnefer Modell nicht zufrieden, diese reiche immer noch nicht aus, um wenigstens das Existenzminimum für den Lebensunterhalt zu sichern.","VDS nicht zufrieden","Schnell informiert","","",[4],1,[1],[2],2,"20","1"],["4148","1968-10-09","Senator Stein lobt den Gesetzentwurf über Reformversuche an den Universitäten im Berliner Abgeordnetenhaus. Der VdS kritisiert dagegen den Vorsitzenden des Ausschusses für Wissenschaft und Kultur, dieser habe die Befragung der Studenten unvollständig und einseitig wiedergegeben.","Parlament entscheidet/ Stein lobt Gesetz über Reformen an Universitäten","Schnell informiert","Personalabbau im Entschädigungsamt","LUK",[4],1,[1],[2,1],2,"20","1,5"],["4149","1968-10-09","Einer Klage eines Studenten im Zuge der Demonstration gegen den Besuch des Schahs am 2. Juni 1967 wurde stattgegeben. Danach war der Gebrauch des polizeilichen Schlagstockes gegen den Kläger gesetzeswidrig. Die CDU kritisierte die Entscheidung scharf.","Polizei durfte nicht schlagen","","","",[1],1,[1],[2],2,"20","7"],["4150","1968-10-09","Etwa 50 Studenten haben das Podium des Deutschen Germanistentages besetzt. Transparente wie \"Schlagt die Germanistik tot - macht die blaue Blume rot\". Mehrfache Störungen.","Tumulte beim Germanistentag","","","",[1],1,[1],[2],2,"20","7"],["4151","1968-10-09","Ein Prozess gegen einen schahkritischen Perser wurde vertagt, sein Anwalt ist Horst Mahler.","Prozeß gegen Perser zunächst vertagt","","","",[1],1,[1],[2],2,"20","7"],["4152","1968-10-10","Die AStA-Vorsitzende der FU Berlin, Sigrid Fronius, erklärte ihren Rücktritt, weil sie sich wieder auf ihr Studium konzentrieren müsse.","Fronius trat zurück","","","",[4],1,[1],[2],2,"22","3"],["4153","1968-10-10","Sprecher des AStA der FU Berlin fordern die sofortige Enteignung der klinischen Ordinarien im neuen Klinikum der FU. Kritik auch an der Struktur des Klinikums. Ferner wurde beanstandet, dass die Amerikaner in Vietnam mit Bomben Hospitäler zerstören würden, hier in Berlin aber neue Krankenhäuser bauten. Dies sei eine Verschleierung der militanten westlichen Freiheitsideologie.","FU-AStA: Vorwürfe und Forderungen","","","M.M.",[4],1,[1],[2],2,"22","3"],["4154","1968-10-10","Störungen des Deutschen Germanistentags durch Studenten, mehrere Vorträge mussten abgesagt werden. Eine Generaldebatte mit den Studenten wurde einberäumt.","Germanisten sagten mehrere Referate ab","","","",[1],1,[1],[2],2,"22","7"],["4155","1968-10-11","Das Berliner Abgeordnetenhaus verabschiedet das sogenannte Vorschaltgesetz nach dem, bis zur Umsetzung des eigentlichen Universitätsgesetzes, Institute jeweils für ein Semester Reformmodelle beschließen können. Hintergrund war das Reformmodell des Otto-Suhr-Instituts. Scharfe Kritik aus den Reihen der CDU, insbesondere von Heinrich Lummer.","Universitäten können jetzt Reformen üben","","Abgeordnetenhaus verabschiedete \"Vorschaltgesetz\"","MM/LUK",[4],1,[1],[1],1,"24","3"],["4156","1968-10-12","Für seinen Stockschlag auf Rudi Dutschkes Kopf während dessen Gottesdienststörung am 24.12.1967 wurde ein Angeklagter zu 200 DM Geldstrafe verurteilt.","Stockschlag gesühnt","","","",[1],1,[1],[2],2,"16","5"],["4157","1968-10-12","Fortsetzung des Prozesses des Axel Springer Verlags gegen Horst Mahler wegen dessen Beteiligung an den Osterunruhen vor dem Springer-Verlag. Ein Film über die Demonstrationen wurde gezeigt.","Gericht sah Film","","","",[6],1,[1],[2],2,"16","5"],["4158","1968-10-12","Die SPD-Betriebsgruppe der Berliner Hochschule begrüßt das neue Vorschaltgesetz für Reformmodelle an den Instituten.","\"Vorschaltgesetz jetzt ausnutzen!\"","","","",[4],1,[1],[2],2,"16","5"],["4159","1968-10-12","Studenten kündigen neue Aktionen gegen den gegenwärtigen Zustand der Germanistik an, dieser sei parasitär, weshalb zerstörerische Schritte eingeleitet werden sollen. Man plant die Kooperation mit Gymnasiallehrern und einen Kampf in Basisgruppen an den Schulen.","\"Neue Aktionswelle\"","","Studenten streiken für \"bessere\" Germanistik","",[1],1,[1],[2],2,"16","6"],["4160","1968-10-13","Prof. Weichselberger, ehemaliger Rektor der TU Berlin, forderte in einer Rede die Abschaffung aller akademischen Titel und Abschlussprüfungen. Diese Titel seien nur als Gegengewicht zu den Adelstiteln sinnvoll gewesen. Die Universität solle sich auf ihre Rolle als Lehr- und Forschungsinsitution beschränken.","\"Akademische Titel abschaffen\"/ \"Universitätszeugnis heute schon oft ohne Bedeutung\"","","","MM",[4],1,[1],[2],2,"70","1,6"],["4161","1968-10-13","Der Deutsche Germanistentag wurde planmäßig beendet. Insgesamt seien sechs Referate ausgefallen, zwei zu Gunsten von Diskussionen mit Studenten und eines wegen Störungen der Studenten.","Germanistentag wurde planmäßig beendet","","","",[4],1,[1],[2],2,"70","3"],["4162","1968-10-15","Die Westberliner SED versucht auf den SDS einzuwirken, den gemeinsamen \"Kampf gegen den Krieg in Vietnam, gegen Notstandspolitik, Springer-Monopol und Neonazismus\" wieder aufzunehmen. Die Kontakte waren vom SDS nach dem Einmarsch der sowjetischen Truppen in die CSSR abgebrochen worden. Zur Zeit sei vom SDS auch kein Interesse an einer Wiederaufnahme gegeben.","Westberliner SED umwirbt den SDS","","","",[9],1,[1],[2],2,"18","2"],["4163","1968-10-15","Ein 20-jähriger Arbeitsloser wurde wegen Steinwürfen auf Polizisten während der Osterunruhen um das Axel-Springer-Verlagshaus zu drei Wochen Dauerarrest verurteilt.","Nach Prozeßende sofort abgeführt","","","",[1],1,[1],[2],2,"18","3"],["4164","1968-10-20","Anklagen wegen Hausfriedensbruch und Sachbeschädigung im Zuge der Besetzung des FU-Rektorats im Juli 1968 u.a. gegen Sigrid Fronius.","Erstes Nachspiel zur FU-Rektoratsbesetzung","","","",[1],1,[1],[2],2,"58","5"],["4165","1968-10-20","An der Deutschen Film- und Fernsehakademie Berlin wurde ein vorläufiger akademischer Rat gegründet, dem Vertreter der Dozenten, Studenten und Direktoren anhöhren und der über Ausbildungsodnung der Akademie beraten soll.","Vorläufiger Rat gebildet","","","",[4],1,[1],[2],2,"58","5"],["4166","1968-10-20","Erste Sitzung des neuen Institutsrates des Otto-Suhr-Instituts nach der Verabschiedung des Vorschaltgesetzes. Das vom Akademischen Senat zweimal zurückgewiesene Reformmodell des OSI wurde vom Institutsrat auf Grundlage des neuen Gesetzes ohne Änderungen verbaschiedet.","Vom \"Sandkastenspiel\" zur politischen Praxis","","","",[4],1,[1],[2],2,"58","5"],["4167","1968-10-22","Gundrun Ensslin und Andreas Baader gestehen die Brandlegung in dem Frankfurter Kaufhaus Schneider, bestreiten aber die Brandlegung im Frankfurter \"Kaufhof\". Dies sei ein Protest gegen die Gesellschaftsordnung in der Bundesrepublik gewesen und sollte die Öffentlichkeit gegen den Vietnamkrieg aufrütteln. Menschen habe man nicht gefährden wollen. Ensslin würde ihre Tat bedauern, Baader dagegen erklärte, dadurch dass sich der SDS von der Tat distanziert habe, sei bewiesen, dass die revolutionäre Bewegung in der Bundesrepublik tot sei. Die weiteren Angeklagten Proll und Söhnlein hätten von der Brandlegung erst hinterher erfahren.","Brandstiftung zugegeben","","","",[9],1,[1],[2],2,"16","1"],["4168","1968-10-22","Entscheidungen des neuen Institutsrates des Otto-Suhr-Instituts im Zuge des neuen Reformmodells.","OSI wird in vier Bereiche aufgeteilt","","","",[4],1,[1],[2],2,"16","3"],["4169","1968-10-23","Neuwahl des AStA-Vorsitzenden an der FU Berlin, Nachfolger von der zurückgetretenen Sigrid Fronius ist Jürgen Treulieb, ebenfalls SDS-Mitglied. Treulieb kündigte an, dass die Studentenvertretung in ein Rätemodell umgewandelt werden soll. Zudem wolle man Klage gegen den Rektor einreichen, weil dieser die Zahlung der Gebühren für die Studentenvertretung bei der Rückmeldung von Studenten nicht erzwinge. Etwa 44 Prozent aller FU-Studenten hatten den Beitrag bisher verweigert.","Neuer AStA-Chef für \"Rätemodell\"","","","MM",[4],1,[1],[2],2,"16","5"],["4170","1968-10-24","Vierter Selbstmordversuch von Josef Bachmann, dem Attentäter Dutschkes. Diesmal hat er ein Messer verschluckt.","Gestern in Tegel: Neuer Selbstmordversuch Bachmanns","","","",[2],1,[1],[2],2,"20","5"],["4171","1968-10-24","Ein Prozess gegen Pawla wurde wegen Richterbeleidigung Pawlas unterbrochen, Pawla zu drei Tagen Ordnungsstrafe verurteilt.","Richter wurde unflätig beschimpft","","","",[9],1,[1],[2],2,"20","5"],["4172","1968-10-25","Der Konvent der Münchener Univeristät beschloss seinen Austritt aus dem VdS, weil dieser studentische Gelder für tendenziöse politische Aktionen verwende.","Austritt aus dem VDS","Kurz gemeldet","","",[4],1,[1],[2],2,"22","2"],["4173","1968-10-25","Ein dem SDS nahestehender persischer Journalist wurde wegen seiner Beteiligung bei den Protesten auf der Frankfurter Buchmesse gegen die Verleihung des Friedenspreises an den senegalesischen Staatspräsidenten Senghor zu sechs Monaten Gefängnis mit Bewährung verurteilt.","Demonstrant verurteilt","Kurz gemeldet","","",[1],1,[1],[2],2,"22","2"],["4174","1968-10-26","Wegen Nötigung bei einer Vietnam-Demonstration im Februar wurden drei Tübinger Studenten zu drei Monaten Gefängnis verurteilt. Nach dem Urteil kam es zu Protesten von Studenten vor dem Amerikahaus","Studenten zu Gefängnis verurteilt","","","",[1],1,[1],[2],2,"16","2"],["4175","1968-10-26","Senator Stein hat einen Aufruf der Studentenvertretungen der Berliner Universitäten und Hochschulen als rechtswidrig gekennzeichnet. Die Studenten hatten ihre Kommilitonen aufgefordert, Fragebögen für Wohnungszählungen nicht den amtlichen Zählern, sondern den Studentenvertretungen auszuhändigen.","Keine Extratour für die Studenten","","Jeder muß Fragebogen abliefern","MM",[4],1,[1],[1],2,"16","3"],["4176","1968-10-26","Erste Sitzung der Philosophischen Fakultät der TU Berlin im neuen Semester, künftig sollen Studenten und Assistenten stärker mit einbezogen werden.","Studenten sitzen mit im Ausschuß","","","",[4],1,[1],[3],2,"16","3"],["4177","1968-10-27","Stellungnahme eines Hamburger Studenten, der früher in West-Berlin arbeitete, zur Situation für junge Menschen in West-Berlin und warum diese vermehrt aus West-Berlin wegziehen.","Warum verlassen junge Leute Berlin?","Zur Sache","","Rainer-Eckhard Wassner",[9],1,[5],[1],2,"60","2"],["4178","1968-10-27","Neuwahl des Finanz-Referenten des AStA der FU Berlin.","Neuer Finanz-Referent","","","",[4],1,[1],[2],2,"60","7"],["4179","1968-10-27","Neurordnung des Ostasiatischen Seminars der FU Berlin. Die Wirtschafts- und Sozialwissenschaftliche Fakultät der FU will künftig u.a. neue Professoren auf dem Wege der öffentlichen Ausschreibung berufen.","Studentische Forderungenn werden jetzt verwirklicht","","Endlich Neuordnung des Ostasiatischen Seminars an der FU","MM",[4],1,[1],[1],2,"60","7"],["4180","1968-10-29","Der Dutschke-Attentäter Bachmann muss nach seinem fünften Selbstmordversuch nicht operiert werden. Das verschluckte Messer habe den Körper mittlerweile auf natürlichen Wege verlassen.","Keine Operation","","","",[2],1,[1],[2],2,"20","3"],["4181","1968-10-29","Studenten erreichten ihre Teilnahme an der Lehrplanbesprechung des Romanischen Seminars der FU Berlin.","Kein Präzedenzfall","","","",[1],1,[1],[2],2,"20","3"],["4182","1968-10-29","Die Linksliberale Hochschulgruppe (LL) fordert eine politische Amnestie für alle Beteiligten an den studentischen Aktionen seit dem 2. Juni 1967.","Hochschulgruppe für Amnestie","","","",[1],1,[1],[2],2,"20","3"],["4183","1968-10-30","Der VdS drohte einen bundesweiten Streik aller Studenten an, wenn ihre Forderung nach Demokratisierung der Hochschulen nicht erfüllt werde. Man wolle auch die Unterstützung des DGB ersuchen.","VdS droht mit Streik","Kurz gemeldet","","",[1],1,[1],[2],2,"28","2"],["4184","1968-10-30","Etwa 20 Assistenten des Instituts der Soziologie haben ihre Lehrtätigkeit eingestellt. So wolle man gegen die Entscheidung des FU-Rektors Harndt protestieren, den Studenten Bernd Rabehl vom SDS nicht als Hilfsassistenten einzustellen. Die Pressestelle des Rektorats wies den Vorwurf zurück, Rabehl sei aus politischen Gründen abgelehnt worden. Dieser habe sich nicht nur mehrfach gegen die freiheitlich-demokratische Grundordnung ausgesprochen, sondern auch zu strafbaren Handlungen gegenüber seinem potentiellen Dienstherrn aufgerufen.","Assistenten stellen Lehrtätigkeit ein","","","",[4],1,[1],[2],2,"28","3"],["4185","1968-10-31","Die Ministerpräsidenten der Länder fordern eine Verkürzung der Studienzeiten. Zudem sollen Lehrstühle künftig öffentlich ausgeschrieben werden und die Studenten eine funktionsgerechte Mitsprache an den akademischen Organen erhalten.","Studienzeit kürzer?","","","",[4],1,[1],[2],2,"24","1"],["4186","1968-10-31","Etwa 200 Studenten verhinderten erstmalig eine Sitzung des Akademischen Senats der FU Berlin. Hintergrund war die Ablehnung Bernd Rabehls als Hilfsassistent durch den Rektor.","Wirbel im Fall Rabehl","","","",[1],1,[1],[2],2,"24","3"],["4187","1968-10-31","Zwei Studenten in Frankfurt wurden unter der Begründung, unter gewissen Umständen sei die Blockade einer Zeitungsdruckerei durch das Demonstrationsrecht gerechtfertigt, freigesprochen. Sie hatten während der Osterunruhen versucht, die Auslieferung der BILD-Zeitung u.a. durch Entweichenlassen der Luft aus den Rädern von Lieferfahrzeugen zu verhindern. Dies sei nur Ausdruck gewesen, auf die Gefahren der Pressekonzentration hinzuweisen. Schwere Kritik an diesem Urteil und am Richter.","Zwei Freisprüche in Frankfurt","","","Jo.",[1],1,[1],[2],2,"24","2"],["4188","1968-11-01","Eine studentische Vollversammlung der FU Berlin fordert den FU-Rektor Harndt im Zuge der Nichtbeschäftigung von Bernd Rabehl zum Rücktritt auf. In der 2. Fassung der Ausgabe zudem eine Ergänzung um die Zeilen, dass die Assistentenschaft des OSI bei Senator Stein wegen der Nichteinstellung Rabehls eine Dienstaufsichtsbeschwerde gegen Rektor Harndt eingelegt hat.","Rücktritt gefordert","","Studenten stellen dem Rektor ein Ultimatum","",[1],1,[1],[2],2,"28","3"],["4189","1968-11-01","Senator Stein weist in einem Brief an den AStA der FU Berlin darauf hin, dass dieser kein Recht habe, ein allgemein-politisches Mandat für sich in Anspruch zu nehmen.","Stein: AStA ohne politisches Mandat","","","",[11],1,[1],[2],2,"28","3"],["4190","1968-11-01","Prof. Philipp erklärte vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses, dass die Auflösung der Fakultäten in Abteilungen keine Vorteile bringen würde und verwies auf die Universität Konstanz (Dieser Artikel ist nur in der ersten Form dieser Ausgabe vorhanden).","Keine Vorteile","","","",[4],1,[1],[2],2,"28","3"],["4191","1968-11-01","Verurteilung von Baader, Ensslin, Proll und Söhnlein zu je drei Jahren Zuchthaus wegen der Kaufhausbrandstiftung in Frankfurt/Main. Nach dem Urteil kam es zu schweren Tumulten im Gericht. Der Richter führte an, dass diese Tat nicht in einem Zusammenhang mit den Studentenunruhen/ der APO geschehen ist, daraufhin wollten die Angeklagten empört den Saal verlassen. Cohn-Bendit rief, nur ein Studentengericht könne über die Zugehörigkeit entscheiden. Freigesprochen wurden zwei Kölner AStA-Mitglieder vom Vorwurf der Nötigung, des Landfriedensbruchs und des Aufruhrs.","Schwere Tumulte im Brandstifter-Prozeß","","Je drei Jahre Zuchthaus für die Angeklagten","",[9],1,[1],[1],1,"28","28"],["4192","1968-11-02","Studenten haben die auf dem Hamburger Universitätsgelände befindlichen Statuen des Afrikaforschers von Wissmann und des Kolonialoffiziers Dominik umgestoßen. Sie seien eine Provokation für jeden Afrikaner.","Denkmäler umgestürzt","Kurz gemeldet","","",[1],1,[1],[2],2,"24","2"],["4193","1968-11-02","Kritik von der \"Außerparlamentarischen Mitarbeit\" an dem Freispruch zweier Studenten wegen der Blockade der Auslieferung von BILD-Zeitungen. Dies würde Linksextremisten die Option eröffnen, dass jede ihrer Aktionen mit dem Recht auf freie Meinungsäußerung gerechtfertigt werden kann.","Urteil befremdete","Kurz gemeldet","","",[1],1,[1],[2],2,"24","2"],["4194","1968-11-02","Einen Tag nach dem Urteil gegen Baader, Ensslin, Proll und Söhnlein wurden Molotow-Cocktails auf das Frankfurter Justizministerium geworfen. Nach dem Urteil hatte dies einer der Zuhörer gefordert, der SDS hatte zu militanten Aktionen gegen die Frankfurter Justiz aufgefordert.","Anschlag auf Frankfurter Justizpalast","","Protestaktion mit Molotow-Cocktails","",[9],1,[1],[1],2,"24","24"],["4195","1968-11-03","U.a. Ankündigung des Ehrengerichtsverfahrens gegen Horst Mahler, die APO hätte bereits größere Demonstrationen angekündigt.","Freisler-Beisitzer und \"Chefarzt\" vor Gericht","","Anwaltskammer verhandelt gegen Mahler","M.K.",[6],1,[1],[5],2,"70","7"],["4196","1968-11-03","Anhänger des SDS haben die Jahrestagung der Hochschulgesellschaft für die Erneuerung der deutschen Universität in der Frankfurter Universität gestört. Sie forderten die Freilassung Cohn-Bendits und eine Erklärung der \"Terrorurteile\" im Kaufhausbrand-Prozess. Eugen Kogon kritisiert die Studenten scharf. Als Kogon zu einem Vergleich mit der SS ansetzte, erhoben etliche Studenten die Hand zum Hitler-Gruß und riefen Sieg Heil.","Diskussion mit Eiern","","SDS störte Hochschultagung","",[1],1,[1],[2],2,"70","7"],["4197","1968-11-05","Im Zuge des Ehrengerichtverfahrens gegen Horst Mahler kam es vor dem Landgericht zu schweren Ausschreitungen, der sogenannten Schlacht am Tegeler Weg. 500 Demonstranten hatten die Polizisten wiederholt mit Steinen und Molotowcocktails angegriffen, 130 Polizisten wurden verletzt, 48 Demonstranten festgenommen, überwiegend Studenten aus Westdeutschland. Ein 90-jähriger Passant sei von Demonstranten so schwer zusammengeschlagen worden, dass er in Lebensgefahr schwebe. An der TU Berlin wurden an zahlreiche Studenten Gasmasken ausgegeben. Scharfe Kritik von Innensenator Neubauer, das sei keine Demonstration, sondern nur gewaltsamer Aufruhr. Auch weitere sehr kritische Stellungnahmen von Politikern/ Verbänden.","\"Gewaltsamer Aufruhr\" vor dem Landgericht","","130 Polizisten bei der Straßenschlacht verletzt","",[6],1,[1],[2],1,"16","1"],["4198","1968-11-05","Im Zuge des Ehrengerichtverfahrens gegen Horst Mahler kam es vor dem Landgericht zu schweren Ausschreitungen, der sogenannten Schlacht am Tegeler Weg. 500 Demonstranten hatten die Polizisten wiederholt mit Steinen und Molotowcocktails angegriffen, 130 Polizisten wurden verletzt, 48 Demonstranten festgenommen, überwiegend Studenten aus Westdeutschland. Die Polizei war vollkommen überfordert und schlecht ausgerüstet. Die Demonstranten griffen unter der Parole \"Hände weg von Mahler\" an. An der TU Berlin wurden verschiedene Personen aufgegriffen, die man verdächtigte, Beamte der Politischen Polizei zu sein. Bejubelt wurde von den Studenten die Teilnahme von Rockern an der Straßenschlacht, Christian Semler sieht den Straßenkampf auf eine völlig neue militante Ebene gebracht","Erst nach einer Stunde kam Polizei-Verstärkung","","Neubauer: Auch Frauen und Kinder bei der Straßenschlacht","L. R.",[6],1,[1],[1],1,"16","3"],["4199","1968-11-05","Das Ehrengericht der Berliner Anwaltskammer lehnte es ab, ein Berufsverbot für Horst Mahler zu verhängen. Weiter läuft jedoch ein Verfahren gegen Mahler mit dem Ziel, ihn aus der Anwaltschaft auszuschließen. Weitere Ermittlungen gegen Mahler wegen Landfriedensbruch etc.","Kein Berufsverbot für Mahler","","","",[6],1,[1],[2],2,"16","3"],["4200","1968-11-05","Schwere Kritik an der Straßenschlacht am Tegeler Weg, dies sei Bürgerkrieg. Der demokratische Rechtsstaat sollte zum Einsturz gebracht und für die Parteigänger Ulbrichts reif gemacht werden. Der parlamentarischen Demokratie sei der Krieg erklärt worden, Vergleich mit der Weimarer Republik. Die Teilnehmer der \"Schlacht am Tegeler Weg\" werden als \"Totengräber der Freiheit\" bezeichnet. Schwere Kritik an politisch Verantwortlichen, die die Vorfälle der APO verharmlosen würden, u.a. zielt es auf Heinrich Albertz und Bischof Scharf (werden nicht direkt genannt). Dazu eine Karikatur: Walter Ulbricht schaut mit einem Fernglas von einem Wachturm begeistert der \"Schlacht am Tegeler Weg\" zu, überschrieben mit \"APOlitisch\".","Attentat auf die Demokratie","","","Jo.",[6],1,[5,4],[2],1,"16","2"],["4201","1968-11-06","Kritik an der Entscheidung des FU-Rektors, Bernd Rabehl nun doch als Hilfassistenten zuzulassen. Dieser habe seinen Traum vom Umsturz der Gesellschaft nicht aufgegeben.","Hilfsrevolutionär","","","wbr.",[11],1,[2],[2],2,"16","2"],["4202","1968-11-06","Fritz Teufel wurde wegen versuchten Diebstahls einer Polizeimütze und Widerstandes gegen die Staatsgewalt zu fünf Wochen Gefängnis ohne Bewährung verurteilt.","Bewährungsfrist gab's nicht","","","",[5],1,[1],[2],2,"16","3"],["4203","1968-11-06","Unbekannte haben unter dem AStA-Gebäude der FU Berlin Feuer gelegt.","Feuer gelegt","","","",[11],1,[1],[2],2,"16","3"],["4204","1968-11-06","Mehr als 20 Anzeigen von Berlinern, die durch die Schlacht am Tegeler Weg verletzt oder geschädigt wurden, seien bei der Polizei eingegangen. 48 Festnahmen. Drei der 130 verletzten Polizisten befinden sich noch im Krankenhaus. Der 92-jährige Passant mit einem Oberschenkelhalsbruch ist nicht von einem Demonstranten geschlagen, sondern angerempelt worden und dabei gestürzt. Die Steine kamen von einem zufällig anwesenden LKW, der mit diesen beladen war.","Bilanz der Straßenschlacht vor dem Landgericht","","","E. B.",[6],1,[1],[2],2,"16","3"],["4205","1968-11-06","Erklärung des Berliner Senats in Folge der \"Schlacht am Tegeler Weg\". Vor weiteren Gewalttaten wird gewarnt, die Polizei werde entschlossen dagegen vorgehen. Dies seien keine Demonstrationen mehr, sondern Terrorakte. Mehrere Studentenverbände distanzieren sich von den Ausschreitungen, so der SHB und die HSU. Stellungnahmen von Politikern und Gewerkschaften.","Polizei wird entschlossen gegen Terror-Akte vorgehen","","Scharfe Verurteilung der Gewalttätigkeiten","MM",[6],1,[1],[1],2,"16","3"],["4206","1968-11-06","Nach einer zweiten Unterredung entschied FU-Rektor Harndt, dass Bernd Rabehl doch als Hilfsassistent angestellt werden könne. Rabehl habe sich bereit erklärt, die Pflichten eines im öffentlichen Dienst tätigen Hilfsassistenten entsprechend den geltenden Gesetzen zu erfüllen. Er räumte aber ein, sich gegebenfalls auf das Widerstandsrecht zu berufen. Bei der ersten Unterredung mit Harndt hate Rabehl im nachhinein erklärt, die Begründungen für die Ablehnung seien aus Bespitzelungen seines politischen Denkens erstellt worden. Der AStA sieht die Einstellung Rabehls als Erfolg seines Protests.","Schlußstrich unter 'Fall Rabehl'","","","",[11],1,[1],[3],2,"16","5"],["4207","1968-11-07","Dem AStA der TU Berlin ist wegen seiner Haltung zur Schlacht am Tegeler Weg das Mißtrauen ausgesprochen worden.","Mißtrauen ausgesprochen","Schnell informiert","","",[6],1,[1],[2],2,"18","1"],["4208","1968-11-07","Lob und Kritik für die Glosse \"Brandstifter\" vom 5.11.1968 in der BERLINER MORGENPOST. Gudrun Ensslin habe nur aus Verzweiflung an der Gesellschaft gehandelt, für andere Leser sind die Täter ganz gewöhnliche Kriminelle.","\"Die Brandstifter\" in \"Panorama\"","Leserbriefe","","Leser",[9],1,[6],[2],2,"18","2"],["4209","1968-11-07","Drei Polizisten sind im Zuge der Schlacht am Tegeler Weg weiter im Krankenhaus, einer wird noch mehrere Wochen stationär behandelt werden müssen. Mehrere Berliner CDU-Abegeordnete und wohl auch SPD-Abgeordnete haben Morddrohungen auf Schreiben mit dem Briefkopf des Otto-Suhr-Instituts erhalten. Das OSI sieht darin Provokationen rechtsradikaler Kreise. Die APO strebt einen Musterprozess über den Status West-Berlins an. West-Berlin sei weder der DDR noch der Bundesrepublik zugehörig, dies werde man im Prozess gegen einen Bundeswehr-Fahnenflüchtigen darstellen.","Drei Polizisten liegen noch im Krankenhaus","","","",[6],1,[1],[2],2,"18","3"],["4210","1968-11-07","Der evangelische Pfarrer der Westberliner Polizei, Harms, fordert in einem offenen Brief die Studentenschaft auf, aktiv gegen die Gewalttäter unter ihnen vorzugehen. Dies solle aber kein Aufruf zur Selbstjustiz sein. Die Täter seien nur Feiglinge, über die die Geschichte hinweggehen wird.","Polizeipfarrer: \"Man muß gegen Gewalt etwas tun\"","","","",[6],1,[1],[2],2,"18","3"],["4211","1968-11-07","Schwere Kritik an der Schlacht am Tegeler Weg, es wird ein hartes Durchgreifen gegen die Demonstranten gefordert, die Justiz und Politik wegen ihrer Milde kritisiert. Diese müsse sich endlich schützend vor die Polizei stellen.","Das Maß ist voll","Leserbriefe","Stimmen zu den Vorfällen am Landgericht","Leser",[6],1,[6],[2],2,"18","6"],["4212","1968-11-08","Schwere Kritik an der Schlacht am Tegeler Weg, es wird ein hartes Durchgreifen gegen die Demonstranten gefordert. Vergleich mit den Straßenschlachten in der Weimarer Republik.","Augenzeugenbericht","Leserbriefe","","Leser",[6],1,[6],[2],2,"24","2"],["4213","1968-11-08","Während eines Seminar am Romanischen Institut der FU Berlin forderten Studenten, dass ein neues, von ihnen verabschiedetes Konzept verwirklicht werde. Als die Studenten den Raum nicht verließen, zogen die Dozenten aus.","Krach bei Romanisten","","","",[1],1,[1],[2],2,"24","3"],["4214","1968-11-08","Auch nach dem Sturz des AStA-Vorsitzenden der TU Berlin beherrsche der SDS weiter das TU-Studentenparlament. Das Mißtrauensvotum war wegen nicht klaren Haltung des Vorstands der Studentenvertretung zur Schlacht am Tegeler Weg ausgesprochen worden. Bekannt wurde zudem, dass eine Basisgruppe im Märkischen Viertel Kontakt mit \"Rockern\" halten solle. Diese seien vor der Schlacht am Tegeler Weg politisch aufgeklärt worden.","Keine Jubelstimmung","","SDS beherrscht weiter TU-Studentenparlament","MM",[4],1,[1],[2],2,"24","6"],["4215","1968-11-09","Nachdem Studenten die Einführungsvorlesung von Prof. Erler als \"völlig unzureichend\" bezeichnet hatten, ruht mit Beschluss der Mehrheit der Professoren an der juristischen Fakultät der Universität Frankfurt der Vorlesungsbetrieb.","Vorlesungen eingestellt","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["4216","1968-11-09","Innensenator Neubauer plädiert an die Veranstalter der Vietnam-Demonstration, jegliche kriminelle Handlungen zu unterlassen. Er werde es nicht zulassen, dass sich Vorgänge wie bei der Schlacht am Tegeler Weg wiederholen. Ermutigend findet Neubauer die ablehnende Haltung in Kreisen der Berliner Studentenschaft zu den Vorgängen am Tegeler Weg. Die \"Linksliberale Hochschulgruppe\" fordert die Demonstrationsteilnehmer auf, eine Umfunktionierung der Demonstration in eine Straßenschlacht zu verhindern. Die SED West-Berlin riet von einer Teilnahme an der Demo ab, da antisowjetische Aktionen zu erwarten seien. Das Bonner SPD-Präsidium kritisiert die Ausschreitungen am Tegeler Weg scharf, das Demonstrationsrecht sei zu übelstem Terror und blutigen Straßenkämpfen missbraucht worden.","Neubauer mahnt Demonstranten zur Vernunft","","","",[11],1,[1],[2],2,"14","1"],["4217","1968-11-09","Schwere Kritik an der Schlacht am Tegeler Weg und generell den Unruhen, es wird ein hartes Durchgreifen gegen die Demonstranten gefordert.","Demokratie heißt nicht Zügellosigkeit","Leserbriefe","","Leser",[6],1,[6],[2],2,"14","2"],["4218","1968-11-09","Durch den verbesserten Gesundheitszustand vom Dutschke-Attentäter Josef Bachmann ist dessen Prozessbeginn für den 13. Dezember 1968 angesetzt worden,","Termin für Bachmann","","","",[2],1,[1],[2],2,"14","3"],["4219","1968-11-09","Der Bund Deutscher Kriminalbeamter kritisiert scharf alle Eltern, die Kinder zu Demonstrationen mitnehmen. Anlass war die Anwesenheit zahlreicher Kinder bei der Schlacht am Tegeler Weg. Der Bund weist darauf hin, dass es gesetzliche Möglichkeiten gibt, solche Eltern zur Rechenschaft zu ziehen.","Keine Kinder in Demonstrationen!","","","Disc-",[6],1,[1],[2],2,"14","3"],["4220","1968-11-09","Die Zahnmediziner der Freien Universität haben eine neue reformierte Satzung erhalten, die nicht von Studenten erkämpft wurde, sondern von langer Hand von \"oben\" geplant wurde.","FU-Reform von \"oben\"","","Kollegiales System bei den Zahnmedizinern","MM",[4],1,[1],[2],2,"14","5"],["4221","1968-11-10","Ohne Zwischenfälle sei die Vietnam-Demonstration der APO, vom SDS organisiert, verlaufen. Sie demonstrierten für ein \"rotes Vietnam\".","Mit roten Fahnen für \"rotes Vietnam\"","","","",[11],1,[1],[2],2,"72","3"],["4222","1968-11-10","Mehrere Gruppen der APO haben das Münchner Justizgebäude mit Steinen angegriffen. In der Münchner Universität hätten Fritz Teufel und Horst Mahler zu weiteren Aktionen gegen die Justiz aufgerufen.","Studentischer \"Fensterkrieg\"","","","",[1],1,[1],[2],2,"72","72"],["4223","1968-11-12","Die Philosophische Fakultät der FU Berlin hat das traditionelle Lehrstuhlprinzip der Ordinarien abgeschafft. Alle Habilitierten und wissenschaftlichen Mitarbeiter sollen das Recht zur eigenen Forschung erhalten. ","FU-Fakultät brach die Allmacht der Ordinarien","","Gleiche Rechte für Habilitierte bei den Philosophen","Michael L. Müller",[4],1,[1],[1],1,"16","7"],["4224","1968-11-13","Etwa 20 Studenten der Deutschen Studenten-Union protestierten gegen die westdeutsche Rektorenkonferenz. Diese solle zu Gunsten einer Bundesuniversitätskonferenz, in der Studenten gleichberechtigt beteiligt wären, abgeschafft werden","Studenten gegen Rektorenkonferenz","","","",[1],1,[1],[2],2,"18","2"],["4225","1968-11-14","Der von den Demonstranten der Schlacht am Tegeler Weg umgestoßene 93-jährige Karl Gross, der dadurch einen Oberschenkelhalsbruch erlitten hatte, ist im Krankenhaus verstorben, vermutlich an einer Lungenentzündung. Eine Sonderkommission der Staatsanwaltschaft ermittelt. Der Rektor der TU Berlin wurde von einem Berliner Bürger wegen Beihilfe zur Aufforderung zu strafbaren Handlungen angezeigt. Diese Beihilfe bestehe in der wiederholten Bereitstellung von Räumen der TU Berlin, in denen zu strafbaren Handlungen aufgefordert wurde. Kunzelmann und Langhans wurden wegen Bedrohung und Aufforderung zu Verbrechen angezeigt. Mehrere weitere Anzeigen wegen Beschädigungen durch die Schlacht am Tegeler Weg. Gegen 50 Demonstranten soll wegen Aufruhrs ermittelt werden.","Krawalle forderten ein Todesopfer","","Sonderkommission ermitteln wegen Aufruhrs","",[6],1,[1],[1],1,"22","3"],["4226","1968-11-15","Das Studentenparlament der TU Berlin hat die wegen der Schlacht am Tegeler Weg abgewählten Studentenvertreter wieder in ihren Ämtern bestätigt. (Nur in der II. Fassung der Ausgabe vom 15.11.1968!)","FU-AStA wieder im Amt","Schnell informiert","","",[4],1,[1],[2],2,"28","1"],["4227","1968-11-16","Das Studentenparlament der TU Berlin hat die wegen der Schlacht am Tegeler Weg abgewählten Studentenvertreter wieder in ihren Ämtern bestätigt. Die Berliner Burschenschaft sieht das TU-Studentenparlament dadurch zu \"einem reinen Theater herabgesunken\".","Nur Theater?","","","",[4],1,[1],[2],2,"14","5"],["4228","1968-11-16","Auf dem Flur vor dem Dekanat der Philosophischen Fakultät ist ein Feuerwerkskörper explodiert. Ein zufällig vorbeikommender Dozent klagte danach über Schmerzen im rechten Ohr.","Kein Studentenulk","","","",[1],1,[1],[2],2,"14","5"],["4229","1968-11-16","Alle Prozesse gegen Demonstranten, die wegen Auflaufs am Ostersonnabend angeklagt werden sollen, werden zunächst ausgesetzt, da Unklarheit darüber herrscht, ob Polizeioberkommissar Textor die Demonstranten korrekt zum Auseinandergehen aufgefordert hat, oder ob seine Aufforderungen zu \"zivil\" waren.","Textors Texte zu \"zivil\"?","","","K.G.",[1],1,[1],[2],2,"14","5"],["4230","1968-11-17","Schwere Kritik an Prof. Gottschalch, der die Schlacht am Tegeler Weg als Notwehrsituation der Demonstranten bezeichnet habe, bei solchen Professoren brauche man sich nicht über Steinwürfe wundern.","Politik der Steine","","","wbr.",[6],1,[2],[3],2,"70","2"],["4231","1968-11-20","Der AStA der FU Berlin hat Rektor Harndt in einem offenen Brief aufgefordert, zu den Vorwürfen, er sei NSDAP-Mitglied gewesen, Stellung zu nehmen.","Offener Brief","","","",[11],1,[1],[2],2,"28","3"],["4232","1968-11-22","In Saarbrücken und Erlangen streiken Studenten aus Protest gegen eine neue Universitätssatzung bzw. wegen Professorenmangels.","Vorlesungsstreiks","Kurz gemeldet","","",[1],1,[1],[2],2,"28","2"],["4233","1968-11-22","Die \"Arbeitsgemeinschaft am Otto-Suhr-Institut\" kritisiert Senator Stein, weil dieser die von rückgemeldeten Studenten nicht entrichteten AStA-Beiträge aus Steuergeldern dem AStA zahlte. Über 4.600 FU-Studenten hatten die Beiträge nicht gezahlt.","Vorwürfe gegen Senator Stein","","","",[4],1,[1],[2],2,"28","3"],["4234","1968-11-22","Der parlamentarische Wissenschaftsausschuss des Berliner Abgeordnetenhauses beschäftigt sich mit der Zusammenlegung von Lehrstühlen und \"Ein-Mann-Instituten\".","Größere Einheiten","","","",[4],1,[1],[2],2,"28","3"],["4235","1968-11-22","Harry Pross, neuer Ordinarius für Publizistik, erhielt seine Ernennungsurkunde.","Neuer Ordinarius","","","",[4],1,[1],[2],2,"28","3"],["4236","1968-11-23","Die Rektoratsübergabe an der TU Berlin wurde ohne das traditionelle Zeremoniell durchgeführt.","Pfiffe und Zwischenrufe statt festlicher Musik","","Die TU probte neue Form der Rektoratsübergabe","MM",[4],1,[1],[2],1,"16","7"],["4237","1968-11-23","Protestmarsch von etwa 40 Studenten der Romanistik durch das Gelände der FU Berlin. Sie protestierten dagegen, dass ihnen die Mitbestimmung bei der Gestaltung von Lehrveranstaltungen verweigert wurde.","Romanisten fordern \"Mitbestimmung\"","","","",[1],1,[1],[2],2,"16","7"],["4238","1968-11-23","In Charlottenburg findet eine \"Konsultation über Aufgaben der Christen angesichts der Studentenunruhen in Westeuropa\" statt, an der 50 Vertreter aus mehreren europäischen Ländern teilnehmen. Die Teilnehmer erklärten sich mit den demonstrierenden Studenten in der CSSR solidarisch.","Tagung über Studentenunruhen","","","",[1],1,[1],[2],2,"16","7"],["4239","1968-11-23","Der Institutsrat am Otto-Suhr-Institut hat beschlossen, dass mündliche Prüfungen künftig öffentlich sein sollen. Auch die Beratung über das Prüfungsergebnis können auf Wunsch öffentlich sein.","Prüfungen sollen öffentlich sein","","","",[4],1,[1],[2],2,"16","7"],["4240","1968-11-23","FU-Rektor Harndt nimmt Stellung zu den Vorwürfen, er sei SA- und NSDAP-Miglied gewesen. Der SA habe er nie angehört, NSDAP-Mitglied sei er lediglich automatisch durch die Überfuhrung aus einer anderen Organisation geworden. Nach der Machtübernahme Hitlers habe er wochenlang den SPD-Reichtagsabgeordneten Otto Brass versteckt.","Harndt: Nie SA-Mann gewesen","","","",[11],1,[1],[2],2,"16","7"],["4241","1968-11-23","Für die nächsten Konventswahlen an der FU Berlin treten nur 119 Kandidaten an, im Vorjahr waren es noch 218. Dies habe mit dem Desinteresse der Kommilitonen an der Arbeit ihres Studentenparlaments zu tun.","Nur 119 Kandidaten für Konventswahlen","","","",[4],1,[1],[2],2,"16","7"],["4242","1968-11-23","Verhandlung über die Rechtmäßigkeit des Einsatzes von Schlagstöcken durch Polizisten bei Demonstrationen. Hintergrund ist eine Klage einer Studentin, die bei den Demonstrationen am 2. Juni 1967 durch den Einsatz eines Polizei-Schlagstocks verletzt wurde. Offen ist, ob der Gebrauch des Schlagstocks gegen die alliierten Waffengebrauchsbestimmungen verstieß.","Schlagstock schwingt weiter im Ungewissen","","","",[1],1,[1],[2],2,"16","7"],["4243","1968-11-24","Der Jurist Prof. Klug bezeichnete den Paragraph 116 des StGB (Auflauf) als verfassungswidrig, auch der den Landfriedensbruch betreffende Paragraph müsse mindestens überarbeitet werden. Überwiegender Tenor, dass Demonstrationen ein Teil der Demokratie sind und Teilnehmer daran nicht so hart bestraft werden dürfen. Unterschiedliche Meinungen, ob die Blockade von Zeitungsauslieferungen bereits strafbare Gewalt darstelle.","\"Demonstrationen sind ein Element der Demokratie\"","","Richterbund beschäftigte sich mit \"heißem Eisen\"","",[1],1,[1],[1],2,"76","2"],["4244","1968-11-24","An der FU Berlin sind alle studentischen Disziplinarverfahren (etwa 40) aus der zurückliegenden Zeit eingestellt worden.","Eingestellt","","","",[1],1,[1],[2],2,"76","3"],["4245","1968-11-26","Mehrere Ordnungsstrafen gegen Mitglieder der Kommune I bei einer Berufungsverhandlung. Teufel, Gebbert und von Doetinchen erhielten einen Tag Haft, weil sie sich geweigert hatten, vor dem Richter aufzustehen. Kunzelmann erhielt sechs Tage Haft, weil er sich auf den Zeugentisch gesetzt und Polizisten ekelhaft genannt hatte.","Zum Prozeßbeginn Ordnungsstrafen","","","",[5],1,[1],[2],2,"16","3"],["4246","1968-11-27","Das SDS-Mitglied Christian Semler soll eventuell Hausverbot an der Technischen Universität erhalten. Auf eine Anfrage der CDU erklärte Senator Stein, dass nur bei Störung und Gefährdung des Universitätsbetriebes Räume für Versammlungen verweigert werden könnten.","TU-Hausverbot für SDS-Mitglied?","","","",[1],1,[1],[2],2,"20","3"],["4247","1968-11-28","Der Pflichtverteidiger Josef Bachmanns muss wegen Krankheit sein Mandat niederlegen.","Dutschke-Attentäter ohne Verteidiger","","","",[2],1,[1],[2],2,"20","3"],["4248","1968-11-29","Das Berliner Abgeordnetenhaus beschäftigte sich mit der aktuellen Situation an den Universitäten, heftige Debatten. Mehrere CDU-Sprecher kritisierten scharf die Einstellung Bernd Rabehls als Hilfsassistenten, dieser sei ein Stratege des Aufstandes in Deutschland. Senator Stein entgegnete, dies sei eine Entscheidung des Rektors gewesen, um die Situation an der Universität zu entschärfen. Karl-Heinz Schmitz (CDU) bezeichnete Prof. Gottschalch als Schreibtischtäter. Dem SDS gehe es nicht um Mitbestimmung, sondern um die völlige Beherrschung der Gesellschaft. Die CDU fordert ein schärferes Vorgehen gegen die Unruhen.","Heftige Debatte um Rabehl/ Schmitz nennt Gottschalch einen \"Schreibtischtäter\"","","Scharfe Debatte über Situation an den Universitäten","Go./LUK",[1],1,[1],[2,1],1,"36","1,2"],["4249","1968-11-29","18 Studenten der Deutschen Film- und Fernsehakademie wurden ihre Ausbildungsverträge gekündigt, nachdem sie mehrfach in die Räume des Direktors der Akademie eingedrungen waren, um so gegen die eventuelle Entlassung eines anderen Studenten zu protestieren.","Kündigung für 18 Film-Studenten","","","",[1],1,[1],[2],2,"36","3"],["4250","1968-12-01","Die Arbeitsgemeinschaft der Polizeichef beschließt, dass die Polizei künftig bei Barrikadenbau und Sammlung von Wurfgeschossen früher eingreifen soll. Laut Frankfurts Polizeipräsidenten Littmann befänden sich zunehmend \"kriminelle Elemente\" in der Gefolgschaft des SDS.","Polizei will eher einschreiten","","","",[1],1,[1],[2],2,"70","1"],["4251","1968-12-03","Laut Bundesinnenministerium bemühen sich einige linksradikale Studentengruppen um die Beschaffung von Handfeuerwaffen und Anleitungen zur Herstellung und Gebrauch von Sprengmitteln.","Radikale suchen Waffen","Schnell informiert","","",[1],1,[1],[2],2,"14","1"],["4252","1968-12-03","Der Tübinger Rektor nannte die jüngsten Störungen an der Uni \"Kulturbarbarei\". Er fordert neue Disziplinarordnungen, um besser gegen die Störer vorgehen zu können. Das Tübinger Studentenparlament löste sich auf. In Bochum sprengten 70 Studenten die Sitzung des Rektorats. Die ersten drei von 124 beschuldigten Tübinger Studenten wurden wegen Hausfriedensbruchs zu Geldstrafen verurteilt.","Studenten stehen hinter Halbfas","","","",[1],1,[1],[3],2,"14","2"],["4253","1968-12-03","Der SDS-Hessen erhält vorerst keine staatliche Unterstützung mehr, da er die Voraussetzungen für finanzielle Zuwendungen nicht mehr erfülle.","Kein Geld für den SDS","Kurz gemeldet","","",[8],1,[1],[2],2,"14","2"],["4254","1968-12-03","Etwa 100 Studenten des Philosophischen Seminars der FU Berlin beschlossen auf einer Vollversammlung, dass allen Professoren, Dozenten und Assistenten der Zutritt in das Haus verwehrt werden solle, die einen neuen Satzungsentwurf nicht akzeptieren. Dies wurde sofort bei einem Seminar von Prof. Lieber umgesetzt, der daraufhin das Haus verließ. Ein weitere Dozent hielt sein Seminar bei sich zu Hause.","Es gärt bei den Philosophen","","","",[1],1,[1],[2],2,"14","3"],["4255","1968-12-03","Eine Vollversammlung der Studenten der Wirtschafts- und Sozialwissenschaftlichen Fakultät forderte dazu auf, in die für den nächsten Tag angesetzte Fakultätssitzung einzudringen und die Öffentlichkeit herzustellen. Nur etwa 60 der 2.800 Studenten waren bei der Beschlussfassung anwesend.","Einsamer Beschluß","","","",[1],1,[1],[2],2,"14","3"],["4256","1968-12-04","Nach Hessen hat auch Nordrhein-Westfalen beschlossen, dem SDS keine Gelder mehr zur Verfügung zu stellen. Ministerpräsident Kühn erklärte, er habe nicht die Absicht, Rektoratsbesetzungen und Universitätsbarrikaden zu finanzieren.","Kein Geld für den SDS","Kurz gemeldet","","",[8],1,[1],[2],2,"16","2"],["4257","1968-12-04","Der BND hat erneut versucht, Studenten der Kieler Universität anzuwerben. Das schleswig-holsteinische Kultusministerium kritisiert dies, der Direktor des soziologischen Seminars der Uni Kiel, Prof. Trappe, trat aus Protest von seinem Amt zurück","Nachrichtendienst warb um Studenten","","","",[1],1,[1],[2],2,"16","2"],["4258","1968-12-04","Schadensersatzklage der FU Berlin in Höhe von etwa 36.000 DM gegen 19 Studenten wegen Beschädigungen bei verschiedenen Besetzungen. Das Phliosphische Seminar der FU ist weiter besetzt, da alle Dozenten, bis auf eine Ausnahme, den neuen Satzungsentwurf nicht anerkennen wollen. Erklärung der relegierten Studenten der Film- und Fernsehakademie Berlin, dass ihre Entlassung politisch begründet sei. Auf einer Kundgebung wurde ein Plakat angebracht, auf dem unter der Schrift \"Bendas Haus\" ein Haus in Flammen zu sehen war.","Studenten sollen zahlen","","FU-Kuratorium will 36.000 Mark einklagen","MM",[1],1,[1],[2],2,"16","3"],["4259","1968-12-05","Prof. Weischedel bekennt in einem Brief an den Dekan der philosophischen Fakultät, dass er die Lage an der FU falsch eingeschätzt hätte. Er habe gedacht, dass es den Studenten wirklich auf eine vernünftige Zusammenarbeit mit den Professoren und um eine sinnvolle Gestaltung der Universität gehe. Er müsse den Kritikern nun recht geben.","Professor Weischedel bekennt Irrtum","Schnell informiert","","",[1],1,[1],[2],2,"22","1"],["4260","1968-12-05","Im Prozess Springer gegen Mahler wurde die Frage behandelt, ob Horst Mahler in die Eingangshalle des Axel Springer Verlagshauses eingedrungen oder von nachdrängenden Demonstranten hineingestoßen worden sei. Ein Polizist widerspricht der letzteren These.","Gericht hörte Polizeibeamte","","","",[6],1,[1],[2],2,"22","3"],["4261","1968-12-05","Radikale Studenten würden wieder für Tumulte sorgen, haben erneut Gewalt zum einzig adäquaten Mittel erklärt. Einem SFB-Team wurde gewaltsam die Kamera entwendet und diese für \"vergesellschaftet\" erklärt. Begründet wurde dies damit, dass der SFB der Polizei seine Aufnahmen zur Verfügung stellen würde. Weitere \"Enteignungen\" wurden angekündigt. Studenten der Wirtschafts- und Sozialwissenschaftlichen Fakultät der FU Berlin sprengten eine Sitzung ihrer Fakultät. Wieder Plakat mit brennendem Haus von Innenminister Benda, ein zum Paket verschnürter Pflasterstein wurde als \"Wurfsendung an die politische Justiz\" deklariert. Am Philosophischen und Romanischen Seminar der FU wurde wegen anhaltender Störungen die Lehrveranstaltungen abgesagt. Die \"Gruppierung demokratischer Studenten\" kritisierte Senator Stein scharf, er ließe die ständigen Unruhen zu. Zudem kritisierten sie die Einstellung Rabehls als Hilfsassistent. Die Aussperrung der Dozenten aus dem Philosophischen Seminar zeige die Umwandlung einer Arbeitsstätte in eine Revolutionszentrale, so Prof. Landmann. Dieser kritisierte zudem die geforderte studentische Satzung für das Philosophische Seminar.","Konflikt mit Agenten des Kapitals militant austragen'","","","L. R.",[1],1,[1],[5],2,"22","3"],["4262","1968-12-05","Etwa 300 Studenten der Rechts- und Sozialwissenschaftlichen Fakultät der Uni Kiel sprengten eine Fakultätssitzung, um die \"Öffentlichkeit der Sitzung\" herzustellen. Der Rektor der Kieler Uni sprach sich vehement gegen versuchte Anwerbung des BND auf dem Unibereich aus.","Studenten sprengten Fakultätssitzung","","","",[1],1,[1],[2],2,"22","15"],["4263","1968-12-06","Laut Bundesinnenministerium müssen radikale Studenten, die sich krimineller Vergehen schuldig machen, mit dem Entzug ihrer nach dem Honnefer-Modell gewährten Stipendien rechnen.","Stipendien-Entzug droht","Schnell informiert","","",[1],1,[1],[2],2,"30","1"],["4264","1968-12-06","Studenten der Pädagogischen Hochschule Berlin hinderten Prof. Schweitzer an der Abhaltung seiner Lehrveranstaltung wegen \"undemokratischer Verhältnisse\" am Lehrstuhl für Politologie. Die Junge Union Berlin ruft zum Widerstand gegen den \"individuellen Terror\" an der Uni auf. Mehrere Punkte der Reform der Wirtschafts- und Sozialwissenschaftlichen Fakultät konnten durch die Störung durch Studenten nicht behandelt werden. Die Studenten würden sich nach Meinung des Dekans mit solchen Aktionen daher selber schaden, da sie Reformen blockieren. Wegen Geringfügigkeit wurde ein Verfahren wegen Auflaufs am 2. Juni 1967 eingestellt.","Seminar gesperrt","","Studenten behinderten Professor Schweitzer","",[1],1,[1],[2],2,"30","6"],["4265","1968-12-06","Weitere Reformen an der TU Berlin, die Vertreter der Nichtordinarien, Studenten und Assistenten sollen mehr Mitbestimmung bekommen, Entscheidungen des Akademischen Senats sollen künftig vom Rektor oder seinem Sprecher bekanntgegeben werden.","TU-Satzung wurde geändert","","","",[4],1,[1],[2],2,"30","12"],["4266","1968-12-07","Senator Stein hat sich in einer Erklärung gegen \"Willkür\" und \"Terror\" gewandt, einige Extremisten würden keine Hochschulreform anstreben, sondern die Zerstörung der Universität, um so die Gesellschaft zu erschüttern. Studenten und Dozenten sollten entschieden gegen die Störungen auftreten. Der Dekan der Philosophischen Fakultät der FU Berlin, Prof. Otto von Simson, stellte fest, dass es sich bei den radikalen Aktivisten nur um eine Minderheit handle, die nicht repräsentativ für die Mehrheit der Studenten sei. Die Bezeichnung \"Liberaler\" sei schon wieder zum Schimpfwort geworden. Mehrere Lehrveranstaltungen wurden am Vortag gestört. Harry Pross gibt eine Gegendarstellung zu der Aufnahme von den gekündigten Akademiestudenten auf.","Stein gegen Terror/ \"Angriff - Willkür - Terror\"","","Scharfe Absage des Senators an Extremisten/ Senator Stein über ein Flugblatt der Studentenvertretung","Michael L. Müller",[1],1,[1],[2,5],2,"20","1,7"],["4267","1968-12-08","Ankündigung des bevorstehenden Prozesses gegen den Dutschke-Attentäter Josef Bachmann, Zusammenfassung seiner Selbstmordversuche. Rudi Dutschke wird wohl nicht als Zeuge auftreten, da sein Gesundheitszustand dies nicht zulasse.","Bachmann vor Gericht","","Prozeß gegen Dutschke-Attentäter beginnt Freitag","G. W.",[2],1,[1],[2],2,"62","7"],["4268","1968-12-10","Der LSD hat zu seiner Delegiertenkonferenz auch Vertreter der FDJ eingeladen.","FDJ eingeladen","Schnell informiert","","",[9],1,[1],[2],2,"16","1"],["4269","1968-12-10","Der Bundesvorsitzende der Deutschen Studenten-Union (DSU) hat den SDS als \"insitutionalisierte Anti-Reformbewegung\" an den Universitäten bezeichnet und kündigte Aufklärungskampagnen unter der Studentenschaft an. An der FU habe die DSU nicht an den Konventswahlen teilnehmen können, da man mit der Vorbereitung dafür zu spät begonnen habe. Kritik der DSU am Aufruf von Senator Stein, dass entschieden gegen Störer Front gemacht werden solle, dies könne als Aufforderung zur Lynchjustiz verstanden werden. Die DSU stehe zwischen der Resignation derer, die den Radikalen das Feld überlassen, und dem blinden Aktionismus jener, die Reformwillige als ihre größten Feinde bezeichnen. Erneut zahlreiche Störungen von Lehrveranstaltungen an der FU Berlin, teils stieß dies auf entschiedenen Protest der Hörer.","Studenten sollen aufgeklärt werden/ Aufruf zur Lynchjustiz?","Schnell informiert","","MM",[1],1,[1],[2],2,"16","1,3"],["4270","1968-12-11","Studenten wollen wegen der Kündigung von 18 Studenten der Film- und Fernsehakademie eine Streik an allen Berliner Hochschulen erzwingen. In Göttingen hat der dortige Rektor der Universität die Zusammenarbeit mit dem AStA und dem Studentenrat eingestellt, da diese sich nicht eindeutig von Störungen Androhungen strafbarer Gewalttaten gegen Frauen und Töchter von Professoren distanzierten.","Studenten wollen Streik erzwingen","","","",[1],1,[1],[2],2,"16","1"],["4271","1968-12-11","Der Verteidiger des Dutschke-Attentäters Josef Bachmann stellte einen Antrag, in dem er die Richter wegen Befangenheit ablehnt. Die selben Richter hatten wenige Tage zuvor zur Empörung der großen Mehrheit der Bevölkerung den ehemaligen NS-Richter Rehse freigesprochen. Bachmanns Anwalt befürchtet nun, dass dieses Urteil durch ein besonders hartes Urteil gegen seinen Mandanten ausgeglichen werden soll.","Bachmann-Anwalt: Gericht ist befangen","","Wird der Prozeß verschoben?","",[2],1,[1],[2],2,"16","1"],["4272","1968-12-11","Der Verteidiger des Dutschke-Attentäters Josef Bachmann stellte einen Antrag, in dem er die Richter wegen Befangenheit ablehnt. Die selben Richter hatten wenige Tage zuvor zur Empörung der großen Mehrheit der Bevölkerung den ehemaligen NS-Richter Rehse freigesprochen. Bachmanns Anwalt befürchtet nun, dass dieses Urteil durch ein besonders hartes Urteil gegen seinen Mandanten ausgeglichen werden soll.","Bachmann will nicht vor Rehse-Richter","","Anwalt des Dutschke-Attentäters: \"Befangen\"","M.K.",[2],1,[1],[1],2,"16","3"],["4273","1968-12-11","Studenten wollen wegen der Kündigung von 18 Studenten der Film- und Fernsehakademie eine Streik an allen Berliner Hochschulen erzwingen. Das Gebäude der Wirtschafts- und Sozialwissenschaftlichen Fakultät soll als Zentrum dienen. Am OSI haben die acht linken Studentenvertreter ihre Mitarbeit im Institutsrat beendet. Die Studenten der Berliner Ingenieur-Akademien beschlossen einen dreitägigen Streik, um so auf die Notwendigkeit von Reformen aufmerksam zu machen.","Wieder Studenten-Streik","","Weitere Störungen an der FU angekündigt","MM",[1],1,[1],[2],2,"16","3"],["4274","1968-12-11","Prof. Schweitzer von der Pädagogischen Hochschule sieht \"eindeutig politische Hintergründe\" für Aufruf von Studenten zum Boykott seiner Lehrveranstaltungen. Dies sei durch sein Eintreten für den 16-jährigen Günter Oppermann, der bei seiner versuchten Flucht aus der DDR von einer Mine schwer verletzt worden war, ausgelöst worden.","\"Eindeutig\"","","","",[1],1,[1],[2],2,"16","3"],["4275","1968-12-12","Der Prozess gegen den Dutschke-Attentäter Bachmann wurde erneut vertagt. Damit gab man einem Antrag des erkrankten Verteidigers Bachmanns statt. Abgelehnt wurde es jedoch, das Gericht wegen des Rehse-Urteils für befangen zu erklären.","Rehse-Richter Oske: Bachmann-Prozeß findet später statt","","Schwurgericht hält sich nicht","MK.",[2],1,[1],[1],2,"18","1"],["4276","1968-12-12","Bundespräsident Lübke erklärt, niemand bestreite den Bedarf an Reformen an den wissenschaftlichen Hochschulen in Deutschland. Dies entschuldige aber nicht die revolutionären Gewaltakte.","Lübke verurteilt Gewalt","Kurz gemeldet","","",[1],1,[1],[2],2,"18","2"],["4277","1968-12-12","Rektor und Senat der Kieler Universität fordern alle Studenten und Professoren auf, eine Zusammenarbeit mit dem BND zu verweigern und eventuelle Kontaktaufnahmen sofort zu melden. In Saarbrücken besetzten Studenten das Rektorat der Uni, weil man den Professoren vorwirft, in einem Schreiben an den saarländischen Ministerpräsidenten die studentischen Forderungen \"global diffamiert\" zu haben.","Kieler Uni gegen Geheimdienst-Arbeit","","","",[1],1,[1],[2],2,"18","2"],["4278","1968-12-12","Etwa 150 Studenten der Pädagogischen Hochschule drangen während der Steglitzer Bezirksverodnetenversammlung in den Sitzungssaal des Rathauses ein. Ihr Protest richtete sich gegen einen Antrag der drei Fraktionen, nach dem die künftigen Lehrer an Steglitzer Schulen nicht von Lehrpersonen unterrichtet werden sollen, die Verstöße gegen Grundrechte und Strafgesetze gutheißen (bezieht sich wohl auf Prof. Gottschalch). Es gab Diskussionen, der Antrag wurde trotzdem angenommen.","Studenten stürmten Rathaus Steglitz","","","Bg.",[1],1,[1],[2],2,"18","3"],["4279","1968-12-12","Zeugenaussagen beim Prozess des Springer-Konzerns gegen Horst Mahler. Demnach sei Mahler einer der Hauptakteure des Demonstrationszuges gegen das Axel Springer Verlagshaus Ostern 1968 gewesen.","\"Mahler war ein Hauptakteur\"","","","",[6],1,[1],[2],2,"18","7"],["4280","1968-12-13","Laut Bundesinnenministerium versuchen östliche Spionagedienste gezielt Studenten anzuwerben, die ihre Tätigkeit jedoch erst nach Erreichen von hohen beruflichen Stellungen nach dem Studium aufnehmen sollen.","Osten wirbt Studenten als Agenten","","","",[11],1,[1],[2],2,"14","2"],["4281","1968-12-13","Bundespressechef Diehl verteidigt die Aktivität des BND an der Kieler Universität. Es gehe dabei um die Gewinnung von Wissenschaftlern für die Analyse des geheimdienstlichen Nachrichtenmaterials.","Diehl verteidigt BND","Kurz gemeldet","","",[11],1,[1],[2],2,"14","2"],["4282","1968-12-13","Studenten der TU Berlin besetzten den Lehrstuhl des Dekans der Architekturfakultät, dabei brachen sie die Tür des Arbeitszimmers auf und sichteten Akten. Sie erklärten, man habe die Taktik der Professoren durchschaut, die Reformansätze mit wohlwollenden Äußerungen bedächten, gleichzeitig aber deren Verwirklichung unterdrücken würden. Studenten sämtlicher Berliner Akademien lehnten einen Marsch zum Hause des Schulsenators ab, die extreme Linke habe diesen Marsch als schon beschlossen darstellen wollen, dies seien eine empfindliche Niederlage für sie. Etwa 100 Studenten drangen in die Akademie für soziale Arbeit in Schöneberg ein und besetzten einen Unterrichtsraum.","Marsch abgeblasen","","Statt dessen neuer Wirbel an der TU","",[1],1,[1],[2],2,"14","3"],["4283","1968-12-14","Weiter Unklarheit darüber, ob die Bundesregierung einen Antrag auf Verbot der NPD stellen wird. Vor allem von Seiten der CDU wird argumentiert, dass dann auch ein Verbot des SDS oder der neugegründeten DKP geprüft werden müsse.","Noch keine Klarheit über NPD-Verbot","","","",[8],1,[1],[3],2,"18","2"],["4284","1968-12-14","Der Wissenschaftsrat stellte verschiedene Empfehlungen für die Hochschulreformen vor. Die von Studenten geforderte Öffentlichkeit der Universitätsgremien lehnte er jedoch ab. Der VdS lehnt die Vorschläge des Wissenschaftrates ab, diese würden nicht dazu dienen, die Krise des deutschen Bildungswesens zu lösen.","Studenten lehnen ab","","","",[4],1,[1],[2],2,"18","2"],["4285","1968-12-14","Ein Vortrag von Bundesforschungsminister Stoltenberg in der Universität Kiel wurde massiv gestört. Stoltenberg wurde von Studenten aufgefordert, sich bei den Verfassern eines Manifestes gegen die Notstandsgesetze zu entschuldigen. Als Stoltenberg zunächst seinen Vortrag halten wollte, versuchten mehrere Studenten das Podium zu stürmen. Stoltenberg wurde von einem Ring aus Studenten geschützt, zahlreiche Studenten sollen Platzwunden gehabt haben.","Tumulte in Kiel um Stoltenberg","","","",[1],1,[1],[2],2,"18","2"],["4286","1968-12-14","Debatte im Berliner Abgeordnetenhaus über die Lage an den Berliner Universitäten, CDU und SPD stimmen überein, verurteilen scharf die jüngsten Störaktionen. Laut Senator Stein hätten sich die radikalen Studenten doppelt isoliert: sowohl von der Bevölkerung als auch vom größten Teil der Studentenschaft. Die Universitäten müssten den Störern energisch entgegentreten, die CDU will per Antrag erreichen, dass der Senat durch Beauftragte bei wiederholten rechtswidrigen Eingriffen selbst eingreifen kann.","\"Radikale isolieren sich\"","","","Go./LUK",[1],1,[1],[5],2,"18","3"],["4287","1968-12-14","Peter Brandt wurde in der Neuaufnahme seines Prozesses wegen Auflaufs in zwei Fällen zu 400 DM Geldstrafe verurteilt. Im ersten Urteil war er zu zwei Wochen Dauerarrest verurteilt worden.","Peter Brandt soll 400 Mark zahlen","","","",[9],1,[1],[2],2,"18","6"],["4288","1968-12-14","Bei den Wahlen zum Studentenparlament der FU Berlin wurden 52 der 76 Sitze durch linke Studenten errungen. Dies lag aber wohl auch daran, dass die \"gemäßigten\" Vertreter des VAFU diesesmal keine Vertreter aufgestellt hatten. Die Wahlbeteiligung lag nur noch bei 38,7 Prozent. Die Studenten der Musikhochschule haben eine neue Satzung angenommen, die ihnen künftig eine 50-prozentige Beteiligung bei Bestimmungen der Abteilungsleiter zusichert. Rücktritt der studentischen Vertreter des Institutsrates des OSI, damit die Studenten zu einer grundlegenden Auseinandersetzung über ihre Stellung zum Insitutsrat und der konkreten Verwirklichung der Reformsatzung finden.","FU-Konvent weiter \"links\"","","Nicht einmal 40 Prozent der Studenten wählten","",[11],1,[1],[2],2,"18","6"],["4289","1968-12-17","Vor dem Hintergrund der Kontroverse um die Einstellung Bernd Rabehls als Hilfsassistent an der FU Berlin erklärte die Innenverwaltung, dass ein Bewerber für den öffentlichen Dienst wegen seiner Zugehörigkeit zum SDS oder anderen nicht verfassungswidrigen Organisationen nicht abgelehnt werden kann. Alles weitere käme auf den Einzelfall an.","\"Fall\" Rabehl und die Folgen","","","",[1],1,[1],[2],2,"16","5"],["4290","1968-12-17","Eine Berufung zweier Polizisten wegen ihrer Verurteilung zu Gefängnisstrafen auf Bewährung durch Körperverletzung im Amt während der Demonstrationen am 2. Juni 1967 wurde als unbegründet abgewiesen.","Berufung verworfen","","","",[1],1,[1],[2],2,"16","6"],["4291","1968-12-17","Bei einer Urabstimmung am Otto-Suhr-Institut sprach sich die große Mehrheit der Studenten für die Fortführung der eingeleiteten Reformen aus.","Für Reformen","","","",[4],1,[1],[2],2,"16","6"],["4292","1968-12-17","Mehrere Studenten der FU Berlin fechten die jüngsten Wahlen zum Studentenparlament an, da Manipulationen vorgekommen seien. Das von linken Studenten besetzte Philosophische Seminar wurde nun auch von politisch andersdenkenden Studenten ihrerseits für besetzt erklärt.","Studenten fechten Wahlen an","","","",[1],1,[1],[2],2,"16","6"],["4293","1968-12-17","Bei der Eröffnungsfeier der Dortmunder Universität kam es zu Auseinandersetzungen zwischen etwa 40 Studenten, der Polizei und einigen Ehrengästen. Ministerpräsident Kühn bezeichnete die Störung von Studenten, die das Weihnachtslied \"Stille Nacht\" mit auf die Situation an der Universität angepassten Text sangen, als \"Manifestation pöbelnder Rüpelhaftigkeit\". Etwa 100 Studenten der Ruhr-Universität besetzten die Fakultätsräume der sozialwissenschaftlichen Abteilung und eröffneten eine \"Gegenuniversität\".","Tumulte bei Eröffnung der Universität Dortmund","","Kühn: \"Manifestation pöbelnder Rüpelhaftigkeit\"","",[1],1,[1],[5],2,"16","11"],["4294","1968-12-18","Das Institut für Biophysik der FU Berlin hat eine neue Satzung erhalten, das Direktionsprinzip wurde zu Gunsten des Kollegialprinzips aufgegeben.","Neue Satzung für FU-Institut","","","",[4],1,[1],[2],2,"16","2"],["4295","1968-12-19","Polizeibeamte besetzten das von Studenten beschlagnahmte Institut für Soziologie der Uni Frankfurt. Bei Eintreffen der Polizei waren keine Studenten mehr anwesend. Diese kündigten jedoch weitere Besetzungen an, wenn die Polizei das soziologische Seminar nicht wieder freigibt.","Institut geräumt","Schnell informiert","","",[1],1,[1],[2],2,"20","1"],["4296","1968-12-19","Laut Senator Stein zeichne sich eine neue Entwicklung an der Universität ab. Radikale Studenten seien nur noch eine sehr kleine Minderheit, die Mehrheit wendet sich erfolgreich gegen die Störungen. Spricht von Selbstheilungskräften der Universität. Fordert die konsequente Anwendung des Hausrechts gegen Störer.","Wie soll es nun weitergehen?","Zur Sache","","Senator Werner Stein",[1],1,[5],[1],1,"20","2"],["4297","1968-12-19","Gegen neun Studenten der FU Berlin hat der Rektor Hausordnungsverfahren eingeleitet. Ihnen wird vorgeworfen, Mitglieder der FU Berlin beim Betreten ihrer Arbeitsplätze gehindert oder den Abbruch von Lehrveranstaltungen erzwungen zu haben. Assistenten und Studenten des OSI haben die Hausordnungsverfahren scharf kritisiert, diese seien kein geeignetes Mittel der Hochschulpolitik, massive Demonstrationen gegen diesen \"Terrorakt\" werden angekündigt.","Verfahren gegen neun Studenten","","","",[1],1,[1],[2],2,"20","3"],["4298","1968-12-19","Studenten durften während einer Sitzung der Schöneberger Bezirksverordnetensammlung ein Flugblatt verteilen. Ihrem Wunsch, dieses auch vorzulesen und zu diskutieren, wurde nicht entsprochen. Hintergrund des Flugblatts ist eine Anfrage der CDU, ob das Bezirksamt bereit sei, sich bei der zuständigen Senatsverwaltung dafür einzusetzen, dass die künftigen Lehrer an den Schöneberger Schulen nicht von Lehrpersonen ausgebildet werden, die Verstöße gegen das Grundrecht und Strafgesetz dulden.","Studenten durften ihre Flugblätter verteilen","","In Schöneberg gab es keinen Krach","Hi.",[1],1,[1],[1],2,"20","4"],["4299","1968-12-19","Die Westdeutsche Rektorenkonferenz lehnte den Vorschlag des Wissenschaftsrates, Rektoren durch längerdienenden Präsidenten zu ersetzen, ab. Weitere Reformvorschläge der Rektorenkonferenz. Der VdS begrüßte die in den Vorschlägen enthaltene Eigenständigkeit der Universitäten, kritisierte jedoch die ungenügende Berücksichtigung der studentischen Mitbestimmung.","Die Rektoren lehnen ab","","Wenig Übereinstimmung mit dem Wissenschaftsrat","",[4],1,[1],[2],2,"20","9"],["4300","1968-12-20","Studenten der FU Berlin nehmen einen Beschluss des AStA an, wonach für den Beginn des Jahres 1969 Studenten, Professoren und Assistenten zu einem allgemeinen Streik aufgerufen werden, um so gegen die vom Rektor eingeleiteten Hausordnungsrechtsverfahren zu protestieren. Ziel sei die völlige Schließung der Uni. Die Institutsratsvorsitzenden des OSI wurden von einem SDS-Vertreter beleidigt. Diese hatten zuvor den Verfahren als \"Dolchstoß\" gegen die Reformer bewertet. Ein Student schlug vor, den Universitätsdirektor solange als Geisel zu behalten, bis die Verfahren eingestellt werden, Mehrheit lehnte dies aber ab. Brandanschlag auf das Gebäude des FU-Rektors. Weitere Hausordnungsverfahren gegen Studenten auch an der Juristischen Fakultät.","Studenten rufen zum \"Generalstreik\" auf/ FU-Direktor sollte als Geisel dienen","","Weitere Hausordnungsverfahren gegen Studenten","MM.",[1],1,[1],[2],2,"20","1,8"],["4301","1968-12-20","Bauarbeiter protestierten mit Plakaten wie \"Kommunisten raus\" gegen die Störung des Lehrbetriebs an der sozialwissenschaftlichen Abteilung der Ruhr-Universität in Bochum.","Protest gegen Radikale","Schnell informiert","","",[1],1,[1],[3],2,"20","1"],["4302","1968-12-21","Mit Rücksicht auf seinen Gesundheitszustand soll ein Verfahren wegen Landfriedensbruchs gegen Rudi Dutschke eingestellt werden. Gegen seine zwei Mitangeklagten soll das Verfahren jedoch aufrecht erhalten werden.","Rudi Dutschke nicht vor Gericht","","","",[2],1,[1],[2],2,"16","3"],["4303","1968-12-21","An der Zweiten Medizinischen Klinik ist eine Reform der Satzung am Votum der Hochschullehrer gescheitert. Horst Mahler übernimmt den Rechtsbeistand von sieben der 14 FU-Studenten, gegen die ein Ordnungsverfahren eingeleitet wurde. Betroffene Studenten der Juristischen Fakultät wollen öffentlich aussagen. Die Anfechtung der Konventswahlen der FU Berlin wurde zurückgewiesen.","Professoren gegen Institutssatzung","","","",[4],1,[1],[2],2,"16","3"],["4304","1968-12-22","Im Berliner Extra-Dienst wird zur Verhinderung der Bundesversammlung in West-Berlin aufgerufen.","Aufruf zur Revolte","","Radikale wollen Bundesversammlung stören","",[11],1,[1],[2],2,"44","2"],["4305","1968-12-22","Etwa 100 Demonstranten haben die Kaufhäuser Kaufhof und Horten in Hamburg gestürmt und Sachschaden angerichtet. Es kam zu Auseinandersetzungen mit der Polizei. Am Abend wurden Scheiben der Geschäftsstelle des \"Hamburger Abendblatts\" eingeworfen. 28 Demonstranten wurde festgenommen.","Studenten stürmten zwei Kaufhäuser","","","",[1],1,[1],[3],2,"44","2"],["4306","1968-12-22","Der angekündigte Marsch von Studenten für ihre mit Ordnungsverfahren belegten Kommilitonen fand nicht statt.","Studenten-Marsch fand nicht statt","","","",[1],1,[1],[2],2,"44","3"],["4307","1968-12-22","Studenten der Wirtschaftsakademie Berlin kritisieren den Entwurf für ein neues Fachhochschulgesetz.","Kritik am Entwurf","","","",[4],1,[1],[2],2,"44","3"],["4308","1968-12-24","Absolventen der Pädagogischen Hochschule sollen bei der Einstellung in den öffentlichen Dienst keine Nachteile entstehen, weil sie Vorlesungen von Lehrkräften, die Verstöße gegen Grundrechte und Strafgesetze gutheißen, stören, so das Steglitzer Bezirksamt.","Keine Nachteile für Studenten","","","",[4],1,[1],[2],2,"14","4"],["4309","1968-12-25","Der Akademische Senat der Pädagogischen Hochschule Berlin kritisiert Beschlüsse mehrerer Bezirksverordnetenversammlungen, wonach empfohlen wird, dass künftige Lehrer nicht von Personen, die Verstöße gegen Grundrechte und Strafrechte gutheißen, ausgebildet werden sollen. Diese Empfehlungen seien Eingriffe in die Freiheit von Lehre und Forschung.","PH: \"Freiheit der Lehre gefährdet\"","","","",[4],1,[1],[2],2,"40","7"],["4310","1968-12-28","Störung des Gottesdienstes in der Kaiser-Wilhelm-Gedächtniskirche am Heiligabend, Demonstration von dem Zuchthaus Tegel, Parolen wie \"Stellt die Wärter an die Wand - nehmt das Haus in eure Hand!\"","Radikale störten den Frieden der Heiligen Nacht","","Gottesdienst unterbrochen - Tumulte vor dem Zuchthaus Tegel","",[11],1,[1],[1],1,"18","5"],["4311","1968-12-31","Rückblick auf das Jahr 1968. In der monatlichen Zeitleiste wird eine Ankündigung des VDS im März, dass man einen heißen Sommer erwarte, sowie Proteste gegen die Notstandsgesetzgebung erwähnt. Dazu kommt ein Foto von der Demonstration nach dem Vietnamkongress im Februar, wo in der Bildunterschrift geschrieben wird, dass es ein jahr der Demonstrationen, der Ausschreitungen, der Gewalt war. Erwähnt werden das Attentat auf Dutschke und die anschließenden Unruhen vor dem Axel Springer Verlag. In Frankreich sei die Situation jedoch schlimmer gewesen.","1968: Rückblick auf das alte Jahr","","","",[1],1,[1],[4],1,"14","10,11"],["4312","1968-07-01","Kritik an dem Beschluss des Akademischen Senats, die Reformsatzung des Otto-Suhr-Instituts nicht zu genehmigen. Zwar könne man die Satzung nur mit größten Bedenken genehmigen, jedoch richtet die Ablehnung des Senats mehr Schaden an als die Satzung, wenn als Experiment gedachte Reformen so blockiert werden. Die Autonomie der Hochschulen wird in Frage gestellt.","Unfähig zur Reform?","","","P.I.",[4],4,[5],[2],2,"20","2"],["4313","1968-07-01","Mittels eines \"Go-in\" wurde die Wahl des Rektors der Universität Marburg verhindert. Laut dem Rektor seien etwa 150 Studenten unter Gewaltanwendung gegen Bedienstete des Rektorats in die Veranstaltung eingedrungen, der AStA widersprach dem.","Studenten verhindern Wahl des Rektors in Marburg","","","w. m.",[1],4,[1],[3],2,"20","3"],["4314","1968-07-01","Vorschläge der Jungen Union zur Hochschulreform, Verneinung eines politischen Mandats der Studentenvertretungen.","Absage der Jungen Union an politisches Mandat und Politisierung der Hochschule","","Zahlreiche Vorschläge für ein Bildungsprogramm","K. P.",[4],4,[1],[1],2,"20","3"],["4315","1968-07-01","Bei der Besetzung des FU-Rektorats ist ein Sachschaden von mehr als 1.000 DM entstanden. Gestohlen wurden u.a. der Ornat von Rektor Harndt sowie dienstliche Briefbögen.","Sachschaden im Rektorat beträgt mehr als 1000 DM","","","",[1],4,[1],[2],2,"20","11"],["4316","1968-07-01","Die Jüdische Studentengemeinschaft kritisiert die Räumung des Ostasiatischen Seminars der FU Berlin, damit habe der Rektor mit Polizeigewalt dafür gesorgt, dass der \"Antisemit Eckardt wieder seine nazistisch durchgesetzten Vorlesungen halten kann\". Von den verantwortlichen Stellen wie dem Regierenden Bürgermeister werden Maßnahmen gefordert, damit Prof. Eckardt keine Vorlesungen mehr halten kann. In Erwägung wird gezogen, ob nicht alle jüdischen Mitglieder von einem Studium bzw. einer Anstellung an der FU Berlin absehen bzw. diese verlassen sollten.","Jüdische Studentenvereinigung: Maßnahmen gegen Eckardt","","","",[1],4,[1],[2],2,"20","11"],["4317","1968-07-01","Einstimmig forderte die Delegiertenversammlung der Berliner CDU den Rücktritt von Senator Stein, da dieser auf dem Universitätssektor versagt habe und eine Gefahr für die Stadt darstelle. Stein wurde als heimlicher Mitläufer des SDS in den Reihen des Senats bezeichnet, er sei mitverantwortlich für die Unruhen. Der Berliner RCDS-Vorsitzende Hacke warf der CDU vor, den RCDS nicht ausreichend untersützt und sich der Diskussion an der Universität nicht gestellt zu haben.","CDU: Stein behindert die Senatsarbeit","","Parteitags-Delegierte einstimmig für Rücktritt","gvc",[1],4,[1],[1],2,"20","12"],["4318","1968-07-01","Senator Stein widerspricht der Kritik von der CDU und schließt einen Rücktritt aus. Zudem sei er nie im SDS bzw. seit dem Unvereinbarkeitsbeschluss von der SPD auch in keine ihm nahestehenden Organisationen gewesen, seine politische Überzeugung sei sehr weit vom SDS entfernt. Stien bezweifelt, dass der AStA der FU überhaupt an konstruktiver Mitarbeit interessiert ist.","Sehr weit vom SDS entfernt","","Interview mit Wissenschaftssenator Prof. Werner Stein","Hans-Erich Bilges",[1],4,[3],[5],1,"20","12"],["4319","1968-07-01","In einer Presseerklärung des AStA der TU Berlin werden die Bundestagsfraktionen aufgefordert, noch in dieser Legislaturperiode ein Ausbildungs-Förderungsgesetz zu verabschieden.","Studenten fordern Ausbildungsförderungsgesetz","","","",[4],4,[1],[2],2,"20","12"],["4320","1968-07-01","Stellungnahme der Studentenvertretung des Ostasiatischen Seminars zur Räumung desselben sowie zur Begründung von Rektor Harndt. Ein zweiter Lehrstuhl neben Prof. Eckardt sei keine Lösung, da die meisten westdeutschen Japanologen sich weigern würden, neben oder unter Prof. Eckardt zu lesen.","Zweiter Lehrstuhl ist keine Lösung","Aus Briefen an die Lokalredaktion","","Studentenvertretung des Ostasiatischen Seminars",[1],4,[6],[2],2,"20","13"],["4321","1968-07-02","Eine Veranstaltung des RCDS mit Innenminister Benda in der Kölner Universität endete in Handgreiflichkeiten zwischen Studenten, SDS-Anhänger warfen mit Farbe, Eiern und Tomaten. Sprechchöre \"Benda raus\" und \"SDS raus\". Die Diskussion sei von seiten der Studenten polemisch geführt worden, Benda ging insbesondere auf die Auflagebschränkungen für Zeitungen ein, er hält diese für falsch. Bendas Abfahrt wurde verhindert, ein Hakenkreuztuch an seinem Mercedes angebracht.","\"Diskussion\" mit Eiern, Farbbeuteln und Tomaten","Studenten","Wirbel um Benda in der Kölner Universität","Kr./pt.",[1],4,[1],[5],1,"20","3"],["4322","1968-07-02","Der Regierende Bürgermeister Schütz entgegnet der Kritik der Berliner CDU an Senator Stein, er sieht keine Notwendigkeit, den Senat umzubilden. Die Unruhen an der FU Berlin seien keine Erscheinung der Berliner Bildungspolitik. Stein soll auch in der SPD umstritten sein, insbesondere beim linken Flügel. Einigkeit im Abgeordnetenhaus, dass es den demonstrierenden Studenten nicht um Reformen und Mitarbeit ginge.","\"Kein Anlaß zur Senats-Umbildung\"","","Schütz greift in hochschulpolitische Auseinandersetzungen ein","v.C./Bi.",[1],4,[1],[3],1,"20","4"],["4323","1968-07-02","Am Berlin-Kolleg wird weiter gestreikt. Man wolle über den erarbeiteten Reform-Plan und den Instituts-Ordnungs-Entwurf diskutieren, zudem fordert man die Versetzung einer Lehrkraft, der man \"autoritäre und rückständige\" Lehrweise vorwirft.","Schüler des Berlin-Kollegs streiken","","Bis zum Ferienbeginn keine Beteiligung am Unterricht","",[4],4,[1],[2],2,"20","13"],["4324","1968-07-02","Fritz Teufel und ein weiterer Angeklagter gestanden in einer Berufungsverhandlung, während einer Urteilsverkündung Knallkörper geworfen zu haben. Beide forderten trotzdem einen Freispruch.","Knallkörper-Werfer gestehen","","","",[5],4,[1],[2],2,"20","13"],["4325","1968-07-02","Drei Vertreter des SDS wurden vor dem Ausschuß für Wissenschaft und Kunst des Berliner Abgeordnetenhauses zum geplanten Universitätsgesetz gehört. Sie hätten wiederholt versucht, die Anhörung zu einer politischen Diskussion über die aktuelle Lage an der FU Berlin umzupolen. Die revolutionären Wünsche der Studenten müssten maßgebend für die Hochschulgesetzgebung sein. Die SDS-Studenten brachen die Befragung ab, als der Ausschussvorsitzende Löffler ihnen vorwarf, am eigentlichen Zweck der Anhörung Desinteresse zu zeigen. Auch ein RCDS-Vertreter wurde vom Ausschuss gehört.","Heftige Kontroversen beim Hearing","","SDS-Studenten wollten Anhörung \"umfunktionalisieren\"","eb",[4],4,[1],[2],2,"20","14"],["4326","1968-07-03","Rektor Harndt von der FU Berlin habe nach abermaliger Besetzung des Ostasiatischen Seminars die Erfüllung mehrerer Forderungen der Studenten zugesichert, worauf diese die Besetzung abbrachen. Eine Vollversammlung des Otto-Suhr-Instituts beschloss, die vom Akademischen Senat abgelehnte Reformsatzung ohne Veränderungen erneut dem Senat zuzuleiten.","FU-Rektor einigt sich mit Studenten","","Über Ostasiatisches Seminar","Bi.",[1],4,[1],[2],2,"22","5"],["4327","1968-07-03","Der Dutschke-Attentäter Josef Bachmann wurde zum Tathergang vernommen.","Bachmann erklärte Tathergang","","","",[2],4,[1],[2],1,"22","13"],["4328","1968-07-03","Auf der Rückseite der neuesten Ausgabe des \"FU-Spiegels\" sei eine Fotomontage der AStA-Vorsitzenden Fronius abgebildet, wie sie Rektor Harndt ihren entblößten Po zukehrt, versehen mit dem Spruch \"Salut der AStA-Vorsitzenden\". Fronius erklärte, sie habe davon nichts gewußt, sei aber gegen eine Beschlagnahmung der Ausgabe. Scharfe Kritik vom Verfasser des Artikels, dies lasse einmal mehr auf die geistige Verfassung der Herausgeber des FU-Spiegels schließen.","Kritisch betrachtet","","","au",[1],4,[1],[2],2,"22","14"],["4329","1968-07-04","Die Bundesregierung empfiehlt den Bundesländern, die Ausbildung an den Ingenieurschulen und den höheren Fachschulen der Regelung innerhalb der EWG anzupassen.","\"Ingenieurstudium der EWG anpassen\"","","Empfehlung der Bundesregierung","ems.",[4],4,[1],[2],2,"20","1,3"],["4330","1968-07-04","Unterschiedliche Auffassungen der Bundestagsfraktionen über ein Ausbildungsförderungsgesetz. Einig ist man sich in der Ablehnung der Forderung des VdS nach einer familienunabhängigen Ausbildungsordnung, die ein Studienhonorar zur Folge hätte.","Ein Studienhonorar wollen die Parteien nicht zahlen","Ausbildungsförderung","Harte Kontroversen im Bundestag zu erwarten","ems.",[4],4,[1],[1],2,"20","5"],["4331","1968-07-04","Stellungnahme von Prof. Dr. Thielicke zum Vorwurf, er habe seinen Gottesdienst Anfang Januar 1968 von der Bundeswehr beschützen lassen. Dies sei falsch, er habe sie nicht gerufen, lediglich aus Sorge um den Ablauf einen Ordnungsschutz zusammengestellt, hierzu hätte er privat auch einen Brigadegeneral gefragt, der seinerseits wieder einige Offiziere ansprechen wollte. Der Ordnerschutz hätte im übrigen sehr gut funktioniert und die versuchten Störungen immer wieder im Keim erstickt, ohne dass es zu irgendwelchen Handgreiflichkeiten kommen musste.","Thielicke rief kein Militär zur Hilfe","Aus Briefen an die Redaktion","","Prof. Dr. Helmut Thielicke",[1],4,[6],[1],1,"20","13"],["4332","1968-07-05","Der \"Bildungsnotstand\" wird als Desaster bezeichnet, schwere Kritik an den Bundesländern und Universitäten, dass sie nicht zu einer einheitlichen Bildungsreform in der Lage sind, der Föderalismus müsse für dringend notwendige Reformen überwunden werden","Sehend ins Chaos","","Das Desaster unserer Bildungspolitik. Uneinsichtiger Föderalismus. Viele Plätze, aber kein Plan","Bernd Nellessen",[4],4,[5],[2],2,"24","2"],["4333","1968-07-05","Streik der Studenten der Pädagogischen Hochschule Bonn, um auf den \"katastrophalen Lehrkräftemangel\" aufmerksam zu machen. Dies sei die letzte Stufe der Eskalation, nachdem alle ruhigen Forderungen nicht gehört wurden, bzw. an der Situation nichts geändert wurde.","Den Studenten reißt der Geduldsfaden","Nordrhein-Westfalen","Dauerstreik an der Pädagogischen Hochschule in Bonn","ems.",[1],4,[1],[2],2,"24","5"],["4334","1968-07-05","Tumulte bei der Rektoratswahl an der Universität Hamburg, Studenten wollten die Öffentlichkeit der Wahl erzwingen, besetzten den Sitzungssaal, die Polizei wurde gerufen. Zur Wahl kam es nicht, da nach der Freigabe des Raumes die Studentenvertreter aus Protest die Sitzung verließen und man so nicht mehr beschlussfähig war.","Tumulte vor der Wahl des Rektors","","In der Universität Hamburg","bh.",[1],4,[1],[2],2,"24","5"],["4335","1968-07-05","Prof. Richard Löwenthal verlässt die FU Berlin in Richtung Stanford, die Frage wird gestellt, warum, Löwenthal sei es immer um den Ausgleich der Kontrahenten und um die Uni gegangen, wurde von allen Seiten geschätzt. Vager Vergleich mit seiner Emigration 1933 wegen der Machtübernahme Hitlers wird unternommen.","Warum verläßt Richard Löwenthal die Freie Universität Berlin?","","Der Ostblock-Kenner geht in die USA","Hans-Erich Bilges",[1],4,[1],[3],2,"24","5"],["4336","1968-07-05","Kritik am Entwurf eines Universitätsgesetzes des Hamburger Senats, sowohl von Studenten als auch vom Rektor und den Professoren der Uni Hamburg. Der Entwurf der oppositionellen CDU habe unter den Studenten mehr Zustimmung gefunden.","Hamburgs Hochschulgesetz umstritten","","Podiumsdiskussion um Regierungsentwurf - Die CDU lehnt ab","bh.",[4],4,[1],[2],2,"24","10"],["4337","1968-07-05","Erstmals wurden bei der Rektoratswahl Studenten als Hörer sowie öffentliche Befragungen der Kandidaten zugelassen. Laut den Studentenvertretern habe sich der neue Rektor Prof. Scheuermann in jüngster Zeit als schärfster Gegner einer Liberalisierung des Disziplinarrechts gezeigt.","Studenten stellen Fragen bei Münchner Rektorwahl","","","di.",[4],4,[1],[2],2,"24","10"],["4338","1968-07-05","Maßnahmen des FU-Rektors in Bezug auf das Ostasiatische Seminar der FU Berlin, u.a. Entfernung von Prof. Eckardt von der kommissarischen Leitung der Sinologischen Abteilung.","Prof. Eckardt durch Prof. Bruhn ersetzt","","Dekan der Philosophischen Fakultät legt Pläne vor","dw",[4],4,[1],[2],2,"24","11"],["4339","1968-07-05","Scharfe Angriffe des ehemaligen RCDS-Vorsitzenden an der FU, Jürgen-Bernd Runge, gegen den RCDS. Dieser sei formaldemokratisch-konservativ und lethargisch, keine Alternative zur marxistischen Linken, die reine Negation des SDS.","Scharfe Angriffe gegen den RCDS","","","",[1],4,[1],[2],2,"24","11"],["4340","1968-07-05","Vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses wurden Vertreter des LSD und des Coburger Convents zum neuen Universitätsgesetz gehört. Vertreter des SHB erklärten sich lediglich solidarisch mit dem SDS und forderten eine erneute Anhörung des SDS.","Den Numerus Clausus lehnten alle ab","","Drei studentische Organisationen vor dem parlamentarischen Wissenschaftsausschuß","wt",[4],4,[1],[3],2,"24","11"],["4341","1968-07-06","Stoltenberg nimmt Stellung zu den Studentenunruhen, die Forderung nach Reformen sei zunächst berechtigt gewesen, nun seien sie teils umgesetzt bzw. würden sich die Bundesländer gegenseitig im Erlass von Reformen überbieten, trotzdem sei nun Enttäuschung bei den Studenten festzustellen. Dies läge vor allen an den Linksradikalen um den SDS, diese hätten den Kontakt zur politischen und sozialen Realität Deutschlands verloren, hätten jüngst viel Widerstand an den Universitäten erfahren. Kritik an einigen Hochschullehrern und Publizisten, die den SDS 1967 unterstützten, obwohl bereits damals dessen antiliberaler und antidemokratischer Charaker sichtbar wurde, sei Zeichen der Abneigung gegen das Bonner System. Antidemokratische Linke und Rechte würden sich zwar unterschiedlich definieren, jedoch beide gegen die aktuelle Staats- und Gesellschaftsordnung sein.","Nach der Ernüchterung: Zusammenarbeit","Gast der WELT","","Gerhard Stoltenberg",[1],4,[5],[2],1,"28","2"],["4342","1968-07-06","Die Ministerpräsidenten der Bundesländer haben eine Neuordnung des Ingenieurschulwesens und der Höheren Fachhochschulen als dringend erforderlich bezeichnet.","\"Reform der Ingenieurschulen dringend\"","Bildungspolitik","Ministerpräsidenten beauftragen eine Sonderkommission","ems.",[4],4,[1],[3],2,"28","4"],["4343","1968-07-06","Nach einem Antrag des Erlangener SDS solle sich künftig jeder qualifizierte Bürger um das Amt des Rektors an einer Hochschule bewerben können. Der Erlangener Rektor untersützt den Antrag.","Jeder Bürger soll Rektor werden","","Ein Antrag des SDS","di.",[4],4,[1],[2],2,"28","5"],["4344","1968-07-06","Nicht einmal die Hälfte der angehenden Medizinstudenten wird zum kommenden Semester das Studium auf Grund eines Platzmangels beginnen können.","Studienchancen der Mediziner verschlechtert","","","",[11],4,[1],[2],2,"28","5"],["4345","1968-07-06","Die SPD- und FDP-Abgeordneten des Ausschusses für Wissenschaft und Kultur des Berliner Abgeordnetenhauses empfehlen den Akademischen Senaten, noch vor Verabschiedung eines Universitätsgesetzes Reformmodelle zu erproben. Zudem befürworte man ein allgemeinpolitisches Mandat des AStA, sofern keine Zwangsmitgliedschaft mehr vorläge. Die CDU wendet sich gegen diese Empfehlung.","SPD und FDP für politisches Mandat","","","Bi.",[4],4,[1],[2],2,"28","5"],["4346","1968-07-08","Der LSD hat auf seiner Delegiertenkonferenz den Bruch mit der FDP überraschend abgewendet, das Potential der APO für die nächste Bundestagswahl sei noch zu klein. Die FDP unterstützt den LSD jedoch bereits seit der letzten Delegiertenversammlung nicht mehr finanziell und hat auch keinen Vertreter zur Versammlung geschickt.","Bruch mit der Partei vermieden","","Delegiertenversammlung des LSD","lh.",[4],4,[1],[2],2,"18","5"],["4347","1968-07-08","Der Verband der Studentenvertretungen Deutscher Ingenieurschulen begrüßt grundsätzlich den Beschluss der Ministerpräsidenten der Bundesländer zur Neuordnung des Ingenieurwesens, kritisiert aber auch, dass immer noch genügend Spielraum für sehr rückschrittliche Regelungen bleibe.","\"Ansätze für Reformschritte\"","","Ingenieurstudenten tagten","",[4],4,[1],[2],2,"18","5"],["4348","1968-07-09","Über die vorgeschlagene Reformsatzung des Otto-Suhr-Instituts, die gäbe zwar Anlass zur Kritik, müsse aber als Experiment verstanden werden, deshalb solle der Akademische Senat sie eher zulassen. Der Entwurf käme auch nicht aus einer linken Ecke. Man muss jedoch aufpassen, dass die neue Satzung nicht von einigen wenigen dazu missbraucht wird, eine Universität in der Universität zu etablieren. Die verantwortlichen Kreise hätten bei der großen Mehrheit der Studenten eine gute Chance, gehört zu werden.","Reformer an der FU fordern Mut zum Experiment","","Studenten müssen Mitverantwortung tragen - Neue Institutssatzung wieder vor dem Senat","Hans-Erich Bilges",[4],4,[1],[3],2,"22","2"],["4349","1968-07-09","Linksradikale Studenten hätten die Vorlesung des Frankfurter Literaturhistoriker Prof. Stern gestört, sie wollten die Vorlesung in eine Diskussion über die Abschaffung der Germanistik umfunktionieren.","Diskussion über Abschaffung der Germanistik gefordert","","","Nea.",[1],4,[1],[2],2,"22","3"],["4350","1968-07-09","Vorschläge der Jungen Union zur Hochschulreform, u.a. Einführung des Trimesters.","Junge Union empfiehlt das Trimester","","Vorschlag zur Hochschulreform: Amt für zentrale Bildungsplanung","H.A.",[4],4,[1],[2],2,"22","7"],["4351","1968-07-09","Selbstmordversuch des Dutschke-Attentäters Bachmann, indem er im Gefängnis einen abgebrochenen Löffelstiel verschluckte.","Bachmann unternahm erneut Selbstmordversuch","","","",[2],4,[1],[2],2,"22","11"],["4352","1968-07-09","Der Coburger Convent in Berlin teilt mit, dass er künftig die Zahlung der Zwangsgebühren für die studentische Selbstverwaltung verweigern wird, da die Studentenvertretungen nicht mehr die studentischen Interessen vertreten würde. Kritik vor allem an der Anmaßung des politischen Mandats, Deutschland wurde für Vietnam außer Acht gelassen. Man fordert die Abschaffung von AStA und Konvent. Die Universität der Zukunft müsse eine Leistungsuniversität werden","Coburger Convent verweigert Zahlung von AStA-Gebühren","","Demonstrativer Protest. Organisation in Hochschulgruppen","Bi.",[4],4,[1],[5],2,"22","11"],["4353","1968-07-10","Der Akademische Senat der FU Berlin hat erneut den Satzungsentwurf des Otto-Suhr-Instituts abgelehnt, woraufhin das Direktorium des OSI zurücktrat, und das Institut von etwa 150 Studenten besetzt wurde. Der Akademische Senat kritisierte, dass der Institutsrat nach der ersten Ablehnung nicht einmal den Versuch unternommen habe, einige Punkte an der Satzung zu ändern. Der RCDS sieht nach der Ablehnung nur noch die Möglichkeit einer \"studentischen Einheitsfront\" gegen den Akademischen Senat.","FU-Senat lehnt Satzung erneut ab","","OSI-Direktoren zurückgetreten","Bi.",[4],4,[1],[2],2,"22","1"],["4354","1968-07-10","Die acht baden-württembergischen Rektoren fordern die sofortige Einführung des Numerus Clausus in allen \"Massenfächern\" der Universitäten, um die Funktionsfähigkeit der Universitäten zu erhalten.","Rektoren fordern Numerus clausus","","Für \"Massenfächer\" an Hochschulen Baden-Württembergs","uhl.",[4],4,[1],[2],2,"22","1"],["4355","1968-07-10","Arthur Enk widerspricht der Meldung, wonach Studentenvertreter der TU und FU Berlin sowie der Kirchlichen Hochschulen erklärt hatten, Gewalt gegen Sachen sei die einzige mögliche Artikulation in einem kapitalistischen System. Er habe sich mit fünf Kirchlichen Hochschulen in Verbindung gesetzt, und keine hätte eine solche Erklärung verfasst noch würde sie gutheißen.","Keine Gewalt gegen \"Sachen\"","Aus Briefen an die Redaktion","","Arthur Enk",[1],4,[6],[2],1,"22","2"],["4356","1968-07-10","Am Beispiel des Weggangs von Prof. Löwenthal wird ein konsequentes Vorgehen gegen die Störungen an der FU Berlin gefordert.","Entscheidung an der FU","Aus Briefen an die Redaktion","","Siegfried Lehmann (Leser)",[1],4,[6],[2],2,"22","2"],["4357","1968-07-10","Bei einem Prozess gegen fünf Mitglieder der Kommune I und drei weiteren Anghörigen wegen eines Sit-ins im Berliner Abgeordnetenhaus wurden sechs der Angeklagten zu mehrtägigen Haftstrafen wegen ungebührlichen Verhaltens vor Gericht verurteilt. U.a. hatten sie auf den Richtertischen gesessen und mit den Richterbaretts jongliert sowie Akten durcheinander gebracht. Unter ihnen waren auch Langhans, Teufel und Kunzelmann, deren Prozess wurde vertagt. Die beiden nicht auffällig gewordenen Angeklagten wurden im Prozess zu drei bzw. zwei Monaten Gefängnis verurteilt.","Dann flog das Richterbarett durch den Saal","Kommune","Prozeß wurde zum Happening","",[5],4,[1],[5],1,"22","3"],["4358","1968-07-10","Ein Student der TU Berlin klagt mit Unterstützung der Humanistischen Union auf die Feststellung, dass der Polizeieinsatz am 13. April 1968 rechtswidrig gewesen sei. Der Kläger sei von der Polizei nach Verlassen der Demonstration zusammengeschlagen worden.","Student klagt in Berlin","","","",[1],4,[1],[2],2,"22","3"],["4359","1968-07-10","Die Wahl des neuen Rektors der Universität Hamburg soll im schwer erreichbaren Deutschen Elektronen-Synchroton stattfinden, damit es nicht wie bei der Wahlansetzung erneut zu Störungen durch Studenten kommt.","Rektorwahl im DESY","","","bh.",[4],4,[1],[2],2,"22","3"],["4360","1968-07-10","Die studentische Linke ist als Siegerin aus den Wahlen zum Studentenparlament der Universität Heidelberg hervorgegangen. Bei einer Wahlbeteiligung von 41,3 % erhielten sie mit 23 Plätzen wesentlich mehr als im vorherigen Parlament. Allein der SDS erhielt 11 Mandate. Die übrigen 30 Mitglieder gelten als unabhängig, wären jedoch links von der Mitte einzuordnen.","Linksruck in Heidelberg bei Studentenwahlen","","","Se.",[4],4,[1],[2],2,"22","3"],["4361","1968-07-10","In Schleswig-Holstein soll geprüft werden, ob den Ingenieurstudenten das Sommersemester auf Grund ihres Streiks überhaupt angerechnet werden kann.","Ingenieurschulen: Gilt das Semester?","","","H.A.",[4],4,[1],[2],2,"22","3"],["4362","1968-07-10","Die SPD im schleswig-holsteinischen Landtag wird ein öffentliches Anhörverfahren zum Hochschulgesetz beantragen. Man solle es auf den Versuch einer studentischen Mitwirkung in der Universitätsverwaltung ankommen lassen, so der Fraktionsvorsitzende Conrady. Eine Hinweis auf die Schwierigkeiten bei der Erarbeitung eines neuen Hochschulgesetzes sieht er in der Tatsache, dass der AStA der Kieler Universität bisher noch keinen eigenen Entwurf habe vorlegen können.","Studentische Mitwirkung soll erprobt werden","","","H.A.",[4],4,[1],[2],2,"22","3"],["4363","1968-07-10","Erneute Zurückweisung der Reformsatzung des Otto-Suhr-Instituts durch den Akademischen Senat der FU Berlin. Bedingungen des Senats für eine annehmbare Satzung. Prof. Schwan, Direktor des OSI, erklärte, mit der Entscheidung seien die Hoffnungen vieler, die FU könne sich aus sich selbst heraus reformieren, zerstört worden.","Mitsprache in der Forschung abgelehnt","Berlin","Professor Schwan: Die Hoffnungen vieler wurden zerstört","Bi.",[4],4,[1],[2],2,"22","3"],["4364","1968-07-10","Aus der Antrittsrede vom neuen Rektor der Bochumer Universität, Prof. Faillard. Dieser fordert u.a. die Rückkehr der Universität zur wissenschaftlichen Stätte.","Neuer Rektor mahnt zur Besinnung","Universität Bochum","Professor Faillard drängt auf intensivere Forschung","W.E.",[4],4,[1],[2],1,"22","3"],["4365","1968-07-10","Die \"Linksliberale Hochschulgruppe\" (LL) hat sich an der Freien Universität gebildet. Sie versteht sich als Alternative zur \"radikal-sozialistischen Ideologie\" des SDS und der \"verbalreformerischen Inhaltslosigkeit\" des RCDS (die Initiative zur Gründung ging von früheren RCDS-Mitgliedern um Jürgen-Bernd Runge aus).","\"LL\" konstituierte sich","","","",[4],4,[1],[2],2,"22","9"],["4366","1968-07-10","Ausführlich zu den bisherigen Selbstmordversuchen von Josef Bachmann. Dieser lebe in einer Art Sühnewahn, er habe bekannt, dass er den Prozess nicht durchstehen werde. Bachmann sei psychisch schwer krank, ein ernstzunehmender Selbstmordkandidat.","Josef Bachmann sitzt meistens teilnahmslos in der Zelle","","Attentäter Dutschkes lebt in einer Art Sühnewahn","Bi.",[2],4,[1],[1],2,"22","22"],["4367","1968-07-11","Ca. vierstündige Besetzung des FU-Rektorats durch Studenten. Es soll ein Schaden von etwa 30.000 DM entstanden sein. Anlass ist die erneute Zurückweisung des Satzungsentwurfs für das Otto-Suhr-Institut durch den Akademischen Senat. Die Polizei räumte das Rektorat, die Studenten hätten kaum Widerstand geleistet. Senator Stein erklärte auf die Frage, wie er die Krise an der Universität lösen wolle, er habe kein Patentrezept. Der Berlin-Beauftragte des Bundeskanzlers, Ernst Lemmer, erklärte, der Senat müsse jetzt Haltung zeigen.","FU-Rektorat von Studenten verwüstet","","Lemmer: Senat soll Haltung zeigen","Bi.",[1],4,[1],[2],2,"18","1"],["4368","1968-07-11","Prof. Löwenthal stellt klar, dass er entgegen anders lautender Berichte in der \"Welt\" die FU nicht grundsätzlich verlassen habe, sondern nur einen einjährigen Forschungsurlaub angetreten habe. Er zeigt sich verstimmt über die jüngsten Entwicklungen an der FU Berlin.","Nur ein Jahr Forschungsurlaub","Aus Briefen an die Redaktion","","Prof. Dr. Richard Löwenthal",[1],4,[6],[2],1,"18","2"],["4369","1968-07-11","Besetzung und Räumung des FU-Rektorats. Es sei zu heftigen Auseinandersetzungen zwischen Studenten und der Polizei gekommen, mehrere Festnahmen. Akten, Zigarren und Kekse seien geklaut worden. Ernst Lemmer besichtigte das Rektorat, er zeigte sich bestürzt über das Ausmaß der Schäden und forderte den Senat auf, endlich dem ungesetzlichen Treiben ein Ende zu bereiten. Berlins Regierender Bürgermeister Schütz wurde mit Sand beworfen und bespuckt. Eine Personalversammlung der Arbeiter, Angestellten und Beamten begrüßte den Satzungsentwurf für das OSI und kritisierte die Zurückweisung durch den Akademischen Senat. Die Philosophische Fakultät erklärte sich dagegen solidarisch mit der Zurückweisung, der Satzungsentwurf setze die Grundlagen der Universität wie Freiheit von Lehre und Forschung aufs Spiel und leiste antidemokratischen Kräfte vorschub. An der TU Berlin erklärte Prof. Weichselberger seinen Verzicht auf die Übernahme eines Postens der akadamischen Selbstverwaltung.","Barrikaden vor dem Rektorat der FU","Berlin","Schütz und Neubauer diskutieren mit Studenten - Regierender Bürgermeister bespuckt","Bi.",[1],4,[1],[2],2,"18","2"],["4370","1968-07-11","150-Jahr-Feier der Universität Bonn, dabei werde auf zuviel Tradition verzichtet, so bspw. auf das Tragen der Talare. Trotzdem Gegenveranstaltungen und -veröffentlichungen von studentischer Seite.","Von Talaren ist zum Jubiläum der Alma mater nicht die Rede","Universität Bonn","Trotzdem Gegenprogramm der Studenten","Eberhard Nitschke",[1],4,[1],[1],1,"18","3"],["4371","1968-07-11","Der Rektor der Kieler Universität spricht sich gegen den Vorschlag der Jungen Union aus, künftig Trimester an den Hochschulen einzuführen,","\"Universität ist kein gehobenes Gymnasium\"","","Erklärung des Kieler Rektors","H.A.",[4],4,[1],[2],2,"18","5"],["4372","1968-07-11","Bei den Wahlen zum Kölner Studentenparlament haben die linksgerichteten Studenten ihre Mehrheit verloren, stattdessen haben die Kölner Studenten-Union und der RCDS eine deutlicher Mehrheit.","Die Linke verliert Mehrheit bei Kölner Studentenwahlen","","","W. E.",[4],4,[1],[2],2,"18","5"],["4373","1968-07-11","Die FU Berlin wurde gerichtlich dazu verurteilt, die schlagende Verbindung \"Corps Lusatia-Leipzig zu Berlin\" als studentische Vereinigung an der Uni zuzulassen. Erwartet wird, dass dieses Urteil Vorbildcharakter für weitere Verbindungen hat.","Erfolg der schlagenden Verbindungen","","Freie Universität zur Anerkennung des Corps Lusatia als förderungswürdige Vereinigung verurteilt","fa",[4],4,[1],[2],2,"18","12"],["4374","1968-07-12","Forderung nach einem nationalen Bildungsplan, nach einheitlicher Hochschulreform. Kritik am bestehenden föderalen Bildungssystem.","Bildungsplan","Zum Tage","","W.G.",[4],4,[1],[2],2,"16","2"],["4375","1968-07-12","Horst Mahler wurde wegen \"Interessenskollision\" von der Verteidigung dreier Demonstranten ausgeschlossen, da er unter dem Verdacht stehe, als Anstifter der den Angeklagten zur Last gelegten strafbaren Handlungen tätig gewesen zu sein.","Mahler der Anstiftung verdächtig","Kurz berichtet","","fa",[1],4,[1],[2],2,"16","3"],["4376","1968-07-12","Professor Marcuse ist mit unbekannten Ziel aus seinem Haus geflohen, nachdem er postalische Morddrohungen erhalten hatte.","Professor Marcuse verschwunden","Kurz berichtet","","",[9],4,[1],[2],2,"16","3"],["4377","1968-07-12","Im Berliner Abgeordnetenhaus wurden der Schlußbericht des parlamentarischen Untersuchungsausschusses über die Studentenunruhenund die Hochschulreformen behandelt. Ua. Wird ein allgemein-politisches mandat bei gleichzeitiger studentischer Zangsmitgliedschaft ausgeschlossen. Positiv wird das politische Engagement vieler Studenten gewürdigt. Scharfe Kritik am SDS, der mißachte die Spielregeln der Demokratie, die Selbstisolierung der \"Extremisten\" hätte bereits begonnen. Kritik auch von der CDU an der Ablehnung des Reformmodells für das OSI durch den Akademischen Senat. Nach der Solidarisierung der Philosophischen Fakultät mit der Entschediung des Akademischen Senats haben die Professoren Schwan und Sontheimer aus Protest ihre Ämter niedergelegt.","Grundsatzerklärungen über Studentenunruhen","Berlin","Abgeordnetenhaus beschließt Durchsicht der staatlichen Prüfungsordnungen","v.C./Bi.",[1],4,[1],[1],2,"16","3"],["4378","1968-07-12","Die evangelischen Studentengemeinden in West-Berlin, der AStA der Pädagogischen Hochschule, der FU und der kirchlichen Hochschule veranstalten einen Autocorso für Biafra.","Demonstration mit Autos gegen Krieg in Biafra","","","",[1],4,[1],[2],2,"16","10"],["4379","1968-07-13","Das Rektorat der Uni Würzburg hat die Universität wegen Studentenunruhen geschlossen. Etwa 300 Studenten hatten eine Sitzung des Großen Senats über eine neue Satzung der Uni gestört, der AStA hatte zu zweitägigen Vorlesungsstreiks aufgerufen, weil der Satzungsentwurf zu wenig studentische Mitbestimmung vorsehe.","Studenten fordern Wiedereröffnung","","Aber die Universität Würzburg bleibt zunächst geschlossen","pff",[1],4,[1],[2],2,"26","1"],["4380","1968-07-13","Kritik an der Zerstörung von Rektorat und Instituten, da ginge es nicht um Studienreform, das sei nur studentischer Pöbel, der auch immer Pöbel bleiben werde.","Pöbel an der FU","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"26","2"],["4381","1968-07-13","Über die erstmalige Schließung einer Universität in Deutschland (Uni Würzburg). Gegen die Kritik der Würzburger Studenten, dass in der diskutierten Satzung nicht genügend studentische Mitbestimmung vorgesehen sei..","Würzburg","Zum Tage","","gaz.",[1],4,[5],[2],2,"26","2"],["4382","1968-07-13","Der SDS trifft sich zu einem grundlagentheoretischen Arbeitsseminar und einem marxistischen Schulungsseminar. Das Schwergewicht liege auf der \"Reflexion der Massenaktionen seit Ostern\". ","SDS-Klausur im Odenwald","Kurz berichtet","","",[8],4,[1],[2],2,"26","3"],["4383","1968-07-13","Etwa 150 Demonstranten beteiligten sich an einem Autocorso für Biafra, anschließend wurde dem britischen Generalkonsul eine Petition überreicht, in der die sofortige Einstellung der Kampfhandlungen zwischen Nigeria und Biafra gefordert wird.","Jugend-Demonstration für \"Frieden in Biafra\"","","","",[1],4,[1],[2],2,"26","3"],["4384","1968-07-13","Über die Schließung der Uni Würzburg und die vorherigen Störung der Sitzung des Großen Senats. Professoren und AStA seien geschockt über die Vorfälle, von Seiten der Professoren wird der Verdacht geäußert, dass eigens angereiste Frankfurter Studenten für die Unruhen verantwortlich seien. Die Uni Würzburg galt vorher als ausgesprochen ruhig, der AStA gilt als gemäßigt. Sein Streikaufruf wegen der umstrittenen neuen Satzung der Uni hatte die Proteste mit ausgelöst, er distanzierte sich von der Störung.","Im geruhsamen Würzburg ein \"Go-in\" der Studenten","Bayern","Die Sitzung des Großen Senats wurde gesprengt","Rüdiger Dilloo",[1],4,[1],[5],2,"26","3"],["4385","1968-07-13","Professor Marcuse will trotz der Morddrohungen gegen seine Person seine Lehrtätigkeit an der Universität in San Diego fortsetzen.  In einem Brief, wahrscheinlich vom Ku-Klux-Klan, wurde er als \"dreckiges Kommunistenschwein\" bezeichnet und aufgefordert, innerhalb der nächsten 72 Stunden die USA zu verlassen.","Marcuse: Ich lasse mich nicht einschüchtern","","","",[9],4,[1],[2],2,"26","5"],["4386","1968-07-13","Kritik an dem Vorhaben des Berliner Senats, die Reformsatzung des OSI zuzulassen, dies würde nur dem \"prokommunistischen\" SDS nützen und zu einer mit Steuergeldern finanzierten \"Parteihochschule der SED in West-Berlin\" führen.","Otto-Suhr-Institut","Leserbriefe","","Leser",[4],4,[6],[2],2,"26","7"],["4387","1968-07-13","Korrespondenz zwischen Pfarrer Horst Bannach und Axel Springer. Bannach hatte Springer in einem früheren Brief vorgeworfen, dass seine Zeitungen eine Mitverantwortung an den Osterunruhen hätten. Im neuerlichen Brief kritisiert Bannach die zu starke Macht des Verlegers und die Überschriften der BILD-Zeitung, welche die Studenten der Bevölkerung verhasst gemacht hätten.","Die Demokratie ist wert, verteidigt zu werden","Aus Briefen an die Redaktion","","Horst Bannach",[1],4,[6],[1],2,"26","7"],["4388","1968-07-13","Antwort Springers auf den jüngsten Brief von Pfarrer Bannach,weist den Brief als Polemik zurück, insbesondere auch den Vorwurf, seine Blätter hätten die Studenten der Bevölkerung verhasst gemacht. Seine Zeitungen würden seit 13 Jahren auf die Probleme der Hochschulreform aufmerksam machen. Verteidigt die \"Steigerung der Sprache\" einiger seiner Zeitungen nach den radikalen Aktionen einiger Studenten, man wolle nicht zulassen, dass aus der Bundesrepublik ein zweites Vietnam werde.","\"Die Probe aufs demokratische Exempel...\"","","","Axel Springer",[1],4,[6],[2],2,"26","7"],["4389","1968-07-15","Die FU Berlin habe sich dazu entschlossen, dass ihre Studenten künftig keinen Pflichtbeitrag für die studentische Selbstverwaltung zahlen müsse, dieser werde ein freiwilliger Beitrag, wenn man die Politik des AStA unterstütze.","FU streicht Pflichtbeitrag für AStA","","Vom Wintersemester an nur noch freiwillige Zahlungen","Bi.",[4],4,[1],[2],2,"18","1"],["4390","1968-07-15","Hessische SPD-Politiker besuchen Diskussionsveranstaltungen in den Universitäten, Bericht über die Veranstaltung in der Technischen Hochschule Darmstadt.","Ein Student in blauem Freizeithemd verwirrt acht Herren von der SPD","Hessen","Politiker stellen sich zur Diskussion","",[1],4,[1],[1],2,"18","3"],["4391","1968-07-15","Der neue Rektor der TU Berlin ist Prof. Wever. Erstmals waren auch Studentenvertreter und Assistenten an der Wahl beteiligt. Die Wahl Wevers wird begrüßt, er sei reformfreudig, aber ein entschiedener Gegner radikaler studentischer Bestrebungen, war Mitunterzeichner des Marburger Manifests.","Professor Hans Wever neuer Rektor der TU","","","Bi.",[4],4,[1],[2],2,"18","3"],["4392","1968-07-15","Die FU Berlin würde bei Berufungen von Professoren auf zunehmende Schwierigkeiten stoßen, ein Grund seien die Studentenunruhen. Mehrere Professoren verlassen deshalb auch die Uni. Ein weiterer Grund seien aber auch die finanziellen Forderungen.","Warum eine Berufung nach Berlin häufig scheitert","Freie Universität","Professoren stellen härtere Forderungen","Bi.",[4],4,[1],[5],2,"18","3"],["4393","1968-07-15","Das Hauptportal der Universität Würzburg wurde von Studenten zertrümmert, es sei ein Schaden von mindestens 8.000 DM entstanden.","Schaden in Würzburg: mindestens 8000 DM","","","",[1],4,[1],[2],2,"18","5"],["4394","1968-07-15","Streit der Studenten in Tübingen über die Mitarbeit im Ausschuss für eine neue Grundordnung der Universität. RCDS und der Hochschulring Tübinger Studenten wollen mitarbeiten, SDS und die übrigen Verbände der Linken lehnen dies als Verrat ab. Störungen des Ausschusses.","Mitarbeit bezeichnen die \"Linken\" als Verrat","Studenten","Streit in Tübingen über neue Grundordnung","Rg.",[4],4,[1],[5],2,"18","5"],["4395","1968-07-16","Der AStA der FU Berlin kritisiert die Entscheidung der FU, die Pflichtbeiträge für die studentische Selbstverwaltung solange auszusetzen, wie ein Gericht über die Rechtmäßigkeit der Zwangszahlung entschieden hat. Nur etwa 60 Prozent hätten nach der Entscheidung die AStA-Gebühren gezahlt, erwartet wird gar ein Rückgang auf 30 Prozent.","Studenten verlangen ihr Geld zurück","","Neuer Streit in Berlin: AStA der FU beharrt auf Pflichtbeiträgen","Bi.",[4],4,[1],[2],2,"22","1,3"],["4396","1968-07-16","Die Schuldigen der Sachbeschädigungen bei den Besetzungen in der FU Berlin sollten mit empfindlichen Geldstrafen belegt werden, welche für die Bedürftigen in Biafra gespendet werden könnten.","Strafgeld für Biafra","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["4397","1968-07-16","Die Universität Würzburg wurde wieder geöffnet, die Professoren haben teilweise Polizeischutz erhalten.","Würzburg: Polizei schützt Professoren","","","di.",[1],4,[1],[2],2,"22","3"],["4398","1968-07-16","Der niedersächsische Kultusminister Langeheine erklärt die Pflichtbeiträge für die studentische Selbstverwaltung auch dann für verbindlich, wenn die Studentenvertretung Rechtsbrüche begehe. Da der AStA kein politisches Mandat habe, könne die Studentenschaft die Zahlung auch nicht mit Begründung anderer politischer Auffassungen verweigern. An der Uni Göttingen haben bereits mehrere Studenten die Zahlung verweigert., an den meisten anderen Unis ist dies nicht der Fall, in München wird dies zumindest diskutiert.","Langeheine warnt vor Selbstjustiz","Studentenausschüsse","Mißbrauch des Mandats befreit nicht von Zahlung der AStA-Beiträge","P.W.",[4],4,[1],[1],2,"22","3"],["4399","1968-07-16","Vorschläge des Hochschulpolitischen Arbeitskreises des Coburger Convents in Berlin, u.a. gegen Drittelparität und für Auflösung von AStA und Studentenparlament, aber auch der weiteren Personalorgane durch Schaffung eines gemeinsamen Organs mit Vertretern aller Schichten der Mitglieder. Für eine Neugliederung der Universität, gegen das politische Mandat der Studentenschaft. Straffällige Studenten sollen nach Verbüßung der Strafe an der Uni bleiben dürfen. Das Otto-Suhr-Institut will die vom Akademischen Senat abgelehnte Satzung zum Wintersemester ausführen.","Neue Vorschläge des Coburger Convents","","Verurteilte Studenten sollen an der Universität bleiben","wt",[4],4,[1],[2],2,"22","11"],["4400","1968-07-16","Drei Studenten des Ostasiatischen Seminars der FU Berlin kritisieren scharf die Besetzung des Seminars, dies hätte ihnen ein Semester gekostet. Zudem werden die Besetzer der wiederholten Lüge bezichtigt, sie hätten durchaus von den Reformplänen des Seminars schon vor der Besetzung gewusst.","Besatzer haben ein Semester verdorben","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[5],2,"22","12"],["4401","1968-07-17","Der RCDS will versuchen, zusammen mit der Deutschen Studentenunion (DSU) die Mehrheit der politisch links stehenden Studentengruppen an den Universitäten zu brechen.","RCDS will Linksgruppen verdrängen","","Koalition mit der Deutschen Studentenunion","W. E.",[4],4,[1],[2],2,"18","1"],["4402","1968-07-17","Dem nun abgelaufenen Sommersemester würde keiner eine Träne nachweinen: Die revolutionären Studenten nicht, weil ihre Aktionen nicht den gewünschten Erfolg gebracht hätten, und die Professoren nicht, weil ihre Ruhe und hohe Stellung an der Universität nun endgültig vorbei ist. Die Fronten seien verhärtet, dies sei genauso ungünstig für Reformen wie die Fülle an verschiedenen Empfehlungen. Eine umfassende Reform sei jedoch dringend notwendig. Lehr- und Lernfreiheit muss verteidigt werden, allerdings könne Lehrfreiheit auch zu einem Mittel der Repression werden, dies müsse man verhindern.","Ende eines Semesters","","Noch unversöhnte Fronten. Zwischen Lehr- und Lernfreiheit. Gesamtreform ist notwendig.","Günter Zehm",[1],4,[5],[1],2,"18","2"],["4403","1968-07-17","Der AStA der FU Berlin hat klargestellt, dass nach der jüngsten Entscheidung der FU momentan der gesamte Beitrag für die studentische Selbstverwaltung freiwillig sei, nicht nur der für die politische Arbeit.","Gesamter AStA-Beitrag in Berlin freiwillig","","","",[4],4,[1],[2],2,"18","3"],["4404","1968-07-17","Der Hamburger Senat fordert für die durch die Osterunruhen entstandenen Schäden Schadensersatz von vermeintlichen Rädelsführern. Auch in Tübingen wird wegen der Schäden während der Besetzung von Räumen des Luftschutzhilfsdienstes ähnliches erwogen","Hamburger Senat fordert Schadensersatz","","","",[1],4,[1],[2],1,"18","3"],["4405","1968-07-17","Prof. Ritter hat einen Ruf an die FU Berlin abgeleht. Er begründet dies mit den Unruhen an der FU, eine wirkliche fruchtbare Lehrtätigkeit sei so nicht möglich. Die FU Berlin will zivilrechtlich gegen die Studenten der Besetzung des Rektorats vorgehen. Der AStA der FU hat beim Rektor angefragt, ob die Universität bereit sei, den vollen Beitrag für die studentische Selbstverwaltung zu zahlen. Bisher haben sich 289 von 596  Studenten geweigert, den Beitrag zu zahlen.","Professor Ritter lehnt Ruf an FU ab","Berlin","Zweifel an Möglichkeit zu fruchtbarer Lehrtätigkeit","Bi.",[4],4,[1],[2],2,"18","3"],["4406","1968-07-17","Der Bundesvorsitzende des RCDS, Simon, kritisiert die Hochschulpolitik des RCDS. Simon befürwortet übergangsweise Ad-hoc-Maßnahmen von Professoren und Satzungen für Insitute, für eine paritätische Zusammensetzung der Institutsräte. Der SDS werde seiner Meinung nach weitere Besetzungen vornehmen und versuchen, die Studentenparlamente mittels Berufung auf die plebiszitäre Komponente lahmzulegen. Maximen des RCDS, u.a. Nähe zur CDU, man möchte aber keineswegs eine Unterorganisation der Partei sein. Die innerparteiliche Demokratie in der CDU müsse gestärkt werden. Grund für die Krise sei das Versagen der politischen Bildung, dadurch hätten viele ein zu idealistisches oder utopisches Bild von der Demokratie.","Der RCDS will neue Formen der studentischen Auseinandersetzung finden","Hochschulpolitik","Bundesvorsitzender Simon kritisiert CDU","Werner Erdmann",[4],4,[1],[2],1,"18","3"],["4407","1968-07-17","Gegen Dieter Kunzelmann und Rainer Langhans wurde Anklage wegen Beleidigung des Regierenden Bürgermeisters erhoben. Beide hatten in einem Leserbrief im \"FU-Spiegel\" behauptet, Schütz hätte seinen rechten Arm im Krieg wegen Feigheit vor dem Feinde verloren.","Anklage wegen Beleidigung des Regierenden Bürgermeisters","","","",[5],4,[1],[2],2,"18","9"],["4408","1968-07-18","Rückblick auf das Sommersemester 1968, die Unruhen seien noch nicht beendet. Sehr kritisch zu den Besetzungen und Aktionen an der FU Berlin. Der revolutionäre Elan würde jedoch abbröckeln. Schwere Kritik an Senator Stein für seine Politik/Reaktionen. Immer mehr Studenten würden sich gegen extremistische Aktionen und für wirkliche Reformen engagieren. Über die Ablehnung des Reformentwurfs des OSI durch den Akademischen Senat, einiges spreche für, einiges gegen den Entwurf. Die Reaktionen auf die zweite Ablehnung hätten jedoch gezeigt, dass der Gedanke an studentische Mitbestimmung nicht \"seriös\" sei. Walden hofft auf einen Neubeginn im Wintersemester, sieht aber noch nicht das passende Rezept dafür. Walden spricht von den studentischen Einpeitscher des SDS und dem \"Hinterhofnarr\" Teufel.","Es fehlt an Therapien für die FU Berlin","","Aber mehr Studenten als vor einem halben Jahr wollen wirklich studieren","Matthias Walden",[1],4,[5],[5],2,"18","2"],["4409","1968-07-18","Studenten der Universität Würzburg haben mittels eines Sarges die freiheitliche Universität zu Grabe getragen. Anlass ist die neue Satzung der Uni.","Studenten mit Sarg","","","",[1],4,[1],[2],2,"18","3"],["4410","1968-07-18","Nach der Philosophischen Fakultät haben auch die Medizinische und die Mathematisch-Naturwissenschaftliche Fakultät den Satzungsentwurf des Otto-Suhr-Insitutes abgelehnt. Diese betreibe eine \"Gleichschaltung des Lehr- und Forschungsbetriebes im Sinne einer bestimmten Ideologie\".","Drei FU-Fakultäten gegen neue OSI-Satzung","","","",[4],4,[1],[2],2,"18","3"],["4411","1968-07-18","Ausführlich über das von den Studentenvertretungen geforderte allgemein-politische Mandat. Die Universität stehe durch die Verweigerung der Zahlungen des Pflichtbeitrages zur studentischen Selbstverwaltung an der FU nun am Scheideweg, da der AStA entweder zugeben müsste, dass er ein solches Mandat nicht habe, um Anspruch auf das Geld zu haben, oder aus der Organisation der Universität austreten müsste, damit es keine Zwangsmitgliedschaft der Studenten mehr gäbe.","Die Universität - nur noch eine Gelehrtenrepublik?","Hochschule am Scheideweg","\"Irrweg öffentlicher Zwangskorporation\" - Aber Studentensyndikat zerstört Gemeinschaft mit den Professoren","Paul Lersch",[11],4,[1],[3],2,"18","3"],["4412","1968-07-18","Der AStA der FU Berlin fordert, dass die fehlenden Beiträge für die studentische Selbstverwaltung durch öffentliche Mittel ausgeglichen werde, alles andere wäre eine \"weitere soziale Unterprivilegierung der Studentenschaft\",","Selbstverwaltung soll vom Staat finanziert werden","Diskussion um das studentische Mandat","Forderung des FU-AStA","Bi.",[4],4,[1],[2],2,"18","3"],["4413","1968-07-18","Der Bonner Student Uwe Schramm hat einen Vollstreckungsbeschluss gegen den Bonner AStA erwirkt. Danach wird diesem ein Zwangsgeld in Höhe von 500 DM angedroht, sollte er eine politische Forderung oder eine politische Stellungnahme abgeben. Das politische Mandat der Studentenschaft wird in der Begründung des Urteils eindrücklich verneint. Kritik in der Begründung am Rektor, dieser hätte gegen die wiederholten politischen Äußerungen bereits einschreiten müssen.","In der Tasche Uwe Schramms tickt eine Zeitbombe gegen den Bonner AStA","Diskussion um das studentische Mandat","Bei politischen Äußerungen drohen 500 DM Zwangsgeld","ems.",[11],4,[1],[1],2,"18","3"],["4414","1968-07-19","Senator Stein hat sich für die Umsetzung des Satzungsentwurfs des Otto-Suhr-Instituts ausgesprochen, aber gegen ein politisches Mandat.","Senator Stein spricht sich für Experimente aus","","Interview mit der WELT","Bi.",[4],4,[1],[2],2,"18","1"],["4415","1968-07-19","Senator Stein nimmt Stellung zum Pflichtbeitrag für die studentische Selbstverwaltung. Er sit gegen das politische Mandat einer Zwangsmitgliedschaft. Disziplinarverfahren gegen Studenten sollten nur noch auf Delikte innerhalb der Universität angewandt werden. Die meisten Einstellungsverhandlungen mit Professoren seien an der FU nach wie vor erfolgreich. Stein plädiert für die Erprobung des Satzungsentwurfs des OSI, auch wenn er teils Bedenken gegen den Inhalt hat.","\"Das Nein ist hörbarer als das Ja\"","WELT-Interview mit Senator Stein","Die Professoren sollen sagen, welche Reformen möglich sind","Hans Erich Bilges",[4],4,[3],[1],1,"18","6"],["4416","1968-07-20","Vier Mitarbeiter der Bundesgeschäftstelle des VdS kündigen, weil sie nicht mit den politischen Aktivitäten des VdS-Vorsitzenden Ehmann übereinstimmen.","VDS-Referenten kündigen","","","ems.",[4],4,[1],[2],2,"26","5"],["4417","1968-07-20","Bericht und Statistik über die Zuschüsse der Bundesländer für ihre Universitäten.","Eines der reichsten Länder zahlt am wenigsten für die Hochschule","Bildungspolitik","Leistungsgefälle zwischen Hamburg und Berlin","bh.",[4],4,[1],[5],2,"26","5"],["4418","1968-07-22","Plädoyer für die studentische Selbstverwaltung, diese habe sich über die Jahre sehr bewährt. Nur weil einige \"ideologische Fanatiker\" diese mißbrauchen, sollte man nicht gleich über ihre Abschaffung nachdenken.","Selbstverwaltung hat sich bewährt","Aus Briefen an die Redaktion","","Leser",[4],4,[1],[3],2,"18","2"],["4419","1968-07-22","Fritz Teufel ist in München-Schwabing festgenommen worden. In einem Schwabinger Lokal waren er und Bekannte wegen \"ihres ungepflegten Äußeren\" nicht bedient worden, der Wirt rief die Polizei. Teufel warf dem Wirt einen Teller ins Gesicht, wurde daraufhin von der Polizei verhaftet und angezeigt.","Fritz Teufel in München angezeigt","","","di.",[5],4,[1],[3],2,"18","5"],["4420","1968-07-22","Die Wahl zum Studentenparlament in Marburg wurde für ungültig erklärt, da linke Studenten sich als Gegner der linken Gruppen deklariert hatten, um so Stimmen aus dem rechten Lager zu bekommen.","Studentenwahlen für ungültig erklärt","","","",[4],4,[1],[2],2,"18","5"],["4421","1968-07-22","Plädoyer für Studentenverbindungen. Der Senat sollte seine negative Haltung den Verbindungen überprüfen und ablegen.","Senat sollte endlich Haltung überprüfen","Aus Briefen an die Lokalredaktion","","Leser",[4],4,[6],[2],2,"18","10"],["4422","1968-07-23","Brief des Dekans der Philosophischen Fakultät der FU Berlin, Prof. Loos, an Wissenschaftssenator Stein, Sorge um die Zukunft der FU. Auf Grund der prekären Lage der FU würden immer mehr Wissenschaftler von der FU fortgehen und es würde schwieriger werden, erfolgreichen Berufungen durchzuführen. Kritik innerhalb der Professorenschaft an Senator Stein.","\"Akute Gefahr bedroht Freie Universität\"","Professor Loos schreibt an Senator Stein:","Wissenschaftler wandern ab - \"Lage ist prekär\"","Bi.",[4],4,[1],[5],2,"18","1"],["4423","1968-07-23","Abdruck des Briefes des Dekans der Philosophischen Fakultät der FU Berlin, Prof. Loos, an Wissenschaftssenator Stein, Sorge um die Zukunft der FU. Auf Grund der prekären Lage der FU würden immer mehr Wissenschaftler von der FU fortgehen und es würde schwieriger werden, erfolgreichen Berufungen durchzuführen. Kritik innerhalb der Professorenschaft an Senator Stein.","Der Brief von Professor Loos wird als Alarmsignal gewertet","Freie Universität","Kritik an Politikern verstärkt sich","Hans-Erich Bilges",[4],4,[6],[1],1,"18","3"],["4424","1968-07-23","Das Erziehungswissenschaftliche Seminar der Universität Marburg hat sich mit den Reformbestrebungen des Berliner Otto-Suhr-Instituts solidarisch erklärt.","Solidarisch mit OSI-Reform","","","",[4],4,[1],[2],2,"18","3"],["4425","1968-07-23","Forderung des studentischen Vertreters im Senat der Kieler Universität nach Mitbestimmung der Studenten bei den Hochschulgesetzen. Der AStA- Vorsitzende Achterberg (SDS) bezeichnet dies zudem als \"gesellschaftliche Machtfrage\". Außerdem solle das Studium als gesellschaftlich notwendige Arbeit anerkannt und dementsprechend bezahlt werden.","AStA: Das Studium als Arbeit bezahlen","","","H.A.",[4],4,[1],[2],2,"18","3"],["4426","1968-07-23","Vorschläge des Rektors der Universität Kiel bzw. der Kommission der Kieler Uni für ein neues Hochschulgesetz. Ablehnung einer Präsidialverfassung, für ein Kollegialorgan.","Fünf Professoren und ein Kanzler sollen an der Spitze stehen","Universität Kiel","","H.A.",[4],4,[1],[5],1,"18","3"],["4427","1968-07-23","Der Deutsche Bundesjugendring wird erstmals eine offizielle Gruppe zu den kommunistischen Weltjugendfestspielen entsenden.Auch der SDS, der SHB und weitere Jugend- und Studentenverbände entsenden Vertreter.","Deutsche Teilnehmer am Sofia-Festival","","","",[9],4,[1],[2],2,"18","4"],["4428","1968-07-23","Der RCDS richtet einen Offenen Brief an den sowjetischen Botschafter Zarapkin und kritisiert den auf die CSSR ausgeübten Druck durch die Sowjetunion. Zudem kritisieren sie die systematische Diffamierung der Bundesrepublik.","Offener Brief des RCDS an Zarapkin","","","Sch.",[11],4,[1],[3],2,"18","4"],["4429","1968-07-23","Der VdS weist Meldungen zurück, wonach vier Mitarbeiter seiner Bundesgeschäftsstelle aus politischen Gründen ausscheiden (siehe Welt vom 20.07.1968).","VDS: Keine politischen Gründe für Kündigung","Studenten","Warum vier Mitarbeiter gehen","ems.",[4],4,[1],[2],2,"18","5"],["4430","1968-07-23","Seminar des VdS mit Vertretern der FDJ. Man verwahrt sich gegen die Anerkennung der DDR, generell Kritik am Auftreten der FDJ-Vertreter, insbesondere an deren nationalstaatlicher Betonung. Zudem Stellungnahmen zu den Hochschulreformen, der VdS wolle die Autonomie der Hochschule verteidigen.","FDJ-Delegierte hörten stumm und staunend zu","Studenten","VDS-Seminar in Marburg","Nea.",[4],4,[1],[2],1,"18","5"],["4431","1968-07-23","Ausführliche Chronologie der verschiedenen Vorschläge für Hochschulreformen seit 1946.","Die Hürde wurde nie genommen?","26 Ansätze in 22 Jahren: Ringen um die neue Universität","Chronologie der Hochschulreform - Eine Übersicht","Wolfgang Bergsdorf und Walter Görlitz",[4],4,[1],[1],1,"18","13"],["4432","1968-07-24","Senator Stein kündigte eine Antwort auf den Brief von Prof. Loos an (siehe Welt vom 23.7.1968). Er bedauert die öffentliche Behandlung noch nicht abgeschlossener Berufungsverhandlungen. Auch Prof. Loos bedauert, dass sein Brief an die Öffentlichkeit gekommen ist, es sei ihm nur um die Berufungen gegangen. Jürgen Wohlrabe von der CDU nimmt den Brief zum Anlass, erneut den Rücktritt von Senator Stein auf Grund der Verhältnisse an der FU zu fordern.","Senator Stein kündigt Antwort an","","Auf den Brief von Professor Loos - Veröffentlichung bedauert","Bi.",[4],4,[1],[2],2,"18","1"],["4433","1968-07-24","Bericht über die Situation der Außerparlamentarischen Opposition, Stellungnahmen von Helmut Schauer. Insbesondere die Kritik von Jürgen Habermas mache der APO zu schaffen. Laut Schauer hätten die aktiven Mitglieder der APO nicht resigniert, insgesamt habe man sich verbreitert. Ähnlich Reimut Reiche vom SDS, der zudem erklärt, dass man deshalb nicht zu sogenannten gewaltlosen Aktionen zurückkehren dürfe. Im Zentrum der APO soll künftig das Thema \"Mitbestimmung\" stehen. APO und SDS erhoffen sich von Daniel Cohn-Bendit, der zum Wintersemester als Soziologiestudent der Uni Frankfurt eingeschrieben ist, neue Impulse.","\"Nach einem Lernprozeß neue Aktionen\"","Außerparlamentarische Opposition","\"Nach einem Lernprozeß neue Aktionen\"","Joachim Neander",[11],4,[1],[1],1,"18","3"],["4434","1968-07-24","Der VdS will eine einstweilige Verfügung gegen den AStA der Uni München beantragen. In Briefen an alle Münchner Studenten hatte dieser für den Austritt aus dem VdS plädiert und geschrieben, dass der VdS die Mitgliedsbeiträge der Studenten für Desertationskampagnen, die Ziele der APO und zur Verbreitung der Gesellschaftsmodelle von Ho Tschi Minh und Mao Tse-Tung verwende.","VDS kontra AStA München","Kurz berichtet","","",[4],4,[1],[2],2,"18","3"],["4435","1968-07-24","Stellungnahmen des ehemaligen Direktor des VDI, Grünewald, des ehemaligen Vorsitzenden des Studentenverbandes Deutscher Ingenieurschulen, Schlaghecke, sowie des Mitinhabers einer Maschinenfabrik, Aengeneyndt, zu den Forderungen und der Situation der Ingenieur-Studenten und zu nötigen Reformen für die Ingenieurschulen.","Gesucht: Der beste Bildungsweg für Ingenieure","Drei Fachleute äußern sich zu den Klagen und Forderungen der Ingenieur-Studenten","","Heinrich Grünewald, Wolf Aengeneyndt, Johannes Schlaghecke",[4],4,[5],[4],1,"18","11"],["4436","1968-07-25","Die Feststellung von Innenminister Benda, dass der Linksradikalismus gegenwärtig keine ernste Gefahr für die verfassungsmäßige Ordnung darstelle, müsse revidiert werden, da der Bericht Bendas nur das Jahr 1967 berücksichtige, nicht aber das Jahr 1968. Die linksextremen Organisationen und allen voran der SDS würden die gleiche Aufmerksamkeit und Wachsamkeit verdienen wie die NPD, man dürfe die Gefahr von links nicht bagatellisieren.","Gefahr von links","Zum Tage","","W.T.",[9],4,[5],[2],2,"18","2"],["4437","1968-07-25","Das Kuratorium der FU Berlin hat Verständnis für die Entscheidung des Rektors, die Rückmeldung der Studenten unter den gegebenen Umständen nicht von der Zahlung der Pflichtbeiträge für die studentische Selbstverwaltung abhängig zu machen. Eine Befreiung von der Zahlung kann jedoch nicht ausgesprochen werden. Bis zur gerichtlichen Entscheidung könne ein Verwahrungskonto eingerichtet werden. Unterschiedliche Aussagen von Rektor Harndt und Prof. Loos, ob dessen Brief an Senator Stein für die Öffentlichkeit bestimmt gewesen sei.","Kuratorium befürwortet Weiterzahlung","Freie Universität","AStA-Beiträge können auf Verwahrungskonto genommen werden","Bi.",[4],4,[1],[2],2,"18","3"],["4438","1968-07-25","Der baden-württembergische Kultusminister Hahn empfiehlt den Studenten, im kommenden Semester ihr Studium nicht an der Universität Tübingen aufzunehmen, da deren \"Massenfächer\" überlastet seien, sondern auf die Unis Stuttgart oder Mannheim auszuweichen.","Vor dem Studium in Tübingen gewarnt","","Hahn: Größte Schwierigkeiten","hh.",[4],4,[1],[2],2,"18","3"],["4439","1968-07-25","Die studentische Vollversammlung der Universität Regensburg fordert den Rücktritt ihres Rektors, da dieser an der Verleihung der Konrad-Adenauer-Preise der Deutschland-Stiftung teilgenommen habe und sich so mit den \"rechtsreaktionären Thesen\" des Preisträger Emil Franzel solidarisiert hätte. Rektor Mayer verteidigte die Deutschland-Stiftung, diese sei mindestens so ansehnlich wie die Vollversammlung.","Regensburger Rektor soll zurücktreten","","","pff.",[11],4,[1],[2],2,"18","5"],["4440","1968-07-26","Willy Brandt hat die Studenten um Rudi Dutschke, die am 24.12.1967 den Gottesdienst in der Kaiser-Wilhelm-Gedächtniskirche in Berlin gestört hatten, in Schutz genommen. Ihm sei politisches Engagement in der Kirche zwar fremd, man solle sich aber dem Anliegen der Protestierer zuwenden. Sie könnten gezielt in die Kirche und zu den Christen gekommen sein, eben weil es die Kirche und Christen sind.","Brandt zeigt Verständnis für Protest in der Kirche","","","",[3,2],4,[1],[2],2,"16","5"],["4441","1968-07-26","In Baden-Württemberg wird eine Koordinierungsstelle der Universitäten des Landes für Studienbewerber eingerichtet, um in Verbindung mit einem Numerus Clausus bei sogenannten Massenfächern Studenten auf freie Plätze an anderen Universitäten umleiten zu können.","Bewerbungen von Studenten werden koordiniert","","Für die Massenfächer","uhl.",[4],4,[1],[2],1,"16","5"],["4442","1968-07-26","Tagung von Rektoren, Studenten und Professoren in der Evangelischen Akademie Tutzing über die \"Kritische Universität\". Der Münchner Prorektor Kotter erklärte, einem Teil der jungen Linken ginge es nicht um die Verbesserung der Universität, sondern um eine Veränderung der Gesellschaft. Dann wäre die Kritische Universität aber überflüssig. Von Berliner AStA-Vertretern war Selbstkritik geäußert worden. Ein VdS-Sprecher empfahl die Diskussion von Gewalt an den Kritischen Universitäten und kündigte an, dass eines Tages auch die Professoren sich radikalisieren werden und bei ihnen eintreten werden.","\"Eines Tages werden Professoren radikal\"","Bildungspolitik","Tagung in Tutzing über die kritische Universität","wfm.",[1],4,[1],[3],1,"16","5"],["4443","1968-07-27","Der AStA der FU Berlin ersucht Senator Stein, die Frage der studentischen Selbstverwaltung im Wege der Staatsaufsicht zu klären, da die materielle Grundlage der Studentenvertretung eindeutig gesichert sein müsse.","Stein soll Beitragsfrage klären","Kurz berichtet","","",[4],4,[1],[2],2,"26","3"],["4444","1968-07-27","Interview mit Bundesforschungsminister Stoltenberg über Bildungs- und Hochschulpolitik. Insbesondere der Studienplatzmangel bzw. die Situation der überfüllten Universitäten müsse gelöst werden Kritisiert Ideologisierung und Radikalisierung eines Teils der Studentenschaft, daran seien auch sehr links orientierte Hochschullehrer schuld. Es gäbe aber auch legitime Gründe für kritische, oppositionelle Tendenzen.","\"Wir müssen neue Berufswege für die Abiturienten finden\"","Das Interview mit Bundesforschungsminister Gerhard Stoltenberg","Zuerst muß das Problem der Überfüllung der Hochschulen gelöst werden","Günter Krems",[4],4,[3],[1],1,"26","5"],["4445","1968-07-29","Der Verband der Vereine Deutscher Studenten hat sich auf seiner Verbandstagung gegen den Anspruch eines politischen Mandats der studentischen Selbstverwaltungen ausgesprochen.","Gegen politisches Mandat der Studentenschaft","","","",[11],4,[1],[2],2,"16","4"],["4446","1968-07-29","Fritz Teufel wurde in München zu einer dreitägigen Ordnungsstrafe verurteilt, weil er bei einer Verhandlung gegen einen Teilnehmer der Münchner Osterunruhen zunächst den Richter in eine Diskussion über die \"Brutalität der Münchner Polizei\" verwickeln wollte und sich anschließend auf den Richterstuhl setzte und selbst verhandeln wollte.","Drei Tage Haft für Fritz Teufel in München","","","",[5],4,[1],[2],2,"16","4"],["4447","1968-07-29","Bundesdelegiertenversammlung des SHB. Zwar sei der erwartete Linksrutsch zu verzeichnen, jedoch habe der SHB nicht komplett mit der SPD gebrochen, wie teils gefordert. Man werde aber nur mit der innerparteilichen Opposition in der SPD zusammenarbeiten und bei der Bundestagswahl 1969 nur solche Kandidaten unterstützen, die gegen die Große Koalition und die Notstandsgesetzgebung sind. Man verstehe sich weiter als Teil der APO.","Der erwartete Bruch mit der SPD blieb wieder aus","Sozialdemokratischer Hochschulbund","Ruck nach links auf der Delegierten-Versammlung","d.",[11],4,[1],[1],1,"16","5"],["4448","1968-07-31","Drei Studenten und ein wissenschaftlicher Assistent der FU Berlin haben Strafanzeigen erstattet. Alle gelten als Gegner linksgerichteter Studentengruppen. Sie hatten Drohbriefe bekommen (\"Denken Sie an Frau und Kinder\"), einer Studentin wurde eine Vergewaltigung angedroht, einem Studenten war eine Übungshandgranate ins Schlafzimmer geworfen worden.","FU-Studenten bedroht","","","Bi.",[1],4,[1],[2],2,"20","5"],["4449","1968-07-31","Am Soziologischen Institut der Universität München ist ein Institutsrat gegründet worden, in dem die Hälfte der Plätze von studentischen Vertretern besetzt werden. Dies ist bis dorthin das höchste Maß an studentischer Mitbestimmung in der Bundesrepublik.","Studenten werden erstmals zur Hälfte beteiligt","","An Münchner Institutsrat","pff",[4],4,[1],[2],2,"20","5"],["4450","1968-09-03","Der parlamentarische Ausschuß für Wissenschaft und Kunst des Berliner Abgeordnetenhauses nimmt seine Beratungen über das geplante Hochschulgesetz wieder auf.","Beratungen wiederaufgenommen","","Hochschulgesetze anderer Bundesländer angefordert","sh",[4],4,[1],[2],2,"20","11"],["4451","1968-09-04","Gegen fünf Mitglieder des SDS wurde ein Ausschlußverfahren vorbereitet. Ihnen wird autoritäres Verhalten vorgeworfen, sie würden zum Establishment gehören. Die fünf gehören zum KPD-nahen Flügel, der auch für eine Mitarbeit im Parlamentarismus eintritt.","Ausschlußverfahren gegen SDS-Mitglieder","","","pt.",[8],4,[1],[2],2,"20","6"],["4452","1968-09-04","Der Dutschke-Attentäter Josef Bachmann soll abschließend zum Tathergang vernommen werden.","Bachmann erneut vor dem Vernehmungsrichter","","","",[2],4,[1],[2],2,"20","9"],["4453","1968-09-05","Mitglieder des SDS haben einen Kongreß über \"Karl Marx und die Philosophie der Gegenwart\" in Wien gestört, nachdem ein polnischer Referent die Redner, die die sowjetischen Referenten kritisiert hatten, scharf getadelt hatte. Dies seien \"autoritäre Praktiken\".","SDS stört Kongreß in Österreich","","","gaz.",[1],4,[1],[2],2,"18","1"],["4454","1968-09-05","Karl-Heinz Pawla hat während eines Prozesses gegen sich im Gerichtssaal seine Notdurft verrichtet und sich anschließend mit Akten vom Richtertisch gesäubert. Wegen der eigentlichen Anklage wurde er zu drei Monaten Gefängnis ohne Bewährung verurteilt.","Nicht nur der Richter rümpfte die Nase","","Kommune-Student verunreinigte den Sitzungssaal","",[1],4,[1],[5],2,"18","12"],["4455","1968-09-05","Der Dutschke-Attentäter Josef Bachmann wurde abschließend vernommen. Da dieser seinen \"seelischen Tiefstand\" überwunden haben soll, wird mit einer baldigen Anklageerhebung gerechnet.","Bald Anklageerhebung gegen Dutschke-Attentäter","","","",[2],4,[1],[2],2,"18","12"],["4456","1968-09-07","Karl-Heinz Pawla wurde wegen der Verrichtung seiner Notdurft im Gerichtssaal zu 10 Monaten Haft verurteilt. Beim Plädoyer des Staatsanwalts hatte Pawla nach diesem zudem mit seiner Sandale geworfen.","Provokation im Gericht geahndet","Kurz berichtet","","",[1],4,[1],[2],2,"32","24"],["4457","1968-09-07","Der Untersuchungs-Ausschuss der Bremer Bürgerschaft über die Demonstrationen gegen die Fahrpreiserhöhungen kritisiert das Verhalten des Bremer Polizeipräsidenten, dieser hätte nüchterner handeln müssen. Kritik auch am Senat. An den Demonstrationen waren laut dem Ausschuss auch zahlreiche Arbeiter beteiligt, die so die Grenze ihrer wirtschaftlichen Belastungsfähigkeit sichtbar machen wollten.","Vorwurf gegen Polizeipräsidenten","","Parlaments-Ausschuß berichtet über Demonstrationen in Bremen","M. ",[1],4,[1],[2],2,"32","24"],["4458","1968-09-09","Prof. Froese über die Notwendigkeit einer Reform des Hessischen Hochschulgesetzes, obwohl dieses in der gegenwärtigen Form erst vor zwei Jahren erlassen wurde.","Reform tut not für ein Reformgesetz","Neuordnung der Universität","Debatte in Hessen - Bedeutung weit über Hessen hinaus","Leonhard Froese",[4],4,[1],[1],2,"20","8"],["4459","1968-09-10","Der SDS teilte mit, dass künftig die Bundeswehr im Zentrum ihrer Aktionen stehen solle, das Ziel sei eine \"innere Revolte der Bundeswehr\". Die Brüder Wolff erklärten, auf der nächsten Delegiertenkonferen nicht mehr für den Vorstand kandidieren zu wollen.","Bundeswehr als Ziel neuer Aktionen","","","Nea.",[8],4,[1],[2],2,"18","3"],["4460","1968-09-10","Laut einem Urteil des Berliner Oberverwaltungsgerichts hat der Konvent der FU Berlin kein Recht, sich zu allgemein politischen Fragen zu äußeren, und damit auch kein politisches Mandat. Anlass war eine Klage zweier Studenten wegen Stellungnahmen des Konvents zum Vietnamkrieg.","Konvent der Freien Universität hat kein politisches Mandat","","OVG-Entscheidung. Revision beim Bundesgericht zugelassen","wt",[11],4,[1],[1],2,"18","11"],["4461","1968-09-10","Fassungslosigkeit über Pawlas Verrichtung seiner Notdurft im Gerichtssaal, die Demokratie würde mit der milden Bestrafung ihr letztes Anssehen verspielen (Pawla wurde jedoch nicht nur zu drei Tagen Ordnungshaft, sondern auch noch zu weiteren zehn Monaten Haft wegen dieser Sache verurteilt). Die Prügelstrafe wird gefordert.","Nennt sich Student","Aus Briefen an die Lokalredaktion","","Leser",[1],4,[6],[2],2,"18","12"],["4462","1968-09-11","Der SDS versuche sich mit der großen Ankündigung seiner Bundeswehrkampagne in das öffentliche Interesse zu bringen, dies sei bereits Teil der Kampagne. Ziel sei die revolutionäre Transformation der Gesellschaftsordnung. Verwirft die Möglichkeit, dass es eine Revolte in der Bundeswehr geben könnte, wenn der SDS dies trotzdem versuchen sollte, wäre dies die unmittelbare Herausforderung des Staates.","SDS rüstet sich","","","W.H.-E.",[8],4,[5],[2],2,"22","2"],["4463","1968-09-11","Das Rektorat der FU Berlin legt Wert auf die Feststellung, dass Karl-Heinz Pawla, der wegen Verrichtung seiner Notdurft im Gericht zu zehn Monaten Gefängnis verurteilt worden war, bereits seit dem Wintersemester 1967/68 kein Student der FU mehr ist.","Nicht mehr Student","","","",[1],4,[1],[2],2,"22","13"],["4464","1968-09-11","Der Bundesgerichtshof bestätigte den Freispruch gegen Fritz Teufel im Prozess wegen Landfriedensbruchs am 2. Juni 1967.","Freispruch rechtskräftig","","","",[5],4,[1],[2],2,"22","13"],["4465","1968-09-11","Der Berliner Senat hat sich einstimmig für ein Gesetz (\"Vorschaltgesetz\"), dass die Entwicklung und Erprobung neuer Modelle von Lehrformen an den Universitätsinstituten ermöglichen soll, ausgesprochen. Hintergrund war die Ablehnung einer Satzung des Otto-Suhr-Instituts durch den Akademischen Senat der FU, was mittels des geplanten Gesetzes nicht mehr möglich wäre. Diese Reformexperimente sollen auf ein Semester zeitlich befristet sein. Die CDU kritisiert das Gesetzesvorhaben als schweren Eingriff in die Autonomie der Universitäten.","Grünes Licht für Experimente an beiden Universitäten","","Prof. Stein unterbreitet Vorschläge. Reformen jeweils von Urabstimmung abhängig.","hae",[4],4,[1],[1],2,"22","13"],["4466","1968-09-11","Der Dutschke-Attentäter Josef Bachmann wurde zum zweiten Mal in der Haft operiert. Die Operation sollte der Wiederherstellung der seit der Schießerei mit der Polizei beeinträchtigten Funktion seines rechten Armes dienen.","Dutschke-Attentäter operiert","","","",[2],4,[1],[2],2,"22","14"],["4467","1968-09-12","Die SED Westberlin ist nicht bereit, auf die Forderung der APO, die Intervention in der CSSR durch die Staaten des Warschauer Pakts zu verurteilen, einzugehen. Man sei aber jederzeit bereit, ohne Vorbedingungen die Aktionseinheit und das Zusammenwirken aller antiimperialistischen und sozialistischen Kräfte zu verstärken.","SED lehnt APO-Forderung ab","","Kurz berichtet","Bi.",[9],4,[1],[2],2,"22","3"],["4468","1968-09-12","Der persische Schah erklärte während einer Pressekonferenz zum Besuch Bundeskanzler Kiesingers, dass die Demonstrationen gegen seine Person vom 2. Juni 1967 keine Ursache für eine Verstimmung zwischen den Ländern gewesen seien. Er habe Verständnis für die Unruhe unter der Jugend in aller Welt, hätte sich aber gefragt, was mit einem Land, in dem Unwahrheiten verbreitet würden, geschehen könne.","Schah: Kein Grund zur Verstimmung","Bonn-Teheran","Gespräche über Demonstrationen im vergangenen Sommer","St,",[1],4,[1],[2],2,"22","4"],["4469","1968-09-12","In Nordrhein-Westfalen legen SPD und CDU jeweils Entwürfe für ein Hochschulgesetz vor.","Parteien stoßen in Hochschulfrage vor","","Initiativen in Düsseldorf","frh.",[4],4,[1],[2],2,"22","6"],["4470","1968-09-12","Der Konvent der FU Berlin hat gegen das Urteil des Berliner Oberverwaltungsgerichts, in dem ihm das politische Mandat abgesprochen wurde, Revision beim Bundesverwaltungsgerichtshof eingelegt.","Konvent geht in Berufung","","","",[11],4,[1],[2],2,"22","9"],["4471","1968-09-12","Die SPD-Betriebsgruppe der Berliner Hochschulen begrüßt das Vorhaben des Berliner Senats, Reform-Experimente an den Hochschulen zu ermöglichen. Die Studentenvertretungen der TU und FU Berlin lehnen die Übernahme von Kompetenzen des Akademischen Senats durch den Senat ab, wenn dieser ebenfalls die Art der Reformen einschränke.","Reform-Experimente begrüßt","","","",[4],4,[1],[2],2,"22","9"],["4472","1968-09-13","23. Bundesdelegiertenkonferenz des SDS. Der Bundesvorsitzende Wolff äußerte Kritik an der jüngsten Entwicklung des SDS, es gäbe Auflösungserscheinungen in einigen Hochschulgruppen, nach den Aktionen gegen den Springer-Verlag sei es nicht gelungen, die Mobilisierung in eine organisierte Aktionseinheit von Schülern, Studenten und Arbeitern zu überführen. Zu den Ereignissen in der CSSR habe Wolff gar keine Stellung genommen.","Der SDS übt Selbstkritik","","Delegiertenkonferenz in Frankfurt","Nea.",[8],4,[1],[3],2,"32","6"],["4473","1968-09-13","Der RCDS fordert in einem Brief an Senator Stein, dass zum geplanten Gesetz zur Ermöglichung von kurzfristigen Reformsatzungen an Universitätsinsituten studentische Vertreter gehört werden. Den SDS will man davon jedoch ausschließen, da dieser nicht die Reform der Hochschule, sondern den Beweis ihrer Reformunabhängigkeit anstrebe. Grundsätzlich begrüßt der RCDS das Vorhaben des Senats.","RCDS schreibt offenen Brief an den Wissenschaftssenator","","","",[4],4,[1],[2],2,"32","15"],["4474","1968-09-14","Fünf Mitglieder des SDS wurden auf der 23. Delegiertenkonferenz wegen verbandsschädigendem Verhaltens ausgeschlossen. Sie hatten während der Weltjugendfestspiele in Sofia eine Demonstration des Bundesvorsitzenden Wolff als \"spalterisch\" bezeichnet. Zudem hätten sie sich an einem Empfang der FDJ beteiligt, bei dem als einziger Vertreter der Bundesvorsitzende des SDS ausgeladen worden war. Der Ausschluss erfolgte im 2. Wahlgang mit Zweidrittelmehrheit, zuvor musste extra die Verfahrensordnung geändert werden.","Fünf \"Genossen\" wurden vom SDS ausgeschlossen","","\"Verbandsschädigendes Verhalten\"","P. L.",[8],4,[1],[2],2,"28","6"],["4475","1968-09-16","23. Bundesdelegiertenkonferenz des SDS. Fritz Teufel wird gefragt, ob er nicht wieder Mitglied werden wolle. Teufel berichtet über seine Erfahrungen mit der Justiz, Kampagne gegen den \"Jusitzterror\" soll künftig mit im Zentrum des SDS stehen. Die Desertationskampagne in der Bundeswehr stieß dagegen auf harsche Kritik. Der Ausschluss von fünf Mitgliedern sei ein Erfolg des antiautoritären Lagers und solle der organisatorischen und ideologischen Verfestigung des SDS dienen. Kurz zu den Protesten der Frauen im SDS, diese würden sich ihre eigene Schwäche als \"Unterdrückung\" einreden. Teufel sagt dazu, dass er dafür sei, alle Mädchen aus dem SDS auszuschließen.","Teufels große Stunde kam in der Justizdebatte","SDS-Delegiertenkonferenz","Versöhnung mit dem Verstoßenen rührte die \"Genossen\"","Paul Lersch",[8],4,[1],[1],1,"22","5"],["4476","1968-09-17","Etliche Prozesse gegen Studenten stehen der Justiz in Kürze vor. Diese wolle sich künftig mehr auf die Anstifter von Krawallen konzentrieren und Mitläufer laufen lassen.","Welle von Studenten-Prozessen naht","","Justizminister: Verfahren auf Anstifter konzentrieren","uhl.",[1],4,[1],[2],1,"22","1"],["4477","1968-09-17","Der 26. Kongress der deutschen Gesellschaft für Psychologie in Tübingen wurde von Studenten gestört. Der gegenwärtigen Psychologie warfen sie vor, kritische Wissenschaft zu verhindern.","Studenten demonstrieren auf Psychologen-Kongreß","","","tr.",[1],4,[1],[2],2,"22","3"],["4478","1968-09-17","Falls es zu den vom SDS bereits angekündigten Störungen auf der Frankfurter Buchmesse kommen sollte, wird ein Ausschluss aller Besucher von der Messe erwogen.","Ausschluß der Besucher angedroht","","Zum Schutz der Buchmesse","",[1],4,[1],[2],2,"22","3"],["4479","1968-09-17","Über die bevorstehenden Prozesse gegen Studenten wegen der Unruhen 1967/68. Geplantes Vorgehen der Justiz, man solle sich mehr auf die Anführer konzentrieren. Das Vorhaben der Akteure, die Justiz durch Selbstanzeigen lahmzulegen, sei gescheitert. Kritik an pauschalen Urteilen.","Justiz soll nicht mit dem stumpfen Schwert dreinschlagen","Studenten-Prozesse","Empfehlung des Justizministers Schieler","Walter Pfuhl",[1],4,[1],[1],2,"22","3"],["4480","1968-09-18","Die Bundedelegiertenversammlung des SDS wurde wegen schweren Gegensätzen innerhalb des Verbandes abgebrochen. Die Wahl des neuen Vorstandes soll im November nachgeholt werden. Auch kein Übergangsvorstand konnte gewählt werden. Der SDS drohe in zahlreiche autonome Gruppen auseinanderzufallen.  Auch über die geplanten Aktionen wurden keine Beschlüsse gefasst.","SDS-Delegiertenkonferenz abgebrochen","Studenten","Unüberbrückbare Gegensätze - Kein Vorstand gewählt","",[8],4,[1],[2],2,"22","3"],["4481","1968-09-18","Entwurf eines Hochschulgesetzes des hessischen Kultusministers. U.a. wird die von Studenten geforderte Drittelparität berücksichtigt.","Drittelparität für Studenten vorgeschlagen","Hessisches Hochschulgesetz","Kultusminister Schütte erläutert Rahmengesetz für Hoch- und Fachschulen - Fachbereiche statt Fakultäten","lh.",[4],4,[1],[1],2,"22","10"],["4482","1968-09-18","Fortführung des Prozesses gegen mehrere Mitglieder der Kommune I. Der Prozess war am 09.07.1968 teilweise unterbrochen worden, weil mehrere der ursprünglich acht Angeklagten Ordnungsstrafen wegen Ungebühr vor Gericht erhalten hatten. Dieses Mal sei es zu keinen Störungen gekommen.","Benehmen war diesmal tadellos","","Prozeß um Krawall vor dem Plenarsaal begann","wt",[5],4,[1],[2],2,"22","11"],["4483","1968-09-19","Der Arbeitskreis zur Beratung des nationalen Bildungswesens unter Leitung von Bundeskanzler Kiesinger hat die Mitwirkung der Studenten in den Gremien der Hochschulen als eine vordringliche Aufgabe bezeichnet. Schematische Lösungen wie die Drittelparität werden jedoch abgelehnt.","\"Mitwirkung der Studenten ist vordringlich\"","","Bildungs-Konferenz beim Kanzler","",[4],4,[1],[2],2,"24","1"],["4484","1968-09-19","Die Messeleitung der Frankfurter Buchmesse hat angekündigt, die Messe bei anhaltenden Störungen für die Öffentlichkeit zu schließen.","Frankfurter Buchmesse eröffnet","Schaufenster der Verlage","Friedrich Georgi kündigt neuen Vorsteher des Börsenvereins an","jn",[1],4,[1],[1],2,"24","12"],["4485","1968-09-19","Wegen gemeinschaftlichen Hausfriedensbruchs wurde die Dieter Kunzelmann zu acht und Rainer Langhans zu sieben Monaten Gefängnis verurteilt. Gegen Fritz Teufel wurde Hafbefehl wegen Fernbleiben vom Prozess erlassen. Bewährungsstrafen wurden versagt, weil das öffentliche Interesse die Vollstreckung der Strafen fordere. Die Nachnahmen der Kommunarden wurden im Artikel nicht ausgeschrieben.","Gefängnis für \"Kommune\"-Mitglieder","","Wegen gemeinschaftlichen Hausfriedensbruchs verurteilt","wt",[5],4,[1],[2],2,"24","13"],["4486","1968-09-20","Nach einer neuen Anordnung der westalliierten Stadtkommandanten werden Störung des Berlin-Verkehrs und Aufforderungen zur Desertation von Militärangehörigen künftig mit bis zu zehn bzw. bis zu fünf Jahren Freiheitsstrafe geahndet. Dies wird als Reaktion auf die APO gewertet, die wiederholt zu beiden Tatbeständen aufgerufen hatte.","Alliierte drohen mit harten Strafen","","Warnung an \"außerparlamentarische Opposition\" in Berlin","v. C.",[11],4,[1],[3],2,"24","1"],["4487","1968-09-20","Die oben genannte Anordnung der alliierten Stadtkommandanten wird als scharfe Warnung gegen die APO verstanden, Störungen des Berlin-Verkehrs oder Aufrufe zur Desertation seien keine politischen Spielereien, sondern Verstöße gegen die vitalen Interessen der Schutzmächte.","Scharfe Warnung","Zum Tage","","co",[11],4,[1],[2],2,"24","2"],["4488","1968-09-20","Die Rektoren der hessischen Hochschulen haben dem hessischen Kultusminister Schütte wegen dessen Entwurfs für ein neues Hochschulgesetz einstimmig das Mißtrauen ausgesprochen. Auch FDP und CDU fordern ihn zum Rücktritt auf. Die Rektoren brechen ihre Gesprächsbereitschaft mit Schütte ab. Der Entwurf gefährde die Funktionsfähigkeit der Hochschulen und erscheine als Belohnung für die rechtswidrigen Aktionen radikaler Studenten in Frankfurt und Marburg.","Rektoren fühlen sich von Minister Schütte brüskiert","Hessen","Kritik am Hochschulgesetzentwurf","lh.",[4],4,[1],[1],1,"24","5"],["4489","1968-09-20","Vier Studentengruppen haben sich in Westberlin zu einer Opposition gegen die außerparlamentarische Opposition formiert (Linksliberale Gruppe, Außerparlamentarische Mitarbeit, Aktionsgemeinschaft liberaler Deutscher, Arbeitsgemeinschaft am Otto-Suhr-Institut). Sie wollen eine Alternative zum SDS bieten, verstehen sich aber auch als kritisch. Zahlreiche reformwillige Professoren und Politiker hätten ihre Unterstützung zugesagt.","Die Gegen-Opposition formiert sich","Westberlin","Studenten wollen \"Alternative zum SDS\"","Bi.",[1],4,[1],[3],2,"24","5"],["4490","1968-09-20","Der Berliner RCDS-Vorsitzende Christian Hacke spricht sich gegen Bestrebungen des AStA der FU Berlin aus, sozialistische Politik links von Moskau zu betreiben. Sozialistische Politik sei rückschrittlich.","\"Sozialistische Politik\" nüchtern gesehen","Aus Briefen an die Redaktion","","Christian Hacke (Leserbrief)",[1],4,[6],[1],2,"24","17"],["4491","1968-09-21","Proteste von überwiegend jugendlichen Demonstranten gegen Franz-Josef Strauß auf der Frankfurter Buchmesse, u.a. Sprechchöre wie \"Strauß ist ein Faschist\"","Demonstration gegen Strauß auf der Buchmesse","","","",[1],4,[1],[3],2,"30","1"],["4492","1968-09-23","Proteste bei der Verleihung des Friedenspreises des deutschen Buchhandels an den senegalesischen Staatspräsidenten Senghor. Der SDS wirft Senghor unter anderem die \"Unterdrückung revolutionärer Bewegungen im eigenen Land\" vor.  Daniel Cohn-Bendit wurde bei den Protesten vor der Paulskirche festgenommen, soll von der Polizei geschlagen worden sein. Die Buchmesse wurde zeitweise wegen einer Vielzahl von Demonstranten geschlossen, mehrere Verlage haben aus Protest gegen einen Polizeieinsatz auf der Messe ihre Stände geräumt. Willy Brandt kritisiert die Demonstrationen scharf, es müsse möglich sein, Gäste würdig zu empfangen. Insbesondere kritisierte er, dass dem israelischen Botschafter Asher Ben-Natan der Weg versperrt wurde und er mit Rufen wie \"Ihr Schweine\" bedeckt wurde. Drei Polizisten und ein Messepförtner wurden bei den Ausschreitungen verletzt.","Schwere Zwischenfälle bei der Verleihung des Friedenspreises","","","",[1],4,[1],[1],1,"30","1"],["4493","1968-09-23","Über die kurzzeitige Schließung der Frankfurter Buchmesse und die Kundgebungen nach der Wiedereröffnung. Daniel Cohn-Bendit sei der neue Star der deutschen Bewegung, er sei auch intelligenter und frischer als der Rest, achte aber auch darauf, dass er stets wahrgenommen wird.","Autoren machen müde Messe munter","In den Frankfurter Ausstellungshallen notiert","Prunk des Geistes und des Geschäfts","Christian Ferber",[1],4,[1],[1],1,"30","5"],["4494","1968-09-24","Gegen Daniel Cohn-Bendit wurde Haftbefehl u.a. wegen Körperverletzung und Land- und Hausfriedensbruchs erlassen, begangen bei den Demonstration vor der Paulskirche zur Verleihung des Friedenspreises an Senghor. Der Frankfurter Polizei hätten Pläne für ein Attentat auf Senghor vorgelegen. Von 26 festgenommenen Demonstranten waren nur acht Studenten. Mehrere Verlage drohen eine Gegenmesse, sollten die Festgenommenen nicht unverzüglich wieder freigelassen werden. Demonstranten seien am Polizeipräsidium mit Hitlergruß und lauten Sieg-Heil-Rufen vorbeigegangen. Im SDS gibt es intern Vorwürfe, Daniel Cohn-Bendit seinem Schicksal überlassen zu haben. Dieser war als einziger über die Absperrung vor der Paulskirche gesprungen. Scharfe Kritik an den Demonstrationen vor der Paulskirche kam vom Frankfurter AStA. ","Haftbefehl gegen Cohn-Bendit wegen schweren Landfriedensbruchs/ Vorwurf des Landfriedensbruchs","","Brundert: Auf Senghor war Attentat geplant","lh./ Nea.",[1],4,[1],[2],2,"22","1,5"],["4495","1968-09-24","Schwere Kritik an den Ausschreitungen zur Verleihung des Friedenspreises des Deutschen Buchhandels an Senghor, die Demonstrationen gegen ausländische Staatsgäste habe Deutschlands Ansehen genauso geschadet wie die Wahlerfolge der NPD, die Demonstranten hätten den Geist des Grundgesetzes und des Völkerrechts verletzt. Dazu eine Karikatur: Linke Demonstranten gießen die Pflanze NPD, welche im Topf SDS gedeiht.","Gastfreundschaft","Zum Tage","","W.H.-E.",[1],4,[5,4],[2],1,"22","2"],["4496","1968-09-24","Dr. Otto Wenzel, Vorstandsmitglied des Demokratischen Klubs, spricht sich vehement gegen eine Drittelparität oder noch weitergehende Forderungen an den Universitäten aus. Dies nütze nur den radikalen Kräften an der Universität. Aus Sorge um die Demokratie müsse man die Forderung nach \"Demokratisierung\" zurückweisen.","Paralysiert die \"Drittelparität\" die Hochschulen? ","Aus Briefen an die Redaktion","","Leser",[4],4,[6],[2],2,"22","8"],["4497","1968-09-24","Über die Proteste auf der Frankfurter Buchmesse. Die APO sei momentan schwach und zerstritten, auch Cohn-Bendit sei am Anfang nicht viel eingefallen, seine Aktionen seien kläglich gewesen.  Erst die Gegenwehr von Polizei und Messeführung bewirkte wieder revolutionären Elan bei den Demonstranten.","Bücher, Krawall und Polizei","","","Jost Nolte",[1],4,[5],[2],2,"22","11"],["4498","1968-09-24","Wissenschaftssenator Stein nimmt Stellung zur Kritik von mehreren Professoren und Dozenten der FU, nach der die Empfehlung des Senats, Reformexperimente zuzulassen, die \"Verwirklichung der Drittelparität\" anstrebe. Er widerspricht auch der Kritik, dass der Senat in die Autonomie der Hochschule eingreife.","Autonome Rechte bleiben gewahrt","","Prof. Stein nimmt Stellung zur Kritik der FU-Dozenten","tw",[4],4,[1],[2],2,"22","13"],["4499","1968-09-25","Die Forderung der Drittelparität wird verspottet, dies sei Standesdünkel, die Universität habe doch auch Angestellte und Arbeiter, deshalb müsse wenn schon die Viererparität das \"Ideal der totalen Volldemokratie\" sein.","Viertelparität","Zum Tage","","W. G.",[4],4,[5],[2],2,"24","2"],["4500","1968-09-25","Auftakt der \"Justizkampagne\" des SDS. Etwa hundert Personen versuchten im Frankfurter Justizgebäude zu demonstrieren, forderten u.a. Freiheit für Cohn-Bendit. Ein Rechtsanwalt eines angeklagten Demonstranten distanzierte sich von den Protesten.","SDS begann mit der Justizkampagne","","","Nea.",[1],4,[1],[2],2,"24","3"],["4501","1968-09-25","Die SPD-Fraktion im hessischen Landtag kritisiert scharf die Demonstrationen vor der Frankfurter Paulskirche und auf der Buchmesse. Dies seien keine Demonstrationen mehr gewesen, sondern \"Ausschreitungen krimineller Art\".","SPD: Ausschreitungen von krimineller Art","","","lh.",[1],4,[1],[2],2,"24","6"],["4502","1968-09-25","Diskussion im Rahmen der Frankfurter Buchmesse zum Thema \"Wer manipuliert die Literatur?\", u.a. mit Golo Mann, diversen Verlegern und SDS-Vertretern. Diskussion über die Verleihung des Friedenspreises an Senghor. Senghor-Laudator Bondy kritisiert den SDS, dass dieser zu wenig Sachkenntnis bei seinem Protest bewiesen habe, Senghor sei Marxist und mit Fanon befreundet. Zudem würden die Verleger mittlerweile etliche Bücher herausgeben, die der SDS wünsche, aber anscheinend nicht die, die der SDS auch brauche. Demarche von Verlegern wegen des Polizeieinsatzes auf der Messe. Die wirkliche Kriegserklärung an die \"geschäftstüchtigen Pseudolinken\" sei ausgeblieben.","Wer manipuliert die Literatur?","","Verleger, Schriftsteller und der studentische Protest - Diskussion im Rahmen der Buchmesse","Rudolf Krämer-Badoni",[1],4,[1],[3],2,"24","12"],["4503","1968-09-26","Daniel Cohn-Bendit ist wegen seiner Beteiligung bei den Demonstrationen vor der Frankfurter Paulskirche in Untersuchungshaft genommen worden.","Cohn-Bendit in Haft","Kurz berichtet","","",[1],4,[1],[2],2,"24","3"],["4504","1968-09-26","Der hessische Justizminister Strelitz nimmt Stellung zu der begonnenen \"Justizkampagne\" des SDS. Er kündigt ein schärferes Vorgehen der Polizei bei weiteren Demonstrationen und Störungen in Justizgebäuden an, es gehe dem SDS nur darum, die Ordnung zu stören. Strelitz hätte auch beim Auftakt der Justizkampagne am vorigen Dienstag bereits einen Polizeieinsatz befürwortet. Kritik am Landgerichtspräsidenten Wassermann, der mit den Demonstranten diskutierte und die Justiz zur \"Antiautorität\" zählte.","\"Unabhängigkeit der Justiz schützen\"","Hessen","Minister Strelitz kritisiert Krawalle im Gerichtsgebäude","lh.",[1,8],4,[1],[2],2,"24","3"],["4505","1968-09-26","Empfehlungen von Senator Stein für einen Gesetz zur Umsetzung von Reformen in Universitätsinstituten. Die Studentenvertreter kritisieren die Empfehlungen als Eingriff in die Autonomie der Universitäten, man müsse den Instituten völlige Freiheit lassen. Die SPD sieht die Kritik als Beweis, dass dem AStA \"die Felle wegschwimmen\", da ihm mit Reformen seine Grundlage entzogen wird. Seine Aktionen  seien deshalb auch bloße Negation gewesen. Die TU-Studentenvertretung fordert nun sogar die Halbparität. Kritik auch von Professoren an den Empfehlungen.","Die Macht des Senats soll begrenzt werden","Universitäten","Grünes Licht für Reformen?","Bi.",[4],4,[1],[3],1,"24","5"],["4506","1968-09-26","Diskussionsveranstaltung der Fachschaft Chemie an der Universität Frankfurt. Der eingeladene hessische Kultusminister Schütte erscheint nicht. Ausführlich über die Zustände am Chemie-Institut.","Schütte kam nicht ins explosive Chemie-Institut","Hessen","Protestversammlung in der Universität Frankfurt","Nea.",[4],4,[1],[1],1,"24","5"],["4507","1968-09-26","Zu den Demonstrationen auf der Frankfurter Buchmesse und der Reaktion der Messeleitung werden zwei unterschiedliche Resolutionen von Verlegern veröffentlicht. Während die einen den Polizeieinsatz und die vorübergehende Schließung der Messe kritisieren, empfanden die anderen diese Maßnahmen als notwendig.","Verleger blieben zerstritten","Wie die Buchmesse ausklang","Gegensätzliche Resolutionen machten in Frankfurt die Runde","",[1],4,[1],[5],2,"24","9"],["4508","1968-09-27","Leserbrief von Helmut Schauerte vom RCDS. Die letzte Bundesdelegiertenversammlung des SDS habe zwar gezeigt, dass dieser unheilbar zerstritten sei. Das bedeute jedoch nicht, dass der \"Spuk\" des SDS nun vorbei sei. Vielmehr existiere mittlerweile allzeit bereite Proteststimmung. Kritik an der Politik, diese müsse endlich aus ihren Fehlern lernen und mit vernünftiger Politik dem Treiben des SDS Einhalt gebieten.","Allzeit bereite Proteststimmung","Aus Briefen an die Redaktion","","Helmut Schauerte (RCDS), Leser",[8],4,[6],[2],2,"26","2"],["4509","1968-09-27","Die Bundesregierung will möglichen Zersetzungsversuchen des SDS bei der Bundeswehr entgegentreten.","Zersetzungsversuchen des SDS soll begegnet werden","","","",[1],4,[1],[2],2,"26","5"],["4510","1968-09-27","Forderung der Studenten der Ingenieur-Akademien nach Reformen.","Ingenieur-Studenten drängen zur Eile","Bildungsreform","\"Kollegs\" sollen schon 1969 mit dem Unterricht beginnen","Or.",[4],4,[1],[2],2,"26","5"],["4511","1968-09-27","Entwurf des bayerischen Kultusministers Huber (CSU) für ein neues Hochschulgesetz. Er plädiert u.a. für eine Präsidialverfassung und gegen die Drittelparität, ist aber für mehr  Mitsprache.","Im Mittelpunkt stehen die Fachbereiche","Bayern","Kultusminister Huber erläutert sein Hochschul-Konzept","pff",[4],4,[1],[1],1,"26","5"],["4512","1968-09-28","Lob für den Gesetzesentwurf des bayerischen Kultusminister Huber für ein neues Hochschulgesetz, indirekte Kritik an den Reformplänen in Hessen und Berlin. Drittelparität wäre Danaergeschenk und modische Extravaganz.","Bayern - modern","Zum Tage","","W. G.",[4],4,[5],[2],2,"34","2"],["4513","1968-09-28","Wegen Aufruhrs, schweren Hausfriedensbruchs, Landfriedensbruchs und Beamtennötigung im Zuge der Demonstration vor der Frankfurter Paulskirche wurde Daniel Cohn-Bendit zu acht Monaten Gefängnis mit Bewährung verurteilt. Cohn-Bendit erklärte, er habe in der Paulskirche eine Gegenlaudatio gegen den senegalesischen Präsidenten Senghor halten wollen, der ihm als Friedenspreisträger unwürdig erschienen sei. Sein Anwalt kündigte an, in Berufung zu gehen.","Cohn-Bendit verurteilt","","Acht Monate mit Bewährung","Nea.",[1],4,[1],[2],1,"34","7"],["4514","1968-09-30","Laut dem \"Extra-Dienst\" haben verschieden Gruppen der APO Geld gesammelt und dafür Waffen für die FNL gekauft.","Linksextremisten kaufen Waffen für den Vietkong","","","Bi.",[11],4,[1],[2],2,"24","1"],["4515","1968-09-30","Kritik der hessischen CDU an der SPD, u.a. werfen sie dieser vor, dass sie den SDS verharmlost und so den Unruhen Vorschub geleistet zu haben. Viele Funktionäre der SPD seien auf dem linken Auge blind. In einer Resolution wird nur der SDS namentlich als Feind der Demokratie bezeichnet. Kritik auch am Hochschulgesetzesentwurf von Kultusminister Schütte (SPD).","Dregger: Viele Funktionäre sind auf dem linken Auge blind","Hessen","CDU tritt zum Angriff auf die SPD an","Ludwig Harms",[1],4,[1],[5],2,"24","5"],["4516","1968-09-30","Weil rund 40 Prozent der Studenten der FU Berlin bei ihrer Rückmeldung die Gebühren für die studentische Selbstverwaltung nicht gezahlt haben, muss der AStA der FU seine Ausgaben eventuell drastisch einschränken. Das Kuratorium der FU ist nicht gewillt, die fehlenden Einnahmen durch öffentliche Mittel auszugleichen. Zudem beschloss das Kuratorium, einen zweiten Lehrstuhl für Japanologie zu bewilligen, um so den lange schwelenden Konflikt am Ostasiatischen Seminar zu entschärfen.","AStA der FU muß sparen","","Viele Studenten zahlen nicht","Bi.",[4],4,[1],[2],2,"24","6"],["4517","1968-10-01","Über die bevorstehende Flut von Prozessen wegen der Osterunruhen. Die Richter hätten es schwer, weil die zu Grunde liegenden Gesetze teils aus dem 19. Jahrhundert stammen. In Frankfurt seien mehr Ermittlungen gegen Polizisten als gegen Demonstranten eingeleitet worden. Um einen reibungslosen Ablauf der Prozesse zu garantieren, wird ein entschlossenes Auftreten der Justiz gegen Störungen im Rahmen der Justizkampagne des SDS gefordert.","Die Autorität der Justiz","","Das Nachspiel der Oster-Krawalle","Hans Schueler",[1],4,[5],[2],2,"20","2"],["4518","1968-10-01","Senegals Staatspräsident Senghor bezeichnete die gegen ihn gerichteten Demonstration wegen der Verleihung des Friedenspreises als Ausdruck des \"Kolonialismus und Rassismus gewisser linksgerichteter Gruppen\". Dabei sei es aber nicht allein um seine Person gegangen, man hätte auch demonstriert, wenn ein Eskimopräsident an seiner Stelle dagewesen wäre.","Senghor: Auch wenn's ein Eskimo gewesen wäre?","","","",[1],4,[1],[2],2,"20","4"],["4519","1968-10-02","Der Freispruch von Karl-Heinz Kurras wegen des Vorwurfs der fahrlässigen Tötung von Benno Ohnesorg wurde vom Bundesgerichtshof aufgehoben. Wegen des Versäumnis der Vernehmung eines Zeugen, der widersprüchliche Aussagen von Kurras widerlegen könnte, soll neu verhandelt. Es geht dabei um die Frage, ob ein oder zwei Schüsse abgegeben wurden.","Neue Verhandlung gegen Karl-Heinz Kurras","","","fa.",[1],4,[1],[2],2,"28","3"],["4520","1968-10-02","Die hessische FDP-Fraktion hat einen Entwurf für ein Hochschulgesetz vorgelegt. Eine Drittelparität wird strikt abgelehnt, die Umwandlung der Universität in eine Präsidialordnung befürwortet.","FDP legt Hochschulgesetz-Entwurf vor","Hessen","\"Drittelparität\" abgelehnt - Landeskuratorium vorgeschlagen","lh.",[4],4,[1],[2],2,"28","5"],["4521","1968-10-02","Die Ingenieurstudenten Bayerns beenden nach drei Monaten ihren Vorlesungs- und Prüfungsboykott. Die Mißverständnisse über die angestrebte Reform des Ingenieurschulwesens seien in einem Gespräch mit dem bayerischen Kultusminister Huber ausgeräumt worden.","Ingenieur-Studenten beenden Streik","Bayern","Ausgefallene Examen werden am Semesteranfang nachgeholt","pff",[4],4,[1],[3],1,"28","5"],["4522","1968-10-02","Schwere Ausschreitungen vor dem Berliner Kriminalgericht im Zuge eines Prozesses gegen einen persischen Studenten, der als Rädelsführer der Unruhen vor der Deutschen Oper am 2. Juni 1967 angeklagt ist. Die Verhandlung an sich wurde unterbrochen, da die Anklageschrift nicht in persischer Schrift vorlag. In einem weiteren Prozess wird die Klage eines Studenten gegen den Polizeipräsidenten verhandelt. Gegenstand ist die Frage, ob die Anwendung des polizeilichen Schlagstocks ihm gegenüber rechtswidrig war. Hier kam es noch zu keinem abschließenden Urteil.","Polizei trug Jugendliche aus dem Saal","","Prozeß gegen persischen Studenten vertagt - Aus Moabit","fa.",[1],4,[1],[2],2,"28","13"],["4523","1968-10-03","Matthias Walden sieht sich in seiner pessimistischen Sicht des SDS der letzte Jahre und des vorhergesagten Scheiterns der Neuen Linken bestätigt, will dies aber auch nicht als Triumph verstehen. Gerade linksliberale Sympathisanten wie Günter Grass oder auch die Journalisten der \"Zeit\" würden diese Einsicht mittlerweile teilen, ohne dies jedoch öffentlich direkt zugeben zu wollen. Das Schablonendenken würde allmählich abnehmen.","Einsicht und zerbrochene Schablonen","","Konfusion bei der \"neuen Linken\"","Matthias Walden",[1],4,[5],[5],2,"22","2"],["4524","1968-10-03","Kampagne Tübinger Studenten gegen die Pflichtzahlung des Beitrags zur studentischen Selbstverwaltung. Bereits im Sommersemester verweigerten etwa 1000 der 11.000 Studenten die Zahlung des Beitrags. Laut Gerichtsurteil darf der AStA bis zur endgültigen gerichtlichen Klärung der Frage nichts gegen die Beitragsverweigerung unternehmen.","Tübinger Studenten verstärken Kampagne","","Gegen Zahlung der AStA-Beiträge","tr.",[4],4,[1],[2],2,"22","5"],["4525","1968-10-03","Die Immatrikulationsveranstaltung für Studienanfänger an der TU Braunschweig soll ohne feierliches Zeremoniell abgehalten werden, d. h. auch ohne Anlegen der Talare.","Immatrikulation ohne Zeremoniell und Talar","","","P.W.",[4],4,[1],[2],2,"22","5"],["4526","1968-10-03","Bericht über die Situation der Bundeswehr. Es wird eine zunehmende Anzahl an Wehrdienstverweigerern konstatiert, insbesondere die Verweigerer, die dies erst nach Einzug in die Kasernen tun, werden in den Zusammenhang mit der Bundeswehrkampagne des SDS bzw. der APO gebracht. Schilderung eines Vorfalls, bei dem der Oberleutnant der Reserve Hanner bei der Erteilung von staatsbürgerlichen Unterricht bekannte, dass er aktiv in der APO und maßgeblich bei den Osterunruhen in Berlin beteiligt gewesen sei, wofür er auch im Gefängnis gesessen habe.  Das Ziel von ihm und der APO sei die Bekämpfung der Bundeswehr von innen. Es wird mit zunehmenden ähnlichen Fällen gerechnet. Auch die gezielte Wehrdienstverweigerung könne eine erhebliche Beeinträchtigung der Bundeswehr bedeuten. Rainer Langhans sollen Rang und Würde eines Offiziersanwärters von der Bundeswehr aberkannt werden.","Nein zum Wehrdienst aus \"gewissen Gründen\"","Verteidigung","Ein schwieriges Problem für Bonn","Nils v. d. Heyde",[9],4,[1],[1],1,"22","5"],["4527","1968-10-03","Vertreter der Universitäten und der Studentenschaft debattierten vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses über das geplante \"Vorschaltgesetz\", nach dem zur Erprobung Reformen an den Universitätsinstituten auch bereits vor dem eigentlichen Hochschulgesetz umgesetzt werden können, ohne dass der Akademische Senat zustimmen muss. Der Rektor der TU Berlin, Wever, begrüßt dies und kündigt die Mitarbeit seiner Uni an. Studenten der TU bemängeln, dass die als Einschränkung die ungestörte Arbeit der Uni vorausgesetzt wird.  Störungen könnten nützlich für Reformen sein. FU-Rektor Harndt hat Bedenken gegen die zeitlichen Begrenzung der Reformsatzungen. Der VdS will, dass Professoren Teile ihrer Macht zu Gunsten der Studenten aufgeben. Zudem weitere Forderungen des VdS wie die Möglichkeit selbständiger Forschung für Studenten.","TU will Universitäts-Vorschaltgesetz verwirklichen","","Diskussion vor dem parlamentarischen Ausschuß für Wissenschaft und Kunst","el",[4],4,[1],[3],2,"22","11"],["4528","1968-10-04","Kritik am Föderalismus der Hochschulgesetze. Die geplanten Gesetze in Hessen und Berlin seien eine Flucht nach vorn, um die Anarchie unter den Studenten einzudämmen. Gekennzeichnet seien sie durch Modernitätssucht. Kritik an Drittelparität und Präsidialverfassung. Die Gesetze in Hessen und Berlin tragen die Gefahr in sich, dass die Professoren nicht mehr an deutschen Universitäten lehren und forschen wollen. Befürchtet Präzedenzfälle, stattdessen solle man sich lieber an den neuen Gesetzen in Baden-Württemberg und Bayern orientieren.","Jedem sein Hochschulgesetz","","In Hessen und Berlin. Gefährliche Präzedenzfälle. Niedergang der Universität.","Walter Görlitz",[4],4,[1],[1],2,"24","2"],["4529","1968-10-04","Horst Mahler hat sein Mandat als Verteidiger des wegen zweifachen Hausfriedensbruchs angeklagten Fritz Teufel niedergelegt. Teufel hatte im Prozess ein \"theatralisches\" Geständnis abgelegt und u.a. Mahler und Dutschke ironisch als seine \"Verführer\" bezeichnet. Der eigentliche Grund der Niederlegung seien jedoch zunehmende Differenzen zwischen Mahler und der APO.","Mahler verteidigt Teufel nicht mehr","","Angeklagter spielt reuigen Sünder","fa.",[5],4,[1],[2],2,"24","6"],["4530","1968-10-04","Im ersten Prozess gegen einen Beteiligten an den Frankfurter Osterunruhen wurde dieser aus Mangel an Beweisen freigesprochen. Auch in Köln endete ein Verfahren gegen drei Studenten wegen Aufruhrs mit Freispruch.","Freisprüche von der Anklage des Aufruhrs","","","",[1],4,[1],[2],2,"24","6"],["4531","1968-10-04","Der Frankfurter Landgerichtspräsident Wassermann warnt den SDS vor der Fortsetzung seiner Justizkampagne. Damit habe der SDS endgültig den Anspruch verspielt, Motor des Fortschritts zu sein. Vielmehr erweise sich der SDS als autoritär.","Wassermann: Der SDS ist autoritär","","Warnung vor \"Justiz-Kampagne\"","P. W.",[1,8],4,[1],[2],2,"24","6"],["4532","1968-10-04","Sechs Professoren (Sontheimer, Schwan, Herzog, Ziebura, Schramm, Skuhr) äußerten sich vor dem Ausschuss für Wissenschaft und Kunst des Berliner Abgeordnetenhauses zum Universitätsvorschaltgesetz. Kritik und Zustimmung.","Professoren äußerten sich","","","",[4],4,[1],[2],2,"24","9"],["4533","1968-10-05","Die Kultusminister der Länder lehnen eine Drittelparität an den Hochschulen ab. Neue Richtlinien für Berufungsverfahren und vereinheitliche Rahmenordnungen für Diplomprüfungen.","Kultusminister lehnen Forderung nach Dritteparität weiter ab","Hochschulen","Berufungsverfahren für Professoren neu geregelt","D.",[4],4,[1],[2],2,"32","3"],["4534","1968-10-08","Fritz Teufel ist wegen zweifachen Hausfriedensbruchs zu einer Haftstrafe von sieben Monaten verurteilt worden. Zwei Mitangeklagte (Gebbert und Schlotterer) erhielten je fünf Monate Gefängnis. Von einer Bewährung sah das Gericht ab, da das öffentliche Interesse die Strafvollstreckung erfordere. Teufel hatte während des Prozesses fünf Ordnungsstrafen von insgesamt zwölf Tagen Haft erhalten.","Teufel soll sieben Monate ins Gefängnis","","","fa.",[5],4,[1],[2],2,"28","6"],["4535","1968-10-08","Der Prozess des Axel-Springer-Verlags gegen Horst Mahler vor dem Landgericht wegen Geltungmachung von Schadensersatz in Höhe von 506.000 DM, entstanden durch die Osterunruhen vor und in dem Verlagsgebäude, musste abgebrochen werden, da eine Originalfilmkopie des SFB von den Ereignissen nicht rechtzeitig beschafft werden konnte. Mahlers Anwalt wies die Beschuldigung, sein Mandant sei in das Verlagsgebäude eingedrungen, zurück. Vielmehr sei er von nachrückenden Demonstranten hineingedrängt worden.","Originalfilm muß beschafft werden","","Prozeß gegen Mahler kam gestern wenig voran","vc",[6],4,[1],[2],1,"28","13"],["4536","1968-10-08","Das Universität-Vorschaltgesetz soll bereits in der nächsten Sitzung des Berliner Abgeordnetenhauses verabschiedet werden. Auch immer mehr Professoren würden das Vorhaben begrüßen. Die SPD erwartet sich davon, dass eine Konsolidierung der Universitätssituation eintritt.","Kurz vor der Verabschiedung","","Universitäts-Vorschaltgesetz bereits eingehend erörtert","hae",[4],4,[1],[2],2,"28","13"],["4537","1968-10-08","Der VDS kündigte an, die in Berlin beginnende Deutsche Germanistentagung \"umfunktionieren\" zu wollen. Kritik am offiziellen Tagungsprogramm.","Germanistentagung in Gefahr","","","",[1],4,[1],[2],2,"28","14"],["4538","1968-10-09","Wegen einer Podiumsbesetzung durch Studenten musste die Dienstag-Veranstaltung der Germanisten-Tagung vorzeitig abgebrochen werden.","Germanistik-Veranstaltung vorzeitig abgebrochen","","","",[1],4,[1],[3],2,"22","1"],["4539","1968-10-09","Nach einem Urteil des Berliner Verwaltungsgerichts habe die Berliner Polizei keine Rechtsgrundlage für den Schlagstockgebrauch. Hintergrund war eine Klage eines Demonstranten vom 2. Juni 1967.","\"Schlagstockgebrauch war ohne Rechtsgrundlage\"","","","fa.",[1],4,[1],[3],2,"22","1"],["4540","1968-10-09","Karikatur. Während Vertreter der \"großen\" Parteien ein Verbot der NPD debattieren, steht ein Vertreter der APO daneben mit einer Bombe in der Hand und streckt dem NPD-Vertreter, der durch eine Linie von den Anderen getrennt und mit einer Zwille bewaffnet ist, die Zunge heraus.","Die NPD muss weg ... aber wie?","","","Hartung",[11],4,[5,4],[2],1,"22","2"],["4541","1968-10-09","Günter Grass befürchtet ein Bündnis der extremen Rechten und Linken, wenn es darum ginge, der SPD zu schaden. Dies könne tödlich für die Demokratie sein. Den SDS nannte er pseudorevolutionär, diesem ginge es um den Staatsstreich.","Grass nennt SDS pseudorevolutionär","","Warnung vor Bündnis","",[8],4,[1],[2],2,"22","6"],["4542","1968-10-09","Der VDS hat die Verbesserung der Förderung nach dem Honnefer Modell als gänzlich unzureichend kritisiert. ","VDS kritisiert scharf das neue \"Honnefer Modell\"","","","",[4],4,[1],[2],2,"22","6"],["4543","1968-10-10","An der Göttinger Universität wird es estmals keine Immatrikulationsfeier geben, nachdem es im vorigen Semester zu Studentenprotesten kam.","Keine Immatrikulationsfeier","Kurz berichtet","","P.W.",[1],4,[1],[2],2,"26","3"],["4544","1968-10-10","Eine Rede Rainer Barzels in Schwarzenbek wurde von Demonstranten verhindert, indem diese den Veranstaltungssaal stürmten.","Demonstranten stürmen Saal nach Barzel-Rede","Parteien","Aktion in Schwarzenbek","H.A.",[11],4,[1],[2],2,"26","5"],["4545","1968-10-10","Der Kommunarde Reinhard Wetter wurde wegen schweren Landfriedensbruchs, fortgesetzten erschwerten Hausfriedensbruchs und Aufruhrs in einem Berufungsverfahren zu acht Monaten Gefängnis ohne Bewährung verurteilt. Zuvor war er zu 12 Monaten Haft verurteilt worden. Es kam mehrmals zu Störungen im Justizgebäude, weshalb die Öffentlichkeit aus dem Prozess ausgeschlossen wurde.","Acht Monate Jugendstrafe für Kommunarden","Krawalle","Wegen Landfriedensbruchs","",[1],4,[1],[2],2,"26","5"],["4546","1968-10-10","Über die Germanistentagung in Berlin. Den Studenten sei es weitestgehend gelungen, die Tagung und auch die Vorstellungen der Teilnehmer \"umzufunktionieren\". Waren die Kritiker der Störungen anfangs noch deutlich in der Mehrheit unter den Tagungsteilnehmern, so habe sich dies mittlerweile rasch geändert.","Die austauschbaren Minderheiten","","Notizen vom Germanistenkongreß","Lucie Schauer",[1],4,[1],[3],2,"26","10"],["4547","1968-10-10","Übergabe des Klinikums der FU Berlin. Dabei kam es zu Demonstrationen vor dem Klinikum. Der AStA der FU begründete diese damit, dasss das Ordninarienprinzip beibehalten worden sei und dass zu wenig Mitbestimmung am Klinikum existiere. ","Symbol einer Freundschaft","","Klinikum-Übergabe an die FU beendet Arbeit der Benjamin-Franklin-Stiftung","co/bi",[1],4,[1],[1],2,"26","11"],["4548","1968-10-11","Erneut musste eine Veranstaltung der Germanisten-Tagung vorzeitig abgebrochen werden. Studenten und Schüler wollten eine Diskussion über politische Vorfälle in der Schule erreichen.","Tumulte auf dem Germanisten-Kongreß","","","",[1],4,[1],[3],2,"26","1"],["4549","1968-10-11","Ausführlich über den Germanistentag. Am Vortag sei dieser ruhig verlaufen, im Gegensatz zum Mittwoch.","Einsichten","","Der Gemanistentag geht weiter","Lucie Schauer",[1],4,[1],[2],2,"26","9"],["4550","1968-10-11","Gegen die Stimmen der CDU-Fraktion verabschiedeten SPD und FDP im Berliner Abgeordnetenhaus das sogenannte Universitäts-Vorschaltgesetz, dass es ermöglich soll, Reformsatzungen vor der Verabschiedung des eigentlichen Universitätsgesetzes an Insituten zu erproben. Stellungnahmen von Politikern zum Gesetz.","Reformversuche an TU und FU können beginnen","","Parlame nahm Gesetz gegen die Stimmen der CDU an","hae/ vc",[4],4,[1],[1],2,"26","11"],["4551","1968-10-14","Etwa 30 Studentinnen des SDS stürmten eine Jubiläumsveranstaltung zu 50 Jahren Frauenwahlrecht.","Demonstration in der Paulskirche","Kurz berichtet","","",[1],4,[1],[2],2,"24","3"],["4552","1968-10-14","Entgegnung von Wissenschaftssenator Stein auf einen Kommentar von Walter Görlitz vom 4.10.1968 in der WELT. Er weist die Kritik an dem Vorschaltgesetz für Reformsatzungen an den Universitätsinstituten zurück, wichtige Fakten seien unterschlagen und Motive verfälscht worden.","Berliner Universitätsmaßnahmen kein Patentrezept","Aus Briefen an die Redaktion","","Prof. Dr. Werner Stein (Leserbrief)",[4],4,[6],[1],2,"24","16"],["4553","1968-10-14","Ausführlich zum Deutschen Germanistentag. Kritik an den Veranstaltern, dass sie den Studenten nicht von Beginn mit Diskussionsbereitschaft begegnet sind. Kritik auch an den Professoren, die erst gar nicht gekommen sind.","Die zwei Gangarten der Reform","","Studenten contra Professoren beim Germanisten-Kongreß - Aufschlußreiches Referat zur Literatur-Soziologie","Lucie Schauer",[1],4,[1],[5],2,"24","16"],["4554","1968-10-15","Die SED Westberlin sucht die erneute Kontaktaufnahme zum SDS. Man solle sich unbeschadet verschiedener Auffassungen wie bspw. über die Ereignisse in der CSSR nicht auseinander manövrieren lassen. Kritik aber an der letzten Delegiertenkonferenz des SDS und den Ausschluss der sogenannten KP-Gruppe.","SED sucht wieder Kontakte zum SDS","","","Bi.",[9],4,[1],[3],2,"26","7"],["4555","1968-10-15","Prozeßauftakt wegen der Kaufhausbrandstiftung in Frankfurt/Main. Angeklagt sind Baader, Ensslin, Proll, Söhnlein. Alle verweigern die Aussage. Der SDS ist nicht zum Prozess erschienen. Ordnungsstrafen gegen Baader, Proll und Söhnlein. Auch zu den Werdegängen der Angeklagten. Zu den Verteidigern zählen Mahler und Schily.","Die drei Männer erhielten zunächst drei Tage Ordnungsstrafe","","Auftakt im Frankfurter Kaufhausbrandstifter-Prozeß","Joachim Neander",[9],4,[1],[1],1,"26","22"],["4556","1968-10-16","Der AStA der TU Hannover protestiert mit einer Denkschrift gegen den Numerus Clausus.","AStA protestiert gegen Numerus clausus","","","P. W.",[4],4,[1],[3],2,"28","5"],["4557","1968-10-16","Prozeßauftakt in Köln gegen den früheren AStA-Vorsitzenden der Uni Köln, Klaus W. Laepple, und seinen damaligen Pressereferenten Lutzenberger. Beiden wird vorgeworfen, verantwortlich für die Demonstration gegen die Fahrpreiserhöhung in Köln im Oktober 1966 gewesen zu sein. ","Laepple: Ich hatte der Polizei den Sitzstreik angekündigt","","Prozeß um die Demonstrationen in Köln","Alfred Freudenhammer",[1],4,[1],[1],2,"28","24"],["4558","1968-10-16","Über den 2. Prozesstag gegen die mutmaßlichen Brandstifter Baader, Ensslin, Söhnlein und Proll. Alle verweigern nach wie vor ihre Aussage. Zeugenvernehmung. Außer den Nachtwächtern seien auch noch fünf Handwerker zum Tatzeitpunkt im Gebäude gewesen, wichtig für die Frage der Menschengefährdung.","Nun stehen alle bei einer Vereidigung auf","","","Nea.",[9],4,[1],[2],2,"28","24"],["4559","1968-10-17","Forderung nach Umsetzung von Hochschulreformen, gerade die Hochschullehrer hätten nun die Chance, den \"studentischen Extremisten\" mit konstruktiven Vorschlägen entgegenzutreten. Schuld an den schleppenden Reformen sei u.a. auch die Bürokratie und der Föderalismus. Nicht an den Strukturen, sondern an der Praxis im Alltag solle man mit Reformen beginnen.","Reformieren - nicht nur diskutieren","","Chancen des Wintersemesters. Eine Prüfung für die Professoren. Bessere Studienbedingungen nötig.","Hans-Erich Bilges",[4],4,[5],[1],2,"26","2"],["4560","1968-10-17","Der AStA der Uni Köln ist aus Protest der Wahl Prof. Hübners zum neuen Rektor der Uni zurückgetreten. Man kritisierte, dass die Wahl ohne Beteiligung der Studenten stattfand. Aus dem gleichen Grund beantragten zwei Studenten auch eine einstweilige Verfügung, die dem Rektor die Führung der Amtgeschäfte untersagen soll.","Kölner AStA tritt wegen Wahl des Rektors zurück","","","pt.",[1],4,[1],[2],2,"26","5"],["4561","1968-10-18","Laut ÖTV wurden im Jahr 1968 mehr als 400 Polizisten bei Demonstrationen und Unruhen verletzt, davon 36 schwer.","Mehr als 400 Polizeibeamte bei Unruhen verletzt","","Nach Feststellung der ÖTV","pff",[1],4,[1],[2],2,"28","6"],["4562","1968-06-01","NRW-Kultusminister hält Hochschulreform für Sache der Länder, die sich jetzt einigen müssten. Macht Vorschläge für neun Grundsätze.","Hochschulreform durch Staatsverträge","Bildungswesen","Gespräch der WELT mit Kultusminister Fritz Holthoff","Alfred Freudenhammer",[4],4,[1],[1],1,"32","5"],["4563","1968-06-01","OSI will sich richtungweisend für die Hochschulreform reformieren.","Otto-Suhr-Institut wird reformiert","Berlin","Professoren, Assistenten und Studenten ergreifen die Initiative","Co.",[11],4,[1],[2],2,"32","5"],["4564","1968-06-01","Nach Räumung des Germanischen Seminars der FU bietet sich ein Bild der Verwüstung. Wände beschmiert, Unterlagen verschwunden. Kommunarden schweigen.","Zurück blieben nur die Parolen der Besatzer","Die Lage in den deutschen Universitäten hat sich beruhigt","Germanisches Seminar wieder frei","v.C.",[11],4,[1],[2],2,"32","8"],["4565","1968-06-01","Gymnasien arbeiten wieder normal. SDS-Räume durchsucht. Polizei in der Frankfurter Uni.","\"Mit allen Mitteln den Unterricht sicherstellen\"","Die Lage in den deutschen Universitäten hat sich beruhigt","Schulbetrieb in Frankfurt normal","lh.",[11],4,[1],[2],1,"32","8"],["4566","1968-06-01","Suspendierter Asta bittet um Geldspenden, da seine Konten gesperrt sind.","Heidelberger AStA wartet nicht auf Urabstimmung","","","uhl.",[11],4,[1],[2],2,"32","8"],["4567","1968-06-01","Kein Widerstand bei Räumung des Aktionszentrums der Münchner Uni","Münchner Rektor ließ \"Aktionszentrum\" räumen","","","pff",[11],4,[1],[2],2,"32","8"],["4568","1968-06-04","Foto vom Ohnesorg-Gedenken ein Jahr nach seinem Tod","Ein Jahr nach dem Tod von Benno Ohnesorg","","","",[7],4,[1],[3],1,"22","1"],["4569","1968-06-04","Professoren sehen in diesem Semester keine Möglichkeit mehr zur gedeihlichen Arbeit.","Deutsche Professoren klagen: Forschung und Lehre behindert","","Durch Unruhe an Hochschulen - \"Die Arbeit gedeiht nicht\"","E.D.",[1],4,[1],[5],2,"22","1,3"],["4570","1968-06-04","Nach Ende der Besetzung der Frankfurter Uni Ernüchterung und Ratlosigkeit beim SDS und den Studenten des Umfelds.","Plötzlich stand der SDS allein","","Die Vorgänge in Frankfurt haben auch vielen \"Rebellen\" die Augen geöffnet","Ludwig Harms",[8],4,[5],[5],1,"22","2"],["4571","1968-06-04","Uni soll besetzt bleiben bis AStA-Suspendierung aufgehoben wird.","AStA Heidelberg gibt nicht auf","","Universität bleibt besetzt","UPI",[11],4,[1],[2],2,"22","3"],["4572","1968-06-04","Pfingsten in Berlin mit Platzkonzerten, Turnfest und friedlich verlaufenden Demonstrationen.","Zehntausende riefen: Berlin lebe hoch","Pfingsten an der Spree","Begeisterung auf dem Kaiserdamm - Toleranz für Demonstranten","Co.",[7],4,[1],[1],2,"22","5"],["4573","1968-06-04","Zum Frankfurter Kongress \"Politik, Protest und Widerstand\" des VDS und SDS kommen statt der erwarteten 10.000 Teilnehmer nur etwa 1.000. ","VDS und SDS erlebten ein Fiasko","","","lh.",[11],4,[1],[2],1,"22","5"],["4574","1968-06-04","Beschreibt die \"Technik\" des Sprengens von Vorlesungen durch eingespielte Gruppen von Aktivisten des SDS und nahestehender Studenten.","Viele \"Wander-Demokraten\" mischen mit","Hochschulen","Ein geschlossener Block, der weiß, was er will: Diskussion oder Abbruch der Vorlesung","Hans-Erich Bilges",[1],4,[1],[3],2,"22","5"],["4575","1968-06-05","Leser kritisiert, dass die Welt Orte und Zeitpunkte von Demonstrationen nennt","Negative Wirkung","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["4576","1968-06-05","Details zur Heidelberger Kontroverse und zur Berechtigung der Forderung eines politischen Mandats der Studentenvertretungen","Heidelberger Studenten haben sich in der Grabengasse verschanzt","Universität","Politisches Mandat im Streit zwischen AStA und Rektorin","uhl.",[11],4,[1],[5],1,"22","5"],["4577","1968-06-05","Kölner Professor wird nach \"Gegen-Happening\" gebeten, sich beurlauben zu lassen. Aufgrund verschiedener Vorkommnisse soll auch seine Zurechnungsfähigkeit untersucht werden.","Professor Rubin soll sich beurlauben lassen","","","pt.",[11],4,[1],[2],2,"22","5"],["4578","1968-06-05","Polizei hat sich aus Uni zurückgezogen. Lehrbetrieb wieder angelaufen.","In Frankfurt heute wieder voller Lehrbetrieb","","","lh.",[11],4,[1],[2],2,"22","5"],["4579","1968-06-05","Prozess gegen fünf Demonstranten bei Schah-Besuch. Demonstrant begründet seinen Eierwurf. - Gegen Bachmann hat die gerichtliche Voruntersuchung begonnen. - Zu Dutschkes Gesundheitszustand nichts Neues.","Rohes Ei als Symbol der Missachtung","","Vorfälle während des Schah-Besuchs vor Gericht - Voruntersuchung gegen Bachmann","fa",[7],4,[1],[3],2,"22","13"],["4580","1968-06-05","JU-Kreisverband unterstützt Linksruck des RCDS","Junge Union Reinickendorf mit RCDS solidarisch","","","",[11],4,[1],[2],2,"22","13"],["4581","1968-06-06","SDS-Mitglied wird wegen mehrerer Vergehen bei Demontrationen zu hoher Freiheitsstrafe verurteilt. Geht in Berufung.","Ein Jahr Gefängnis für Münchener Studenten","","","pff",[1],4,[1],[2],2,"20","6"],["4582","1968-06-07","AStA-Klage gegen Suspendierung von Gericht zurückgewiesen. Auch EV gegen Kontensperrung abgelehnt. AStA tritt zurück.","Zwei Niederlagen waren dem AStA zuviel","Heidelberg","Rücktritt und Selbstkritik nach der gerichtlichen Entscheidung","uhl.",[11],4,[1],[1],2,"26","5"],["4583","1968-06-07","Rektor der Frankfurter Uni will entschiedener gegen Studenten vorgehen, die den Hochschulbetrieb stören.","Rüegg geht jetzt schärfer vor","","Zivilklage angekündigt","lh.",[11],4,[1],[2],2,"26","5"],["4584","1968-06-07","Voraussichtlicher Entlassungstermin Dutschkes in der kommenden Woche. Konnte für Voruntersuchung vernommen werden. Bachmann hat sein erstes Geständnis widerrufen.","Rudi Dutschke wird aus dem Krankenhaus entlassen","","","UPI, dpa",[2],4,[1],[2],2,"26","5"],["4585","1968-06-07","Burschen sprechen sich gegen Radikalisierungstendenzen und Gewalt aus.","Burschenschafter lehnen Gewalt ab","","","UPI",[1],4,[1],[2],2,"26","5"],["4586","1968-06-07","Mit Bilck auf RCDS und CDU stellt Leser die Nachwuchsarbeit der Parteien kritisch in Frage.","Vernachlässigen die Parteien ihren Nachwuchs?","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"26","23"],["4587","1968-06-08","Studenten, die nicht so reichliche Monatswechsel haben, sind die Leidtragen der Streiks an den Unis.","Verlorenes Semester","Aus Briefen an die Redaktion","","Leserin",[1],4,[6],[2],2,"28","2"],["4588","1968-06-08","Bremer Untersuchungsausschuss beschäftigt sich mit den angeblichen Umsturzplänen der Chefs des Beat-Lokals \"Lila Eule\", Ernst Wilhelm Settje.","\"Kinder könnten den Senat in Bremen stürzen\"","","?meinte der Lila-Eulen-Chef","E.D.",[8],4,[1],[3],1,"28","3"],["4589","1968-06-08","Kultusminister erleichtern den Zugang zu den Ingenieur-Akademien","Über die Realschule zur Akademie","Kultusminister","Voraussetzungen für das Ingenieur-Studium festgelegt","P.W., S.",[4],4,[1],[2],2,"28","4"],["4590","1968-06-08","Wissenschaftler wenden sich in einer Entschließung gegen eine Fünftel- oder gar Drittelparität an den Hochschulen. ","Gegen ein Proporz-System an den Universitäten","Hochschulreform","Mehr als 1000 Professoren und Dozenten unterzeichnen \"Marburger Manifest\"","wm",[4],4,[1],[3],2,"28","4"],["4591","1968-06-10","Jugenddeligiertentag des Deutschen Bundesjugendrings tagt ohne die befürchteten Störungen. Lediglich während des Festaktes in der Paulskirche stört der SDS. Belgischer Friedensnobelpreisträger Pater Pire warnt vor Anarchie.","\"Anarchie führt zu Faschismus oder Stalinismus\"","Hessen","Jugend in Frankfurt","Ludwig Harms",[1],4,[1],[2],2,"22","5"],["4592","1968-06-11","Anriss des Artikels auf Seite 5","Dutschke in der Schweiz - Bachmann wollte sich töten","","","",[2],4,[1],[2],2,"22","1"],["4593","1968-06-11","Leser bezieht sich auf Juristen-Leserbrief vom 21. Mai und sieht die Justiz in der Pflicht, auch bei Unruhen mit politischer Ursache einzuschreiten.","Kein Grund zum Einschreiten?","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"22","2"],["4594","1968-06-11","Dutschke aus dem Krankenhaus entlassen und in die Schweiz zur Weiterbehandlung geflogen. Bachmann hatte am Vortag versucht, sich in seiner Zelle zu erhängen. US-Politiker hat beantragt, ein Einreiseverbot gegen Dutschke auszusprechen.","Abflug von Berlin in früher Morgenstunde","","Dutschke zur Kur in die Schweiz","hae.",[2],4,[1],[3],1,"22","5"],["4595","1968-06-11","In einer Zivilklage versucht der Axel Springer Verlag von RA Mahler Schadenersatz für die während der Osterunruhen entstandenen Schäden zu bekommen. Fotos sollen Mahlers Rolle bei den Unruhen belegen.","Prozess gegen Mahler vertagt","","Vertreter des Verlagshauses Springer legten Fotos vor","cg",[10,6],4,[1],[2],2,"22","13"],["4596","1968-06-11","Professor Weichselberger warnt davor, Unruhen nur auf Universitäten zu beziehen. Die Individualität der Universitätsbürger dürfe nicht durch etwaige Reformen eingeschränkt werden.","Abkehr vom Universitätspräsidenten","","TU-Rektor nahm Stellung zur Hochschulreform","dw",[4],4,[1],[2],2,"22","13"],["4597","1968-06-12","60.000 Ingenieur-Studenten streiken wegen der Kultusminister-Beschlüsse zu Reformen in ihrem Bereich.","Vorlesungsstreik von Ingenieur-Studenten","","","",[11],4,[1],[2],2,"22","1"],["4598","1968-06-12","Wo bleiben die Proteste der Theologiestudenten gegen die Sprengung der Leipziger Universitätskirche?","Hier schweigen die Protestler","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","2"],["4599","1968-06-12","Marburger AStA widerspricht Professoren, die gegen eine Proporzregelung in den Unis sind.","AStA kritisiert das Marburger Manifest","","","dpa",[4],4,[1],[2],2,"22","6"],["4600","1968-06-13","3000 Demonstranten, \"unter ihnen Vertreter linksorientierter Studentenverbände\" fordern von den Alliierten Schritte gegen Beeinträchtigungen des Berlin-Verkehrs durch die DDR. SDS-Mitglieder versuchen, an einem Grenzübergang eine Resolution zu übergeben.","Studenten fordern Schritte der Alliierten","","","",[1],4,[1],[2],2,"16","1"],["4601","1968-06-13","Versuch der Aktionsgemeinschaft Demokratische Universität ADU, den Münchener AStA abwählen zu lassen, ist gescheitert.","Vorstoß für Studentenwahl in München gescheitert","","","pff",[11],4,[1],[2],2,"16","5"],["4602","1968-06-13","200 Fachschüler dringen in Landtag ein, um gegen Akademiegesetzentwurf zu protestieren. ","Düsseldorfer Bannmeile verletzt","Studenten","Sit-in im Landtag - Auf Polizeieinsatz verzichtet","frh.",[11],4,[1],[3],2,"16","5"],["4603","1968-06-13","VV-Beschluss zum VDS-Austritt wird nicht anerkannt.","Hannover bleibt trotz Opposition im VDS","","","P.W. ",[11],4,[1],[2],2,"16","5"],["4604","1968-06-13","Große Mehrheit aller Abgeordnetenhausfraktionen räumen der FU die Möglichkeit ein, Urabstimmungen durchzuführen.","Änderung der FU-Satzung beschlossen","","Akademischer Senat kann zu Urabstimmungen aufrufen - Abgeordnetenhaus tagte","hae.",[4],4,[1],[3],2,"16","9"],["4605","1968-06-14","Demo von 1500 Jugendlichen, darunter SDS, am Übergang Heinrich-Heine-Straße gegen die Behinderungen im Transitverkehr","Proteste gegen die neuen Behinderungen","","","",[1],4,[1],[2],1,"26","3"],["4606","1968-06-14","Assistenten und Studenten sind künftig an der TU an der Rektoratswahl beteiligt. Auseinandersetzungen in der Katholischen Studentengemeinde.","Studenten dürfen TU-Rektor mitwählen","","Beschluss des Akademischen Senats","wt",[4],4,[1],[2],2,"26","9"],["4607","1968-06-15","Kommentator vergleicht die Träger von roten Fahnen heute mit denen, die 1953 dagegen gekämpft haben.","Das Recht auf Freiheit verjährt nicht","","Damals am 17. Juni 1953 - Rebellische Jugend heute - Worauf es ankommt","Matthias Walden",[1],4,[5],[1],2,"28","2"],["4608","1968-06-15","Klaus Läpple u. a. vor Gericht wegen Verekhrsbehinderung und ungenehmigter Demo gegen Fahrpreiserhöhungen 1966","Strafverfahren gegen Kölner Studenten","","","pt.",[1],4,[1],[2],1,"28","5"],["4609","1968-06-18","Alte Rektoren wiedergewählt. Auch im TU-Studentenprlament keine großen Verschiebungen.","Die neuen Rektoren sind die alten","","Prof. Harndt und Prof. Weichselberger wiedergewählt","wt",[11],4,[1],[2],2,"22","12"],["4610","1968-06-20","Rektor der Ruhr-Universität Bochum kritisiert die Bildungssituation massiv und macht Reformvorschläge.","\"Notfalls das Kartell der Kultusminister sprengen\"","Universität","Professor Biedenkopf fordert radikale Bildungsreform","frh.",[4],4,[1],[1],1,"24","5"],["4611","1968-06-20","VDS-Chef stellt bei Studenten nach dem vergeblichen Widerstand gegen die Notstandsgesetze Aktionsmüdigkeit und Resignation fest. Ähnlich äußert sich Günter Grass.","Ehmann: Die Studenten beginnen zu resignieren","","","dpa",[1],4,[1],[2],2,"24","5"],["4612","1968-06-20","CSU-Chef fordert im\"Bayern-Kurier\" Restriktionen für studentische Teilnehmer an ungesetzlichen Aktionen. \"Der Kult zur Opposition darf in unserem Staat nicht weiter Schule machen.\"","Strauß gegen Stipendien für straffällige Demonstranten","","","",[1],4,[1],[2],2,"24","5"],["4613","1968-06-20","Leser unterstellt Demontranten, die Mao-Parolen rufen, Ahnungslosigkeit, und versucht das mit Mao-Zitaten zu belegen.","Ahnungslose \"Revolutionäre\"","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"24","8"],["4614","1968-06-20","Demonstranten argumentieren mit selbstherrlicher Arroganz. Springer-Angriffe zeugen von verlogener Moral. \"Die Scheinheiligkeit dieser jungen Menschen ist gekonnt.\"","Der Anmaßung folgt üble Verleumdung","Aus Briefen an die Redaktion","","Leser",[10],4,[6],[2],2,"24","14"],["4615","1968-06-20","APO-Mitglieder versuchen eine Bürgerversammlung im Märkischen Viertel umzufunktionieren.","Doch keine echte Zwiesprache","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"24","14"],["4616","1968-06-21","Ausschuss will Bericht bis Sommerpause vorlegen. Als Beginn der Studentenunruhen wird das FU-Verbot des Auftritts von Erich Kuby als Redner zum zwanzigesten Jahrestag des Kriegsendes 1965 ausgemacht.","Sachdarstellungen und politische Wertungen","","Bericht des Untersuchungsausschusses zu Studentenunruhen bald erwartet","hae.",[7],4,[1],[3],2,"26","11"],["4617","1968-06-22","VDS kritisiert Kultusminister für ihre Reformansätze und schlägt Modellversuche als Alternative vor.","VDS schlägt Modellversuche zur Hochschulreform vor","Neue Strategie der Studenten","Angebot an Kultusminister und Rektoren","ems.",[4],4,[1],[5],2,"30","1"],["4618","1968-06-22","Teufel wird verdächtigt, bei der Besetzung des Germanischen Seminars Stempel und andere Unterlagen der FU entwendet zu haben. Eine Frau, der er die gesuchten Dinge angeblich übergeben hat, hat diese bei der Polizei abgegeben.","Polizei: Fritz Teufel unter Einbruchsverdacht","","","dpa",[5],4,[1],[2],2,"30","3"],["4619","1968-06-22","Dokuentation der VDS-Vorschläge für Reformen in den Hochschulen.","Studenten fordern Institutsräte und Abteilungen statt Fakultäten","Universitäten","Sechs Vorschläge des VDS für Modellversuche","ems.",[4],4,[1],[1],2,"30","5"],["4620","1968-06-22","Juraprofessor will AStA gerichtlich verbieten lassen durch Streikaufrufe den Unibetrieb zu behindern.","Marburger Professor klagt gegen den AStA","","","lh.",[11],4,[1],[2],2,"30","5"],["4621","1968-06-22","Bruder des in München getöteten Studenten wirft der Polizei einseitige Ermittlungen vor. ","Schwere Vorwürfe im Fall Schreck","","","di.",[10,2],4,[1],[2],2,"30","5"],["4622","1968-06-22","100 Psychologiestudenten besetzen einen Luftschutzraum, um auf ihre unzulänglichen Studienbedingungen hinzuweisen: 70 Arbeitsplätze für 500 Studenten.","Tübinger Studenten besetzen Räume des Luftschutzes","","","UPI",[1],4,[1],[2],2,"30","5"],["4623","1968-06-22","FU-Betriebsgruppe der SPD begrüßt die Besetzung des Ostasiatischen Instituts.","SPD-Hochschul-Betriebsgruppe wählt neuen Vorstand","","","",[11],4,[1],[2],2,"30","9"],["4624","1968-06-22","Streikende versuchen Reformen in ihren Bereichen durchzusetzen: Vorlesungs- und Prüfungsboykott.","Dozenten und Studenten einig","","Vorlesungsstreik an Ingenieur-Akademien beschlossen","eb",[11],4,[1],[2],2,"30","9"],["4625","1968-06-24","Angekündigte Störungen und Proteste gegen Schütz bei der Eröffnung der Kieler Woche hielten sich in Grenzen","Schütz blieb keine Antwort schuldig","","Kieler Woche eröffnet - Ein faules Ei flog","H.A.",[1],4,[1],[5],1,"18","18"],["4626","1968-06-26","Professor begründet seinen Weggang mit dem Studentenunruhen. Gerüchte über weitere Abgänge.","FU-Professor geht nach Erlangen","","\"Studententumulte entscheidend\"","v.C.",[11],4,[1],[2],2,"18","1"],["4627","1968-06-26","Leser widerspricht der Strauß-Forderung, straffälligen Studenten Stipendien zu streichen. Stipendien sollen allein von Leistungen abhängen.","Strauß und junge Demonstranten","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"18","2"],["4628","1968-06-26","Frage der Bund-/Länder-Kompetenz im Zusammenhang mit dem Ingenieur-Streit","Kühn warnt vor drohenden Eingriffen des Bundes im Ingenieurschul-Streit","Nordrhein-Westfalen","Hitzige Debatte um Akademie-Gesetzentwürfe","frh.",[11],4,[1],[1],1,"18","3"],["4629","1968-06-26","Springers Verkauf von Zeitschriften könnte als Ermunterung zum Protest gegen andere Verlage missverstanden werden, befürchten Konkurrenzverleger.","Verleger befürchten neue Angriffe","","\"Ermunterung für Radikale\"","sei.",[10],4,[1],[2],2,"18","3"],["4630","1968-06-27","Ehmann und drei Vorstandsmitglieder zu Gesprächen bei der FDJ","VDS zu Gesprächen in Ostberlin","","Erster persönlicher Kontakt mit de FDJ seit acht Jahren","ems.",[11],4,[1],[2],2,"18","1"],["4631","1968-06-27","Urabstimmung mit Unterschriftensammlung durchgesetzt.","RCDS will das politische Mandat verhindern","","Urabstimmung in Erlangen","pff",[11],4,[1],[2],2,"18","5"],["4632","1968-06-27","Aufgrund einer Studentenbeschwerde gegen einen politischen AStA-Beschluss hebt der niedersächsische Kultusminister diesen auf.","Langeheine hebt Beschluss des AStA Göttingen auf","","","P.W.",[11],4,[1],[2],2,"18","5"],["4633","1968-06-27","Aussetzung des Streiks zum Semesterende vorgeschlagen.","Wollen Ingenieur-Studenten jetzt den Streik beenden?","","","P.W.",[11],4,[1],[2],2,"18","5"],["4634","1968-06-27","\"Extra-Dienst\" berichtet über eine Sammlung von Briefen an Rudi Dutschke, darunter auch Schreiben von Augstein und Bucerius. Bucerius spendet 10.000 DM für Krankenhauskosten.","\"Auch ein Brief von Rudolf Augstein\"","","","",[2],4,[1],[2],2,"18","5"],["4635","1968-06-27","Opposition macht Stein Vorwürfe wegen der Unruhen im Unibereich","CDU will Senator Stein zum Rücktritt zwingen","","Hitzige Debatte auf der letzten Parlamentssitzung vor den Ferien erwartet","hae.",[1],4,[1],[3],2,"18","11"],["4636","1968-06-27","Berliner Landesverband des RCDS hält Distanz zu Mutterpartei","RCDS lässt sich keinesfalls bevormunden","","","",[11],4,[1],[2],2,"18","11"],["4637","1968-06-27","Institutsbesetzung gegen den umstrittenen Professor Eckardt","Sinologisches Institut besetzt","","","",[11],4,[1],[2],2,"18","11"],["4638","1968-06-28","Studenten dringen gewaltsam ins Rektorat ein. VV im Audimax mit Cohn-Bendit.","FU-Rektoraten von Studenten besetzt","","Polizei räumt Institute - Prof. Harndt verweigert Diskussion","Bi., v.C.",[11],4,[1],[2],2,"28","1,4"],["4639","1968-06-28","Informativ und erfolgreich ist das Treffen mit der FDJ laut VDS gewesen.","VDS befriedigt über Gespräche in Ostberlin","","","Bi. ",[11],4,[1],[2],2,"28","1"],["4640","1968-06-28","Für und Wider der geplanten Institutsreform in Berlin","Manche Professoren sprechen offen von \"Ausverkauf\"","","Mit dem Beschluss über die neue Satzung für das Otto-Suhr-Institut fällt an der FU Berlin eine wichtige Entscheidung","Hans-Erich Bilges",[4],4,[1],[2],2,"28","2"],["4641","1968-06-28","Details über die Gespräche.","Das nächste Treffen in Sofia?","Ostkontakte","Differenzen zwischen VDS und FDJ über Entwicklung in Prag","Bi.",[11],4,[1],[2],2,"28","5"],["4642","1968-06-28","Hochschulreform Thema im Abgeordnetenhaus","Parlament fordert Entwurf eines Fachhochschulgesetzes","","Studenten applaudierten auf der Zuschauertribüne","hae.",[4],4,[1],[1],2,"28","9"],["4643","1968-06-28","Mann, der am 2. Juni bei der Anti-Schah-Demo ein Ei geworfen hatte, wurde freigesprochen.","Urheber des Strafprozesses wurde freigesprochen","","Schwere Landfriedensbruch nicht erwiesen - Aus Moabit","fa",[7],4,[1],[3],2,"28","9"],["4644","1968-06-28","Untersuchungsrichter vernahm Bachmann zu dessen Lebenslauf","Bachmann erstmals vernommen","","","",[2],4,[1],[2],2,"28","9"],["4645","1968-06-29","Verschärfung der Lage nach Ablehnung der neuen OSI-Satzung durch den Akademischen Senat. Senator Stein kritisiert Räumung des Japanologischen und Sinologischen Instituts mit Hilfe der Polizei.","Lage an der FU weiter verschärft","","Mehrstündiger Warnstreik - Stein kritisiert Räumung","Bi., v.C.",[11],4,[1],[2],2,"30","1,3"],["4646","1968-06-29","Chaos, Zerstörungen und Partyatmosphäre in den besetzen Instituten und im Rektorat. Bemühungen um Deeskalation: Professoren und Regierender Bürgermeister treffen sich zu Beratungen im Dahlemer Dorfkrug. Polizeiräumung verschärft die Lage.","Am Fenster ein Student im Talar des Rektors","FU-Berlin","Frühmorgens kam die Polizei","Hans-Erich Bilges",[11],4,[1],[1],1,"30","3"],["4647","1968-08-01","Professor Ernst Wolf aus Marburg listet Gewaltaufrufe und Anti-Springer-Aussagen etc. von Professor Wolfgang Abendroth auf, die er, Wolf, z.B. im \"Spiegel\" hatte veröffentlichen wollen.","Demokratisierung durch Professor Abendroth","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[1],2,"16","11"],["4648","1968-08-01","FU-Mitarbeiter lobt Walden-Kommentar, der Zustände an der FU kritisiert hatte.","Es fehlt an Therapien für die FU","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"16","11"],["4649","1968-08-01","Student lobt die Rolle von Senator Stein im Konflikt","Studenten hören noch auf Senator Stein","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"16","11"],["4650","1968-08-01","Professor Kurt Sontheimer wundert sich , wie die WELT seine Abwanderungspläne bekanntmachen konnte. Die Redaktion erläutert den Vorgang.","Von Abwanderungswelle bedroht?","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[5],2,"16","11"],["4651","1968-08-02","Berliner SDS-Mitglieder, u.a. Rabehl, Lefevre und Treulieb, nehmen an Schulungen auf Kuba teil.","Führende SDS-Mitglieder zur Schulung in Kuba","","","AP",[8],4,[1],[2],2,"16","1"],["4652","1968-08-05","K.-D. Wolff bei Weltjugendfestival in Sofia nach Auseinandersetzungen um die Rednerliste von Bulgaren mit Goebbels verglichen und verprügelt.","SDS-Vorsitzender Wolff in Sofia verprügelt","","","dpa",[8],4,[1],[2],2,"16","4"],["4653","1968-08-05","VDS will Münchener AStA gerichtlich Austritt aus Verband untersagen lassen.","VDS will gegen AStA München klagen","","","UPI",[11],4,[1],[2],2,"16","5"],["4654","1968-08-08","Studenten, die die Zahlung der AStA-Beiträge (z. B. aus politischen Gründen) nicht tätigen, können sich dennoch formrichtig zurückmelden. Sie dürfen nicht exmatrikuliert werden. Urteil des Berliner Verwaltungsgerichts.","FU darf Studenten nicht ausschließen","","Wenn sie die Zahlung der AStA-Beiträge verweigern","fa., Bi.",[11],4,[1],[3],2,"18","1,5"],["4655","1968-08-08","Über die Teilnahme westdeutscher linker Gruppierungen am Weltjugendfestival in Sofia und deren Probleme, Verständnis für eigene Anliegen und Aktionen zu finden.","Westdeutsche Delegierte als Prügelknaben","","Bittere Erfahrungen auf den Weltjugendfestspielen in Sofia","Walter Günzel",[8],4,[1],[3],2,"18","2"],["4656","1968-08-08","Nach Auskunft von RA Mahler plant Daniel Cohn-Bendit nach Berlin überzusiedeln.","Cohn-Bendit geht nach Berlin","","Mahler: Studien treiben","UPI",[9],4,[1],[2],1,"18","5"],["4657","1968-08-09","FU richtet für AStA-Beiträge ein \"Verwahrkonto\" ein.","FU Berlin: AStA-Beiträge weiter freiwillig","","","Bi.",[11],4,[1],[2],2,"16","5"],["4658","1968-08-09","Ankündigung, dass eine FDJ-Delegation den VDS in Westdeutschland besuchen wird","VDS plant neue Gespräche mit FDJ","","Dritter Kontakt innerhalb weniger Wochen - Absprache in Sofia","ems.",[11],4,[1],[2],2,"16","5"],["4659","1968-08-13","Engegen einem Gerichtsentscheid zum politischen Mandat will der Tübinger AStA sich weiter politisch äußern, wenn er die Grundordnung der Bundesrepublik gefährdet sieht.","AStA Tübingen: Pflicht zu politischen Äußerungen","","","rg.",[11],4,[1],[2],2,"16","5"],["4660","1968-08-13","Votum eines GEW-Vertreters für eine grundsätzliche Bildungsreform","Reformen brauchen einen langen Atem","Wie die GEW es sieht","Fachschulneuordnung bedingt Neugliederung der Bildungswege","Erich Frister",[4],4,[5],[1],2,"16","11"],["4661","1968-08-13","Ministerialdirektor im Bundesinnenminister stellt die Forderung nach politischem Mandat den Aufgaben und Eigenschaften eines Zwangsverbandes gegenüber. Beispiel VDS.","Was bedeutet ein Zwangsverband?","Student und Politik","Ein Wort zur Lage","Karl-Ulrich Hagelberg",[11],4,[5],[5],2,"16","11"],["4662","1968-08-14","AStA fordert seine Finanzierung durch die Uni und nicht durch Beiträge","FU soll AStA finanzieren","","","UPI",[11],4,[1],[2],2,"18","3"],["4663","1968-08-15","Anriss zu einem Interview mit Professor Harndt von der FU über die aktuelle Situation an seiner Universität. U.a. Frage der AStA-Gebühren.","\"Für Selbstverwaltung selbst zahlen\"","","Rektor der Freien Universität weist Forderung des AStA zurück","Bi.",[11],4,[1],[2],2,"16","1"],["4664","1968-08-15","Äußerungen zu den Unruhen an der FU, den AStA-Gebühren, dem politischen Mandat.","\"Ich glaube nicht an einen heißen Herbst\"","Das Interview mit dem Rektor der Freien Universität Berlin","Professor Harndt analysiert Konflikte an der FU","Hans-Erich Bilges",[11],4,[3],[1],1,"16","5"],["4665","1968-08-16","Eine Stelle im Disziplinarausschuss der Philosophischen Fakultät ist sein langem unbesetzt. Rektor will jetzt Gericht bemühen.","Nach einem Jahr klagt der FU-Rektor","","Es geht um \"Ersatzmann\" in den Disziplinarausschüssen","ska",[11],4,[1],[2],2,"18","9"],["4666","1968-08-19","APO droht auseinanderzudriften, da im SDS zunehmende Orientierungslosigkeit und Uneinigekeit besteht. Neue, straffere Organisationsform soll Abhilfe schaffen. Vorstellung fünf neuer Sekretariate.","Suche nach revolutionärem Establishment","Außerpralamentarische Opposition","Ohne straffe Führung büßt der SDS seine Stoßkraft ein","Karsten Plog",[8],4,[1],[1],1,"18","6"],["4667","1968-08-21","LSD-Geschäftsführer geht auf Sofia-Bericht der Welt vom 8.8. ein und korrigiert, dass Frank v. Auer nicht SDS-Mitglied ist.","Frank von Auer war Gast","Aus Briefen an die Redaktion","","Leser",[8],4,[6],[2],2,"20","13"],["4668","1968-08-21","Leser kritisiert die Diskussion, ob denn Ingenieure \"richtige\" Akademiker seien.","Wenn die Ingenieure aufrücken?","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"20","13"],["4669","1968-08-23","Gem. Urteil des OVG Münster erhält SDS keine Mittel aus dem Bundesjugendplan.","Oberverwaltungsgericht: SDS nicht förderungswürdig","","","dpa",[8],4,[1],[2],2,"20","8"],["4670","1968-08-27","VDS stellt Gelder bereit und richtet Spendenkonto ein, um in Deutschland studierende oder aus der CSSR geflohene Studenten zu unterstützen.","VDS stellt Mittel für CSSR-Studenten bereit","","","",[11],4,[1],[2],2,"20","5"],["4671","1968-08-27","Auflistung von Fördermöglichkeiten, Stipendien und Mängeln in dieser Angelegenheit.","Knauserei ist der Moral abträglich","Das geht nicht nur Studenten an","Förderung Studierender in Deutschland - Eine Revue","Eberhard Nitschke",[11],4,[1],[1],2,"20","8"],["4672","1968-08-27","Gastbeitrag des VDS-Vorsitzenden als Erwiderung auf den WELT-Gastbeitrag von K.-U. Hagelberg zum Thema Zwangsverband","\"Unter dem Mäntelchen der Juristerei?\"","","VDS verteidigt politisches Mandat","Christoph Ehmann",[11],4,[5],[2],2,"20","8"],["4673","1968-11-01","Je drei Jahre Zuchthaus für Gudrun Ensslin, Andreas Baader, Thorwald Proll und Horst Söhnlein wegen menschengefährdender Brandstiftung. Tumulte im Zuschauerraum, u.a. mit Beteiligung von Daniel Cohn-Bendit","Tumult bei der Urteilsverkündung","","Zuchthausstrafen im Frankfurter Kaufhausbrand-Prozess","",[9],4,[1],[3],1,"22","1"],["4674","1968-11-01","Kommentator kritisiert die Uneinheitlichkeit bei der Rechtsprechung in sog. Studentenproszessen. Negativ beurteilt wird z.B. die zurückhaltende Wertung von Auslieferungsblockaden bei Zeitungen.","Die Krise der Justiz","","Widerspruchsvolle Entscheidungen - Was ist \"sozialadäquat\"? - Pendelschlag ins Extreme","Hans Schueler",[9],4,[5],[1],2,"22","2"],["4675","1968-11-01","TU-Studentenvertretung billigt mehrheitlich Aufruf an US-Soldaten zu desertieren. TU-Zeitung publiziert Anti-CDU-Texte.","US-Soldaten zur Desertion aufgerufen","","","dpa",[11],4,[1],[2],2,"22","4"],["4676","1968-11-01","Angeklagte vom Kölner AStA wegen der 1966er Sitzstreiks gegen Fahrpreiserhöhungen freigesprochen","Der Sitzstreik in Köln war nicht schwerer Landfriedensbruch","","Laepple und Lutzenberger freigesprochen","Alfred Freudenhammer",[1],4,[1],[1],2,"22","22"],["4677","1968-11-01","Schilderung der Gerichtssitzung mit Urteilsverkündung und diversen massiven Störungen in Frankfurt. Cohn-Bendit zu dreitägiger Ordnungsstrafe verurteilt.","Rauchbomben im Frankfurter Gerichtssaal","","Kaufhaus-Brandstifter erhielten je drei Jahre Zuchthaus - Daniel Cohn-Bendit festgenommen","Nea.",[9],4,[7],[5],1,"22","22"],["4678","1968-11-02","Kommentar zum Frankfurter Urteil. Staatsanwalt und Gericht verneinen politische Motivation. Zum Tumult der Zuschauer: Ist hier späte Reue in Zorn umgeschlagen?","Brandstiftung und Motiv","","","H.Sch.",[9],4,[5],[2],2,"34","2"],["4679","1968-11-02","Assistenten beschweren sich bei Senator Stein über Prof. Harndt, weil dieser einer Einstellung von Bernd Rabehl als Assistent nicht zustimmt.","Dienstbeschwerde gegen FU-Rektor","","","Bi.",[11],4,[1],[2],2,"34","3"],["4680","1968-11-02","Leser wundert sich über Freispruch für Laepple und Lutzenberger","Legaler Widerstand?","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"34","11"],["4681","1968-11-02","RCDS krtisiert APO-Aktionen gegen CDU-Parteitag in Berlin","Anarchistischer Geist","","","",[1],4,[1],[2],2,"34","13"],["4682","1968-11-02","Desertions-Aufruf verstößt womöglich gegen alliiertes Recht. Juristische Prüfung der Angelegenheit eingeleitet.","Ermittlung wegen Desertions-Aufruf","","Polizei schaltet Staatsanwaltschaft ein","hae.",[11],4,[1],[2],2,"34","13"],["4683","1968-11-02","CDU-MdA scheitert mit seinem Antrag, den Berliner AStA die öffentlichen Mittel zu streichen.","Debatte um AStA-Zuschüsse geht weiter","","Hauptausschuss lehnte Antrag auf Streichung ab","sh",[11],4,[1],[2],2,"34","13"],["4684","1968-11-02","Frankfurter Ordnungsstrafe wirkt sich bei Cohn-Bendit nicht auf eine laufende Bewährungsstrafe aus.","Daniel Cohn-Bendit bleibt in Freiheit","","Bewährung nicht aufgehoben","dpa",[9],4,[1],[2],2,"34","24"],["4685","1968-11-04","Diskussionsveranstaltung der Evangelischen Akademie Mülheim räumt der Opposition, auch der außerparlamentarischen, großen Spielraum für ihre Aktionen ein.","\"Der Verkehr hat keine Vorfahrt\"","Demonstrationen","Diskussion über die Grenzen außerparlamentarischer Aktionen","tie.",[1],4,[1],[2],2,"20","3"],["4686","1968-11-04","Brandanschlag auf Briefkasten des Kriminalgerichts. Aufkleber legen Zusammenhang mit Ehrengerichtsverfahren gegen RA Mahler nahe.","Anschlag gegen Berliner Kriminalgericht","","","dpa",[6],4,[1],[2],2,"20","3"],["4687","1968-11-05","Bisher schwerste Auseinandersetzungen zwischen Demonstranten und Polizei mit vielen Verletzten. Gründe für Ehrengerichtsverfahren gegen Mahler u.a. seine Rolle bei der Anti-Springer-Demo im April. Stimmen zu den Krawallen.","Straßenschlacht in Berlin","","Während des Ehrengerichtsverfahrens gegen Horst Mahler","Bi.",[6],4,[1],[5],1,"22","1"],["4688","1968-11-05","Über die sogenannte \"Schlacht am Tegeler Weg\". Keine Demo, sondern Aufruhr. Gerade stattfindender Anhängerschwund der APO möglicher Grund für Radikalisierung. SDS-Sprecher (Christian Semler) habe als Erfolg verkauft, die \"Bekämpfung von Polizeiketten durch massiven Steinwurf\".","Straßenschlacht  ","Zum Tage","","Co.",[6],4,[5],[2],2,"22","2"],["4689","1968-11-05","Straßenschlacht von \"Pariser Ausmaßen\". Schilderung der Abläufe am Tegeler Weg und später im Audimax der TU. Erwähnung des Brandanschlages auf die Stallungen der Polizeipferde. Innensenator spricht von Terroraktionen und Aufruhr. Stimmen weiterer Politiker.","Ständig fuhren Krankenwagen","Demonstration ","Polizei im Steinhagel - Privatwagen als Straßenbarrikade - Neubauer: Das ist Aufruhr","Bi.",[6],4,[1,7],[5],1,"22","3"],["4690","1968-11-05","Treffen zwischen FU-Rektor und Bernd Rabehl ergebnislos. Senator weist Dienstaufsichtsbeschwerde zurück.","Gespräch Harndt-Rabehl bleibt ohne Ergebnis","","","Bi.",[11],4,[1],[2],2,"22","6"],["4691","1968-11-06","Rückblick und Bewertung der Ausschreitungen am Tegeler Weg. Bilanz der Schäden. Entschiedene Verurteilung der Vorfälle durch Politiker.","Senat verurteilt Ausschreitungen","","\"Terroristen Absage erteilen\" - CDU dankt Berliner Polizei","",[6],4,[1],[2],2,"22","1"],["4692","1968-11-06","Leser kritisiert Freispruch zweier Teilnehmer aus der Auslieferungsblockade von Springer-Zeitungen in Frankfurt.","Das Zeitalter des Faustrechts?","Aus Briefen an die Redaktion","","Leser",[10,2],4,[6],[2],2,"26","2"],["4693","1968-11-06","Leser sieht in liberalen Gerichtsurteilen der letzten Zeit Anzeichen für \"Weimar\".","Verheerend","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"26","2"],["4694","1968-11-06","Zahlreiche kritische und selbstkritische Stimmen verschiedner APO-Gruppierungen nach der Straßenschlacht in Charlottenburg.","\"Wir haben gestern keinen Sieg errungen\"","Berlin","Selbstkritik der Demonstranten nach der Straßenschlacht","Bi.",[6],4,[1],[1],1,"26","5"],["4695","1968-11-06","Rabehl verpflichtet sich, Gesetze zu achten. Harndt nimmt Widerspruch zurück.","SDS-Mitglied Rabehl wird Hilfsassistent","","","Bi.",[11],4,[1],[2],2,"26","5"],["4696","1968-11-06","Ausführliche Schilderung der Situation am OSI der FU nach Einführung einer Satzung und Geschäftsordnung, die den Studenten weitgehende Rechte einräumt.","\"Mitbürger, man beutet uns aus\"","Das Experiment am Otto-Suhr-Institut","Auch die Drittelparität ist den studentische Räten zu wenig","Bernd Nellessen",[4],4,[1],[4],1,"26","8"],["4697","1968-11-07","Brandt spricht u.a. von einer \"Rebellion der Jugend gegen die Zivilisation\" als internationales Phänomen.","Die Jugend will nicht \"verplant\" werden","Willy Brandt vor der UNESCO","Der Außenminister entwickelt universale Doktrin für friedliches Zusammenleben","L.R.",[1],4,[1],[1],2,"28","4"],["4698","1968-11-07","SHB setzt sich für die Vietnam-Demo-Teilnehmer ein, die mit Parteistrafen belegt worden sind.","SHB attackiert die Führung der SPD","","Sympathie für Ristock und Beck","dpa",[11],4,[1],[2],2,"28","8"],["4699","1968-11-07","Uneinigkeit in FU-Gremien wegen Rabehl-Anstellung","Rabehl beschäftigte FU-Senat","","","",[11],4,[1],[2],2,"28","13"],["4700","1968-11-07","Brief des Berliner Polizei-Seelsorgers aus Anlass der jüngsten Krawalle","\"Auch Mitgehen ist untragbar\"","","Polizei-Pfarrer Harms appelliert an die Studenten","Klaus Harms",[6],4,[5],[5],2,"28","14"],["4701","1968-11-08","Misstrauensantrag der Unabhängigen Aktionsgemeinschaft UAG hat Erfolg.","Studentenvertretung der TU wurde gestürzt","","","Bi.",[11],4,[1],[2],2,"32","1"],["4702","1968-11-08","Misstrauensantrag der Unabhängigen Aktionsgemeinschaft UAG hat Erfolg. Grund war die aktuelle Gewalteskalation. Kurze Schilderung der stürmischen Sitzung des TU-Parlaments.","TU-Studentenvertretung gestürzt","Berlin","Reaktion des Parlaments nach den Vorgängen am Landgericht","Bi.",[11],4,[1],[2],2,"32","3"],["4703","1968-11-08","SDS will laut Aussage von Christian Semler künftig intensiver mit Rockern zusammenarbeiten. Diese sollen politisch unterwiesen werden. Vietenamdemo angekündigt.","Rocker sollen \"politisiert\" werden","SDS","Demonstration angekündigt","AP",[8],4,[1],[2],2,"32","6"],["4704","1968-11-08","Gegen den Widerstand einiger Professoren und Dekane sagt Uni-Rektor geplante Rektoratsübergabe im Mainzer Theater ab. Ungestörter Verlauf kann nicht garantiert werden.","\"Ungestörter Festakt nicht gesichert\"","Universität Mainz","Rektor rechtfertigt Absage der feierlichen Amtsübergabe","lh.",[11],4,[1],[2],2,"32","6"],["4705","1968-11-08","Nach einer polizeilichen Durchsuchung des SDS-Büros in Hannover erscheint eine geplante Konferenz des Verbandes gefährdet.","Delegiertenkonferenz des SDS in Hannover gefährdet","","","P.W.",[8],4,[1],[2],2,"32","6"],["4706","1968-11-08","Dekan muss sich im Zusammenhang mit der Personalie Rabehl einer Vertrauensabstimmung stellen.","Vollstes Vertrauen ausgesprochen","","Fakultätsvertretung und Assistenten unterstützten Prof. Fischer","",[11],4,[1],[2],2,"32","13"],["4707","1968-11-08","Deutlich mehr Mitbestimmungsrechte für Studenten an der TU","TU-Studenten errangen beachtlichen Erfolg","","","",[4],4,[1],[2],2,"32","13"],["4708","1968-11-08","Luise Rinser, Hans Hellmut Kirst und Carl Amery protestieren gegen harte Strafe für Kaufhausbrandstifter: Täter seien Idealisten.","Offener Brief zum Frankfurter Urteil","","Protest gegen Zuchthausstrafe für die Brandstifter","dpa",[9],4,[1],[2],2,"32","24"],["4709","1968-11-04","Statusbericht über die momentane (politische) Situation an der FU.","Freie Universität Berlin - Der Wind fegt durch's Gemäuer","","","Bernd Nellessen",[11],4,[1,5],[4],1,"32","29"],["4710","1968-11-09","Professor, Assistent und acht Studenten des OSI bedauern in einem Brief Angriffe auf Polizei am Tegeler Weg.","Studenten äußern Bedauern über Steinwürfe gegen Polizei","","","",[6],4,[1],[2],2,"32","9"],["4711","1968-11-09","Neue Selbstverwaltungsmodalitäten in diesem Bereich ad experimentum.","Das Ergebnis wird erst ausprobiert","","Reform der FU-Zahnmedizinklinik \"ohne Beispiel\"","ska",[4],4,[1],[2],2,"32","9"],["4712","1968-11-09","Leser bemängelt uneinheitliche Vorgehensweise der Justiz gegen Krawall-Verantwortliche","Justiz ohne klare Linie gegenüber Demonstranten","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"32","19"],["4713","1968-11-11","Leser empört sich über niedriges Strafmaß für Kaufhausbrandstifter","Recht auf Schutz gegen Gewalt","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"22","2"],["4714","1968-11-11","Leser kritisiert Rinser-Brief und fragt, wie sie denken würde, hätte man ihr Haus angezündet.","Und das eigene Haus?","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"22","2"],["4715","1968-11-11","Bürgermeister Schütz vermutet, dass ein \"harter Kern von Terroristen\" Auseinandersetzungen am 4. November vorbereitet hatten. Sie müssten wie andere Kriminelle auch behandelt werden.","\"Terroristen wie Kriminelle behandeln\"","","","Bi.",[6],4,[1],[2],2,"22","3"],["4716","1968-11-12","Leser gibt dem Staat Schuld an den Ausschreitungen, weil er zu schlaff damit umgehe.","Lebensgefährlich","Aus Briefen an die Redaktion","","Leser",[6],4,[6],[2],2,"22","2"],["4717","1968-11-12","Fünf Personen hatten in Hamburger Uni versucht, ein Wissmann-Denkmal umzustürzen. Drei der Beteiligten sind SDS-Leute.","Geldstrafen für Studenten wegen Hausfriedensbruchs","","","ei.",[11],4,[1],[2],2,"22","6"],["4718","1968-11-12","Prozessauftakt wegen Ausschreitungen bei Demos zu Ostern","Das Gericht zog in einen größeren Saal","Niedersachsen","In Hannover begann erster Prozess gegen Oster-Demonstranten","P.W.",[1],4,[1],[2],2,"22","6"],["4719","1968-11-13","Studentische VV beschließt über Reformen am Philosophischen Seminar","Seminarleitung durch Institutsrat?","","Reformversuch an der FU","dpa",[4],4,[1],[2],2,"26","3"],["4720","1968-11-13","Demo in München anlässlich eines Verfahrens gegen das SDS-Mitglied Thomas Schmitz-Bender","Demonstration vor dem Justizpalast","","Berufungsverfahren in München","AP",[8],4,[1],[2],2,"26","5"],["4721","1968-11-13","Via FDJ rät die DDR dem SDS, sie als Verbündeten zu betrachten.","Ostberlin gibt dem SDS Tips","","","v.C.",[8],4,[1],[2],2,"26","5"],["4722","1968-11-13","Zwanzig Mitglieder der Deutschen Studentenunion DSU demonstrieren gegen die Westdeutsche Rektorenkonferenz","Blumiger Protest gegen Rektoren","","DSU: Konferenz abschaffen","",[4],4,[1],[2],2,"26","6"],["4723","1968-11-13","Filmische Dokumentation der Krawalle anläßlich des Ehrengerichtsverfahrens gegen Mahler liegt jetzt vor und soll juristisch ausgewertet werden.","Polizeifilm über Krawalle am Landgericht fertiggestellt","","Strafjustiz bekommt Material - Künftig verstärkte Einsätze von Kameratrupps","eb",[6],4,[1],[1],2,"26","13"],["4724","1968-11-14","Leser vergleicht Hamburger Denkmal-Schändung mit Bücherverbrennung, an der auch Studenten beteiligt gewesen sind.","Denkmal-Stürzer","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"24","2"],["4725","1968-11-14","Senatssitzung in Kiel gestört, die über Aufruf zur Störung einer Immatrikulationsfeier beraten wollte.","Sitzung des Senats in Kiel gestürmt","Universität","","H.A.",[11],4,[1],[2],2,"24","5"],["4726","1968-11-14","Je zwei Assistenten und Studenten dürfen sich künftig am Berufungsverfahren an der Evangelistischen-Theologischen Fakultät der Uni Münster beteiligen.","Studenten dürfen bei Berufung mitentscheiden","","","er ",[4],4,[1],[2],2,"24","5"],["4727","1968-11-14","Ehemaliger TU-Rektor erwägt seinen Weggang nach München.","Weichselberger: Ich habe mmich noch nicht entschieden","Berlin","Über Berufung nach München","Bi.",[11],4,[1],[1],1,"24","6"],["4728","1968-11-14","Studenten kündigen an, am kommenden Bußtag in Gottesdiensten diskutieren zu wollen.","Marburger Studenten wollen am Bußtag diskutieren","","","wm",[11],4,[1],[2],2,"24","6"],["4729","1968-11-15","Leser kritisiert Rinser, Kirst und Amery und meint, deren Argumentation wäre auch bei Hitler zutreffend gewesen.","Auch Brandstifter","Aus Briefen an die Redaktion","","Leser",[9],4,[6],[2],2,"26","2"],["4730","1968-11-15","In Kiel vorgesehener Schleiermacher-Kongress wurde abgesagt, weil Störungen angekündigt worden waren. Kommentator spricht von Terror.","Terror gegen Theologen","Zum Tage","","W.G.",[11],4,[5],[2],2,"26","2"],["4731","1968-11-15","Gegendarstellung des AStA-Vorsitzenden der FU zu einem WELT-Bericht","Nicht der SDS, sondern der AStA","","","Jürgen Treulieb",[11],4,[6],[2],2,"26","6"],["4732","1968-11-15","AStA-Chef resigniert, weil er mit Vorgehen der VV bei Reformen nicht einverstanden ist.","Vorsitzender des AStA in Kiel legt Amt nieder","","Vor der Vollversammlung","",[4],4,[1],[2],2,"26","6"],["4733","1968-11-15","Teilnehmer an einer Berliner Podiumsdiskussion, u.a. Knut Nevermann, sprechen sich nach Krawallen für verändertes Vorgehen der APO aus.","Die \"APO\" will jetzt umdenken","","Podiumsgespräch in der Evangelischen Akademie","ki",[1],4,[1],[2],2,"26","12"],["4734","1968-11-16","Beginn des Schadenersatzprozesses gegen SDS-Leute wegen Demo gegen Societätsdruckerei","Prozess gegen SDS","Kurz berichtet","","dpa",[10,2,8],4,[1],[2],2,"34","3"],["4735","1968-11-18","Aufzählung von Teilnehmern, Reisekosten und Programmpunkten einer Reise von SDS-Leuten nach Kuba.","Arbeitslager statt Ferien-Vergnügen","Sozialistischer Deutscher Studentenbund","Die Kuba-Reise von SDS-Mitgliedern - Kaum Konakte zur Bevölkerung","St.",[8],4,[1],[1],2,"20","6"],["4736","1968-11-18","Lange und teils kontroverse Debatten bei SDS-Kongress ohne klare Richtung. Gerichte als Teile des \"Herrschaftsapparates\".","\"Wir brauchen überhaupt keine Justiz\"","Kongress","SDS berät in Hannover - Gerichtskampagne im Mittelpunkt","P.W.",[8],4,[1],[2],2,"20","6"],["4737","1968-11-18","Studentenvertretung gegen neue Unisatzung, die am 1. Dezember in Kraft treten soll.","Würzburger AStA lehnt neue Hochschul-Satzung ab","","","wfm.",[4],4,[1],[2],2,"20","10"],["4738","1968-11-19","Diverse Zitate aus den unterschiedlichen Diskussionen. Neuer Vorstand: Reinhard Wolff, Udo Knapp, Klaus-Jürgen Behuken, Günter Mangold und Eberhard Becker.","Beim SDS ist die Rede von einem Zerfallsprozess","","Doch noch ein neuer Vorstand","Paul Lersch",[8],4,[1],[1],1,"30","5"],["4739","1968-11-21","Uni-Streik gegen neue Universitätsverfassung","Studenten beschließen Vorlesungs-Streik","","","D.",[4],4,[1],[2],2,"26","6"],["4740","1968-11-21","Kommentar zur Delegierten-Tagung des SDS in Hannover. Verband versucht auch künftig der Welt, die davon nichts wissen will, seine großen Ansprüche aufzudrängen.","Wohin treibt der SDS?","Nach dem Treffen in Hannover","Selbstquälerische Experimente - ohne Narkose","Paul Lersch",[8],4,[5],[4],1,"26","7"],["4741","1968-11-21","Professor Harndt soll Auskunft darüber geben, ob er früher SA- und NSDAP-Mitglied gewesen ist.","Vorwürfe gegen FU-Rektor","","","",[11],4,[1],[2],2,"26","14"],["4742","1968-11-22","Hochschulreform in NRW kommt nur in kleinen Schritten voran. Drei Gesetzesinitiativen vorgestellt.","Kühn schweigt sich über seine Pläne aus","Nordrhein-Westfalen","Statt eines Entwurfs zur Hochschulreform nur drei Gesetzesvorlagen","tie.",[4],4,[1],[1],2,"28","5"],["4743","1968-11-22","Beschreibung von Aktionen der NRW-CDU in Sachen Reform","Hochschul-Hearing der CDU","","Diskussion mit Studenten - \"Für neue Vorschläge offen\"","W.E.",[4],4,[1],[2],2,"28","5"],["4744","1968-11-22","Geringen Beteiligung bei Unistreik in Saarbrücken gegen neue Hochschulverfassung","Vorlesungsstreik an der Saar nur ein Teilerfolg","","","D.",[4],4,[1],[2],2,"28","5"],["4745","1968-11-22","Zusammenarbeit von deutschen und französischen Hochschulen angestrebt.","\"Europa-Markt\" der Hochschulen angestrebt","","Faure bei Goppel","pff",[4],4,[1],[2],2,"28","5"],["4746","1968-11-22","Harry Pross als Nachfolger von Fritz Eberhard als Ordinarius am Publizistischen Institut der FU eingeführt","Deutliche Worte vom neuen Ordinarius","","","",[11],4,[1],[2],2,"28","13"],["4747","1968-11-22","Auseinandersetzungen über Zuständigkeiten für Seminarinhalte und -formen in FU-Institut","Wieder Auseinandersetzung am Romanischen Seminar","","","",[11],4,[1],[2],2,"28","13"],["4748","1968-11-23","NRW-Landtagspräsident hatte Staatsanwalt angesprochen, ob er nicht den Freispruch für den früheren Kölner AStA-Vorsitzenden Laepple zurücknehmen könnte.","\"Weisung an Staatsanwaltschaft ist verfassungswidrig\"","","","W.E.",[1],4,[1],[2],2,"30","6"],["4749","1968-11-23","Gewerkschafter gibt der weltweit revoltierenden Jugend im Hinblick auf die politische Situation recht.","\"Die Jugend protestiert zu Recht\"","Gewerkschaften","Rede Stephans auf dem DGB-Kongress in Braunschweig","AP",[1],4,[1],[2],2,"30","6"],["4750","1968-11-23","Studentin hatte Polizeipräsidenten wegen Schlagstockgebrauchs von Polizisten angeklagt. Noch kein Urteil aufgrund komplizierter Zusammenhänge mit alliiertem Recht in Berlin.","Gericht verschob Urteil über Schlagstockgebrauch","","","er",[1],4,[1],[2],2,"30","17"],["4751","1968-11-23","Formlose Amtsübergabe an den neuen TU-Rektor Wever. Dennoch Störungen von Studenten.","Misstöne trotz fehlender Fanfaren","","Diskussionen bei TU-Rektoratsübergabe","wt",[11],4,[1],[2],2,"30","17"],["4752","1968-11-23","Professor Harndt erklärt, Mitglied mehrerer NSDAP-Gliederungen gewesen zu sein. Der SA habe er nicht angehört. In die NSDAP sei er 1937 ohne sein Zutun aufgenommen worden.","\"Ich habe nichts zu verbergen\"","","FU-Rektor antwortet auf Vorwürfe über seine Vergangenheit","tw",[11],4,[1],[2],2,"30","18"],["4753","1968-11-23","Institutsrat beschließt, dass Zwischenprüfungen öffentlich sein sollen.","Zwischenprüfungen öffentlich","","","",[11],4,[1],[2],2,"30","18"],["4754","1968-11-25","Rechtsaberkennung des SDS als studentische Vereinigung an der TH Aachen aufgehoben","SDS-Verbot aufgehoben","Kurz berichtet","","tie.",[8],4,[1],[2],2,"20","4"],["4755","1968-11-25","Ausführliche Darstellung der juristischen Probleme und Diskussionen anhand mehrerer konkreter Beispiele.","Richter auf der Suche nach neuen Maßstäben","Juristen","Unterschiedliche Rechtsprechung bei den Demonstranten-Prozessen im Mittelpunkt einer Tagung in Bad Homburg","Hans Schueler",[1],4,[1],[3],2,"20","5"],["4756","1968-11-25","Bericht über einen gem. Berichterstatter unergiebigen Fachkongress des VDS in Hannover","Keine \"Konsumveranstaltung\" sollte es sein?","","?doch auf dem VDS-Kongress \"Schulreform und Lehrerbildung\" gab es weder Diskussionen noch Ergebnisse","Karsten Plog",[11],4,[1,5],[3],2,"20","10"],["4757","1968-11-25","Hundert Studenten wollten Sitzung im Rektorat der Kölner Uni stürmen, die Professoren hatten ihre Tagung aber an einen unbekannten Ort verlegt. Polizei wurde nicht gerufen, um den Konflikt kleinzuhalten.","Kölner Studenten besetzten Rektorat","","Sie wollten die \"Öffentlichkeit\" einer Beratung erzwingen","tie.",[11],4,[1],[2],2,"20","20"],["4758","1968-11-26","Wohnungen von Richtern, die mit Demonstranten-Verfahren, auch im Zusammenhang mit den Unruhen am Tegeler Weg, zu tun haben, wurden mit Steinwürfen attackiert. Gegen den Kommunarden Langhans, der zu solchen Aktionen aufgerufen haben soll, wurde ein Ermittlungsverfahren eingeleitet.","Hoppe: Heimtückische Steinwürfe","","Justizsenator verurteilt \"Aktion\" gegen Richterwohnungen","v.C.",[6],4,[1],[2],2,"24","1"],["4759","1968-11-26","Wegen Osterdemos angeklagte Studenten und SDS-Leute von anderen Studenten aus dem Gerichtssaal \"entführt\". Richter stellt Vorführungsbefehle aus.","Studenten \"entführten\" angeklagte Demonstranten","","","P.W",[8],4,[1],[2],2,"24","5"],["4760","1968-11-26","Über die Verfassung englischer Hochschulen und die dortigen Unruhen.","Bevor die Rebellen aufkreuzten?","Mitbestimmung an englischen Universitäten","?hatte die Studenten-Union das Wesentliche erreicht","Alfred Starkmann",[9],4,[1],[1],1,"24","12"],["4761","1968-11-26","Reformerfolge und weiter nötige Maßnahmen bei der Ingenieurausbildung.","Wie unsere künftigen Fachhochschulen aussehen werden","Vom Standpunkt des Ingenieurs aus gesehen","Modell für Länderparlamente und Kultusminister - Nicht alles ist erreicht","Heinrich Grünewald",[11],4,[1],[5],2,"24","12"],["4762","1968-11-27","FDP plädiert für verbindliche Regelungen über Bundesländergrenzen hinweg. Tritt für Mitbestimmung von Studenten und Assistenten ein.","Für paritätische Vertretung","","Hochschulgesetzentwurf der FDP","ems.",[4],4,[1],[2],2,"28","1"],["4763","1968-11-27","Ministerpräsidenten werden sich im Dezember mit dem Thema befassen","\"Der Föderalismus steht vor einer Bewährungsprobe\"","Hochschulreform","Heinz Kühn appelliert an die Länder","tie.",[4],4,[1],[1],2,"28","5"],["4764","1968-11-27","Ausführliche Auflistung der FDP-Vorstellungen zum Thema Hochschulreform.","Die FDP fordert eine radikale Reform der Universitäten","","Gesamthochschule, Autonomie, Globalhaushalt und Drittelparität - Auszüge aus dem Entwurf der Freien Demokraten","ems.",[4],4,[1],[3],2,"28","5"],["4765","1968-11-27","TU prüft die Möglichkeit eines Hausverbots für Christian Semler, da dieser zu militanten Aktionen aufgerufen haben soll.","Hausverbot für TU erwogen","","","",[8],4,[1],[2],2,"28","16"],["4766","1968-11-28","Kommentator kritisiert zwar etliche Punkte des FDP-Vorschlages, lobt jedoch die Vorlage des Entwurfs an sich.","Modell von der parlamentarischen Universität","","FDP legt als erste Partei einen Hochschul-Gesetzentwurf vor","Walter Görlitz",[4],4,[5],[3],2,"24","2"],["4767","1968-11-28","Zwei Studenten wegen nichtgenehmigter Demo bei SPD-Parteitag verurteilt. Mit Namensnennung.","Zwei Demonstranten verurteilt","","","AP",[1],4,[1],[2],2,"24","3"],["4768","1968-11-29","Senator Stein im Abgeordnetenhaus: Gegen radikale Studentenaktionen werde man nicht nur rein administrativ vorgehen. Zusammenarbeit von SDS und \"Asozialen\" sei Eingeständnis eines hochschulpolitischen Bankrotts.","\"Polizei nicht in Abenteuer jagen\"","","Debatte über Studentenunruhen","v.C.",[1],4,[1],[2],2,"28","1"],["4769","1968-11-29","Zahlreiche Zitate aus einer Abgeordnetenhaus-Debatte, die sich u.a. mit den jüngsten Unruhen befasste, u.a. ist auch von roten Faschisten die Rede.","Persönliche Konfrontationen seltener Schärfe","","\"Gefährdung des Rechtsstaates\" erhitzte die Parlamentarier","hae.",[1],4,[1],[1],2,"28","15"],["4770","1968-11-29","Eine \"Gruppierung demokratischer Studenten\" tritt in einem Aufruf für Reformen ein und kritisiert den Wissenschaftssenator, dass er nicht genug gegen den Missbrauch öffentlicher Räume durch Radikale unternimmt.","Aufruf von Studenten","","","",[4],4,[1],[2],2,"28","15"],["4771","1968-11-29","RCDS-Auftakt für den Wahlkampf zum 21. FU-Konvent","RCDS: Rationale Argumente statt sinnloser Gewalt","","","",[11],4,[1],[2],2,"28","15"],["4772","1968-11-30","Streik, wenn Uni nicht bis Jahresende demokratisiert ist.","In Bochum drohen Studenten mit Streik","Ruhruniversität","Ultimatum bis Jahresende","W.E.",[11],4,[1],[2],2,"34","5"],["4773","1968-11-30","Rektor schreibt an AStA-Vorsitzenden, dass Sitzungsstörungen die Verabschiedung der neuen Hochschulsatzung gefährden. AStA-Chef begründet Störungen mit Reform-Unwilligkeit","Rektor: Neue Satzung jetzt gefährdet","Göttingen","Nach Aktion gegen Senatssitzung","P.W.",[11],4,[1],[2],2,"34","5"],["4774","1968-11-30","18 Studenten von der Deutschen Film- und Fernsehakademie gekündigt. An den Berliner Hochschulen wird deshalb zu \"massenhaften militanten Aktionen\" aufgerufen.","Wollen militant vorgehen","","","",[1],4,[1],[2],2,"34","17"],["4775","1968-11-30","FU will Finanzgebaren des AStA überprüfen lassen. Auslöser: CDU-Anfrage im Abgeordnetenhaus.","FU-Kuratorium will Rechnungshof einschalten","","","",[11],4,[1],[2],2,"34","17"],["4776","1968-10-21","Austrittswelle seit der Münchener Tagung bringt den VDS in Geldnöte.","VDS in finanzieller Bedrängnis","","Tritt Ehmann zurück?","ems.",[11],4,[1],[2],2,"22","1"],["4777","1968-10-21","Neuer Strukturplan, der wegen seiner finanziellen Auswirkungen noch vom Kuratorium gebilligt werden muss.","TU-Senat verabschiedet neuen Strukturplan","","","dpa",[11],4,[1],[2],2,"22","3"],["4778","1968-10-21","Institutsrat mit Drittelparität.","Otto-Suhr-Institut mit neuer Satzung","","","Bi",[11],4,[1],[2],2,"22","3"],["4779","1968-10-21","Details zu den Finanzproblemen und ideologischen Streitigkeiten des VDS.","Ehmann im Feuer zwischen rechtem und linkem Flügel","Studenten","Die VDS-Spitze ist gespalten","Günter Krems",[11],4,[1],[1],1,"22","5"],["4780","1968-10-21","Mittelfristiger Plan für Strukturänderungen vom Akademischen Senat der TU verabschiedet.","Reformplan der TU","","","",[4],4,[1],[2],2,"22","13"],["4781","1968-10-22","VDS-Vorstand betont Handlungsfähigkeit und dementiert baldigen Ehmann-Rücktritt.","VDS-Vorstand: Wir sind handlungsfähig","","","",[11],4,[1],[2],2,"26","5"],["4782","1968-10-23","AStA-Vorsitzende Fronius und Fianzreferent Fleck zurückgetreten. Letzterer hat \"in einigen Fällen\" sauberere Finanzpolitik für nötig erklärt. Neuer AStA-Chef ist der SDS-Mann Jürgen Treulieb.","Im Finanzgebaren des AStA gibt es einige \"haarige Fälle\"","Freie Universität","SDS-Kandidat zum neuen Vorsitzenden gewählt","Bi",[11],4,[1],[1],2,"30","5"],["4783","1968-10-23","Kommentator kritsiert, dass die Justiz in Deutschland mit unterschiedlichem Maß misst. Er macht das an diversen Beispielen deutlich. ","Nachspiele im Gerichtssaal","Studentenprozesse in Deutschalnd","Gegenüber Demonstranten hat die Justiz keine klare Linie","Paul Lersch",[1],4,[5],[4],1,"30","6"],["4784","1968-10-24","Ergebnisse einer Enmid-Umfrage unter Schülern und Studenten","Jeder vierte Student gegen die bestehende Staatsform","","","dpa",[11],4,[1],[2],2,"24","3"],["4785","1968-10-25","Verfahren wegen angeblicher gemeinschaftlicher Nötigung gegen SDS-Mitglied wird nicht eröffnet. Gerichtsreferendar hatte an Auslieferungsblockade in Esslingen teilgenommen.","Gerichtsverfahren gegen SDS-Mitglied abgelehnt","","","dpa",[10],4,[1],[2],2,"28","4"],["4786","1968-10-25","CSU-MdB fragt nach angeblichen militanten Plänen internationler Studentenbrigaden","Bewaffnete Aktionen radikaler Studenten?","","","",[1],4,[1],[2],2,"28","5"],["4787","1968-10-25","Absage wegen drohender Demonstrationen","Senat sagt Rektoratsfeier an Saar-Universität ab","","","d.",[11],4,[1],[2],2,"28","6"],["4788","1968-10-26","Beschwerde gegen Nichteröffnung des Verfahrens gegen einen Auslieferungsblockierer.","Staatsanwalt legt Beschwerde ein","","","La.",[10],4,[1],[2],2,"34","5"],["4789","1968-10-26","Drei SDS-Mitglieder zu Haftstrafen wegen Nötigung bei Vietnam-Demo verurteilt. Verurteilte sind inzwischen verschwunden.","Keine Bewährung für Tübinger Studenten","","","La.",[1],4,[1],[2],2,"34","5"],["4790","1968-10-26","Konzilentwurf wird von Studenten und Mittelbau als nicht ausreichend für eine Unireform empfunden. Große Unruhe an der Hochschule.","Studenten feiern mit Barockmusik","Saarland","An der Universität Saarbrücken stehen die Zeichen auf Sturm","D.",[4],4,[1],[3],2,"34","7"],["4791","1968-10-26","Verwaltungsgerichtsklage um Besetzung von Disziplinarausschüssen im Einvernehmen zwischen Uni und Senator ausgesetzt.","FU-Klage ausgesetzt","","","",[9],4,[1],[2],2,"34","9"],["4792","1968-10-26","Aufruf der Studentenvertretungen der Berliner Hochschulen, Fragebögen der anstehenden Wohnungszählung bei den Studentenvertretungen abzugeben, ist laut Senator Stein rechtswidrig.","Aufruf ist rechtswidrig","","","",[11],4,[1],[2],2,"34","9"],["4793","1968-10-28","Leser plädiert nach Bachmanns fünftem Selbstmordversuch für dessen Überweisung in die Psychiatrie.","Fall für Psychiater","Aus Briefen an die Redaktion","","Leser",[2],4,[6],[2],2,"24","2"],["4794","1968-10-28","Rücktrittsdrohung für den Fall, dass Unireform durch Studentenmaßnahmen stagniert.","Rektor der Saar-Universität droht mit dem Rücktritt","","","D.",[4],4,[1],[2],2,"24","5"],["4795","1968-10-29","Rektor lehnt AStA-Vorschlag, Räte zu etablieren ab, kündigt aber tiefgreifende Strukturveränderungen an.","Offensive des Senats der Technischen Universität","Berlin","Rektor Wever: Permanente Rform an der TU","Bi.",[4],4,[1],[1],1,"26","3"],["4796","1968-10-29","Deutsche Studentenunion fordert Abschaffung der Westdeutschen Rektorenkonferenz und Installierung eines umfassenderen Ersatzgremiums","Studenten fordern Universitätstag","","DSU tagt in München","di.",[11],4,[1],[2],1,"26","6"],["4797","1968-10-29","Universitäten gehen erstaunlich langmütig mit ihren unruhigen Studenten um. Kommentator bringt historische Vergleiche.","Feudalismus an der Universität","","","Horst Diemel",[1],4,[5],[2],2,"26","8"],["4798","1968-10-29","Insbesondere soll für Schadenersatzprozess Verhalten von RA Mahler (hier \"Maler\" genannt) untersucht werden. - Als Anhang: Carl Guggomos ist wegen Vergehens gegen das Pressegesetz zu Geldstrafe verurteilt worden. Er hatte Einzelheiten aus der Anklageschrift im \"Extra-Dienst\" veröffentlicht.","Gericht ordnete Beweisaufnahme an ","","Wegen der Zwischenfälle vor dem Springerhaus","fa., Bi.",[10,2,6],4,[1],[2],2,"26","11"],["4799","1968-10-29","In offenem Brief an Schütz fordert Gruppierung Amnestie für an vergangenen Unruhen beteiligte Personen.","Linksliberale Hochschulgruppe fordert generelle Amnestie","","","",[1],4,[1],[2],2,"26","11"],["4800","1968-10-29","Wenig Erfolg für Anti-Wohnungszählungs-Aufruf der Berliner Studentenvertreter.","Nur geringer Erfolg","","","",[11],4,[1],[2],2,"26","12"],["4801","1968-10-30","Assistenten-Streik wegen Nichteinstellung Rabehls als Hilfsassistent","Soziologie-Assistenten der FU in den Streik getreten","","","Bi",[11],4,[1],[2],2,"28","3"],["4802","1968-10-30","DSU will im VDS die linke Spitze ablösen.","Studentenunion will Linkskräfte ablösen","","\"An 25 Universitäten vertreten\"","Di.",[11],4,[1],[2],2,"28","6"],["4803","1968-10-30","Tübinger Uni-Rektor will wegen Nötigung bei Vietnam-Demo verurteilte Studenten beraten. Droht mit Amtsniederlegung.","Rektor Raiser will Studenten beraten","","","la.",[1],4,[1],[2],1,"28","6"],["4804","1968-10-30","VDS droht mit umfassendem Streik, wenn die Hochschulreform nicht voran kommt","Der VDS droht mit einem Vorlesungsstreik","","Ankündigung in Bonn","ems.",[4],4,[1],[2],2,"28","6"],["4805","1968-10-30","Prozess gegen früheren Kölner AStA-Chef Laepple, der 1966 gegen Fahrpreiserhöhung demonstriert hatte. Kölner Strafrechts-Ordinarius hält Sitzstreik für legal.","\"Sitzstreik ist eine legale Form des gewaltlosen Widerstandes\"","","Professor Klug im Kölner Laepple-Prozess","Alfred Freudenhammer",[1],4,[1],[1],2,"28","24"],["4806","1968-10-30","Plädoyers der Staatsanwaltschaft und der Verteidigung im Frankfurter Prozess. Mehrere Zitate der beiden Seiten.","Sechs Jahre Zuchthaus beantragt","","Gegen alle vier Angeklagten im Kaufhausbrand-Prozess","Joachim Neander",[9],4,[1],[5],2,"28","24"],["4807","1968-10-30","Auszug aus einem Buchbeitrag von Erwin Scheuch, in dem er die Ideen der Neuen Linken analysiert","Der \"Neuen Linken\" ins Konzept geschaut","Ein Buch mit dreizehn Autoren","\"Die Wiedertäufer der Wohlstandsgesellschaft\"","Erwin K. Scheuch",[1],4,[5],[4],1,"28","25"],["4808","1968-10-31","Zunehmende Widerstände und Aktionen wegen Harndts Weigerung, Bernd Rabehl als Assistenten an der FU einzustellen.","Studenten verhindern Sitzung des Akademischen Senats","FU Berlin","Protest gegen Entscheidung des Rektors wächst","Bi.",[11],4,[1],[1],2,"24","3"],["4809","1968-10-31","Medizin-Assistenten kritisieren Harndt-Rede bei Übergabe des FU-Klinikums, weil sie reformkritische Töne herausgehört zu haben glauben.","Medizin-Assistenten kritisieren Rektor Harndt","","","V.D.",[4],4,[1],[2],2,"24","4"],["4810","1968-10-31","Zwei Studenten, die an Blockade der Frankfurter Societäts-Druckerei beteiligt waren, sind freigesprochen worden. Ihr Verhalten deckt das Grundrecht auf freie Meinungsäußerung.","Freispruch für Demonstranten","","\"Durch Meinungsfreiheit gedeckt\"","UPI",[10,2],4,[1],[2],2,"24","6"],["4811","1968-10-31","VDS empört sich über geplantes Ehrengerichtsverfahren gegen Mahler","VDS empört über Verfahren gegen Mahler","","","AP",[6],4,[1],[2],2,"24","6"],["4812","1968-12-02","Arbeitsgemeinschaft der Polizeichefs einiget sich auf veränderte Vorgehensweise gegen militante Demonstranten.","Die Polizei will früher eingreifen","Ausschreitungen","Wenn Demonstranten Barrikaden bauen und Steine sammeln","AP, dpa",[1],4,[1],[3],2,"20","3"],["4813","1968-12-02","Dringlichkeitsantrag der CDU im Landtag zu den Vorgägnen an der Uni Tübingen. Professoren sehen Freiheit der Lehre durch Radikale gefährdet.","CDU verlangt von der Regierung: Die Freiheit der Lehre sichern","Baden-Württemberg","Professoren warnen vor Politisierung der Universität","la.",[11],4,[1],[3],1,"20","3"],["4814","1968-12-02","Der rheinland-pfälzische CDU-Vorsitzende Helmut Kohl: \"Das Fernsehen hat den Sachforderungen der außerparlamentarischen Opposition genützt, der APO-Bewegung aber geschadet.\" Andere betonen Verstärker-Funktion des Fernsehens für die APO.","Das Fernsehen als \"Verstärker\"","","Diskussion in der Evangelischen Akademie Herrenalb","la.",[1],4,[1],[2],2,"20","5"],["4815","1968-12-02","Vorerst keine öffentlichen Gelder mehr für den SDS an hessischen Hochschulen.","Hessischer Kultusminister sperrt Mittel für den SDS","","","dpa",[8],4,[1],[2],2,"20","5"],["4816","1968-12-02","Ausführlicher Artikel beschäftigt sich mit dem Taktieren der AStA, deren ursprünglichen Aufgaben und ihren Einflüssen auf die Versuche einer Hochschulreform.","Eine Union zur Verhinderung der Reform","Student und Universität","AStA-Politik zwischen Pseudorevolutionären und konservativen Professoren","Jens Litten",[11],4,[5],[1],1,"20","9"],["4817","1968-12-02","Kurzmeldungen zu verschiedenen studentischen Themen, u.a. zu Streiks in Bonn","Am Schwarzen Brett","","","",[11],4,[1],[2],2,"20","9"],["4818","1968-12-02","Veränderungen des Studienfachs. Das Fach und die Rebellion. Politologen und Arbeitsmarkt.","Die Politikwissenschaft - zum Modefach degradiert","","Warnungen vor dem Studium berechtigt?","Karsten Plog",[11],4,[5],[5],2,"20","9"],["4819","1968-12-02","Senator Stein erinnert in einem Text an die Gründung der FU vor 20 Jahren und an ihr Gründungscharisma der Freiheit.","Freiheitsbekenntnis gilt wie damals","","","",[11],4,[1],[2],2,"20","14"],["4820","1968-12-03","Erste Zeugenvernehmungen im Schadenersatzprozess des Axel Springer Verlages gegen RA Horst Mahler. Schadenshöhe: 506.000 DM.","Die ersten Zeugen im Mahler-Prozess","","","v.C.",[10,6],4,[1],[2],2,"22","3"],["4821","1968-12-03","Verweis von 18 Studenten von der Film- und Fernsehhochschule von zwei Akademie-Direktoren gebilligt.","Relegation gebilligt","","","Bi.",[1],4,[1],[2],2,"22","3"],["4822","1968-12-03","Biedenkopf kann Sprengung einer Unisitzung nicht verhindern. Professoren verlassen den Raum.","Senatssitzung in Bochum von Studenten gesprengt","","","W.E.",[11],4,[1],[2],2,"22","5"],["4823","1968-12-03","An der Wirtschafts- und Sozialwissenschaftlichen Fakultät der FU sollen die Dozenten ausgesperrt werden, die die Reformvorstellungen der Studenten nicht teilen. Erst Professoren brechen Lehrveranstaltungen ab.","Dozenten sollen ausgesperrt werden","","","",[4],4,[1],[2],2,"22","13"],["4824","1968-12-04","SFB-Team wird während einer VV, in der auch die von der Film-Akademie relegierten Studenten Thema waren, angegriffen. Kamera und Stativ werden weggenommen.","SFB-Kamera-Team in der FU angegriffen","","","Bi.",[1],4,[1],[2],2,"26","1"],["4825","1968-12-04","Bonner AStA protestiert gegen Südkoreanischen Spionageprozess","Bonner AStA protestiert","","","dpa",[11],4,[1],[2],2,"26","3"],["4826","1968-12-04","Rückblick auf zwanzige Jahre Universitätsgeschichte.","Suche nach Wahrheit in Freiheit","Berlin","Vor 20 Jahren wurde die Freie Universität gegründet","Bernt Conrad",[11],4,[1],[1],2,"26","5"],["4827","1968-12-04","Entsprechender Beschluss des Institutsrates.","Prüfungen jetzt öffentlich","","Am Otto-Suhr-Institut","Bi.",[11],4,[1],[2],2,"26","5"],["4828","1968-12-04","FU-Kurator will Wiedergutmachung von bei Institutsbesetzungen entstandenen Schäden. ","Schadenersatz-Forderung soll eingeklagt werden","","","dpa",[1],4,[1],[2],2,"26","5"],["4829","1968-12-04","Nach drei gestörten Sitzungen tagen die Fakultäten in Göttingen jetzt unter Polizeischutz.","Polizeischutz wurde angefordert","","Göttinger Rektor wurde bestätigt","di.",[11],4,[1],[2],2,"26","5"],["4830","1968-12-04","Bestand der Uni trotz Bremer Finanzproblemen gesichert.","Universität Bremen nicht gefährdet","","Speckmann zu Finanzproblemen","M.",[11],4,[1],[2],2,"26","5"],["4831","1968-12-04","Verfahrenseinstellung gegen Blockierer der Esslinger Druckerei als unbegründet aufgehoben.","Landgericht hebt Eßlinger Beschluss auf","","","uhl.",[10,2],4,[1],[2],2,"26","6"],["4832","1968-12-04","Drei juristische Kommentare zum Artikel 8 des Grundgesetzes und zu den vergangenen Demonstrationen.","Wo liegen die Grenzen der Demonstrationsfreiheit?","Drei Juristen setzen sich mit den neuen Formen öffentlicher Meinungsäußerung auseinander","Trotz der Proteste hat sich bisher kaum etwas geändert - Friedliche Versammlungen - ohne Waffen - Die Rechtsordnung gilt nicht nur für Demonstranten","Josef Augstein, Anton Henneka, Ernst Forsthoff",[1],4,[5],[4],2,"26","24"],["4833","1968-12-05","Journalistenverband, Politiker u. a. protestieren gegen Angriff auf Kamerateam. Studentenvertreter teilt mit, Kamera sei vergesellschaftet worden, da der SFB als Propagandainstrument der bürgerlichen Klasse wirke.","Zwischenfall in der FU scharf verurteilt","","Kamera \"vergesellschaftet\"","Bi.",[1],4,[1],[2],2,"26","3"],["4834","1968-12-05","Zunehmend kontroverse Diskussionen unter den Studenten über das \"Wie weiter?\"","Verlieren Radikale an Resonanz?","Berlin","Viele Studenten kritisieren \"militante Aktionen\"","Bi.",[1],4,[1],[5],2,"26","3"],["4835","1968-12-05","Aussagen über die Ausschreitungen von dem Springer-Verlagshaus in Berlin zu Ostern, im Rahmen des vom Springer-Verlag angestrengten Prozesses gegen Horst Mahler.","Unterschiedliche Aussagen","","","dpa",[10,6,2],4,[1],[2],2,"26","3"],["4836","1968-12-05","Während die Studenten dem Reformentwurf des Kultusministers knapp zustimmen, verweigern sich die bayerischen Rektoren.","Rektoren: Entwurf in dieser Form nicht annehmbar","Hochschulreform","Kritik an Kultusminister Huber","pff",[4],4,[1],[2],2,"26","5"],["4837","1968-12-05","Frankfurter Jurist behauptet, dem SDS gehe es um die Zerschlagung der Justiz.","\"Aufgeregte Urteile meiden\"","","Warnung Wassermanns","S.",[8],4,[1],[2],2,"26","6"],["4838","1968-12-05","Landesjustizminister fordert bei einer Veranstaltung entschiedeneres Vorgehen der justiz gegen SDS und APO.","Richter sollen der Justizkampagne des SDS entschieden begegnen","Niedersachsen","Minister Bosselmann rügt Auftreten von Rechtsanwälten","P.W.",[8],4,[1],[1],1,"26","6"],["4839","1968-12-06","Dekan verweist darauf, dass Sitzungsstörungen den Reformprozess stören und verlangsamen. Junge Union in Berlin will verstärkt gegen \"individuellen Terror\" vorgehen.","Prof. Fischer: Mit Störungen gewinnen Studenten nichts","","","Bi.",[4],4,[1],[2],2,"24","1"],["4840","1968-12-06","Liberale und reformfreudige Professoren gehen zunehmend auf Distanz zu radikalen Studenten, \"in denen sie sich geirrt\" hätten. Gollwitzer zur Gewaltfrage.","Professoren besorgt über die weitere Entwicklung","Berlin","Wissenschaftliche Seminare in Privatwohnungen","Bi.",[1],4,[1],[5],2,"24","3"],["4841","1968-12-06","Termin für Grundsteinlegung eines Baukomplexes der Uni wegen Furcht vor Störungen verschoben","Studenten verpassten Grundsteinlegung","","Langeheine in Göttingen","ze",[11],4,[1],[2],2,"24","5"],["4842","1968-12-07","Senator bittet Studenten, sich für konstruktive Reformen einzusetzen.","\"Extremisten das Gesetz des Handelns entziehen\"","","Stein appelliert an Studenten","v.C.",[1],4,[1],[2],2,"33","1"],["4843","1968-12-07","Kommentator philosophiert über die gegenwärtigen Probleme der Universitäten an Hand von Rückblicken in deren Geschichte.","Die Alma mater zerfällt","","Wieder Aufrufe zur Gewalt - Explosion und Implosion - Wissenschaft ohne Eros","Günter Zehm",[1],4,[5],[1],2,"33","2"],["4844","1968-12-07","Ein Flugblatt der Studentenvertretungen von FU und TU hatte jüngst studentische Gewalt als \"einzig adäquates Mittel\" gegen die Macht der Herrschenden propagiert. Hiergegen wendet sich der Berliner Wissenschaftssenator in einem Aufruf an die Studenten.","Appell zu positivem Engagement","Freie Universität","Stein: Studenten sollen für das Wohl ihrer Hochschule eintreten.","v.C.",[1],4,[1],[2],2,"33","3"],["4845","1968-12-07","BND-Mitarbeiter wollte in einem Gespräch in Kieler Uni Mitarbeiter für seine Behörde interessieren. Um Agenten-Anwerbung sei es nicht gegangen. Anregung zu diesem Kontakt sei aus Tübingen gekommen.","Bonn bestreitet Versuch der Agenten-Werbung","Bundesnachrichtendienst","Tübinger AStA fordert Rücktritt Eschenburgs","vdh., la., Z.",[9],4,[1],[1],1,"33","5"],["4846","1968-12-09","Anlässlich des zwanzigsten Gründungstages äußert Schütz Hoffnung auf gute Zukunft für die FU. Auseinandersetzungen müssten ausgetragen werden, aber ohne Terror und Gewalt.","Schütz: Freie Universität Modell für die Zukunft","","","dpa",[11],4,[1],[2],2,"22","3"],["4847","1968-12-10","Fortgang des Prozesses gegen Horst Mahler um dessen vermeintliche Verantwortung für Osterunruhen vor dem Springer-Haus.","Aussagen über Sachschäden","","","dpa",[10,6,2],4,[1],[2],2,"22","3"],["4848","1968-12-10","Aufgrund eines anonymen Tipps konnte der SFB seine Kameraausrüstung zurückbekommen","Kamera zurückerobert","","","v.C.",[1],4,[2],[2],2,"22","3"],["4849","1968-12-10","DSU veranstaltet Tagung in Berlin. Hat jetzt 2000 Mitglieder an 25 Unis.","Studenten-Union kritisiert linksextreme Kommilitonen","","","Bi.",[11],4,[1],[2],2,"22","3"],["4850","1968-12-10","Störung von 15 Lehrveranstaltungen in der FU wegen der relegierten Filmstudenten","Handgemenge nach \"Go-in\"","","Studentische Aktionsgruppe störte Vorlesungen und Seminare","wt",[1],4,[1],[2],2,"22","9"],["4851","1968-12-11","Im Zuge einer Sitzungssprengung hatten Göttinger Studenten einige Professoren in \"revolutionäres Gewahrsam\" genommen. Nun drohen strafrechtliche Schritte.","Übergekocht","Zum Tage","","gaz.",[11],4,[5],[2],2,"28","2"],["4852","1968-12-11","300 Studenten besetzen aus Solidarität mit den relegierten Filmstudenten ein Gebäude der Wirtschafts- und Sozialwissenschaftliche Fakultät. Widerstand der Studentenmehrheit formiert sich. Dagegen werden die Fronten zwischen Professoren und Studenten im OSI immer härter.","Fakultätsgebäude der FU besetzt - Lernwillige Studenten wehren sich","Berlin","Unterschriften gegen \"Maßnahmen des Meinungsterrors\"","Bi.",[1],4,[1],[1],2,"28","3"],["4853","1968-12-11","Ost-Berliner Rechtsanwalt Kaul fordert Zusammenlegung verschiedener Studentenprozesse, bei denen er Mandanten zu vertreten hat.","Kaul will Prozess gegen 50 Studenten in Bonn","","","UPI",[1],4,[1],[2],2,"28","3"],["4854","1968-12-11","Innensenator Neubauer warnt auf einer SPD-Veranstaltung vor Gewalt bei Demonstrationen","Neubauer warnt vor Gewaltanwendung","","","dpa",[1],4,[1],[2],2,"28","3"],["4855","1968-12-11","Richter wird abgelehnt, weil er kürzlich einen stark umstrittenen Freispruch für einen früheren Richter mit NS-Vergangenheit gesprochen hatte. Details zur Verfahrensordnung.","Bachmann lehnt Kammergerichtsrat Dr. Oske ab","","Dutschke-Attentäter verweigert außerdem Ersatz-Verteidiger das Vertrauen","fa., Bi.",[2],4,[1],[3],2,"28","13"],["4856","1968-12-12","Vierter Tag der Beweisaufnahme im Prozess gegen Mahler wegen dessen vermeintlicher Verantwortung für die entstanden Schäden des Springer-Verlags während der Osterunruhen. ","Zeugenaussagen über Mahler","","","dpa",[10,2],4,[1],[2],2,"22","3"],["4857","1968-12-12","Vertagung wegen Erkrankung des Verteidigers.","Bachmann-Prozess wurde vertagt","","","",[2],4,[1],[2],2,"22","13"],["4858","1968-12-12","Störungen bei der Steglitzer BVV-Sitzung durch Studenten der Pädagogischen Hochschule","Studenten stürmten Bezirksparlament","","PH-Angehörige fanden \"ihr\" Thema - Tempelhofer debattierten über politische Bildung","kpk, loh",[1],4,[1],[3],2,"22","13"],["4859","1968-12-12","3.500 Ingenieur-Studenten fordern Demokratisierung ihrer Hochschulbereiche.","Ingenieur-Studenten streiken","","Senator Evers: Forderungen weitgehend erfüllt","wt",[11],4,[1],[2],2,"22","14"],["4860","1968-12-12","Professor Helmut Gollwitzer macht sich in einem längeren Leserbrief zum Anwalt der rebellierenden Studenten. Befasst sich auch mit der Frage der Gewalt.","Eine Lanze für die Studenten","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"22","15"],["4861","1968-12-13","Friedliche Demonstration von 2.000 PH-Studenten in Düsseldorf.","Angehende Lehrer demonstrieren gegen Professorenmangel","","","",[1],4,[1],[5],1,"28","1"],["4862","1968-12-13","Professoren und Assistenten rufen zur Urabstimmung über den Fortgang des Reform-Experiments. Bei Studenten wird fehlende Kompromissbereitschaft beklagt.","Reformen zum Scheitern verurteilt?","Otto-Suhr-Institut","Extreme Vorderungen von Studenten gefährden das Exeperiment","Bi.",[11],4,[1],[5],2,"28","6"],["4863","1968-12-13","Ingenieure wollen sich nicht zu \"Manipulationsobjekten\" von FU- oder TU-Studenten machen lassen. Weisen deren Solidaritätsangebote zurück.","Mehrere Go in und ein Go out","","Ingenieurstudenten lehnten Schützenhilfe ab","eb",[11],4,[1],[2],2,"28","9"],["4864","1968-12-14","Leser stimmt dem Leitartikel \"Alma mater zerfällt\" zu.","Skandalös","Aus Briefen an die Redaktion","","Leser",[1],4,[6],[2],2,"30","2"],["4865","1968-12-14","Vorstellung der neuen Hochschule.","Neue Hochschule für eine Milliarde DM","Nordrhein-Westfalen","In Dortmund wird die 37. Universität der Bundesrepublik eröffnet","tie.",[11],4,[1],[1],2,"30","3"],["4866","1968-12-14","Gastbeitrag eines Dozenten am Philosophischen Seminar der FU, wo z.Z. kein Lehrbetrieb möglich ist. Abwägend kritische Einschätzung.","Haben die Studenten recht?","","","Norbert Hinske",[1],4,[5],[2],2,"30","I"],["4867","1968-12-16","An der Kieler Uni hatten Studenten vergeblich versucht, eine Veranstaltung mit Bundesforschungsminister \"umzufunktionieren\". Stoltenberg wertet das als einen Sieg.","\"Klare Niederlage der Linksradikalen\"","","Tumulte um Stoltenberg","Z.",[1],4,[1],[2],2,"20","3"],["4868","1968-12-16","Zustandsbeschreibung der Frankfurter Uni, die wie gelähmt wirkt.","Wer lernen will, geht heimlich zum Professor","Frankfurt","Ein Universität siecht dahin","Joachim Neander",[11],4,[1],[3],1,"20","5"],["4869","1968-12-16","\"Revolutionäre\" Institutsratsmitglieder zurückgetreten. Urabstimmung davon nicht beeinträchtigt.","\"OSI-Urabstimmung als Vertrauensfrage\"","","Reformer verurteilen Störungen","dpa",[11],4,[1],[2],2,"20","5"],["4870","1968-12-17","Störungen und Handgreiflichkeiten bei der feierlichen Eröffnung der neuen Uni in Dortmund.","Ruhr-Universität Dortmund eröffnet","","Feier von Studenten gestört","tie.",[11],4,[1],[5],1,"22","1"],["4871","1968-12-17","Zug von Korporierten aus Bayern durch Nürnberg. Bekunden auf Flugblättern ihre Gewaltlosigkeit.","Thomas-Bummel mit einem Hauch von Politik","","","",[1],4,[1],[2],1,"22","5"],["4872","1968-12-17","Neueste Entwicklungen an der PH, am OSI, am Romanischen Institut, an der TU, am Philosophischen Seminar.","PH-Studenten beschlossen Streik","","OSI-Urabstimmung positiv","Bi.",[1],4,[1],[2],2,"22","5"],["4873","1968-12-17","Bericht über mehrere Strafverfahren, u.a. über Prozess, die sich bei Schah-Demo übergriffen gegen Demonstranten schuldig gemacht haben.","Polizisten leugneten standhaft","","Auch von Berufungsinstanz verurteilt - Aus Moabit","af",[7],4,[1],[1],2,"22","10"],["4874","1968-12-17","Kommentator rügt die mangelhafte Pressearbeit der Universitäten. Im Gegensatz zu den Professoren haben die Studenten z.B. eigene Zeitungen.","Ohne Presse","","","Bernd Nellessen",[11],4,[5],[2],2,"22","12"],["4875","1968-12-17","Über den Zustand der Juristenausbildung.","Juristen zwischen Campus und Kasernenhof","","Reform zur wissenschaftlichen Freiheit oder schulische Zucht?","Paul Lersch",[4],4,[1],[1],1,"22","12"],["4876","1968-12-17","Kurzmeldungen zu verschiedenen studentischen Themen.","Am Schwarzen Brett","","","",[11],4,[1],[2],2,"22","12"],["4877","1968-12-18","Effekt der neuen Vorschläge für eine Reform könnte die Annäherung der Professoren und Studenten in ihrer Ablehnung sein.","Das Tauziehen um die Reform der Hochschulen","","Studentenvertreter und Rektoren haben Bedenken gegen die Vorschläge des Wissenschaftsrates","Günter Krems",[4],4,[5],[3],2,"28","2"],["4878","1968-12-18","Organisationsreform am Physiologischen Institut der FU","Departments-Ordnung an FU-Institut angenommen","","","dpa",[4],4,[1],[2],2,"28","4"],["4879","1968-12-18","Störung von Weihnachtsgottesdiensten angekündigt.","Pfarrer Pohl hofft auf die Vernunft der Menschen","Gottesdienste","APO droht mit Aktionen","Co.",[3],4,[1],[5],2,"28","5"],["4880","1968-12-18","TU-Architekten finden Kompromiss zur vorläufigen Befriedung ihres Instituts.","Kompromiss an TU-Fakultät","","","dpa",[4],4,[1],[2],2,"28","5"],["4881","1968-12-18","SDS gründet politische Bildungseinrichtung in Frankfurt","\"Sozialistischer Club\" in Frankfurt gegründet","","","dpa",[8],4,[1],[2],2,"28","6"],["4882","1968-12-18","Studenten drängen Rektor, AStA der Uni Hannover aus dem VDS auszutreten","Rektor soll Zwang gegen die AStA anwenden","","Forderung von Studenten","P.W.",[11],4,[1],[2],2,"28","6"],["4883","1968-12-19","Darstellung des Zehn-Punkte-Vorschlages der Westdeutschen Rektorenkonferenz für eine Hochschulreform","Fachbereiche und Fakultäten \"neuer Art\"","Hochschulreform","Die Vorschläge der Rektoren","Günter Krems",[4],4,[1],[1],1,"20","5"],["4884","1968-12-19","Institutsbesetzungen in Frankfurt und Bochum. Teils erhebliche Schäden.","Der Rektor musste wieder die Polizei rufen","","Aber Studenten räumten freiwillig","Lh, WE",[1],4,[1],[2],2,"20","5"],["4885","1968-12-19","Bei BVV-Sitzung in Schöneberg anwesende Lehramtsstudenten ziehen ab, nachdem Stadtrat klargemacht hat, dass Hochschulangelegenheiten nicht in seine Kompetenz fallen.","Stadtrat nahm Wind aus den Segeln","","PH-Studenten verließen enttäuscht Schöneberger Parlament","loh",[4],4,[1],[2],2,"20","9"],["4886","1968-12-19","Aufhebung der für Januar geplanten Terminierung eines Prozesses gegen Dutschke wegen Landfriedensbruchs gefordert. Will noch nicht wieder nach Deutschland kommen, da nicht für seine Unversehrtheit garantiert werden könne.","Dutschke wünscht Prozess noch nicht","","","",[2],4,[1],[2],2,"20","10"],["4887","1968-12-20","Vermutlich wegen Einleitung eines Hausordnungsverfahrens gegen 14 Studenten Brandanschlag auf Registratur des FU-Rektorats","Brandstiftung im Rektorat der Berliner FU","","Großer Sachschaden","Bi.",[11],4,[1],[5],1,"24","1,5"],["4888","1968-12-20","Sieht man die Zustände an den Unis und die Vorschläge der Rektoren, könnte man meinen Letztere \"operierten ? gewissermaßen im luftleeren Raum\". \"Aber die Situation ist gerade deshalb so prekär geworden, weil man in Sachen Hochschulreform zwanzig Jahre hindurch immer nur laviert hat.\"","In der Praxis aber herrscht Anarchie","Reformvorschläge der Rektoren","Zunächst müssen Recht und Freiheit an den Universitäten wiederhergestellt sein","Walter Görlitz",[4],4,[5],[5],1,"24","2"],["4889","1968-12-20","Kritik am VDS für dessen Kritik am Bundesinnenministerium","Keine Stipendien","Aus Briefen an die Redaktion","","Leser",[11],4,[6],[2],2,"24","2"],["4890","1968-12-20","SDS kündigt für 1969 verstärkte Kampfmaßnahmen an den Universitäten an","SDS prophezeit ein unruhiges neues Jahr","","","",[8],4,[1],[2],2,"24","6"],["4891","1968-12-20","Beratungen über Reformen in Göttingen sollen mit Jahresbeginn wieder aufgenommen werden. Assistenten äußern sich kritisch.","Universitätssenat berät wieder über Satzungsreform","","","P.W.",[11],4,[1],[2],2,"24","6"],["4892","1968-12-20","Reportage von einer aus dem Ruder laufenden Diskussionsveranstaltung zwischen Juristen und APO-Leuten in einer Münchner Brauerei.","Diskussion mit der APO auf bayrisch","","Plötzlich war der Oberstaatsanwalt umringt - Auf dem Klavier ertönte \"Hänschen klein\"","Wilhelm F. Maschner",[1],4,[7],[3],2,"24","7"],["4893","1968-12-20","Katholische Priester und Laien sprechen sich gegen Gottesdienststörungen aus","Gegen Störungen des Gottesdienstes","","","",[3],4,[1],[2],2,"24","13"],["4894","1968-12-20","Termin für Prozess gegen \"Rudolf Dutschke\" hängt an medizinischem Gutachten","Gutachten entscheidet über Dutschke-Termin","","","",[2],4,[1],[2],2,"24","13"],["4895","1968-12-20","Gespräch, bei dem es auch um Polizeitaktik bei Demos und um Polizeibewaffnung geht.","\"Echter Schutz dem wirklichen Demonstranten\"","","Gespräch mit Berlins künftigem Polizeipräsidenten Klaus Hübner","Klaus Haetzel",[9],4,[3],[1],1,"24","14"],["4896","1968-12-20","HU beklagt Diskriminierung von PH-Studenten durch die Bezirksverwaltungen in Tiergarten und Steglitz. ","Studenten-Diskriminierung verhindern","","Humanistische Union schreibt an Senator Evers","eb",[11],4,[1],[2],2,"24","14"],["4897","1968-12-21","Regierender Bürgermeister spricht in seiner Jahrespressekonferenz von einer leichten Entspannung der Situation an den Berliner Hochschulen. Meinungs- und Demonstrationsfreiheit müssen geschützt werden, Terror muss entgegengetreten werden.","Einige Spannungsmomente abgebaut","","Klaus Schütz zur Universitäts-Situation","cg",[1],4,[1],[2],2,"30","17"],["4898","1968-12-21","Anfechtungsgründe gegen FU-Konventswahlen als unbegründet zurückgewiesen","Konventswahl war korrekt","","","",[11],4,[1],[2],2,"30","17"],["4899","1968-12-21","RA Mahler hat im Republikanischen Club APO-Leute aufgefordert, vom 28.-31.12. am Kranzler-Eck mit Passanten politische Diskussionen zu führen.","APO will diskutieren","","","",[1],4,[1],[2],2,"30","17"],["4900","1968-12-21","Vorläufige Verfahrenseinstellung wird mit Dutschkes Gesundheitszustand begründet.","Dutschke-Prozess vorläufig eingestellt","","","",[2],4,[1],[2],2,"30","18"],["4901","1968-12-21","PH-Senat verwahrt sich gegen Dozenten-kritische Beschlüsse einiger BVV","PH gegen BVV-Beschlüsse","","","",[11],4,[1],[2],2,"30","18"],["4902","1968-12-21","Ausführliche Beiträge zu den Unruhen der Jugend in ihren verschiedenen Aspekten. Die ersten drei Seiten der siebenseitigen Beilage beschäftigen sich vornehmlich mit der Situation in Deutschland.","Revolte der Jugend","","","Günter Zehm, Rudolf Herlt, J. H. Knoll, Karsten Plog, Bernd Nellessen, René Leudesdorff, Walter Görlitz",[1],4,[5],[4],1,"30","I,II,III"],["4903","1968-12-24","Gastbeitrag eines Politologen vom Otto-Suhr-Institut, der trotz aller Probleme für eine Reform der Hochschulen wirbt.","Der dornige Weg der Hochschulreform","Hat die Öffentlichkeit das Vertrauen verloren?","Die einzige Alternative zwischen Anarchie und untragbaren Zuständen","Alexander Schwan",[4],4,[5],[5],1,"24","2"],["4904","1968-12-24","Vorabkritik an den zu befürchtenden Störungen von Gottesdiensten in der Kaiser Wilhelm Gedächtniskirche","Verheißung und Verwirrung","Zum Tage","","Co.",[3],4,[5],[2],2,"24","2"],["4905","1968-12-27","Trotz Störungen in der KWG keine Handgreiflichkeiten","Demonstranten stürzten Christus-Figur um","","","v.C.",[3],4,[1],[2],2,"16","1"],["4906","1968-12-27","Ausführlicher Bericht von den Vorgängen in der Gedächtniskirche während der Weihnachtsgottesdienste. In der Turmruine der KWG wird eine Christus-Figur umgeworfen.","Einige Demonstranten drängten zum Altar","","Zwischenfälle in der Gedächniskirche - Polizei braucht nicht einzugreifen","gvc",[3],4,[1],[1],1,"16","9"],["4907","1968-12-31","Kommentierter Jahresrückblick, bei dem die Studentenunruhen eine eher untergeordnete Bedeutung haben.","Blick zurück ohne Zorn","","Letzte Jahr der Großen Koalition? - Erfolgskatalog ist klein - Der Wahlkampf beginnt","Georg Schröder",[1],4,[5],[1],2,"30","2"],["4908","1968-12-31","Rektor rügt AStA in Hannover schriftlich, weil dieser sich trotz entsprechendem Abstimmungsergebnis weigert, aus dem VDS auszutreten.","Rektor rügt den AStA in Hannover","","\"Urabstimmung nicht befolgt\"","P.W.",[11],4,[1],[2],2,"30","6"],["4909","1968-12-31","In Beantwortung einer Anfrage im Abgeordnetenhaus nennt Senator Stein Gründe für die Relegierung von Studenten der Film- und Fernsehakademie.","\"Verschiedene Gründe maßgebend\"","","Stein nimmt Stellung zu Studenten-Entlassungen","sh",[1],4,[1],[2],2,"30","13"],["4910","1966-12-08","Etwa 600 Studenten der FU Berlin haben eine Veranstaltung mit dem südvietnamesischen Botschafter gestört. Die geforderte Diskussion mit dem Botschafter fand zunächst statt, dieser sei jedoch kaum zu Wort gekommen und mit Parolen wie \"Es lebe die Rote Garde\" niedergebrüllt worden. Nach einem Handgemenge um das Mikrofon brach der Botschafter die Veranstaltung ab.","Botschafter niedergebrüllt","","","",[1],7,[1],[2],2,"22","2"],["4911","1966-12-12","Auseinandersetzungen zwischen etwa 2000 jugendlichen Demonstranten gegen den Vietnamkrieg und der Polizei in Westberlin. Die Polizisten wurden mit Steinen beworfen, 74 Demonstranten wurden festgenommen. Ein Senatssprecher bezeichnet die Demonstranten als \"politische Rowdys\" und spricht von einer \"verschwindend kleine[n] Minderheit\".","Krawall am Kurfürstendamm","","","",[1],7,[1],[2],2,"20","18"],["4912","1966-12-13","Bei der Veranstaltung \"sing-out 66\" im Auditorium Maximum der Hamburger Universität kam es zu Störungen durch Studenten, die Polizei verhinderte, dass die Studenten auf die Bühne gelangten. Eine anschließende Diskussion hätte gezeigt, dass Befürworter und Gegner des Protests erstaunlich uninformiert gewesen seien.","Störung bei \"sing-out 66\"","","","",[1],7,[1],[2],2,"18","4"],["4913","1966-12-16","Der Rektor der Universität Hamburg, Prof. Schäfer, erwartet einen Anstieg der Studentenzahlen von 19.000 auf 30.000 innerhalb der nächsten zehn Jahre. Er fordert weitere Bauten von Institutsgebäuden und insbesondere den Ausbau der Bibliothek, ansonsten drohe eine \"Katastrophe\". Parteivertreter äußern sich dazu kritisch.","Hamburg: 11000 Studenten mehr","","Notruf der Universität: Gebäude nicht ausreichend","mor.",[4],7,[1],[1],2,"26","1"],["4914","1966-12-17","Die Vorsitzenden des AStA der Uni Hamburg, Detlev Albers und Gert Hinnerk Behlmer, verließen unter Protest eine Sitzung des Akademischen Senats, da dieser sich weigerte, die Frage der studentischen Vertretungen in den Fakultäten zu besprechen. Erst wenn den Studenten eine angemessene Mitwirkung zugesichert wird, wolle man die Arbeit wieder aufnehmen.","AStA-Vertreter verließen die Sitzung","","","",[1],7,[1],[2],2,"44","5"],["4915","1966-12-17","Bundeswissenschaftsminister Stoltenberg bezeichnet den Ausbau der Hochschulen als die Lebensfrage unserer Volkswirtschaft. Allein bis 1970 müßten zehn Milliarden DM ausgegeben werden, wenn man der dynamischen Entwicklung Rechnung tragen wolle.","Universitäts-Ausbau wird Lebensfrage","","","ff",[4],7,[1],[3],2,"44","14"],["4916","1966-12-17","Auf einer Diskussionsveranstaltung von Rektor Lieber vor 600 Studenten in der FU Berlin kam es zu Störungen durch eine \"verschwindend kleine\" Gruppe. Diese las ein Flugblatt vor (das sogenannte \"Fachidiotenflugblatt\") und entriss dem Rektor das Mikrofon, woraufhin dieser die Veranstaltung verließ. Bericht über die Ziele dieser \"Roten Garde\", es ginge ihnen um die radikale Änderung der Universitäten, Berlin nur der Ausgangspunkt, Studenten sollen gleichberechtigt neben den Professoren stehen. Dies wird als \"diskutabel\" bezeichnet, jedoch würden die Studenten ihre Ziele nicht gemeinsam mit den Professoren erreichen, sondern im Kampf. Den Kern der Aktivisten würden 20 bis maximal 30 Studenten aus dem SDS und dem Argument-Club bilden, diese hätten sich quasi selbst links überholt. Ihre Gesichter würden teils \"fanatische Züge\" aufweisen, meist seien es ältere Semester, die anscheinend ihren Abschluss aufgegeben hätten. Namen seien nicht bekannt. Die Kommune-Idee würde empört fortgewiesen werden. Rektor Lieber bezeichnet sie als \"intolerante Minderheit\", Gefahr für Lehre und Forschung beständen nicht, wohl aber für den Ruf der FU. Grundsätzlich hält Lieber aber Unruhe auch für förderlich. Dem SDS seien die \"Rotgardisten\" auch unheimlich, da man sich aber weigert, deren Namen bekanntzugeben, überlegt man seitens der FU, dem SDS die Förderungsfähigkeit abzusprechen. Ankündigung der \"Spaziergangsdemonstration\", kritisch zu einem Flugblatt dazu.","Die \"Rote Garde\" von Berlin","","Radikale Studenten stören Universitätsleben","",[1],7,[1],[5],2,"44","37"],["4917","1966-12-19","\"Spaziergangsdemonstration\" des SDS auf dem Berliner Kurfürstendamm gegen den Vietnamkrieg, insgesamt 86 Demonstranten wurden vorläufig festgenommen, es sei zu Schlägereien zwischen Jugendlichen und der Polizei gekommen. Studentenvertreter erklärten, die Unruhen seien von einzelnen Radaubrüdern, der FDJ und SED-Anhängern provoziert worden.","Berliner Polizei nahm 86 Demonstranten fest","","","",[1],7,[1],[3],2,"16","2"],["4918","1966-12-19","Der Hamburger Rektor Schäfer weist die Darstellung der AStA-Vertreter Albers und Behlmer zurück, wonach die Frage der studententischen Mitbestimmung vom Akademischen Senat bei der letzten Sitzung nicht behandelt werden sollte. Ein entsprechender Antrag sei zu spät eingereicht worden, nun werde dieser Punkt bei der nächsten Sitzung behandelt (siehe HA vom 17.12.1966)","Rektor weist Vorwurf des AStA zurück","","","",[1],7,[1],[2],2,"16","5"],["4919","1966-12-20","Berlins Regierender Bürgermeister Albertz und der Berliner Senat kündigen Gespräche mit dem Rektor umd dem AStA der FU wegen der jüngsten Ausschreitungen an. Man werde dies nicht hinnehmen, die Ausschreitungen seien Ausdruck \"bewußt undemokratischer Haltung\", die Studentenschaft wird aufgefordert, sich von den Demonstranten zu distanzieren und diese \"auszuschalten\".","Krawalle in Berlin werden nicht hingenommen","","","",[1],7,[1],[2],2,"18","2"],["4920","1966-12-21","Hamburgs Bürgermeister Weichmann erklärte, dass man nicht vorhabe, die Universität über den gegenwärtigen Rahmen von 18.000 bis 20.000 Studenten auszubauen. Falls ein Zuwachs von Studenten zu verzeichnen sei, müsse man diesem mit einem Numerus Clausus bzw. verschärften Leistungsprüfungen begegnen.","Universität wird nicht vergrößert","","","",[4],7,[1],[2],2,"22","3"],["4921","1966-12-21","Der Hamburger AStA-Vorsitzende Albers widerspricht einer Darstellung des Rektors über die letzte Sitzung des Akademischen Senats. Mittels einer Dokumentation belegte er, dass die Frage der studentischen Mitbestimmung seit 1959 bereits dreimal positiv vom Akademischen Senat behandelt, von den Fakultäten aber immer abgelehnt worden war. Ziel sei eine ständige Beteilung von zwei Studenten mit Sitz und Stimme. (siehe HA vom 17. und 19.12.1966)","AStA gegen Erklärung des Rektors","","","",[1],7,[1],[2],2,"22","5"],["4922","1967-01-10","Eröffnung einer weiteren Mensa an der Universität Hamburg","Neue Mensa: Jeden Tag 3600 Portionen","","","",[4],7,[1],[5],1,"16","3"],["4923","1967-01-13","Das Studentenparlament der Hamburger Universität erklärte sich mit seinen AStA-Vorsitzenden wegen deren Verlassen der Sitzung des Akademischen Senats solidarisch (siehe HA vom 17.12.1966). Zudem begrüßte man eine Entscheidung der Mathematisch-Naturwissenschaftlichen Fakultät, welche als erste Fakultät zwei Vertreter der Studentenschaft mit Sitz und Stimme an einer Fakultätssitzung teilnehmen ließ.","Parlament mit AStA solidarisch","","","",[1],7,[1],[2],2,"22","5"],["4924","1967-01-14","Neubau der Univerisität Bremen, CDU und FDP befürchten eine Politisierung der Universität","Bremer Universität soll 1971 ihre Arbeit aufnehmen","","Voraussetzung: Einigung über die Kosten von 700 Millionen DM","er.",[4],7,[1],[1],1,"52","8"],["4925","1967-01-21","Laut einer Verlautbarung des Akademischen Senats sei die studentische Mitwirkung bei studentischen Angelegenheiten künftig in allen Fakultäten gesichert.","Die Studenten können mitwirken","","","",[4],7,[1],[2],2,"54","4"],["4926","1967-01-23","Der AStA der Universität Hamburg kritisiert das Ergebnis der Beratungen über die studentische Mitbestimmung in den Fakultäten. Gefordert wird eine gleichberechtigte Mitbestimmung der Studentenvertreter, dies sei jedoch nur von der Mathematisch-Naturwissenschaftlichen und der Wirtschafts- und Sozialwissenschaftlichen Fakultät zugestanden worden.","AStA ist unzufrieden","","Mitspracherecht wird in allen Fakultäten gefordert","U. W.",[4],7,[1],[2],2,"16","3"],["4927","1967-01-26","Ankündigung der bevorstehenden Wahlen zum Hamburger Studentenparlament, es gäbe so viele Kandidaten wie noch nie, was auf das vieldiskutierte Mitspracherecht der Studenten in den Fakultäten zurückgeführt wird.","Großer Andrang zum Studentenparlament","","","",[4],7,[1],[2],2,"18","6"],["4928","1967-01-27","Die Berliner politische Polizei hat die Büroräume des SDS durchsucht und Schreibmaschinen wie Schriftproben und die Mitgliederkartei des SDS beschlagnahmt. Hintergrund war eine Beleidigungsanzeige von vier früheren FU-Rektoren auf Grund eines Flugblattes, in dem von professoralen Fachidioten die Rede war. Der SDS protestiert gegen die Beschlagnahmung seiner Mitgliederkartei.","Polizei durchsucht SDS-Büro","","","wy",[1],7,[1],[5],2,"20","1"],["4929","1967-01-30","Berlins Regierender Bürgermeister Albertz wird bei der Erföffnung des John-F.-Kennedy-Instituts der FU Berlin mit Buhrufen und Pfiffen empfangen. Im Gespräch mit Studentenvertretern bedauert er die Beschlagnahmung der Mitgliederkartei des SDS durch die Polizei. Eine weitere Demonstration fand unter der Beteiligung der Schriftsteller Grass und Enzensberger am Kurfürsstendamm statt.","Wieder Demonstrationen in West-Berlin","","","wy",[1],7,[1],[3],2,"16","2"],["4930","1967-02-10","Die Notwendigkeit einer Hochschulreform wird konstatiert. Bericht über die Vorschläge des Wissenschaftsrates, Stellungnahmen aller Dekane der Hamburger Universität dazu.","Hamburgs Dekane nehmen Stellung zur geplanten Studienreform","","Reaktion auf Empfehlungen des Wissenschaftsrates/ Meinungen sind geteilt","Ursula Weiner",[4],7,[1],[1],1,"24","4"],["4931","1967-02-16","Protestdemonstration in Hamburg gegen die amerikanische Vietnampolitik, es werden 2000 bis 3000 Teilnehmer erwartet. Organisiert wird die Veranstaltung u. a. vom SDS, es spricht u. a. Fritz J. Raddatz.","Protest gegen die Vietnam-Politik","","","",[1],7,[1],[2],2,"18","6"],["4932","1967-02-18","Bericht über die Hamburger Vietnamdemonstration, an der etwa 2000 Menschen teilnahmen. Zum Abschluss sei es zu Auseinandersetzungen mit der Polizei gekommen, es gab einige Verletzte und Festnahmen. Zuvor ist die Rede von ungewöhnlichen Sprechchören wie die Anpreisung Maos oder Ho-Tschi-Minhs. Unterschiedliche Kritik an den USA wird erwähnt.","Vietnam-Demonstration endete mit Krawallen","","","schü.",[1],7,[1],[3],1,"58","5"],["4933","1967-02-20","Rücktritt des Gründungsausschusses der Bremer Universität wegen grundlegender Meinungsverschiedenheiten mit dem Bremer Senat. CDU und FDP fordern den Bildungssenator deshalb zum Rücktritt auf.","Streit um Bremer Universität","","","",[4],7,[1],[2],2,"16","1"],["4934","1967-02-20","Ausführlich über den Rücktritt des Gründungsausschusses der Bremer Universität wegen grundlegener Meinungsverschiedenheiten mit dem Bremer Senat und der SPD. CDU und FDP fordern den Rücktritt des Bremer Bildungssenators. Die norddeutschen Studentenschaften bedauern den Rücktritt und fordern die Einhaltung der Öffnung der Universität bis 1971.","Gründungsausschuss für Bremer Universität zurückgetreten","Norddeutschland","CDU und FDP legen Bildungssenator Thape Rücktritt nahe","er.",[4],7,[1],[1],1,"16","5"],["4935","1967-02-21","Gegen fünf Teilnehmer der Hamburger Vietnam-Demonstration ermittelt die Staatsanwaltschaft. Der nigerianische Student Obi L. wurde wegen seiner Teilnahme nach Nigeria abgeschoben. Er soll u.a. einem Demonstranten ein Messer gegeben haben, mit dem dieser einen Polizist verletzt habe, sowie Polizisten als SS-Schergen beschimpft haben. Sein Studium sei durch die Bundesrepublik finanziert worden.","Demonstrant per Flugzeug abgeschoben","","","",[1],7,[1],[2],2,"16","3"],["4936","1967-02-22","Die Studentenschaft der staatlichen Ingenierschule Flensburg hat in einem Brief an den schleswig-holsteinischen Kultusminister gegen den Dozentenmangel an ihrer Hochschule protestiert. Mehrere Veranstaltungen mussten deshalb ausfallen.","Studenten protestieren wegen Dozentenmangels","","","",[1],7,[1],[2],2,"28","14"],["4937","1967-02-24","Der geschäftsführende Landesvorsitzende der Berliner CDU, Karl-Heinz Schmitz, schlägt vor, dass die FU Berlin in eine Bundes-Universität umgewandelt werde. Dies würde die Verzahnung der deutschen Hauptstadt mit dem übrigen Bundesgebiet verstärken.","Universität des Bundes?","","","wy",[4],7,[1],[2],2,"28","2"],["4938","1967-02-24","Ausführlich zur Ausweisung des nigerianischen Studenten Obi Ifeobu wegen der Teilnahme an einer nicht genehmigten Demonstration. Der AStA bestreitet, dass Ifeobu die ihm zur Last gelegten Taten begangen hat. Entgegen früherer Meldungen hat Ifeobu sein Studium selbst finanziert. Auch generelle Kritik am Vorgehen der Polizei auf der Demonstration. Der nigerianische Generalkonsul kritisiert, dass er erst nach der Ausweisung informiert wurde.","AStA: Ermessensmissbrauch","","Protest gegen die Ausweisung des  Nigerianers Ifeobu","schü.",[1],7,[1],[5],2,"28","18"],["4939","1967-02-25","Der Hamburger Rektor Schäfer will versuchen, einen Gnadenerweis für den ausgewiesenen nigerianischen Studenten Obi Ifeobu zu erwirken. Zugleich forderte er die Studentenschaft auf, sich nicht zu Kurzschlußreaktionen hinreißen zu lassen. Der AStA-Vorsitzende Albers distanziert sich von der Vietnam-Demonstration, wegen der Ifeobu ausgewiesen wurde, verlangt aber eine gerichtliche Überprüfung der Ausweisung. Stellungnahme des Fachschaftsleiters Medizin der Uni Hamburg. Dieser sei falsch von einem Polizeisprecher wiedergegeben worden, er hätte Ifeobus Verhalten nie als empörend bezeichnet, nach aktuellem Stande beurteile man die Sache genauso wie das Studentenparlament und der AStA","Gnadenerweis für Ifeobu gefordert","","Professor Schäfer sprach auf einer Protestveranstaltung der Studenten","schü.",[1],7,[1],[5],2,"58","4"],["4940","1967-02-25","Neuwahl der AStA-Vorsitzenden der Universität Hamburg sowie der Parlaments-Präsidenten. Neue AStA-Vorsitzende sind Otto Herz und Helga Bauer.","Studenten wählten ihre neue \"Führungsspitze\"","","","",[4],7,[1],[2],1,"58","11"],["4941","1967-03-02","Der Bremer Senat will ein klärendes Gespräch mit dem zurückgetretenen Gründungsausschuß der Bremer Universität. Einer der Gründe sei die nicht berücksichtigte Forderung nach einer Pädagogischen Fakultät gewesen.","Klärendes Gespräch um Bremer Universität","","","er.",[4],7,[1],[2],2,"22","18"],["4942","1967-03-03","Prof. Wolf Herre wird Nachfolger von Prof. Erdmann als Rektor der Kieler Universität.","Rektorenwechsel in Kiel","","","",[4],7,[1],[2],2,"40","8"],["4943","1967-03-08","Die Hamburger CDU spricht sich gegen eine Einführung des Numerus Clausus. Mit einer Großen Anfrage will man klären, wie der Senat die Zukunft der Hamburger Universität gestalten will. Die Einrichtung einer Technischen Hochschule wird erwogen.","CDU gegen Numerus clausus","","","",[4],7,[1],[2],2,"28","3"],["4944","1967-03-08","Gegen zwölf Teilnehmer der Hamburger Vietnamdemonstration läuft ein Ermittlungsverfahren, u.a. wegen Aufruhr, Landfriedensbruch und Körperverletzung. Der AStA der Uni Hamburg hat einen Anwalt für den ausgewiesenen Studenten Obi Ifeobu organisiert. Mehrere Gastfamilien Ifeobus schilderten ihn als sympathischen Menschen.","Ermittlungen gegen 12 Demonstranten","","Nachspiel zum Zwischenfall am 17. Februar","schü/ -l",[1],7,[1],[2],2,"28","3"],["4945","1967-03-11","Obi Ifeobu hat beim Hamburger Polizeipräsidenten Einspruch gegen seine Ausweisung eingelegt. Er habe sich während der letzten sechs Jahre immer an die Gesetze der Bundesrepublik gehalten, sein Wunsch sei es, sein Studium in der Bundesrepublik zu beenden.","Ifeobu möchte weiter in Deutschland studieren","","","",[1],7,[1],[2],2,"60","3"],["4946","1967-03-13","Den ehemaligen Hamburger AStA-Vorsitzenden Detlev Albers und Gert-Hinnerk Behlmer wurden vom Zusammenschluss der Norddeutschen AStA-Vorsitzenden zu den studentischen Gründungsbeauftragten der Bremer Universität gewählt.","Hamburger Studenten im Gründungsausschuss","","","",[4],7,[1],[2],1,"18","3"],["4947","1967-03-18","Die Ausweisung des nigerianischen Studenten Ifeobu soll auf Antrag eines FDP-Abgeordneten vor der Hamburger Bürgerschaft behandelt werden. In Erwägung gezogen wird auch, ob der Fall auch vor dem Bundestag besprochen werden soll.","Kommt der Fall Ifeobu vor den Bundestag?","","","",[1],7,[1],[2],2,"54","4"],["4948","1967-03-21","Die Vorsitzenden des Hamburger AStA müssen neugewählt werden, da der gewählte Vorsitzende Otto Herz in den Vorstand des VDS gewählt wurde und somit sein Hamburger Amt niederlegen wird.","AStA muss neuen Vorstand wählen","","","",[4],7,[1],[2],2,"18","3"],["4949","1967-03-23","Sitzung der Hamburger Bürgerschaft, u.a. zur Hochschulsituation. Die Hamburger Universität soll für eine Fassung von 20.000 Studenten ausgebaut werden. Bürgermeister Drexelius kündigte eine Denkschrift über den weiteren Ausbau der Universität an. Diskussion über einen geplanten Numerus Clausus, ein genereller NC wird abgelehnt.","Was wird aus unserer Uni?","","Bürgerschaft diskutierte über Ausbau und Zulassungsstopp","wl/ga",[4],7,[1],[1],1,"28","6"],["4950","1967-03-28","Kurzbericht über die Ostermärsche 1967 unter dem Motto \"Für Sicherheit in Europa, für Abrüstung und Demokratie, gegen Notstandsgesetze, gegen den Krieg in Vietnam\". Etwa 100.000 Menschen haben teilgenommen, lediglich in Berlin sei es zu Zwischenfällen von Teilnehmern mit der Polizei gekommen.","Ostermärsche verliefen ruhig","","","",[1],7,[1],[2],2,"20","1"],["4951","1967-04-04","Der Studentenverband Deutscher Ingenierschulen (SVI) fordert eine Neuordnung des Ingenieurwesens. Die Ingenieurschulen sollten künftig dem Hochschulbereich zugeordnet werden.","Ingenieurschüler wollen als Studenten gelten","","","",[4],7,[1],[2],2,"18","3"],["4952","1967-04-06","Elf Studenten wurden im Vorfeld des Humphrey-Besuches festgenommen, sie hätten ein Bombenattentat auf den amerikanischen Vizepräsidenten geplant (das später sogenannte Puddingattentat der Kommune I, im Bericht noch keine Nennung der Kommune). Den Sprengstoff hätten die Täter aus Kreisen der chinesischen Botschaft der DDR erhalten. Der Anwalt der Verhafteten erklärte, seine Mandanten haben Humphrey nur erschrecken wollen. Der SDS distanzierte sich von jeglicher Verschwörung. Als vor dem SDS-Büro ein Polizeiwagen ausfindig gemacht wurde, hätten 50 bis 60 Personen versucht, diesen umzustoßen. Mit weiteren Demonstrationen im Zuge des Humphrey-Besuches wird gerechnet.","Humphrey-Besuch in Berlin unter starkem Polizeischutz","","Außenseiter wollen stören. Elf Personen verhaftet","wy",[5],7,[1],[1],1,"20","1"],["4953","1967-04-10","Berlins Regierender Bürgermeister hat disziplinarrechtliche Folgen für die elf Studenten, denen ein geplantes Sprengstoffattentat auf Humphrey zur Last gelegt wird, angekündigt. Die Staatsanwaltschaft habe Ermittlungsverfahren wegen Verdachts von Sprengstoffverbrechen eingeleitet. (Auch hier noch keine Nennung der Kommune I, dafür Festhalten am vermeintlichen Sprengstoffattentat)","Disziplinarfolgen für Krawall-Studenten","","","wy",[5],7,[1],[2],2,"18","2"],["4954","1967-04-11","Die Berliner Landesorganisationen der SPD und FDP fordern den Akademischen Senat der FU Berlin auf, Disziplinarverfahren gegen die elf wegen eines vermeintlichen Sprengstoffattentates festgenommenen Studenten einzuleiten, da sie ihrer Alma Mater und Berlin schweren Schaden zugefügt hätten. (weiter keine Nennung der Kommune I)","Universität soll Studenten bestrafen","","","wy",[5],7,[1],[2],2,"20","2"],["4955","1967-04-19","Spatenstich für die neue Pädagogische Hochschule in Kiel.","Kiel bekommt neue Pädagogische Hochschule","","","",[4],7,[1],[2],2,"28","7"],["4956","1967-04-21","Der Rektor der FU Berlin Lieber will ein Dsiziplinarverfahren gegen den AStA-Vorsitzenden Häußermann einleiten. Hintergund ist ein sit-in in der FU Berlin, an dem etwa 1000 Studenten teilgenommen hatten. 70 Polizisten lösten das sit-in auf, die Studenten leisteten passiven Widerstand.","Sitzstreik in der FU","","","",[1],7,[1],[3],2,"30","1"],["4957","1967-04-21","Professoren der Universität Göttingen haben ihrer Universität 28.800 DM gespendet. Sie folgten damit einem Aufruf, einen Teil ihrer vierprozentigen Gehaltserhöhung ein Vierteljahr lang an einen Spendenfonds zu überweisen.","Professoren zahlen für Uni","Bunte Welt","","",[4],7,[1],[2],2,"30","2"],["4958","1967-04-21","Bericht über die Universitäts-Neubauten in Regensburg, Ulm und Konstanz.","Die Professoren siegten","","In Regensburg und Konstanz entstehen neue Universitäten","Mathilde Köhler",[4],7,[1],[1],1,"30","17"],["4959","1967-04-25","Mehrere tausend Studenten der Universität Frankfurt haben gegen eine Erhöhung der Preise des Mensa-Essens gestreikt.","Mensa-Boykott","Bunte Welt","","",[1],7,[1],[2],2,"20","2"],["4960","1967-04-27","Fortsetzung des Berichts über die Universitäts-Neubauten in Regensburg, Ulm und Konstanz","Die Professoren siegten","","Schön, alt und doch modern: Die neuen Universitäten","Mathilde Köhler",[4],7,[1],[5],1,"24","9"],["4961","1967-04-28","Fortsetzung des Berichts über die Universitäts-Neubauten in Regensburg, Ulm und Konstanz","Die Professoren siegten","","Deutschlands neue Universitäten/ Was sagen die Bürger?","Mathilde Köhler",[4],7,[1],[5],1,"32","17"],["4962","1967-05-05","Der AStA der Universität Bonn ist zurückgetreten, da der Bonner Rektor eine Veranstaltung über den Militärputsch in Griechenland untersagt hatte. Auch der Akademische Senat hatte eine Veranstaltung unmöglich gemacht. Der Studentenausschuß sehe daher keine Möglichkeit mehr, seine Aufgaben zur politischen Bildung wahrzunehmen.","Bonner AStA aus Protest zurückgetreten","","","",[1],7,[1],[2],2,"28","2"],["4963","1967-05-11","Die Vollversammlung der Universität Hamburg hat Prof. Ehrlicher zu ihrem neuen Rektor gewählt. Beruflicher Werdegang von Prof. Ehrlicher.","Uni wählte neuen Rektor","","","jh",[4],7,[1],[2],1,"28","3"],["4964","1967-05-12","Der AStA der Universität Hamburg ist weiter ohne Führungsspitze. Nach dem Kandidaten Herz trat nun auch der Kandidat Achim Tippe im Verbund mit Helga Bauer zurück. Beiden werden vielversprechende Programme attestiert. Helga Bauer wurde gebeten, sich einen neuen Partner für den AStA-Vorsitz zu suchen.","AStA noch immer ohne Führung","","Kandidaten überraschend zurückgetreten","U.W.",[4],7,[1],[1],1,"30","10"],["4965","1967-05-19","Bundeswissenschaftsminister Stoltenberg erklärt den Bau einer neuen Universität im nordwestdeutschen Raum für absolut notwendig, der Bund sei deshalb auch zu konstruktiven Gesprächen über die Finanzierung bereit.","Zu Gesprächen über Universität Bremen bereit","","","jk",[4],7,[1],[2],2,"26","11"],["4966","1967-05-23","Bericht über die Immatrikulationsfeier an der Universität Hamburg.","Feierstunde für 3250 Studenten","","","",[4],7,[1],[2],2,"24","3"],["4967","1967-05-25","Eine vom SDS geplante Demonstration gegen den Beusch des Schahs am 3.6.1967 in Hamburg wurde von der Polizei untersagt, um die Sicherheit des Herrscherpaares nicht zu gefährden. In München soll dagegen eine Demonstration stattfinden, jedoch entweder vor dem Besuch oder in einem entlegeneren Stadtteil.","Polizei verbietet Demonstration gegen den Schah","","","",[1],7,[1],[2],2,"20","1"],["4968","1967-05-26","Der AStA der Universität Hamburg will seine Satzung dahingehend ändern, dass künftig auch Studenten zu Vorstandsmitgliedern gewählt werden können, die im Studentenparlament keinen Sitz haben. Damit will man der personellen Not begegnen, da der AStA seit geraumer Zeit nur kommissarisch von Helga Bauer geleitet wurde und kein weiteres Mitglied des Studentenparlaments eine Mehrheit von diesem erhielt.","AStA will jetzt Satzung ändern","","","",[4],7,[1],[2],2,"26","4"],["4969","1967-05-29","Der Hamburger SDS rechnet trotz des Verbots seiner geplanten Demonstration gegen den Schah mit \"Mißfallenskundgebungen\", diese zu erwartenden Demonstrationen seien aber nicht vom SDS gesteuert. Ein \"Schah-Happening\" im Universitätsviertel wurde für den 2.6.1968 genehmigt, Rudi Dutschke soll dabei eine Rede halten. Bahman Nirumand hält in der Hamburger Universität einen Vortrag über \"Die permanente Konterrevolution - Persien und der Westen\".","\"Schah-Happening\" von der Polizei genehmigt","","Veranstaltungen am Vorabend des Schah-Besuches","l.",[1],7,[1],[2],2,"16","5"],["4970","1967-05-31","Bahman Nirumand hat in einem Vortrag in der Hamburger Universität die persischen Studenten der Universität zu Protesten gegen den Besuch des Schahs aufgerufen. Ein Schweigemarsch zum iranischen Generalkonsulat ist geplant, zudem hat man bereits einen Brief an Bundeskanzler Kiesinger geschickt, in dem sie diesen die Gründe für ihre Ablehnung des Schahs darlegen.","Proteste gegen Schah-Besuch","","","",[1],7,[1],[2],2,"26","3"],["4971","1967-06-02","Bundesweite Kritik an den Sicherheitsmaßnahmen und dem Polieziaufgebot im Zuge des Staatsbesuches des persischen Schahs. Persische Studenten beschweren sich bzw. klagen gegen Entscheidungen, sich während des Besuches nicht politisch betätigen bzw. nicht die Stadt verlassen zu dürfen.","Kritik an der Polizei","","Sicherheitsmaßnahmen für den Schahbesuch übertrieben","",[1],7,[1],[1],2,"28","2"],["4972","1967-06-02","Erstmalig in der Geschichte der FU Berlin hat der Senat von seiner Staatsaufsicht über die Hochschulen Gebrauch gemacht. Wissenschaftssenator Stein verbot eine Protestaktion auf dem Gelände der FU, weil auf Grund der jüngsten Erfahrungen mit erneuten Beeinträchtigungen des Lehrbetriebs gerechnet werden müsse.","Protestaktion verboten","","","",[1],7,[1],[2],2,"28","2"],["4973","1967-06-02","Zu den neuen AStA-Vorsitzenden der Universität Hamburg wurden Helga Bauer und Felix Willmeroth gewählt. Als ihre wichtigste Aufgabe bezeichneten sie die Mitarbeit am neuen Hochschulgesetz.","Der AStA hat wieder einen Vorstand","","","",[4],7,[1],[2],1,"28","9"],["4974","1967-06-03","Bericht über die Demonstration am 2. Juni 1967 vor der Deutschen Oper gegen den Besuch des Schahs, es sei zu regelrechten Straßenschlachten gekommen, etliche Polizisten und Demonstranten seien verletzt worden. Benno Ohnesorg sei durch einen Schädelbruch gestorben. Die Bundesregierung erwähe auf Grund der Demonstrationen eine Entschuldigung beim Schah.","Proteste gegen Schah forderten Todesopfer","","","wy",[1],7,[1],[5],2,"54","1"],["4975","1967-06-03","Das Berliner Verwaltungsgericht hat das Verbot einer Protest-Veranstaltung auf dem Gelände der FU Berlin durch den Senat für rechtsunwirksam erklärt. Die Protestaktion richtet sich gegen die kürzliche Entscheidung des Akademischen Senats, dem SDS die Förderungswürdigkeit abzusprechen","Berliner Studenten dürfen protestieren","","","wy",[1],7,[1],[3],2,"54","2"],["4976","1967-06-05","Hamburgs Bürgermeister Weichmann kritisiert die Demonstrationen gegen den Besuch des Schahs scharf, dies sei eine Verletzung des Gesetzes der Gastfreundschaft gewesen. Die Zwischenfälle seien nur Ausdruck einer kleinen Minderheit gewesen, deren Intoleranz dürfe man nicht dulden. In Berlin wurden nach dem Tod Ohnesorgs bis auf weiteres alle Demonstrationen untersagt. Berlins Regierender Bürgermeister Heinrich Albertz sprach davon, dass man sich nicht länger von einer terroristischen Minderheit terrorisieren lassen wolle. Eine Sonderkommission zu den Umständen des Todes von Ohnesorg wurde einegsetzt. Während die Polizei behauptet, der Schuß auf Ohnesorg sei in Notwehr abgegeben worden, widerspricht Horst Mahler als Anwalt der Angehörigen dem.","\"Schwarzer Tag für Hamburg\"","","","wl/wy",[1],7,[1],[2],1,"16","2"],["4977","1967-06-05","Scharfe Kritik an den Demonstrationen gegen den Schahbesuch, das Gastrecht sei unter schamlosen Mißbrauch der demokratischen Grundrechte mißhandelt worden. Die verantwortlichen studentischen Demonstranten werden als wirrköpfig und im Bund mit rüpelhaften dümmlichen Halbstarken beschrieben. Die Jugend habe zwar ein Recht zu protestieren, dürfe aber nicht selbstgerecht über die demokratischen Tugenden ferner, fremder Völker wachen, vor allem nicht vor dem Hintergrund der deutschen Vergangenheit. Echtes demokratisches Engagement sei von diesen \"wirrköpfigen\" Demonstranten nicht zu erwarten. Scharfe Kritik auch an den hohen Sicherheitsmaßnahmen, wäre quasi eine polizeiliche Bürgerkriegs-Übung gewesen, das \"Überaufgebot an Schlagstöcken\" hätte die Unruhen auch provoziert. Alles zusammen sei ein nationaler Skandal, eine deutsche Blamage.","Das misshandelte Gastrecht","","","M. S.",[1],7,[5],[2],2,"16","2"],["4978","1967-06-05","Dokumentation des Schah-Besuches in Hamburg, immer wieder Demonstrationen oder Mißfallenskundgebungen gegen den Schah.","Die dreißig Stunden des Schah-Besuchs","","","",[1],7,[1],[1],1,"16","4"],["4979","1967-06-05","Hamburgs Bürgermeister Weichmann kritisiert die Demonstrationen gegen den Besuch des Schahs scharf, dies sei eine Verletzung des Gesetzes der Gastfreundschaft gewesen, für ihn sei es ein schwarzer Tag in seiner Zeit als Bürgermeister. Die Zwischenfälle seien auch innerhalb der Studentenschaft nur Ausdruck einer kleinen Minderheit gewesen. Dem Ansehen der Stadt sei jedoch geschadet worden, die Demonstration ein Schlag ins Gesicht der eigenen nationalen Würde. Er kündigte genaue Prüfungen der Demonstranten an, die Universität werde nicht aus Steuermitteln finanziert, um dem \"Rabaukentum eine Stätte der Betätigung\" zu geben. Man habe in Zukunft nicht vor, das Gesetz der Toleranz mißbrauchen zu lassen.","Weichmann: Freiheit hat ihre Grenzen!","","","",[1],7,[1],[5],2,"16","4"],["4980","1967-06-06","Trauermärsche und Kundgebungen in mehreren deutschen Städten für Benno Ohnesorg. Die Staatsanwaltschaft ermittelt, Regierungssprecher Ahlers erklärt, dass der Tod Ohnesorgs durch die \"unverantwortlichen Handlungen einer kleinen radikalen Gruppe\" eingetreten ist. An den Berliner Hochschulen wurden die Vorlesungen abgebrochen. Neben scharfer Kritik an der Polizei wurde Rücktrittsforderungen gegenüber Albertz und Duensing gefordert. Die Humanistische Union hat Strafanzeige gegen Kurras gestellt (dieser wird nicht namentlich genannt), die Berliner FDP fordert einen parlamentarischen Untersuchungsausschuß. Ohnesorg ist laut gerichtsmedizinischer Untersuchung an einem Steckschuss gestorben, ein Querschläger wird ausgeschlossen.","Schweigemärsche für den erschossenen Studenten","","Rückhaltlose Klärung des Zwischenfalls gefordert","",[1],7,[1],[5],2,"18","2"],["4981","1967-06-06","Trauermarsch für Benno Ohnesorg von der Universität Kiel aus. U.a. wird der Rücktritt von Berlins Regierendem Bürgermeister Albertz gefordert. Der Dekan der Philosophischen Fakultät, Prof. Hinterhäuser, erklärt, dass die Studenten mit ihrer Trauer nicht alleine seien, Ohnesorg habe für die Sache der Gerechtigkeit und Freiheit demonstrieren wollen.","Protest in Kiel","","","",[1],7,[1],[2],2,"18","14"],["4982","1967-06-07","Das Hamburger Studentenparlament erhebt schwere Vorwürfe gegen den Polizeieinsatz bei der Demonstration gegen den Schah in Hamburg. Bürgermeister Weichmann wird für seine Stellungnahme nach der Abreise des Schahs schrf kritisiert, er solle sich bei der Studentenschaft entschuldigen. Rektor Schäfer verließ aus Protest die Sitzung des Studentenparlaments, weil ihm vorgeworfen wurde, nicht Stellung zu beziehen. Er sei zutiefst gekränkt. Das Studentenparlament erklärte, es sei jetzt nicht die Zeit für Trauermärsche für Ohnesorg, sondern für flammenden Protest, um die noch übriggelassene Freiheit in unserem Staat zu verteidigen. Ein Student habe auch erklärt, dass die Studenten eine Mitschuld an den Zwischenfällen in Hamburg tragen. Erklärungen des Akademischen Senats und des AStA, letzterer kritisiert die Professorenschaft, weil sie sich den Protesten nicht anschließt. Presserklärung dess AStA, in der in 25 Augenzeugenberichten auf Übergriffe der Polizei bei der Demonstration hingewiesen wird. Im Gegensatz zu den Studenten hätten die \"Jubel-Perser\" demonstrieren dürfen. Im Kommentar wird die Hoffnung geäußert, dass Studenten und Bürgermeister Weichmann bald gemeinsam diskutieren werden, insbesondere über die Frage der Meinungsfreiheit.","Studenten richten scharfe Angriffe gegen Bürgermeister und Rektor","","Weichmann sagte Vorlesung ab/ Prof. Dr. Schäfer verließ die Parlamentssitzung","ga/wl.",[1],7,[1],[1],1,"26","3"],["4983","1967-06-08","Studenten verteilen in Hamburg etwa 38.000 Flugblätter, in denen sie sich gegen Pauschalisierungen von  Studenten als \"Radaubrüder\" und \"Radikale\" wenden. Es kommt zu Diskussionen mit der Bevölkerung, die Polizei schreitet nicht ein. Zudem wird eine Dokumentation über die Übergriffe der Polizei bei der Demonstration in Hamburg angekündigt. Der Kommandeur der Hamburger Schutzpolizei, Leddin, gab zu, dass die \"Jubelperser\" bewußt auf günstige Plätze innerhalb der Bannmeile gelotst wurden und die Demonstrationen gegen den Schah dagegen aufgelöst wurden. Dies sei bei Staatsbesuchen ein normaler Vorgang, den er so auch wiederholen würde.","Diskussion auf der Straße","","","ga/wl.",[1],7,[1],[5],1,"20","3"],["4984","1967-06-08","Trauerfeier in der TU Berlin für Benno Ohnesorg, Bischof Scharf erklärt, dass beide Seiten Schuld tragen. Ankündigung des Trauerkonvois nach Hannover und der geplanten Veranstaltung in Hannover. Willy Brandt hat die Vorsitzenden aller deutschen AStAs und den Vorsitzenden des VDS zu einer Aussprache mit dem SPD-Präsidium eingeladen.","Bischof Scharf: Schuldig sind alle gemeinsam","","Trauerfeier für den erschossenen Studenten","",[1],7,[1],[1],2,"20","9"],["4985","1967-06-08","Foto zum Datensatz 4984, Bischof Scharf auf der Trauerfeier für Ohnesorg in der TU Berlin","Trauerfeier für Benno Ohnesorg","","","",[1],7,[1],[2],1,"20","9"],["4986","1967-06-09","Der AStA der Universität Hamburg kritisiert Innensenator Ruhnau für seine Äußerung, dass ihm von Übergriffen der Polizei nichts bekannt sei. Der Studentenausschuß der Ingenieur-Schule kritisiert dagegen die Studenten, viele würden den Unterschied zwischen Randalierern und Demonstranten nicht kennen. Das Präsidium des Studentenparlaments hat sich bei Rektor Schäfer für die Formulierungen ihm gegenüber entschuldigt. SDS und SHB kündigen eine Veranstaltung zum Tod von Ohnesorg in Hamburg an, Horst Mahler und Peter Rühmkorf werden als Redner erwartet. Weitere studentische Stellungnahmen.","Streit zwischen Rektor und Studenten beigelegt","","Aber die Diskussion um Schah-Besuch geht weiter","ga ",[1],7,[1],[2],2,"24","5"],["4987","1967-06-09","Ankündigung der Trauerkundgebung für Benno Ohnesorg in Hannover, 10.000 Studenten werden erwartet. In Berlin wurde Polizeipräsident Duensing auf eigenen Wunsch beurlaubt, Innensenator Büsch soll wegen der Vorfälle am 2. Juni 1967 bereits seinen Rücktritt angeboten haben.","10000 Studenten demonstrieren","","","",[1],7,[1],[2],1,"24","11"],["4988","1967-06-10","Trauermarsch und Beisetzung von Benno Ohnesorg. An der Trauerkundgebung in Hannover nahmen etwa 6000 Studenten teil, Ohnesorg wurde als vorbildlicher und besonnener Student gewürdigt. Gegen Karl-Heinz Kurras wird wegen illegalen Waffenbesitzes ermittelt. Eine Mieterin hat bei der Polizei eine Kiste aus Kurras' Besitz mit einer Pistole und 1460 Schuß Munition abgegeben.","Benno Ohnesorg beigesetzt","","6000 Studenten zogen schweigend durch Hannover","",[1],7,[1],[3],2,"52","2"],["4989","1967-06-10","Verständnis für Studentenproteste. Beklagenswerte Vorfälle bei den Demonstrationen gegen den Schah werden konstatiert, allzu pauschale Urteile über die Studenten kritisiert. Die Studenten haben ein Recht darauf, respektiert zu werden, die ältere Generation setzt keine Leitbilder für die Studenten, deshalb sei es verständlich, dass der Protest der Studenten in totalen Protest umschlägt. Allerdings müssten die Studenten auch zur Selbstbesinnung kommen, man solle sich nicht anmaßen, für die ganze Welt zu demonstrieren, dass erinnere an den Slogan \"Am deutschen Wesen soll die Welt genesen\", mehr Maß und Takt sei gefordert.","Die Studenten, der Schah und unser Staat","","Ein Wort an die Engagierten","M. S.",[1],7,[5],[5],2,"52","3"],["4990","1967-06-10","Der DGB-Hamburg hat Studenten, Polizei und Gewerkschaftler zu einer Diskussion eingeladen, um zu einer Klärung des Verhältnisses der Studenten zu gelangen.","Polizei und Studenten diskutieren","","Im Gewerkschaftshaus","",[1],7,[1],[2],1,"52","3"],["4991","1967-06-12","Den vom AStA der Uni Hamburg angeprangerten polizeilichen Übergriffen auf Demonstranten soll sämtlich nachgegangen werden. 23 Zeugenaussagen existieren hierzu.","Vorwürfe der Studenten werden genau geprüft","","Ruhnau: \"Allergrößtes Interesse\"/ 23 Zeugenaussagen","",[1],7,[1],[2],2,"16","5"],["4992","1967-06-13","Streitfrage, ob die Polizei oder die Staatsanwaltschaft die Ermittlungen im Fall der polizeilichen Übergriffe während der Demonstration gegen den Schah in Hamburg führen soll. Insbesondere die CDU hält es für unmöglich, dass die Polizei gegen sich selber ermitteln kann.","Wer ermittelt gegen Polizisten?","","","",[1],7,[1],[2],2,"18","3"],["4993","1967-06-14","Die Hamburger Staatsanwaltschaft hat ein Ermittlungsverfahren gegen den Kommandeur der Schutzpolizei, Martin Leddin, eingeleitet. Er soll Demonstranten während der Demonstration gegen den Schah geschlagen haben. Weitere Vorwürfe gegen Polizisten sollen geprüft werden. Die FDP fordert, Polizeibeamte durch Nummern zu kennzeichnen.","Staatsanwalt ermittelt gegen den Kommandeur der Polizei","","","wl./thi",[1],7,[1],[2],1,"26","1"],["4994","1967-06-14","Aussprache zwischen dem Hamburger AStA und der Polizeiführung unter Vermittlung des DGBs. Gemeinsam will man Spielregeln für Form und Inhalt künftiger Studentendemonstrationen entwickeln. DGB-Chef Höhne erklärt, dass Ruhe der Demokratie schade. Der ehemalige AStA-Vorsitzende Behlmer kritisierte scharf den Polizeieinsatz. Martin Leddin, Kommandeur der Schutzpolizei, verteidigt den Einsatz, dieser war notwendig. Weitere Stellungnahmen von Studenten und Polizisten.","Studentenschaft und Polizei wollen zu vernünftigen Spielregeln kommen","","Erste Aussprache am DGB-Tisch/ Höhne: Ruhe schadet der Demokratie","l.",[1],7,[1],[1],1,"26","5"],["4995","1967-06-14","In Berlin haben etwa 5000 Studenten gegen den Polizeieinsatz bei der Demonstration gegen Schah-Besuch am 2. Juni 1967 demonstriert. Die Demonstration sei sehr diszipliniert verlaufen, eine Auflage, nach der auf 50 Studenten ein Ordner kommen müsse, begegnete man mit dem \"Studentenulk\", dass nur etwa 150 Teilnehmer als Demonstranten und der Rest als Ordner gekennzeichnet waren. ","Studentendemonstration verlief diszipliniert","","","",[1],7,[1],[2],2,"26","15"],["4996","1967-06-15","Über 100 Studentenvertreter diskutierten mit dem Präsidium der SPD über die jüngsten Unruhen und die Vorfälle bei den Demonstrationen gegen den Schah-Besuch. Willy Brandt sprach von einer Vertrauenskrise zwischen der Studentenschaft auf der einen und der politischen Führung und der Bevölkerung auf der anderen Seite. Der VDS-Sprecher Haubold erklärte, dass die SPD sich von den Aussagen des Berliner Regierenden Bürgermeisters Albertz disanzieren müsse. Brandt erklärt, dass sich die Partei zu keiner Zeit mit dessen Äußerungen identifiziert hätte. Der VDS-Sprecher erklärte, dass man zwar zu keinem Ergebnis gekommen sei, man aber Genutuung empfinde, die Ansichten der Studenten dargelegt haben zu können.","Brandt diskutiert in Bonn mit den Studenten","","SPD soll sich von Bürgermeister Albertz distanzieren","wst",[1],7,[1],[5],1,"24","2"],["4997","1967-06-15","Landespressekonferenz zu den Vorfällen bei der Demonstration gegen den Besuch des Schahs in Hamburg. Von studentischer Seite nahmen der ehemalige AStA-Vorsitzende Behlmer und die amtierende Vorsitzende Bauer teil. Behlmer erklärte, dass man in der Studentenschaft die Einsicht verbreiten wolle, dass auf Demonstrationen nur akustische Mittel, nicht aber Wurfgeschosse eingesetzt werden dürften. Mit Nachdruck wandte man sich gegen Pauschalisierungen wie \"Rabauken\". Sowohl Studentenvertreter als auch Politiker waren sich einig, dass der Sicherheitsaufwand beim Schah-Besuch zu groß war. Die Hamburger Bürgerschaft bedauerte in einer Erklärung, dass es zu Zusammenstößen zwischen der Polizei und der Studentenschaft gekommen ist. Aufgabe der Polizei sei es nur, das Demonstrationsrecht zu gewährleisten, nicht über den Inhalt zu urteilen. Die Studenten sollten sich aber von einigen \"Wirrköpfen\" innerhalb der Studentenschaft distanzieren. Eine schnelle Untersuchung der Vorfälle wird gefordert.","\"Auf beiden Seiten gilt es, Vorurteile zu beseitigen\"","","Vorfälle beim Schah-Besuch vor der Landes-Pressekonferenz","l.",[1],7,[1],[1],1,"24","5"],["4998","1967-06-16","Vier persischen Studenten droht die Ausweisung, weil sie als \"Rädelsführer\" der Demonstrationen gegen den Besuch des Schahs in Hamburg angesehen werden. Der AStA der Uni Hamburg hat seine Hilfe zugesichert.","Persischen Studenten droht Ausweisung","","","ga.",[1],7,[1],[2],2,"52","1"],["4999","1967-06-16","Vier persischen Studenten droht die Ausweisung, weil sie als \"Rädelsführer\" der Demonstrationen gegen den Besuch des Schahs in Hamburg angesehen werden. In Persien befürchten sie die Einkerkerung. Der AStA der Uni Hamburg hat seine Hilfe zugesichert. Das Studentenparlament hat zudem 500 arabischen Studenten ihre Hilfe zugesichert, die auf Grund der Nahost-Krise kein Geld mehr aus ihrer Heimat empfangen. Die Erklärung der Hamburger Bürgerschaft wird vom Studentenparlament teils kritisiert, die Schuld an den Auseinandersetzungen werde einseitig den Studenten zugesprochen, eine Ehrenerklärung für die Studentenschaft werde hinfällig, wenn zugleich von einer wirrköpfigen Minderheit die Rede sei und die Übergriffe der Polizei nicht mit einem Wort erwähnt werden.","Persische Studenten haben Angst vor der Ausweisung","","Als Rädelsführer beschuldigt/ AStA will ihnen helfen","ga.",[1],7,[1],[1],2,"52","3"],["5000","1967-06-16","Der Politologie-Doktorand Gerhard Maurer antwortet auf den Kommentar \"Die Studenten, der Schah und unser Staat\" vom 10.06.1967. Verteidigung der Demonstrationen gegen den Schah. Es war die Pflicht der Studenten, gegen den Schah zu demonstrieren, wenn er einen solchen Staatsempfang bekommt. Die Bevölkerung hätte Stolz auf die demonstrierenden Studenten sein müssen, der Schah-Besuch war ein deutsches Thema. Die Studenten befürchten, als Minderheit mundtot gemacht zu werden.","\"Der Besuch des Schahs war ein deutsches Thema\"","","Stellungnahme eines \"engagierten Studenten\" aus Berlin","Gerhard Maurer (Leser)",[1],7,[6],[1],1,"52","8"],["5001","1967-06-19","Der AStA der Universität Hamburg hat ein Spendenkonto für arabische Studenten und Praktikanten, die durch den Krieg in ihrer Heimat von dieser abgeschnitten sind, eingerichtet.","AStA will arabischen Kommilitonen helfen","","","",[4],7,[1],[2],2,"18","3"],["5002","1967-06-19","Die vier persischen Studenten, die wegen des Verdachts der Rädelsführerschaft bei den Demonstrationen gegen den Schah-Besuch in Hamburg ihre Ausweisung befürchtet hatten, brauchen laut der Senatspressestelle keine Angst vor einer Abschiebung haben, dies werde nicht geschehen.","Schutz vor Ausweisung","","","",[1],7,[1],[2],2,"18","3"],["5003","1967-06-19","Der Sportreferent des Hamburger AStA, Graffitti, bat in einem Offenen Brief den Präsidenten des Deutschen Sportbundes um Hilfe. Die Bedingungen für die sporttreibenden Hamburger Studenten seien sehr schlecht.","Sportstudenten bitten um Hilfe","","Offener Brief an DSB-Präsident Daume","ga",[4],7,[1],[2],2,"18","3"],["5004","1967-06-20","Etwa 200 Berliner Studenten wollen aus Protest gegen das Verhalten der Berliner Polizei während der Demonstration gegen Besuch des Schahs am 2. Juni 1967 in einen viertägigen Hungerstreik treten. Zudem will man so die Freilassung von Fritz Teufel erreichen. Die Kommune I wird als \"extrem radikale Studentengruppe\" vorgestellt.","Hungerstreik für Teufel","","","wy",[1],7,[1],[2],2,"16","6"],["5005","1967-06-21","Diskussion in der evangelischen Neu-Westend-Kirche in Berlin über die jüngsten Studentenunruhen. Ein geplanter Hungerstreik in der Kirche wurde untersagt, was Rudi Dutschke, als der \"rote Rudi\" bezeichnet, schwer kritisierte. Gemeindemitglieder waren empört über die Diskussion in der Kirche.","\"Roter Rudi\" auf der Kanzel","","Berliner Studenten diskutierten in einer Kirche/ Hungerstreik","wy",[1],7,[1],[5],2,"26","2"],["5006","1967-06-21","Studenten und Vertreter der \"Obrigkeit\" würden aneinander vorbeireden. In Bezug auf die Demonstrationen gegen den Schah-Besuch wird von \"unmöglicher brachialer Polizeigewalt\" geschrieben. Das politische Engagement der Studenten wird begrüßt, die Hinhaltetaktik der Politik für eine Aussprache kritisiert, man dürfe Studenten ihr politisches Engagement nicht absprechen. Kritisiert wird obrigkeitsstaatliches Denken und fehlendes staatsbewußtes Denken bei Professoren. Leitbilder der älteren Generation provozieren geradezu die Unruhe der Jugend, diese dürfe es sich aber auch nicht zu leicht machen bei der Verurteilung der älteren Generation. Die Demokratie-Ideologie der Studenten wird in einer Tradition mit der Herrenmensch-Attitüde und dem Büßertum gesehen, alles wird immer totalitär gedacht. Fordert mehr Selbstkritik.","Die Studentenkrise","","","M. S.",[1],7,[5],[5],2,"26","2"],["5007","1967-06-21","Brief der Hamburger AStA-Vorsitzenden Bauer an Rektor Schäfer. Die Professorenschaft wird kritisiert, weil sie der Stellungnahme der Hamburger Bürgerschaft, die Studenten hätten die Ausschreitungen bei den Demonstrationen provoziert, nicht widersprochen hat. Die Gesamtstudentenschaft werde diffamiert, indem man ihr Minderheiten als Wirrköpfe unterschiebt. Die Rede ist von einer tiefen Vertrauenskrise der Studentenschaft zu den Professoren. Der SDS sieht in der Erklärung der Bürgerschaft den Beweis, dass das liberale und demokratische Image Hamburgs nur eine Fiktion sei. Die Hamburger CDU hat den AStA zu einem Gespräch über die Vorfälle bei den Demonstrationen gegen den Schah-Besuch eingeladen.","\"Vertrauenskrise in der Studentenschaft\"","","AStA-Vorsitzende schrieb an Rektor Prof. Schäfer","l.",[1],7,[1],[2],2,"26","4"],["5008","1967-06-22","Das Bundeskabinett hat über die Studentenunruhen gesprochen. Bundeskanzler Kiesinger bezeichnete die Unruhen als ein Problem, das höchste Aufmerksamkeit verdiene. Kiesinger sprach auch mit mehreren Studenten der FU Berlin.","Kiesinger sprach mit Berliner Studenten","","","",[1],7,[1],[2],2,"18","1"],["5009","1967-06-22","Mehr als 100 Studenten demonstrieren mittels eines Hungerstreiks im Haus der Evangelischen Studentengemeinde für die Freilassung von Fritz Teufel. Teufel habe im Untersuchungsgefängnis ebenfalls einen Hungerstreik begonnen. Bischof Scharfs Vermittlungsversuch, wonach Teufel unter der Auflage, dass er in ein evangelisches Studentenhaus einziehe, freigelassen werde, hat Teufel abgelehnt. Prof. Bettermann hat Berlins Wissenschaftssenator Stein schwer kritisiert, dieser hätte dem Anspruch der Studenten, zu allen politischen Vorgängen sich zu äußern, früher entschieden entgegentreten müssen.","Bischof Scharf wollte für Teufel vermitteln","","","wy",[1],7,[1],[1],1,"18","2"],["5010","1967-06-22","Die Hamburger Staatsanwaltschaft ermittelt gegen vier Polizisten wegen Übergriffen auf Demonstranten bei der Demonstration gegen den Schah am 3. Juni 1967. Unter den Polizisten ist auch der Kommandeur der Schutzpolizei Leddin. Auch über die Rechtmäßigkeit und Angemessenheit der Befehle wird ermittelt.","Verfahren gegen höhere Polizisten","","Staatsanwalt überprüfte Einsatzbefehle","l.",[1],7,[1],[1],2,"18","4"],["5011","1967-06-22","Mehrere Leserbriefe zum Kommentar \"Der Schah, die Studenten und unser Staat\" vom 10.06.1967. Unterschiedliche Reaktion, Zustimmung und Kritik wie auch Zustimmung und Kritik an den Studentenprotesten allgemein, überwiegend sachliche Leserbriefe.","\"Der Schah, die Studenten und unser Staat\"","","Die Meinung der Leser zu den Demonstrationen der Studenten in Hamburg","Leser",[1],7,[6],[1],2,"18","8"],["5012","1967-06-23","Bereits nach 45 Stunden haben die Studenten den Hungerstreik für die Freilassung von Fritz Teufel abgebrochen, angeblich, weil die Evangelische Studentengemeinde ihnen die Räume nicht mehr zur Verfügung stellte. Die Gemeinde widerspricht dem. Die Berliner SPD stecke durch die Unruhen in einer Krise, eine Senatsumbildung wird erwogen.","Schwere Krise der Berliner SPD","","","wy.",[1],7,[1],[2],2,"24","2"],["5013","1967-06-24","Der beurlaubte Berliner Polizeipräsident Duensing wird vom Parlamentarischen Untersuchungsausschuß zu den Vorkommnissen am 2. Juni 1967 befragt. Duensing erklärte, eine Weisung des Bundesinnenministeriums, wonach weitere Sicherheitsmaßnahmen der Polizei in Kraft zu setzen seien, nicht erhalten zu haben. Der Protokollschef des Senats widerspricht dem.","Polizeipräsident im Verhör","","","",[1],7,[1],[2],1,"54","2"],["5014","1967-06-24","Auf dem Rathausplatz in Hamburg findet eine Kundgebung gegen den Bildungsnotstand statt. Dazu aufgerufen haben Studenten, Lehrergewerkschaft und Schülerparlament. Hauptredner wird Prof. Carl Friedrich Freiherr von Weizsäcker sein.","Kundgebung zum Bildungsnotstand","","","",[9],7,[1],[2],2,"54","5"],["5015","1967-06-24","Diskussion zwischen Studenten und der Hamburger CDU. Tenor war, dass die Demonstrationsfreiheit der Studenten nicht angetastet werden darf. Die Form der Demonstrationen wurde von der CDU aber scharf kritisiert. Das Gespräch sei sachlich verlaufen, weitere Gespräche über künftige strittige Fragen sollen Folgen.","Studenten und CDU: Wir bleiben in Kontakt","","Ruhige Diskussionen","l.",[1],7,[1],[2],2,"54","5"],["5016","1967-06-24","Ein neuer Gründungsausschuß für die Bremer Universität hat sich konstituiert. Der Bremer Senat ist zu Konzessionen bei der Organisationsform der neuen Universität bereit.","Neue Initiative für die Bremer Universität","","","er.",[4],7,[1],[2],2,"54","8"],["5017","1967-06-27","Die erste Lesung der Notstandsgesetzgebung wird von den Bundestagsfraktionen vorbereitet. In 19 Städten haben studentische und gewerkschaftliche Gruppen zu Demonstrationen gegen die erste Lesung aufgerufen.","Fraktionen bereiten Notstandsgesetze vor","","Gewerkschaften und Studenten protestieren","",[9],7,[1],[5],2,"18","1"],["5018","1967-06-27","Der beurlaubte Berliner Polizeipräsident Duensing wurde erneut vom parlamentarischen Untersuchungsausschuß vernommen. Während einer ersten Vernehmung hatte Duensing erklärt, er wisse nicht, wer die Weisung für die bevorzugte Behandlung der \"Jubel-Perser\" gegeben habe. Nach der Aussage des Kommandeurs der Schutzpolizei hatte Duensing selbst die Weisung gegeben. Dieser erklärte nun, dies sei ihm entfallen.","Polizeipräsident muss sich berichtigen","","","wy",[1],7,[1],[2],2,"18","2"],["5019","1967-06-28","Etwa 1600 Menschen protestierten in Frankfurt gegen die Notstandsgesetzgebung. Dazu aufgerufen hatten 18 Jugendorganisationen unter der Führung des AStA der Uni Frankfurt sowie der Gewerkschaftsjugend.","Demonstration gegen Notstandsgesetze","","","",[1],7,[1],[2],2,"26","2"],["5020","1967-06-28","Karl-Heinz Kurras wird wegen fahrlässiger Tötung angeklagt. Zur Vorbereitung der Anklage waren 89 Zeugen verhört worden.","Kurras muss vor Gericht","","","",[1],7,[1],[2],2,"26","2"],["5021","1967-06-28","Die Vorfälle während der Demonstration gegen den Schah-Besuch in Hamburg werden erneut vor der Hamburger Bürgerschaft besprochen. Die CDU will klären, ob der Befehl zur Räumung des Rathausplatzes direkt von Senator Ruhnau kam. Zudem wird die sofortige Härte des Polizeieinsatzes kritisiert. Die FDP erwartet spätestens bis zum 30.9.1967 einen Zwischenbericht des Senats über die Vorfälle bei der Demonstration.","Warum Polizei-Aktion ohne Warnung?","","Schah-Demonstration nochmals vor der Bürgerschaft","ga.",[1],7,[1],[3],2,"26","3"],["5022","1967-06-29","Karl-Heinz Kurras ist wegen der Anklage auf fahrlässige Tötung vorübergehend vom Dienst suspendiert worden. Zu Widersprüchen kam es vor dem parlamentarischen Untersuchungsausschuß. Entgegen der Behauptung der Polizei, dass bis zum Räumbefehl bereits elf Polizisten verletzt worden waren, sprachen Augenzeugen nur von zwei verletzten Polizisten. Der stellv. AStA-Vorsitzende der FU, Wilhelmer, rief seine Kommilitonen zu neuen großen Aktionen auf.","Kurras dienstenthoben","","Widersprüche vor Berliner Untersuchungsausschuß","wy.",[1],7,[1],[2],2,"20","2"],["5023","1967-06-29","Auf der Moorweide in Hamburg findet eine Kundgebung gegen den Bildungsnotstand statt. Dazu aufgerufen haben Studenten, Lehrergewerkschaft und Schülerparlament. Hauptredner wird Prof. Carl Friedrich Freiherr von Weizsäcker sein.","Protest auf der Moorweide","","","",[9],7,[1],[2],2,"20","4"],["5024","1967-06-29","Ausführlicher Bericht über die Situation an der FU Berlin. Die \"radikale Minderheit\" der Linken verweigere sich längst der Mitarbeit an der Hochschulreform, für sie geht es um allgemeinpolitische Forderungen, so will man die Massen \"verführen\". Senator Steins Entwurf für ein neues Universitätsgesetz.","An der FU brodelt es","","\"Heißer\" Sommer erwartet","wy",[1],7,[1],[1],1,"20","13"],["5025","1967-06-30","Laut Prof. Bettermann verstößt eine politische Betätigung von Studenten oder Professoren in Ausübung eines universitären Amtes gegen die Verfassung der Bundesrepublik. Auch der AStA müsse dies wissen, sein Beharren auf ein allgemeinpolitisches Mandat sei daher rechtswidrig. An der FU Berlin laufen zwei Disziplinarverfahren, einmal gegen die Kommune I für die Störungen beim Humphrey-Besuch, und einmal gegen mehrere Studenten um die AStA-Vorsitzenden Häussermann und Wilhelmer wegen eines nicht genehmigten Sit-ins.","Hochschule darf nicht \"politisiert\" werden","","Rechtsgutachten zur Lage an der Universität Berlin","wy",[1],7,[1],[5],2,"28","1"],["5026","1967-06-30","Auch in Kiel werden Studentenunruhen erwartet. Streitpunkt ist ein Paragraph in der neuen Satzung der Universität, wonach Veranstaltungen studentischer Gruppen generell genehmigungspflichtig seien. Dies sei obrigkeitsstaatlich.","Auch in Kiel Studentenproteste","","Gegen Genehmigungspflicht von Veranstaltungen/ Parteien verschiedener Ansicht","fa",[1],7,[1],[2],2,"28","18"],["5027","1967-07-01","Etwa 2000 Studenten, Lehrer und Schüler nahmen an einer Kundgebung gegen den Bildungsnotstand auf der Hamburger Moorweide teil. Hauptredner war Prof. Carl Friedrich Freiherr von Weizsäcker.","Prof. von Weizsäcker warnt vor Bildungsnotstand","","2000 Lehrer und Studenten protestieren in Hamburg","ga.",[9],7,[1],[2],1,"50","1"],["5028","1967-07-01","Der Akademische Senat spricht sich entschieden gegen eine pauschale Verurteilung der Studentenschaft aus. Stattdessen sollte politisches Engagement im Rahmen der Legalität begrüßt werden, das Recht auf freie Meinungsäußerung sei unbestreitbar.","Professoren verteidigen Studenten","","","",[1],7,[1],[2],2,"50","3"],["5029","1967-07-01","Fortsetzung der Berichterstattung über die Kundgebung gegen den Bildungsnotstand auf der Hamburger Moorwiese. Prof. von Weizsäcker nahm auch Stellung zu den Demonstrationen gegen den Schah-Besuch. Er könne diese nicht vollständig befürworten, aber es käme darin eine berechtigte Unzufriedenheit über die politische Situation zum Ausdruck. Kritik an der Bildungspolitik der Bundesrepublik. Die Hamburger Lehrerverbände gaben eine Protestresolution über die Zustände an den Schulen heraus.","Studenten-Kundgebung ohne Zwischenfälle","","Fortsetzung von Seite 1","ga",[7,9],7,[1],[5],2,"50","3"],["5030","1967-07-01","Nach Vorschlag des Göttinger Konrektors Prof. Henckel soll die Universität Göttingen eine Patenschaft für die Bremer Universität übernehmen. Göttinger Professoren sollen demnach für eine Übergangszeit auch einen Lehrstuhl in Bremen übernehmen.","Patenschaft für Bremer Universität","","","er.",[4],7,[1],[2],2,"50","9"],["5031","1967-07-04","Nach einem Beschluß des Berliner Kammergerichts bleibt Fritz Teufel in Haft. Ihm wird u. a. vorgeworfen, während der Demonstration gegen den Schah am 2. Juni 1967 Polizisten mit Steinen beworfen zu haben.","Teufel bleibt in Haft","","","wy",[1],7,[1],[2],2,"14","1"],["5032","1967-07-04","In der Evangelischen Studentengemeinde in Hamburg diskutierten Studenten und Professoren über die Situation an den Universitäten. Insbesondere die fehlenden Stellungnahmen der Professorenschaft zu den Demonstrationen gegen den Schah-Besuch wurden von studentischer Seite kritisiert. Zudem wird mehr Mitspracherecht gefordert. Podiumsteilnehmer waren u.a. die Studenten Behlmer und Bauer sowie Rektor Schäfer und Prof. von Weizsäcker.","Zwei Stunden lang sagte man sich hart die Meinung","","Podiumsdiskussion zwischen Professoren und Studentenschaft","Ursula Weiner",[1],7,[1],[1],1,"14","4"],["5033","1967-07-07","Bei den Wahlen zum Hamburger Studentenparlament meldeten sich über 100 Kandidaten für die 40 freien Plätze. Eine solch hohe Beteiligung gab es zuvor noch nie.","An der \"Uni\" wurde gewählt","","","U.W.",[4],7,[1],[5],1,"20","4"],["5034","1967-07-07","Die Studenten der Kieler Universität hatten mit ihrem Protest gegen einen umstrittenen Paragraphen der neuen geplanten Satzung für die Universität Erfolg. Veranstaltungen von studentischen Gruppen müssen nicht mehr generell angemeldet werden, stattdessen heißt es, dass solche Vereinigungen gefördert werden sollen.","Protestaktion hatte Erfolg","","","",[1],7,[1],[2],2,"20","11"],["5035","1967-07-07","Der AStA der FU Berlin hat die Studenten zur Selbstanzeige aufgerufen, um so die wegen Aufrufs zur vorsätzlichen Brandstiftung angeklagten Fritz Teufel und Rainer Langhans zu helfen. Es müsse verhindert werden, dass an beiden ein Exempel statuiert wird. Bereits 200 Selbstanzeigen wurden dem Generalstaatsanwalt übermittelt. Die Kommune I rief zur Teilnahme am Prozess gegen Teufel auf. Kurzer Bericht über den ersten Prozesstag gegen Teufel und Langhans wegen der Kaufhausbrand-Flugblätter, Gutachter sehen in den Flugblättern ein Mittel der bittersten Ironie, um Unruhe unter den Bürgern zu verbreiten. Langhans und Teufel bestreiten, dass sie mit den Flugblättern zur Brandstiftung aufrufen wollten.","Selbstanzeige für Teufel","","Berliner Studenten wollen Hilfestellung leisten","",[5],7,[1],[5],1,"20","15"],["5036","1967-07-08","Mehrere Farbfotos von Hamburger Studenten, diese werden als engagierte Menschen, die lernen wollen und voll wachen Mißtrauens sind, dargestellt.","Hamburger Studenten","","","",[9],7,[1],[1],1,"52","1"],["5037","1967-07-08","Der Prozeß gegen Fritz Teufel und Rainer Langhans wegen Aufforderung zur vorsätzlichen Brandstiftung (Kaufhausbrand-Flugblätter der Kommune I) wurde vertagt. Es sollen zunächst psychiatrische und neurologische Untersuchungen abgewartet werden.","Teufel-Prozess wurde vertagt","","","wy",[5],7,[1],[2],2,"52","1"],["5038","1967-07-08","Gegen den Berliner Polizeipräsidenten Duensing und weitere führende Polizeibeamte ist ein Verfahren wegen Begünstigung im Amt eingeleitet worden. Ihnen wird vorgeworfen, die \"Jubel-Perser\" bei der Demonstration am 2. Juni 1967 bevorzugt behandelt und sie nicht gehindert zu haben, tätlich gegen andere Demonstranten vorzugehen.","Verfahren gegen Berlins Polizeipräsidenten","","","",[1],7,[1],[2],2,"52","1"],["5039","1967-07-10","Etwa 46 Prozent der Studenten beteiligten sich an der Wahl zum Hamburger Studentenparlament. Dies war zwar eine Steigerung, man hatte sich jedoch eine größere Beteiligung erhofft. Keiner der neun SDS-Kandidaten erhielt einen Sitz.","Nur die Hälfte ging zur Wahl","","","",[4],7,[1],[2],2,"14","4"],["5040","1967-07-14","In der Münchner Studentenzeitschrift \"Information\" wurden erstmals Vorlesungen der Professoren von Studenten rezensiert. Die Studenten blieben dabei anonym.","Studenten zensieren ihre Professoren","","","",[1],7,[1],[3],2,"20","2"],["5041","1967-07-14","Helga Bauer trat als Vorsitzende des Hamburger AStA zurück. Sie begründete dies mit Zeitmangel. Zuvor kritisierte sie die polizeilichen Vernehmungen bzgl. der Demonstrationen gegen den Schah. Diese würden den Minimalgrundsätzen eines Rechtsstaates widersprechen. Zeugen würden beeinflusst werden, und Kriminalbeamte teils gegen sich selbst ermitteln.Der stellvertretende Polizeipräsident Hamburgs widerspricht dieser Darstellung. Bericht eines griechischen Studenten, dem die Flucht aus seinem Land geglückt war, über die Zustände in Griechenland. Kritik auch am Rektor und einem SPD-Abgeordneten, der den Polizeieinsatz am 3. Juni 1967 billigte.","AStA protestiert gegen Polizei-Ermittlungen","","Dr. Rauschning antwortet/ Helga Bauer trat zurück","re/ ga",[1],7,[1],[5],1,"20","5"],["5042","1967-07-15","Gegen Fritz Teufel wird Anklage wegen Landfriedensbruchs erhoben. Ihm wird vorgeworfen, einer der Rädelsführer bei der Demonstration gegen den Schah am 2. Juni 1967 gewesen zu sein.","Zweite Anklage gegen Fritz Teufel erholen","","","",[5],7,[1],[2],2,"50","1"],["5043","1967-07-15","Zum neuen Präsidenten des Hamburger Studentenparlaments wurde Hanns Jürgen Flieger, zu seinem Stellvertreter Wolfgang Wunnenberg gewählt. Ziel des Präsidiums sei es, das Verhältnis zum Rektorat zu verbessern.","Neuer Präsident des Studentenparlaments","","","",[4],7,[1],[2],1,"50","5"],["5044","1967-07-15","130 Architektenvorschläge wurden für den Neubau der Bremer Universität eingereicht, die neun besten prämiert. Drei Entwürfe werden im Artikel vorgestellt.","Neuer Auftrieb für Bremens Universitätspläne","","130 Architektenvorschläge beleben die Diskussion","er.",[4],7,[1],[1],1,"50","9"],["5045","1967-07-18","Demonstration von Studenten und Dozenten der Staatlichen Ingenieurschule für das Bauwesen Buxtehude gegen die unzulängliche technische Ausrüstung.","Studenten demonstrierten in Buxtehude","","","",[4],7,[1],[3],1,"14","1"],["5046","1967-07-18","Etwa 120 Studenten und Dozenten der Staatlichen Ingenieurschule für das Bauwesen Buxtehude demonstrierten gegen die Verlängerung ihres Schulprovisoriums und die Verzögerung des Neubaus.","Buxtehuder Studenten gingen auf die Straße","","Protest gegen Verzögerung des Ingenieurschulbaus","jk",[4],7,[1],[2],1,"14","4"],["5047","1967-07-18","Die neugewählten Dekane der Hamburger Universität werden ausführlich vorgestellt.","Die neuen Dekane der Universität","","Vor schweren Aufgaben","",[4],7,[1],[1],1,"14","4"],["5048","1967-07-20","Rektor Lieber von der FU Berlin hat bei Senator Stein um ein Rechtsgutachten gebeten. Hintergrund ist die Frage, ob die \"Kritische Unversität\" Anerkennung als offizielles Organ der Studentenschaft finden könne. Kurze Beschreibung der Kritischen Universität. Bisher lehnt es Lieber ab, Räume für die Kritische Universität zur Verfügung zu stellen.","\"Kritische Universität\" soll geprüft werden","","","wy",[1],7,[1],[3],2,"16","1"],["5049","1967-07-21","An der FU Berlin hat sich das \"Aktionskomitee 20. Konvent\" gebildet. Sie ruft zur Sammlung der gemäßigten Kräfte innerhalb der Studentenschaft auf, um den radikalen Kräften Einhalt zu gebieten.","Gemäßigte Studenten sammeln sich","","","wy",[4],7,[1],[2],2,"18","1"],["5050","1967-07-21","Fünf Monate nach dem Rücktritt des Gründungsauschusses der Bremer Universität kommt ein neuer Ausschuss zu seiner ersten konstituierenden Sitzung zusammen.","Neuer Beratungsausschuss für Bremer Universität","","","er.",[4],7,[1],[2],2,"18","1"],["5051","1967-07-21","Neuwahl des AStA der Hamburger Universität. Neuer Vorsitzender ist Björn Pätzoldt, sein Stellvertreter Norbert Jankowski. Beide sollen dem SHB nahe stehen.","Studenten wählten den neuen AStA-Vorstand","","Nachtsitzung des Parlaments/ Blumen für Helga Bauer","U.W.",[4],7,[1],[2],1,"18","3"],["5052","1967-07-24","Kritik an Erwachsenen, die jungen Menschen das Demonstrationsrecht absprechen. Eine \"Demokratisierung der Grundrechte\" wird gefordert. Bericht über eine Sendung vom NDR zum Thema \"Wer hat Angst vor Demonstrationen?\". Kritik an Autoritätshörigen. Verständnis für Demonstrationen und für die Jugend, nur teils Kritik an der Form des Protests. Zu Beiträgen von Dutschke und Nevermann wird konstatiert, dass diese teils ideologischen Unsinn von sich gaben, diese aber das Grundgesetz beim Wort und die Demokratie ernst nehmen würden. Die Demonstranten werden ernst genommen, stellvertretend dafür die Sätze: \"Seien wir doch froh, dass sie denken, mit dem Bestehenden unzufrieden sind und opponieren, sogar rebellieren.\" Von diesen Rebellen haben wir in unserer Geschichte zum Schaden des immer wieder zur Restaurierung des Gewesenen geneigten Vaterlandes zu wenige gehabt.\"","Wer hat Angst vor Demonstrationen?","","Junge Hörer am Mikrofon/ \"Rebellen, Rowdys, und Rabauken\"/ Der Katalog der Grundrechte","wmh",[1],7,[1],[1],1,"14","7"],["5053","1967-07-25","Hamburger Philosophie-Studenten wollen künftig zu jedem Ende eines Semesters Vorlesungsrezensionen veröffentlichen. Diese sollen anonym sein, Gegendarstellungen will man kommentarlos bringen. ","Studenten wollen \"Zensuren\" geben","","","",[1],7,[1],[2],2,"16","3"],["5054","1967-07-26","Die persische Regierung hat in einer Note an das Auswärtige Amt eine Bestrafung der Demonstranten gegen den Schah-Besuch sowie einen Bericht über die Strafverfahren gefordert. Bei der Strafverfolgung würden laut des Hamburger Oberstaatsanwalts die größten Probleme bei der Identifizierung der beschuldigten Polizeibeamten entstehen.","Schah verlangt Bestrafung von Demonstranten","","Diplomatisches Nachspiel des Staatsbesuchs im Juni","ga",[1],7,[1],[1],2,"22","1"],["5055","1967-07-27","Kritik von allen Seiten an der Forderung der persischen Regierung nach Bestrafung der Demonstranten während des Schah-Besuches. Insbesondere auch scharfe Kritik vom Hamburger AStA-Vorsitzenden Pätzoldt. Von politischer Seite wird betont, dass die Forderung keine Auswirkungen auf die bereits laufenden Ermittlungen haben wird. Der Tatbestand \"Beleidigung des Schahs\" wird zurückgewiesen, dies könnte zu \"peinlichen\" Situationen führen, weil dann die politische Lage in Persien intensiv dargestellt werden müsste. Im Kommentar zum Bericht wird ausdrücklich gesagt, dass die \"Phalanx der Jubelperser\" zuerst handgreiflich geworden ist, zudem wird das große Polizeiaufgebot als \"Eskalation von deutscher Gründlichkeit\" bezeichnet, die Studentenunruhen als Reaktion darauf gewertet.","Schah-Forderung stößt überall auf heftige Kritik","","Hamburger Stimme aus Bonn: \"Peinliche Situation\"","ga",[1],7,[1],[1],1,"18","11"],["5056","1967-07-28","In Kreisen der Bundesregierung ist man verärgert über die persische Forderung nach Bestrafung der Demonstranten gegen den Schah-Besuch, ein Strafverlangen kann nicht einfach abgewiesen werden.","Persische Note bringt Bonn in peinliche Lage","","Regierungskreise verärgert/ \"Prozedur muss rollen\"","wst.",[1],7,[1],[2],2,"18","2"],["5057","1967-07-28","Die FDP will die Frage klären lassen, ob es der Polizei erlaubt ist, bei Demonstrationen zu filmen und zu fotografieren. Hamburgs stellv. Polizeipräsident Rauschning rechtfertigt dies. Kritik von der FDP auch an der Staatsanwaltschaft, diese habe bei einen \"zu geringen Aufklärungswillen\" bei der Aufarbeitung der Geschenisse um die Demonstrationen gegen den Schah-Besuch.","Diskussion um den Polizisten mit der Kamera","","FDP untersucht die Rechtmäßigkeit","ga",[1],7,[1],[1],1,"18","3"],["5058","1967-07-29","Karl-Heinz Kurras wird wegen fahrlässiger Tötung angeklagt. Insbesondere zwei Kollegen belasten ihn schwer. Demnach soll er entgegen seiner eigenen Aussage nicht bedroht  und von einem Kollegen vor dem Gebrauch der Waffe gewarnt worden sein.","Kurras kommt vor Gericht","","Staatsanwaltschaft: Ohnesorg fahrlässig getötet","wy",[1],7,[1],[2],2,"56","2"],["5059","1967-07-29","Die Staatliche Pressestelle erklärt das Fotografieren und Filmen der Polizei bei Demonstrationen für rechtmäßig. Im Kommentar Kritik an dieser Stellungnahme, dies gehe am Problem vorbei. Die Archivierung von Fotos von friedlichen Demonstrationen werde durch die Strafprozeßordnung und das Grundgesetz eingeschränkt.","Diskussion um die Polizei-Fotos","","Staatliche Pressestelle: \"Erlaubt\"","l.",[1],7,[1],[2],2,"56","5"],["5060","1967-07-31","Die \"Jungdemokraten\" nennen das Verlangen des Schahs nach Bestrafung der Demonstranten gegen ihn \"unverschämt\". Die Bundesregierung solle dieses Ansinnen zurückweisen.","Protest gegen das Ansinnen des Schahs","","","",[1],7,[1],[2],2,"14","3"],["5061","1967-08-05","Vertreter der Hamburger Studentenschaft erklären in einem Brief an die Hamburger Bürgerschaft, dass die Vorgänge während der Demonstration gegen den Schah-Besuch auch in Hamburg gezeigt hätten, dass die Existenz einer freien, öffentlich geäußerten Meinung gefährdet sei. Die Fehler der Polizei seien nicht auf bösen Willen, aber auf Rechtsunsicherheit bei der politischen Führung und der Polizei zurückzuführen. Neun Forderungen an die Politiker für zukünftige Demonstrationen, insbesondere was das Vorgehen der Polizei betrifft.","Studenten fürchten um die Meinungsfreiheit","","Brief an die Bürgerschaft/ Neun Forderungen","",[1],7,[1],[3],2,"52","3"],["5062","1967-08-09","Studenten versuchten, das Wissmann-Denkmal umzustürzen, nachdem der SDS dazu vorher aufgerufen hatte. Es sollte so gegen den \"Kolonialismus in der afrikanischen Welt\" protestiert werden. Schulsenator Drexelius zeigt sich verwundert zu der Aktion, dies sei aber wohl eine Generationenfrage. Ähnlich äußert sich auch der künftige Rektor Prof. Ehrlicher. Leichte Kritik auch im Kommentar, Unmut wurde mit Handgreiflichkeit verwechselt. ","Wissmann-Denkmal sollte umgestürzt werden","","Studenten-Aktion gegen Kolonialismus/ Bürgermeister Drexelius: \"Etwas verwundert\"","jh",[1],7,[1],[1],1,"26","4"],["5063","1967-08-10","Studenten der Kommune I störten die Trauerfeier des verstorbenen Reichstagspräsidenten Paul Löbe in Berlin. Aus einem Sarg stand ein Kommune-Mitglied im Nachthemd auf und verteilte Flugblätter, auf denen die Freilassung von Fritz Teufel gefordert wurde. Die Polizei habe die \"taktlosen Studenten\" vor dem Zorn empörter Berliner schützen müssen.","Studenten-Kommune störte Trauerfeier","","","",[1],7,[1],[2],1,"16","2"],["5064","1967-08-16","Das Bundesjustizministerium ist zu der Erkenntnis gekommen, dass die persische Regierung in ihrer Note kein ausdrückliches Verlangen nach Strafverfolgen der Demonstranten gegen den Schah fordert. Die erwartete Prozesslawine soll daher ausbleiben. Die Bonner Studenten-Gewerkschaft hat bereits vorsorglich gegen einen eventuellen Staatsbesuchs des griechischen Königs protestiert. Das Bundesinnenministerium teilte mit, dass seit 1954 im Zusammenhang mit politischen Ausschreitungen etwa 20 Tote und ebenso viele Verschleppungen registriert worden sind.","Keine Prozesse gegen \"Schah-Beleidiger\"","","Bonn: Persien hat keine Strafverfolgung verlangt","wst",[1],7,[1],[2],2,"26","2"],["5065","1967-08-17","Laut dem Hamburger Justizsenator Schulz soll es in der Hansestadt nicht zu einer Prozesslawine wegen Beleidigung des Schahs kommen. Aktuell laufe kein einziges Strafermittlungsverfahren in diesem Punkt, lediglich in sechs Fällen sammle die Staatsanwaltschaft beweise. Unabhängig davon wird jedoch gegen Polizisten und Studenten ermittelt, die sich u.a. der Körperverletzung schuldig gemacht haben könnten.","Keine Prozess-Lawine gegen Studenten","","","wl.",[1],7,[1],[2],2,"22","1"],["5066","1967-08-28","Mit \"krawallähnlichen Demonstrationen\" haben Studenten die verlängerten Öffnungszeiten im Zuge der Funkausstellung angegriffen. Mit Blockaden von Kaufhäusern erzwang man die frühere Schließung. Die Verkäufer wurden dazu aufgerufen, sich dagegen zu wehren, die \"Kulis des Senats\" zu sein. Gegen Horst Mahler wurde Strafanzeige gestellt, weil er in einem Kaufhaus die Demonstranten juristisch beraten haben soll. Der Berliner Senat erklärte, er werde solche gesetzeswidrigen Aktionen nicht dulden.","Studenten-Krawalle in Berliner Kaufhäusern","","Demonstrationen gegen späteren Ladenschluß","wy",[1],7,[1],[2],2,"16","2"],["5067","1967-08-29","Die Berliner Bevölkerung werfe dem Berliner Senat vor, nicht mit den Unruhen einer Minderheit fertig zu werden. Hintergrund ist die jüngste Blockade von Kaufhäusern durch Studenten. Verbände und Parteien fordern ein energischeres Vorgehen gegen die Unruhen, die SPD erwäge, diesen künftig mit mehr staatlicher Autorität zu begegnen. Auch die Jungsozialisten und die Falken kritisieren die Aktion. Unruhe würde vor allem die Taktik der Demonstranten auslösen, da diese kaum von den Kunden unterschieden werden konnten.","Berliner fordern: Senat soll durchgreifen","","Empörung über Kaufhaus-Krawalle der Studenten","wy",[1],7,[1],[2],2,"20","2"],["5068","1967-08-30","Im Wintersemester 1966/67 wurde ein neuer Rekord an Studentinnen verzeichnet. Gegenüber dem Vorjahr stieg ihre Quote um über 150 Prozent, insgesamt stellen sie 24,2 Prozent der Studentenschaft. Auch insgesamt wird ein Anstieg der Studentenzahlen konstatiert, mit Aufzählung der größten Fachrichtungen.","Die Frauen stürmen auf die Universitäten","","Rekord-Zuwachs an Studentinnen im letzten Semester","",[11],7,[1],[3],2,"26","2"],["5069","1967-08-30","Der Berliner Senat hat in einer Erklärung die Blockade von Kaufhäusern durch Studenten während der verlängerten Öffnungszeiten scharf verurteilt.","Störaktionen vom Senat scharf verurteilt","","","wy",[1],7,[1],[2],2,"26","2"],["5070","1967-09-01","Die Kieler Universität soll derart erweitert werden, dass sie künftig statt 7000 Studenten 8000 aufnehmen kann.","Weitere 200 Mill. DM für Kieler Universität","","","",[4],7,[1],[2],2,"32","1"],["5071","1967-09-02","Die Bremer CDU kritisiert die Pläne des Senats für die Gründung der Bremer Universität. Insbesondere die Besetzung des neuen Gründungsausschusses wird kritisiert, dieser sei ein Affront gegen die Mitglieder des ersten Ausschusses. Die CDU plädiert dafür, dass Göttinger Angebot einer Partnerschaft zwischen den Universitäten anzunehmen.","Affront gegen bekannte deutsche Professoren","","Bremer CDU kritisiert Universitätspläne der SPD","er.",[4],7,[1],[3],2,"56","2"],["5072","1967-09-04","In einem Appell an die Berliner Bevölkerung verurteilte Berlins Regierender Bürgermeister Albertz die \"Aktionen linksradikaler Gruppen\". Diese würden ein Anwachsen des Rechtsextremismus begünstigen. Zugleich rief er die Berliner zu demokratischer Toleranz auf. Das Vorgehen der Polizei würdigte er, weitere Verunglimpfungen der Polizei solle man nicht zulassen. ","Aufruf zur Toleranz","","","wy",[1],7,[1],[3],2,"16","1"],["5073","1967-09-05","Die Hamburger CDU stellte eine Kleine Anfrage an den Senat, ob dem ausgewiesenen Studenten Ifeobu mittlerweile die Rückkehr gestattet wurde, welche Kosten durch die Ausweisung entstanden sind und ob der Senat die damalige Ausweisung gegenwärtig immer noch für gerechtfertigt hält.","Fall Ifeobu vor der Bürgerschaft","","","",[1],7,[1],[2],2,"18","4"],["5074","1967-09-05","Der SDS äußerte auf seiner 22. Delegiertenkonferenz Kritik an den Deutschen Gewerkschaften. Diese hätten sich mit \"dem kapitalistischen System arrangiert, um bessere Löhne für die Arbeiter zu erhalten.\"","SDS übt Kritik","","","",[8],7,[1],[2],2,"18","10"],["5075","1967-09-08","Die Beantwortung einer Anfrage der Hamburger CDU zum Fall Obi Ifeobu. Demnach habe die Ausweisung etwas mehr als 6000 DM gekostet, der Senat hält die seinerzeitige Ausweisung nach wie vor für gerechtfertigt. Man prüfe aber die Erteilung einer erneuten Aufenthaltsgenehmigung, nachdem sich Ifeobu für sein Verhalten entschuldigt hat. Die Staatsanwaltschaft ermittelt nach wie vor gegen Ifeobu.","Ausweisung des Studenten Ifeobu kostet 6184 Mark","","Zwei Beamte flogen mit nach Nigeria","ga",[1],7,[1],[1],1,"24","3"],["5076","1967-09-12","Das Ermittlungsverfahren gegen den Kommandeur der Hamburger Schutzpolizei, Leddin, wurde eingestellt. Die Vorwürfe, u.a. soll er während der Demonstrationen gegen den Schah-Besuch Demonstranten geschlagen haben, hätten sich als unbegründet erwiesen.","Ermittlungen gegen Leddin eingestellt","","\"Beschuldigungen erwiesen sich als unbegründet\"","wo.",[1],7,[1],[5],1,"16","4"],["5077","1967-09-12","In Göttingen soll künftig jeder Student 75 Pfennig pro Semester an eine Darlehenskasse entrichten, um Studenten, die kurz vor dem Examen stehen und in finanziellen Nöten sind, zu unterstützen. Beispiele von in Not geratenen Studenten.","Studenten gründeten Hilfswerk","","Darlehenskasse für Notfälle/ Jeder zahlt 75 Pfennig pro Semester","R. St.",[9],7,[1],[5],1,"16","16"],["5078","1967-09-13","Die Abschlussberatungen für das neue Hochschulgesetz der Universität Hamburg werden verschoben","Hochschulgesetz wird noch nicht verabschiedet","","","",[4],7,[1],[2],2,"24","3"],["5079","1967-09-15","Der SDS und der AStA der FU Berlin kündigen eine Protestaktion gegen die Politik des Berliner Senats an. Auf dieser Veranstaltung will sich auch Fritz Teufel, dessen Haftverschonung aufgehoben war, der Polizei stellen. Berlins Regierender Bürgermeister Albertz wird vor dem Senat eine Erklärung über die innere Sicherheit der Stadt mit Bezug auf die jüngsten Unruhen abgeben.","Wieder Protestaktion in Berlin geplant","","","wy",[1],7,[1],[3],1,"28","1"],["5080","1967-09-15","Die Hamburger FDP will in der Bürgerschaft eine Debatte über das geplante Hochschulgesetz herbeiführen. Die CDU hatte dieses Gesetz als gescheitert bezeichnet, weil die abschließenden Beratungen auf unbestimmte Zeit vertagt wurden.","FDP will Debatte über das Hochschulgesetz","","","",[4],7,[1],[2],2,"28","5"],["5081","1967-09-16","Entgegen der Aussage des Hamburger Justizsenators Schulz wird gegen den Kommandeur der Schutzpolizei, Leddin, weiter ermittelt, allerdings nur noch zu dem Vorwurf, bei Räumung der Demonstration am 4. Juni 1967 falsche Befehle gegeben zu haben. Leddin wird gegen die Demonstranten, die ihn der Körperverletzung bezichtigt hatten, seinerseits Anzeige wegen falscher Anschuldigungen stellen. Die Justizbehörde hat zudem mitgeteilt, dass gegen zwei Gruppen von Demonstranten ermittelt wird. Dabei geht es um den Tatbestand der Beleidigung eines ausländischen Staatsgastes.","Leddin erstattet Anzeige","","Gegen den Kommandeur der Schutzpolizei wird noch ermittelt","ga/ wo",[1],7,[1],[3],1,"56","5"],["5082","1967-09-19","Der Untersuchungsausschuss des Berliner Abgeordnetenhauses zu den Vorfällen während der Demonstration am 2. Juni 1967 hat die Abberufung des Berliner Polizeipräsidenten Duensing empfohlen. Dieser habe sich nicht an Verfügungen des Innensenators gehalten. Der Untersuchungsausschuss spricht sich ferner dafür aus, unangemeldete und nicht genehmigte Demonstrationen mit allen zur Verfügung stehenden Mitteln zu verhindern, versteht darunter aber nicht Ansammlungen von Diskussionsgruppen. Zudem wird ein Amtswechsel des Leiters der Polizeiabteilung in der Senatsabteilung für Inneres, Prill, empfohlen.","Berliner Polizeipräsident Duensing soll gehen","","","",[1],7,[1],[2],1,"18","2"],["5083","1967-09-19","Die CDU-Fraktion der Hamburger Bürgerschaft will einen eigenen Entwurf für ein neues Hochschulgesetz erarbeiten. Der vom Senat ausgearbeitete Entwurf sei in ihren Augen praktisch gescheitert.","CDU arbeitet am Hochschulgesetz","","","",[4],7,[1],[2],2,"18","4"],["5084","1967-09-20","Berlins Innensenator Büsch ist auf Grund der Vorfälle am 2. Juni 1967 zurückgetreten. Er habe dies bereits unmittelbar nach den Ereignissen zweimal angeboten, damals sei dies aber vom Regierenden Bürgermeister Albertz abgelehnt worden. Als sein Nachfolger ist der bisherige Sozialsenator Neubauer im Gespräch.","Berliner Senator zurückgetreten","","","",[1],7,[1],[2],1,"30","1"],["5085","1967-09-20","Die Hamburger Polizei hat Filmaufnahmen von den Demonstrationen gegen den Schahbesuch der Staatsanwaltschaft vorenthalten. Es soll nun geklärt werden, wer die Aufnahmen zurückhielt. Kritik an den Ermittlungen zu den Vorfällen.","Und wer unterdrückte dieses Beweismaterial?","","Fernseh-\"Konserve\" der Polizei jetzt herausgegeben","ga.",[1],7,[1],[5],2,"30","5"],["5086","1967-09-21","Die Hamburger Staatsanwaltschaft untersucht, warum ihr seitens der Polizei nicht sämtliche Aufnahmen der Demonstrationen gegen den Schahbesuch zur Verfügung gestellt wurden. Schon Ende August gab es durch Hinweise von Studenten Kenntnis über weiteres Filmmaterial.","Jetzt ermittelt man im Polizeipräsidium","","Wer hielt die Fernseh-Aufzeichnungen zurück?","ga.",[1],7,[1],[5],1,"22","3"],["5087","1967-09-22","Die Hamburger Staatsanwaltschaft hat weiteres Beweismaterial in Form von Fotos für die Geschehnisse bei den Demonstrationen gegen den Schah-Besuch erhalten. Die CDU will in der Bürgerschaft klären, wie Filmaufnahmen von der Polizei zurückgehalten werden konnten.","Schah-Besuch: Neues Material über die Vorfälle","","","ga.",[1],7,[1],[2],2,"24","1"],["5088","1967-09-23","Der Untersuchungsausschuss des Berliner Abgeordnetenhauses zu den Vorfällen während der Demonstration am 2. Juni 1967 kommt zu dem Schluss, dass die Zusammenstöße von keiner Seite systematisch geplant worden waren. Der Vorsitzende des Ausschusses, Löffler, weist die Kritik am Vorgehen der Polizei zurück. Polizeipräsident Duensing bat um vorzeitige Pensionierung, dem wurde stattgegeben. Der Empfehlung einer Versetzung des Leiters der Polizeiabteilung beim Innensenator, Prill, folgte das Abgeordnetenhaus dagegen nicht.","Schlussstrich unter die Berliner Zusammenstöße","","Polizeipräsident Duensing vorzeitig pensioniert","",[1],7,[1],[2],2,"58","1"],["5089","1967-09-26","Die Intendanz des ZDF hat mit Befremden zur Kenntnis genommen, dass ein vom ZDF abgelehnter Kommentar von Günter Grass in der ARD-Sendung \"Panorama\" ausgestrahlt wurde. Die Intendanz begründete ihre Ablehnung damit, dass Grass' Beitrag gegen den Staatsvertrag und die Programmrichtlinien verstoßen habe.","Befremden beim ZDF über Panorama-Sendung","","Intendanz distanziert sich von Grass-Kommentar","",[10],7,[1],[5],2,"18","2"],["5090","1967-09-26","Schwere Kritik an der ARD-Sendung \"Panorama\", die eine Rede von Günter Grass, hier als \"Hetzpamphlet\" bezeichnet, ausgestrahlt hatte. Grass bezichtigte den Springer-Verlag darin faschistischer Methoden und rief zum Boykott des Verlages auf. Hintergrund war ein angeblicher Brief Arnold Zweigs, in dem dieser sich über Zustände in der DDR beklage. Dieser Brief existierte jedoch nicht, die Springer-Presse berichtete jedoch darüber, gab ihren Irrtum wohl auch zu. Kritik an dieser Berichterstattung sei gerechtfertigt, nicht jedoch in der Art des Panorama-Beitrages. Auch Grass sei schon Fälschungen aufgesessen, mit Beispiel. Schwere Kritik an Grass, dieser wird u.a. als rosaroter Erfolgsschriftsteller bezeichnet.","Ein Hetz-Pamphlet","","","M. S.",[10],7,[5],[1],2,"18","2"],["5091","1967-09-27","Das Wissmann-Denkmal in Hamburg wurde von Unbekannten gestürzt. Bereits am 8. August hatten Mitglieder des SDS das Gleiche versucht.","Denkmal gestürzt","","","",[1],7,[1],[2],1,"28","3"],["5092","1967-09-28","Die Polizei verhinderte, dass Studenten das Hamburger Dominik-Denkmal stürzten. Der SDS hatte dazu aufgerufen. Zudem protestierte man vor dem Amerikahaus, wobei eine nordvietnamesische Fahne entrollt wurde, die anschließend beschlagnahmt wurde. Ein Kriegerdenkmal wurde von Unbekannten beschädigt.","Polizei schützte Dominik-Denkmal","","","",[1],7,[1],[2],2,"22","5"],["5093","1967-10-05","Das umgestürzte Wißmann-Denkmal wurde wieder aufgerichtet. Der SDS streitet eine Täterschaft ab, wenn denn hätte man dies vor den Augen der Öffentlichkeit gemacht, alles andere sei sinnlos.","Denkmalstürzer sind noch immer unbekannt","","Wißmann wieder auf dem Sockel/ Dicke Rechnung","ga.",[1],7,[1],[3],2,"24","3"],["5094","1967-10-05","Mehrere Leserbriefe zum Sturz des Wißmann-Denkmals in Hamburg. Kritik an der Aktion, diese sei hinterhältig gewesen. Wißmann sei ein Freund der Afrikaner gewesen.","Wißmann-Denkmal","Briefe an das Hamburger Abendblatt","","Leser",[1],7,[6],[2],1,"24","10"],["5095","1967-10-16","Demonstrationen von Studenten auf der Frankfurter Buchmesse, vor allem gegen Stände des Springer-Verlags sowie gegen griechische und südafrikanische Stände. Kritik von Veranstaltern und Politikern.","Scharfe Kritik an den Krawallmachern","","Die \"Show\" der SDS-Studenten/ \"Happenings\" in Halle 5 und 6/ Erlebnisse auf dem Bücher-Supermarkt","Paul Theodor Hoffmann",[1],7,[1],[1],2,"16","13"],["5096","1967-10-17","Erneut kam es zu Demonstrationen auf der Frankfurter Buchmesse, organisiert vom SDS. Ziel war vor allem der Springer-Stand \"Welt der Literatur\". Günter Grass soll sich gegen die Demonstrationen ausgesprochen haben, wird aber als \"Schrittmacher einer Anti-Springer-Kampagne\" bezeichnet. Mehrere ausländische Verleger haben mit ihrem künftigen Teilnahmeverzicht gedroht, sollten sich solche Demonstrationen wiederholen. Mehrere Autoren und auch Verleger haben eine Boykotterklärung der publizistischen Organe des Springer-Verlags unterzeichnet, mehrere junge Verleger kritisieren dies.","Die Bücher interessierten sie nicht","","Neue Demonstrationen auf der Frankfurter Messe/ Aussteller brechen Stände ab/ Junge Verleger distanzieren sich vom Boykott/ Das Ansehen der Messe gefährdet","",[1],7,[1],[1],2,"18","10"],["5097","1967-10-18","Das Studienjahr 1967/68 der Staatlichen Hochschule für Musik und Darstellende Kunst wurde eröffnet. Der Direktor der Hochschule betonte die Dringlichkeit der Lösung des Raumproblems, was nur durch finanzielle Unterstützung durch den Senat möglich sei.","Musikhochschule braucht mehr Platz","","","",[4],7,[1],[2],2,"30","5"],["5098","1967-10-19","In Hamburg wurde eine \"Kritische Universität\" gegründet. Diese verstehe sich nicht als Gegenpol zur bestehenden Universität, sondern will Reformen auf Gebieten vorantreiben, auf denen Studenten selbständig arbeiten können. Die Vorlesungszeichnisse fänden reißenden Absatz, im Gegensatz zu anderen Kritischen Universitäten kann die Hamburger mit einem fertigen Programm aufwarten. Nur äußerlich lehne man sich an das Berliner Modell an. Man will mehr kritisches Bewußtsein schaffen und verhindern, dass Wissenschaft unkritisch betrieben wird. Insgesamt recht wohlwollend zu den Plänen.","Studenten gründen \"Kritische Universität\"","","AStA: Vorbereitung weniger lautstark als in Berlin","U.W.",[1],7,[1],[2],2,"24","5"],["5099","1967-10-21","Etwa 2500 Anhänger der Kampagne für Abrüstung demonstrierten in Hamburg gegen den Vietnam-Krieg. Die Demonstration sei ohne Zwischenfälle verlaufen. Eine Gruppe von SDS-Mitgliedern habe die Demonstration zum Anlaß genommen, vor dem Amerikahaus zu protestieren und dieses sowie einige Polizisten mit Eiern und Farbbeuteln zu bewerfen. Die Polizisten hätten sich jedoch nicht provozieren lassen.","Polizeibeamte ließen sich nicht provozieren","","Störversuche während der Vietnam-Demonstration","",[1],7,[1],[2],2,"62","4"],["5100","1967-10-24","44 Londoner Demonstranten gegen den Vietnamkrieg wurden wegen verschiedener Delikten wie tätlichen Angriffen auf die Polizei angeklagt, einer wurde mit drei Monaten Gefängnis bestraft, 25 bekamen Geldstrafen. Der Rest wurde auf Kaution freigelassen.","Gerichtliches Nachspiel","Bunte Welt","","",[1],7,[1],[2],2,"24","2"],["5101","1967-10-24","Versammlung des Verbandes Deutscher Zeitschriften-Verleger in Berlin, diese bekennen sich zu Berlin und erklären, die Pressefreiheit ist unteilbar. Es dürfe nicht geduldet werden, dass eine Minderheit ihre Mitbürger zu hindern versuche, bestimmte Zeitungen und Zeitschriften zu kaufen. Gegen Auflagebeschränkungen. Springer äußert sich zur Bedeutung von Berlin. Der Präsident des Verbandes der Zeitschriftenverleger, Kluthe, spricht von rechten und insbesondere linken Elementen, die die Verfassung beseitigen wollen: \"Sie sagen Springer, aber sie meinen unsere demokratische Freiheit.\" Kluthe warnte vor einer roten SA und erklärte es zur Pflicht, sich mit Springer solidarisch zu erklären.","Die Pressefreiheit ist unteilbar!","","Verleger gegen Gesinnungsdiktatur","wy",[10],7,[1],[1],2,"24","13"],["5102","1967-10-24","Lob für den Oberkommisar Textor für seine Leitung eines Polizeieinsatzes bei einer Anti-Vietnam-Demonstration. Er hatte immer wieder versucht, mit Humor die Situation zu entschärfen, dies sei ihm auch gelungen.","Wer sitzt, kann nicht tanzen","","Berliner Polizei mit Humor gegen Demonstranten","",[1],7,[1],[2],2,"24","13"],["5103","1967-10-27","Axel Springer sprach vor dem Hamburger Übersee-Club über die politische Ausrichtung seines Hauses. Erstmals Nennung der vier Leitlinien des Hauses.","\"Es geht um die Erhaltung der bürgerlichen Freiheiten\"","","Axel Springer sprach vor dem Hamburger Übersee-Club","",[10],7,[1],[1],1,"32","2"],["5104","1967-10-27","Der AStA der Universität Hamburg will den Rektor der Universität künftig nicht mehr Magnifizienz nennen. Dies sei nicht persönlich gegen den Rektor gerichtet, sondern solle vielmehr \"alte Zöpfe\" abschneiden und Barrieren zwischen Professoren und Studenten beseitigen. Das Hamburger Studentenparlament lehnte jegliche eidliche Verpflichtung der neuimmatrikulierten Studenten ab.","AStA gegen \"alte Zöpfe\" im Universitätsleben","","Der Rektor soll nicht mehr \"Magnifizienz\" heißen","U. W.",[1],7,[1],[2],2,"32","9"],["5105","1967-10-27","Der Hamburger RCDS ist nicht damit einverstanden, dass der AStA im Namen aller Studenten zu aktuellen politischen Fragen Stellung nimmt. Er solle sich auf den akademischen Aufgabenbereich beschränken.","\"Auf die akademischen Aufgaben beschränken\"","","","",[11],7,[1],[2],2,"32","9"],["5106","1967-11-01","Prof. Thielicke von der Theologischen Fakultät der Universität Hamburg begrüßt die Einrichtung einer \"Kritischen Universität\". Er betonte, dass die Hamburger Studentenschaft keine Gegenuniversität wolle, sondern im Bestehenden reformieren möchte. Thielicke äußerte sich aber gegen eine paritätische Mitbestimmung und gegen die studentische Mitbestimmung bei Berufungen von Professoren.","Thielicke begrüßt kritische Universität","","","U. W.",[11],7,[1],[2],2,"32","2"],["5107","1967-11-01","Fünf Studenten wurden in Berlin wegen Hausfriedensbruchs zu jeweils einer Geldstrafe von 200 DM verurteilt. Sie gehörten zu den Demonstranten vom 2.8.1966, die die Absetzung des Films Africa Addio gefordert hatten.","Wegen Hausfriedensbruchs?","Bunte Welt","","",[1],7,[1],[2],2,"32","2"],["5108","1967-11-02","In West-Berlin ist eine \"Kritische Universität\" gegründet worden. Laut Prof. Gottschalch soll die KU der APO als Unterstützungsorgan dienen. Kurz zu den Zielen. Die KU ist gegen den Widerstand der Berliner Universitätsbehörden entstanden.","\"Kritische Universität\" in Berlin gegründet","","","wy",[11],7,[1],[3],2,"24","2"],["5109","1967-11-03","Beginn des Prozesses gegen Karl-Heinz Kurras wegen fahrlässiger Tötung von Benno Ohnesorg. Kurras beruft sich auf Notwehr.","Polizist Kurras: Es war Notwehr","","","",[1],7,[1],[3],2,"38","2"],["5110","1967-11-04","Karl-Heinz Kurras erklärt zum Prozessauftakt wegen fahrlässiger Tötung, dass er den Tod Ohnesorgs bedauert. Insgesamt 83 Zeugen und 5 Sachverständige sind geladen. Kurras erklärte, er habe in Notwehr gehandelt, sei von etwa 20 Demonstranten umringt gewesen, einer hätte gerufen: \"Da ist ein Bulle, schlagt ihn tot!\". Er sei niedergeschlagen worden, zwei Demonstranten mit Messern hätten sich genähert. Daraufhin habe er einen Warnschuß abgegeben, ein zweiter Schuß hätte sich kurz danach gelöst. Zeugenaussagen widersprechen dieser Darstellung.","Kurras: Es ist furchtbar","","Widersprüche im Prozeß um den Tod Ohnesorgs","wy",[1],7,[1],[2],2,"62","2"],["5111","1967-11-07","Die Westdeutsche Rektorenkonferenz wirft den staatlichen Behörden vor, durch ihr Zögern eine Studienreform zu behindern. Ferner werfen die Rektoren Bund und Ländern vor, dass sie nichts für die Verbesserung der Studienförderung getan hätten.","\"Staat behindert Studienreform\"","","","",[4],7,[1],[2],2,"16","1"],["5112","1967-11-08","Auch der zweite Tag im Prozess gegen Karl-Heinz Kurras habe nicht klären können, ob dieser Ohnesorg in Notwehr erschossen habe. Keiner der vernommenen Zeugen habe den Schuss gehört. Ein Student sagte aus, dass er gesehen habe, wie Polizisten auf den bereits am Boden liegenden Ohnesorg einschlugen. Der medizinische Sachverständige bestätigte dazu, dass an Ohnesorgs Körper mehrere blutunterlaufene Stellen gefunden wurden.","Keiner bemerkte den Schuss","","","wy",[1],7,[1],[2],2,"32","1"],["5113","1967-11-08","Vertreter des SDS und SHB kündigten an, bei der kommenden Rekoratsübergabe an der Uni Hamburg dem Rektor, den Dekanen und dem AStA Fragen zu stellen. Es wird ein großer Andrang zur Rektoratsfeier erwartet. Der AStA-Vorsitzende Pätzoldt wird einen Vortrag zur geplanten Hochschulreform aus studentischer Sicht halten.","Studentengruppen wünschen Diskussion","","Morgen Feierstunde zum Rektoratswechsel an der Uni","U. W.",[1],7,[1],[2],2,"32","4"],["5114","1967-11-08","Der AStA der Uni Hamburg sowie jener der FU Berlin und der TU Aachen lehnen die Teilnahme am Bonner Festakt zum zehnjährigen Bestehen des Wissenschaftsrates ab, weil dieser entgegen der studentischen Interessen an der hierarchischen Struktur der Hochschulen festhalte.","AStA feiert in Bonn nicht mit","","","",[1],7,[1],[2],2,"32","5"],["5115","1967-11-09","Bei der Rektoratsfeier zur Einführung des neuen Hamburger Rektors Prof. Ehrlicher entrollte eine Gruppe von Studenten vor dem Zug der Professorenschaft ein Plakat mit der Aufschrift \"Unter den Talaren der Muff von 1000 Jahren\" (in der Berichterstattung ist von 100 Jahren die Rede). Die verschiedenen Reden wurden mit Beifall und Gezische begleitet. Der Hamburger AStA-Vorsitzende Pätzoldt habe erschreckende Details über die Situation an der Universität bekanntgegeben. Weiter erklärte er, wenn die Forderung nach studentischer Mitbestimmung nicht erfüllt werde, bliebe nur die Obstruktion und die Gründung einer Gegenuniversität.","Studenten schockieren die Professorenschaft/ Hamburger Studenten","","Ungewöhnliche Amtseinführung des neuen Rektors","",[1],7,[1],[1],2,"22","1,2"],["5116","1967-11-09","Der Ruf nach Hochschulreformen werde berechtigterweise von Tag zu Tag lauter, durch den hohen Zuwachs von Studenten sei die Einheit von Forschung und Lehre nicht mehr gewährleistet, die Leidtragenden seien die Studenten. Das alte Universitätsmodell sei überholt. Kritik an den Verantwortlichen, die seit vielen Jahren über Reformen reden, aber nichts umsetzen. Die Forderungen der Studenten nach Mitbestimmung und Abbau hierarchischer Ordnungen werden kurz vorgestellt. Die studentische Forderung nach Verbesserung der finanziellen Unterstützung sei zwar sehr umstritten, doch warum sollten nicht auch die Studenteneinkommen an die gehobenen Lebensverhältnisse angepasst werden?","Papas Universität hat sich überlebt","","Reformen sind überfällig/ Der Aufstand der Studenten","J. Hus.",[4],7,[5],[1],2,"22","2"],["5117","1967-11-09","Zur Störung der Rektoratsfeier an der Uni Hamburg. Deren Zeremoniell sei zu traditionell. Generell sei die Situation an den Hochschulen nicht mehr zeit- und zukunftsgemäß. Stellvertretend dafür wurde die Refktoratsübergabe gestört. Die Schärfe der studentischen Forderungen nach Mitbestimmung und Abbau von Hierarchien sowie nach kritischer Wissenschaft erkläre sich auch daraus, dass die Studenten seit Jahren auf die von ihnen gerügten Mißstände hinweisen, aber nie gehört werden. Zur Verwirklichung einer Gegenuniversität dürfe es aber nicht kommen, die Universität darf nicht weiter schlafen und müsse den Studenten entgegenkommen, die längst fälligen Folgerungen aus den studentischen Forderungen müssten gezogen werden.","Väter und Söhne","","","wmh",[1],7,[5],[2],2,"22","2"],["5118","1967-11-10","Im Bonner Bundeshaus verlief die erste Anhörung zur Notstandsgesetzgebung ohne die befürchteten Proteste. Gehört wurden vor allem Professoren, die sich mehrheitlich für eine Notstandsgesetzgebung ausgesprochen hätten, gegenüber dem Regierungsentwurf aber erhebliche Vorbehalte äußerten. Kurze Stellungnahmen von den Professoren Kogon, Abendroth, Ellwein, Bernhard, Schneider, Freund, Evers und Ridder.","Notstandsgesetze im Urteil der Professoren","","\"Hearing\" im Bonner Bundeshaus ohne Demonstration","w.st.",[9],7,[1],[2],2,"28","2"],["5119","1967-11-10","Weiter zur Störung der Rektoratsfeier an der Uni Hamburg. Es ist von den weitgehend berechtigten studentischen Forderungen die Rede. Eine studentische Urabstimmung soll klären, ob die Studentenschaft den neuen Rektor Ehrlicher \"auch als den ihren\" betrachtet. Schon vor der Rektoratsfeier sei es zu Ausschreitungen gekommen, als Polizisten ein SDS-Mitglied vorübergehend festgenommen hatten. Die von Studenten gewünschte Diskussion mit der Professorenschaft blieb aus, stattdessen diskutierten die Studenten unter sich über die Hochschulsituation. Es sei auch zu studentischen Äußerungen gekommen, die die Störung der Rektoratsfeier kritisierten und die Frage aufwarfen, ob eine radikale Minderheit für die Mehrheit sprechen dürfe. Längerer Auszug aus der Rede des Hamburger AStA-Vorsitzenden Pätzoldt über die Situation an der Hamburger Universität, inklusive der Androhung der Obstruktion und der Gründung einer Gegenuniversität, sollte die paritätische Mitbestimmung nicht kommen.","Der ungewöhnlichste Tag der Uni","","Leidenschaftliche Studenten-Diskussion nach der Feier des Rektoratswechsels","Ursula Weiner",[1],7,[1],[1],1,"28","10"],["5120","1967-11-11","Bericht über den vierten Tag im Prozess gegen Karl-Heinz Kurras. Erstmals hat ein Zeuge die Aussage Kurras, nach der dieser zwei Schüsse abgegeben habe, gestützt. Ein Schusswaffensachverständiger bezweifelt die Aussage. Ein anderer Zeuge will einen Studenten mit einem Messer gesehen haben. Das Urteil wird bereits in Kürze erwartet, vorher werden als Zeugen noch u. a. Prof. Gollwitzer und der damalige Regierende Bürgermeister Albertz vernommen.","Albertz und Gollwitzer Zeugen im Kurras-Prozess","","Urteil Ende nächster Woche/ Doch zwei Schüsse?","wy",[1],7,[1],[5],2,"62","2"],["5121","1967-11-13","Eröffnung der Universität Regensburg","Universität eröffnet","Bunte Welt","","",[4],7,[1],[2],2,"16","2"],["5122","1967-11-14","Studentenvertretungen von elf Hochschulen haben die Teilnahme zum zehnjährigen Jubiläum des Wissenschaftsrates abgelehnt. Begründet wird dies mit Favorisierung des hierarchischen Prinzips durch den Wissenschaftsrat, dies stehe gegen die Interessen der Mehrheit der Mitglieder der Uni, so auch gegen die Interessen der Studenten. Man wolle sich nicht als Dekoration mißbrauchen lasse. Zudem verfolge der Rat eine restriktive Bildungspolitik und fördere nicht die soziale Chancengleichheit und das allgemeine Recht auf Bildung. Der VDS will an der Veranstaltung teilnehmen, kritisiert aber ebenfalls die Politik des Rates.","\"Kein Anlass zum Feiern\"","","Studenten boykottieren Wissenschaftsrats-Jubiläum","",[1],7,[1],[2],2,"18","1"],["5123","1967-11-15","Vernehmung von Prof. Gollwitzer und dem früheren Regierenden Bürgermeister Albertz als Zeugen im Prozess gegen Karl-Heinz Kurras. Bis auf eine Frage wurden jedoch alle Fragen an die beiden Zeugen vom Verteidiger beanstandet, da sie für den Prozess nicht von Bedeutung seien.","Fragen ohne Bedeutung","","","",[1],7,[1],[2],1,"30","2"],["5124","1967-11-15","Der Rektor der Hamburger Universität, Prof. Ehrlicher, kündigt eine öffentliche Diskussion mit den Studenten über die Situation an der Universität an.","Rektor diskutiert heute mit Studenten","","","",[1],7,[1],[2],2,"30","3"],["5125","1967-11-16","Großer Andrang bei der Diskussion zwischen dem Hamburger Rektor Prof. Ehrlicher und den Studenten über die Hochschulsituation","Heiße Diskussion in der Universität","","","",[1],7,[1],[2],2,"24","1"],["5126","1967-11-16","Die Annäherung von Studenten und Professoren wird gefordert. Wenn auch die Studenten die Demokratisierung der Hochschulen manchmal zu laut fordern würden, so würde diese Forderung von der Professorenschaft zu leise kommen. Verständnis für diese Forderung der Studenten, die Professoren müssten sich den Gegebenheiten anpassen und dürften nicht überkommen Privilegien festhalten. Kritik an einem Professor, der während der Rektoratsfeier äußerte, die studentischen Störer gehören alle ins KZ.","Demokratisierung","","","wmh",[1],7,[5],[2],2,"24","2"],["5127","1967-11-16","Prof. Spuler gab zu, bei der Hamburger Rektoratsfeier gegenüber demonstrierenden Studenten den Ausspruch \"Ihr gehört alle ins KZ\" getätigt zu haben. Er habe sich in der Erregung der Situation dazu hinreißen lassen. Er beantragte ein Disziplinarverfahren gegen sich selbst. Kritik von Politkern aller Parteien an Prof. Spuler.","\"Ich habe mich in der Erregung hinreissen lassen\"","","Prof. Spuler gab schwerwiegendes Wort zu","thi.",[1],7,[1],[1],1,"24","3"],["5128","1967-11-16","Pressekonferenzen des neuen Hamburger Rektors Ehrlicher und des Hamburger AStA, die Rede ist von einem akademischen Stellungskrieg. Der Rektor sprach in Bezug auf die Rektoratsfeier davon, dass diese von zwei kleinen studentischen Gruppen terrorisiert worden sei. Anschließend Diskussion zwischen dem Rektor und der Studentenschaft. Diese sei sachlicher und besser als erwartet gewesen.","Trotz harter Fronten kam es zum Gespräch","Ein heißer Tag an der Hamburger Universität: Rektor und Studenten kämpften gestern um ihre Standpunkte","Pressekonferenzen und Diskussion","jh/ UW",[1],7,[1],[1],1,"24","4"],["5129","1967-11-17","Prof. Spuler, der Studenten zugerufen hatte, dass sie ins KZ gehören, wurde vorläufig suspendiert. Spuler bedauert nach eigenen Angaben seine Äußerung.","Professor Spuler suspendiert","","","thi.",[1],7,[1],[2],2,"32","1"],["5130","1967-11-17","Hamburgs Rektor Prof. Ehrlicher möchte künftig Diskussionen über die Studienreform nur noch auf Fakultätsebene abhalten.","Uni-Rektor: Diskussion nur in den Fakultäten","","","u. w.",[1],7,[1],[2],2,"32","1"],["5131","1967-11-17","Professoren der Uni Hamburg sowie der Rektor Prof. Ehrlicher verließen aus Protest die Diskussionsveranstaltung mit den Studenten über die Situation an der Hochschule. Anlass war ein Zwischenruf, in dem ein Professor als arrogant bezeichnet wurde. Zuvor sei die Diskussion sehr sachlich gewesen. Überblick über diese Diskussion. Erregte Diskussionen nach dem Auszug der Professorenschaft, die Forderung des SDS nach Abbruch aller Gespräche mit den Professoren wurde von der Studentenschaft niedergezischt. Der AStA distanzierte sich von der Bezeichnung \"arrogant\", kritisierte aber zugleich die Professorenschaft, dass sie dies als Anlass zum Abbruch der Diskussion genommen hat.","Gespräch endete mit dem Auszug der Professoren/ Professoren zogen demonstrativ aus","","Protest gegen Studenten-Zwischenruf","ga",[1],7,[1],[1],1,"32","3"],["5132","1967-11-17","Der Ausschuss für Schule und Universität will ein Anhörverfahren zum neuen Hochschulgesetz durchführen, obwohl der Gesetzentwurf an sich noch nicht ausgearbeitet wurde.","Anhörverfahren zum Hochschulgesetz","","","",[4],7,[1],[2],2,"32","6"],["5133","1967-11-18","Im Prozeß gegen Karl-Heinz Kurras hat der Generalstaatsanwalt eine Gefängnisstrafe von acht Monaten auf Bewährung beantragt. Kurras könne den Schuß, der zur Tötung von Benno Ohnesorg führte, nicht in Notwehr abgegeben haben. Der Verteidiger plädierte dagegen auf Freispruch.","Acht Monate Gefängnis für Kurras beantragt","","\"Keine Notwehr\"/ Verteidigung verlangt Freispruch","wy",[1],7,[1],[2],2,"60","2"],["5134","1967-11-18","Vollversammlung der Studenten der Uni Hamburg im Audimax. In einer Urabstimmung wollen die Studenten entscheiden, ob Rektor Ehrlicher für sie als Rektor aktzeptabel sei. Von einem Misstrauensantrag gegen ihn wurde Abstand genommen. U.a. wird der Numerus Clausus abgelehnt und die Kritische Universität gebilligt. Großer Rückhalt für den AStA. Der Akademische Senat hat die studentischen Angelegenheiten auf seiner letzten Sitzung von der Tagesordnung genommen. Begründet wird dies damit, dass der AStA sich nicht vollends von den Vorfällen während der Rektoratsübergabe distanziere.","Studenten-Vollversammlung steht hinter dem AStA","","Diskussionen und Beschlüsse im Audimax/ 2000 erschienen","U. W./ ff",[1],7,[1],[1],1,"60","4"],["5135","1967-11-21","Das Urteil im Prozess gegen Karl-Heinz Kurras wird erwartet. Kurzer Überblick über den Prozessverlauf, dieser habe kein klares Bild vom Ablauf der Geschehnisse geben können.","Heute Kurras-Urteil","","Berlin: Zeugenaussagen brachten keine Klärung","",[1],7,[1],[2],2,"30","1"],["5136","1967-11-23","Heftige Kritik der Berliner Studentenschaft am Freispruch von Karl-Heinz Kurras. Dieses Urteil sei eine \"Unterstützung der polizeilichen Terrorakte\", so der AStA der FU Berlin.","Kurras-Freispruch löst heftige Kritik aus","","","wy",[1],7,[1],[2],2,"20","2"],["5137","1967-11-24","Karl-Heinz Kurras bleibt trotz seines Freispruchs beurlaubt, da von seiten der Staatsanwaltschaft Revision gegen das Urteil eingelegt worden war und Kurras zudem das Disziplinarverfahren gegen sich abwarten muss. Die FDP fordert die Entfernung Kurras' aus dem Polizeidienst.","Kurras bleibt beurlaubt","","","",[1],7,[1],[3],2,"30","2"],["5138","1967-11-24","Mit \"tumultartigen Szenen\" haben Studenten des SDS und des LSD versucht, die 581-Jahrfeier der Universität Heidelberg zu stören.","Neue Störaktion","Bunte Welt","","",[1],7,[1],[2],2,"30","2"],["5139","1967-11-25","Der Rektor der Frankfurter Uni verhängte ein Hausverbot für den SDS. Prof. Ruegg bezichtigte den SDS faschistischer Methoden, der SDS will deshalb Strafanzeige erstatten. Die Rektoratsübergabe an der TU Berlin wurde von Studenten mit Zwischenrufen und Eierwürfen gestört. Eine Rede von Berlins Regierendem Bürgermeister Schütz wurde gestört. Bei der Rektoratsübergabe waren die Professoren erstmals nicht in den Talaren erschienen. Weitere Veranstaltung des SHB in der Kirchlichen Hochschule Berlins mit Bürgermeister Schütz. Auch hier kam es zu massiven Störungen, zum Schluß ertönte der Ruf \"Alle macht den Räten, brecht dem Schütz die Gräten\". An der FU haben Studenten eine Veranstaltung des NHB gestürmt.","Radikale Studenten machen Front gegen Klaus Schütz","","Tumulte an Berlins Hochschulen/ SDS in Frankfurt gerügt","wy",[1],7,[1],[1],1,"58","2"],["5140","1967-11-25","Diskussion im Hamburger Audimax über die Studentenunruhen. Unter den Podiumsteilnehmern befanden sich Rudi Dutschke, Rolf Dahrendorf und Rudolf Augstein. Die Veranstaltung unter dem Motto \"Revolution 1967 - Studentenulk oder Notwendigkeit?\" sei vom Inhalt her enttäuschend gewesen, verlief aber ohne Störungen. Dutschke wird als \"Revoluzzer gegen alles Bestehende\" bezeichnet. Für Dahrendorf liegt die Studentenunruhe begründet in der Situation an den Hochschulen, für Dutschke ist sie dagegen Ausdruck einer erstarrten gesellschaftlichen Formel. Dutschke forderte die Selbstbefreiung des Menschen und kritisierte die Parteien, diese seien unfähig, einen Dialog mit dem Volk zu führen. Jens Litten vom SHB nennt konkrete Forderungen für Veränderungen an der Universität.","\"Linksaußen\" Dutschke kam im Klassenkampfpullover","","\"Revolution\" der Studenten/ Große Diskussion im Audimax","jh/ ff",[1],7,[1],[1],1,"58","5"],["5141","1967-11-25","Stellungnahme des Hamburger CDU-Abgeordneten de Chapeaurouge zum geplanten Hochschulgesetz","CDU-Fraktion: Gegensätze in der Uni abbauen","","","Alfred de Chapeaurouge",[4],7,[1],[2],2,"58","5"],["5142","1967-11-25","An der FU Berlin würden sich erstmals Studenten gegen ihre linksgerichteten Kommilitonen wenden. Für die bevorstehenden Wahlen zum Studentenparlament haben sich hierfür die \"Vereinigten Arbeitsgemeinschaften an der FU\" (VAFU) gebildet. Diese greifen den AStA scharf an. Für einen Sitz im Studentenparlament sind insgesamt 219 Kandidaten angetreten, fast 100 mehr als im Vorjahr.","Studenten setzen sich zur Wehr","","Gegen linksgerichtete Aktionen","wy",[1],7,[1],[2],2,"58","51"],["5143","1967-11-27","Beginn des Prozesses gegen Fritz Teufel wegen des Vorwurfs des schweren Landfriedensbruchs am 2. Juni 1967. ","Landgerichtsdirektor warnte die Zuhörer","","Teufel-Prozeß begann mit Polizei-Aufgebot","wy",[5],7,[1],[5],2,"22","2"],["5144","1967-11-28","Ungenehmigte Demonstration für die Freilassung von Fritz Teufel vor dem Moabiter Gericht. Die Polizei ging mit Wasserwerfern gegen die Demonstranten vor, es kam zu schweren Schlägereien. Besonders aktiv soll Rudi Dutschke gewesen sein. 14 Demonstranten wurden festgenommen. Der Prozess an sich verlief ohne Störungen, Teufel streitet die Vorwürfe ab. Vor dem Gericht ertönen Sprechchöre wie \"Teufel raus, Springer rein\".","Tumulte um Fritz Teufel","","Mit Wasserwerfern gegen Demonstranten/ Erster Prozeßtag","wy",[5],7,[1],[1],1,"22","15"],["5145","1967-11-29","Wegen der Beteiligung an der ungenehmigten Demonstration für die Freilassung Fritz Teufels vor dem Moabiter Gericht läuft gegen Rudi Dutschke ein Ermittlungsverfahren wegen des Verdachts auf schweren Landfriedensbruchs.","Ermittlungsverfahren gegen Dutschke","","","",[1],7,[1],[2],2,"30","1"],["5146","1967-11-29","Prof. Ortlieb, Direktor des Hamburger Weltwirtschaftsarchiv, fordert mehr Mitspracherecht der Studentenvertretungen.","Mehr Rechte für Studenten","","","",[4],7,[1],[2],2,"30","3"],["5147","1967-11-29","Leserbrief eines Hamburger Studenten. Seiner Meinung entstehe durch die Berichterstattung des Hamburger Abendblattes der Eindruck, die Mehrheit der Studenten sei für jene Art des Protests, wie er bei Rektoratsübergabe praktiziert wurde. Dies wäre jedoch nicht der Fall. Kritik am Akademischen Senat, weil dieser die Gespräche mit dem AStA abgebrochen hat","Um die Studienreform","Briefe an das Hamburger Abendblatt","","Leser",[4],7,[6],[2],2,"30","13"],["5148","1967-11-30","Erste Gespräche auf Fakultätsebene zwischen Studenten- und Professorenschaft über die Situation an der Hamburger Universität. Zwischen dem AStA und dem Rektor wehe dagegen der Wind des \"Kalten Krieges\". Offener Brief des AStA an den Rektor, in diesem wird Auslassung der studentischen Angelegenheiten auf der letzten Sitzung des Akademischen Senats kritisiert. In der Wirtschafts- und Sozialwissenschaftlichen Fakultät sei die Diskussion erfreulich sachlich gewesen. Auch die Diskussion der Medizinstudenten verlief sachlich und erfreulich.","In den Fakultäten beginnen jetzt faire Diskussionen","","Offener Brief des AStA an den Rektor","uw./ wr.",[1],7,[1],[5],1,"28","3,4"],["5149","1967-12-01","Der Rektor der Universität Hamburg, Prof. Ehrlicher, beantwortet den Offenen Brief des AStA. Grundsätzlich begrüßt er dessen Inhalt und ist auch zu Gesprächen bereit. Das es zu Verzögerungen von Reformen gekommen ist, läge vor allem daran, dass die Studenten ihre Forderungen immer an die Professorenschaft richte anstatt an die Politik. Zudem habe die Form, in der diese Forderungen vorgetragen wurden, eine sachliche Zusammenarbeit erschwert, weshalb er auf der letzten Sitzung des Akademischen Senats die studentischen Angelegenheiten von der Tagesordnung gestrichen habe, diese würden jedoch auf der nächsten Sitzung behandelt werden,","Rektor antwortet auf Offenen Brief","","Zum Gespräch mit dem AStA bereit","",[1],7,[1],[1],1,"44","9"],["5150","1967-12-02","Foto von Fritz Teufel nach seiner Haftentlassung, auf dem Kopf trägt er einen Adventskranz","Tötet Lächerlichkeit nicht mehr?","","","",[5],7,[1],[3],1,"58","1"],["5151","1967-12-05","Diskussionsveranstaltung in der Hamburger Universität über die Kürzung des Etats für politische Bildung. Schwere Kritik von Studenten, Professoren und Politikern der CDU an der Kürzung. Es seien zu wenig Studenten zu der Diskussion erschienen, das Interesse an der politischen Bildungsarbeit lasse zu wünschen übrig.","Studenten: Mehr Geld für politische Bildung","","Protest gegen vorgesehene 22,5prozentige Etatkürzung","UW",[4],7,[1],[5],2,"20","5"],["5152","1967-12-06","Rektor Ehrlicher von der Universität Hamburg fordert 102 weitere Planstellen für wissenschaftliches Personal. Schulsenator Drexelius sieht für die Realisierung der Forderung keine Chance.","Universität fordert 102 weitere Planstellen","","","U.W.",[4],7,[1],[2],2,"28","1"],["5153","1967-12-06","Rektor Ehrlicher von der Universität Hamburg fordert 102 weitere Planstellen für wissenschaftliches Personal. Schulsenator Drexelius sieht für die Realisierung der Forderung keine Chance (ausführlichere Version des Berichts).","Universität fordert über hundert weitere Planstellen","","Senator Drexelius verweist auf die schlechte Finanzlage","",[4],7,[1],[2],2,"28","3"],["5154","1967-12-07","Frankfurter Studenten blockierten mittels eines sit-ins die Räumlichkeiten vor der Sitzung des satzungsgebenden Konzils der Frankfurter Uni. Die Studenten fordern mit ihrer Aktion die paritätische Besetzung aller Gremien.","Die Professoren mussten klettern","","","",[1],7,[1],[3],1,"26","1"],["5155","1967-12-07","Stellungnahme des Hamburger FDP-Abgeordneten Frankenfeld zum geplanten Hochschulgesetz.","Entweder Reform oder Revolution","","FDP-Abgeordneter nimmt Stellung zum geplanten Hamburger Hochschulgesetz","Alfred Frankenfeld",[4],7,[1],[3],2,"26","7"],["5156","1967-12-08","Bei den Wahlen zum Münchner Studentenparlament hat die Münchner Studenten-Union 25 der 51 Sitze errungen. Sie besteht aus Vertretern des RCDS und der Katholischen Studentengruppen. Die Wahlgemeinschaft von SDS, SHB und LSD errang dagegen nur noch zehn Sitze","Studentische Linke verlor Stimmen","","","",[4],7,[1],[3],2,"32","1"],["5157","1967-12-08","Etliche Studenten forderten mit Transparenten und Sprechchören eine Entschuldigung von Prof. Wenke bei dem Studenten Reinhold Oberlercher, \"Starfunktionär des Hamburger SDS\", weil er diesen aus seinem Hauptseminar gewiesen hatte. Wenke sagte seine Vorlesung im Audimax der Uni Hamburg daraufhin ab. Vorausgegangen war dem eine Vorlesungsrezension Oberlerchers in der Studentenzeitschrift Auditorium über das Seminar Wenkes. Der AStA stellt sich vor Oberlercher. Auseinandersetzungen zwischen Studenten über diesen Vorfall, Kritik an der Form von Oberlerchers Rezension. Dieser hatte Wenke u.a. als Rattenfänger und \"alternden Ideologen des pädagogischen Hitlerismus\" bezeichnet. Zudem hatte er zur Sprengung der Veranstaltung aufgerufen.","Wieder wurde das Audimax zum brodelnden Kessel","","Handfester Krach zwischen Professor Wenke und Studenten","Ursula Weiner",[1],7,[1],[1],1,"32","4"],["5158","1967-12-08","Zum Wenke-Oberlercher-Fall. Grundsätzlich seien Vorlesungsrezensionen \"ein positiver Beitrag zum Abbau der patriarchalischen Struktur unserer Universitäten\", Kritik jedoch an Oberlerchers Rezension, diese vergifte die Atmosphäre an der Uni weiter. Kritik auch an Prof. Wenke für den Rauswurf Oberlerchers aus seinem Seminar, dies hätten andere Organe entscheiden sollen.","Kritik und Spielregeln","","","hu",[1],7,[5],[2],2,"32","4"],["5159","1967-12-08","Über den Verlauf der Wahlen zum Studentenparlament der FU Berlin, Aussagen über die Ergebnisse seien noch nicht möglich. Rudi Dutschke wird als \"roter Rudi\" beschrieben, der anarchistische und leninistische Thesen mit gewissen urchristlichen Vorstellungen zu einem utopischen Programm verbinde, dass die bolschewistische Heilslehre noch weiter links zu überholen versuche. Aufzählung der Forderungen Dutschkes. Der SDS habe an der FU etwa 100 Mitglieder, in Hamburg etwa 40. Dutschke erklärte, dass er für seine politische Arbeit Spenden bekomme.","Heute wählt Berlins Freie Universität","","Dutschke linker als links","",[1],7,[1],[2],2,"32","19"],["5160","1967-12-11","Ausgang der Wahlen zum Studentenparlament an der FU Berlin. Die studentische Linke habe die Wahl knapp gewonnen und 40 der 76 Sitze errungen, die Opposition habe jedoch deutlich dazugewonnen. Der SDS steigerte seine Fraktionsstärke von 7 Sitzen auf 16 zu Kosten des SHB. Die Wahlbeteiligung lag bei etwa 67 Prozent.","Stärkere Opposition","","","wy",[4],7,[1],[3],2,"16","2"],["5161","1967-12-11","Nach Ansicht des Bundesinnenministeriums ist die Überwachung des SDS durch den Verfassungsschutz rechtmäßig, da dessen Tätigkeit auf den Sturz der verfassungsmäßigen Ordnung gerichtet sei. Die SPD kritisiert dagegen die Anwerbung von Vertrauensleuten des Verfassungsschutzes innerhalb der Studentenschaft als verfassungsrechtlich äußerst bedenklich.","SDS-Überwachung \"rechtmäßig\"","","","r. st.",[8],7,[1],[2],2,"16","6"],["5162","1967-12-12","Prof Thielicke verteidigt seinen Kollegen Prof. Wenke für den Rauswurf Oberlerchers aus dessen Seminar. An Stelle seiner Vorlesung hielt er eine Verteidigungsrede für Wenke. Thielicke wolle damit deutlich machen, dass er am Gesamtverhalten der Studenten verzweifle.","\"Ich verzweifle am Verhalten der Studenten\"","","Prof. Thielicke stellt sich vor Prof. Wenke","U. W.",[1],7,[1],[2],1,"16","1"],["5163","1967-12-12","Fortsetzung des Artikels aus Datensatz 5162, Verteidigung von Prof. Wenke durch Prof. Thielicke. Thielicke spricht in Bezug auf den Artikel von Oberlercher von psychopathischen Zügen. Was ihn verzweifeln ließe, sei die Masse der Studenten, die sich nicht gegen die neue \"Oligarchie der Funktionäre\" auflehne. Er vergleicht die Unruhen mit dem Nationalsozialismus, es nur eine andere Färbung.","Thielicke: Auch damals fing es mit Terror an","","","U. W.",[1],7,[1],[1],2,"16","3"],["5164","1967-12-13","Die Auseinandersetzung zwischen Reinhold Oberlercher und Prof. Wenke ziehe immer weitere Kreise. Zur Solidaritätserklärung für Wenke durch Prof. Thielicke äußerten sich mehrere Vertreter der Universität.","Die Diskussion reist nicht ab","","","U. W.",[1],7,[1],[2],2,"27","1"],["5165","1967-12-13","Mehrere Stellungnahmen zur Solidaritätserklärung Prof. Thielickes mit Prof. Wenke, längere Auszüge daraus. Schwere Kritik vom AStA an der Erklärung, wie auch vom SDS und den Fachschaftsleitern. Die Assistenten Wenkes verteidigen dagegen dessen Entscheidung.","Im Streit um Oberlercher verhärten sich die Fronten","","Kritische Stellungnahmen zu Prof. Thielickes Erklärung","U. W.",[1],7,[1],[1],2,"27","5"],["5166","1967-12-14","Das Deutsche Industrieinstitut hat dem SDS vorgeworfen, er wolle durch Revolution die bestehende kapitalistischen Wirtschafts- und Gesellschaftsordnung stürzen. Der SDS wiederum protestierte gegen die \"Bespitzelung und Diffamierung\" des SDS durch das Bundesinnenministerium.","Industrieinstitut: SDS will Revolution","","","",[8],7,[1],[2],2,"24","2"],["5167","1967-12-14","Mehrere tausend Studenten protestierten in Gießen gegen die Verurteilung ihres südkoreanischen Kommilitonen Chong Gil Choe in Seoul zu 15 Jahren Gefängnis. Dieser war zuvor von der südkoreanischen Geheimpolizei aus Deutschland entführt worden. Die Gießener Studenten fordern die Bundesrepublik auf, die Beziehungen die zu Südkorea abzubrechen.","Demo in Gießen","","","",[1],7,[1],[2],1,"24","10"],["5168","1967-12-15","Der AStA der Universität Hamburg ruft die Hamburger Studenten zur Mäßigung auf und bietet sie, von allen Aktionen gegen die Sitzung des Akademischen Senats abzusehen.","AStA-Aufruf zur Mäßigung","","","U. W.",[1],7,[1],[2],2,"34","1"],["5169","1967-12-15","Der Hamburger AStA wäre beinahe vom Studentenparlament gestürzt worden. Man warf ihm Konzeptionslosigkeit vor und mißbilligte seinen Aufruf zur Mäßigung. Bericht über die letzte Vorlesung von Prof. Wenke, als Reinhold Oberlercher erschien, begann ein Tumult, Wenke brach die Vorlesung ab. Wenke sprach von der \"Diktatur der Minderheit\" und fragte, ob niemand Willens sei, dem Einhalt zu gebieten. Das Studentenparlament beschloss in seiner Sitzung, Prof. Wenke solange zu Diskussionen über den Fall Oberlercher aufzufordern, bis dieser dazu bereit sei. Der AStA stellte daraufhin die Vertrauensfrage, er wurde im Amt bestätigt.","Der AStA um ein Haar gestürzt - Prof. Wenke brach die Vorlesung ab","","Björn Pätzoldt rief zur Mäßigung auf","U. W./ ff",[1],7,[1],[1],1,"34","3"],["5170","1967-12-15","Interview mit dem Hamburger Rektor Prof. Ehrlicher über die jüngsten Unruhen an der Uni Hamburg. Ehrlicher verteidigt Prof. Wenke für den Rauswurf Oberlerchers aus dessen Seminar. Die Gespräche mit dem AStA ruhen generell, Ehrlicher bedaure dies. Sachliche Vorlesungskritik würde er akzeptieren. Ehrlicher hält den \"Kreis der Krawallmacher\" für klein, er wisse aber nicht, wie weit der AStA noch unabhängig arbeiten könne. Er macht sich Sorgen um die Universität. Innerhalb der Professorenschaft sei die Einstellung zu den Unruhen geteilt, doch auch Professoren, die sich für die Studenten einsetzten, würden sich mittlerweile zunehmend verprellt fühlen.","Was sagt der Rektor zur neuen Situation?","","Interview mit Prof. Dr. Werner Ehrlicher","Ursula Weiner",[1],7,[1],[5],1,"34","3"],["5171","1967-12-16","Der Akademische Senat der Uni Hamburg hat die Bildung einer Kommission zur Hochschulreform beschlossen. In ihr sollen Professoren und Studenten gleichberechtigt vertreten sein. Außerdem wurde die Einleitung eines Disziplinarverfahrens gegen Reinhold Oberlercher beschlossen. Zu den befürchteten Störungen der Sitzung des Akademischen Senats kam es nicht.","Studenten und Dozenten an einem Tisch","","Gemeinsam an die Reform","ff.",[1],7,[1],[2],2,"46","1"],["5172","1967-12-16","Über die Studentenunruhen. Diese seien Ausdruck der Stimme einer neuen Generation, die den Schritt in die Zukunft unbelastet von der Vergangenheit tun will. Kritik jedoch an den jüngsten \"Exzessen\", die dienen dieser Sache nicht. Es ist die Rede von der Terrorisierung der maßvollen Mehrheit durch die extremistische Minderheit.","Besonnenheit!","","","wmh",[1],7,[5],[2],2,"46","2"],["5173","1967-12-16","Der Akademische Senat der Uni Hamburg hat die Bildung einer Kommission zur Hochschulreform beschlossen. In ihr sollen Professoren und Studenten gleichberechtigt vertreten sein (ausführlicherer Artikel). Studenten hatten zuvor zu einem Marsch gegen den Akademischen Senat aufgerufen, dieser war jedoch auf einen anderen Ort ausgewichen. Einleitung eines Disziplinarverfahrens gegen Reinhold Oberlercher. Auch Schulsenator Drexelius billigt den Rauswurf Oberlerchers aus dem Seminar von Prof. Wenke. Die Vertreter des AStA, Pätzoldt und Jankowski, zeigten sich zufrieden mit der Sitzung des Akademischen Senats und verurteilten die Ausschreitungen einer \"radikalisierten Minderheit\". Mit deren Studenten sei jede Basis für eine weitere Zusammenarbeit zerbrochen.","AStA und Dozenten einig: Gemeinsam an die Reform","","Akademischer Senat tagte im \"Bücherturm\"/ Wieder Krawall","ff.",[1],7,[1],[1],1,"46","3"],["5174","1967-12-18","Die Professoren der Philosophischen Fakultät erklärten sich mit Prof. Wenke bzgl. seines Rauswurfes von Reinhold Oberlercher solidarisch.","Philosophie-Professoren mit Wenke solidarisch","","","U. W.",[1],7,[1],[2],2,"16","1"],["5175","1967-12-18","Bundesforschungsminister Stoltenberg begrüßt die Unruhe unter den Studenten. Die Politiker hätten sich in den letzten Jahren wiederholt über mangelndes politisches Interesse der Studenten beschwert, deshalb solle man das jetzige Interesse begrüßen, auch wenn sie viele Äußerungen inhaltlich nicht überzeugen würde.","Stoltenberg begrüßt Unruhe unter Studenten","","","",[1],7,[1],[3],2,"16","2"],["5176","1967-12-20","Demonstrierende Studenten haben Fensterscheiben des Berliner Amerika-Hauses eingeworfen. Zuvor hatte man vor der griechischen Militärmission protestiert. Berlins Regierender Bürgermeister Schütz stellte sich einer Diskussionin der FU Berlin mit 2000 Studenten, er wurde verbal und via Plakaten scharf angegriffen.","Studenten warfen Fensterscheiben ein","","","wy",[1],7,[1],[2],2,"24","1"],["5177","1967-12-21","Gesetzesentwurf der Hamburger Jungen Union für eine Hochschulreform. Im Zentrum steht der Bruch mit der Rektoratsverfassung hin zu einer Präsidialverfassung.","Präsident statt Rektor","","","U. W.",[4],7,[1],[2],2,"20","1"],["5178","1967-12-21","Berlins Regierender Bürgermeister Schütz hat sich bei dem amerikanischen Stadtkommandanten Berlins für die Steinwürfe auf das Amerika-Haus entschuldigt. Auch zu den Beleidigungen gegen seine Person während einer Diskussionsveranstaltung in der FU Berlin nahm er Stellung. Solange in der Uni keine Ordnung herrsche, werde er diese nicht wieder betreten.","\"Steine sind keine Argumente\"","","","wy",[1],7,[1],[2],2,"20","2"],["5179","1967-12-21","Gesetzesentwurf der Hamburger Jungen Union für eine Hochschulreform. Im Zentrum steht der Bruch mit der Rektoratsverfassung hin zu einer Präsidialverfassung. (ausführlicherer Artikel)","Präsident statt Rektor an der Spitze der Uni","","\"Junge Union\" legt Entwurf zur Hochschulreform vor","U. W.",[4],7,[1],[2],1,"20","5"],["5180","1967-12-22","Fritz Teufel wurde vom Vorwurf des schweren Landfriedensbruchs freigesprochen.","Teufel freigesprochen","","","wy",[5],7,[1],[2],2,"20","1"],["5181","1967-12-27","Mehrere Studenten, unter ihnen Rudi Dutschke, haben den Gottesdienst am 24.12.1967 in der Berliner Kaiser-Wilhelm-Gedächtniskirche gestört. Man wollte so gegen die amerikanische Politik in Vietnam protestieren. Es kam zu Auseinandersetzungen mit Gemeindemitgliedern, Dutschke wurde dabei so von einem Krückstock getroffen, dass er eine Platzwunde am Kopf davon trug. Gegen Dutschke wurde Strafanzeige wegen Hausfriedensbruchs gestellt. Unterschiedliche Darstellungen über den Verlauf der Ereignisse, während die Gemeindemitglieder sagen, erst handgreiflich geworden zu sein, nachdem man die Demonstranten wiederholt zum Verlassen des Gebäudes aufgefordert hatte, widerspricht Dutschke dem. Dutschke widerspricht zudem Darstellungen, nach denen er unter Alkoholeinfluss gestanden habe.","Anzeige gegen Dutschke wegen Hausfriedensbruch?","","Weihnachtsgottesdienst gestört/ Widersprüche","wy.",[3,2],7,[1],[3],2,"24","2"],["5182","1967-12-27","Die Oldenburger SPD hat einen \"Universitätsplan der SPD\" entworfen und allen an einer nordwestdeutschen Hochschulgründung interessierten zugeschickt. Demnach solle mit der Bremer SPD Einigkeit darin bestehen, eine Schwerpunkt-Universität in Oldenburg zu gründen. Die Bremer SPD wies dies scharf zurück.","Universitätsplan der SPD","","","er.",[4],7,[1],[2],2,"24","2"],["5183","1967-12-29","Eine ausführliche Stellungnahme von Hamburgs Innensenator Heinz Ruhnau zu den Studentenunruhen. Die Unruhen seien Ausdruck eines Generationenwechsels. Dies rechtfertige aber nicht die Verletzung bestimmter Regeln. Die APO sei nicht nur legal, sondern auch notwendig. Ruhnau ist gegen ein Verbot des SDS. Die Krawalle einer Minderheit würden zu einer Denunziation der Studenten führen sowie zu einem Anwachsen des Rechtsextremismus. Die Gefahr von rechts sei viel größer als von links. Drei Forderungen Ruhnaus, um dem zu begegnen: Das Gespräch mit der Jugend suchen, diesen frühzeitig mehr Verantwortung geben sowie die Hochschulreformen umsetzen.","Die unruhige Jugend","","","Heinz Ruhnau",[1],7,[1],[1],1,"26","13"],["5184","1967-12-30","Die Hamburger Schulbehörde hat die Dienstaufsichtsbeschwerde des AStA der Uni Hamburg gegen Prof. Wenke wegen dessen Rauswurf von Reinhold Oberlercher aus seinem Seminar zurückgewiesen. Wenke habe das ihm zustehende Hausrecht wahrgenommen, er sei dazu verpflichtet darauf zu achten, dass seine Lehrveranstaltungen störungsfrei verliefen. Sollten erneut Veranstaltungen Wenkes wegen Störungen ausfallen, müsse dies künftig als Hausfriedensbruch gewertet werden.","Behörde: Prof. Wenke hat das Hausrecht","","AStA abgewiesen","U. W.",[1],7,[1],[2],2,"36","9"],["5185","1968-01-02","Bei einer Veranstaltung mit Kommunarden und SDS-Leuten fordert Peter Brandt zum Widerstand gegen die autoritäre Lehrerschaft auf","Aufforderung zum Boykott","","","",[9],7,[1],[3],1,"18","2"],["5186","1968-01-02","SDS und Humanistische Studentenunion drohen, Scheiben einzuwerfen, wenn Rudi Dutschke nicht im Kurhaus Baden-Baden auftreten darf.","Scheiben sollen klirren","Bunte Welt","","",[8],7,[1],[2],2,"18","2"],["5187","1968-01-02","40 Demonstranten haben einen Gottesdienst in der Berliner Kaiser-Wilhelm-Gedächtniskirche gestört.","Studenten störten Silvestergottesdienst","","","wy",[3],7,[1],[2],2,"18","2"],["5188","1968-01-04","Ankündigung einer von Studenten erarbeiteten Ausstellung über die UNESCO im Audimax.","\"UNESCO\"-Ausstellung ab Montag im Audimax","","","",[11],7,[1],[2],2,"20","4"],["5189","1968-01-04","Rektor der Uni kündigt in einem Aushang an, Störungen des Lehrbetriebes nicht mehr hinnehmen zu wollen. Sein Verweis auf das Hausrecht wird als Angriff interpretiert.","Jetzt Streit an der Uni um Rektor-Aufruf","","","ga.",[11],7,[1],[2],2,"20","4"],["5190","1968-01-05","Schulsenator Drexelius äußert sich zu Unruhen um Professor Wenke. Will sich vom AStA keine Diskussionen aufdrängen lassen.","\"Universität soll ihre Angelegenheiten regeln\"","","","U.W.",[11],7,[1],[2],2,"30","1"],["5191","1968-01-05","Aus Angst vor einer Saalschlacht mit dem NHB wird in der Uni Hamburg das Audimax vorübergehend geschlossen. Studenten diskutieren unter freiem Himmel.","Der Rektor schloss das Audimax","","Furcht vor Schlägerei","Ursula Weiner",[11],7,[1],[1],1,"30","3"],["5192","1968-01-06","Rücktritt des Kutusministers gefordert, weil dieser an der Möglichkeit von Exmatrikulationen festhalten will.","Kieler AStA fordert Rücktritt Heydebrecks","","","dpa",[11],7,[1],[2],1,"54","2"],["5193","1968-01-06","In einer Pressekonferenz äußert sich der Hamburger AStA zum Stand der Hochschulreform. Außerdem fordert er den Rücktritt des Polizeidirektors wegen des Vorgehens der Polizei beim Besuch des Schah. ","\"Leddin soll zurücktreten\"","","Forderung des AStA - Senator Ruhnau: Polizeidirektor bleibt","",[7],7,[1],[3],2,"54","4"],["5194","1968-01-08","Teufel und Kunzelmann festgenommen, weil sie die Anfahrt der Gäste des Berliner Juristenballs mit Knallkörpern gestört haben.","Teufel war wieder dabei","","","wy",[5],7,[1],[2],2,"16","2"],["5195","1968-01-08","Harburger Pastor kritisiert in einer Predigt die Aufregung der KWG-Gemeinde in Berlin nach Gottesdienststörung durch Demonstranten als Zeichen verstaubter Bürgerlichkeit. Er wendet sich gegen Tätlichkeiten.","\"Ich verstehe die Aufregung nicht\"","","Diskussion über Zwischenfälle beim Gottesdienst","lie",[3],7,[1],[3],1,"16","5"],["5196","1968-01-09","Neun namentlich genannte Hamburger Professoren machen Reformvorschläge.","Hamburg: Professoren machen Vorschläge zur Hochschulreform","","","U.W.",[4],7,[1],[2],2,"16","1"],["5197","1968-01-09","Chef der Rektorenkonferenz kritisiert Staat, Parteien und Öffentlichkeit wegen deren Indifferenz zu politischen Studentengruppen.","Prof. Rüegg übt harte Kritik","","","dpa",[1],7,[1],[2],2,"16","1"],["5198","1968-01-09","Parallel zu den Uniwahlen wollen Studenten über ihr Verhältnis zu Prof Wenke abstimmen. Er hatte z. B. kürzlich das Audimax sperren lassen.","Studenten stimmen über ihren Rektor ab","","Ende Januar - Professor Wenke will wieder lesen","U.W., ff.",[11],7,[1],[2],2,"16","7"],["5199","1968-01-10","Westdeutsche Rektorenkonferenz stellt ihre \"Godesberger Rektoren-Erklärung zur Hochschulreform\" vor.","Ein Programm für die Universität von morgen","","Rektoren legen Reformpläne vor - Demokratisierung gefordert","dpa, ap, upi",[4],7,[1],[1],2,"26","2"],["5200","1968-01-10","Schleswig-Holsteinischer Kultusminister will zum Thema Zwangsexmatrikulationen mit aufgebrachten Studenten reden.","Kieler Studenten drohen mit Streik","","Heydebreck für Aussprache uber Exmatrikulation","fa.",[11],7,[1],[5],2,"26","9"],["5201","1968-01-11","AStA-Chef vom RCDS durch einen vom SHB ersetzt. Heydebreck setzt Erlass zur Exmatrikulation aus.","Linksrutsch an der Kieler Universität","","Alter AStA gestürzt - Heydebreck machte Rückzieher","fa.",[11],7,[1],[3],1,"20","1"],["5202","1968-01-11","Uni Düsseldorf soll von 1200 auf 6000 Studenten ausgebaut werden.","Uni wird erweitert","Bunte Welt","","",[11],7,[1],[2],2,"20","2"],["5203","1968-01-11","AStA-Antrag angenommen, in dem es heißt, dass Schulsenator Drexelius nicht das Vertrauen der Hamburger Studenten besitzt. Drexelius nicht bereit, vor den Studenten zu reden. Dazu eine Karikatur, in der ein Dozent von Stacheldraht und in einem Verschlag geschützt lehrt.","Studenten fordern: Der Schulsenator soll zurücktreten","","Dreistündige Debatte im Audimax","U.W.",[1],7,[1,5,4],[1],1,"20","4"],["5204","1968-01-11","Vorstellung der neuen medizinischen Hochschule Hannover als ideale Universität der Zukunft.","Reform-Hochschule in Hannover","","Ideales Studium für 1000 Mediziner angestrebt","R.St.",[4],7,[1],[5],2,"20","13"],["5205","1968-01-12","Fortschrittliche Leitsätze zu einer Hochschulreform von Hamburger Professoren decken sich vielfach mit Studentenwünschen.","81 Leitsätze zur Reform der Universität","","","U.W.",[4],7,[1],[2],2,"24","1"],["5206","1968-01-12","Eckpunkte der Professoren-Vorschläge in Kurzform","Professoren präsentierten ihre 81 Reformleitsätze","","Basis für Hochschulgesetz - Ohne amtlichen Auftrag","",[4],7,[1],[5],1,"24","3,6"],["5207","1968-01-12","Störer verhindern Vorlesung von Professor Wenke im Audimax. SDS-Mann Oberlercher einer der Wortführer.","Prof. Wenke resignierte","","","ff",[1],7,[1],[2],2,"24","6"],["5208","1968-01-12","Hans Heigert von Report München nutzt die Verleihung der Goldenen Kamera im Berliner Springer-Haus, um über die Funktion von Kritik für den freiheitlichen Rechtsstaat zu sprechen. Ausdrücklich erwähnt werden die Studenten nicht.","\"Ohne Kritik keine Demokratie\"","","Goldene Kameras in Berlin überreicht - Bemerkenswerte Rede Dr. Heigerts","pth, wy",[1],7,[1],[5],1,"24","14"],["5209","1968-01-13","Rektor prognostiziert starkes Wachstum der Studentenzahlen in Hamburg.","Braucht Hamburg eine zweite Universität?","","Rektor Ehrlicher: 1975 haben wir 27000 Studenten","hoe.",[11],7,[1],[1],2,"60","1"],["5210","1968-01-13","Hamburger Jusos kritisieren Schulsenator Drexelius scharf für seine Hochschulpolitik.","Jungsozialisten-Attacke","","","ga.",[4],7,[1],[2],2,"60","1"],["5211","1968-01-13","Jahresanfangsgottesdienst der Evangelischen Jugend Hamburgs, Gegen Erbauung und Ruhe in der Kirche, große Sympathie mit den Demonstranten.","Jugendgottesdienst in St. Nikolai wurde zum Protest ohne Krawall","","Das große Unbehagen an der Welt, in der wir leben / Für und wider Demonstrationen","sic.",[3],7,[1],[2],2,"60","7"],["5212","1968-01-13","Drei Studenten haben Hamburger Innenbehörde auf Schadenersatz aufgrund des damaligen Polizeieinsatzes verklagt.","Studenten klagen gegen die Innnenbehörde","","","",[7],7,[1],[2],2,"60","8"],["5213","1968-01-13","Anhand von Vorgängen um die Höhere Wirtschaftsfachschule moniert ein Leser den ideologischen Primat in der Hamburger Bildungspolitik.","Höhere Wirtschaftsfachschule","Briefe an das Hamburger Abendblatt","","Leser",[4],7,[6],[2],2,"60","9"],["5214","1968-01-13","Schilderung der Entwicklung der Uni in jüngerer Vergangenheit u. a. anhand statistischer Zahlen. Kritische Sicht der Dinge: \"Während Hamburg noch nicht einmal mit den Problemen seiner ersten Universität fertig wird, müsste es eigentlich schon an den Aufbau seiner zweiten herangehen.\"","Wohin treibt die Hochschule?","Hamburgs Universität im Kreuzfeuer","Zahl der Studenten stieg beängstigend","Erich Hoepfner",[11],7,[5],[4],1,"60","53"],["5215","1968-01-15","SDS hatte Diskussion in der Kirche über Thielicke-Predigt gefordert. Nach Ablehnung kam es nur zu vereinzelten Störungen.","Orgelspiel übertönte die Rufe der Studenten nach Diskussionen","","Gespräch über die Predigt von Prof. Thielicke fand im Michel nicht statt","U.W.",[3],7,[1],[2],2,"16","5"],["5216","1968-01-16","SPD im Kieler Landtag fordert Rücktritt des Kultusministers wegen dessen Haltung zu Zwangsexmatrikulationen.","Kieler SPD fordert Entlassung von Heydebrecks","","","fa.",[11],7,[1],[2],2,"18","1"],["5217","1968-01-16","Mehrere Pastoren äußern sich zur Frage von Diskussionen in der Kirche.","\"Für ein Spektakel ist der Michel zu schade\"","","Hauptpastor Quest zur Diskussion in der Kirche bereit","ff",[3],7,[1],[3],1,"18","8"],["5218","1968-01-17","Kieler Studentenparlament forder in einer Entschließung die Entlassung Heydebrecks","Auch Studenten fordern Rücktritt von Heydebrecks","","","fa.",[11],7,[1],[2],2,"28","1"],["5219","1968-01-17","Erklärung Prof. Wenkes zu seiner Lehrtätigkeit","Professor Wenke will weiter lesen","","","U.W.",[11],7,[1],[2],2,"28","1"],["5220","1968-01-17","Meldung zu Moch als Nachfolger Dünsings als Berliner Polizeichef","Neuer Polizeichef","","","wy",[7],7,[1],[2],2,"28","2"],["5221","1968-01-17","Bürgerschaftsausschuss will sich mit studentischen Vorschlägen zur Hochschulreform befassen.","Politiker hören morgen Reformpläne des AStA","","Auch der SDS hat ein Programm ausgearbeitet","thi.",[4],7,[1],[3],2,"28","3"],["5222","1968-01-18","Nach Gießen und Göttingen sind jetzt auch in Kiel Fälle bekannt geworden, bei denen Studenten vom Verfassungsschutz für Spitzeldienste angeworben werden sollten. Studenten-Vollversammlung fordert Einstellung jeder Überwachungstätigkeit an der Uni.","Kieler Studenten empört über Spitzeldienste","","Verfassungsschutz warb Hochschüler für 150 DM","fa.",[9],7,[1],[2],2,"20","1"],["5223","1968-01-18","Demonstrationen in Bremen gegen Fahrpreiserhöhungen \"entwickelten sich fast zu einer Straßenschlacht.\"","Schwere Krawalle in Bremen - Verkehr im Zentrum blockiert","","Polizei ging mit Wasserwerfern vor","er., dpa",[1],7,[1],[1],1,"20","1"],["5224","1968-01-18","Anlässlich der Vorkommnisse im Michel bittet Bischof Wölber die Hamburger Gemeinden um Geduld und Toleranz gegenüber den Demonstranten. \"Ich meine, Christen können einen Tumult ertragen. Es sollte nicht ihr erster Gedanke sein, die Polizei zu Hilfe zu rufen oder Störenfriede vor den Richter zu schleppen.\" Ruft zu Diskussionen auf.","Wölber: \"Mit der jungen Generation diskutieren!\"","","Bischof schrieb an die Gemeinden - Bitte um Besonnenheit","U.W.",[3],7,[1],[1],1,"20","5"],["5225","1968-01-18","Kritisches Porträt des SDS. Geht besonders auf Dutschke und Marcuse ein. SDS habe durch seine radikalen Aktionen die studentische Reformbewegung in Misskredit gebracht. SDS-Haltung zur Pressefreiheit und zu \"Enteignet Springer\".","Stoßtrupp des Linksradikalismus","Hamburgs Universität im Kreuzfeuer","Der SDS zwischen Utopie und Krawall","Erich Hoepfner",[8],7,[5],[4],1,"20","9"],["5226","1968-01-19","Über die Ausschreitungen bei den Fahrpreisdemos in Bremen. \"Die Bremer Innenstadt glich einem Hexenkessel.\"","Bremen: Wasserwerfer gegen Demonstranten","","","",[1],7,[5],[5],1,"24","1"],["5227","1968-01-19","Entwicklung der Eskalationen in Bremen. \"Der harte Polizeieinsatz führte zu einer wahren Massenschlacht.\" \"Ihr Einsatz entwickelte sich immer mehr zu einem wahllosen Dreinschlagen auf alles, was sich auf der Straße bewegte.\" Selbstkritik eines Polizeioffiziers.","Bremer Senat: In unserer Stadt herrscht Chaos","Straßenschlachten in der Innenstadt","Tariferhöhung soll jetzt überprüft werden","er. ",[1],7,[1,5],[1],2,"24","1"],["5228","1968-01-19","CDU will Ursachen für Studentenunruhen ergründen. Stoltenberg gründet \"Beirat für die Hochschul- und Forschungspolitik\", der aus 40 Politiker, Professoren, Assistenten und Studenten bestehen soll.","CDU nimmt sich der Studenten an","","Gleichzeitig scharfe Absage an die \"antidemokratische Linke\"","wst",[1],7,[1],[1],2,"24","2"],["5229","1968-01-19","AStA, Fakultätssprecher und Fachschaftsvertreter diskutieren mit Bürgerschaftsvertretern ihre Reformvorstellungen. Vor dem Rathaus befassen sich 500 Studenten ebenfalls mit diesen Themen. Zuvor hatte im Audimax ein \"Kritisches Kolloquium\" zur Vorlesungsabsage von Professor Wenke gegeben, bei dem Oberlercher damit gescheitert war, eine neue pädagogische Theorie zu verkünden.","Die \"Erstürmung\" des Rathauses fand nicht statt","","Studenten erläuterten ihre Reformpläne","U.W.",[4],7,[1],[1],1,"24","3"],["5230","1968-01-19","Hinweis auf den Beginn des ersten Schadensersatzprozesses, den Demonstranten gegen die Hamburger Innenbehörde angestrengt haben.","Heuter erster Prozess wegen Schah-Krawallen","","","",[7],7,[1],[2],2,"24","3"],["5231","1968-01-19","Darstellung der unterschiedlichen Reformpläne von den verschiedenen Studentengruppierungen. Klare Abgrenzung gegen den SDS. Infragestellung verschiedener Vorschläge. Bei aller Kritik im Detail, verhalten positiv gegenüber Demokratisierungsbestrebungen.","Der Schrei nach \"Demokratisierung\"","Hamburgs Universität im Kreuzfeuer","Studenten fordern Mitbestimmung und Vetorecht","Erich Hoepfner",[4],7,[5],[4],1,"24","13"],["5232","1968-01-20","Sondersitzung der Bremer Bürgerschaft nach Befriedung des Streits um die Fahrpreiserhöhungen","\"Burgfrieden\" beendete Krawalle in Bremen","","Am Montag Sondersitzung der Bürgerschaft","er.",[1],7,[1],[3],2,"62","1"],["5233","1968-01-20","Uni setzt Forscher ein, um Langfristplanung der Universitätsentwicklung vorzubereiten. Anhängend wird auf den Thielicke-Konflikt eingegangen: Der Theologe hat erklärt, in der Kirche keine Diskussionen zulassen zu wollen.","Planung für die Zukunft der Uni","","Im Jahr 1975: Rund 32500 Studenten","W.W.",[11],7,[1],[2],2,"62","3"],["5234","1968-01-20","Bundesinnenministerium kündigt an, die Hochschule für Gestaltung in Ulm künftig nicht mehr finanziell zu unterstützen.","Gefährdete Hochschule","","","",[11],7,[1],[2],2,"62","11"],["5235","1968-01-22","Kieler SDS-Chef wird mit deutlicher Mehrheit zum dortigen AStA-Vorsitzenden gewählt.","Linksrutsch an der Kieler Universität","","","fa.",[11],7,[1],[2],2,"16","1"],["5236","1968-01-22","Bürgermeister von Bremen kritisiert die Härte des Vorgehens der Polizei bei den Demonstrationen gegen die Fahrpreiserhöhungen.","Koschnick kritisiert Vorgehen der Polizei","","","er.",[1],7,[1],[2],2,"16","2"],["5237","1968-01-22","In Freiburg haben jetzt erstmals auch die nichtakademischen Mitarbeiter einer Uni eine Mitwirkung in den Selbstverwaltungsgremien gefordert.","Uni-Personal fordert \"Demokratisierung\"","","","dpa",[4],7,[1],[2],2,"16","2"],["5238","1968-01-23","Im Thielicke-Gottesdienst, bei dem Demonstranten über die Predigt hätten diskutieren wollen, waren in Zivil auch 70 Bundeswehroffiziere anwesend. Kirche bemüht sich, deutlich zu machen, dass sie nicht \"die Bundeswehr gerufen\" hat.","\"Soldaten wurden nicht in die Kirche gerufen\"","","Pastor Quest zum Gottesdienst in St. Michaelis am 13.1.","ga.",[3],7,[1],[2],1,"16","3"],["5239","1968-01-23","Überblick über Studentenunruhen von Berkeley bis Mexiko. Nebenstehend vier Leserbriefe, die die Aktikelserie des Abendblatts würdigen.","Die Unruhe muss erhalten bleiben","Hamburgs Universität im Kreuzfeuer","Eine \"Modell-Revolte\" für Studenten in aller Welt","Erich Hoepfner",[1],7,[5,6],[4],1,"16","9"],["5240","1968-01-24","Kurzvorstellung der Spitzenkandidaten und ihrer Hauptforderungen vor den anstehenden AStA-Wahlen. Der Kandidat des RSD ist Jürgen Rieger, der spätere NPD-Anwalt.","Jetzt geht es um mehr als das Mensa-Essen","","Studenten wählen ab morgen ihr neues Parlament","ff, ey",[11],7,[1],[5],1,"24","3"],["5241","1968-01-24","Kommentator spricht sich für Gespräche der Kirchen mit Jugendlichen aus, distanziert sich jedoch von Krawallen. Verweist darauf, dass Dutschke sich von seinem Go-in in die Berliner Gedächtniskirche distanziert habe. Die Kirche sollte ihre Portale offen halten.","Freie Diskussion in der Kirche?","","","Walter M. Herrmann",[3],7,[5],[5],2,"24","7"],["5242","1968-01-24","Schulsenator Drexelius erklärt auf einer SPD-Veranstaltung, dass er die Unruhe an der Uni heilsam findet. Ein Chaos herrsche dort nicht.","Drexelius: Kein Chaos an der Uni","","","",[1],7,[1],[2],2,"24","10"],["5243","1968-01-24","Erster Schadensersatzprozess nach Hamburger Schah-Besuch führt zu noch keinem Ergebnis.","Keine Einigung im zweiten \"Schah-Prozess\"","","","",[7],7,[1],[2],2,"24","10"],["5244","1968-01-24","Diskussion von Dozenten und Studenten der Akademie für Wirtschaft und Politik mit Bürgerschaftsabgeordneten über die Frage der Errichtung einer neuen Höheren Wirtschaftsfachschule.","Konkurrenz zur Akademie?","","Diskussion um höhere Wirtschaftsschule geht weiter","thi.",[4],7,[1],[5],2,"24","15"],["5245","1968-01-25","Bremer Bürgermeister verkündet vor Studenten Rücknahme einiger der kürzlich beschlossenen Fahrpreiserhöhungen.","Stürmischer Beifall für Koschnick","","","er",[1],7,[1],[2],2,"20","1"],["5246","1968-01-25","Ruhige und sachliche Diskussion zwischen Dozenten und Studenten im Audimax über die kürzlich veröffentlichten 81 Leitsätze zur Hochschulreform.","Partner an der Uni haben sich genähert","","Sachliche Diskussion über Hochschulreform-Leitsätze","ff",[4],7,[1],[2],1,"20","7"],["5247","1968-01-26","\"Nach dem Bremer Vorbild\" nun in zwei anderen Unistädten Demos gegen Fahrpreise.","Jetzt Demonstrationen in Kiel und Regensburg","","","dpa",[1],7,[1],[2],2,"20","2"],["5248","1968-01-26","Kontroverse Diskussionen auf der Synode über Diskussionsgottesdienste. Bischof Wölber ist zu Gesprächen bereit, aber \"warum ? ausgerechnet im Gotteshaus\"? ","Bischof Wölber ist zu Diskussionen in der Kirche bereit","Im Hamburger Rathaus tagte die Synode. Es kam zu einem harten Meinungsstreit.","Kompromissvorschlag angenommen","ff",[3],7,[1],[1],1,"20","3"],["5249","1968-01-26","In Deutschland lebende Studenten aus Biafra brauchen Unterstützung, da sie keine Verbindung mehr zu ihrem Heimatland haben. Hamburger AStA unterstützt entsprechenden Aufruf.","Biafra-Studenten brauchen Hilfe","","","",[11],7,[1],[2],2,"20","4"],["5250","1968-01-26","Vier SDS-Mitglieder haben an Wenke-Vorlesung teilnehmen wollen, obwohl sie dafür nicht eingeschrieben waren. Haben auch den Hörsaal trotz Aufforderung nicht verlassen.","Disziplinarverfahren gegen vier Studenten","","Grund: Teilnahme an nicht belegten Vorlesungen","ff",[8],7,[1],[2],2,"20","5"],["5251","1968-01-27","Uni beantragt Mittel für 102 neue Planstellen, um die Lehrverhältnisse zu verbessern.","Uni braucht zusätzlich drei Millionen","","","thi.",[11],7,[1],[2],2,"74","9"],["5252","1968-01-29","Helmut Schmidt fordert verstärkte politische Aufklärung Jugendlicher, um diese vor radikalen Einflüssen zu schützen.","Schmidt fordert mehr politische Aufklärung","","","dpa",[1],7,[1],[2],2,"16","1"],["5253","1968-01-29","Wissenschaftsminister plädiert für intensivere Zusammenarbeit von Bund und Ländern in Fragen des Uniausbaus und bei der Hochschulreform.","Stoltenberg: Mehr Zusammenarbeit nötig!","","","dpa",[4],7,[1],[2],2,"16","2"],["5254","1968-01-30","Einladung in einen Jugendklub zu einer Diskussionsveranstaltung zum Thema","Kein Respekt mehr?","","","",[1],7,[1],[2],2,"18","5"],["5255","1968-01-30","Mündliche Verhandlung ohne greifbares Ergebnis zur Frage der Angemessenheit des Vorgehens der Polizei während des Schah-Besuchs in Hamburg.","Wieder keine Einigung","","Dritter \"Schah-Prozess\" vor dem Verwaltungsgericht","frk",[7],7,[1],[3],2,"18","5"],["5256","1968-01-30","Dutschke und andere SDS-Mitglieder auf dem FDP-Parteitag. Dahrendorf stellt sich der Diskussion und pariert z. B. Duschkes Vorwurf, dass Parteien Fachidioten der Politik seien mit dem Satz: \"Ich habe ein bisschen den Eindruck, Herr Dutschke, dass es nicht nur Fachidioten der Politik gibt, sondern auch Fachidioten des Protestes.\"","Dahrendorf setzte Dutschke matt","","Niederlage für die jungen \"Rebellen\" auf dem Freiburger FDP-Parteitag","Herbert G. Haake",[2],7,[1],[1],1,"18","2"],["5257","1968-01-31","Während der Fortsetzung des Anhörverfahrens zur Reform der Uni im Rathaus wollen Studenten davor mit Passanten diskutieren.","Studenten wollen wieder auf der Straße diskutieren","","Auf dem und um den Rathausmarkt - Anhörverfahren","ff",[4],7,[1],[3],1,"26","3"],["5258","1968-01-31","Veranstaltung von Jugendring und AStA anlässlich des 35. Jahrestages der \"Machtübernahme\". Teilnehmer u. a. Jens Litten vom SHB, Werner Witt von der IG Chemie, der Schriftsteller Erich Fried und Pastor Peter Stolt.","Politisches Engagement gehört zur Demokratie","","Podiumsdiskussion des Hamburger Jugendringes","ff",[1],7,[1],[2],2,"26","7"],["5259","1968-01-31","Hinweis auf ein Kostümfest von Studenten der Ingenieurschule für Bauwesen.","Studenten feiern","","","",[11],7,[1],[2],2,"26","7"],["5260","1968-02-01","Foto von Demonstranten, die ein Auto umstürzen: \"Unerträgliche Missbrauch des Demonstrationsrechts?\" Hinweise auf Artikel auf Seite 2","Krawalle auch in Kiel","","","",[1],7,[5],[3],1,"20","1"],["5261","1968-02-01","Ergebnis der Wahlen zum Hamburger Studentenparlament \"Absage an alle extremistischen Kräfte\". Sitzverteilung.","Sieg der Reformwilligen","Studentenwahl:","","ff",[11],7,[1,5],[2],2,"20","1"],["5262","1968-02-01","Bericht über die teils von Tumulten begleitete Demonstration gegen die Erhöhung der Nahverkehrstarife in Kiel.","Demonstrationen in Kiel","","Jugendliche protestierten gegen Fahrpreiserhöhung","fa.",[1],7,[1],[3],2,"20","2"],["5263","1968-02-01","Go-in beim Rektor der Hamburger Uni wegen der Disziplinarverfahren gegen die Studenten, die an Wenke-Vorlesung hatten teilnehmen wollen, ohne dafür eingeschrieben gewesen zu sein.","Demonstration gegen Disziplinarverfahren","","Hundert Studenten diskutierten mit dem Rektor","ff",[11],7,[1],[3],2,"20","3"],["5264","1968-02-02","Erklärung des FU-Rektors Harndt zu Ausschreitungen an der Freien Universität. Studenten seien \"zu brutalem Terror übergegangen\". Während einer TU-Veranstaltung wird ein Film über Herstellung und Anwendung von Molotow-Cocktails gezeigt.","Berliner Rektor: \"Brutaler Terror\"","","","wy.",[11],7,[1],[2],2,"30","1"],["5265","1968-02-02","Hinweis auf Tumulte in mehreren hier nicht namentlich genannten Städten wegen Fahrpreiserhöhungen.","Tumulte in mehreren Großstädten","","","",[1],7,[1],[2],2,"30","1"],["5266","1968-02-02","Kommentar zum Ausgang der Studentenwahlen in Hamburg, die, vor dem Hintergrund der Unruhen in Bremen, Kiel und Berlin, gezeigt hätten, \"dass es auch anders geht\". Vorbildfunktion der Hamburger Jugend wird betont.","Sieg der Vernunft","","","hoe.",[11],7,[5],[5],2,"30","2"],["5267","1968-02-02","\"Studenten machen nur Krawall\", \"Studenten tragen Bärte und sind schmuddelig\", \"Studenten fordern nur und tun nichts\": Mit solchen Vorwürfen wollen sich die Hamburger Studenten jetzt öffentlich auseinandersetzen, und laden deshalb zu einer Diskussion ins Audimax. - Überlegungen zur Zusammensetzung des nächsten AStA.","Hamburgs Studenten stellen sich der Kritik des Bürgers","","Öffentliche Diskussion im Audimax - Schwierige AStA-Wahl","Sebastian Lorff",[11],7,[1],[1],1,"30","4"],["5268","1968-02-02","Zusammenfassender Bericht über die Unruhen in Kiel, Hannover, Freiburg, Münster und Bremen.","Tumulte in mehreren Großstädten","","Schüler und Studenten demonstrierten gegen Fahrpreiserhöhungen","fa., R.St., er.",[1],7,[1],[1],1,"30","22"],["5269","1968-02-03","Äußerungen von Berliner Politikern zu den Angriffen auf Filialen der Berliner Morgenpost. Hingewiesen wird im Bericht auf den zuvor in der TU gezeigten Film über Molotow-Cocktails. Es wird von Terroristen und von \"faschistischen Methoden\" gesprochen. Auch das Haus Springer fühlt sich an die \"Übergriffe der Nationalsozialisten\" erinnert.","Kriminelle Anschläge","","Terror gegen Zeitungsfilialen in Berlin verurteilt","wy",[10],7,[1],[5],2,"70","1"],["5270","1968-02-03","Bericht über Ausschreitungen in Kiel. Schleswig-Holsteinischer Ministerpräsident Lemke weist Polizei an, energischer gegen Provokateure einzuschreiten.","Lemke: Jetzt sind die Grenzen überschritten","","Kieler Polizei zu energischem Vorgehen angewiesen","f.a.",[11],7,[1],[2],2,"70","2"],["5271","1968-02-03","SHB-Mitglieder haben vor dem griechischen Generalkonsulat in Hamburg demonstriert. Einige sind wegen unerlaubten Betretens exterritorialen Bodens vorübergehend festgenommen worden.","Sitzstreik im Konsulat","","","cvb",[11],7,[1],[2],2,"70","5"],["5272","1968-02-05","Gründung eines \"Sozialistischen Zentrums\" in Offenbach. SPD und SDS distanzieren sich von dieser Organisation.","SPD distanziert sich","","","AP, dpa, upi",[8],7,[1],[2],2,"18","1"],["5273","1968-02-05","Sammelbericht über Unruhen und Ausschreitungen in Kiel, Berlin, Frankfurt und Bochum. Richard Stücklen spricht von \"übelstem Rauditum\". Helmut Schmidt: \"?wir  haben zuzuhören, wenn junge Leute etwas Intelligentes vorbringen, und ebenso haben unsere Behörden einzuschreiten, wenn junge Leute das Gesetz missachten.\" Ernst Lemmer: \"Mit solchen Exzessen kündigen sich stets neue Katastrophen an.\" Er spricht von \"nihilistischen Rüpeleien\".","Krawalle beunruhigen Politiker","","Wirkungsvolles Durchgreifen gefordert - Schwerpunkte Kiel und Berlin","wy, fa., we.",[1],7,[1,5],[1],1,"18","2"],["5274","1968-02-05","Kritischer Kommentar zu den Ausschreitungen vom Wochenende. Die Rücknahme der Fahrpreiserhöhungen in Bremen hat die weiteren Demos provoziert. \"?da mussten die linksfaschistischen Drahtzieher der Unruhen in der ganzen Bundesrepublik daraus den Schluss ziehen: Nur weiter so.\" Hier wird das Demonstrationsrecht missverstanden. Und die Angriffe auf Zeitungen in Berlin, nachdem zuvor ein \"Terror-'Lehrfilm'\" über Molotow-Cockteils gezeigt worden war, müssen klarmachen, dass es hier gegen die Demokratie geht.","Niederlage für die Demokratie","","","hoe.",[1],7,[5],[5],2,"18","2"],["5275","1968-02-05","Demonstranten stören Gottesdienst im Michel. Behaupten, die beim Thielicke-Gottesdienst anwesenden Soldaten wären bezahlt gewesen. ","Gottesdienst erneut gestört","","","",[3],7,[1],[2],2,"18","3"],["5276","1968-02-06","Mit den jüngsten Krawallen wird sich demnächst der Bundestag beschäftigen.","Krawalle vor den Bundestag","","","wst",[1],7,[1],[2],2,"18","1"],["5277","1968-02-06","FU-Konvents-Chef Lefevre musste sein Amt zur Verfügung stellen, da er nicht mehr immatrikuliert ist.","An der FU exmatrikuliert","Bunte Welt","","",[8],7,[1],[2],2,"18","2"],["5278","1968-02-06","Bericht über Demonstrationen und Auschreitungen in Frankfurt, Osnabrück, Kiel, Heidelberg und Berlin. Dutschke wird als Demonstrant in Frankfurt namentlich genannt. Dort war eine deutsche Fahne heruntergerissen und verbrannt worden. SPD-MdB Arndt äußert sich in einem Brief an Axel Springer zu den Angriffen auf BM-Filialen. Er spricht hierbei von \"roten Faschisten\".","Fahne vom Mast gerissen und verbrannt","","Krawalle in Frankfurt - Arndt: Empörung und Abscheu","wy, fa. ",[1],7,[1],[5],1,"18","2"],["5279","1968-02-06","In der Studenten-Bürger-Diskussion überwog Sachlichkeit. Rund 1000 Hamburger waren ins Audimax gekommen. Zitiert werden Äußerungen von SDS-Vertretern Roth und Neckermann, von Litten (SHB) u. a. Anwesender Arbeiter verwahrt sich gegen Oberlerchers Behauptung, Arbeiter hätten keine politischen Interessen.","Erste Aussprache führte nicht zum Kern der Probleme","","Bürger diskutierten mit Studenten","U.W.",[11],7,[1],[1],1,"18","6"],["5280","1968-02-07","Landesverband Niedersachsen des VDS legt eigenen Entwurf für eine neues Hochschulgesetz vor.","Studenten legten Hochschulgesetz vor","","","R.St.",[4],7,[1],[2],2,"30","2"],["5281","1968-02-07","Erstmals tagt Hochschulreform-Kommission auf Senatseben in Hamburg.","Jetzt wird es ernst mit der Hochschulreform","","","",[4],7,[1],[2],2,"30","3"],["5282","1968-02-07","SHB widerspricht der Darstellung, dass Demonstranten in das griechische Generalkonsulat eingedrungen wären.","SHB: Kein gewaltsames Eindringen","","","ey",[11],7,[1],[2],2,"30","7"],["5283","1968-02-07","Wegen umstrittener Äußerungen während der NS-Zeit vom SDS angegriffener Psychologie-Professor stellt sich einer Diskussion. Fachschaft verteidigt ihn angesichts seiner aktuellen Äußerungen.","Hofstätter stellte sich der Kritik","","Hörsaal-Diskussion","U.W.",[11],7,[1],[5],1,"30","8"],["5284","1968-02-07","Bundestagsfraktionen diskutieren über \"Straßenterror\". Anzeigen gegen Demonstranten in Frankfurt, u. a. gegen Dutschke. Meldungen auch aus Freiburg, Kiel und Berlin. Erwähnt wird der Kaul-Auftritt bei einer SDS-Veranstaltung in Bonn.","Thema der Woche in Bonn: Krawalle in den Städten","","Anzeige gegen Dutschke und 12 weitere Demonstranten","wst, fa.",[1],7,[1],[2],2,"30","13"],["5285","1968-02-08","Sammelmeldung über Regierungsberatungen zum Thema, über das Eindringen von Demonstranten ins Bonner Rektorat, bei dem das Goldene Buch der Uni beschmiert wurde, über Vorgänge in Hannover, Freiburg, Duisburg und Gummersbach. In Berlin fordert die CDU eine SDS-Verbot und nimmt die KU ihre Arbeit auf.","Bonn im Zeichen der Krawalle","","Kanzler und Länderchefs beraten - Berliner CDU für SDS-Verbot","wst, wy., R.St., we.",[1],7,[1],[3],2,"20","2"],["5286","1968-02-08","Von den \"81 Leitsätzen zur Hochschulreform\" sind inzwischen 3500 Exemplare im Umlauf. Senat hat sich mit den Autoren bislang nicht in Verbindung gesetzt.","Hamburger Reformleitsätze fanden ein starkes Echo","Neun Professoren warten auf ein Gespräch mit dem Senator","Inzwischen ein \"Bestseller\" - Auch Stoltenberg interessiert","UW",[4],7,[1],[1],2,"20","3"],["5287","1968-02-09","Vor dem Hintergrund erneuter Demonstrationen beschäftigt sich jetzt der Bundestag mit den Unruhen. Am Vortag war dies Thema im Berliner Abgeordnetenhaus gewesen, wo u. a. über ein SDS-Verbot gestritten worden war.","Radikalen soll stärker entgegengetreten werden","","Jugendkrawalle heute morgen vor dem Bundestag","wst., wy., fa.",[1],7,[1],[2],2,"26","1"],["5288","1968-02-09","Zur Finanzierung der Hochschulen in diesem und dem kommenden Jahr","630 Millionen DM für die Hochschulen","","","dpa",[4],7,[1],[2],2,"26","2"],["5289","1968-02-09","Auszug aus dem Harrprecht-Interview mit Axel Springer. Hier äußert sich Springer u. a. zum SDS und zu den Angriffen auf seinen Verlag.","Axel Springer: Wir bejahen diesen Staat","","Interview des Verlegers im Zweiten Deutschen Fernsehen","",[10],7,[3],[3],2,"26","2"],["5290","1968-02-09","Die SHB-Mitglieder Nobert Jankowski und Jens Litten sind nach vierstündiger Diskussion als AStA-Vorstand gewählt worden. ","Jankowski und Litten neue AStA-Vorsitzende","","Mit knapper Mehrheit gewählt - Breite Opposition","ff",[11],7,[1],[5],1,"26","3"],["5291","1968-02-09","Studentenvertreter und Soldaten der Heeresoffiziersschule II werden sich zu einer Diskussionsveranstaltung treffen.","Studenten und Soldaten wollen diskutieren","","","",[11],7,[1],[2],2,"26","3"],["5292","1968-02-10","Anti-Vietnamkriegs-Demo des SDS mit 1500 Teilnehmern. Roth und Frank Wolff als Redner.","Demonstration in Hamburg","","","",[1],7,[1],[2],2,"68","1"],["5293","1968-02-10","Äußerungen verschiedener Politiker in der Aktuellen Stunde des Bundestages zu den Unruhen. Walter Scheel wird zitiert, \"Dutschkes habe es zu allen Zeiten gegeben? Beunruhigend sei nur, dass man ihnen zuhöre.\"","Bonn: Den Terror unterbinden!","","Parteien und Regierung bekennen sich zur Verteidigung des Rechtsstaates","haa, we, wy, fa",[1],7,[1],[1],1,"68","2"],["5294","1968-02-10","Bericht über die SDS-Demo gegen den Vietnamkrieg. Auch bei anschließendem Marsch durch die Stadt keine Gewalt. Lob vom Innensenator.","Protest, aber ohne Gewalt","","Kundgebung auf der Moorweide - Anschließend Diskussion","",[1],7,[1],[3],1,"68","3"],["5295","1968-02-12","Marburger Professoren verhindern durch Raumbelegung die konstituierende Sitzung des neuen satzunggebenden Senats, an dem auch Assistenten und Studenten beteiligt werden sollten.","Marburg: Sit-in der Professoren","","","dpa",[11],7,[2],[2],2,"16","2"],["5296","1968-02-13","Kritik an einer Panorama-Sendung Peter Merseburgers, dem in seiner Berichterstattung über die Anti-Springer-Aktion \"böse Fehlurteile, falsche Behauptungen und Abträglichkeiten\" vorgeworfen werden.","Tendenziös","","","M.S.",[10],7,[5],[2],2,"20","2"],["5297","1968-02-13","Äußerungen von Bürgermeister Weichmann und Gewerkschaftsvertretern anlässlich eines Senatsempfangs zu den Unruhen.","Gewerkschaften wollen den Staat schützen","","Bürgermeister: 'Gewalt der Straße' nicht verharmlosen","thi.",[1],7,[1],[2],2,"20","3"],["5298","1968-02-13","Auszubildende am Sozialpädagogischen Institut sind in einen Vorlesungsstreik getreten.","Studenten \"streikten\"","","","",[9,11],7,[1],[2],2,"20","3"],["5299","1968-02-13","Vertreter des Rings politischer Jugend konstatieren größeres Interesse an ihren Mitgliedsverbänden. Abgrenzung vom SDS.","Großer Zulauf zu den politischen Gruppen","","Ring politischer Jugend: Keine Aktionen mit dem SDS","U.W.",[8],7,[1],[2],2,"20","5"],["5300","1968-02-13","Offenbar Uneinigkeit in der Regierung über die Frage der Verfassungsfeindlichkeit des SDS. Kurzinformationen über Demonstrationen etc. in Kiel, Heidelberg, Bonn und München","Uneinigkeit über den SDS","","","wst, dpa, ap",[8],7,[1],[2],2,"20","15"],["5301","1968-02-14","Gespräch zwischen Soldaten und Studenten an Störmanövern des SDS beinahe gescheitert. Hierzu werden Details geschildert. Ein Gespräch zwischen Studenten und Polizisten verlief \"fair und sachlich\". In einem anschließenden Kommentar wird festgestellt, dass diese Gespräche eine Klärung gebracht haben: \"Es muss von nun an deutlich zwischen der Unruhe der Studentenschaft und studentischen Unruhestiftern unterschieden werden.\" SDS lege es nur auf Provokation an.","Eine faire Diskussion kam in Wandsbek nicht zustande","","Am SDS gescheitert - Sachliches Gespräch im Haus Rissen","ff, U.W., jh",[8],7,[1,5],[1],1,"32","5"],["5302","1968-02-15","Details zu den Vorstellungen der Assistenten für eine Reform. Unirektor und Schulsenator unter den Zuhörern.","Nun kamen die Assistenten zu Wort","","Anhörverfahren zur Uni-Reform im Rathaus - Nicht in allen Fragen einig","U.W.",[4],7,[1],[2],2,"20","7"],["5303","1968-02-17","Berlin vor der Vietnam-Demo. Senat warnt vor Demo, die er verboten hat. Dutschke kündigt an, sie auf jeden Fall stattfinden zu lassen.","Schütz warnt vor illegalen Demonstranten","","","wy",[1],7,[1],[2],2,"64","2"],["5304","1968-02-17","HA-Serie \"Hamburgs Universität im Kreuzfeuer\" wird als Sonderdruck angeboten.","Universitäts-Serie als Sonderdruck","","","",[11],7,[1],[2],2,"64","3"],["5305","1968-02-19","Ankündigung der Senatsdemo. Bereits bei der Vietnam-Demo war es zu Protesten gekommen.","Berliner protestieren","","","wy",[1],7,[1],[2],2,"16","1"],["5306","1968-02-19","Senatsdemo als Antwort auf Vietnam-Demo angekündigt. Letztere nun doch genehmigt. Etwa 10000 Teilnehmer. Deutlicher Widerstand von Bürgern. SPD plant Maßnahmen gegen ihre Mitglieder Ristock und Beck, die an der Demo teilgenommen haben. Erwähnung des Auftritts von Rechtsanwalt Prelinger beim Vietnam-Kongress.","Berlins Bevölkerung protestiert","","Empörung über Linksextremisten - Gegenkundgebung geplant","fr, wy",[1],7,[1],[1],2,"16","2"],["5307","1968-02-19","Ausführliche Darstellung der Finanzierungs- und Rechts-Probleme der Ulmer Hochschule für Gestaltung. ","Das heftige Tauziehen in Ulm","","Hochschule für Gestaltung in Not - Werden die fortschrittlichen Ideen gebrenst?","Mathilde Köhler",[11],7,[1],[5],1,"16","7"],["5308","1968-02-20","Berliner SPD plant Schritte gegen Vietnam-Demo-Teilnehmer aus den eigenen Reihen. Hinweise auf die Senatsdemo.","Berliner SPD will hart reagieren","","","wy",[1],7,[1],[2],2,"16","1"],["5309","1968-02-20","Hinweis auf die Tagung der Westdeutschen Rektorenkonferenz zur Hochschulreform","Rektoren tagen in Bad Godesberg","","","",[4],7,[1],[3],1,"16","2"],["5310","1968-02-21","Rüegg will Wahlperiode für Rektoren verlängern und die Rektorenkonferenz reformieren. Hierüber gibt es Dissenz.","Brisante Spannungen zwischen den Rektoren","","Heftige Auseinandersetzungen über Prof. Rüeggs Pläne","wst",[4],7,[1],[3],2,"30","2"],["5311","1968-02-22","In München wollen Studenten, Assistenten und Professoren gemeinsam an einer Reform arbeiten. Sie gründen einen \"Arbeitskreis für die Neue Universität\" Kurzmeldung auf derselben Seite berichtet über Anwahl von Rüegg bei der Rektorenkonferenz.","Gemeinsam an die Hochschulreform!","","","dpa",[4],7,[1],[2],2,"20","1"],["5312","1968-02-22","Weil er die Verhaftung eines Kommilitonen fotografiert hat, ist der Student Holger Oehrens verhaftet worden. Die Rechtmäßigkeit hierfür wird jetzt vor Gericht geprüft.","Niemand nannte den Grund seiner Festnahme","","Student klagt gegen die Hamburger Polizeiführung","ff",[7],7,[1],[3],1,"20","4"],["5313","1968-02-22","Existenzsicherung der Hochschule für Gestaltung in Ulm durch Verstaatlichung beschlossen.","Ulms Hochschule verstaatlicht","","","",[11],7,[1],[2],2,"20","11"],["5314","1968-02-23","Rektorenkonferenz will den Studenten nicht die geforderte Mitbestimmung einräumen, die Assistenten jedoch besserstellen. Hierzu Details.","Rektorenkonferenz gegen \"Mitbestimmung\"","","Nur \"Mitwirkung\" - Assistenten-Stellung verbessert","wst",[4],7,[1],[2],2,"26","1"],["5315","1968-02-23","Auslandsstelle des Bundesstudentenringes bietet günstige Reisen für Studenten an.","Wie wär's mit Afrika?","","Billige Studentenreisen in die ganze Welt möglich","U.W.",[9],7,[1],[2],2,"26","4"],["5316","1968-02-24","Störung einer Gedenkveranstaltung für die Geschwister Scholl: SDS-Mitglieder protestieren in München gegen den Festredner Prof. Bussmann.","München: Tumulte bei Gedenkfeier","","","AP, dpa, upi",[1],7,[1],[2],1,"66","2"],["5317","1968-02-24","Studenten haben bei Protest gegen die umstrittene Ausweisung des nigerianischen Studenten Ifeobu versehentlich die Bannmeile verletzt: Freispruch. Verbleib von Ifeobu unklar.","Protestierende Studenten vom Gericht freigesprochen","Für ihren ausgewiesenen Kommilitonen trugen sie Plakate","Bannmeile irrtümlich verletzt - Obi Ifeobu verschollen","drd.",[1],7,[1],[1],1,"66","3"],["5318","1968-02-27","SPD-Mitglieder, die an Anti-Vietnamkriegs-Demo teilgenommen hatten, sind wegen \"schwere Schädigung des Parteiinteresses?\" gerügt worden.","SPD-Demonstranten wurden gerügt","","","wy",[1],7,[1],[2],2,"18","2"],["5319","1968-02-27","Staatsanwaltschaft legt Berufung ein gegen Freispruch für Ibeofu-Demonstranten.","Studenten müssen wieder vor Gericht","","","",[1],7,[1],[2],2,"18","3"],["5320","1968-02-28","Kommentator kennzeichnet Diskussionsbereitschaft als Zeichen wiedergewonnener Haltung, nachdem den Deutschen zuvor das Rückgrat gebrochen worden war. Grenzt sich aber von \"Dutschkisten\" und anderen Radikalen ab. Vietnam-Demo in Berlin macht deren andere politische Zielsetzung deutlich.","Die \"Diskussion\"","","","wmh",[1],7,[5],[5],2,"30","2"],["5321","1968-02-29","Ausblick auf die in München anstehende VDS-Mitgliederversammlung. Geplanter Wandel vom \"Selbstverwaltungsverband\" zum \"politischen Interessenverband\".","Studenten-Verband will sich politisieren","","Vor heißer Tagung - Weitere Radikalisierung?","wst., wy., fa.",[11],7,[1],[5],2,"24","2"],["5322","1968-03-01","Fortsetzung des Anhörverfahrens im Hamburger Rathaus. Thema: der Mittelbau.","Gleiche Chancen für alle Dozenten","","Wünsche der Wissenschaftlichen Beamten","U.W.",[4],7,[1],[5],2,"36","4"],["5323","1968-03-01","Bei den Demonstrationen während des Hamburger Schah-Besuches von der Polizei bedrängte Studentin akzepiert Entschuldigung der Behörde.","Klage der Studentin endete mit Vergleich","","Behörde bat junge Demonstrantin um Entschuldigung","frk.",[7],7,[1],[3],2,"36","4"],["5324","1968-03-01","Instrumentalisierungsversuch der anstehenden Kampnagel-Stilllegung durch den SDS wird vom Betriebsrat zurückgewiesen.","Abfuhr für den SDS","","Erfolgloser Einmischungsversuch bei Fa. Kampnagel","ga.",[8],7,[1],[3],2,"36","5"],["5325","1968-03-02","Protokoll einer Diskussion von fünf Studenten zum Thema Demonstrationsrecht etc. im Rahmen der HA-Veranstaltungsformats \"Die Box\"","\"Es geht uns um die Demokratie\"","Box Diskussion","Thema: Haltung, Maß und Form - Die Jugend erweitert die Vorstellungen vom Recht auf Diskussion","",[1],7,[7],[1],1,"64","61"],["5326","1968-03-05","Erster Verhandlungstag gegen die Kommunarden Teufel und Langhans endet mit Ordnungsstrafe für Teufel, weil dieser, statt seinen eigenen Lebenslauf zu schildern, gefordert hatte, dass die Mitglieder des Gerichts die ihren vortragen sollten.","Ordnungsstrafe für Teufel","","","dpa, ap ",[5],7,[1],[2],2,"20","2"],["5327","1968-03-05","Hauptstreitpunkt schon am ersten Tag des VDS-Kongresses ist die Frage des politischen Mandats.","Brisante Stimmung beim VDS-Kongress in München","","Spaltung? - Burschenschaft gegen politisches Engagement","dpa, upi",[11],7,[1],[5],2,"20","2"],["5328","1968-03-06","Demonstration von Ingenieurstudenten gegen Beschlüsse der Kultusministerkonferenz zu ihrem Status.","Ingenieurstudenten protestieren","","","",[11],7,[1],[3],1,"30","1"],["5329","1968-03-06","VDS-Boykott eines Empfangs der Bayerischen Staatsregierung für die Teilnehmer des Kongresses wegen deren \"studentenfeindlicher Politik\".","Betretenes Schweigen im Schwarzen Saal Münchens","","Studenten sagten Einladung der Staatsregierung ab","su.",[11],7,[1],[3],1,"30","2"],["5330","1968-03-06","Ausführlicherer Bericht über die Demo der Ingenieurstudenten gegen Beschlüsse der Kultusministerkonferenz. Auflistung ihrer Forderungen.","Protestmarsch der dreitausend","","Kundgebung der Ingenieur-Studenten","U.W.",[11],7,[1],[5],2,"30","4"],["5331","1968-03-07","Demo gegen den zur Abstimmung anstehenden Entwurf des neuen baden-württembergischen Hochschulgesetzes. Missachtung der Bannmeile.","Demonstrationen vor dem Stuttgarter Landtag","","Studenten protestieren gegen Hochschul-Gesetz","th.",[4],7,[1],[2],2,"22","1"],["5332","1968-03-08","Ingenieur-Studenten demonstrieren im Rathaus für ein zeitgemäßes Akademie-Gesetz","\"Invasion\" der Studenten","","","ff",[11],7,[1],[5],1,"32","4"],["5333","1968-03-08","Fortsetzung des Anhörverfahrens im Hamburger Rathaus mit den Stellungnahmen der Dozenten.","Nur das Können soll entscheiden","","Gestern hatten Dozenten das Wort","U.W",[4],7,[1],[1],2,"32","4"],["5334","1968-03-08","Beinahe alle Teilnehmer am VDS-Kongress erscheinen im Münchener Rathaus, wo OB Vogel spontan zu einer Diskussion im Großen Sitzungssaal einlädt.","Diskussion statt \"Sit-in\"","","Studentenempfang im Münchener Rathaus","dpa, ap",[11],7,[1],[5],2,"32","8"],["5335","1968-03-09","VDS widerspricht Berichterstattung des Presse- und Informationsamtes der Bundesregierung über den Verlauf des Münchener Kongresses.","VDS behauptet: Bonn manipuliert Meinungen","","","su.",[11],7,[1],[2],2,"64","2"],["5336","1968-03-11","Bei einer SDS-Vietnam-Demo in Hannover kommt es zu Auseinandersetzungen zwischen Links- und Rechtsradikalen.","Krawalle in Hannover","","","R.St.",[8],7,[1],[2],2,"16","1"],["5337","1968-03-11","Ingenieur-Studenten versuchen über ihre Anliegen mit der Bevölkerung ins Gespräch zu kommen.","Ingenieurstudenten planen Diskussionen","","Vorlesungsstreik beendet - \"Tag der offenen Tür\"","U.W.",[11],7,[1],[2],2,"16","5"],["5338","1968-03-11","Reinhold Oberlercher will per Verwaltungsgerichtsentscheid wieder an Vorlesungen teilnehmen dürfen.","Oberlercher gibt nicht auf","","","",[11],7,[1],[2],2,"16","5"],["5339","1968-03-11","Wachsende Politisierung des Dachverbandes führt zu ersten Ausstritten aus dem VDS.","VDS vor der Spaltung?","","Delegierte von vier Hochschulen ausgetreten","su.",[11],7,[1],[5],2,"16","7"],["5340","1968-03-12","Flügelkämpfe in der Berliner SPD. Ristock und Beck, sowie drei weitere Parteilinke vom Landesvorstand aus der SPD ausgeschlossen.","Berliner SPD vor einer Zerreissprobe","","Die Lage hat sich durch Parteiausschlüsse bedrohlich zugespitzt","wy.",[1],7,[1],[1],2,"18","2"],["5341","1968-03-12","Beschluss der Schulbehörde über Mindestlehrverpflichtungen für Assistenten und Räte ist Grund für Sitzung des Akademischen Senats trotz Ferien.","Trotz Ferien tagt der Uni-Senat","","","",[11],7,[1],[2],2,"18","9"],["5342","1968-03-13","Heftiger Protest des Akademischen Senats gegen Pläne der Schulbehörde zu Lehrverpflichtung der Assistenten und neue Regeln für Akademische Räte.","Scharfer Protest der Universität","","Gegen Mindestlehrverpflichtung","U.W.",[11],7,[1],[1],2,"34","6"],["5343","1968-03-14","Zum Verwaltungsgerichtverfahren Oberlercher gegen Uni Hamburg. Begründung der Angelegenheit. Zwischenzeitlich hat Professor Wenke angekündigt. Im kommenden Semester nicht mehr zu lesen.","Professor Wenke hält keine Vorlesungen mehr","","Student Oberlercher klagt gegen seine Suspendierung","ff",[11],7,[1],[1],2,"26","4"],["5344","1968-03-14","Hamburger Jugendring ruft zu großer Anti-Vietnamkriegs-Demo auf. Verteilt 100000 Flugblätter.","Jugendring demonstriert für Frieden in Vietnam","","","",[1],7,[1],[2],2,"26","5"],["5345","1968-03-15","Krise in West-Berliner SPD zwei Tage vor Bundesparteitag durch Ausschluss von Parteilinken.","Schwere Krise in der Berliner SPD","","Ristock und Beck ausgeschlossen - Zwei Rücktritte","wy",[1],7,[1],[5],2,"36","1"],["5346","1968-03-15","Disziplinarordnung und insbesondere die Frage von Zwangsexmatrikulationen sind Streitpunkte im Kieler Landtag und innerhalb der Studentenschaft.","Diskussionen um Kieler Hochschulgesetz","","","fa.",[11],7,[1],[2],2,"36","12"],["5347","1968-03-16","Schilderung der Atmosphäre vor Beginn des Nürnberger SPD-Bundesparteitages. Befürchtung, dass Ausschluss der Vietnam-Demonstranten zur Abspaltung des linken Parteiflügels führen könnte.","Sturmzeichen über Nürnberg","","SPD-Parteitag durch Ausschlüsse Ristocks und Becks belastet","wy, dpa, ap",[1],7,[1],[1],1,"62","2"],["5348","1968-03-18","Zahlreiche Demonstranten vor der Nürnberger Meistersingerhalle. Zwischenfälle beginnen, als Schütz entdeckt wird. Brandt und Wehner werden angegriffen. Zahlreiche Protestparolen haben Vietnam-Bezug.","Schwere Tumule in Nürnberg","","Willy Brandt und Herbert Wehner von Demonstranten tätlich angegriffen","Herbert G. Haake",[1],7,[1],[1],1,"20","2"],["5349","1968-03-18","Neue, fortschrittliche Geschäftsordnung der Hmburger Hochschule für bildende Künste ist von zuständigen Senatsausschuss gebilligt worden. Entstanden im Miteinander von Studenten und Dozenten. ","Mitbestimmungsrecht der Studenten","Das Fazit eines Semesters in der Hamburger Kunsthochschule","Fortschritt ohne Aufruhr - Verständnisvolle Dozenten - Wichtiger Schritt nach vorn","Paul Theodor Hoffmann",[4],7,[1],[1],2,"20","8"],["5350","1968-03-19","Studentenverband der Ingenieure lobt Polizei für Verhalten bei Demo zwei Wochen zuvor.","Ingenieurstudenten danken der Polizei","","","",[11],7,[1],[2],2,"20","5"],["5351","1968-03-20","In einem Interview mit einer Kieler Jugendzeitung bejaht Justizminister Heinemann das Recht, Studenten durch den Verfassungsschutz überwachen zu lassen, wenn diese zum Umsturz aufrufen.","Verfassungsschutz zur Wachsamkeit verpflichtet","","","fa.",[9],7,[1],[2],2,"30","2"],["5352","1968-03-20","FDP fordert neue Zugangsmöglichkeiten zum Ingenieurstudium","FDP fordert das \"Technische Abitur\"","","","",[11],7,[1],[2],2,"30","5"],["5353","1968-03-21","Technische Hocschulen Hannover, Braunschweig und Clausthal werden TU.","\"Technische Universität\"","Kurz informiert","","",[11],7,[1],[2],2,"26","1"],["5354","1968-03-21","Uni warnt vor Zeitschriftenverkäufern, die sich fälschlich als Studenten ausgeben.","Uni: Das sind Schwindler","","","",[11],7,[1],[2],2,"26","3"],["5355","1968-03-23","Anti-Vietnamkriegs-Demo des Jugendrings spaltet sich: Während viele an einem ökumenischen Gottesdienst teilnehmen, gibt es Aufläufe mit Verkehrsstörungen beim Verlagshaus Axel Springer, am Hauptbahnhof, am US-Generalkonsulat und vor dem Amerikahaus. ","Gebet um Frieden in der überfüllten St. Jacobi-Kirche","","Minderheit versuchte den Sinn der Demonstration zu verfälschen","schu, ff., ab., cvb",[3],7,[1],[1],1,"62","5"],["5356","1968-03-25","Zitate aus einem Interview mit Peter Brandt im italienischen Fernsehen.","Sohn kritisiert den Vater","","","sad",[9],7,[1],[2],2,"18","2"],["5357","1968-03-26","Spekulationen um Vorstrafen des neuen VDS-Chefs Ehmann.","Muss der neue VDS-Vorsitzende gehen?","","","dpa",[11],7,[1],[2],2,"18","1"],["5358","1968-03-26","SPD-Bürgerschaftsfraktionlegt Entwurf für neues Akademie-Gesetz vor.","Initiative der SPD für ein neues Akademie-Gesetz","","Reaktion auf Proteste der Ingenieur-Studenten","thi.",[11],7,[1],[2],2,"18","5"],["5359","1968-03-26","Längerer Aufsatz über die Jugendpolitik der Parteien und die Mitwirkungsmöglichkeiten der Jugend dort.","Die Jugend fühlt sich ausgeschlossen","Die Parteien und die Jugend","Sind die Parteien demokratisch genug?","Erich Hoepfner",[1],7,[5],[1],1,"18","11"],["5360","1968-03-27","Delegiertenrat missbilligt, dass Ehmann Vorstrafe verschwiegen hat, sieht aber keinen Anlass zu dessen Rücktritt.","Christoph Ehmann soll VDS-Vorsitzender bleiben","","","dpa",[11],7,[1],[2],2,"36","2"],["5361","1968-03-30","Plädoyer für ein Ernstnehmen der Anliegen der demokratischen Jugend. Ständige Reformbedürftigkeit der Demokratie. Ausführlicher Text.","Traum vom neuen Sozialismus","Die Parteien und die Jugend","Die Stimme der Jugend darf nicht überhört werden - Reformbedürftige Demokratie","Erich Hoepfner",[1],7,[5],[1],1,"62","57"],["5362","1968-04-01","DGB veranstaltet gemeinsam mit der Volkshochschule ein Seminar zur studentischen Opposition","Untersuchung über die studentische Opposition","","","",[1],7,[1],[2],2,"20","3"],["5363","1968-04-04","Bericht über Gerichtsverhandlung gegen drei Personen, die am 17.2.1967 in der Wandelhalle des Hamburger Hauptbahnhofes demonstriert hatten.","Die zornigen jungen Männer gerieten an die Bahnpolizei","","Drei Demonstranten vor Gericht","frk",[1],7,[1],[1],1,"26","7"],["5364","1968-04-06","Freispruch für Verteiler von Anti-Vietnamkriegs-Flugblättern, denen Verletzung der Bannmeile vorgeworfen worden war.","Es war keine Verletzung der Bannmeile","","","",[1],7,[1],[2],2,"60","3"],["5365","1968-04-06","Bericht über die Verhaftung der Verdächtigen Proll, Baader, Ensslin und Söhnlein. Alle hätten an der Bundesdelegiertentagung des SDS teilgenommen, seien aber wohl keine Mitglieder des Verbandes.","Die Brandbombenleger von Frankfurt gefasst?","","Drei Männer und eine Frau verhaftet - Belastendes Material","dpa, ap",[9],7,[1],[1],1,"60","24"],["5366","1968-04-09","Bericht über den Prozess gegen Demonstranten auf dem Hamburger Hauptbahnhof. Ausführliche Vernehmungszitate. Hinweis auf die vom Schreiber als überflüssig empfundene Abschiebung von Ifeobu.","Manche Zeugen bieten einen Strauß von widersprüchlichen Darstellungen","Von den schweren Vorwürfen der Anklage bleibt vor Gericht wenig übrig","Prozess um die Demonstration im Hauptbahnhof","Alwin Bellmann",[1],7,[1,7],[1],1,"18","3"],["5367","1968-04-11","Kultusministerkonferenz einigt sich auf Maßnahmenpaket zur Reform des Hochschulstudiums. Sieben Punkte werden vorgestellt.","Künftig kürzeres Hochschulstudium?","","Kultusminister-Konferenz einigte sich auf ein Reformprogramm","wst., wy., fa.",[4],7,[1],[1],2,"30","2"],["5368","1968-04-11","Beim Prozess gegen die Bahnhofsdemonstranten werden die Zuschauer aufgrund von Zwischenrufen ausgeschlossen.","Richter wies Zuhörer aus dem Gerichtssaal","","Zwischenfall beim Prozess gegen Demonstranten","Alwin Bellmann",[1],7,[1],[2],2,"30","4"],["5369","1968-04-11","Hinweis auf mehrere aktuelle Buchveröffentlichungen zu den Studentenunruhen.","Was treibt die Jugend zur Unruhe?","","Berichte und Analysen zu einem brennenden aktuellen Problem","hoe.",[1],7,[1],[2],2,"30","11"],["5370","1968-04-13","Titelgeschichte über das Dutschke-Attentat. Ausführliche Darstellung der zu Bachmann vorliegenden Erkenntnise. Hinweis auf Ausschreitungen in verschiedenen Städten, insbesondere die Anti-Springer-Aktionen.","\"Ich konnte Dutschke nicht leiden\" - Die Aussage des Attentäters - Ausschreitungen nach dem Mord-Anschlag","","Ausschreitungen nach dem Mord-Anschlag","ap, dpa, upi",[2],7,[1],[1],1,"54","1,2"],["5371","1968-04-13","Bundeskanzler ruft angesichts des Aufruhrs zu Ruhe und Wachsamkeit auf. Besorgnis über Radikalisierung. Er und die Regierung haben den revolutionären Willen militanter Gruppen bisher nicht ernst genug genommen.","Kiesinger: Eskalation von Gewalt verhindern!","","Osterurlaub unterbrochen - Sorge über Radikalismus","wst., wy., fa.",[2],7,[1],[3],2,"54","1"],["5372","1968-04-13","Schilderung des Tathergangs \"nach Berichten von der Polizei, von Augenzeugen und aus Kreisen um den Sozialistischen Deutschen Studentenbund (SDS)\". Am Schluss des Beitrags kürzere Erwähnung des Sturms auf das Springer-Haus in Berlin.","Die drei verhängnisvollen Schüsse","","Augenzeugenbericht über den Anschlag gegen Rudi Dutschke","wy",[2],7,[1],[1],1,"54","2"],["5373","1968-04-13","Kommentator verurteilt das Attentat und weist auf den Teufelskreis von Terror und Gegenterror am Ende der Weimarer Republik hin. Er kritisiert die Schuldzuweisung an führende Politiker und Axel Springer als Sündenböcke. Er versucht eine Erklärung, wie das alles hat kommen können: \"Wir alle haben irgendwie \"schuld\", wenn man so will, die Älteren zumal, die die berechtigten Forderungen der Jugend erst zu Kenntnis nahmen, als diese offen provozierte. Es ist keineswegs alles in Ordnung zwischen Alpen und Nordsee! Wie wäre es sonst zu erklären, dass so breite Teile unserer Jugend, der studentischen Jugend zumal, dem Staat, den politischen Parteien und der Gesellschaft den Rücken kehren und in eine anarchistischen Opposition weglaufen.\"","Politische Barbarei","","","M.S.",[2,10],7,[5],[5],2,"54","2"],["5374","1968-04-13","Bericht über die Hamburger Demonstration nach dem Attentat auf Rudi Dutschke und die anschließenden Unruhen vor dem Hamburger Springer-Haus. Zitate mehrerer Redner, u. a. von Litten und Roth. ","Um 22:40 Uhr hagelte es die ersten Steine - Demonstranten verbarrikadierten Straßen","","Zahlreiche Verletzte - Parkende Wagen demoliert","Schü, uw, ff, wo, cvb",[10,2],7,[7,1,5],[4],1,"54","3"],["5375","1968-04-13","Versuch, den Werdegang von Rudi Dutschke nachzuzeichnen. Über sein Aussehen, seine Familie, seine Art zu Reden, seine Geldquellen etc. Er wird als der intelligente Eiferer, ein \"Generalstäbler ohne Armee\" dargestellt.","Revolutionär in der Sackgasse","","Das Drama des Rudi Dutschke - Prediger der permanenten Revolution","Wolfgang Fricke",[2],7,[5],[4],1,"54","20"],["5376","1968-04-13","Biografische Daten zu Dutschke","Rudi Dutschke","","","",[2],7,[1],[2],2,"54","20"],["5377","1968-04-16","\"Nach den Ausschreitungen und Gewalttätigkeiten während der Osterfeiertage und dem Aufruf des SDS zu einem \"Marsch auf Bonn\" wird in der Bundeshauptstadt heute über wirksame Gegenmaßnahmen beraten.\"","Bundestag kann nicht mehr länger schweigen","Bonn alarmiert über Ausmaß der Ausschreitungen:","Dringende Forderung aus Kreisen der CDU","w.st.",[1],7,[1],[1],1,"18","1,2"],["5378","1968-04-16","Bericht über zahlreiche Demos in deutschen Städten, u. a. mit Angriffen gegen Springer-Einrichtungen.","Heiße Ostern mit schweren Unruhen","","Viele Verletzte und Verhaftete in mehreren Städten","dpa, ap",[1],7,[1],[3],2,"18","1"],["5379","1968-04-16","Kommentar zu den Ausschreitungen an den Ostertagen. Eskalation und Gewalttätigkeit bereiten Sorge, auch im Ausland. Mutmaßungen über Gründe für den Aufstand: Generationenkonflikt?","Heiße Ostern","","","G.S.",[1],7,[1],[5],2,"18","2"],["5380","1968-04-16","Demonstrationen an vielen Stellen Hamburgs, insbersondere gegen den Axel Springer Verlag und seine Zeitungen.","Erst heute früh herrschte Ruhe","","Ostermontag im Zeichen der Demonstrationen - Letzte Etappe: Polizeipräsidium","ff, wo",[10,2],7,[7,1,5],[4],1,"18","3"],["5381","1968-04-17","Politiker aller Ebenen beraten über die Unruhen der letzten Tage. \"Autorität des Rechts\" müsse bewahrt werden.","Der demokratische Staat muss verteidigt werden","","Kabinett tagt - Auch Länderinnenminister beraten","wst., wy., fa.",[1],7,[1],[1],2,"26","1,2"],["5382","1968-04-17","Fotograf Klaus Frings Opfer der Ausschreitungen vor dem Münchner Buchgewerbehaus.","Erstes Todesopfer der Unruhen","","Folge eines Steinwurfs","ap ",[10,2],7,[1],[2],1,"26","1"],["5383","1968-04-17","Kieler Kultusministerium stellt Regierungsvorschlag für neues Akademie-Gesetz vor","Akademie-Gesetz sichert Mitwirkung der Studenten","","","fa.",[4],7,[1],[2],2,"26","2"],["5384","1968-04-17","Auseinandersetzungen im Berliner Senat. Senatoren Evers und Stein kritisieren Polizeieinsatz gegen Osterdemonstranten.","Differenzen im Berliner Senat über Polizeieinsatz","","Linker Flügel kritisiert Härte - Morgen Erklärung","wy",[10,2],7,[1],[3],1,"26","2"],["5385","1968-04-17","Urteil in einem Schnellgerichtsverfahren gegen einen Münchner Demonstranten. Anti-Springer-Demo in London. Stimmen zur Forderung, Springer zu enteignen. Neues zum Befinden Dutschkes.","Sieben Monate Gefängnis für Aufrührer in München","","Er wusste nicht recht, warum er demonstrierte","SAD, dpa, ap, upi",[10,2],7,[1],[5],2,"26","2"],["5386","1968-04-17","Hamburger AStA-Vize Litten äußert sich auf Pressekonferenz zu den Unruhen der letzten Tage und macht der Polizei Vorwürfe wegen ihres harten Vorgehens. Rechnet Eskalation Provokateuren zu.","AStA: Einzelaktionen von Rockern und Provokateuren","","","ff",[1],7,[1],[3],2,"26","3"],["5387","1968-04-17","Kommentator meint, die berechtigten Reformanliegen werden durch die momentanen Gewalttätigkeiten beschädigt.","Sie begehen Verrat an der eigenen Sache","","","jh",[1],7,[5],[2],2,"26","3"],["5388","1968-04-17","Bilanz von Polizei und Justiz nach den Ausschreitungen in Hamburg. Appelle an Besonnenheit von verschiedenen Politikern. SDS-Geschäftsstelle durchsucht. Zum Zustand eines von einem Zeitungswagen angefahrenen Demonstranten.","Staatsanwälte ermitteln gegen 96 Demonstranten","","Eine Bilanz der Unruhen - Deutliche Warnung des Senats","wo ",[1],7,[1],[1],2,"26","3"],["5389","1968-04-17","Kommentierender Bericht über die Plädoyers im Verfahren gegen die Bahnhofsdemonstranten.","Hohe Strafanträge für Demonstranten vom Hauptbahnhof","","Die Urteile werden Freitag gefällt","Me.",[1],7,[1,5],[1],2,"26","5"],["5390","1968-04-18","Haftbefehl gegen einen Teilnehmer der Anti-Springer-Demo, weil er angeblich einen Polizisten mit einer Holzlatte geschlagen hat.","Haftbefehl","","","wo.",[10,2],7,[1],[2],2,"22","1"],["5391","1968-04-18","Bundeskabinett, Länderinnenminister und Innenausschuss des Bundestages beraten über Unruhen. Bilanz der letzten Tage. Ein SDS-Verbot wird abgelehnt.","Schnellverfahren gegen Anführer","","Kein SDS-Verbot - Beratungen in Bonn über die jüngsten Unruhen","w.st.",[1],7,[1],[3],2,"22","1"],["5392","1968-04-18","Versicherungsgesellschaften beraten über den Umgang mit den durch die Tumulte entstandenen Schäden. Hinweis, dass es seit 1933 keine spezielle Aufruhr-Versicherung mehr gibt.","Zahlen Versicherungen bei Krawall-Schäden?","","","bo.",[1],7,[1],[2],2,"22","1"],["5393","1968-04-18","Brandt kritisiert in einem Brief an Schütz, dass die Berliner Behörden im Zusammenhang mit den jüngsten Unruhen zu spät reagiert haben.","Indirekte Kritik","","","ap",[1],7,[1],[2],2,"22","2"],["5394","1968-04-18","Studentenvertreter äußern sich betroffen über den Tod von Klaus Frings. SDS beschließt in mehreren Städten, Aktionen auszusetzen. In München findet ein Schweigemarsch im Gedenken an den Fotografen statt.","Linksradikale kommen langsam zur Besinnung","","Vorerst keine weiteren Aktionen - Schock über Tod des Fotografen","ap, dpa, upi",[1],7,[1],[1],1,"22","2"],["5395","1968-04-18","3000 Studenten der Hamburger Uni debattieren im Audimax über die Unruhen der jüngsten Zeit. Sehr verhaltene Töne, deutliche Distanzierung zur Gewalt","Die Versammlung stand im Zeichen der Selbstkritik","","Studenten distanzieren sich von Gewalt","U.W., ff, sic",[1],7,[1],[5],1,"22","3"],["5396","1968-04-18","Ankündigung einer Kundgebung \"Freiheit für Griechenland\".","Protestkundgebung gegen Diktatur findet statt","","","",[1],7,[1],[2],2,"22","3"],["5397","1968-04-18","Auf einer Reemtsma-Betriebsversammlung äußert sich Bürgermeister Weichmann grundsätzlich zu den Unruhen der letztem Tage: \"Es ist nun nötig, den Unruhestiftern klarzumachen, dass ihnen die Menschen in den Büros und Fabriken nicht folgen!\"","\"Unsere Demokratie ruht auf den Freiheitsrechten\"","","Erklärung Weichmanns - Stellungnahmen zu den Unruhen","thi, ga",[1],7,[1],[2],2,"22","4"],["5398","1968-04-19","Klaus Schütz warnt im Abgeordnetenhaus vor Überreaktionen auf die Osterunruhen. Wolfgang Landsberg, der Vorsitzende des FU-AStA, kündigt Rücktritt an, weil man sich in der FU nicht auf einen Beschluss über einen Trauermarsch für die Münchener Opfer der Unruhen einigen kann. Axel Springer betont auf einem Empfang in seinem Haus den Willen, in Berlin zu bleiben. ","Bürgermeister Schütz warnt vor Hysterie","","Berliner AStA-Vorsitzender kündigt Rücktritt an","wy, wst.",[1],7,[1],[5],2,"30","1"],["5399","1968-04-19","Zwei SDS-Mitglieder, die im Januar in München in einer Vorlesung in Polizeiuniformen aufgetreten waren, werden wegen verschiedener Delikte zu Haftstrafen verurteilt.","Gefängnisstrafen für zwei SDS-Mitglieder","","","M.K.",[8],7,[1],[2],2,"30","2"],["5400","1968-04-19","Axel Springer Verlag appelliert an Staat und Gesellschaft zur Einhaltung der Grundrechte. Erklärung im Anschluß an eine Sitzung des Gesamtbetriebsrats festgehalten ","Grundrechte achten!","","","Eigener Bericht/DPA",[10],7,[1],[2],2,"30","2"],["5401","1968-04-19","Besinnung auf die demokratische Grundordnung ist nach Eskalieren der Gewalt notwendig. Politiker sollten \"in größerer Zahl zur Stelle\" sein, um mit der jüngeren Generation ins Gespräch zu kommen.","Öffnet die Tür zum Gespräch","","","G.S.",[1],7,[5],[2],2,"30","2"],["5402","1968-04-19","Obduktionsbericht offenbart Todesursache von Rüdiger Schreck, der vermutlich nicht aktiv an der Demonstration beteiligt war. CDU/CSU, SPD und der AStA der Hamburger Universität zeigen sich bestürzt über die Todesfälle.","Schreck starb durch Schlag mit eine Bohle","","Der Obduktionsbericht liegt vor / Täter noch unbekannt","Eigener Bericht/DPA/upi",[1],7,[1],[1],1,"30","2"],["5403","1968-04-19","Brand in einem Gladbecker Möbelhaus steht in keinem Zusammenhang mit den Studentendemonstrationen","Möbelhausbrand nicht von Demonstranten gelegt","","","DPA",[1],7,[1],[2],2,"30","30"],["5404","1968-04-20","Fraktionen des Bundestages einigen sich, zu einer Sondersitzung über die innenpolitische Lage am 30. April zusammenzukommen","Bundestags-Debatte über die Unruhen","","FDP setzte sich nach langem Tauziehen durch","DPA",[9],7,[1],[5],2,"64","1"],["5405","1968-04-20","Gericht spricht zwei Angeklagte im Hauptbahnhof-Prozess frei. Ein Verurteilter wurde zu vier Monaten Gefängnis mit Bewährung und 400 Mark Geldstrafe verurteilt","Freispruch für zwei Angeklagte","\"Hauptbahnhof-Prozeß\"","","Eigener Bericht",[9],7,[1],[2],2,"64","1"],["5406","1968-04-20","Axel Springer verfechtet die demokratische Grundordnung und Werte, er hat Vertrauen in die neue Generation, welche überwiegend selbstbewusst, politisch interessiert, kritisch und \"frei von Schuld an der Vergangenheit\" ist","\"Ich habe Vertrauen in die neue Generation\"","","Axel-Springer-Interview in der \"Daily Mail\"","Springer-Auslandsdienst",[10],7,[3],[5],2,"64","2"],["5407","1968-04-20","Demonstrationsveranstaltung von etwa 1000 Beteiligten vor dem griechischen Generalkonsulat für \"freiheitliche demokratische Verhältnisse in Griechenland\"","Jugend kam zum Griechenland-Protest","","","ff",[9],7,[1],[5],1,"64","3"],["5408","1968-04-20","Gericht spricht zwei Angeklagte im Hauptbahnhof-Prozess frei. Ein Verurteilter wurde zu vier Monaten Gefängnis mit Bewährung und 400 Mark Geldstrafe verurteilt","Im \"Hauptbahnhof-Prozess\": Zwei wurden freigesprochen","","Der dritte Angeklagte erhielt 4 Monate Gefängnis mit Bewährung","Dr. Hildegard Damrow",[9],7,[7],[1],2,"64","4"],["5409","1968-04-20","Dietrich Rollmann, CD-Landesvorsitzender, lädt AStA und politische Studentengruppen zur Diskussion um die Reform von Staat und Gesellschaft ein","Rollmann lädt Studenten ein","","","k.a.",[9],7,[1],[2],2,"64","4"],["5410","1968-04-22","Regierungsparteien wollen SDS-Verbot vermeiden, um keinen Anlass zu neuen Unruhen zu geben","Koalition einig: Kein Verbot des SDS","","","Von unserer Bonner Redaktion",[8],7,[1],[5],2,"16","2"],["5411","1968-04-22","Kirche soll zwischen studentischer Jugend und Bürgern vermitteln. Diskussionskultur soll aufgebaut werden","Ein klärendes Wort des Bischofs wurde vermisst","","Diskussionsabend in der Hammer Dreifaltigkeitskirche","sic",[9],7,[1],[5],2,"16","3"],["5412","1968-04-22","Rektor und Akademischer Senat der Hamburger Universität fordern parlamentarischen Untersuchungsausschuss. Die Medien wurden dazu aufgerufen, neutral zu berichten, um eine sachliche gesellschaftliche Diskussion zu gewährleisten. Studentenverbände wollen sich in Zukunft um gewaltlose Aktionen bemühen und die Bevölkerung über die Ziele des Protestes informieren ","Akademischer Senat fordert Sonderausschuss","","Zur Untersuchung der schweren Vorwürfe","U.W.",[1],7,[1],[1],2,"16","4"],["5413","1968-04-23","Studenten  der \"forstchrittlichen Mitte\" schließen sich zur Deutschen Studentenunion zusammen und attackieren den SDS","Studenten gründen \"Fortschrittliche Mitte\"","","","Eigener bericht/ap",[11],7,[1],[2],2,"18","1"],["5414","1968-04-23","Bürgermeister, Junge Union und Bürgerschaft diskutieren mit Senats- und Studentenvertretern über die Demonstrationen und Ausschreitungen der Ostertage","Debatte über die Demonstrationen ","","Morgen in der Bürgerschaft / Harte Fronten beim gestrigen Gespräch im Rathaus","ff/thi",[1],7,[1],[5],1,"18","3"],["5415","1968-04-23","Der Semesterbeginn an der Hamburger Kunsthochschule wird mit einer Eröffnungsfeier begangen, auf der auch der AStA-Vorsitzende offiziell reden darf. Dies wird als Ausdruck des Mitspracherechts der Studenten gewertet und positiv begrüßt. ","\"Wir sind keine finsteren Revoluzzer?\"","Semesterauftakt am Lerchenfeld","Das \"Hamburger Modell\" / Renato Guttuso berufen","Gottfried Sello",[11],7,[7],[1],1,"18","11"],["5416","1968-04-23","BGH bestimmt mit Bezug auf §830 BGB, dass Steinwerfer bei Demonstrationen gemeinsam haftbar gemacht werden können, ohne dass nachgewiesen werden muss, dass sein Stein getroffen hat","BGH: Steinewerfer haften gemeinsam","","","Eigener Bericht",[9],7,[1],[2],2,"18","18"],["5417","1968-04-24","TU-Rektor Prof. Dr. Weichselberger fordert APO auf, universitätseigene Räume nicht als Treffpunkt und Vorbereitungsstätte für ihre Aktionen zu nutzen. Berlins Regierender Bürgermeister Schütz erklärt sich zu einem Gespräch mit AStA-Vertretern bereit","Verschärfte Lage an der TU Berlin","","Rektor fordert Auszug der außerparlamentarischen Opposition","Von unserer Berliner Redaktion",[11],7,[1],[1],1,"32","2"],["5418","1968-04-24","CDU-Landesvorstand diskutiert mit politischen Studentengruppen und AStA-Vertretern. Übereinkunft hinsichtlich Eindämmung der Ausschreitungen, Einberufung eines parlamentarischen Untersuchungsausschusses und schnellem Vorantreiben von Hochschulreformen erzielt","Rollmann stellt sich hinter die Studenten","","Gespräch mit dem AStA","ff",[9],7,[1],[5],2,"32","9"],["5419","1968-04-25","Bürgermeister Prof. Weichmann spricht sich gegen einen Missbrauch des Demonstrationsrechts aus. Es sei ein stärkerer Dialog mit der jungen Generation zu führen","Professor Weichmann ruft zur Besinnung auf","","Staat kann Mißbrauch des Grundrechts nicht dulden","Eigener Bericht",[9],7,[1],[1],2,"26","1"],["5420","1968-04-25","Genesung von Dutschke schreitet fort","Dutschke erholt sich","","","DPA",[2],7,[1],[2],2,"26","1"],["5421","1968-04-25","Gegendemonstration der APO zum 1. Mai wird genehmigt","Demonstration wird genehmigt","","","DPA",[1],7,[1],[2],2,"26","1"],["5422","1968-04-25","Diskussion in der Bremer Bürgerschaft über angebliche Umsturzpläne des SPD-Mitglieds Gert Settje","Umsturzpläne in der \"Lila Eule\"?","","","Eigener Bericht",[9],7,[1],[2],2,"26","1"],["5423","1968-04-25","Axel Springer Verlag reicht Schadensersatzklage gegen Horst Mahler beim Landgericht Berin ein. Mahler soll in der Nacht zum 12. April mit Demonstranten in die Geschäftsräume des Springer Verlages eingedrungen sein","Schadenersatzklage gegen Horst Mahler","","","DPA/ap",[6],7,[1],[3],2,"26","2"],["5424","1968-04-25","Die Hochschul- und Studienreform droht an der Fülle von Reformvorschlägen zu scheitern - es müsse endlich gehandelt werden. Denkbar sind auch zeitlich befristet gültige Reformsatzungen","Zeit zum Handeln","","","hoe",[4],7,[5],[5],2,"26","2"],["5425","1968-04-25","Recht auf friedliche Demonstrationen dürfe von Staats wegen nicht beschnitten, von Demonstranten aber ebenso wenig als Grundlage für Gesetzesbrüche genommen werden, so Prof. Weichmann in seiner Regierungserklärung vor der Hamburger Bürgerschaft. Es folgen die Stellungnahmen von CDU-, FDP- und SPD-Abgeordneten.","Prof. Weichmann appeliert an die Jugend","","Regierungserklärung vor der Bürgerschaft / Absage der Gewalt / Ein Wort der Besinnung","thi",[9],7,[7],[4],1,"26","4"],["5426","1968-04-25","Diskussionsveranstaltung zwischen Studenten der Ingenieurschule Hamburg, Bürgerschaftsmitgliedern sowie AStA- und SDS-Vertretern beleuchtet Verlauf und Gründe für die Ausschreitungen zu Ostern","Sprecher rieten zur Besonnenheit","","Diskussion in der Ingenieurschule","ff",[9],7,[1],[1],1,"26","9"],["5427","1968-04-25","Klaus Schütz ist zu einem Gespräch mit Studentenvertretern bereit, jedoch nicht zu einem Umfunktionieren der Diskussion durch die APO, welche zwei ihrer Hauptsprecher abgesandt hat, die keiner Hoschulvertretung angehören","Fronten in Berlin erneut verhärtet","","Gespräche Schütz - Studenten in Frage gestellt / Sondersitzung am 30. April","DPA",[9],7,[1],[5],1,"26","11"],["5428","1968-04-26","Heidelberger Studenten bezeichnen Kiesinger in Sprechchören als \"Nazi\", \"Lügner\" und \"Schwätzer\" - dieser muss seine Rede abbrechen. Auch Konfrontationen in Biberach, Konstanz und Karlsruhe","Studenten zwangen Kiesinger zur Diskussion","","Lärmszenen in Heidelberg und Karlsruhe","Eigener Bericht/DPA",[1],7,[1],[5],2,"40","1"],["5429","1968-04-26","Polizeipräsident Jürgen Wenzel erstattet Strafanzeige gegen AStA wegen übler Nachrede","Polizeipräsident zeigt Studenten an","","","k.a.",[9],7,[1],[2],2,"40","3"],["5430","1968-04-26","Studentenparlament beschließt mehr Diskussions- und Aufklärungsveranstaltungen statt Demonstrationen und Streiks. Ebenfalls gefordert wird die Einsetzung eines parlamentarischen Untersuchungsausschusses zur Klärung der Ausschreitungen zu Ostern","Studentenparlament gegen \"spektakuläre Aktionen\"","","Nach langer Nachtsitzung / Untersuchungsausschuß gefordert","ff",[11],7,[1],[1],2,"40","3"],["5431","1968-04-26","Rektor und Dekane äußern sich vor dem Bürgerschaftlichen Ausschuss für Schule und Universität zum neuen Hochschulgesetz. Sie sprechen sich u.a. für eine Beibehaltung der Fakultäten aus","Anhörverfahren mit Ordinarien","","Rektor und Dekane kamen zu Wort","U.W.",[9],7,[1],[1],2,"40","4"],["5432","1968-05-02","APO nutzt Immatrikulationsveranstaltung zur Aufklärung über 1. Mai-Aktionen. AStA und Fakultätssprecher können Erstsemester nicht wie geplant über Studienfragen beraten","Unter Protest zog der AStA aus","","Immatrikuationsversammlung gesprengt","U.W.",[11],7,[1],[1],2,"28","5"],["5433","1968-05-03","Klaus Schütz äußert sich kritisch zur Teilnahme der SED an der Mai-Kundgebung der APO; bezeichnet dies als \"bemerkenswerten Tatbestand\"","Schütz: SED fand neue Plattform in West-Berlin","","Annäherung an die außerparlamentarische Opposition","Eigener Bericht",[11],7,[1],[1],2,"40","2"],["5434","1968-05-03","Diskussion des \"Sinneswandels\" der SED zur \"radikalen jugendlichen Protestbewegung\"","SED unterwandert Protestbewegung","","","Wy",[11],7,[5],[5],2,"40","2"],["5435","1968-05-03","Studentenparlament der Hamburger Universität protestiert gegen die Verhaftung von Karl-Heinz Roth; weitere Diskussion des Falls für die Vollversammlung der Studentschaft angekündigt","Proteste gegen Verhaftung eines SDS-Mitgliedes","","Vollversammlung der Studentenschaft","U.W.",[11,1,8],7,[1],[1],1,"40","3"],["5436","1968-05-04","Vietnam-Kundgebung im Auditorium maximum angekündigt","Mittwoch im Audimax: Kundgebung für Vietnam","","","k.a.",[9],7,[1],[2],2,"72","5"],["5437","1968-05-04","Karl-Heinz Roth frei gelassen - Hamburger Landgericht gibt Haftbeschwerde statt","Roth wieder auf freiem Fuß","","","k.a.",[9],7,[1],[2],2,"72","5"],["5438","1968-05-04","Generalstaatsanwalt Hans Günther beantragt Voruntersuchung gegen Horst Mahler","Verfahren gegen Mahler beantragt","","","AP",[6],7,[1],[2],2,"72","9"],["5439","1968-05-06","Parteien beraten über gesetzgeberische Zuständigkeiten des Bundes in der Hochschulreform am Vorabend der Kultur-Debatte im Bundestag","Harte Debatte über Hochschulreform erwartet","","","Von unserer Bonner Redaktion",[4],7,[1],[2],2,"72","1"],["5440","1968-05-07","Bundestag debattiert über Studenten-Proteste und Beschleunigung der Hochschulreform","Heute zweite Debatte über Studenten-Unruhen","","Kabinett prüft politisches Mandat der Studentenschaft","Von unserer Bonner Redaktion",[4],7,[1],[5],2,"18","2"],["5441","1968-05-07","Richtigstellung der Berichte und vermeintlich sinnentstellter Zitate, mit denen \"Der Spiegel\" versuchte, den Axel Springer Verlag in Zusammenhang mit dem Mordanschlag auf Dutschke und den Oster-Unruhen zu bringen","So \"zitiert\" der Spiegel","","","k.a.",[10],7,[5],[5],2,"18","2"],["5442","1968-05-08","Bund und Länder einigen sich auf gemeinsame Hochschulreform (Neugestaltung des Lehr- und Prüfungswesens, Reform des Berufungsverfahrens, Mitspracherecht der Studenten)","Bund und Länder für schnelle Hochschulreform","","","Von unserer Bonner Redaktion",[4],7,[1],[2],2,"32","1"],["5443","1968-05-08","Studenten veranstalten \"Notstandsübungen\", um auf mögliche Folgen der Notstandsgesetze hinzuweisen","Studenten \"übten\" den Notstand","","","k.a.",[1],7,[1],[3],2,"32","4"],["5444","1968-05-08","Stoltenberg kündigt in der Bundestagsdebatte schnelle Umsetzung der Hochschulreformen an und setzt sich für eine überregionale Bildungsplanung ein. Bund und Länder drängen auf gemeinsame Zusammenarbeit","Plädoyer für schnelle Hochschulreform","","Stoltenberg: Überregionale Bildungsplanung!","Von unserer Bonner Redaktion",[4],7,[7],[1],1,"32","10"],["5445","1968-05-09","Sigrid Fronius, SDS-Mitglied, wird vom Konvent der FU Berlin zur AStA-Vorsitzenden gewählt","SDS-Mitglied wurde AStA-Vorsitzende","","","Eigener Bericht/DPA",[8],7,[1],[2],2,"28","1"],["5446","1968-05-09","Zwei Hauptwachtmeister werden wegen gemeinschaftlicher Körperverletzung im Amt während des Schah-Besuchs zu je vier Monaten verurteilt. Beide bestreiten den Vorfall und legen Berufung ein","Zwei Berliner Polizisten verurteilt","","","DPA/ap/upi",[7],7,[1],[2],2,"28","1"],["5447","1968-05-09","Hochschulgesetzentwurf wird am 26. Juni der Bürgerschaft vorgelegt","Weichmann: \"Ein recht gutes Gesetz\"","","","thi",[4],7,[1],[2],2,"28","4"],["5448","1968-05-09","Studenten protestieren in der Innenstadt gegen Notstandsgesetze. Erneut Haftbefehl gegen Karl-Heinz Roth erlassen","Weitere Proteste gegen Notstandsgesetzgebung","","\"Ironische Demonstration\" / Haftbefehl gegen Roth","ff",[1],7,[1],[5],2,"28","8"],["5449","1968-05-10","Finanzierung der Bremer Universität auf Konferenz der Ministerpräsidenten in Bonn geklärt","Bremer Universität wird Wirklichkeit","","","Eigener Bericht",[11],7,[1],[3],2,"40","1"],["5450","1968-05-10","Polizei und Behörden bereiten sich auf \"Sternmarsch\" der Gegner der Notstandsgesetze vor. NRW-Innenminister Weyer sieht keinen Grund zur Besorgnis","\"Sternmarsch\" auf Bonn - kein Anlass zur Nervosität","","Innenminister Weyer leitet Polizei-Einsatz","Von unserer Bonner Redaktion",[1],7,[1],[5],2,"40","2"],["5451","1968-05-10","AStA beantragt Vorlesungsstopp während der Bundestagsdebatte über die Notstandsgesetze im Akademischen Senat","Vorlesungsstopp wegen der Notstandsdebatte?","","Antrag des AStA beim Akademischen Senat","ff",[9],7,[1],[5],2,"40","3"],["5452","1968-05-11","Der sich für eine Zusammenarbeit mit der SED aussprechende AStA der TU Berlin wird durch eine Abstimmung des Studentenparlaments gestürzt","TU-Studenten fordern: SED soll Farbe bekennen","","AStA von Gemäßigten nach Nachtdebatte gestürzt","Eigener Bericht",[11],7,[1],[5],2,"72","1"],["5453","1968-05-11","Urabstimmung zum Ende des Sommersemesters soll entscheiden, ob die Studenten der Universität München Mitglied im VDS bleiben wollen","Urabstimmung in München","","","DPA",[11],7,[1],[2],2,"72","1"],["5454","1968-05-11","Bonn bereitet sich auf den \"Sternmarsch\" vor. Bundes- und Vizekanzler sehen keine Notwendigkeit, ihre Auswärtstermine anzuändern","Bonn sieht dem Sternmarsch gelassen entgegen","","Kiesinger und Brandt nicht in der Bundeshauptstadt","Von unserer Bonner Redaktion",[1],7,[1],[5],2,"72","2"],["5455","1968-05-11","Landgericht Hamburg verbietet der Wochenzeitung \"Die Zeit\" die Behauptung, die Presse des Springer Verlages hätte bei der Berichterstattung über die Oster-Unruhen Nachrichten konsequent unterdrückt","Einstweilige Verfügung","","","Eigener Bericht/DPA",[10],7,[1],[3],2,"72","2"],["5456","1968-05-14","Kieler Studenten wollen Berlins Regierenden Bürgermeister, Klaus Schütz, bei seiner geplanten Eröffnungsrede zu Beginn der Kieler Woche mit Protesten empfangen, wenn er nicht zu einer gemeinsamen Diskussion bereit ist","Kieler Studenten protestieren gegen Schütz","","","Eigener Bericht",[9],7,[1],[2],2,"18","1"],["5457","1968-05-14","Innensenator Hein Runau kündigt Diskussion über künftige Formen politischer Demonstrationen mit relevanten Gesprächspartnern an und fordert diese zur Einreichung von Vorschlägen auf","Ruhnau führt Gespräche über Demonstrationen","","Organisationen sollen Vorschläge übermitteln","thi",[9],7,[1],[5],1,"18","4"],["5458","1968-05-14","Fernseh- und Rundfunktgeräte an der Hamburger Universität und Hochschule für bildende Künste soll das Mitverfolgen der Notstandsdebatte im Bundestag sicherstellen. Am Abend ist eine Diskussionsveranstaltung im Audimax geplant","Studenten sollen Debatte hören","","Abends wird über den Notstand diskutiert","U.W.",[9],7,[1],[5],2,"18","4"],["5459","1968-05-14","Studenten der Hamburger Universität geben Schülern der 7. und 8. Klasse im Rahmen der Aktion \"Bildungswerbung\" Nachhilfe","Studenten halfen bei Schulaufgaben","","","k.a.",[9],7,[1],[2],2,"18","5"],["5460","1968-05-14","Berliner Jugendschöffengericht spricht 19jährigen frei, der angeklagt wurde, Teilnehmer eines \"verbotenen Auflaufs\" gewesen zu sein. Er wurde bei der Demonstration auf dem Kurfürstendamm am Ostersonnabend von der Polizei aufgegriffen. Dieses erste Urteil ist möglicherweise von grundsätzlicher Bedeutung.","Jugendlicher Demonstrant in Berlin freigesprochen","","","Eigener Bericht/DPA",[1],7,[1],[2],2,"18","9"],["5461","1968-05-14","Studentenversammlung der Hochschule für bildende Künste Hamburg verabschiedet neue Satzung","Neue Satzung","","","s.",[11],7,[1],[2],2,"18","12"],["5462","1968-05-15","Rudi Dutschke wird entferntes Stück der Schädeldecke eingesetzt; OP verläuft ohne Komplikationen","Nachoperation Dutschkes ohne Komplikationen","","","DPA",[2],7,[1],[2],2,"33","1"],["5463","1968-05-15","SED nicht zu einer stärkeren Zusammenabeit mit der APO bereit. Aufsatz von Kurt Hager erscheint im \"Forum\", der Studentenzeitschrift der FDJ","SED misstraut linken Rebellen","","","Von unserer Berliner Redaktion",[9],7,[1],[3],2,"33","2"],["5464","1968-05-15","\"Teach-in\" und Proteste an der Hamburger Universität stören der Lehrbetrieb und werden nicht von allen Studenten begrüßt","Debatten über den Notstand in der Uni","","","U.W./ff.",[1],7,[7],[5],2,"33","3"],["5465","1968-05-15","SPD will Reformplan für ein neues Hochschulgesetz vorlegen, Hauptpunkte werden vorgestellt. AStA sieht darin nicht den \"langerwarteten Durchbruch\"","AStA kritisiert SPD-Reformplan","","Von der Fraktion gestern veröffentlicht","thi",[4],7,[1],[1],2,"33","4"],["5466","1968-05-15","750 Kieler Studenten verschafften sich mit gefälschten Eintrittskarten Zugang zur Rektorats-Feier im Kieler Schloss. Die dort geplante Feierstunde zur Rektoratsübergabe an der Christian-Albrecht-Universität wurde abgesagt; auf dem Weg befindliche Honoratioren mussten umkehren.","Kieler Studenten ließen Rektorats-Feier platzen","","Protest gegen \"Muff-out\" mit \"Mummenschanz\"","Eigener Bericht/ap",[1],7,[1],[5],2,"33","11"],["5467","1968-05-16","Bundesverteidigungsministerium will Bundeswehreinheiten nicht gegen Demonstranten einsetzen","Keine Bundeswehr gegen Demonstranten","","","upi",[1],7,[1],[3],2,"24","1"],["5468","1968-05-16","Protestaktionen und Streiks dominieren an allen deutschen Hochschulen kurz vor Verabschiedung der Notstandsgesetze. Belegschaftsmitglieder einzelner Betriebe unterstützten die Maßnahmen und veranstalteten Warnstreiks. Auseinandersetzungen zwischen Frankfurter SDS und Studenten","Tausende protestierten gegen Notstandsgesetze","","Aufruf zum Generalstreik / Zwischenfälle in Frankfurt","Eigener Bericht/ap/DPA/upi",[1],7,[1],[5],2,"24","1"],["5469","1968-05-16","Vorlesungsstreiks und Diskussionen begleiten die Bundestagsdebatte über die Notstandsgesetze an der Hamburger Universität. Im Audimax findet eine Diskussionsveranstaltung zwischen Studenten-, Partei- und Gewerkschaftsvertretern mit 2000 Teilnehmerm statt, darunter auch Schüler und ältere Leute.","Fast zwei Drittel blieben den Vorlesungen fern","","Uni im Zeichen der Notstandsdebatte","ff",[9],7,[7],[1],1,"24","3"],["5470","1968-05-16","Oberstaatsanwalt fordert Bericht der Polizei an, warum der Haftbefehl gegen Karl-Heinz Roth bisher nicht vollstreckt wurde. Roth hatte zwei Tage zuvor an einer Diskussionsveranstaltung der Hamburger Universität teilgenommen und dort gesprochen","Wird der Haftbefehl gegen Roth vollstreckt?","","Staatsanwaltschaft fordert Bericht von der Polizei","ga",[9],7,[1],[5],2,"24","3"],["5471","1968-05-16","Anlässlich ihres Delegiertentages fordert die Gewerkschaft der Polizei eine Ausrüstung, mit der sie bei Krawallen besser geschützt ist.","Bessere Ausrüstung für die Polizeibeamten gefordert","","Schutzbrillen und Schilde","wo.",[1],7,[1],[1],1,"24","4"],["5472","1968-05-16","Erster Bürgermeister trifft sich zu einem Meinungsaustausch mit Vertretern verschiedener Jugendverbände. Letztere hatten darauf bestanden, dass das Gespräch per Tonband aufgezeichnet wird.","Jugend und Senat sind sich über vieles einig","","Gespräch bei Prof. Weichmann \"in guter Atmosphäre\"","ff",[1],7,[1],[2],2,"24","4"],["5473","1968-05-16","Vorgesehene Rektorenwahl musste auf Einspruch der Studenten verschoben werden, die wünschten dabeisein zu können.","Rektorwahl verschoben","","","U.W.",[11],7,[1],[5],1,"24","4"],["5474","1968-05-16","Ereignisse der Oster-Unruhen sollen vor dem Innenausschuss der Bürgerschaft öffentlich behandelt werden. Vertreter des AStA, des Rings politischer Jungend und des Jugendrings sollen Stellung nehmen","Osterunruhen werden öffentlich diskutiert","","","k.a.",[1],7,[1],[2],2,"24","5"],["5475","1968-05-17","Bürgerschaftsausschuss berät in erster Anhörung über Akademiegesetz. Ingenieurschulen sollen in Akademien und Körperschaften des öffentlichen Rechts umgewandelt werden ","Nach den Protesten folgen jetzt Gespräche","","Bürgerschaftsausschuß diskutiert Akadamiegesetz","ff",[4],7,[1],[5],2,"32","5"],["5476","1968-05-17","Kein Klassenbündnis in Sicht: radikale Studentenbewegung kann Arbeiterschaft auch in Zukunft nicht für sich gewinnen","Rudi Dutschke und die deutschen Arbeiter","","Radikalismus und Ideologien nicht mehr gefragt","Dr. Erich Hoepfner",[2],7,[5],[5],1,"32","14"],["5477","1968-05-18","FDP diskutiert über Oster-Unruhen auf ihrem Landesparteitag. Angestrebt wird die Einforderung eines parlamentarischen Untersuchungsausschusses ","FDP-Parteitag diskutiert über die Osterunruhen","","","k.a.",[9],7,[1],[2],2,"70","5"],["5478","1968-05-20","Hamburgs Polizeipräsident äußert sich zu den Osterzusammenstößen zwischen Demonstranten und Polizisten. Die Eskalation von Gewalt und Gegengewalt soll künftig vermieden werden.","Flexible Taktik der Polizei wird weiter ausgebaut","","Dr. Frenzel: Eskalation vermeiden","wo.",[10],7,[1],[1],1,"20","3"],["5479","1968-05-20","Sachschaden bei Verwüstung der SDS-Zentrale am Kudamm und eines APO-Büros in Tiergarten.","Berliner SDS-Zentrale verwüstet","","","wy.",[8],7,[1],[2],2,"20","9"],["5480","1968-05-21","2000 Studenten fordern vor der DGB-Zentrale München den Generalstreik zur Abwendung der Notstandsgesetze. Diskussion soll in einem kleineren Rahmen fortgesetzt werden","Münchener DGB empfing Demonstranten mit Musik","","Weiter Unruhe an Hochschulen / Notstands-Proteste","Eigener Bericht/DPA/ap/upi",[1],7,[1],[5],2,"22","2"],["5481","1968-05-21","CDU und FDP beschließen unabhängig voneinander, vorläufig keinen parlamentarischen Untersuchungsausschuss zu den Ereignissen der Oster-Unruhen zu beantragen","CDU und FDP: Keinen Untersuchungsausschuss","","Demonstrationen werden im Anhörverfahren erörtert","thi",[9],7,[1],[5],2,"22","3"],["5482","1968-05-22","Axel Springer stellt in der ZDF-Sendung \"Bilanz\" klar, dass es ein \"Meinungsmonopol\" aufgrund der Vielfalt der Kommunikationsmittel nicht geben würde.","Springer: Es gibt kein Meinungsmonopol","","Vielfalt der Informationsmittel verhindert es","Eigener Bericht",[10],7,[1],[5],2,"40","2"],["5483","1968-05-22","SPD schließt in ihren Richtlinien für ein neues Akadamiegesetz alle Höheren Fachschulen ein. Diese sollen in Akademien umgewandelt werden. Studenten fordern, Ingenieurschulen in den Gesamt-Hochschulbereich einzugliedern, drohen sonst mit Vorlesungsstreik.","Vorlesungsstreik droht","","SPD: Höhere Fachschulen sollen Akademien werden","thi",[4],7,[1],[3],2,"40","5"],["5484","1968-05-24","AstA der Hamburger Universität begrüßt Hochschulgesetzentwurf der CDU-Fraktion, u.a. die hier festgeschriebene Mitbestimmung aller Universitätsmitglieder","AStA begrüßt CDU-Entwurf","","","k.a.",[4],7,[1],[2],2,"36","3"],["5485","1968-05-27","APO will vor der Verabschiedung der Notstandsgesetze bundesweit gegen diese protestieren. Die Diskussionen in der SPD nehmen zu; Willy Brandt fordert namentliche Abstimmung in der dritten Lesung","Protestwelle vor ihrem Höhepunkt","","Heftige Diskussionen in der SPD um Notstandsgesetze","Von unserer Bonner Redaktion",[9],7,[1],[5],2,"18","1"],["5486","1968-05-27","SDS-Mitglieder schlagen einen Studenten und einen Taxifahrer auf dem Gelände der Hamburger Universität zusammen. Diese wollten andere Studenten mit einem Plakat gegen den vom SDS geplanten Vorlesungsstreik mobilisieren","Schlägerei vor der Hamburger Uni","","","Eigener Bericht",[1],7,[1],[2],2,"18","1"],["5487","1968-05-27","Diskussion über demokratische Strukturen, Notstandsgesetze, Wahlrechtsreform","Ausdiskutieren!","","","G.G.",[9],7,[5],[5],2,"18","2"],["5488","1968-05-27","AStA und Studentenparlament beschäftigt sich mit Verhaftung von Herbert von Fintel, dem Straftaten bei den Oster-Unruhen zur Last gelegt wurden. Vizekanzler Brandt und DBG-Chef Höhne unterzeichnen Resolution zur Freilassung von Fintel","Kritik an Verhaftung des SHB-Vorsitzenden","","Prominente SPD-Politiker nahmen Stellung","ga.",[9,11,1],7,[1],[5],2,"18","3"],["5489","1968-05-28","AStA beschließt mehrtägigen Vorlesungsstreik \"ohne körperliche Gewalt\", Versammlungen und Demonstrationen. Herbert von Fintel wieder frei gelassen","AStA: Alle Demonstrationen \"ohne körperliche Gewalt\"","","Vorlesungsstreik bis Donnerstag / Von Fintel wieder frei","ff",[1],7,[1],[1],2,"30","4"],["5490","1968-05-29","Bundesweite Protestaktionen zu den Notstandsgesetzen; Berichte aus Berlin, Göttingen, München, Frankfurt und Stuttgart","Notstands-Debatten auf Theater-Bühnen","","Die Welle der Protestaktionen schwillt weiter an","DPA/ap/upi",[1],7,[1],[5],2,"32","2"],["5491","1968-05-29","Bei der bisher größten Demonstration gegen die Notstandsgesetze in Hamburg nehmen 8000 Menschen teil. Die anschließende Diskussionsveranstaltung im Audimax mit mehreren Politikern wird von Tumulten überlagert","Am Ende Tumulte im vollen Audimax","","8000 demonstrieren gestern in Hamburg","ff",[1],7,[7],[1],1,"32","3"],["5492","1968-05-30","Kriminalpolizei ruft zur Mitfahndung nach Karl-Heinz Roth auf","Polizei fahndet nach SDS-Roth","","","ff",[9],7,[1],[2],2,"22","3"],["5493","1968-05-30","Studenten dringen in das Schauspielhaus ein; Diskussion mit den Theatergästen über die Notstandsgesetze scheitert; \"Diskussionstrupps\" versuchen an mehreren Stellen in der Stadt, mit der Bevölkerung ins Gespräch zu kommen","Tumult im Schauspielhaus -Von Demonstranten besetzt","","Notstandsgegner stürmten die Bühne / Theatergäste gingen","vcb/ff",[1],7,[7],[5],1,"22","3"],["5494","1968-05-31","Bundesweite Protestaktionen zu den Notstandsgesetzen; in Frankfurt besetzen Studenten das Schauspielhaus","Die Protestwelle ebbt langsam ab","","","DPA/ap/upi",[1],7,[1],[3],2,"28","1"],["5495","1968-05-31","Letzte Protestaktion gegen die Notstandsgesetze mit 1000 Teilnehmern im Audimax; Gründe für die Niederlage werden erörtert. Jens Litten, Zweiter Vorsitzender des AStA schlägt vor, kollektiv in die SPD einzutreten","Littens Vorschlag ging in Zwischenrufen unter","","AStA-Vorsitzender plädiert für Eintritt in die SPD","ff",[1],7,[1],[5],1,"28","3"],["5496","1968-06-01","Haussuchung der Polizei im Frankfurter Büro des SDS-Bundesvorstands. Die Polizei suchte nach Akten, die während der studentischen Besetzung der Universität aus dem Rektorat verschwunden sind.","Haussuchung beim SDS","","","k.a.",[8],7,[1],[5],1,"60","2"],["5497","1968-06-07","Peter Brandt, Sohn Willy Brandts, wird \"wegen Auflaufs in zwei Fällen\" zu einem Dauerarrest von zwei Wochen verurteilt. Sein Verteidiger, Horst Mahler, legt Berufung ein.","Zwei Wochen Arrest für Peter Brandt","","","DPA/ap",[1],7,[1],[2],2,"28","2"],["5498","1968-06-07","Höhere Fachschulen legen ihre Ansichten über das Akademiegesetz dem Bürgerschaftsausschuss für Schule und Universität dar. Gefordert wird u.a. ein Staatsexamen nach dem sechssemestrigen Studium","Ihre Forderung: Staatsexamen","","","ff",[4],7,[1],[3],2,"28","10"],["5499","1968-06-10","Gewalt und Terror werden von der Jugend abgelehnt, so Bundesfamilienminister Heck","Der Jugend geht es nicht um Radau","","","DPA",[9],7,[1],[3],2,"16","2"],["5500","1968-06-11","Dutschke reist zur Nachbehandlung nach Zürich; Attentäter wollte sich im Untersuchungsgefängnis erhängen","Rudi Dutschke in die Schweiz gereist","","","DPA",[2],7,[1],[2],2,"18","2"],["5501","1968-06-11","CDU- und SPD-Fraktion streiten über einen Beratungstermin des CDU-Universitätsgesetzentwurfs in der Hamburger Bürgerschaft","Streit um Hamburger Universitätsgesetz","","","Eigener Bericht",[4],7,[1],[3],2,"18","2"],["5502","1968-06-11","SPD-Entwurf zum Gesetz über die Fachhochschulen wird von Studenten positiv aufgenommen. Eine Beratung in der Hamburger Bürgerschaft ist für den 26. Juni geplant","Ingenieurschule mit Staatsexamen","","Studenten begrüßen SPD-Gesetzentwurf","ff",[4],7,[1],[5],2,"18","5"],["5503","1968-06-11","Bremer Senat rechnet mit Grundsteinlegung für Universität im Frühjahr 1970; erste Vorlesungen sollen im Wintersemester 1972/73 beginnen. Bausumme wird auf 800 bis 1000 Millionen DM geschätzt","Universität an der Weser","","Bremer Senat will 1970 den Grundstein legen","Eigener Bericht",[11],7,[1],[5],2,"18","15"],["5504","1968-06-12","60000 Ingenieurstudenten treten bundesweit in den Vorlesungsstreik und demonstrieren für eine Schulreform. Hamburg bildet eine Ausnahme; hier findet der SPD-Entwurf zum Gesetz über die Fachhochschulen Anklang bei den Studenten","Ingenieurstudenten im Vorlesungsstreik","","","DPA/ap",[1],7,[1],[2],2,"30","1"],["5505","1968-06-13","Ingenieur-Studenten dringen ins Düsseldorfer Landtagsgebäude ein und diskutieren mit Abgeordneten; sie protestieren gegen die Reformvorschläge der Kultusminister-Konferenz","Ingenieur-Studenten diskutieren mit Abgeordneten","","","k.a.",[1],7,[1],[5],1,"18","2"],["5506","1968-06-13","Bürgermeister Weichmann verliest in der Hamburger Bürgerschaft Erklärung des Senats zur Berlin-Situation. SPD stimmt Diskussion des CDU-Universitätsgesetzentwurfs zu; dieser wird zur weiteren Beratung an den Ausschuss für Schule und Universität überwiesen.","In letzter Minute kam es doch zu einer Einigung","","Bürgerschaft diskutierte über CDU-Entwurf für Uni-Gesetz","thi/ga",[4],7,[7],[1],1,"18","4"],["5507","1968-06-14","Barbara Pöhls wird neue Präsidentin des Studentenparlaments nachdem Alfred Siercke sein Amt überraschend niederlegte. Bei einer Diskussionsveranstaltung mit Bürgerschaftsabgeordneten sah er sich außerstande, Störversuche zu unterbinden","Nach Störversuchen: Präsident trat zurück","","Turbulente Sitzung des Studentenparlaments","ff",[1],7,[1],[5],1,"30","4"],["5508","1968-06-14","Nach der SPD bringt auch die CDU-Fraktion der Hamburger Bürgerschaft einen Entwurf für ein Fachhochschulgesetz ein; er soll am 25. Juni beraten werden","Konsequenter in den Zielsetzungen","","CDU-Entwurf für Fachhochschulgesetz","ff",[4],7,[1],[5],2,"30","12"],["5509","1968-06-15","Jugendring und Bürgerkomitee protestieren gegen den Beschluss der SPD, Innensenator Heinz Ruhnau und die Polizeiführung beim Anhörverfahren über die Oster-Unruhen unter Ausschluss der Öffentlichkeit sprechen zu lassen","Protest gegen Ausschluss der Öffentlichkeit","","","k.a.",[1],7,[1],[2],2,"62","5"],["5510","1968-06-19","Senat beantragt bei der Hamburger Bürgerschaft 45 neue Stellen für Wissenschaftliche Räte und Oberräte, um die Lehrsituation an der Universität zu verbessern","Lehrpersonal der Uni wird verstärkt","","","k.a.",[11],7,[1],[2],2,"26","3"],["5511","1968-06-22","Akademischer Senat folgt der AStA-Forderung nach Beteiligung der Studenten, Assistenten und nichthabilitierten Dauerstelleninhaber an der Wahl zum Rektor der Hamburger Universität","Auch Studenten dürfen mitwählen","","","k.a.",[11],7,[1],[2],2,"60","4"],["5512","1968-06-22","Akademischer Senat der Universität Hamburg kritisiert den Regierungsentwurf für ein neues Hochschulgesetz. Es wird bezweifelt, ob mit ihm die angestrebten Ziele verwirklicht werden können oder ob das Leistungsniveau und die weitere Entwicklung der Hamburger Universität gefährdet würde","Uni kritisiert Hochschulgesetz","","Akademischer Senat: Ernste Bedenken","ff",[4],7,[1],[5],2,"60","4"],["5513","1968-06-25","Berliner SPD-Landesvorstand billigt den vom OSI eingebrachten Entwurf einer Institutssatzung. Diese sieht u.a. die Einführung einer \"Drittel-Parität\" im Institutsrat vor, die Professoren, Studenten und Assistenten gleichberechtigt. Die Satzung muss noch vom Akademischen Senat der FU Berlin verabschiedet werden.","Berliner SPD begrüßt Experiment an der FU","","Satzung des Otto-Suhr-Instituts bringt Drittel-Parität","Von unserer Berliner Redaktion",[11],7,[1],[5],2,"18","2"],["5514","1968-06-25","Neun Professoren üben Kritik am Entwurf des Hamburger Senats für ein neues Hochschulgesetz; sehen diesen sogar als Rückschritt an. Sie erinnern an ihre im Januar vorgestellten 81 Leitsätze zur Hochschulreform","Neun Professoren üben Kritik am Unigesetz","","Sie sagen: \"Keine Reform, sondern Rückschritt\"","ff",[4],7,[1],[5],2,"18","4"],["5515","1968-06-25","Drei Dozenten der Deutschen Film- und Fernsehakademie treten zurück, weil sie unüberbrückbare Differenzen zwischen den \"administrativ-reaktionären\" Vorstellung der Dozentenschaft und dem \"romantisch-revolutionären Programm\" der Studenten sehen.","Streit in der Filmakademie","","","k.a.",[11],7,[1],[2],2,"18","11"],["5516","1968-06-26","Prof. Dr. Robert Werner verlässt die FU Berlin wegen anhaltender Studentenproteste; auch andere Hochschullehrer sollen über diesen Schritt nachdenken","Professor verlässt FU","","","Von unserer Berliner Redaktion",[9],7,[1],[3],2,"28","2"],["5517","1968-06-26","Studenten der Physikalisch-Technischen Lehranstalt Wedel protestieren in Kiel für ein neues Akademiegesetz und wollen vor dem Landeshaus eine Resolution übergeben","Wedeler Studenten protestieren in Kiel","","","k.a.",[4],7,[1],[2],2,"28","3"],["5518","1968-06-27","Vollversammlung der Hamburger Universität erhöht den Kreis der Wähler für die anstehende Rektorwahl auf 249. Erstmals dürfen auch Studenten, Assistenten und nichthabilitierte Beamte sowie Angestellte abstimmen","249 wählen den Rektor","","Beschluß der Vollversammlung / Ohne Öffentlichkeit","U.W.",[11],7,[1],[3],2,"18","4"],["5519","1968-06-28","Studenten besetzen japanologisches und sinologisches Institut sowie Rektoratsgebäude der FU Berlin; Polizei muss eingreifen. Vollversammlung soll weiteres Vorgehen der Studentenschaft klären","Neue Krisen an Berlins Freier Universität","","Polizei räumte von Studenten besetztes Rektorat","Von unserer Berliner Redaktion",[1],7,[1],[5],2,"24","1"],["5520","1968-06-28","VDS und FDJ diskutieren in Ost-Berlin; weitere Kontaktaufnahmen sind geplant","Gespräch VDS-FDJ","","","DPA",[9],7,[1],[3],2,"24","19"],["5521","1968-06-29","Max-Planck-Gesellschaft macht Vielzahl von Studenten bei mangelnden Studienkapazitäten für die gegenwärten Ereignisse verantwortlich; nur wenige Universitten hätten bspw. Zulassungsbeschränkungen eingeführt","Studenten-Massen nicht zu bewältigen","","","DPA",[11],7,[1],[3],2,"64","1"],["5522","1968-06-29","Akademischer Senat der FU Berlin weist Satzungsentwurf für das OSI zurück. Daraufhin besetzen 800 Studenten Räume der Wirtschafts- und Sozialwissenschaftlichen Fakultät","Wieder Unruhen an der Freien Universität","","","Von unserer Berliner Redaktion",[1],7,[1],[2],2,"64","1"],["5523","1968-06-29","Hans Martin Z. entkommt Polizeifahndung; ihm wird vorgeworfen am Sturz des Wissmann-Denkmals in der Hamburger Universität betiligt gewesen zu sein","Der Student entkam im Gedränge","","","k.a.",[1],7,[1],[2],2,"64","3"],["5524","1968-07-02","Eine Diskussionsveranstaltung des RCDS mit Bundesinnenminister Benda in der Kölner Universität wurde zeitweise von Studenten in ein \"Happening\" umfunktioniert.","\"Happening\" mit Benda","","","",[1],7,[1],[2],1,"16","1"],["5525","1968-07-02","Über die bevorstehenden Wahlen zum Hamburger Studentenparlament. Deutlich weniger Kandidaten als im letzten Semester stellen sich zur Wahl, dies wird mit einer \"Aktionsmüdigkeit\" erklärt. Vorstellung der Ziele der verschiedenen Wahlgemeinschaften/ Studentenverbände (u. a. SDS, SHB und die Gemeinschaft mit dem RCDS).","Sie alle werben um die Stimmen der Studenten","","Die Kandidaten erläutern ihr Programm","U. W.",[4],7,[1],[5],1,"16","4"],["5526","1968-07-03","Eine kurzzeitige Besetzung des Japanologischen Instituts der FU Berlin wurde nach Aushandlung eines Kompromißes zwischen Rektor Harndt und Studenten beigelegt. Das Institut soll nun räumlich wie auch personell neu geordnet werden. Eine Vollversammlung des Otto-Suhr-Institus beschloss unterdessen, die vom Akademischen Senat bereits abgelehnte neue Satzung für das OSI unverändert erneut vor den Akademischen Senat zu bringen. In Bonn konstituierte sich ein \"Arbeitskreis zur Beratung des nationalen Bildungswesens\". Dr. Kastler sprach Daniel Cohn-Bendit und \"seinen Kameraden\" seinen Dank aus, ohne sie würde man immer noch auf dem Ruhekissen eines guten Gewissens schlafen.","Kompromiss an der FU","","Das Japanologische Institut wird reformiert","wy",[1],7,[1],[2],2,"30","2"],["5527","1968-07-05","Etwa 100 Studenten verhinderten die Wahl des neuen Hamburger Rektors, indem sie die Räume der dafür vorgesehenen Vollversammlung blockierten. Man wollte so eine öffentliche Wahl erwzingen. Es kam zu Handgreiflichkeiten. ","Rektorwahl verhindert","","","",[1],7,[1],[5],1,"28","1"],["5528","1968-07-06","Die Ministerpräsidenten der Bundesländer haben sich darauf geeinigt, Ingenieurschulen und gleichrangige Bildungseinrichtungen künftig unter dem Status Fachhochschulen zu führen.","Ingenieurschulen werden Fachhochschulen","","","",[4],7,[1],[3],2,"62","1"],["5529","1968-07-06","Ausgang der Wahlen zum Hamburger Studentenparlament. Etwa 42 Prozent der Studenten beteiligten sich, als Wahlsieger werden die Unabhängigen mit 19 Sitzen angesehen, der SHB errang elf, der RCDS zehn Sitze. Der SDS errang gar keinen Sitz. Insbesondere die Vertreter des amtierenden AStA erhielten hohe Stimmanteile.","Großer Wahlerfolg für die Vorsitzenden des Hamburger AStA","","8000 gaben ihre Stimme ab","ff",[4],7,[1],[3],2,"62","3"],["5530","1968-07-09","Sollte es zu einer Umwandlung der Ingenieurschulen zu Fachhochschulen kommen, müsste nach Meinung des nordrheinwestfälischen Kultusministers Holthoff eine zweijährige Kollegstufe vor dem eigentlichen Besuch der Hochschule geschaffen werden, um so auch bei einem Realschulabschluss die erforderliche Schulzeit von zwölf Jahren zu erreichen.","\"Kollegstufe\" für Ingenieur-Studenten","","","",[4],7,[1],[2],2,"16","13"],["5531","1968-07-10","Studenten haben das Otto-Suhr-Insitut besetzt, nachdem der Akademische Senat der FU Berlin die Reformsatzung des OSI erneut zurückgewiesen hatte. Das Direktorium des OSI ist auf Grund der Ablehnung zurückgetreten.","Studenten besetzten Otto-Suhr-Institut","","","wy",[1],7,[1],[2],2,"26","1"],["5532","1968-07-10","Während eines Prozesses wegen Hausfriedenbruchs gegen mehrere Angehörige der Kommune I veranstalteten die Angeklagten ein \"Happening\". U. a. besetzten sie den Richtertisch und warfen mit Akten umher. Die Angeklagten bekamen jeweils zwei Tage Ordnungshaft. Zu ihnen gehörten auch Kunzelmann, Teufel und Langhans.","Kommunarden-\"Happening\"","","","",[1],7,[1],[2],1,"26","2"],["5533","1968-07-10","Die Rektorenkonferenz Baden-Württembergs fordert, für sogenannte Massenfächer künftig einen Numerus Clausus an den acht Universitäten in Baden-Württemberg einzuführen.","Rektoren stoppen den Andrang der Studenten","","Baden-Württemberg: Numerus Clausus als Notbremse?","th.",[4],7,[1],[3],2,"26","2"],["5534","1968-07-10","Der Bundesvorstand der Deutschen Angestellten Gewerkschaft (DAG) hat Studenten, Assistenten und Dozenten der Universität Hamburg zu einem zweitägigen \"Hearing\" über die notwendigen Hochschulreformen eingeladen. Von studentischer Seite äußerten sich u. a. Jens Litten und Detlev Albers.","\"Hearing zur \"Hochschulreform\"","","","",[4],7,[1],[2],2,"26","4"],["5535","1968-07-10","Der Hamburger AStA wandte sich in einer Erklärung gegen \"spektakuläre direkte Aktionen\" und die \"Phantastereien\" einiger Studenten. Das Studentenparlament lehnte zudem jegliche Blockaden der Vollversammlung zur Rektoratswahl ab. Der Versuch eines Vertreter des LSD, den AStA zu stürzen, scheiterte. Der AStA will sich mit Nachdruck dafür einsetzen, dass die Wahl des neuen Rektors öffentlich abgehalten wird. Wahl des neuen Präsidiums des Studentenparlaments.","Mehrheit lehnte AStA-Sturz ab","","Studentenparlament wählte Präsidium","ff",[4],7,[1],[1],1,"26","4"],["5536","1968-07-10","Das Landgericht München hat die Studenten Koderer und Aschenbrenner zu sieben Monaten bzw. sechs Wochen Gefängnis mit Bewährung verurteilt. Beide hatten in der Universität München Polizeiuniformen getragen und sich in einigen Vorlesungen in diesem Aufzug neben Professoren gestellt. Dies wurde als erschwerter Hausfriedensbruch und unerlaubtes Uniformtragen gewertet. Während des Prozesses sei es zu tumultartigen Szenen gekommen","Studenten als \"Polizisten\"","","Wegen unberechtigten Uniformtragens verurteilt","",[1],7,[1],[2],2,"26","26"],["5537","1968-07-11","An der FU Berlin wurde das Rektorat besetzt. Dabei entstand ein Schaden von mehreren zehntausend DM, etliche Dienstsigel und Stempel des Rektors wurden entwendet. Unter den Studenten war auch die AStA-Vorsitzende Sigrid Fronius, diese wird als \"Revolutionärin im Minirock\" bezeichnet. Berlins Regierender Bürgermeister Schütz sprach von einem \"Akt des Vandalismus\". In Bonn protestierten Studenten gegen die Teilnahme von Rektoren aus Griechenland und Spanien bei einem Empfang in der Universität. An der TU Berlin sei es im Rahmen der Kandidatenaufstellung für die kommenden Rektoratswahlen zu einem Streit zwischen Professoren gekommen.","Berliner Studenten demolierten Rektorat","","Schaden beläuft sich auf mehrere zehntausend DM","wy/ hps",[1],7,[1],[5],1,"18","1"],["5538","1968-07-11","Die Hamburger Innenbehörde will die \"Rädelsführer\" der Osterunruhen für die Schäden, die der Polizei entstanden sind, verantwortlich machen.","Demonstranten sollen bezahlen","","","",[1],7,[1],[2],2,"18","3"],["5539","1968-07-12","Die Universität Würzburg ist vom Prorektor geschlossen worden. Er könne anders nicht mehr die Sicherheit der Professoren und Universitätsbediensteten gewährleisten. Vorausgegangen waren dem ein Streik, Blockaden und die Stürmung der Sitzung des Großen Senats, zu denen der AStA aufgerufen hatte. Nach Meinung des AStA berücksichtigt die kurz vor der Verabschiedung stehende neue Satzung der Universität die studentischen Interessen nicht genügend. Der AStA distanzierte sich anschließend von den Störungen. An der FU Berlin schützt die Polizei das Rektorat sowie zwie Fakultätsgebäude, um weitere Besetzungen zu verhindern.","Würzburger Universität nach Krawallen geschlossen","","Studenten: \"Haut den Professoren die Satzung um die Ohren\"","",[1],7,[1],[1],2,"20","2"],["5540","1968-07-13","Die Universität Würzburg soll nach der Schließung wegen der Studentenunruhen am kommenden Montag wieder geöffnet werden.","Kurz informiert","Kurz informiert","Uni wird wieder geöffnet","",[1],7,[1],[2],2,"58","1"],["5541","1968-07-16","Rektor Harndt von der FU Berlin hat die Beitragszahlung für die studentische Selbstverwaltung ausgesetzt, solange vor dem Berliner Verwaltungsgericht ein Verfahren in dieser Frage anhängig ist.","Keine Pflichtbeiträge für Berliner AStA","","","",[1],7,[1],[2],2,"16","2"],["5542","1968-07-17","Ein erneuter Misstrauensantrag gegen den Hamburger AStA wurde abgelehnt. Parteinahme des Redakteurs für den Kurs des AStA. Vorausgegangen war dem eine \"Redeschlacht\". Auch der SHB unterstützte den Misstrauensantrag gegen den eigenen zweiten AStA-Vorsitzenden Litten.","Misstrauensantrag gegen AStA abgelehnt","","","ff.",[4],7,[1],[2],2,"24","2"],["5543","1968-07-19","Vergleich der Finanzierung der Universitäten durch die einzelnen Bundesländer. Hamburg zahlt seiner Universität am zweitwenigsten, obwohl es zu den reichsten Bundesländern gehört. Rektor Ehrlicher und Prof. Littmann befürchten schwere Folgen für die Hamburger Universität.","Hamburg zahlt der Universität am wenigsten","","Vergleich mit anderen Bundesländern","Ursula Weiner",[4],7,[1],[5],1,"18","4"],["5544","1968-07-23","Der Dekan der Philosophischen Fakultät der FU Berlin, Prof. Loos, warnt in einem Brief an den Berliner Wissenschaftssenator Stein vor den Gefahren, die aus der instabilen Lage der FU Berlin erwachsen würden. Insbesondere die Gewinnung neuer Hochschullehrer werde erschwert. Der Brief wird als Kritik an der Politik des Senators gewertet.","FU-Professor warnt Senator","","","wy",[1],7,[1],[2],2,"16","2"],["5545","1968-07-23","Es wird ein \"heißer Winter\" an den Universitäten erwartet. Grund sei die verständliche Ungeduld der Studenten bzgl. der Hochschulreformen, welche durch die Ratlosigkeit der Verantwortlichen immer weiter verzögert werden würden. Nachdem die ältere Generation über einen langen Zeitraum keine Ideen für die Hochschulreformen entwickelt habe, sei es an der Zeit, die jüngere Generation stärker einzubeziehen.","Kühler Sommer - heißer Winter","","","wmh",[1],7,[5],[2],2,"16","2"],["5546","1968-07-23","An der Kieler Universität gibt es Auseinandersetzungen zwischen den Studentenvertretern und dem Rektor über die neue Hochschulverfassung. Streitpunkt ist die studentische Mitbestimmung. Die Forderung der Studenten nach genereller Mitbestimmung geht dem Rektor zu weit. FDP und CDU legen eigene Entwürfe für ein Hochschulgesetz vor. Der FDP-Entwurf kommt den studentischen Forderung am nächsten, wird vom Rektor dafür scharf kritisiert.","Machtkampf droht an Kieler Universität","","Es geht um die studentische Mitbestimmung","fa.",[4],7,[1],[2],2,"16","2"],["5547","1968-07-23","Der SHB will seine Vorstellungen von einem neuen Hochschulgesetz innerhalb der SPD erläutern. Zugleich kündigte er an, die derzeitige Politik der SPD zu bekämpfen und Doppelmitgliedschaften mit dem SDS anzustreben.","SHB kontra SPD","","","",[1],7,[1],[2],2,"16","3"],["5548","1968-07-24","Der AStA der Hamburger Kunsthochschule (HfbK) legt eine Zwischenbilanz über die Umstrukturierung der Hochschule vor.","Kunststudenten ziehen Zwischenbilanz","","Lerchenfeld: AStA über erreichte Ziele/ Semesterschluß","R.",[4],7,[1],[2],2,"24","13"],["5549","1967-07-25","Der neugewählte Hamburger AStA (Pätzoldt und Jankowski) kündigen ständige Gespräche mit der Professorenschaft an, insbesondere auch durch ständige Mitarbeit in den akademischen Gremien. Auch die Studentenschaft will man besser informieren, u. a. über sit-ins und Vollversammlungen. Das politische Mandat will man in Anspruch nehmen.","AStA will Studenten besser informieren","","Für ständiges Gespräch mit der Professorenschaft","U. W.",[1],7,[1],[5],1,"16","4"],["5550","1968-07-26","Die ausländischen Stipendiaten der Alexander-von-Humboldt-Stiftung übten auf ihrer Jahrestagung scharfe Kritik an der Situation an den Hochschulen. Insbesondere die unbefriedigende Stellung der Assistenten an den Hochschulen kritisierten sie. Deren Abhängigkeit von den Ordinarien sei feudal und patriarchalisch.","Assistenten müssen Kammerdiener spielen","","","wst",[11],7,[1],[2],2,"20","2"],["5551","1968-08-07","Nachdem das Bundesverfassungsgericht die Beschwerde des Studenten Karl-Heinz Roth (wird als SDS-Ideologe bezeichnet) über seinen Haftbefehl abgelehnt hat, will dessen Anwalt die Europäische Kommission für Menschenrechte anrufen. Hintergrund ist die Verwehrung der Akteneinsicht bzgl. der Vorfälle bei den Osterunruhen. Aus Mangel an Beweisen wurde ein Ermittlungsverfahren gegen einen Polizeiobermeister, ebenfalls wegen Vorfällen bei den Osterunruhen, eingestellt. Es stände Aussage gegen Aussage. Wegen Landfriedensbruchs, begangen bei den Osterunruhen vor dem Axel-Springer-Verlag, wurde ein 22-jähriger Angestellter zu vier Monaten Gefängnis mit Bewährung verurteilt.","Demonstranten jetzt vor Gericht","","Student Roth sucht Hilfe in Straßburg","frk",[1],7,[1],[3],2,"28","4"],["5552","1968-08-08","Das Berliner Verwaltungsgericht hat entschieden, dass die Rückmeldung eines Studenten an der FU Berlin nicht von der gleichzeitigen Zahlung des Pflichtbeitrags für die studentische Selbstverwaltung abhängig gemacht werden kann. Laut Rektor Harndt kläre dies aber noch nicht die Frage, ob der Beitrag grundsätzlich verweigert werden könne.","Rückmeldung nicht von AStA-Gebühren abhängig","","","",[4],7,[1],[2],2,"18","1"],["5553","1968-08-09","Eine Delegation der FDJ wird im September zu Gesprächen mit dem VDS in die Bundesrepublik reisen. Thema sollen Austausch von Studentenzeitungen, Reisedelegationen und ein gemeinsames großes Seminar in der DDR sein.","Neue Gespräche zwischen VdS und FDJ","","","",[9],7,[1],[3],2,"18","1"],["5554","1968-08-09","Bericht über die Weltjugendfestspiele in Sofia. Die Teilnahme einer westdeutschen Delegation sei ein Politikum ersten Ranges gewesen. Innerhalb der deutschen Gruppe kam es zu Spannungen. Der SDS und die Gruppe der Tschechoslowaken hätten den bulgarischen Polizeistaat ständig provoziert und deshalb erhebliche Probleme bekommen.","Weltjugendfestspiele am Scheideweg","","Flegel: Sofia war ein Politikum ersten Ranges","bo.",[9],7,[1],[5],1,"18","11"],["5555","1968-08-10","Laut einer Entscheidung des baden-württembergischen Verwaltungsgerichtshofes hat die Studentenschaft kein politisches Mandat. Anlaß war eine Klage Tübinger Studenten, die mit einem Flugblatt des AStA nicht einverstanden waren.","Studentenschaft hat kein politisches Mandat","","","",[11],7,[1],[2],2,"62","1"],["5556","1968-08-14","Die geplante Universität in Bremen hat wieder einen neuen Gründungssenat, nachdem der erste im Februar 1967 zurückgetreten war.","Bremer Universität hat neuen Gründungssenat","","","er",[4],7,[1],[2],2,"30","1"],["5557","1968-08-16","Der AStA der Hamburger Universität nimmt Stellung zu einem Urteil gegen einen 21-jährigen Arbeiter. Dieser war wegen Landfriedensbruchs zu vier Monaten Gefängnis mit Bewährung verurteilt worden. Dieses Urteil kriminalisiere laut dem AStA das Grundrecht auf Demonstrationsfreiheit. Während des Prozesses kam es zu Störungen durch etwa 100 Studenten.","AStA nimmt Stellung","","","U. W./ frk",[1],7,[1],[3],2,"22","4"],["5558","1968-08-21","Ein starkes Polizeiaufgebot sicherte einen Prozess gegen einen Versicherungskaufmann wegen seiner Beteiligung an den Osterunruhen vor Störungen. Der Angeklagte verweigerte die Aussage und forderte eine größere Öffentlichkeit des Prozesses. Im Gerichtskorridor warteten etwa 50 Studenten, darunter SDS-Mitglieder, sie verhielten sich diszipliniert.","Der Megaphonsprecher verweigerte die Aussage","","Osterdemonstrant vor Gericht/ Prozeß unterbrochen","frk",[1],7,[1],[3],2,"30","5"],["5559","1968-08-21","Der Hamburger Student Lustfeld klagt vor dem Verwaltungsgericht gegen den AStA der Universität. Streitpunkt ist das politische Mandat, Lustfeld will, dass es dem AStA untersagt wird, politische Stellungnahmen zu äußern. Der AStA will am politischen Mandat festhalten, dazu Äußerung von Litten und Jankowski. Sechs Studenten des SHB und des SDS würden von der Polizei für Schäden bei den Osterunruhen schadensersatzpflichtig gemacht werden.","Ein Student klagt vor dem Gericht: AStA soll keine Politik machen","","Kompetenz überschritten? Geeigneter Rechtsbeistand wird noch gesucht","U. W.",[11],7,[1],[1],2,"30","5"],["5560","1968-08-24","Der VDS will tschechoslowakischen Studenten, die wegen der Niederschlagung des \"Prager Frühlings\" aus der CSSR fliehen oder nicht mehr dorthin zurück konnen, finanziell helfen.","Studentische Hilfsaktion","","","",[9],7,[1],[2],2,"64","1"],["5561","1968-08-29","Der Hamburger Bürgerschaftsabgeordnete und Dozent am Pädagogischen Insitut Dr. Döbertin (SPD) hat einen detaillierten Entwurf für ein Hochschulgesetz vorgelegt. Im Kern sollen dabei Fachhochschulen und Universitäten zu Gesamthochschulen zusammengelegt werden. Er sieht eine größere Gefahr in der gleichgültigen denn in der revoltierenden Studentenschaft.","Uni und Fachhochschulen künftig unter einem Dach?","","Dr. Döbertin macht neue Vorschläge/ Revision des Abiturs","Ursula Weiner",[4],7,[1],[1],1,"20","3"],["5562","1968-09-02","In Göttingen hat sich ein neuer Gründungssenat für die künftige Bremer Universität konstituiert.","Neuer Gründungssenat für Bremer Universität","","","er",[4],7,[1],[3],2,"18","9"],["5563","1968-09-03","Der AStA der Universität Hamburg, das Hamburger Komitee des Weltstudentendienstes und das Schülerparlament rufen zu Spenden für tschechoslowakische Studenten, die sich in Hamburg aufhalten, auf. Die Ereignisse in der CSSR hätten diese in wirtschaftliche Not gebracht.","Studenten aus der CSSR brauchen Hilfe","","","",[9],7,[1],[2],2,"18","3"],["5564","1968-09-04","Im Bundesvorstand des SDS werde der Ausschuß von fünf Mitgliedern vorbereitet, denen vorgeworfen werde, auf Grund ihrer Nähe zur KPD zum \"Establishment\" zu gehören.","Krach im SDS","","","",[8],7,[1],[3],2,"32","1"],["5565","1968-09-05","Der Student und Kommunarde Karl-Heinz Pawla verrichtete während eines Prozesses gegen ihn im Gerichtsaal seine Notdurft. Anschließend reinigte er sich mit Akten vom Richtertisch. Pawla wurde zu einer Ordnungsstrafe von drei Tagen verurteilt, ein weiteres Strafverfahren in dieser Sache wird außerdem auf ihn zukommen.","Zwischenfall im Gericht","","Berliner Student ließ plötzlich die Hosen 'runter","wy",[1],7,[1],[2],2,"22","22"],["5566","1968-09-06","Im Zusammenhang mit den Osterunruhen in Hamburg werden 164 Verfahren gegen Demonstranten erwartet. Zudem schweben 73 Verfahren gegen Polizeibeamte. Insgesamt 314 Selbstanzeigen wurden erstattet, der Großteil davon wurde eingestellt. Durch Anzeige wurden 238 Verfahren eingeleitet. Justizsenator Schulz erklärte zum studentischen Vorwurf, die bisherigen Verfahren seien in zu kleinen Räumen abgehalten worden, dass man sich nicht dem Vorwurf habe aussetzen wollen, Schauprozesse abzuhalten. Er werde sich künftig aber um größere Räume für die anstehenden Prozesse bemühen.","164 Verfahren gegen Oster-Demonstranten","","Studenten sprachen mit Justizsenator Schulz","U. W.",[1],7,[1],[2],2,"34","8"],["5567","1968-09-07","Der Hamburger AStA protestiert gegen den Film \"Die Grünen Teufel\", der seiner Meinung nach den Krieg in Vietnam in unerträglicher Weise verherrliche und den Völkermord fördere. Er fordert die Absetzung des Films, der Verleih verweigert dies jedoch.","AStA protestiert gegen \"Die grünen Teufel\"","","","",[4],7,[1],[3],2,"68","4"],["5568","1968-09-07","Wegen der Verrichtung seiner Notdurft im Gerichtssaal wurde Karl-Heinz Pawla zu zehn Monaten Gefängnis verurteilt. Pawla bezeichnete seine Tat als \"Demonstration\". Er hatte vorher Abführtabletten eingenommen und freue sich, dass alles so gut geklappt habe.","Strafe für Beleidigung","","","",[1],7,[1],[2],2,"68","36"],["5569","1968-09-11","Der AStA der Universität Hamburg plant die Herausgabe einer neuen Studentenzeitschrift. Die erste Nummer soll Ende Oktober erscheinen. Die finanzielle Unterstützung der Zeitschrift \"Zur Sache\", als deren Herausgeber der AStA bislang fungierte, soll dagegen eingestellt werden.","AStA plant neue Studentenzeitung","","","",[4],7,[1],[2],2,"30","4"],["5570","1968-09-13","Der SDS will auf der in Frankfurt eröffneten 23. Delegiertenkonferenz über seinen künftigen Kurs bestimmen. Nach der Phase der antiautoritären Mobilisierung beginne nun die organisatorische Festigung der Protestbewegung als Organisation des offenen Widerstands, so der SDS-Vorsitzende Wolff.","SDS berät über künftigen Kurs","","","",[8],7,[1],[3],2,"30","2"],["5571","1968-09-14","Dem SDS drohe eine Spaltung. Auf der Delegiertenkonferenz in Frankfurt wurden fünf Mitglieder der sogenannten KP-Fraktion ausgeschlossen. Diesen wurde vorgeworfen, auf den Weltjugendfestspielen in Sofia gegen die Aktionseinheit des SDS verstoßen zu haben. Mehrere Delegierte brachten daraufhin den Antrag ein, auch die mit der KP-Fraktion solidarisierenden Gruppen auszuschließen und die Spaltung des Verbandes zu vollziehen.","SDS von Spaltung bedroht","","","",[8],7,[1],[2],2,"74","2"],["5572","1968-09-16","Der SDS wolle auf seine geplante Bundeswehrkampagne vorerst verzichten und stattdessen eine Justizkampagne beginnen. Der in Kürze in Nürnberg stattfindende Juristentag soll den Auftakt bieten. Man wolle Richter und Staatsanwälte verunsichern, der Gerichtssaal müsse das neue Spielfeld des SDS sein.","SDS will die deutschen Richter \"verunsichern\"","","","",[8],7,[1],[2],2,"20","1"],["5573","1968-09-16","Etwa 1300 Studenten mehr als erwartet haben sich an der TU München für das Wintersemester 1968/69 eingeschrieben. Dadurch steigt die Zahl der Studenten an der Uni von 8000 auf fast 10.000. Grund sei die Freistellung von Abiturienten, die eine Anmeldung zum Studium an der TH vorweisen konnten, durch das Kreiswehrersatzamt.","Andrang an Münchner TH","","","M.K.",[11],7,[1],[3],2,"20","2"],["5574","1968-09-17","Die Bundesdelegiertenkonferenz des SDS sei chaotisch zu Ende gegangen. Es kam weder zur Neuwahl des Vorstands noch zur Annahme irgendeiner Resolution. Man einigte sich lediglich darauf, im November in Hannover wieder zusammenzukommen. Auflösungserscheinungen des SDS werden konstatiert, die Hamburger Delegation habe eine rätedemokratische Umgestaltung des Verbandes nach dem Motto \"Brecht dem Bundesvorstand die Gräten - alle Macht den Räten\" gefordert.","SDS-Konferenz endete im Chaos","","","",[8],7,[1],[2],2,"18","2"],["5575","1968-09-17","Der AStA der Hamburger Uni empfindet das Zögern der Bürgerschaftsparteien in der Frage des neuen Hochschulgesetzes als Verrat an seiner konstruktiven und maßvollen Politik. Sollte dies nicht enden, werde die Ruhe an der Universität enden. Äußerungen des AStA-Vorsitzenden Jankowski und Litten, Kritik vor allem an der SPD, die nur aktiv werde, wenn die Unruhe der Studentenmasse sie dazu zwinge.","AStA übt harte Kritik an den drei Parteien","","Hochschulgesetz verzögert/ Studenten sagen \"Verrat\"","U. W.",[4],7,[1],[2],2,"18","4"],["5576","1968-09-18","Die Hamburger CDU will konkrete Vorschläge zur schnelleren Beratung des neuen Hochschulgesetzes machen. Noch im Jahr 1968 sollen die Beratungen abgeschlossen sein.","CDU: Schnellere Beratung des Uni-Gesetzes","","","",[4],7,[1],[2],2,"30","6"],["5577","1968-09-19","Sprecher aller drei Fraktionen in der Hamburger Bürgerschaft wandten sich gegen den Vorwurf des AStA, man verschleppe die Hochschulgesetzgebung.","Vorwürfe des AStA abgewiesen","","","",[4],7,[1],[2],2,"24","6"],["5578","1968-09-21","Die Rektoren der hessischen Hochschulen lehnten ein Gespräch mit dem hessischen Kultusminister Schütte ab. Hintergrund des Konflikt ist der Entwurf Schüttes für ein Hochschulgesetz, in dem auch die Drittelparität enthalten ist. Die Rektoren lehnen diese strikt ab.","Fehde in Hessen um Hochschulgesetz","","","",[4],7,[1],[3],2,"72","2"],["5579","1968-09-21","Die Polizeigewerkschaft weist die Kritik des Hamburger AStA an der Ernennung von Günter Redding zum Polizeipräsidenten und von Martin Leddin zu dessen Stellvertreter scharf zurück.","Scharfe Erwiderung","","Polizeigewerkschaft weist Kritik des AStA zurück","",[4],7,[1],[3],2,"72","8"],["5580","1968-09-23","Bei der Verleihung des Friedenspreises des Deutschen Buchhandels an den senegalesischen Staatspräsidenten Senghor in der Frankfurter Paulskirche kam es zu Demonstration und schweren Auseinandersetzungen. Mehrere hundert Studenten hätten, angefeuert vom SDS, versucht, die Paulskirche zu stürmen. Auch der israelische Botschafter Asher Ben Nathan wurde von den Demonstranten beschimpft. Daniel Cohn-Bendit wurde festgenommen, nachdem er über die Absperrung geklettert war. Mehrere Politiker, darunter Willy Brandt, kritisierten die Demonstration scharf. Auch auf der Frankfurter Buchmesse kam es zu Demonstrationen, zeitweilig ruhte der Messebetrieb komplett, einige Tore wurden für Besucher geschlossen. Mehrere Verlage schlossen ihre Stände.","Schwere Krawalle vor der Frankfurter Paulskirche","","Demonstranten wollten Friedenspreis-Feier stören","pth",[1],7,[1],[5],1,"18","1"],["5581","1968-09-23","An der Universität Hamburg wurden drei neue Dekane gewählt (Professoren Kob, Sieverts und Roemer)","Drei neue Dekane an der Universität","","","",[4],7,[1],[2],2,"18","4"],["5582","1968-09-23","Über die Preisverleihung an den senegalesischen Staatspräsidenten Senghor und Auszüge aus dessen Rede in der Frankfurter Paulskirche. Vor der Paulskirche hätten sich unterdessen beschämende Krawallszenen abgespielt.","Kein Fortschritt ohne Gerechtigkeit","Feierstunde in der Frankfurter Paulskirche","Aus der großen Rede des Friedenspreisträgers Léopold Sédar Senghor","",[1],7,[1],[1],1,"18","9"],["5583","1968-09-24","Daniel Cohn-Bendit bleibt wegen seiner Beteiligung an den Demonstrationen vor der Frankfurter Paulskirche in Untersuchungshaft. Der Untersuchungsrichter erließ einen Haftbefehl wegen Verdachts auf schweren Landfriedensbruchs, schweren Hausfriedensbruchs, des Aufruhrs, der Körperverletzung und des Auflaufs. 22 der 26 weiteren Festgenommenen sind wieder entlassen worden. Der hessische Innenminister Schneider rechtfertigte den erstmaligen Gebrauch von Tränengas in Hessen bei dieser Demonstration damit, dass zahlreiche Studenten aus anderen Bundesländern vor Ort gewesen seien und die Stimmung angeheizt hätten. Zudem soll es Attentatspläne auf Senghor gegeben haben.","Cohn-Bendit bleibt vorläufig in Haft","","","",[1],7,[1],[3],1,"20","2"],["5584","1968-09-25","Die Westdeutsche Rektorenkonferenz hat scharfe Kritik an den Plänen Berlins und Hessens für ein neues Hochschulgesetz geäußert. Insbesondere die Drittelparität lehnen die Rektoren ab.","Rektoren gegen \"Drittelparität\"","","","",[4],7,[1],[2],2,"36","1"],["5585","1968-09-28","Daniel Cohn-Bendit ist in einem Schnellverfahren zu acht Monaten Gefängnis auf Bewährung verurteilt worden. Er wurde des Aufruhrs, des Land- und Hausfriedensbruchs sowie der Beamtennötigung, begangen bei den Demonstrationen vor der Frankfurter Paulskirche wegen der Verleihung des Friedenspreises an den senegalesischen Staatspräsidenten Senghor, für schuldig befunden.","Gefängnis mit Bewährung für Cohn-Bendit","","","",[1],7,[1],[2],1,"80","1"],["5586","1968-10-01","Drei Hauptwachtmeister der Schutzpolizei wurden wegen Körperverletzung im Amt zu Gefängnisstrafen von je 6 Wochen auf Bewährung verurteilt. Sie sollen während der Demonstration am 2. Juni 1967 in West-Berlin einen auf dem Boden liegenden Studenten mißhandelt und mit ihren Schlagstöcken geschlagen haben.","Schlagende Polizisten veruteilt","","","",[1],7,[1],[3],2,"22","2"],["5587","1968-10-01","Die Hamburger CDU fordert den Senat zu einer Stellungnahme zu seinen Plänen für den Ausbau der Hamburger Universität auf. Der Senat lasse die Öffentlichkeit über seine Pläne im Dunkeln. Insbesondere will die CDU klären, wie der Senat räumlich, personell und finanziell dem erwarteten deutlichen Anstieg der Studentenzahlen begegnen will.","CDU drängt auf Hochschulreform","","Senat soll endlich seine Pläne vorlegen","co",[4],7,[1],[2],2,"22","5"],["5588","1968-10-05","Der Medizinstudent Gerhard Paar wurde wegen Aufruhrs und Landfriedensbruchs zu einem Jahr Gefängnis verurteilt. Er hatte während der Osterunruhen an der Demonstration vor der Frankfurter Societätdruckerei teilgenommen, mit der die Auslieferung der dort gedruckten Zeitungen verhindert werden sollte.","Ein Jahr Gefängnis","Bunte Welt","","",[1],7,[1],[2],2,"68","2"],["5589","1968-10-05","Das Studentenwerk Göttingen wirbt um Spenden für die Schaffung einer größeren Tagesheimstätte für Kleinkinder von Studenten.","Hilfe für Studenten-Babys","Bunte Welt","","",[4],7,[1],[2],2,"68","2"],["5590","1968-10-07","Der Anteil an Arbeiterkindern unter den Studenten in Hamburg liegt nur bei etwa fünf Prozent, obwohl über 40 Prozent der Erwerbstätigen Arbeiter sind.","Rollmann: Zu wenig Arbeiterkinder studieren","","","",[11],7,[1],[2],2,"20","5"],["5591","1968-10-08","Kurzbericht über den bevorstehenden Germanistentag in West-Berlin. Studenten haben Störungen angesagt.","Germanistentag soll \"umfunktioniert\" werden","","","",[1],7,[1],[2],2,"22","18"],["5592","1968-10-09","Die Hamburger Polizei soll künftig für Großeinsätze besser ausgerüstet werden. Insgesamt stehen für die Nachrüstung 752.000 DM zur Verfügung.","Neue Wagen, Funkgeräte, Schutzhelme","","Polizei besser gerüstet","ga.",[1],7,[1],[2],2,"32","4"],["5593","1968-10-09","Studenten besetzten das Podium des Germanistentages, um entgegen eines Mehrheitsbescheids statt einem Vortrag eine Diskussion abzuhalten. Der Germanistentag wurde vorzeitig abgebrochen.","Studenten forderten Diskussion","","","",[1],7,[1],[2],2,"32","14"],["5594","1968-10-10","Die Hamburger Polizei bekommt einen Helm, der bei künftigen Demonstrationen für besseren Schutz sorgen soll.","Kopfschutz für 5000 Polizisten","","","",[1],7,[1],[2],1,"24","4"],["5595","1968-10-10","Laut eines Lesers werden Demonstrationen und Sit-ins durch die Demokratie hervorgerufen. Solage zwar jeder Bürger Parteien gründen könne, solche wie die KPD oder NPD jedoch behindert werden, wird die Unruhe weiter zunehmen.","Demonstrationsrecht","Briefe an das Hamburger Abendblatt","","Leser",[1],7,[6],[2],2,"24","8"],["5596","1968-10-10","Erstmals hätten die studentischen Demonstranten auf dem Germanistentag einen Erfolg gehabt. Ihrer Forderung nach Absetzung eines Vortrages zu Gunsten einer Diskussion wurde stattgegeben, selbst das Diskussionspodium wurde paritätisch besetzt. Die Diskussion selbst sei jedoch enttäuschend gewesen.","Fragwürdiger Erfolg","","","",[1],7,[1],[2],2,"24","14"],["5597","1968-10-11","Der Hamburger Senat widerspricht einem Gutachten von Prof. Littmann, nach dem Hamburg im Vergleich der Bundesländer seiner Universität am zweitwenigsten Geld zur Verfügung stellt. Prof. Littmann habe falsch gerechnet.","Senat zerpflückt Uni-Gutachten: Falsch gerechnet!","","Senator Drexelius kontra Prof. Littmann","Ursula Weiner",[4],7,[1],[1],1,"28","5"],["5598","1968-10-11","Das Berliner Abgeordnetenhaus hat ein Gesetz verabschiedet, durch das Universitätsinstitute noch vor der Verabschiedung eines neuen Hochschulgesetzes eigenständige neue Satzungsmodelle ausprobieren können. Diese als Experimente gedachten Satzungen sind jeweils auf ein Semester zeitlich befristet. Hintergrund war eine mehrfach vom Akademischen Senat der FU Berlin abgelehnte Satzung des Otto-Suhr-Institutes.","Berlins Hochschulen erproben Reformmodell","","Institute regeln Selbstverwaltung nach ihren Wünschen","",[4],7,[1],[3],2,"28","22"],["5599","1968-10-12","Das französische Parlament hat ohne Gegenstimme eine Universitätsreform verabschiedet.","Hochschulreform in Frankreich","","","",[4],7,[1],[2],2,"72","1"],["5600","1968-10-12","Rektor Ehrlicher von der Universität Hamburg weist die Kritik des Senats an dem Gutachten von Prof. Littmann über die Finanzierung der Universitäten zurück. Littmann habe nicht falsch gerechnet, die Behauptung von Senator Drexelius, die Hamburger Universität stehe in ihrer finanziellen Ausrüstung unter den gleich großen Universitäten, sei zudem unzutreffend und irreführend.","Rektor weist Kritik zurück","","","",[4],7,[1],[3],2,"72","3"],["5601","1968-10-12","Interview mit Hamburgs Rektor Ehrlicher und dem zweiten AStA-Vorsitzenden Jens Litten. Ehrlicher sieht eine Annäherung zwischen Studenten- und Professorenschaft, Litten verwirft die Zusammenarbeit mit den Professoren bzgl. der Hochschulreform, wichtiger seien die politischen Parteien. Litten fordert die Studentenschaft auf, sich auf die Hochschulreform zu konzentrieren. Rektor Ehrlicher ist gegen eine Drittelparität. Reformziele von Litten und Ehrlicher für das kommende Semester. Litten bezeichnet das letzte Semester als ein Verlust für die Studenten, man habe nichts erreicht. Für Litten ist der RCDS die disziplinierteste Studentengruppe, der SDS habe dagegen viele Anhänger verloren. Zu einer Zusammenarbeit mit dem RCDS ist er bereit, die politische Führung will er ihm jedoch nicht überlassen. Litten erwartet keinen \"heißen Winter\" im kommenden Semester.","Wintersemester wird nicht \"heiß\"","","Darüber sind sich Rektor und AStA einig","Ursula Weiner",[1],7,[1],[5],2,"72","9"],["5602","1968-10-14","Der SDS habe erstmalig eine \"Mädchen-Brigade\" eingesetzt. Etwa 30 Studentinnen hätten einen Festakt in der Frankfurter Paulskirche zum 50-jährigen Bestehen des Frauenwahlrechts gestört.","Protest in der Paulskirche","Bunte Welt","","",[1],7,[1],[2],2,"20","2"],["5603","1968-10-14","Der Rektor der TU Berlin, Prof. Weichselberger, hat die Abschaffung aller akademischen Titel, Grade und Abschlußprüfungen gefordert. Diese Verleihung von Statussymbolen sei nicht mehr vertretbar.","Rektor für Abschaffung von Prüfungen und Titeln","","","",[4],7,[1],[2],2,"20","2"],["5604","1968-10-14","Bericht über den bevorstehenden Prozess gegen die mutmaßlichen Kaufhausbrandstifter von Frankfurt (Baader, Proll, Söhnlein, Ensslin). Schilderung des Tathergangs aus der Sicht des Staatsanwaltes. Die Angeklagten haben sich bisher nicht geäußert. In anonymen Briefen wurden Störungen des Prozesses angedroht. Es wird die Frage aufgeworfen, ob die Tat unter Rauschgifteinfluß begangen wurde, oder ob es ein Fall von gewalttätigem Anarchismus sei.","Molotow-Zeitzünder auf dem Richtertisch","","Heute beginnt der Frankfurter Kaufhausbrand-Prozeß","Dr. Hildegard Damrow",[9],7,[1],[5],2,"20","20"],["5605","1968-10-15","Bericht über den ersten Tag im Prozess wegen der Kaufhausbrände in Frankfurt. Von außen habe es keine Störungen gegeben, der Gerichtssaal sei nur halbgefüllt gewesen. Baader, Söhnlein und Proll bekamen je drei Tage Ordnungshaft und wurden kurz nach Beginn des Prozesses wieder aus dem Saal geführt. Angaben zu Gudrun Ensslin. Die Angeklagten verweigerten bisher jede Angabe zum Motiv.","Ordnungsstrafen für \"Possenspiele\" vor Gericht","","Zwischenfälle im Frankfurter Brandstifterprozeß","Dr. Hildegard Damrow",[9],7,[1],[1],1,"20","7"],["5606","1968-10-17","Hamburgs Bürgermeister Drexelius beantwortete eine Anfrage der CDU zur Situation der Universität. Demnach habe sich die Fläche der Uni seit 1960 fast verdoppelt, das Gleiche betreffe die Anzahl des wissenschaftlichen Personals. Drexelius erwartet bis zum Wintersemester 1973/74 einen Anstieg der Studentenzahlen von jetzt 16500 auf 20000 Studenten.","Viel Geld für Universität","","","",[4],7,[1],[3],2,"28","3,4"],["5607","1968-10-17","Der Hamburger CDU-Fraktionsgeschäftsführer Horst Schröder hat einen Entwurf für ein neues Hochschulgesetz präsentiert. Im Gegensatz zu seinem SPD-Kollegen Döbertin verwahrt er sich gegen eine Gesamthochschule, die die Universitäten und Fachhochschulen umschließt.","Universität und Fachhochschulen","","Horst Schröder legt seinen Plan vor","U. W.",[4],7,[1],[2],2,"28","9"],["5608","1968-10-18","Die Bundesrepublik hat von allen EWG-Staaten den geringsten Studentenzuwachs.","Die Bundesrepublik hinkt hinterher","","","",[4],7,[1],[2],2,"36","2"],["5609","1968-10-18","Vor dem Hintergrund, dass die Bundesrepublik von allen EWG-Staaten den geringsten Anstieg von Studenten zu verzeichnen hat, wird der Föderalismus der Bildungspolitik kritisiert. Dies hemme die Hochschul- und Studienreform. Eine Forderung nach einem Bundeskultusministerium sei jedoch illusorisch, dies würde an den Bundesländern scheitern.","Höchste Zeit","","","hoe",[4],7,[1],[2],2,"36","2"],["5610","1968-10-18","Die Fachschaft Erziehungswissenschaften der Universität Hamburg protestiert gegen die Zustände am Institut und kritisiert die Politik für die Verzögerung von Reformen. Insbesondere der räumliche Mißstand wird angeprangert. Ausgelegt sind die Räume für 800 Studenten, genutzt werden sie von 3000. Für diese stehen lediglich 36 Lehrkräfte zur Vefügung.","Studenten schlagen Alarm","","Pädagogisches Institut überfüllt/ Dreißig Dozenten fehlen","U. W.",[1],7,[1],[3],2,"36","4"],["5611","1968-10-19","Prof. Littmann kontert die Kritik des Senats an seinem Gutachten über die Finanzierung der Universitäten mit einem neuen Gutachten. Auch nach diesem Gutachten stehe die Universität Hamburg im bundesweiten Vergleich in Sachen Finanzierung an letzter oder vorletzter Stelle. Der Senat hatte das Gegenteil behauptet.","Littmann tritt Gegenbeweis an","","Dritte Runde im Streit um Uni-Gutachten","U. W. ",[4],7,[1],[5],2,"74","3"],["5612","1968-10-19","Mit 40.000 Flugblättern in sieben Ausgaben will der AStA der Universität Hamburg gegen den Gesetzesentwurf des Senats für ein neues Hochschulgesetz protestieren. Die Flugblätter sollen auch Änderungsvorschläge enthalten. Für den 11. November wurde eine Veranstaltung zum politischen Mandat angekündigt.","AStA verteilt 40000 Flugblätter","","","",[4],7,[1],[2],2,"74","4"],["5613","1968-10-19","Die Hamburger Bürgerschaft beschäftigte sich auf Grund der Anfrage eines FDP-Abgeordneten erneut mit der Ausweisung Obi Ifeobus. Der Senat hält nach wie vor die damalige Ausweisung für korrekt, obwohl die ihn belastenden Zeugen nachweislich betrunken waren bzw. die Unwahrheit gesagt haben. Über das Schicksal Ifeobus in Nigeria sei nichts bekannt. Kommentar des Journalisten: \"Obi Ifeobu wurde abgeschoben, um ein Exempel zu statuieren. Es hätte dem Senat gut angestanden, wenn er in seiner Antwort zugegeben hätte, dass damals eine peinliche Panne passierte und eine eines Rechtsstaats unwürdige Maßnahme ergriffen wurde.","Ifeobu, das Opfer falscher Anklagen","","Senat bleibt dabei: Ausweisung korrekt","Alwin Bellmann",[1],7,[1,5],[1],1,"74","5"],["5614","1968-10-21","Etwa 14 Hochschulen seien aus dem VDS ausgetreten, weil ihnen die Politisierung bzw. die Inanspruchnahme eines politischen Mandats nicht gefalle. Dadurch geriet der VDS in finanzielle Nöte, da zudem auch die Studentenschaft der FU Berlin wegen eigener finanzieller Schwierigkeiten sowie das Bundesinnenministerium Zahlungen an den VDS eingestellt haben.","VDS durch politischen Anspruch in Bedrängnis","","Rund 14 Hochschulen kündigten/ Weniger Geld","",[11],7,[1],[3],2,"20","2"],["5615","1968-10-22","Die SPD-Mitglieder des Hamburger Bürgerschaftsausschusses Schule und Universität haben sich bei den Beratungen zum neuen Hochschulgesetz für eine starke studentische Mitarbeit in Gremien ausgesprochen und teils sogar die Drittelparität gefordert.","SPD: Studenten stark beteiligen","","","",[4],7,[1],[2],2,"20","1"],["5616","1968-10-23","Professoren der Mathematisch-Naturwissenschaftlichen Fakultät Hamburgs haben den Politikern der Bürgerschaft eigene Vorschläge zur Hochschulreform unterbreitet. U.a. sollen auch die Doktoranden künftig in der Mitbestimmung berücksichtigt werden. Dozenten sollen zunehmend auch aus der freien Wirtschaft gewonnen werden.","Dozenten aus der Wirschaft holen!","","Neue Vorschläge zum Hochschulgesetz","U. W.",[4],7,[1],[1],2,"36","10"],["5617","1968-10-23","Gegen die Verteidiger der mutmaßlichen Frankfurter Kaufhausbrandstifter (Baader, Ensslin..), Mahler und Eschen, will die Staatsanwaltschaft ein Disziplinarverfahren anstrengen, weil diese bei der Zeugenbefragung nicht aufgestanden sind und ihre Roben nicht trugen. Mahler bezeichnete die Robe als \"antiquarisches Requisit\".","\"Unnötige Berufskleidung\"","","","",[6],7,[1],[2],2,"36","36"],["5618","1968-10-24","Die Hamburger AStA-Vorsitzenden Jankowski und Litten werden in der kommenden Sitzung des Studentenparlaments von ihren Ämtern zurücktreten. Litten könne aus privaten Gründen das Amt nicht weiter wahrnehmen. Beide werden als \"Verfechter einer Politik der Vernunft\" dargestellt.","AStA-Vorsitzende treten heute zurück","","Aus privaten Gründen/ Amtszeit betrug acht Monate","V. W.",[4],7,[1],[2],1,"28","1"],["5619","1968-10-24","Ein CDU-Abgeordneter der Hamburger Bürgerschaft will mittels einer Anfrage klären, warum der vor fünf Monaten erlassene Haftbefehl gegen Karl-Heinz Roth noch nicht vollstreckt wurde.","\"Fall Roth\" wieder vor der Bürgerschaft","","","",[1],7,[1],[2],2,"28","3"],["5620","1968-10-24","Ein Seminar des Generalleutnant a. D. Wolf Graf von Baudissin wurde gestört. Mitglieder des LSD und des SDS versuchten von Beginn an, das Seminar in eine Diskussion umzufunktionieren. Das ein Soldat an der Universität lehre, sei ungeheuerlich, hieß es in einem Flugblatt.","Erstes Seminar von Baudissin wurde gestört","","Mit Trillerpfeife und Zwischenrufen","U. W.",[1],7,[1],[5],1,"28","6"],["5621","1968-10-25","Neuwahl des Hamburger AStA-Vorstandes. Nach über siebenstündiger Sitzung wurden der alte Vorsitzende Jankowski sowie Jochen Grote gewählt. Grote ist RCDS-Mitglied, Jankowski gehörte früher dem SHB an. Der alte Vorstand wurde politisch nicht entlastet. Mit der Wahl des neuen Vorstandes sei die Fortsetzung der bisherigen Politik des AStA mit dem Schwerpunkt der Hochschulreformen gewährleistet.","Neuer AStA hält den alten Kurs","","Die Wahl dauerte fast sieben Stunden","U. W.",[4],7,[1],[5],1,"32","4"],["5622","1968-10-25","Ein Leser lobt die Berichterstattung des Abendblattes über den Fall Obi Ifeobu und kritisiert ebenfalls den Hamburger Senat dafür, dass dieser immer noch an der Korrektheit der Ausweisung Ifeobus festhält.","\"Ifeobu, das Opfer?\"","Briefe an das Hamburger Abendblatt","","Leser",[1],7,[6],[2],2,"32","10"],["5623","1968-10-26","Die CDU fragt den Hamburger Senat, wann dieser den Bericht über die Ermittlungsverfahren gegen Demonstranten und Polizisten bzgl. der Vorfälle bei den Demonstration gegen den Schah-Besuch in Hamburg vorlegt.","Wann kommt der Senatsbericht?","","","",[1],7,[1],[2],2,"74","4"],["5624","1968-10-26","In Kürze sollen die Ingenieurschulen in Fachhochschulen umgewandelt werden.","Ingenieurschulen sollen Fachhochschulen werden","","","",[4],7,[1],[2],2,"74","8"],["5625","1968-10-26","Der Hochschulsprecher der CDU-Fraktion in der Hamburger Bürgerschaft widerspricht einem Artikel des Hamburger Abendblattes. Der Entwurf der CDU für ein neues Hochschulgesetz würde sich von dem der SPD unterscheiden und enthalte all die Grundsätze, die auch im Abendblatt an das Hochschulgesetz gestellt wurden.","\"Macht keine halbe Sache\"","Briefe an das Hamburger Abendblatt","","Horst Schröder (Leser, CDU)",[4],7,[6],[2],2,"74","9"],["5626","1968-10-30","Der VDS-Vorsitzende Ehmann kündigte einen bundesweiten Vorlesungsstreik für Januar 1969 an, sollte die Forderung nach \"Demokratisierung der Hochschulen\" nicht erfüllt werden. Zudem will der VDS eine koordinierte Öffentlichkeits- und Mitbestimmungskampagne an allen Universitäten beginnen, um überall die paritätische Mitbestimmung zu erreichen. Etwa 20 Assistenten des soziologischen Instituts der FU Berlin haben ihre Lehrtätigkeit aus Protest gegen die Entscheidung Rektor Harndts, Bernd Rabehl nicht als wissenschaftlichen Hilfsassistenten einzustellen, eingestellt. Der Tübinger Rektor Raiser hat drei Studenten des SDS, die zu Gefängnisstrafen verurteilt worden sind, seinen Rechtsbeistand angeboten. Er hält das Urteil für zu hart und würde notfalls auch sein Amt als Rektor zur Verfügung stellen.","Studenten drohen mit Vorlesungsstreik","","\"Mitbestimmungskampagne\" an allen Universitäten","",[1],7,[1],[3],2,"40","2"],["5627","1968-10-30","Die Staatsanwaltschaft hat für die Angeklagten im Prozess wegen der Frankfurter Kaufhausbrände (Baader, Ensslin, Proll, Söhnlein) je sechs Jahre Zuchthaus gefordert.","Zuchthaus beantragt","","","",[9],7,[1],[2],2,"40","26"],["5628","1968-10-31","Der Bundestagsausschuss für Wissenschaft, Kulturpolitik und Kunst empfiehlt, dass der Bund künftig die Rahmenkompetenz für das Hochschulwesen und die Bildungsplanung bekommt.","Bund zuständig für Hochschulwesen?","","","",[4],7,[1],[2],2,"26","2"],["5629","1968-10-31","Der neugegründete Hamburger Verband der Medizinalassistenten protestiert gegen die unzureichende Bezahlung und Ausbildung der Medizinalassistenten und gegen die unsichere rechtliche Stellung. Die Medizinstudenten erklärten sich mit ihnen solidarisch.","Jungärzte trommeln für bessere Bedingungen","","Mit Ausbildung und Bezahlung sind sie unzufrieden","U. W.",[4],7,[1],[5],1,"26","6"],["5630","1968-10-31","Die studentischen Vertreter der Mathematisch-Naturwissenschaftlichen Fakultät haben aus Protest ihre Mitarbeit in der Fakultät eingestellt, da die Fakultät es zuvor mit großer Mehrheit abgelehnt hatte, die Studentenvertreter an den Entscheidungen der Fakultät zu beteiligen.","Protest gegen Fakultätsbeschluss","","","",[1],7,[1],[2],2,"26","6"],["5631","1968-11-01","Bürgerschaft beschäftigt sich schwerpunktmäßig mit der unzureichenden Ausstattung der Universität und der Situation alter Leute in Hamburg.","Uni-Situation ist alarmierend, sagt die Opposition","","Massive Vorwürfe gegen den Senat","ga,thi",[11],7,[1],[1],2,"34","3"],["5632","1968-11-01","Professoren, Dozenten und Studenten des englischen Seminars protestieren gemeinsam gegen die schlechte personelle und materielle Ausstattung des Instituts.","Jetzt packen die Anglisten aus","","Unzumutbare Studien-Verhältnisse","U.W.",[11],7,[1],[1],2,"34","10"],["5633","1968-11-01","Tumulte im Gerichtssaal bei der Verkündung der Urteile für die Frankfurter Kaufhaus-Brandstifter.","Zuhörer erhielten Ordnungsstrafen","","","dpa",[9],7,[1],[2],2,"34","14"],["5634","1968-11-01","Ministerpräsidenten der Länder einigen sich darauf, dass aus den bisherigen Ingenieur-Schulen Fachhochschulen werden.","Ingenieurschulen werden Fachhochschulen","","","dpa",[11],7,[1],[2],2,"34","29"],["5635","1968-11-02","Kommentar zur Weigerung des FU-Rektors, Bernd Rabehl als Assistent einzustellen. ","Die Grenze der Toleranz","","","hoe",[11],7,[5],[5],2,"74","2"],["5636","1968-11-02","Gestürztes Wissmann-Denkmal nun von Studenten in der Mensa aufgestellt.","Jetzt steht Wissmann in der Mensa","","","",[11],7,[2],[2],2,"74","12"],["5637","1968-11-04","\"Linksextreme Splittergruppen\" gründen ein Aktionsbündnis zur Teilnahme an der Bundestagswahl 1969.","\"APO\" will neue Partei gründen","","","dpa",[11],7,[1],[2],2,"18","2"],["5638","1968-11-04","Kurzmeldung zur \"Schlacht am Tegeler Weg\" am Vormittag desselben Tages.","Tumult vor dem Berliner Landgericht","","","wy.",[6],7,[1],[2],2,"18","2"],["5639","1968-11-05","Kurzer Bericht zu den Unruhen am Tegeler Weg. Zitate von den Berliner Senatoren Hoppe und Neubauer dazu. Hinweis auf das Ehrengerichtsverfahren gegen Rechtsanwalt Mahler und den für ihn positiven Ausgang. ","Harte Kritik an der Berliner Straßenschlacht","","130 Polizisten verletzt - Hoppe: \"Kriminelles Unrecht!\"","wy",[6],7,[1],[2],1,"20","1"],["5640","1968-11-06","Innensenator Neubauer warnt \"Krawallmacher\" der APO, dass die Polizei im Wiederholungsfall solcher Tumulte Gebrauch von den Schusswaffen machen werde. \"Die Polizeibeamten haben nicht Planstellen als Zielscheibe für Wildgewordene.\"","Neubauer warnt die Krawallmacher","","","dpa, upi",[6],7,[1],[2],2,"40","1"],["5641","1968-11-06","Jens Litten wird aus dem SHB ausgeschlossen, da er einen RCDS-Kandidaten zum AStA-Referenten unterstützt habe. Außerdem habe er durch Intrigen Zwietracht gesät.","SHB schloss Jens Litten aus","","","",[11],7,[1],[2],2,"40","3"],["5642","1968-11-07","Erster Anlauf des Wissmann-Prozesses gescheitert, weil die Angeklagten das Verfahren im Audimax abgehalten wissen wollten. Ungewissheit über den künftigen Standplatz des Denkmals.","Abends gingen sie zum Gericht","","Montag findet die Verhandlung gegen die Wissmann-Angeklagten statt","U.W.",[11],7,[1],[5],1,"26","6"],["5643","1968-11-07","Gastbeitrag Littens zur Politik des SHB und des AStA in Hamburg und zu seinem Ausschluss aus dem Verband.","Jens Litten: Studentenschaft ist irritiert","","Kritik an der Politik des SHB","Jens Litten",[11],7,[5],[1],1,"26","6"],["5644","1968-11-07","Brandt verteidigt die Unruhe der Jugend bei gleichzeitiger Verwerfung von Gewalt und Intoleranz.","Brandt plädiert für die Jugend","","Rede vor der UNESCO","sad, upi",[1],7,[1],[5],2,"26","23"],["5645","1968-11-08","Student musste Nacht in Untersuchungshaft verbringen, weil der in Sachen Wissmann-Denkmal nicht vor Gericht erschienen war.","Student verhaftet: Eine Nacht im UG","","","",[11],7,[1],[2],1,"36","3"],["5646","1968-11-09","SPD-Präsidium in Bonn hat die Ausschreitungen der jüngsten Zeit scharf verurteilt. Berliner TU-AStA abgewählt, weil er sich nicht von den Krawallen distanziert hat. Professor Gollwitzer verurteilt Krawalle scharf.","SPD verurteilt Ausschreitungen der APO","","","wst, dpa ",[6],7,[1],[2],2,"84","1"],["5647","1968-11-09","Mehrere hundert Demonstranten in München demonstrieren am Rande eines Juristenballs gegen \"Klassenjustiz\".","APO-Demonstration gegen Juristenball","","","AP",[1],7,[1],[2],2,"84","2"],["5648","1968-11-11","Angeklage im Wissmann-Fall erscheinen nicht vor Gericht. \"Durch ihren Verteidiger, Rechtsanwalt Groenewold, ließen die Angeklagten wie schon in der vergangenen Woche vortragen, dass der Saal ihrer Meinung zu klein sei, um eine politisch interessierte studentische Öffentlichkeit aufzunehmen. Der Anwalt erklärte sich mit seinen Mandanten solidarisch, legte sein Mandat nieder und verließ den Saal.\" ","Angeklagte Studenten kamen nicht zum Termin","Letzte Meldung:","Heute Prozess gegen Hamburger Denkmalsstürmer","frk.",[11],7,[1],[5],2,"20","1"],["5649","1968-11-11","Leser stellt fest, dass sich der NHB am Sturz des Wissmann-Denkmals nicht beteiligt hat.","Wissmann-Denkmal","Briefe an das Hamburger Abendblatt","","Leser",[11],7,[6],[2],2,"20","7"],["5650","1968-11-12","FDP legt als Orientierungshilfe den Entwurf eines einheitlichen Hochschulgesetzes vor.","FDP legt einheitliches Hochschulgesetz vor","","","dpa, ap, upi",[4],7,[1],[2],2,"22","1"],["5651","1968-11-12","Kommentar, der zwar grundsätzliche Sympathie für die mit der Wissmann-Sache verdeutlichte Kritik am Kolonialismus zeigt, jedoch den Tätern mangelndes Geschichtsbewusstsein ankreidet.","Bilderstürmer","","","hoe.",[11],7,[5],[5],2,"22","2"],["5652","1968-11-12","Ergebnis einer Diskussion im Audimax: \"Die Universität habe sich auch politisch für die Freiheit der Wissenschaft einzusetzen. Daher sei auch die Studentenschaft als Teil der Universität verpflichetet, sich politisch zu äußern.\"","Studenten wollen in der Politik mitreden","","AStA diskutierte mit Professoren im Audimax","t.w.",[11],7,[1],[2],2,"22","4"],["5653","1968-11-12","Je 300 Mark Geldstrafe für die fünf Personen, die vor einem Jahr versucht hatten, das Wissmann-Denkmal zu stürzen. Der Leiter des Arbeits- und Freundeskreises der Ostafrikaner in Hamburg will jetzt gegen diejenigen klagen, die das Denkmal nun tatsächlich entfernt haben.","Die Urteile im Wissmann-Prozess: 300 DM Geldstrafe","","Kreis der Ostafrikaner will klagen","frk.",[11],7,[1],[1],2,"22","5"],["5654","1968-11-13","Leserbrief von Mitgliedern des SHB-Landesvorstandes. Erwiderung zum Gastbeitrag Littens über seinen Ausschluss aus dem Verband.","SHB zu Littens Ausschluss","Briefe an das Hamburger Abendblatt","","Leser",[11],7,[6],[2],2,"36","4"],["5655","1968-11-13","Fachschaft der Mathematisch-Naturwissenschaftlichen Fakultät der Hamburger Uni legt Entwurf eines Hochschulgesetzes vor.","Studenten mit eigenem Hochschulgesetz-Entwurf","","","",[4],7,[1],[2],2,"36","5"],["5656","1968-11-14","\"Die Kieler Studentenschaft scheint von den 'Radikalinskis' in der Führung genug zu haben.\" AStA-Chef vom SDS zurückgetreten, weil sein Antrag, kein eigenes studentisches Hochschulmodell vorzulegen, gescheitert war.","Kieler Studenten gehen auf maßvolleren Kurs","","AStA-Vorsitzender Achterberg zurückgetreten","dpa",[11],7,[1],[3],2,"30","2"],["5657","1968-11-14","Leserbriefschreiber betont, dass die FSU Freisoziale Union Demokratische Mitte nicht zur APO gehört.","Gehört nicht zur APO","Briefe an das Hamburger Abendblatt","","Leser",[11],7,[6],[2],2,"30","24"],["5658","1968-11-15","In Frankfurt ist eine Diskussion über die Hochschulreform an Störungen des SDS gescheitert.","Hochschulreform nur gegen SDS möglich","","","dpa",[4],7,[1],[2],2,"38","2"],["5659","1968-11-15","Hamburger Studentenparlament richtet Hilfsfond ein, um Studenten helfen zu können, die Prozesse wegen Demoteilnahme zu erwarten haben.","Studenten erhalten Hilfe in Prozessen","","","",[1],7,[1],[2],2,"38","5"],["5660","1968-11-16","Bei einer Veranstaltung der Evangelischen Studentengemeinde werden die spezifischen Probleme ausländischer Gaststudenten diskutiert.","Gaststudenten scheitern oft an der Sprache","","","",[11],7,[1],[2],2,"70","3"],["5661","1968-11-19","CSSR sperrt vorübergehend bayerische Grenzübergänge für westliche Studenten.","Für Studenten gesperrt","Bunte Welt","","",[9],7,[1],[2],2,"32","2"],["5662","1968-11-19","Vorstellung des neuen fünfköpfigen SDS-Vorstandes.","SDS hat jetzt ein \"Vorstandskollektiv\"","","","dpa",[8],7,[1],[2],2,"32","2"],["5663","1968-11-19","Das Braunschweiger Verwaltungsgericht hat in einem Grundsatzurteil die Zwangsexmatrikulation eines Dauerstudenten bestätigt. Details zu den Voraussetzungen des Urteils.","30 Semester waren auch dem Gericht zuviel","","Ausschluss wegen Missbrauchs der Studierfreiheit","R.St.",[9],7,[1],[5],2,"32","14"],["5664","1968-11-21","Der am 20. Februar wegen angeblichen Landfriedensbruchs ausgewiesene Nigerianer Ifeobu darf wieder nach Hamburg kommen, um sein Medizinstudium fortzusetzen.","Ifeobu darf nach Hamburg zurückkehren","","","ab",[9],7,[1],[2],1,"34","5"],["5665","1968-11-21","Resultate eines Teach-in evangelischer Jugend: Demonstrationen vor dem griechischen und iranischen Konsulat, eine kritische Resolution an den hamburgischen Landesbischof Wölber und ein Telegramm an die Bundesregierung, sich für einen zum Tode verurteilten Griechen einzusetzen.","In diesem \"Teach-in\" wurde etwas in Gang gesetzt","","Junge Christen trafen sich am Bußtag - Thema: Dritte Welt","sic.",[1],7,[1],[1],1,"34","5"],["5667","1968-11-22","Evangelische Jugend distanziert sich von Demonstrationszug vor das Haus des Bischofs Wölber","Evangelische Jugend distanziert sich","","","epd",[1],7,[1],[2],2,"34","4"],["5668","1968-11-25","Philosophische Fakultät gliedert sich probeweise für zwei Semester in sechs Abteilungen.","Die erste Fakultät hat sich aufgegliedert","","Aber nur auf Probe / Philosophen in sechs Gruppen","U.W.",[11],7,[1],[2],2,"18","5"],["5669","1968-11-25","Teilnehmer widersprechen der HA-Berichterstattung zum Teach-in vier Tage zuvor","Zum \"Teach-in\" junger Christen","Briefe an das Hamburger Abendblatt","","Leser",[1],7,[6],[2],2,"18","8"],["5670","1968-11-26","Tumulte bei Diskussionsveranstaltung zwischen Studentenvertretern, Bürgermeister und Bürgerschaftsarbgeordneten im Audimax","Studenten warfen mit Bananenschalen","","","k.a.",[1],7,[1],[2],2,"22","3"],["5671","1968-11-27","FDP bringt bundeseinheitlichen Gesetzentwurf für die Hochschulreform ein","FDP für Drittelparität in Hochschul-Gremien","","Erster bundeseinheitlicher Reformgesetz-Entwurf","Eigener Bericht",[4],7,[1],[5],2,"36","2"],["5672","1968-11-27","AStA entschuldigt sich für die Tumulte bei Diskussionsveranstaltung zwischen Studentenvertretern, Bürgermeister und Bürgerschaftsabgeordneten im Audimax","AStA bedauert das Bananen-Bombardement","","","k.a.",[1],7,[1],[2],2,"36","3"],["5673","1968-11-29","Kultusminister und Senatoren der Bundesländer einigen sich darauf, dass Lehrstühle an Hochschulen in Zukunft grundsätzlich ausgeschrieben werden sollen.","Lehrstühle werden ausgeschrieben","","","DPA",[4],7,[1],[5],2,"48","1"],["5674","1968-11-29","Studentenparlament stiftet insgesamt 2000 Mark für die Biafra-Soforthilfe und einen Informationsfeldzug","Studentenparlament stiftet Geld für Biafra","","","k.a.",[9],7,[1],[2],2,"48","3"],["5675","1968-12-02","Polizei will bei Demonstrationen nicht mehr \"tatenlos zusehen\".","Demonstranten sollen früh zerstreut werden","","","DPA",[1],7,[1],[3],2,"18","1"],["5676","1968-12-04","BND wollte an der Kieler Universität Studenten als neue Mitarbeiter anwerben - Proteste in Kiel und Bonn","BND wollt erneut Kieler Studenten anwerben","","Prof. Trappe will zurücktreten / Protest in Bonn","Eigener Bericht",[9],7,[1],[5],2,"34","12"],["5677","1968-12-05","Richter und Staatsanwälte sollen der \"Justizkampagne\" von APO/SDS entgegentreten","Richter sollen sich nicht unter Druck setzen lassen","","Bosselmann fordert Härte gegen Störaktionen","Eigener Bericht / DPA",[9],7,[1],[5],2,"34","1"],["5678","1968-12-07","Demonstrationszug mit 800 Beteiligten durch die Hamburger Innenstadt","Demonstrationszug durch die Stadt","","","k.a.",[1],7,[1],[2],2,"68","4"],["5679","1968-12-09","Anwerbungsversuche des BND an Kieler Universität - Rekonstruktion der Ereignisse","Nachwuchs für BND offen anwerben","","Professor Freund zu den Vorfällen in Kiel / Universität erregt","Eigener Bericht",[9],7,[1],[5],2,"16","2"],["5680","1968-12-10","Niedersächsische Landesregierung will \"modernes Ordnungsrecht\" an Hochschulen einführen, um Studenten leichter exmatrikulieren zu können","Modernes Ordnungsrecht für die Hochschulen","","Anlaß: Skandal an der Göttinger Universität","Eigener Bericht",[9],7,[1],[5],2,"18","1"],["5681","1968-12-10","AStA kündigt neue Demonstrationen an, wenn das neue Hochschulgesetz Wünsche der Studentschaft nicht berücksichtigt","Der AStA kündigt neue Aktionen an","","Nur mit Zustimmung der Studentenschaft / Es geht um das Hochschulgesetz","U.W.",[11],7,[1],[5],2,"18","4"],["5682","1968-12-10","Aufforderung zu Demonstrationen der Öffentlichkeit. Der Protest dürfe nicht nur auf die studentische Jugend beschränkt bleiben ","Protestdemonstrationen und Studenten","","","Dietrich Green",[1],7,[6],[2],2,"18","14"],["5683","1968-12-11","Etatdebatte der Hamburger Bürgerschaft","Debatte über die Demonstrationen: CDU fordert mehr Entschiedenheit","","Ruhnau: \"Es gibt kein festes Rezept\" - Kritik an der Personalpolitik der SPD","co./ga./thi.",[1],7,[7],[1],1,"34","6"],["5684","1968-12-11","Hamburger Kirchenleitung plant Evangelische Studentengemeinde zu schaffen.","Evangelische Studenten eine unbequeme Gruppe?","","Schwere Vorwürfe gegen Hamburger Kirchenleitung","hoe",[3],7,[1],[5],2,"34","8"],["5685","1968-12-12","Komponist Henze stand in Verbindung zum SDS - hat die Störungen zu Beginn seines Oratoriums \"Das Floß der Medusa\" selbst zu verantworten","Henze bestellte Demonstranten","","","Eigener Bericht",[1],7,[1],[1],2,"32","1"],["5686","1968-12-12","Wahl des neuen Dekans der Philosophischen Fakultät wurde durch eindringende, singende Studenten verhindert - Forderung nach Wahlrecht und öffentlicher Aussprache","Gesang verhinderte Wahl des Dekans","","","k.a.",[1],7,[1],[2],2,"32","3"],["5687","1968-12-13","Gerichtsverhandlung gegen Philologie-Studentin wegen Hausfriedensbruch. Acht Studentinnen strippen im Gerichtssaal","Striptease vor Gericht","","\"Oben-ohne Schau\" verpuffte / Angeklagte freigesprochen","frk",[1],7,[7],[5],2,"34","8"],["5688","1968-12-13","Acht Rezensionen zum Thema \"Jugendproteste\"","Rebellen ohne Programm!","","Der Protest der Jugend - Thema zahlreicher Neuerscheinungen","hoe",[9],7,[5],[1],2,"34","10"],["5689","1967-12-14","Beginn eines Berichts über die Etatdebatte in der Bürgerschaft. U. a. Kritik an Finanzzuwendungen an den SDS.","Jahrelang halfen Steuern dem SDS","","Etatdebatte: Ruhnau scharf angegriffen","",[8],7,[1],[5],1,"24","3"],["5690","1968-12-16","Eröffnung der Universität Dortmund in Anwesenheit von Bundespräsident Lübke","Neue Universität","","","DPA",[11],7,[1],[3],2,"16","1"],["5691","1968-12-16","Demonstration in Berlin gegen den Freispruch von Hans-Joachim Rehse","5000 demonstrierten gegen Rehse-Urteil","","","DPA",[1],7,[1],[3],2,"16","2"],["5692","1968-12-17","Dr. Werner Skuhr referiert über \"Revolution oder Reform an der Hochschule\" an der Hamburger Hochschule und erläutert das OSI-Reformmodell","Reform oder Revolution?","","","ck.",[4],7,[1],[2],2,"20","9"],["5693","1968-12-17","Festveranstaltung zur Eröffnung der Universität Dortmund wird von Handgreiflichkeiten und studentischen Protestgesängen begleitet","Handgemenge bei der Universitätseröffnung","","Polizei schritt gegen studentische \"Protestsänger\" ein","DPA/ap/upi",[1],7,[1],[5],2,"20","17"],["5694","1968-12-18","Studentenvertretung der TU Clausthal beschließt Demonstration vor dem Generalkonsulat des Iran","Neuer Protest vor Generalkonsulat","","","k.a.",[1],7,[1],[2],2,"28","3"],["5695","1968-12-18","Demonstrationszug der \"Kampagne für Demokratie und Aufrüstung\" mit 300 Beteiligten legt Hamburger Innenstadtverkehr lahm","Hupkonzert bei Demonstration in der City","","","szw",[1],7,[1],[2],2,"28","4"],["5696","1968-12-19","Brandanschlag auf das Rektoratsgebäude der FU Berlin verübt - Gesamtschaden 5000 DM","Brandanschlag auf Rektoratsgebäude","","","Von unserer Berliner Redaktion",[1],7,[1],[2],2,"28","1"],["5697","1968-12-19","Prof. Dr. Kurt Pawlik wurde unter Ausschluß der Öffentlichkeit zum neuen Dekan der Philosophischen Fakultät gewählt. Rund 100 Studenten protestieren gegen \"undemokratischen Wahlmodus\"","Neuer Dekan der Philosophen","","","k.a.",[11],7,[1],[2],2,"28","3"],["5698","1968-12-19","Hauptverhandlung gegen Studenten musste aufgrund von Unruhen und Verfahrensfehlern ausgesetzt werden","Der Richter übersah das Happening","","Studenten-Prozeß geplatzt","frk",[9],7,[7],[2],2,"28","5"],["5699","1968-12-19","Westdeutsche Rektorenkonferenz lehnt eine vom Saat bestellte Leitung der Universität ab ","Rektoren gegen Staatsdirigismus","","","DPA/ap",[11],7,[1],[2],2,"28","12"],["5700","1968-12-20","Wahl von Prof. Bruno Bösch zum Rektor der Universität Freiburg erfolgt unter Polizeischutz. SDS rief im Vorfeld zu Protestaktionen auf","Rektorwahl unter Polizeischutz","","","DPA",[1],7,[1],[2],2,"28","2"],["5701","1968-12-23","Memorandum über den Ausbau des Instituts für Leibesübungen wird dem Akademischen Senat der Universität vorgelegt","Ausbau-Memorandum soll vorgelegt werden","","","k.a.",[11],7,[1],[2],2,"18","3"],["5702","1968-12-23","Jugendliche randalieren in Kaufhäusern und beschädigen Autos - 25 Festnahmen","Jugendliche randalierten","","","k.a.",[1],7,[1],[2],2,"18","6"],["5703","1968-12-24","Bericht über die Entwicklung eines \"Neuen Christentums\" und einem größeren politischen Engagement der Kirche","Das politische Evangelium","","Rebellen im Namen Christi","Dr. Erich Hoepfner",[3],7,[1,2],[4],1,"32","IV"],["5704","1968-12-24","Forderung nach Reformation von Kirche und Gesellschaft","Die rebellischen Thesen an den Kirchentüren","","Auszüge aus den am Reformationstag in Hamburg angeschlagenen 55 Thesen junger Christen","k.a.",[3],7,[1],[2],2,"32","IV"],["5705","1968-12-24","Arbeitsgemeinschaft der Studentenausschüsse der \"zukünftigen Hamburger Fachhochschulen\" bringt eigenen Entwurf zur Fachhochschulgesetzgebung ein","Eigener Gesetzentwurf für die Fachhochschulen","","","k.a.",[9],7,[1],[2],2,"32","5"],["5706","1968-12-27","APO dringt in leerstehendes Gebäude der chinesischen Botschaft in Berlin ein. Bereits im Vorfeld kam zu Handgreiflichkeiten und Störaktionen.","APO randalierte in Berlin","","","Von unserer Berliner Redaktion",[11],7,[1],[2],2,"22","10"],["5707","1968-12-31","Differenzierte Bewertung der Studentenproteste, Gewalt als \"untaugliches Mittel zur fortschrittlichen Veränderung der Gesellschaft\", Demokratie im Staat muss \"zur Sache aller Bürger\" werden ","Vertrauen in die junge Generation!","","","Heinz Ruhnau",[1],7,[5],[4],1,"36","19"],["5708","1967-09-22","Die Staatsanwaltschaft hat neues Beweismaterial über Polizisten, die sich bei den Demonstrationen gegen den Schah-Besuch strafbar gemacht haben könnten, erhalten. Zudem gehen die Ermittlungen weiter, wer für die Zurückhaltung von Videobändern der Polizei im gleichen Zusammenhang verantwortlich ist. Gegen 42 Demonstranten laufen noch Ermittlungsverfahren.","Neues Beweismaterial zu den Schah-Demonstrationen","","Justizbehörde: Zahl der verdächtigen Polizisten erhöht.","ga.",[1],7,[1],[1],2,"24","4"],["5709","1968-02-14","Berlins Regierender Bürgermeister Schütz stellt Strafantrag wegen Beleidigung gegen Redakteure der Studentenzeitung \"FU-Spiegel\", die einen Leserbrief der \"Kommune I\" abgedruckt hatten, in dem Schütz verunglimpft wurde","Strafantrag gegen Studentenzeitung","","","rb.",[9],2,[1],[2],2,"8","2"],["5710","1968-02-14","Wissenschaftler des Osteuropa-Instituts analysiert SDS vor Untersuchungsausschuss.","SDS unter die Lupe genommen","","","rb.",[8],2,[1],[2],2,"8","2"],["5711","1968-02-15","Rudi Dutschke sieht große Gemeinsamkeiten mit dem \"kommunistischen Lager\" ","\"Gemeinsam mit Kommunisten\"","","SDS legt seine Haltung fest","rb.",[8],2,[1],[3],2,"8","2"],["5712","1968-02-16","Berliner Polizeigewerkschaft ruft Bürger auf, sich nicht an nicht genehmigten Studenten-Demos zu beteiligen","Aufruf an die Berliner","","Gewerkschaft: Unterstützt die Polizei!","rb.",[1],2,[1],[2],2,"14","1"],["5713","1968-02-16","Chefredakteur der Studentenzeitung \"FU-Spiegel\" entschuldigt sich bei Regierendem Bürgermeister Schütz für Abdruck eines beleidigenden Leserbriefs der \"Kommune I\"","\"FU-Spiegel\" entschuldigt sich bei Schütz","","","rb.",[9],2,[1],[2],2,"14","8"],["5714","1968-02-17","Schütz warnt SDS vor nicht genehmigter Vietnam-Demo und kündigt Einsatz der Polizei an","Schütz: Letzter Appell an die Demonstranten","","? aber der SDS will auf die Straße","Jürgen Oster",[1],2,[1],[3],2,"12","2"],["5715","1968-02-19","Kaum Gewalt bei Groß-Demo des SDS gegen Vietnamkrieg","Berliner ließen sich nicht aus der Ruhe bringen!","10.000 unter roten Fahnen: Vietnam-Protest wurde zur Propaganda-Schau für den Kommunismus - aber","Auch Gegen-Demonstrationen ohne Zwischenfälle","rb.",[1],2,[1],[1],1,"12","1"],["5716","1968-02-19","Polizei kontrolliert Vietnam-Demo auf dem Kudamm und hält Gegen-Demonstranten in Schach","Arbeiter holten Fahne vom Kran","","keine ","",[1],2,[1],[1],1,"12","2"],["5717","1968-02-20","Berliner Bürger und Gewerkschaften wollen auf ÖTV-Großkundgebung ein Zeichen gegen linke Vietnam-Demo setzen","Schütz: Wir müssen sagen, was wir wollen","","Gewerkschaft ÖTV ruft zur Demonstration auf","Jürgen Oster",[1],2,[1],[1],1,"10","2"],["5718","1968-02-21","Schütz und Gewerkschaften rufen zur Kundgebung vor dem Rathaus Schöneberg auf","Berlin steht für Freiheit und Frieden!","Heute 16 Uhr 30:","","rb.",[1],2,[1],[1],2,"10","1"],["5719","1968-02-21","Zahlen und Daten zur Kundgebung vor dem Schöneberger Rathaus","Laßt Eure Autos zu Hause!","Großkundgebung vor dem Rathaus","","jo/P. be",[1],2,[1],[1],1,"10","2"],["5720","1968-02-22","Schütz bekennt sich zu Amerika, der Schutzmacht Berlins","150.000 vor dem Rathaus","Das war die Antwort Berlins","","rb.",[1],2,[1],[1],1,"10","1"],["5721","1968-02-22","Bericht über die Senatsdemo. Berliner schwenken amerikanische Fahnen, störende Gegegendemonstranten werden von Polizei verhaftet. Abgebildet sind mehrere der mitgeführten Transparente, u. a. eines mit dem Text \"Lasst Bauarbeiter ruhig schaffen - kein Geld für langbehaarte Affen\". In der Hamburg-Ausgabe der BILD war dieses Zitat als Beleg für den besonderen \"Witz\" der Berliner zur Titelschlagzeile avanciert.","Ohne Amerikaner gibt es keine Freiheit für Berlin!","150.000 vor dem Rathaus","","rb.",[1],2,[1],[1],1,"10","2,3"],["5722","1968-02-24","Wegen Werfen von Knallkörpern und Richterbeleidigung zwei Monate Haft für Kommunarden Fritz Teufel","Teufel muß zwei Monate ins Gefängnis","","","zy.",[5],2,[1],[2],2,"8","2"],["5723","1968-02-24","SDS stört Gedenkfeier zum Widerstand an der Münchner Universität","Studenten setzten den Krawall-SDS an die Luft","","","ma.",[8],2,[1],[2],2,"8","8"],["5724","1968-02-26","Dutschke-Vortrag in Amsterdam mit wenig Resonanz","Dutschke - 2 Jahre zu spät?","","","",[2],2,[1],[2],1,"12","2"],["5725","1968-02-29","Wegen Beleidigung der Königsfamilie soll in Holland ein Strafverfahren gegen Dutschke eingeleitet werden","Dutschke beleidigt Prinz Claus","","","",[2],2,[1],[2],2,"10","10"],["5726","1968-02-03","Gewaltaktionen gegen Filialen des Axel Springer Verlages sorgen für Empörung bei Senat und Opposition","Gewaltaktion gegen Springer-Filialen","","In fünf Westberliner Bezirken Fensterscheiben zertrümmert. Justizsenator Hoppe: Das sind faschistische Methoden","",[10],8,[1],[2],1,"16","1"],["5727","1968-02-04","Nach Abschluß einer genehmigten Demo vor der griechischen Militärmission kam es zu Zusammenstössen radikaler Studentengruppen mit der Polizei","Demonstranten blockierten zeitweise den Kurfürstendamm","","Wasserwerfer eingesetzt - Sitzdemonstration vor der griechischen Militärmission verlief ohne Zwischenfälle","",[1],8,[1],[2],1,"42","1,2"],["5728","1968-02-04","Krawalle bei Anti-Vietnam-Demo am Kudamm legen Verkehr lahm","Krawall nach ruhiger Demonstration","","Mindestens 24 Festnahmen - Polizei setzte Wasser und Schlagstöcke ein","",[1],8,[1],[1],1,"42","14"],["5729","1968-02-04","Leserbriefschreiber fordern Aufklärung von Polizeiübergriff","Körperverletzung im Amt","","","Prof. Dr. Hermann Blei, Udo Wille",[9],8,[6],[1],2,"42","17"],["5730","1968-02-06","Mit Dutschke an der Spitze demonstrierten 1000 Studenten gewaltsam vor dem amerikanischen Generalkonsukat in Frankfurt ","Dutschke provozierte in Frankfurt antiamerikanische Tumulte","","Auch Bundesflagge wurde angezündet - Polizei setzte Wasserwerfer ein","",[2],8,[1],[1],2,"14","2"],["5731","1968-02-06","Studentenvertretung der TU fordert Parität in allen Uni-Gremien","Demokratisierung - mit radikalen Methoden?","","","",[9,11],8,[5],[1],2,"14","6"],["5732","1968-02-11","Soziologiestudent fühlt sich von Studentenvertretung nicht repräsentiert","Wunsch der Studenten","","","Jürgen Matthes",[9],8,[6],[1],2,"42","16"],["5733","1968-02-13","Soziologiestudent lehnt \"Kritische Universität\" ab und kritisiert Unwissenschaftlichkeit der Auseinandersetzung mit dem Axel-Springer-Verlag","Minderheit einer Minderheit","","","Jürgen Matthes",[10],8,[5],[5],1,"12","6"],["5734","1968-02-15","SDS rechnet mit 10.000 bis 15.000 Teilnehmer der nicht genehmigten Vietnam-Demo in Berlin","Dutschke und Mahler sprechen von angeblichem Widerstandsrecht","","Erklärungen der Veranstalter des Vietnam-Kongresses in Berlin","",[2,1],8,[1],[1],2,"16","6"],["5735","1968-02-17","Studie warnt vor Infragestellung der Demokratie durch Moralisierung des Vietnam-Krieges","Die Vietnam-Kampagne an den deutschen Universitäten","","Eine Analyse des \"Arbeitskreises zum Schutz der Freiheit von Forschung und Lehre in der Freien Universität Berlin\"","",[9],8,[1],[5],2,"12","3"],["5736","1968-02-17","In der Rubrik \"Die Meinung der Opposition\" beklagt ein Politiker das politische Mitläufertum der Masse der Studenten","Konventionelle Vorstellungen überspringen","","","Hans-Joachim Boehm, MdA",[9],8,[5],[1],2,"12","6"],["5737","1968-02-18","Bericht über ominöses Flugblatt, das zu Demo gegen SDS-Aktivitäten gegen amerikanische Einrichtungen in Zehlendorf aufruft","Am Rande bemerkt - Bürger von Zehlendorf","","","thes",[8],8,[1],[2],2,"48","8"],["5738","1968-02-18","Leserbriefschreiber kritisiert den evangelischen Theologen Gollwitzer, der die Darstellung des Gemeinderats zur Gottesdienststörung in der Kaiser-Wilhelm-Gedächtniskirche als \"wahrheitswidrig\" bezeichnet hatte","Professor Gollwitzer kritisiert","","","Dr. Ulrich Brost",[3],8,[6],[1],2,"48","17"],["5739","1968-02-22","Berliner folgen dem Aufruf des Senats, der Parteien und der Gewerkschaften und demonstrieren ihr Vertrauen in die Schutzmächte","150.000 demonstrierten auf dem Kennedy-Platz","","Absage an Extremisten - Vertrauensverhältnis zu den Schutzmächten bekundet - Für friedliche Vietnam-Lösung - Mehrere Zwischenfälle","",[1],8,[1],[1],1,"14","1,2"],["5740","1968-02-22","Kritik an einigen hundert \"rechten\" Demonstranten, die nach der Kundgebung am Rathaus Schöneberg geprügelt hatten","Saat der Gewalt","Unsere Meinung:","","thes",[1],8,[5],[2],2,"14","1"],["5741","1968-02-25","Kommentator wirbt für Recht der Jugend auf Veränderung und fordert Bund und Länder auf, endlich Universitätsreformen einzuleiten","Berlin - was nun?","","","sx",[4],8,[5],[5],2,"44","1"],["5742","1968-02-25","Verletzte schildern, wie sie von Kundgebungsteilnehmern bedroht und verprügelt wurden. 20 Verletzte.","Verletzte schildern ihre Kundgebungserlebnisse","","Nicht mitgeklatscht - Prügelszene fotographiert","son",[1],8,[1],[1],2,"44","14"],["5743","1968-02-25","Leserbriefschreiber sehr kontrovers zum Streit über Demonstrationen und Kundgebungen in Berlin","Demonstrationen","","","Karl-Otto Nikusch, H. Weigert, A. Pritsch, W. Lenz, Cralotte Haberland, Melchior Fischer, Hartmut Walsdorff, Ulrich Hinz, Emmi Plückhahn",[1],8,[6],[1],2,"44","25"],["5744","1968-02-27","Begründung der Zeitungsherausgeber, warum ein AStA-Beitrag der FU nicht im Tagesspiegel erscheinen kann","Studenten über ihre Probleme","","","Die Herausgeber",[9],8,[5],[5],2,"12","6"],["5745","1968-02-29","Bericht über Teilreformen und Veränderungen im Studienablauf an der Juristischen Fakultät der FU","Von der Vorlesung zur Besprechungsstunde","Studienreform an der Freien Universität","Änderungen im Studium an der Juristischen Fakultät","Hartwig Heber",[4],8,[1],[1],2,"16","10"],["5746","1968-04-11","Jugendliche stören Faust-Aufführung mit Ho-Tschi-Minh-Rufen","Faust II mit Ho Tschi Minh gestört","","Zwischenfälle gestern Abend im Schillertheater - Zwei Festnahmen","",[1],8,[1],[5],2,"18","8"],["5747","1968-04-12","Attentat auf Rudi Dutschke löst Gewalt gegen Axel-Springer-Verlag aus","Mordanschlag in Berlin auf Rudi Dutschke","","Bei Revolver-Attentat am Kurfürstendamm schwer verletzt - Täter nach Feuergefecht mit der Polizei gefaßt - Demonstranten im Springer-Haus","",[2,10],8,[1],[1],1,"16","1,2"],["5748","1968-04-12","Kommentator befürchtet Weimarer Verhältnisse und wirft Senat Versäumnisse vor, Dutschke wird als Fanatiker der geistigen Auseinandersetzung bezeichnet.","Der Mordanschlag","","","",[2],8,[5],[2],2,"16","2"],["5749","1968-04-14","Linke Studenten attackieren Einrichtungen des Axel-Springer-Verlages und blockieren Straßen","Nach Mordanschlag auf Dutschke Kettenreaktion von Gewalttätigkeiten","","Appelle von Kiesinger und Schütz - Springerkonzern Hauptziel der Übergriffe - Außerparlamentarische Opposition plant neue Aktionen","",[2,10],8,[1],[1],1,"44","1,2"],["5750","1968-04-14","Schwere Ausschreitungen von Jugendlichen in Hamburg, Frankfurt, München, Hannover, Aachen und Esslingen nach dem Attentat auf Rudi Dutschke.","Ausschreitungen auch in Westdeutschland","","Straßenschlachten zwischen Jugendlichen und Polizei - Demonstranten drangen in Kirchen ein","",[10,2],8,[1],[1],2,"44","2"],["5751","1968-04-14","Studenten fordern als Bedingung für Gespräche, Schütz müsse die Enteignung des Axel-Springer-Verlages im Abgeordnetenhaus diskutieren . Weitere Demonstrationen/Ausschreitungen nach dem Attentat auf Dutschke.","Demonstranten kurz bei Schütz","","Treffen mit außerparlamentarischer Opposition kam nicht über Anfang hinaus","",[10,2],8,[1],[5],1,"44","2"],["5752","1968-04-14","Dutschke-Attentäter Josef Bachmann plante länger schon aufsehenerregendes Verbrechen","Durch Mord an King angeregt","keine ","Geständnis des Dutschke-Attentäters","",[2],8,[1],[2],2,"44","2"],["5753","1968-04-14","Kommentator meint, \"geistige Unruhe\" sei \"Bürgerpflicht\" und attackiert Springer wegen \"politisch eingesetzter Konzentrierung publizistischer Macht\"","Bestehen wir die Probe?","","","",[10,2],8,[5],[2],2,"44","2"],["5754","1968-04-14","Linke Demonstranten stürmen Springer-Hochhaus und entfesseln Straßenschlacht in der Kochstraße, am Rathaus Schöneberg und am RIAS-Gebäude","Tag und Nacht Unruhe und Zusammenstösse","","Die Ereignisse in den Berliner Straßen seit dem Anschlag auf Dutschke - Brennpunkt Springer-Haus","",[10,2],8,[1],[1],1,"44","3"],["5755","1968-04-14","SDS erklärt bei Protestveranstaltung an TU, \"das ganze System sei umzuwälzen\" und ruft zu \"kalkulierter Gewalt\" besonders gegen Springer auf","Aufrufe zu \"Aktionsunruhe\" und \"kalkulierter Gewalt\"","","Die Diskussionen in der Technischen Universität am Freitag und Sonnabend","",[8],8,[1],[5],2,"44","3"],["5756","1968-04-14","Strafanzeigen gegen Schütz und Amrehn wegen Anstiftung zum Mord; Berliner CDU verurteilt Angriffe auf Springer","Strafanzeige gegen Schütz - Verbot des SDS gefordert","","Kontroverse Reaktionen in der Bundesrepublik auf den Anschlag gegen Dutschke und die Ausschreitungen","",[10,2],8,[1],[1],2,"44","9"],["5757","1968-04-17","Aufruf zu Reformbereitschaft, \"um Revoluzzer zu isolieren\"","Für radikale Vernunft","Unsere Meinung:","","",[9],8,[5],[2],2,"18","1"],["5758","1968-04-17","Osterschlacht auf dem Kudamm mit zahlreichen Verletzten","Von der Straßenschlacht zur Diskussion","","Berliner Oster-Einsatz bei Polizei und Demonstranten - Alle 381 Festgenommenen wieder frei","",[1],8,[1],[1],1,"18","5"],["5759","1968-04-17","AStA FU/TU/Kirchliche Hochschule propagieren in Studentenkolumne \"Gewalt gegen Sachen\"","Warum Gewalt? Und Entscheidung gegen Gewalt","Studenten über ihre Probleme","","AStA, Vereinigte Arbeitsgemeinschaften an der FU",[11],8,[5],[1],2,"18","6"],["5760","1968-04-17","Diskussion in der TU Berlin, der Theologe Gollwitzer befürwortete Gewalt gegen Sachen und Auflösung des Springer-Konzerns","Änderungen durch vollendete Tatsachen?","","Diskussionen in der TU über Autobahnblockade, Gewalt und eine Reform der Demokratie","U.S., ber",[9],8,[1],[1],1,"18","6"],["5761","1968-04-17","Hunderte von Jugendlichen bei Oster-Demonstrationen festgenommen","Hunderte von Festnahmen bei den Unruhen","","Aktionen gegen Springer-Zeitungen in zahlreichen Städten - Vielfach Kritik am Verhalten der Polizei","",[10,2],8,[1],[1],1,"18","11"],["5762","1968-04-17","2000 SDS-Unterstützer versuchten in London Springer-Niederlassung zu stürmen","Polizei schützt Springer-Büro in London","","","AP",[10],8,[1],[2],1,"18","12"],["5763","1968-04-18","Studentenunruhen fordern Todesopfer. Fotograf von Stein eines Demonstranten getroffen","Münchner Photoreporter Todesopfer der Unruhen","","Ursache: Durch Steinwurfe erlittene Verletzungen. Bundeskanzler Kiesinger sprach sein Beileid aus","",[1],8,[1],[1],1,"16","1"],["5764","1968-04-18","Die Tagesspiegel-Herausgeber wehren sich gegen den Vorwurf der Morgenpost, das Blatt habe nach den Anschlägen keine Solidarität mit den Redakteuren und Mitarbeitern des Springer-Verlages gezeigt ","Aus dem Hause Springer","","Faksimile aus der Berliner Morgenpost vom 17. April 1968, Seite 2","Herausgeber des Tagesspiegels",[10],8,[5],[2],1,"16","3"],["5765","1968-04-19","Regierender Schütz sieht kleine Gruppe von radikalen Studenten, deren kriminelle Aktionen rasch und entschieden bekämpft werden müssten, ohne das Gespräch mit der Masse der reformorientierten Studenten abreißen zu lassen","Schütz sieht doppelte Bewährungsprobe","","Mit kriminellen Aktionen fertig werden und Gesprächsmöglichkeiten wiederfinden - Debatte über die Osterunruhen im Abgeordnetenhaus","",[1],8,[1],[1],2,"18","1,5,6"],["5766","1968-04-19","Kölner Studenten lehnen Gewalt ab, verurteilen aber die \"systematische Hetze\" der Springer-Presse","Aufklärung statt Gewalt","keine ","Bericht über Studentenversammlung in Köln","Winfried Honert",[10,2],8,[1],[1],2,"18","6"],["5767","1968-04-19","CDU-Politiker kritisiert \"Anbiederung\" an \"Revolutionäre\"","Grenzen der Liberalität","","","Hans-Joachim Boehm, MdA",[8],8,[5],[5],2,"18","6"],["5768","1968-04-21","Leserbriefschreiber schreiben für und gegen linke Studentenaktionen; Professor Gollwitzer distanziert sich von \"Gewalt gegen Sachen\"","Studentenunruhen","","","Carl Herrmann, Manfred Scheler, Günter Rogall, Professor C. Schweitzer, Lothar Berthold, F. Wolff, F. Wentzel, Henning Niefert, Bernd Balzer, Rainer Stark, Helmut Gollwitzer, Eugen Bärhausen",[1],8,[6],[1],2,"44","25"],["5769","1968-04-23","Stellungnahme der Unabhängigen Aktionsgemeinschaft an der TU Berlin (UAG), einer zu den linken Gruppen in Opposition stehenden Studentengruppierung. Angriff auf Horst Mahler, der die Reformdebatte zur politischen Mobilisierung der Studenten mißbrauche, und die Ausschreitungen nach dem Attentat auf Dutschke.","Nachruf auf eine Studentenvertretung","","","Gerhard Nicolait, Dirk Rogge",[1,2,11,6],8,[5],[5],2,"18","6"],["5770","1968-04-23","Keine Krawalle bei Demonstration von 2000 Jugendlichen gegen Militörjunta in Griechenland","Griechisches Theater mit dem SDS","keine ","Demonstration auf dem Wittenbergplatz gegen das Athener Militärregime","Mü",[1],8,[1],[1],1,"18","9"],["5771","1968-04-30","AStA der FU kritisiert, dass es nach drei Jahren noch immer der Publizistik-Lehrstuhl nicht neu besetzt wurde","Streik nur für einen Lehrstuhl?","","","",[11],8,[5],[5],2,"16","6"],["5772","1968-11-03","SDS stört Frankfurter Tagung über Hochschulreform","Hochschulreform beginnt in der Schule","","Diskussion auf einer Frankfurter Tagung","H. Ziermann",[4],8,[1],[3],2,"46","15"],["5773","1968-11-05","1000 studentische Störer attackieren Polizisten bei Mahler-Prozeß in Charlottenburg. 130 Polizisten und weitere 21 Personen schwer verletzt","Schwere Aufruhrszenen vor dem West-Berliner Landgericht","","130 Polizeibeamte verletzt - Zum erstenmal Tränengas eingesetzt. Während des Ehrengerichtsverfahrens gegen Rechtsanwalt Mahler","",[6],8,[1],[2],2,"16","1"],["5774","1968-11-05","AStA beklagt sich, dass FU-Rektor Harndt die Einstellung des SDS-Aktivisten Rabehl als wissenschaftlichen Hilfsassistenten verhinderte","Harndt zurücktreten!","","","AStA der FU",[11],8,[5],[1],2,"16","6"],["5775","1968-11-16","Aufforderung an den Senat, die Polizei besser auf linke Störaktionen vorzubereiten","Polizei in der Bewährung","","","Heinrich Lummer, MdA",[9],8,[5],[5],2,"14","6"],["5776","1968-01-03","Evangelische Kirchenleitung von Berlin-Brandenburg verurteilt Kirchenstörungen in der Kaiser-Wilhelm-Gedächtniskirche","Kirchenleitung verurteilt Gottesdienststörung","","","v.C.",[3],4,[1],[2],2,"18","1"],["5777","1968-01-03","Leserbriefschreiber üben Kritik an Unterstützer-Schreiber von 30 Bremer Pastoren für Kirchenstörungen","Pastoren-Telegramm","","","Ingeborg Wolske, Sigrid jencquel, Gerhard Chun, Siegfried Heine, H. Weber",[3],4,[6],[3],2,"18","2"],["5778","1968-01-04","AStA der FU droht mit Verleumdungsklage wegen Sammlung für Witwe des getöteten Studenten Benno Ohnesorg","Berliner Studenten drohen mit Verleumdungsklage","","","dpa",[7],4,[1],[2],2,"16","4"],["5779","1968-01-04","Verteidigung des Habilitationsverfahrens gegen Kritiker","Schon zu Max Webers Zeiten?","Aus Briefen an die Redaktion:","","Horst Jürgen Helle",[11],4,[6],[1],2,"16","6"],["5780","1968-01-04","Ermittlungsverfahren gegen Teufel, Kunzelmann, Langhans und Krüger wegen Gotteslästerung","Neues Ermittlungsverfahren gegen Kommunarden","","","",[5],4,[1],[2],2,"16","10"],["5781","1968-01-05","Verteidigung von Dutschkes Kanzelauftritt und Kritik an Gewalt der Kirchgänger, die Dutschke angriffen","Dutschke auf der Kanzel","","Von Studentenpfarrer Walter Lück, Bremen","Walter Lück",[3,2],4,[5],[5],2,"18","2"],["5782","1968-01-05","Leserbriefschreiberin kritisiert Forderung von Bremer Pastoren, Gemeinde der Wilhelm-Gedächtniskirche müsse sich bei Dutschke entschuldigen","Am falschen Ort","Aus Briefen an die Redaktion:","","Gerda Zimmermann",[3],4,[6],[3],2,"18","2"],["5783","1968-01-06","Nicht linksradikale Studenten, sondern \"etablierte\" Realisten werden die Reformen auf den Weg bringen","Was nutzen die Proteste?","","Die Radikalen rechts und links. Zielprojektionen für die Zukunft. Evolution und Revolution","Werner Titzrath",[9],4,[5],[1],2,"22","2"],["5784","1968-01-06","AStA weist Kritik an Pöbeleien gegen Regierenden Bürgermeister Schütz zurück. Dieser habe die Zwischenrufe und Plakate selbst provoziert","AStA antwortet Senator Stein","","","",[11],4,[1],[2],2,"22","12"],["5785","1968-01-06","Der evangelische Bischof von Berlin Scharf kritisiert Gottesdienststörungen","Bischof kritisiert Methoden","","Scharf zu den Vorfällen in der Kaiser-Wilhelm-Gedächtniskirche","",[3],4,[1],[3],2,"22","12"],["5786","1968-01-08","Kritik an Schulsenator Drexler, der Vorlesung wegen befürchteter Störungen abgesagt hatte, Rieger wehrt sich gegen die Bezeichnung rechtsextrem.","Armes Deutschland","Aus Briefen an die Redaktion:","","Jürgen Rieger",[9],4,[6],[3],2,"16","2"],["5787","1968-01-08","Kritik an Theologen, die Gottesdienststörungen für legitim halten","Debattieren im Gottesdienst?","","","Bernt Conrad",[3],4,[5],[3],2,"16","2"],["5788","1968-01-08","Humanistische Union fordert Anklage gegen Perser, die bei Schah-Besuch Demonstranten angegriffen hatten","Humanistische Union zum Thema \"Jubelperser\"","","","",[7],4,[1],[2],2,"16","9"],["5789","1968-01-09","Leserbriefschreiber sieht im Auftritt von Dutschke in der Gedächtniskirche reine Provokation","Nur ein Schritt","Aus Briefen an die Redaktion:","","Edelhard Rock",[3,2],4,[6],[3],2,"16","2"],["5790","1968-01-09","Strafverfahren gegen Teilnehmer von Störaktionen beim Juristenball und wegen Widerstandes gegen die Staatsgewalt, Körperverletzung und versuchter Gefangenenbefreiung eingeleitet","Strafverfahren gegen Demonstranten","","Nachspiel der Vorfälle anläßlich des Juristenballs","eb",[9],4,[1],[2],2,"16","9"],["5791","1968-01-10","Rektoren der westdeutschen Universitäten legen Reformplan für eine \"dialogische Universität\" mit studentischem Mitspracherecht vor","Rektoren: Die Universität erneuern","Plan für die Hochschulen vorgelegt","Professor RÜegg wirft dem Staat Gleichgültigkeit vor","ems",[4],4,[1],[5],1,"18","1"],["5792","1968-01-10","Hamburger Bürgermeister rechtfertigt die Absage einer Vorlesung durch den Uni-Rektor ","Fehl am Platz","Aus Briefen an die Redaktion:","","Wilhelm Drexelius",[9],4,[6],[3],2,"18","2"],["5793","1968-01-10","Godesberger Erklärung westdeutscher Rektoren zur Notwendigkeit einer umfassenden Hochschulreform. Fünf Leitsätze","Verfassung der Universität soll neu bestimmt werden","Das Konzept der Rektoren","Widerstand von Studenten und Professoren erwartet","ems.",[4],4,[1],[5],2,"18","6"],["5794","1968-01-11","Als Polizisten verkleidete Münchner Studenten stören Vorlesung","Studenten in Polizeiuniform","","Vorlesungen in München gestört","di.",[1],4,[1],[1],2,"20","3"],["5795","1968-01-12","WELT-Umfrage: Linke Studentengruppen gewinnen in Studentenparlamenten weiter an Stimmen","Politische Gruppen profitieren am meisten","Studenten über ihre Probleme","Von der Unruhe an den deutschen Hochschulen - AStA der Kieler Universität abgewählt","",[1],4,[1],[5],2,"16","3"],["5796","1968-01-12","Studenten der Staatlichen Ingenieur-Akademie diskutieren mit Berliner Bereitschaftspolizisten","Gewissensfreiheit bleibt unangetastet","","Studenten diskutierten mit Beamten der Schutzpolizei","Bi.",[9],4,[1],[2],2,"16","9"],["5797","1968-01-13","Kontroverse Diskussionsveranstaltung zu Störungen in der Kaiser-Wilhelm-Gedächtniskirche","Debatten ohne jede Polemik","","Sachliche Diskussion über \"Gottesdienst und politisches Verhalten\"","Bi.",[3],4,[1],[2],1,"24","10"],["5798","1968-01-15","Jurist verteidigt in Leserbrief das gewaltsame Hinausdrängen der Gottesdienststörer","Mit vollem Recht","Aus Briefen an die Redaktion:","","Haase",[3],4,[6],[3],2,"20","2"],["5799","1968-01-15","Linke Studenten wollen diskutieren und stören Gottesdienst des Hamburger Theologieprofessors Helmut Thielicke","Studenten des SDS stören Predigt von Thielicke","","","",[3],4,[8],[2],1,"20","3"],["5800","1968-01-16","Verband Deutscher Studentenschaften bezweifelt Ernsthaftigkeit der Godesberger Rektoren-Erklärung zur Studienreform","Studenten kritisieren Reformvorschläge","","VDS: Hoffentlich der Anfang eines umfangreichen Programms","ems",[4],4,[1],[2],2,"18","1"],["5801","1968-01-16","Studentenverband fordert neue \"Kompetenzverteilung\" an reformierten Universitäten und stellt der Rektorenerklärung eigene Vorschläge entgegen","VDS: Auch die Parlamente müssen an der Hochschule mitwirken","Universitäten","Studenten für starke Universitätsspitze","ems",[4],4,[1],[5],2,"18","4"],["5802","1968-01-16","TU-Studentenvertretung sendet Protestbrief wegen politischem Prozeß an Vorsitzenden des Ministerrats der Sowjetunion","Studenten protestieren gegen Moskauer Urteile","","","",[1],4,[1],[2],2,"18","9"],["5803","1968-01-16","Leserbriefschrieber schlägt vor, Studenten sollten statt Demonstrieren in Gottesdiensten in Vietnam karitativ tätig werden","Karitative Hilfe anstatt Demonstrationen","Aus Briefen an die Lokalredaktion","","Wolfgang Richters",[3],4,[6],[2],1,"18","10"],["5804","1968-01-17","Linke stellen bei Konventswahl den neuen Vorsitzenden","Durch Stimmenthaltung entschieden","","Wahlen an der freien Universität","wt",[11],4,[1],[2],2,"18","9"],["5805","1968-01-19","Bundesforschungsminister Gerhard Stoltenberg antwortet auf Kritik des Präsidenten der Rektorenkonferenz, der Staat zeige Gleichgültigkeit gegenüber der Studenten-Rebellion. Stoltenberg verurteilt Aktionen linksradikaler Studenten als \"antidemokratisch\" und fordert mehr staatliche Mitwirkung bei Hochschulreform","Stoltenberg: Aktionen radikaler Studenten sind anti-demokratisch","Zur Lage an den Hochschulen","Der Staat soll bei Reformen mitwirken","ems",[9],4,[1],[1],2,"20","1,2"],["5806","1968-01-19","Studenten planen Streik-Aktionen, um \"Veränderung der Universität\" zu erzwingen","Studenten planen Streik-Aktionen","Universitäten","Frankfurter Rektor verläßt Diskussion - \"Chance vertan\"","",[9],4,[1],[5],2,"20","3"],["5807","1968-01-19","Ring Christlich-Demokratischer Studenten kritisiert \"sit-ins\" bei Sitzungen des akademischen Senats als \"Terror\", will aber das Disziplinarrecht der Uni abschaffen ","RCDS gegen Disziplinarrecht","Berlin","Untersuchungsausschuß hörte weitere Studenten","Bi.",[9],4,[1],[2],2,"20","4"],["5808","1968-01-20","Die junge Generation brauche eine \"straffe Führung\", meint eine Leserbriefschreiberin","Unsicher","Aus Briefen an die Redaktion:","","Sigrid v. Otto",[9],4,[6],[2],2,"22","2"],["5809","1968-01-20","Kommentator verteidigt Stoltenberg-Erklärung","Stoltenberg","Zum Tage","","Walter Görlitz",[4],4,[5],[2],2,"22","2"],["5810","1968-01-22","Bei den Wahlen zum Kieler Studentenparlament setzt sich SDS durch","Linksrutsch an der Kieler Universität","","","",[11],4,[1],[2],2,"14","3"],["5811","1968-01-22","Neue Sitzverteilung im Marburger Uni-Senat","Marburger Studenten am Senat beteiligt","","","pff",[11],4,[1],[2],2,"14","3"],["5812","1968-01-23","Kommentator geißelt \"totalitäre Ideologie\" der Gottesdienststörer und kritisiert politisierte Pastoren","Ein Gotteshaus ist kein Parteilokal","","\"Rollkomandos\" wollen nicht diskutieren, sondern torpedieren","Bernd Nellesen",[3],4,[1],[3],2,"20","2"],["5813","1968-01-23","Rektor der Uni Würzburg verurteilt Vorlesungsstörung durch 30 Studenten","Rektor verurteilt Protest der Studenten","","","AP",[1],4,[1],[2],1,"20","6"],["5814","1968-01-24","Leserbriefschrieber fordert, Bundesregierung und Bundestag sollten \"Antidemokraten\" von  Beamtenschaft, Universitäten und Stipendien ausschließen","Antidemokraten","Aus Briefen an die Redaktion:","","Otto Karlsbach",[1],4,[6],[2],2,"20","2"],["5815","1968-01-24","Studenten zwingen Bremens Bürgermeister Koschnik zu Zugeständnissen bei Senkung der Straßenbahngebühren","Demonstranten setzen sich durch","Bremen","Koschnik verspricht Senkung der Straßenbahngebühren","M.",[1],4,[1],[2],2,"20","4"],["5816","1968-01-25","Leserbriefschreiber meint: Gegen Störer darf sich die Kirche zur Wehr setzen","Kein Debattierclub","Aus den Briefen an die Redaktion","","Egon Brogi",[3],4,[6],[2],2,"18","2"],["5817","1968-01-26","Schließung des Romanischen Seminars wegen Störungen: Studenten wollen gegen \"Diskussionsverweigerung\" der Dozenten vorgehen","Die Spannungen an der Freien Universität steuern einem neuen Höhepunkt zu","Berlin","Ursache: Schließung des Romanischen Seminars","v.C./bi",[11],4,[1],[5],2,"16","3"],["5818","1968-01-27","Gustav Heinemann schlägt in seinem Leserbrief vor, bei Gottesdienststörungen so lange Kirchenlieder zu singen, bis die Demonstranten aufgeben","Singen ist besser","Aus Briefen an die Redaktion:","","Gustav Heinemann",[3],4,[6],[2],2,"30","2"],["5819","1968-01-27","Münchner Professoren warnen Studenten vor Mißbrauch ihrer Freiheiten","Studenten antworten mit Tumulten","Universitäten","Münchner Professoren warnen vor Mißbrauch der Freiheit","wfm.",[1],4,[1],[2],2,"30","4"],["5820","1967-01-27","Gegen die Schließung des Lehrbetriebes am Romanischen Seminar der FU heftige Studenten-Proteste ","Situation an der FU spitzt sich zu. \"Ordinarien mißbrauchen Hausrecht\"","Berlin","RCDS-Vorsitzender Runge trat aus \"internen Gründen\" zurück","Bi.",[11],4,[1],[5],2,"30","4"],["5821","1968-01-27","Kommentator bezichtigt Studentenzeitschrift verzerrter Darstellung der Presse-Berichterstattung über die Gottesdienststörungen ","Kritisch betrachtet","","","vc",[3],4,[5],[2],2,"30","17"],["5822","1968-01-29","Kommentator veteidigt Schließung des Romanischen Seminars der FU","Geschlossen","Zum Tage","","Wa. ",[11],4,[5],[2],2,"20","2"],["5823","1968-01-30","Leserbriefschreiber fordert juristische Maßnahmen gegen Gottesdienststörer","Zur Wehr setzen","Aus Briefen an die Redaktion:","","Karl H. Wolbrandt",[1],4,[6],[2],2,"14","2"],["5824","1968-01-30","FDP-Parteitag fordert US-Bombardement in Vietnam und Einstellung aller Kampfhandlungen des Vietkong in Südvietnam. Dutschke spricht vor der Parteitagshalle zu 2000 Studenten","Parteitag fordert Vietnam-Debatte in Bonn","Freie Demokraten","Reaktion auf Vorstoß der Rebellen - Draußen vor der Tür: Rudi Dutschke","St.",[2,9],4,[1],[5],1,"14","4"],["5825","1968-01-31","Beschluß zur Reform des Marburger Uni-Senats kam auf Druck der Studenten zustande","Massiver Druck","Aus Briefen an die Redaktion:","","Prof. Dr. Ernst Dammann",[4],4,[6],[2],2,"20","2"],["5826","1968-01-31","Vollversammlung der Philosophischen Fakultät fordert Diskussion bei Lehrveranstaltungen, Romanisches Seminar muss wieder geöffnet werden, Zwischenprüfung soll suspendiert werden","In Berlin droht eine Kraftprobe","Hochschulen","Wird der Lehrbetrieb an der Freien Universität eingestellt?","Bi.",[11],4,[1],[5],2,"20","3"],["5827","1968-01-31","Experten sagen Massenuniversität voraus, für die neue Organisationsstrukturen und Prrüfungsordnungen benötigt werden. Bildungsminister Stoltenberg fordert Verkürzung der Studiengänge und Forschungsschwerpunkte an den Unis. Dazu eine Karikatur zur Massenuniversität.","Die Universität nach dem Jahre 1970","Hochschulkrise: Die härtesten Jahre kommen erst / Ein Minister, ein Professor und ein Studentenvertreter nehmen Stellung","","Hans Leissink, Hans-Joachim Haubold, Gerhard Stoltenberg",[4],4,[1,5,4],[4],1,"20","7"],["5828","1968-02-13","Allgemeiner Studentenausschuß der Pädagogischen Hochschule fordert Mitspracherecht bei Studienreform","Studenten wollen mitreden","","","",[4],2,[1],[2],2,"10","4"],["5829","1967-07-13","Vom Wissenschaftssenator bekannt gegebene Statistik, wie viele Delikte von Studenten in den letzten Jahren zu FU-Disziplinarverfahren geführt haben.","109 Studenten standen vor dem Richter","","","lh.",[9],2,[1],[2],2,"8","2"],["5830","1967-08-29","Hinweis auf Sitzungen des Untersuchungsausschusses zur Klärung der Zwischenfälle beim Schah-Besuch.","Ausschuss tagt","Blickpunkt Berlin","","",[7],2,[1],[2],2,"8","2"],["5831","1967-11-18","Gelegentlich ihres Jahreskongresses grenzt sich die Junge Union vom SDS ab.","Absage an linksradikale Studenten","","","L.H.",[11],2,[1],[2],2,"10","3"],["5832","1968-01-03","Verfahren gegen Dutschke wegen Störung eines Gottesdienstes in der Gedächtniskirche und gegen einen Gottesdienstteilnehmer wegen Körperverletzung.","Verfahren gegen Dutschke","","","rb.",[2,3],2,[1],[2],2,"8","3"],["5833","1968-01-26","100 Verfahren wegen Krawallen seit dem Schah-Besuch. 92 Verfahren gegen Polizisten, von denen 82 bereits eingestellt sind.","Über 100 Verfahren gegen Randalierer","","","kh.",[1],2,[1],[2],2,"12","3"],["5834","1968-02-03","AStA der Pädagogischen Hochschule hat den Vorsitzenden der SEW, Danelius, zu einem Vortrag eingeladen.","AStA lud ein","Blickpunkt Berlin","","",[11],2,[1],[2],2,"14","2"],["5835","1968-02-14","Durchführung einer Vietnam-Demonstration auch bei Verbot geplant. Zitat Dutschke: \"Wir lassen es auf eine Krafprobe ankommen. Keiner von uns hat Angst vor dem Gefängnis!\"","Trotz Verbot: Radikale wollen die Kraftprobe","","Wieder Krawalle am Wochenende!","jo.",[1],2,[1],[1],2,"8","2"],["5836","1968-02-15","Mitglieder des Abgeordnetenhauses bereiten Entwurf für Hochschulgesetz vor.","Einigkeit in Uni-Reform","","","jo.",[4],2,[1],[2],2,"8","3"],["5837","1968-02-15","West-Berliner Synode beschließt, Gespräch mit der jungen Generation aufzunehmen.","Kirche will mit Studenten sprechen","","","",[3],2,[1],[2],2,"8","3"],["5838","1968-02-17","Klage der Humanistischen Union gegen das Berliner Versammlungsgesetz ohne Erfolg.","Klage wurde zurückgewiesen","","","rb.",[1],2,[1],[2],2,"12","2"],["5839","1968-02-19","Reaktionen von Schütz und Neubauer auf die Vietnam-Demo vom Wochenende","\"Sie wollen unsere Städte in Unordnung bringen\"","","","rb.",[1],2,[1],[3],2,"12","2"],["5840","1968-02-19","Kurzer Bericht über den Vietnam-Kongress mit Nennung einiger Redner und Teilnehmerzahl 4000.","Universität glich einem Heerlager","","","rb.",[1],2,[1],[2],1,"12","2"],["5841","1968-02-20","Über Ausschlussforderungen von SPD-Mitgliedern gegen die Vietnam-Demo-Teilnehmer Ristock und Beck.","Fünf Stunden wurde debattiert - doch der Rausschmiss blieb aus","","","jo.",[1],2,[1],[5],1,"10","2"],["5842","1968-02-20","Funktionäre der ESG, des SHB und des LSD, die an der Vietnam-Demo teilgenommen haben, äußern sich zu ihrer Haltung zum SDS.","Gegen den Vietnam-Krieg, aber sonst anderer Meinung?","","","hb.",[1],2,[3],[2],2,"10","2"],["5843","1968-02-21","Bundesaußenminister ruft die Berliner zur Teilnahme an der Senatsdemo auf.","Brandt: Kommt zum Rathaus!","","","Martin Klaus Keune",[1],2,[1],[5],1,"10","1"],["5844","1968-02-21","Leitung der Berliner Evangelischen Kirche distanziert sich von Gewaltaufrufen der Vietnam-Demonstrierer.","Stellungnahme der Kirchenleitung","","","rb.",[1],2,[1],[2],2,"10","2"],["5845","1968-02-21","Verfahren gegen Teufel und einen zweiten Mann wegen des Zündens von Knallkörpern im Gerichtssaal.","Teufel gab keine Antwort","","","rb.",[5],2,[1],[2],2,"10","2"],["5846","1968-02-21","CDU will in Parlamentsanfrage wissen, ob die Stadträte Ristock und Beck amtsenthoben werden. In der SPD wird über Ordnungsmaßnahmen diskutiert.","Urabstimmung über SPD-Marschierer","","","jo.",[1],2,[1],[2],1,"10","2"],["5847","1968-02-21","Parteiordnungsverfahren gegen FU-AStA-Chef Landsberg wegen Beschimpfung von Schütz und Neubauer.","Verfahren gegen AStA-Vorsitzenden","","","rb.",[11],2,[1],[2],2,"10","2"],["5848","1968-02-21","Mehrere Studentenverbände kritisieren Senatsdemo: Sie solle \"die von der Springer-Presse und dem Schütz-Neubauer-Senat erzeugte Pogromstimmung gegen die außerparlamentarische Opposition ? verschärfen.\"","Aufrufe der Studentenverbände","","","rb.",[1],2,[1],[2],2,"10","2"],["5849","1968-02-21","US-Stadtkommandant lobt Polizei und Senat für Haltung zur Vietnam-Demo.","Dank für Haltung der Polizei","","","rb.",[1],2,[1],[2],1,"10","2"],["5850","1968-03-23","Freispruch im Verfahren gegen Teufel und Langhans wegen des Aufrufs zur Brandstiftung.","Freispruch für Teufel und Langhans","","","rb.",[5],2,[1],[2],1,"10","3"],["5851","1968-05-11","In FU, TU und der Kirchlichen Hochschule Berlins soll während der Bundestagslesung der Notstandsgesetze gestreikt werden.","Studenten-Streik","blickpunkt Berlin","","",[1],2,[1],[2],2,"10","2"],["5852","1968-05-29","Studenten mussten vor Passanten in Schutz (-haft) genommen werden, weil sie wegen eines Plakats, das Jesus als Revolutionär bezeichnet hat, attackiert worden sind.","Studenten in Schutzhaft","","","rb.",[1],2,[1],[2],2,"12","5"],["5853","1968-11-06","Von Innensenator Neubauer vorgetragene Ergebnisse der Senatssitzung nach der sog. Schlacht am Tegeler Weg zum möglichen Vorgehen der Polizei im Wiederholungsfalle. Erwähnung des möglichen Schusswaffengebrauchs.","Polizisten nicht länger Zielscheibe für Wildgewordene!","Scharf Warnung des Senats:","\"Gesetzliche Mittel reichen bis zum Gebrauch der Schusswaffe\"","rb.",[6],2,[1],[1],1,"10","1"],["5854","1967-01-28","2000 FU-Studenten protestieren gegen Beschlagnahmung der SDS-Mitgliederkartei","Proteste gegen Polizeimaßnahme","","","Eigener Bericht",[1],1,[1],[3],2,"50","1"],["5855","1967-07-07","Prozess gegen Teufel und Langhans beginnt vor der 6. Großen Strafkammer","Teufel seit gestern vor Gericht","","","k.a.",[5],1,[1],[2],2,"12","1"],["5856","1967-07-27","AStA-Gebäude der FU Berlin mit Farbbeuteln beworfen","Protest oder Unfug?","","","k.a.",[1],1,[1],[2],2,"14","3"],["5857","1967-09-11","Landgericht Berlin hebt Haftverschonungsbeschluss Teufels auf, der zurück ins Untersuchungsgefängnis muss","Teufel soll wieder ins Gefängnis","","","k.a.",[5],1,[1],[3],2,"12","3"],["5858","1967-09-16","Teufel wird nach Entlassung aus der Untersuchungshaft erneut festgenommen; Proteste vor dem Rathaus Schöneberg und dem Polizeirevier","Erzürnte Passanten vor dem Rathaus Schöneberg","","Bartloser Teufel wieder festgenommen","k.a.",[5],1,[7],[5],2,"14","10"],["5859","1967-01-17","AStA der FU Berlin hält am Projekt \"Kritischen Universität\" fest","AStA hält an seinem Plan fest","","","k.a.",[11],1,[1],[3],2,"50","3"],["5860","1967-01-24","Senat berät über Demonstrationsverbot in der City, um Fahrzeugverkehr künftig nicht mehr zu behindern. Vorausgegangen waren Tumulte nach der Vietnam-Demonstration","Sperrbezirk für Demonstrationen?","","Verkehr in der City soll nicht mehr behindert werden","D. Goos",[1],1,[1],[1],1,"12","3"],["5861","1967-10-27","Berliner Senat sucht Gespräch mit Studenten und politischen Gruppierungen; Rede-Auszüge von Bürgermeister Schütz","Gespräch mit den Studenten","","Peinliche Besserwisserei","k.a.",[9],1,[1],[5],2,"14","13"],["5862","1967-11-19","Kritik an fehlenden präventiven Maßnahmen bei der Demonstration vor dem Schöneberger Rathaus","Krawalle","","","G.G.",[1],1,[6],[3],2,"12","2"],["5863","1967-11-28","Tumulte bei der Rektoratsübergabe an der Münchner Universität vermutlich von Einzeltätern und nicht vom SDS verübt","Krawalle das Werk von Einzelgängern","","","AP",[1],1,[1],[2],2,"14","2"],["5864","1967-12-02","Haftbefehl gegen Fritz Teufel wird aufgehoben","Teufel wieder auf freiem Fuß","","","k.a.",[5],1,[1],[2],2,"32","3"],["5865","1967-12-03","Bürgermeister und Innensenator Kurt Neubauer spricht sich gegen ein generelles Demonstrationsverbot in der Berliner City aus. Er stellt klar: Demonstrationen gegen Kurras-Freispruch und Teufel-Prozess waren genehmigt","Zusammenstöße gesucht","","Neubauer: Teufel-Demonstranten wollten Klamauk","Eigener Bericht/DPA",[1],1,[1],[5],1,"56","1"],["5866","1967-12-21","\"Teach-in\" an Münchner Universität endet mit Tumulten, nachdem ein Student jemanden als Polizeispitzel bezeichnete","Erneut Tumulte an der Uni München","","","AP/DPA",[1],1,[1],[2],2,"12","2"],["5867","1967-12-21","Verhältnis Schütz-Studenten; Aufforderung an den Senat, \"die Drahtzieher der Radikalisierung\" ausfindig zu machen und zu bestrafen; Aufforderung zur Unterstützung Schütz'","So geht es nicht weiter","","","St.",[9],1,[5],[5],2,"12","2"],["5868","1968-01-31","Über 1000 Studenten an der Philosophischen Fakultät der FU Berlin sprechen ihren Professoren in einer Vollversammlung das Misstrauen aus","Sie wollten diskutieren","","","k.a.",[9,11],1,[1],[2],2,"12","3"],["5869","1968-09-11","Wissenschaftssenator Werner Stein stellt Reform-Pläne für FU und TU vor; Vorschläge sollen zunächst auf ein Semester befristet sein","So will Stein toten Punkt überwinden","","Studenten kennen Reform-Pläne noch nicht","M.M.",[4],1,[1],[1],2,"14","3"],["5870","1967-04-27","Studentenparlament diskutiert über Urabstimmung an der FU Berlin","FU-Urabstimmung?","","","k.a.",[11],6,[1],[2],2,"32","32"],["5871","1968-11-07","Berliner Spitzenpolitiker erhalten anonyme Schreiben mit Morddrohungen; sie tragen den Briefkopf des OSI der FU Berlin und sind mit \"Der revolutionäre Rat\" unterzeichnet. Das OSI distanzierte sich von den Schreiben","Anonyme Schreiben mit Morddrohungen","","","k.a.",[1],6,[1],[5],2,"34","4"],["5872","1968-11-07","APO will Musterprozess über rechtlichen Status West-Berlins erzwingen; Horst Mahler reicht Klage gegen das Land Berlin ein","APO-Klage ganz auf Pankows Kurs","","","k.a.",[11],6,[1],[2],2,"34","4"],["5873","1968-11-07","Studentenvereinigungen distanzieren sich von Ausschreitungen am Berliner Landgericht","Studenten gegen Gewalt","","","k.a.",[1],6,[1],[2],2,"34","4"],["5874","1968-11-07","APO und Studentenvertretungen sagen angekündigte Aktionen zur CDU-Veranstaltung in der Neuen Welt ab","Wenn wir nicht siegen können?","","Störaktionen zur CDU-Kundgebung wurden in letzter Minute abgesagt","L.R.",[1],6,[1],[1],2,"34","4"],["5875","1968-12-17","Studentische Vollversammlung der Pädagogischen Hochschule beschließt Streik; gemäßigte Studenten sind dagegen und wollen ihn nicht befolgen","Viele gegen Streik","","","R.M.",[1],6,[1],[3],2,"34","3"],["5876","1967-12-21","Vortragsreihe mit Professoren aus Ost-Berlin beginnt im Studentendorf der FU Berlin","Diskussion bewies die Diskrepanz","","Dozenten der Humboldt-Universität vor FU-Studenten","el",[9],4,[1],[5],2,"20","12"],["5877","1967-12-21","Rektor der FU Berlin nimmt zu Vorwürfen des AStA Stellung, wonach der Rechtsausschuss der Universität an der befristeten Immatrikulation für Ausländer festhalte","Rektor widerspricht AStA-Behauptungen","","Stellungnahme in den Informationsblättern","wt",[11],4,[1],[5],2,"20","12"],["5878","1966-12-12","Betrachtung der anstehenden Hochschulreform; Vergleich mit dem englischen Hochschulsystem","Akademische Freiheit - das Goldene Kalb","","Ein Engländer zur deutschen Universitätsreform","David Heald",[4],4,[6],[5],2,"20","I"],["5879","1966-12-14","Göttinger Studenten bitten unter dem Motto \"Notopfer UB\" um Gelsdpenden für die Staats- und Universitätsbibliothek","Studenten sammeln für Universitäts-Bibliothek","","","k.a.",[9],4,[1],[2],2,"22","10"],["5880","1966-12-14","Hessische Universitäten und Hochschulen wollen Zusammenarbeit mit dem HR-Funk-Kolleg ausweiten; vorgeschlagen wird eine Ausweitung auf Geisteswissenschaften","Hessische Universitäten unterstützen Funk-Kolleg","","","pff",[9],4,[1],[2],2,"22","10"],["5881","1967-01-13","Die acht pädagogischen Hochschulen Niedersachsens sollen neu strukturiert und zu größeren Einheiten zusammengefasst werden; Kultusminister Langeheine äußert sich positiv zu dem Vorhaben","Pädagogische Hochschulen wollen sich zusammenschließen","","","R.S.",[4],4,[1],[2],2,"18","10"],["5882","1967-01-27","Bundespräsident Lübke würdigt Arbeit des Wissenschaftsrates; dieser hätte den Ausbau der Hochschulen und Forschungseinrichtungen den Weg geebnet","Lübke würdigt Arbeit des Wissenschaftsrates","","","DPA",[4],4,[1],[2],2,"30","1"],["5883","1967-01-31","Studenten an der Madrider Universität geraten mit der Polizei aneinander; sie demonstrieren für die Freilassung festgenommener Kommilitonen","Unruhen in Madrid reißen nicht ab","","Wieder Zusammenstöße zwischen Studenten und Polizei","AP/DPA",[1],4,[1],[3],2,"18","4"],["5884","1967-01-31","Zwei Dozenten der Rostocker Universität drohen Beschränkung der studentischen Freiheit an, wenn Studenten selbstständig ihre Vorlesungsliste zusammenstellen","Studentische Freiheiten eingeengt","","","v.C.",[9],4,[1],[2],2,"18","4"],["5885","1968-01-02","Studenten, vornehmlich SDS-Mitglieder, stören in der Silvesternacht Gottesdienst in der Kaiser-Wilhelm-Gedächtniskirche; Polizei muss eingreifen","Wieder Störung in der Gedächtniskirche","","Demonstranten erzwangen Unterbrechung des Gottesdienstes","Co./Bi.",[1],4,[1],[5],2,"24","1"],["5886","1968-01-20","Kultusminister planen Hochschulreform; Sonderkonferenz im April geplant","Sonderkonferenz für Studienreform","Universitäten","Kultusminister wollen modernes Hochschulrecht","V.D.",[4],4,[1],[5],2,"22","3"],["5887","1968-01-23","SDS kann für den geplanten Vietnam-Kongress Mitte Februar noch keinen geeigneten Raum finden; bei der Veranstaltung werden 10000 Teilnehmer erwartet","Kein Raum für SDS-Kongreß","","","k.a.",[8],4,[1],[2],2,"20","9"],["5888","1968-01-25","Diskussion über die Vorfälle während der Predigt von Prof. Thielicke im Hamburger Michel; Diskussionskultur innerhalb der Kirche","Was ist wirklich geschehen im Hamburger \"Michel\"?","","","Hans-Jürgen Quest",[3],4,[5],[3],1,"18","2"],["5889","1968-01-26","DDR-Grenzkontrolleuren fotografieren AStA-Akten und verhörten den AStA-Vorsitzenden Landsberg von der FU Berlin.","AStA-Akten fotografiert","","","UPI",[11],4,[1],[2],2,"24","3"],["5890","1968-01-26","Diskussion zwischen Jungliberalen und Dutschke auf dem FDP-Parteitag findet nicht statt; Parteiführung lehnte Vorschlag ab","Keine Diskussion mit Dutschke","","","DPA",[2],4,[1],[2],2,"24","3"],["5891","1968-01-29","Kritik an der unsicheren und beschönigenden Haltung der älteren Generation gegenüber den momentanen Entwicklungen; fordert die Unterstützung der größeren Gruppe \"gemäßigter\", ebenso kritischer Studenten, die jedoch \"nicht nur auf Negation eingestellt\" sei.","Die Sorge wächst","Aus Briefen an die Redaktion","","Jürgen Westermann",[1],4,[6],[2],2,"20","2"],["5892","1968-04-26","Regierungsentwurf für die Notstandsverfassung grundlegend umgestaltet; lediglich drei von zwanzig Artikel sind unverändert geblieben. Klärung der Komplexe \"Äußerer Notstand\", \"Notparlament\", \"Dienstverpflichtungen\"","Entwurf für Notstandsgesetze wird grundlegend geändert","","Bundestag in Zeitnot - \"Verabschiedung verzögert sich\"","ems",[9],4,[1],[1],2,"28","1"],["5893","1968-04-29","Hans Filbinger und Walter Krause äußern sich übereinstimmend zum Wahlergebnis in Baden-Württemberg; bezeichneten NPD-Zuwachs als \"direkte Auswirkung der Unruhen während der Osterfeiertage\"","\"Die Oster-Unruhen haben dieses Wahlergebnis nachhaltig beeinflußt\"","Baden-Württemberg","Übereinstimmende Ansicht von CDU und SPD: Profitiert hat die NPD","uhl",[1],4,[1],[1],2,"24","3"],["5894","1968-04-29","Dutschke unternimmt erste Gehübungen im Berliner Westend-Krankenhaus","Dutschke macht Gehübungen","","","AP",[2],4,[1],[2],2,"24","3"],["5895","1968-07-04","Fakultätssitzung der Wirtschafts- und Sozialwissenschaftlichen Fakultät der FU Berlin muss wegen Störungen zwei Mal unterbrochen werden; Studenten demonstrierten gegen nichtöffentliche Berufungsverfahren von Lehrstühlen","Störer unterbrachen Fakultätssitzungen","","Nach Zwischenfall an der FU zum Rathaus Schöneberg","k.a.",[1],4,[1],[5],2,"20","11"],["5896","1968-11-06","SDS-Mitglieder stören Rektoratsfeier in Erlangen; Polizei schlichtet","Studenten störten Erlanger Rektoratsfeier","","","pff",[1],4,[1],[2],2,"26","3"],["5897","1968-11-06","VDS ruft Mitgliedsverbände auf, \"Justizterror\" zu verhindern; die gängige Gerichtspraxis dürfe sich nicht vom verfassungsmäßigen Grundsatz der Unabhängigkeit entfernen","VDS kritisiert \"Justizterror\"","","","DPA",[11],4,[1],[2],2,"26","3"],["5898","1966-12-22","Bemühungen des AStA der Hamburger Universität um studentische Mitsprache in den Fakultäten verläuft seit sieben Jahren ergebnislos","Noch immer weder Sitz noch Stimme","","Studenten warten seit Jahren auf Mitspracherecht in den Fakultäten","if",[4],4,[7],[5],2,"18","8"],["5899","1966-12-14","Kommentar zu Studententreffen nach Vietnamdemo. Ironisch gemeinte \"Übersetzungen\" von Passagen des Einladungsflugblatts. Beispiel: \"Für alle diejenigen ? 'die mit der Brutalität der Polizei zu Beginn und am Ende der Demonstration sich nicht einfach abfinden wollen' (auf deutsch: Polizeihiebe auf Krawallköpfe, um den möglicherweise doch vorhandenen Grips locker zu machen, sind brutal. Steine gegen Polizisten, das ist intelligent).\"","Probe fürs nächste Mal?","","Nach Krawallen: Studenten treffen sich","Lutz Horst",[1],2,[5],[3],2,"8","3"],["5900","1968-02-23","Kritik an der Teilnahme von Ristock und Beck an der Vietnamdemo. \"Sie kochen ihr Süppchen auf dem Feuer der Radikalen und merken nicht, dass Dutschkes Zottelhaare Otto Normalverbraucher im Halse steckenbleiben.\"","Sie spielen immer wieder Bürgerschreck","","Der schlimmste Feind der SPD ist ihr ultralinker Flügel","",[1],2,[5],[2],3,"14","14"],["5901","1967-04-30","Kommentator nennt protestierenden Studenten \"neurotische Narren\" und erklärt ihr Verhalten als krankheitsbedingt. \"Dass die paar hundert geistig und moralisch gestörten Studenten, die einigen deutschen Universitäten die üble Reputation eines intellektuellen Bordells anhängen, nur eine winzige Minderheit der deutschen Studentenschaft sind, ist gewiss wahr und ein schwacher Trost.\"","Aufstand der Neurotiker","","","William S. Schlamm",[1],5,[5],[3],4,"40","5"],["5902","1967-10-27","Dem Artikel \"Schütz verurteilt mit aller Schärfe den Berlin-Pessimismus\" beigestellte Karikatur: Straßenfeger fegt Demonstranten fort, die Schilder mit folgenden Aufschriften tragen: \"Schwarzseher\", \"Angstmacher\", \"Politische Dummköpfe\" und \"Miesmacher\".","Berliner Stadtreinigung","","","Oskar",[],1,[4,5],[2],5,"24","1"],["5903","1968-01-20","Kritik an Bremens Bürgermeister für sein Nachgeben im Streit um die dortigen Fahrpreiserhöhungen. Vorsichtige Kritik an der Polizei du deren Knüppeleinsatz bei den Fahrpreisdemos. Aber: \"Auch Jugendliche müssen sich an die verbindlichen Spielregeln der Demokratie halten...\" Wo das nicht geschehe, helfe nur Härte.","Bremen","","","hoe",[9],7,[5],[2],2,"68","2"],["5904","1967-06-11","Drei Leserbriefe, die für die Polizei und gegen die Demonstranten Partei ergreifen.","\"Nicht gleich urteilen\"","Briefe - Hier kann jeder seine Meinung sagen","","",[7],3,[6],[1],1,"48","21"],["5905","1967-06-18","Zwei Leserbriefe zu den Unruhen beim Schah-Besuch und zum Tod Benno Ohnesorgs. Beide verteidigen das Vorgehen der Polizei.","\"Mitgegangen - Mitgehangen\"","Briefe - Hier kann jeder seine Meinung sagen","","",[7],3,[6],[1],1,"48","21"]]

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(211);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root) {
    'use strict';

    /**
     * charMap
     * @type {Object}
     */
    var charMap = {

        // latin
        'À': 'A',
        'Á': 'A',
        'Â': 'A',
        'Ã': 'A',
        'Ä': 'Ae',
        'Å': 'A',
        'Æ': 'AE',
        'Ç': 'C',
        'È': 'E',
        'É': 'E',
        'Ê': 'E',
        'Ë': 'E',
        'Ì': 'I',
        'Í': 'I',
        'Î': 'I',
        'Ï': 'I',
        'Ð': 'D',
        'Ñ': 'N',
        'Ò': 'O',
        'Ó': 'O',
        'Ô': 'O',
        'Õ': 'O',
        'Ö': 'Oe',
        'Ő': 'O',
        'Ø': 'O',
        'Ù': 'U',
        'Ú': 'U',
        'Û': 'U',
        'Ü': 'Ue',
        'Ű': 'U',
        'Ý': 'Y',
        'Þ': 'TH',
        'ß': 'ss',
        'à': 'a',
        'á': 'a',
        'â': 'a',
        'ã': 'a',
        'ä': 'ae',
        'å': 'a',
        'æ': 'ae',
        'ç': 'c',
        'è': 'e',
        'é': 'e',
        'ê': 'e',
        'ë': 'e',
        'ì': 'i',
        'í': 'i',
        'î': 'i',
        'ï': 'i',
        'ð': 'd',
        'ñ': 'n',
        'ò': 'o',
        'ó': 'o',
        'ô': 'o',
        'õ': 'o',
        'ö': 'oe',
        'ő': 'o',
        'ø': 'o',
        'ù': 'u',
        'ú': 'u',
        'û': 'u',
        'ü': 'ue',
        'ű': 'u',
        'ý': 'y',
        'þ': 'th',
        'ÿ': 'y',
        'ẞ': 'SS',

        // language specific

        // Arabic
        'ا': 'a',
        'أ': 'a',
        'إ': 'i',
        'آ': 'aa',
        'ؤ': 'u',
        'ئ': 'e',
        'ء': 'a',
        'ب': 'b',
        'ت': 't',
        'ث': 'th',
        'ج': 'j',
        'ح': 'h',
        'خ': 'kh',
        'د': 'd',
        'ذ': 'th',
        'ر': 'r',
        'ز': 'z',
        'س': 's',
        'ش': 'sh',
        'ص': 's',
        'ض': 'dh',
        'ط': 't',
        'ظ': 'z',
        'ع': 'a',
        'غ': 'gh',
        'ف': 'f',
        'ق': 'q',
        'ك': 'k',
        'ل': 'l',
        'م': 'm',
        'ن': 'n',
        'ه': 'h',
        'و': 'w',
        'ي': 'y',
        'ى': 'a',
        'ة': 'h',
        'ﻻ': 'la',
        'ﻷ': 'laa',
        'ﻹ': 'lai',
        'ﻵ': 'laa',

        // Persian additional characters than Arabic
        'گ': 'g',
        'چ': 'ch',
        'پ': 'p',
        'ژ': 'zh',
        'ک': 'k',
        'ی': 'y',

        // Arabic diactrics
        'َ': 'a',
        'ً': 'an',
        'ِ': 'e',
        'ٍ': 'en',
        'ُ': 'u',
        'ٌ': 'on',
        'ْ': '',

        // Arabic numbers
        '٠': '0',
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',

        // Persian numbers
        '۰': '0',
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',

        // Burmese consonants
        'က': 'k',
        'ခ': 'kh',
        'ဂ': 'g',
        'ဃ': 'ga',
        'င': 'ng',
        'စ': 's',
        'ဆ': 'sa',
        'ဇ': 'z',
        'စျ': 'za',
        'ည': 'ny',
        'ဋ': 't',
        'ဌ': 'ta',
        'ဍ': 'd',
        'ဎ': 'da',
        'ဏ': 'na',
        'တ': 't',
        'ထ': 'ta',
        'ဒ': 'd',
        'ဓ': 'da',
        'န': 'n',
        'ပ': 'p',
        'ဖ': 'pa',
        'ဗ': 'b',
        'ဘ': 'ba',
        'မ': 'm',
        'ယ': 'y',
        'ရ': 'ya',
        'လ': 'l',
        'ဝ': 'w',
        'သ': 'th',
        'ဟ': 'h',
        'ဠ': 'la',
        'အ': 'a',
        // consonant character combos
        'ြ': 'y',
        'ျ': 'ya',
        'ွ': 'w',
        'ြွ': 'yw',
        'ျွ': 'ywa',
        'ှ': 'h',
        // independent vowels
        'ဧ': 'e',
        '၏': '-e',
        'ဣ': 'i',
        'ဤ': '-i',
        'ဉ': 'u',
        'ဦ': '-u',
        'ဩ': 'aw',
        'သြော': 'aw',
        'ဪ': 'aw',
        // numbers
        '၀': '0',
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        // virama and tone marks which are silent in transliteration
        '္': '',
        '့': '',
        'း': '',

        // Czech
        'č': 'c',
        'ď': 'd',
        'ě': 'e',
        'ň': 'n',
        'ř': 'r',
        'š': 's',
        'ť': 't',
        'ů': 'u',
        'ž': 'z',
        'Č': 'C',
        'Ď': 'D',
        'Ě': 'E',
        'Ň': 'N',
        'Ř': 'R',
        'Š': 'S',
        'Ť': 'T',
        'Ů': 'U',
        'Ž': 'Z',

        // Dhivehi
        'ހ': 'h',
        'ށ': 'sh',
        'ނ': 'n',
        'ރ': 'r',
        'ބ': 'b',
        'ޅ': 'lh',
        'ކ': 'k',
        'އ': 'a',
        'ވ': 'v',
        'މ': 'm',
        'ފ': 'f',
        'ދ': 'dh',
        'ތ': 'th',
        'ލ': 'l',
        'ގ': 'g',
        'ޏ': 'gn',
        'ސ': 's',
        'ޑ': 'd',
        'ޒ': 'z',
        'ޓ': 't',
        'ޔ': 'y',
        'ޕ': 'p',
        'ޖ': 'j',
        'ޗ': 'ch',
        'ޘ': 'tt',
        'ޙ': 'hh',
        'ޚ': 'kh',
        'ޛ': 'th',
        'ޜ': 'z',
        'ޝ': 'sh',
        'ޞ': 's',
        'ޟ': 'd',
        'ޠ': 't',
        'ޡ': 'z',
        'ޢ': 'a',
        'ޣ': 'gh',
        'ޤ': 'q',
        'ޥ': 'w',
        'ަ': 'a',
        'ާ': 'aa',
        'ި': 'i',
        'ީ': 'ee',
        'ު': 'u',
        'ޫ': 'oo',
        'ެ': 'e',
        'ޭ': 'ey',
        'ޮ': 'o',
        'ޯ': 'oa',
        'ް': '',

        // Georgian https://en.wikipedia.org/wiki/Romanization_of_Georgian
        // National system (2002)
        'ა': 'a',
        'ბ': 'b',
        'გ': 'g',
        'დ': 'd',
        'ე': 'e',
        'ვ': 'v',
        'ზ': 'z',
        'თ': 't',
        'ი': 'i',
        'კ': 'k',
        'ლ': 'l',
        'მ': 'm',
        'ნ': 'n',
        'ო': 'o',
        'პ': 'p',
        'ჟ': 'zh',
        'რ': 'r',
        'ს': 's',
        'ტ': 't',
        'უ': 'u',
        'ფ': 'p',
        'ქ': 'k',
        'ღ': 'gh',
        'ყ': 'q',
        'შ': 'sh',
        'ჩ': 'ch',
        'ც': 'ts',
        'ძ': 'dz',
        'წ': 'ts',
        'ჭ': 'ch',
        'ხ': 'kh',
        'ჯ': 'j',
        'ჰ': 'h',

        // Greek
        'α': 'a',
        'β': 'v',
        'γ': 'g',
        'δ': 'd',
        'ε': 'e',
        'ζ': 'z',
        'η': 'i',
        'θ': 'th',
        'ι': 'i',
        'κ': 'k',
        'λ': 'l',
        'μ': 'm',
        'ν': 'n',
        'ξ': 'ks',
        'ο': 'o',
        'π': 'p',
        'ρ': 'r',
        'σ': 's',
        'τ': 't',
        'υ': 'y',
        'φ': 'f',
        'χ': 'x',
        'ψ': 'ps',
        'ω': 'o',
        'ά': 'a',
        'έ': 'e',
        'ί': 'i',
        'ό': 'o',
        'ύ': 'y',
        'ή': 'i',
        'ώ': 'o',
        'ς': 's',
        'ϊ': 'i',
        'ΰ': 'y',
        'ϋ': 'y',
        'ΐ': 'i',
        'Α': 'A',
        'Β': 'B',
        'Γ': 'G',
        'Δ': 'D',
        'Ε': 'E',
        'Ζ': 'Z',
        'Η': 'I',
        'Θ': 'TH',
        'Ι': 'I',
        'Κ': 'K',
        'Λ': 'L',
        'Μ': 'M',
        'Ν': 'N',
        'Ξ': 'KS',
        'Ο': 'O',
        'Π': 'P',
        'Ρ': 'R',
        'Σ': 'S',
        'Τ': 'T',
        'Υ': 'Y',
        'Φ': 'F',
        'Χ': 'X',
        'Ψ': 'PS',
        'Ω': 'O',
        'Ά': 'A',
        'Έ': 'E',
        'Ί': 'I',
        'Ό': 'O',
        'Ύ': 'Y',
        'Ή': 'I',
        'Ώ': 'O',
        'Ϊ': 'I',
        'Ϋ': 'Y',

        // Latvian
        'ā': 'a',
        // 'č': 'c', // duplicate
        'ē': 'e',
        'ģ': 'g',
        'ī': 'i',
        'ķ': 'k',
        'ļ': 'l',
        'ņ': 'n',
        // 'š': 's', // duplicate
        'ū': 'u',
        // 'ž': 'z', // duplicate
        'Ā': 'A',
        // 'Č': 'C', // duplicate
        'Ē': 'E',
        'Ģ': 'G',
        'Ī': 'I',
        'Ķ': 'k',
        'Ļ': 'L',
        'Ņ': 'N',
        // 'Š': 'S', // duplicate
        'Ū': 'U',
        // 'Ž': 'Z', // duplicate

        // Macedonian
        'Ќ': 'Kj',
        'ќ': 'kj',
        'Љ': 'Lj',
        'љ': 'lj',
        'Њ': 'Nj',
        'њ': 'nj',
        'Тс': 'Ts',
        'тс': 'ts',

        // Polish
        'ą': 'a',
        'ć': 'c',
        'ę': 'e',
        'ł': 'l',
        'ń': 'n',
        // 'ó': 'o', // duplicate
        'ś': 's',
        'ź': 'z',
        'ż': 'z',
        'Ą': 'A',
        'Ć': 'C',
        'Ę': 'E',
        'Ł': 'L',
        'Ń': 'N',
        'Ś': 'S',
        'Ź': 'Z',
        'Ż': 'Z',

        // Ukranian
        'Є': 'Ye',
        'І': 'I',
        'Ї': 'Yi',
        'Ґ': 'G',
        'є': 'ye',
        'і': 'i',
        'ї': 'yi',
        'ґ': 'g',

        // Romanian
        'ă': 'a',
        'Ă': 'A',
        'ș': 's',
        'Ș': 'S',
        // 'ş': 's', // duplicate
        // 'Ş': 'S', // duplicate
        'ț': 't',
        'Ț': 'T',
        'ţ': 't',
        'Ţ': 'T',

        // Russian https://en.wikipedia.org/wiki/Romanization_of_Russian
        // ICAO

        'а': 'a',
        'б': 'b',
        'в': 'v',
        'г': 'g',
        'д': 'd',
        'е': 'e',
        'ё': 'yo',
        'ж': 'zh',
        'з': 'z',
        'и': 'i',
        'й': 'i',
        'к': 'k',
        'л': 'l',
        'м': 'm',
        'н': 'n',
        'о': 'o',
        'п': 'p',
        'р': 'r',
        'с': 's',
        'т': 't',
        'у': 'u',
        'ф': 'f',
        'х': 'kh',
        'ц': 'c',
        'ч': 'ch',
        'ш': 'sh',
        'щ': 'sh',
        'ъ': '',
        'ы': 'y',
        'ь': '',
        'э': 'e',
        'ю': 'yu',
        'я': 'ya',
        'А': 'A',
        'Б': 'B',
        'В': 'V',
        'Г': 'G',
        'Д': 'D',
        'Е': 'E',
        'Ё': 'Yo',
        'Ж': 'Zh',
        'З': 'Z',
        'И': 'I',
        'Й': 'I',
        'К': 'K',
        'Л': 'L',
        'М': 'M',
        'Н': 'N',
        'О': 'O',
        'П': 'P',
        'Р': 'R',
        'С': 'S',
        'Т': 'T',
        'У': 'U',
        'Ф': 'F',
        'Х': 'Kh',
        'Ц': 'C',
        'Ч': 'Ch',
        'Ш': 'Sh',
        'Щ': 'Sh',
        'Ъ': '',
        'Ы': 'Y',
        'Ь': '',
        'Э': 'E',
        'Ю': 'Yu',
        'Я': 'Ya',

        // Serbian
        'ђ': 'dj',
        'ј': 'j',
        // 'љ': 'lj',  // duplicate
        // 'њ': 'nj', // duplicate
        'ћ': 'c',
        'џ': 'dz',
        'Ђ': 'Dj',
        'Ј': 'j',
        // 'Љ': 'Lj', // duplicate
        // 'Њ': 'Nj', // duplicate
        'Ћ': 'C',
        'Џ': 'Dz',

        // Slovak
        'ľ': 'l',
        'ĺ': 'l',
        'ŕ': 'r',
        'Ľ': 'L',
        'Ĺ': 'L',
        'Ŕ': 'R',

        // Turkish
        'ş': 's',
        'Ş': 'S',
        'ı': 'i',
        'İ': 'I',
        // 'ç': 'c', // duplicate
        // 'Ç': 'C', // duplicate
        // 'ü': 'u', // duplicate, see langCharMap
        // 'Ü': 'U', // duplicate, see langCharMap
        // 'ö': 'o', // duplicate, see langCharMap
        // 'Ö': 'O', // duplicate, see langCharMap
        'ğ': 'g',
        'Ğ': 'G',

        // Vietnamese
        'ả': 'a',
        'Ả': 'A',
        'ẳ': 'a',
        'Ẳ': 'A',
        'ẩ': 'a',
        'Ẩ': 'A',
        'đ': 'd',
        'Đ': 'D',
        'ẹ': 'e',
        'Ẹ': 'E',
        'ẽ': 'e',
        'Ẽ': 'E',
        'ẻ': 'e',
        'Ẻ': 'E',
        'ế': 'e',
        'Ế': 'E',
        'ề': 'e',
        'Ề': 'E',
        'ệ': 'e',
        'Ệ': 'E',
        'ễ': 'e',
        'Ễ': 'E',
        'ể': 'e',
        'Ể': 'E',
        'ỏ': 'o',
        'ọ': 'o',
        'Ọ': 'o',
        'ố': 'o',
        'Ố': 'O',
        'ồ': 'o',
        'Ồ': 'O',
        'ổ': 'o',
        'Ổ': 'O',
        'ộ': 'o',
        'Ộ': 'O',
        'ỗ': 'o',
        'Ỗ': 'O',
        'ơ': 'o',
        'Ơ': 'O',
        'ớ': 'o',
        'Ớ': 'O',
        'ờ': 'o',
        'Ờ': 'O',
        'ợ': 'o',
        'Ợ': 'O',
        'ỡ': 'o',
        'Ỡ': 'O',
        'Ở': 'o',
        'ở': 'o',
        'ị': 'i',
        'Ị': 'I',
        'ĩ': 'i',
        'Ĩ': 'I',
        'ỉ': 'i',
        'Ỉ': 'i',
        'ủ': 'u',
        'Ủ': 'U',
        'ụ': 'u',
        'Ụ': 'U',
        'ũ': 'u',
        'Ũ': 'U',
        'ư': 'u',
        'Ư': 'U',
        'ứ': 'u',
        'Ứ': 'U',
        'ừ': 'u',
        'Ừ': 'U',
        'ự': 'u',
        'Ự': 'U',
        'ữ': 'u',
        'Ữ': 'U',
        'ử': 'u',
        'Ử': 'ư',
        'ỷ': 'y',
        'Ỷ': 'y',
        'ỳ': 'y',
        'Ỳ': 'Y',
        'ỵ': 'y',
        'Ỵ': 'Y',
        'ỹ': 'y',
        'Ỹ': 'Y',
        'ạ': 'a',
        'Ạ': 'A',
        'ấ': 'a',
        'Ấ': 'A',
        'ầ': 'a',
        'Ầ': 'A',
        'ậ': 'a',
        'Ậ': 'A',
        'ẫ': 'a',
        'Ẫ': 'A',
        // 'ă': 'a', // duplicate
        // 'Ă': 'A', // duplicate
        'ắ': 'a',
        'Ắ': 'A',
        'ằ': 'a',
        'Ằ': 'A',
        'ặ': 'a',
        'Ặ': 'A',
        'ẵ': 'a',
        'Ẵ': 'A',
        "⓪": "0",
        "①": "1",
        "②": "2",
        "③": "3",
        "④": "4",
        "⑤": "5",
        "⑥": "6",
        "⑦": "7",
        "⑧": "8",
        "⑨": "9",
        "⑩": "10",
        "⑪": "11",
        "⑫": "12",
        "⑬": "13",
        "⑭": "14",
        "⑮": "15",
        "⑯": "16",
        "⑰": "17",
        "⑱": "18",
        "⑲": "18",
        "⑳": "18",

        "⓵": "1",
        "⓶": "2",
        "⓷": "3",
        "⓸": "4",
        "⓹": "5",
        "⓺": "6",
        "⓻": "7",
        "⓼": "8",
        "⓽": "9",
        "⓾": "10",

        "⓿": "0",
        "⓫": "11",
        "⓬": "12",
        "⓭": "13",
        "⓮": "14",
        "⓯": "15",
        "⓰": "16",
        "⓱": "17",
        "⓲": "18",
        "⓳": "19",
        "⓴": "20",

        "Ⓐ": "A",
        "Ⓑ": "B",
        "Ⓒ": "C",
        "Ⓓ": "D",
        "Ⓔ": "E",
        "Ⓕ": "F",
        "Ⓖ": "G",
        "Ⓗ": "H",
        "Ⓘ": "I",
        "Ⓙ": "J",
        "Ⓚ": "K",
        "Ⓛ": "L",
        "Ⓜ": "M",
        "Ⓝ": "N",
        "Ⓞ": "O",
        "Ⓟ": "P",
        "Ⓠ": "Q",
        "Ⓡ": "R",
        "Ⓢ": "S",
        "Ⓣ": "T",
        "Ⓤ": "U",
        "Ⓥ": "V",
        "Ⓦ": "W",
        "Ⓧ": "X",
        "Ⓨ": "Y",
        "Ⓩ": "Z",

        "ⓐ": "a",
        "ⓑ": "b",
        "ⓒ": "c",
        "ⓓ": "d",
        "ⓔ": "e",
        "ⓕ": "f",
        "ⓖ": "g",
        "ⓗ": "h",
        "ⓘ": "i",
        "ⓙ": "j",
        "ⓚ": "k",
        "ⓛ": "l",
        "ⓜ": "m",
        "ⓝ": "n",
        "ⓞ": "o",
        "ⓟ": "p",
        "ⓠ": "q",
        "ⓡ": "r",
        "ⓢ": "s",
        "ⓣ": "t",
        "ⓤ": "u",
        "ⓦ": "v",
        "ⓥ": "w",
        "ⓧ": "x",
        "ⓨ": "y",
        "ⓩ": "z",

        // symbols
        '“': '"',
        '”': '"',
        '‘': "'",
        '’': "'",
        '∂': 'd',
        'ƒ': 'f',
        '™': '(TM)',
        '©': '(C)',
        'œ': 'oe',
        'Œ': 'OE',
        '®': '(R)',
        '†': '+',
        '℠': '(SM)',
        '…': '...',
        '˚': 'o',
        'º': 'o',
        'ª': 'a',
        '•': '*',
        '၊': ',',
        '။': '.',

        // currency
        '$': 'USD',
        '€': 'EUR',
        '₢': 'BRN',
        '₣': 'FRF',
        '£': 'GBP',
        '₤': 'ITL',
        '₦': 'NGN',
        '₧': 'ESP',
        '₩': 'KRW',
        '₪': 'ILS',
        '₫': 'VND',
        '₭': 'LAK',
        '₮': 'MNT',
        '₯': 'GRD',
        '₱': 'ARS',
        '₲': 'PYG',
        '₳': 'ARA',
        '₴': 'UAH',
        '₵': 'GHS',
        '¢': 'cent',
        '¥': 'CNY',
        '元': 'CNY',
        '円': 'YEN',
        '﷼': 'IRR',
        '₠': 'EWE',
        '฿': 'THB',
        '₨': 'INR',
        '₹': 'INR',
        '₰': 'PF',
        '₺': 'TRY',
        '؋': 'AFN',
        '₼': 'AZN',
        'лв': 'BGN',
        '៛': 'KHR',
        '₡': 'CRC',
        '₸': 'KZT',
        'ден': 'MKD',
        'zł': 'PLN',
        '₽': 'RUB',
        '₾': 'GEL'

    };

    /**
     * special look ahead character array
     * These characters form with consonants to become 'single'/consonant combo
     * @type [Array]
     */
    var lookAheadCharArray = [
        // burmese
        '်',

        // Dhivehi
        'ް'
    ];

    /**
     * diatricMap for languages where transliteration changes entirely as more diatrics are added
     * @type {Object}
     */
    var diatricMap = {
        // Burmese
        // dependent vowels
        'ာ': 'a',
        'ါ': 'a',
        'ေ': 'e',
        'ဲ': 'e',
        'ိ': 'i',
        'ီ': 'i',
        'ို': 'o',
        'ု': 'u',
        'ူ': 'u',
        'ေါင်': 'aung',
        'ော': 'aw',
        'ော်': 'aw',
        'ေါ': 'aw',
        'ေါ်': 'aw',
        '်': '်', // this is special case but the character will be converted to latin in the code
        'က်': 'et',
        'ိုက်': 'aik',
        'ောက်': 'auk',
        'င်': 'in',
        'ိုင်': 'aing',
        'ောင်': 'aung',
        'စ်': 'it',
        'ည်': 'i',
        'တ်': 'at',
        'ိတ်': 'eik',
        'ုတ်': 'ok',
        'ွတ်': 'ut',
        'ေတ်': 'it',
        'ဒ်': 'd',
        'ိုဒ်': 'ok',
        'ုဒ်': 'ait',
        'န်': 'an',
        'ာန်': 'an',
        'ိန်': 'ein',
        'ုန်': 'on',
        'ွန်': 'un',
        'ပ်': 'at',
        'ိပ်': 'eik',
        'ုပ်': 'ok',
        'ွပ်': 'ut',
        'န်ုပ်': 'nub',
        'မ်': 'an',
        'ိမ်': 'ein',
        'ုမ်': 'on',
        'ွမ်': 'un',
        'ယ်': 'e',
        'ိုလ်': 'ol',
        'ဉ်': 'in',
        'ံ': 'an',
        'ိံ': 'ein',
        'ုံ': 'on',

        // Dhivehi
        'ައް': 'ah',
        'ަށް': 'ah'
    };

    /**
     * langCharMap language specific characters translations
     * @type   {Object}
     */
    var langCharMap = {
        'en': {}, // default language

        'az': { // Azerbaijani
            'ç': 'c',
            'ə': 'e',
            'ğ': 'g',
            'ı': 'i',
            'ö': 'o',
            'ş': 's',
            'ü': 'u',
            'Ç': 'C',
            'Ə': 'E',
            'Ğ': 'G',
            'İ': 'I',
            'Ö': 'O',
            'Ş': 'S',
            'Ü': 'U'
        },

        'cs': { // Czech
            'č': 'c',
            'ď': 'd',
            'ě': 'e',
            'ň': 'n',
            'ř': 'r',
            'š': 's',
            'ť': 't',
            'ů': 'u',
            'ž': 'z',
            'Č': 'C',
            'Ď': 'D',
            'Ě': 'E',
            'Ň': 'N',
            'Ř': 'R',
            'Š': 'S',
            'Ť': 'T',
            'Ů': 'U',
            'Ž': 'Z'
        },

        'fi': { // Finnish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'hu': { // Hungarian
            'ä': 'a', // ok
            'Ä': 'A', // ok
            // 'á': 'a', duplicate see charMap/latin
            // 'Á': 'A', duplicate see charMap/latin
            'ö': 'o', // ok
            'Ö': 'O', // ok
            // 'ő': 'o', duplicate see charMap/latin
            // 'Ő': 'O', duplicate see charMap/latin
            'ü': 'u',
            'Ü': 'U',
            'ű': 'u',
            'Ű': 'U'
        },

        'lt': { // Lithuanian
            'ą': 'a',
            'č': 'c',
            'ę': 'e',
            'ė': 'e',
            'į': 'i',
            'š': 's',
            'ų': 'u',
            'ū': 'u',
            'ž': 'z',
            'Ą': 'A',
            'Č': 'C',
            'Ę': 'E',
            'Ė': 'E',
            'Į': 'I',
            'Š': 'S',
            'Ų': 'U',
            'Ū': 'U'
        },

        'lv': { // Latvian
            'ā': 'a',
            'č': 'c',
            'ē': 'e',
            'ģ': 'g',
            'ī': 'i',
            'ķ': 'k',
            'ļ': 'l',
            'ņ': 'n',
            'š': 's',
            'ū': 'u',
            'ž': 'z',
            'Ā': 'A',
            'Č': 'C',
            'Ē': 'E',
            'Ģ': 'G',
            'Ī': 'i',
            'Ķ': 'k',
            'Ļ': 'L',
            'Ņ': 'N',
            'Š': 'S',
            'Ū': 'u',
            'Ž': 'Z'
        },

        'pl': { // Polish
            'ą': 'a',
            'ć': 'c',
            'ę': 'e',
            'ł': 'l',
            'ń': 'n',
            'ó': 'o',
            'ś': 's',
            'ź': 'z',
            'ż': 'z',
            'Ą': 'A',
            'Ć': 'C',
            'Ę': 'e',
            'Ł': 'L',
            'Ń': 'N',
            'Ó': 'O',
            'Ś': 'S',
            'Ź': 'Z',
            'Ż': 'Z'
        },

        'sv': { // Swedish
            // 'å': 'a', duplicate see charMap/latin
            // 'Å': 'A', duplicate see charMap/latin
            'ä': 'a', // ok
            'Ä': 'A', // ok
            'ö': 'o', // ok
            'Ö': 'O' // ok
        },

        'sk': { // Slovak
            'ä': 'a',
            'Ä': 'A'
        },

        'sr': { // Serbian
            'љ': 'lj',
            'њ': 'nj',
            'Љ': 'Lj',
            'Њ': 'Nj',
            'đ': 'dj',
            'Đ': 'Dj'
        },

        'tr': { // Turkish
            'Ü': 'U',
            'Ö': 'O',
            'ü': 'u',
            'ö': 'o'
        }
    };

    /**
     * symbolMap language specific symbol translations
     * translations must be transliterated already
     * @type   {Object}
     */
    var symbolMap = {
        'ar': {
            '∆': 'delta',
            '∞': 'la-nihaya',
            '♥': 'hob',
            '&': 'wa',
            '|': 'aw',
            '<': 'aqal-men',
            '>': 'akbar-men',
            '∑': 'majmou',
            '¤': 'omla'
        },

        'az': {},

        'ca': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'amor',
            '&': 'i',
            '|': 'o',
            '<': 'menys que',
            '>': 'mes que',
            '∑': 'suma dels',
            '¤': 'moneda'
        },

        'cs': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'nebo',
            '<': 'mensi nez',
            '>': 'vetsi nez',
            '∑': 'soucet',
            '¤': 'mena'
        },

        'de': {
            '∆': 'delta',
            '∞': 'unendlich',
            '♥': 'Liebe',
            '&': 'und',
            '|': 'oder',
            '<': 'kleiner als',
            '>': 'groesser als',
            '∑': 'Summe von',
            '¤': 'Waehrung'
        },

        'dv': {
            '∆': 'delta',
            '∞': 'kolunulaa',
            '♥': 'loabi',
            '&': 'aai',
            '|': 'noonee',
            '<': 'ah vure kuda',
            '>': 'ah vure bodu',
            '∑': 'jumula',
            '¤': 'faisaa'
        },

        'en': {
            '∆': 'delta',
            '∞': 'infinity',
            '♥': 'love',
            '&': 'and',
            '|': 'or',
            '<': 'less than',
            '>': 'greater than',
            '∑': 'sum',
            '¤': 'currency'
        },

        'es': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'y',
            '|': 'u',
            '<': 'menos que',
            '>': 'mas que',
            '∑': 'suma de los',
            '¤': 'moneda'
        },

        'fa': {
            '∆': 'delta',
            '∞': 'bi-nahayat',
            '♥': 'eshgh',
            '&': 'va',
            '|': 'ya',
            '<': 'kamtar-az',
            '>': 'bishtar-az',
            '∑': 'majmooe',
            '¤': 'vahed'
        },

        'fi': {
            '∆': 'delta',
            '∞': 'aarettomyys',
            '♥': 'rakkaus',
            '&': 'ja',
            '|': 'tai',
            '<': 'pienempi kuin',
            '>': 'suurempi kuin',
            '∑': 'summa',
            '¤': 'valuutta'
        },

        'fr': {
            '∆': 'delta',
            '∞': 'infiniment',
            '♥': 'Amour',
            '&': 'et',
            '|': 'ou',
            '<': 'moins que',
            '>': 'superieure a',
            '∑': 'somme des',
            '¤': 'monnaie'
        },

        'ge': {
            '∆': 'delta',
            '∞': 'usasruloba',
            '♥': 'siqvaruli',
            '&': 'da',
            '|': 'an',
            '<': 'naklebi',
            '>': 'meti',
            '∑': 'jami',
            '¤': 'valuta'
        },

        'gr': {},

        'hu': {
            '∆': 'delta',
            '∞': 'vegtelen',
            '♥': 'szerelem',
            '&': 'es',
            '|': 'vagy',
            '<': 'kisebb mint',
            '>': 'nagyobb mint',
            '∑': 'szumma',
            '¤': 'penznem'
        },

        'it': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amore',
            '&': 'e',
            '|': 'o',
            '<': 'minore di',
            '>': 'maggiore di',
            '∑': 'somma',
            '¤': 'moneta'
        },

        'lt': {
            '∆': 'delta',
            '∞': 'begalybe',
            '♥': 'meile',
            '&': 'ir',
            '|': 'ar',
            '<': 'maziau nei',
            '>': 'daugiau nei',
            '∑': 'suma',
            '¤': 'valiuta'
        },

        'lv': {
            '∆': 'delta',
            '∞': 'bezgaliba',
            '♥': 'milestiba',
            '&': 'un',
            '|': 'vai',
            '<': 'mazak neka',
            '>': 'lielaks neka',
            '∑': 'summa',
            '¤': 'valuta'
        },

        'my': {
            '∆': 'kwahkhyaet',
            '∞': 'asaonasme',
            '♥': 'akhyait',
            '&': 'nhin',
            '|': 'tho',
            '<': 'ngethaw',
            '>': 'kyithaw',
            '∑': 'paungld',
            '¤': 'ngwekye'
        },

        'mk': {},

        'nl': {
            '∆': 'delta',
            '∞': 'oneindig',
            '♥': 'liefde',
            '&': 'en',
            '|': 'of',
            '<': 'kleiner dan',
            '>': 'groter dan',
            '∑': 'som',
            '¤': 'valuta'
        },

        'pl': {
            '∆': 'delta',
            '∞': 'nieskonczonosc',
            '♥': 'milosc',
            '&': 'i',
            '|': 'lub',
            '<': 'mniejsze niz',
            '>': 'wieksze niz',
            '∑': 'suma',
            '¤': 'waluta'
        },

        'pt': {
            '∆': 'delta',
            '∞': 'infinito',
            '♥': 'amor',
            '&': 'e',
            '|': 'ou',
            '<': 'menor que',
            '>': 'maior que',
            '∑': 'soma',
            '¤': 'moeda'
        },

        'ro': {
            '∆': 'delta',
            '∞': 'infinit',
            '♥': 'dragoste',
            '&': 'si',
            '|': 'sau',
            '<': 'mai mic ca',
            '>': 'mai mare ca',
            '∑': 'suma',
            '¤': 'valuta'
        },

        'ru': {
            '∆': 'delta',
            '∞': 'beskonechno',
            '♥': 'lubov',
            '&': 'i',
            '|': 'ili',
            '<': 'menshe',
            '>': 'bolshe',
            '∑': 'summa',
            '¤': 'valjuta'
        },

        'sk': {
            '∆': 'delta',
            '∞': 'nekonecno',
            '♥': 'laska',
            '&': 'a',
            '|': 'alebo',
            '<': 'menej ako',
            '>': 'viac ako',
            '∑': 'sucet',
            '¤': 'mena'
        },

        'sr': {},

        'tr': {
            '∆': 'delta',
            '∞': 'sonsuzluk',
            '♥': 'ask',
            '&': 've',
            '|': 'veya',
            '<': 'kucuktur',
            '>': 'buyuktur',
            '∑': 'toplam',
            '¤': 'para birimi'
        },

        'uk': {
            '∆': 'delta',
            '∞': 'bezkinechnist',
            '♥': 'lubov',
            '&': 'i',
            '|': 'abo',
            '<': 'menshe',
            '>': 'bilshe',
            '∑': 'suma',
            '¤': 'valjuta'
        },

        'vn': {
            '∆': 'delta',
            '∞': 'vo cuc',
            '♥': 'yeu',
            '&': 'va',
            '|': 'hoac',
            '<': 'nho hon',
            '>': 'lon hon',
            '∑': 'tong',
            '¤': 'tien te'
        }
    };

    var uricChars = [';', '?', ':', '@', '&', '=', '+', '$', ',', '/'].join('');

    var uricNoSlashChars = [';', '?', ':', '@', '&', '=', '+', '$', ','].join('');

    var markChars = ['.', '!', '~', '*', "'", '(', ')'].join('');

    /**
     * getSlug
     * @param  {string} input input string
     * @param  {object|string} opts config object or separator string/char
     * @api    public
     * @return {string}  sluggified string
     */
    var getSlug = function getSlug(input, opts) {
        var separator = '-';
        var result = '';
        var diatricString = '';
        var convertSymbols = true;
        var customReplacements = {};
        var maintainCase;
        var titleCase;
        var truncate;
        var uricFlag;
        var uricNoSlashFlag;
        var markFlag;
        var symbol;
        var langChar;
        var lucky;
        var i;
        var ch;
        var l;
        var lastCharWasSymbol;
        var lastCharWasDiatric;
        var allowedChars = '';

        if (typeof input !== 'string') {
            return '';
        }

        if (typeof opts === 'string') {
            separator = opts;
        }

        symbol = symbolMap.en;
        langChar = langCharMap.en;

        if (typeof opts === 'object') {
            maintainCase = opts.maintainCase || false;
            customReplacements = (opts.custom && typeof opts.custom === 'object') ? opts.custom : customReplacements;
            truncate = (+opts.truncate > 1 && opts.truncate) || false;
            uricFlag = opts.uric || false;
            uricNoSlashFlag = opts.uricNoSlash || false;
            markFlag = opts.mark || false;
            convertSymbols = (opts.symbols === false || opts.lang === false) ? false : true;
            separator = opts.separator || separator;

            if (uricFlag) {
                allowedChars += uricChars;
            }

            if (uricNoSlashFlag) {
                allowedChars += uricNoSlashChars;
            }

            if (markFlag) {
                allowedChars += markChars;
            }

            symbol = (opts.lang && symbolMap[opts.lang] && convertSymbols) ?
                symbolMap[opts.lang] : (convertSymbols ? symbolMap.en : {});

            langChar = (opts.lang && langCharMap[opts.lang]) ?
                langCharMap[opts.lang] :
                opts.lang === false || opts.lang === true ? {} : langCharMap.en;

            // if titleCase config is an Array, rewrite to object format
            if (opts.titleCase && typeof opts.titleCase.length === 'number' && Array.prototype.toString.call(opts.titleCase)) {
                opts.titleCase.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });

                titleCase = true;
            } else {
                titleCase = !!opts.titleCase;
            }

            // if custom config is an Array, rewrite to object format
            if (opts.custom && typeof opts.custom.length === 'number' && Array.prototype.toString.call(opts.custom)) {
                opts.custom.forEach(function (v) {
                    customReplacements[v + ''] = v + '';
                });
            }

            // custom replacements
            Object.keys(customReplacements).forEach(function (v) {
                var r;

                if (v.length > 1) {
                    r = new RegExp('\\b' + escapeChars(v) + '\\b', 'gi');
                } else {
                    r = new RegExp(escapeChars(v), 'gi');
                }

                input = input.replace(r, customReplacements[v]);
            });

            // add all custom replacement to allowed charlist
            for (ch in customReplacements) {
                allowedChars += ch;
            }
        }

        allowedChars += separator;

        // escape all necessary chars
        allowedChars = escapeChars(allowedChars);

        // trim whitespaces
        input = input.replace(/(^\s+|\s+$)/g, '');

        lastCharWasSymbol = false;
        lastCharWasDiatric = false;

        for (i = 0, l = input.length; i < l; i++) {
            ch = input[i];

            if (isReplacedCustomChar(ch, customReplacements)) {
                // don't convert a already converted char
                lastCharWasSymbol = false;
            } else if (langChar[ch]) {
                // process language specific diactrics chars conversion
                ch = lastCharWasSymbol && langChar[ch].match(/[A-Za-z0-9]/) ? ' ' + langChar[ch] : langChar[ch];

                lastCharWasSymbol = false;
            } else if (ch in charMap) {
                // the transliteration changes entirely when some special characters are added
                if (i + 1 < l && lookAheadCharArray.indexOf(input[i + 1]) >= 0) {
                    diatricString += ch;
                    ch = '';
                } else if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + charMap[ch];
                    diatricString = '';
                } else {
                    // process diactrics chars
                    ch = lastCharWasSymbol && charMap[ch].match(/[A-Za-z0-9]/) ? ' ' + charMap[ch] : charMap[ch];
                }

                lastCharWasSymbol = false;
                lastCharWasDiatric = false;
            } else if (ch in diatricMap) {
                diatricString += ch;
                ch = '';
                // end of string, put the whole meaningful word
                if (i === l - 1) {
                    ch = diatricMap[diatricString];
                }
                lastCharWasDiatric = true;
            } else if (
                // process symbol chars
                symbol[ch] && !(uricFlag && uricChars
                    .indexOf(ch) !== -1) && !(uricNoSlashFlag && uricNoSlashChars
                    // .indexOf(ch) !== -1) && !(markFlag && markChars
                    .indexOf(ch) !== -1)) {
                ch = lastCharWasSymbol || result.substr(-1).match(/[A-Za-z0-9]/) ? separator + symbol[ch] : symbol[ch];
                ch += input[i + 1] !== void 0 && input[i + 1].match(/[A-Za-z0-9]/) ? separator : '';

                lastCharWasSymbol = true;
            } else {
                if (lastCharWasDiatric === true) {
                    ch = diatricMap[diatricString] + ch;
                    diatricString = '';
                    lastCharWasDiatric = false;
                } else if (lastCharWasSymbol && (/[A-Za-z0-9]/.test(ch) || result.substr(-1).match(/A-Za-z0-9]/))) {
                    // process latin chars
                    ch = ' ' + ch;
                }
                lastCharWasSymbol = false;
            }

            // add allowed chars
            result += ch.replace(new RegExp('[^\\w\\s' + allowedChars + '_-]', 'g'), separator);
        }

        if (titleCase) {
            result = result.replace(/(\w)(\S*)/g, function (_, i, r) {
                var j = i.toUpperCase() + (r !== null ? r : '');
                return (Object.keys(customReplacements).indexOf(j.toLowerCase()) < 0) ? j : j.toLowerCase();
            });
        }

        // eliminate duplicate separators
        // add separator
        // trim separators from start and end
        result = result.replace(/\s+/g, separator)
            .replace(new RegExp('\\' + separator + '+', 'g'), separator)
            .replace(new RegExp('(^\\' + separator + '+|\\' + separator + '+$)', 'g'), '');

        if (truncate && result.length > truncate) {
            lucky = result.charAt(truncate) === separator;
            result = result.slice(0, truncate);

            if (!lucky) {
                result = result.slice(0, result.lastIndexOf(separator));
            }
        }

        if (!maintainCase && !titleCase) {
            result = result.toLowerCase();
        }

        return result;
    };

    /**
     * createSlug curried(opts)(input)
     * @param   {object|string} opts config object or input string
     * @return  {Function} function getSlugWithConfig()
     **/
    var createSlug = function createSlug(opts) {

        /**
         * getSlugWithConfig
         * @param   {string} input string
         * @return  {string} slug string
         */
        return function getSlugWithConfig(input) {
            return getSlug(input, opts);
        };
    };

    /**
     * escape Chars
     * @param   {string} input string
     */
    var escapeChars = function escapeChars(input) {
        return input.replace(/[-\\^$*+?.()|[\]{}\/]/g, '\\$&');
    };

    /**
     * check if the char is an already converted char from custom list
     * @param   {char} ch character to check
     * @param   {object} customReplacements custom translation map
     */
    var isReplacedCustomChar = function (ch, customReplacements) {
        for (var c in customReplacements) {
            if (customReplacements[c] === ch) {
                return true;
            }
        }
    };

    if (typeof module !== 'undefined' && module.exports) {

        // export functions for use in Node
        module.exports = getSlug;
        module.exports.createSlug = createSlug;
    } else if (true) {

        // export function for use in AMD
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return getSlug;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else {

        // don't overwrite global if exists
        try {
            if (root.getSlug || root.createSlug) {
                throw 'speakingurl: globals exists /(getSlug|createSlug)/';
            } else {
                root.getSlug = getSlug;
                root.createSlug = createSlug;
            }
        } catch (e) {}
    }
})(this);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('b-navbar',{attrs:{"toggleable":"md","ttype":"light","variante":"light","id":"m68_navbar_top"}},[_c('b-navbar-toggle',{attrs:{"target":"m68_nav_collapse_top"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"href":"/"}},[_c('img',{attrs:{"src":__webpack_require__(213),"alt":"Axel Springer Logo"}})]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"m68_nav_collapse_top"}},[_c('b-navbar-nav',{attrs:{"id":"m68_navbar_top_nav"}},_vm._l((_vm.menuItems),function(item,index){return _c('b-nav-item',{key:index,attrs:{"to":{ name: item.route },"exact":true}},[_vm._v("\n          "+_vm._s(item.label)+"\n        ")])})),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('b-nav-form',{attrs:{"right":""}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keywords),expression:"keywords"}],staticClass:"mr-sm-1 form-control form-control-sm",attrs:{"type":"text","placeholder":"Suchbegriff eingeben"},domProps:{"value":(_vm.keywords)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.simpleSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.keywords=$event.target.value}}})])],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('img',{staticClass:"mb-4",attrs:{"src":__webpack_require__(214),"height":"90","width":"880"}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('ol',{staticClass:"breadcrumb m68_breadcrumb"},[_c('li',{staticClass:"text-muted"},[_vm._v("Sie befinden sich hier: ")]),_vm._v(" "),_vm._l((_vm.breadcrumbs),function(item,index){return [(item.to)?_c('li',{key:index,staticClass:"breadcrumb-item",attrs:{"role":"presentation"}},[_c('b-link',{attrs:{"to":item.to,"target":"_self"}},[_vm._v(_vm._s(item.text))])],1):_c('li',{key:index,staticClass:"breadcrumb-item",attrs:{"role":"presentation"}},[_c('span',[_vm._v(_vm._s(item))])])]})],2)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo.png?f364e2349b7da0c112cf6281db6ed79f";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9327332_89da99e9a6.jpg?c6d0d15177c36015517a3d8735b5995b";

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207df06_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(216);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9207df06_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mt-4"},[_c('b-navbar',{staticClass:"navbar-expand",attrs:{"toggleable":"","type":"light","variante":"light","id":"m68_navbar_footer"}},[_c('b-navbar-toggle',{attrs:{"target":"m68_nav_collapse_footer"}}),_vm._v(" "),_c('b-collapse',{staticClass:"justify-content-center",attrs:{"is-nav":"","id":"m68_nav_collapse_footer"}},[_c('b-navbar-nav',[_c('b-nav-text',[_c('strong',[_vm._v("© Axel Springer SE "+_vm._s(_vm.date)+".")])]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'contact' },"exact":true}},[_vm._v("Impressum")]),_vm._v(" "),_c('b-nav-text',[_vm._v(" | ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'privacy' }}},[_vm._v("Hinweise zum Datenschutz")]),_vm._v(" "),_c('b-nav-text',[_vm._v(" | ")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":{ name: 'contact' },"exact":true}},[_vm._v("Anmerkungen zu Artikeln in der Datenbank\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('app-navigation'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('app-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_HomePage_vue__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AboutPage_vue__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_FAQPage_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ArchivePage_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_SearchHelpPage_vue__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_PressPage_vue__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_ContactPage_vue__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_MediaDetailPage_vue__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_PrivacyClausePage_vue__ = __webpack_require__(254);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_HomePage_vue__["a" /* default */]
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_AboutPage_vue__["a" /* default */]
  }, {
    path: '/about/faq',
    name: 'faq',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_FAQPage_vue__["a" /* default */]
  }, {
    path: '/archive',
    name: 'archive',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_ArchivePage_vue__["a" /* default */]
  }, {
    path: '/archive/help',
    name: 'searchhelp',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_SearchHelpPage_vue__["a" /* default */]
  }, {
    path: '/press',
    name: 'press',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_PressPage_vue__["a" /* default */]
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_ContactPage_vue__["a" /* default */]
  }, {
    path: '/contact/privacy-clause',
    name: 'privacy',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_PrivacyClausePage_vue__["a" /* default */]
  }, {
    path: '/medienarchiv/:slug',
    name: 'mediadetail',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_MediaDetailPage_vue__["a" /* default */]
  }, {
    path: '*',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_HomePage_vue__["a" /* default */]
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v3.0.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.0.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658799bb_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__ = __webpack_require__(225);
function injectStyle (ssrContext) {
  __webpack_require__(223)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658799bb_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(224);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("677adfa8", content, true, {});

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('b-media',[_c('h1',[_vm._v("Editorial zum Medienarchiv68")]),_vm._v(" "),_c('figure',{staticClass:"m68_article_teaser"},[_c('b-img',{attrs:{"thumbnail":"","fluid":"","src":__webpack_require__(226),"alt":"Dr. Mathias Döpfner"}}),_vm._v(" "),_c('figcaption',[_vm._v("von Dr. Mathias Döpfner, Vorstandsvorsitzender Axel Springer SE")])],1),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Zu wissen, wie es wirklich war, ist schon immer ein Grundimpuls des Journalismus und der\n          Geschichtswissenschaft gewesen – und das ist auch unser Anliegen mit dem Medienarchiv68.")]),_vm._v(" "),_c('p',[_vm._v("Wie wichtig es ist, dass wir uns mit diesem Kapitel deutscher Geschichte und unseres Unternehmens erneut\n          auseinandersetzen, zeigen zwei Meldungen des vergangenen Jahres: Karl-Heinz Kurras, der den Studenten Benno\n          Ohnesorg am 2. Juni 1967 erschoss, war ein inoffizieller Mitarbeiter der Staatssicherheit. Und der\n          Dutschke-Attentäter Josef Bachmann hielt enge Kontakte zu Neonazis, die von der Stasi wie auch der Polizei\n          beobachtet wurden. Beide Erkenntnisse werfen die Frage auf: Was wäre gewesen, wenn das alles schon damals\n          bekannt geworden wäre?")]),_vm._v(" "),_c('p',[_vm._v("Wir wollen aber nicht spekulieren, sondern uns an das halten, was geschrieben steht. Im Medienarchiv68\n          haben\n          wir rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und Interviews aus den\n          Jahren 1966 bis 1968 zusammengestellt, die ein Bild vermitteln, wie die Redaktionen von Axel Springer, aber\n          auch andere Medien wie der Berliner „Tagesspiegel“ über die 68er-Bewegung berichtet haben. Was die Texte aus\n          den Blättern der Axel Springer SE betrifft, so ist die Dokumentation nach unserem besten Wissen vollständig.\n          Sollten uns dennoch einzelne Artikel entgangen sein, sind wir für Hinweise dankbar. ")]),_vm._v(" "),_c('p',[_vm._v("Schon länger habe ich mir gewünscht, dass unabhängige Wissenschaftler die publizistische Positionierung der\n          Axel-Springer-Zeitungen in der damaligen Zeit wissenschaftlich aufarbeiten. Mit dem Material des\n          Medienarchivs68 ist dies erstmals über eine für jedermann zugängliche Datenbank online und umfassend\n          möglich.\n          Da mag es dann bei der Recherche Überraschungen geben, für uns oder für andere. Mein persönliches,\n          vorläufiges\n          Fazit: Wenn man genauer hinschaut, ergibt sich ein differenziertes Bild. Die These, das Haus Axel Springer\n          sei\n          eine zentral gelenkte Meinungsmaschine gewesen, welche die Studentenbewegung verhindern wollte, bestätigt\n          sich\n          jedenfalls nicht. ")]),_vm._v(" "),_c('p',[_vm._v("Kommentarzeilen wie „Stoppt den Terror der Jung-Roten jetzt“ (BILD Berlin, 7. Februar 1968) oder „Wer\n          Terror\n          produziert, muss Härte in Kauf nehmen.\" (B.Z., 3. Juni 1967) werden immer wieder zitiert. Aber war ebenso\n          bekannt, dass die B.Z. auch schrieb „Es ist ein Unding, einen Dutschke zum ,Volksfeind Nr. 1’ stempeln zu\n          wollen“ (B.Z., 22. Februar 1968)? Dass die WELT den Freispruch der Kommunarden Teufel und Langhans begrüßte\n          (WELT, 23. März 1968)? Oder dass BILD nach dem Attentat auf Rudi Dutschke titelte „Millionen bangen mit“\n          (BILD\n          Berlin, 13. April 1968)? Manche Klischees in den Köpfen erweisen sich auch als Endmoränen einer bis heute\n          wirkungsvollen SED-Propaganda und Stasi-Desinformation.")]),_vm._v(" "),_c('p',[_vm._v("Unser Haus hat großes Interesse an einer ergebnisoffenen Debatte. Dass die Diskussion im vergangenen Jahr\n          über die Rolle unseres Verlags um das Jahr 1968 so intensiv und dynamisch war, hat mich gefreut und\n          beeindruckt. Forschungsarbeiten und Dokumentationen wie „Feindbild Springer“ des Forschungsverbunds\n          SED-Staat\n          oder Tilman Jens’ WDR-Dokumentation „Bespitzelt Springer“ haben dazu viel beigetragen. Auch durch die\n          Ausrichtung der Tagung „1968 und die deutschen Unternehmen“ der Gesellschaft für Unternehmensgeschichte oder\n          die Öffnung unseres Archivs für die Axel Springer-Biographie von Hans-Peter Schwarz haben wir – so glaube\n          ich\n          – die Aufarbeitung befördert. Natürlich hätte ich mir gewünscht, dass unser Interesse an einem ernsthaften\n          Dialog – dazu gehört ausdrücklich auch die neuerliche Entschuldigung für die journalistischen Fehler, die\n          unser Haus damals gemacht hat – erwidert worden wäre. Dass maßgebliche Akteure der 1968er Bewegung, die\n          immer\n          den offenen Diskurs gefordert haben, diesen auf unsere Einladung zum „Springer Tribunal 2009“ hin verweigert\n          haben, war eine Enttäuschung und eine verpasste Chance.")]),_vm._v(" "),_c('p',[_vm._v("Meine Hoffnung ist, dass dieses Medienarchiv als eine Einladung verstanden wird. Eine Einladung nicht nur\n          an\n          Zeitzeugen von damals, sondern ausdrücklich auch an die Generation danach, sich selbst einen Eindruck zu\n          verschaffen und herauszufinden, wie es damals wirklich war. Sollte sich daraus ein neuer Impuls für die\n          weitere Debatte und wissenschaftliche Aufarbeitung ergeben, würden wir uns freuen. ")]),_vm._v(" "),_c('p',[_vm._v("Ich wünsche Ihnen spannendes Stöbern und erkenntnisreiche Recherchen. ")]),_vm._v(" "),_c('p',[_c('b-link',{attrs:{"to":{ name: 'archive' }}},[_vm._v("Zur Recherche in der Datenbank")])],1)])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "10063903_42b0a83e04.jpg?87e9fadc70b5500480b5f30a8b67b648";

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d7f755_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__ = __webpack_require__(230);
function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50d7f755_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(229);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("69630de1", content, true, {});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Über das Medienarchiv")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Bis heute wird die Berichterstattung der Medien von Axel Springer über „1968“ und die\n        Studentenbewegung kontrovers diskutiert. Nicht selten geschieht dies ohne Kenntnis der Berichte selbst. Mit\n        dem Medienarchiv68 will die Axel Springer SE jedem den unkomplizierten Zugriff auf die Originalquellen\n        ermöglichen, um sich selbst ein Bild zu machen.\n      ")]),_vm._v(" "),_c('p',[_vm._v("Rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und Interviews aus den Jahren\n        1966 bis 1968 zeigen, wie die Redaktionen von Axel Springer über die 68er-Bewegung berichtet haben.")]),_vm._v(" "),_c('p',[_vm._v("Von den damaligen Medienangeboten des Unternehmens wurden ausgewertet:")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("BERLINER MORGENPOST")]),_vm._v(" "),_c('li',[_vm._v("BILD Berlin")]),_vm._v(" "),_c('li',[_vm._v("B.Z.")]),_vm._v(" "),_c('li',[_vm._v("DIE WELT Berlin")]),_vm._v(" "),_c('li',[_vm._v("HAMBURGER ABENDBLATT")]),_vm._v(" "),_c('li',[_vm._v("WELT am SONNTAG")]),_vm._v(" "),_c('li',[_vm._v("BILD am SONNTAG.")])]),_vm._v(" "),_c('p',[_vm._v("In Ergänzung wurden in die Auswertung aufgenommen: DER TAGESSPIEGEL als eine repräsentative\n        bürgerlich-liberale Stimme und der TELEGRAF als ein eher sozialdemokratisch orientiertes Berliner Blatt. Beide\n        Zeitungen werden beispielhaft zu ausgewählten Ereignissen zitiert. Die Berichterstattung der Blätter des\n        Verlags Axel Springer kann dadurch punktuell mit jener von Konkurrenzzeitungen verglichen werden.")]),_vm._v(" "),_c('p',[_vm._v("Der Betrachtungszeitraum erstreckt sich vom Dezember 1966 bis Dezember 1968. Gesucht wurde nach allen\n        Artikeln, die sich mit der Studentenbewegung im weitesten Sinne befasst haben. Zur leichteren Erschließung\n        einzelner Aspekte wurden die Artikel nach Stichworten wie beispielsweise Schah/Ohnesorg/Kurras,\n        Hochschulreform, SDS oder Kommune I unterteilt. Artikel, die sich keinem dieser Stichworte direkt zuordnen\n        ließen, sind unter „Sonstiges“ zusammengefasst.")]),_vm._v(" "),_c('p',[_vm._v("Die Datenbank enthält neben den Original-Überschriften zusätzlich auch redaktionell bearbeitete\n        Inhaltsangaben zu jedem Artikel, die einer Verbesserung der Suchergebnisse dienen. Eine Volltextsuche in den\n        Zeitungsartikeln ist derzeit leider noch nicht möglich. Um das Angebot möglichst zeitnah zu starten, wurde die\n        dafür erforderliche automatische Texterkennung aufgrund der hohen Fehlerquote und damit langen\n        Bearbeitungsdauer zunächst zurückgestellt. Für eine Optimierung der Suchergebnisse ist diese Option aber für\n        eine nächste Ausbaustufe geplant.")]),_vm._v(" "),_c('p',[_vm._v("Die Sammlung der Artikel und Erstellung der Datenbank erfolgte unter Leitung von Rainer Laabs, Leiter\n        Unternehmensarchiv Axel Springer SE.")]),_vm._v(" "),_c('p',[_vm._v("Wir haben uns bemüht, möglichst alle relevanten Artikel zu erfassen. Sollten Artikel fehlen,\n        "),_c('b-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("freuen wir uns über Hinweise per E-Mail")]),_vm._v(".")],1),_vm._v(" "),_c('p',[_c('b-link',{attrs:{"to":{ name: 'archive' }}},[_vm._v("Suche im Medienarchiv68 starten")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FAQPage_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646cf9c4_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FAQPage_vue__ = __webpack_require__(234);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FAQPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_646cf9c4_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FAQPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("3387c8fa", content, true, {});

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Fragen und Antworten")]),_vm._v(" "),_c('h3',[_vm._v("Was hat die Axel Springer SE bewogen, das Medienarchiv68 zu erstellen?")]),_vm._v(" "),_c('p',[_vm._v("Bis heute wird die Berichterstattung der Medien von Axel Springer über „1968“ und die Studentenbewegung\n        kontrovers diskutiert. Nicht selten geschieht dies ohne Kenntnis der Berichte selbst. Mit dem Medienarchiv68\n        will die Axel Springer SE jedem den unkomplizierten Zugriff auf die Originalquellen ermöglichen, um sich\n        selbst ein Bild zu machen. Rund 5.900 Beiträge, Kommentare, Leserbriefe, Karikaturen, Reportagen, Glossen und\n        Interviews aus den Jahren 1966 bis 1968 zeigen, wie die Redaktionen von Axel Springer über die 68er-Bewegung\n        berichtet haben. ")]),_vm._v(" "),_c('h3',[_vm._v("Welche Medien wurden für die Erstellung der Datenbank ausgewertet?")]),_vm._v(" "),_c('p',[_vm._v("Von den damaligen Medienangeboten des Verlags Axel Springer wurden ausgewertet: BERLINER MORGENPOST, BILD\n        Berlin, B.Z., DIE WELT Berlin, HAMBURGER ABENDBLATT, WELT am SONNTAG, BILD am SONNTAG. Schwerpunktmäßig wurden\n        die Berliner Zeitungen bzw. die Berliner Ausgaben der überregionalen Zeitungen von Axel Springer ausgewertet,\n        da Berlin als so genannte „Frontstadt“ eine besonders wichtige Rolle 1968 spielte. In Ergänzung wurden in\n        die Auswertung aufgenommen: DER TAGESSPIEGEL als eine repräsentative bürgerlich-liberale Stimme und der\n        TELEGRAF als ein eher sozialdemokratisch orientiertes Berliner Blatt. Beide Zeitungen werden beispielhaft zu\n        ausgewählten Ereignissen zitiert. Die Berichterstattung der Blätter des Verlags Axel Springer kann dadurch\n        punktuell mit jener von Konkurrenzzeitungen verglichen werden.")]),_vm._v(" "),_c('h3',[_vm._v("Über welchen Zeitraum erstreckt sich die Auswertung?")]),_vm._v(" "),_c('p',[_vm._v("Der Betrachtungszeitraum erstreckt sich vom Dezember 1966 bis Dezember 1968. Ab Dezember 1966 beginnen die\n        Zeitungen von Axel Springer vermehrt über die Studentenbewegung zu berichten. Grund sind die einsetzenden\n        Unruhen an der Freien Universität Berlin und mehrere gewaltsame Studenten-Demonstrationen in Berlin. Das Ende\n        der Auswertung ist mit dem Jahresende 1968 und dem sukzessiven Nachlassen der Studentenproteste gesetzt.")]),_vm._v(" "),_c('h3',[_vm._v("Woran orientierte sich die thematische Auswahl der Artikel und wie sind diese in der Datenbank\n        rubriziert?")]),_vm._v(" "),_c('p',[_vm._v("Gesucht wurde nach allen Artikeln, die sich mit der Studentenbewegung im weitesten Sinne befasst haben. \n        Zur leichteren Erschließung einzelner Aspekte wurden die Artikel nach Stichworten wie beispielsweise\n        Schah/Ohnesorg/Kurras, Hochschulreform, SDS oder Kommune I unterteilt. Artikel, die sich keinem dieser\n        Stichworte direkt zuordnen ließen, sind unter „Sonstiges“ zusammengefasst.")]),_vm._v(" "),_c('h3',[_vm._v("Wurden wirklich alle relevanten Artikel erfasst?")]),_vm._v(" "),_c('p',[_vm._v("Wir haben uns bemüht, möglichst alle relevanten Artikel zu erfassen. Sollten Artikel fehlen,\n        "),_c('b-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("freuen wir uns über Hinweise per E-Mail")]),_vm._v(".\n      ")],1),_vm._v(" "),_c('p',[_vm._v("Haben Sie weitere Fragen? Dann\n        "),_c('b-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("nehmen Sie bitte Kontakt mit uns auf")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchivePage_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de813e0_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchivePage_vue__ = __webpack_require__(242);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchivePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3de813e0_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchivePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac150f2_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__ = __webpack_require__(237);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ac150f2_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',[_c('b-tab',{attrs:{"title":"Schnellsuche","active":""}},[_c('b-card',{attrs:{"bg-variant":"light"}},[_c('b-input-group',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.keywords),expression:"filter.keywords"}],staticClass:"form-control",attrs:{"state":_vm.state,"tabindex":"0"},domProps:{"value":(_vm.filter.keywords)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.simpleSearch($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter, "keywords", $event.target.value)}}}),_vm._v(" "),_c('b-input-group-append',[_c('b-btn',{attrs:{"variant":"outline-primary"},on:{"click":_vm.simpleSearch}},[_vm._v("Suche starten")])],1)],1),_vm._v(" "),_c('small',{staticClass:"form-text text-muted"},[_vm._v("\n                Hinweis: Neben den Original-Überschriften enthält die Datenbank eine redaktionell gepflegte Inhaltsangabe zu jedem Artikel. Die Artikeltexte sind als Bilddaten erfasst und nicht maschinell durchsuchbar.\n            ")])],1)],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"Erweiterte Suche"}},[_c('b-card',{attrs:{"bg-variant":"light"}},[_c('b-form-group',{attrs:{"id":"fieldset_topic","label":"Thema","label-for":"input_topic"}},[_c('b-form-select',{attrs:{"id":"input_topic","state":_vm.state,"options":_vm.options.topics},model:{value:(_vm.filter.topic),callback:function ($$v) {_vm.$set(_vm.filter, "topic", $$v)},expression:"filter.topic"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_title","label":"Titel des Artikels","label-for":"input_title"}},[_c('b-form-input',{attrs:{"id":"input_title","state":_vm.state},model:{value:(_vm.filter.title),callback:function ($$v) {_vm.$set(_vm.filter, "title", $$v)},expression:"filter.title"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_keywords","label":"Stichworte","label-for":"input_keywords"}},[_c('b-form-input',{attrs:{"id":"input_keywords","state":_vm.state},model:{value:(_vm.filter.keywords),callback:function ($$v) {_vm.$set(_vm.filter, "keywords", $$v)},expression:"filter.keywords"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_media","label":"Medien","label-for":"input_media"}},[_c('b-form-checkbox-group',{attrs:{"id":"input_media","state":_vm.state},model:{value:(_vm.filter.media),callback:function ($$v) {_vm.$set(_vm.filter, "media", $$v)},expression:"filter.media"}},[_vm._l((_vm.options.media),function(m){return [_c('b-form-checkbox',{key:m.value,attrs:{"value":m.value}},[_vm._v(_vm._s(m.text))])]})],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_externalmedia","label":"Fremdmedien","label-for":"input_externalmedia"}},[_c('b-form-checkbox-group',{attrs:{"id":"input_externalmedia","state":_vm.state},model:{value:(_vm.filter.externalMedia),callback:function ($$v) {_vm.$set(_vm.filter, "externalMedia", $$v)},expression:"filter.externalMedia"}},[_vm._l((_vm.options.externalMedia),function(m){return [_c('b-form-checkbox',{key:m.value,attrs:{"value":m.value}},[_vm._v(_vm._s(m.text))])]})],2)],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_type","label":"Textsorte","label-for":"input_type"}},[_c('b-form-select',{attrs:{"id":"input_type","options":_vm.options.textType,"state":_vm.state},model:{value:(_vm.filter.textType),callback:function ($$v) {_vm.$set(_vm.filter, "textType", $$v)},expression:"filter.textType"}}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"1","state":_vm.state},model:{value:(_vm.filter.frontPage),callback:function ($$v) {_vm.$set(_vm.filter, "frontPage", $$v)},expression:"filter.frontPage"}},[_vm._v("Auf der Titelseite")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_type","label":"Platzierung","label-for":"input_placement"}},[_c('b-form-select',{attrs:{"id":"input_placement","options":_vm.options.placement},model:{value:(_vm.filter.placement),callback:function ($$v) {_vm.$set(_vm.filter, "placement", $$v)},expression:"filter.placement"}}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"value":"1"},model:{value:(_vm.filter.illustration),callback:function ($$v) {_vm.$set(_vm.filter, "illustration", $$v)},expression:"filter.illustration"}},[_vm._v("Mit Bild")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_dataindex","label":"Datensatznummer","label-for":"input_dataindex"}},[_c('b-form-input',{attrs:{"id":"input_dataindex","state":_vm.state},model:{value:(_vm.filter.dataIndex),callback:function ($$v) {_vm.$set(_vm.filter, "dataIndex", $$v)},expression:"filter.dataIndex"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"fieldset_date","label":"Datum","label-for":"input_date_group"}},[_c('div',{staticClass:"form-group row",attrs:{"id":"fieldset_date_group"}},[_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"input_date_from"}},[_vm._v("von")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.dateRange.begin),expression:"filter.dateRange.begin"}],staticClass:"form-control",attrs:{"id":"input_date_from","state":_vm.state},domProps:{"value":(_vm.filter.dateRange.begin)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter.dateRange, "begin", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticClass:"col-sm-2 col-form-label",attrs:{"for":"input_date_till"}},[_vm._v("bis")]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filter.dateRange.end),expression:"filter.dateRange.end"}],staticClass:"form-control",attrs:{"id":"input_date_till","state":_vm.state},domProps:{"value":(_vm.filter.dateRange.end)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filter.dateRange, "end", $event.target.value)}}})])])]),_vm._v(" "),_c('b-form-group',[_c('b-button',{attrs:{"type":"submit","variant":"outline-primary"},on:{"click":_vm.filteredSearch}},[_vm._v("Suche starten")]),_vm._v(" "),_c('b-button',{attrs:{"type":"reset","variant":"outline-danger"},on:{"click":_vm.resetSearchFilter}},[_vm._v("Zurücksetzen")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResult_vue__ = __webpack_require__(80);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8535c7_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResult_vue__ = __webpack_require__(241);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8535c7_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResult_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResultSingle_vue__ = __webpack_require__(81);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f21947d_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResultSingle_vue__ = __webpack_require__(240);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchResultSingle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f21947d_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchResultSingle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3"},[_c('b-media',[_c('b-img',{attrs:{"slot":"aside","height":"150","src":_vm.imageSrc,"alt":_vm.imageAlt},slot:"aside"}),_vm._v(" "),_c('span',{staticClass:"d-inline-block mb-2"},[_c('strong',[_vm._v(_vm._s(_vm.item.object))]),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(_vm.item.externalObject),expression:"item.externalObject"}],staticClass:"text-danger"},[_vm._v("(Fremdpublikation)")]),_vm._v(" "),_c('span',[_vm._v(" vom ")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formattedDate))]),_vm._v(": "+_vm._s(_vm.item.text)+"\n    ")]),_vm._v(" "),_c('h3',[_c('router-link',{staticClass:"text-dark",attrs:{"to":{ name: 'mediadetail', params: { index: _vm.item.index, slug: _vm.item.slug }}}},[_vm._v(_vm._s(_vm.item.headline))])],1),_vm._v(" "),_c('div',{staticClass:"mb-1 text-muted"},[_vm._v(_vm._s(_vm.item.subline))]),_vm._v(" "),_c('p',{staticClass:"mb-2"},[_vm._v(_vm._s(_vm.shortedContent))]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'mediadetail', params: { index: _vm.item.index, slug: _vm.item.slug }}}},[_vm._v("Mehr...")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_c('span',[_vm._v("Download der Suchergebnisse")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-outline-primary btn-sm d-inline",attrs:{"data":_vm.getCurrentResultJSON(),"fields":_vm.getExportFields(),"meta":_vm.getExportMeta()}},[_vm._v("xls")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-outline-primary btn-sm d-inline",attrs:{"type":"csv","data":_vm.getCurrentResultJSON(),"fields":_vm.getExportFields(),"meta":_vm.getExportMeta()}},[_vm._v("csv")]),_vm._v(" "),_c('span',[_vm._v("Download des kompletten Medienarchives")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-outline-primary btn-sm d-inline",attrs:{"data":_vm.getCompleteResultJSON(),"fields":_vm.getExportFields(),"meta":_vm.getExportMeta()}},[_vm._v("xls")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-outline-primary btn-sm d-inline",attrs:{"type":"csv","data":_vm.getCompleteResultJSON(),"fields":_vm.getExportFields(),"meta":_vm.getExportMeta()}},[_vm._v("csv")])],1)]),_vm._v(" "),_c('b-col',{attrs:{"cols":"12"}},[_c('p',[_vm._v("Artikel "+_vm._s(_vm.offsetFrom + 1)+"-"+_vm._s(_vm.offsetTo)+" von "+_vm._s(_vm.totalRows))])]),_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"col-12"},[_c('SearchResultSingle',{attrs:{"item":item}})],1)}),_vm._v(" "),_c('b-pagination',{attrs:{"align":"center","total-rows":_vm.totalRows,"per-page":_vm.limit},on:{"input":_vm.paginatedData},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Durchsuchen Sie das Archiv")]),_vm._v(" "),_c('p',[_vm._v("Nutzen Sie die Schnellsuche für eine erste Stichwortsuche. Für genauere Abfragen nach Themen, Medien und\n        Zeiträumen schalten Sie auf die Erweiterte Suche um.\n        "),_c('router-link',{attrs:{"to":{ name: 'searchhelp' }}},[_vm._v("[zur Hilfe]")])],1)])],1),_vm._v(" "),_c('b-row',[_c('app-searchform')],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('h2',{staticClass:"mt-4"},[_vm._v("Ihre Suchergebnisse")])])],1),_vm._v(" "),_c('app-searchresult')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchHelpPage_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b144950a_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchHelpPage_vue__ = __webpack_require__(246);
function injectStyle (ssrContext) {
  __webpack_require__(244)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchHelpPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b144950a_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchHelpPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(245);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("0a19bf26", content, true, {});

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Hilfe")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Im Medienarchiv68 finden Sie Artikel aus Medien von Axel Springer vom 1. Dezember 1966 bis 31. Dezember 1968, die sich mit „1968“ und der Studentenbewegung beschäftigen. Zusätzlich stehen ausgewählte Artikel aus Blättern anderer Verlage zur Verfügung.")]),_vm._v(" "),_c('p',[_vm._v("Zu jedem Artikel in der Datenbank ist eine pdf-Datei mit einem Scan der jeweiligen Original-Zeitungsseite verfügbar. Zudem enthält die Datenbank neben den Original-Überschriften zusätzlich auch redaktionell bearbeitete Inhaltsangaben zu jedem Artikel, die einer Verbesserung der Suchergebnisse dienen. Eine Volltextsuche ist aufgrund der zu hohen Fehlerrate bei der automatischen Texterkennung der alten Zeitungsseiten leider noch nicht möglich, jedoch für eine nächste Ausbaustufe bereits geplant.")]),_vm._v(" "),_c('h2',[_vm._v("Schnellsuche")]),_vm._v(" "),_c('p',[_vm._v("Mit der Schnellsuche können Sie alle Textfelder der Datenbank frei nach Stichworten durchsuchen und sich somit einen ersten Überblick verschaffen. ")]),_vm._v(" "),_c('h3',[_vm._v("Suchbeispiele:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Die Eingabe "),_c('em',[_vm._v("Kurras Ohnesorg")]),_vm._v(" findet beispielsweise sämtliche Artikel, die "),_c('strong',[_vm._v("beide")]),_c('strong',[_vm._v(" Wörter")]),_vm._v(" im Thema, der Überschrift oder den Inhaltsstichworten enthalten. ")]),_vm._v(" "),_c('li',[_vm._v("Die Eingabe "),_c('em',[_vm._v("\"Kurras und Teufel\"")]),_vm._v(" (mit Anführungszeichen) findet beispielsweise sämtliche Artikel, die "),_c('strong',[_vm._v("genau diese Zeichenkette")]),_vm._v(" im Thema, der Überschrift oder den Inhaltsstichworten enthalten.")]),_vm._v(" "),_c('li',[_vm._v("Die Suche bevorzugt einzelne Wörter: Eine Suche nach "),_c('em',[_vm._v("TU")]),_vm._v(" gibt beispielsweise zuoberst Artikel mit "),_c('em',[_vm._v("TU")]),_vm._v(" oder "),_c('em',[_vm._v("TU-Rektor")]),_vm._v(" aus, bevor auch Artikel mit dem Wort S"),_c('em',[_vm._v("tu")]),_vm._v("denten ausgegeben werden.")])]),_vm._v(" "),_c('p',[_vm._v("Die Ergebnisse können anschließend nach Datum, Medium oder Artikeltitel "),_c('strong',[_vm._v("sortiert")]),_vm._v(" werden. ")]),_vm._v(" "),_c('h3',[_vm._v("Erweiterte Suche")]),_vm._v(" "),_c('p',[_vm._v("Diese Suche bietet genaue Abfragemöglichkeiten: Kombinieren Sie sämtliche Felder der Datenbank, um beispielsweise herauszufinden, wie viele Aufmacher sich mit dem Thema "),_c('em',[_vm._v("Dutschke")]),_vm._v(" beschäftigten, oder wie häufig das Wort "),_c('em',[_vm._v("Demonstration")]),_vm._v(" in Überschriften auf der ersten Seite vorkam. ")]),_vm._v(" "),_c('h3',[_vm._v("Suchhinweise:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Je mehr Kriterien Sie auswählen, desto enger fassen Sie das Suchergebnis.")]),_vm._v(" "),_c('li',[_vm._v("Im Feld \"Titel des Artikels\" suchen Sie automatisch im Titel "),_c('strong',[_vm._v("und")]),_vm._v(" in dessen Über- und Unterzeile, falls vorhanden. ")])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressPage_vue__ = __webpack_require__(83);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f9745f_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PressPage_vue__ = __webpack_require__(248);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PressPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28f9745f_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PressPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Pressespiegel")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Hier finden Sie eine chronologische Zusammenstellung von Berichten zum Medienarchiv68.")]),_vm._v(" "),_c('dl',[_c('dt',[_vm._v("26. April 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("DIE WELT: "),_c('a',{attrs:{"href":"http://www.welt.de/die-welt/kultur/article7337222/Die-Eifersucht-der-Revolutionaere.html","target":"_blank"}},[_vm._v("Die Eifersucht der Revolutionäre")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("8. April 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("DEUTSCHLANDRADIO KULTUR: "),_c('a',{attrs:{"href":"http://www.dradio.de/dkultur/sendungen/laenderreport/1158239/","target":"_blank"}},[_vm._v("Ist das sowas wie Aufarbeitung? - \"Medienarchiv 68\" vom Axel-Springer-Verlag seit 100 Tagen abrufbar")])])])]),_vm._v(" "),_c('dt',[_vm._v("31. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("FRANKFURTER ALLGEMEINE SONNTAGSZEITUNG: Statt Plätzchen zu backen ... (nur Printausgabe)"),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("29. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("KÖLNER STADTANZEIGER: "),_c('a',{attrs:{"href":"http://www.ksta.de/html/artikel/1264185792963.shtml","target":"_blank"}},[_vm._v("Der Versuch einer Korrektur")])])])]),_vm._v(" "),_c('dt',[_vm._v("23. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("STUTTGARTER ZEITUNG: "),_c('a',{attrs:{"href":"http://www.stuttgarter-zeitung.de/stz/page/2358868_0_9223_-mediengeschichte-des-springer-verlags-feindbild-von-einst-gibt-fehler-zu.html","target":"_blank"}},[_vm._v("Feindbild von einst gibt Fehler zu")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("22. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("DIE TAGESPOST: "),_c('a',{attrs:{"href":"http://www.die-tagespost.de/2008/index.php?option=com_content&task=view&id=200054652&Itemid=26","target":"_blank"}},[_vm._v("\"Drei Kugeln auf Rudi Dutschke\"")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("21. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("RHEINISCHER MERKUR: "),_c('a',{attrs:{"href":"http://www.merkur.de/index.php?id=39800","target":"_blank"}},[_vm._v("Dialektik der Aufklärung")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("20. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("Evangelischer Pressedienst (EPD): "),_c('a',{attrs:{"href":"http://www.epd.de/medien/medien_index_71227.html","target":"_blank"}},[_vm._v("Die Mähne des roten Rudi. Springer öffnet sein \"Medienarchiv68\"")])])])]),_vm._v(" "),_c('dt',[_vm._v("19. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("NEUE ZÜRICHER ZEITUNG: "),_c('a',{attrs:{"href":"http://www.nzz.ch/nachrichten/kultur/medien/springer_1968_und_die_wahrheit_1.4543013.html","target":"_blank"}},[_vm._v("Springer, 1968 und die Wahrheit ")])])])]),_vm._v(" "),_c('dt',[_vm._v("18. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("BILDblog.de: "),_c('a',{attrs:{"href":"http://www.bildblog.de/15266/der-staatsfeind-der-kein-staatsfeind-war/","target":"_blank"}},[_vm._v("Der Staatsfeind, der kein \"Staatsfeind\" war")]),_vm._v("  ")]),_c('li',[_vm._v("HAMBURGER ABENDBLATT: "),_c('a',{attrs:{"href":"http://www.abendblatt.de/kultur-live/article1345874/Springer-oeffnet-Medienarchiv-68.html","target":"_blank"}},[_vm._v("Springer öffnet Medienarchiv 68")]),_vm._v(" "),_c('br')]),_c('li',[_vm._v("DIE TAGESZEITUNG: "),_c('a',{attrs:{"href":"http://www.taz.de/1/leben/medien/artikel/1/heischen-nach-spaeter-genugtuung/","target":"_blank"}},[_vm._v("Heischen nach später Genugtuung")])]),_c('li',[_vm._v("Kress.de: "),_c('a',{attrs:{"href":"http://kress.de/tagesdienst/detail/beitrag/102112-stechender-blick-und-klassenkampfpulli-springer-oeffnet-68er-archiv.html","target":"_blank"}},[_vm._v("\"Stechender Blick\" und \"Klassenkampfpulli\": \u2028Springer öffnet 68er-Archiv")]),_vm._v(" ")]),_c('li',[_vm._v("Deutschland Radio: "),_c('a',{attrs:{"href":"http://www.dradio.de/dlf/sendungen/hintergrundpolitik/1108222/","target":"_blank"}},[_vm._v("Medienhetzer und Politgammler")]),_vm._v(" ")]),_c('li',[_vm._v("BERLINER ZEITUNG und FRANKFURTER RUNDSCHAU: "),_c('a',{attrs:{"href":"http://www.fr-online.de/in_und_ausland/kultur_und_medien/medien/?em_cnt=2213729&","target":"_blank"}},[_vm._v("Krawalle, Terror und der Studenten-Mob")]),_vm._v(" ")]),_c('li',[_vm._v("DIE WELT: "),_c('a',{attrs:{"href":"http://www.welt.de/die-welt/vermischtes/article5889180/Das-Archiv-zur-Revolte.html","target":"_blank"}},[_vm._v("Das Archiv zur Revolte")])]),_c('li',[_vm._v("SÜDDEUTSCHE ZEITUNG: "),_c('a',{attrs:{"href":"http://www.sueddeutsche.de/kultur/122/500388/text/","target":"_blank"}},[_vm._v("Geröllhaufen der Geschichte")])]),_c('li',[_vm._v("DRadio Wissen: "),_c('a',{attrs:{"href":"http://wissen.dradio.de/index.8.36.de.html?dram%3Aarticle_id=130","target":"_blank"}},[_vm._v("Springer schaltet Online-Archiv zu 68 frei ")])]),_c('li',[_vm._v("SPIEGEL: \"Wir wollen Sachlichkeit\" - Interview mit WELT-Chefredakteur Thomas Schmid (nur Printausgabe)")]),_c('li',[_vm._v("FOCUS: \"Demonstrationen waren Krawall\" - Interview mit WELT-Chefredakteur Thomas Schmid (nur Printausgabe)")])])]),_vm._v(" "),_c('dt',[_vm._v("17. Januar 2010:")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("KÖLNER STADTANZEIGER: "),_c('a',{attrs:{"href":"http://www.ksta.de/html/artikel/1262873727179.shtml","target":"_blank"}},[_vm._v("Springer-Konzern startet Medienarchiv")])]),_c('li',[_vm._v("WELT am SONNTAG: "),_c('a',{attrs:{"href":"http://www.welt.de/die-welt/vermischtes/article5878119/Springer-und-der-Protest.html","target":"_blank"}},[_vm._v("Springer und der Protest")]),_vm._v(" (Beitrag von Thomas Schmid)")]),_c('li',[_vm._v("BERLINER MORGENPOST: "),_c('a',{attrs:{"href":"http://www.morgenpost.de/printarchiv/berlin/article1240480/Axel-Springer-oeffnet-Medienarchiv-68.htm","target":"_blank"}},[_vm._v("Axel Springer öffnet Medienarchiv ‘68")]),_vm._v(" "),_c('br')]),_c('li',[_vm._v("B.Z. am SONNTAG: "),_c('a',{attrs:{"href":"http://www.bz-berlin.de/archiv/die-kampagne-die-keine-war-article693123.html","target":"_blank"}},[_vm._v("Die Kampagne, die keine war - Interview mit Thomas Schmid")]),_vm._v(" "),_c('br')]),_c('li',[_vm._v("BILD am SONNTAG: "),_c('a',{attrs:{"href":"http://www.bild.de/BILD/politik/2010/01/17/axel-springer-internet-archiv/ueber-68er-studentenbewegung.html","target":"_blank"}},[_vm._v("Wie wild war die Schreibe in den wilden 68ern?")]),_vm._v(" ")]),_c('li',[_vm._v("fixmbr.de: "),_c('a',{attrs:{"href":"http://www.fixmbr.de/springer-stellt-das-medienarchiv68-online/","target":"_blank"}},[_vm._v("Springer stellt das Medienarchiv68 online")]),_vm._v(" ")]),_c('li',[_vm._v("Gesichtspunkte.de: "),_c('a',{attrs:{"href":"http://gesichtspunkte.de/2010/01/der-axel-springer-verlag-fuhrt-glasnost-ein-die-jahre-1966-68/","target":"_blank"}},[_vm._v("Der Axel-Springer-Verlag führt Glasnost ein: Die Jahre 1966-68")]),_vm._v(" ")]),_c('li',[_vm._v("Scienceblogs.de: "),_c('a',{attrs:{"href":"http://www.scienceblogs.de/zeittaucher/2010/01/zeitgeschichte-springerverlag-veroffentlicht-online-alle-berichte-uber-studentenunruhen-1968-webseitenrezension.php","target":"_blank"}},[_vm._v("Zeitgeschichte - Springer-Verlag veröffentlicht online alle Berichte über Studentenunruhen 1968")]),_vm._v(" ")])])]),_vm._v(" "),_c('dt',[_vm._v("16. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("Meedia.de: "),_c('a',{attrs:{"href":"http://meedia.de/nc/details-topstory/article/springer-ffnet-medienarchiv68de_100025682.html?tx_ttnews%5BbackPid%5D=911&cHash=ea46a7f6c2","target":"_blank"}},[_vm._v("Springer öffnet Medienarchiv68.de")]),_vm._v(" ")]),_c('li',[_vm._v("Deutschlandradio Kultur: "),_c('a',{attrs:{"href":"http://www.dradio.de/dkultur/sendungen/fazit/1108011/","target":"_blank"}},[_vm._v("Historische Zeitungsseiten gegen ein schlechtes Image")])])])]),_vm._v(" "),_c('dt',[_vm._v("12. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("DIE TAGESZEITUNG: "),_c('a',{attrs:{"href":"http://www.taz.de/1/leben/medien/artikel/1/neues-aus-der-wagenburg/","target":"_blank"}},[_vm._v("Neues aus der Wagenburg")]),_vm._v(" ")]),_c('li',[_vm._v("turi2.de: "),_c('a',{attrs:{"href":"http://www.turi2.de/2010/01/12/heute2-springer-oeffnet-archiv-berichten-68er-bewegung-7739180/","target":"_blank"}},[_vm._v("Springer öffnet Archiv mit Berichten zur 68er-Bewegung")])]),_c('li',[_vm._v("DWDL.de: "),_c('a',{attrs:{"href":"http://www.dwdl.de/story/24249/springers_medienarchiv68_geht_online/","target":"_blank"}},[_vm._v("Springers \"Medienarchiv68\" geht online")]),_vm._v(" "),_c('br')])])]),_vm._v(" "),_c('dt',[_vm._v("11. Januar 2010")]),_vm._v(" "),_c('dd',[_c('ul',[_c('li',[_vm._v("Meedia.de: "),_c('a',{attrs:{"href":"http://meedia.de/nc/background/meedia-blogs/georg-altrogge/georg-altrogge-post/article/68er-archiv--nur-einer-kann-gewinnen_100025576.html?tx_ttnews[backPid]=1686%23formular","target":"_blank"}},[_vm._v("68er-Archiv: Nur einer kann gewinnen")]),_vm._v(" ")]),_c('li',[_vm._v("Meedia.de: "),_c('a',{attrs:{"href":"http://meedia.de/nc/details-topstory/article/medienarchiv68--springer-macht-ernst_100025575.html","target":"_blank"}},[_vm._v("Medienarchiv68: Springer macht Ernst")])])])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPage_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4958e725_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPage_vue__ = __webpack_require__(250);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4958e725_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Kontakt")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Haben Sie Anregungen oder Fragen?")]),_vm._v(" "),_c('p',[_vm._v("Wir stehen Ihnen gerne unter "),_c('a',{attrs:{"href":"mailto:medienarchiv68@axelspringer.de"}},[_vm._v("medienarchiv68@axelspringer.de")]),_vm._v(" zur Verfügung.")]),_vm._v(" "),_c('h2',[_vm._v("Impressum")]),_vm._v(" "),_c('b-media',[_c('b-img',{attrs:{"slot":"aside","thumbnail":"","src":__webpack_require__(251),"alt":"Rainer Laabs"},slot:"aside"}),_vm._v(" "),_c('h3',[_vm._v("Verantwortlich für den Inhalt")]),_vm._v(" "),_c('p',[_vm._v("Lars-Broder Keil"),_c('br'),_vm._v("\n          Leiter Unternehmensarchiv"),_c('br'),_vm._v("\n          Axel Springer SE"),_c('br'),_vm._v("\n          Axel-Springer-Straße 65"),_c('br'),_vm._v("\n          10888 Berlin"),_c('br'),_vm._v("\n          Tel. 030-2591-73281"),_c('br'),_vm._v("\n          Fax 030-2591-71782"),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:medienarchiv68@axelspringer.de"}},[_vm._v("medienarchiv68@axelspringer.de")])]),_vm._v(" "),_c('dl',{staticClass:"row"},[_c('dt',{staticClass:"col-sm-2"},[_vm._v("Firma")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-10"},[_vm._v("Axel Springer SE "),_c('br'),_vm._v(" Axel-Springer-Straße 65 "),_c('br'),_vm._v(" 10888 Berlin")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-2"},[_vm._v("Vorstand")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-10"},[_vm._v("\n            Dr. Mathias Döpfner (Vorsitzender)"),_c('br'),_vm._v("\n            Mark Dekan"),_c('br'),_vm._v("\n            Claudius Senst\n          ")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-2"},[_vm._v("Amtsgericht")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-10"},[_vm._v("Amtsgericht Charlottenburg "),_c('br'),_vm._v(" USt-IdNr. DE 136 627 286")]),_vm._v(" "),_c('dt',{staticClass:"col-sm-2"},[_vm._v("Handelsregister")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-10"},[_vm._v("Sitz Berlin"),_c('br'),_vm._v(" HRB 154517 B")])])],1),_vm._v(" "),_c('h3',[_vm._v("Information gemäß § 36 Verbraucherstreitbeilegungsgesetz")]),_vm._v(" "),_c('p',[_vm._v("medienarchiv68.de nimmt an einem freiwilligen Streitbeilegungsverfahren vor einer deutschen\n        Verbraucherschlichtungsstelle nicht teil. Eine gesetzliche Verpflichtung besteht nicht.")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "261861674_d0dfdd9403.jpg?d8989028d356e74846c158c7c24b93bc";

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaDetailPage_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c94bb302_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaDetailPage_vue__ = __webpack_require__(253);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MediaDetailPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c94bb302_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MediaDetailPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[(_vm.slugNotFound)?_c('b-row',[_c('b-col',[_c('h3',[_vm._v("404 - Archiv Eintrag konnte nicht gefunden werden")])])],1):_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',[_c('b-media',[_c('b-img',{attrs:{"slot":"aside","src":_vm.imageSrc,"alt":_vm.imageAlt},slot:"aside"}),_vm._v(" "),(_vm.item.kicker)?_c('h6',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.item.kicker))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.item.headline))]),_vm._v(" "),_c('dl',{staticClass:"row"},[_c('dt',{staticClass:"col-sm-3"},[_vm._v("Datensatznummer:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.id))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Medium:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.object)+" vom "+_vm._s(_vm.date)+", Seite "+_vm._s(_vm.item.page)+" von "+_vm._s(_vm.item.pageCount))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Autor:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.author))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Thema:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.topic))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Textsorte:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.text))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Platzierung:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.place))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Bebildert:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.illustration))]),_vm._v(" "),_c('dt',{staticClass:"col-sm-3"},[_vm._v("Inhalt:")]),_vm._v(" "),_c('dd',{staticClass:"col-sm-9"},[_vm._v(_vm._s(_vm.item.content))])]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":_vm.pdfDownloadurl}},[_vm._v("PDF-Download")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyClausePage_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a0f9f4_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyClausePage_vue__ = __webpack_require__(257);
function injectStyle (ssrContext) {
  __webpack_require__(255)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyClausePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17a0f9f4_hasScoped_false_transformToRequire_img_src_image_xlink_href_b_img_src_b_img_lazy_src_blank_src_b_card_img_src_b_card_img_img_src_b_carousel_slide_img_src_b_embed_src_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyClausePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(256);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(14)("025b858c", content, true, {});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(11)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Datenschutzerklärung Medienarchiv68")]),_vm._v(" "),_c('p',[_vm._v("Wir freuen uns sehr über Ihr Interesse an Medienarchiv68. Mit dieser Datenschutzerklärung informieren wir Sie über Art, Umfang und Zweck der von uns verarbeiteten personenbezogenen Daten und Ihre Rechte als betroffene Person.")]),_vm._v(" "),_c('h2',[_vm._v("1. Verantwortlicher")]),_vm._v(" "),_c('p',[_vm._v("Verantwortlich für die Datenverarbeitung gemäß Art. 4 Nr. 7 DSGVO ist vorbehaltlich abweichender Angaben in dieser Datenschutzerklärung die Axel Springer SE, Axel-Springer-Str. 65, 10888 Berlin, Telefon: +49 30 2591 0, E-Mail: kontakt@axelspringer.de (nachfolgend auch \"wir\" oder \"uns\").")]),_vm._v(" "),_c('h2',[_vm._v("2. Aufruf der Website")]),_vm._v(" "),_c('p',[_vm._v("Wenn Sie unser Angebot nutzen, werden durch uns automatisch verschiedene Daten erfasst und verarbeitet, wie z. B.:")]),_vm._v(" "),_c('p',[_vm._v("• Informationen über das zugreifende Endgerät und die verwendete Software")]),_vm._v(" "),_c('p',[_vm._v("• Datum und Uhrzeit des Zugriffs")]),_vm._v(" "),_c('p',[_vm._v("• Websites, von denen der Nutzer auf unsere Website gelangt oder die der Nutzer über unsere Website aufruft")]),_vm._v(" "),_c('p',[_vm._v("• IP-Adresse")]),_vm._v(" "),_c('p',[_vm._v("Die zumindest vorübergehende Speicherung der IP-Adresse ist technisch erforderlich, um eine Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Rechtsgrundlage der Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO. Unsere Server speichern Ihre IP-Adresse außerdem für bis zu 14 Tage zu eigenen Sicherheitszwecken (Art. 6 Abs. 1 lit. f DSGVO).")]),_vm._v(" "),_c('h2',[_vm._v("3. Datenweitergabe")]),_vm._v(" "),_c('p',[_vm._v("Vorbehaltlich abweichender Angaben in dieser Datenschutzerklärung übermitteln wir Ihre personenbezogenen Daten nur dann an Dritte, wenn die Übermittlung erforderlich ist, um unsere vertraglichen Verpflichtungen Ihnen gegenüber zu erfüllen und dies ersichtlich bei oder gemeinsam mit einem anderen Anbieter erfolgt, wir zur Weitergabe in sonstiger Weise gesetzlich berechtigt oder verpflichtet sind, oder Sie uns eine entsprechende Einwilligung erteilt haben.")]),_vm._v(" "),_c('h2',[_vm._v("4. Speicherdauer")]),_vm._v(" "),_c('p',[_vm._v("Wir verarbeiten personenbezogene Daten nur solange dies für den jeweils vorstehend genannten Zweck erforderlich ist. Die personenbezogenen Daten werden anschließend gelöscht, sofern einer Datenlöschung keine gesetzlichen Aufbewahrungsfristen entgegenstehen.")]),_vm._v(" "),_c('h2',[_vm._v("5. Kontaktdaten und Ihre Rechte als betroffene Person")]),_vm._v(" "),_c('p',[_vm._v("Bitte wenden Sie sich bei Fragen und Anregungen zum Datenschutz sowie zur Durchsetzung Ihrer Rechte als betroffene Person jederzeit an unseren Datenschutzbeauftragten:")]),_vm._v(" "),_c('p',[_vm._v("Axel Springer SE"),_c('br'),_vm._v("\n        Datenschutz"),_c('br'),_vm._v("\n        Axel-Springer-Str. 65"),_c('br'),_vm._v("\n        10888 Berlin"),_c('br'),_vm._v("\n        dataprivacy.holding@axelspringer.com")]),_vm._v(" "),_c('h3',[_vm._v("Auskunft und Berichtigung")]),_vm._v(" "),_c('p',[_vm._v("Sie können von uns jederzeit unentgeltlich Auskunft darüber erhalten, ob personenbezogene Daten zu Ihrer Person von uns verarbeitet werden und auch konkret welche Daten über Sie gespeichert werden sowie eine Kopie der gespeicherten Daten verlangen. Sie können ferner unrichtige Daten berichtigen und vervollständigen lassen.")]),_vm._v(" "),_c('h3',[_vm._v("Löschung, Einschränkung und das Recht auf Vergessenwerden")]),_vm._v(" "),_c('p',[_vm._v("Sie können die Löschung und Einschränkung Ihrer personenbezogenen Daten verlangen. Soweit einer Löschung Ihrer personenbezogenen Daten gesetzliche Aufbewahrungspflichten entgegenstehen, werden Ihre Daten mit dem Ziel markiert, ihre künftige Verarbeitung einzuschränken.")]),_vm._v(" "),_c('h3',[_vm._v("Datenübertragbarkeit")]),_vm._v(" "),_c('p',[_vm._v("Sofern anwendbar haben Sie außerdem das Recht, dass die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format an Sie oder einen anderen Verantwortlichen übermittelt werden, sofern die Verarbeitung auf der Einwilligung oder einem Vertrag beruht und mithilfe automatisierter Verfahren erfolgt. Dies gilt jedoch nicht, sofern die Verarbeitung für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, welche dem Verantwortlichen übertragen wurde. Ferner haben Sie das Recht, zu erwirken, dass die personenbezogenen Daten direkt von einem Verantwortlichen an einen anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist und sofern hiervon nicht die Rechte und Freiheiten anderer Personen beeinträchtigt werden.")]),_vm._v(" "),_c('h3',[_vm._v("Widerruf / Widerspruch")]),_vm._v(" "),_c('p',[_vm._v("Ihre abgegebenen Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft unter der o. g. Kontaktadresse widerrufen."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        Ferner haben Sie das Recht aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Sie betreffender personenbezogener Daten, die aufgrund eines berechtigten Interesses erfolgt, Widerspruch einzulegen. Dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Wir verarbeiten die personenbezogenen Daten im Falle des Widerspruchs nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die den Interessen, Rechten und Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        Sofern wir personenbezogene Daten verarbeiten, um Direktwerbung zu betreiben, so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der personenbezogenen Daten zum Zwecke derartiger Werbung unter der o. g. Kontaktadresse einzulegen. Dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Zudem haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Sie betreffende Verarbeitung personenbezogener Daten, die bei uns zu wissenschaftlichen oder historischen Forschungszwecken oder zu statistischen Zwecken erfolgen, Widerspruch einzulegen, es sei denn, eine solche Verarbeitung ist zur Erfüllung einer im öffentlichen Interesse liegenden Aufgabe erforderlich.")]),_vm._v(" "),_c('h3',[_vm._v("Beschwerderecht")]),_vm._v(" "),_c('p',[_vm._v("Ferner haben Sie ein Beschwerderecht bei der zuständigen Aufsichtsbehörde sowie die Möglichkeit Rechtsbehelfe einzulegen. Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs.")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("Stand:")]),_vm._v(" 9. April 2021")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js